var Hf = Object.defineProperty;
var Wf = (d, e, t) => e in d ? Hf(d, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : d[e] = t;
var ft = (d, e, t) => (Wf(d, typeof e != "symbol" ? e + "" : e, t), t);
var Fs = /* @__PURE__ */ ((d) => (d.TRADE = "trade", d.READ = "read", d.WITHDRAW = "withdraw", d))(Fs || {});
const Yf = {
  // transport related errors
  rpc: {
    parse: {
      code: -32700,
      message: "JSON parsing error",
      description: "{data.description}",
      documentation: "An error occurred on the server while parsing the JSON text"
    },
    invalidRequest: {
      code: -32600,
      message: "Invalid request object",
      description: "{data.description}",
      documentation: "The JSON sent is not a valid Request object"
    },
    methodNotFound: {
      code: -32601,
      message: "Method not found",
      description: "{data.description}",
      documentation: "The method does not exist / is not available"
    },
    invalidParams: {
      code: -32602,
      message: "Invalid method parameter(s)",
      description: "{data.description}",
      documentation: "Provided parameters do not match the method signature"
    },
    internal: {
      code: -32603,
      message: "Internal JSON-RPC error",
      description: "{data.description}",
      documentation: "Something went wrong in the communication engine of cede.store"
    }
  },
  defaultError: {
    code: 1e3,
    message: "cede.store default error",
    description: "{vault_and_account}: An error occurred",
    documentation: "Something went wrong in cede.store"
  },
  // ccxt library specific errors
  ccxt: {
    baseError: {
      code: 3e3,
      message: "CEX error",
      description: "{account}: {error.message}",
      documentation: "The exchange has a system abnormality. The original exchange error is provided."
    },
    requestExpired: {
      code: 3001,
      message: "Request expired",
      description: "{account}: request expired. This happens when ccxt throttler drops pending requests",
      documentation: "The request has expired"
    }
    // general: {
    //   cexError: {
    //     code: 3001,
    //     message: "CEX error",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The exchange has a system abnormality. The original exchange error is provided.",
    //   },
    //   cexApiAuthError: {
    //     code: 3002,
    //     message: "CEX API authentication error",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Invalid API key or permission denied",
    //   },
    //   cexNotAvailable: {
    //     code: 3003,
    //     message: "CEX is not available",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Exchange is not available, please try again later",
    //   },
    //   cexOnMaintenance: {
    //     code: 3004,
    //     message: "CEX on maintenance",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Exchange is on maintenance, please try again later",
    //   },
    //   invalidNonce: {
    //     code: 3005,
    //     message: "Invalid nonce",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation:
    //       "The API keys seem to be used by another app. The user should create new API keys and use them only for cede.store.",
    //   },
    //   notSupported: {
    //     code: 3006,
    //     message: "Not supported",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "This error is raised if the endpoint is not offered/not supported by the exchange API",
    //   },
    // },
    // order: {
    //   orderNotFound: {
    //     code: 3100,
    //     message: "Could not find the order",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Raised when you are trying to fetch or cancel a non-existent order",
    //   },
    //   orderImmediatelyFillable: {
    //     code: 3101,
    //     message: "The order is immediately fillable",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation:
    //       "Raised when the order you're trying to place would immediately be triggered and filled, and not be placed on the order book",
    //   },
    //   orderNotFillable: {
    //     code: 3102,
    //     message: "The order is not fillable",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Unable to fill this order",
    //   },
    //   invalidOrder: {
    //     code: 3103,
    //     message: "The order is invalid",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Raised when the order you're trying to place is not valid",
    //   },
    //   duplicateOrderId: {
    //     code: 3104,
    //     message: "Two or more orders have identical ids",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Raised when two or more orders have identical ids",
    //   },
    // },
    // request: {
    //   badRequest: {
    //     code: 3200,
    //     message: "Bad request",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request is malformed, the content of the request is not valid",
    //   },
    //   requestTimeout: {
    //     code: 3201,
    //     message: "Request timeout",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request timed out",
    //   },
    //   badResponse: {
    //     code: 3202,
    //     message: "Bad response",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The response from the exchange is malformed",
    //   },
    //   rateLimitExceeded: {
    //     code: 3203,
    //     message: "Rate limit exceeded",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request rate limit has been exceeded",
    //   },
    //   argumentsRequired: {
    //     code: 3204,
    //     message: "Method requires some arguments",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The method requires some arguments",
    //   },
    //   nullResponse: {
    //     code: 3205,
    //     message: "Null response",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The response from the exchange is null",
    //   },
    //   ddosProtection: {
    //     code: 3206,
    //     message: "DDOS protection",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request has been rejected by the exchange due to DDOS protection",
    //   },
    //   badSymbol: {
    //     code: 3207,
    //     message: "Bad symbol",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The symbol is not valid",
    //   },
    // },
    // account: {
    //   accountSuspended: {
    //     code: 3300,
    //     message: "Account suspended",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The user account is suspended",
    //   },
    //   permissionDenied: {
    //     code: 3301,
    //     message: "Permission denied",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The user doesn't have enough permission to perform the action",
    //   },
    //   insufficientFunds: {
    //     code: 3302,
    //     message: "Insufficient funds",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The user doesn't have enough funds to perform the action",
    //   },
    //   invalidAddress: {
    //     code: 3303,
    //     message: "Invalid address",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The address is not valid",
    //   },
    //   addressPending: {
    //     code: 3304,
    //     message: "Address pending",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The address is pending",
    //   },
    //   cancelPending: {
    //     code: 3305,
    //     message: "Cancel pending",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The cancel is pending",
    //   },
    // },
  },
  internal: {
    general: {
      badPassword: {
        code: 4e3,
        message: "Bad password",
        description: "Bad password",
        documentation: "The password provided is incorrect"
      }
    },
    misc: {
      jobs: {
        fetchTransactionHistoryError: {
          code: 4100,
          message: "Transaction history cannot be fetched through the job",
          description: "An error happened while fetching the transaction history",
          documentation: "An error happened while fetching the transaction history"
        },
        getLastTxUpdateError: {
          code: 4101,
          message: "Last transaction update cannot be fetched through the job",
          description: "An error happened while getting the last transaction update",
          documentation: "An error happened while getting the last transaction update"
        }
      },
      cancelTrackingError: {
        code: 4102,
        message: "Tracking cannot be cancelled",
        description: "An error happened while cancelling the tracking",
        documentation: "An error happened while cancelling the tracking"
      }
    },
    vault: {
      accountAlreadyExists: {
        code: 4200,
        message: "Vault account already exists",
        description: "The exchange account has already been added to the vault",
        documentation: "The exchange account has already been added to the vault"
      },
      nameExists: {
        code: 4201,
        message: "Vault name already exists",
        description: "The vault {vault} already exists",
        documentation: "Raised when trying to create the vault with same name as the existent vault"
      },
      nameCannotBeGenerated: {
        code: 4202,
        message: "Vault name cannot be generated",
        description: "The vault name cannot be generated",
        documentation: "Raised when there is an error in the vault name generation"
      },
      accountKeysInconsistent: {
        code: 4203,
        message: "Account keys inconsistent. They may not relate to the same account",
        description: "The Api Keys are not related to the same CEX account",
        documentation: "Raised when the user is trying to a second pair of API keys for the 2 key CEX which are not related to the same account"
      },
      cannotUnlockStorage: {
        code: 4204,
        message: "The storage cannot be unlocked",
        description: "Cede Store cannot unlock the storage",
        documentation: "Raised when the storage cannot be unlocked"
      },
      cannotPersisted: {
        code: 4205,
        message: "Vaults cannot persisted",
        description: "The vaults cannot be persisted",
        documentation: "Raised when the vaults cannot be persisted"
      },
      creationError: {
        code: 4206,
        message: "Vault creation error",
        description: "{vault}: An error happened while creating the vault",
        documentation: "Raised when an error happened while creating the vault"
      },
      deletionError: {
        code: 4207,
        message: "Vault deletion error",
        description: "{vault}: An error happened while deleting the vault",
        documentation: "Raised when an error happened while deleting the vault"
      },
      checkApiCredentialsError: {
        code: 4208,
        message: "API check credentials failure",
        description: "{vault}: An error happened while checking the API credentials",
        documentation: "Raised when an error happened while checking the API credentials when adding a new CEX"
      },
      updateApiCredentialsError: {
        code: 4209,
        message: "API update credentials failure",
        description: "{vault_and_account}: An error happened while updating the API credentials",
        documentation: "Raised when an error happened while updating the API credentials when updating a CEX"
      },
      updateCexSettingsError: {
        code: 4210,
        message: "Vault CEX update settings error",
        description: "{vault_and_account}: An error happened while updating the CEX settings",
        documentation: "Raised when an error happened while updating the CEX settings when updating a CEX"
      },
      accountCreationError: {
        code: 4211,
        message: "Vault account creation error",
        description: "{vault}: An error happened while creating the account",
        documentation: "Raised when an error happened while creating the account"
      },
      accountUpdateError: {
        code: 4212,
        message: "Vault account update error",
        description: "{vault_and_account}: An error happened while updating the account",
        documentation: "Raised when an error happened while updating the account"
      },
      globalUnlockError: {
        code: 4213,
        message: "Vault cannot be unlocked",
        description: "An error happened while unlocking the vaults",
        documentation: "Raised when an error happened while unlocking globally the vaults"
      },
      notWhitelisted: {
        code: 4214,
        message: "IP not whitelisted for API keys",
        description: "IP addresses weren't whitelisted. Please, whitelist them first.",
        documentation: "Raised when cede.store proxy IP was not whitelisted on the CEX side"
      },
      accountKeyAlreadyExists: {
        code: 4215,
        message: "API key already exists",
        description: "The API Key already exists",
        documentation: "Raised when the user is trying to update a key using one that already exists in the vault for the same CEX"
      },
      whitelistCheckFail: {
        code: 4216,
        message: "Whitelist check failed",
        description: "Whitelist check failed. Please try again later.",
        documentation: "Raised when the whitelist check failed"
      }
    }
  },
  // cede.store background errors
  cede: {
    general: {
      dispatcherDefaultError: {
        code: 5e3,
        message: "Dispatcher default error",
        description: "An error occured while {data.humanizedAction}",
        documentation: "An error occured while executing the method."
      },
      approvalNotFound: {
        code: 5001,
        message: "Approval not found",
        description: "The approval {data.approvalId} isn't found",
        documentation: "The approval isn't found. This can happen if the approval is not in pending approvals array"
      },
      vaultNotAllowedToAccess: {
        code: 5002,
        message: "Vault is not allowed to access",
        description: "You aren't allowed to access to this vault",
        documentation: "You aren't allowed to access to this vault"
      },
      accountNotPermission: {
        code: 5003,
        message: "Account does not have sufficient permissions to perform this action",
        description: "The account {account} doesn't have the permission to {data.permission} : {vault}",
        documentation: "The account doesn't have the permission to perform this action. If the account is read-only, you can't perform trades/withdrawals"
      },
      notConnected: {
        code: 5005,
        message: "Not connected",
        description: "Connect with cede.store to perfom this request",
        documentation: "Connect with cede.store to perfom this request"
      },
      notInitialized: {
        code: 5006,
        message: "Not initialized",
        description: "The user must set up at least one vault in the cede.store first",
        documentation: "Raised when cede.store has been downloaded but not initialized. The user must set up at least one vault in the cede.store first"
      },
      notSupportedFeature: {
        code: 5008,
        message: "This feature is not supported by the {account}",
        description: "This feature is not supported by the {account}",
        documentation: "Verify if the feature is supported by the CEX"
      },
      userDeniedApproval: {
        code: 5009,
        message: "User denied approval",
        description: "User denied approval",
        documentation: "User denied approval"
      },
      accountInvalidSetOfPermissions: {
        code: 5010,
        message: "Invalid set of permissions",
        description: "The account has an invalid set of permissions",
        documentation: "The account has an invalid set of permissions"
      },
      methodNotAvailableForThisExchange: {
        code: 5011,
        message: "Method not available",
        description: "This method is not available on this exchange",
        documentation: "The provider was requested to perform an action on an exchange that does not support the action"
      },
      invalidPermissionsSetup: {
        code: 5012,
        message: "Invalid key permissions",
        description: "Missing API permissions, please reimport your API key with the valid permissions",
        documentation: "API key permissions aren't valid, you should add missing permissions to the key and try again"
      }
    },
    vault: {
      notFound: {
        code: 5100,
        message: "Vault not found",
        description: "The vault was not found",
        documentation: "The vault was not found. Verify the vauld id"
      },
      accountNotFound: {
        code: 5101,
        message: "Vault account not found",
        // TODO make sure the error handler puts accountId in the context
        description: "{vault}: The account {account} was not found",
        documentation: "The account was not found. Verify the account name"
      },
      fetchVaultsError: {
        code: 5102,
        message: "Vaults cannot be retrieved",
        description: "An error happened while retrieveing the vaults",
        documentation: "Raised when the vaults cannot be retrieved from cede.store"
      },
      generateAccountNameError: {
        code: 5103,
        message: "An error occured while generating the account name",
        description: "An error occured while generating the account name",
        documentation: "The generate account name method shouldn't fail"
      },
      validateAccountNameError: {
        code: 5104,
        message: "An error occured while validating the account name",
        description: "An error occured while validating the account name",
        documentation: "The validate account name method shouldn't fail"
      },
      updateAccountNameError: {
        code: 5105,
        message: "An error occured while updating the account name",
        description: "An error occured while updating the account name",
        documentation: "Verify if the old account name is valid because we are using it to update the account"
      },
      getAccountError: {
        code: 5106,
        message: "An error occured while getting the account",
        description: "An error occured while getting the account",
        documentation: "Verify if the account id is valid"
      },
      getAccountsError: {
        code: 5107,
        message: "An error occured while getting the accounts",
        description: "An error occured while getting the accounts",
        documentation: "Verify if the vault id is valid"
      },
      notOAuthAccount: {
        code: 5108,
        message: "The account is not an OAuth account",
        description: "The account is not an OAuth account",
        documentation: "This error is raised when we try to perform an action on an OAuth account and the account is not using OAuth"
      },
      accountAlreadyContainsApiKeys: {
        code: 5109,
        message: "The account already contains these API keys",
        description: "The account already contains these API keys",
        documentation: "The account already contains the API keys added for different permissions. The CEX requires different keys for different permissions."
      }
    },
    exchange: {
      // public data, such as available tickers, tokens, etc.
      public: {
        fetchTickerFromTokenError: {
          code: 5201,
          message: "Cannot fetch ticker from token",
          description: "{vault_and_account}: An error happened while fetching tickers",
          documentation: "Raised when the ticker for a given token symbol cannot be retrieved from the CEX"
        },
        serverDown: {
          code: 5204,
          message: "Exchange's server is down",
          description: "The exchange's server is down",
          documentation: "Raised when the exchange server status is offline."
        },
        underMaintenance: {
          code: 5205,
          message: "Exchange is under maintenance",
          description: "The exchange is under maintenance",
          documentation: "Raised when the exchange server status is under maintenance."
        },
        supportedTokensError: {
          code: 5206,
          message: "Supported tokens not found",
          description: "{account}: The supported tokens were not found",
          documentation: "Raised when getSupportedTokens returns an error."
        },
        unavailableInThisCountry: {
          code: 5207,
          message: "The exchange is not available in this country",
          description: "{account}: The exchange is not available in this country",
          documentation: "Raised when the exchange is not available in this country"
        }
      },
      // fungible and non-fungible balances (tokens, nfts, fiat)
      balances: {
        getBalancesError: {
          code: 5210,
          message: "Cannot retrieve vault portfolio from CEX",
          description: "{vault_and_account}: An error happened while fetching the portfolio from the CEX",
          documentation: "Raised when the portfolio cannot be retrieved from the CEX"
        },
        getNftFromCexError: {
          code: 5211,
          message: "NFTs cannot be fetched from CEX",
          description: "{vault_and_account}: An error happened while fetching the NFTs",
          documentation: "Raised when the NFTs cannot be retrieved from the CEX"
        }
      },
      transactions: {
        getVaultTransactionsError: {
          code: 5220,
          message: "Cannot retrieve vault transactions",
          description: "{vault_and_account}: An error happened while fetching the vault transactions",
          documentation: "Raised when the transactions cannot be retrieved from the CEX"
        }
      },
      deposit: {
        getDepositableTokensError: {
          code: 5230,
          message: "Cannot get depositable tokens",
          description: "{vault_and_account}: An error happened while fetching the depositable tokens",
          documentation: "Raised when the depositable tokens cannot be retrieved from the CEX"
        },
        getDepositAddressError: {
          code: 5231,
          message: "Cannot get deposit address",
          description: "{vault_and_account}: An error happened while fetching the deposit address",
          documentation: "Raised when the deposit address cannot be retrieved from the CEX"
        }
      },
      trade: {
        postOrderError: {
          code: 5240,
          message: "Error encountered while posting order",
          description: "{vault_and_account}: An error occured with the market order",
          documentation: "Raised when the order cannot be posted to the CEX"
        },
        fetchMarketPairsError: {
          code: 5241,
          message: "Market pairs cannot be fetched",
          description: "{vault_and_account}: An error happened while fetching the market pairs",
          documentation: "Raised when the market pairs cannot be retrieved from the CEX"
        },
        fetchAllTickersFromSymbolsError: {
          code: 5242,
          message: "Tickers cannot be fetched from symbols",
          description: "{vault_and_account}: An error happened while fetching the tickers",
          documentation: "Raised when the tickers cannot be retrieved from the CEX"
        },
        orderNotFound: {
          code: 5243,
          message: "Order not found",
          description: "{vault_and_account}: The order {data.orderId} was not found",
          documentation: "Raised when the order cannot be found on the CEX"
        },
        minAmountError: {
          code: 5244,
          message: "Minimum amount error",
          description: "{vault_and_account}: The amount should be greater than {data.minAmount}",
          documentation: "Raised when the amount is too low to execute the trade"
        },
        tickerNotFound: {
          code: 5245,
          message: "Ticker not found",
          description: "{vault_and_account}: The ticker for {data.pairSymbol} was not found",
          documentation: "Raised when the ticker cannot be found on the CEX"
        },
        invalidOrderRequest: {
          code: 5246,
          message: "Invalid order request",
          description: "{vault_and_account}: The order request is invalid: {data.error}",
          documentation: "This error is triggered by invalid order requests. It could arise due to inappropriate data inputs, such as a price set to zero. To streamline error handling, we avoid generating overly specific errors for each scenario. This approach assumes that proper data validation is performed within the dApp, ensuring user inputs are correct."
        },
        fetchMarketPriceError: {
          code: 5247,
          message: "Market rates cannot be fetched",
          description: "{vault_and_account}: An error happened while fetching market rates",
          documentation: "Raised when market rates cannot be retrieved from the CEX"
        },
        getTradePathError: {
          code: 5248,
          message: "Trade path cannot be fetched",
          description: "{vault_and_account}: An error happened while fetching trade path",
          documentation: "Raised when trade path cannot be retrieved from the CEX"
        }
      },
      network: {
        networkNotFound: {
          code: 5250,
          message: "Network not found",
          description: "The network {data.network} isn't found",
          documentation: "Raised when the network isn't found"
        },
        networkNotProvided: {
          code: 5251,
          message: "Network not provided",
          description: "The network is not provided",
          documentation: "Raised when the network is not provided, but required"
        },
        networksNotStandardized: {
          code: 5252,
          message: "Networks are not standardized",
          description: "The networks are not standardized",
          documentation: "Raised when the networks are not standardized"
        }
      },
      withdrawal: {
        tokenToDefiAddressError: {
          code: 5260,
          message: "Error encountered while withdrawing token to DeFi address",
          description: "{vault_and_account}: An error happened while withdrawing to a DeFi address",
          documentation: "Raised when the withdrawal cannot be posted to DeFi address"
        },
        tokenToAnotherCexError: {
          code: 5261,
          message: "Error encountered while withdrawing token to another CEX",
          description: "{vault_and_account}: An error happened while withdrawing to another CEX",
          documentation: "Raised when the withdrawal cannot be posted to the CEX"
        },
        notFound: {
          code: 5262,
          message: "Withdrawal not found",
          description: "The withdrawal with id {data.withdrawalId} isn't found",
          documentation: "Raised when the withdrawal isn't found"
        },
        infoError: {
          code: 5263,
          message: "Withdrawal info error",
          description: "{vault_and_account}: Withdrawal info not found",
          documentation: "Raised when the withdrawal info cannot be retrieved from the CEX"
        },
        invalidAddress: {
          code: 5268,
          message: "Invalid address",
          description: "{vault_and_account}: Invalid address",
          documentation: "Raised when the address is invalid"
        }
      },
      coinbase: {
        accountNotFound: {
          code: 5270,
          message: "Coinbase account not found",
          description: "{account}: The account for currency {data.currency} was not found",
          documentation: "Raised when the account for currency cannot be found on the CEX"
        }
      },
      exchangeInstance: {
        notFound: {
          code: 5293,
          message: "Exchange instance not found",
          description: "The exchange instance was not found",
          documentation: "Raised when the exchange instance was not found"
        }
      },
      authentication: {
        oauthFlowInterruptedByTheUser: {
          code: 5301,
          message: "Connection has been interrupted. Please try again.",
          description: "Connection has been interrupted. Please try again.",
          documentation: "Raised when the OAuth flow is interrupted by the user (e.g. user closes the authorization popup)"
        }
      },
      nft: {
        notSupportedNfts: {
          code: 5400,
          message: "NFTs are not supported",
          description: "{account}: NFTs aren't supported.",
          documentation: "NFTs aren't supported on the given exchange"
        }
      }
    }
  },
  api: {
    invalidRequest: {
      code: 6e3,
      message: "Error encountered when sending a request to the api",
      description: "Request failed",
      documentation: "Raised when an API request failed"
    }
  }
}, Gs = {
  LOCKED_FOR_INACTIVITY: "Cede.store has been automatically locked due to a period of inactivity.",
  MESSAGE_SENT_TO_CEDE_TEAM: "Message sent to Cede Labs team",
  FEEDBACK_ERROR: "Error when sending feedback",
  API_KEY: {
    ALREADY_EXISTS: "API keys already exist.",
    CREDENTIALS_INCORRECT: "API credentials are incorrect",
    SUCCESSFULLY: (d) => `API key successfully ${d}`,
    REMOVED: "API key successfully removed",
    VERIFYING_VALIDITY: "Just verifying the validity of your keys…"
  },
  VAULT: {
    CANT_DELETE_SINGLE: "You can't delete your single vault.",
    REQUIRE_NON_EMPTY: "You must have at least one account in your vault to perform this action.",
    CREATED_SUCCESSFULLY: "Vault created successfully",
    NOT_FOUND: "Vault not found"
  },
  TRANSACTION: {
    TOKEN_FROM_NOT_FOUND: "Token from not found for this transaction",
    ACCOUNT_NOT_FOUND: "Account not found for this transaction",
    ORDER_NOT_FOUND: "Order not found for this transaction"
  },
  ACCOUNT: {
    NOT_FOUND: "Account not found",
    NOT_FOUND_WITH_NAME: (d) => `Account ${d} not found`,
    RECONNECT: (d) => `Please, reconnect your ${d} account`,
    DELETED: (d) => `${d} has been deleted.`,
    RECONNECTION_REQUIRED: "Reconnection required"
  },
  MARKET_NOT_FOUND: (d) => `Market ${d} not found`,
  CANCELLATION_FAILED: "The cancellation failed",
  OAUTH: {
    FAILED: "OAuth2 Connection failed, please try again.",
    SUCCESSFULLY_SETUP: "OAuth successfully setup"
  },
  UNKNOWN_ERROR: "Oups, something went wrong.",
  PRICES: {
    CANT_FETCH: "Sorry, we can't fetch the prices."
  },
  SEND: {
    YOUR_FUND_SAFE: "Your funds are safe",
    CONFIRM_EMAIL: (d) => `To process, please confirm the email from ${d} sent to your email address linked
      with your ${d} account.`
  },
  WIDGETS: {
    SEND: {
      LOGIN_LOADING_FIRST_LINE: "Select the vault you want to connect to from cede.store extension.",
      LOGIN_LOADING_SECOND_LINE: "You will be transferring your assets from the CEX accounts connected in the vault.",
      TRANSACTION_LOADING_FIRST_LINE: "Confirm the transaction on the cede.store popup.",
      TRANSACTION_LOADING_SECOND_LINE: "Make sure all the parameters are correct before confirming.",
      TRANSFER_CEX_ASSETS: "Transfer your CEX assets to your blockchain address from any dApp",
      CONNECT: "Connect",
      CONNECT_WALLET: "Connect wallet",
      CANT_FETCH_BUNDLE: "Could not connect to Cede.store. Please make sure you have the latest version of the extension."
    },
    TRADE_SEND: {
      ACTIONS_LABEL: "What actions you will validate:",
      WITHDRAW_CURRENCY: (d, e, t) => `Withdraw ${d} to ${e} on ${t}`,
      RECEIVE_CURRENCY: (d) => `In the end, you will receive ${d} in your wallet`,
      MODAL_CONFIRM: "Continue",
      PERFORM_TRADE_PATH: (d, e) => `You will need to perform the following ${d} trade(s) in order to withdraw on the ${e} network.`,
      NO_TRADE_PATH: "There is no trade path available for the destination currency. Please select another currency.",
      CONFIRM_TX: (d) => `Confirm Transaction ${d}`,
      FINISH: "Finish",
      ERROR: "Error, try again later"
    },
    TRADE_SQUARE: {
      ACTIONS_LABEL: "What actions you will validate:",
      PERFORM_TRADE_PATH: (d, e) => `You will need to perform the following ${d} trade(s) in order to get ${e} token.`,
      INFO_DETAILS: (d, e, t) => [
        `${d} `,
        "does not support ",
        `a ${e}/${t} pair. However, cede.store `,
        "has found the best price route. ",
        "You are going to ",
        `automatically perform a series of trades to receive ${t}`
      ],
      CLOSE: "Close"
    },
    TRADE: {
      CONNECT: "Connect",
      TRANSACTION_LOADING_FIRST_LINE: "Confirm the transaction on the cede.store popup.",
      TRANSACTION_LOADING_SECOND_LINE: "Make sure all the parameters are correct before confirming.",
      CANT_FETCH_BUNDLE: "Could not connect to Cede.store. Please make sure you have the latest version of the extension.",
      WELCOME_MESSAGE: "Your non-custodial gateway to your CeFi liquidity from any dApp"
    }
  },
  EXCHANGES_STATUSES: {
    SINGLE_DOWN: (d) => `${d} server is temporarily down, please try again later.`,
    TWO_DOWN: (d, e) => `${d} and ${e} servers are temporarily down, please try again later.`,
    THREE_DOWN: (d, e, t) => `${d}, ${e} and ${t} servers are temporarily down, please try again later.`,
    SINGLE_BACK_ONLINE: (d) => `${d} server is back available.`,
    TWO_BACK_ONLINE: (d, e) => `${d} and ${e} servers are back available.`,
    THREE_BACK_ONLINE: (d, e, t) => `${d}, ${e} and ${t} servers are back available.`,
    UNDER_MAINTENANCE: "Under maintenance",
    ADD_PERMISSION: "Add permission +",
    TEMPORARILY_UNAVAILABLE: "Temporarily unavailable",
    TEMPORARILY_UNAVAILABLE_IN_YOUR_COUNTRY: "Temporarily unavailable in your country"
  },
  STATE_MACHINE_ROUTER: {
    ERRORS: {
      MISSING_PARAMETERS: "Missing parameters from the redirection.",
      TWO_KEY_NOT_SUPPORTED: (d) => `The exchange ${d} doesn't support 2 key system.`
    }
  },
  READ_ONLY_ONBOARDING: {
    TITLE: "Specific server-side onboarding",
    PERMISSION_HINT: "Trade and withdraw permissions are not available for this specific onboarding"
  },
  AVAILABLE_SOON: "Available soon"
};
var qe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Kf(d) {
  return d && d.__esModule && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d;
}
var Rr = {}, Ho;
function nn() {
  return Ho || (Ho = 1, function(d) {
    Object.defineProperties(d, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: "Module" } });
    var e = {}, t = {};
    t.byteLength = u, t.toByteArray = h, t.fromByteArray = m;
    for (var i = [], s = [], n = typeof Uint8Array < "u" ? Uint8Array : Array, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, o = r.length; a < o; ++a)
      i[a] = r[a], s[r.charCodeAt(a)] = a;
    s["-".charCodeAt(0)] = 62, s["_".charCodeAt(0)] = 63;
    function c(S) {
      var b = S.length;
      if (b % 4 > 0)
        throw new Error("Invalid string. Length must be a multiple of 4");
      var T = S.indexOf("=");
      T === -1 && (T = b);
      var x = T === b ? 0 : 4 - T % 4;
      return [T, x];
    }
    function u(S) {
      var b = c(S), T = b[0], x = b[1];
      return (T + x) * 3 / 4 - x;
    }
    function f(S, b, T) {
      return (b + T) * 3 / 4 - T;
    }
    function h(S) {
      var b, T = c(S), x = T[0], v = T[1], _ = new n(f(S, x, v)), V = 0, j = v > 0 ? x - 4 : x, G;
      for (G = 0; G < j; G += 4)
        b = s[S.charCodeAt(G)] << 18 | s[S.charCodeAt(G + 1)] << 12 | s[S.charCodeAt(G + 2)] << 6 | s[S.charCodeAt(G + 3)], _[V++] = b >> 16 & 255, _[V++] = b >> 8 & 255, _[V++] = b & 255;
      return v === 2 && (b = s[S.charCodeAt(G)] << 2 | s[S.charCodeAt(G + 1)] >> 4, _[V++] = b & 255), v === 1 && (b = s[S.charCodeAt(G)] << 10 | s[S.charCodeAt(G + 1)] << 4 | s[S.charCodeAt(G + 2)] >> 2, _[V++] = b >> 8 & 255, _[V++] = b & 255), _;
    }
    function l(S) {
      return i[S >> 18 & 63] + i[S >> 12 & 63] + i[S >> 6 & 63] + i[S & 63];
    }
    function p(S, b, T) {
      for (var x, v = [], _ = b; _ < T; _ += 3)
        x = (S[_] << 16 & 16711680) + (S[_ + 1] << 8 & 65280) + (S[_ + 2] & 255), v.push(l(x));
      return v.join("");
    }
    function m(S) {
      for (var b, T = S.length, x = T % 3, v = [], _ = 16383, V = 0, j = T - x; V < j; V += _)
        v.push(p(S, V, V + _ > j ? j : V + _));
      return x === 1 ? (b = S[T - 1], v.push(
        i[b >> 2] + i[b << 4 & 63] + "=="
      )) : x === 2 && (b = (S[T - 2] << 8) + S[T - 1], v.push(
        i[b >> 10] + i[b >> 4 & 63] + i[b << 2 & 63] + "="
      )), v.join("");
    }
    var y = {};
    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
    y.read = function(S, b, T, x, v) {
      var _, V, j = v * 8 - x - 1, G = (1 << j) - 1, W = G >> 1, B = -7, Q = T ? v - 1 : 0, se = T ? -1 : 1, $ = S[b + Q];
      for (Q += se, _ = $ & (1 << -B) - 1, $ >>= -B, B += j; B > 0; _ = _ * 256 + S[b + Q], Q += se, B -= 8)
        ;
      for (V = _ & (1 << -B) - 1, _ >>= -B, B += x; B > 0; V = V * 256 + S[b + Q], Q += se, B -= 8)
        ;
      if (_ === 0)
        _ = 1 - W;
      else {
        if (_ === G)
          return V ? NaN : ($ ? -1 : 1) * (1 / 0);
        V = V + Math.pow(2, x), _ = _ - W;
      }
      return ($ ? -1 : 1) * V * Math.pow(2, _ - x);
    }, y.write = function(S, b, T, x, v, _) {
      var V, j, G, W = _ * 8 - v - 1, B = (1 << W) - 1, Q = B >> 1, se = v === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, $ = x ? 0 : _ - 1, te = x ? 1 : -1, E = b < 0 || b === 0 && 1 / b < 0 ? 1 : 0;
      for (b = Math.abs(b), isNaN(b) || b === 1 / 0 ? (j = isNaN(b) ? 1 : 0, V = B) : (V = Math.floor(Math.log(b) / Math.LN2), b * (G = Math.pow(2, -V)) < 1 && (V--, G *= 2), V + Q >= 1 ? b += se / G : b += se * Math.pow(2, 1 - Q), b * G >= 2 && (V++, G /= 2), V + Q >= B ? (j = 0, V = B) : V + Q >= 1 ? (j = (b * G - 1) * Math.pow(2, v), V = V + Q) : (j = b * Math.pow(2, Q - 1) * Math.pow(2, v), V = 0)); v >= 8; S[T + $] = j & 255, $ += te, j /= 256, v -= 8)
        ;
      for (V = V << v | j, W += v; W > 0; S[T + $] = V & 255, $ += te, V /= 256, W -= 8)
        ;
      S[T + $ - te] |= E * 128;
    };
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */
    (function(S) {
      const b = t, T = y, x = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
      S.Buffer = B, S.SlowBuffer = U, S.INSPECT_MAX_BYTES = 50;
      const v = 2147483647;
      S.kMaxLength = v;
      const { Uint8Array: _, ArrayBuffer: V, SharedArrayBuffer: j } = globalThis;
      B.TYPED_ARRAY_SUPPORT = G(), !B.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
      function G() {
        try {
          const D = new _(1), I = { foo: function() {
            return 42;
          } };
          return Object.setPrototypeOf(I, _.prototype), Object.setPrototypeOf(D, I), D.foo() === 42;
        } catch {
          return !1;
        }
      }
      Object.defineProperty(B.prototype, "parent", {
        enumerable: !0,
        get: function() {
          if (B.isBuffer(this))
            return this.buffer;
        }
      }), Object.defineProperty(B.prototype, "offset", {
        enumerable: !0,
        get: function() {
          if (B.isBuffer(this))
            return this.byteOffset;
        }
      });
      function W(D) {
        if (D > v)
          throw new RangeError('The value "' + D + '" is invalid for option "size"');
        const I = new _(D);
        return Object.setPrototypeOf(I, B.prototype), I;
      }
      function B(D, I, C) {
        if (typeof D == "number") {
          if (typeof I == "string")
            throw new TypeError(
              'The "string" argument must be of type string. Received type number'
            );
          return te(D);
        }
        return Q(D, I, C);
      }
      B.poolSize = 8192;
      function Q(D, I, C) {
        if (typeof D == "string")
          return E(D, I);
        if (V.isView(D))
          return L(D);
        if (D == null)
          throw new TypeError(
            "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof D
          );
        if (Ft(D, V) || D && Ft(D.buffer, V) || typeof j < "u" && (Ft(D, j) || D && Ft(D.buffer, j)))
          return z(D, I, C);
        if (typeof D == "number")
          throw new TypeError(
            'The "value" argument must not be of type number. Received type number'
          );
        const F = D.valueOf && D.valueOf();
        if (F != null && F !== D)
          return B.from(F, I, C);
        const X = K(D);
        if (X)
          return X;
        if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof D[Symbol.toPrimitive] == "function")
          return B.from(D[Symbol.toPrimitive]("string"), I, C);
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof D
        );
      }
      B.from = function(D, I, C) {
        return Q(D, I, C);
      }, Object.setPrototypeOf(B.prototype, _.prototype), Object.setPrototypeOf(B, _);
      function se(D) {
        if (typeof D != "number")
          throw new TypeError('"size" argument must be of type number');
        if (D < 0)
          throw new RangeError('The value "' + D + '" is invalid for option "size"');
      }
      function $(D, I, C) {
        return se(D), D <= 0 ? W(D) : I !== void 0 ? typeof C == "string" ? W(D).fill(I, C) : W(D).fill(I) : W(D);
      }
      B.alloc = function(D, I, C) {
        return $(D, I, C);
      };
      function te(D) {
        return se(D), W(D < 0 ? 0 : R(D) | 0);
      }
      B.allocUnsafe = function(D) {
        return te(D);
      }, B.allocUnsafeSlow = function(D) {
        return te(D);
      };
      function E(D, I) {
        if ((typeof I != "string" || I === "") && (I = "utf8"), !B.isEncoding(I))
          throw new TypeError("Unknown encoding: " + I);
        const C = Y(D, I) | 0;
        let F = W(C);
        const X = F.write(D, I);
        return X !== C && (F = F.slice(0, X)), F;
      }
      function N(D) {
        const I = D.length < 0 ? 0 : R(D.length) | 0, C = W(I);
        for (let F = 0; F < I; F += 1)
          C[F] = D[F] & 255;
        return C;
      }
      function L(D) {
        if (Ft(D, _)) {
          const I = new _(D);
          return z(I.buffer, I.byteOffset, I.byteLength);
        }
        return N(D);
      }
      function z(D, I, C) {
        if (I < 0 || D.byteLength < I)
          throw new RangeError('"offset" is outside of buffer bounds');
        if (D.byteLength < I + (C || 0))
          throw new RangeError('"length" is outside of buffer bounds');
        let F;
        return I === void 0 && C === void 0 ? F = new _(D) : C === void 0 ? F = new _(D, I) : F = new _(D, I, C), Object.setPrototypeOf(F, B.prototype), F;
      }
      function K(D) {
        if (B.isBuffer(D)) {
          const I = R(D.length) | 0, C = W(I);
          return C.length === 0 || D.copy(C, 0, 0, I), C;
        }
        if (D.length !== void 0)
          return typeof D.length != "number" || Dr(D.length) ? W(0) : N(D);
        if (D.type === "Buffer" && Array.isArray(D.data))
          return N(D.data);
      }
      function R(D) {
        if (D >= v)
          throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + v.toString(16) + " bytes");
        return D | 0;
      }
      function U(D) {
        return +D != D && (D = 0), B.alloc(+D);
      }
      B.isBuffer = function(I) {
        return I != null && I._isBuffer === !0 && I !== B.prototype;
      }, B.compare = function(I, C) {
        if (Ft(I, _) && (I = B.from(I, I.offset, I.byteLength)), Ft(C, _) && (C = B.from(C, C.offset, C.byteLength)), !B.isBuffer(I) || !B.isBuffer(C))
          throw new TypeError(
            'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
          );
        if (I === C)
          return 0;
        let F = I.length, X = C.length;
        for (let ne = 0, de = Math.min(F, X); ne < de; ++ne)
          if (I[ne] !== C[ne]) {
            F = I[ne], X = C[ne];
            break;
          }
        return F < X ? -1 : X < F ? 1 : 0;
      }, B.isEncoding = function(I) {
        switch (String(I).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;
          default:
            return !1;
        }
      }, B.concat = function(I, C) {
        if (!Array.isArray(I))
          throw new TypeError('"list" argument must be an Array of Buffers');
        if (I.length === 0)
          return B.alloc(0);
        let F;
        if (C === void 0)
          for (C = 0, F = 0; F < I.length; ++F)
            C += I[F].length;
        const X = B.allocUnsafe(C);
        let ne = 0;
        for (F = 0; F < I.length; ++F) {
          let de = I[F];
          if (Ft(de, _))
            ne + de.length > X.length ? (B.isBuffer(de) || (de = B.from(de)), de.copy(X, ne)) : _.prototype.set.call(
              X,
              de,
              ne
            );
          else if (B.isBuffer(de))
            de.copy(X, ne);
          else
            throw new TypeError('"list" argument must be an Array of Buffers');
          ne += de.length;
        }
        return X;
      };
      function Y(D, I) {
        if (B.isBuffer(D))
          return D.length;
        if (V.isView(D) || Ft(D, V))
          return D.byteLength;
        if (typeof D != "string")
          throw new TypeError(
            'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof D
          );
        const C = D.length, F = arguments.length > 2 && arguments[2] === !0;
        if (!F && C === 0)
          return 0;
        let X = !1;
        for (; ; )
          switch (I) {
            case "ascii":
            case "latin1":
            case "binary":
              return C;
            case "utf8":
            case "utf-8":
              return Lr(D).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return C * 2;
            case "hex":
              return C >>> 1;
            case "base64":
              return zo(D).length;
            default:
              if (X)
                return F ? -1 : Lr(D).length;
              I = ("" + I).toLowerCase(), X = !0;
          }
      }
      B.byteLength = Y;
      function J(D, I, C) {
        let F = !1;
        if ((I === void 0 || I < 0) && (I = 0), I > this.length || ((C === void 0 || C > this.length) && (C = this.length), C <= 0) || (C >>>= 0, I >>>= 0, C <= I))
          return "";
        for (D || (D = "utf8"); ; )
          switch (D) {
            case "hex":
              return Tt(this, I, C);
            case "utf8":
            case "utf-8":
              return Pe(this, I, C);
            case "ascii":
              return mt(this, I, C);
            case "latin1":
            case "binary":
              return ue(this, I, C);
            case "base64":
              return Ie(this, I, C);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return Ot(this, I, C);
            default:
              if (F)
                throw new TypeError("Unknown encoding: " + D);
              D = (D + "").toLowerCase(), F = !0;
          }
      }
      B.prototype._isBuffer = !0;
      function ae(D, I, C) {
        const F = D[I];
        D[I] = D[C], D[C] = F;
      }
      B.prototype.swap16 = function() {
        const I = this.length;
        if (I % 2 !== 0)
          throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (let C = 0; C < I; C += 2)
          ae(this, C, C + 1);
        return this;
      }, B.prototype.swap32 = function() {
        const I = this.length;
        if (I % 4 !== 0)
          throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (let C = 0; C < I; C += 4)
          ae(this, C, C + 3), ae(this, C + 1, C + 2);
        return this;
      }, B.prototype.swap64 = function() {
        const I = this.length;
        if (I % 8 !== 0)
          throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (let C = 0; C < I; C += 8)
          ae(this, C, C + 7), ae(this, C + 1, C + 6), ae(this, C + 2, C + 5), ae(this, C + 3, C + 4);
        return this;
      }, B.prototype.toString = function() {
        const I = this.length;
        return I === 0 ? "" : arguments.length === 0 ? Pe(this, 0, I) : J.apply(this, arguments);
      }, B.prototype.toLocaleString = B.prototype.toString, B.prototype.equals = function(I) {
        if (!B.isBuffer(I))
          throw new TypeError("Argument must be a Buffer");
        return this === I ? !0 : B.compare(this, I) === 0;
      }, B.prototype.inspect = function() {
        let I = "";
        const C = S.INSPECT_MAX_BYTES;
        return I = this.toString("hex", 0, C).replace(/(.{2})/g, "$1 ").trim(), this.length > C && (I += " ... "), "<Buffer " + I + ">";
      }, x && (B.prototype[x] = B.prototype.inspect), B.prototype.compare = function(I, C, F, X, ne) {
        if (Ft(I, _) && (I = B.from(I, I.offset, I.byteLength)), !B.isBuffer(I))
          throw new TypeError(
            'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof I
          );
        if (C === void 0 && (C = 0), F === void 0 && (F = I ? I.length : 0), X === void 0 && (X = 0), ne === void 0 && (ne = this.length), C < 0 || F > I.length || X < 0 || ne > this.length)
          throw new RangeError("out of range index");
        if (X >= ne && C >= F)
          return 0;
        if (X >= ne)
          return -1;
        if (C >= F)
          return 1;
        if (C >>>= 0, F >>>= 0, X >>>= 0, ne >>>= 0, this === I)
          return 0;
        let de = ne - X, Me = F - C;
        const We = Math.min(de, Me), Ue = this.slice(X, ne), Ye = I.slice(C, F);
        for (let Ve = 0; Ve < We; ++Ve)
          if (Ue[Ve] !== Ye[Ve]) {
            de = Ue[Ve], Me = Ye[Ve];
            break;
          }
        return de < Me ? -1 : Me < de ? 1 : 0;
      };
      function A(D, I, C, F, X) {
        if (D.length === 0)
          return -1;
        if (typeof C == "string" ? (F = C, C = 0) : C > 2147483647 ? C = 2147483647 : C < -2147483648 && (C = -2147483648), C = +C, Dr(C) && (C = X ? 0 : D.length - 1), C < 0 && (C = D.length + C), C >= D.length) {
          if (X)
            return -1;
          C = D.length - 1;
        } else if (C < 0)
          if (X)
            C = 0;
          else
            return -1;
        if (typeof I == "string" && (I = B.from(I, F)), B.isBuffer(I))
          return I.length === 0 ? -1 : M(D, I, C, F, X);
        if (typeof I == "number")
          return I = I & 255, typeof _.prototype.indexOf == "function" ? X ? _.prototype.indexOf.call(D, I, C) : _.prototype.lastIndexOf.call(D, I, C) : M(D, [I], C, F, X);
        throw new TypeError("val must be string, number or Buffer");
      }
      function M(D, I, C, F, X) {
        let ne = 1, de = D.length, Me = I.length;
        if (F !== void 0 && (F = String(F).toLowerCase(), F === "ucs2" || F === "ucs-2" || F === "utf16le" || F === "utf-16le")) {
          if (D.length < 2 || I.length < 2)
            return -1;
          ne = 2, de /= 2, Me /= 2, C /= 2;
        }
        function We(Ye, Ve) {
          return ne === 1 ? Ye[Ve] : Ye.readUInt16BE(Ve * ne);
        }
        let Ue;
        if (X) {
          let Ye = -1;
          for (Ue = C; Ue < de; Ue++)
            if (We(D, Ue) === We(I, Ye === -1 ? 0 : Ue - Ye)) {
              if (Ye === -1 && (Ye = Ue), Ue - Ye + 1 === Me)
                return Ye * ne;
            } else
              Ye !== -1 && (Ue -= Ue - Ye), Ye = -1;
        } else
          for (C + Me > de && (C = de - Me), Ue = C; Ue >= 0; Ue--) {
            let Ye = !0;
            for (let Ve = 0; Ve < Me; Ve++)
              if (We(D, Ue + Ve) !== We(I, Ve)) {
                Ye = !1;
                break;
              }
            if (Ye)
              return Ue;
          }
        return -1;
      }
      B.prototype.includes = function(I, C, F) {
        return this.indexOf(I, C, F) !== -1;
      }, B.prototype.indexOf = function(I, C, F) {
        return A(this, I, C, F, !0);
      }, B.prototype.lastIndexOf = function(I, C, F) {
        return A(this, I, C, F, !1);
      };
      function q(D, I, C, F) {
        C = Number(C) || 0;
        const X = D.length - C;
        F ? (F = Number(F), F > X && (F = X)) : F = X;
        const ne = I.length;
        F > ne / 2 && (F = ne / 2);
        let de;
        for (de = 0; de < F; ++de) {
          const Me = parseInt(I.substr(de * 2, 2), 16);
          if (Dr(Me))
            return de;
          D[C + de] = Me;
        }
        return de;
      }
      function H(D, I, C, F) {
        return gn(Lr(I, D.length - C), D, C, F);
      }
      function le(D, I, C, F) {
        return gn(Uf(I), D, C, F);
      }
      function oe(D, I, C, F) {
        return gn(zo(I), D, C, F);
      }
      function he(D, I, C, F) {
        return gn(qf(I, D.length - C), D, C, F);
      }
      B.prototype.write = function(I, C, F, X) {
        if (C === void 0)
          X = "utf8", F = this.length, C = 0;
        else if (F === void 0 && typeof C == "string")
          X = C, F = this.length, C = 0;
        else if (isFinite(C))
          C = C >>> 0, isFinite(F) ? (F = F >>> 0, X === void 0 && (X = "utf8")) : (X = F, F = void 0);
        else
          throw new Error(
            "Buffer.write(string, encoding, offset[, length]) is no longer supported"
          );
        const ne = this.length - C;
        if ((F === void 0 || F > ne) && (F = ne), I.length > 0 && (F < 0 || C < 0) || C > this.length)
          throw new RangeError("Attempt to write outside buffer bounds");
        X || (X = "utf8");
        let de = !1;
        for (; ; )
          switch (X) {
            case "hex":
              return q(this, I, C, F);
            case "utf8":
            case "utf-8":
              return H(this, I, C, F);
            case "ascii":
            case "latin1":
            case "binary":
              return le(this, I, C, F);
            case "base64":
              return oe(this, I, C, F);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return he(this, I, C, F);
            default:
              if (de)
                throw new TypeError("Unknown encoding: " + X);
              X = ("" + X).toLowerCase(), de = !0;
          }
      }, B.prototype.toJSON = function() {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      function Ie(D, I, C) {
        return I === 0 && C === D.length ? b.fromByteArray(D) : b.fromByteArray(D.slice(I, C));
      }
      function Pe(D, I, C) {
        C = Math.min(D.length, C);
        const F = [];
        let X = I;
        for (; X < C; ) {
          const ne = D[X];
          let de = null, Me = ne > 239 ? 4 : ne > 223 ? 3 : ne > 191 ? 2 : 1;
          if (X + Me <= C) {
            let We, Ue, Ye, Ve;
            switch (Me) {
              case 1:
                ne < 128 && (de = ne);
                break;
              case 2:
                We = D[X + 1], (We & 192) === 128 && (Ve = (ne & 31) << 6 | We & 63, Ve > 127 && (de = Ve));
                break;
              case 3:
                We = D[X + 1], Ue = D[X + 2], (We & 192) === 128 && (Ue & 192) === 128 && (Ve = (ne & 15) << 12 | (We & 63) << 6 | Ue & 63, Ve > 2047 && (Ve < 55296 || Ve > 57343) && (de = Ve));
                break;
              case 4:
                We = D[X + 1], Ue = D[X + 2], Ye = D[X + 3], (We & 192) === 128 && (Ue & 192) === 128 && (Ye & 192) === 128 && (Ve = (ne & 15) << 18 | (We & 63) << 12 | (Ue & 63) << 6 | Ye & 63, Ve > 65535 && Ve < 1114112 && (de = Ve));
            }
          }
          de === null ? (de = 65533, Me = 1) : de > 65535 && (de -= 65536, F.push(de >>> 10 & 1023 | 55296), de = 56320 | de & 1023), F.push(de), X += Me;
        }
        return bt(F);
      }
      const He = 4096;
      function bt(D) {
        const I = D.length;
        if (I <= He)
          return String.fromCharCode.apply(String, D);
        let C = "", F = 0;
        for (; F < I; )
          C += String.fromCharCode.apply(
            String,
            D.slice(F, F += He)
          );
        return C;
      }
      function mt(D, I, C) {
        let F = "";
        C = Math.min(D.length, C);
        for (let X = I; X < C; ++X)
          F += String.fromCharCode(D[X] & 127);
        return F;
      }
      function ue(D, I, C) {
        let F = "";
        C = Math.min(D.length, C);
        for (let X = I; X < C; ++X)
          F += String.fromCharCode(D[X]);
        return F;
      }
      function Tt(D, I, C) {
        const F = D.length;
        (!I || I < 0) && (I = 0), (!C || C < 0 || C > F) && (C = F);
        let X = "";
        for (let ne = I; ne < C; ++ne)
          X += Gf[D[ne]];
        return X;
      }
      function Ot(D, I, C) {
        const F = D.slice(I, C);
        let X = "";
        for (let ne = 0; ne < F.length - 1; ne += 2)
          X += String.fromCharCode(F[ne] + F[ne + 1] * 256);
        return X;
      }
      B.prototype.slice = function(I, C) {
        const F = this.length;
        I = ~~I, C = C === void 0 ? F : ~~C, I < 0 ? (I += F, I < 0 && (I = 0)) : I > F && (I = F), C < 0 ? (C += F, C < 0 && (C = 0)) : C > F && (C = F), C < I && (C = I);
        const X = this.subarray(I, C);
        return Object.setPrototypeOf(X, B.prototype), X;
      };
      function Le(D, I, C) {
        if (D % 1 !== 0 || D < 0)
          throw new RangeError("offset is not uint");
        if (D + I > C)
          throw new RangeError("Trying to access beyond buffer length");
      }
      B.prototype.readUintLE = B.prototype.readUIntLE = function(I, C, F) {
        I = I >>> 0, C = C >>> 0, F || Le(I, C, this.length);
        let X = this[I], ne = 1, de = 0;
        for (; ++de < C && (ne *= 256); )
          X += this[I + de] * ne;
        return X;
      }, B.prototype.readUintBE = B.prototype.readUIntBE = function(I, C, F) {
        I = I >>> 0, C = C >>> 0, F || Le(I, C, this.length);
        let X = this[I + --C], ne = 1;
        for (; C > 0 && (ne *= 256); )
          X += this[I + --C] * ne;
        return X;
      }, B.prototype.readUint8 = B.prototype.readUInt8 = function(I, C) {
        return I = I >>> 0, C || Le(I, 1, this.length), this[I];
      }, B.prototype.readUint16LE = B.prototype.readUInt16LE = function(I, C) {
        return I = I >>> 0, C || Le(I, 2, this.length), this[I] | this[I + 1] << 8;
      }, B.prototype.readUint16BE = B.prototype.readUInt16BE = function(I, C) {
        return I = I >>> 0, C || Le(I, 2, this.length), this[I] << 8 | this[I + 1];
      }, B.prototype.readUint32LE = B.prototype.readUInt32LE = function(I, C) {
        return I = I >>> 0, C || Le(I, 4, this.length), (this[I] | this[I + 1] << 8 | this[I + 2] << 16) + this[I + 3] * 16777216;
      }, B.prototype.readUint32BE = B.prototype.readUInt32BE = function(I, C) {
        return I = I >>> 0, C || Le(I, 4, this.length), this[I] * 16777216 + (this[I + 1] << 16 | this[I + 2] << 8 | this[I + 3]);
      }, B.prototype.readBigUInt64LE = mi(function(I) {
        I = I >>> 0, Qi(I, "offset");
        const C = this[I], F = this[I + 7];
        (C === void 0 || F === void 0) && _s(I, this.length - 8);
        const X = C + this[++I] * 2 ** 8 + this[++I] * 2 ** 16 + this[++I] * 2 ** 24, ne = this[++I] + this[++I] * 2 ** 8 + this[++I] * 2 ** 16 + F * 2 ** 24;
        return BigInt(X) + (BigInt(ne) << BigInt(32));
      }), B.prototype.readBigUInt64BE = mi(function(I) {
        I = I >>> 0, Qi(I, "offset");
        const C = this[I], F = this[I + 7];
        (C === void 0 || F === void 0) && _s(I, this.length - 8);
        const X = C * 2 ** 24 + this[++I] * 2 ** 16 + this[++I] * 2 ** 8 + this[++I], ne = this[++I] * 2 ** 24 + this[++I] * 2 ** 16 + this[++I] * 2 ** 8 + F;
        return (BigInt(X) << BigInt(32)) + BigInt(ne);
      }), B.prototype.readIntLE = function(I, C, F) {
        I = I >>> 0, C = C >>> 0, F || Le(I, C, this.length);
        let X = this[I], ne = 1, de = 0;
        for (; ++de < C && (ne *= 256); )
          X += this[I + de] * ne;
        return ne *= 128, X >= ne && (X -= Math.pow(2, 8 * C)), X;
      }, B.prototype.readIntBE = function(I, C, F) {
        I = I >>> 0, C = C >>> 0, F || Le(I, C, this.length);
        let X = C, ne = 1, de = this[I + --X];
        for (; X > 0 && (ne *= 256); )
          de += this[I + --X] * ne;
        return ne *= 128, de >= ne && (de -= Math.pow(2, 8 * C)), de;
      }, B.prototype.readInt8 = function(I, C) {
        return I = I >>> 0, C || Le(I, 1, this.length), this[I] & 128 ? (255 - this[I] + 1) * -1 : this[I];
      }, B.prototype.readInt16LE = function(I, C) {
        I = I >>> 0, C || Le(I, 2, this.length);
        const F = this[I] | this[I + 1] << 8;
        return F & 32768 ? F | 4294901760 : F;
      }, B.prototype.readInt16BE = function(I, C) {
        I = I >>> 0, C || Le(I, 2, this.length);
        const F = this[I + 1] | this[I] << 8;
        return F & 32768 ? F | 4294901760 : F;
      }, B.prototype.readInt32LE = function(I, C) {
        return I = I >>> 0, C || Le(I, 4, this.length), this[I] | this[I + 1] << 8 | this[I + 2] << 16 | this[I + 3] << 24;
      }, B.prototype.readInt32BE = function(I, C) {
        return I = I >>> 0, C || Le(I, 4, this.length), this[I] << 24 | this[I + 1] << 16 | this[I + 2] << 8 | this[I + 3];
      }, B.prototype.readBigInt64LE = mi(function(I) {
        I = I >>> 0, Qi(I, "offset");
        const C = this[I], F = this[I + 7];
        (C === void 0 || F === void 0) && _s(I, this.length - 8);
        const X = this[I + 4] + this[I + 5] * 2 ** 8 + this[I + 6] * 2 ** 16 + (F << 24);
        return (BigInt(X) << BigInt(32)) + BigInt(C + this[++I] * 2 ** 8 + this[++I] * 2 ** 16 + this[++I] * 2 ** 24);
      }), B.prototype.readBigInt64BE = mi(function(I) {
        I = I >>> 0, Qi(I, "offset");
        const C = this[I], F = this[I + 7];
        (C === void 0 || F === void 0) && _s(I, this.length - 8);
        const X = (C << 24) + // Overflow
        this[++I] * 2 ** 16 + this[++I] * 2 ** 8 + this[++I];
        return (BigInt(X) << BigInt(32)) + BigInt(this[++I] * 2 ** 24 + this[++I] * 2 ** 16 + this[++I] * 2 ** 8 + F);
      }), B.prototype.readFloatLE = function(I, C) {
        return I = I >>> 0, C || Le(I, 4, this.length), T.read(this, I, !0, 23, 4);
      }, B.prototype.readFloatBE = function(I, C) {
        return I = I >>> 0, C || Le(I, 4, this.length), T.read(this, I, !1, 23, 4);
      }, B.prototype.readDoubleLE = function(I, C) {
        return I = I >>> 0, C || Le(I, 8, this.length), T.read(this, I, !0, 52, 8);
      }, B.prototype.readDoubleBE = function(I, C) {
        return I = I >>> 0, C || Le(I, 8, this.length), T.read(this, I, !1, 52, 8);
      };
      function De(D, I, C, F, X, ne) {
        if (!B.isBuffer(D))
          throw new TypeError('"buffer" argument must be a Buffer instance');
        if (I > X || I < ne)
          throw new RangeError('"value" argument is out of bounds');
        if (C + F > D.length)
          throw new RangeError("Index out of range");
      }
      B.prototype.writeUintLE = B.prototype.writeUIntLE = function(I, C, F, X) {
        if (I = +I, C = C >>> 0, F = F >>> 0, !X) {
          const Me = Math.pow(2, 8 * F) - 1;
          De(this, I, C, F, Me, 0);
        }
        let ne = 1, de = 0;
        for (this[C] = I & 255; ++de < F && (ne *= 256); )
          this[C + de] = I / ne & 255;
        return C + F;
      }, B.prototype.writeUintBE = B.prototype.writeUIntBE = function(I, C, F, X) {
        if (I = +I, C = C >>> 0, F = F >>> 0, !X) {
          const Me = Math.pow(2, 8 * F) - 1;
          De(this, I, C, F, Me, 0);
        }
        let ne = F - 1, de = 1;
        for (this[C + ne] = I & 255; --ne >= 0 && (de *= 256); )
          this[C + ne] = I / de & 255;
        return C + F;
      }, B.prototype.writeUint8 = B.prototype.writeUInt8 = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 1, 255, 0), this[C] = I & 255, C + 1;
      }, B.prototype.writeUint16LE = B.prototype.writeUInt16LE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 2, 65535, 0), this[C] = I & 255, this[C + 1] = I >>> 8, C + 2;
      }, B.prototype.writeUint16BE = B.prototype.writeUInt16BE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 2, 65535, 0), this[C] = I >>> 8, this[C + 1] = I & 255, C + 2;
      }, B.prototype.writeUint32LE = B.prototype.writeUInt32LE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 4, 4294967295, 0), this[C + 3] = I >>> 24, this[C + 2] = I >>> 16, this[C + 1] = I >>> 8, this[C] = I & 255, C + 4;
      }, B.prototype.writeUint32BE = B.prototype.writeUInt32BE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 4, 4294967295, 0), this[C] = I >>> 24, this[C + 1] = I >>> 16, this[C + 2] = I >>> 8, this[C + 3] = I & 255, C + 4;
      };
      function Je(D, I, C, F, X) {
        pn(I, F, X, D, C, 7);
        let ne = Number(I & BigInt(4294967295));
        D[C++] = ne, ne = ne >> 8, D[C++] = ne, ne = ne >> 8, D[C++] = ne, ne = ne >> 8, D[C++] = ne;
        let de = Number(I >> BigInt(32) & BigInt(4294967295));
        return D[C++] = de, de = de >> 8, D[C++] = de, de = de >> 8, D[C++] = de, de = de >> 8, D[C++] = de, C;
      }
      function nt(D, I, C, F, X) {
        pn(I, F, X, D, C, 7);
        let ne = Number(I & BigInt(4294967295));
        D[C + 7] = ne, ne = ne >> 8, D[C + 6] = ne, ne = ne >> 8, D[C + 5] = ne, ne = ne >> 8, D[C + 4] = ne;
        let de = Number(I >> BigInt(32) & BigInt(4294967295));
        return D[C + 3] = de, de = de >> 8, D[C + 2] = de, de = de >> 8, D[C + 1] = de, de = de >> 8, D[C] = de, C + 8;
      }
      B.prototype.writeBigUInt64LE = mi(function(I, C = 0) {
        return Je(this, I, C, BigInt(0), BigInt("0xffffffffffffffff"));
      }), B.prototype.writeBigUInt64BE = mi(function(I, C = 0) {
        return nt(this, I, C, BigInt(0), BigInt("0xffffffffffffffff"));
      }), B.prototype.writeIntLE = function(I, C, F, X) {
        if (I = +I, C = C >>> 0, !X) {
          const We = Math.pow(2, 8 * F - 1);
          De(this, I, C, F, We - 1, -We);
        }
        let ne = 0, de = 1, Me = 0;
        for (this[C] = I & 255; ++ne < F && (de *= 256); )
          I < 0 && Me === 0 && this[C + ne - 1] !== 0 && (Me = 1), this[C + ne] = (I / de >> 0) - Me & 255;
        return C + F;
      }, B.prototype.writeIntBE = function(I, C, F, X) {
        if (I = +I, C = C >>> 0, !X) {
          const We = Math.pow(2, 8 * F - 1);
          De(this, I, C, F, We - 1, -We);
        }
        let ne = F - 1, de = 1, Me = 0;
        for (this[C + ne] = I & 255; --ne >= 0 && (de *= 256); )
          I < 0 && Me === 0 && this[C + ne + 1] !== 0 && (Me = 1), this[C + ne] = (I / de >> 0) - Me & 255;
        return C + F;
      }, B.prototype.writeInt8 = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 1, 127, -128), I < 0 && (I = 255 + I + 1), this[C] = I & 255, C + 1;
      }, B.prototype.writeInt16LE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 2, 32767, -32768), this[C] = I & 255, this[C + 1] = I >>> 8, C + 2;
      }, B.prototype.writeInt16BE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 2, 32767, -32768), this[C] = I >>> 8, this[C + 1] = I & 255, C + 2;
      }, B.prototype.writeInt32LE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 4, 2147483647, -2147483648), this[C] = I & 255, this[C + 1] = I >>> 8, this[C + 2] = I >>> 16, this[C + 3] = I >>> 24, C + 4;
      }, B.prototype.writeInt32BE = function(I, C, F) {
        return I = +I, C = C >>> 0, F || De(this, I, C, 4, 2147483647, -2147483648), I < 0 && (I = 4294967295 + I + 1), this[C] = I >>> 24, this[C + 1] = I >>> 16, this[C + 2] = I >>> 8, this[C + 3] = I & 255, C + 4;
      }, B.prototype.writeBigInt64LE = mi(function(I, C = 0) {
        return Je(this, I, C, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      }), B.prototype.writeBigInt64BE = mi(function(I, C = 0) {
        return nt(this, I, C, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      function ks(D, I, C, F, X, ne) {
        if (C + F > D.length)
          throw new RangeError("Index out of range");
        if (C < 0)
          throw new RangeError("Index out of range");
      }
      function Es(D, I, C, F, X) {
        return I = +I, C = C >>> 0, X || ks(D, I, C, 4), T.write(D, I, C, F, 23, 4), C + 4;
      }
      B.prototype.writeFloatLE = function(I, C, F) {
        return Es(this, I, C, !0, F);
      }, B.prototype.writeFloatBE = function(I, C, F) {
        return Es(this, I, C, !1, F);
      };
      function Ns(D, I, C, F, X) {
        return I = +I, C = C >>> 0, X || ks(D, I, C, 8), T.write(D, I, C, F, 52, 8), C + 8;
      }
      B.prototype.writeDoubleLE = function(I, C, F) {
        return Ns(this, I, C, !0, F);
      }, B.prototype.writeDoubleBE = function(I, C, F) {
        return Ns(this, I, C, !1, F);
      }, B.prototype.copy = function(I, C, F, X) {
        if (!B.isBuffer(I))
          throw new TypeError("argument should be a Buffer");
        if (F || (F = 0), !X && X !== 0 && (X = this.length), C >= I.length && (C = I.length), C || (C = 0), X > 0 && X < F && (X = F), X === F || I.length === 0 || this.length === 0)
          return 0;
        if (C < 0)
          throw new RangeError("targetStart out of bounds");
        if (F < 0 || F >= this.length)
          throw new RangeError("Index out of range");
        if (X < 0)
          throw new RangeError("sourceEnd out of bounds");
        X > this.length && (X = this.length), I.length - C < X - F && (X = I.length - C + F);
        const ne = X - F;
        return this === I && typeof _.prototype.copyWithin == "function" ? this.copyWithin(C, F, X) : _.prototype.set.call(
          I,
          this.subarray(F, X),
          C
        ), ne;
      }, B.prototype.fill = function(I, C, F, X) {
        if (typeof I == "string") {
          if (typeof C == "string" ? (X = C, C = 0, F = this.length) : typeof F == "string" && (X = F, F = this.length), X !== void 0 && typeof X != "string")
            throw new TypeError("encoding must be a string");
          if (typeof X == "string" && !B.isEncoding(X))
            throw new TypeError("Unknown encoding: " + X);
          if (I.length === 1) {
            const de = I.charCodeAt(0);
            (X === "utf8" && de < 128 || X === "latin1") && (I = de);
          }
        } else
          typeof I == "number" ? I = I & 255 : typeof I == "boolean" && (I = Number(I));
        if (C < 0 || this.length < C || this.length < F)
          throw new RangeError("Out of range index");
        if (F <= C)
          return this;
        C = C >>> 0, F = F === void 0 ? this.length : F >>> 0, I || (I = 0);
        let ne;
        if (typeof I == "number")
          for (ne = C; ne < F; ++ne)
            this[ne] = I;
        else {
          const de = B.isBuffer(I) ? I : B.from(I, X), Me = de.length;
          if (Me === 0)
            throw new TypeError('The value "' + I + '" is invalid for argument "value"');
          for (ne = 0; ne < F - C; ++ne)
            this[ne + C] = de[ne % Me];
        }
        return this;
      };
      const Qt = {};
      function Ps(D, I, C) {
        Qt[D] = class extends C {
          constructor() {
            super(), Object.defineProperty(this, "message", {
              value: I.apply(this, arguments),
              writable: !0,
              configurable: !0
            }), this.name = `${this.name} [${D}]`, this.stack, delete this.name;
          }
          get code() {
            return D;
          }
          set code(X) {
            Object.defineProperty(this, "code", {
              configurable: !0,
              enumerable: !0,
              value: X,
              writable: !0
            });
          }
          toString() {
            return `${this.name} [${D}]: ${this.message}`;
          }
        };
      }
      Ps(
        "ERR_BUFFER_OUT_OF_BOUNDS",
        function(D) {
          return D ? `${D} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
        },
        RangeError
      ), Ps(
        "ERR_INVALID_ARG_TYPE",
        function(D, I) {
          return `The "${D}" argument must be of type number. Received type ${typeof I}`;
        },
        TypeError
      ), Ps(
        "ERR_OUT_OF_RANGE",
        function(D, I, C) {
          let F = `The value of "${D}" is out of range.`, X = C;
          return Number.isInteger(C) && Math.abs(C) > 2 ** 32 ? X = ln(String(C)) : typeof C == "bigint" && (X = String(C), (C > BigInt(2) ** BigInt(32) || C < -(BigInt(2) ** BigInt(32))) && (X = ln(X)), X += "n"), F += ` It must be ${I}. Received ${X}`, F;
        },
        RangeError
      );
      function ln(D) {
        let I = "", C = D.length;
        const F = D[0] === "-" ? 1 : 0;
        for (; C >= F + 4; C -= 3)
          I = `_${D.slice(C - 3, C)}${I}`;
        return `${D.slice(0, C)}${I}`;
      }
      function _r(D, I, C) {
        Qi(I, "offset"), (D[I] === void 0 || D[I + C] === void 0) && _s(I, D.length - (C + 1));
      }
      function pn(D, I, C, F, X, ne) {
        if (D > C || D < I) {
          const de = typeof I == "bigint" ? "n" : "";
          let Me;
          throw ne > 3 ? I === 0 || I === BigInt(0) ? Me = `>= 0${de} and < 2${de} ** ${(ne + 1) * 8}${de}` : Me = `>= -(2${de} ** ${(ne + 1) * 8 - 1}${de}) and < 2 ** ${(ne + 1) * 8 - 1}${de}` : Me = `>= ${I}${de} and <= ${C}${de}`, new Qt.ERR_OUT_OF_RANGE("value", Me, D);
        }
        _r(F, X, ne);
      }
      function Qi(D, I) {
        if (typeof D != "number")
          throw new Qt.ERR_INVALID_ARG_TYPE(I, "number", D);
      }
      function _s(D, I, C) {
        throw Math.floor(D) !== D ? (Qi(D, C), new Qt.ERR_OUT_OF_RANGE(C || "offset", "an integer", D)) : I < 0 ? new Qt.ERR_BUFFER_OUT_OF_BOUNDS() : new Qt.ERR_OUT_OF_RANGE(
          C || "offset",
          `>= ${C ? 1 : 0} and <= ${I}`,
          D
        );
      }
      const jf = /[^+/0-9A-Za-z-_]/g;
      function Ff(D) {
        if (D = D.split("=")[0], D = D.trim().replace(jf, ""), D.length < 2)
          return "";
        for (; D.length % 4 !== 0; )
          D = D + "=";
        return D;
      }
      function Lr(D, I) {
        I = I || 1 / 0;
        let C;
        const F = D.length;
        let X = null;
        const ne = [];
        for (let de = 0; de < F; ++de) {
          if (C = D.charCodeAt(de), C > 55295 && C < 57344) {
            if (!X) {
              if (C > 56319) {
                (I -= 3) > -1 && ne.push(239, 191, 189);
                continue;
              } else if (de + 1 === F) {
                (I -= 3) > -1 && ne.push(239, 191, 189);
                continue;
              }
              X = C;
              continue;
            }
            if (C < 56320) {
              (I -= 3) > -1 && ne.push(239, 191, 189), X = C;
              continue;
            }
            C = (X - 55296 << 10 | C - 56320) + 65536;
          } else
            X && (I -= 3) > -1 && ne.push(239, 191, 189);
          if (X = null, C < 128) {
            if ((I -= 1) < 0)
              break;
            ne.push(C);
          } else if (C < 2048) {
            if ((I -= 2) < 0)
              break;
            ne.push(
              C >> 6 | 192,
              C & 63 | 128
            );
          } else if (C < 65536) {
            if ((I -= 3) < 0)
              break;
            ne.push(
              C >> 12 | 224,
              C >> 6 & 63 | 128,
              C & 63 | 128
            );
          } else if (C < 1114112) {
            if ((I -= 4) < 0)
              break;
            ne.push(
              C >> 18 | 240,
              C >> 12 & 63 | 128,
              C >> 6 & 63 | 128,
              C & 63 | 128
            );
          } else
            throw new Error("Invalid code point");
        }
        return ne;
      }
      function Uf(D) {
        const I = [];
        for (let C = 0; C < D.length; ++C)
          I.push(D.charCodeAt(C) & 255);
        return I;
      }
      function qf(D, I) {
        let C, F, X;
        const ne = [];
        for (let de = 0; de < D.length && !((I -= 2) < 0); ++de)
          C = D.charCodeAt(de), F = C >> 8, X = C % 256, ne.push(X), ne.push(F);
        return ne;
      }
      function zo(D) {
        return b.toByteArray(Ff(D));
      }
      function gn(D, I, C, F) {
        let X;
        for (X = 0; X < F && !(X + C >= I.length || X >= D.length); ++X)
          I[X + C] = D[X];
        return X;
      }
      function Ft(D, I) {
        return D instanceof I || D != null && D.constructor != null && D.constructor.name != null && D.constructor.name === I.name;
      }
      function Dr(D) {
        return D !== D;
      }
      const Gf = function() {
        const D = "0123456789abcdef", I = new Array(256);
        for (let C = 0; C < 16; ++C) {
          const F = C * 16;
          for (let X = 0; X < 16; ++X)
            I[F + X] = D[C] + D[X];
        }
        return I;
      }();
      function mi(D) {
        return typeof BigInt > "u" ? zf : D;
      }
      function zf() {
        throw new Error("BigInt not supported");
      }
    })(e);
    const w = e.Buffer;
    d.Buffer = e.Buffer, d.default = w;
  }(Rr)), Rr;
}
var Xf = nn();
const $f = /* @__PURE__ */ Kf(Xf);
function Zf(d) {
  return d && d.__esModule && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d;
}
var pc = { exports: {} }, Ze = pc.exports = {}, Gt, zt;
function ma() {
  throw new Error("setTimeout has not been defined");
}
function ya() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Gt = setTimeout : Gt = ma;
  } catch {
    Gt = ma;
  }
  try {
    typeof clearTimeout == "function" ? zt = clearTimeout : zt = ya;
  } catch {
    zt = ya;
  }
})();
function gc(d) {
  if (Gt === setTimeout)
    return setTimeout(d, 0);
  if ((Gt === ma || !Gt) && setTimeout)
    return Gt = setTimeout, setTimeout(d, 0);
  try {
    return Gt(d, 0);
  } catch {
    try {
      return Gt.call(null, d, 0);
    } catch {
      return Gt.call(this, d, 0);
    }
  }
}
function Qf(d) {
  if (zt === clearTimeout)
    return clearTimeout(d);
  if ((zt === ya || !zt) && clearTimeout)
    return zt = clearTimeout, clearTimeout(d);
  try {
    return zt(d);
  } catch {
    try {
      return zt.call(null, d);
    } catch {
      return zt.call(this, d);
    }
  }
}
var ii = [], us = !1, Ui, _n = -1;
function Jf() {
  !us || !Ui || (us = !1, Ui.length ? ii = Ui.concat(ii) : _n = -1, ii.length && mc());
}
function mc() {
  if (!us) {
    var d = gc(Jf);
    us = !0;
    for (var e = ii.length; e; ) {
      for (Ui = ii, ii = []; ++_n < e; )
        Ui && Ui[_n].run();
      _n = -1, e = ii.length;
    }
    Ui = null, us = !1, Qf(d);
  }
}
Ze.nextTick = function(d) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      e[t - 1] = arguments[t];
  ii.push(new yc(d, e)), ii.length === 1 && !us && gc(mc);
};
function yc(d, e) {
  this.fun = d, this.array = e;
}
yc.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Ze.title = "browser";
Ze.browser = !0;
Ze.env = {};
Ze.argv = [];
Ze.version = "";
Ze.versions = {};
function ci() {
}
Ze.on = ci;
Ze.addListener = ci;
Ze.once = ci;
Ze.off = ci;
Ze.removeListener = ci;
Ze.removeAllListeners = ci;
Ze.emit = ci;
Ze.prependListener = ci;
Ze.prependOnceListener = ci;
Ze.listeners = function(d) {
  return [];
};
Ze.binding = function(d) {
  throw new Error("process.binding is not supported");
};
Ze.cwd = function() {
  return "/";
};
Ze.chdir = function(d) {
  throw new Error("process.chdir is not supported");
};
Ze.umask = function() {
  return 0;
};
var eh = pc.exports;
const Ce = /* @__PURE__ */ Zf(eh), wc = typeof window < "u", th = typeof Ce < "u" && typeof Ce.versions < "u" && typeof Ce.versions.electron < "u", bc = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, ih = typeof Ce < "u" && Ce.platform === "win32", sh = !(wc || bc), ut = Number.isFinite, nh = Number.isInteger, Os = Array.isArray, rn = (d) => d != null, Wa = (d) => typeof d == "string", rr = (d) => d !== null && typeof d == "object", rh = (d) => d instanceof RegExp, wa = (d) => rr(d) && Object.getPrototypeOf(d) === Object.prototype && !Os(d) && !rh(d), $t = (d) => rn(d) && d.toString || ut(d), Zt = (d, e) => rr(d) && d[e] !== "" && d[e] !== null ? d[e] : void 0, _i = (d, e, t) => rr(d) ? d[e] !== void 0 && d[e] !== "" && d[e] !== null ? d[e] : d[t] !== "" && d[t] !== null ? d[t] : void 0 : void 0, Li = (d, e) => d[e.find((t) => Zt(d, t) !== void 0)], ui = (d) => ut(d) || Wa(d) && d.length !== 0 ? parseFloat(d) : NaN, Ms = (d) => ut(d) || Wa(d) && d.length !== 0 ? Math.trunc(Number(d)) : NaN, ah = (d, e, t) => {
  const i = ui(Zt(d, e));
  return ut(i) ? i : t;
}, oh = (d, e, t) => {
  const i = Ms(Zt(d, e));
  return ut(i) ? i : t;
}, dh = (d, e, t, i) => {
  const s = ui(Zt(d, e));
  return ut(s) ? parseInt(s * t) : i;
}, ch = (d, e, t) => {
  const i = ui(Zt(d, e));
  return ut(i) ? parseInt(i * 1e3) : t;
}, uh = (d, e, t) => {
  const i = Zt(d, e);
  return rn(i) ? i : t;
}, fh = (d, e, t) => {
  const i = Zt(d, e);
  return $t(i) ? String(i) : t;
}, hh = (d, e, t) => {
  const i = Zt(d, e);
  return $t(i) ? String(i).toLowerCase() : t;
}, lh = (d, e, t) => {
  const i = Zt(d, e);
  return $t(i) ? String(i).toUpperCase() : t;
}, ph = (d, e, t, i) => {
  const s = ui(_i(d, e, t));
  return ut(s) ? s : i;
}, gh = (d, e, t, i) => {
  const s = Ms(_i(d, e, t));
  return ut(s) ? s : i;
}, mh = (d, e, t, i, s) => {
  const n = Ms(_i(d, e, t));
  return ut(n) ? parseInt(n * i) : s;
}, yh = (d, e, t, i) => {
  const s = ui(_i(d, e, t));
  return ut(s) ? parseInt(s * 1e3) : i;
}, wh = (d, e, t, i) => {
  const s = _i(d, e, t);
  return rn(s) ? s : i;
}, bh = (d, e, t, i) => {
  const s = _i(d, e, t);
  return $t(s) ? String(s) : i;
}, Sh = (d, e, t, i) => {
  const s = _i(d, e, t);
  return $t(s) ? String(s).toLowerCase() : i;
}, Th = (d, e, t, i) => {
  const s = _i(d, e, t);
  return $t(s) ? String(s).toUpperCase() : i;
}, Ah = (d, e, t) => {
  const i = ui(Li(d, e));
  return ut(i) ? i : t;
}, Ih = (d, e, t) => {
  if (d === void 0)
    return t;
  const i = Ms(Li(d, e));
  return ut(i) ? i : t;
}, Oh = (d, e, t, i) => {
  const s = Ms(Li(d, e));
  return ut(s) ? parseInt(s * t) : i;
}, Mh = (d, e, t) => {
  const i = ui(Li(d, e));
  return ut(i) ? parseInt(i * 1e3) : t;
}, Ch = (d, e, t) => {
  if (d === void 0)
    return t;
  const i = Li(d, e);
  return rn(i) ? i : t;
}, xh = (d, e, t) => {
  if (d === void 0)
    return t;
  const i = Li(d, e);
  return $t(i) ? String(i) : t;
}, vh = (d, e, t) => {
  if (d === void 0)
    return t;
  const i = Li(d, e);
  return $t(i) ? String(i).toLowerCase() : t;
}, kh = (d, e, t) => {
  const i = Li(d, e);
  return $t(i) ? String(i).toUpperCase() : t;
}, Ya = Object.keys, $i = (d) => Os(d) ? d : Object.values(d), Sc = (d) => new Set($i(d)), Tc = (...d) => Object.assign({}, ...d), Ac = (d) => Os(d) ? Array.from(d) : Tc(d), Eh = (d) => d, Nh = (d) => Array.from(Sc(d)), Ph = (d, e) => d.concat(e), _h = (d, e) => e.includes(d), Lh = (d) => Object.values(d), Dh = (d) => d ? (Array.isArray(d) ? d : Object.keys(d)).length < 1 : !0, Rh = (d, e = {}) => {
  for (const t of Ya(d).sort())
    e[t] = d[t];
  return e;
}, Bh = (d, e, t = {}) => {
  for (const i of $i(d))
    if (e in i) {
      const s = i[e];
      t[s] = t[s] || [], t[s].push(i);
    }
  return t;
}, Vh = (d, e, t = {}) => {
  for (const i of $i(d))
    e in i && (t[i[e]] = i);
  return t;
}, jh = (d, e, t = void 0, i = []) => {
  for (const s of $i(d))
    s[e] === t && i.push(s);
  return i;
}, Fh = (d, e, t = !1, i = 0, s = t ? -1 : 1) => d.sort((n, r) => {
  const a = e in n ? n[e] : i, o = e in r ? r[e] : i;
  return a < o ? -s : a > o ? s : 0;
}), Uh = (d, e, t, i = !1, s = i ? -1 : 1) => d.sort((n, r) => n[e] < r[e] ? -s : n[e] > r[e] ? s : n[t] < r[t] ? -s : n[t] > r[t] ? s : 0), qh = function d(e, t = []) {
  for (const i of e)
    Os(i) ? d(i, t) : t.push(i);
  return t;
}, Gh = (d, e) => $i(d).filter((t) => e in t).map((t) => t[e]), zh = (d, ...e) => {
  if (!Array.isArray(d)) {
    const t = Ac(d);
    for (const i of e)
      if (Os(i))
        for (const s of i)
          delete t[s];
      else
        delete t[i];
    return t;
  }
  return d;
}, Hh = (...d) => {
  const e = d.filter(ut);
  return e.length > 0 ? e.reduce((t, i) => t + i, 0) : void 0;
}, Wh = function d(...e) {
  let t;
  for (const i of e)
    if (wa(i)) {
      wa(t) || (t = {});
      for (const s in i)
        t[s] = d(t[s], i[s]);
    } else
      t = i;
  return t;
}, Yh = (d, ...e) => {
  const t = {}, i = Object.assign({}, ...e), s = Object.keys(i);
  for (let n = 0; n < s.length; n++) {
    const r = s[n];
    d[r] === void 0 && (t[r] = i[r]);
  }
  return Object.assign({}, d, t);
}, Kh = (d) => {
  const e = {
    fetchOHLCVWs: "fetch_ohlcv_ws"
    // ws = websocket
  };
  return e[d] ? e[d] : d.match(/[A-Z]/) ? d.replace(/[a-z0-9][A-Z]/g, (t) => t[0] + "_" + t[1]).replace(/[A-Z0-9][A-Z0-9][a-z][^$]/g, (t) => t[0] + "_" + t[1] + t[2] + t[3]).replace(/[a-z][0-9]$/g, (t) => t[0] + "_" + t[1]).toLowerCase() : d;
}, Xh = (d) => d.length ? d.charAt(0).toUpperCase() + d.slice(1) : d, $h = (d) => d.replace(/^\s+|\s+$/g, ""), Ic = (d) => d ? (d ^ Math.random() * 16 >> d / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, Ic), Oc = (d) => d ? (d ^ Math.random() * 16 >> d / 4).toString(16) : ([1e5] + 100 + 400 + 8e3).replace(/[018]/g, Oc), Mc = (d) => d ? (d ^ Math.random() * 16 >> d / 4).toString(16) : ([1e7] + 1e3 + 4e3 + 8e5).replace(/[018]/g, Mc), Et = 0, Dt = 1, ar = 2, Ka = 3, St = 2, or = 3, ct = 4, Ht = 5, Cc = 6, Zh = {
  ROUND: Dt,
  TRUNCATE: Et,
  ROUND_UP: ar,
  ROUND_DOWN: Ka,
  DECIMAL_PLACES: St,
  SIGNIFICANT_DIGITS: or,
  TICK_SIZE: ct,
  NO_PADDING: Ht,
  PAD_WITH_ZERO: Cc
}, xc = 22, Qh = 2;
function Xa(d) {
  if (d === void 0)
    return;
  if (typeof d != "number")
    return d.toString();
  const e = d.toString();
  if (Math.abs(d) < 1) {
    const t = e.split("e-"), i = t[0].replace(".", ""), s = parseInt(t[1]), n = e[0] === "-";
    if (s)
      return d = (n ? "-" : "") + "0." + new Array(s).join("0") + i.substring(n), d;
  } else {
    const t = e.split("e");
    if (t[1]) {
      let i = parseInt(t[1]);
      const s = t[0].split(".");
      let n = "";
      return s[1] && (i -= s[1].length, n = s[1]), s[0] + n + new Array(i + 1).join("0");
    }
  }
  return e;
}
const Wo = [], vc = (d, e = 0) => {
  if (d = Xa(d), e > 0) {
    const t = Wo[e] || (Wo[e] = new RegExp("([-]*\\d+\\.\\d{" + e + "})(\\d)")), [, i] = d.toString().match(t) || [null, d];
    return i.toString();
  }
  return parseInt(d).toString();
}, Jh = (d, e = 0) => parseFloat(vc(d, e));
function qn(d) {
  if (d.indexOf("e") > -1) {
    const t = d.replace(/\de/, "");
    return parseInt(t) * -1;
  }
  const e = d.replace(/0+$/g, "").split(".");
  return e.length > 1 ? e[1].length : 0;
}
const el = (d, e, t, i = St, s = Ht, n = !1) => {
  let r = t;
  if (typeof r == "string" && (r = parseFloat(r)), !n) {
    if (i === ct) {
      const a = Mi(r, Dt, xc, St, Ht);
      r = qn(a);
    }
    d = Mi(d, Dt, r + Qh, St, Ht);
  }
  return Mi(d, e, t, i, s);
}, Mi = (d, e, t, i = St, s = Ht) => {
  if (i === ct && (typeof t == "string" && (t = parseFloat(t)), t <= 0))
    throw new Error("TICK_SIZE cant be used with negative or zero numPrecisionDigits");
  if (t < 0) {
    const U = Math.pow(10, -t);
    if (e === Dt)
      return (U * Mi(d / U, e, 0, i, s)).toString();
    if (e === Et)
      return (d - d % U).toString();
  }
  if (i === ct) {
    const U = Mi(t, Dt, xc, St, Ht), Y = qn(U);
    let J = d % t;
    J = Number(Mi(J, Dt, 8, St, Ht));
    const ae = Mi(J / t, Dt, Math.max(Y, 8), St, Ht);
    return qn(ae) !== 0 && (e === Dt ? d > 0 ? J >= t / 2 ? d = d - J + t : d = d - J : J >= t / 2 ? d = Number(d) - J : d = Number(d) - J - t : e === Et && (d = d - J)), Mi(d, e, Y, St, s);
  }
  const n = Xa(d), r = n[0] === "-", a = r ? 1 : 0, o = n.length;
  for (var c = 0; c < o && n[c] !== "."; c++)
    ;
  const u = c < n.length, f = 45, h = 46, l = 48, p = l + 1, m = l + 5, y = l + 9, w = new Uint8Array(o - a + (u ? 0 : 1));
  w[0] = l;
  let S = w.length, b = -1, T = -1;
  for (var x = 1, v = a; v < o; v++, x++) {
    const U = n.charCodeAt(v);
    if (U === h)
      S = x--;
    else {
      if (U < l || U > y)
        throw new Error(`${n}: invalid number (contains an illegal character '${n[x - 1]}')`);
      w[x] = U, U !== l && b < 0 && (b = x);
    }
  }
  b < 0 && (b = 1);
  let _ = i === St ? S : b, V = _ + t;
  T = -1;
  let j = !0, G = r;
  for (let U = w.length - 1, Y = 0; U >= 0; U--) {
    let J = w[U];
    if (U !== 0) {
      if (J += Y, U >= _ + t) {
        const ae = e === Dt && J >= m && !(J === m && Y), A = e === ar && J >= p;
        J = ae || A ? y + 1 : l;
      }
      J > y ? (J = l, Y = 1) : Y = 0;
    } else
      Y && (J = p);
    w[U] = J, J !== l && (j = !1, b = U, T = T < 0 ? U + 1 : T);
  }
  i === or && (_ = b, V = _ + t), j && (G = !1);
  const W = b >= S || j ? S - 1 : b, B = T < S ? S : T, Q = G ? 1 : 0, se = Q + (S - W), $ = Math.max(B - S, 0), te = B - W, E = s === Ht ? te : V - W, N = Math.max(E - te, 0), L = se + 1 + $, z = L + N, K = $ + N === 0, R = new Uint8Array(se + (K ? 0 : 1) + $ + N);
  for (G && (R[0] = f), x = Q, v = W; x < se; x++, v++)
    R[x] = w[v];
  for (K || (R[se] = h), x = se + 1, v = S; x < L; x++, v++)
    R[x] = w[v];
  for (x = L; x < z; x++)
    R[x] = l;
  return String.fromCharCode(...R);
};
function tl(d) {
  if (!(d === void 0 || d === "") && parseFloat(d) !== 0)
    return d;
}
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Cs(d) {
  if (!Number.isSafeInteger(d))
    throw new Error(`Wrong integer: ${d}`);
}
function fi(...d) {
  const e = (s, n) => (r) => s(n(r)), t = Array.from(d).reverse().reduce((s, n) => s ? e(s, n.encode) : n.encode, void 0), i = d.reduce((s, n) => s ? e(s, n.decode) : n.decode, void 0);
  return { encode: t, decode: i };
}
function hi(d) {
  return {
    encode: (e) => {
      if (!Array.isArray(e) || e.length && typeof e[0] != "number")
        throw new Error("alphabet.encode input should be an array of numbers");
      return e.map((t) => {
        if (Cs(t), t < 0 || t >= d.length)
          throw new Error(`Digit index outside alphabet: ${t} (alphabet: ${d.length})`);
        return d[t];
      });
    },
    decode: (e) => {
      if (!Array.isArray(e) || e.length && typeof e[0] != "string")
        throw new Error("alphabet.decode input should be array of strings");
      return e.map((t) => {
        if (typeof t != "string")
          throw new Error(`alphabet.decode: not string element=${t}`);
        const i = d.indexOf(t);
        if (i === -1)
          throw new Error(`Unknown letter: "${t}". Allowed: ${d}`);
        return i;
      });
    }
  };
}
function li(d = "") {
  if (typeof d != "string")
    throw new Error("join separator should be string");
  return {
    encode: (e) => {
      if (!Array.isArray(e) || e.length && typeof e[0] != "string")
        throw new Error("join.encode input should be array of strings");
      for (let t of e)
        if (typeof t != "string")
          throw new Error(`join.encode: non-string input=${t}`);
      return e.join(d);
    },
    decode: (e) => {
      if (typeof e != "string")
        throw new Error("join.decode input should be string");
      return e.split(d);
    }
  };
}
function dr(d, e = "=") {
  if (Cs(d), typeof e != "string")
    throw new Error("padding chr should be string");
  return {
    encode(t) {
      if (!Array.isArray(t) || t.length && typeof t[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let i of t)
        if (typeof i != "string")
          throw new Error(`padding.encode: non-string input=${i}`);
      for (; t.length * d % 8; )
        t.push(e);
      return t;
    },
    decode(t) {
      if (!Array.isArray(t) || t.length && typeof t[0] != "string")
        throw new Error("padding.encode input should be array of strings");
      for (let s of t)
        if (typeof s != "string")
          throw new Error(`padding.decode: non-string input=${s}`);
      let i = t.length;
      if (i * d % 8)
        throw new Error("Invalid padding: string should have whole number of bytes");
      for (; i > 0 && t[i - 1] === e; i--)
        if (!((i - 1) * d % 8))
          throw new Error("Invalid padding: string has too much padding");
      return t.slice(0, i);
    }
  };
}
function kc(d) {
  if (typeof d != "function")
    throw new Error("normalize fn should be function");
  return { encode: (e) => e, decode: (e) => d(e) };
}
function Yo(d, e, t) {
  if (e < 2)
    throw new Error(`convertRadix: wrong from=${e}, base cannot be less than 2`);
  if (t < 2)
    throw new Error(`convertRadix: wrong to=${t}, base cannot be less than 2`);
  if (!Array.isArray(d))
    throw new Error("convertRadix: data should be array");
  if (!d.length)
    return [];
  let i = 0;
  const s = [], n = Array.from(d);
  for (n.forEach((r) => {
    if (Cs(r), r < 0 || r >= e)
      throw new Error(`Wrong integer: ${r}`);
  }); ; ) {
    let r = 0, a = !0;
    for (let o = i; o < n.length; o++) {
      const c = n[o], u = e * r + c;
      if (!Number.isSafeInteger(u) || e * r / e !== r || u - c !== e * r)
        throw new Error("convertRadix: carry overflow");
      if (r = u % t, n[o] = Math.floor(u / t), !Number.isSafeInteger(n[o]) || n[o] * t + r !== u)
        throw new Error("convertRadix: carry overflow");
      if (a)
        n[o] ? a = !1 : i = o;
      else
        continue;
    }
    if (s.push(r), a)
      break;
  }
  for (let r = 0; r < d.length - 1 && d[r] === 0; r++)
    s.push(0);
  return s.reverse();
}
const Ec = (d, e) => e ? Ec(e, d % e) : d, Gn = (d, e) => d + (e - Ec(d, e));
function ba(d, e, t, i) {
  if (!Array.isArray(d))
    throw new Error("convertRadix2: data should be array");
  if (e <= 0 || e > 32)
    throw new Error(`convertRadix2: wrong from=${e}`);
  if (t <= 0 || t > 32)
    throw new Error(`convertRadix2: wrong to=${t}`);
  if (Gn(e, t) > 32)
    throw new Error(`convertRadix2: carry overflow from=${e} to=${t} carryBits=${Gn(e, t)}`);
  let s = 0, n = 0;
  const r = 2 ** t - 1, a = [];
  for (const o of d) {
    if (Cs(o), o >= 2 ** e)
      throw new Error(`convertRadix2: invalid data word=${o} from=${e}`);
    if (s = s << e | o, n + e > 32)
      throw new Error(`convertRadix2: carry overflow pos=${n} from=${e}`);
    for (n += e; n >= t; n -= t)
      a.push((s >> n - t & r) >>> 0);
    s &= 2 ** n - 1;
  }
  if (s = s << t - n & r, !i && n >= e)
    throw new Error("Excess padding");
  if (!i && s)
    throw new Error(`Non-zero padding: ${s}`);
  return i && n > 0 && a.push(s >>> 0), a;
}
function il(d) {
  return Cs(d), {
    encode: (e) => {
      if (!(e instanceof Uint8Array))
        throw new Error("radix.encode input should be Uint8Array");
      return Yo(Array.from(e), 2 ** 8, d);
    },
    decode: (e) => {
      if (!Array.isArray(e) || e.length && typeof e[0] != "number")
        throw new Error("radix.decode input should be array of strings");
      return Uint8Array.from(Yo(e, d, 2 ** 8));
    }
  };
}
function Di(d, e = !1) {
  if (Cs(d), d <= 0 || d > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (Gn(8, d) > 32 || Gn(d, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (t) => {
      if (!(t instanceof Uint8Array))
        throw new Error("radix2.encode input should be Uint8Array");
      return ba(Array.from(t), 8, d, !e);
    },
    decode: (t) => {
      if (!Array.isArray(t) || t.length && typeof t[0] != "number")
        throw new Error("radix2.decode input should be array of strings");
      return Uint8Array.from(ba(t, d, 8, e));
    }
  };
}
function Ko(d) {
  if (typeof d != "function")
    throw new Error("unsafeWrapper fn should be function");
  return function(...e) {
    try {
      return d.apply(null, e);
    } catch {
    }
  };
}
const Ri = fi(Di(4), hi("0123456789abcdef"), li("")), Nc = fi(Di(5), hi("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), dr(5), li(""));
fi(Di(5), hi("0123456789ABCDEFGHIJKLMNOPQRSTUV"), dr(5), li(""));
fi(Di(5), hi("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), li(""), kc((d) => d.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const pi = fi(Di(6), hi("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), dr(6), li("")), sl = fi(Di(6), hi("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), dr(6), li("")), $a = (d) => fi(il(58), hi(d), li("")), ms = $a("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
$a("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
$a("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
const Xo = [0, 2, 3, 5, 6, 7, 9, 10, 11], nl = {
  encode(d) {
    let e = "";
    for (let t = 0; t < d.length; t += 8) {
      const i = d.subarray(t, t + 8);
      e += ms.encode(i).padStart(Xo[i.length], "1");
    }
    return e;
  },
  decode(d) {
    let e = [];
    for (let t = 0; t < d.length; t += 11) {
      const i = d.slice(t, t + 11), s = Xo.indexOf(i.length), n = ms.decode(i);
      for (let r = 0; r < n.length - s; r++)
        if (n[r] !== 0)
          throw new Error("base58xmr: wrong padding");
      e = e.concat(Array.from(n.slice(n.length - s)));
    }
    return Uint8Array.from(e);
  }
}, Sa = fi(hi("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), li("")), $o = [996825010, 642813549, 513874426, 1027748829, 705979059];
function Ls(d) {
  const e = d >> 25;
  let t = (d & 33554431) << 5;
  for (let i = 0; i < $o.length; i++)
    (e >> i & 1) === 1 && (t ^= $o[i]);
  return t;
}
function Zo(d, e, t = 1) {
  const i = d.length;
  let s = 1;
  for (let n = 0; n < i; n++) {
    const r = d.charCodeAt(n);
    if (r < 33 || r > 126)
      throw new Error(`Invalid prefix (${d})`);
    s = Ls(s) ^ r >> 5;
  }
  s = Ls(s);
  for (let n = 0; n < i; n++)
    s = Ls(s) ^ d.charCodeAt(n) & 31;
  for (let n of e)
    s = Ls(s) ^ n;
  for (let n = 0; n < 6; n++)
    s = Ls(s);
  return s ^= t, Sa.encode(ba([s % 2 ** 30], 30, 5, !1));
}
function Pc(d) {
  const e = d === "bech32" ? 1 : 734539939, t = Di(5), i = t.decode, s = t.encode, n = Ko(i);
  function r(u, f, h = 90) {
    if (typeof u != "string")
      throw new Error(`bech32.encode prefix should be string, not ${typeof u}`);
    if (!Array.isArray(f) || f.length && typeof f[0] != "number")
      throw new Error(`bech32.encode words should be array of numbers, not ${typeof f}`);
    const l = u.length + 7 + f.length;
    if (h !== !1 && l > h)
      throw new TypeError(`Length ${l} exceeds limit ${h}`);
    return u = u.toLowerCase(), `${u}1${Sa.encode(f)}${Zo(u, f, e)}`;
  }
  function a(u, f = 90) {
    if (typeof u != "string")
      throw new Error(`bech32.decode input should be string, not ${typeof u}`);
    if (u.length < 8 || f !== !1 && u.length > f)
      throw new TypeError(`Wrong string length: ${u.length} (${u}). Expected (8..${f})`);
    const h = u.toLowerCase();
    if (u !== h && u !== u.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    u = h;
    const l = u.lastIndexOf("1");
    if (l === 0 || l === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const p = u.slice(0, l), m = u.slice(l + 1);
    if (m.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const y = Sa.decode(m).slice(0, -6), w = Zo(p, y, e);
    if (!m.endsWith(w))
      throw new Error(`Invalid checksum in ${u}: expected "${w}"`);
    return { prefix: p, words: y };
  }
  const o = Ko(a);
  function c(u) {
    const { prefix: f, words: h } = a(u, !1);
    return { prefix: f, words: h, bytes: i(h) };
  }
  return { encode: r, decode: a, decodeToBytes: c, decodeUnsafe: o, fromWords: i, fromWordsUnsafe: n, toWords: s };
}
Pc("bech32");
Pc("bech32m");
const ai = {
  encode: (d) => new TextDecoder().decode(d),
  decode: (d) => new TextEncoder().encode(d)
}, rl = fi(Di(4), hi("0123456789abcdef"), li(""), kc((d) => {
  if (typeof d != "string" || d.length % 2)
    throw new TypeError(`hex.decode: expected string, got ${typeof d} with length ${d.length}`);
  return d.toLowerCase();
})), al = {
  utf8: ai,
  hex: rl,
  base16: Ri,
  base32: Nc,
  base64: pi,
  base64url: sl,
  base58: ms,
  base58xmr: nl
};
`${Object.keys(al).join(", ")}`;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ol = BigInt(0), Za = BigInt(1), dl = BigInt(2), cr = (d) => d instanceof Uint8Array, cl = Array.from({ length: 256 }, (d, e) => e.toString(16).padStart(2, "0"));
function ki(d) {
  if (!cr(d))
    throw new Error("Uint8Array expected");
  let e = "";
  for (let t = 0; t < d.length; t++)
    e += cl[d[t]];
  return e;
}
function _c(d) {
  const e = d.toString(16);
  return e.length & 1 ? `0${e}` : e;
}
function Qa(d) {
  if (typeof d != "string")
    throw new Error("hex string expected, got " + typeof d);
  return BigInt(d === "" ? "0" : `0x${d}`);
}
function ys(d) {
  if (typeof d != "string")
    throw new Error("hex string expected, got " + typeof d);
  if (d.length % 2)
    throw new Error("hex string is invalid: unpadded " + d.length);
  const e = new Uint8Array(d.length / 2);
  for (let t = 0; t < e.length; t++) {
    const i = t * 2, s = d.slice(i, i + 2), n = Number.parseInt(s, 16);
    if (Number.isNaN(n) || n < 0)
      throw new Error("invalid byte sequence");
    e[t] = n;
  }
  return e;
}
function wt(d) {
  return Qa(ki(d));
}
function Wt(d) {
  if (!cr(d))
    throw new Error("Uint8Array expected");
  return Qa(ki(Uint8Array.from(d).reverse()));
}
const ni = (d, e) => ys(d.toString(16).padStart(e * 2, "0")), Kt = (d, e) => ni(d, e).reverse(), ul = (d) => ys(_c(d));
function Ne(d, e, t) {
  let i;
  if (typeof e == "string")
    try {
      i = ys(e);
    } catch (n) {
      throw new Error(`${d} must be valid hex string, got "${e}". Cause: ${n}`);
    }
  else if (cr(e))
    i = Uint8Array.from(e);
  else
    throw new Error(`${d} must be hex string or Uint8Array`);
  const s = i.length;
  if (typeof t == "number" && s !== t)
    throw new Error(`${d} expected ${t} bytes, got ${s}`);
  return i;
}
function ot(...d) {
  const e = new Uint8Array(d.reduce((i, s) => i + s.length, 0));
  let t = 0;
  return d.forEach((i) => {
    if (!cr(i))
      throw new Error("Uint8Array expected");
    e.set(i, t), t += i.length;
  }), e;
}
function Lc(d, e) {
  if (d.length !== e.length)
    return !1;
  for (let t = 0; t < d.length; t++)
    if (d[t] !== e[t])
      return !1;
  return !0;
}
function ur(d) {
  if (typeof d != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof d}`);
  return new TextEncoder().encode(d);
}
function fl(d) {
  let e;
  for (e = 0; d > 0n; d >>= Za, e += 1)
    ;
  return e;
}
const hl = (d, e) => d >> BigInt(e) & 1n, ll = (d, e, t) => d | (t ? Za : ol) << BigInt(e), Ja = (d) => (dl << BigInt(d - 1)) - Za, Br = (d) => new Uint8Array(d), Qo = (d) => Uint8Array.from(d);
function Dc(d, e, t) {
  if (typeof d != "number" || d < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof t != "function")
    throw new Error("hmacFn must be a function");
  let i = Br(d), s = Br(d), n = 0;
  const r = () => {
    i.fill(1), s.fill(0), n = 0;
  }, a = (...f) => t(s, i, ...f), o = (f = Br()) => {
    s = a(Qo([0]), f), i = a(), f.length !== 0 && (s = a(Qo([1]), f), i = a());
  }, c = () => {
    if (n++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const h = [];
    for (; f < e; ) {
      i = a();
      const l = i.slice();
      h.push(l), f += i.length;
    }
    return ot(...h);
  };
  return (f, h) => {
    r(), o(f);
    let l;
    for (; !(l = h(c())); )
      o();
    return r(), l;
  };
}
const pl = {
  bigint: (d) => typeof d == "bigint",
  function: (d) => typeof d == "function",
  boolean: (d) => typeof d == "boolean",
  string: (d) => typeof d == "string",
  isSafeInteger: (d) => Number.isSafeInteger(d),
  array: (d) => Array.isArray(d),
  field: (d, e) => e.Fp.isValid(d),
  hash: (d) => typeof d == "function" && Number.isSafeInteger(d.outputLen)
};
function Bi(d, e, t = {}) {
  const i = (s, n, r) => {
    const a = pl[n];
    if (typeof a != "function")
      throw new Error(`Invalid validator "${n}", expected function`);
    const o = d[s];
    if (!(r && o === void 0) && !a(o, d))
      throw new Error(`Invalid param ${String(s)}=${o} (${typeof o}), expected ${n}`);
  };
  for (const [s, n] of Object.entries(e))
    i(s, n, !1);
  for (const [s, n] of Object.entries(t))
    i(s, n, !0);
  return d;
}
const gl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: hl,
  bitLen: fl,
  bitMask: Ja,
  bitSet: ll,
  bytesToHex: ki,
  bytesToNumberBE: wt,
  bytesToNumberLE: Wt,
  concatBytes: ot,
  createHmacDrbg: Dc,
  ensureBytes: Ne,
  equalBytes: Lc,
  hexToBytes: ys,
  hexToNumber: Qa,
  numberToBytesBE: ni,
  numberToBytesLE: Kt,
  numberToHexUnpadded: _c,
  numberToVarBytesBE: ul,
  utf8ToBytes: ur,
  validateObject: Bi
}, Symbol.toStringTag, { value: "Module" }));
function ml(d, e) {
  if (e && e.multiple && !Array.isArray(d))
    throw new Error("Invalid argument type: Expected an Array to serialize multiple values.");
  const t = 4294967296;
  let i, s, n = new Uint8Array(128), r = 0;
  if (e && e.multiple)
    for (let b = 0; b < d.length; b++)
      a(d[b]);
  else
    a(d);
  return n.subarray(0, r);
  function a(b, T) {
    switch (typeof b) {
      case "undefined":
        o();
        break;
      case "boolean":
        c(b);
        break;
      case "number":
        u(b);
        break;
      case "string":
        f(b);
        break;
      case "object":
        b === null ? o() : b instanceof Date ? m(b) : Array.isArray(b) ? h(b) : b instanceof Uint8Array || b instanceof Uint8ClampedArray ? l(b) : b instanceof Int8Array || b instanceof Int16Array || b instanceof Uint16Array || b instanceof Int32Array || b instanceof Uint32Array || b instanceof Float32Array || b instanceof Float64Array ? h(b) : p(b);
        break;
      default:
        if (!T && e && e.invalidTypeReplacement)
          typeof e.invalidTypeReplacement == "function" ? a(e.invalidTypeReplacement(b), !0) : a(e.invalidTypeReplacement, !0);
        else
          throw new Error("Invalid argument type: The type '" + typeof b + "' cannot be serialized.");
    }
  }
  function o(b) {
    y(192);
  }
  function c(b) {
    y(b ? 195 : 194);
  }
  function u(b) {
    if (isFinite(b) && Math.floor(b) === b)
      if (b >= 0 && b <= 127)
        y(b);
      else if (b < 0 && b >= -32)
        y(b);
      else if (b > 0 && b <= 255)
        w([204, b]);
      else if (b >= -128 && b <= 127)
        w([208, b]);
      else if (b > 0 && b <= 65535)
        w([205, b >>> 8, b]);
      else if (b >= -32768 && b <= 32767)
        w([209, b >>> 8, b]);
      else if (b > 0 && b <= 4294967295)
        w([206, b >>> 24, b >>> 16, b >>> 8, b]);
      else if (b >= -2147483648 && b <= 2147483647)
        w([210, b >>> 24, b >>> 16, b >>> 8, b]);
      else if (b > 0 && b <= 18446744073709552e3) {
        let T = b / t, x = b % t;
        w([207, T >>> 24, T >>> 16, T >>> 8, T, x >>> 24, x >>> 16, x >>> 8, x]);
      } else
        b >= -9223372036854776e3 && b <= 9223372036854776e3 ? (y(211), S(b)) : b < 0 ? w([211, 128, 0, 0, 0, 0, 0, 0, 0]) : w([207, 255, 255, 255, 255, 255, 255, 255, 255]);
    else
      s || (i = new ArrayBuffer(8), s = new DataView(i)), s.setFloat64(0, b), y(203), w(new Uint8Array(i));
  }
  function f(b) {
    let T = yl(b), x = T.length;
    x <= 31 ? y(160 + x) : x <= 255 ? w([217, x]) : x <= 65535 ? w([218, x >>> 8, x]) : w([219, x >>> 24, x >>> 16, x >>> 8, x]), w(T);
  }
  function h(b) {
    let T = b.length;
    T <= 15 ? y(144 + T) : T <= 65535 ? w([220, T >>> 8, T]) : w([221, T >>> 24, T >>> 16, T >>> 8, T]);
    for (let x = 0; x < T; x++)
      a(b[x]);
  }
  function l(b) {
    let T = b.length;
    T <= 15 ? w([196, T]) : T <= 65535 ? w([197, T >>> 8, T]) : w([198, T >>> 24, T >>> 16, T >>> 8, T]), w(b);
  }
  function p(b) {
    let T = 0;
    for (let x in b)
      b[x] !== void 0 && T++;
    T <= 15 ? y(128 + T) : T <= 65535 ? w([222, T >>> 8, T]) : w([223, T >>> 24, T >>> 16, T >>> 8, T]);
    for (let x in b) {
      let v = b[x];
      v !== void 0 && (a(x), a(v));
    }
  }
  function m(b) {
    let T = b.getTime() / 1e3;
    if (b.getMilliseconds() === 0 && T >= 0 && T < 4294967296)
      w([214, 255, T >>> 24, T >>> 16, T >>> 8, T]);
    else if (T >= 0 && T < 17179869184) {
      let x = b.getMilliseconds() * 1e6;
      w([215, 255, x >>> 22, x >>> 14, x >>> 6, x << 2 >>> 0 | T / t, T >>> 24, T >>> 16, T >>> 8, T]);
    } else {
      let x = b.getMilliseconds() * 1e6;
      w([199, 12, 255, x >>> 24, x >>> 16, x >>> 8, x]), S(T);
    }
  }
  function y(b) {
    if (n.length < r + 1) {
      let T = n.length * 2;
      for (; T < r + 1; )
        T *= 2;
      let x = new Uint8Array(T);
      x.set(n), n = x;
    }
    n[r] = b, r++;
  }
  function w(b) {
    if (n.length < r + b.length) {
      let T = n.length * 2;
      for (; T < r + b.length; )
        T *= 2;
      let x = new Uint8Array(T);
      x.set(n), n = x;
    }
    n.set(b, r), r += b.length;
  }
  function S(b) {
    let T, x;
    b >= 0 ? (T = b / t, x = b % t) : (b++, T = Math.abs(b) / t, x = Math.abs(b) % t, T = ~T, x = ~x), w([T >>> 24, T >>> 16, T >>> 8, T, x >>> 24, x >>> 16, x >>> 8, x]);
  }
}
function yl(d) {
  let e = !0, t = d.length;
  for (let n = 0; n < t; n++)
    if (d.charCodeAt(n) > 127) {
      e = !1;
      break;
    }
  let i = 0, s = new Uint8Array(d.length * (e ? 1 : 4));
  for (let n = 0; n !== t; n++) {
    let r = d.charCodeAt(n);
    if (r < 128) {
      s[i++] = r;
      continue;
    }
    if (r < 2048)
      s[i++] = r >> 6 | 192;
    else {
      if (r > 55295 && r < 56320) {
        if (++n >= t)
          throw new Error("UTF-8 encode: incomplete surrogate pair");
        let a = d.charCodeAt(n);
        if (a < 56320 || a > 57343)
          throw new Error("UTF-8 encode: second surrogate character 0x" + a.toString(16) + " at index " + n + " out of range");
        r = 65536 + ((r & 1023) << 10) + (a & 1023), s[i++] = r >> 18 | 240, s[i++] = r >> 12 & 63 | 128;
      } else
        s[i++] = r >> 12 | 224;
      s[i++] = r >> 6 & 63 | 128;
    }
    s[i++] = r & 63 | 128;
  }
  return e ? s : s.subarray(0, i);
}
var Vr = Object.prototype.hasOwnProperty, as = Array.isArray, Ut = function() {
  for (var d = [], e = 0; e < 256; ++e)
    d.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return d;
}(), wl = function(e) {
  for (; e.length > 1; ) {
    var t = e.pop(), i = t.obj[t.prop];
    if (as(i)) {
      for (var s = [], n = 0; n < i.length; ++n)
        typeof i[n] < "u" && s.push(i[n]);
      t.obj[t.prop] = s;
    }
  }
}, Rc = function(e, t) {
  for (var i = t && t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, s = 0; s < e.length; ++s)
    typeof e[s] < "u" && (i[s] = e[s]);
  return i;
}, bl = function d(e, t, i) {
  if (!t)
    return e;
  if (typeof t != "object") {
    if (as(e))
      e.push(t);
    else if (e && typeof e == "object")
      (i && (i.plainObjects || i.allowPrototypes) || !Vr.call(Object.prototype, t)) && (e[t] = !0);
    else
      return [e, t];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(t);
  var s = e;
  return as(e) && !as(t) && (s = Rc(e, i)), as(e) && as(t) ? (t.forEach(function(n, r) {
    if (Vr.call(e, r)) {
      var a = e[r];
      a && typeof a == "object" && n && typeof n == "object" ? e[r] = d(a, n, i) : e.push(n);
    } else
      e[r] = n;
  }), e) : Object.keys(t).reduce(function(n, r) {
    var a = t[r];
    return Vr.call(n, r) ? n[r] = d(n[r], a, i) : n[r] = a, n;
  }, s);
}, Sl = function(e, t) {
  return Object.keys(t).reduce(function(i, s) {
    return i[s] = t[s], i;
  }, e);
}, Tl = function(d, e, t) {
  var i = d.replace(/\+/g, " ");
  if (t === "iso-8859-1")
    return i.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(i);
  } catch {
    return i;
  }
}, Al = function(e, t, i) {
  if (e.length === 0)
    return e;
  var s = typeof e == "string" ? e : String(e);
  if (i === "iso-8859-1")
    return escape(s).replace(/%u[0-9a-f]{4}/gi, function(o) {
      return "%26%23" + parseInt(o.slice(2), 16) + "%3B";
    });
  for (var n = "", r = 0; r < s.length; ++r) {
    var a = s.charCodeAt(r);
    if (a === 45 || a === 46 || a === 95 || a === 126 || a >= 48 && a <= 57 || a >= 65 && a <= 90 || a >= 97 && a <= 122) {
      n += s.charAt(r);
      continue;
    }
    if (a < 128) {
      n = n + Ut[a];
      continue;
    }
    if (a < 2048) {
      n = n + (Ut[192 | a >> 6] + Ut[128 | a & 63]);
      continue;
    }
    if (a < 55296 || a >= 57344) {
      n = n + (Ut[224 | a >> 12] + Ut[128 | a >> 6 & 63] + Ut[128 | a & 63]);
      continue;
    }
    r += 1, a = 65536 + ((a & 1023) << 10 | s.charCodeAt(r) & 1023), n += Ut[240 | a >> 18] + Ut[128 | a >> 12 & 63] + Ut[128 | a >> 6 & 63] + Ut[128 | a & 63];
  }
  return n;
}, Il = function(e) {
  for (var t = [{ obj: { o: e }, prop: "o" }], i = [], s = 0; s < t.length; ++s)
    for (var n = t[s], r = n.obj[n.prop], a = Object.keys(r), o = 0; o < a.length; ++o) {
      var c = a[o], u = r[c];
      typeof u == "object" && u !== null && i.indexOf(u) === -1 && (t.push({ obj: r, prop: c }), i.push(u));
    }
  return wl(t), e;
}, Ol = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, Ml = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, Cl = function(e, t) {
  return [].concat(e, t);
}, Bc = {
  arrayToObject: Rc,
  assign: Sl,
  combine: Cl,
  compact: Il,
  decode: Tl,
  encode: Al,
  isBuffer: Ml,
  isRegExp: Ol,
  merge: bl
}, xl = String.prototype.replace, vl = /%20/g, Vc = {
  default: "RFC3986",
  formatters: {
    RFC1738: function(d) {
      return xl.call(d, vl, "+");
    },
    RFC3986: function(d) {
      return d;
    }
  },
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, jc = Bc, zs = Vc, kl = Object.prototype.hasOwnProperty, Jo = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, t) {
    return e + "[" + t + "]";
  },
  repeat: function(e) {
    return e;
  }
}, fs = Array.isArray, El = Array.prototype.push, Ta = function(d, e) {
  El.apply(d, fs(e) ? e : [e]);
}, Nl = Date.prototype.toISOString, lt = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: jc.encode,
  encodeValuesOnly: !1,
  formatter: zs.formatters[zs.default],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return Nl.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Pl = function d(e, t, i, s, n, r, a, o, c, u, f, h, l) {
  var p = e;
  if (typeof a == "function" ? p = a(t, p) : p instanceof Date ? p = u(p) : i === "comma" && fs(p) && (p = p.join(",")), p === null) {
    if (s)
      return r && !h ? r(t, lt.encoder, l) : t;
    p = "";
  }
  if (typeof p == "string" || typeof p == "number" || typeof p == "boolean" || jc.isBuffer(p)) {
    if (r) {
      var m = h ? t : r(t, lt.encoder, l);
      return [f(m) + "=" + f(r(p, lt.encoder, l))];
    }
    return [f(t) + "=" + f(String(p))];
  }
  var y = [];
  if (typeof p > "u")
    return y;
  var w;
  if (fs(a))
    w = a;
  else {
    var S = Object.keys(p);
    w = o ? S.sort(o) : S;
  }
  for (var b = 0; b < w.length; ++b) {
    var T = w[b];
    n && p[T] === null || (fs(p) ? Ta(y, d(p[T], typeof i == "function" ? i(t, T) : t, i, s, n, r, a, o, c, u, f, h, l)) : Ta(y, d(p[T], t + (c ? "." + T : "[" + T + "]"), i, s, n, r, a, o, c, u, f, h, l)));
  }
  return y;
}, _l = function(e) {
  if (!e)
    return lt;
  if (e.encoder !== null && e.encoder !== void 0 && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var t = e.charset || lt.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var i = zs.default;
  if (typeof e.format < "u") {
    if (!kl.call(zs.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    i = e.format;
  }
  var s = zs.formatters[i], n = lt.filter;
  return (typeof e.filter == "function" || fs(e.filter)) && (n = e.filter), {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : lt.addQueryPrefix,
    allowDots: typeof e.allowDots > "u" ? lt.allowDots : !!e.allowDots,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : lt.charsetSentinel,
    delimiter: typeof e.delimiter > "u" ? lt.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : lt.encode,
    encoder: typeof e.encoder == "function" ? e.encoder : lt.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : lt.encodeValuesOnly,
    filter: n,
    formatter: s,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : lt.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : lt.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : lt.strictNullHandling
  };
}, Ll = function(d, e) {
  var t = d, i = _l(e), s, n;
  typeof i.filter == "function" ? (n = i.filter, t = n("", t)) : fs(i.filter) && (n = i.filter, s = n);
  var r = [];
  if (typeof t != "object" || t === null)
    return "";
  var a;
  e && e.arrayFormat in Jo ? a = e.arrayFormat : e && "indices" in e ? a = e.indices ? "indices" : "repeat" : a = "indices";
  var o = Jo[a];
  s || (s = Object.keys(t)), i.sort && s.sort(i.sort);
  for (var c = 0; c < s.length; ++c) {
    var u = s[c];
    i.skipNulls && t[u] === null || Ta(r, Pl(t[u], u, o, i.strictNullHandling, i.skipNulls, i.encode ? i.encoder : null, i.filter, i.sort, i.allowDots, i.serializeDate, i.formatter, i.encodeValuesOnly, i.charset));
  }
  var f = r.join(i.delimiter), h = i.addQueryPrefix === !0 ? "?" : "";
  return i.charsetSentinel && (i.charset === "iso-8859-1" ? h += "utf8=%26%2310003%3B&" : h += "utf8=%E2%9C%93&"), f.length > 0 ? h + f : "";
}, Ws = Bc, Aa = Object.prototype.hasOwnProperty, rt = {
  allowDots: !1,
  allowPrototypes: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: Ws.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, Dl = function(d) {
  return d.replace(/&#(\d+);/g, function(e, t) {
    return String.fromCharCode(parseInt(t, 10));
  });
}, Rl = "utf8=%26%2310003%3B", Bl = "utf8=%E2%9C%93", Vl = function(e, t) {
  var i = {}, s = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, n = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, r = s.split(t.delimiter, n), a = -1, o, c = t.charset;
  if (t.charsetSentinel)
    for (o = 0; o < r.length; ++o)
      r[o].indexOf("utf8=") === 0 && (r[o] === Bl ? c = "utf-8" : r[o] === Rl && (c = "iso-8859-1"), a = o, o = r.length);
  for (o = 0; o < r.length; ++o)
    if (o !== a) {
      var u = r[o], f = u.indexOf("]="), h = f === -1 ? u.indexOf("=") : f + 1, l, p;
      h === -1 ? (l = t.decoder(u, rt.decoder, c), p = t.strictNullHandling ? null : "") : (l = t.decoder(u.slice(0, h), rt.decoder, c), p = t.decoder(u.slice(h + 1), rt.decoder, c)), p && t.interpretNumericEntities && c === "iso-8859-1" && (p = Dl(p)), p && t.comma && p.indexOf(",") > -1 && (p = p.split(",")), Aa.call(i, l) ? i[l] = Ws.combine(i[l], p) : i[l] = p;
    }
  return i;
}, jl = function(d, e, t) {
  for (var i = e, s = d.length - 1; s >= 0; --s) {
    var n, r = d[s];
    if (r === "[]" && t.parseArrays)
      n = [].concat(i);
    else {
      n = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var a = r.charAt(0) === "[" && r.charAt(r.length - 1) === "]" ? r.slice(1, -1) : r, o = parseInt(a, 10);
      !t.parseArrays && a === "" ? n = { 0: i } : !isNaN(o) && r !== a && String(o) === a && o >= 0 && t.parseArrays && o <= t.arrayLimit ? (n = [], n[o] = i) : n[a] = i;
    }
    i = n;
  }
  return i;
}, Fl = function(e, t, i) {
  if (e) {
    var s = i.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, n = /(\[[^[\]]*])/, r = /(\[[^[\]]*])/g, a = n.exec(s), o = a ? s.slice(0, a.index) : s, c = [];
    if (o) {
      if (!i.plainObjects && Aa.call(Object.prototype, o) && !i.allowPrototypes)
        return;
      c.push(o);
    }
    for (var u = 0; (a = r.exec(s)) !== null && u < i.depth; ) {
      if (u += 1, !i.plainObjects && Aa.call(Object.prototype, a[1].slice(1, -1)) && !i.allowPrototypes)
        return;
      c.push(a[1]);
    }
    return a && c.push("[" + s.slice(a.index) + "]"), jl(c, t, i);
  }
}, Ul = function(e) {
  if (!e)
    return rt;
  if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
  var t = typeof e.charset > "u" ? rt.charset : e.charset;
  return {
    allowDots: typeof e.allowDots > "u" ? rt.allowDots : !!e.allowDots,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : rt.allowPrototypes,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : rt.arrayLimit,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : rt.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : rt.comma,
    decoder: typeof e.decoder == "function" ? e.decoder : rt.decoder,
    delimiter: typeof e.delimiter == "string" || Ws.isRegExp(e.delimiter) ? e.delimiter : rt.delimiter,
    depth: typeof e.depth == "number" ? e.depth : rt.depth,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : rt.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : rt.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : rt.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : rt.strictNullHandling
  };
}, ql = function(d, e) {
  var t = Ul(e);
  if (d === "" || d === null || typeof d > "u")
    return t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var i = typeof d == "string" ? Vl(d, t) : d, s = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, n = Object.keys(i), r = 0; r < n.length; ++r) {
    var a = n[r], o = Fl(a, i[a], t);
    s = Ws.merge(s, o, t);
  }
  return Ws.compact(s);
}, Gl = Ll, zl = ql, Hl = Vc, fr = {
  formats: Hl,
  parse: zl,
  stringify: Gl
};
const Wl = (d, e = void 0) => JSON.stringify(d), Yl = (d) => typeof d == "string" && d.length >= 2 && (d[0] === "{" || d[0] === "["), Kl = ai.encode, Xl = ai.decode, Fc = (d) => pi.encode(ai.decode(d)), $l = (d) => ai.encode(pi.decode(d)), Uc = pi.decode, qc = pi.encode, Gc = Ri.decode, Zl = Ri.encode, Ql = ms.decode, Jl = ms.encode, ep = ot, tp = (d) => ot(...d), ip = (d) => fr.stringify(d), sp = (d) => fr.stringify(d), np = (d) => fr.stringify(d, { arrayFormat: "repeat" }), rp = (d) => fr.stringify(d, { encode: !1 }), ap = ai.decode, op = ai.encode, os = (d) => (typeof d == "string" ? Fc(d) : qc(d)).replace(/[=]+$/, "").replace(/\+/g, "-").replace(/\//g, "_"), dp = (d, e) => Kt(BigInt(d), e), cp = (d, e) => ni(BigInt(d), e);
function up(d) {
  return ml(d);
}
function Ia(d) {
  if (!Number.isSafeInteger(d) || d < 0)
    throw new Error(`Wrong positive integer: ${d}`);
}
function fp(d) {
  if (typeof d != "boolean")
    throw new Error(`Expected boolean, not ${d}`);
}
function zc(d, ...e) {
  if (!(d instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (e.length > 0 && !e.includes(d.length))
    throw new TypeError(`Expected Uint8Array of length ${e}, not of length=${d.length}`);
}
function hp(d) {
  if (typeof d != "function" || typeof d.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Ia(d.outputLen), Ia(d.blockLen);
}
function lp(d, e = !0) {
  if (d.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && d.finished)
    throw new Error("Hash#digest() has already been called");
}
function pp(d, e) {
  zc(d);
  const t = e.outputLen;
  if (d.length < t)
    throw new Error(`digestInto() expects output buffer of length at least ${t}`);
}
const qi = {
  number: Ia,
  bool: fp,
  bytes: zc,
  hash: hp,
  exists: lp,
  output: pp
}, jr = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0, Fr = (d) => new DataView(d.buffer, d.byteOffset, d.byteLength), qt = (d, e) => d << 32 - e | d >>> e, gp = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!gp)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (d, e) => e.toString(16).padStart(2, "0"));
function Hc(d) {
  if (typeof d != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof d}`);
  return new TextEncoder().encode(d);
}
function eo(d) {
  if (typeof d == "string" && (d = Hc(d)), !(d instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof d})`);
  return d;
}
function Wc(...d) {
  if (!d.every((i) => i instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (d.length === 1)
    return d[0];
  const e = d.reduce((i, s) => i + s.length, 0), t = new Uint8Array(e);
  for (let i = 0, s = 0; i < d.length; i++) {
    const n = d[i];
    t.set(n, s), s += n.length;
  }
  return t;
}
class Yc {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Zi(d) {
  const e = (i) => d().update(eo(i)).digest(), t = d();
  return e.outputLen = t.outputLen, e.blockLen = t.blockLen, e.create = () => d(), e;
}
function hr(d = 32) {
  if (jr && typeof jr.getRandomValues == "function")
    return jr.getRandomValues(new Uint8Array(d));
  throw new Error("crypto.getRandomValues must be defined");
}
class Kc extends Yc {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, qi.hash(e);
    const i = eo(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const s = this.blockLen, n = new Uint8Array(s);
    n.set(i.length > s ? e.create().update(i).digest() : i);
    for (let r = 0; r < n.length; r++)
      n[r] ^= 54;
    this.iHash.update(n), this.oHash = e.create();
    for (let r = 0; r < n.length; r++)
      n[r] ^= 106;
    this.oHash.update(n), n.fill(0);
  }
  update(e) {
    return qi.exists(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    qi.exists(this), qi.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: i, finished: s, destroyed: n, blockLen: r, outputLen: a } = this;
    return e = e, e.finished = s, e.destroyed = n, e.blockLen = r, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = i._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const to = (d, e, t) => new Kc(d, e).update(t).digest();
to.create = (d, e) => new Kc(d, e);
let ji;
const Ys = {
  decode(d) {
    let e;
    if (ji === void 0) {
      const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = `= \f
\r	 \u2028\u2029`;
      for (ji = /* @__PURE__ */ Object.create(null), e = 0; e < 64; ++e)
        ji[n.charAt(e)] = e;
      for (ji["-"] = 62, ji._ = 63, e = 0; e < r.length; ++e)
        ji[r.charAt(e)] = -1;
    }
    const t = [];
    let i = 0, s = 0;
    for (e = 0; e < d.length; ++e) {
      let n = d.charAt(e);
      if (n == "=")
        break;
      if (n = ji[n], n != -1) {
        if (n === void 0)
          throw new Error("Illegal character at offset " + e);
        i |= n, ++s >= 4 ? (t[t.length] = i >> 16, t[t.length] = i >> 8 & 255, t[t.length] = i & 255, i = 0, s = 0) : i <<= 6;
      }
    }
    switch (s) {
      case 1:
        throw new Error("Base64 encoding incomplete: at least 2 bits missing");
      case 2:
        t[t.length] = i >> 10;
        break;
      case 3:
        t[t.length] = i >> 16, t[t.length] = i >> 8 & 255;
        break;
    }
    return t;
  },
  re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
  unarmor(d) {
    const e = Ys.re.exec(d);
    if (e)
      if (e[1])
        d = e[1];
      else if (e[2])
        d = e[2];
      else
        throw new Error("RegExp out of sync");
    return Ys.decode(d);
  }
}, Ji = 1e13;
class Us {
  constructor(e) {
    this.buf = [+e || 0];
  }
  mulAdd(e, t) {
    const i = this.buf, s = i.length;
    let n, r;
    for (n = 0; n < s; ++n)
      r = i[n] * e + t, r < Ji ? t = 0 : (t = 0 | r / Ji, r -= t * Ji), i[n] = r;
    t > 0 && (i[n] = t);
  }
  sub(e) {
    const t = this.buf, i = t.length;
    let s, n;
    for (s = 0; s < i; ++s)
      n = t[s] - e, n < 0 ? (n += Ji, e = 1) : e = 0, t[s] = n;
    for (; t[t.length - 1] === 0; )
      t.pop();
  }
  toString(e) {
    if ((e || 10) != 10)
      throw new Error("only base 10 is supported");
    const t = this.buf;
    let i = t[t.length - 1].toString();
    for (let s = t.length - 2; s >= 0; --s)
      i += (Ji + t[s]).toString().substring(1);
    return i;
  }
  valueOf() {
    const e = this.buf;
    let t = 0;
    for (let i = e.length - 1; i >= 0; --i)
      t = t * Ji + e[i];
    return t;
  }
  simplify() {
    const e = this.buf;
    return e.length == 1 ? e[0] : this;
  }
}
const Xc = "…", mp = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/, yp = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
function hs(d, e) {
  return d.length > e && (d = d.substring(0, e) + Xc), d;
}
class Hs {
  constructor(e, t) {
    this.hexDigits = "0123456789ABCDEF", e instanceof Hs ? (this.enc = e.enc, this.pos = e.pos) : (this.enc = e, this.pos = t);
  }
  get(e) {
    if (e === void 0 && (e = this.pos++), e >= this.enc.length)
      throw new Error(`Requesting byte offset ${e} on a stream of length ${this.enc.length}`);
    return typeof this.enc == "string" ? this.enc.charCodeAt(e) : this.enc[e];
  }
  hexByte(e) {
    return this.hexDigits.charAt(e >> 4 & 15) + this.hexDigits.charAt(e & 15);
  }
  hexDump(e, t, i) {
    let s = "";
    for (let n = e; n < t; ++n)
      if (s += this.hexByte(this.get(n)), i !== !0)
        switch (n & 15) {
          case 7:
            s += "  ";
            break;
          case 15:
            s += `
`;
            break;
          default:
            s += " ";
        }
    return s;
  }
  isASCII(e, t) {
    for (let i = e; i < t; ++i) {
      const s = this.get(i);
      if (s < 32 || s > 176)
        return !1;
    }
    return !0;
  }
  parseStringISO(e, t) {
    let i = "";
    for (let s = e; s < t; ++s)
      i += String.fromCharCode(this.get(s));
    return i;
  }
  parseStringUTF(e, t) {
    let i = "";
    for (let s = e; s < t; ) {
      const n = this.get(s++);
      n < 128 ? i += String.fromCharCode(n) : n > 191 && n < 224 ? i += String.fromCharCode((n & 31) << 6 | this.get(s++) & 63) : i += String.fromCharCode((n & 15) << 12 | (this.get(s++) & 63) << 6 | this.get(s++) & 63);
    }
    return i;
  }
  parseStringBMP(e, t) {
    let i = "", s, n;
    for (let r = e; r < t; )
      s = this.get(r++), n = this.get(r++), i += String.fromCharCode(s << 8 | n);
    return i;
  }
  parseTime(e, t, i) {
    let s = this.parseStringISO(e, t);
    const n = (i ? mp : yp).exec(s);
    return n ? (i && (n[1] = +n[1], n[1] += +n[1] < 70 ? 2e3 : 1900), s = n[1] + "-" + n[2] + "-" + n[3] + " " + n[4], n[5] && (s += ":" + n[5], n[6] && (s += ":" + n[6], n[7] && (s += "." + n[7]))), n[8] && (s += " UTC", n[8] != "Z" && (s += n[8], n[9] && (s += ":" + n[9]))), s) : "Unrecognized time: " + s;
  }
  parseInteger(e, t) {
    let i = this.get(e);
    const s = i > 127, n = s ? 255 : 0;
    let r, a = "";
    for (; i == n && ++e < t; )
      i = this.get(e);
    if (r = t - e, r === 0)
      return s ? -1 : 0;
    if (r > 4) {
      for (a = i, r <<= 3; !((+a ^ n) & 128); )
        a = +a << 1, --r;
      a = "(" + r + ` bit)
`;
    }
    s && (i = i - 256);
    const o = new Us(i);
    for (let c = e + 1; c < t; ++c)
      o.mulAdd(256, this.get(c));
    return a + o.toString();
  }
  parseBitString(e, t, i) {
    const s = this.get(e), r = "(" + ((t - e - 1 << 3) - s) + ` bit)
`;
    let a = "";
    for (let o = e + 1; o < t; ++o) {
      const c = this.get(o), u = o == t - 1 ? s : 0;
      for (let f = 7; f >= u; --f)
        a += c >> f & 1 ? "1" : "0";
      if (a.length > i)
        return r + hs(a, i);
    }
    return r + a;
  }
  parseOctetString(e, t, i) {
    if (this.isASCII(e, t))
      return hs(this.parseStringISO(e, t), i);
    const s = t - e;
    let n = "(" + s + ` byte)
`;
    i /= 2, s > i && (t = e + i);
    for (let r = e; r < t; ++r)
      n += this.hexByte(this.get(r));
    return s > i && (n += Xc), n;
  }
  parseOID(e, t, i) {
    let s = "", n = new Us(), r = 0;
    for (let a = e; a < t; ++a) {
      const o = this.get(a);
      if (n.mulAdd(128, o & 127), r += 7, !(o & 128)) {
        if (s === "")
          if (n = n.simplify(), n instanceof Us)
            n.sub(80), s = "2." + n.toString();
          else {
            const c = n < 80 ? n < 40 ? 0 : 1 : 2;
            s = c + "." + (n - c * 40);
          }
        else
          s += "." + n.toString();
        if (s.length > i)
          return hs(s, i);
        n = new Us(), r = 0;
      }
    }
    return r > 0 && (s += ".incomplete"), s;
  }
}
class Gi {
  constructor(e, t, i, s, n) {
    if (!(s instanceof ed))
      throw new Error("Invalid tag value.");
    this.stream = e, this.header = t, this.length = i, this.tag = s, this.sub = n;
  }
  typeName() {
    switch (this.tag.tagClass) {
      case 0:
        switch (this.tag.tagNumber) {
          case 0:
            return "EOC";
          case 1:
            return "BOOLEAN";
          case 2:
            return "INTEGER";
          case 3:
            return "BIT_STRING";
          case 4:
            return "OCTET_STRING";
          case 5:
            return "NULL";
          case 6:
            return "OBJECT_IDENTIFIER";
          case 7:
            return "ObjectDescriptor";
          case 8:
            return "EXTERNAL";
          case 9:
            return "REAL";
          case 10:
            return "ENUMERATED";
          case 11:
            return "EMBEDDED_PDV";
          case 12:
            return "UTF8String";
          case 16:
            return "SEQUENCE";
          case 17:
            return "SET";
          case 18:
            return "NumericString";
          case 19:
            return "PrintableString";
          case 20:
            return "TeletexString";
          case 21:
            return "VideotexString";
          case 22:
            return "IA5String";
          case 23:
            return "UTCTime";
          case 24:
            return "GeneralizedTime";
          case 25:
            return "GraphicString";
          case 26:
            return "VisibleString";
          case 27:
            return "GeneralString";
          case 28:
            return "UniversalString";
          case 30:
            return "BMPString";
        }
        return "Universal_" + this.tag.tagNumber.toString();
      case 1:
        return "Application_" + this.tag.tagNumber.toString();
      case 2:
        return "[" + this.tag.tagNumber.toString() + "]";
      case 3:
        return "Private_" + this.tag.tagNumber.toString();
    }
  }
  content(e) {
    if (this.tag === void 0)
      return null;
    e === void 0 && (e = 1 / 0);
    const t = this.posContent(), i = Math.abs(this.length);
    if (!this.tag.isUniversal())
      return this.sub !== null ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(t, t + i, e);
    switch (this.tag.tagNumber) {
      case 1:
        return this.stream.get(t) === 0 ? "false" : "true";
      case 2:
        return this.stream.parseInteger(t, t + i);
      case 3:
        return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseBitString(t, t + i, e);
      case 4:
        return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(t, t + i, e);
      case 6:
        return this.stream.parseOID(t, t + i, e);
      case 16:
      case 17:
        return this.sub !== null ? "(" + this.sub.length + " elem)" : "(no elem)";
      case 12:
        return hs(this.stream.parseStringUTF(t, t + i), e);
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
      case 26:
        return hs(this.stream.parseStringISO(t, t + i), e);
      case 30:
        return hs(this.stream.parseStringBMP(t, t + i), e);
      case 23:
      case 24:
        return this.stream.parseTime(t, t + i, this.tag.tagNumber == 23);
    }
    return null;
  }
  toString() {
    return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + (this.sub === null ? "null" : this.sub.length) + "]";
  }
  toPrettyString(e) {
    e === void 0 && (e = "");
    let t = e + this.typeName() + " @" + this.stream.pos;
    if (this.length >= 0 && (t += "+"), t += this.length, this.tag.tagConstructed ? t += " (constructed)" : this.tag.isUniversal() && (this.tag.tagNumber == 3 || this.tag.tagNumber == 4) && this.sub !== null && (t += " (encapsulates)"), t += `
`, this.sub !== null) {
      e += "  ";
      for (let i = 0, s = this.sub.length; i < s; ++i)
        t += this.sub[i].toPrettyString(e);
    }
    return t;
  }
  posStart() {
    return this.stream.pos;
  }
  posContent() {
    return this.stream.pos + this.header;
  }
  posEnd() {
    return this.stream.pos + this.header + Math.abs(this.length);
  }
  toHexString() {
    return this.stream.hexDump(this.posStart(), this.posEnd(), !0);
  }
  static decodeLength(e) {
    let t = e.get();
    const i = t & 127;
    if (i == t)
      return i;
    if (i > 6)
      throw new Error("Length over 48 bits not supported at position " + (e.pos - 1));
    if (i === 0)
      return null;
    t = 0;
    for (let s = 0; s < i; ++s)
      t = t * 256 + e.get();
    return t;
  }
  /**
   * Retrieve the hexadecimal value (as a string) of the current ASN.1 element
   * @returns {string}
   * @public
   */
  getHexStringValue() {
    const e = this.toHexString(), t = this.header * 2, i = this.length * 2;
    return e.substr(t, i);
  }
  static decode(e) {
    let t;
    e instanceof Hs ? t = e : t = new Hs(e, 0);
    const i = new Hs(t), s = new ed(t);
    let n = Gi.decodeLength(t);
    const r = t.pos, a = r - i.pos;
    let o = null;
    const c = function() {
      const u = [];
      if (n !== null) {
        const f = r + n;
        for (; t.pos < f; )
          u[u.length] = Gi.decode(t);
        if (t.pos != f)
          throw new Error("Content size is not correct for container starting at offset " + r);
      } else
        try {
          for (; ; ) {
            const f = Gi.decode(t);
            if (f.tag.isEOC())
              break;
            u[u.length] = f;
          }
          n = r - t.pos;
        } catch (f) {
          throw new Error("Exception while decoding undefined length content: " + f);
        }
      return u;
    };
    if (s.tagConstructed)
      o = c();
    else if (s.isUniversal() && (s.tagNumber == 3 || s.tagNumber == 4))
      try {
        if (s.tagNumber == 3 && t.get() != 0)
          throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
        o = c();
        for (let u = 0; u < o.length; ++u)
          if (o[u].tag.isEOC())
            throw new Error("EOC is not supposed to be actual content.");
      } catch {
        o = null;
      }
    if (o === null) {
      if (n === null)
        throw new Error("We can't skip over an invalid tag with undefined length at offset " + r);
      t.pos = r + Math.abs(n);
    }
    return new Gi(i, a, n, s, o);
  }
}
class ed {
  constructor(e) {
    let t = e.get();
    if (this.tagClass = t >> 6, this.tagConstructed = (t & 32) !== 0, this.tagNumber = t & 31, this.tagNumber == 31) {
      const i = new Us();
      do
        t = e.get(), i.mulAdd(128, t & 127);
      while (t & 128);
      this.tagNumber = i.simplify();
    }
  }
  isUniversal() {
    return this.tagClass === 0;
  }
  isEOC() {
    return this.tagClass === 0 && this.tagNumber === 0;
  }
}
function wp(d, e, t, i) {
  if (typeof d.setBigUint64 == "function")
    return d.setBigUint64(e, t, i);
  const s = BigInt(32), n = BigInt(4294967295), r = Number(t >> s & n), a = Number(t & n), o = i ? 4 : 0, c = i ? 0 : 4;
  d.setUint32(e + o, r, i), d.setUint32(e + c, a, i);
}
class io extends Yc {
  constructor(e, t, i, s) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = i, this.isLE = s, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = Fr(this.buffer);
  }
  update(e) {
    qi.exists(this);
    const { view: t, buffer: i, blockLen: s } = this;
    e = eo(e);
    const n = e.length;
    for (let r = 0; r < n; ) {
      const a = Math.min(s - this.pos, n - r);
      if (a === s) {
        const o = Fr(e);
        for (; s <= n - r; r += s)
          this.process(o, r);
        continue;
      }
      i.set(e.subarray(r, r + a), this.pos), this.pos += a, r += a, this.pos === s && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    qi.exists(this), qi.output(e, this), this.finished = !0;
    const { buffer: t, view: i, blockLen: s, isLE: n } = this;
    let { pos: r } = this;
    t[r++] = 128, this.buffer.subarray(r).fill(0), this.padOffset > s - r && (this.process(i, 0), r = 0);
    for (let f = r; f < s; f++)
      t[f] = 0;
    wp(i, s - 8, BigInt(this.length * 8), n), this.process(i, 0);
    const a = Fr(e), o = this.outputLen;
    if (o % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const c = o / 4, u = this.get();
    if (c > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < c; f++)
      a.setUint32(4 * f, u[f], n);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const i = e.slice(0, t);
    return this.destroy(), i;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: i, length: s, finished: n, destroyed: r, pos: a } = this;
    return e.length = s, e.pos = a, e.finished = n, e.destroyed = r, s % t && e.buffer.set(i), e;
  }
}
const bp = (d, e, t) => d & e ^ ~d & t, Sp = (d, e, t) => d & e ^ d & t ^ e & t, Tp = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), yi = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), wi = new Uint32Array(64);
class $c extends io {
  constructor() {
    super(64, 32, 8, !1), this.A = yi[0] | 0, this.B = yi[1] | 0, this.C = yi[2] | 0, this.D = yi[3] | 0, this.E = yi[4] | 0, this.F = yi[5] | 0, this.G = yi[6] | 0, this.H = yi[7] | 0;
  }
  get() {
    const { A: e, B: t, C: i, D: s, E: n, F: r, G: a, H: o } = this;
    return [e, t, i, s, n, r, a, o];
  }
  // prettier-ignore
  set(e, t, i, s, n, r, a, o) {
    this.A = e | 0, this.B = t | 0, this.C = i | 0, this.D = s | 0, this.E = n | 0, this.F = r | 0, this.G = a | 0, this.H = o | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      wi[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const h = wi[f - 15], l = wi[f - 2], p = qt(h, 7) ^ qt(h, 18) ^ h >>> 3, m = qt(l, 17) ^ qt(l, 19) ^ l >>> 10;
      wi[f] = m + wi[f - 7] + p + wi[f - 16] | 0;
    }
    let { A: i, B: s, C: n, D: r, E: a, F: o, G: c, H: u } = this;
    for (let f = 0; f < 64; f++) {
      const h = qt(a, 6) ^ qt(a, 11) ^ qt(a, 25), l = u + h + bp(a, o, c) + Tp[f] + wi[f] | 0, m = (qt(i, 2) ^ qt(i, 13) ^ qt(i, 22)) + Sp(i, s, n) | 0;
      u = c, c = o, o = a, a = r + l | 0, r = n, n = s, s = i, i = l + m | 0;
    }
    i = i + this.A | 0, s = s + this.B | 0, n = n + this.C | 0, r = r + this.D | 0, a = a + this.E | 0, o = o + this.F | 0, c = c + this.G | 0, u = u + this.H | 0, this.set(i, s, n, r, a, o, c, u);
  }
  roundClean() {
    wi.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
class Ap extends $c {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
const Re = Zi(() => new $c());
Zi(() => new Ap());
const st = BigInt(0), Xe = BigInt(1), Fi = BigInt(2), Ip = BigInt(3), Oa = BigInt(4), td = BigInt(5), id = BigInt(8);
BigInt(9);
BigInt(16);
function _e(d, e) {
  const t = d % e;
  return t >= st ? t : e + t;
}
function Zc(d, e, t) {
  if (t <= st || e < st)
    throw new Error("Expected power/modulo > 0");
  if (t === Xe)
    return st;
  let i = Xe;
  for (; e > st; )
    e & Xe && (i = i * d % t), d = d * d % t, e >>= Xe;
  return i;
}
function Ge(d, e, t) {
  let i = d;
  for (; e-- > st; )
    i *= i, i %= t;
  return i;
}
function Ma(d, e) {
  if (d === st || e <= st)
    throw new Error(`invert: expected positive integers, got n=${d} mod=${e}`);
  let t = _e(d, e), i = e, s = st, n = Xe;
  for (; t !== st; ) {
    const a = i / t, o = i % t, c = s - n * a;
    i = t, t = o, s = n, n = c;
  }
  if (i !== Xe)
    throw new Error("invert: does not exist");
  return _e(s, e);
}
function Op(d) {
  const e = (d - Xe) / Fi;
  let t, i, s;
  for (t = d - Xe, i = 0; t % Fi === st; t /= Fi, i++)
    ;
  for (s = Fi; s < d && Zc(s, e, d) !== d - Xe; s++)
    ;
  if (i === 1) {
    const r = (d + Xe) / Oa;
    return function(o, c) {
      const u = o.pow(c, r);
      if (!o.eql(o.sqr(u), c))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  const n = (t + Xe) / Fi;
  return function(a, o) {
    if (a.pow(o, e) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let c = i, u = a.pow(a.mul(a.ONE, s), t), f = a.pow(o, n), h = a.pow(o, t);
    for (; !a.eql(h, a.ONE); ) {
      if (a.eql(h, a.ZERO))
        return a.ZERO;
      let l = 1;
      for (let m = a.sqr(h); l < c && !a.eql(m, a.ONE); l++)
        m = a.sqr(m);
      const p = a.pow(u, Xe << BigInt(c - l - 1));
      u = a.sqr(p), f = a.mul(f, p), h = a.mul(h, u), c = l;
    }
    return f;
  };
}
function Mp(d) {
  if (d % Oa === Ip) {
    const e = (d + Xe) / Oa;
    return function(i, s) {
      const n = i.pow(s, e);
      if (!i.eql(i.sqr(n), s))
        throw new Error("Cannot find square root");
      return n;
    };
  }
  if (d % id === td) {
    const e = (d - td) / id;
    return function(i, s) {
      const n = i.mul(s, Fi), r = i.pow(n, e), a = i.mul(s, r), o = i.mul(i.mul(a, Fi), r), c = i.mul(a, i.sub(o, i.ONE));
      if (!i.eql(i.sqr(c), s))
        throw new Error("Cannot find square root");
      return c;
    };
  }
  return Op(d);
}
const Ai = (d, e) => (_e(d, e) & Xe) === Xe, Cp = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Qc(d) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, t = Cp.reduce((i, s) => (i[s] = "function", i), e);
  return Bi(d, t);
}
function xp(d, e, t) {
  if (t < st)
    throw new Error("Expected power > 0");
  if (t === st)
    return d.ONE;
  if (t === Xe)
    return e;
  let i = d.ONE, s = e;
  for (; t > st; )
    t & Xe && (i = d.mul(i, s)), s = d.sqr(s), t >>= 1n;
  return i;
}
function vp(d, e) {
  const t = new Array(e.length), i = e.reduce((n, r, a) => d.is0(r) ? n : (t[a] = n, d.mul(n, r)), d.ONE), s = d.inv(i);
  return e.reduceRight((n, r, a) => d.is0(r) ? n : (t[a] = d.mul(n, t[a]), d.mul(n, r)), s), t;
}
function so(d, e) {
  const t = e !== void 0 ? e : d.toString(2).length, i = Math.ceil(t / 8);
  return { nBitLength: t, nByteLength: i };
}
function no(d, e, t = !1, i = {}) {
  if (d <= st)
    throw new Error(`Expected Fp ORDER > 0, got ${d}`);
  const { nBitLength: s, nByteLength: n } = so(d, e);
  if (n > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const r = Mp(d), a = Object.freeze({
    ORDER: d,
    BITS: s,
    BYTES: n,
    MASK: Ja(s),
    ZERO: st,
    ONE: Xe,
    create: (o) => _e(o, d),
    isValid: (o) => {
      if (typeof o != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof o}`);
      return st <= o && o < d;
    },
    is0: (o) => o === st,
    isOdd: (o) => (o & Xe) === Xe,
    neg: (o) => _e(-o, d),
    eql: (o, c) => o === c,
    sqr: (o) => _e(o * o, d),
    add: (o, c) => _e(o + c, d),
    sub: (o, c) => _e(o - c, d),
    mul: (o, c) => _e(o * c, d),
    pow: (o, c) => xp(a, o, c),
    div: (o, c) => _e(o * Ma(c, d), d),
    // Same as above, but doesn't normalize
    sqrN: (o) => o * o,
    addN: (o, c) => o + c,
    subN: (o, c) => o - c,
    mulN: (o, c) => o * c,
    inv: (o) => Ma(o, d),
    sqrt: i.sqrt || ((o) => r(a, o)),
    invertBatch: (o) => vp(a, o),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (o, c, u) => u ? c : o,
    toBytes: (o) => t ? Kt(o, n) : ni(o, n),
    fromBytes: (o) => {
      if (o.length !== n)
        throw new Error(`Fp.fromBytes: expected ${n}, got ${o.length}`);
      return t ? Wt(o) : wt(o);
    }
  });
  return Object.freeze(a);
}
function kp(d, e) {
  if (!d.isOdd)
    throw new Error("Field doesn't have isOdd");
  const t = d.sqrt(e);
  return d.isOdd(t) ? d.neg(t) : t;
}
function Ep(d, e, t = !1) {
  d = Ne("privateHash", d);
  const i = d.length, s = so(e).nByteLength + 8;
  if (s < 24 || i < s || i > 1024)
    throw new Error(`hashToPrivateScalar: expected ${s}-1024 bytes of input, got ${i}`);
  const n = t ? Wt(d) : wt(d);
  return _e(n, e - Xe) + Xe;
}
const Np = BigInt(0), Ur = BigInt(1);
function Jc(d, e) {
  const t = (s, n) => {
    const r = n.negate();
    return s ? r : n;
  }, i = (s) => {
    const n = Math.ceil(e / s) + 1, r = 2 ** (s - 1);
    return { windows: n, windowSize: r };
  };
  return {
    constTimeNegate: t,
    // non-const time multiplication ladder
    unsafeLadder(s, n) {
      let r = d.ZERO, a = s;
      for (; n > Np; )
        n & Ur && (r = r.add(a)), a = a.double(), n >>= Ur;
      return r;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(s, n) {
      const { windows: r, windowSize: a } = i(n), o = [];
      let c = s, u = c;
      for (let f = 0; f < r; f++) {
        u = c, o.push(u);
        for (let h = 1; h < a; h++)
          u = u.add(c), o.push(u);
        c = u.double();
      }
      return o;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(s, n, r) {
      const { windows: a, windowSize: o } = i(s);
      let c = d.ZERO, u = d.BASE;
      const f = BigInt(2 ** s - 1), h = 2 ** s, l = BigInt(s);
      for (let p = 0; p < a; p++) {
        const m = p * o;
        let y = Number(r & f);
        r >>= l, y > o && (y -= h, r += Ur);
        const w = m, S = m + Math.abs(y) - 1, b = p % 2 !== 0, T = y < 0;
        y === 0 ? u = u.add(t(b, n[w])) : c = c.add(t(T, n[S]));
      }
      return { p: c, f: u };
    },
    wNAFCached(s, n, r, a) {
      const o = s._WINDOW_SIZE || 1;
      let c = n.get(s);
      return c || (c = this.precomputeWindow(s, o), o !== 1 && n.set(s, a(c))), this.wNAF(o, c, r);
    }
  };
}
function ro(d) {
  return Qc(d.Fp), Bi(d, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({ ...so(d.n, d.nBitLength), ...d });
}
function Pp(d) {
  const e = ro(d);
  Bi(e, {
    a: "field",
    b: "field",
    fromBytes: "function",
    toBytes: "function"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean"
  });
  const { endo: t, Fp: i, a: s } = e;
  if (t) {
    if (!i.eql(s, i.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof t != "object" || typeof t.beta != "bigint" || typeof t.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: _p, hexToBytes: Lp } = gl, zi = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  _parseInt(d) {
    const { Err: e } = zi;
    if (d.length < 2 || d[0] !== 2)
      throw new e("Invalid signature integer tag");
    const t = d[1], i = d.subarray(2, t + 2);
    if (!t || i.length !== t)
      throw new e("Invalid signature integer: wrong length");
    if (i[0] === 0 && i[1] <= 127)
      throw new e("Invalid signature integer: trailing length");
    return { d: _p(i), l: d.subarray(t + 2) };
  },
  toSig(d) {
    const { Err: e } = zi, t = typeof d == "string" ? Lp(d) : d;
    if (!(t instanceof Uint8Array))
      throw new Error("ui8a expected");
    let i = t.length;
    if (i < 2 || t[0] != 48)
      throw new e("Invalid signature tag");
    if (t[1] !== i - 2)
      throw new e("Invalid signature: incorrect length");
    const { d: s, l: n } = zi._parseInt(t.subarray(2)), { d: r, l: a } = zi._parseInt(n);
    if (a.length)
      throw new e("Invalid signature: left bytes after parsing");
    return { r: s, s: r };
  },
  hexFromSig(d) {
    const e = (c) => Number.parseInt(c[0], 16) >= 8 ? "00" + c : c, t = (c) => {
      const u = c.toString(16);
      return u.length & 1 ? `0${u}` : u;
    }, i = e(t(d.s)), s = e(t(d.r)), n = i.length / 2, r = s.length / 2, a = t(n), o = t(r);
    return `30${t(r + n + 4)}02${o}${s}02${a}${i}`;
  }
}, ti = BigInt(0), vt = BigInt(1);
function Dp(d) {
  const e = Pp(d), { Fp: t } = e;
  function i(h) {
    const { a: l, b: p } = e, m = t.sqr(h), y = t.mul(m, h);
    return t.add(t.add(y, t.mul(h, l)), p);
  }
  function s(h) {
    return typeof h == "bigint" && ti < h && h < e.n;
  }
  function n(h) {
    if (!s(h))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function r(h) {
    const { allowedPrivateKeyLengths: l, nByteLength: p, wrapPrivateKey: m, n: y } = e;
    if (l && typeof h != "bigint") {
      if (h instanceof Uint8Array && (h = ki(h)), typeof h != "string" || !l.includes(h.length))
        throw new Error("Invalid key");
      h = h.padStart(p * 2, "0");
    }
    let w;
    try {
      w = typeof h == "bigint" ? h : wt(Ne("private key", h, p));
    } catch {
      throw new Error(`private key must be ${p} bytes, hex or bigint, not ${typeof h}`);
    }
    return m && (w = _e(w, y)), n(w), w;
  }
  const a = /* @__PURE__ */ new Map();
  function o(h) {
    if (!(h instanceof c))
      throw new Error("ProjectivePoint expected");
  }
  class c {
    constructor(l, p, m) {
      if (this.px = l, this.py = p, this.pz = m, l == null || !t.isValid(l))
        throw new Error("x required");
      if (p == null || !t.isValid(p))
        throw new Error("y required");
      if (m == null || !t.isValid(m))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(l) {
      const { x: p, y: m } = l || {};
      if (!l || !t.isValid(p) || !t.isValid(m))
        throw new Error("invalid affine point");
      if (l instanceof c)
        throw new Error("projective point not allowed");
      const y = (w) => t.eql(w, t.ZERO);
      return y(p) && y(m) ? c.ZERO : new c(p, m, t.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(l) {
      const p = t.invertBatch(l.map((m) => m.pz));
      return l.map((m, y) => m.toAffine(p[y])).map(c.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(l) {
      const p = c.fromAffine(e.fromBytes(Ne("pointHex", l)));
      return p.assertValidity(), p;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(l) {
      return c.BASE.multiply(r(l));
    }
    // "Private method", don't use it directly
    _setWindowSize(l) {
      this._WINDOW_SIZE = l, a.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (e.allowInfinityPoint)
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: l, y: p } = this.toAffine();
      if (!t.isValid(l) || !t.isValid(p))
        throw new Error("bad point: x or y not FE");
      const m = t.sqr(p), y = i(l);
      if (!t.eql(m, y))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: l } = this.toAffine();
      if (t.isOdd)
        return !t.isOdd(l);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(l) {
      o(l);
      const { px: p, py: m, pz: y } = this, { px: w, py: S, pz: b } = l, T = t.eql(t.mul(p, b), t.mul(w, y)), x = t.eql(t.mul(m, b), t.mul(S, y));
      return T && x;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new c(this.px, t.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: l, b: p } = e, m = t.mul(p, 3n), { px: y, py: w, pz: S } = this;
      let b = t.ZERO, T = t.ZERO, x = t.ZERO, v = t.mul(y, y), _ = t.mul(w, w), V = t.mul(S, S), j = t.mul(y, w);
      return j = t.add(j, j), x = t.mul(y, S), x = t.add(x, x), b = t.mul(l, x), T = t.mul(m, V), T = t.add(b, T), b = t.sub(_, T), T = t.add(_, T), T = t.mul(b, T), b = t.mul(j, b), x = t.mul(m, x), V = t.mul(l, V), j = t.sub(v, V), j = t.mul(l, j), j = t.add(j, x), x = t.add(v, v), v = t.add(x, v), v = t.add(v, V), v = t.mul(v, j), T = t.add(T, v), V = t.mul(w, S), V = t.add(V, V), v = t.mul(V, j), b = t.sub(b, v), x = t.mul(V, _), x = t.add(x, x), x = t.add(x, x), new c(b, T, x);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(l) {
      o(l);
      const { px: p, py: m, pz: y } = this, { px: w, py: S, pz: b } = l;
      let T = t.ZERO, x = t.ZERO, v = t.ZERO;
      const _ = e.a, V = t.mul(e.b, 3n);
      let j = t.mul(p, w), G = t.mul(m, S), W = t.mul(y, b), B = t.add(p, m), Q = t.add(w, S);
      B = t.mul(B, Q), Q = t.add(j, G), B = t.sub(B, Q), Q = t.add(p, y);
      let se = t.add(w, b);
      return Q = t.mul(Q, se), se = t.add(j, W), Q = t.sub(Q, se), se = t.add(m, y), T = t.add(S, b), se = t.mul(se, T), T = t.add(G, W), se = t.sub(se, T), v = t.mul(_, Q), T = t.mul(V, W), v = t.add(T, v), T = t.sub(G, v), v = t.add(G, v), x = t.mul(T, v), G = t.add(j, j), G = t.add(G, j), W = t.mul(_, W), Q = t.mul(V, Q), G = t.add(G, W), W = t.sub(j, W), W = t.mul(_, W), Q = t.add(Q, W), j = t.mul(G, Q), x = t.add(x, j), j = t.mul(se, Q), T = t.mul(B, T), T = t.sub(T, j), j = t.mul(B, G), v = t.mul(se, v), v = t.add(v, j), new c(T, x, v);
    }
    subtract(l) {
      return this.add(l.negate());
    }
    is0() {
      return this.equals(c.ZERO);
    }
    wNAF(l) {
      return f.wNAFCached(this, a, l, (p) => {
        const m = t.invertBatch(p.map((y) => y.pz));
        return p.map((y, w) => y.toAffine(m[w])).map(c.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(l) {
      const p = c.ZERO;
      if (l === ti)
        return p;
      if (n(l), l === vt)
        return this;
      const { endo: m } = e;
      if (!m)
        return f.unsafeLadder(this, l);
      let { k1neg: y, k1: w, k2neg: S, k2: b } = m.splitScalar(l), T = p, x = p, v = this;
      for (; w > ti || b > ti; )
        w & vt && (T = T.add(v)), b & vt && (x = x.add(v)), v = v.double(), w >>= vt, b >>= vt;
      return y && (T = T.negate()), S && (x = x.negate()), x = new c(t.mul(x.px, m.beta), x.py, x.pz), T.add(x);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(l) {
      n(l);
      let p = l, m, y;
      const { endo: w } = e;
      if (w) {
        const { k1neg: S, k1: b, k2neg: T, k2: x } = w.splitScalar(p);
        let { p: v, f: _ } = this.wNAF(b), { p: V, f: j } = this.wNAF(x);
        v = f.constTimeNegate(S, v), V = f.constTimeNegate(T, V), V = new c(t.mul(V.px, w.beta), V.py, V.pz), m = v.add(V), y = _.add(j);
      } else {
        const { p: S, f: b } = this.wNAF(p);
        m = S, y = b;
      }
      return c.normalizeZ([m, y])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(l, p, m) {
      const y = c.BASE, w = (b, T) => T === ti || T === vt || !b.equals(y) ? b.multiplyUnsafe(T) : b.multiply(T), S = w(this, p).add(w(l, m));
      return S.is0() ? void 0 : S;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(l) {
      const { px: p, py: m, pz: y } = this, w = this.is0();
      l == null && (l = w ? t.ONE : t.inv(y));
      const S = t.mul(p, l), b = t.mul(m, l), T = t.mul(y, l);
      if (w)
        return { x: t.ZERO, y: t.ZERO };
      if (!t.eql(T, t.ONE))
        throw new Error("invZ was invalid");
      return { x: S, y: b };
    }
    isTorsionFree() {
      const { h: l, isTorsionFree: p } = e;
      if (l === vt)
        return !0;
      if (p)
        return p(c, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: l, clearCofactor: p } = e;
      return l === vt ? this : p ? p(c, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(l = !0) {
      return this.assertValidity(), e.toBytes(c, this, l);
    }
    toHex(l = !0) {
      return ki(this.toRawBytes(l));
    }
  }
  c.BASE = new c(e.Gx, e.Gy, t.ONE), c.ZERO = new c(t.ZERO, t.ONE, t.ZERO);
  const u = e.nBitLength, f = Jc(c, e.endo ? Math.ceil(u / 2) : u);
  return {
    ProjectivePoint: c,
    normPrivateKeyToScalar: r,
    weierstrassEquation: i,
    isWithinCurveOrder: s
  };
}
function Rp(d) {
  const e = ro(d);
  return Bi(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function Bp(d) {
  const e = Rp(d), t = e.n, i = e.Fp, s = i.BYTES + 1, n = 2 * i.BYTES + 1;
  function r($) {
    return ti < $ && $ < i.ORDER;
  }
  function a($) {
    return _e($, t);
  }
  function o($) {
    return Ma($, t);
  }
  const { ProjectivePoint: c, normPrivateKeyToScalar: u, weierstrassEquation: f, isWithinCurveOrder: h } = Dp({
    ...e,
    toBytes($, te, E) {
      const N = te.toAffine(), L = i.toBytes(N.x), z = ot;
      return E ? z(Uint8Array.from([te.hasEvenY() ? 2 : 3]), L) : z(Uint8Array.from([4]), L, i.toBytes(N.y));
    },
    fromBytes($) {
      const te = $.length, E = $[0], N = $.subarray(1);
      if (te === s && (E === 2 || E === 3)) {
        const L = wt(N);
        if (!r(L))
          throw new Error("Point is not on curve");
        const z = f(L);
        let K = i.sqrt(z);
        const R = (K & vt) === vt;
        return (E & 1) === 1 !== R && (K = i.neg(K)), { x: L, y: K };
      } else if (te === n && E === 4) {
        const L = i.fromBytes(N.subarray(0, i.BYTES)), z = i.fromBytes(N.subarray(i.BYTES, 2 * i.BYTES));
        return { x: L, y: z };
      } else
        throw new Error(`Point of length ${te} was invalid. Expected ${s} compressed bytes or ${n} uncompressed bytes`);
    }
  }), l = ($) => ki(ni($, e.nByteLength));
  function p($) {
    const te = t >> vt;
    return $ > te;
  }
  function m($) {
    return p($) ? a(-$) : $;
  }
  const y = ($, te, E) => wt($.slice(te, E));
  class w {
    constructor(te, E, N) {
      this.r = te, this.s = E, this.recovery = N, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(te) {
      const E = e.nByteLength;
      return te = Ne("compactSignature", te, E * 2), new w(y(te, 0, E), y(te, E, 2 * E));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(te) {
      const { r: E, s: N } = zi.toSig(Ne("DER", te));
      return new w(E, N);
    }
    assertValidity() {
      if (!h(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!h(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(te) {
      return new w(this.r, this.s, te);
    }
    recoverPublicKey(te) {
      const { r: E, s: N, recovery: L } = this, z = _(Ne("msgHash", te));
      if (L == null || ![0, 1, 2, 3].includes(L))
        throw new Error("recovery id invalid");
      const K = L === 2 || L === 3 ? E + e.n : E;
      if (K >= i.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const R = L & 1 ? "03" : "02", U = c.fromHex(R + l(K)), Y = o(K), J = a(-z * Y), ae = a(N * Y), A = c.BASE.multiplyAndAddUnsafe(U, J, ae);
      if (!A)
        throw new Error("point at infinify");
      return A.assertValidity(), A;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return p(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new w(this.r, a(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return ys(this.toDERHex());
    }
    toDERHex() {
      return zi.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return ys(this.toCompactHex());
    }
    toCompactHex() {
      return l(this.r) + l(this.s);
    }
  }
  const S = {
    isValidPrivateKey($) {
      try {
        return u($), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: u,
    /**
     * Produces cryptographically secure private key from random of size (nBitLength+64)
     * as per FIPS 186 B.4.1 with modulo bias being neglible.
     */
    randomPrivateKey: () => {
      const $ = e.randomBytes(i.BYTES + 8), te = Ep($, t);
      return ni(te, e.nByteLength);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute($ = 8, te = c.BASE) {
      return te._setWindowSize($), te.multiply(BigInt(3)), te;
    }
  };
  function b($, te = !0) {
    return c.fromPrivateKey($).toRawBytes(te);
  }
  function T($) {
    const te = $ instanceof Uint8Array, E = typeof $ == "string", N = (te || E) && $.length;
    return te ? N === s || N === n : E ? N === 2 * s || N === 2 * n : $ instanceof c;
  }
  function x($, te, E = !0) {
    if (T($))
      throw new Error("first arg must be private key");
    if (!T(te))
      throw new Error("second arg must be public key");
    return c.fromHex(te).multiply(u($)).toRawBytes(E);
  }
  const v = e.bits2int || function($) {
    const te = wt($), E = $.length * 8 - e.nBitLength;
    return E > 0 ? te >> BigInt(E) : te;
  }, _ = e.bits2int_modN || function($) {
    return a(v($));
  }, V = Ja(e.nBitLength);
  function j($) {
    if (typeof $ != "bigint")
      throw new Error("bigint expected");
    if (!(ti <= $ && $ < V))
      throw new Error(`bigint expected < 2^${e.nBitLength}`);
    return ni($, e.nByteLength);
  }
  function G($, te, E = W) {
    if (["recovered", "canonical"].some((q) => q in E))
      throw new Error("sign() legacy options not supported");
    const { hash: N, randomBytes: L } = e;
    let { lowS: z, prehash: K, extraEntropy: R } = E;
    z == null && (z = !0), $ = Ne("msgHash", $), K && ($ = Ne("prehashed msgHash", N($)));
    const U = _($), Y = u(te), J = [j(Y), j(U)];
    if (R != null) {
      const q = R === !0 ? L(i.BYTES) : R;
      J.push(Ne("extraEntropy", q, i.BYTES));
    }
    const ae = ot(...J), A = U;
    function M(q) {
      const H = v(q);
      if (!h(H))
        return;
      const le = o(H), oe = c.BASE.multiply(H).toAffine(), he = a(oe.x);
      if (he === ti)
        return;
      const Ie = a(le * a(A + he * Y));
      if (Ie === ti)
        return;
      let Pe = (oe.x === he ? 0 : 2) | Number(oe.y & vt), He = Ie;
      return z && p(Ie) && (He = m(Ie), Pe ^= 1), new w(he, He, Pe);
    }
    return { seed: ae, k2sig: M };
  }
  const W = { lowS: e.lowS, prehash: !1 }, B = { lowS: e.lowS, prehash: !1 };
  function Q($, te, E = W) {
    const { seed: N, k2sig: L } = G($, te, E);
    return Dc(e.hash.outputLen, e.nByteLength, e.hmac)(N, L);
  }
  c.BASE._setWindowSize(8);
  function se($, te, E, N = B) {
    var oe;
    const L = $;
    if (te = Ne("msgHash", te), E = Ne("publicKey", E), "strict" in N)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: z, prehash: K } = N;
    let R, U;
    try {
      if (typeof L == "string" || L instanceof Uint8Array)
        try {
          R = w.fromDER(L);
        } catch (he) {
          if (!(he instanceof zi.Err))
            throw he;
          R = w.fromCompact(L);
        }
      else if (typeof L == "object" && typeof L.r == "bigint" && typeof L.s == "bigint") {
        const { r: he, s: Ie } = L;
        R = new w(he, Ie);
      } else
        throw new Error("PARSE");
      U = c.fromHex(E);
    } catch (he) {
      if (he.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (z && R.hasHighS())
      return !1;
    K && (te = e.hash(te));
    const { r: Y, s: J } = R, ae = _(te), A = o(J), M = a(ae * A), q = a(Y * A), H = (oe = c.BASE.multiplyAndAddUnsafe(U, M, q)) == null ? void 0 : oe.toAffine();
    return H ? a(H.x) === Y : !1;
  }
  return {
    CURVE: e,
    getPublicKey: b,
    getSharedSecret: x,
    sign: Q,
    verify: se,
    ProjectivePoint: c,
    Signature: w,
    utils: S
  };
}
function Vp(d, e) {
  const t = d.ORDER;
  let i = 0n;
  for (let h = t - 1n; h % 2n === 0n; h /= 2n)
    i += 1n;
  const s = i, n = (t - 1n) / 2n ** s, r = (n - 1n) / 2n, a = 2n ** s - 1n, o = 2n ** (s - 1n), c = d.pow(e, n), u = d.pow(e, (n + 1n) / 2n);
  let f = (h, l) => {
    let p = c, m = d.pow(l, a), y = d.sqr(m);
    y = d.mul(y, l);
    let w = d.mul(h, y);
    w = d.pow(w, r), w = d.mul(w, m), m = d.mul(w, l), y = d.mul(w, h);
    let S = d.mul(y, m);
    w = d.pow(S, o);
    let b = d.eql(w, d.ONE);
    m = d.mul(y, u), w = d.mul(S, p), y = d.cmov(m, y, b), S = d.cmov(w, S, b);
    for (let T = s; T > 1; T--) {
      let x = 2n ** (T - 2n), v = d.pow(S, x);
      const _ = d.eql(v, d.ONE);
      m = d.mul(y, p), p = d.mul(p, p), v = d.mul(S, p), y = d.cmov(m, y, _), S = d.cmov(v, S, _);
    }
    return { isValid: b, value: y };
  };
  if (d.ORDER % 4n === 3n) {
    const h = (d.ORDER - 3n) / 4n, l = d.sqrt(d.neg(e));
    f = (p, m) => {
      let y = d.sqr(m);
      const w = d.mul(p, m);
      y = d.mul(y, w);
      let S = d.pow(y, h);
      S = d.mul(S, w);
      const b = d.mul(S, l), T = d.mul(d.sqr(S), m), x = d.eql(T, p);
      let v = d.cmov(b, S, x);
      return { isValid: x, value: v };
    };
  }
  return f;
}
function eu(d, e) {
  if (Qc(d), !d.isValid(e.A) || !d.isValid(e.B) || !d.isValid(e.Z))
    throw new Error("mapToCurveSimpleSWU: invalid opts");
  const t = Vp(d, e.Z);
  if (!d.isOdd)
    throw new Error("Fp.isOdd is not implemented!");
  return (i) => {
    let s, n, r, a, o, c, u, f;
    s = d.sqr(i), s = d.mul(s, e.Z), n = d.sqr(s), n = d.add(n, s), r = d.add(n, d.ONE), r = d.mul(r, e.B), a = d.cmov(e.Z, d.neg(n), !d.eql(n, d.ZERO)), a = d.mul(a, e.A), n = d.sqr(r), c = d.sqr(a), o = d.mul(c, e.A), n = d.add(n, o), n = d.mul(n, r), c = d.mul(c, a), o = d.mul(c, e.B), n = d.add(n, o), u = d.mul(s, r);
    const { isValid: h, value: l } = t(n, c);
    f = d.mul(s, i), f = d.mul(f, l), u = d.cmov(u, r, h), f = d.cmov(f, l, h);
    const p = d.isOdd(i) === d.isOdd(f);
    return f = d.cmov(d.neg(f), f, p), u = d.div(u, a), { x: u, y: f };
  };
}
function jp(d) {
  if (d instanceof Uint8Array)
    return d;
  if (typeof d == "string")
    return ur(d);
  throw new Error("DST must be Uint8Array or string");
}
const Fp = wt;
function Ii(d, e) {
  if (d < 0 || d >= 1 << 8 * e)
    throw new Error(`bad I2OSP call: value=${d} length=${e}`);
  const t = Array.from({ length: e }).fill(0);
  for (let i = e - 1; i >= 0; i--)
    t[i] = d & 255, d >>>= 8;
  return new Uint8Array(t);
}
function Up(d, e) {
  const t = new Uint8Array(d.length);
  for (let i = 0; i < d.length; i++)
    t[i] = d[i] ^ e[i];
  return t;
}
function Ks(d) {
  if (!(d instanceof Uint8Array))
    throw new Error("Uint8Array expected");
}
function ao(d) {
  if (!Number.isSafeInteger(d))
    throw new Error("number expected");
}
function qp(d, e, t, i) {
  Ks(d), Ks(e), ao(t), e.length > 255 && (e = i(ot(ur("H2C-OVERSIZE-DST-"), e)));
  const { outputLen: s, blockLen: n } = i, r = Math.ceil(t / s);
  if (r > 255)
    throw new Error("Invalid xmd length");
  const a = ot(e, Ii(e.length, 1)), o = Ii(0, n), c = Ii(t, 2), u = new Array(r), f = i(ot(o, d, c, Ii(0, 1), a));
  u[0] = i(ot(f, Ii(1, 1), a));
  for (let l = 1; l <= r; l++) {
    const p = [Up(f, u[l - 1]), Ii(l + 1, 1), a];
    u[l] = i(ot(...p));
  }
  return ot(...u).slice(0, t);
}
function Gp(d, e, t, i, s) {
  if (Ks(d), Ks(e), ao(t), e.length > 255) {
    const n = Math.ceil(2 * i / 8);
    e = s.create({ dkLen: n }).update(ur("H2C-OVERSIZE-DST-")).update(e).digest();
  }
  if (t > 65535 || e.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return s.create({ dkLen: t }).update(d).update(Ii(t, 2)).update(e).update(Ii(e.length, 1)).digest();
}
function sd(d, e, t) {
  Bi(t, {
    DST: "string",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p: i, k: s, m: n, hash: r, expand: a, DST: o } = t;
  Ks(d), ao(e);
  const c = jp(o), u = i.toString(2).length, f = Math.ceil((u + s) / 8), h = e * n * f;
  let l;
  if (a === "xmd")
    l = qp(d, c, h, r);
  else if (a === "xof")
    l = Gp(d, c, h, s, r);
  else if (a === void 0)
    l = d;
  else
    throw new Error('expand must be "xmd", "xof" or undefined');
  const p = new Array(e);
  for (let m = 0; m < e; m++) {
    const y = new Array(n);
    for (let w = 0; w < n; w++) {
      const S = f * (w + m * n), b = l.subarray(S, S + f);
      y[w] = _e(Fp(b), i);
    }
    p[m] = y;
  }
  return p;
}
function zp(d, e) {
  const t = e.map((i) => Array.from(i).reverse());
  return (i, s) => {
    const [n, r, a, o] = t.map((c) => c.reduce((u, f) => d.add(d.mul(u, i), f)));
    return i = d.div(n, r), s = d.mul(s, d.div(a, o)), { x: i, y: s };
  };
}
function oo(d, e, t) {
  if (typeof e != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    hashToCurve(i, s) {
      const n = sd(i, 2, { ...t, DST: t.DST, ...s }), r = d.fromAffine(e(n[0])), a = d.fromAffine(e(n[1])), o = r.add(a).clearCofactor();
      return o.assertValidity(), o;
    },
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
    encodeToCurve(i, s) {
      const n = sd(i, 1, { ...t, DST: t.encodeDST, ...s }), r = d.fromAffine(e(n[0])).clearCofactor();
      return r.assertValidity(), r;
    }
  };
}
function Hp(d) {
  return {
    hash: d,
    hmac: (e, ...t) => to(d, e, Wc(...t)),
    randomBytes: hr
  };
}
function tu(d, e) {
  const t = (i) => Bp({ ...d, ...Hp(i) });
  return Object.freeze({ ...t(e), create: t });
}
const lr = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), zn = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), iu = BigInt(1), Ca = BigInt(2), nd = (d, e) => (d + e / Ca) / e;
function su(d) {
  const e = lr, t = BigInt(3), i = BigInt(6), s = BigInt(11), n = BigInt(22), r = BigInt(23), a = BigInt(44), o = BigInt(88), c = d * d * d % e, u = c * c * d % e, f = Ge(u, t, e) * u % e, h = Ge(f, t, e) * u % e, l = Ge(h, Ca, e) * c % e, p = Ge(l, s, e) * l % e, m = Ge(p, n, e) * p % e, y = Ge(m, a, e) * m % e, w = Ge(y, o, e) * y % e, S = Ge(w, a, e) * m % e, b = Ge(S, t, e) * u % e, T = Ge(b, r, e) * p % e, x = Ge(T, i, e) * c % e, v = Ge(x, Ca, e);
  if (!Ei.eql(Ei.sqr(v), d))
    throw new Error("Cannot find square root");
  return v;
}
const Ei = no(lr, void 0, void 0, { sqrt: su }), an = tu({
  a: BigInt(0),
  b: BigInt(7),
  Fp: Ei,
  n: zn,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (d) => {
      const e = zn, t = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), i = -iu * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), s = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), n = t, r = BigInt("0x100000000000000000000000000000000"), a = nd(n * d, e), o = nd(-i * d, e);
      let c = _e(d - a * t - o * s, e), u = _e(-a * i - o * n, e);
      const f = c > r, h = u > r;
      if (f && (c = e - c), h && (u = e - u), c > r || u > r)
        throw new Error("splitScalar: Endomorphism failed, k=" + d);
      return { k1neg: f, k1: c, k2neg: h, k2: u };
    }
  }
}, Re), co = BigInt(0), nu = (d) => typeof d == "bigint" && co < d && d < lr, Wp = (d) => typeof d == "bigint" && co < d && d < zn, rd = {};
function Hn(d, ...e) {
  let t = rd[d];
  if (t === void 0) {
    const i = Re(Uint8Array.from(d, (s) => s.charCodeAt(0)));
    t = ot(i, i), rd[d] = t;
  }
  return Re(ot(t, ...e));
}
const uo = (d) => d.toRawBytes(!0).slice(1), xa = (d) => ni(d, 32), qr = (d) => _e(d, lr), Xs = (d) => _e(d, zn), fo = an.ProjectivePoint, Yp = (d, e, t) => fo.BASE.multiplyAndAddUnsafe(d, e, t);
function va(d) {
  let e = an.utils.normPrivateKeyToScalar(d), t = fo.fromPrivateKey(e);
  return { scalar: t.hasEvenY() ? e : Xs(-e), bytes: uo(t) };
}
function ru(d) {
  if (!nu(d))
    throw new Error("bad x: need 0 < x < p");
  const e = qr(d * d), t = qr(e * d + BigInt(7));
  let i = su(t);
  i % 2n !== 0n && (i = qr(-i));
  const s = new fo(d, i, iu);
  return s.assertValidity(), s;
}
function au(...d) {
  return Xs(wt(Hn("BIP0340/challenge", ...d)));
}
function Kp(d) {
  return va(d).bytes;
}
function Xp(d, e, t = hr(32)) {
  const i = Ne("message", d), { bytes: s, scalar: n } = va(e), r = Ne("auxRand", t, 32), a = xa(n ^ wt(Hn("BIP0340/aux", r))), o = Hn("BIP0340/nonce", a, s, i), c = Xs(wt(o));
  if (c === co)
    throw new Error("sign failed: k is zero");
  const { bytes: u, scalar: f } = va(c), h = au(u, s, i), l = new Uint8Array(64);
  if (l.set(u, 0), l.set(xa(Xs(f + h * n)), 32), !ou(l, i, s))
    throw new Error("sign: Invalid signature produced");
  return l;
}
function ou(d, e, t) {
  const i = Ne("signature", d, 64), s = Ne("message", e), n = Ne("publicKey", t, 32);
  try {
    const r = ru(wt(n)), a = wt(i.subarray(0, 32));
    if (!nu(a))
      return !1;
    const o = wt(i.subarray(32, 64));
    if (!Wp(o))
      return !1;
    const c = au(xa(a), uo(r), s), u = Yp(r, o, Xs(-c));
    return !(!u || !u.hasEvenY() || u.toAffine().x !== a);
  } catch {
    return !1;
  }
}
an.utils.randomPrivateKey;
const $p = zp(Ei, [
  // xNum
  [
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
    "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
    "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
  ],
  // xDen
  [
    "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
    "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ],
  // yNum
  [
    "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
    "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
    "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
    "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
  ],
  // yDen
  [
    "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
    "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
    "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ]
].map((d) => d.map((e) => BigInt(e)))), Zp = eu(Ei, {
  A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
  B: BigInt("1771"),
  Z: Ei.create(BigInt("-11"))
});
oo(an.ProjectivePoint, (d) => {
  const { x: e, y: t } = Zp(Ei.create(d[0]));
  return $p(e, t);
}, {
  DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
  encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
  p: Ei.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: Re
});
const $s = no(BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff")), du = $s.create(BigInt("-3")), cu = BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"), Qp = eu($s, {
  A: du,
  B: cu,
  Z: $s.create(BigInt("-10"))
}), ho = tu({
  // Params: a, b
  a: du,
  b: cu,
  Fp: $s,
  // Curve order, total count of valid points in the field
  n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"),
  // Base point (x, y) aka generator point
  Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"),
  Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),
  h: BigInt(1),
  lowS: !1
}, Re), Jp = ho;
oo(Jp.ProjectivePoint, (d) => Qp(d[0]), {
  DST: "P256_XMD:SHA-256_SSWU_RO_",
  encodeDST: "P256_XMD:SHA-256_SSWU_NU_",
  p: $s.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: Re
});
const uu = {
  binary: (d) => d,
  hex: Ri.encode,
  base64: pi.encode
}, ad = {
  "1.3.132.0.10": an,
  "1.2.840.10045.3.1.7": ho
}, fu = (d, e, t = "hex") => {
  const i = e(d);
  return uu[t](i);
}, lo = (d, e, t, i = "hex") => {
  const s = to(t, e, d);
  return uu[i](s);
};
function hu(d, e, t, i = null, s = !1) {
  if (i && (d = fu(d, i, "hex")), typeof e == "string" && e.length > 64)
    if (e.startsWith("-----BEGIN EC PRIVATE KEY-----")) {
      const c = Ys.unarmor(e);
      let u = Gi.decode(c);
      if (u.sub.length === 4) {
        if (typeof u.sub[2].sub !== null && u.sub[2].sub.length > 0) {
          const f = u.sub[2].sub[0].content(void 0);
          if (ad[f] === void 0)
            throw new Error("Unsupported curve");
          t = ad[f];
        }
        e = u.sub[1].getHexStringValue();
      } else
        throw new Error("Unsupported key format");
    } else
      throw new Error("Unsupported key format");
  let n = t.sign(d, e, {
    lowS: !0
  });
  const r = (BigInt(1) << BigInt(8) * BigInt(31)) - BigInt(1), a = t.CURVE.n / BigInt(2);
  let o = 0;
  for (; s && (n.r > a || n.r <= r || n.s <= r); )
    n = t.sign(d, e, {
      lowS: !0,
      extraEntropy: Kt(BigInt(o), 32)
    }), o += 1;
  return {
    r: n.r.toString(16),
    s: n.s.toString(16),
    v: n.recovery
  };
}
function lu(d, e, t) {
  const i = t.signModified(d, e);
  return ms.encode(i);
}
function pu(d, e, t) {
  let i;
  e.length === 32 ? i = e : typeof e == "string" && (i = new Uint8Array(Ys.unarmor(e).slice(16)));
  const s = t.sign(d, i);
  return pi.encode(s);
}
function Ln(d, e = !1) {
  const t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
  Ln.table === void 0 && (Ln.table = t.split(" ").map((n) => parseInt(n, 16)));
  let i = -1;
  for (let n = 0; n < d.length; n++)
    i = i >>> 8 ^ Ln.table[(i ^ d.charCodeAt(n)) & 255];
  const s = (i ^ -1) >>> 0;
  return e && s >= 2147483648 ? s - 4294967296 : s;
}
const Yt = Date.now, gu = () => Yt() * 1e3, eg = Yt, tg = () => Math.floor(Yt() / 1e3), ig = () => {
  const i = (gu() * 10 + 122192928e9).toString(16), s = i.slice(7, 15) + i.slice(3, 7) + "1" + i.slice(0, 3), n = "9696", r = "ff".repeat(6);
  return s + n + r;
}, sg = setTimeout, pr = (d, e, t = sg, i = Yt() + e) => {
  if (e >= 2147483647)
    throw new Error("setTimeout() function was called with unrealistic value of " + e.toString());
  let s = () => {
  }, n = !0;
  const r = t(() => {
    n = !0;
    const a = i - Yt();
    a > 0 ? s = pr(d, a, t, i) : d();
  }, e);
  return function() {
    n && (n = !1, clearTimeout(r)), s();
  };
};
class Zs extends Error {
  constructor() {
    const e = "timed out";
    super(e), this.constructor = Zs, this.__proto__ = Zs.prototype, this.message = e;
  }
}
const ng = (d) => {
  let e;
  if (typeof d == "number" ? e = Math.floor(d) : e = parseInt(d, 10), !(Number.isNaN(e) || e < 0))
    try {
      return new Date(e).toISOString();
    } catch {
      return;
    }
}, mu = (d) => {
  if (!(typeof d != "string" || !d) && !d.match(/^[0-9]+$/) && !(d.indexOf("-") < 0 || d.indexOf(":") < 0))
    try {
      const e = Date.parse(d.indexOf("+") >= 0 || d.slice(-1) === "Z" ? d : (d + "Z").replace(/\s(\d\d):/, "T$1:"));
      return Number.isNaN(e) ? void 0 : e;
    } catch {
      return;
    }
}, rg = (d) => {
  if (!(typeof d != "string" || !d)) {
    if (d.indexOf("GMT") >= 0)
      try {
        return Date.parse(d);
      } catch {
        return;
      }
    return mu(d);
  }
}, ag = (d = void 0) => new Date(d).toUTCString(), og = (d, e = "-") => {
  e = e || "";
  const t = new Date(d), i = t.getUTCFullYear().toString();
  let s = t.getUTCMonth() + 1, n = t.getUTCDate();
  return s = s < 10 ? "0" + s : s.toString(), n = n < 10 ? "0" + n : n.toString(), s + e + n + e + i;
}, po = (d, e, t = !0) => {
  e = e || "";
  const i = new Date(d), s = i.getUTCFullYear(), r = (t ? s : s - 2e3).toString();
  let a = i.getUTCMonth() + 1, o = i.getUTCDate();
  return a = a < 10 ? "0" + a : a.toString(), o = o < 10 ? "0" + o : o.toString(), r + e + a + e + o;
}, dg = (d, e = "") => po(d, e, !1), cg = (d, e = "-") => po(d, e, !0), ug = (d, e = " ") => {
  const t = new Date(d), i = t.getUTCFullYear();
  let s = t.getUTCMonth() + 1, n = t.getUTCDate(), r = t.getUTCHours(), a = t.getUTCMinutes(), o = t.getUTCSeconds();
  return s = s < 10 ? "0" + s : s, n = n < 10 ? "0" + n : n, r = r < 10 ? "0" + r : r, a = a < 10 ? "0" + a : a, o = o < 10 ? "0" + o : o, i + "-" + s + "-" + n + e + r + ":" + a + ":" + o;
}, yu = (d) => new Promise((e) => pr(e, d)), fg = async (d, e) => {
  let t = () => {
  };
  const i = new Promise((s) => t = pr(s, d));
  try {
    return await Promise.race([e, i.then(() => {
      throw new Zs();
    })]);
  } finally {
    t();
  }
};
var ce;
(function(d) {
  d[d.DEFAULT_ERROR = 1e4] = "DEFAULT_ERROR", d[d.INVALID_PARAMS = 10001] = "INVALID_PARAMS", d[d.INVALID_CACHE = 10002] = "INVALID_CACHE", d[d.INVALID_ADDRESS = 10003] = "INVALID_ADDRESS", d[d.FETCH_FROM_CACHE_ERROR = 10004] = "FETCH_FROM_CACHE_ERROR", d[d.INTERNAL_ERROR = 11e3] = "INTERNAL_ERROR", d[d.INVALID_EXCHANGE_ID = 11001] = "INVALID_EXCHANGE_ID", d[d.INVALID_EXCHANGE_INSTANCE_ID = 11002] = "INVALID_EXCHANGE_INSTANCE_ID", d[d.AUTHENTICATION_ERROR = 12e3] = "AUTHENTICATION_ERROR", d[d.INVALID_CREDENTIALS = 12001] = "INVALID_CREDENTIALS", d[d.AUTHENTICATION_FLOW_NOT_SUPPORTED = 12002] = "AUTHENTICATION_FLOW_NOT_SUPPORTED", d[d.OAUTH_ACCESS_REVOKED = 12003] = "OAUTH_ACCESS_REVOKED", d[d.WITHDRAWAL_ERROR = 13e3] = "WITHDRAWAL_ERROR", d[d.READONLY_EXCHANGE_NOT_PROVIDED_ERROR = 13001] = "READONLY_EXCHANGE_NOT_PROVIDED_ERROR", d[d.TOKEN_SYMBOL_NOT_FOUND = 13002] = "TOKEN_SYMBOL_NOT_FOUND", d[d.WITHDRAWAL_NOT_FOUND = 13003] = "WITHDRAWAL_NOT_FOUND", d[d.UNDER_WITHDRAW_MINIMUM = 13004] = "UNDER_WITHDRAW_MINIMUM", d[d.OVER_WITHDRAW_MAXIMUM = 13005] = "OVER_WITHDRAW_MAXIMUM", d[d.WHITELIST_CHECK_FAILED = 13006] = "WHITELIST_CHECK_FAILED", d[d.WITHDRAWAL_FORBIDDEN = 13007] = "WITHDRAWAL_FORBIDDEN", d[d.TRADE_ERROR = 14e3] = "TRADE_ERROR", d[d.MARKET_ERROR = 14001] = "MARKET_ERROR", d[d.MARKET_NOT_FOUND = 14002] = "MARKET_NOT_FOUND", d[d.ORDER_NOT_FOUND = 14003] = "ORDER_NOT_FOUND", d[d.MARKET_NOT_LOADED = 14004] = "MARKET_NOT_LOADED", d[d.MARKET_TYPE_NOT_SUPPORTED = 14005] = "MARKET_TYPE_NOT_SUPPORTED", d[d.INVALID_OHLCV_FORMAT = 14006] = "INVALID_OHLCV_FORMAT", d[d.CANNOT_PROVIDE_OHLCV = 14007] = "CANNOT_PROVIDE_OHLCV", d[d.PORTFOLIO_ERROR = 15e3] = "PORTFOLIO_ERROR", d[d.NOT_ENOUGH_BALANCE = 15001] = "NOT_ENOUGH_BALANCE", d[d.DEPOSIT_ERROR = 16e3] = "DEPOSIT_ERROR", d[d.GET_DEPOSIT_ADDRESS = 16001] = "GET_DEPOSIT_ADDRESS", d[d.CREATE_DEPOSIT_ADDRESS = 16002] = "CREATE_DEPOSIT_ADDRESS", d[d.DEPOSIT_NOT_FOUND = 16003] = "DEPOSIT_NOT_FOUND", d[d.NETWORK_ERROR = 17e3] = "NETWORK_ERROR", d[d.NETWORK_NOT_FOUND = 17001] = "NETWORK_NOT_FOUND", d[d.NETWORK_NOT_FOUND_FOR_TOKEN_SYMBOL = 17002] = "NETWORK_NOT_FOUND_FOR_TOKEN_SYMBOL", d[d.API_ERROR = 18e3] = "API_ERROR", d[d.INVALID_API_REQUEST = 18001] = "INVALID_API_REQUEST", d[d.INTERNAL_API_EXCEPTION = 18002] = "INTERNAL_API_EXCEPTION", d[d.EXCHANGE_ERROR = 19e3] = "EXCHANGE_ERROR", d[d.EXCHANGE_SERVER_DOWN = 19001] = "EXCHANGE_SERVER_DOWN", d[d.EXCHANGE_UNDER_MAINTENANCE = 19002] = "EXCHANGE_UNDER_MAINTENANCE", d[d.EXCHANGE_REQUEST_EXPIRED = 19003] = "EXCHANGE_REQUEST_EXPIRED", d[d.EXCHANGE_INVALID_PERMISSION = 19004] = "EXCHANGE_INVALID_PERMISSION", d[d.EXCHANGE_TRANSFER_NOT_ALLOWED = 19005] = "EXCHANGE_TRANSFER_NOT_ALLOWED", d[d.EXCHANGE_TRANSFER_ERROR = 19006] = "EXCHANGE_TRANSFER_ERROR", d[d.EXCHANGE_DDOS_PROTECTION = 19007] = "EXCHANGE_DDOS_PROTECTION", d[d.EXCHANGE_RATE_LIMIT_EXCEEDED = 19008] = "EXCHANGE_RATE_LIMIT_EXCEEDED", d[d.EXCHANGE_INTERNAL_ERROR = 19009] = "EXCHANGE_INTERNAL_ERROR", d[d.EXCHANGE_UNKNOWN_ASSET = 19010] = "EXCHANGE_UNKNOWN_ASSET", d[d.EXCHANGE_OPERATION_FAILED = 19011] = "EXCHANGE_OPERATION_FAILED", d[d.EXCHANGE_ACCOUNT_SUSPENDED = 19012] = "EXCHANGE_ACCOUNT_SUSPENDED", d[d.EXCHANGE_NOT_ALLOWED_METHOD = 19013] = "EXCHANGE_NOT_ALLOWED_METHOD", d[d.EXCHANGE_NOT_AVAILABLE = 19014] = "EXCHANGE_NOT_AVAILABLE", d[d.EXCHANGE_INVALID_NONCE = 19015] = "EXCHANGE_INVALID_NONCE", d[d.EXCHANGE_UNAVAILABLE_IN_COUNTRY = 19016] = "EXCHANGE_UNAVAILABLE_IN_COUNTRY", d[d.EXCHANGE_WALLET_TYPE_NOT_SUPPORTED = 19017] = "EXCHANGE_WALLET_TYPE_NOT_SUPPORTED", d[d.SUB_ACCOUNT_ERROR = 2e4] = "SUB_ACCOUNT_ERROR", d[d.SUB_ACCOUNT_NOT_FOUND_ERROR = 20001] = "SUB_ACCOUNT_NOT_FOUND_ERROR";
})(ce || (ce = {}));
const ye = {
  DEFAULT_ERROR: "Default error",
  INVALID_PARAMS: (d) => `Invalid params: ${d}`,
  INVALID_CACHE: (d) => `Invalid cache state for key: ${d}`,
  INVALID_ADDRESS: "Invalid address",
  FETCH_FROM_CACHE_ERROR: (d) => `An error occured while fetching from the cache: ${d}`,
  INTERNAL_ERROR: "Internal error",
  INVALID_EXCHANGE_INSTANCE_ID: (d) => `Invalid exchange instance id: ${d}`,
  INVALID_EXCHANGE_ID: (d) => `Invalid exchange id: ${d}`,
  AUTHENTICATION_ERROR: "Authentication error",
  INVALID_CREDENTIALS: "Invalid credentials provided",
  AUTHENTICATION_FLOW_NOT_SUPPORTED: "Authentication flow not supported",
  OAUTH_ACCESS_REVOKED: "OAuth access revoked",
  WITHDRAWAL_ERROR: "Withdrawal error",
  READONLY_EXCHANGE_NOT_PROVIDED_ERROR: "Readonly exchange account not provided",
  TOKEN_SYMBOL_NOT_FOUND: (d) => `Token symbol not found: ${d}`,
  WITHDRAWAL_NOT_FOUND: "Withdrawal not found",
  UNDER_WITHDRAW_MINIMUM: "Under withdrawal minimum",
  OVER_WITHDRAW_MAXIMUM: "Over withdrawal maximum",
  WHITELIST_CHECK_FAILED: "The receipt address has not been whitelisted",
  WITHDRAWAL_FORBIDDEN: "Withdrawal forbidden",
  TRADE_ERROR: "Trade error",
  MARKET_ERROR: "Market error",
  MARKET_NOT_FOUND: (d) => `Market not found: ${d}`,
  ORDER_NOT_FOUND: "Order not found",
  MARKET_NOT_LOADED: "Market not loaded",
  MARKET_TYPE_NOT_SUPPORTED: (d) => `Market type not supported: ${d}`,
  ORDER_UNDER_MINIMUM: "Order quantity below minimum limit. Please use getMinAmounts() to get the minimum quantity for the order.",
  INVALID_OHLCV_FORMAT: (d) => `Invalid OHLCV format: ${d}`,
  CANNOT_PROVIDE_OHLCV: "Cannot provide OHLCV data",
  PORTFOLIO_ERROR: "Portfolio error",
  NOT_ENOUGH_BALANCE: "Not enough balance",
  DEPOSIT_ERROR: "Deposit error",
  DEPOSIT_NOT_FOUND: "Deposit not found",
  GET_DEPOSIT_ADDRESS: (d, e) => `An error occured while fetching the deposit address for token symbol ${d}${e ? " on network " + e : ""}`,
  CREATE_DEPOSIT_ADDRESS: (d, e) => `An error occured while creating the deposit address for token symbol ${d}${e ? " on network " + e : ""}`,
  NETWORK_ERROR: "Network error",
  NETWORK_NOT_FOUND: (d) => `Network not found: ${d}`,
  NETWORK_NOT_FOUND_FOR_TOKEN_SYMBOL: (d) => `Network not found for token symbol: ${d}`,
  API_ERROR: "API error",
  INVALID_API_REQUEST: (d) => `Invalid request: ${d}`,
  EXCHANGE_ERROR: "Exchange error",
  EXCHANGE_SERVER_DOWN: "Exchange server down",
  EXCHANGE_UNDER_MAINTENANCE: "Exchange under maintenance",
  EXCHANGE_REQUEST_EXPIRED: "Exchange request expired",
  EXCHANGE_INVALID_PERMISSION: "Missing API permissions, please reimport your API key with the valid permissions",
  EXCHANGE_TRANSFER_NOT_ALLOWED: "Transfer not allowed",
  EXCHANGE_TRANSFER_ERROR: "Transfer error",
  EXCHANGE_DDOS_PROTECTION: "DDoS protection error",
  EXCHANGE_RATE_LIMIT_EXCEEDED: "Rate limit exceeded",
  EXCHANGE_INTERNAL_ERROR: "Internal exchange error",
  EXCHANGE_UNKNOWN_ASSET: (d) => `Unknown asset ${d}`,
  EXCHANGE_OPERATION_FAILED: "Operation failed",
  EXCHANGE_ACCOUNT_SUSPENDED: "Account suspended",
  EXCHANGE_NOT_ALLOWED_METHOD: (d) => `Method not allowed: ${d}`,
  EXCHANGE_NOT_AVAILABLE: "Exchange not available",
  EXCHANGE_INVALID_NONCE: "Invalid nonce",
  EXCHANGE_UNAVAILABLE_IN_COUNTRY: "Exchange unavailable in the country",
  EXCHANGE_WALLET_TYPE_NOT_SUPPORTED: (d) => `Wallet type ${d} not supported or not available for transfers`,
  SUB_ACCOUNT_ERROR: "Sub account error",
  SUB_ACCOUNT_NOT_FOUND_ERROR: (d) => `Sub account not found for uid: ${d}`
};
ce.DEFAULT_ERROR + "", ce.INVALID_PARAMS + "", ce.INVALID_CACHE + "", ce.INVALID_ADDRESS + "", ce.FETCH_FROM_CACHE_ERROR + "", ce.INTERNAL_ERROR + "", ce.INVALID_EXCHANGE_INSTANCE_ID + "", ce.INVALID_EXCHANGE_ID + "", ce.AUTHENTICATION_ERROR + "", ce.INVALID_CREDENTIALS + "", ce.AUTHENTICATION_FLOW_NOT_SUPPORTED + "", ce.OAUTH_ACCESS_REVOKED + "", ce.WITHDRAWAL_ERROR + "", ce.READONLY_EXCHANGE_NOT_PROVIDED_ERROR + "", ce.TOKEN_SYMBOL_NOT_FOUND + "", ce.WITHDRAWAL_NOT_FOUND + "", ce.UNDER_WITHDRAW_MINIMUM + "", ce.OVER_WITHDRAW_MAXIMUM + "", ce.WHITELIST_CHECK_FAILED + "", ce.TRADE_ERROR + "", ce.MARKET_NOT_FOUND + "", ce.ORDER_NOT_FOUND + "", ce.CANNOT_PROVIDE_OHLCV + "", ce.INVALID_OHLCV_FORMAT + "", ce.MARKET_ERROR + "", ce.MARKET_TYPE_NOT_SUPPORTED + "", ce.MARKET_NOT_LOADED + "", ce.PORTFOLIO_ERROR + "", ce.NOT_ENOUGH_BALANCE + "", ce.DEPOSIT_ERROR + "", ce.GET_DEPOSIT_ADDRESS + "", ce.CREATE_DEPOSIT_ADDRESS + "", ce.NETWORK_ERROR + "", ce.NETWORK_NOT_FOUND + "", ce.API_ERROR + "", ce.INVALID_API_REQUEST + "", ce.EXCHANGE_ERROR + "", ce.EXCHANGE_SERVER_DOWN + "", ce.EXCHANGE_UNDER_MAINTENANCE + "", ce.EXCHANGE_REQUEST_EXPIRED + "", ce.EXCHANGE_INVALID_PERMISSION + "", ce.EXCHANGE_TRANSFER_NOT_ALLOWED + "", ce.EXCHANGE_TRANSFER_ERROR + "", ce.EXCHANGE_DDOS_PROTECTION + "", ce.EXCHANGE_RATE_LIMIT_EXCEEDED + "", ce.EXCHANGE_OPERATION_FAILED + "", ce.EXCHANGE_UNKNOWN_ASSET + "", ce.EXCHANGE_ACCOUNT_SUSPENDED + "", ce.EXCHANGE_NOT_ALLOWED_METHOD + "", ce.EXCHANGE_NOT_AVAILABLE + "", ce.EXCHANGE_INVALID_NONCE + "", ce.EXCHANGE_UNAVAILABLE_IN_COUNTRY + "", ce.EXCHANGE_WALLET_TYPE_NOT_SUPPORTED + "";
class _t extends Error {
  constructor(e, t) {
    super(t), this.code = e, this.message = t, this.isBaseError = !0, this.metadata = {}, this.notReportable = !1, this.sentryName = void 0, this.name = "CedeSDKError";
  }
  addOriginalError(e) {
    return this.originalErrorMessage = e, this;
  }
  reportSentry() {
    const e = this.metadata, t = this.sentry;
    if (this.metadata = {}, delete this.sentry, this.notReportable || !t)
      return;
    const i = structuredClone(this);
    i.name = this.sentryName || this.name, t.captureException(i, {
      captureContext: {
        extra: {
          ...e,
          code: this.code,
          exchangeId: this.exchangeId
        }
      }
    });
  }
  setSentryName(e) {
    this.sentryName = e;
  }
  setMetadata(e) {
    this.metadata = e;
  }
  addMetadata(e, t) {
    return this.metadata[e] = t, this;
  }
  overwriteMessage(e) {
    return this.message = e, this;
  }
  addMessage(e) {
    return this.message = `${this.message}. ${e}`, this;
  }
  exchange(e) {
    return this.exchangeId = e, this;
  }
  apply({ shouldPrependExchangeId: e = !1 } = {}) {
    return e && this.exchangeId && (this.message = `${this.exchangeId}: ${this.message}`), this.reportSentry(), this;
  }
}
class on extends _t {
  constructor(e = ce.DEFAULT_ERROR, t = ye.DEFAULT_ERROR) {
    super(e, t), this.name = "DefaultError";
  }
}
class g extends on {
  constructor(e) {
    super(ce.INVALID_PARAMS, ye.INVALID_PARAMS(e)), this.name = "InvalidParamsError";
  }
}
class hg extends on {
  constructor(e) {
    super(ce.INVALID_CACHE, ye.INVALID_CACHE(e)), this.name = "InvalidCacheError";
  }
}
class wu extends on {
  constructor(e) {
    super(ce.FETCH_FROM_CACHE_ERROR, ye.FETCH_FROM_CACHE_ERROR(e)), this.name = "FetchFromCacheError";
  }
}
class et extends on {
  constructor() {
    super(ce.INVALID_ADDRESS, ye.INVALID_ADDRESS), this.name = "InvalidAddressError";
  }
}
class O extends _t {
  constructor(e = ce.EXCHANGE_ERROR, t = ye.EXCHANGE_ERROR) {
    super(e, t), this.name = "ExchangeError";
  }
}
class lg extends O {
  constructor() {
    super(ce.EXCHANGE_SERVER_DOWN, ye.EXCHANGE_SERVER_DOWN), this.name = "ExchangeServerDownError";
  }
}
class dt extends O {
  constructor() {
    super(ce.EXCHANGE_UNDER_MAINTENANCE, ye.EXCHANGE_UNDER_MAINTENANCE), this.name = "ExchangeUnderMaintenanceError";
  }
}
class Nt extends O {
  constructor() {
    super(ce.EXCHANGE_REQUEST_EXPIRED, ye.EXCHANGE_REQUEST_EXPIRED), this.name = "ExchangeRequestExpiredError";
  }
}
class ee extends O {
  constructor() {
    super(ce.EXCHANGE_INVALID_PERMISSION, ye.EXCHANGE_INVALID_PERMISSION), this.name = "ExchangeInvalidPermissionsError";
  }
}
class Vt extends O {
  constructor() {
    super(ce.EXCHANGE_TRANSFER_NOT_ALLOWED, ye.EXCHANGE_TRANSFER_NOT_ALLOWED), this.name = "ExchangeTransferNotAllowedError";
  }
}
class je extends O {
  constructor() {
    super(ce.EXCHANGE_TRANSFER_ERROR, ye.EXCHANGE_TRANSFER_ERROR), this.name = "ExchangeTransferError";
  }
}
class Rt extends O {
  constructor() {
    super(ce.EXCHANGE_DDOS_PROTECTION, ye.EXCHANGE_DDOS_PROTECTION), this.name = "ExchangeDDosProtectionError";
  }
}
class Ae extends O {
  constructor() {
    super(ce.EXCHANGE_RATE_LIMIT_EXCEEDED, ye.EXCHANGE_RATE_LIMIT_EXCEEDED), this.name = "ExchangeRateLimitExceededError";
  }
}
class ie extends O {
  constructor() {
    super(ce.EXCHANGE_OPERATION_FAILED, ye.EXCHANGE_OPERATION_FAILED), this.name = "ExchangeOperationFailedError";
  }
}
class $e extends O {
  constructor(e) {
    super(ce.EXCHANGE_UNKNOWN_ASSET, ye.EXCHANGE_UNKNOWN_ASSET(e)), this.name = "ExchangeUnknownAssetError";
  }
}
class Ee extends O {
  constructor() {
    super(ce.EXCHANGE_ACCOUNT_SUSPENDED, ye.EXCHANGE_ACCOUNT_SUSPENDED), this.name = "ExchangeAccountSuspendedError";
  }
}
class pe extends O {
  constructor(e) {
    super(ce.EXCHANGE_NOT_ALLOWED_METHOD, ye.EXCHANGE_NOT_ALLOWED_METHOD(e)), this.name = "ExchangeNotAllowedMethodError";
  }
}
class Te extends O {
  constructor() {
    super(ce.EXCHANGE_NOT_AVAILABLE, ye.EXCHANGE_NOT_AVAILABLE), this.name = "ExchangeNotAvailableError";
  }
}
class ze extends O {
  constructor() {
    super(ce.EXCHANGE_INVALID_NONCE, ye.EXCHANGE_INVALID_NONCE), this.name = "ExchangeInvalidNonceError";
  }
}
class go extends O {
  constructor() {
    super(ce.EXCHANGE_UNAVAILABLE_IN_COUNTRY, ye.EXCHANGE_UNAVAILABLE_IN_COUNTRY), this.name = "ExchangeUnavailableInCountry";
  }
}
class pg extends O {
  constructor(e) {
    super(ce.EXCHANGE_WALLET_TYPE_NOT_SUPPORTED, ye.EXCHANGE_WALLET_TYPE_NOT_SUPPORTED(e)), this.name = "ExchangeWalletTypeNotSupportedError";
  }
}
var Wn;
(function(d) {
  d[d.HIGH = 1] = "HIGH", d[d.MEDIUM = 2] = "MEDIUM", d[d.LOW = 3] = "LOW";
})(Wn || (Wn = {}));
let gg = class {
  constructor(e) {
    this.config = {
      refillRate: 1,
      delay: 1e-3,
      capacity: 1,
      maxCapacity: 1e5,
      tokens: 0,
      cost: 1,
      priorities: {},
      expireIntervals: {
        myTrades: 1e3 * 50
        // 50 seconds
      }
    }, Object.assign(this.config, e), this.priorityQueue = {}, this.running = !1, this.isActive = !0;
  }
  /**
   * Returns the most important queue (lower number => hight priority), if there are no priorities, returns the normal queue
   */
  getMostImportantQueue() {
    const e = Object.keys(this.priorityQueue), t = Math.min(...e);
    return {
      highestPriorityQueue: this.priorityQueue[t],
      highestPriorityIndex: t
    };
  }
  stop() {
    this.isActive = !1;
  }
  async loop() {
    let e = Yt();
    for (; this.running; ) {
      const { highestPriorityQueue: t, highestPriorityIndex: i } = this.getMostImportantQueue();
      if (t === void 0) {
        this.running = !1;
        continue;
      }
      const { resolver: s, cost: n, rejecter: r, timestamp: a, expireInterval: o } = t[0];
      if (this.config.tokens >= 0 || !this.isActive)
        o !== void 0 && a + o < Yt() || !this.isActive ? r(new Nt()) : (this.config.tokens -= n, s()), t.shift(), await Promise.resolve(), t.length === 0 && delete this.priorityQueue[i], Object.keys(this.priorityQueue).length === 0 && (this.running = !1);
      else {
        await yu(this.config.delay * 1e3);
        const c = Yt(), u = c - e;
        e = c;
        const f = this.config.tokens + this.config.refillRate * u;
        this.config.tokens = Math.min(f, this.config.capacity);
      }
    }
  }
  customThrottle(e = void 0, t = void 0, i = void 0, s = void 0) {
    let n, r;
    const a = new Promise((f, h) => {
      n = f, r = h;
    });
    if (Object.keys(this.priorityQueue).reduce((f, h) => f + this.priorityQueue[h].length, 0) > this.config.maxCapacity)
      throw new Error("throttle queue is over maxCapacity (" + this.config.maxCapacity.toString() + ")");
    e = e === void 0 ? this.config.cost : e;
    let c;
    s !== void 0 && s in Wn ? c = s : t !== void 0 && this.config.priorities[t] !== void 0 ? c = this.config.priorities[t] : c = Wn.MEDIUM;
    let u;
    i !== void 0 ? u = i : t !== void 0 && (u = this.config.expireIntervals[t]), this.priorityQueue[c] === void 0 && (this.priorityQueue[c] = []), this.priorityQueue[c].push({
      resolver: n,
      cost: e,
      rejecter: r,
      timestamp: Yt(),
      expireInterval: u
    });
    for (let f = 0; f < this.priorityQueue.length; f++)
      this.priorityQueue[f];
    return this.running || (this.running = !0, this.loop()), a;
  }
};
const bu = (d) => {
  const e = ui(d.slice(0, -1)), t = d.slice(-1);
  let i;
  if (t === "y")
    i = 60 * 60 * 24 * 365;
  else if (t === "M")
    i = 60 * 60 * 24 * 30;
  else if (t === "w")
    i = 60 * 60 * 24 * 7;
  else if (t === "d")
    i = 60 * 60 * 24;
  else if (t === "h")
    i = 60 * 60;
  else if (t === "m")
    i = 60;
  else if (t === "s")
    i = 1;
  else
    throw new g("timeframe unit " + t + " is not supported");
  return e * i;
}, mg = (d, e, t = Ka) => {
  const i = bu(d) * 1e3, s = e % i;
  return e - s + (t === ar ? i : 0);
}, yg = (d) => {
  const e = /{([\w-]+)}/g, t = [];
  let i = e.exec(d);
  for (; i; )
    t.push(i[1]), i = e.exec(d);
  return t;
}, wg = (d, e) => {
  if (!Array.isArray(e)) {
    const t = Object.keys(e);
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      Array.isArray(e[s]) || (d = d.replace("{" + s + "}", e[s]));
    }
  }
  return d;
};
function Su(d, e) {
  return d !== void 0 && e !== void 0 && d > 0 ? e / d : void 0;
}
function bg(d) {
  const e = {};
  for (let t = 0; t < d.length; t++) {
    const [i, s] = d[t];
    s > 0 && (e[i] = (e[i] || 0) + s);
  }
  return Object.keys(e).map((t) => [parseFloat(t), parseFloat(e[t])]);
}
const mo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DECIMAL_PLACES: St,
  NO_PADDING: Ht,
  PAD_WITH_ZERO: Cc,
  ROUND: Dt,
  ROUND_DOWN: Ka,
  ROUND_UP: ar,
  SIGNIFICANT_DIGITS: or,
  TICK_SIZE: ct,
  TRUNCATE: Et,
  Throttler: gg,
  TimedOut: Zs,
  aggregate: bg,
  arrayConcat: Ph,
  asFloat: ui,
  asInteger: Ms,
  axolotl: lu,
  base16ToBinary: Gc,
  base58ToBinary: Ql,
  base64ToBinary: Uc,
  base64ToString: $l,
  binaryConcat: ep,
  binaryConcatArray: tp,
  binaryToBase16: Zl,
  binaryToBase58: Jl,
  binaryToBase64: qc,
  binaryToString: Kl,
  capitalize: Xh,
  clone: Ac,
  crc32: Ln,
  decimalToPrecision: el,
  decode: op,
  deepExtend: Wh,
  ecdsa: hu,
  eddsa: pu,
  encode: ap,
  extend: Tc,
  extractParams: yg,
  filterBy: jh,
  flatten: qh,
  groupBy: Bh,
  hasProps: rn,
  hash: fu,
  hmac: lo,
  implodeParams: wg,
  inArray: _h,
  index: Sc,
  indexBy: Vh,
  isArray: Os,
  isBrowser: wc,
  isDictionary: wa,
  isElectron: th,
  isEmpty: Dh,
  isInteger: nh,
  isJsonEncodedObject: Yl,
  isNode: sh,
  isNumber: ut,
  isObject: rr,
  isString: Wa,
  isStringCoercible: $t,
  isWebWorker: bc,
  isWindows: ih,
  iso8601: ng,
  json: Wl,
  keys: Ya,
  keysort: Rh,
  mdy: og,
  merge: Yh,
  microseconds: gu,
  milliseconds: eg,
  now: Yt,
  numberToBE: cp,
  numberToLE: dp,
  numberToString: Xa,
  omit: zh,
  omitZero: tl,
  ordered: Eh,
  packb: up,
  parse8601: mu,
  parseDate: rg,
  parseTimeframe: bu,
  pluck: Gh,
  precisionConstants: Zh,
  precisionFromString: qn,
  prop: Zt,
  rawencode: rp,
  rfc2616: ag,
  roundTimeframe: mg,
  safeFloat: ah,
  safeFloat2: ph,
  safeFloatN: Ah,
  safeInteger: oh,
  safeInteger2: gh,
  safeIntegerN: Ih,
  safeIntegerProduct: dh,
  safeIntegerProduct2: mh,
  safeIntegerProductN: Oh,
  safeString: fh,
  safeString2: bh,
  safeStringLower: hh,
  safeStringLower2: Sh,
  safeStringLowerN: vh,
  safeStringN: xh,
  safeStringUpper: lh,
  safeStringUpper2: Th,
  safeStringUpperN: kh,
  safeTimestamp: ch,
  safeTimestamp2: yh,
  safeTimestampN: Mh,
  safeValue: uh,
  safeValue2: wh,
  safeValueN: Ch,
  seconds: tg,
  setTimeout_safe: pr,
  sha256: Re,
  sleep: yu,
  sortBy: Fh,
  sortBy2: Uh,
  stringToBase64: Fc,
  stringToBinary: Xl,
  strip: $h,
  sum: Hh,
  timeout: fg,
  toArray: Lh,
  truncate: Jh,
  truncate_to_string: vc,
  unCamelCase: Kh,
  unique: Nh,
  urlencode: ip,
  urlencodeBase64: os,
  urlencodeNested: sp,
  urlencodeWithArrayRepeat: np,
  uuid: Ic,
  uuid16: Oc,
  uuid22: Mc,
  uuidv1: ig,
  values: $i,
  vwap: Su,
  ymd: po,
  ymdhms: ug,
  yymmdd: dg,
  yyyymmdd: cg
}, Symbol.toStringTag, { value: "Module" })), Sg = BigInt(0), Tg = BigInt(-1), es = BigInt(10);
class P {
  constructor(e, t = void 0) {
    if (this.base = void 0, t === void 0) {
      let i = 0;
      e = e.toLowerCase(), e.indexOf("e") > -1 && ([e, i] = e.split("e"), i = parseInt(i.toString()));
      const s = e.indexOf(".");
      this.decimals = s > -1 ? e.length - s - 1 : 0;
      const n = e.replace(".", "");
      this.integer = BigInt(n), this.decimals = this.decimals - i;
    } else
      this.integer = e, this.decimals = t;
  }
  mul(e) {
    const t = this.integer * e.integer;
    return new P(t, this.decimals + e.decimals);
  }
  div(e, t = 18) {
    const i = t - this.decimals + e.decimals;
    let s;
    if (i === 0)
      s = this.integer;
    else if (i < 0) {
      const r = es ** BigInt(-i);
      s = this.integer / r;
    } else {
      const r = es ** BigInt(i);
      s = this.integer * r;
    }
    const n = s / e.integer;
    return new P(n, t);
  }
  add(e) {
    if (this.decimals === e.decimals) {
      const t = this.integer + e.integer;
      return new P(t, this.decimals);
    } else {
      const [t, i] = this.decimals > e.decimals ? [e, this] : [this, e], s = i.decimals - t.decimals, r = t.integer * es ** BigInt(s) + i.integer;
      return new P(r, i.decimals);
    }
  }
  mod(e) {
    const t = Math.max(-this.decimals + e.decimals, 0), i = this.integer * es ** BigInt(t), s = Math.max(-e.decimals + this.decimals, 0), n = e.integer * es ** BigInt(s), r = i % n;
    return new P(r, s + e.decimals);
  }
  sub(e) {
    const t = new P(-e.integer, e.decimals);
    return this.add(t);
  }
  abs() {
    return new P(this.integer < 0 ? this.integer * Tg : this.integer, this.decimals);
  }
  neg() {
    return new P(-this.integer, this.decimals);
  }
  min(e) {
    return this.lt(e) ? this : e;
  }
  max(e) {
    return this.gt(e) ? this : e;
  }
  gt(e) {
    return this.sub(e).integer > 0;
  }
  ge(e) {
    return this.sub(e).integer >= 0;
  }
  lt(e) {
    return e.gt(this);
  }
  le(e) {
    return e.ge(this);
  }
  reduce() {
    const e = this.integer.toString(), t = e.length - 1;
    if (t === 0)
      return e === "0" && (this.decimals = 0), this;
    let i;
    for (i = t; i >= 0 && e.charAt(i) === "0"; i--)
      ;
    const s = t - i;
    if (s === 0)
      return this;
    this.decimals -= s, this.integer = BigInt(e.slice(0, i + 1));
  }
  equals(e) {
    return this.reduce(), e.reduce(), this.decimals === e.decimals && this.integer === e.integer;
  }
  toString() {
    this.reduce();
    let e, t;
    this.integer < 0 ? (e = "-", t = -this.integer) : (e = "", t = this.integer);
    const i = Array.from(t.toString(Number(es)).padStart(this.decimals, "0")), s = i.length - this.decimals;
    let n;
    return s === 0 ? n = "0." : this.decimals < 0 ? n = "0".repeat(-this.decimals) : this.decimals === 0 ? n = "" : n = ".", i.splice(s, 0, n), e + i.join("");
  }
  static stringMul(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).mul(new P(t)).toString();
  }
  static stringDiv(e, t, i = 18) {
    if (e === void 0 || t === void 0)
      return;
    const s = new P(t);
    if (s.integer !== Sg)
      return new P(e).div(s, i).toString();
  }
  static stringAdd(e, t) {
    if (!(e === void 0 && t === void 0))
      return e === void 0 ? t : t === void 0 ? e : new P(e).add(new P(t)).toString();
  }
  static stringSub(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).sub(new P(t)).toString();
  }
  static stringAbs(e) {
    if (e !== void 0)
      return new P(e).abs().toString();
  }
  static stringNeg(e) {
    if (e !== void 0)
      return new P(e).neg().toString();
  }
  static stringMod(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).mod(new P(t)).toString();
  }
  static stringEquals(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).equals(new P(t));
  }
  static stringEq(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).equals(new P(t));
  }
  static stringMin(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).min(new P(t)).toString();
  }
  static stringMax(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).max(new P(t)).toString();
  }
  static stringGt(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).gt(new P(t));
  }
  static stringGe(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).ge(new P(t));
  }
  static stringLt(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).lt(new P(t));
  }
  static stringLe(e, t) {
    if (!(e === void 0 || t === void 0))
      return new P(e).le(new P(t));
  }
}
function yo() {
  let d, e;
  const t = new Promise((i, s) => {
    d = i, e = s;
  });
  return t.resolve = function() {
    setTimeout(() => {
      d.apply(this, arguments);
    });
  }, t.reject = function() {
    setTimeout(() => {
      e.apply(this, arguments);
    });
  }, t;
}
function Ag(d) {
  const e = yo();
  return d.then(e.resolve, e.reject), e;
}
yo.race = (d) => Ag(Promise.race(d));
class be extends _t {
  constructor(e = ce.INTERNAL_ERROR, t = ye.INTERNAL_ERROR) {
    super(e, t), this.name = "InternalError";
  }
}
class Ig extends be {
  constructor(e) {
    super(ce.INVALID_EXCHANGE_INSTANCE_ID, ye.INVALID_EXCHANGE_INSTANCE_ID(e)), this.name = "InvalidExchangeInstanceIdError", this.notReportable = !0;
  }
}
class Og extends be {
  constructor(e) {
    super(ce.INVALID_EXCHANGE_ID, ye.INVALID_EXCHANGE_ID(e)), this.name = "InvalidExchangeIdError";
  }
}
class Z extends _t {
  constructor(e = ce.AUTHENTICATION_ERROR, t = ye.AUTHENTICATION_ERROR) {
    super(e, t), this.name = "AuthenticationError";
  }
}
class Pt extends Z {
  constructor() {
    super(ce.INVALID_CREDENTIALS, ye.INVALID_CREDENTIALS), this.name = "InvalidCredentialsError", this.notReportable = !0;
  }
}
class Mg extends Z {
  constructor() {
    super(ce.AUTHENTICATION_FLOW_NOT_SUPPORTED, ye.AUTHENTICATION_FLOW_NOT_SUPPORTED), this.name = "AuthenticationFlowNotSupportedError";
  }
}
class Cg extends Z {
  constructor() {
    super(ce.OAUTH_ACCESS_REVOKED, ye.OAUTH_ACCESS_REVOKED), this.name = "OAuthAccessRevokedError", this.notReportable = !0;
  }
}
class ke extends _t {
  constructor(e = ce.WITHDRAWAL_ERROR, t = ye.WITHDRAWAL_ERROR) {
    super(e, t), this.name = "WithdrawalError";
  }
}
class xg extends ke {
  constructor() {
    super(ce.READONLY_EXCHANGE_NOT_PROVIDED_ERROR, ye.READONLY_EXCHANGE_NOT_PROVIDED_ERROR), this.name = "ReadonlyExchangeNotProvidedError", this.notReportable = !0;
  }
}
class wo extends ke {
  constructor(e) {
    super(ce.TOKEN_SYMBOL_NOT_FOUND, ye.TOKEN_SYMBOL_NOT_FOUND(e)), this.name = "TokenSymbolNotFoundError";
  }
}
class Tu extends ke {
  constructor() {
    super(ce.WITHDRAWAL_NOT_FOUND, ye.WITHDRAWAL_NOT_FOUND), this.name = "WithdrawalNotFoundError";
  }
}
class Xt extends ke {
  constructor() {
    super(ce.UNDER_WITHDRAW_MINIMUM, ye.UNDER_WITHDRAW_MINIMUM), this.name = "UnderWithdrawMinimumError";
  }
}
class ws extends ke {
  constructor() {
    super(ce.OVER_WITHDRAW_MAXIMUM, ye.OVER_WITHDRAW_MAXIMUM), this.name = "OverWithdrawMaximumError";
  }
}
class gi extends ke {
  constructor() {
    super(ce.WHITELIST_CHECK_FAILED, ye.WHITELIST_CHECK_FAILED), this.name = "WhitelistCheckFailedError", this.notReportable = !0;
  }
}
class Yn extends ke {
  constructor() {
    super(ce.WITHDRAWAL_FORBIDDEN, ye.WITHDRAWAL_FORBIDDEN), this.name = "WithdrawalForbiddenError";
  }
}
class bo extends _t {
  constructor(e = ce.NETWORK_ERROR, t = ye.NETWORK_ERROR) {
    super(e, t), this.name = "NetworkError";
  }
}
class ka extends bo {
  constructor(e) {
    super(ce.NETWORK_NOT_FOUND, ye.NETWORK_NOT_FOUND(e)), this.name = "NetworkNotFoundError";
  }
}
class Kn extends bo {
  constructor(e) {
    super(ce.NETWORK_NOT_FOUND_FOR_TOKEN_SYMBOL, ye.NETWORK_NOT_FOUND_FOR_TOKEN_SYMBOL(e)), this.name = "NetworkNotFoundForTokenSymbol";
  }
}
class gr extends _t {
  constructor(e = ce.DEPOSIT_ERROR, t = ye.DEPOSIT_ERROR) {
    super(e, t), this.name = "DepositError";
  }
}
class It extends gr {
  constructor(e, t) {
    super(ce.GET_DEPOSIT_ADDRESS, ye.GET_DEPOSIT_ADDRESS(e, t)), this.name = "GetDepositAddressError";
  }
}
class mr extends gr {
  constructor(e, t) {
    super(ce.CREATE_DEPOSIT_ADDRESS, ye.CREATE_DEPOSIT_ADDRESS(e, t)), this.name = "CreateDepositAddressError";
  }
}
class vg extends gr {
  constructor() {
    super(ce.DEPOSIT_NOT_FOUND, ye.DEPOSIT_NOT_FOUND), this.name = "DepositNotFoundError";
  }
}
class So extends _t {
  constructor(e = ce.API_ERROR, t = ye.API_ERROR) {
    super(e, t), this.name = "ApiError";
  }
}
class kg extends So {
  constructor(e) {
    super(ce.INVALID_API_REQUEST, ye.INVALID_API_REQUEST(e)), this.name = "InvalidApiRequestError";
  }
}
class Eg extends So {
  constructor(e) {
    super(ce.INTERNAL_API_EXCEPTION, e), this.name = "InternalApiExceptionError";
  }
}
class To extends _t {
  constructor(e = ce.PORTFOLIO_ERROR, t = ye.PORTFOLIO_ERROR) {
    super(e, t), this.name = "PortfolioError";
  }
}
class re extends To {
  constructor() {
    super(ce.NOT_ENOUGH_BALANCE, ye.NOT_ENOUGH_BALANCE), this.name = "InsufficientBalanceError";
  }
}
class k extends _t {
  constructor(e = ce.TRADE_ERROR, t = ye.TRADE_ERROR) {
    super(e, t);
  }
}
class Se extends k {
  constructor() {
    super(ce.ORDER_NOT_FOUND, ye.ORDER_NOT_FOUND);
  }
}
class it extends k {
  constructor(e) {
    super(ce.MARKET_NOT_FOUND, ye.MARKET_NOT_FOUND(e)), this.name = "MarketNotFoundError";
  }
}
class Ng extends k {
  constructor(e) {
    super(ce.INVALID_OHLCV_FORMAT, ye.INVALID_OHLCV_FORMAT(e)), this.name = "InvalidOHLCVFormatError";
  }
}
class Au extends k {
  constructor() {
    super(ce.CANNOT_PROVIDE_OHLCV, ye.CANNOT_PROVIDE_OHLCV), this.name = "CannotProvideOHLCVError";
  }
}
class pt extends k {
  constructor(e = ce.MARKET_ERROR, t = ye.MARKET_ERROR) {
    super(e, t), this.name = "MarketError";
  }
}
class bs extends pt {
  constructor() {
    super(ce.MARKET_NOT_LOADED, ye.MARKET_NOT_LOADED), this.name = "MarketNotLoadedError";
  }
}
class ge extends pt {
  constructor(e) {
    super(ce.MARKET_TYPE_NOT_SUPPORTED, ye.MARKET_TYPE_NOT_SUPPORTED(e)), this.name = "MarketTypeNotSupportedError";
  }
}
const od = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApiError: So,
  AuthenticationError: Z,
  AuthenticationFlowNotSupportedError: Mg,
  CannotProvideOHLCVError: Au,
  CedeSDKError: _t,
  CreateDepositAddressError: mr,
  DefaultError: on,
  DepositError: gr,
  DepositNotFoundError: vg,
  ExchangeAccountSuspendedError: Ee,
  ExchangeDDosProtectionError: Rt,
  ExchangeError: O,
  ExchangeInvalidNonceError: ze,
  ExchangeInvalidPermissionsError: ee,
  ExchangeNotAllowedMethodError: pe,
  ExchangeNotAvailableError: Te,
  ExchangeOperationFailedError: ie,
  ExchangeRateLimitExceededError: Ae,
  ExchangeRequestExpiredError: Nt,
  ExchangeServerDownError: lg,
  ExchangeTransferError: je,
  ExchangeTransferNotAllowedError: Vt,
  ExchangeUnavailableInCountry: go,
  ExchangeUnderMaintenanceError: dt,
  ExchangeUnknownAssetError: $e,
  ExchangeWalletTypeNotSupportedError: pg,
  FetchFromCacheError: wu,
  GetDepositAddressError: It,
  InsufficientBalanceError: re,
  InternalApiExceptionError: Eg,
  InternalError: be,
  InvalidAddressError: et,
  InvalidApiRequestError: kg,
  InvalidCacheError: hg,
  InvalidCredentialsError: Pt,
  InvalidExchangeIdError: Og,
  InvalidExchangeInstanceIdError: Ig,
  InvalidOHLCVFormatError: Ng,
  InvalidParamsError: g,
  MarketError: pt,
  MarketNotFoundError: it,
  MarketNotLoadedError: bs,
  MarketTypeNotSupportedError: ge,
  NetworkError: bo,
  NetworkNotFoundError: ka,
  NetworkNotFoundForTokenSymbol: Kn,
  OAuthAccessRevokedError: Cg,
  OrderNotFoundError: Se,
  OverWithdrawMaximumError: ws,
  PortfolioError: To,
  ReadonlyExchangeNotProvidedError: xg,
  TokenSymbolNotFoundError: wo,
  TradeError: k,
  UnderWithdrawMinimumError: Xt,
  WhitelistCheckFailedError: gi,
  WithdrawalError: ke,
  WithdrawalForbiddenError: Yn,
  WithdrawalNotFoundError: Tu
}, Symbol.toStringTag, { value: "Module" }));
class Pg {
  constructor() {
    this.i = 0, this.j = 0, this.S = [];
  }
  // Arcfour.prototype.init = ARC4init;
  // Initialize arcfour context from key, an array of ints, each from [0..255]
  init(e) {
    let t, i, s;
    for (t = 0; t < 256; ++t)
      this.S[t] = t;
    for (i = 0, t = 0; t < 256; ++t)
      i = i + this.S[t] + e[t % e.length] & 255, s = this.S[t], this.S[t] = this.S[i], this.S[i] = s;
    this.i = 0, this.j = 0;
  }
  // Arcfour.prototype.next = ARC4next;
  next() {
    let e;
    return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, e = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = e, this.S[e + this.S[this.i] & 255];
  }
}
function _g() {
  return new Pg();
}
let Iu = 256, mn, Ci = null, Lt;
if (Ci == null) {
  Ci = [], Lt = 0;
  let d;
  if (typeof window < "u" && window.crypto && window.crypto.getRandomValues) {
    const t = new Uint32Array(256);
    for (window.crypto.getRandomValues(t), d = 0; d < t.length; ++d)
      Ci[Lt++] = t[d] & 255;
  }
  var yn = 0;
  const e = function(t) {
    if (yn = yn || 0, yn >= 256 || Lt >= Iu) {
      window.removeEventListener ? window.removeEventListener("mousemove", e, !1) : window.detachEvent && window.detachEvent("onmousemove", e);
      return;
    }
    try {
      const i = t.x + t.y;
      Ci[Lt++] = i & 255, yn += 1;
    } catch {
    }
  };
  typeof window < "u" && (window.addEventListener ? window.addEventListener("mousemove", e, !1) : window.attachEvent && window.attachEvent("onmousemove", e));
}
function Lg() {
  if (mn == null) {
    for (mn = _g(); Lt < Iu; ) {
      const d = Math.floor(65536 * Math.random());
      Ci[Lt++] = d & 255;
    }
    for (mn.init(Ci), Lt = 0; Lt < Ci.length; ++Lt)
      Ci[Lt] = 0;
    Lt = 0;
  }
  return mn.next();
}
class Xn {
  nextBytes(e) {
    for (let t = 0; t < e.length; ++t)
      e[t] = Lg();
  }
}
const wn = (d) => `marketsById-${d}`, bn = (d) => `markets-${d}`, Sn = (d) => `symbols-${d}`, Tn = (d) => `ids-${d}`, Ds = (d) => `currencies-${d.id}${["binance", "bybit", "mexc", "okx"].includes(d.id) ? `-${d.exchangeInstanceId}` : ""}`, Rs = (d) => `currenciesById-${d.id}${["binance", "bybit", "mexc", "okx"].includes(d.id) ? `-${d.exchangeInstanceId}` : ""}`, dd = (d) => `networkIdsByCurrencyAndNetworkCodes-${d}`, cd = (d) => `currencyIdsByCodeAndNetworkCode-${d}`, ud = (d) => `chainIdbyEcids-${d}`, fd = (d) => `ecidByChainIds-${d}`, ts = (d, e) => `accounts-${d}-${e}`, hd = (d) => `timeDifference-${d}`, qs = 1e3 * 60 * 60 * 24, Dg = 1e3 * 60 * 30, Rg = 1e3 * 60 * 5, An = (d) => ["binance", "bybit", "mexc", "okx"].includes(d.id) ? Dg : d.id === "htx" ? 1e3 * 60 * 30 : qs, Gr = (d, e) => d << e | d >>> 32 - e >>> 0, Bg = (d, e, t) => d & e ^ ~d & t, Vg = (d, e, t) => d & e ^ d & t ^ e & t, Bs = new Uint32Array([1732584193, 4023233417, 2562383102, 271733878, 3285377520]), bi = new Uint32Array(80);
class jg extends io {
  constructor() {
    super(64, 20, 8, !1), this.A = Bs[0] | 0, this.B = Bs[1] | 0, this.C = Bs[2] | 0, this.D = Bs[3] | 0, this.E = Bs[4] | 0;
  }
  get() {
    const { A: e, B: t, C: i, D: s, E: n } = this;
    return [e, t, i, s, n];
  }
  set(e, t, i, s, n) {
    this.A = e | 0, this.B = t | 0, this.C = i | 0, this.D = s | 0, this.E = n | 0;
  }
  process(e, t) {
    for (let o = 0; o < 16; o++, t += 4)
      bi[o] = e.getUint32(t, !1);
    for (let o = 16; o < 80; o++)
      bi[o] = Gr(bi[o - 3] ^ bi[o - 8] ^ bi[o - 14] ^ bi[o - 16], 1);
    let { A: i, B: s, C: n, D: r, E: a } = this;
    for (let o = 0; o < 80; o++) {
      let c, u;
      o < 20 ? (c = Bg(s, n, r), u = 1518500249) : o < 40 ? (c = s ^ n ^ r, u = 1859775393) : o < 60 ? (c = Vg(s, n, r), u = 2400959708) : (c = s ^ n ^ r, u = 3395469782);
      const f = Gr(i, 5) + c + a + u + bi[o] | 0;
      a = r, r = n, n = Gr(s, 30), s = i, i = f;
    }
    i = i + this.A | 0, s = s + this.B | 0, n = n + this.C | 0, r = r + this.D | 0, a = a + this.E | 0, this.set(i, s, n, r, a);
  }
  roundClean() {
    bi.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Fg = Zi(() => new jg());
function Ug(d) {
  const e = (c) => (c < 15.5 ? "0" : "") + Math.round(c).toString(16), t = (c) => parseInt(c, 16), i = (c, u) => (u + c).slice(-u.length);
  d = d.replace(" ", "");
  const s = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3), n = i(e(Math.floor(s / 30)), "0000000000000000"), r = lo(Ri.decode(n), Nc.decode(d), Fg, "hex"), a = t(r.substring(r.length - 1));
  let o = (t(r.substr(a * 2, 8)) & t("7fffffff")) + "";
  return o.substring(o.length - 6, o.length);
}
const { isNode: is, deepExtend: qg, extend: Gg, clone: zg, flatten: Hg, unique: Wg, indexBy: Yg, sortBy: Kg, sortBy2: Xg, safeFloat2: $g, groupBy: Zg, aggregate: Qg, uuid: Jg, unCamelCase: ld, precisionFromString: e0, Throttler: t0, capitalize: i0, now: s0, decimalToPrecision: n0, safeValue: r0, safeValue2: a0, safeString: o0, safeString2: d0, seconds: c0, milliseconds: u0, binaryToBase16: f0, numberToBE: h0, base16ToBinary: l0, iso8601: p0, omit: g0, isJsonEncodedObject: m0, safeInteger: y0, sum: w0, omitZero: b0, implodeParams: S0, extractParams: T0, json: A0, merge: I0, binaryConcat: O0, hash: M0, ecdsa: lT, arrayConcat: C0, encode: x0, urlencode: v0, hmac: k0, numberToString: E0, parseTimeframe: N0, safeInteger2: P0, safeStringLower: _0, parse8601: L0, yyyymmdd: D0, safeStringUpper: R0, safeTimestamp: B0, binaryConcatArray: V0, uuidv1: j0, numberToLE: F0, ymdhms: U0, stringToBase64: q0, decode: G0, uuid22: z0, safeIntegerProduct2: H0, safeIntegerProduct: W0, safeStringLower2: Y0, yymmdd: K0, base58ToBinary: X0, binaryToBase58: $0, safeTimestamp2: Z0, rawencode: Q0, keysort: J0, inArray: em, isEmpty: tm, ordered: im, filterBy: sm, uuid16: nm, safeFloat: rm, base64ToBinary: am, safeStringUpper2: om, urlencodeWithArrayRepeat: dm, microseconds: cm, binaryToBase64: um, strip: fm, toArray: hm, safeFloatN: lm, safeIntegerN: pm, safeIntegerProductN: gm, safeTimestampN: mm, safeValueN: ym, safeStringN: wm, safeStringLowerN: bm, safeStringUpperN: Sm, urlencodeNested: Tm, parseDate: Am, ymd: Im, base64ToString: Om, crc32: Mm, TRUNCATE: zr, ROUND: pd, DECIMAL_PLACES: Hr, NO_PADDING: Cm, TICK_SIZE: gd, SIGNIFICANT_DIGITS: xm } = mo;
let gt = class {
  constructor(e = {}) {
    this.throttleProp = void 0, this.api = void 0, this.userAgent = void 0, this.user_agent = void 0, this.userAgents = {
      chrome: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/62.0.3202.94 Safari/537.36",
      chrome39: "Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36",
      chrome100: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.75 Safari/537.36"
    }, this.headers = {}, this.forcedProxy = "", this.origin = "*", this.agent = void 0, this.termId = void 0, this.nodeHttpModuleLoaded = !1, this.httpAgent = void 0, this.httpsAgent = void 0, this.minFundingAddressLength = 1, this.quoteJsonNumbers = !0, this.number = Number, this.handleContentTypeApplicationZip = !1, this.fetchPrivateMethodsFromCache = !1, this.reduceFees = !0, this.validateServerSsl = !0, this.validateClientSsl = !1, this.timeout = 1e4, this.verbose = !1, this.twofa = void 0, this.balance = {}, this.orderbooks = {}, this.tickers = {}, this.bidsasks = {}, this.orders = void 0, this.triggerOrders = void 0, this.transactions = {}, this.requiresWeb3 = !1, this.requiresEddsa = !1, this.enableLastJsonResponse = !0, this.enableLastHttpResponse = !0, this.enableLastResponseHeaders = !0, this.last_http_response = void 0, this.last_json_response = void 0, this.last_response_headers = void 0, this.last_request_headers = void 0, this.last_request_body = void 0, this.last_request_url = void 0, this.last_request_path = void 0, this.id = void 0, this.markets = void 0, this.status = void 0, this.rateLimit = void 0, this.tokenBucket = void 0, this.throttler = void 0, this.enableRateLimit = void 0, this.httpExceptions = void 0, this.markets_by_id = void 0, this.symbols = void 0, this.ids = void 0, this.currencies = void 0, this.tokensMapping = void 0, this.tokensMetadata = void 0, this.baseCurrencies = void 0, this.quoteCurrencies = void 0, this.currencies_by_id = void 0, this.codes = void 0, this.reloadingMarkets = void 0, this.marketsLoading = void 0, this.accounts = void 0, this.accountsById = void 0, this.hostname = void 0, this.precisionMode = void 0, this.paddingMode = void 0, this.exceptions = {}, this.timeframes = {}, this.version = void 0, this.marketsByAltname = void 0, this.name = void 0, this.targetAccount = void 0, this.stablePairs = {}, this.clients = {}, this.newUpdates = !0, this.streaming = {}, this.alias = !1, this.externalSigner = void 0, this.deepExtend = qg, this.isNode = is, this.keys = Ya, this.values = $i, this.extend = Gg, this.clone = zg, this.flatten = Hg, this.unique = Wg, this.indexBy = Yg, this.sortBy = Kg, this.sortBy2 = Xg, this.groupBy = Zg, this.aggregate = Qg, this.uuid = Jg, this.unCamelCase = ld, this.precisionFromString = e0, this.capitalize = i0, this.now = s0, this.decimalToPrecision = n0, this.safeValue = r0, this.safeValue2 = a0, this.safeString = o0, this.safeString2 = d0, this.safeFloat = rm, this.safeFloat2 = $g, this.seconds = c0, this.milliseconds = u0, this.binaryToBase16 = f0, this.numberToBE = h0, this.base16ToBinary = l0, this.iso8601 = p0, this.omit = g0, this.isJsonEncodedObject = m0, this.safeInteger = y0, this.sum = w0, this.omitZero = b0, this.implodeParams = S0, this.extractParams = T0, this.json = A0, this.vwap = Su, this.merge = I0, this.binaryConcat = O0, this.hash = M0, this.arrayConcat = C0, this.encode = x0, this.urlencode = v0, this.hmac = k0, this.numberToString = E0, this.parseTimeframe = N0, this.safeInteger2 = P0, this.safeStringLower = _0, this.parse8601 = L0, this.yyyymmdd = D0, this.safeStringUpper = R0, this.safeTimestamp = B0, this.binaryConcatArray = V0, this.uuidv1 = j0, this.numberToLE = F0, this.ymdhms = U0, this.yymmdd = K0, this.stringToBase64 = q0, this.decode = G0, this.uuid22 = z0, this.safeIntegerProduct2 = H0, this.safeIntegerProduct = W0, this.binaryToBase58 = $0, this.base58ToBinary = X0, this.base64ToBinary = am, this.safeTimestamp2 = Z0, this.rawencode = Q0, this.keysort = J0, this.inArray = em, this.safeStringLower2 = Y0, this.safeStringUpper2 = om, this.isEmpty = tm, this.ordered = im, this.filterBy = sm, this.uuid16 = nm, this.urlencodeWithArrayRepeat = dm, this.microseconds = cm, this.binaryToBase64 = um, this.strip = fm, this.toArray = hm, this.safeFloatN = lm, this.safeIntegerN = pm, this.safeIntegerProductN = gm, this.safeTimestampN = mm, this.safeValueN = ym, this.safeStringN = wm, this.safeStringLowerN = bm, this.safeStringUpperN = Sm, this.urlencodeNested = Tm, this.parseDate = Am, this.ymd = Im, this.base64ToString = Om, this.crc32 = Mm, this.cache = void 0, this.exchangeInstanceId = void 0, this.mutex = void 0, this.httpProxyAgentModule = void 0, this.httpsProxyAgentModule = void 0, this.socksProxyAgentModule = void 0, this.socksProxyAgentModuleChecked = !1, this.proxyDictionaries = {}, this.proxyModulesLoaded = !1, Object.assign(this, mo), this.options = this.getDefaultOptions(), this.headers = {}, this.forcedProxy = "", this.origin = "*", this.minFundingAddressLength = 1, this.quoteJsonNumbers = !0, this.number = Number, this.handleContentTypeApplicationZip = !1, this.reduceFees = !0, this.fetchImplementation = void 0, this.validateServerSsl = !0, this.validateClientSsl = !1, this.timeout = 1e4, this.verbose = !1, this.twofa = void 0, this.apiKey = void 0, this.secret = void 0, this.uid = void 0, this.login = void 0, this.password = void 0, this.privateKey = void 0, this.walletAddress = void 0, this.token = void 0, this.balance = {}, this.orderbooks = {}, this.tickers = {}, this.orders = void 0, this.trades = {}, this.transactions = {}, this.ohlcvs = {}, this.myTrades = void 0, this.positions = void 0, this.requiresWeb3 = !1, this.requiresEddsa = !1, this.lastRestRequestTimestamp = 0, this.enableLastJsonResponse = !0, this.enableLastHttpResponse = !0, this.enableLastResponseHeaders = !0, this.last_http_response = void 0, this.last_json_response = void 0, this.last_response_headers = void 0, this.last_request_headers = void 0, this.last_request_body = void 0, this.last_request_url = void 0, this.last_request_path = void 0;
    const t = (n = this) => {
      if (n !== null) {
        const r = Object.getOwnPropertyNames(n);
        for (let a = 0; a < r.length; a++) {
          const o = r[a];
          this[ld(o)] = this[o];
        }
        t(Object.getPrototypeOf(n));
      }
    };
    t();
    const i = Object.entries(this.describe()).concat(Object.entries(e));
    for (let n = 0; n < i.length; n++) {
      const [r, a] = i[n];
      a && Object.getPrototypeOf(a) === Object.prototype ? this[r] = this.deepExtend(this[r], a) : this[r] = a;
    }
    this.validateServerSsl;
    const s = Object.keys(this.has);
    for (let n = 0; n < s.length; n++) {
      const r = s[n];
      this["has" + this.capitalize(r)] = !!this.has[r];
    }
    this.api && this.defineRestApi(this.api, "request"), this.initRestRateLimiter(), this.newUpdates = this.options.newUpdates !== void 0 ? this.options.newUpdates : !0, this.afterConstruct();
  }
  describe() {
    return {
      id: void 0,
      name: void 0,
      countries: void 0,
      enableRateLimit: !0,
      rateLimit: 2e3,
      certified: !1,
      pro: !1,
      alias: !1,
      has: {
        publicAPI: !0,
        privateAPI: !0,
        CORS: void 0,
        spot: void 0,
        margin: void 0,
        swap: void 0,
        future: void 0,
        option: void 0,
        cancelAllOrders: void 0,
        cancelOrder: !0,
        cancelOrders: void 0,
        createDepositAddress: void 0,
        createLimitOrder: !0,
        createMarketOrder: !0,
        createOrder: !0,
        createMarketBuyOrderWithCost: void 0,
        createMarketOrderWithCost: void 0,
        createMarketSellOrderWithCost: void 0,
        createOrders: void 0,
        createOrderWithTakeProfitAndStopLoss: void 0,
        createTakeProfitOrder: void 0,
        createTrailingAmountOrder: void 0,
        createTrailingPercentOrder: void 0,
        createTriggerOrder: void 0,
        editOrder: "emulated",
        fetchAccounts: void 0,
        fetchBalance: !0,
        fetchCanceledOrders: void 0,
        fetchCanceledAndClosedOrders: void 0,
        fetchClosedOrder: void 0,
        fetchClosedOrders: void 0,
        fetchCurrencies: "emulated",
        fetchDeposit: void 0,
        fetchDepositAddress: void 0,
        fetchDepositAddresses: void 0,
        fetchDepositAddressesByNetwork: void 0,
        fetchDeposits: void 0,
        fetchDepositsWithdrawals: void 0,
        fetchTransactionFee: void 0,
        fetchTransactionFees: void 0,
        fetchL2OrderBook: !0,
        fetchLedger: void 0,
        fetchLedgerEntry: void 0,
        fetchMarkets: !0,
        fetchMyTrades: void 0,
        fetchOHLCV: void 0,
        fetchOpenOrder: void 0,
        fetchOpenOrders: void 0,
        fetchOrder: void 0,
        fetchOrderBook: !0,
        fetchOrderBooks: void 0,
        fetchOrders: void 0,
        fetchOrderTrades: void 0,
        fetchPermissions: void 0,
        fetchPosition: void 0,
        fetchPositions: void 0,
        fetchPositionsForSymbol: void 0,
        fetchPositionsRisk: void 0,
        fetchStatus: void 0,
        fetchTicker: !0,
        fetchTickers: void 0,
        fetchTime: void 0,
        fetchTrades: !0,
        fetchTradingFee: void 0,
        fetchTradingFees: void 0,
        fetchTradingLimits: void 0,
        fetchTransactions: void 0,
        fetchTransfers: void 0,
        fetchWithdrawAddresses: void 0,
        fetchWithdrawal: void 0,
        fetchWithdrawals: void 0,
        transfer: void 0,
        withdraw: void 0
      },
      urls: {
        logo: void 0,
        api: void 0,
        www: void 0,
        doc: void 0,
        fees: void 0
      },
      api: void 0,
      requiredCredentials: {
        apiKey: !0,
        secret: !0,
        uid: !1,
        login: !1,
        password: !1,
        twofa: !1,
        privateKey: !1,
        walletAddress: !1,
        token: !1
        // reserved for HTTP auth in some cases
      },
      markets: void 0,
      currencies: {},
      timeframes: void 0,
      fees: {
        trading: {
          tierBased: void 0,
          percentage: void 0,
          taker: void 0,
          maker: void 0
        },
        funding: {
          tierBased: void 0,
          percentage: void 0,
          withdraw: {},
          deposit: {}
        }
      },
      status: {
        status: "ok",
        updated: void 0,
        eta: void 0,
        url: void 0
      },
      exceptions: void 0,
      httpExceptions: {
        422: O,
        418: Rt,
        429: Ae,
        404: Te,
        409: Te,
        410: Te,
        451: Te,
        500: Te,
        501: Te,
        502: Te,
        520: Te,
        521: Te,
        522: Te,
        525: Te,
        526: Te,
        400: Te,
        403: Te,
        405: Te,
        503: Te,
        530: Te,
        408: Nt,
        504: Nt,
        401: Z,
        407: Z,
        511: Z
      },
      precisionMode: Hr,
      paddingMode: Cm,
      limits: {
        leverage: { min: void 0, max: void 0 },
        amount: { min: void 0, max: void 0 },
        price: { min: void 0, max: void 0 },
        cost: { min: void 0, max: void 0 }
      }
    };
  }
  // describe ()
  encodeURIComponent(...e) {
    return encodeURIComponent(...e);
  }
  checkAddress(e) {
    if (e === void 0)
      throw new et().addMessage("Address is undefined").exchange(this.id);
    if (this.unique(e).length === 1 || e.length < this.minFundingAddressLength || e.includes(" "))
      throw new et().addMessage("Address is invalid or has less than " + this.minFundingAddressLength.toString() + ' characters: "' + this.json(e) + '"').exchange(this.id);
    return e;
  }
  initRestRateLimiter() {
    if (this.rateLimit === void 0)
      throw new be().addMessage("rateLimit property is not configured").exchange(this.id);
    this.tokenBucket = this.extend({
      delay: 1e-3,
      capacity: 1,
      cost: 1,
      maxCapacity: 1e4,
      refillRate: this.rateLimit > 0 ? 1 / this.rateLimit : Number.MAX_VALUE
    }, this.tokenBucket), this.throttler = this.throttlerFactory({
      tokenBucket: this.tokenBucket,
      id: this.id
    });
  }
  throttlerFactory(e) {
    const t = this.safeValue(e, "tokenBucket");
    return new t0(t);
  }
  throttle(e = void 0, t = void 0, i = void 0, s = void 0) {
    return this.throttler.customThrottle(e, t, i, s);
  }
  defineRestApiEndpoint(e, t, i, s, n, r, a = {}) {
    const o = n.split(/[^a-zA-Z0-9]/), c = o.map(this.capitalize).join(""), u = o.map((w) => w.trim().toLowerCase()).filter((w) => w.length > 0).join("_"), f = [r[0]].concat(r.slice(1).map(this.capitalize)).join(""), h = [r[0]].concat(r.slice(1).map((w) => w.trim()).filter((w) => w.length > 0)).join("_"), l = f + s + this.capitalize(c), p = h + "_" + i + "_" + u, m = r.length > 1 ? r : r[0], y = async (w = {}, S = {}) => this[e](n, m, t, w, void 0, void 0, a, S);
    this[l] = y, this[p] = y;
  }
  defineRestApi(e, t, i = []) {
    const s = Object.keys(e);
    for (let n = 0; n < s.length; n++) {
      const r = s[n], a = e[r], o = r.toUpperCase(), c = r.toLowerCase(), u = this.capitalize(c);
      if (Array.isArray(a))
        for (let f = 0; f < a.length; f++) {
          const h = a[f].trim();
          this.defineRestApiEndpoint(t, o, c, u, h, i);
        }
      else if (r.match(/^(?:get|post|put|delete|head|patch)$/i)) {
        const f = Object.keys(a);
        for (let h = 0; h < f.length; h++) {
          const l = f[h], p = l.trim(), m = a[l];
          if (typeof m == "object")
            this.defineRestApiEndpoint(t, o, c, u, p, i, m);
          else if (typeof m == "number")
            this.defineRestApiEndpoint(t, o, c, u, p, i, { cost: m });
          else
            throw new be().addMessage("defineRestApi : API format is not supported, API leafs must strings, objects or numbers").exchange(this.id);
        }
      } else
        this.defineRestApi(a, t, i.concat([r]));
    }
  }
  log(...e) {
    console.log(...e);
  }
  async loadProxyModules() {
    if (!this.proxyModulesLoaded) {
      this.proxyModulesLoaded = !0;
      try {
        this.httpProxyAgentModule = await import(
          /* webpackIgnore: true */
          "./index-d3db679c.mjs"
        ), this.httpsProxyAgentModule = await import(
          /* webpackIgnore: true */
          "./index-a7950765.mjs"
        );
      } catch {
        try {
          this.httpProxyAgentModule = await import(
            /* webpackIgnore: true */
            "./index-b1557b45.mjs"
          ).then((t) => t.i), this.httpProxyAgentModule = await import(
            /* webpackIgnore: true */
            "./index-b56bbf4e.mjs"
          ).then((t) => t.i);
        } catch {
        }
      }
      if (this.socksProxyAgentModuleChecked === !1) {
        this.socksProxyAgentModuleChecked = !0;
        try {
          this.socksProxyAgentModule = await import(
            /* webpackIgnore: true */
            "./index-f7a9a5f6.mjs"
          ).then((e) => e.i);
        } catch {
        }
      }
    }
  }
  setProxyAgents(e, t, i) {
    let s;
    if (e) {
      if (this.httpProxyAgentModule === void 0)
        throw new be().addMessage("You need to load JS proxy modules with `.loadProxyModules()` method at first to use proxies").exchange(this.id);
      e in this.proxyDictionaries || (this.proxyDictionaries[e] = new this.httpProxyAgentModule.HttpProxyAgent(e)), s = this.proxyDictionaries[e];
    } else if (t) {
      if (this.httpsProxyAgentModule === void 0)
        throw new be().addMessage("You need to load JS proxy modules with `.loadProxyModules()` method at first to use proxies").exchange(this.id);
      t in this.proxyDictionaries || (this.proxyDictionaries[t] = new this.httpsProxyAgentModule.HttpsProxyAgent(t)), s = this.proxyDictionaries[t], s.keepAlive = !0;
    } else if (i) {
      if (this.socksProxyAgentModule === void 0)
        throw new be().addMessage('To use SOCKS proxy with ccxt, at first you need install module "npm i socks-proxy-agent" and then initialize proxies with `.loadProxyModules()` method').exchange(this.id);
      i in this.proxyDictionaries || (this.proxyDictionaries[i] = new this.socksProxyAgentModule.SocksProxyAgent(i)), s = this.proxyDictionaries[i];
    }
    return s;
  }
  async loadHttpProxyAgent() {
    if (!this.httpAgent) {
      const e = await import(
        /* webpackIgnore: true */
        "./index-9da16b22.mjs"
      ).then((t) => t.h);
      this.httpAgent = new e.Agent();
    }
    return this.httpAgent;
  }
  getHttpAgentIfNeeded(e) {
    if (is && e.substring(0, 5) === "ws://") {
      if (this.httpAgent === void 0)
        throw new be().addMessage("To use proxy with non-ssl ws:// urls, at first run  `await exchange.loadHttpProxyAgent()` method").exchange(this.id);
      return this.httpAgent;
    }
  }
  async fetch(e, t = "GET", i = void 0, s = void 0) {
    if (is && !this.nodeHttpModuleLoaded) {
      this.nodeHttpModuleLoaded = !0;
      const y = await import(
        /* webpackIgnore: true */
        "./index-eb732fc3.mjs"
      ).then((w) => w.h);
      this.httpsAgent = new y.Agent({ keepAlive: !0 });
    }
    i = this.extend(this.headers, i);
    const n = this.checkProxyUrlSettings(e, t, i, s);
    let r = !1;
    n !== void 0 && (is && (i = this.extend({ Origin: this.origin }, i), n.substring(0, 5) === "http:" && (await this.loadHttpProxyAgent(), r = this.httpAgent)), e = n + e);
    const [a, o, c] = this.checkProxySettings(e, t, i, s);
    this.checkConflictingProxies(a || o || c, n);
    const u = this.setProxyAgents(a, o, c), f = this.userAgent !== void 0 ? this.userAgent : this.user_agent;
    if (f && is && (typeof f == "string" ? i = this.extend({ "User-Agent": f }, i) : typeof f == "object" && "User-Agent" in f && (i = this.extend(f, i))), i = this.setHeaders(i), this.verbose && this.log(`fetch Request:
`, this.id, t, e, `
RequestHeaders:
`, i, `
RequestBody:
`, s, `
`), this.fetchImplementation === void 0)
      if (is) {
        this.agent === void 0 && (this.agent = this.httpsAgent);
        try {
          const y = await import(
            /* webpackIgnore: true */
            "./index-5d944d4f.mjs"
          );
          this.AbortError = y.AbortError, this.fetchImplementation = y.default, this.FetchError = y.FetchError;
        } catch {
          if (typeof fetch == "function")
            this.fetchImplementation = fetch, this.AbortError = DOMException, this.FetchError = TypeError;
          else
            throw new be().addMessage('Seems, "fetch" function is not available in your node-js version, please use latest node-js version');
        }
      } else
        this.fetchImplementation = self.fetch, this.AbortError = DOMException, this.FetchError = TypeError;
    const h = this.fetchImplementation, l = { method: t, headers: i, body: s, timeout: this.timeout };
    this.agent && (l.agent = this.agent), r ? l.agent = r : u && (l.agent = u);
    const p = new AbortController();
    l.signal = p.signal;
    const m = setTimeout(() => {
      p.abort();
    }, this.timeout);
    try {
      const y = await h(e, l);
      return clearTimeout(m), this.handleRestResponse(y, e, t, i, s);
    } catch (y) {
      throw y instanceof this.AbortError ? new Nt().addMessage(t + " " + e + " request timed out (" + this.timeout + " ms)").exchange(this.id) : y instanceof this.FetchError ? new be().addMessage(t + " " + e + " fetch failed").exchange(this.id) : y;
    }
  }
  async fetchFromCache(e = void 0) {
    throw new wu("Not implemented").exchange(this.id);
  }
  parseJson(e) {
    try {
      if (this.isJsonEncodedObject(e))
        return JSON.parse(this.onJsonResponse(e));
    } catch {
      return;
    }
  }
  getResponseHeaders(e) {
    const t = {};
    return e.headers.forEach((i, s) => {
      s = s.split("-").map((n) => this.capitalize(n)).join("-"), t[s] = i;
    }), t;
  }
  handleRestResponse(e, t, i = "GET", s = void 0, n = void 0) {
    const r = this.getResponseHeaders(e);
    if (this.handleContentTypeApplicationZip && r["Content-Type"] === "application/zip") {
      const a = e.buffer();
      return this.enableLastResponseHeaders && (this.last_response_headers = r), this.enableLastHttpResponse && (this.last_http_response = a), this.verbose && this.log(`handleRestResponse:
`, this.id, i, t, e.status, e.statusText, `
ResponseHeaders:
`, r, "ZIP redacted", `
`), a;
    }
    return e.text().then((a) => {
      const o = this.onRestResponse(e.status, e.statusText, t, i, r, a, s, n), c = this.parseJson(o);
      return this.enableLastResponseHeaders && (this.last_response_headers = r), this.enableLastHttpResponse && (this.last_http_response = a), this.enableLastJsonResponse && (this.last_json_response = c), this.verbose && this.log(`handleRestResponse:
`, this.id, i, t, e.status, e.statusText, `
ResponseHeaders:
`, r, `
ResponseBody:
`, a, `
`), this.handleErrors(e.status, e.statusText, t, i, r, a, c, s, n) || this.handleHttpStatusCode(e.status, e.statusText, t, i, a), c || a;
    });
  }
  onRestResponse(e, t, i, s, n, r, a, o) {
    return r.trim();
  }
  onJsonResponse(e) {
    return this.quoteJsonNumbers ? e.replace(/":([+.0-9eE-]+)([,}])/g, '":"$1"$2') : e;
  }
  async loadMarketsHelper(e = !1, t = {}) {
    var o, c, u, f, h, l;
    await this.mutex.waitForUnlockAll([
      bn(this.id),
      Ds(this),
      Rs(this),
      wn(this.id),
      Sn(this.id),
      Tn(this.id)
    ]), this.markets = (o = await this.cache.get(bn(this.id), { clone: !1 })) == null ? void 0 : o.data, this.currencies = (c = await this.cache.get(Ds(this), { clone: !1 })) == null ? void 0 : c.data, this.currencies_by_id = (u = await this.cache.get(Rs(this), { clone: !1 })) == null ? void 0 : u.data, this.markets_by_id = (f = await this.cache.get(wn(this.id), { clone: !1 })) == null ? void 0 : f.data, this.symbols = (h = await this.cache.get(Sn(this.id), { clone: !1 })) == null ? void 0 : h.data, this.ids = (l = await this.cache.get(Tn(this.id), { clone: !1 })) == null ? void 0 : l.data;
    const i = (!this.currencies || !this.currencies_by_id || e) && this.has.fetchCurrencies === !0, s = !this.markets || !this.markets_by_id || !this.symbols || !this.ids || e, n = [
      Ds(this),
      Rs(this)
    ], r = [
      bn(this.id),
      wn(this.id),
      Sn(this.id),
      Tn(this.id)
    ], a = [];
    if (i && a.push(...n), s && a.push(...r), this.mutex.isLockedMany(a))
      return this.loadMarketsHelper(e, t);
    await this.mutex.acquireAll(a);
    try {
      const p = [];
      if (i) {
        const m = (async () => {
          this.currencies = await this.fetchCurrencies(), this.currencies_by_id = this.indexBy(this.currencies, "id"), await Promise.all([
            this.cache.set({
              key: Ds(this),
              data: this.currencies,
              ttl: An(this),
              clone: !1
            }),
            this.cache.set({
              key: Rs(this),
              data: this.currencies_by_id,
              ttl: An(this),
              clone: !1
            })
          ]);
        })();
        p.push(m);
      }
      if (s) {
        const m = (async () => {
          const y = this.markets || await this.fetchMarkets(t);
          this.markets = y;
        })();
        p.push(m);
      }
      if (await Promise.all(p), !this.currencies) {
        if (this.has.fetchCurrencies === !0)
          throw new Error("Currencies should have been fetched but are not available.");
        this.currencies = {}, this.currencies_by_id = {};
      }
      this.markets && await this.setMarkets(this.markets, this.currencies);
    } finally {
      await this.mutex.releaseAll(a);
    }
    return this.markets;
  }
  async loadMarkets(e = !1, t = {}) {
    return (e && !this.reloadingMarkets || !this.marketsLoading) && (this.reloadingMarkets = !0, this.marketsLoading = this.loadMarketsHelper(e, t).then((i) => (this.reloadingMarkets = !1, i), (i) => {
      throw this.reloadingMarkets = !1, i;
    })), this.marketsLoading;
  }
  async fetchCurrencies(e = {}) {
    return new Promise((t, i) => t(this.currencies));
  }
  async fetchMarkets(e = {}) {
    return new Promise((t, i) => t(Object.values(this.markets)));
  }
  parseNumber(e, t = void 0) {
    if (e === void 0)
      return t;
    try {
      return this.number(e);
    } catch {
      return t;
    }
  }
  handleHttpStatusCode(e, t, i, s, n) {
    const r = e.toString();
    if (r in this.httpExceptions) {
      const a = this.httpExceptions[r];
      throw new a(s + " " + i + " " + r + " " + t + " " + n).exchange(this.id);
    }
  }
  remove0xPrefix(e) {
    return e.slice(0, 2) === "0x" ? e.slice(2) : e;
  }
  spawn(e, ...t) {
    const i = yo();
    return setTimeout(() => {
      e.apply(this, t).then(i.resolve).catch(i.reject);
    }, 0), i;
  }
  delay(e, t, ...i) {
    setTimeout(() => {
      this.spawn(t, ...i);
    }, e);
  }
  convertToBigInt(e) {
    return BigInt(e);
  }
  stringToCharsArray(e) {
    return e.split("");
  }
  valueIsDefined(e) {
    return e != null;
  }
  arraySlice(e, t, i = void 0) {
    return i === void 0 ? e.slice(t) : e.slice(t, i);
  }
  randomBytes(e) {
    const t = new Xn(), i = [];
    return i.length = e, t.nextBytes(i), $f.from(i).toString("hex");
  }
  getProperty(e, t, i = void 0) {
    return t in e ? e[t] : i;
  }
  setProperty(e, t, i = void 0) {
    e[t] = i;
  }
  axolotl(e, t, i) {
    return lu(e, t, i);
  }
  fixStringifiedJsonMembers(e) {
    let t = e.replaceAll("\\", "");
    return t = t.replaceAll('"{', "{"), t = t.replaceAll('}"', "}"), t;
  }
  /* eslint-enable */
  // ------------------------------------------------------------------------
  // ########################################################################
  // ########################################################################
  // ########################################################################
  // ########################################################################
  // ########                        ########                        ########
  // ########                        ########                        ########
  // ########                        ########                        ########
  // ########                        ########                        ########
  // ########        ########################        ########################
  // ########        ########################        ########################
  // ########        ########################        ########################
  // ########        ########################        ########################
  // ########                        ########                        ########
  // ########                        ########                        ########
  // ########                        ########                        ########
  // ########                        ########                        ########
  // ########################################################################
  // ########################################################################
  // ########################################################################
  // ########################################################################
  // ########        ########        ########                        ########
  // ########        ########        ########                        ########
  // ########        ########        ########                        ########
  // ########        ########        ########                        ########
  // ################        ########################        ################
  // ################        ########################        ################
  // ################        ########################        ################
  // ################        ########################        ################
  // ########        ########        ################        ################
  // ########        ########        ################        ################
  // ########        ########        ################        ################
  // ########        ########        ################        ################
  // ########################################################################
  // ########################################################################
  // ########################################################################
  // ########################################################################
  safeBoolN(e, t, i = void 0) {
    const s = this.safeValueN(e, t, i);
    return typeof s == "boolean" ? s : i;
  }
  safeBool2(e, t, i, s = void 0) {
    return this.safeBoolN(e, [t, i], s);
  }
  safeBool(e, t, i = void 0) {
    return this.safeBoolN(e, [t], i);
  }
  safeDictN(e, t, i = void 0) {
    const s = this.safeValueN(e, t, i);
    return s === void 0 ? i : typeof s == "object" ? s : i;
  }
  safeDict(e, t, i = void 0) {
    return this.safeDictN(e, [t], i);
  }
  safeDict2(e, t, i, s = void 0) {
    return this.safeDictN(e, [t, i], s);
  }
  safeListN(e, t, i = void 0) {
    const s = this.safeValueN(e, t, i);
    return s === void 0 ? i : Array.isArray(s) ? s : i;
  }
  safeList2(e, t, i, s = void 0) {
    return this.safeListN(e, [t, i], s);
  }
  safeList(e, t, i = void 0) {
    return this.safeListN(e, [t], i);
  }
  handleDeltas(e, t) {
    for (let i = 0; i < t.length; i++)
      this.handleDelta(e, t[i]);
  }
  handleDelta(e, t) {
    throw new pe("handleDelta").exchange(this.id);
  }
  getCacheIndex(e, t) {
    return -1;
  }
  findTimeframe(e, t = void 0) {
    t === void 0 && (t = this.timeframes);
    const i = Object.keys(t);
    for (let s = 0; s < i.length; s++) {
      const n = i[s];
      if (t[n] === e)
        return n;
    }
  }
  checkProxyUrlSettings(e = void 0, t = void 0, i = void 0, s = void 0) {
    const n = [];
    let r;
    if (this.proxyUrl !== void 0 && (n.push("proxyUrl"), r = this.proxyUrl), this.proxy_url !== void 0 && (n.push("proxy_url"), r = this.proxy_url), this.proxyUrlCallback !== void 0 && (n.push("proxyUrlCallback"), r = this.proxyUrlCallback(e, t, i, s)), this.proxy_url_callback !== void 0 && (n.push("proxy_url_callback"), r = this.proxy_url_callback(e, t, i, s)), this.proxy !== void 0 && (n.push("proxy"), typeof this.proxy == "function" ? r = this.proxy(e, t, i, s) : r = this.proxy), n.length > 1) {
      const o = n.join(",");
      throw new be().addMessage("You have multiple conflicting proxy settings (" + o + "), please use only one from : proxyUrl, proxy_url, proxyUrlCallback, proxy_url_callback").exchange(this.id);
    }
    return r;
  }
  checkProxySettings(e = void 0, t = void 0, i = void 0, s = void 0) {
    const n = [];
    let r, a, o;
    if (this.valueIsDefined(this.httpProxy) && (n.push("httpProxy"), r = this.httpProxy), this.valueIsDefined(this.http_proxy) && (n.push("http_proxy"), r = this.http_proxy), this.httpProxyCallback !== void 0 && (n.push("httpProxyCallback"), r = this.httpProxyCallback(e, t, i, s)), this.http_proxy_callback !== void 0 && (n.push("http_proxy_callback"), r = this.http_proxy_callback(e, t, i, s)), this.valueIsDefined(this.httpsProxy) && (n.push("httpsProxy"), a = this.httpsProxy), this.valueIsDefined(this.https_proxy) && (n.push("https_proxy"), a = this.https_proxy), this.httpsProxyCallback !== void 0 && (n.push("httpsProxyCallback"), a = this.httpsProxyCallback(e, t, i, s)), this.https_proxy_callback !== void 0 && (n.push("https_proxy_callback"), a = this.https_proxy_callback(e, t, i, s)), this.valueIsDefined(this.socksProxy) && (n.push("socksProxy"), o = this.socksProxy), this.valueIsDefined(this.socks_proxy) && (n.push("socks_proxy"), o = this.socks_proxy), this.socksProxyCallback !== void 0 && (n.push("socksProxyCallback"), o = this.socksProxyCallback(e, t, i, s)), this.socks_proxy_callback !== void 0 && (n.push("socks_proxy_callback"), o = this.socks_proxy_callback(e, t, i, s)), n.length > 1) {
      const u = n.join(",");
      throw new be().addMessage("You have multiple conflicting proxy settings (" + u + "), please use only one from: httpProxy, httpsProxy, httpProxyCallback, httpsProxyCallback, socksProxy, socksProxyCallback").exchange(this.id);
    }
    return [r, a, o];
  }
  checkConflictingProxies(e, t) {
    if (e && t)
      throw new be().addMessage("You have multiple conflicting proxy settings, please use only one from : proxyUrl, httpProxy, httpsProxy, socksProxy").exchange(this.id);
  }
  filterByLimit(e, t = void 0, i = "timestamp", s = !1) {
    if (this.valueIsDefined(t)) {
      const n = e.length;
      if (n > 0) {
        let r = !0;
        if (i in e[0]) {
          const a = e[0][i], o = e[n - 1][i];
          a !== void 0 && o !== void 0 && (r = a <= o);
        }
        s ? (t > n && (t = n), e = r ? this.arraySlice(e, 0, t) : this.arraySlice(e, -t)) : e = r ? this.arraySlice(e, -t) : this.arraySlice(e, 0, t);
      }
    }
    return e;
  }
  filterBySinceLimit(e, t = void 0, i = void 0, s = "timestamp", n = !1) {
    const r = this.valueIsDefined(t), a = this.toArray(e);
    let o = a;
    if (r) {
      o = [];
      for (let u = 0; u < a.length; u++) {
        const f = a[u], h = this.safeValue(f, s);
        h && h >= t && o.push(f);
      }
    }
    if (n && i !== void 0)
      return this.arraySlice(o, -i);
    const c = !n && r;
    return this.filterByLimit(o, i, s, c);
  }
  filterByValueSinceLimit(e, t, i = void 0, s = void 0, n = void 0, r = "timestamp", a = !1) {
    const o = this.valueIsDefined(i), c = this.valueIsDefined(s), u = this.toArray(e);
    let f = u;
    if (o || c) {
      f = [];
      for (let h = 0; h < u.length; h++) {
        const l = u[h], p = l[t] === i, m = o ? p : !0, y = this.safeValue(l, r), w = y && s && y >= s;
        m && (c ? w : !0) && f.push(l);
      }
    }
    return a && n !== void 0 ? this.arraySlice(f, -n) : this.filterByLimit(f, n, r, c);
  }
  setSandboxMode(e) {
    if (e)
      if ("test" in this.urls)
        typeof this.urls.api == "string" ? (this.urls.apiBackup = this.urls.api, this.urls.api = this.urls.test) : (this.urls.apiBackup = this.clone(this.urls.api), this.urls.api = this.clone(this.urls.test));
      else
        throw new O().addMessage("does not have a sandbox URL").exchange(this.id);
    else if ("apiBackup" in this.urls) {
      typeof this.urls.api == "string" ? this.urls.api = this.urls.apiBackup : this.urls.api = this.clone(this.urls.apiBackup);
      const t = this.omit(this.urls, "apiBackup");
      this.urls = t;
    }
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    return {};
  }
  async fetchAccounts(e = {}) {
    throw new pe("fetchAccounts").exchange(this.id);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    throw new pe("fetchTrades").exchange(this.id);
  }
  async fetchDepositAddresses(e = void 0, t = {}) {
    throw new pe("fetchDepositAddresses").exchange(this.id);
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    throw new pe("fetchOrderBook").exchange(this.id);
  }
  async fetchRestOrderBookSafe(e, t = void 0, i = {}) {
    const s = this.handleOption("watchOrderBook", "maxRetries", 3);
    for (let n = 0; n < s; n++)
      try {
        return await this.fetchOrderBook(e, t, i);
      } catch (r) {
        if (n + 1 === s)
          throw r;
      }
  }
  async fetchTime(e = {}) {
    throw new pe("fetchTime").exchange(this.id);
  }
  async fetchTradingLimits(e = void 0, t = {}) {
    throw new pe("fetchTradingLimits").exchange(this.id);
  }
  parseMarket(e) {
    throw new pe("parseMarket").exchange(this.id);
  }
  parseMarkets(e) {
    const t = [];
    for (let i = 0; i < e.length; i++)
      t.push(this.parseMarket(e[i]));
    return t;
  }
  parseTicker(e, t = void 0) {
    throw new pe("parseTicker").exchange(this.id);
  }
  parseDepositAddress(e, t = void 0) {
    throw new pe("parseDepositAddress").exchange(this.id);
  }
  parseTrade(e, t = void 0) {
    throw new pe("parseTrade").exchange(this.id);
  }
  parseTransaction(e, t = void 0) {
    throw new pe("parseTransaction").exchange(this.id);
  }
  parseTransfer(e, t = void 0) {
    throw new pe("parseTransfer").exchange(this.id);
  }
  parseAccount(e) {
    throw new pe("parseAccount()").exchange(this.id);
  }
  parseLedgerEntry(e, t = void 0) {
    throw new pe("parseLedgerEntry").exchange(this.id);
  }
  parseOrder(e, t = void 0) {
    throw new pe("parseOrder").exchange(this.id);
  }
  parsePosition(e, t = void 0) {
    throw new pe("parsePosition").exchange(this.id);
  }
  async transfer(e, t, i, s, n = {}) {
    throw new pe("transfer").exchange(this.id);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    throw new pe("withdraw").exchange(this.id);
  }
  async createDepositAddress(e, t = {}) {
    throw new pe("createDepositAddress").exchange(this.id);
  }
  async fetchDepositAddressesByNetwork(e, t = {}) {
    throw new pe("fetchDepositAddressesByNetwork").exchange(this.id);
  }
  parseToInt(e) {
    const t = e.toString(), i = parseFloat(t);
    return parseInt(i);
  }
  parseToNumeric(e) {
    const t = this.numberToString(e);
    return t.indexOf(".") >= 0 ? parseFloat(t) : parseInt(t);
  }
  isRoundNumber(e) {
    return this.parseToNumeric(e % 1) === 0;
  }
  afterConstruct() {
    this.createNetworksByIdObject();
  }
  createNetworksByIdObject() {
    const e = this.invertFlatStringDictionary(this.safeValue(this.options, "networks", {}));
    this.options.networksById = this.extend(e, this.safeValue(this.options, "networksById", {}));
  }
  getDefaultOptions() {
    return {
      networkCodeReplacements: {
        ETH: { ERC20: "ETH" },
        TRX: { TRC20: "TRX" },
        CRO: { CRC20: "CRONOS" }
      }
    };
  }
  safeLedgerEntry(e, t = void 0) {
    t = this.safeCurrency(void 0, t);
    let i = this.safeString(e, "direction"), s = this.safeString(e, "before"), n = this.safeString(e, "after");
    const r = this.safeString(e, "amount");
    r !== void 0 && (s === void 0 && n !== void 0 ? s = P.stringSub(n, r) : s !== void 0 && n === void 0 && (n = P.stringAdd(s, r))), s !== void 0 && n !== void 0 && i === void 0 && (P.stringGt(s, n) && (i = "out"), P.stringGt(n, s) && (i = "in"));
    const a = this.safeValue(e, "fee");
    a !== void 0 && (a.cost = this.safeNumber(a, "cost"));
    const o = this.safeInteger(e, "timestamp"), c = this.safeDict(e, "info", {});
    return {
      id: this.safeString(e, "id"),
      timestamp: o,
      datetime: this.iso8601(o),
      direction: i,
      account: this.safeString(e, "account"),
      referenceId: this.safeString(e, "referenceId"),
      referenceAccount: this.safeString(e, "referenceAccount"),
      type: this.safeString(e, "type"),
      currency: t.code,
      amount: this.parseNumber(r),
      before: this.parseNumber(s),
      after: this.parseNumber(n),
      status: this.safeString(e, "status"),
      fee: a,
      info: c
    };
  }
  safeCurrencyStructure(e) {
    return this.extend({
      info: void 0,
      id: void 0,
      numericId: void 0,
      code: void 0,
      precision: void 0,
      type: void 0,
      name: void 0,
      active: void 0,
      deposit: void 0,
      withdraw: void 0,
      fee: void 0,
      fees: {},
      networks: {},
      limits: {
        deposit: {
          min: void 0,
          max: void 0
        },
        withdraw: {
          min: void 0,
          max: void 0
        }
      }
    }, e);
  }
  safeMarketStructure(e = void 0) {
    const t = {
      id: void 0,
      lowercaseId: void 0,
      symbol: void 0,
      base: void 0,
      quote: void 0,
      settle: void 0,
      baseId: void 0,
      quoteId: void 0,
      settleId: void 0,
      type: void 0,
      spot: void 0,
      margin: void 0,
      swap: void 0,
      future: void 0,
      option: void 0,
      index: void 0,
      active: void 0,
      contract: void 0,
      linear: void 0,
      inverse: void 0,
      subType: void 0,
      taker: void 0,
      maker: void 0,
      contractSize: void 0,
      expiry: void 0,
      expiryDatetime: void 0,
      strike: void 0,
      optionType: void 0,
      precision: {
        amount: void 0,
        price: void 0,
        cost: void 0,
        base: void 0,
        quote: void 0
      },
      limits: {
        leverage: {
          min: void 0,
          max: void 0
        },
        amount: {
          min: void 0,
          max: void 0
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: void 0,
          max: void 0
        }
      },
      created: void 0,
      info: void 0
    };
    if (e !== void 0) {
      const i = this.extend(t, e);
      return i.spot && (i.contract === void 0 && (i.contract = !1), i.swap === void 0 && (i.swap = !1), i.future === void 0 && (i.future = !1), i.option === void 0 && (i.option = !1), i.index === void 0 && (i.index = !1)), i;
    }
    return t;
  }
  async setMarkets(e, t = void 0) {
    const i = [];
    this.markets_by_id = {};
    const s = this.sortBy(this.toArray(e), "spot", !0, !0);
    for (let o = 0; o < s.length; o++) {
      const c = s[o];
      c.id in this.markets_by_id ? this.markets_by_id[c.id].push(c) : this.markets_by_id[c.id] = [c];
      const u = this.deepExtend(this.safeMarketStructure(), {
        precision: this.precision,
        limits: this.limits
      }, this.fees.trading, c);
      u.linear ? u.subType = "linear" : u.inverse ? u.subType = "inverse" : u.subType = void 0, i.push(u);
    }
    this.markets = this.indexBy(i, "symbol");
    const n = this.keysort(this.markets), r = this.keysort(this.markets_by_id);
    if (this.symbols = Object.keys(n), this.ids = Object.keys(r), t !== void 0)
      this.currencies = this.deepExtend(this.currencies, t);
    else {
      let o = [], c = [];
      for (let m = 0; m < i.length; m++) {
        const y = i[m], w = this.precisionMode === Hr ? 8 : this.parseNumber("1e-8"), S = this.safeDict(y, "precision", {});
        if ("base" in y) {
          const b = this.safeCurrencyStructure({
            id: this.safeString2(y, "baseId", "base"),
            numericId: this.safeInteger(y, "baseNumericId"),
            code: this.safeString(y, "base"),
            precision: this.safeValue2(S, "base", "amount", w)
          });
          o.push(b);
        }
        if ("quote" in y) {
          const b = this.safeCurrencyStructure({
            id: this.safeString2(y, "quoteId", "quote"),
            numericId: this.safeInteger(y, "quoteNumericId"),
            code: this.safeString(y, "quote"),
            precision: this.safeValue2(S, "quote", "price", w)
          });
          c.push(b);
        }
      }
      o = this.sortBy(o, "code", !1, ""), c = this.sortBy(c, "code", !1, ""), this.baseCurrencies = this.indexBy(o, "code"), this.quoteCurrencies = this.indexBy(c, "code");
      const u = this.arrayConcat(o, c), f = this.groupBy(u, "code"), h = Object.keys(f), l = [];
      for (let m = 0; m < h.length; m++) {
        const y = h[m], w = this.safeList(f, y, []);
        let S = this.safeValue(w, 0);
        for (let b = 1; b < w.length; b++) {
          const T = w[b];
          this.precisionMode === gd ? S = T.precision < S.precision ? T : S : S = T.precision > S.precision ? T : S;
        }
        l.push(S);
      }
      const p = this.sortBy(l, "code");
      this.currencies = this.deepExtend(this.currencies, this.indexBy(p, "code"));
    }
    this.currencies_by_id = this.indexBy(this.currencies, "id");
    const a = this.keysort(this.currencies);
    return this.codes = Object.keys(a), await Promise.all([
      this.cache.set({
        key: wn(this.id),
        data: this.markets_by_id,
        ttl: qs,
        clone: !1
      }),
      this.cache.set({
        key: bn(this.id),
        data: this.markets,
        ttl: qs,
        clone: !1
      }),
      this.cache.set({
        key: Ds(this),
        data: this.currencies,
        ttl: An(this),
        clone: !1
      }),
      this.cache.set({
        key: Rs(this),
        data: this.currencies_by_id,
        ttl: An(this),
        clone: !1
      }),
      this.cache.set({
        key: Sn(this.id),
        data: this.symbols,
        ttl: qs,
        clone: !1
      }),
      this.cache.set({
        key: Tn(this.id),
        data: this.ids,
        ttl: qs,
        clone: !1
      })
    ]), this.markets;
  }
  safeBalance(e) {
    const t = this.omit(e, ["info", "timestamp", "datetime", "free", "used", "total"]), i = Object.keys(t), s = {
      info: e == null ? void 0 : e.info,
      timestamp: e == null ? void 0 : e.timestamp,
      datetime: e == null ? void 0 : e.datetime,
      free: {},
      used: {},
      total: {},
      dept: {}
    };
    for (let a = 0; a < i.length; a++) {
      const o = i[a];
      let c = this.safeString(e[o], "total"), u = this.safeString(e[o], "free"), f = this.safeString(e[o], "used");
      const h = this.safeString(e[o], "debt");
      c === void 0 && u !== void 0 && f !== void 0 && (c = P.stringAdd(u, f)), u === void 0 && c !== void 0 && f !== void 0 && (u = P.stringSub(c, f)), f === void 0 && c !== void 0 && u !== void 0 && (f = P.stringSub(c, u));
      const l = this.parseNumber(u), p = this.parseNumber(f), m = this.parseNumber(c);
      if (!(m === void 0 || l === void 0 || p === void 0 || m === 0) && (s[o] = {
        free: l,
        used: p,
        total: m
      }, s.free[o] = l, s.used[o] = p, s.total[o] = m, h !== void 0)) {
        const y = this.parseNumber(h);
        s[o].debt = y, s.dept[o] = y;
      }
    }
    return Object.keys(s.dept).length === 0 && delete s.dept, s;
  }
  safeOrder(e, t = void 0) {
    let i = this.omitZero(this.safeString(e, "amount")), s = this.safeString(e, "remaining"), n = this.safeString(e, "filled"), r = this.safeString(e, "cost"), a = this.omitZero(this.safeString(e, "average")), o = this.omitZero(this.safeString(e, "price")), c = this.safeInteger(e, "lastTradeTimestamp"), u = this.safeString(e, "symbol"), f = this.safeString(e, "side");
    const h = this.safeString(e, "status"), l = n === void 0, p = r === void 0, m = c === void 0, y = this.safeValue(e, "fee"), w = y === void 0, S = this.safeValue(e, "fees") === void 0, b = u === void 0, T = f === void 0, x = w || S, v = this.safeList(e, "fees", []);
    let _ = [];
    if (l || p || x) {
      const K = this.safeValue(e, "trades", _), R = this.number;
      this.number = String;
      const U = this.safeValue(K, 0);
      U !== void 0 && "info" in U && "id" in U ? _ = K : _ = this.parseTrades(K, t), this.number = R;
      let J = 0;
      const ae = Array.isArray(_);
      if (ae && (J = _.length), ae && J > 0) {
        e.symbol === void 0 && (e.symbol = _[0].symbol), e.side === void 0 && (e.side = _[0].side), e.type === void 0 && (e.type = _[0].type), e.id === void 0 && (e.id = _[0].order), l && (n = "0"), p && (r = "0");
        for (let A = 0; A < _.length; A++) {
          const M = _[A], q = this.safeString(M, "amount");
          l && q !== void 0 && (n = P.stringAdd(n, q));
          const H = this.safeString(M, "cost");
          p && H !== void 0 && (r = P.stringAdd(r, H)), b && (u = this.safeString(M, "symbol")), T && (f = this.safeString(M, "side"));
          const le = this.safeValue(M, "timestamp");
          if (m && le !== void 0 && (c === void 0 ? c = le : c = Math.max(c, le)), x) {
            const oe = this.safeValue(M, "fees");
            if (oe !== void 0)
              for (let he = 0; he < oe.length; he++) {
                const Ie = oe[he];
                v.push(this.extend({}, Ie));
              }
            else {
              const he = this.safeValue(M, "fee");
              he !== void 0 && v.push(this.extend({}, he));
            }
          }
        }
      }
    }
    if (x) {
      const K = this.reduceFees ? this.reduceFeesByCurrency(v) : v, R = K.length;
      for (let U = 0; U < R; U++)
        K[U].cost = this.safeNumber(K[U], "cost"), "rate" in K[U] && (K[U].rate = this.safeNumber(K[U], "rate"));
      if (!w && R === 0) {
        const U = this.deepExtend(y);
        U.cost = this.safeNumber(U, "cost"), "rate" in U && (U.rate = this.safeNumber(U, "rate")), K.push(U);
      }
      e.fees = K, w && R === 1 && (e.fee = K[0]);
    }
    i === void 0 && (n !== void 0 && s !== void 0 ? i = P.stringAdd(n, s) : h === "closed" && (i = n)), n === void 0 && (i !== void 0 && s !== void 0 ? n = P.stringSub(i, s) : h === "closed" && i !== void 0 && (n = i)), s === void 0 && (i !== void 0 && n !== void 0 ? s = P.stringSub(i, n) : h === "closed" && (s = "0"));
    const V = this.safeBool(t, "inverse", !1), j = this.numberToString(this.safeValue(t, "contractSize", 1));
    if (a === void 0 && n !== void 0 && r !== void 0 && P.stringGt(n, "0")) {
      const K = P.stringMul(n, j);
      V ? a = P.stringDiv(K, r) : a = P.stringDiv(r, K);
    }
    if (p && n !== void 0 && (a !== void 0 || o !== void 0)) {
      let K;
      a === void 0 ? K = o : K = a;
      const R = P.stringMul(n, j);
      V ? r = P.stringDiv(R, K) : r = P.stringMul(R, K);
    }
    const W = this.safeValue(e, "type");
    (o === void 0 || P.stringEquals(o, "0")) && W === "market" && (o = a);
    for (let K = 0; K < _.length; K++) {
      const R = _[K];
      R.amount = this.safeNumber(R, "amount"), R.price = this.safeNumber(R, "price"), R.cost = this.safeNumber(R, "cost");
      const U = this.safeDict(R, "fee", {});
      U.cost = this.safeNumber(U, "cost"), "rate" in U && (U.rate = this.safeNumber(U, "rate"));
      const Y = this.safeList(R, "fees", []);
      for (let J = 0; J < Y.length; J++)
        Y[J].cost = this.safeNumber(Y[J], "cost");
      R.fees = Y, R.fee = U;
    }
    let Q = this.safeString(e, "timeInForce"), se = this.safeValue(e, "postOnly");
    Q === void 0 ? (this.safeString(e, "type") === "market" && (Q = "IOC"), se && (Q = "PO")) : se === void 0 && (se = Q === "PO");
    const $ = this.safeInteger(e, "timestamp"), te = this.safeInteger(e, "lastUpdateTimestamp");
    let E = this.safeString(e, "datetime");
    E === void 0 && (E = this.iso8601($));
    const N = this.parseNumber(this.safeString2(e, "triggerPrice", "stopPrice")), L = this.parseNumber(this.safeString(e, "takeProfitPrice")), z = this.parseNumber(this.safeString(e, "stopLossPrice"));
    return this.extend(e, {
      id: this.safeString(e, "id"),
      clientOrderId: this.safeString(e, "clientOrderId"),
      timestamp: $,
      datetime: E,
      symbol: u,
      type: this.safeString(e, "type"),
      side: f,
      lastTradeTimestamp: c,
      lastUpdateTimestamp: te,
      price: this.parseNumber(o),
      amount: this.parseNumber(i),
      cost: this.parseNumber(r),
      average: this.parseNumber(a),
      filled: this.parseNumber(n),
      remaining: this.parseNumber(s),
      timeInForce: Q,
      postOnly: se,
      trades: _,
      reduceOnly: this.safeValue(e, "reduceOnly"),
      stopPrice: N,
      triggerPrice: N,
      takeProfitPrice: L,
      stopLossPrice: z,
      status: h,
      fee: this.safeValue(e, "fee")
    });
  }
  parseOrders(e, t = void 0, i = void 0, s = void 0, n = {}) {
    let r = [];
    if (Array.isArray(e))
      for (let o = 0; o < e.length; o++) {
        const c = this.extend(this.parseOrder(e[o], t), n);
        r.push(c);
      }
    else {
      const o = Object.keys(e);
      for (let c = 0; c < o.length; c++) {
        const u = o[c], f = this.extend(this.parseOrder(this.extend({ id: u }, e[u]), t), n);
        r.push(f);
      }
    }
    r = this.sortBy(r, "timestamp");
    const a = t !== void 0 ? t.symbol : void 0;
    return this.filterBySymbolSinceLimit(r, a, i, s);
  }
  calculateFee(e, t, i, s, n, r = "taker", a = {}) {
    if (t === "market" && r === "maker")
      throw new g('calculateFee() - you have provided incompatible arguments - "market" type order can not be "maker". Change either the "type" or the "takerOrMaker" argument to calculate the fee.').exchange(this.id);
    const o = this.markets[e], c = this.safeString(o, "feeSide", "quote");
    let u;
    c === "get" ? u = i === "sell" : c === "give" ? u = i === "buy" : u = c === "quote";
    let f = this.numberToString(s), h;
    if (u) {
      const p = this.numberToString(n);
      f = P.stringMul(f, p), h = "quote";
    } else
      h = "base";
    o.spot || (h = "settle"), t === "market" && (r = "taker");
    const l = this.safeString(o, r);
    return f = P.stringMul(f, l), {
      type: r,
      currency: o[h],
      rate: this.parseNumber(l),
      cost: this.parseNumber(f)
    };
  }
  safeLiquidation(e, t = void 0) {
    const i = this.safeString(e, "contracts"), s = this.safeString(t, "contractSize"), n = this.safeString(e, "price");
    let r = this.safeString(e, "baseValue"), a = this.safeString(e, "quoteValue");
    return r === void 0 && i !== void 0 && s !== void 0 && n !== void 0 && (r = P.stringMul(i, s)), a === void 0 && r !== void 0 && n !== void 0 && (a = P.stringMul(r, n)), e.contracts = this.parseNumber(i), e.contractSize = this.parseNumber(s), e.price = this.parseNumber(n), e.baseValue = this.parseNumber(r), e.quoteValue = this.parseNumber(a), e;
  }
  safeTrade(e, t = void 0) {
    const i = this.safeString(e, "amount"), s = this.safeString(e, "price");
    let n = this.safeString(e, "cost");
    if (n === void 0) {
      const f = this.safeString(t, "contractSize");
      let h = s;
      f !== void 0 && (this.safeBool(t, "inverse", !1) && (h = P.stringDiv("1", s)), h = P.stringMul(h, f)), n = P.stringMul(h, i);
    }
    const r = this.safeValue(e, "fee") === void 0, a = this.safeValue(e, "fees") === void 0, o = r || a, c = [], u = this.safeValue(e, "fee");
    if (o) {
      const f = this.reduceFees ? this.reduceFeesByCurrency(c) : c, h = f.length;
      for (let p = 0; p < h; p++)
        f[p].cost = this.safeNumber(f[p], "cost"), "rate" in f[p] && (f[p].rate = this.safeNumber(f[p], "rate"));
      if (!r && h === 0) {
        const p = this.deepExtend(u);
        p.cost = this.safeNumber(p, "cost"), "rate" in p && (p.rate = this.safeNumber(p, "rate")), f.push(p);
      }
      a && (e.fees = f), r && h === 1 && (e.fee = f[0]);
      const l = this.safeValue(e, "fee");
      l !== void 0 && (l.cost = this.safeNumber(l, "cost"), "rate" in l && (l.rate = this.safeNumber(l, "rate")), e.fee = l);
    }
    return e.amount = this.parseNumber(i), e.price = this.parseNumber(s), e.cost = this.parseNumber(n), e;
  }
  invertFlatStringDictionary(e) {
    const t = {}, i = Object.keys(e);
    for (let s = 0; s < i.length; s++) {
      const n = i[s], r = e[n];
      typeof r == "string" && (t[r] = n);
    }
    return t;
  }
  reduceFeesByCurrency(e) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], a = this.safeString(r, "currency");
      if (a !== void 0) {
        const o = this.safeString(r, "rate"), c = this.safeValue(r, "cost");
        if (P.stringEq(c, "0"))
          continue;
        a in t || (t[a] = {});
        const u = o === void 0 ? "" : o;
        u in t[a] ? t[a][u].cost = P.stringAdd(t[a][u].cost, c) : (t[a][u] = {
          currency: a,
          cost: c
        }, o !== void 0 && (t[a][u].rate = o));
      }
    }
    let i = [];
    const s = Object.values(t);
    for (let n = 0; n < s.length; n++) {
      const r = Object.values(s[n]);
      i = this.arrayConcat(i, r);
    }
    return i;
  }
  safeTicker(e, t = void 0) {
    let i = this.omitZero(this.safeString(e, "open")), s = this.omitZero(this.safeString(e, "close")), n = this.omitZero(this.safeString(e, "last")), r = this.omitZero(this.safeString(e, "change")), a = this.omitZero(this.safeString(e, "percentage")), o = this.omitZero(this.safeString(e, "average")), c = this.omitZero(this.safeString(e, "vwap"));
    const u = this.safeString(e, "baseVolume"), f = this.safeString(e, "quoteVolume");
    return c === void 0 && (c = P.stringDiv(this.omitZero(f), u)), n !== void 0 && s === void 0 ? s = n : n === void 0 && s !== void 0 && (n = s), n !== void 0 && i !== void 0 && (r === void 0 && (r = P.stringSub(n, i)), o === void 0 && (o = P.stringDiv(P.stringAdd(n, i), "2"))), a === void 0 && r !== void 0 && i !== void 0 && P.stringGt(i, "0") && (a = P.stringMul(P.stringDiv(r, i), "100")), r === void 0 && a !== void 0 && i !== void 0 && (r = P.stringDiv(P.stringMul(a, i), "100")), i === void 0 && n !== void 0 && r !== void 0 && (i = P.stringSub(n, r)), this.extend(e, {
      bid: this.parseNumber(this.omitZero(this.safeNumber(e, "bid"))),
      bidVolume: this.safeNumber(e, "bidVolume"),
      ask: this.parseNumber(this.omitZero(this.safeNumber(e, "ask"))),
      askVolume: this.safeNumber(e, "askVolume"),
      high: this.parseNumber(this.omitZero(this.safeString(e, "high"))),
      low: this.parseNumber(this.omitZero(this.safeNumber(e, "low"))),
      open: this.parseNumber(this.omitZero(this.parseNumber(i))),
      close: this.parseNumber(this.omitZero(this.parseNumber(s))),
      last: this.parseNumber(this.omitZero(this.parseNumber(n))),
      change: this.parseNumber(r),
      percentage: this.parseNumber(a),
      average: this.parseNumber(o),
      vwap: this.parseNumber(c),
      baseVolume: this.parseNumber(u),
      quoteVolume: this.parseNumber(f),
      previousClose: this.safeNumber(e, "previousClose")
    });
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    let r = "";
    throw this.has.fetchTrades && (r = '. If you want to build OHLCV candles from trade executions data, visit https://github.com/ccxt/ccxt/tree/master/examples/ and see "build-ohlcv-bars" file'), new pe("fetchOHLCV").addMessage(r).exchange(this.id);
  }
  convertTradingViewToOHLCV(e, t = "t", i = "o", s = "h", n = "l", r = "c", a = "v", o = !1) {
    const c = [], u = this.safeList(e, t, []), f = this.safeList(e, i, []), h = this.safeList(e, s, []), l = this.safeList(e, n, []), p = this.safeList(e, r, []), m = this.safeList(e, a, []);
    for (let y = 0; y < u.length; y++)
      c.push([
        o ? this.safeInteger(u, y) : this.safeTimestamp(u, y),
        this.safeValue(f, y),
        this.safeValue(h, y),
        this.safeValue(l, y),
        this.safeValue(p, y),
        this.safeValue(m, y)
      ]);
    return c;
  }
  convertOHLCVToTradingView(e, t = "t", i = "o", s = "h", n = "l", r = "c", a = "v", o = !1) {
    const c = {};
    c[t] = [], c[i] = [], c[s] = [], c[n] = [], c[r] = [], c[a] = [];
    for (let u = 0; u < e.length; u++) {
      const f = o ? e[u][0] : this.parseToInt(e[u][0] / 1e3);
      c[t].push(f), c[i].push(e[u][1]), c[s].push(e[u][2]), c[n].push(e[u][3]), c[r].push(e[u][4]), c[a].push(e[u][5]);
    }
    return c;
  }
  async fetchWebEndpoint(e, t, i, s = void 0, n = void 0) {
    let r = "";
    const a = this.safeValue(this.options, e, {}), o = this.safeBool(a, "webApiMuteFailure", !0);
    try {
      if (this.safeBool(a, "webApiEnable", !0) !== !0)
        return;
      const c = this.safeValue(a, "webApiRetries", 10);
      let u, f = 0;
      for (; f < c; )
        try {
          u = await this[t]({});
          break;
        } catch (l) {
          if (f = f + 1, f === c)
            throw l;
        }
      let h = u;
      if (s !== void 0 && (h = h.split(s)[1]), n !== void 0 && (h = h.split(n)[0]), i && typeof h == "string") {
        const l = this.parseJson(h.trim());
        if (l)
          return l;
        throw new be().addMessage("could not parse the response into json").exchange(this.id);
      } else
        return h;
    } catch {
      r = this.id + " " + e + "() failed to fetch correct data from website. Probably webpage markup has been changed, breaking the page custom parser.";
    }
    if (!o)
      throw new be().addMessage(r).exchange(this.id);
  }
  marketIds(e) {
    if (e === void 0)
      return e;
    const t = [];
    for (let i = 0; i < e.length; i++)
      t.push(this.marketId(e[i]));
    return t;
  }
  marketSymbols(e, t = void 0, i = !0, s = !1, n = !1) {
    if (e === void 0) {
      if (!i)
        throw new g("Empty list of symbols is not supported").exchange(this.id);
      return e;
    }
    if (e.length === 0) {
      if (!i)
        throw new g("Empty list of symbols is not supported").exchange(this.id);
      return e;
    }
    const a = [];
    let o, c;
    for (let u = 0; u < e.length; u++) {
      const f = this.market(e[u]);
      if (s && o !== void 0 && f.type !== o)
        throw new pt().addMessage("Symbols must be of the same type, either " + o + " or " + f.type + ".").exchange(this.id);
      if (n && c !== void 0 && f.linear !== c)
        throw new pt().addMessage("Symbols must be of the same subType, either linear or inverse.").exchange(this.id);
      if (t !== void 0 && f.type !== t)
        throw new pt().addMessage("Symbols must be of the same type " + t + ". If the type is incorrect you can change it in options or the params of the request").exchange(this.id);
      o = f.type, f.spot || (c = f.linear);
      const h = this.safeString(f, "symbol", e[u]);
      a.push(h);
    }
    return a;
  }
  marketCodes(e) {
    if (e === void 0)
      return e;
    const t = [];
    for (let i = 0; i < e.length; i++)
      t.push(this.getCodeFromCurrencyId(e[i]));
    return t;
  }
  parseBidsAsks(e, t = 0, i = 1, s = 2) {
    e = this.toArray(e);
    const n = [];
    for (let r = 0; r < e.length; r++)
      n.push(this.parseBidAsk(e[r], t, i, s));
    return n;
  }
  async fetchL2OrderBook(e, t = void 0, i = {}) {
    const s = await this.fetchOrderBook(e, t, i);
    return this.extend(s, {
      asks: this.sortBy(this.aggregate(s.asks), 0),
      bids: this.sortBy(this.aggregate(s.bids), 0, !0)
    });
  }
  filterBySymbol(e, t = void 0) {
    if (t === void 0)
      return e;
    const i = [];
    for (let s = 0; s < e.length; s++)
      this.safeString(e[s], "symbol") === t && i.push(e[s]);
    return i;
  }
  parseOHLCV(e, t = void 0) {
    return Array.isArray(e) ? [
      this.safeInteger(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 2),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 5)
      // volume
    ] : e;
  }
  networkCodeToId(e, t = void 0) {
    if (e === void 0)
      return;
    const i = this.safeValue(this.options, "networks", {});
    let s = this.safeString(i, e);
    if (s === void 0)
      if (t === void 0)
        s = e;
      else {
        const n = this.safeValue(this.options, "networkCodeReplacements", {});
        if (t in n) {
          const r = n[t], a = Object.keys(r);
          for (let o = 0; o < a.length; o++) {
            const c = a[o];
            if (r[c] === e) {
              s = c;
              break;
            }
          }
        }
        s === void 0 && (s = e);
      }
    return s;
  }
  networkIdToCode(e, t = void 0) {
    if (e === void 0)
      return;
    const i = this.safeDict(this.options, "networksById", {});
    let s = this.safeString(i, e, e);
    if (t !== void 0) {
      const n = this.safeValue(this.options, "networkCodeReplacements", {});
      if (t in n) {
        const r = this.safeValue(n, t, {});
        s = this.safeString(r, s, s);
      }
    }
    return s;
  }
  handleNetworkCodeAndParams(e) {
    const t = this.safeString2(e, "networkCode", "network");
    return t !== void 0 && (e = this.omit(e, ["networkCode", "network"])), [t, e];
  }
  handleEcidAndParams(e) {
    const t = this.safeString2(e, "ecid", "network");
    return t !== void 0 && (e = this.omit(e, ["ecid", "network"])), [t, e];
  }
  defaultNetworkCode(e) {
    let t;
    const i = this.safeDict(this.options, "defaultNetworks", {});
    if (e in i)
      t = i[e];
    else {
      const s = this.safeDict(this.options, "defaultNetwork");
      s !== void 0 && (t = s);
    }
    return t;
  }
  selectNetworkCodeFromUnifiedNetworks(e, t, i) {
    return this.selectNetworkKeyFromNetworks(e, t, i, !0);
  }
  selectNetworkIdFromRawNetworks(e, t, i) {
    return this.selectNetworkKeyFromNetworks(e, t, i, !1);
  }
  selectNetworkKeyFromNetworks(e, t, i, s = !1) {
    let n;
    const r = Object.keys(i), a = r.length;
    if (t !== void 0) {
      if (a === 0)
        throw new ka(t).addMessage("Network did not return any result for " + e).exchange(this.id);
      {
        const o = s ? t : this.networkCodeToId(t, e);
        if (o in i)
          n = o;
        else
          throw new ka(o).addMessage("Network was not found for " + e + ", use one of " + r.join(", ")).exchange(this.id);
      }
    } else {
      if (a === 0)
        throw new Kn(e).exchange(this.id);
      {
        const o = this.defaultNetworkCode(e), c = s ? o : this.networkCodeToId(o, e);
        n = c in i ? c : r[0];
      }
    }
    return n;
  }
  safeNumber2(e, t, i, s = void 0) {
    const n = this.safeString2(e, t, i);
    return this.parseNumber(n, s);
  }
  parseOrderBook(e, t, i = void 0, s = "bids", n = "asks", r = 0, a = 1, o = 2) {
    const c = this.parseBidsAsks(this.safeValue(e, s, []), r, a, o), u = this.parseBidsAsks(this.safeValue(e, n, []), r, a, o);
    return {
      symbol: t,
      bids: this.sortBy(c, 0, !0),
      asks: this.sortBy(u, 0),
      timestamp: i,
      datetime: this.iso8601(i),
      nonce: void 0
    };
  }
  parseOHLCVs(e, t = void 0, i = "1m", s = void 0, n = void 0) {
    const r = [];
    for (let o = 0; o < e.length; o++)
      r.push(this.parseOHLCV(e[o], t));
    const a = this.sortBy(r, 0);
    return this.filterBySinceLimit(a, s, n, 0);
  }
  async loadTradingLimits(e = void 0, t = !1, i = {}) {
    if (this.has.fetchTradingLimits && (t || !("limitsLoaded" in this.options))) {
      const s = await this.fetchTradingLimits(e);
      for (let n = 0; n < e.length; n++) {
        const r = e[n];
        this.markets[r] = this.deepExtend(this.markets[r], s[r]);
      }
      this.options.limitsLoaded = this.milliseconds();
    }
    return this.markets;
  }
  safePosition(e) {
    const t = this.safeString(e, "unrealisedPnl"), i = this.safeString(e, "initialMargin");
    if (this.safeValue(e, "percentage") === void 0 && t !== void 0 && i !== void 0) {
      const o = P.stringMul(P.stringDiv(t, i, 4), "100");
      e.percentage = this.parseNumber(o);
    }
    let n = this.safeNumber(e, "contractSize");
    const r = this.safeString(e, "symbol");
    let a;
    return r !== void 0 && (a = this.safeValue(this.markets, r)), n === void 0 && a !== void 0 && (n = this.safeNumber(a, "contractSize"), e.contractSize = n), e;
  }
  parsePositions(e, t = void 0, i = {}) {
    t = this.marketSymbols(t), e = this.toArray(e);
    const s = [];
    for (let n = 0; n < e.length; n++) {
      const r = this.extend(this.parsePosition(e[n], void 0), i);
      s.push(r);
    }
    return this.filterByArrayPositions(s, "symbol", t, !1);
  }
  parseAccounts(e, t = {}) {
    e = this.toArray(e);
    const i = [];
    for (let s = 0; s < e.length; s++) {
      const n = this.extend(this.parseAccount(e[s]), t);
      i.push(n);
    }
    return i;
  }
  parseTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    e = this.toArray(e);
    let r = [];
    for (let o = 0; o < e.length; o++) {
      const c = this.extend(this.parseTrade(e[o], t), n);
      r.push(c);
    }
    r = this.sortBy2(r, "timestamp", "id");
    const a = t !== void 0 ? t.symbol : void 0;
    return this.filterBySymbolSinceLimit(r, a, i, s);
  }
  parseTransactions(e, t = void 0, i = void 0, s = void 0, n = {}) {
    e = this.toArray(e);
    let r = [];
    for (let o = 0; o < e.length; o++) {
      const c = this.extend(this.parseTransaction(e[o], t), n);
      r.push(c);
    }
    r = this.sortBy(r, "timestamp");
    const a = t !== void 0 ? t.code : void 0;
    return this.filterByCurrencySinceLimit(r, a, i, s);
  }
  parseTransfers(e, t = void 0, i = void 0, s = void 0, n = {}) {
    e = this.toArray(e);
    let r = [];
    for (let o = 0; o < e.length; o++) {
      const c = this.extend(this.parseTransfer(e[o], t), n);
      r.push(c);
    }
    r = this.sortBy(r, "timestamp");
    const a = t !== void 0 ? t.code : void 0;
    return this.filterByCurrencySinceLimit(r, a, i, s);
  }
  parseLedger(e, t = void 0, i = void 0, s = void 0, n = {}) {
    let r = [];
    const a = this.toArray(e);
    for (let c = 0; c < a.length; c++) {
      const u = this.parseLedgerEntry(a[c], t);
      if (Array.isArray(u))
        for (let f = 0; f < u.length; f++)
          r.push(this.extend(u[f], n));
      else
        r.push(this.extend(u, n));
    }
    r = this.sortBy(r, "timestamp");
    const o = t !== void 0 ? t.code : void 0;
    return this.filterByCurrencySinceLimit(r, o, i, s);
  }
  nonce() {
    return this.seconds();
  }
  setHeaders(e) {
    return e;
  }
  marketId(e) {
    const t = this.market(e);
    return t !== void 0 ? t.id : e;
  }
  symbol(e) {
    const t = this.market(e);
    return this.safeString(t, "symbol", e);
  }
  handleParamString(e, t, i = void 0) {
    const s = this.safeString(e, t, i);
    return s !== void 0 && (e = this.omit(e, t)), [s, e];
  }
  resolvePath(e, t) {
    return [
      this.implodeParams(e, t),
      this.omit(t, this.extractParams(e))
    ];
  }
  getListFromObjectValues(e, t) {
    const i = this.toArray(e), s = [];
    for (let n = 0; n < i.length; n++)
      s.push(i[n][t]);
    return s;
  }
  getSymbolsForMarketType(e = void 0, t = void 0, i = !0, s = !0) {
    let n = this.markets;
    e !== void 0 && (n = this.filterBy(n, "type", e)), t !== void 0 && (this.checkRequiredArgument("getSymbolsForMarketType", t, "subType", ["linear", "inverse", "quanto"]), n = this.filterBy(n, "subType", t));
    const r = [];
    return i && r.push(!0), s && r.push(void 0), n = this.filterByArray(n, "active", r, !1), this.getListFromObjectValues(n, "symbol");
  }
  filterByArray(e, t, i = void 0, s = !0) {
    if (e = this.toArray(e), i === void 0 || !i)
      return s ? this.indexBy(e, t) : e;
    const n = [];
    for (let r = 0; r < e.length; r++)
      this.inArray(e[r][t], i) && n.push(e[r]);
    return s ? this.indexBy(n, t) : n;
  }
  isUsingForcedProxy(e = void 0, t = void 0) {
    return !1;
  }
  async fetch2(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0, a = {}) {
    let o;
    if ("methodCallId" in s && (o = s.methodCallId, s = this.omit(s, "methodCallId")), this.enableRateLimit) {
      let l, p;
      "customExpireInterval" in s && (l = s.customExpireInterval, s = this.omit(s, "customExpireInterval")), "customPriority" in s && (p = s.customPriority, s = this.omit(s, "customPriority"));
      const m = this.calculateRateLimiterCost(t, i, e, s, a);
      await this.throttle(m, e, l, p);
    }
    this.lastRestRequestTimestamp = this.milliseconds();
    const c = this.isUsingForcedProxy(s, t), u = c && this.forcedProxy ? this.forcedProxy : "", f = o ? await this.generateMethodCallId(o, e, t, i, s) : void 0, h = s.customExtraHeaders;
    if (h && (s = this.omit(s, "customExtraHeaders")), this.fetchPrivateMethodsFromCache && c) {
      const l = await this.fetchFromCache(f);
      return this.handleRestResponse(l, "", i, n, r);
    } else {
      const l = await this.sign(e, t, i, s, n, r);
      return f && (l.headers || (l.headers = {}), l.headers["x-request-call-id"] = f), h && (l.headers = this.extend(l.headers, h)), this.last_request_headers = l.headers, this.last_request_body = l.body, this.last_request_url = l.url, await this.fetch(u + l.url, l.method, l.headers, l.body);
    }
  }
  async generateMethodCallId(e, t, i, s, n) {
    const r = JSON.stringify(n);
    return [
      e,
      s,
      i,
      t,
      r
    ].join(":");
  }
  async request(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0, a = {}) {
    return await this.fetch2(e, t, i, s, n, r, a);
  }
  async loadAccounts(e = !1, t = {}) {
    var i;
    if (e)
      this.accounts = await this.fetchAccounts(t);
    else {
      if (await this.mutex.waitForUnlock(ts(this.id, this.exchangeInstanceId)), this.accounts = (i = await this.cache.get(ts(this.id, this.exchangeInstanceId), { clone: !1 })) == null ? void 0 : i.data, this.accounts)
        return this.accounts;
      try {
        if (this.mutex.isLocked(ts(this.id, this.exchangeInstanceId)))
          return this.loadAccounts(void 0, t);
        await this.mutex.acquire(ts(this.id, this.exchangeInstanceId)), this.accounts = await this.fetchAccounts(t), await this.cache.set({
          key: ts(this.id, this.exchangeInstanceId),
          data: this.accounts,
          ttl: Rg,
          clone: !1
        });
      } finally {
        this.mutex.release(ts(this.id, this.exchangeInstanceId));
      }
    }
    return this.accountsById = this.indexBy(this.accounts, "id"), this.accounts;
  }
  buildOHLCVC(e, t = "1m", i = 0, s = 2147483647) {
    const n = this.parseTimeframe(t) * 1e3, r = [], a = 0, o = 2, c = 3, u = 4, f = 5, h = 6, l = e.length, p = Math.min(l, s);
    for (let m = 0; m < p; m++) {
      const y = e[m], w = y.timestamp;
      if (w < i)
        continue;
      const S = Math.floor(w / n) * n;
      if (S < i)
        continue;
      const T = r.length - 1;
      T === -1 || S >= this.sum(r[T][a], n) ? r.push([
        S,
        y.price,
        y.price,
        y.price,
        y.price,
        y.amount,
        1
        // count
      ]) : (r[T][o] = Math.max(r[T][o], y.price), r[T][c] = Math.min(r[T][c], y.price), r[T][u] = y.price, r[T][f] = this.sum(r[T][f], y.amount), r[T][h] = this.sum(r[T][h], 1));
    }
    return r;
  }
  parseTradingViewOHLCV(e, t = void 0, i = "1m", s = void 0, n = void 0) {
    const r = this.convertTradingViewToOHLCV(e);
    return this.parseOHLCVs(r, t, i, s, n);
  }
  async editLimitBuyOrder(e, t, i, s = void 0, n = {}) {
    return await this.editLimitOrder(e, t, "buy", i, s, n);
  }
  async editLimitSellOrder(e, t, i, s = void 0, n = {}) {
    return await this.editLimitOrder(e, t, "sell", i, s, n);
  }
  async editLimitOrder(e, t, i, s, n = void 0, r = {}) {
    return await this.editOrder(e, t, "limit", i, s, n, r);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    return await this.cancelOrder(e, t), await this.createOrder(t, i, s, n, r, a);
  }
  async fetchPermissions(e = {}) {
    throw new pe("fetchPermissions").exchange(this.id);
  }
  async fetchPosition(e, t = {}) {
    throw new pe("fetchPosition").exchange(this.id);
  }
  async getSubAccounts() {
    throw new pe("getSubAccounts").exchange(this.id);
  }
  async fetchSubAccountBalances(e, t = {}) {
    throw new pe("fetchSubAccountBalances").exchange(this.id);
  }
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    throw new pe("subAccountTransfer").exchange(this.id);
  }
  async fetchPositionsForSymbol(e, t = {}) {
    throw new pe("fetchPositionsForSymbol() is not supported yet").exchange(this.id);
  }
  async fetchPositions(e = void 0, t = {}) {
    throw new pe("fetchPositions").exchange(this.id);
  }
  async fetchPositionsRisk(e = void 0, t = {}) {
    throw new pe("fetchPositionsRisk").exchange(this.id);
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    throw new pe("fetchLedger").exchange(this.id);
  }
  async fetchLedgerEntry(e, t = void 0, i = {}) {
    throw new pe("fetchLedgerEntry").exchange(this.id);
  }
  parseBidAsk(e, t = 0, i = 1, s = 2) {
    const n = this.safeNumber(e, t), r = this.safeNumber(e, i), a = this.safeInteger(e, s), o = [n, r];
    return a !== void 0 && o.push(a), o;
  }
  safeCurrency(e, t = void 0) {
    if (e === void 0 && t !== void 0)
      return t;
    if (this.currencies_by_id !== void 0 && e in this.currencies_by_id && this.currencies_by_id[e] !== void 0)
      return this.currencies_by_id[e];
    let i = e;
    return e !== void 0 && (i = this.getCodeFromCurrencyId(e.toUpperCase())), {
      id: e,
      code: i,
      precision: void 0
    };
  }
  safeMarket(e, t = void 0, i = void 0, s = void 0) {
    const n = this.safeMarketStructure({
      symbol: e,
      marketId: e
    });
    if (e !== void 0) {
      if (this.markets_by_id !== void 0 && e in this.markets_by_id) {
        const r = this.markets_by_id[e];
        if (r.length === 1)
          return r[0];
        if (s === void 0) {
          if (t === void 0)
            throw new be().addMessage("safeMarket() requires a fourth argument for " + e + " to disambiguate between different markets with the same market id").exchange(this.id);
          s = t.type;
        }
        for (let o = 0; o < r.length; o++) {
          const c = r[o];
          if (c[s])
            return c;
        }
      } else if (i !== void 0 && i !== "") {
        const r = e.split(i);
        return r.length === 2 && (n.baseId = this.safeString(r, 0), n.quoteId = this.safeString(r, 1), n.base = this.safeCurrencyCode(n.baseId), n.quote = this.safeCurrencyCode(n.quoteId), n.symbol = n.base + "/" + n.quote), n;
      }
    }
    return t !== void 0 ? t : n;
  }
  checkRequiredCredentials(e = !0) {
    const t = Object.keys(this.requiredCredentials);
    if (this.token)
      return !0;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (this.requiredCredentials[s] && !this[s]) {
        if (s === "secret" && this.externalSigner)
          continue;
        if (e)
          throw new Pt().addMessage('It requires "' + s + '" credential').exchange(this.id);
        return !1;
      }
    }
    return !0;
  }
  oath() {
    if (this.twofa !== void 0)
      return Ug(this.twofa);
    throw new be().addMessage("exchange.twofa has not been set for 2FA Two-Factor Authentication").exchange(this.id);
  }
  async fetchBalance(e = {}) {
    throw new pe("fetchBalance").exchange(this.id);
  }
  parseBalance(e) {
    throw new pe("parseBalance").exchange(this.id);
  }
  async fetchPartialBalance(e, t = {}) {
    return (await this.fetchBalance(t))[e];
  }
  async fetchFreeBalance(e = {}) {
    return await this.fetchPartialBalance("free", e);
  }
  async fetchUsedBalance(e = {}) {
    return await this.fetchPartialBalance("used", e);
  }
  async fetchTotalBalance(e = {}) {
    return await this.fetchPartialBalance("total", e);
  }
  async fetchStatus(e = {}) {
    throw new pe("fetchStatus").exchange(this.id);
  }
  async fetchFundingFee(e, t = {}) {
    if (this.safeBool(this.options, "warnOnFetchFundingFee", !0))
      throw new pe("fetchFundingFee").addMessage("This method is deprecated").exchange(this.id);
    return await this.fetchTransactionFee(e, t);
  }
  async fetchFundingFees(e = void 0, t = {}) {
    if (this.safeBool(this.options, "warnOnFetchFundingFees", !0))
      throw new pe("fetchFundingFees").addMessage("This method is deprecated").exchange(this.id);
    return await this.fetchTransactionFees(e, t);
  }
  async fetchTransactionFee(e, t = {}) {
    if (!this.has.fetchTransactionFees)
      throw new pe("fetchTransactionFee").exchange(this.id);
    return await this.fetchTransactionFees([e], t);
  }
  async fetchTransactionFees(e = void 0, t = {}) {
    throw new pe("fetchTransactionFees").exchange(this.id);
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    throw new pe("fetchDepositWithdrawFees").exchange(this.id);
  }
  async fetchDepositWithdrawFee(e, t = {}) {
    if (!this.has.fetchDepositWithdrawFees)
      throw new pe("fetchDepositWithdrawFee").exchange(this.id);
    const i = await this.fetchDepositWithdrawFees([e], t);
    return this.safeValue(i, e);
  }
  getSupportedMapping(e, t = {}) {
    if (e in t)
      return t[e];
    throw new be().addMessage(e + " does not have a value in mapping").exchange(this.id);
  }
  handleOptionAndParams(e, t, i, s = void 0) {
    const n = "default" + this.capitalize(i);
    let r = this.safeValue2(e, i, n);
    if (r !== void 0)
      e = this.omit(e, [i, n]);
    else {
      const a = this.safeValue(this.options, t);
      a !== void 0 && (r = this.safeValue2(a, i, n)), r === void 0 && (r = this.safeValue2(this.options, i, n)), r = r !== void 0 ? r : s;
    }
    return [r, e];
  }
  handleOptionAndParams2(e, t, i, s, n = void 0) {
    const r = "default" + this.capitalize(s);
    let a = this.safeValue2(e, s, r);
    if (a !== void 0)
      e = this.omit(e, [s, r]);
    else {
      const o = this.safeValue2(this.options, t, i);
      o !== void 0 && (a = this.safeValue2(o, s, r)), a === void 0 && (a = this.safeValue2(this.options, s, r)), a = a !== void 0 ? a : n;
    }
    return [a, e];
  }
  handleOption(e, t, i = void 0) {
    const [s, n] = this.handleOptionAndParams({}, e, t, i);
    return s;
  }
  handleMarketTypeAndParams(e, t = void 0, i = {}) {
    const s = this.safeString2(this.options, "defaultType", "type", "spot"), n = this.safeDict(this.options, e);
    let r = s;
    n !== void 0 && (typeof n == "string" ? r = n : r = this.safeString2(n, "defaultType", "type", r));
    const a = t === void 0 ? r : t.type, o = this.safeString2(i, "defaultType", "type", a);
    return i = this.omit(i, ["defaultType", "type"]), [o, i];
  }
  handleSubTypeAndParams(e, t = void 0, i = {}, s = void 0) {
    let n;
    const r = this.safeString2(i, "subType", "defaultSubType");
    return r !== void 0 ? (n = r, i = this.omit(i, ["subType", "defaultSubType"])) : (t !== void 0 && (t.linear ? n = "linear" : t.inverse && (n = "inverse")), n === void 0 && (n = this.handleOptionAndParams({}, e, "subType", s)[0])), [n, i];
  }
  handleMarginModeAndParams(e, t = {}, i = void 0) {
    return this.handleOptionAndParams(t, e, "marginMode", i);
  }
  throwExactlyMatchedException(e, t, i) {
    if (t !== void 0 && t in e) {
      const s = new e[t]();
      throw s instanceof g && s.overwriteMessage(this.replaceErrorMessage(i)).addOriginalError(i), s.addOriginalError(i || t).exchange(this.id);
    }
  }
  throwBroadlyMatchedException(e, t, i) {
    const s = this.findBroadlyMatchedKey(e, t);
    if (s !== void 0) {
      const n = new e[s]();
      throw n instanceof g && n.overwriteMessage(this.replaceErrorMessage(i)), n.addOriginalError(i || t).exchange(this.id);
    }
  }
  replaceErrorMessage(e) {
    if (!this.exceptions.messages)
      return e;
    const t = this.findBroadlyMatchedKey(this.exceptions.messages, e);
    return t ? this.exceptions.messages[t] : e;
  }
  findBroadlyMatchedKey(e, t) {
    if (!t)
      return;
    const i = "%%", s = Object.keys(e);
    for (let n = 0; n < s.length; n++) {
      const r = s[n];
      if (r.includes(i) && r.split(i).every((o) => t.includes(o)) || t.indexOf(r) >= 0)
        return r;
    }
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
  }
  calculateRateLimiterCost(e, t, i, s, n = {}) {
    return this.safeValue(n, "cost", 1);
  }
  async fetchTicker(e, t = {}) {
    if (this.has.fetchTickers) {
      await this.loadMarkets(), e = this.market(e).symbol;
      const s = await this.fetchTickers([e], t), n = this.safeDict(s, e);
      if (n === void 0)
        throw new pt().addMessage("fetchTickers() could not find a ticker for " + e).exchange(this.id);
      return n;
    } else
      throw new pe("fetchTicker").exchange(this.id);
  }
  async fetchTickers(e = void 0, t = {}) {
    throw new pe("fetchTickers").exchange(this.id);
  }
  async fetchOrderBooks(e = void 0, t = void 0, i = {}) {
    throw new pe("fetchOrderBooks").exchange(this.id);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    throw new pe("fetchOrder").exchange(this.id);
  }
  async fetchOrderStatus(e, t = void 0, i = {}) {
    return (await this.fetchOrder(e, t, i)).status;
  }
  async fetchUnifiedOrder(e, t = {}) {
    return await this.fetchOrder(this.safeString(e, "id"), this.safeString(e, "symbol"), t);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    throw new pe("createOrder").exchange(this.id);
  }
  async createTrailingAmountOrder(e, t, i, s, n = void 0, r = void 0, a = void 0, o = {}) {
    if (r === void 0)
      throw new g("createTrailingAmountOrder() requires a trailingAmount argument").exchange(this.id);
    if (o.trailingAmount = r, a !== void 0 && (o.trailingTriggerPrice = a), this.has.createTrailingAmountOrder)
      return await this.createOrder(e, t, i, s, n, o);
    throw new pe("createTrailingAmountOrder").exchange(this.id);
  }
  async createTrailingPercentOrder(e, t, i, s, n = void 0, r = void 0, a = void 0, o = {}) {
    if (r === void 0)
      throw new g("createTrailingPercentOrder() requires a trailingPercent argument").exchange(this.id);
    if (o.trailingPercent = r, a !== void 0 && (o.trailingTriggerPrice = a), this.has.createTrailingPercentOrder)
      return await this.createOrder(e, t, i, s, n, o);
    throw new pe("createTrailingPercentOrder").exchange(this.id);
  }
  async createMarketOrderWithCost(e, t, i, s = {}) {
    if (this.has.createMarketOrderWithCost || this.has.createMarketBuyOrderWithCost && this.has.createMarketSellOrderWithCost)
      return await this.createOrder(e, "market", t, i, 1, s);
    throw new pe("createMarketOrderWithCost").exchange(this.id);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    if (this.options.createMarketBuyOrderRequiresPrice || this.has.createMarketBuyOrderWithCost)
      return await this.createOrder(e, "market", "buy", t, 1, i);
    throw new pe("createMarketBuyOrderWithCost").exchange(this.id);
  }
  async createMarketSellOrderWithCost(e, t, i = {}) {
    if (this.options.createMarketSellOrderRequiresPrice || this.has.createMarketSellOrderWithCost)
      return await this.createOrder(e, "market", "sell", t, 1, i);
    throw new pe("createMarketSellOrderWithCost").exchange(this.id);
  }
  async createTriggerOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    if (r === void 0)
      throw new g("createTriggerOrder() requires a triggerPrice argument").exchange(this.id);
    if (a.triggerPrice = r, this.has.createTriggerOrder)
      return await this.createOrder(e, t, i, s, n, a);
    throw new pe("createTriggerOrder").exchange(this.id);
  }
  async createStopLossOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    if (r === void 0)
      throw new g("createStopLossOrder() requires a stopLossPrice argument").exchange(this.id);
    if (a.stopLossPrice = r, this.has.createStopLossOrder)
      return await this.createOrder(e, t, i, s, n, a);
    throw new pe("createStopLossOrder").exchange(this.id);
  }
  async createTakeProfitOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    if (r === void 0)
      throw new g("createTakeProfitOrder() requires a takeProfitPrice argument").exchange(this.id);
    if (a.takeProfitPrice = r, this.has.createTakeProfitOrder)
      return await this.createOrder(e, t, i, s, n, a);
    throw new pe("createTakeProfitOrder").exchange(this.id);
  }
  async createOrderWithTakeProfitAndStopLoss(e, t, i, s, n = void 0, r = void 0, a = void 0, o = {}) {
    if (r === void 0 && a === void 0)
      throw new g("createOrderWithTakeProfitAndStopLoss() requires either a takeProfit or stopLoss argument").exchange(this.id);
    r !== void 0 && (o.takeProfit = {
      triggerPrice: r
    }), a !== void 0 && (o.stopLoss = {
      triggerPrice: a
    });
    const c = this.safeString(o, "takeProfitType"), u = this.safeString(o, "takeProfitPriceType"), f = this.safeString(o, "takeProfitLimitPrice"), h = this.safeString(o, "takeProfitAmount"), l = this.safeString(o, "stopLossType"), p = this.safeString(o, "stopLossPriceType"), m = this.safeString(o, "stopLossLimitPrice"), y = this.safeString(o, "stopLossAmount");
    if (c !== void 0 && (o.takeProfit.type = c), u !== void 0 && (o.takeProfit.priceType = u), f !== void 0 && (o.takeProfit.price = this.parseToNumeric(f)), h !== void 0 && (o.takeProfit.amount = this.parseToNumeric(h)), l !== void 0 && (o.stopLoss.type = l), p !== void 0 && (o.stopLoss.priceType = p), m !== void 0 && (o.stopLoss.price = this.parseToNumeric(m)), y !== void 0 && (o.stopLoss.amount = this.parseToNumeric(y)), o = this.omit(o, ["takeProfitType", "takeProfitPriceType", "takeProfitLimitPrice", "takeProfitAmount", "stopLossType", "stopLossPriceType", "stopLossLimitPrice", "stopLossAmount"]), this.has.createOrderWithTakeProfitAndStopLoss)
      return await this.createOrder(e, t, i, s, n, o);
    throw new pe("createOrderWithTakeProfitAndStopLoss").exchange(this.id);
  }
  async createOrders(e, t = {}) {
    throw new pe("createOrders").exchange(this.id);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    throw new pe("cancelOrder").exchange(this.id);
  }
  async cancelAllOrders(e = void 0, t = {}) {
    throw new pe("cancelAllOrders").exchange(this.id);
  }
  async cancelUnifiedOrder(e, t = {}) {
    return this.cancelOrder(this.safeString(e, "id"), this.safeString(e, "symbol"), t);
  }
  async fetchOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    throw this.has.fetchOpenOrders && this.has.fetchClosedOrders ? new pe("fetchOrders").addMessage("Consider using fetchOpenOrders() and fetchClosedOrders() instead").exchange(this.id) : new pe("fetchOrders").exchange(this.id);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    throw new pe("fetchOrderTrades").exchange(this.id);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    if (this.has.fetchOrders) {
      const n = await this.fetchOrders(e, t, i, s);
      return this.filterBy(n, "status", "open");
    }
    throw new pe("fetchOpenOrders").exchange(this.id);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    if (this.has.fetchOrders) {
      const n = await this.fetchOrders(e, t, i, s);
      return this.filterBy(n, "status", "closed");
    }
    throw new pe("fetchClosedOrders").exchange(this.id);
  }
  async fetchCanceledAndClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    throw new pe("fetchCanceledAndClosedOrders").exchange(this.id);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    throw new pe("fetchMyTrades").exchange(this.id);
  }
  async fetchDepositsWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    throw new pe("fetchDepositsWithdrawals").exchange(this.id);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    throw new pe("fetchDeposits").exchange(this.id);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    throw new pe("fetchWithdrawals").exchange(this.id);
  }
  parseLastPrice(e, t = void 0) {
    throw new pe("parseLastPrice").exchange(this.id);
  }
  async fetchDepositAddress(e, t = {}) {
    if (this.has.fetchDepositAddresses) {
      const i = await this.fetchDepositAddresses([e], t), s = this.safeValue(i, e);
      if (s === void 0)
        throw new It(e).addMessage("Make sure you have created a corresponding deposit address in your wallet on the exchange website").exchange(this.id);
      return s;
    } else
      throw new pe("fetchDepositAddress").exchange(this.id);
  }
  account() {
    return {
      free: void 0,
      used: void 0,
      total: void 0
    };
  }
  getCodeFromCurrencyId(e) {
    if (!this.tokensMapping || !Array.isArray(this.tokensMapping))
      return e;
    const t = this.tokensMapping.find((i) => i.currencyId === e);
    return (t == null ? void 0 : t.code) || e;
  }
  currency(e) {
    if (this.currencies === void 0)
      throw new be().addMessage("Currencies not loaded").exchange(this.id);
    if (typeof e == "string") {
      if (e in this.currencies)
        return this.currencies[e];
      if (e in this.currencies_by_id)
        return this.currencies_by_id[e];
    }
    throw new $e(e).exchange(this.id);
  }
  market(e) {
    if (this.markets === void 0)
      throw new bs().exchange(this.id);
    if (e in this.markets)
      return this.markets[e];
    if (e in this.markets_by_id) {
      const t = this.markets_by_id[e], i = this.safeString2(this.options, "defaultType", "defaultSubType", "spot");
      for (let s = 0; s < t.length; s++) {
        const n = t[s];
        if (n[i])
          return n;
      }
      return t[0];
    } else if (e.endsWith("-C") || e.endsWith("-P") || e.startsWith("C-") || e.startsWith("P-"))
      return this.createExpiredOptionMarket(e);
    throw new it(e).exchange(this.id);
  }
  createExpiredOptionMarket(e) {
    throw new pe("createExpiredOptionMarket").exchange(this.id);
  }
  handleWithdrawTagAndParams(e, t) {
    return e !== void 0 && typeof e == "object" && (t = this.extend(e, t), e = void 0), e === void 0 && (e = this.safeString(t, "tag"), e !== void 0 && (t = this.omit(t, "tag"))), [e, t];
  }
  async createLimitOrder(e, t, i, s, n = {}) {
    return await this.createOrder(e, "limit", t, i, s, n);
  }
  async createMarketOrder(e, t, i, s = void 0, n = {}) {
    return await this.createOrder(e, "market", t, i, s, n);
  }
  async createLimitBuyOrder(e, t, i, s = {}) {
    return await this.createOrder(e, "limit", "buy", t, i, s);
  }
  async createLimitSellOrder(e, t, i, s = {}) {
    return await this.createOrder(e, "limit", "sell", t, i, s);
  }
  async createMarketBuyOrder(e, t, i = {}) {
    return await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createMarketSellOrder(e, t, i = {}) {
    return await this.createOrder(e, "market", "sell", t, void 0, i);
  }
  costToPrecision(e, t) {
    const i = this.market(e);
    return this.decimalToPrecision(t, zr, i.precision.price, this.precisionMode, this.paddingMode);
  }
  priceToPrecision(e, t) {
    const i = this.market(e), s = this.decimalToPrecision(t, pd, i.precision.price, this.precisionMode, this.paddingMode);
    if (s === "0")
      throw new g("Price of " + i.symbol + " must be greater than minimum price precision of " + this.numberToString(i.precision.price)).exchange(this.id);
    return s;
  }
  amountToPrecision(e, t) {
    const i = this.market(e), s = this.decimalToPrecision(t, zr, i.precision.amount, this.precisionMode, this.paddingMode);
    if (s === "0")
      throw new g("Amount of " + i.symbol + " must be greater than minimum amount precision of " + this.numberToString(i.precision.amount)).exchange(this.id);
    return s;
  }
  feeToPrecision(e, t) {
    const i = this.market(e);
    return this.decimalToPrecision(t, pd, i.precision.price, this.precisionMode, this.paddingMode);
  }
  currencyToPrecision(e, t, i = void 0, s = !1) {
    const n = this.currencies[e];
    let r = this.safeValue(n, "precision");
    if (i !== void 0) {
      const a = this.safeDict(n, "networks", {}), o = this.safeDict(a, i, {});
      r = this.safeValue(o, "precision", r);
    }
    return r === void 0 ? this.forceString(t) : this.decimalToPrecision(t, zr, r, this.precisionMode, this.paddingMode, s);
  }
  forceString(e) {
    return typeof e != "string" ? this.numberToString(e) : e;
  }
  isTickPrecision() {
    return this.precisionMode === gd;
  }
  isDecimalPrecision() {
    return this.precisionMode === Hr;
  }
  isSignificantPrecision() {
    return this.precisionMode === xm;
  }
  safeNumber(e, t, i = void 0) {
    const s = this.safeString(e, t);
    return this.parseNumber(s, i);
  }
  safeNumberN(e, t, i = void 0) {
    const s = this.safeStringN(e, t);
    return this.parseNumber(s, i);
  }
  parsePrecision(e) {
    if (e === void 0)
      return;
    const t = parseInt(e);
    if (t === 0)
      return "1";
    let i = "0.";
    for (let s = 0; s < t - 1; s++)
      i = i + "0";
    return i + "1";
  }
  async loadTimeDifference(e = {}) {
    var n;
    const t = (n = await this.cache.get(hd(this.id), { local: !0 })) == null ? void 0 : n.data;
    if (t !== void 0)
      return this.options.timeDifference = t, t;
    const i = await this.fetchTime(e), s = this.milliseconds();
    return this.options.timeDifference = s - i, this.cache.set({
      key: hd(this.id),
      data: this.options.timeDifference,
      ttl: 1 / 0,
      local: !0
    }), this.options.timeDifference;
  }
  implodeHostname(e) {
    return this.implodeParams(e, { hostname: this.hostname });
  }
  safeCurrencyCode(e, t = void 0) {
    return t = this.safeCurrency(e, t), t.code;
  }
  filterBySymbolSinceLimit(e, t = void 0, i = void 0, s = void 0, n = !1) {
    return this.filterByValueSinceLimit(e, "symbol", t, i, s, "timestamp", n);
  }
  filterByCurrencySinceLimit(e, t = void 0, i = void 0, s = void 0, n = !1) {
    return this.filterByValueSinceLimit(e, "currency", t, i, s, "timestamp", n);
  }
  filterBySymbolsSinceLimit(e, t = void 0, i = void 0, s = void 0, n = !1) {
    const r = this.filterByArray(e, "symbol", t, !1);
    return this.filterBySinceLimit(r, i, s, "timestamp", n);
  }
  parseTickers(e, t = void 0, i = {}) {
    const s = [];
    if (Array.isArray(e))
      for (let n = 0; n < e.length; n++) {
        const r = this.extend(this.parseTicker(e[n]), i);
        s.push(r);
      }
    else {
      const n = Object.keys(e);
      for (let r = 0; r < n.length; r++) {
        const a = n[r], o = this.safeMarket(a), c = this.extend(this.parseTicker(e[a], o), i);
        s.push(c);
      }
    }
    return t = this.marketSymbols(t), this.filterByArray(s, "symbol", t);
  }
  parseDepositAddresses(e, t = void 0, i = !0, s = {}) {
    let n = [];
    for (let r = 0; r < e.length; r++) {
      const a = this.extend(this.parseDepositAddress(e[r]), s);
      n.push(a);
    }
    return t !== void 0 && (n = this.filterByArray(n, "currency", t, !1)), i ? this.indexBy(n, "currency") : n;
  }
  safeSymbol(e, t = void 0, i = void 0, s = void 0) {
    return t = this.safeMarket(e, t, i, s), t.symbol;
  }
  isTriggerOrder(e) {
    const t = this.safeBool2(e, "trigger", "stop");
    return t && (e = this.omit(e, ["trigger", "stop"])), [t, e];
  }
  isPostOnly(e, t, i = {}) {
    const s = this.safeStringUpper(i, "timeInForce");
    let n = this.safeBool2(i, "postOnly", "post_only", !1);
    const r = s === "IOC", a = s === "FOK";
    if (n = n || s === "PO" || t, n) {
      if (r || a)
        throw new g("postOnly orders cannot have timeInForce equal to " + s).exchange(this.id);
      if (e)
        throw new g("market orders cannot be postOnly").exchange(this.id);
      return !0;
    } else
      return !1;
  }
  handlePostOnly(e, t, i = {}) {
    const s = this.safeStringUpper(i, "timeInForce");
    let n = this.safeBool(i, "postOnly", !1);
    const r = s === "IOC", a = s === "FOK", o = s === "PO";
    if (n = n || o || t, n) {
      if (r || a)
        throw new g("postOnly orders cannot have timeInForce equal to " + s).exchange(this.id);
      if (e)
        throw new g("market orders cannot be postOnly").exchange(this.id);
      return o && (i = this.omit(i, "timeInForce")), i = this.omit(i, "postOnly"), [!0, i];
    }
    return [!1, i];
  }
  async fetchTradingFees(e = {}) {
    throw new pe("fetchTradingFees").exchange(this.id);
  }
  async fetchTradingFee(e, t = {}) {
    if (!this.has.fetchTradingFees)
      throw new pe("fetchTradingFee").exchange(this.id);
    return await this.fetchTradingFees(t);
  }
  handleTimeInForce(e = {}) {
    const t = this.safeStringUpper(e, "timeInForce");
    if (t !== void 0) {
      const i = this.safeString(this.options.timeInForce, t);
      if (i === void 0)
        throw new g('It does not support timeInForce "' + t + '"').exchange(this.id);
      return i;
    }
  }
  convertTypeToAccount(e) {
    const t = this.safeDict(this.options, "accountsByType", {}), i = e.toLowerCase();
    return i in t ? t[i] : e in this.markets || e in this.markets_by_id ? this.market(e).id : e;
  }
  checkRequiredArgument(e, t, i, s = []) {
    const n = s.length;
    if (t === void 0 || n > 0 && !this.inArray(t, s)) {
      const r = s.join(", ");
      let a = this.id + " " + e + "() requires a " + i + " argument";
      throw r !== "" && (a += ", one of (" + r + ")"), new g(a).exchange(this.id);
    }
  }
  parseDepositWithdrawFees(e, t = void 0, i = void 0) {
    const s = {};
    t = this.marketCodes(t);
    const n = Array.isArray(e);
    let r = e;
    n || (r = Object.keys(e));
    for (let a = 0; a < r.length; a++) {
      const o = r[a], c = n ? o : e[o], u = n ? this.safeString(c, i) : o, f = this.safeValue(this.currencies_by_id, u), h = this.safeString(f, "code", u);
      (t === void 0 || this.inArray(h, t)) && (s[h] = this.parseDepositWithdrawFee(c, f));
    }
    return s;
  }
  parseDepositWithdrawFee(e, t = void 0) {
    throw new pe("parseDepositWithdrawFee").exchange(this.id);
  }
  depositWithdrawFee(e) {
    return {
      info: e,
      withdraw: {
        fee: void 0,
        percentage: void 0
      },
      deposit: {
        fee: void 0,
        percentage: void 0
      },
      networks: {}
    };
  }
  assignDefaultDepositWithdrawFees(e, t = void 0) {
    const i = Object.keys(e.networks), s = i.length;
    if (s === 1)
      return e.withdraw = e.networks[i[0]].withdraw, e.deposit = e.networks[i[0]].deposit, e;
    const n = this.safeString(t, "code");
    for (let r = 0; r < s; r++)
      i[r] === n && (e.withdraw = e.networks[i[r]].withdraw, e.deposit = e.networks[i[r]].deposit);
    return e;
  }
  getMarketFromSymbols(e = void 0) {
    if (e === void 0)
      return;
    const t = this.safeString(e, 0);
    return this.market(t);
  }
  async fetchTransactions(e = void 0, t = void 0, i = void 0, s = {}) {
    if (this.has.fetchDepositsWithdrawals)
      return await this.fetchDepositsWithdrawals(e, t, i, s);
    throw new pe("fetchTransactions").exchange(this.id);
  }
  filterByArrayPositions(e, t, i = void 0, s = !0) {
    return this.filterByArray(e, t, i, s);
  }
  filterByArrayTickers(e, t, i = void 0, s = !0) {
    return this.filterByArray(e, t, i, s);
  }
  handleMaxEntriesPerRequestAndParams(e, t = void 0, i = {}) {
    let s;
    return [s, i] = this.handleOptionAndParams(i, e, "maxEntriesPerRequest"), s !== void 0 && s !== t && (t = s), t === void 0 && (t = 1e3), [t, i];
  }
  async fetchPaginatedCallDynamic(e, t = void 0, i = void 0, s = void 0, n = {}, r = void 0) {
    let a;
    [a, n] = this.handleOptionAndParams(n, e, "paginationCalls", 10);
    let o;
    [o, n] = this.handleOptionAndParams(n, e, "maxRetries", 3);
    let c;
    [c, n] = this.handleOptionAndParams(n, e, "paginationDirection", "backward");
    let u, f = 0, h = [], l = 0;
    const p = this.safeInteger2(n, "untill", "till");
    if ([r, n] = this.handleMaxEntriesPerRequestAndParams(e, r, n), c === "forward") {
      if (i === void 0)
        throw new g("Pagination requires a since argument when paginationDirection set to forward").exchange(this.id);
      u = i;
    }
    for (; f < a; ) {
      f += 1;
      try {
        if (c === "backward") {
          u !== void 0 && (n.until = u - 1);
          const w = await this[e](t, void 0, r, n), S = w.length;
          if (this.verbose) {
            const T = "Dynamic pagination call " + f + " method " + e + " response length " + S + " timestamp " + u;
            this.log(T);
          }
          if (S === 0)
            break;
          l = 0, h = this.arrayConcat(h, w);
          const b = this.safeValue(w, 0);
          if (u = this.safeInteger2(b, "timestamp", 0), i !== void 0 && u <= i)
            break;
        } else {
          const w = await this[e](t, u, r, n), S = w.length;
          if (this.verbose) {
            const T = "Dynamic pagination call " + f + " method " + e + " response length " + S + " timestamp " + u;
            this.log(T);
          }
          if (S === 0)
            break;
          l = 0, h = this.arrayConcat(h, w);
          const b = this.safeValue(w, S - 1);
          if (u = this.safeInteger(b, "timestamp") - 1, p !== void 0 && u >= p)
            break;
        }
      } catch (w) {
        if (l += 1, l > o)
          throw w;
      }
    }
    const m = this.removeRepeatedElementsFromArray(h), y = e === "fetchOHLCV" ? 0 : "timestamp";
    return this.filterBySinceLimit(m, i, s, y);
  }
  async safeDeterministicCall(e, t = void 0, i = void 0, s = void 0, n = void 0, r = {}) {
    let a;
    [a, r] = this.handleOptionAndParams(r, e, "maxRetries", 3);
    let o = 0;
    try {
      return n ? await this[e](t, n, i, s, r) : await this[e](t, i, s, r);
    } catch (c) {
      if (c instanceof Ae || (o += 1, o > a))
        throw c;
    }
  }
  async fetchPaginatedCallDeterministic(e, t = void 0, i = void 0, s = void 0, n = void 0, r = {}, a = void 0) {
    let o;
    [o, r] = this.handleOptionAndParams(r, e, "paginationCalls", 10), [a, r] = this.handleMaxEntriesPerRequestAndParams(e, a, r);
    const c = this.milliseconds(), u = [], h = this.parseTimeframe(n) * 1e3 * a;
    let l = c - o * h - 1;
    i !== void 0 && (l = Math.max(l, i));
    const p = this.safeInteger2(r, "until", "till");
    if (p !== void 0) {
      const b = Math.ceil((p - i) / h);
      if (b > o)
        throw new g("The number of required calls is greater than the max number of calls allowed, either increase the paginationCalls or decrease the since-until gap. Current paginationCalls limit is " + o.toString() + " required calls is " + b.toString()).exchange(this.id);
    }
    for (let b = 0; b < o && !(p !== void 0 && l >= p); b++)
      u.push(this.safeDeterministicCall(e, t, l, a, n, r)), l = this.sum(l, h) - 1;
    const m = await Promise.all(u);
    let y = [];
    for (let b = 0; b < m.length; b++)
      y = this.arrayConcat(y, m[b]);
    const w = this.removeRepeatedElementsFromArray(y), S = e === "fetchOHLCV" ? 0 : "timestamp";
    return this.filterBySinceLimit(w, i, s, S);
  }
  async fetchPaginatedCallCursor(e, t = void 0, i = void 0, s = void 0, n = {}, r = void 0, a = void 0, o = void 0, c = void 0) {
    let u;
    [u, n] = this.handleOptionAndParams(n, e, "paginationCalls", 10);
    let f;
    [f, n] = this.handleOptionAndParams(n, e, "maxRetries", 3), [c, n] = this.handleMaxEntriesPerRequestAndParams(e, c, n);
    let h, l = 0, p = 0, m = [];
    for (; l < u; ) {
      try {
        h !== void 0 && (o !== void 0 && (h = this.parseToInt(h) + o), n[a] = h);
        let S;
        e === "fetchAccounts" ? S = await this[e](n) : S = await this[e](t, i, c, n), p = 0;
        const b = S.length;
        if (this.verbose) {
          const _ = "Cursor pagination call " + (l + 1).toString() + " method " + e + " response length " + b.toString() + " cursor " + h;
          this.log(_);
        }
        if (b === 0)
          break;
        m = this.arrayConcat(m, S);
        const T = this.safeValue(S, b - 1);
        if (h = this.safeValue(T.info, r), h === void 0)
          break;
        const x = this.safeInteger(T, "timestamp");
        if (x !== void 0 && x < i)
          break;
      } catch (S) {
        if (p += 1, p > f)
          throw S;
      }
      l += 1;
    }
    const y = this.sortCursorPaginatedResult(m), w = e === "fetchOHLCV" ? 0 : "timestamp";
    return this.filterBySinceLimit(y, i, s, w);
  }
  async fetchPaginatedCallIncremental(e, t = void 0, i = void 0, s = void 0, n = {}, r = void 0, a = void 0) {
    let o;
    [o, n] = this.handleOptionAndParams(n, e, "paginationCalls", 10);
    let c;
    [c, n] = this.handleOptionAndParams(n, e, "maxRetries", 3), [a, n] = this.handleMaxEntriesPerRequestAndParams(e, a, n);
    let u = 0, f = 0, h = [];
    for (; u < o; ) {
      try {
        n[r] = u + 1;
        const m = await this[e](t, i, a, n);
        f = 0;
        const y = m.length;
        if (this.verbose) {
          const S = "Incremental pagination call " + (u + 1).toString() + " method " + e + " response length " + y.toString();
          this.log(S);
        }
        if (y === 0)
          break;
        h = this.arrayConcat(h, m);
      } catch (m) {
        if (f += 1, f > c)
          throw m;
      }
      u += 1;
    }
    const l = this.sortCursorPaginatedResult(h), p = e === "fetchOHLCV" ? 0 : "timestamp";
    return this.filterBySinceLimit(l, i, s, p);
  }
  sortCursorPaginatedResult(e) {
    const t = this.safeValue(e, 0);
    if (t !== void 0) {
      if ("timestamp" in t)
        return this.sortBy(e, "timestamp", !0);
      if ("id" in t)
        return this.sortBy(e, "id", !0);
    }
    return e;
  }
  removeRepeatedElementsFromArray(e) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], a = this.safeString(r, "id");
      if (a !== void 0)
        this.safeString(t, a) === void 0 && (t[a] = r);
      else {
        const o = this.safeInteger2(r, "timestamp", 0);
        o !== void 0 && this.safeString(t, o) === void 0 && (t[o] = r);
      }
    }
    const i = Object.values(t);
    return i.length > 0 ? i : e;
  }
  handleUntilOption(e, t, i, s = 1) {
    const n = this.safeInteger2(i, "until", "till");
    return n !== void 0 && (t[e] = this.parseToInt(n * s), i = this.omit(i, ["until", "till"])), [t, i];
  }
}, vm = class extends gt {
};
function $n(d) {
  return pi.encode(Ri.decode(d));
}
function md(d) {
  return Ri.encode(pi.decode(d));
}
let ss;
const km = {
  decode(d) {
    let e;
    if (ss === void 0) {
      let n = "0123456789ABCDEF";
      const r = ` \f
\r	 \u2028\u2029`;
      for (ss = {}, e = 0; e < 16; ++e)
        ss[n.charAt(e)] = e;
      for (n = n.toLowerCase(), e = 10; e < 16; ++e)
        ss[n.charAt(e)] = e;
      for (e = 0; e < r.length; ++e)
        ss[r.charAt(e)] = -1;
    }
    const t = [];
    let i = 0, s = 0;
    for (e = 0; e < d.length; ++e) {
      let n = d.charAt(e);
      if (n == "=")
        break;
      if (n = ss[n], n != -1) {
        if (n === void 0)
          throw new Error("Illegal character at offset " + e);
        i |= n, ++s >= 2 ? (t[t.length] = i, i = 0, s = 0) : i <<= 4;
      }
    }
    if (s)
      throw new Error("Hex encoding incomplete: 4 bits missing");
    return t;
  }
}, Em = "0123456789abcdefghijklmnopqrstuvwxyz";
function yd(d) {
  return Em.charAt(d);
}
function Nm(d, e) {
  return d & e;
}
function In(d, e) {
  return d | e;
}
function wd(d, e) {
  return d ^ e;
}
function bd(d, e) {
  return d & ~e;
}
function Pm(d) {
  if (d == 0)
    return -1;
  let e = 0;
  return d & 65535 || (d >>= 16, e += 16), d & 255 || (d >>= 8, e += 8), d & 15 || (d >>= 4, e += 4), d & 3 || (d >>= 2, e += 2), d & 1 || ++e, e;
}
function _m(d) {
  let e = 0;
  for (; d != 0; )
    d &= d - 1, ++e;
  return e;
}
let xi;
const Lm = 244837814094590, Sd = (Lm & 16777215) == 15715070, yt = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997], Dm = (1 << 26) / yt[yt.length - 1];
class we {
  constructor(e, t, i) {
    e != null && (typeof e == "number" ? this.fromNumber(e, t, i) : t == null && typeof e != "string" ? this.fromString(e, 256) : this.fromString(e, t));
  }
  //#region PUBLIC
  // BigInteger.prototype.toString = bnToString;
  // (public) return string representation in given radix
  toString(e) {
    if (this.s < 0)
      return "-" + this.negate().toString(e);
    let t;
    if (e == 16)
      t = 4;
    else if (e == 8)
      t = 3;
    else if (e == 2)
      t = 1;
    else if (e == 32)
      t = 5;
    else if (e == 4)
      t = 2;
    else
      return this.toRadix(e);
    const i = (1 << t) - 1;
    let s, n = !1, r = "", a = this.t, o = this.DB - a * this.DB % t;
    if (a-- > 0)
      for (o < this.DB && (s = this[a] >> o) > 0 && (n = !0, r = yd(s)); a >= 0; )
        o < t ? (s = (this[a] & (1 << o) - 1) << t - o, s |= this[--a] >> (o += this.DB - t)) : (s = this[a] >> (o -= t) & i, o <= 0 && (o += this.DB, --a)), s > 0 && (n = !0), n && (r += yd(s));
    return n ? r : "0";
  }
  // BigInteger.prototype.negate = bnNegate;
  // (public) -this
  negate() {
    const e = xe();
    return we.ZERO.subTo(this, e), e;
  }
  // BigInteger.prototype.abs = bnAbs;
  // (public) |this|
  abs() {
    return this.s < 0 ? this.negate() : this;
  }
  // BigInteger.prototype.compareTo = bnCompareTo;
  // (public) return + if this > a, - if this < a, 0 if equal
  compareTo(e) {
    let t = this.s - e.s;
    if (t != 0)
      return t;
    let i = this.t;
    if (t = i - e.t, t != 0)
      return this.s < 0 ? -t : t;
    for (; --i >= 0; )
      if ((t = this[i] - e[i]) != 0)
        return t;
    return 0;
  }
  // BigInteger.prototype.bitLength = bnBitLength;
  // (public) return the number of bits in "this"
  bitLength() {
    return this.t <= 0 ? 0 : this.DB * (this.t - 1) + On(this[this.t - 1] ^ this.s & this.DM);
  }
  // BigInteger.prototype.mod = bnMod;
  // (public) this mod a
  mod(e) {
    const t = xe();
    return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(we.ZERO) > 0 && e.subTo(t, t), t;
  }
  // BigInteger.prototype.modPowInt = bnModPowInt;
  // (public) this^e % m, 0 <= e < 2^32
  modPowInt(e, t) {
    let i;
    return e < 256 || t.isEven() ? i = new Td(t) : i = new Ad(t), this.exp(e, i);
  }
  // BigInteger.prototype.clone = bnClone;
  // (public)
  clone() {
    const e = xe();
    return this.copyTo(e), e;
  }
  // BigInteger.prototype.intValue = bnIntValue;
  // (public) return value as integer
  intValue() {
    if (this.s < 0) {
      if (this.t == 1)
        return this[0] - this.DV;
      if (this.t == 0)
        return -1;
    } else {
      if (this.t == 1)
        return this[0];
      if (this.t == 0)
        return 0;
    }
    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
  }
  // BigInteger.prototype.byteValue = bnByteValue;
  // (public) return value as byte
  byteValue() {
    return this.t == 0 ? this.s : this[0] << 24 >> 24;
  }
  // BigInteger.prototype.shortValue = bnShortValue;
  // (public) return value as short (assumes DB>=16)
  shortValue() {
    return this.t == 0 ? this.s : this[0] << 16 >> 16;
  }
  // BigInteger.prototype.signum = bnSigNum;
  // (public) 0 if this == 0, 1 if this > 0
  signum() {
    return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this[0] <= 0 ? 0 : 1;
  }
  // BigInteger.prototype.toByteArray = bnToByteArray;
  // (public) convert to bigendian byte array
  toByteArray() {
    let e = this.t;
    const t = [];
    t[0] = this.s;
    let i = this.DB - e * this.DB % 8, s, n = 0;
    if (e-- > 0)
      for (i < this.DB && (s = this[e] >> i) != (this.s & this.DM) >> i && (t[n++] = s | this.s << this.DB - i); e >= 0; )
        i < 8 ? (s = (this[e] & (1 << i) - 1) << 8 - i, s |= this[--e] >> (i += this.DB - 8)) : (s = this[e] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --e)), s & 128 && (s |= -256), n == 0 && (this.s & 128) != (s & 128) && ++n, (n > 0 || s != this.s) && (t[n++] = s);
    return t;
  }
  // BigInteger.prototype.equals = bnEquals;
  equals(e) {
    return this.compareTo(e) == 0;
  }
  // BigInteger.prototype.min = bnMin;
  min(e) {
    return this.compareTo(e) < 0 ? this : e;
  }
  // BigInteger.prototype.max = bnMax;
  max(e) {
    return this.compareTo(e) > 0 ? this : e;
  }
  // BigInteger.prototype.and = bnAnd;
  and(e) {
    const t = xe();
    return this.bitwiseTo(e, Nm, t), t;
  }
  // BigInteger.prototype.or = bnOr;
  or(e) {
    const t = xe();
    return this.bitwiseTo(e, In, t), t;
  }
  // BigInteger.prototype.xor = bnXor;
  xor(e) {
    const t = xe();
    return this.bitwiseTo(e, wd, t), t;
  }
  // BigInteger.prototype.andNot = bnAndNot;
  andNot(e) {
    const t = xe();
    return this.bitwiseTo(e, bd, t), t;
  }
  // BigInteger.prototype.not = bnNot;
  // (public) ~this
  not() {
    const e = xe();
    for (let t = 0; t < this.t; ++t)
      e[t] = this.DM & ~this[t];
    return e.t = this.t, e.s = ~this.s, e;
  }
  // BigInteger.prototype.shiftLeft = bnShiftLeft;
  // (public) this << n
  shiftLeft(e) {
    const t = xe();
    return e < 0 ? this.rShiftTo(-e, t) : this.lShiftTo(e, t), t;
  }
  // BigInteger.prototype.shiftRight = bnShiftRight;
  // (public) this >> n
  shiftRight(e) {
    const t = xe();
    return e < 0 ? this.lShiftTo(-e, t) : this.rShiftTo(e, t), t;
  }
  // BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
  // (public) returns index of lowest 1-bit (or -1 if none)
  getLowestSetBit() {
    for (let e = 0; e < this.t; ++e)
      if (this[e] != 0)
        return e * this.DB + Pm(this[e]);
    return this.s < 0 ? this.t * this.DB : -1;
  }
  // BigInteger.prototype.bitCount = bnBitCount;
  // (public) return number of set bits
  bitCount() {
    let e = 0;
    const t = this.s & this.DM;
    for (let i = 0; i < this.t; ++i)
      e += _m(this[i] ^ t);
    return e;
  }
  // BigInteger.prototype.testBit = bnTestBit;
  // (public) true iff nth bit is set
  testBit(e) {
    const t = Math.floor(e / this.DB);
    return t >= this.t ? this.s != 0 : (this[t] & 1 << e % this.DB) != 0;
  }
  // BigInteger.prototype.setBit = bnSetBit;
  // (public) this | (1<<n)
  setBit(e) {
    return this.changeBit(e, In);
  }
  // BigInteger.prototype.clearBit = bnClearBit;
  // (public) this & ~(1<<n)
  clearBit(e) {
    return this.changeBit(e, bd);
  }
  // BigInteger.prototype.flipBit = bnFlipBit;
  // (public) this ^ (1<<n)
  flipBit(e) {
    return this.changeBit(e, wd);
  }
  // BigInteger.prototype.add = bnAdd;
  // (public) this + a
  add(e) {
    const t = xe();
    return this.addTo(e, t), t;
  }
  // BigInteger.prototype.subtract = bnSubtract;
  // (public) this - a
  subtract(e) {
    const t = xe();
    return this.subTo(e, t), t;
  }
  // BigInteger.prototype.multiply = bnMultiply;
  // (public) this * a
  multiply(e) {
    const t = xe();
    return this.multiplyTo(e, t), t;
  }
  // BigInteger.prototype.divide = bnDivide;
  // (public) this / a
  divide(e) {
    const t = xe();
    return this.divRemTo(e, t, null), t;
  }
  // BigInteger.prototype.remainder = bnRemainder;
  // (public) this % a
  remainder(e) {
    const t = xe();
    return this.divRemTo(e, null, t), t;
  }
  // BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
  // (public) [this/a,this%a]
  divideAndRemainder(e) {
    const t = xe(), i = xe();
    return this.divRemTo(e, t, i), [t, i];
  }
  // BigInteger.prototype.modPow = bnModPow;
  // (public) this^e % m (HAC 14.85)
  modPow(e, t) {
    let i = e.bitLength(), s, n = Oi(1), r;
    if (i <= 0)
      return n;
    i < 18 ? s = 1 : i < 48 ? s = 3 : i < 144 ? s = 4 : i < 768 ? s = 5 : s = 6, i < 8 ? r = new Td(t) : t.isEven() ? r = new Bm(t) : r = new Ad(t);
    const a = [];
    let o = 3;
    const c = s - 1, u = (1 << s) - 1;
    if (a[1] = r.convert(this), s > 1) {
      const y = xe();
      for (r.sqrTo(a[1], y); o <= u; )
        a[o] = xe(), r.mulTo(y, a[o - 2], a[o]), o += 2;
    }
    let f = e.t - 1, h, l = !0, p = xe(), m;
    for (i = On(e[f]) - 1; f >= 0; ) {
      for (i >= c ? h = e[f] >> i - c & u : (h = (e[f] & (1 << i + 1) - 1) << c - i, f > 0 && (h |= e[f - 1] >> this.DB + i - c)), o = s; !(h & 1); )
        h >>= 1, --o;
      if ((i -= o) < 0 && (i += this.DB, --f), l)
        a[h].copyTo(n), l = !1;
      else {
        for (; o > 1; )
          r.sqrTo(n, p), r.sqrTo(p, n), o -= 2;
        o > 0 ? r.sqrTo(n, p) : (m = n, n = p, p = m), r.mulTo(p, a[h], n);
      }
      for (; f >= 0 && !(e[f] & 1 << i); )
        r.sqrTo(n, p), m = n, n = p, p = m, --i < 0 && (i = this.DB - 1, --f);
    }
    return r.revert(n);
  }
  // BigInteger.prototype.modInverse = bnModInverse;
  // (public) 1/this % m (HAC 14.61)
  modInverse(e) {
    const t = e.isEven();
    if (this.isEven() && t || e.signum() == 0)
      return we.ZERO;
    const i = e.clone(), s = this.clone(), n = Oi(1), r = Oi(0), a = Oi(0), o = Oi(1);
    for (; i.signum() != 0; ) {
      for (; i.isEven(); )
        i.rShiftTo(1, i), t ? ((!n.isEven() || !r.isEven()) && (n.addTo(this, n), r.subTo(e, r)), n.rShiftTo(1, n)) : r.isEven() || r.subTo(e, r), r.rShiftTo(1, r);
      for (; s.isEven(); )
        s.rShiftTo(1, s), t ? ((!a.isEven() || !o.isEven()) && (a.addTo(this, a), o.subTo(e, o)), a.rShiftTo(1, a)) : o.isEven() || o.subTo(e, o), o.rShiftTo(1, o);
      i.compareTo(s) >= 0 ? (i.subTo(s, i), t && n.subTo(a, n), r.subTo(o, r)) : (s.subTo(i, s), t && a.subTo(n, a), o.subTo(r, o));
    }
    if (s.compareTo(we.ONE) != 0)
      return we.ZERO;
    if (o.compareTo(e) >= 0)
      return o.subtract(e);
    if (o.signum() < 0)
      o.addTo(e, o);
    else
      return o;
    return o.signum() < 0 ? o.add(e) : o;
  }
  // BigInteger.prototype.pow = bnPow;
  // (public) this^e
  pow(e) {
    return this.exp(e, new Rm());
  }
  // BigInteger.prototype.gcd = bnGCD;
  // (public) gcd(this,a) (HAC 14.54)
  gcd(e) {
    let t = this.s < 0 ? this.negate() : this.clone(), i = e.s < 0 ? e.negate() : e.clone();
    if (t.compareTo(i) < 0) {
      const r = t;
      t = i, i = r;
    }
    let s = t.getLowestSetBit(), n = i.getLowestSetBit();
    if (n < 0)
      return t;
    for (s < n && (n = s), n > 0 && (t.rShiftTo(n, t), i.rShiftTo(n, i)); t.signum() > 0; )
      (s = t.getLowestSetBit()) > 0 && t.rShiftTo(s, t), (s = i.getLowestSetBit()) > 0 && i.rShiftTo(s, i), t.compareTo(i) >= 0 ? (t.subTo(i, t), t.rShiftTo(1, t)) : (i.subTo(t, i), i.rShiftTo(1, i));
    return n > 0 && i.lShiftTo(n, i), i;
  }
  // BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
  // (public) test primality with certainty >= 1-.5^t
  isProbablePrime(e) {
    let t;
    const i = this.abs();
    if (i.t == 1 && i[0] <= yt[yt.length - 1]) {
      for (t = 0; t < yt.length; ++t)
        if (i[0] == yt[t])
          return !0;
      return !1;
    }
    if (i.isEven())
      return !1;
    for (t = 1; t < yt.length; ) {
      let s = yt[t], n = t + 1;
      for (; n < yt.length && s < Dm; )
        s *= yt[n++];
      for (s = i.modInt(s); t < n; )
        if (s % yt[t++] == 0)
          return !1;
    }
    return i.millerRabin(e);
  }
  //#endregion PUBLIC
  //#region PROTECTED
  // BigInteger.prototype.copyTo = bnpCopyTo;
  // (protected) copy this to r
  copyTo(e) {
    for (let t = this.t - 1; t >= 0; --t)
      e[t] = this[t];
    e.t = this.t, e.s = this.s;
  }
  // BigInteger.prototype.fromInt = bnpFromInt;
  // (protected) set from integer value x, -DV <= x < DV
  fromInt(e) {
    this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0;
  }
  // BigInteger.prototype.fromString = bnpFromString;
  // (protected) set from string and radix
  fromString(e, t) {
    let i;
    if (t == 16)
      i = 4;
    else if (t == 8)
      i = 3;
    else if (t == 256)
      i = 8;
    else if (t == 2)
      i = 1;
    else if (t == 32)
      i = 5;
    else if (t == 4)
      i = 2;
    else {
      this.fromRadix(e, t);
      return;
    }
    this.t = 0, this.s = 0;
    let s = e.length, n = !1, r = 0;
    for (; --s >= 0; ) {
      const a = i == 8 ? +e[s] & 255 : Od(e, s);
      if (a < 0) {
        e.charAt(s) == "-" && (n = !0);
        continue;
      }
      n = !1, r == 0 ? this[this.t++] = a : r + i > this.DB ? (this[this.t - 1] |= (a & (1 << this.DB - r) - 1) << r, this[this.t++] = a >> this.DB - r) : this[this.t - 1] |= a << r, r += i, r >= this.DB && (r -= this.DB);
    }
    i == 8 && +e[0] & 128 && (this.s = -1, r > 0 && (this[this.t - 1] |= (1 << this.DB - r) - 1 << r)), this.clamp(), n && we.ZERO.subTo(this, this);
  }
  // BigInteger.prototype.clamp = bnpClamp;
  // (protected) clamp off excess high words
  clamp() {
    const e = this.s & this.DM;
    for (; this.t > 0 && this[this.t - 1] == e; )
      --this.t;
  }
  // BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
  // (protected) r = this << n*DB
  dlShiftTo(e, t) {
    let i;
    for (i = this.t - 1; i >= 0; --i)
      t[i + e] = this[i];
    for (i = e - 1; i >= 0; --i)
      t[i] = 0;
    t.t = this.t + e, t.s = this.s;
  }
  // BigInteger.prototype.drShiftTo = bnpDRShiftTo;
  // (protected) r = this >> n*DB
  drShiftTo(e, t) {
    for (let i = e; i < this.t; ++i)
      t[i - e] = this[i];
    t.t = Math.max(this.t - e, 0), t.s = this.s;
  }
  // BigInteger.prototype.lShiftTo = bnpLShiftTo;
  // (protected) r = this << n
  lShiftTo(e, t) {
    const i = e % this.DB, s = this.DB - i, n = (1 << s) - 1, r = Math.floor(e / this.DB);
    let a = this.s << i & this.DM;
    for (let o = this.t - 1; o >= 0; --o)
      t[o + r + 1] = this[o] >> s | a, a = (this[o] & n) << i;
    for (let o = r - 1; o >= 0; --o)
      t[o] = 0;
    t[r] = a, t.t = this.t + r + 1, t.s = this.s, t.clamp();
  }
  // BigInteger.prototype.rShiftTo = bnpRShiftTo;
  // (protected) r = this >> n
  rShiftTo(e, t) {
    t.s = this.s;
    const i = Math.floor(e / this.DB);
    if (i >= this.t) {
      t.t = 0;
      return;
    }
    const s = e % this.DB, n = this.DB - s, r = (1 << s) - 1;
    t[0] = this[i] >> s;
    for (let a = i + 1; a < this.t; ++a)
      t[a - i - 1] |= (this[a] & r) << n, t[a - i] = this[a] >> s;
    s > 0 && (t[this.t - i - 1] |= (this.s & r) << n), t.t = this.t - i, t.clamp();
  }
  // BigInteger.prototype.subTo = bnpSubTo;
  // (protected) r = this - a
  subTo(e, t) {
    let i = 0, s = 0;
    const n = Math.min(e.t, this.t);
    for (; i < n; )
      s += this[i] - e[i], t[i++] = s & this.DM, s >>= this.DB;
    if (e.t < this.t) {
      for (s -= e.s; i < this.t; )
        s += this[i], t[i++] = s & this.DM, s >>= this.DB;
      s += this.s;
    } else {
      for (s += this.s; i < e.t; )
        s -= e[i], t[i++] = s & this.DM, s >>= this.DB;
      s -= e.s;
    }
    t.s = s < 0 ? -1 : 0, s < -1 ? t[i++] = this.DV + s : s > 0 && (t[i++] = s), t.t = i, t.clamp();
  }
  // BigInteger.prototype.multiplyTo = bnpMultiplyTo;
  // (protected) r = this * a, r != this,a (HAC 14.12)
  // "this" should be the larger one if appropriate.
  multiplyTo(e, t) {
    const i = this.abs(), s = e.abs();
    let n = i.t;
    for (t.t = n + s.t; --n >= 0; )
      t[n] = 0;
    for (n = 0; n < s.t; ++n)
      t[n + i.t] = i.am(0, s[n], t, n, 0, i.t);
    t.s = 0, t.clamp(), this.s != e.s && we.ZERO.subTo(t, t);
  }
  // BigInteger.prototype.squareTo = bnpSquareTo;
  // (protected) r = this^2, r != this (HAC 14.16)
  squareTo(e) {
    const t = this.abs();
    let i = e.t = 2 * t.t;
    for (; --i >= 0; )
      e[i] = 0;
    for (i = 0; i < t.t - 1; ++i) {
      const s = t.am(i, t[i], e, 2 * i, 0, 1);
      (e[i + t.t] += t.am(i + 1, 2 * t[i], e, 2 * i + 1, s, t.t - i - 1)) >= t.DV && (e[i + t.t] -= t.DV, e[i + t.t + 1] = 1);
    }
    e.t > 0 && (e[e.t - 1] += t.am(i, t[i], e, 2 * i, 0, 1)), e.s = 0, e.clamp();
  }
  // BigInteger.prototype.divRemTo = bnpDivRemTo;
  // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
  // r != q, this != m.  q or r may be null.
  divRemTo(e, t, i) {
    const s = e.abs();
    if (s.t <= 0)
      return;
    const n = this.abs();
    if (n.t < s.t) {
      t != null && t.fromInt(0), i != null && this.copyTo(i);
      return;
    }
    i == null && (i = xe());
    const r = xe(), a = this.s, o = e.s, c = this.DB - On(s[s.t - 1]);
    c > 0 ? (s.lShiftTo(c, r), n.lShiftTo(c, i)) : (s.copyTo(r), n.copyTo(i));
    const u = r.t, f = r[u - 1];
    if (f == 0)
      return;
    const h = f * (1 << this.F1) + (u > 1 ? r[u - 2] >> this.F2 : 0), l = this.FV / h, p = (1 << this.F1) / h, m = 1 << this.F2;
    let y = i.t, w = y - u;
    const S = t ?? xe();
    for (r.dlShiftTo(w, S), i.compareTo(S) >= 0 && (i[i.t++] = 1, i.subTo(S, i)), we.ONE.dlShiftTo(u, S), S.subTo(r, r); r.t < u; )
      r[r.t++] = 0;
    for (; --w >= 0; ) {
      let b = i[--y] == f ? this.DM : Math.floor(i[y] * l + (i[y - 1] + m) * p);
      if ((i[y] += r.am(0, b, i, w, 0, u)) < b)
        for (r.dlShiftTo(w, S), i.subTo(S, i); i[y] < --b; )
          i.subTo(S, i);
    }
    t != null && (i.drShiftTo(u, t), a != o && we.ZERO.subTo(t, t)), i.t = u, i.clamp(), c > 0 && i.rShiftTo(c, i), a < 0 && we.ZERO.subTo(i, i);
  }
  // BigInteger.prototype.invDigit = bnpInvDigit;
  // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
  // justification:
  //         xy == 1 (mod m)
  //         xy =  1+km
  //   xy(2-xy) = (1+km)(1-km)
  // x[y(2-xy)] = 1-k^2m^2
  // x[y(2-xy)] == 1 (mod m^2)
  // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
  // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
  // JS multiply "overflows" differently from C/C++, so care is needed here.
  invDigit() {
    if (this.t < 1)
      return 0;
    const e = this[0];
    if (!(e & 1))
      return 0;
    let t = e & 3;
    return t = t * (2 - (e & 15) * t) & 15, t = t * (2 - (e & 255) * t) & 255, t = t * (2 - ((e & 65535) * t & 65535)) & 65535, t = t * (2 - e * t % this.DV) % this.DV, t > 0 ? this.DV - t : -t;
  }
  // BigInteger.prototype.isEven = bnpIsEven;
  // (protected) true iff this is even
  isEven() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
  }
  // BigInteger.prototype.exp = bnpExp;
  // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
  exp(e, t) {
    if (e > 4294967295 || e < 1)
      return we.ONE;
    let i = xe(), s = xe();
    const n = t.convert(this);
    let r = On(e) - 1;
    for (n.copyTo(i); --r >= 0; )
      if (t.sqrTo(i, s), (e & 1 << r) > 0)
        t.mulTo(s, n, i);
      else {
        const a = i;
        i = s, s = a;
      }
    return t.revert(i);
  }
  // BigInteger.prototype.chunkSize = bnpChunkSize;
  // (protected) return x s.t. r^x < DV
  chunkSize(e) {
    return Math.floor(Math.LN2 * this.DB / Math.log(e));
  }
  // BigInteger.prototype.toRadix = bnpToRadix;
  // (protected) convert to radix string
  toRadix(e) {
    if (e == null && (e = 10), this.signum() == 0 || e < 2 || e > 36)
      return "0";
    const t = this.chunkSize(e), i = Math.pow(e, t), s = Oi(i), n = xe(), r = xe();
    let a = "";
    for (this.divRemTo(s, n, r); n.signum() > 0; )
      a = (i + r.intValue()).toString(e).substr(1) + a, n.divRemTo(s, n, r);
    return r.intValue().toString(e) + a;
  }
  // BigInteger.prototype.fromRadix = bnpFromRadix;
  // (protected) convert from radix string
  fromRadix(e, t) {
    this.fromInt(0), t == null && (t = 10);
    const i = this.chunkSize(t), s = Math.pow(t, i);
    let n = !1, r = 0, a = 0;
    for (let o = 0; o < e.length; ++o) {
      const c = Od(e, o);
      if (c < 0) {
        e.charAt(o) == "-" && this.signum() == 0 && (n = !0);
        continue;
      }
      a = t * a + c, ++r >= i && (this.dMultiply(s), this.dAddOffset(a, 0), r = 0, a = 0);
    }
    r > 0 && (this.dMultiply(Math.pow(t, r)), this.dAddOffset(a, 0)), n && we.ZERO.subTo(this, this);
  }
  // BigInteger.prototype.fromNumber = bnpFromNumber;
  // (protected) alternate constructor
  fromNumber(e, t, i) {
    if (typeof t == "number")
      if (e < 2)
        this.fromInt(1);
      else
        for (this.fromNumber(e, i), this.testBit(e - 1) || this.bitwiseTo(we.ONE.shiftLeft(e - 1), In, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(t); )
          this.dAddOffset(2, 0), this.bitLength() > e && this.subTo(we.ONE.shiftLeft(e - 1), this);
    else {
      const s = [], n = e & 7;
      s.length = (e >> 3) + 1, t.nextBytes(s), n > 0 ? s[0] &= (1 << n) - 1 : s[0] = 0, this.fromString(s, 256);
    }
  }
  // BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
  // (protected) r = this op a (bitwise)
  bitwiseTo(e, t, i) {
    let s, n;
    const r = Math.min(e.t, this.t);
    for (s = 0; s < r; ++s)
      i[s] = t(this[s], e[s]);
    if (e.t < this.t) {
      for (n = e.s & this.DM, s = r; s < this.t; ++s)
        i[s] = t(this[s], n);
      i.t = this.t;
    } else {
      for (n = this.s & this.DM, s = r; s < e.t; ++s)
        i[s] = t(n, e[s]);
      i.t = e.t;
    }
    i.s = t(this.s, e.s), i.clamp();
  }
  // BigInteger.prototype.changeBit = bnpChangeBit;
  // (protected) this op (1<<n)
  changeBit(e, t) {
    const i = we.ONE.shiftLeft(e);
    return this.bitwiseTo(i, t, i), i;
  }
  // BigInteger.prototype.addTo = bnpAddTo;
  // (protected) r = this + a
  addTo(e, t) {
    let i = 0, s = 0;
    const n = Math.min(e.t, this.t);
    for (; i < n; )
      s += this[i] + e[i], t[i++] = s & this.DM, s >>= this.DB;
    if (e.t < this.t) {
      for (s += e.s; i < this.t; )
        s += this[i], t[i++] = s & this.DM, s >>= this.DB;
      s += this.s;
    } else {
      for (s += this.s; i < e.t; )
        s += e[i], t[i++] = s & this.DM, s >>= this.DB;
      s += e.s;
    }
    t.s = s < 0 ? -1 : 0, s > 0 ? t[i++] = s : s < -1 && (t[i++] = this.DV + s), t.t = i, t.clamp();
  }
  // BigInteger.prototype.dMultiply = bnpDMultiply;
  // (protected) this *= n, this >= 0, 1 < n < DV
  dMultiply(e) {
    this[this.t] = this.am(0, e - 1, this, 0, 0, this.t), ++this.t, this.clamp();
  }
  // BigInteger.prototype.dAddOffset = bnpDAddOffset;
  // (protected) this += n << w words, this >= 0
  dAddOffset(e, t) {
    if (e != 0) {
      for (; this.t <= t; )
        this[this.t++] = 0;
      for (this[t] += e; this[t] >= this.DV; )
        this[t] -= this.DV, ++t >= this.t && (this[this.t++] = 0), ++this[t];
    }
  }
  // BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
  // (protected) r = lower n words of "this * a", a.t <= n
  // "this" should be the larger one if appropriate.
  multiplyLowerTo(e, t, i) {
    let s = Math.min(this.t + e.t, t);
    for (i.s = 0, i.t = s; s > 0; )
      i[--s] = 0;
    for (const n = i.t - this.t; s < n; ++s)
      i[s + this.t] = this.am(0, e[s], i, s, 0, this.t);
    for (const n = Math.min(e.t, t); s < n; ++s)
      this.am(0, e[s], i, s, 0, t - s);
    i.clamp();
  }
  // BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
  // (protected) r = "this * a" without lower n words, n > 0
  // "this" should be the larger one if appropriate.
  multiplyUpperTo(e, t, i) {
    --t;
    let s = i.t = this.t + e.t - t;
    for (i.s = 0; --s >= 0; )
      i[s] = 0;
    for (s = Math.max(t - this.t, 0); s < e.t; ++s)
      i[this.t + s - t] = this.am(t - s, e[s], i, 0, 0, this.t + s - t);
    i.clamp(), i.drShiftTo(1, i);
  }
  // BigInteger.prototype.modInt = bnpModInt;
  // (protected) this % n, n < 2^26
  modInt(e) {
    if (e <= 0)
      return 0;
    const t = this.DV % e;
    let i = this.s < 0 ? e - 1 : 0;
    if (this.t > 0)
      if (t == 0)
        i = this[0] % e;
      else
        for (let s = this.t - 1; s >= 0; --s)
          i = (t * i + this[s]) % e;
    return i;
  }
  // BigInteger.prototype.millerRabin = bnpMillerRabin;
  // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
  millerRabin(e) {
    const t = this.subtract(we.ONE), i = t.getLowestSetBit();
    if (i <= 0)
      return !1;
    const s = t.shiftRight(i);
    e = e + 1 >> 1, e > yt.length && (e = yt.length);
    const n = xe();
    for (let r = 0; r < e; ++r) {
      n.fromInt(yt[Math.floor(Math.random() * yt.length)]);
      let a = n.modPow(s, this);
      if (a.compareTo(we.ONE) != 0 && a.compareTo(t) != 0) {
        let o = 1;
        for (; o++ < i && a.compareTo(t) != 0; )
          if (a = a.modPowInt(2, this), a.compareTo(we.ONE) == 0)
            return !1;
        if (a.compareTo(t) != 0)
          return !1;
      }
    }
    return !0;
  }
  // BigInteger.prototype.square = bnSquare;
  // (public) this^2
  square() {
    const e = xe();
    return this.squareTo(e), e;
  }
  //#region ASYNC
  // Public API method
  gcda(e, t) {
    let i = this.s < 0 ? this.negate() : this.clone(), s = e.s < 0 ? e.negate() : e.clone();
    if (i.compareTo(s) < 0) {
      const o = i;
      i = s, s = o;
    }
    let n = i.getLowestSetBit(), r = s.getLowestSetBit();
    if (r < 0) {
      t(i);
      return;
    }
    n < r && (r = n), r > 0 && (i.rShiftTo(r, i), s.rShiftTo(r, s));
    const a = function() {
      (n = i.getLowestSetBit()) > 0 && i.rShiftTo(n, i), (n = s.getLowestSetBit()) > 0 && s.rShiftTo(n, s), i.compareTo(s) >= 0 ? (i.subTo(s, i), i.rShiftTo(1, i)) : (s.subTo(i, s), s.rShiftTo(1, s)), i.signum() > 0 ? setTimeout(a, 0) : (r > 0 && s.lShiftTo(r, s), setTimeout(function() {
        t(s);
      }, 0));
    };
    setTimeout(a, 10);
  }
  // (protected) alternate constructor
  fromNumberAsync(e, t, i, s) {
    if (typeof t == "number")
      if (e < 2)
        this.fromInt(1);
      else {
        this.fromNumber(e, i), this.testBit(e - 1) || this.bitwiseTo(we.ONE.shiftLeft(e - 1), In, this), this.isEven() && this.dAddOffset(1, 0);
        const n = this, r = function() {
          n.dAddOffset(2, 0), n.bitLength() > e && n.subTo(we.ONE.shiftLeft(e - 1), n), n.isProbablePrime(t) ? setTimeout(function() {
            s();
          }, 0) : setTimeout(r, 0);
        };
        setTimeout(r, 0);
      }
    else {
      const n = [], r = e & 7;
      n.length = (e >> 3) + 1, t.nextBytes(n), r > 0 ? n[0] &= (1 << r) - 1 : n[0] = 0, this.fromString(n, 256);
    }
  }
}
class Rm {
  constructor() {
  }
  // NullExp.prototype.convert = nNop;
  convert(e) {
    return e;
  }
  // NullExp.prototype.revert = nNop;
  revert(e) {
    return e;
  }
  // NullExp.prototype.mulTo = nMulTo;
  mulTo(e, t, i) {
    e.multiplyTo(t, i);
  }
  // NullExp.prototype.sqrTo = nSqrTo;
  sqrTo(e, t) {
    e.squareTo(t);
  }
}
class Td {
  constructor(e) {
    this.m = e;
  }
  // Classic.prototype.convert = cConvert;
  convert(e) {
    return e.s < 0 || e.compareTo(this.m) >= 0 ? e.mod(this.m) : e;
  }
  // Classic.prototype.revert = cRevert;
  revert(e) {
    return e;
  }
  // Classic.prototype.reduce = cReduce;
  reduce(e) {
    e.divRemTo(this.m, null, e);
  }
  // Classic.prototype.mulTo = cMulTo;
  mulTo(e, t, i) {
    e.multiplyTo(t, i), this.reduce(i);
  }
  // Classic.prototype.sqrTo = cSqrTo;
  sqrTo(e, t) {
    e.squareTo(t), this.reduce(t);
  }
}
class Ad {
  constructor(e) {
    this.m = e, this.mp = e.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
  }
  // Montgomery.prototype.convert = montConvert;
  // xR mod m
  convert(e) {
    const t = xe();
    return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(we.ZERO) > 0 && this.m.subTo(t, t), t;
  }
  // Montgomery.prototype.revert = montRevert;
  // x/R mod m
  revert(e) {
    const t = xe();
    return e.copyTo(t), this.reduce(t), t;
  }
  // Montgomery.prototype.reduce = montReduce;
  // x = x/R mod m (HAC 14.32)
  reduce(e) {
    for (; e.t <= this.mt2; )
      e[e.t++] = 0;
    for (let t = 0; t < this.m.t; ++t) {
      let i = e[t] & 32767;
      const s = i * this.mpl + ((i * this.mph + (e[t] >> 15) * this.mpl & this.um) << 15) & e.DM;
      for (i = t + this.m.t, e[i] += this.m.am(0, s, e, t, 0, this.m.t); e[i] >= e.DV; )
        e[i] -= e.DV, e[++i]++;
    }
    e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
  }
  // Montgomery.prototype.mulTo = montMulTo;
  // r = "xy/R mod m"; x,y != r
  mulTo(e, t, i) {
    e.multiplyTo(t, i), this.reduce(i);
  }
  // Montgomery.prototype.sqrTo = montSqrTo;
  // r = "x^2/R mod m"; x != r
  sqrTo(e, t) {
    e.squareTo(t), this.reduce(t);
  }
}
class Bm {
  constructor(e) {
    this.m = e, this.r2 = xe(), this.q3 = xe(), we.ONE.dlShiftTo(2 * e.t, this.r2), this.mu = this.r2.divide(e);
  }
  // Barrett.prototype.convert = barrettConvert;
  convert(e) {
    if (e.s < 0 || e.t > 2 * this.m.t)
      return e.mod(this.m);
    if (e.compareTo(this.m) < 0)
      return e;
    {
      const t = xe();
      return e.copyTo(t), this.reduce(t), t;
    }
  }
  // Barrett.prototype.revert = barrettRevert;
  revert(e) {
    return e;
  }
  // Barrett.prototype.reduce = barrettReduce;
  // x = x mod m (HAC 14.42)
  reduce(e) {
    for (e.drShiftTo(this.m.t - 1, this.r2), e.t > this.m.t + 1 && (e.t = this.m.t + 1, e.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); e.compareTo(this.r2) < 0; )
      e.dAddOffset(1, this.m.t + 1);
    for (e.subTo(this.r2, e); e.compareTo(this.m) >= 0; )
      e.subTo(this.m, e);
  }
  // Barrett.prototype.mulTo = barrettMulTo;
  // r = x*y mod m; x,y != r
  mulTo(e, t, i) {
    e.multiplyTo(t, i), this.reduce(i);
  }
  // Barrett.prototype.sqrTo = barrettSqrTo;
  // r = x^2 mod m; x != r
  sqrTo(e, t) {
    e.squareTo(t), this.reduce(t);
  }
}
function xe() {
  return new we(null);
}
function Ke(d, e) {
  return new we(d, e);
}
const Id = typeof navigator < "u";
Id && Sd && navigator.appName == "Microsoft Internet Explorer" ? (we.prototype.am = function(e, t, i, s, n, r) {
  const a = t & 32767, o = t >> 15;
  for (; --r >= 0; ) {
    let c = this[e] & 32767;
    const u = this[e++] >> 15, f = o * c + u * a;
    c = a * c + ((f & 32767) << 15) + i[s] + (n & 1073741823), n = (c >>> 30) + (f >>> 15) + o * u + (n >>> 30), i[s++] = c & 1073741823;
  }
  return n;
}, xi = 30) : Id && Sd && navigator.appName != "Netscape" ? (we.prototype.am = function(e, t, i, s, n, r) {
  for (; --r >= 0; ) {
    const a = t * this[e++] + i[s] + n;
    n = Math.floor(a / 67108864), i[s++] = a & 67108863;
  }
  return n;
}, xi = 26) : (we.prototype.am = function(e, t, i, s, n, r) {
  const a = t & 16383, o = t >> 14;
  for (; --r >= 0; ) {
    let c = this[e] & 16383;
    const u = this[e++] >> 14, f = o * c + u * a;
    c = a * c + ((f & 16383) << 14) + i[s] + n, n = (c >> 28) + (f >> 14) + o * u, i[s++] = c & 268435455;
  }
  return n;
}, xi = 28);
we.prototype.DB = xi;
we.prototype.DM = (1 << xi) - 1;
we.prototype.DV = 1 << xi;
const Ao = 52;
we.prototype.FV = Math.pow(2, Ao);
we.prototype.F1 = Ao - xi;
we.prototype.F2 = 2 * xi - Ao;
const yr = [];
let xs, kt;
xs = "0".charCodeAt(0);
for (kt = 0; kt <= 9; ++kt)
  yr[xs++] = kt;
xs = "a".charCodeAt(0);
for (kt = 10; kt < 36; ++kt)
  yr[xs++] = kt;
xs = "A".charCodeAt(0);
for (kt = 10; kt < 36; ++kt)
  yr[xs++] = kt;
function Od(d, e) {
  const t = yr[d.charCodeAt(e)];
  return t ?? -1;
}
function Oi(d) {
  const e = xe();
  return e.fromInt(d), e;
}
function On(d) {
  let e = 1, t;
  return (t = d >>> 16) != 0 && (d = t, e += 16), (t = d >> 8) != 0 && (d = t, e += 8), (t = d >> 4) != 0 && (d = t, e += 4), (t = d >> 2) != 0 && (d = t, e += 2), (t = d >> 1) != 0 && (d = t, e += 1), e;
}
we.ZERO = Oi(0);
we.ONE = Oi(1);
function Vm(d, e) {
  if (e < d.length + 22)
    return console.error("Message too long for RSA"), null;
  const t = e - d.length - 6;
  let i = "";
  for (let n = 0; n < t; n += 2)
    i += "ff";
  const s = "0001" + i + "00" + d;
  return Ke(s, 16);
}
function jm(d, e) {
  if (e < d.length + 11)
    return console.error("Message too long for RSA"), null;
  const t = [];
  let i = d.length - 1;
  for (; i >= 0 && e > 0; ) {
    const r = d.charCodeAt(i--);
    r < 128 ? t[--e] = r : r > 127 && r < 2048 ? (t[--e] = r & 63 | 128, t[--e] = r >> 6 | 192) : (t[--e] = r & 63 | 128, t[--e] = r >> 6 & 63 | 128, t[--e] = r >> 12 | 224);
  }
  t[--e] = 0;
  const s = new Xn(), n = [];
  for (; e > 2; ) {
    for (n[0] = 0; n[0] == 0; )
      s.nextBytes(n);
    t[--e] = n[0];
  }
  return t[--e] = 2, t[--e] = 0, new we(t);
}
class Fm {
  constructor() {
    this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null;
  }
  //#region PROTECTED
  // protected
  // RSAKey.prototype.doPublic = RSADoPublic;
  // Perform raw public operation on "x": return x^e (mod n)
  doPublic(e) {
    return e.modPowInt(this.e, this.n);
  }
  // RSAKey.prototype.doPrivate = RSADoPrivate;
  // Perform raw private operation on "x": return x^d (mod n)
  doPrivate(e) {
    if (this.p == null || this.q == null)
      return e.modPow(this.d, this.n);
    let t = e.mod(this.p).modPow(this.dmp1, this.p);
    const i = e.mod(this.q).modPow(this.dmq1, this.q);
    for (; t.compareTo(i) < 0; )
      t = t.add(this.p);
    return t.subtract(i).multiply(this.coeff).mod(this.p).multiply(this.q).add(i);
  }
  //#endregion PROTECTED
  //#region PUBLIC
  // RSAKey.prototype.setPublic = RSASetPublic;
  // Set the public key fields N and e from hex strings
  setPublic(e, t) {
    e != null && t != null && e.length > 0 && t.length > 0 ? (this.n = Ke(e, 16), this.e = parseInt(t, 16)) : console.error("Invalid RSA public key");
  }
  // RSAKey.prototype.encrypt = RSAEncrypt;
  // Return the PKCS#1 RSA encryption of "text" as an even-length hex string
  encrypt(e) {
    const t = this.n.bitLength() + 7 >> 3, i = jm(e, t);
    if (i == null)
      return null;
    const s = this.doPublic(i);
    if (s == null)
      return null;
    let n = s.toString(16), r = n.length;
    for (let a = 0; a < t * 2 - r; a++)
      n = "0" + n;
    return n;
  }
  // RSAKey.prototype.setPrivate = RSASetPrivate;
  // Set the private key fields N, e, and d from hex strings
  setPrivate(e, t, i) {
    e != null && t != null && e.length > 0 && t.length > 0 ? (this.n = Ke(e, 16), this.e = parseInt(t, 16), this.d = Ke(i, 16)) : console.error("Invalid RSA private key");
  }
  // RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
  // Set the private key fields N, e, d and CRT params from hex strings
  setPrivateEx(e, t, i, s, n, r, a, o) {
    e != null && t != null && e.length > 0 && t.length > 0 ? (this.n = Ke(e, 16), this.e = parseInt(t, 16), this.d = Ke(i, 16), this.p = Ke(s, 16), this.q = Ke(n, 16), this.dmp1 = Ke(r, 16), this.dmq1 = Ke(a, 16), this.coeff = Ke(o, 16)) : console.error("Invalid RSA private key");
  }
  // RSAKey.prototype.generate = RSAGenerate;
  // Generate a new random private key B bits long, using public expt E
  generate(e, t) {
    const i = new Xn(), s = e >> 1;
    this.e = parseInt(t, 16);
    const n = new we(t, 16);
    for (; ; ) {
      for (; this.p = new we(e - s, 1, i), !(this.p.subtract(we.ONE).gcd(n).compareTo(we.ONE) == 0 && this.p.isProbablePrime(10)); )
        ;
      for (; this.q = new we(s, 1, i), !(this.q.subtract(we.ONE).gcd(n).compareTo(we.ONE) == 0 && this.q.isProbablePrime(10)); )
        ;
      if (this.p.compareTo(this.q) <= 0) {
        const c = this.p;
        this.p = this.q, this.q = c;
      }
      const r = this.p.subtract(we.ONE), a = this.q.subtract(we.ONE), o = r.multiply(a);
      if (o.gcd(n).compareTo(we.ONE) == 0) {
        this.n = this.p.multiply(this.q), this.d = n.modInverse(o), this.dmp1 = this.d.mod(r), this.dmq1 = this.d.mod(a), this.coeff = this.q.modInverse(this.p);
        break;
      }
    }
  }
  // RSAKey.prototype.decrypt = RSADecrypt;
  // Return the PKCS#1 RSA decryption of "ctext".
  // "ctext" is an even-length hex string and the output is a plain string.
  decrypt(e) {
    const t = Ke(e, 16), i = this.doPrivate(t);
    return i == null ? null : Um(i, this.n.bitLength() + 7 >> 3);
  }
  // Generate a new random private key B bits long, using public expt E
  generateAsync(e, t, i) {
    const s = new Xn(), n = e >> 1;
    this.e = parseInt(t, 16);
    const r = new we(t, 16), a = this, o = function() {
      const c = function() {
        if (a.p.compareTo(a.q) <= 0) {
          const m = a.p;
          a.p = a.q, a.q = m;
        }
        const h = a.p.subtract(we.ONE), l = a.q.subtract(we.ONE), p = h.multiply(l);
        p.gcd(r).compareTo(we.ONE) == 0 ? (a.n = a.p.multiply(a.q), a.d = r.modInverse(p), a.dmp1 = a.d.mod(h), a.dmq1 = a.d.mod(l), a.coeff = a.q.modInverse(a.p), setTimeout(function() {
          i();
        }, 0)) : setTimeout(o, 0);
      }, u = function() {
        a.q = xe(), a.q.fromNumberAsync(n, 1, s, function() {
          a.q.subtract(we.ONE).gcda(r, function(h) {
            h.compareTo(we.ONE) == 0 && a.q.isProbablePrime(10) ? setTimeout(c, 0) : setTimeout(u, 0);
          });
        });
      }, f = function() {
        a.p = xe(), a.p.fromNumberAsync(e - n, 1, s, function() {
          a.p.subtract(we.ONE).gcda(r, function(h) {
            h.compareTo(we.ONE) == 0 && a.p.isProbablePrime(10) ? setTimeout(u, 0) : setTimeout(f, 0);
          });
        });
      };
      setTimeout(f, 0);
    };
    setTimeout(o, 0);
  }
  sign(e, t, i) {
    const n = qm(i) + t(e).toString(), r = Vm(n, this.n.bitLength() / 4);
    if (r == null)
      return null;
    const a = this.doPrivate(r);
    if (a == null)
      return null;
    const o = a.toString(16);
    return o.length & 1 ? "0" + o : o;
  }
  verify(e, t, i) {
    const s = Ke(t, 16), n = this.doPublic(s);
    if (n == null)
      return null;
    const r = n.toString(16).replace(/^1f+00/, "");
    return Gm(r) == i(e).toString();
  }
}
function Um(d, e) {
  const t = d.toByteArray();
  let i = 0;
  for (; i < t.length && t[i] == 0; )
    ++i;
  if (t.length - i != e - 1 || t[i] != 2)
    return null;
  for (++i; t[i] != 0; )
    if (++i >= t.length)
      return null;
  let s = "";
  for (; ++i < t.length; ) {
    const n = t[i] & 255;
    n < 128 ? s += String.fromCharCode(n) : n > 191 && n < 224 ? (s += String.fromCharCode((n & 31) << 6 | t[i + 1] & 63), ++i) : (s += String.fromCharCode((n & 15) << 12 | (t[i + 1] & 63) << 6 | t[i + 2] & 63), i += 2);
  }
  return s;
}
const Dn = {
  md2: "3020300c06082a864886f70d020205000410",
  md5: "3020300c06082a864886f70d020505000410",
  sha1: "3021300906052b0e03021a05000414",
  sha224: "302d300d06096086480165030402040500041c",
  sha256: "3031300d060960864801650304020105000420",
  sha384: "3041300d060960864801650304020205000430",
  sha512: "3051300d060960864801650304020305000440",
  ripemd160: "3021300906052b2403020105000414"
};
function qm(d) {
  return Dn[d] || "";
}
function Gm(d) {
  for (const e in Dn)
    if (Dn.hasOwnProperty(e)) {
      const t = Dn[e], i = t.length;
      if (d.substr(0, i) == t)
        return d.substr(i);
    }
  return d;
}
/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/
var Qe = {};
Qe.lang = {
  /**
   * Utility to set up the prototype, constructor and superclass properties to
   * support an inheritance strategy that can chain constructors and methods.
   * Static members will not be inherited.
   *
   * @method extend
   * @static
   * @param {Function} subc   the object to modify
   * @param {Function} superc the object to inherit
   * @param {Object} overrides  additional properties/methods to add to the
   *                              subclass prototype.  These will override the
   *                              matching items obtained from the superclass
   *                              if present.
   */
  extend: function(d, e, t) {
    if (!e || !d)
      throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");
    var i = function() {
    };
    if (i.prototype = e.prototype, d.prototype = new i(), d.prototype.constructor = d, d.superclass = e.prototype, e.prototype.constructor == Object.prototype.constructor && (e.prototype.constructor = e), t) {
      var s;
      for (s in t)
        d.prototype[s] = t[s];
      var n = function() {
      }, r = ["toString", "valueOf"];
      try {
        /MSIE/.test(navigator.userAgent) && (n = function(a, o) {
          for (s = 0; s < r.length; s = s + 1) {
            var c = r[s], u = o[c];
            typeof u == "function" && u != Object.prototype[c] && (a[c] = u);
          }
        });
      } catch {
      }
      n(d.prototype, t);
    }
  }
};
/**
 * @fileOverview
 * @name asn1-1.0.js
 * @author Kenji Urushima kenji.urushima@gmail.com
 * @version asn1 1.0.13 (2017-Jun-02)
 * @since jsrsasign 2.1
 * @license <a href="https://kjur.github.io/jsrsasign/license/">MIT License</a>
 */
var fe = {};
(typeof fe.asn1 > "u" || !fe.asn1) && (fe.asn1 = {});
fe.asn1.ASN1Util = new function() {
  this.integerToByteHex = function(d) {
    var e = d.toString(16);
    return e.length % 2 == 1 && (e = "0" + e), e;
  }, this.bigIntToMinTwosComplementsHex = function(d) {
    var e = d.toString(16);
    if (e.substr(0, 1) != "-")
      e.length % 2 == 1 ? e = "0" + e : e.match(/^[0-7]/) || (e = "00" + e);
    else {
      var t = e.substr(1), i = t.length;
      i % 2 == 1 ? i += 1 : e.match(/^[0-7]/) || (i += 2);
      for (var s = "", n = 0; n < i; n++)
        s += "f";
      var r = new we(s, 16), a = r.xor(d).add(we.ONE);
      e = a.toString(16).replace(/^-/, "");
    }
    return e;
  }, this.getPEMStringFromHex = function(d, e) {
    return hextopem(d, e);
  }, this.newObject = function(d) {
    var e = fe, t = e.asn1, i = t.DERBoolean, s = t.DERInteger, n = t.DERBitString, r = t.DEROctetString, a = t.DERNull, o = t.DERObjectIdentifier, c = t.DEREnumerated, u = t.DERUTF8String, f = t.DERNumericString, h = t.DERPrintableString, l = t.DERTeletexString, p = t.DERIA5String, m = t.DERUTCTime, y = t.DERGeneralizedTime, w = t.DERSequence, S = t.DERSet, b = t.DERTaggedObject, T = t.ASN1Util.newObject, x = Object.keys(d);
    if (x.length != 1)
      throw "key of param shall be only one.";
    var v = x[0];
    if (":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + v + ":") == -1)
      throw "undefined key: " + v;
    if (v == "bool")
      return new i(d[v]);
    if (v == "int")
      return new s(d[v]);
    if (v == "bitstr")
      return new n(d[v]);
    if (v == "octstr")
      return new r(d[v]);
    if (v == "null")
      return new a(d[v]);
    if (v == "oid")
      return new o(d[v]);
    if (v == "enum")
      return new c(d[v]);
    if (v == "utf8str")
      return new u(d[v]);
    if (v == "numstr")
      return new f(d[v]);
    if (v == "prnstr")
      return new h(d[v]);
    if (v == "telstr")
      return new l(d[v]);
    if (v == "ia5str")
      return new p(d[v]);
    if (v == "utctime")
      return new m(d[v]);
    if (v == "gentime")
      return new y(d[v]);
    if (v == "seq") {
      for (var _ = d[v], V = [], j = 0; j < _.length; j++) {
        var G = T(_[j]);
        V.push(G);
      }
      return new w({ array: V });
    }
    if (v == "set") {
      for (var _ = d[v], V = [], j = 0; j < _.length; j++) {
        var G = T(_[j]);
        V.push(G);
      }
      return new S({ array: V });
    }
    if (v == "tag") {
      var W = d[v];
      if (Object.prototype.toString.call(W) === "[object Array]" && W.length == 3) {
        var B = T(W[2]);
        return new b({
          tag: W[0],
          explicit: W[1],
          obj: B
        });
      } else {
        var Q = {};
        if (W.explicit !== void 0 && (Q.explicit = W.explicit), W.tag !== void 0 && (Q.tag = W.tag), W.obj === void 0)
          throw "obj shall be specified for 'tag'.";
        return Q.obj = T(W.obj), new b(Q);
      }
    }
  }, this.jsonToASN1HEX = function(d) {
    var e = this.newObject(d);
    return e.getEncodedHex();
  };
}();
fe.asn1.ASN1Util.oidHexToInt = function(d) {
  for (var s = "", e = parseInt(d.substr(0, 2), 16), t = Math.floor(e / 40), i = e % 40, s = t + "." + i, n = "", r = 2; r < d.length; r += 2) {
    var a = parseInt(d.substr(r, 2), 16), o = ("00000000" + a.toString(2)).slice(-8);
    if (n = n + o.substr(1, 7), o.substr(0, 1) == "0") {
      var c = new we(n, 2);
      s = s + "." + c.toString(10), n = "";
    }
  }
  return s;
};
fe.asn1.ASN1Util.oidIntToHex = function(d) {
  var e = function(a) {
    var o = a.toString(16);
    return o.length == 1 && (o = "0" + o), o;
  }, t = function(a) {
    var o = "", c = new we(a, 10), u = c.toString(2), f = 7 - u.length % 7;
    f == 7 && (f = 0);
    for (var h = "", l = 0; l < f; l++)
      h += "0";
    u = h + u;
    for (var l = 0; l < u.length - 1; l += 7) {
      var p = u.substr(l, 7);
      l != u.length - 7 && (p = "1" + p), o += e(parseInt(p, 2));
    }
    return o;
  };
  if (!d.match(/^[0-9.]+$/))
    throw "malformed oid string: " + d;
  var i = "", s = d.split("."), n = parseInt(s[0]) * 40 + parseInt(s[1]);
  i += e(n), s.splice(0, 2);
  for (var r = 0; r < s.length; r++)
    i += t(s[r]);
  return i;
};
fe.asn1.ASN1Object = function() {
  var d = "";
  this.getLengthHexFromValue = function() {
    if (typeof this.hV > "u" || this.hV == null)
      throw "this.hV is null or undefined.";
    if (this.hV.length % 2 == 1)
      throw "value hex must be even length: n=" + d.length + ",v=" + this.hV;
    var e = this.hV.length / 2, t = e.toString(16);
    if (t.length % 2 == 1 && (t = "0" + t), e < 128)
      return t;
    var i = t.length / 2;
    if (i > 15)
      throw "ASN.1 length too long to represent by 8x: n = " + e.toString(16);
    var s = 128 + i;
    return s.toString(16) + t;
  }, this.getEncodedHex = function() {
    return (this.hTLV == null || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = !1), this.hTLV;
  }, this.getValueHex = function() {
    return this.getEncodedHex(), this.hV;
  }, this.getFreshValueHex = function() {
    return "";
  };
};
fe.asn1.DERAbstractString = function(d) {
  fe.asn1.DERAbstractString.superclass.constructor.call(this), this.getString = function() {
    return this.s;
  }, this.setString = function(e) {
    this.hTLV = null, this.isModified = !0, this.s = e, this.hV = stohex(this.s);
  }, this.setStringHex = function(e) {
    this.hTLV = null, this.isModified = !0, this.s = null, this.hV = e;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof d < "u" && (typeof d == "string" ? this.setString(d) : typeof d.str < "u" ? this.setString(d.str) : typeof d.hex < "u" && this.setStringHex(d.hex));
};
Qe.lang.extend(fe.asn1.DERAbstractString, fe.asn1.ASN1Object);
fe.asn1.DERAbstractTime = function(d) {
  fe.asn1.DERAbstractTime.superclass.constructor.call(this), this.localDateToUTC = function(e) {
    utc = e.getTime() + e.getTimezoneOffset() * 6e4;
    var t = new Date(utc);
    return t;
  }, this.formatDate = function(e, t, i) {
    var s = this.zeroPadding, n = this.localDateToUTC(e), r = String(n.getFullYear());
    t == "utc" && (r = r.substr(2, 2));
    var a = s(String(n.getMonth() + 1), 2), o = s(String(n.getDate()), 2), c = s(String(n.getHours()), 2), u = s(String(n.getMinutes()), 2), f = s(String(n.getSeconds()), 2), h = r + a + o + c + u + f;
    if (i === !0) {
      var l = n.getMilliseconds();
      if (l != 0) {
        var p = s(String(l), 3);
        p = p.replace(/[0]+$/, ""), h = h + "." + p;
      }
    }
    return h + "Z";
  }, this.zeroPadding = function(e, t) {
    return e.length >= t ? e : new Array(t - e.length + 1).join("0") + e;
  }, this.getString = function() {
    return this.s;
  }, this.setString = function(e) {
    this.hTLV = null, this.isModified = !0, this.s = e, this.hV = stohex(e);
  }, this.setByDateValue = function(e, t, i, s, n, r) {
    var a = new Date(Date.UTC(e, t - 1, i, s, n, r, 0));
    this.setByDate(a);
  }, this.getFreshValueHex = function() {
    return this.hV;
  };
};
Qe.lang.extend(fe.asn1.DERAbstractTime, fe.asn1.ASN1Object);
fe.asn1.DERAbstractStructured = function(d) {
  fe.asn1.DERAbstractString.superclass.constructor.call(this), this.setByASN1ObjectArray = function(e) {
    this.hTLV = null, this.isModified = !0, this.asn1Array = e;
  }, this.appendASN1Object = function(e) {
    this.hTLV = null, this.isModified = !0, this.asn1Array.push(e);
  }, this.asn1Array = new Array(), typeof d < "u" && typeof d.array < "u" && (this.asn1Array = d.array);
};
Qe.lang.extend(fe.asn1.DERAbstractStructured, fe.asn1.ASN1Object);
fe.asn1.DERBoolean = function() {
  fe.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", this.hTLV = "0101ff";
};
Qe.lang.extend(fe.asn1.DERBoolean, fe.asn1.ASN1Object);
fe.asn1.DERInteger = function(d) {
  fe.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.setByBigInteger = function(e) {
    this.hTLV = null, this.isModified = !0, this.hV = fe.asn1.ASN1Util.bigIntToMinTwosComplementsHex(e);
  }, this.setByInteger = function(e) {
    var t = new we(String(e), 10);
    this.setByBigInteger(t);
  }, this.setValueHex = function(e) {
    this.hV = e;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof d < "u" && (typeof d.bigint < "u" ? this.setByBigInteger(d.bigint) : typeof d.int < "u" ? this.setByInteger(d.int) : typeof d == "number" ? this.setByInteger(d) : typeof d.hex < "u" && this.setValueHex(d.hex));
};
Qe.lang.extend(fe.asn1.DERInteger, fe.asn1.ASN1Object);
fe.asn1.DERBitString = function(d) {
  if (d !== void 0 && typeof d.obj < "u") {
    var e = fe.asn1.ASN1Util.newObject(d.obj);
    d.hex = "00" + e.getEncodedHex();
  }
  fe.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function(t) {
    this.hTLV = null, this.isModified = !0, this.hV = t;
  }, this.setUnusedBitsAndHexValue = function(t, i) {
    if (t < 0 || 7 < t)
      throw "unused bits shall be from 0 to 7: u = " + t;
    var s = "0" + t;
    this.hTLV = null, this.isModified = !0, this.hV = s + i;
  }, this.setByBinaryString = function(t) {
    t = t.replace(/0+$/, "");
    var i = 8 - t.length % 8;
    i == 8 && (i = 0);
    for (var s = 0; s <= i; s++)
      t += "0";
    for (var n = "", s = 0; s < t.length - 1; s += 8) {
      var r = t.substr(s, 8), a = parseInt(r, 2).toString(16);
      a.length == 1 && (a = "0" + a), n += a;
    }
    this.hTLV = null, this.isModified = !0, this.hV = "0" + i + n;
  }, this.setByBooleanArray = function(t) {
    for (var i = "", s = 0; s < t.length; s++)
      t[s] == !0 ? i += "1" : i += "0";
    this.setByBinaryString(i);
  }, this.newFalseArray = function(t) {
    for (var i = new Array(t), s = 0; s < t; s++)
      i[s] = !1;
    return i;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof d < "u" && (typeof d == "string" && d.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(d) : typeof d.hex < "u" ? this.setHexValueIncludingUnusedBits(d.hex) : typeof d.bin < "u" ? this.setByBinaryString(d.bin) : typeof d.array < "u" && this.setByBooleanArray(d.array));
};
Qe.lang.extend(fe.asn1.DERBitString, fe.asn1.ASN1Object);
fe.asn1.DEROctetString = function(d) {
  if (d !== void 0 && typeof d.obj < "u") {
    var e = fe.asn1.ASN1Util.newObject(d.obj);
    d.hex = e.getEncodedHex();
  }
  fe.asn1.DEROctetString.superclass.constructor.call(this, d), this.hT = "04";
};
Qe.lang.extend(fe.asn1.DEROctetString, fe.asn1.DERAbstractString);
fe.asn1.DERNull = function() {
  fe.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500";
};
Qe.lang.extend(fe.asn1.DERNull, fe.asn1.ASN1Object);
fe.asn1.DERObjectIdentifier = function(d) {
  var e = function(i) {
    var s = i.toString(16);
    return s.length == 1 && (s = "0" + s), s;
  }, t = function(i) {
    var s = "", n = new we(i, 10), r = n.toString(2), a = 7 - r.length % 7;
    a == 7 && (a = 0);
    for (var o = "", c = 0; c < a; c++)
      o += "0";
    r = o + r;
    for (var c = 0; c < r.length - 1; c += 7) {
      var u = r.substr(c, 7);
      c != r.length - 7 && (u = "1" + u), s += e(parseInt(u, 2));
    }
    return s;
  };
  fe.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function(i) {
    this.hTLV = null, this.isModified = !0, this.s = null, this.hV = i;
  }, this.setValueOidString = function(i) {
    if (!i.match(/^[0-9.]+$/))
      throw "malformed oid string: " + i;
    var s = "", n = i.split("."), r = parseInt(n[0]) * 40 + parseInt(n[1]);
    s += e(r), n.splice(0, 2);
    for (var a = 0; a < n.length; a++)
      s += t(n[a]);
    this.hTLV = null, this.isModified = !0, this.s = null, this.hV = s;
  }, this.setValueName = function(i) {
    var s = fe.asn1.x509.OID.name2oid(i);
    if (s !== "")
      this.setValueOidString(s);
    else
      throw "DERObjectIdentifier oidName undefined: " + i;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, d !== void 0 && (typeof d == "string" ? d.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(d) : this.setValueName(d) : d.oid !== void 0 ? this.setValueOidString(d.oid) : d.hex !== void 0 ? this.setValueHex(d.hex) : d.name !== void 0 && this.setValueName(d.name));
};
Qe.lang.extend(fe.asn1.DERObjectIdentifier, fe.asn1.ASN1Object);
fe.asn1.DEREnumerated = function(d) {
  fe.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function(e) {
    this.hTLV = null, this.isModified = !0, this.hV = fe.asn1.ASN1Util.bigIntToMinTwosComplementsHex(e);
  }, this.setByInteger = function(e) {
    var t = new we(String(e), 10);
    this.setByBigInteger(t);
  }, this.setValueHex = function(e) {
    this.hV = e;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof d < "u" && (typeof d.int < "u" ? this.setByInteger(d.int) : typeof d == "number" ? this.setByInteger(d) : typeof d.hex < "u" && this.setValueHex(d.hex));
};
Qe.lang.extend(fe.asn1.DEREnumerated, fe.asn1.ASN1Object);
fe.asn1.DERUTF8String = function(d) {
  fe.asn1.DERUTF8String.superclass.constructor.call(this, d), this.hT = "0c";
};
Qe.lang.extend(fe.asn1.DERUTF8String, fe.asn1.DERAbstractString);
fe.asn1.DERNumericString = function(d) {
  fe.asn1.DERNumericString.superclass.constructor.call(this, d), this.hT = "12";
};
Qe.lang.extend(fe.asn1.DERNumericString, fe.asn1.DERAbstractString);
fe.asn1.DERPrintableString = function(d) {
  fe.asn1.DERPrintableString.superclass.constructor.call(this, d), this.hT = "13";
};
Qe.lang.extend(fe.asn1.DERPrintableString, fe.asn1.DERAbstractString);
fe.asn1.DERTeletexString = function(d) {
  fe.asn1.DERTeletexString.superclass.constructor.call(this, d), this.hT = "14";
};
Qe.lang.extend(fe.asn1.DERTeletexString, fe.asn1.DERAbstractString);
fe.asn1.DERIA5String = function(d) {
  fe.asn1.DERIA5String.superclass.constructor.call(this, d), this.hT = "16";
};
Qe.lang.extend(fe.asn1.DERIA5String, fe.asn1.DERAbstractString);
fe.asn1.DERUTCTime = function(d) {
  fe.asn1.DERUTCTime.superclass.constructor.call(this, d), this.hT = "17", this.setByDate = function(e) {
    this.hTLV = null, this.isModified = !0, this.date = e, this.s = this.formatDate(this.date, "utc"), this.hV = stohex(this.s);
  }, this.getFreshValueHex = function() {
    return typeof this.date > "u" && typeof this.s > "u" && (this.date = /* @__PURE__ */ new Date(), this.s = this.formatDate(this.date, "utc"), this.hV = stohex(this.s)), this.hV;
  }, d !== void 0 && (d.str !== void 0 ? this.setString(d.str) : typeof d == "string" && d.match(/^[0-9]{12}Z$/) ? this.setString(d) : d.hex !== void 0 ? this.setStringHex(d.hex) : d.date !== void 0 && this.setByDate(d.date));
};
Qe.lang.extend(fe.asn1.DERUTCTime, fe.asn1.DERAbstractTime);
fe.asn1.DERGeneralizedTime = function(d) {
  fe.asn1.DERGeneralizedTime.superclass.constructor.call(this, d), this.hT = "18", this.withMillis = !1, this.setByDate = function(e) {
    this.hTLV = null, this.isModified = !0, this.date = e, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = stohex(this.s);
  }, this.getFreshValueHex = function() {
    return this.date === void 0 && this.s === void 0 && (this.date = /* @__PURE__ */ new Date(), this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = stohex(this.s)), this.hV;
  }, d !== void 0 && (d.str !== void 0 ? this.setString(d.str) : typeof d == "string" && d.match(/^[0-9]{14}Z$/) ? this.setString(d) : d.hex !== void 0 ? this.setStringHex(d.hex) : d.date !== void 0 && this.setByDate(d.date), d.millis === !0 && (this.withMillis = !0));
};
Qe.lang.extend(fe.asn1.DERGeneralizedTime, fe.asn1.DERAbstractTime);
fe.asn1.DERSequence = function(d) {
  fe.asn1.DERSequence.superclass.constructor.call(this, d), this.hT = "30", this.getFreshValueHex = function() {
    for (var e = "", t = 0; t < this.asn1Array.length; t++) {
      var i = this.asn1Array[t];
      e += i.getEncodedHex();
    }
    return this.hV = e, this.hV;
  };
};
Qe.lang.extend(fe.asn1.DERSequence, fe.asn1.DERAbstractStructured);
fe.asn1.DERSet = function(d) {
  fe.asn1.DERSet.superclass.constructor.call(this, d), this.hT = "31", this.sortFlag = !0, this.getFreshValueHex = function() {
    for (var e = new Array(), t = 0; t < this.asn1Array.length; t++) {
      var i = this.asn1Array[t];
      e.push(i.getEncodedHex());
    }
    return this.sortFlag == !0 && e.sort(), this.hV = e.join(""), this.hV;
  }, typeof d < "u" && typeof d.sortflag < "u" && d.sortflag == !1 && (this.sortFlag = !1);
};
Qe.lang.extend(fe.asn1.DERSet, fe.asn1.DERAbstractStructured);
fe.asn1.DERTaggedObject = function(d) {
  fe.asn1.DERTaggedObject.superclass.constructor.call(this), this.hT = "a0", this.hV = "", this.isExplicit = !0, this.asn1Object = null, this.setASN1Object = function(e, t, i) {
    this.hT = t, this.isExplicit = e, this.asn1Object = i, this.isExplicit ? (this.hV = this.asn1Object.getEncodedHex(), this.hTLV = null, this.isModified = !0) : (this.hV = null, this.hTLV = i.getEncodedHex(), this.hTLV = this.hTLV.replace(/^../, t), this.isModified = !1);
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof d < "u" && (typeof d.tag < "u" && (this.hT = d.tag), typeof d.explicit < "u" && (this.isExplicit = d.explicit), typeof d.obj < "u" && (this.asn1Object = d.obj, this.setASN1Object(this.isExplicit, this.hT, this.asn1Object)));
};
Qe.lang.extend(fe.asn1.DERTaggedObject, fe.asn1.ASN1Object);
class Hi extends Fm {
  constructor(e) {
    super(), e && (typeof e == "string" ? this.parseKey(e) : (Hi.hasPrivateKeyProperty(e) || Hi.hasPublicKeyProperty(e)) && this.parsePropertiesFrom(e));
  }
  /**
   * Method to parse a pem encoded string containing both a public or private key.
   * The method will translate the pem encoded string in a der encoded string and
   * will parse private key and public key parameters. This method accepts public key
   * in the rsaencryption pkcs #1 format (oid: 1.2.840.113549.1.1.1).
   *
   * @todo Check how many rsa formats use the same format of pkcs #1.
   *
   * The format is defined as:
   * PublicKeyInfo ::= SEQUENCE {
   *   algorithm       AlgorithmIdentifier,
   *   PublicKey       BIT STRING
   * }
   * Where AlgorithmIdentifier is:
   * AlgorithmIdentifier ::= SEQUENCE {
   *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
   *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
   * }
   * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
   * RSAPublicKey ::= SEQUENCE {
   *   modulus           INTEGER,  -- n
   *   publicExponent    INTEGER   -- e
   * }
   * it's possible to examine the structure of the keys obtained from openssl using
   * an asn.1 dumper as the one used here to parse the components: http://lapo.it/asn1js/
   * @argument {string} pem the pem encoded string, can include the BEGIN/END header/footer
   * @private
   */
  parseKey(e) {
    try {
      let s = 0, n = 0;
      const a = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/.test(e) ? km.decode(e) : Ys.unarmor(e);
      let o = Gi.decode(a);
      if (o.sub.length === 3 && (o = o.sub[2].sub[0]), o.sub.length === 9) {
        s = o.sub[1].getHexStringValue(), this.n = Ke(s, 16), n = o.sub[2].getHexStringValue(), this.e = parseInt(n, 16);
        const c = o.sub[3].getHexStringValue();
        this.d = Ke(c, 16);
        const u = o.sub[4].getHexStringValue();
        this.p = Ke(u, 16);
        const f = o.sub[5].getHexStringValue();
        this.q = Ke(f, 16);
        const h = o.sub[6].getHexStringValue();
        this.dmp1 = Ke(h, 16);
        const l = o.sub[7].getHexStringValue();
        this.dmq1 = Ke(l, 16);
        const p = o.sub[8].getHexStringValue();
        this.coeff = Ke(p, 16);
      } else if (o.sub.length === 2)
        if (o.sub[0].sub) {
          var t = o.sub[1], i = t.sub[0];
          s = i.sub[0].getHexStringValue(), this.n = Ke(s, 16), n = i.sub[1].getHexStringValue(), this.e = parseInt(n, 16);
        } else
          s = o.sub[0].getHexStringValue(), this.n = Ke(s, 16), n = o.sub[1].getHexStringValue(), this.e = parseInt(n, 16);
      else
        return !1;
      return !0;
    } catch {
      return !1;
    }
  }
  /**
   * Translate rsa parameters in a hex encoded string representing the rsa key.
   *
   * The translation follow the ASN.1 notation :
   * RSAPrivateKey ::= SEQUENCE {
   *   version           Version,
   *   modulus           INTEGER,  -- n
   *   publicExponent    INTEGER,  -- e
   *   privateExponent   INTEGER,  -- d
   *   prime1            INTEGER,  -- p
   *   prime2            INTEGER,  -- q
   *   exponent1         INTEGER,  -- d mod (p1)
   *   exponent2         INTEGER,  -- d mod (q-1)
   *   coefficient       INTEGER,  -- (inverse of q) mod p
   * }
   * @returns {string}  DER Encoded String representing the rsa private key
   * @private
   */
  getPrivateBaseKey() {
    const e = {
      array: [
        new fe.asn1.DERInteger({ int: 0 }),
        new fe.asn1.DERInteger({ bigint: this.n }),
        new fe.asn1.DERInteger({ int: this.e }),
        new fe.asn1.DERInteger({ bigint: this.d }),
        new fe.asn1.DERInteger({ bigint: this.p }),
        new fe.asn1.DERInteger({ bigint: this.q }),
        new fe.asn1.DERInteger({ bigint: this.dmp1 }),
        new fe.asn1.DERInteger({ bigint: this.dmq1 }),
        new fe.asn1.DERInteger({ bigint: this.coeff })
      ]
    };
    return new fe.asn1.DERSequence(e).getEncodedHex();
  }
  /**
   * base64 (pem) encoded version of the DER encoded representation
   * @returns {string} pem encoded representation without header and footer
   * @public
   */
  getPrivateBaseKeyB64() {
    return $n(this.getPrivateBaseKey());
  }
  /**
   * Translate rsa parameters in a hex encoded string representing the rsa public key.
   * The representation follow the ASN.1 notation :
   * PublicKeyInfo ::= SEQUENCE {
   *   algorithm       AlgorithmIdentifier,
   *   PublicKey       BIT STRING
   * }
   * Where AlgorithmIdentifier is:
   * AlgorithmIdentifier ::= SEQUENCE {
   *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
   *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
   * }
   * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
   * RSAPublicKey ::= SEQUENCE {
   *   modulus           INTEGER,  -- n
   *   publicExponent    INTEGER   -- e
   * }
   * @returns {string} DER Encoded String representing the rsa public key
   * @private
   */
  getPublicBaseKey() {
    const e = new fe.asn1.DERSequence({
      array: [
        new fe.asn1.DERObjectIdentifier({ oid: "1.2.840.113549.1.1.1" }),
        new fe.asn1.DERNull()
      ]
    }), t = new fe.asn1.DERSequence({
      array: [
        new fe.asn1.DERInteger({ bigint: this.n }),
        new fe.asn1.DERInteger({ int: this.e })
      ]
    }), i = new fe.asn1.DERBitString({
      hex: "00" + t.getEncodedHex()
    });
    return new fe.asn1.DERSequence({
      array: [e, i]
    }).getEncodedHex();
  }
  /**
   * base64 (pem) encoded version of the DER encoded representation
   * @returns {string} pem encoded representation without header and footer
   * @public
   */
  getPublicBaseKeyB64() {
    return $n(this.getPublicBaseKey());
  }
  /**
   * wrap the string in block of width chars. The default value for rsa keys is 64
   * characters.
   * @param {string} str the pem encoded string without header and footer
   * @param {Number} [width=64] - the length the string has to be wrapped at
   * @returns {string}
   * @private
   */
  static wordwrap(e, t) {
    if (t = t || 64, !e)
      return e;
    const i = "(.{1," + t + `})( +|$
?)|(.{1,` + t + "})";
    return e.match(RegExp(i, "g")).join(`
`);
  }
  /**
   * Retrieve the pem encoded private key
   * @returns {string} the pem encoded private key with header/footer
   * @public
   */
  getPrivateKey() {
    let e = `-----BEGIN RSA PRIVATE KEY-----
`;
    return e += Hi.wordwrap(this.getPrivateBaseKeyB64()) + `
`, e += "-----END RSA PRIVATE KEY-----", e;
  }
  /**
   * Retrieve the pem encoded public key
   * @returns {string} the pem encoded public key with header/footer
   * @public
   */
  getPublicKey() {
    let e = `-----BEGIN PUBLIC KEY-----
`;
    return e += Hi.wordwrap(this.getPublicBaseKeyB64()) + `
`, e += "-----END PUBLIC KEY-----", e;
  }
  /**
   * Check if the object contains the necessary parameters to populate the rsa modulus
   * and public exponent parameters.
   * @param {object} [obj={}] - An object that may contain the two public key
   * parameters
   * @returns {boolean} true if the object contains both the modulus and the public exponent
   * properties (n and e)
   * @todo check for types of n and e. N should be a parseable bigInt object, E should
   * be a parseable integer number
   * @private
   */
  static hasPublicKeyProperty(e) {
    return e = e || {}, e.hasOwnProperty("n") && e.hasOwnProperty("e");
  }
  /**
   * Check if the object contains ALL the parameters of an RSA key.
   * @param {object} [obj={}] - An object that may contain nine rsa key
   * parameters
   * @returns {boolean} true if the object contains all the parameters needed
   * @todo check for types of the parameters all the parameters but the public exponent
   * should be parseable bigint objects, the public exponent should be a parseable integer number
   * @private
   */
  static hasPrivateKeyProperty(e) {
    return e = e || {}, e.hasOwnProperty("n") && e.hasOwnProperty("e") && e.hasOwnProperty("d") && e.hasOwnProperty("p") && e.hasOwnProperty("q") && e.hasOwnProperty("dmp1") && e.hasOwnProperty("dmq1") && e.hasOwnProperty("coeff");
  }
  /**
   * Parse the properties of obj in the current rsa object. Obj should AT LEAST
   * include the modulus and public exponent (n, e) parameters.
   * @param {object} obj - the object containing rsa parameters
   * @private
   */
  parsePropertiesFrom(e) {
    this.n = e.n, this.e = e.e, e.hasOwnProperty("d") && (this.d = e.d, this.p = e.p, this.q = e.q, this.dmp1 = e.dmp1, this.dmq1 = e.dmq1, this.coeff = e.coeff);
  }
}
var lc;
const zm = typeof Ce < "u" ? (lc = Ce.env) == null ? void 0 : lc.npm_package_version : void 0;
class Ou {
  constructor(e = {}) {
    e = e || {}, this.default_key_size = e.default_key_size ? parseInt(e.default_key_size, 10) : 1024, this.default_public_exponent = e.default_public_exponent || "010001", this.log = e.log || !1, this.key = null;
  }
  /**
   * Method to set the rsa key parameter (one method is enough to set both the public
   * and the private key, since the private key contains the public key paramenters)
   * Log a warning if logs are enabled
   * @param {Object|string} key the pem encoded string or an object (with or without header/footer)
   * @public
   */
  setKey(e) {
    this.log && this.key && console.warn("A key was already set, overriding existing."), this.key = new Hi(e);
  }
  /**
   * Proxy method for setKey, for api compatibility
   * @see setKey
   * @public
   */
  setPrivateKey(e) {
    this.setKey(e);
  }
  /**
   * Proxy method for setKey, for api compatibility
   * @see setKey
   * @public
   */
  setPublicKey(e) {
    this.setKey(e);
  }
  /**
   * Proxy method for RSAKey object's decrypt, decrypt the string using the private
   * components of the rsa key object. Note that if the object was not set will be created
   * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
   * @param {string} str base64 encoded crypted string to decrypt
   * @return {string} the decrypted string
   * @public
   */
  decrypt(e) {
    try {
      return this.getKey().decrypt(md(e));
    } catch {
      return !1;
    }
  }
  /**
   * Proxy method for RSAKey object's encrypt, encrypt the string using the public
   * components of the rsa key object. Note that if the object was not set will be created
   * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
   * @param {string} str the string to encrypt
   * @return {string} the encrypted string encoded in base64
   * @public
   */
  encrypt(e) {
    try {
      return $n(this.getKey().encrypt(e));
    } catch {
      return !1;
    }
  }
  /**
   * Proxy method for RSAKey object's sign.
   * @param {string} str the string to sign
   * @param {function} digestMethod hash method
   * @param {string} digestName the name of the hash algorithm
   * @return {string} the signature encoded in base64
   * @public
   */
  sign(e, t, i) {
    try {
      return $n(this.getKey().sign(e, t, i));
    } catch {
      return !1;
    }
  }
  /**
   * Proxy method for RSAKey object's verify.
   * @param {string} str the string to verify
   * @param {string} signature the signature encoded in base64 to compare the string to
   * @param {function} digestMethod hash method
   * @return {boolean} whether the data and signature match
   * @public
   */
  verify(e, t, i) {
    try {
      return this.getKey().verify(e, md(t), i);
    } catch {
      return !1;
    }
  }
  /**
   * Getter for the current JSEncryptRSAKey object. If it doesn't exists a new object
   * will be created and returned
   * @param {callback} [cb] the callback to be called if we want the key to be generated
   * in an async fashion
   * @returns {JSEncryptRSAKey} the JSEncryptRSAKey object
   * @public
   */
  getKey(e) {
    if (!this.key) {
      if (this.key = new Hi(), e && {}.toString.call(e) === "[object Function]") {
        this.key.generateAsync(this.default_key_size, this.default_public_exponent, e);
        return;
      }
      this.key.generate(this.default_key_size, this.default_public_exponent);
    }
    return this.key;
  }
  /**
   * Returns the pem encoded representation of the private key
   * If the key doesn't exists a new key will be created
   * @returns {string} pem encoded representation of the private key WITH header and footer
   * @public
   */
  getPrivateKey() {
    return this.getKey().getPrivateKey();
  }
  /**
   * Returns the pem encoded representation of the private key
   * If the key doesn't exists a new key will be created
   * @returns {string} pem encoded representation of the private key WITHOUT header and footer
   * @public
   */
  getPrivateKeyB64() {
    return this.getKey().getPrivateBaseKeyB64();
  }
  /**
   * Returns the pem encoded representation of the public key
   * If the key doesn't exists a new key will be created
   * @returns {string} pem encoded representation of the public key WITH header and footer
   * @public
   */
  getPublicKey() {
    return this.getKey().getPublicKey();
  }
  /**
   * Returns the pem encoded representation of the public key
   * If the key doesn't exists a new key will be created
   * @returns {string} pem encoded representation of the public key WITHOUT header and footer
   * @public
   */
  getPublicKeyB64() {
    return this.getKey().getPublicBaseKeyB64();
  }
}
Ou.version = zm;
function Zn(d, e, t) {
  const i = new Ou(), s = (r) => Ri.encode(t(r));
  i.setPrivateKey(e);
  const n = t.create().constructor.name.toLowerCase();
  return i.sign(d, s, n);
}
function Hm(d, e, t, i = !1, s = {}) {
  let n = (i ? "RS" : "HS") + t.outputLen * 8;
  s.alg && (n = s.alg.toUpperCase());
  const r = Object.assign({ alg: n, typ: "JWT" }, s);
  r.iat !== void 0 && (d.iat = r.iat, delete r.iat);
  const a = os(JSON.stringify(r)), o = os(JSON.stringify(d)), c = [a, o].join("."), u = n.slice(0, 2);
  let f;
  if (u === "HS")
    f = os(lo(c, e, t, "binary"));
  else if (i || u === "RS")
    f = os(Uc(Zn(c, ai.encode(e), t)));
  else if (u === "ES") {
    const h = hu(c, ai.encode(e), ho, t), l = h.r.padStart(64, "0"), p = h.s.padStart(64, "0");
    f = os(Gc(l + p));
  }
  return [c, f].join(".");
}
const Mn = BigInt(2 ** 32 - 1), Ea = BigInt(32);
function Mu(d, e = !1) {
  return e ? { h: Number(d & Mn), l: Number(d >> Ea & Mn) } : { h: Number(d >> Ea & Mn) | 0, l: Number(d & Mn) | 0 };
}
function Wm(d, e = !1) {
  let t = new Uint32Array(d.length), i = new Uint32Array(d.length);
  for (let s = 0; s < d.length; s++) {
    const { h: n, l: r } = Mu(d[s], e);
    [t[s], i[s]] = [n, r];
  }
  return [t, i];
}
const Ym = (d, e) => BigInt(d >>> 0) << Ea | BigInt(e >>> 0), Km = (d, e, t) => d >>> t, Xm = (d, e, t) => d << 32 - t | e >>> t, $m = (d, e, t) => d >>> t | e << 32 - t, Zm = (d, e, t) => d << 32 - t | e >>> t, Qm = (d, e, t) => d << 64 - t | e >>> t - 32, Jm = (d, e, t) => d >>> t - 32 | e << 64 - t, ey = (d, e) => e, ty = (d, e) => d, iy = (d, e, t) => d << t | e >>> 32 - t, sy = (d, e, t) => e << t | d >>> 32 - t, ny = (d, e, t) => e << t - 32 | d >>> 64 - t, ry = (d, e, t) => d << t - 32 | e >>> 64 - t;
function ay(d, e, t, i) {
  const s = (e >>> 0) + (i >>> 0);
  return { h: d + t + (s / 2 ** 32 | 0) | 0, l: s | 0 };
}
const oy = (d, e, t) => (d >>> 0) + (e >>> 0) + (t >>> 0), dy = (d, e, t, i) => e + t + i + (d / 2 ** 32 | 0) | 0, cy = (d, e, t, i) => (d >>> 0) + (e >>> 0) + (t >>> 0) + (i >>> 0), uy = (d, e, t, i, s) => e + t + i + s + (d / 2 ** 32 | 0) | 0, fy = (d, e, t, i, s) => (d >>> 0) + (e >>> 0) + (t >>> 0) + (i >>> 0) + (s >>> 0), hy = (d, e, t, i, s, n) => e + t + i + s + n + (d / 2 ** 32 | 0) | 0, Oe = {
  fromBig: Mu,
  split: Wm,
  toBig: Ym,
  shrSH: Km,
  shrSL: Xm,
  rotrSH: $m,
  rotrSL: Zm,
  rotrBH: Qm,
  rotrBL: Jm,
  rotr32H: ey,
  rotr32L: ty,
  rotlSH: iy,
  rotlSL: sy,
  rotlBH: ny,
  rotlBL: ry,
  add: ay,
  add3L: oy,
  add3H: dy,
  add4L: cy,
  add4H: uy,
  add5H: hy,
  add5L: fy
}, [ly, py] = Oe.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((d) => BigInt(d))), Si = new Uint32Array(80), Ti = new Uint32Array(80);
class wr extends io {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: t, Bh: i, Bl: s, Ch: n, Cl: r, Dh: a, Dl: o, Eh: c, El: u, Fh: f, Fl: h, Gh: l, Gl: p, Hh: m, Hl: y } = this;
    return [e, t, i, s, n, r, a, o, c, u, f, h, l, p, m, y];
  }
  // prettier-ignore
  set(e, t, i, s, n, r, a, o, c, u, f, h, l, p, m, y) {
    this.Ah = e | 0, this.Al = t | 0, this.Bh = i | 0, this.Bl = s | 0, this.Ch = n | 0, this.Cl = r | 0, this.Dh = a | 0, this.Dl = o | 0, this.Eh = c | 0, this.El = u | 0, this.Fh = f | 0, this.Fl = h | 0, this.Gh = l | 0, this.Gl = p | 0, this.Hh = m | 0, this.Hl = y | 0;
  }
  process(e, t) {
    for (let b = 0; b < 16; b++, t += 4)
      Si[b] = e.getUint32(t), Ti[b] = e.getUint32(t += 4);
    for (let b = 16; b < 80; b++) {
      const T = Si[b - 15] | 0, x = Ti[b - 15] | 0, v = Oe.rotrSH(T, x, 1) ^ Oe.rotrSH(T, x, 8) ^ Oe.shrSH(T, x, 7), _ = Oe.rotrSL(T, x, 1) ^ Oe.rotrSL(T, x, 8) ^ Oe.shrSL(T, x, 7), V = Si[b - 2] | 0, j = Ti[b - 2] | 0, G = Oe.rotrSH(V, j, 19) ^ Oe.rotrBH(V, j, 61) ^ Oe.shrSH(V, j, 6), W = Oe.rotrSL(V, j, 19) ^ Oe.rotrBL(V, j, 61) ^ Oe.shrSL(V, j, 6), B = Oe.add4L(_, W, Ti[b - 7], Ti[b - 16]), Q = Oe.add4H(B, v, G, Si[b - 7], Si[b - 16]);
      Si[b] = Q | 0, Ti[b] = B | 0;
    }
    let { Ah: i, Al: s, Bh: n, Bl: r, Ch: a, Cl: o, Dh: c, Dl: u, Eh: f, El: h, Fh: l, Fl: p, Gh: m, Gl: y, Hh: w, Hl: S } = this;
    for (let b = 0; b < 80; b++) {
      const T = Oe.rotrSH(f, h, 14) ^ Oe.rotrSH(f, h, 18) ^ Oe.rotrBH(f, h, 41), x = Oe.rotrSL(f, h, 14) ^ Oe.rotrSL(f, h, 18) ^ Oe.rotrBL(f, h, 41), v = f & l ^ ~f & m, _ = h & p ^ ~h & y, V = Oe.add5L(S, x, _, py[b], Ti[b]), j = Oe.add5H(V, w, T, v, ly[b], Si[b]), G = V | 0, W = Oe.rotrSH(i, s, 28) ^ Oe.rotrBH(i, s, 34) ^ Oe.rotrBH(i, s, 39), B = Oe.rotrSL(i, s, 28) ^ Oe.rotrBL(i, s, 34) ^ Oe.rotrBL(i, s, 39), Q = i & n ^ i & a ^ n & a, se = s & r ^ s & o ^ r & o;
      w = m | 0, S = y | 0, m = l | 0, y = p | 0, l = f | 0, p = h | 0, { h: f, l: h } = Oe.add(c | 0, u | 0, j | 0, G | 0), c = a | 0, u = o | 0, a = n | 0, o = r | 0, n = i | 0, r = s | 0;
      const $ = Oe.add3L(G, B, se);
      i = Oe.add3H($, j, W, Q), s = $ | 0;
    }
    ({ h: i, l: s } = Oe.add(this.Ah | 0, this.Al | 0, i | 0, s | 0)), { h: n, l: r } = Oe.add(this.Bh | 0, this.Bl | 0, n | 0, r | 0), { h: a, l: o } = Oe.add(this.Ch | 0, this.Cl | 0, a | 0, o | 0), { h: c, l: u } = Oe.add(this.Dh | 0, this.Dl | 0, c | 0, u | 0), { h: f, l: h } = Oe.add(this.Eh | 0, this.El | 0, f | 0, h | 0), { h: l, l: p } = Oe.add(this.Fh | 0, this.Fl | 0, l | 0, p | 0), { h: m, l: y } = Oe.add(this.Gh | 0, this.Gl | 0, m | 0, y | 0), { h: w, l: S } = Oe.add(this.Hh | 0, this.Hl | 0, w | 0, S | 0), this.set(i, s, n, r, a, o, c, u, f, h, l, p, m, y, w, S);
  }
  roundClean() {
    Si.fill(0), Ti.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
class gy extends wr {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
class my extends wr {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
class yy extends wr {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
}
const Ss = Zi(() => new wr());
Zi(() => new gy());
Zi(() => new my());
const wy = Zi(() => new yy()), Jt = BigInt(0), Mt = BigInt(1), Cn = BigInt(2), by = BigInt(8);
function Sy(d) {
  const e = ro(d);
  return Bi(d, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...e });
}
function Io(d) {
  const e = Sy(d), { Fp: t, n: i, preHash: s, hash: n, randomBytes: r, nByteLength: a, h: o } = e, c = Cn ** BigInt(a * 8), u = t.create, f = e.uvRatio || ((N, L) => {
    try {
      return { isValid: !0, value: t.sqrt(N * t.inv(L)) };
    } catch {
      return { isValid: !1, value: Jt };
    }
  }), h = e.adjustScalarBytes || ((N) => N), l = e.domain || ((N, L, z) => {
    if (L.length || z)
      throw new Error("Contexts/pre-hash are not supported");
    return N;
  }), p = (N) => typeof N == "bigint" && 0n < N, m = (N, L) => p(N) && p(L) && N < L, y = (N) => N === Jt || m(N, c);
  function w(N, L) {
    if (m(N, L))
      return N;
    throw new Error(`Expected valid scalar < ${L}, got ${typeof N} ${N}`);
  }
  function S(N) {
    return N === Jt ? N : w(N, i);
  }
  const b = /* @__PURE__ */ new Map();
  function T(N) {
    if (!(N instanceof x))
      throw new Error("ExtendedPoint expected");
  }
  class x {
    constructor(L, z, K, R) {
      if (this.ex = L, this.ey = z, this.ez = K, this.et = R, !y(L))
        throw new Error("x required");
      if (!y(z))
        throw new Error("y required");
      if (!y(K))
        throw new Error("z required");
      if (!y(R))
        throw new Error("t required");
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(L) {
      if (L instanceof x)
        throw new Error("extended point not allowed");
      const { x: z, y: K } = L || {};
      if (!y(z) || !y(K))
        throw new Error("invalid affine point");
      return new x(z, K, Mt, u(z * K));
    }
    static normalizeZ(L) {
      const z = t.invertBatch(L.map((K) => K.ez));
      return L.map((K, R) => K.toAffine(z[R])).map(x.fromAffine);
    }
    // "Private method", don't use it directly
    _setWindowSize(L) {
      this._WINDOW_SIZE = L, b.delete(this);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      const { a: L, d: z } = e;
      if (this.is0())
        throw new Error("bad point: ZERO");
      const { ex: K, ey: R, ez: U, et: Y } = this, J = u(K * K), ae = u(R * R), A = u(U * U), M = u(A * A), q = u(J * L), H = u(A * u(q + ae)), le = u(M + u(z * u(J * ae)));
      if (H !== le)
        throw new Error("bad point: equation left != right (1)");
      const oe = u(K * R), he = u(U * Y);
      if (oe !== he)
        throw new Error("bad point: equation left != right (2)");
    }
    // Compare one point to another.
    equals(L) {
      T(L);
      const { ex: z, ey: K, ez: R } = this, { ex: U, ey: Y, ez: J } = L, ae = u(z * J), A = u(U * R), M = u(K * J), q = u(Y * R);
      return ae === A && M === q;
    }
    is0() {
      return this.equals(x.ZERO);
    }
    negate() {
      return new x(u(-this.ex), this.ey, this.ez, u(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: L } = e, { ex: z, ey: K, ez: R } = this, U = u(z * z), Y = u(K * K), J = u(Cn * u(R * R)), ae = u(L * U), A = z + K, M = u(u(A * A) - U - Y), q = ae + Y, H = q - J, le = ae - Y, oe = u(M * H), he = u(q * le), Ie = u(M * le), Pe = u(H * q);
      return new x(oe, he, Pe, Ie);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(L) {
      T(L);
      const { a: z, d: K } = e, { ex: R, ey: U, ez: Y, et: J } = this, { ex: ae, ey: A, ez: M, et: q } = L;
      if (z === BigInt(-1)) {
        const Le = u((U - R) * (A + ae)), De = u((U + R) * (A - ae)), Je = u(De - Le);
        if (Je === Jt)
          return this.double();
        const nt = u(Y * Cn * q), ks = u(J * Cn * M), Es = ks + nt, Ns = De + Le, Qt = ks - nt, Ps = u(Es * Je), ln = u(Ns * Qt), _r = u(Es * Qt), pn = u(Je * Ns);
        return new x(Ps, ln, pn, _r);
      }
      const H = u(R * ae), le = u(U * A), oe = u(J * K * q), he = u(Y * M), Ie = u((R + U) * (ae + A) - H - le), Pe = he - oe, He = he + oe, bt = u(le - z * H), mt = u(Ie * Pe), ue = u(He * bt), Tt = u(Ie * bt), Ot = u(Pe * He);
      return new x(mt, ue, Ot, Tt);
    }
    subtract(L) {
      return this.add(L.negate());
    }
    wNAF(L) {
      return V.wNAFCached(this, b, L, x.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(L) {
      const { p: z, f: K } = this.wNAF(w(L, i));
      return x.normalizeZ([z, K])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    multiplyUnsafe(L) {
      let z = S(L);
      return z === Jt ? _ : this.equals(_) || z === Mt ? this : this.equals(v) ? this.wNAF(z).p : V.unsafeLadder(this, z);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(o).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return V.unsafeLadder(this, i).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(L) {
      const { ex: z, ey: K, ez: R } = this, U = this.is0();
      L == null && (L = U ? by : t.inv(R));
      const Y = u(z * L), J = u(K * L), ae = u(R * L);
      if (U)
        return { x: Jt, y: Mt };
      if (ae !== Mt)
        throw new Error("invZ was invalid");
      return { x: Y, y: J };
    }
    clearCofactor() {
      const { h: L } = e;
      return L === Mt ? this : this.multiplyUnsafe(L);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(L, z = !0) {
      const { d: K, a: R } = e, U = t.BYTES;
      L = Ne("pointHex", L, U);
      const Y = L.slice(), J = L[U - 1];
      Y[U - 1] = J & -129;
      const ae = Wt(Y);
      ae === Jt || (z ? w(ae, t.ORDER) : w(ae, c));
      const A = u(ae * ae), M = u(A - Mt), q = u(K * A - R);
      let { isValid: H, value: le } = f(M, q);
      if (!H)
        throw new Error("Point.fromHex: invalid y coordinate");
      const oe = (le & Mt) === Mt;
      return (J & 128) !== 0 !== oe && (le = u(-le)), x.fromAffine({ x: le, y: ae });
    }
    static fromPrivateKey(L) {
      return W(L).point;
    }
    toRawBytes() {
      const { x: L, y: z } = this.toAffine(), K = Kt(z, t.BYTES);
      return K[K.length - 1] |= L & Mt ? 128 : 0, K;
    }
    toHex() {
      return ki(this.toRawBytes());
    }
  }
  x.BASE = new x(e.Gx, e.Gy, Mt, u(e.Gx * e.Gy)), x.ZERO = new x(Jt, Mt, Mt, Jt);
  const { BASE: v, ZERO: _ } = x, V = Jc(x, a * 8);
  function j(N) {
    return _e(N, i);
  }
  function G(N) {
    return j(Wt(N));
  }
  function W(N) {
    const L = a;
    N = Ne("private key", N, L);
    const z = Ne("hashed private key", n(N), 2 * L), K = h(z.slice(0, L)), R = z.slice(L, 2 * L), U = G(K), Y = v.multiply(U), J = Y.toRawBytes();
    return { head: K, prefix: R, scalar: U, point: Y, pointBytes: J };
  }
  function B(N) {
    return W(N).pointBytes;
  }
  function Q(N = new Uint8Array(), ...L) {
    const z = ot(...L);
    return G(n(l(z, Ne("context", N), !!s)));
  }
  function se(N, L, z) {
    N = Ne("message", N), s && (N = s(N));
    const { prefix: K, scalar: R, pointBytes: U } = W(L), Y = Q(z, K, N), J = v.multiply(Y).toRawBytes(), ae = Q(z, J, U, N), A = j(Y + ae * R);
    S(A);
    const M = ot(J, Kt(A, t.BYTES));
    return Ne("result", M, a * 2);
  }
  function $(N, L, z) {
    N = Ne("message", N);
    const K = Ne("privKey", L), R = Wt(K), U = v.multiply(j(R)).toRawBytes(), Y = U[31] & 128, J = Q(z, K, N), ae = v.multiply(J).toRawBytes(), M = Q(z, ae, U, N) * R, q = j(J + M);
    S(q);
    const H = Kt(q, t.BYTES);
    H[31] |= Y;
    const le = ot(ae, H);
    return Ne("result", le, a * 2);
  }
  function te(N, L, z, K) {
    const R = t.BYTES;
    N = Ne("signature", N, 2 * R), L = Ne("message", L), s && (L = s(L));
    const U = x.fromHex(z, !1), Y = x.fromHex(N.slice(0, R), !1), J = Wt(N.slice(R, 2 * R)), ae = v.multiplyUnsafe(J), A = Q(K, Y.toRawBytes(), U.toRawBytes(), L);
    return Y.add(U.multiplyUnsafe(A)).subtract(ae).clearCofactor().equals(x.ZERO);
  }
  return v._setWindowSize(8), {
    CURVE: e,
    getPublicKey: B,
    sign: se,
    signModified: $,
    verify: te,
    ExtendedPoint: x,
    utils: {
      getExtendedPublicKey: W,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => r(t.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(N = 8, L = x.BASE) {
        return L._setWindowSize(N), L.multiply(BigInt(3)), L;
      }
    }
  };
}
const Vs = BigInt(0), Wr = BigInt(1);
function Ty(d) {
  return Bi(d, {
    a: "bigint"
  }, {
    montgomeryBits: "isSafeInteger",
    nByteLength: "isSafeInteger",
    adjustScalarBytes: "function",
    domain: "function",
    powPminus2: "function",
    Gu: "bigint"
  }), Object.freeze({ ...d });
}
function Ay(d) {
  const e = Ty(d), { P: t } = e, i = (b) => _e(b, t), s = e.montgomeryBits, n = Math.ceil(s / 8), r = e.nByteLength, a = e.adjustScalarBytes || ((b) => b), o = e.powPminus2 || ((b) => Zc(b, t - BigInt(2), t));
  function c(b, T, x) {
    const v = i(b * (T - x));
    return T = i(T - v), x = i(x + v), [T, x];
  }
  function u(b) {
    if (typeof b == "bigint" && Vs <= b && b < t)
      return b;
    throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
  }
  const f = (e.a - BigInt(2)) / BigInt(4);
  function h(b, T) {
    const x = u(b), v = u(T), _ = x;
    let V = Wr, j = Vs, G = x, W = Wr, B = Vs, Q;
    for (let $ = BigInt(s - 1); $ >= Vs; $--) {
      const te = v >> $ & Wr;
      B ^= te, Q = c(B, V, G), V = Q[0], G = Q[1], Q = c(B, j, W), j = Q[0], W = Q[1], B = te;
      const E = V + j, N = i(E * E), L = V - j, z = i(L * L), K = N - z, R = G + W, U = G - W, Y = i(U * E), J = i(R * L), ae = Y + J, A = Y - J;
      G = i(ae * ae), W = i(_ * i(A * A)), V = i(N * z), j = i(K * (N + i(f * K)));
    }
    Q = c(B, V, G), V = Q[0], G = Q[1], Q = c(B, j, W), j = Q[0], W = Q[1];
    const se = o(j);
    return i(V * se);
  }
  function l(b) {
    return Kt(i(b), n);
  }
  function p(b) {
    const T = Ne("u coordinate", b, n);
    return r === n && (T[r - 1] &= 127), Wt(T);
  }
  function m(b) {
    const T = Ne("scalar", b);
    if (T.length !== n && T.length !== r)
      throw new Error(`Expected ${n} or ${r} bytes, got ${T.length}`);
    return Wt(a(T));
  }
  function y(b, T) {
    const x = p(T), v = m(b), _ = h(x, v);
    if (_ === Vs)
      throw new Error("Invalid private or public key received");
    return l(_);
  }
  const w = l(e.Gu);
  function S(b) {
    return y(b, w);
  }
  return {
    scalarMult: y,
    scalarMultBase: S,
    getSharedSecret: (b, T) => y(b, T),
    getPublicKey: (b) => S(b),
    utils: { randomPrivateKey: () => e.randomBytes(e.nByteLength) },
    GuBytes: w
  };
}
const Qs = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), Md = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752"), Iy = BigInt(0), si = BigInt(1), Qn = BigInt(2), Oy = BigInt(5), Cd = BigInt(10), My = BigInt(20), Cy = BigInt(40), xd = BigInt(80);
function Cu(d) {
  const e = Qs, i = d * d % e * d % e, s = Ge(i, Qn, e) * i % e, n = Ge(s, si, e) * d % e, r = Ge(n, Oy, e) * n % e, a = Ge(r, Cd, e) * r % e, o = Ge(a, My, e) * a % e, c = Ge(o, Cy, e) * o % e, u = Ge(c, xd, e) * c % e, f = Ge(u, xd, e) * c % e, h = Ge(f, Cd, e) * r % e;
  return { pow_p_5_8: Ge(h, Qn, e) * d % e, b2: i };
}
function xu(d) {
  return d[0] &= 248, d[31] &= 127, d[31] |= 64, d;
}
function Oo(d, e) {
  const t = Qs, i = _e(e * e * e, t), s = _e(i * i * e, t), n = Cu(d * s).pow_p_5_8;
  let r = _e(d * i * n, t);
  const a = _e(e * r * r, t), o = r, c = _e(r * Md, t), u = a === d, f = a === _e(-d, t), h = a === _e(-d * Md, t);
  return u && (r = o), (f || h) && (r = c), Ai(r, t) && (r = _e(-r, t)), { isValid: u || f, value: r };
}
const me = no(Qs, void 0, !0), Mo = {
  // Param: a
  a: BigInt(-1),
  // Equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n ** 255n - 19n
  Fp: me,
  // Subgroup order: how many points ed25519 has
  // 2n ** 252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: BigInt(8),
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: Ss,
  randomBytes: hr,
  adjustScalarBytes: xu,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: Oo
}, at = Io(Mo);
function vu(d, e, t) {
  if (e.length > 255)
    throw new Error("Context is too big");
  return Wc(Hc("SigEd25519 no Ed25519 collisions"), new Uint8Array([t ? 1 : 0, e.length]), e, d);
}
Io({ ...Mo, domain: vu });
Io({
  ...Mo,
  domain: vu,
  preHash: Ss
});
Ay({
  P: Qs,
  a: BigInt(486662),
  montgomeryBits: 255,
  nByteLength: 32,
  Gu: BigInt(9),
  powPminus2: (d) => {
    const e = Qs, { pow_p_5_8: t, b2: i } = Cu(d);
    return _e(Ge(t, BigInt(3), e) * i, e);
  },
  adjustScalarBytes: xu,
  randomBytes: hr
});
const xy = (me.ORDER + BigInt(3)) / BigInt(8), vy = me.pow(Qn, xy), vd = me.sqrt(me.neg(me.ONE)), ky = (me.ORDER - BigInt(5)) / BigInt(8), kd = BigInt(486662);
function Ey(d) {
  let e = me.sqr(d);
  e = me.mul(e, Qn);
  let t = me.add(e, me.ONE), i = me.neg(kd), s = me.sqr(t), n = me.mul(s, t), r = me.mul(e, kd);
  r = me.mul(r, i), r = me.add(r, s), r = me.mul(r, i);
  let a = me.sqr(n);
  s = me.sqr(a), a = me.mul(a, n), a = me.mul(a, r), s = me.mul(s, a);
  let o = me.pow(s, ky);
  o = me.mul(o, a);
  let c = me.mul(o, vd);
  s = me.sqr(o), s = me.mul(s, n);
  let u = me.eql(s, r), f = me.cmov(c, o, u), h = me.mul(i, e), l = me.mul(o, d);
  l = me.mul(l, vy);
  let p = me.mul(l, vd), m = me.mul(r, e);
  s = me.sqr(l), s = me.mul(s, n);
  let y = me.eql(s, m), w = me.cmov(p, l, y);
  s = me.sqr(f), s = me.mul(s, n);
  let S = me.eql(s, r), b = me.cmov(h, i, S), T = me.cmov(w, f, S), x = me.isOdd(T);
  return T = me.cmov(T, me.neg(T), S !== x), { xMn: b, xMd: t, yMn: T, yMd: 1n };
}
const Ny = kp(me, me.neg(BigInt(486664)));
function Py(d) {
  const { xMn: e, xMd: t, yMn: i, yMd: s } = Ey(d);
  let n = me.mul(e, s);
  n = me.mul(n, Ny);
  let r = me.mul(t, i), a = me.sub(e, t), o = me.add(e, t), c = me.mul(r, o), u = me.eql(c, me.ZERO);
  n = me.cmov(n, me.ZERO, u), r = me.cmov(r, me.ONE, u), a = me.cmov(a, me.ONE, u), o = me.cmov(o, me.ONE, u);
  const f = me.invertBatch([r, o]);
  return { x: me.mul(n, f[0]), y: me.mul(a, f[1]) };
}
oo(at.ExtendedPoint, (d) => Py(d[0]), {
  DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
  encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
  p: me.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: Ss
});
function Yr(d) {
  if (!(d instanceof At))
    throw new Error("RistrettoPoint expected");
}
const Na = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752"), _y = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235"), Ly = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578"), Dy = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838"), Ry = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952"), Ed = (d) => Oo(si, d), By = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), Kr = (d) => at.CURVE.Fp.create(Wt(d) & By);
function Nd(d) {
  const { d: e } = at.CURVE, t = at.CURVE.Fp.ORDER, i = at.CURVE.Fp.create, s = i(Na * d * d), n = i((s + si) * Dy);
  let r = BigInt(-1);
  const a = i((r - e * s) * i(s + e));
  let { isValid: o, value: c } = Oo(n, a), u = i(c * d);
  Ai(u, t) || (u = i(-u)), o || (c = u), o || (r = s);
  const f = i(r * (s - si) * Ry - a), h = c * c, l = i((c + c) * a), p = i(f * _y), m = i(si - h), y = i(si + h);
  return new at.ExtendedPoint(i(l * y), i(m * p), i(p * y), i(l * m));
}
class At {
  // Private property to discourage combining ExtendedPoint + RistrettoPoint
  // Always use Ristretto encoding/decoding instead.
  constructor(e) {
    this.ep = e;
  }
  static fromAffine(e) {
    return new At(at.ExtendedPoint.fromAffine(e));
  }
  /**
   * Takes uniform output of 64-bit hash function like sha512 and converts it to `RistrettoPoint`.
   * The hash-to-group operation applies Elligator twice and adds the results.
   * **Note:** this is one-way map, there is no conversion from point to hash.
   * https://ristretto.group/formulas/elligator.html
   * @param hex 64-bit output of a hash function
   */
  static hashToCurve(e) {
    e = Ne("ristrettoHash", e, 64);
    const t = Kr(e.slice(0, 32)), i = Nd(t), s = Kr(e.slice(32, 64)), n = Nd(s);
    return new At(i.add(n));
  }
  /**
   * Converts ristretto-encoded string to ristretto point.
   * https://ristretto.group/formulas/decoding.html
   * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
   */
  static fromHex(e) {
    e = Ne("ristrettoHex", e, 32);
    const { a: t, d: i } = at.CURVE, s = at.CURVE.Fp.ORDER, n = at.CURVE.Fp.create, r = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint", a = Kr(e);
    if (!Lc(Kt(a, 32), e) || Ai(a, s))
      throw new Error(r);
    const o = n(a * a), c = n(si + t * o), u = n(si - t * o), f = n(c * c), h = n(u * u), l = n(t * i * f - h), { isValid: p, value: m } = Ed(n(l * h)), y = n(m * u), w = n(m * y * l);
    let S = n((a + a) * y);
    Ai(S, s) && (S = n(-S));
    const b = n(c * w), T = n(S * b);
    if (!p || Ai(T, s) || b === Iy)
      throw new Error(r);
    return new At(new at.ExtendedPoint(S, b, si, T));
  }
  /**
   * Encodes ristretto point to Uint8Array.
   * https://ristretto.group/formulas/encoding.html
   */
  toRawBytes() {
    let { ex: e, ey: t, ez: i, et: s } = this.ep;
    const n = at.CURVE.Fp.ORDER, r = at.CURVE.Fp.create, a = r(r(i + t) * r(i - t)), o = r(e * t), c = r(o * o), { value: u } = Ed(r(a * c)), f = r(u * a), h = r(u * o), l = r(f * h * s);
    let p;
    if (Ai(s * l, n)) {
      let y = r(t * Na), w = r(e * Na);
      e = y, t = w, p = r(f * Ly);
    } else
      p = h;
    Ai(e * l, n) && (t = r(-t));
    let m = r((i - t) * p);
    return Ai(m, n) && (m = r(-m)), Kt(m, 32);
  }
  toHex() {
    return ki(this.toRawBytes());
  }
  toString() {
    return this.toHex();
  }
  // Compare one point to another.
  equals(e) {
    Yr(e);
    const { ex: t, ey: i } = this.ep, { ex: s, ey: n } = e.ep, r = at.CURVE.Fp.create, a = r(t * n) === r(i * s), o = r(i * n) === r(t * s);
    return a || o;
  }
  add(e) {
    return Yr(e), new At(this.ep.add(e.ep));
  }
  subtract(e) {
    return Yr(e), new At(this.ep.subtract(e.ep));
  }
  multiply(e) {
    return new At(this.ep.multiply(e));
  }
  multiplyUnsafe(e) {
    return new At(this.ep.multiplyUnsafe(e));
  }
}
At.BASE = new At(at.ExtendedPoint.BASE);
At.ZERO = new At(at.ExtendedPoint.ZERO);
class Vy extends vm {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "binance",
      name: "Binance",
      countries: ["JP", "MT"],
      rateLimit: 50,
      certified: !0,
      pro: !0,
      // new metainfo2 interface
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !0,
        option: !0,
        cancelAllOrders: !0,
        cancelOrder: !0,
        cancelOrders: !0,
        createDepositAddress: !1,
        createMarketBuyOrderWithCost: !0,
        createMarketOrderWithCost: !0,
        createMarketSellOrderWithCost: !0,
        createOrder: !0,
        createOrders: !0,
        createTakeProfitOrder: !0,
        createTrailingPercentOrder: !0,
        createTriggerOrder: !0,
        editOrder: !0,
        fetchAccounts: void 0,
        fetchBalance: !0,
        fetchCanceledOrders: "emulated",
        fetchClosedOrder: !1,
        fetchClosedOrders: "emulated",
        fetchCurrencies: !0,
        fetchDeposit: !1,
        fetchDepositAddress: !0,
        fetchDepositAddresses: !1,
        fetchDepositAddressesByNetwork: !1,
        fetchDeposits: !0,
        fetchDepositsWithdrawals: !1,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrder: !1,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrderBooks: !1,
        fetchOrders: !0,
        fetchOrderTrades: !0,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchPositionsRisk: !0,
        fetchStatus: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !0,
        fetchTradingLimits: void 0,
        fetchTransactionFee: void 0,
        fetchTransactionFees: !0,
        fetchTransactions: !1,
        fetchTransfers: !0,
        fetchWithdrawAddresses: !1,
        fetchWithdrawal: !1,
        fetchWithdrawals: !0,
        fetchWithdrawalWhitelist: !1,
        transfer: !0,
        withdraw: !0
      },
      timeframes: {
        "1s": "1s",
        "1m": "1m",
        "3m": "3m",
        "5m": "5m",
        "15m": "15m",
        "30m": "30m",
        "1h": "1h",
        "2h": "2h",
        "4h": "4h",
        "6h": "6h",
        "8h": "8h",
        "12h": "12h",
        "1d": "1d",
        "3d": "3d",
        "1w": "1w",
        "1M": "1M"
      },
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/29604020-d5483cdc-87ee-11e7-94c7-d1a8d9169293.jpg",
        test: {
          dapiPublic: "https://testnet.binancefuture.com/dapi/v1",
          dapiPrivate: "https://testnet.binancefuture.com/dapi/v1",
          dapiPrivateV2: "https://testnet.binancefuture.com/dapi/v2",
          fapiPublic: "https://testnet.binancefuture.com/fapi/v1",
          fapiPublicV2: "https://testnet.binancefuture.com/fapi/v2",
          fapiPrivate: "https://testnet.binancefuture.com/fapi/v1",
          fapiPrivateV2: "https://testnet.binancefuture.com/fapi/v2",
          public: "https://testnet.binance.vision/api/v3",
          private: "https://testnet.binance.vision/api/v3",
          v1: "https://testnet.binance.vision/api/v1"
        },
        api: {
          sapi: "https://api.binance.com/sapi/v1",
          sapiV2: "https://api.binance.com/sapi/v2",
          sapiV3: "https://api.binance.com/sapi/v3",
          sapiV4: "https://api.binance.com/sapi/v4",
          dapiPublic: "https://dapi.binance.com/dapi/v1",
          dapiPrivate: "https://dapi.binance.com/dapi/v1",
          eapiPublic: "https://eapi.binance.com/eapi/v1",
          eapiPrivate: "https://eapi.binance.com/eapi/v1",
          dapiPrivateV2: "https://dapi.binance.com/dapi/v2",
          dapiData: "https://dapi.binance.com/futures/data",
          fapiPublic: "https://fapi.binance.com/fapi/v1",
          fapiPublicV2: "https://fapi.binance.com/fapi/v2",
          fapiPrivate: "https://fapi.binance.com/fapi/v1",
          fapiData: "https://fapi.binance.com/futures/data",
          fapiPrivateV2: "https://fapi.binance.com/fapi/v2",
          public: "https://api.binance.com/api/v3",
          private: "https://api.binance.com/api/v3",
          v1: "https://api.binance.com/api/v1",
          papi: "https://papi.binance.com/papi/v1"
        },
        www: "https://www.binance.com",
        referral: {
          // https://accounts.binance.com/en/register?ref=D7YA7CLY - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
          url: "https://accounts.binance.com/en/register",
          discount: 0.1
        },
        doc: [
          "https://binance-docs.github.io/apidocs/spot/en"
        ],
        api_management: "https://www.binance.com/en/usercenter/settings/api-management",
        fees: "https://www.binance.com/en/fee/schedule"
      },
      api: {
        // the API structure below will need 3-layer apidefs
        sapi: {
          // IP (sapi) request rate limit of 12 000 per minute
          // 1 IP (sapi) => cost = 0.1 => (1000 / (50 * 0.1)) * 60 = 12000
          // 10 IP (sapi) => cost = 1
          // UID (sapi) request rate limit of 180 000 per minute
          // 1 UID (sapi) => cost = 0.006667 => (1000 / (50 * 0.006667)) * 60 = 180000
          get: {
            "system/status": 0.1,
            // these endpoints require this.apiKey
            accountSnapshot: 240,
            "margin/asset": 1,
            "margin/pair": 1,
            "margin/allAssets": 0.1,
            "margin/allPairs": 0.1,
            "margin/priceIndex": 1,
            // these endpoints require this.apiKey + this.secret
            "spot/delist-schedule": 10,
            "asset/assetDividend": 1,
            "asset/dribblet": 0.1,
            "asset/transfer": 0.1,
            "asset/assetDetail": 0.1,
            "asset/tradeFee": 0.1,
            "asset/ledger-transfer/cloud-mining/queryByPage": 4.0002,
            "asset/convert-transfer/queryByPage": 0.033335,
            "asset/wallet/balance": 6,
            "asset/custody/transfer-history": 6,
            "margin/borrow-repay": 1,
            "margin/loan": 1,
            "margin/repay": 1,
            "margin/account": 1,
            "margin/transfer": 0.1,
            "margin/interestHistory": 0.1,
            "margin/forceLiquidationRec": 0.1,
            "margin/order": 1,
            "margin/openOrders": 1,
            "margin/allOrders": 20,
            "margin/myTrades": 1,
            "margin/maxBorrowable": 5,
            "margin/maxTransferable": 5,
            "margin/tradeCoeff": 1,
            "margin/isolated/transfer": 0.1,
            "margin/isolated/account": 1,
            "margin/isolated/pair": 1,
            "margin/isolated/allPairs": 1,
            "margin/isolated/accountLimit": 0.1,
            "margin/interestRateHistory": 0.1,
            "margin/orderList": 1,
            "margin/allOrderList": 20,
            "margin/openOrderList": 1,
            "margin/crossMarginData": { cost: 0.1, noCoin: 0.5 },
            "margin/isolatedMarginData": { cost: 0.1, noCoin: 1 },
            "margin/isolatedMarginTier": 0.1,
            "margin/rateLimit/order": 2,
            "margin/dribblet": 0.1,
            "margin/dust": 20.001,
            "margin/crossMarginCollateralRatio": 10,
            "margin/exchange-small-liability": 0.6667,
            "margin/exchange-small-liability-history": 0.6667,
            "margin/next-hourly-interest-rate": 0.6667,
            "margin/capital-flow": 10,
            "margin/delist-schedule": 10,
            "margin/available-inventory": 0.3334,
            "margin/leverageBracket": 0.1,
            "loan/vip/loanable/data": 40,
            "loan/vip/collateral/data": 40,
            "loan/vip/request/data": 2.6668,
            "loan/vip/request/interestRate": 2.6668,
            "loan/income": 40.002,
            "loan/ongoing/orders": 40,
            "loan/ltv/adjustment/history": 40,
            "loan/borrow/history": 40,
            "loan/repay/history": 40,
            "loan/loanable/data": 40,
            "loan/collateral/data": 40,
            "loan/repay/collateral/rate": 600,
            "loan/flexible/ongoing/orders": 30,
            "loan/flexible/borrow/history": 40,
            "loan/flexible/repay/history": 40,
            "loan/flexible/ltv/adjustment/history": 40,
            "loan/flexible/loanable/data": 40,
            "loan/flexible/collateral/data": 40,
            "loan/vip/ongoing/orders": 40,
            "loan/vip/repay/history": 40,
            "loan/vip/collateral/account": 600,
            "fiat/orders": 600.03,
            "fiat/payments": 0.1,
            "futures/transfer": 1,
            "futures/histDataLink": 0.1,
            "rebate/taxQuery": 80.004,
            // https://binance-docs.github.io/apidocs/spot/en/#withdraw-sapi
            "capital/config/getall": 1,
            "capital/deposit/address": 1,
            "capital/deposit/address/list": 1,
            "capital/deposit/hisrec": 0.1,
            "capital/deposit/subAddress": 0.1,
            "capital/deposit/subHisrec": 0.1,
            "capital/withdraw/history": 2,
            "capital/withdraw/address/list": 1,
            "capital/contract/convertible-coins": 4.0002,
            "convert/tradeFlow": 20.001,
            "convert/exchngeInfo": 50,
            "convert/assetInfo": 10,
            "convert/orderStatus": 0.6667,
            "convert/limit/queryOpenOrders": 20.001,
            "account/status": 0.1,
            "account/apiTradingStatus": 0.1,
            "account/apiRestrictions/ipRestriction": 0.1,
            bnbBurn: 0.1,
            "sub-account/futures/account": 1,
            "sub-account/futures/accountSummary": 0.1,
            "sub-account/futures/positionRisk": 1,
            "sub-account/futures/internalTransfer": 0.1,
            "sub-account/list": 0.1,
            "sub-account/margin/account": 1,
            "sub-account/margin/accountSummary": 1,
            "sub-account/spotSummary": 0.1,
            "sub-account/status": 1,
            "sub-account/sub/transfer/history": 0.1,
            "sub-account/transfer/subUserHistory": 0.1,
            "sub-account/universalTransfer": 0.1,
            "sub-account/apiRestrictions/ipRestriction/thirdPartyList": 1,
            "sub-account/transaction-statistics": 0.40002,
            "sub-account/subAccountApi/ipRestriction": 20.001,
            "managed-subaccount/asset": 0.1,
            "managed-subaccount/accountSnapshot": 240,
            "managed-subaccount/queryTransLogForInvestor": 0.1,
            "managed-subaccount/queryTransLogForTradeParent": 0.40002,
            "managed-subaccount/fetch-future-asset": 0.40002,
            "managed-subaccount/marginAsset": 0.1,
            "managed-subaccount/info": 0.40002,
            "managed-subaccount/deposit/address": 6667e-6,
            "managed-subaccount/query-trans-log": 0.40002,
            // lending endpoints
            "lending/project/list": 0.1,
            "lending/project/position/list": 0.1,
            // eth-staking
            "eth-staking/eth/history/stakingHistory": 15,
            "eth-staking/eth/history/redemptionHistory": 15,
            "eth-staking/eth/history/rewardsHistory": 15,
            "eth-staking/eth/quota": 15,
            "eth-staking/eth/history/rateHistory": 15,
            "eth-staking/account": 15,
            "eth-staking/wbeth/history/wrapHistory": 15,
            "eth-staking/wbeth/history/unwrapHistory": 15,
            "eth-staking/eth/history/wbethRewardsHistory": 15,
            // mining endpoints
            "mining/pub/algoList": 0.1,
            "mining/pub/coinList": 0.1,
            "mining/worker/detail": 0.5,
            "mining/worker/list": 0.5,
            "mining/payment/list": 0.5,
            "mining/statistics/user/status": 0.5,
            "mining/statistics/user/list": 0.5,
            "mining/payment/uid": 0.5,
            // liquid swap endpoints
            "bswap/pools": 0.1,
            "bswap/liquidity": { cost: 0.1, noPoolId: 1 },
            "bswap/liquidityOps": 20.001,
            "bswap/quote": 1.00005,
            "bswap/swap": 20.001,
            "bswap/poolConfigure": 1.00005,
            "bswap/addLiquidityPreview": 1.00005,
            "bswap/removeLiquidityPreview": 1.00005,
            "bswap/unclaimedRewards": 6.667,
            "bswap/claimedHistory": 6.667,
            // leveraged token endpoints
            "blvt/tokenInfo": 0.1,
            "blvt/subscribe/record": 0.1,
            "blvt/redeem/record": 0.1,
            "blvt/userLimit": 0.1,
            // broker api TODO (NOT IN DOCS)
            "apiReferral/ifNewUser": 1,
            "apiReferral/customization": 1,
            "apiReferral/userCustomization": 1,
            "apiReferral/rebate/recentRecord": 1,
            "apiReferral/rebate/historicalRecord": 1,
            "apiReferral/kickback/recentRecord": 1,
            "apiReferral/kickback/historicalRecord": 1,
            // brokerage API TODO https://binance-docs.github.io/Brokerage-API/General/ does not state ratelimits
            "broker/subAccountApi": 1,
            "broker/subAccount": 1,
            "broker/subAccountApi/commission/futures": 1,
            "broker/subAccountApi/commission/coinFutures": 1,
            "broker/info": 1,
            "broker/transfer": 1,
            "broker/transfer/futures": 1,
            "broker/rebate/recentRecord": 1,
            "broker/rebate/historicalRecord": 1,
            "broker/subAccount/bnbBurn/status": 1,
            "broker/subAccount/depositHist": 1,
            "broker/subAccount/spotSummary": 1,
            "broker/subAccount/marginSummary": 1,
            "broker/subAccount/futuresSummary": 1,
            "broker/rebate/futures/recentRecord": 1,
            "broker/subAccountApi/ipRestriction": 1,
            "broker/universalTransfer": 1,
            // v2 not supported yet
            // GET /sapi/v2/broker/subAccount/futuresSummary
            "account/apiRestrictions": 0.1,
            // c2c / p2p
            "c2c/orderMatch/listUserOrderHistory": 0.1,
            // nft endpoints
            "nft/history/transactions": 20.001,
            "nft/history/deposit": 20.001,
            "nft/history/withdraw": 20.001,
            "nft/user/getAsset": 20.001,
            "pay/transactions": 20.001,
            "giftcard/verify": 0.1,
            "giftcard/cryptography/rsa-public-key": 0.1,
            "giftcard/buyCode/token-limit": 0.1,
            "algo/spot/openOrders": 0.1,
            "algo/spot/historicalOrders": 0.1,
            "algo/spot/subOrders": 0.1,
            "algo/futures/openOrders": 0.1,
            "algo/futures/historicalOrders": 0.1,
            "algo/futures/subOrders": 0.1,
            "portfolio/account": 0.1,
            "portfolio/collateralRate": 5,
            "portfolio/pmLoan": 3.3335,
            "portfolio/interest-history": 0.6667,
            "portfolio/asset-index-price": 0.1,
            "portfolio/repay-futures-switch": 3,
            "portfolio/margin-asset-leverage": 5,
            // staking
            "staking/productList": 0.1,
            "staking/position": 0.1,
            "staking/stakingRecord": 0.1,
            "staking/personalLeftQuota": 0.1,
            "lending/auto-invest/target-asset/list": 0.1,
            "lending/auto-invest/target-asset/roi/list": 0.1,
            "lending/auto-invest/all/asset": 0.1,
            "lending/auto-invest/source-asset/list": 0.1,
            "lending/auto-invest/plan/list": 0.1,
            "lending/auto-invest/plan/id": 0.1,
            "lending/auto-invest/history/list": 0.1,
            "lending/auto-invest/index/info": 0.1,
            "lending/auto-invest/index/user-summary": 0.1,
            "lending/auto-invest/one-off/status": 0.1,
            "lending/auto-invest/redeem/history": 0.1,
            "lending/auto-invest/rebalance/history": 0.1,
            // simple earn
            "simple-earn/flexible/list": 15,
            "simple-earn/locked/list": 15,
            "simple-earn/flexible/personalLeftQuota": 15,
            "simple-earn/locked/personalLeftQuota": 15,
            "simple-earn/flexible/subscriptionPreview": 15,
            "simple-earn/locked/subscriptionPreview": 15,
            "simple-earn/flexible/history/rateHistory": 15,
            "simple-earn/flexible/position": 15,
            "simple-earn/locked/position": 15,
            "simple-earn/account": 15,
            "simple-earn/flexible/history/subscriptionRecord": 15,
            "simple-earn/locked/history/subscriptionRecord": 15,
            "simple-earn/flexible/history/redemptionRecord": 15,
            "simple-earn/locked/history/redemptionRecord": 15,
            "simple-earn/flexible/history/rewardsRecord": 15,
            "simple-earn/locked/history/rewardsRecord": 15,
            "simple-earn/flexible/history/collateralRecord": 0.1
          },
          post: {
            "asset/dust": 0.06667,
            "asset/dust-btc": 0.1,
            "asset/transfer": 6.0003,
            "asset/get-funding-asset": 0.1,
            "asset/convert-transfer": 0.033335,
            "account/disableFastWithdrawSwitch": 0.1,
            "account/enableFastWithdrawSwitch": 0.1,
            // 'account/apiRestrictions/ipRestriction': 1, discontinued
            // 'account/apiRestrictions/ipRestriction/ipList': 1, discontinued
            "capital/withdraw/apply": 4.0002,
            "capital/contract/convertible-coins": 4.0002,
            "capital/deposit/credit-apply": 0.1,
            "margin/borrow-repay": 20.001,
            "margin/transfer": 4.0002,
            "margin/loan": 20.001,
            "margin/repay": 20.001,
            "margin/order": 0.040002,
            "margin/order/oco": 0.040002,
            "margin/dust": 20.001,
            "margin/exchange-small-liability": 20.001,
            // 'margin/isolated/create': 1, discontinued
            "margin/isolated/transfer": 4.0002,
            "margin/isolated/account": 2.0001,
            "margin/max-leverage": 300,
            bnbBurn: 0.1,
            "sub-account/virtualSubAccount": 0.1,
            "sub-account/margin/transfer": 4.0002,
            "sub-account/margin/enable": 0.1,
            "sub-account/futures/enable": 0.1,
            "sub-account/futures/transfer": 0.1,
            "sub-account/futures/internalTransfer": 0.1,
            "sub-account/transfer/subToSub": 0.1,
            "sub-account/transfer/subToMaster": 0.1,
            "sub-account/universalTransfer": 0.1,
            "sub-account/options/enable": 0.1,
            "managed-subaccount/deposit": 0.1,
            "managed-subaccount/withdraw": 0.1,
            userDataStream: 0.1,
            "userDataStream/isolated": 0.1,
            "futures/transfer": 0.1,
            // lending
            "lending/customizedFixed/purchase": 0.1,
            // liquid swap endpoints
            "bswap/liquidityAdd": 60,
            "bswap/liquidityRemove": 60,
            "bswap/swap": 60,
            "bswap/claimRewards": 6.667,
            // leveraged token endpoints
            "blvt/subscribe": 0.1,
            "blvt/redeem": 0.1,
            // brokerage API TODO: NO MENTION OF RATELIMITS IN BROKERAGE DOCS
            "apiReferral/customization": 1,
            "apiReferral/userCustomization": 1,
            "apiReferral/rebate/historicalRecord": 1,
            "apiReferral/kickback/historicalRecord": 1,
            "broker/subAccount": 1,
            "broker/subAccount/margin": 1,
            "broker/subAccount/futures": 1,
            "broker/subAccountApi": 1,
            "broker/subAccountApi/permission": 1,
            "broker/subAccountApi/commission": 1,
            "broker/subAccountApi/commission/futures": 1,
            "broker/subAccountApi/commission/coinFutures": 1,
            "broker/transfer": 1,
            "broker/transfer/futures": 1,
            "broker/rebate/historicalRecord": 1,
            "broker/subAccount/bnbBurn/spot": 1,
            "broker/subAccount/bnbBurn/marginInterest": 1,
            "broker/subAccount/blvt": 1,
            "broker/subAccountApi/ipRestriction": 1,
            "broker/subAccountApi/ipRestriction/ipList": 1,
            "broker/universalTransfer": 1,
            "broker/subAccountApi/permission/universalTransfer": 1,
            "broker/subAccountApi/permission/vanillaOptions": 1,
            //
            "giftcard/createCode": 0.1,
            "giftcard/redeemCode": 0.1,
            "giftcard/buyCode": 0.1,
            "algo/spot/newOrderTwap": 20.001,
            "algo/futures/newOrderVp": 20.001,
            "algo/futures/newOrderTwap": 20.001,
            // staking
            "staking/purchase": 0.1,
            "staking/redeem": 0.1,
            "staking/setAutoStaking": 0.1,
            // eth-staking
            "eth-staking/eth/stake": 15,
            "eth-staking/eth/redeem": 15,
            "eth-staking/wbeth/wrap": 15,
            // mining endpoints
            "mining/hash-transfer/config": 0.5,
            "mining/hash-transfer/config/cancel": 0.5,
            "portfolio/repay": 20.001,
            "loan/vip/renew": 40.002,
            "loan/vip/borrow": 40.002,
            "loan/borrow": 40.002,
            "loan/repay": 40.002,
            "loan/adjust/ltv": 40.002,
            "loan/customize/margin_call": 40.002,
            "loan/flexible/borrow": 40.002,
            "loan/flexible/repay": 40.002,
            "loan/flexible/adjust/ltv": 40.002,
            "loan/vip/repay": 40.002,
            "convert/getQuote": 1.3334,
            "convert/acceptQuote": 3.3335,
            "convert/limit/placeOrder": 3.3335,
            "convert/limit/cancelOrder": 1.3334,
            "portfolio/auto-collection": 150,
            "portfolio/asset-collection": 6,
            "portfolio/bnb-transfer": 150,
            "portfolio/repay-futures-switch": 150,
            "portfolio/repay-futures-negative-balance": 150,
            "lending/auto-invest/plan/add": 0.1,
            "lending/auto-invest/plan/edit": 0.1,
            "lending/auto-invest/plan/edit-status": 0.1,
            "lending/auto-invest/one-off": 0.1,
            "lending/auto-invest/redeem": 0.1,
            // simple earn
            "simple-earn/flexible/subscribe": 0.1,
            "simple-earn/locked/subscribe": 0.1,
            "simple-earn/flexible/redeem": 0.1,
            "simple-earn/locked/redeem": 0.1,
            "simple-earn/flexible/setAutoSubscribe": 15,
            "simple-earn/locked/setAutoSubscribe": 15
          },
          put: {
            userDataStream: 0.1,
            "userDataStream/isolated": 0.1
          },
          delete: {
            // 'account/apiRestrictions/ipRestriction/ipList': 1, discontinued
            "margin/openOrders": 0.1,
            "margin/order": 6667e-6,
            "margin/orderList": 6667e-6,
            "margin/isolated/account": 2.0001,
            userDataStream: 0.1,
            "userDataStream/isolated": 0.1,
            // brokerage API TODO NO MENTION OF RATELIMIT IN BROKERAGE DOCS
            "broker/subAccountApi": 1,
            "broker/subAccountApi/ipRestriction/ipList": 1,
            "algo/spot/order": 0.1,
            "algo/futures/order": 0.1,
            "sub-account/subAccountApi/ipRestriction/ipList": 20.001
            // Weight(UID): 3000 => cost = 0.006667 * 3000 = 20.001
          }
        },
        sapiV2: {
          get: {
            "eth-staking/account": 15,
            "sub-account/futures/account": 0.1,
            "sub-account/futures/accountSummary": 1,
            "sub-account/futures/positionRisk": 0.1
          },
          post: {
            "eth-staking/eth/stake": 15,
            "sub-account/subAccountApi/ipRestriction": 20.001
            // Weight(UID): 3000 => cost = 0.006667 * 3000 = 20.001
          }
        },
        sapiV3: {
          get: {
            "sub-account/assets": 0.40002
            // Weight(UID): 60 => cost =  0.006667 * 60 = 0.40002
          },
          post: {
            "asset/getUserAsset": 0.5
          }
        },
        sapiV4: {
          get: {
            "sub-account/assets": 0.40002
            // Weight(UID): 60 => cost = 0.006667 * 60 = 0.40002
          }
        },
        dapiPublic: {
          get: {
            ping: 1,
            time: 1,
            exchangeInfo: 1,
            depth: { cost: 2, byLimit: [[50, 2], [100, 5], [500, 10], [1e3, 20]] },
            trades: 5,
            historicalTrades: 20,
            aggTrades: 20,
            premiumIndex: 10,
            fundingRate: 1,
            klines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            continuousKlines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            indexPriceKlines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            markPriceKlines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            premiumIndexKlines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            "ticker/24hr": { cost: 1, noSymbol: 40 },
            "ticker/price": { cost: 1, noSymbol: 2 },
            "ticker/bookTicker": { cost: 2, noSymbol: 5 },
            constituents: 2,
            openInterest: 1
          }
        },
        dapiData: {
          get: {
            "delivery-price": 1,
            openInterestHist: 1,
            topLongShortAccountRatio: 1,
            topLongShortPositionRatio: 1,
            globalLongShortAccountRatio: 1,
            takerBuySellVol: 1,
            basis: 1
          }
        },
        dapiPrivate: {
          get: {
            "positionSide/dual": 30,
            orderAmendment: 1,
            order: 1,
            openOrder: 1,
            openOrders: { cost: 1, noSymbol: 5 },
            allOrders: { cost: 20, noSymbol: 40 },
            balance: 1,
            account: 5,
            "positionMargin/history": 1,
            positionRisk: 1,
            userTrades: { cost: 20, noSymbol: 40 },
            income: 20,
            leverageBracket: 1,
            forceOrders: { cost: 20, noSymbol: 50 },
            adlQuantile: 5,
            commissionRate: 20,
            "income/asyn": 5,
            "income/asyn/id": 5,
            pmExchangeInfo: 0.5,
            pmAccountInfo: 0.5
            // Weight(IP): 5 => cost = 0.1 * 5 = 0.5
          },
          post: {
            "positionSide/dual": 1,
            order: 4,
            batchOrders: 5,
            countdownCancelAll: 10,
            leverage: 1,
            marginType: 1,
            positionMargin: 1,
            listenKey: 1
          },
          put: {
            listenKey: 1,
            order: 1,
            batchOrders: 5
          },
          delete: {
            order: 1,
            allOpenOrders: 1,
            batchOrders: 5,
            listenKey: 1
          }
        },
        dapiPrivateV2: {
          get: {
            leverageBracket: 1
          }
        },
        fapiPublic: {
          get: {
            ping: 1,
            time: 1,
            exchangeInfo: 1,
            depth: { cost: 2, byLimit: [[50, 2], [100, 5], [500, 10], [1e3, 20]] },
            trades: 5,
            historicalTrades: 20,
            aggTrades: 20,
            klines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            continuousKlines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            markPriceKlines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            indexPriceKlines: { cost: 1, byLimit: [[99, 1], [499, 2], [1e3, 5], [1e4, 10]] },
            fundingRate: 1,
            fundingInfo: 1,
            premiumIndex: 1,
            "ticker/24hr": { cost: 1, noSymbol: 40 },
            "ticker/price": { cost: 1, noSymbol: 2 },
            "ticker/bookTicker": { cost: 1, noSymbol: 2 },
            openInterest: 1,
            indexInfo: 1,
            assetIndex: { cost: 1, noSymbol: 10 },
            constituents: 2,
            apiTradingStatus: { cost: 1, noSymbol: 10 },
            lvtKlines: 1
          }
        },
        fapiData: {
          get: {
            "delivery-price": 1,
            openInterestHist: 1,
            topLongShortAccountRatio: 1,
            topLongShortPositionRatio: 1,
            globalLongShortAccountRatio: 1,
            takerlongshortRatio: 1,
            basis: 1
          }
        },
        fapiPrivate: {
          get: {
            forceOrders: { cost: 20, noSymbol: 50 },
            allOrders: 5,
            openOrder: 1,
            openOrders: 1,
            order: 1,
            account: 5,
            balance: 5,
            leverageBracket: 1,
            "positionMargin/history": 1,
            positionRisk: 5,
            "positionSide/dual": 30,
            userTrades: 5,
            income: 30,
            commissionRate: 20,
            apiTradingStatus: 1,
            multiAssetsMargin: 30,
            // broker endpoints
            "apiReferral/ifNewUser": 1,
            "apiReferral/customization": 1,
            "apiReferral/userCustomization": 1,
            "apiReferral/traderNum": 1,
            "apiReferral/overview": 1,
            "apiReferral/tradeVol": 1,
            "apiReferral/rebateVol": 1,
            "apiReferral/traderSummary": 1,
            adlQuantile: 5,
            pmAccountInfo: 5,
            orderAmendment: 1,
            "income/asyn": 1e3,
            "income/asyn/id": 10,
            "order/asyn": 1e3,
            "order/asyn/id": 10,
            "trade/asyn": 1e3,
            "trade/asyn/id": 10
          },
          post: {
            batchOrders: 5,
            "positionSide/dual": 1,
            positionMargin: 1,
            marginType: 1,
            order: 4,
            leverage: 1,
            listenKey: 1,
            countdownCancelAll: 10,
            multiAssetsMargin: 1,
            // broker endpoints
            "apiReferral/customization": 1,
            "apiReferral/userCustomization": 1
          },
          put: {
            listenKey: 1,
            order: 1,
            batchOrders: 5
          },
          delete: {
            batchOrders: 1,
            order: 1,
            allOpenOrders: 1,
            listenKey: 1
          }
        },
        fapiPublicV2: {
          get: {
            "ticker/price": 0
          }
        },
        fapiPrivateV2: {
          get: {
            account: 1,
            balance: 1,
            positionRisk: 1
          }
        },
        eapiPublic: {
          get: {
            ping: 1,
            time: 1,
            exchangeInfo: 1,
            index: 1,
            ticker: 5,
            mark: 5,
            depth: 1,
            klines: 1,
            trades: 5,
            historicalTrades: 20,
            exerciseHistory: 3,
            openInterest: 3
          }
        },
        eapiPrivate: {
          get: {
            account: 3,
            position: 5,
            openOrders: { cost: 1, noSymbol: 40 },
            historyOrders: 3,
            userTrades: 5,
            exerciseRecord: 5,
            bill: 1,
            "income/asyn": 5,
            "income/asyn/id": 5,
            marginAccount: 3,
            mmp: 1,
            countdownCancelAll: 1,
            order: 1
          },
          post: {
            order: 1,
            batchOrders: 5,
            listenKey: 1,
            mmpSet: 1,
            mmpReset: 1,
            countdownCancelAll: 1,
            countdownCancelAllHeartBeat: 10
          },
          put: {
            listenKey: 1
          },
          delete: {
            order: 1,
            batchOrders: 1,
            allOpenOrders: 1,
            allOpenOrdersByUnderlying: 1,
            listenKey: 1
          }
        },
        public: {
          // IP (api) request rate limit of 6000 per minute
          // 1 IP (api) => cost = 0.2 => (1000 / (50 * 0.2)) * 60 = 6000
          get: {
            ping: 0.2,
            time: 0.2,
            depth: { cost: 1, byLimit: [[100, 1], [500, 5], [1e3, 10], [5e3, 50]] },
            trades: 5,
            aggTrades: 0.4,
            historicalTrades: 5,
            klines: 0.4,
            uiKlines: 0.4,
            "ticker/24hr": { cost: 0.4, noSymbol: 16 },
            ticker: { cost: 0.4, noSymbol: 16 },
            "ticker/tradingDay": 0.8,
            "ticker/price": { cost: 0.4, noSymbol: 0.8 },
            "ticker/bookTicker": { cost: 0.4, noSymbol: 0.8 },
            exchangeInfo: 4,
            avgPrice: 0.4
          },
          put: {
            userDataStream: 0.4
          },
          post: {
            userDataStream: 0.4
          },
          delete: {
            userDataStream: 0.4
          }
        },
        private: {
          get: {
            allOrderList: 4,
            openOrderList: 1.2,
            orderList: 0.8,
            order: 0.8,
            openOrders: { cost: 1.2, noSymbol: 16 },
            allOrders: 4,
            account: 4,
            myTrades: 4,
            "rateLimit/order": 8,
            myPreventedMatches: 4,
            myAllocations: 4,
            "account/commission": 4
          },
          post: {
            "order/oco": 0.2,
            "sor/order": 0.2,
            "sor/order/test": 0.2,
            order: 0.2,
            "order/cancelReplace": 0.2,
            "order/test": 0.2
          },
          delete: {
            openOrders: 0.2,
            orderList: 0.2,
            order: 0.2
          }
        },
        papi: {
          get: {
            ping: 1,
            "um/order": 1,
            "um/openOrder": 1,
            "um/openOrders": 1,
            "um/allOrders": 5,
            "cm/order": 1,
            "cm/openOrder": 1,
            "cm/openOrders": 1,
            "cm/allOrders": 20,
            "um/conditional/openOrder": 1,
            "um/conditional/openOrders": 40,
            "um/conditional/orderHistory": 1,
            "um/conditional/allOrders": 40,
            "cm/conditional/openOrder": 1,
            "cm/conditional/openOrders": 40,
            "cm/conditional/orderHistory": 1,
            "cm/conditional/allOrders": 40,
            "margin/order": 5,
            "margin/openOrders": 5,
            "margin/allOrders": 100,
            "margin/orderList": 5,
            "margin/allOrderList": 100,
            "margin/openOrderList": 5,
            "margin/myTrades": 5,
            balance: 20,
            account: 20,
            "margin/maxBorrowable": 5,
            "margin/maxWithdraw": 5,
            "um/positionRisk": 5,
            "cm/positionRisk": 1,
            "um/positionSide/dual": 30,
            "cm/positionSide/dual": 30,
            "um/userTrades": 5,
            "cm/userTrades": 20,
            "um/leverageBracket": 1,
            "cm/leverageBracket": 1,
            "margin/forceOrders": 1,
            "um/forceOrders": 20,
            "cm/forceOrders": 20,
            "um/apiTradingStatus": 1,
            "um/commissionRate": 20,
            "cm/commissionRate": 20,
            "margin/marginLoan": 10,
            "margin/repayLoan": 10,
            "margin/marginInterestHistory": 1,
            "portfolio/interest-history": 50,
            "um/income": 30,
            "cm/income": 30,
            "um/account": 5,
            "cm/account": 5,
            "repay-futures-switch": 3,
            "um/adlQuantile": 5,
            "cm/adlQuantile": 5
          },
          post: {
            "um/order": 1,
            "um/conditional/order": 1,
            "cm/order": 1,
            "cm/conditional/order": 1,
            "margin/order": 0.0133,
            marginLoan: 0.1333,
            repayLoan: 0.1333,
            "margin/order/oco": 0.04,
            "um/leverage": 1,
            "cm/leverage": 1,
            "um/positionSide/dual": 1,
            "cm/positionSide/dual": 1,
            "auto-collection": 0.6667,
            "bnb-transfer": 0.6667,
            "repay-futures-switch": 150,
            "repay-futures-negative-balance": 150,
            listenKey: 1,
            "asset-collection": 3
          },
          put: {
            listenKey: 1
            // 1
          },
          delete: {
            "um/order": 1,
            "um/conditional/order": 1,
            "um/allOpenOrders": 1,
            "um/conditional/allOpenOrders": 1,
            "cm/order": 1,
            "cm/conditional/order": 1,
            "cm/allOpenOrders": 1,
            "cm/conditional/allOpenOrders": 1,
            "margin/order": 1,
            "margin/allOpenOrders": 5,
            "margin/orderList": 2,
            listenKey: 1
            // 1
          }
        }
      },
      fees: {
        trading: {
          feeSide: "get",
          tierBased: !1,
          percentage: !0,
          taker: this.parseNumber("0.001"),
          maker: this.parseNumber("0.001")
        },
        linear: {
          trading: {
            feeSide: "quote",
            tierBased: !0,
            percentage: !0,
            taker: this.parseNumber("0.000400"),
            maker: this.parseNumber("0.000200"),
            tiers: {
              taker: [
                [this.parseNumber("0"), this.parseNumber("0.000400")],
                [this.parseNumber("250"), this.parseNumber("0.000400")],
                [this.parseNumber("2500"), this.parseNumber("0.000350")],
                [this.parseNumber("7500"), this.parseNumber("0.000320")],
                [this.parseNumber("22500"), this.parseNumber("0.000300")],
                [this.parseNumber("50000"), this.parseNumber("0.000270")],
                [this.parseNumber("100000"), this.parseNumber("0.000250")],
                [this.parseNumber("200000"), this.parseNumber("0.000220")],
                [this.parseNumber("400000"), this.parseNumber("0.000200")],
                [this.parseNumber("750000"), this.parseNumber("0.000170")]
              ],
              maker: [
                [this.parseNumber("0"), this.parseNumber("0.000200")],
                [this.parseNumber("250"), this.parseNumber("0.000160")],
                [this.parseNumber("2500"), this.parseNumber("0.000140")],
                [this.parseNumber("7500"), this.parseNumber("0.000120")],
                [this.parseNumber("22500"), this.parseNumber("0.000100")],
                [this.parseNumber("50000"), this.parseNumber("0.000080")],
                [this.parseNumber("100000"), this.parseNumber("0.000060")],
                [this.parseNumber("200000"), this.parseNumber("0.000040")],
                [this.parseNumber("400000"), this.parseNumber("0.000020")],
                [this.parseNumber("750000"), this.parseNumber("0")]
              ]
            }
          }
        },
        inverse: {
          trading: {
            feeSide: "base",
            tierBased: !0,
            percentage: !0,
            taker: this.parseNumber("0.000500"),
            maker: this.parseNumber("0.000100"),
            tiers: {
              taker: [
                [this.parseNumber("0"), this.parseNumber("0.000500")],
                [this.parseNumber("250"), this.parseNumber("0.000450")],
                [this.parseNumber("2500"), this.parseNumber("0.000400")],
                [this.parseNumber("7500"), this.parseNumber("0.000300")],
                [this.parseNumber("22500"), this.parseNumber("0.000250")],
                [this.parseNumber("50000"), this.parseNumber("0.000240")],
                [this.parseNumber("100000"), this.parseNumber("0.000240")],
                [this.parseNumber("200000"), this.parseNumber("0.000240")],
                [this.parseNumber("400000"), this.parseNumber("0.000240")],
                [this.parseNumber("750000"), this.parseNumber("0.000240")]
              ],
              maker: [
                [this.parseNumber("0"), this.parseNumber("0.000100")],
                [this.parseNumber("250"), this.parseNumber("0.000080")],
                [this.parseNumber("2500"), this.parseNumber("0.000050")],
                [this.parseNumber("7500"), this.parseNumber("0.0000030")],
                [this.parseNumber("22500"), this.parseNumber("0")],
                [this.parseNumber("50000"), this.parseNumber("-0.000050")],
                [this.parseNumber("100000"), this.parseNumber("-0.000060")],
                [this.parseNumber("200000"), this.parseNumber("-0.000070")],
                [this.parseNumber("400000"), this.parseNumber("-0.000080")],
                [this.parseNumber("750000"), this.parseNumber("-0.000090")]
              ]
            }
          }
        },
        option: {}
      },
      precisionMode: St,
      // exchange-specific options
      options: {
        sandboxMode: !1,
        fetchMarkets: [
          "spot",
          "linear",
          "inverse"
          // allows CORS in browsers
          // 'option', // does not allow CORS, enable outside of the browser only
        ],
        fetchCurrencies: !0,
        // 'fetchTradesMethod': 'publicGetAggTrades', // publicGetTrades, publicGetHistoricalTrades, eapiPublicGetTrades
        defaultTimeInForce: "GTC",
        defaultType: "spot",
        defaultSubType: void 0,
        warnOnFetchOpenOrdersWithoutSymbol: !0,
        // not an error
        // https://github.com/ccxt/ccxt/issues/11268
        // https://github.com/ccxt/ccxt/pull/11624
        // POST https://fapi.binance.com/fapi/v1/marginType 400 Bad Request
        // binanceusdm
        throwMarginModeAlreadySet: !1,
        fetchPositions: "positionRisk",
        recvWindow: 10 * 1e3,
        timeDifference: 0,
        adjustForTimeDifference: !1,
        newOrderRespType: {
          market: "FULL",
          limit: "FULL"
          // we change it from 'ACK' by default to 'FULL' (returns immediately if limit is not hit)
        },
        quoteOrderQty: !0,
        broker: {
          spot: "x-R4BD3S82",
          margin: "x-R4BD3S82",
          future: "x-xcKtGhcu",
          delivery: "x-xcKtGhcu",
          swap: "x-xcKtGhcu",
          option: "x-xcKtGhcu"
        },
        accountsByType: {
          main: "MAIN",
          spot: "MAIN",
          funding: "FUNDING",
          margin: "MARGIN",
          cross: "MARGIN",
          future: "UMFUTURE",
          delivery: "CMFUTURE",
          linear: "UMFUTURE",
          inverse: "CMFUTURE",
          option: "OPTION"
        },
        accountsById: {
          MAIN: "spot",
          FUNDING: "funding",
          MARGIN: "margin",
          UMFUTURE: "linear",
          CMFUTURE: "inverse",
          OPTION: "option"
        },
        networks: {
          ERC20: "ETH",
          TRC20: "TRX",
          BEP2: "BNB",
          BEP20: "BSC",
          OMNI: "OMNI",
          EOS: "EOS",
          SPL: "SOL"
        },
        // keeping this object for backward-compatibility
        reverseNetworks: {
          "tronscan.org": "TRC20",
          "etherscan.io": "ERC20",
          "bscscan.com": "BSC",
          "explorer.binance.org": "BEP2",
          "bithomp.com": "XRP",
          "bloks.io": "EOS",
          "stellar.expert": "XLM",
          "blockchair.com/bitcoin": "BTC",
          "blockchair.com/bitcoin-cash": "BCH",
          "blockchair.com/ecash": "XEC",
          "explorer.litecoin.net": "LTC",
          "explorer.avax.network": "AVAX",
          "solscan.io": "SOL",
          "polkadot.subscan.io": "DOT",
          "dashboard.internetcomputer.org": "ICP",
          "explorer.chiliz.com": "CHZ",
          "cardanoscan.io": "ADA",
          "mainnet.theoan.com": "AION",
          "algoexplorer.io": "ALGO",
          "explorer.ambrosus.com": "AMB",
          "viewblock.io/zilliqa": "ZIL",
          "viewblock.io/arweave": "AR",
          "explorer.ark.io": "ARK",
          "atomscan.com": "ATOM",
          "www.mintscan.io": "CTK",
          "explorer.bitcoindiamond.org": "BCD",
          "btgexplorer.com": "BTG",
          "bts.ai": "BTS",
          "explorer.celo.org": "CELO",
          "explorer.nervos.org": "CKB",
          "cerebro.cortexlabs.ai": "CTXC",
          "chainz.cryptoid.info": "VIA",
          "explorer.dcrdata.org": "DCR",
          "digiexplorer.info": "DGB",
          "dock.subscan.io": "DOCK",
          "dogechain.info": "DOGE",
          "explorer.elrond.com": "EGLD",
          "blockscout.com": "ETC",
          "explore-fetchhub.fetch.ai": "FET",
          "filfox.info": "FIL",
          "fio.bloks.io": "FIO",
          "explorer.firo.org": "FIRO",
          "neoscan.io": "NEO",
          "ftmscan.com": "FTM",
          "explorer.gochain.io": "GO",
          "block.gxb.io": "GXS",
          "hash-hash.info": "HBAR",
          "www.hiveblockexplorer.com": "HIVE",
          "explorer.helium.com": "HNT",
          "tracker.icon.foundation": "ICX",
          "www.iostabc.com": "IOST",
          "explorer.iota.org": "IOTA",
          "iotexscan.io": "IOTX",
          "irishub.iobscan.io": "IRIS",
          "kava.mintscan.io": "KAVA",
          "scope.klaytn.com": "KLAY",
          "kmdexplorer.io": "KMD",
          "kusama.subscan.io": "KSM",
          "explorer.lto.network": "LTO",
          "polygonscan.com": "POLYGON",
          "explorer.ont.io": "ONT",
          "minaexplorer.com": "MINA",
          "nanolooker.com": "NANO",
          "explorer.nebulas.io": "NAS",
          "explorer.nbs.plus": "NBS",
          "explorer.nebl.io": "NEBL",
          "nulscan.io": "NULS",
          "nxscan.com": "NXS",
          "explorer.harmony.one": "ONE",
          "explorer.poa.network": "POA",
          "qtum.info": "QTUM",
          "explorer.rsk.co": "RSK",
          "www.oasisscan.com": "ROSE",
          "ravencoin.network": "RVN",
          "sc.tokenview.com": "SC",
          "secretnodes.com": "SCRT",
          "explorer.skycoin.com": "SKY",
          "steemscan.com": "STEEM",
          "explorer.stacks.co": "STX",
          "www.thetascan.io": "THETA",
          "scan.tomochain.com": "TOMO",
          "explore.vechain.org": "VET",
          "explorer.vite.net": "VITE",
          "www.wanscan.org": "WAN",
          "wavesexplorer.com": "WAVES",
          "wax.eosx.io": "WAXP",
          "waltonchain.pro": "WTC",
          "chain.nem.ninja": "XEM",
          "verge-blockchain.info": "XVG",
          "explorer.yoyow.org": "YOYOW",
          "explorer.zcha.in": "ZEC",
          "explorer.zensystem.io": "ZEN"
        },
        networksById: {
          "tronscan.org": "TRC20",
          "etherscan.io": "ERC20",
          "bscscan.com": "BSC",
          "explorer.binance.org": "BEP2",
          "bithomp.com": "XRP",
          "bloks.io": "EOS",
          "stellar.expert": "XLM",
          "blockchair.com/bitcoin": "BTC",
          "blockchair.com/bitcoin-cash": "BCH",
          "blockchair.com/ecash": "XEC",
          "explorer.litecoin.net": "LTC",
          "explorer.avax.network": "AVAX",
          "solscan.io": "SOL",
          "polkadot.subscan.io": "DOT",
          "dashboard.internetcomputer.org": "ICP",
          "explorer.chiliz.com": "CHZ",
          "cardanoscan.io": "ADA",
          "mainnet.theoan.com": "AION",
          "algoexplorer.io": "ALGO",
          "explorer.ambrosus.com": "AMB",
          "viewblock.io/zilliqa": "ZIL",
          "viewblock.io/arweave": "AR",
          "explorer.ark.io": "ARK",
          "atomscan.com": "ATOM",
          "www.mintscan.io": "CTK",
          "explorer.bitcoindiamond.org": "BCD",
          "btgexplorer.com": "BTG",
          "bts.ai": "BTS",
          "explorer.celo.org": "CELO",
          "explorer.nervos.org": "CKB",
          "cerebro.cortexlabs.ai": "CTXC",
          "chainz.cryptoid.info": "VIA",
          "explorer.dcrdata.org": "DCR",
          "digiexplorer.info": "DGB",
          "dock.subscan.io": "DOCK",
          "dogechain.info": "DOGE",
          "explorer.elrond.com": "EGLD",
          "blockscout.com": "ETC",
          "explore-fetchhub.fetch.ai": "FET",
          "filfox.info": "FIL",
          "fio.bloks.io": "FIO",
          "explorer.firo.org": "FIRO",
          "neoscan.io": "NEO",
          "ftmscan.com": "FTM",
          "explorer.gochain.io": "GO",
          "block.gxb.io": "GXS",
          "hash-hash.info": "HBAR",
          "www.hiveblockexplorer.com": "HIVE",
          "explorer.helium.com": "HNT",
          "tracker.icon.foundation": "ICX",
          "www.iostabc.com": "IOST",
          "explorer.iota.org": "IOTA",
          "iotexscan.io": "IOTX",
          "irishub.iobscan.io": "IRIS",
          "kava.mintscan.io": "KAVA",
          "scope.klaytn.com": "KLAY",
          "kmdexplorer.io": "KMD",
          "kusama.subscan.io": "KSM",
          "explorer.lto.network": "LTO",
          "polygonscan.com": "POLYGON",
          "explorer.ont.io": "ONT",
          "minaexplorer.com": "MINA",
          "nanolooker.com": "NANO",
          "explorer.nebulas.io": "NAS",
          "explorer.nbs.plus": "NBS",
          "explorer.nebl.io": "NEBL",
          "nulscan.io": "NULS",
          "nxscan.com": "NXS",
          "explorer.harmony.one": "ONE",
          "explorer.poa.network": "POA",
          "qtum.info": "QTUM",
          "explorer.rsk.co": "RSK",
          "www.oasisscan.com": "ROSE",
          "ravencoin.network": "RVN",
          "sc.tokenview.com": "SC",
          "secretnodes.com": "SCRT",
          "explorer.skycoin.com": "SKY",
          "steemscan.com": "STEEM",
          "explorer.stacks.co": "STX",
          "www.thetascan.io": "THETA",
          "scan.tomochain.com": "TOMO",
          "explore.vechain.org": "VET",
          "explorer.vite.net": "VITE",
          "www.wanscan.org": "WAN",
          "wavesexplorer.com": "WAVES",
          "wax.eosx.io": "WAXP",
          "waltonchain.pro": "WTC",
          "chain.nem.ninja": "XEM",
          "verge-blockchain.info": "XVG",
          "explorer.yoyow.org": "YOYOW",
          "explorer.zcha.in": "ZEC",
          "explorer.zensystem.io": "ZEN"
        },
        legalMoney: {
          MXN: !0,
          UGX: !0,
          SDG: !0,
          XOF: !0,
          SEK: !0,
          GNF: !0,
          QAR: !0,
          LYD: !0,
          KWD: !0,
          ISK: !0,
          PAB: !0,
          CHF: !0,
          HRK: !0,
          VND: !0,
          TJS: !0,
          AED: !0,
          DKK: !0,
          BGN: !0,
          BHD: !0,
          KZT: !0,
          AFN: !0,
          EURPS: !0,
          HUF: !0,
          PEN: !0,
          TMT: !0,
          CLP: !0,
          TND: !0,
          DOP: !0,
          MAD: !0,
          PHP: !0,
          COP: !0,
          ETB: !0,
          LAK: !0,
          BND: !0,
          MDL: !0,
          AMD: !0,
          TRY: !0,
          EUR: !0,
          RON: !0,
          NGN: !0,
          CRC: !0,
          PKR: !0,
          PLN: !0,
          BRL: !0,
          ZAR: !0,
          TWD: !0,
          UYU: !0,
          OMR: !0,
          KES: !0,
          ARS: !0,
          UZS: !0,
          RUB: !0,
          DZD: !0,
          KGS: !0,
          XAF: !0,
          TZS: !0,
          AUD: !0,
          KHR: !0,
          IDR: !0,
          BWP: !0,
          MMK: !0,
          NOK: !0,
          CZK: !0,
          MNT: !0,
          GBP: !0,
          BYN: !0,
          GEL: !0,
          AZN: !0,
          UAH: !0,
          ILS: !0,
          GHS: !0,
          JOD: !0,
          HKD: !0,
          CAD: !0,
          SAR: !0,
          JPY: !0,
          EGP: !0,
          NZD: !0
        },
        legalMoneyCurrenciesById: {
          BUSD: "USD"
        }
      },
      exceptions: {
        spot: {
          // https://binance-docs.github.io/apidocs/spot/en/#error-codes
          exact: {
            "-1000": ie,
            "-1001": ie,
            "-1002": ee,
            "-1003": Ae,
            "-1004": ie,
            "-1006": ie,
            "-1007": ie,
            "-1008": ie,
            "-1010": ie,
            "-1013": g,
            "-1014": k,
            "-1015": Ae,
            "-1016": O,
            "-1020": pe,
            "-1021": ze,
            "-1022": Z,
            "-1099": Z,
            "-1100": g,
            "-1101": g,
            "-1102": g,
            "-1103": g,
            "-1104": g,
            "-1105": g,
            "-1106": g,
            "-1108": g,
            "-1111": g,
            "-1112": k,
            "-1114": g,
            "-1115": g,
            "-1116": g,
            "-1117": g,
            "-1118": g,
            "-1119": g,
            "-1120": g,
            "-1121": g,
            "-1125": Z,
            "-1127": g,
            "-1128": g,
            "-1130": g,
            "-1131": g,
            "-1134": g,
            "-1135": g,
            "-1145": g,
            "-1151": g,
            "-2008": Pt,
            "-2010": k,
            "-2011": Se,
            "-2013": Se,
            "-2014": Z,
            "-2015": Z,
            "-2016": k,
            "-2021": k,
            "-2022": k,
            "-2026": k,
            // 3xxx errors are available only for spot
            "-3000": be,
            "-3001": Z,
            "-3002": $e,
            "-3003": g,
            "-3004": k,
            "-3005": g,
            "-3006": g,
            "-3007": ie,
            "-3008": g,
            "-3009": Vt,
            "-3010": g,
            "-3011": g,
            "-3012": ie,
            "-3013": g,
            "-3014": Ee,
            "-3015": g,
            "-3016": g,
            "-3017": Vt,
            "-3018": Ee,
            "-3019": Ee,
            "-3020": g,
            "-3021": k,
            "-3022": Ee,
            "-3023": ie,
            "-3024": ie,
            "-3025": g,
            "-3026": g,
            "-3027": pt,
            "-3028": it,
            "-3029": ie,
            "-3036": Ee,
            "-3037": ie,
            "-3038": g,
            "-3041": re,
            "-3042": g,
            "-3043": ee,
            "-3044": ie,
            "-3045": ie,
            "-3999": ee,
            "-4001": O,
            "-4002": O,
            "-4003": g,
            "-4004": Z,
            "-4005": Ae,
            "-4006": O,
            "-4007": et,
            "-4008": et,
            "-4009": O,
            "-4010": ee,
            "-4011": g,
            "-4012": ee,
            "-4013": Z,
            "-4014": ke,
            "-4015": ee,
            "-4016": ee,
            "-4017": ee,
            "-4018": $e,
            "-4019": Yn,
            "-4021": g,
            "-4022": g,
            "-4023": ws,
            "-4024": re,
            "-4025": re,
            "-4026": re,
            "-4027": ie,
            "-4028": g,
            "-4029": Tu,
            "-4030": O,
            "-4031": ie,
            "-4032": ke,
            "-4033": et,
            "-4034": et,
            "-4035": gi,
            "-4036": ke,
            "-4037": ie,
            "-4038": ie,
            "-4039": ee,
            "-4040": ie,
            "-4041": ie,
            "-4042": It,
            "-4043": ie,
            "-4044": go,
            "-4045": ie,
            "-4046": Z,
            "-4047": g,
            "-4060": re,
            "-5001": O,
            "-5002": re,
            "-5003": re,
            "-5004": ie,
            "-5005": ie,
            "-5006": ie,
            "-5007": g,
            "-5008": ie,
            "-5009": $e,
            "-5010": je,
            "-5011": O,
            "-5012": je,
            "-5013": re,
            "-5021": O,
            "-5022": O,
            "-6001": O,
            "-6003": ee,
            "-6004": O,
            "-6005": O,
            "-6006": O,
            "-6007": ie,
            "-6008": ie,
            "-6009": Ae,
            "-6011": ie,
            "-6012": re,
            "-6013": O,
            "-6014": ie,
            "-6015": g,
            "-6016": g,
            "-6017": ee,
            "-6018": re,
            "-6019": ie,
            "-6020": O,
            "-7001": g,
            "-7002": g,
            "-10001": dt,
            "-10002": g,
            "-10005": O,
            "-10007": g,
            "-10008": g,
            "-10009": g,
            "-10010": g,
            "-10011": re,
            "-10012": g,
            "-10013": re,
            "-10015": ie,
            "-10016": ie,
            "-10017": ie,
            "-10018": g,
            "-10019": O,
            "-10020": g,
            "-10021": Se,
            "-10022": g,
            "-10023": ie,
            "-10024": O,
            "-10025": ie,
            "-10026": g,
            "-10028": g,
            "-10029": ie,
            "-10030": ie,
            "-10031": ie,
            "-10032": ie,
            "-10034": ie,
            "-10039": g,
            "-10040": g,
            "-10041": ie,
            "-10042": $e,
            "-10043": ie,
            "-10044": ie,
            "-10045": ie,
            "-10046": ie,
            "-10047": ee,
            "-11008": g,
            "-12014": Ae,
            // BLVT
            "-13000": ie,
            "-13001": ie,
            "-13002": ie,
            "-13003": ee,
            "-13004": ie,
            "-13005": ie,
            "-13006": g,
            "-13007": ee,
            // 18xxx - BINANCE CODE
            "-18002": Ae,
            "-18003": Ae,
            "-18004": Ae,
            "-18005": Ae,
            "-18006": g,
            "-18007": g,
            // spot & futures algo (TBD for OPTIONS & PORTFOLIO MARGIN)
            "-20121": g,
            "-20124": k,
            "-20130": g,
            "-20132": k,
            "-20194": g,
            "-20195": g,
            "-20196": g,
            "-20198": k,
            "-20204": g,
            // 21xxx - PORTFOLIO MARGIN
            "-21001": g,
            "-21002": Vt,
            "-21003": $e,
            "-21004": ie,
            "-21005": re,
            "-21006": ie,
            "-21007": ie,
            "-32603": O,
            400002: Z,
            100001003: Z,
            200003903: Z
            // undocumented, {"code":200003903,"msg":"Your identity verification has been rejected. Please complete identity verification again."}
          }
        },
        linear: {
          // https://binance-docs.github.io/apidocs/futures/en/#error-codes
          exact: {
            "-1000": O,
            "-1001": O,
            "-1002": Z,
            "-1003": Ae,
            "-1004": ie,
            "-1005": ee,
            "-1006": be,
            "-1007": be,
            "-1008": ie,
            "-1010": ie,
            "-1011": ee,
            "-1013": g,
            "-1014": k,
            "-1015": Ae,
            "-1016": O,
            "-1020": O,
            "-1021": ze,
            "-1022": Z,
            "-1023": g,
            "-1099": Z,
            "-1100": g,
            "-1101": g,
            "-1102": g,
            "-1103": g,
            "-1104": g,
            "-1105": g,
            "-1106": g,
            "-1108": $e,
            "-1109": ee,
            "-1110": g,
            "-1111": g,
            "-1112": k,
            "-1113": g,
            "-1114": g,
            "-1115": g,
            "-1116": g,
            "-1117": g,
            "-1118": g,
            "-1119": k,
            "-1120": g,
            "-1121": it,
            "-1122": O,
            "-1125": Z,
            "-1126": $e,
            "-1127": g,
            "-1128": g,
            "-1130": g,
            "-1136": g,
            "-2010": k,
            "-2011": Se,
            "-2012": ie,
            "-2013": Se,
            "-2014": Z,
            "-2015": Z,
            "-2016": k,
            "-2017": ee,
            "-2018": re,
            "-2019": re,
            "-2020": k,
            "-2021": k,
            "-2022": k,
            "-2023": ie,
            "-2024": re,
            "-2025": k,
            "-2026": g,
            "-2027": k,
            "-2028": re,
            "-4000": g,
            "-4001": g,
            "-4002": g,
            "-4003": g,
            "-4004": g,
            "-4005": g,
            "-4006": g,
            "-4007": g,
            "-4008": g,
            "-4009": g,
            "-4010": g,
            "-4011": g,
            "-4012": g,
            "-4013": g,
            "-4014": g,
            "-4015": g,
            "-4016": k,
            "-4017": g,
            "-4018": g,
            "-4019": k,
            "-4020": g,
            "-4021": g,
            "-4022": g,
            "-4023": g,
            "-4024": g,
            "-4025": g,
            "-4026": g,
            "-4027": g,
            "-4028": g,
            "-4029": g,
            "-4030": g,
            "-4031": g,
            "-4032": k,
            "-4033": g,
            "-4044": g,
            "-4045": k,
            "-4046": k,
            "-4047": k,
            "-4048": k,
            "-4049": k,
            "-4050": re,
            "-4051": re,
            "-4052": ie,
            "-4053": k,
            "-4054": ie,
            "-4055": g,
            "-4056": Z,
            "-4057": Z,
            "-4058": g,
            "-4059": g,
            "-4060": g,
            "-4061": g,
            "-4062": g,
            "-4063": g,
            "-4064": g,
            "-4065": g,
            "-4066": g,
            "-4067": ie,
            "-4068": ie,
            "-4069": g,
            "-4070": g,
            "-4071": g,
            "-4072": k,
            "-4073": g,
            "-4074": g,
            "-4075": k,
            "-4076": k,
            "-4077": k,
            "-4078": ie,
            "-4079": g,
            "-4080": ee,
            "-4081": k,
            "-4082": k,
            "-4083": k,
            "-4084": O,
            "-4085": g,
            "-4086": k,
            "-4087": ee,
            "-4088": ee,
            "-4104": O,
            "-4114": O,
            "-4115": O,
            "-4118": ie,
            "-4131": ie,
            "-4135": g,
            "-4137": g,
            "-4138": g,
            "-4139": g,
            "-4140": g,
            "-4141": ie,
            "-4142": k,
            "-4144": it,
            "-4164": ie,
            "-4165": g,
            "-4167": ie,
            "-4168": ie,
            "-4169": ie,
            "-4170": ie,
            "-4171": ie,
            "-4172 ": ie,
            "-4183": g,
            "-4184": g,
            "-4192": k,
            "-4202": ee,
            "-4203": ee,
            "-4205": ee,
            "-4206": ee,
            "-4208": ie,
            "-4209": ie,
            "-4210": g,
            "-4211": g,
            "-4400": ee,
            "-4401": ee,
            "-4402": ee,
            "-4403": ee,
            "-5021": k,
            "-5022": k,
            "-5024": ie,
            "-5025": ie,
            "-5026": ie,
            "-5027": ie,
            "-5028": g,
            "-5037": k,
            "-5038": g,
            "-5039": g,
            "-5040": g,
            "-5041": ie,
            //
            // spot & futures algo (TBD for OPTIONS & PORTFOLIO MARGIN)
            //
            "-20121": it,
            "-20124": g,
            "-20130": g,
            "-20132": k,
            "-20194": g,
            "-20195": g,
            "-20196": g,
            "-20198": ie,
            "-20204": g
            // The notional of USD is less or more than the limit.
          }
        },
        inverse: {
          // https://binance-docs.github.io/apidocs/delivery/en/#error-codes
          exact: {
            "-1000": be,
            "-1001": be,
            "-1002": Z,
            "-1003": Ae,
            "-1004": ie,
            "-1005": ee,
            "-1006": be,
            "-1007": be,
            "-1010": ie,
            "-1011": ee,
            "-1013": g,
            "-1014": g,
            "-1015": Ae,
            "-1016": O,
            "-1020": O,
            "-1021": ze,
            "-1022": Z,
            "-1023": g,
            "-1100": g,
            "-1101": g,
            "-1102": g,
            "-1103": g,
            "-1104": g,
            "-1105": g,
            "-1106": g,
            "-1108": $e,
            "-1109": Z,
            "-1110": $e,
            "-1111": g,
            "-1112": ie,
            "-1113": g,
            "-1114": g,
            "-1115": g,
            "-1116": g,
            "-1117": g,
            "-1118": g,
            "-1119": g,
            "-1120": g,
            "-1121": pt,
            "-1125": Z,
            "-1127": g,
            "-1128": g,
            "-1130": g,
            "-1136": g,
            "-2010": k,
            "-2011": Se,
            "-2013": Se,
            "-2014": Z,
            "-2015": Z,
            "-2016": ie,
            "-2018": re,
            "-2019": re,
            "-2020": ie,
            "-2021": k,
            "-2022": k,
            "-2023": ie,
            "-2024": k,
            "-2025": ie,
            "-2026": g,
            "-2027": ie,
            "-2028": ie,
            "-4000": g,
            "-4001": g,
            "-4002": g,
            "-4003": g,
            "-4004": g,
            "-4005": g,
            "-4006": g,
            "-4007": g,
            "-4008": g,
            "-4009": g,
            "-4010": g,
            "-4011": g,
            "-4012": g,
            "-4013": g,
            "-4014": g,
            "-4015": g,
            "-4016": g,
            "-4017": g,
            "-4018": g,
            "-4019": ie,
            "-4020": g,
            "-4021": g,
            "-4022": g,
            "-4023": g,
            "-4024": g,
            "-4025": g,
            "-4026": g,
            "-4027": g,
            "-4028": g,
            "-4029": g,
            "-4030": g,
            "-4031": g,
            "-4032": ie,
            "-4033": O,
            "-4044": O,
            "-4045": ie,
            "-4046": O,
            "-4047": ie,
            "-4048": ie,
            "-4049": ie,
            "-4050": re,
            "-4051": re,
            "-4052": ie,
            "-4053": ie,
            "-4054": ie,
            "-4055": g,
            "-4056": Z,
            "-4057": Z,
            "-4058": g,
            "-4059": g,
            "-4060": g,
            "-4061": ie,
            "-4062": g,
            //
            "-4067": ie,
            "-4068": ie,
            "-4082": ie,
            "-4083": ie,
            "-4084": pe,
            "-4086": g,
            "-4087": g,
            "-4088": g,
            "-4089": ee,
            "-4090": ee,
            "-4104": O,
            "-4110": O,
            "-4111": O,
            "-4112": ie,
            "-4113": ie,
            "-4135": g,
            "-4137": g,
            "-4138": g,
            "-4139": g,
            "-4142": k,
            "-4150": ie,
            "-4151": g,
            "-4152": g,
            "-4154": g,
            "-4155": g,
            "-4178": g,
            "-4192": k,
            "-4194": ee,
            "-4195": ee,
            "-4196": g,
            "-4197": ie,
            "-4198": ie,
            "-4199": O,
            "-4200": ee,
            "-4201": ee,
            "-4202": ie,
            "-4188": O,
            //
            // spot & futures algo
            //
            "-20121": it,
            "-20124": g,
            "-20130": g,
            "-20132": k,
            "-20194": g,
            "-20195": g,
            "-20196": g,
            "-20198": ie,
            "-20204": g
            // The notional of USD is less or more than the limit.
          }
        },
        option: {
          // https://binance-docs.github.io/apidocs/voptions/en/#error-codes
          exact: {
            "-1000": be,
            "-1001": be,
            "-1002": Z,
            "-1008": Ae,
            "-1014": k,
            "-1015": Ae,
            "-1016": O,
            "-1020": O,
            "-1021": ze,
            "-1022": Z,
            "-1100": g,
            "-1101": g,
            "-1102": g,
            "-1103": g,
            "-1104": g,
            "-1105": g,
            "-1106": g,
            "-1111": g,
            "-1115": g,
            "-1116": g,
            "-1117": g,
            "-1118": g,
            "-1119": g,
            "-1120": g,
            "-1121": g,
            "-1125": Z,
            "-1127": g,
            "-1128": pt,
            "-1129": pt,
            "-1130": g,
            "-1131": O,
            "-2010": k,
            "-2013": Se,
            "-2014": Z,
            "-2015": Z,
            "-2018": re,
            "-2027": re,
            "-3029": je,
            "-4001": g,
            "-4002": g,
            "-4003": g,
            "-4004": g,
            "-4005": g,
            "-4013": g,
            "-4029": g,
            "-4030": g,
            "-4055": g
            // AMOUNT_MUST_BE_POSITIVE
          }
        },
        portfolioMargin: {
          exact: {
            "-1000": O,
            "-1001": O,
            "-1002": Z,
            "-1003": Ae,
            "-1004": ie,
            "-1005": ee,
            "-1006": be,
            "-1007": be,
            "-1010": ie,
            "-1011": ee,
            "-1013": ie,
            "-1014": k,
            "-1015": Ae,
            "-1016": O,
            "-1020": O,
            "-1021": ze,
            "-1022": Z,
            "-1023": g,
            "-1100": g,
            "-1101": g,
            "-1102": g,
            "-1103": g,
            "-1104": g,
            "-1105": g,
            "-1106": g,
            "-1108": pt,
            "-1109": k,
            "-1110": pt,
            "-1111": g,
            "-1112": ie,
            "-1113": g,
            "-1114": g,
            "-1115": g,
            "-1116": g,
            "-1117": g,
            "-1118": g,
            "-1119": g,
            "-1120": g,
            "-1121": it,
            "-1125": Z,
            "-1127": g,
            "-1128": g,
            "-1130": g,
            "-1136": k,
            "-2010": k,
            "-2011": Se,
            "-2013": Se,
            "-2014": Z,
            "-2015": Z,
            "-2016": ie,
            "-2018": re,
            "-2019": re,
            "-2020": k,
            "-2021": k,
            "-2022": k,
            "-2023": ie,
            "-2024": ie,
            "-2025": ie,
            "-2026": g,
            "-2027": ie,
            "-2028": ie,
            "-4000": g,
            "-4001": g,
            "-4002": g,
            "-4003": g,
            "-4004": g,
            "-4005": g,
            "-4006": g,
            "-4007": g,
            "-4008": g,
            "-4009": g,
            "-4010": g,
            "-4011": g,
            "-4012": g,
            "-4013": g,
            "-4014": g,
            "-4015": g,
            "-4016": g,
            "-4017": g,
            "-4018": g,
            "-4019": ie,
            "-4020": g,
            "-4021": g,
            "-4022": g,
            "-4023": g,
            "-4024": g,
            "-4025": g,
            "-4026": g,
            "-4027": g,
            "-4028": g,
            "-4029": g,
            "-4030": g,
            "-4031": g,
            "-4032": ie,
            "-4033": k,
            "-4044": g,
            "-4045": ie,
            "-4046": ie,
            "-4047": ie,
            "-4048": ie,
            "-4049": g,
            "-4050": re,
            "-4051": re,
            "-4052": ie,
            "-4053": k,
            "-4054": ie,
            "-4055": g,
            "-4056": Z,
            "-4057": Z,
            "-4058": g,
            "-4059": g,
            "-4060": g,
            "-4061": g,
            "-4062": g,
            "-4063": g,
            "-4064": g,
            "-4065": g,
            "-4066": g,
            "-4067": ie,
            "-4068": ie,
            "-4069": g,
            "-4070": g,
            "-4071": g,
            "-4072": ie,
            "-4073": g,
            "-4074": g,
            "-4075": g,
            "-4076": ie,
            "-4077": ie,
            "-4078": ie,
            "-4079": g,
            "-4080": ee,
            "-4081": k,
            "-4082": k,
            "-4083": ie,
            "-4084": k,
            "-4085": g,
            "-4086": g,
            "-4087": ee,
            "-4088": ee,
            "-4104": g,
            "-4114": g,
            "-4115": k,
            "-4118": ie,
            "-4131": ie,
            "-4135": g,
            "-4137": g,
            "-4138": g,
            "-4139": g,
            "-4140": g,
            "-4141": g,
            "-4142": k,
            "-4144": it,
            "-4161": ie,
            "-4164": ie,
            "-4165": g,
            "-4183": g,
            "-4184": g,
            "-5021": k,
            "-5022": k
            // Due to the order could not be executed as maker, the Post Only order will be rejected.
          }
        },
        exact: {
          "System is under maintenance.": dt,
          "System abnormality": be,
          "You are not authorized to execute this request.": ee,
          "API key does not exist": Z,
          "Order would trigger immediately.": k,
          "Stop price would trigger immediately.": k,
          "Order would immediately match and take.": k,
          "Account has insufficient balance for requested action.": re,
          "Rest API trading is not enabled.": ee,
          "This account may not place or cancel orders.": ee,
          "You don't have permission.": ee,
          "Market is closed.": pt,
          "Too many requests. Please try again later.": Ae,
          "This action is disabled on this account.": Ee,
          "Limit orders require GTC for this phase.": k,
          "This order type is not possible in this trading phase.": g,
          "This type of sub-account exceeds the maximum number limit": ie,
          "This symbol is restricted for this account.": ee,
          "This symbol is not permitted for this account.": ee
          // {"code":-2010,"msg":"This symbol is not permitted for this account."}
        },
        broad: {
          "has no operation privilege": ee,
          MAX_POSITION: k
          // {"code":-2010,"msg":"Filter failure: MAX_POSITION"}
        },
        messages: {
          "Filter failure: NOTIONAL": ye.ORDER_UNDER_MINIMUM
        }
      }
    });
  }
  isUsingForcedProxy(e, t = void 0) {
    return e && e.forceProxy ? (delete e.forceProxy, !0) : !1;
  }
  isInverse(e, t = void 0) {
    return t === void 0 ? e === "delivery" : t === "inverse";
  }
  isLinear(e, t = void 0) {
    return t === void 0 ? e === "future" || e === "swap" : t === "linear";
  }
  convertExpireDate(e) {
    const t = e.slice(0, 2), i = e.slice(2, 4), s = e.slice(4, 6);
    return "20" + t + "-" + i + "-" + s + "T00:00:00Z";
  }
  createExpiredOptionMarket(e) {
    const t = "USDT", i = e.split("-"), s = e.split("/");
    let n;
    e.indexOf("/") > -1 ? n = this.safeString(s, 0) : n = this.safeString(i, 0);
    const r = this.safeString(i, 1), a = this.safeInteger(i, 2), o = this.safeString(i, 2), c = this.safeString(i, 3), u = this.convertExpireDate(r), f = this.parse8601(u);
    return {
      id: n + "-" + r + "-" + o + "-" + c,
      symbol: n + "/" + t + ":" + t + "-" + r + "-" + o + "-" + c,
      base: n,
      quote: t,
      baseId: n,
      quoteId: t,
      active: void 0,
      type: "option",
      linear: void 0,
      inverse: void 0,
      spot: !1,
      swap: !1,
      future: !1,
      option: !0,
      margin: !1,
      contract: !0,
      contractSize: void 0,
      expiry: f,
      expiryDatetime: u,
      optionType: c === "C" ? "call" : "put",
      strike: a,
      settle: t,
      settleId: t,
      precision: {
        amount: void 0,
        price: void 0
      },
      limits: {
        amount: {
          min: void 0,
          max: void 0
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: void 0,
          max: void 0
        }
      },
      info: void 0
    };
  }
  market(e) {
    if (this.markets === void 0)
      throw new bs().exchange(this.id);
    let t = this.safeString(this.options, "defaultType");
    const i = this.safeString(this.options, "defaultSubType"), s = t === "future", n = t === "delivery", r = s || n;
    if (typeof e == "string") {
      if (e in this.markets) {
        const a = this.markets[e];
        if (r && a.spot) {
          const o = s ? a.quote : a.base, c = e + ":" + o;
          if (c in this.markets)
            return this.markets[c];
        } else
          return a;
      } else if (e in this.markets_by_id) {
        const a = this.markets_by_id[e];
        s ? t = "linear" : n ? t = "inverse" : t === void 0 && (t = i);
        for (let o = 0; o < a.length; o++) {
          const c = a[o];
          if (c[t])
            return c;
        }
        return a[0];
      } else if (e.indexOf("/") > -1 && e.indexOf(":") < 0) {
        const [a, o] = e.split("/"), c = o === "USD" ? a : o, u = e + ":" + c;
        if (u in this.markets)
          return this.markets[u];
      } else if (e.indexOf("-C") > -1 || e.indexOf("-P") > -1)
        return this.createExpiredOptionMarket(e);
    }
    throw new it(e).exchange(this.id);
  }
  safeMarket(e = void 0, t = void 0, i = void 0, s = void 0) {
    return e !== void 0 && (e.indexOf("-C") > -1 || e.indexOf("-P") > -1) && !(e in this.markets_by_id) ? this.createExpiredOptionMarket(e) : super.safeMarket(e, t, i, s);
  }
  costToPrecision(e, t) {
    return this.decimalToPrecision(t, Et, this.markets[e].precision.quote, this.precisionMode, this.paddingMode);
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  async fetchTime(e = {}) {
    const t = this.safeString2(this.options, "fetchTime", "defaultType", "spot"), i = this.safeString(e, "type", t), s = this.omit(e, "type");
    let n;
    [n, e] = this.handleSubTypeAndParams("fetchTime", void 0, e);
    let r;
    return this.isLinear(i, n) ? r = await this.fapiPublicGetTime(s) : this.isInverse(i, n) ? r = await this.dapiPublicGetTime(s) : r = await this.publicGetTime(s), this.safeInteger(r, "serverTime");
  }
  async fetchCurrencies(e = {}) {
    if (!this.safeValue(this.options, "fetchCurrencies") || !this.checkRequiredCredentials(!1) || this.safeValue(this.urls, "apiBackup") !== void 0)
      return;
    const s = await this.sapiGetCapitalConfigGetall(e), n = {}, r = this.safeValue(this.options, "legalMoney", {});
    for (let a = 0; a < s.length; a++) {
      const o = s[a], c = this.safeString(o, "coin"), u = this.safeString(o, "name"), f = this.safeCurrencyCode(c);
      if (!(f in r)) {
        let h, l = !1, p = !1;
        const m = this.safeValue(o, "networkList", []), y = {}, w = {};
        let S;
        for (let v = 0; v < m.length; v++) {
          const _ = m[v], V = this.safeString(_, "network"), j = this.safeStringUpper(_, "network"), G = this.safeDict(this.options, "networks", {}), W = this.safeString(G, j, j);
          m[v].network = W;
          const B = this.safeString(_, "name"), Q = this.safeNumber(_, "withdrawFee"), se = this.safeValue(_, "depositEnable"), $ = this.safeValue(_, "withdrawEnable");
          p = se || p, l = $ || l, w[V] = Q, (this.safeValue(_, "isDefault") || S === void 0) && (S = Q);
          const E = this.safeString(_, "withdrawIntegerMultiple");
          P.stringEq(E, "0") || (h = h === void 0 ? E : P.stringMin(h, E));
          const N = this.safeValue(_, "withdrawMin"), L = this.safeValue(_, "withdrawMax"), z = this.precisionFromString(this.safeString(_, "withdrawIntegerMultiple"));
          y[W] = {
            info: m[v],
            id: B,
            name: B,
            network: V,
            active: se && $,
            deposit: se,
            withdraw: $,
            fee: Q,
            precision: z,
            limits: {
              withdraw: {
                min: this.parseNumber(N),
                max: this.parseNumber(L)
              },
              deposit: {
                min: void 0,
                max: void 0
              }
            }
          };
        }
        const b = this.safeValue(o, "trading"), T = l && p && b;
        let x;
        h !== void 0 && (x = parseInt(this.numberToString(this.precisionFromString(h)))), n[f] = {
          id: c,
          name: u,
          code: f,
          precision: x,
          info: o,
          active: T,
          deposit: p,
          withdraw: l,
          networks: y,
          fee: S,
          fees: w,
          limits: this.limits
        };
      }
    }
    return n;
  }
  async fetchMarkets(e = {}) {
    const t = [], i = this.safeList(this.options, "fetchMarkets", ["spot", "linear", "inverse"]), s = this.safeBool(this.options, "sandboxMode", !1), n = [];
    for (let l = 0; l < i.length; l++) {
      const p = i[l];
      p === "option" && s || n.push(p);
    }
    for (let l = 0; l < n.length; l++) {
      const p = n[l];
      if (p === "spot")
        t.push(this.publicGetExchangeInfo(e));
      else if (p === "linear")
        t.push(this.fapiPublicGetExchangeInfo(e));
      else if (p === "inverse")
        t.push(this.dapiPublicGetExchangeInfo(e));
      else if (p === "option")
        t.push(this.eapiPublicGetExchangeInfo(e));
      else
        throw new ge(p).exchange(this.id);
    }
    const r = await Promise.all(t), a = this.safeValue(this.safeValue(r, 0), "symbols", []), o = this.safeValue(this.safeValue(r, 1), "symbols", []), c = this.safeValue(this.safeValue(r, 2), "symbols", []), u = this.safeValue(this.safeValue(r, 3), "optionSymbols", []);
    let f = a;
    f = this.arrayConcat(f, o), f = this.arrayConcat(f, c), f = this.arrayConcat(f, u);
    const h = [];
    for (let l = 0; l < f.length; l++)
      h.push(this.parseMarket(f[l]));
    return h;
  }
  parseMarket(e) {
    let t = !1, i = !1, s = !1;
    const n = this.safeString(e, "underlying"), r = this.safeString(e, "symbol"), a = r.split("-"), o = this.safeString(a, 0), c = this.safeStringLower(e, "symbol"), u = this.safeString(e, "baseAsset", o), f = this.safeString(e, "quoteAsset"), h = this.safeCurrencyCode(u), l = this.safeCurrencyCode(f), p = this.safeString(e, "contractType");
    let m = "contractType" in e, y = this.safeInteger2(e, "deliveryDate", "expiryDate"), w = this.safeString(e, "marginAsset");
    p === "PERPETUAL" || y === 41334048e5 ? (y = void 0, t = !0) : n !== void 0 ? (m = !0, s = !0, w = w === void 0 ? "USDT" : w) : y !== void 0 && (i = !0);
    const S = this.safeCurrencyCode(w), b = !m, T = this.safeList(e, "filters", []), x = this.indexBy(T, "filterType"), v = this.safeString2(e, "status", "contractStatus");
    let _, V = this.fees, j, G;
    const W = this.safeInteger(e, "strikePrice");
    let B = h + "/" + l;
    if (m) {
      t ? B = B + ":" + S : i ? B = B + ":" + S + "-" + this.yymmdd(y) : s && (B = B + ":" + S + "-" + this.yymmdd(y) + "-" + this.numberToString(W) + "-" + this.safeString(a, 3)), _ = this.safeNumber2(e, "contractSize", "unit", this.parseNumber("1")), j = S === l, G = S === h;
      const E = j ? "linear" : "inverse";
      V = this.safeDict(this.fees, E, {});
    }
    let Q = v === "TRADING";
    if (b) {
      const E = this.safeList(e, "permissionSets", []);
      for (let N = 0; N < E.length; N++) {
        const L = this.safeList(E, N, []);
        for (let z = 0; z < L.length; z++)
          if (L[z] === "TRD_GRP_003") {
            Q = !1;
            break;
          }
      }
    }
    const se = this.safeBool(e, "isMarginTradingAllowed", !1);
    let $;
    b ? $ = "spot" : t ? $ = "swap" : i ? $ = "future" : s && ($ = "option", Q = void 0);
    const te = {
      id: r,
      lowercaseId: c,
      symbol: B,
      base: h,
      quote: l,
      settle: S,
      baseId: u,
      quoteId: f,
      settleId: w,
      type: $,
      spot: b,
      margin: b && se,
      swap: t,
      future: i,
      option: s,
      active: Q,
      contract: m,
      linear: j,
      inverse: G,
      taker: V.trading.taker,
      maker: V.trading.maker,
      contractSize: _,
      expiry: y,
      expiryDatetime: this.iso8601(y),
      strike: W,
      optionType: this.safeStringLower(e, "side"),
      precision: {
        amount: this.safeInteger2(e, "quantityPrecision", "quantityScale"),
        price: this.safeInteger2(e, "pricePrecision", "priceScale"),
        base: this.safeInteger(e, "baseAssetPrecision"),
        quote: this.safeInteger(e, "quotePrecision")
      },
      limits: {
        leverage: {
          min: void 0,
          max: void 0
        },
        amount: {
          min: this.safeNumber(e, "minQty"),
          max: this.safeNumber(e, "maxQty")
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: void 0,
          max: void 0
        }
      },
      info: e,
      created: this.safeInteger(e, "onboardDate")
      // present in inverse & linear apis
    };
    if ("PRICE_FILTER" in x) {
      const E = this.safeDict(x, "PRICE_FILTER", {});
      te.limits.price = {
        min: this.safeNumber(E, "minPrice"),
        max: this.safeNumber(E, "maxPrice")
      }, te.precision.price = this.precisionFromString(E.tickSize);
    }
    if ("LOT_SIZE" in x) {
      const E = this.safeDict(x, "LOT_SIZE", {}), N = this.safeString(E, "stepSize");
      te.precision.amount = this.precisionFromString(N), te.limits.amount = {
        min: this.safeNumber(E, "minQty"),
        max: this.safeNumber(E, "maxQty")
      };
    }
    if ("MARKET_LOT_SIZE" in x) {
      const E = this.safeDict(x, "MARKET_LOT_SIZE", {});
      te.limits.market = {
        min: this.safeNumber(E, "minQty"),
        max: this.safeNumber(E, "maxQty")
      };
    }
    if ("MIN_NOTIONAL" in x || "NOTIONAL" in x) {
      const E = this.safeDict2(x, "MIN_NOTIONAL", "NOTIONAL", {});
      te.limits.cost.min = this.safeNumber2(E, "minNotional", "notional"), te.limits.cost.max = this.safeNumber(E, "maxNotional");
    }
    return te;
  }
  parseBalanceHelper(e) {
    const t = this.account();
    t.used = this.safeString(e, "locked"), t.free = this.safeString(e, "free");
    const i = this.safeString(e, "interest"), s = this.safeString(e, "borrowed");
    return t.debt = P.stringAdd(s, i), t;
  }
  parseBalanceCustom(e, t = void 0, i = void 0) {
    const s = {
      info: e
    };
    let n;
    const r = i === "isolated", a = t === "margin" || i === "cross";
    if (t === "papi")
      for (let o = 0; o < e.length; o++) {
        const c = e[o], u = this.account(), f = this.safeString(c, "asset"), h = this.safeCurrencyCode(f), l = this.safeString(c, "crossMarginBorrowed"), p = this.safeString(c, "crossMarginInterest");
        u.free = this.safeString(c, "crossMarginFree"), u.used = this.safeString(c, "crossMarginLocked"), u.total = this.safeString(c, "crossMarginAsset"), u.debt = P.stringAdd(l, p), s[h] = u;
      }
    else if (!r && (t === "spot" || a)) {
      n = this.safeInteger(e, "updateTime");
      const o = this.safeList2(e, "balances", "userAssets", []);
      for (let c = 0; c < o.length; c++) {
        const u = o[c], f = this.safeString(u, "asset"), h = this.safeCurrencyCode(f), l = this.account();
        if (l.free = this.safeString(u, "free"), l.used = this.safeString(u, "locked"), a) {
          const p = this.safeString(u, "borrowed"), m = this.safeString(u, "interest");
          l.debt = P.stringAdd(p, m);
        }
        s[h] = l;
      }
    } else if (r) {
      const o = this.safeList(e, "assets");
      for (let c = 0; c < o.length; c++) {
        const u = o[c], f = this.safeString(u, "symbol"), h = this.safeSymbol(f, void 0, void 0, "spot"), l = this.safeDict(u, "baseAsset", {}), p = this.safeDict(u, "quoteAsset", {}), m = this.safeCurrencyCode(this.safeString(l, "asset")), y = this.safeCurrencyCode(this.safeString(p, "asset")), w = {};
        w[m] = this.parseBalanceHelper(l), w[y] = this.parseBalanceHelper(p), s[h] = this.safeBalance(w);
      }
    } else if (t === "savings") {
      const [o, c] = e;
      [...o || [], ...c || []].forEach((u) => {
        const f = this.safeString(u, "asset"), h = this.safeCurrencyCode(f), l = this.safeString(u, "amount") || this.safeString(u, "totalAmount"), p = s[h] || this.account();
        p.total = (p.total || 0) + l, p.used = (p.used || 0) + l, s[h] = p;
      });
    } else if (t === "funding")
      for (let o = 0; o < e.length; o++) {
        const c = e[o], u = this.account(), f = this.safeString(c, "asset"), h = this.safeCurrencyCode(f);
        u.free = this.safeString(c, "free");
        const l = this.safeString(c, "freeze"), p = this.safeString(c, "withdrawing"), m = this.safeString(c, "locked");
        u.used = P.stringAdd(l, P.stringAdd(m, p)), s[h] = u;
      }
    else {
      let o = e;
      Array.isArray(e) || (o = this.safeList(e, "assets", []));
      for (let c = 0; c < o.length; c++) {
        const u = o[c], f = this.safeString(u, "asset"), h = this.safeCurrencyCode(f), l = this.account();
        l.free = this.safeString(u, "availableBalance"), l.used = this.safeString(u, "initialMargin"), l.total = this.safeString2(u, "marginBalance", "balance"), s[h] = l;
      }
    }
    return s.timestamp = n, s.datetime = this.iso8601(n), r ? s : this.safeBalance(s);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const t = this.safeString2(this.options, "fetchBalance", "defaultType", "spot");
    let i = this.safeString(e, "type", t), s;
    [s, e] = this.handleSubTypeAndParams("fetchBalance", void 0, e);
    let n;
    [n, e] = this.handleOptionAndParams2(e, "fetchBalance", "papi", "portfolioMargin", !1);
    let r, a;
    [r, a] = this.handleMarginModeAndParams("fetchBalance", e), a = this.omit(a, "type");
    let o;
    const c = {};
    if (n || i === "papi")
      i = "papi", o = await this.papiGetBalance(this.extend(c, a));
    else if (this.isLinear(i, s))
      i = "linear", o = await this.fapiPrivateV2GetAccount(this.extend(c, a));
    else if (this.isInverse(i, s))
      i = "inverse", o = await this.dapiPrivateGetAccount(this.extend(c, a));
    else if (r === "isolated") {
      const u = this.safeList(e, "symbols");
      if (a = this.omit(a, "symbols"), u !== void 0) {
        let f = "";
        if (Array.isArray(u)) {
          f = this.marketId(u[0]);
          for (let h = 1; h < u.length; h++) {
            const l = u[h], p = this.marketId(l);
            f += "," + p;
          }
        } else
          f = u;
        c.symbols = f;
      }
      o = await this.sapiGetMarginIsolatedAccount(this.extend(c, a));
    } else
      i === "margin" || r === "cross" ? o = await this.sapiGetMarginAccount(this.extend(c, a)) : i === "savings" ? (c.size = 100, o = await Promise.all([
        this.fetchPaginatedPositionsByPage("sapiGetSimpleEarnLockedPosition", this.extend(c, a), c.size),
        this.fetchPaginatedPositionsByPage("sapiGetSimpleEarnFlexiblePosition", this.extend(c, a), c.size)
      ])) : i === "funding" ? o = await this.sapiPostAssetGetFundingAsset(this.extend(c, a)) : o = await this.privateGetAccount(this.extend(c, a));
    return this.parseBalanceCustom(o, i, r);
  }
  async fetchPaginatedPositionsByPage(e, t, i, s = 10) {
    let n = [], r = 1;
    for (; r <= s; ) {
      const a = await this[e](this.extend(t, { current: r, size: i })), o = this.safeValue(a, "rows", []), c = this.safeInteger(a, "total");
      if (n = this.arrayConcat(n, o), o.length === 0 || c < i)
        break;
      r++;
    }
    return n;
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e), n = {
      symbol: s.id
    };
    t !== void 0 && (n.limit = t);
    let r;
    s.option ? r = await this.eapiPublicGetDepth(this.extend(n, i)) : s.linear ? r = await this.fapiPublicGetDepth(this.extend(n, i)) : s.inverse ? r = await this.dapiPublicGetDepth(this.extend(n, i)) : r = await this.publicGetDepth(this.extend(n, i));
    const a = this.safeInteger(r, "T"), o = this.parseOrderBook(r, e, a);
    return o.nonce = this.safeInteger2(r, "lastUpdateId", "u"), o;
  }
  parseTicker(e, t = void 0) {
    const i = this.safeInteger(e, "closeTime");
    let s;
    "time" in e && (s = "contract"), s === void 0 && (s = "bidQty" in e ? "spot" : "contract");
    const n = this.safeString(e, "symbol"), r = this.safeSymbol(n, t, void 0, s), a = this.safeString(e, "lastPrice"), o = "baseVolume" in e;
    let c, u;
    return o ? (c = this.safeString(e, "baseVolume"), u = this.safeString(e, "volume")) : (c = this.safeString(e, "volume"), u = this.safeString2(e, "quoteVolume", "amount")), this.safeTicker({
      symbol: r,
      timestamp: i,
      datetime: this.iso8601(i),
      high: this.safeString2(e, "highPrice", "high"),
      low: this.safeString2(e, "lowPrice", "low"),
      bid: this.safeString(e, "bidPrice"),
      bidVolume: this.safeString(e, "bidQty"),
      ask: this.safeString(e, "askPrice"),
      askVolume: this.safeString(e, "askQty"),
      vwap: this.safeString(e, "weightedAvgPrice"),
      open: this.safeString2(e, "openPrice", "open"),
      close: a,
      last: a,
      previousClose: this.safeString(e, "prevClosePrice"),
      change: this.safeString(e, "priceChange"),
      percentage: this.safeString(e, "priceChangePercent"),
      average: void 0,
      baseVolume: c,
      quoteVolume: u,
      info: e
    }, t);
  }
  async fetchStatus(e = {}) {
    const t = await this.sapiGetSystemStatus(e), i = this.safeString(t, "status");
    return {
      status: this.safeString({ 0: "ok", 1: "maintenance" }, i, i),
      updated: void 0,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    };
    let n;
    if (i.option)
      n = await this.eapiPublicGetTicker(this.extend(s, t));
    else if (i.linear)
      n = await this.fapiPublicGetTicker24hr(this.extend(s, t));
    else if (i.inverse)
      n = await this.dapiPublicGetTicker24hr(this.extend(s, t));
    else {
      const r = this.safeBool(t, "rolling", !1);
      t = this.omit(t, "rolling"), r ? n = await this.publicGetTicker(this.extend(s, t)) : n = await this.publicGetTicker24hr(this.extend(s, t));
    }
    if (Array.isArray(n)) {
      const r = this.safeDict(n, 0, {});
      return this.parseTicker(r, i);
    }
    return this.parseTicker(n, i);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets();
    let i, s;
    if (e = this.marketSymbols(e, void 0, !0, !0, !0), e !== void 0) {
      const a = this.safeString(e, 0);
      s = this.market(a);
    }
    [i, t] = this.handleMarketTypeAndParams("fetchTickers", s, t);
    let n;
    [n, t] = this.handleSubTypeAndParams("fetchTickers", s, t);
    let r;
    if (i === "option")
      r = await this.eapiPublicGetTicker(t);
    else if (this.isLinear(i, n))
      r = await this.fapiPublicGetTicker24hr(t);
    else if (this.isInverse(i, n))
      r = await this.dapiPublicGetTicker24hr(t);
    else {
      const a = {};
      if (e !== void 0) {
        const o = this.marketIds(e);
        a.symbols = this.json(o);
      }
      r = await this.publicGetTicker24hr(this.extend(a, t));
    }
    return this.parseTickers(r, e);
  }
  parseOHLCV(e, t = void 0) {
    const i = t.inverse ? 7 : 5;
    return [
      this.safeInteger2(e, 0, "closeTime"),
      this.safeNumber2(e, 1, "open"),
      this.safeNumber2(e, 2, "high"),
      this.safeNumber2(e, 3, "low"),
      this.safeNumber2(e, 4, "close"),
      this.safeNumber2(e, i, "volume")
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate", !1), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 1e3);
    const a = this.market(e), o = 500, c = 1500, u = this.safeString(n, "price"), f = this.safeInteger(n, "until");
    n = this.omit(n, ["price", "until"]), s = s === void 0 ? o : Math.min(s, c);
    const h = {
      interval: this.safeString(this.timeframes, t, t),
      limit: s
    };
    if (u === "index" ? h.pair = a.id : h.symbol = a.id, i !== void 0 && (h.startTime = i, a.inverse && i > 0)) {
      const p = this.parseTimeframe(t), m = this.sum(i, s * p * 1e3 - 1), y = this.milliseconds();
      h.endTime = Math.min(y, m);
    }
    f !== void 0 && (h.endTime = f);
    let l;
    return a.option ? l = await this.eapiPublicGetKlines(this.extend(h, n)) : u === "mark" ? a.inverse ? l = await this.dapiPublicGetMarkPriceKlines(this.extend(h, n)) : l = await this.fapiPublicGetMarkPriceKlines(this.extend(h, n)) : u === "index" ? a.inverse ? l = await this.dapiPublicGetIndexPriceKlines(this.extend(h, n)) : l = await this.fapiPublicGetIndexPriceKlines(this.extend(h, n)) : a.linear ? l = await this.fapiPublicGetKlines(this.extend(h, n)) : a.inverse ? l = await this.dapiPublicGetKlines(this.extend(h, n)) : l = await this.publicGetKlines(this.extend(h, n)), this.parseOHLCVs(l, a, t, i, s);
  }
  parseTrade(e, t = void 0) {
    if ("isDustTrade" in e)
      return this.parseDustTrade(e, t);
    const i = this.safeInteger2(e, "T", "time");
    let s = this.safeString2(e, "q", "qty");
    s = this.safeString(e, "quantity", s);
    const n = this.safeString(e, "symbol"), a = "isIsolated" in e || "M" in e || "orderListId" in e || "isMaker" in e ? "spot" : "contract";
    t = this.safeMarket(n, t, void 0, a);
    const o = t.symbol;
    let c;
    const u = this.safeValue2(e, "m", "isBuyerMaker");
    let f;
    u !== void 0 ? c = u ? "sell" : "buy" : "side" in e ? c = this.safeStringLower(e, "side") : "isBuyer" in e && (c = e.isBuyer ? "buy" : "sell");
    let h;
    if ("commission" in e && (h = {
      cost: this.safeString(e, "commission"),
      currency: this.safeCurrencyCode(this.safeString(e, "commissionAsset"))
    }), "isMaker" in e && (f = e.isMaker ? "maker" : "taker"), "maker" in e && (f = e.maker ? "maker" : "taker"), "optionSide" in e || t.option) {
      const l = this.safeCurrencyCode(this.safeString(e, "quoteAsset", "USDT"));
      f = this.safeStringLower(e, "liquidity"), "fee" in e && (h = {
        cost: this.safeString(e, "fee"),
        currency: l
      }), c !== "buy" && c !== "sell" && (c = c === "1" ? "buy" : "sell"), "optionSide" in e && c !== "buy" && (s = P.stringMul("-1", s));
    }
    return this.safeTrade({
      info: e,
      timestamp: i,
      datetime: this.iso8601(i),
      symbol: o,
      id: this.safeStringN(e, ["t", "a", "tradeId", "id"]),
      order: this.safeString(e, "orderId"),
      type: this.safeStringLower(e, "type"),
      side: c,
      takerOrMaker: f,
      price: this.safeString2(e, "p", "price"),
      amount: s,
      cost: this.safeString2(e, "quoteQty", "baseQty"),
      fee: h
    }, t);
  }
  parseDustTrade(e, t = void 0) {
    const i = this.safeString(e, "transId"), s = this.safeInteger(e, "operateTime"), n = this.safeString(e, "fromAsset"), r = this.safeCurrencyCode(n), o = this.currency("BNB").code, c = o + "/" + r;
    let u = !1;
    c in this.markets && (u = !0);
    const f = this.safeString(e, "serviceChargeAmount"), h = {
      currency: o,
      cost: this.parseNumber(f)
    };
    let l, p, m, y;
    u ? (l = c, p = this.safeString(e, "transferedAmount"), m = this.safeString(e, "amount"), y = "buy") : (l = r + "/" + o, p = this.safeString(e, "amount"), m = this.safeString(e, "transferedAmount"), y = "sell");
    let w;
    m !== void 0 && p && (w = P.stringDiv(m, p));
    const S = void 0, b = this.parseNumber(p), T = this.parseNumber(w), x = this.parseNumber(m), v = void 0, _ = void 0;
    return {
      id: S,
      timestamp: s,
      datetime: this.iso8601(s),
      symbol: l,
      order: i,
      type: v,
      takerOrMaker: _,
      side: y,
      amount: b,
      price: T,
      cost: x,
      fee: h,
      info: e
    };
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchTrades", e, t, i, s);
    const r = this.market(e), a = {
      symbol: r.id
      // 'fromId': 123,    // ID to get aggregate trades from INCLUSIVE.
      // 'startTime': 456, // Timestamp in ms to get aggregate trades from INCLUSIVE.
      // 'endTime': 789,   // Timestamp in ms to get aggregate trades until INCLUSIVE.
      // 'limit': 500,     // default = 500, maximum = 1000
    };
    if (!r.option) {
      t !== void 0 && (a.startTime = t, a.endTime = this.sum(t, 36e5));
      const u = this.safeInteger(s, "until");
      u !== void 0 && (a.endTime = u);
    }
    if (i !== void 0) {
      const u = r.swap || r.future;
      a.limit = u ? Math.min(i, 1e3) : i;
    }
    let o = this.safeString(this.options, "fetchTradesMethod");
    o = this.safeString2(s, "fetchTradesMethod", "method", o), s = this.omit(s, ["until", "fetchTradesMethod"]);
    let c;
    return r.option || o === "eapiPublicGetTrades" ? c = await this.eapiPublicGetTrades(this.extend(a, s)) : r.linear || o === "fapiPublicGetAggTrades" ? c = await this.fapiPublicGetAggTrades(this.extend(a, s)) : r.inverse || o === "dapiPublicGetAggTrades" ? c = await this.dapiPublicGetAggTrades(this.extend(a, s)) : c = await this.publicGetAggTrades(this.extend(a, s)), this.parseTrades(c, r, t, i);
  }
  async editSpotOrder(e, t, i, s, n, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t);
    if (!o.spot)
      throw new ge(o.type).exchange(this.id);
    const c = this.editSpotOrderRequest(e, t, i, s, n, r, a), u = await this.privatePostOrderCancelReplace(c), f = this.safeValue(u, "newOrderResponse");
    return this.parseOrder(f, o);
  }
  editSpotOrderRequest(e, t, i, s, n, r = void 0, a = {}) {
    const o = this.market(t), c = this.safeStringN(a, ["newClientOrderId", "clientOrderId", "origClientOrderId"]), u = {
      symbol: o.id,
      side: s.toUpperCase()
    }, f = i.toUpperCase();
    let h = f;
    this.isPostOnly(f === "MARKET", f === "LIMIT_MAKER", a) && (h = "LIMIT_MAKER"), u.type = h;
    const p = this.safeNumber2(a, "stopPrice", "triggerPrice");
    p !== void 0 && (h === "MARKET" ? h = "STOP_LOSS" : h === "LIMIT" && (h = "STOP_LOSS_LIMIT"));
    const m = this.safeValue(o.info, "orderTypes");
    if (!this.inArray(h, m))
      throw f !== h ? new g("stopPrice parameter is not allowed for " + t + " " + i + " orders").exchange(this.id) : new g(i + " is not a valid order type for the " + t + " market").exchange(this.id);
    if (c === void 0) {
      const x = this.safeValue(this.options, "broker");
      if (x !== void 0) {
        const v = this.safeString(x, "spot");
        v !== void 0 && (u.newClientOrderId = v + this.uuid22());
      }
    } else
      u.newClientOrderId = c;
    u.newOrderRespType = this.safeValue(this.options.newOrderRespType, i, "RESULT");
    let y = !1, w = !1, S = !1, b = !1;
    if (h === "MARKET")
      if (this.safeValue(this.options, "quoteOrderQty", !0)) {
        const v = this.safeValue2(a, "quoteOrderQty", "cost"), _ = o.precision.price;
        if (v !== void 0)
          u.quoteOrderQty = this.decimalToPrecision(v, Et, _, this.precisionMode);
        else if (r !== void 0) {
          const V = this.numberToString(n), j = this.numberToString(r), G = P.stringMul(V, j);
          u.quoteOrderQty = this.decimalToPrecision(G, Et, _, this.precisionMode);
        } else
          b = !0;
      } else
        b = !0;
    else
      h === "LIMIT" ? (w = !0, y = !0, b = !0) : h === "STOP_LOSS" || h === "TAKE_PROFIT" ? (S = !0, b = !0) : h === "STOP_LOSS_LIMIT" || h === "TAKE_PROFIT_LIMIT" ? (b = !0, S = !0, w = !0, y = !0) : h === "LIMIT_MAKER" && (w = !0, b = !0);
    if (b && (u.quantity = this.amountToPrecision(t, n)), w) {
      if (r === void 0)
        throw new g("It requires a price argument for a " + i + " order").exchange(this.id);
      u.price = this.priceToPrecision(t, r);
    }
    if (y && this.safeString(a, "timeInForce") === void 0 && (u.timeInForce = this.options.defaultTimeInForce), S) {
      if (p === void 0)
        throw new g("It requires a stopPrice extra param for a " + i + " order").exchange(this.id);
      u.stopPrice = this.priceToPrecision(t, p);
    }
    return u.cancelReplaceMode = "STOP_ON_FAILURE", this.safeString2(a, "cancelNewClientOrderId", "cancelOrigClientOrderId") === void 0 && (u.cancelOrderId = e), this.safeString(a, "timeInForce") === "PO" && (a = this.omit(a, ["timeInForce"])), a = this.omit(a, ["quoteOrderQty", "cost", "stopPrice", "newClientOrderId", "clientOrderId", "postOnly"]), this.extend(u, a);
  }
  async editContractOrder(e, t, i, s, n, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t);
    if (!o.contract)
      throw new ge(o.type).exchange(this.id);
    const c = {
      symbol: o.id,
      side: s.toUpperCase()
    }, u = this.safeStringN(a, ["newClientOrderId", "clientOrderId", "origClientOrderId"]);
    c.orderId = e, c.quantity = this.amountToPrecision(t, n), r !== void 0 && (c.price = this.priceToPrecision(t, r)), u !== void 0 && (c.origClientOrderId = u), a = this.omit(a, ["clientOrderId", "newClientOrderId"]);
    let f;
    return o.linear ? f = await this.fapiPrivatePutOrder(this.extend(c, a)) : o.inverse && (f = await this.dapiPrivatePutOrder(this.extend(c, a))), this.parseOrder(f, o);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t);
    if (o.option)
      throw new ge(o.type).exchange(this.id);
    return o.spot ? await this.editSpotOrder(e, t, i, s, n, r, a) : await this.editContractOrder(e, t, i, s, n, r, a);
  }
  parseOrderStatus(e) {
    const t = {
      NEW: "open",
      PARTIALLY_FILLED: "open",
      ACCEPTED: "open",
      FILLED: "closed",
      CANCELED: "canceled",
      CANCELLED: "canceled",
      PENDING_CANCEL: "canceling",
      REJECTED: "rejected",
      EXPIRED: "expired",
      EXPIRED_IN_MATCH: "expired"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    if (this.safeString(e, "code") !== void 0)
      return this.safeOrder({ info: e, status: "rejected" }, t);
    const s = this.parseOrderStatus(this.safeString2(e, "status", "strategyStatus")), n = this.safeString(e, "symbol"), a = "positionSide" in e || "cumQuote" in e ? "contract" : "spot", o = this.safeSymbol(n, t, void 0, a), c = this.safeString(e, "executedQty", "0"), u = this.safeIntegerN(e, ["time", "createTime", "workingTime", "transactTime", "updateTime"]);
    let f;
    if ("transactTime" in e || "updateTime" in e) {
      const G = this.safeInteger2(e, "updateTime", "transactTime");
      s === "open" ? P.stringGt(c, "0") && (f = G) : s === "closed" && (f = G);
    }
    const h = this.safeInteger2(e, "transactTime", "updateTime"), l = this.safeString(e, "avgPrice"), p = this.safeString(e, "price"), m = this.safeString2(e, "origQty", "quantity");
    let y = this.safeString2(e, "cummulativeQuoteQty", "cumQuote");
    y = this.safeString(e, "cumBase", y);
    let w = this.safeStringLower(e, "type");
    const S = this.safeStringLower(e, "side"), b = this.safeList(e, "fills", []);
    let T = this.safeString(e, "timeInForce");
    T === "GTX" && (T = "PO");
    const x = w === "limit_maker" || T === "PO";
    w === "limit_maker" && (w = "limit");
    const v = this.safeString(e, "stopPrice"), _ = this.parseNumber(this.omitZero(v)), V = this.safeNumber(e, "fee");
    let j;
    return V !== void 0 && (j = {
      currency: this.safeString(e, "quoteAsset"),
      cost: V,
      rate: void 0
    }), this.safeOrder({
      info: e,
      id: this.safeString2(e, "strategyId", "orderId"),
      clientOrderId: this.safeString2(e, "clientOrderId", "newClientStrategyId"),
      timestamp: u,
      datetime: this.iso8601(u),
      lastTradeTimestamp: f,
      lastUpdateTimestamp: h,
      symbol: o,
      type: w,
      timeInForce: T,
      postOnly: x,
      reduceOnly: this.safeBool(e, "reduceOnly"),
      side: S,
      price: p,
      triggerPrice: _,
      amount: m,
      cost: y,
      average: l,
      filled: c,
      remaining: void 0,
      status: s,
      fee: j,
      trades: b
    }, t);
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [];
    let s = [];
    for (let o = 0; o < e.length; o++) {
      const c = e[o], u = this.safeString(c, "symbol");
      s.push(u);
      const f = this.safeString(c, "type"), h = this.safeString(c, "side"), l = this.safeValue(c, "amount"), p = this.safeValue(c, "price"), m = this.safeDict(c, "params", {}), y = this.createOrderRequest(u, f, h, l, p, m);
      i.push(y);
    }
    s = this.marketSymbols(s, void 0, !1, !0, !0);
    const n = this.market(s[0]);
    if (n.spot)
      throw new ge(n.type).exchange(this.id);
    let r, a = {
      batchOrders: i
    };
    return a = this.extend(a, t), n.linear ? r = await this.fapiPrivatePostBatchOrders(a) : n.option ? r = await this.eapiPrivatePostBatchOrders(a) : r = await this.dapiPrivatePostBatchOrders(a), this.parseOrders(r);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = this.safeString(r, "type", a.type);
    let c;
    [c, r] = this.handleMarginModeAndParams("createOrder", r);
    let u;
    [u, r] = this.handleOptionAndParams2(r, "createOrder", "papi", "portfolioMargin", !1);
    const f = this.safeString2(r, "triggerPrice", "stopPrice"), h = this.safeString(r, "stopLossPrice"), l = this.safeString(r, "takeProfitPrice"), m = this.safeString2(r, "trailingPercent", "callbackRate") !== void 0, S = f !== void 0 || m || h !== void 0 || l !== void 0, b = this.safeBool2(r, "sor", "SOR", !1), T = this.safeBool(r, "test", !1);
    r = this.omit(r, ["sor", "SOR", "test"]), u && (r.portfolioMargin = u);
    const x = this.createOrderRequest(e, t, i, s, n, r);
    let v;
    return a.option ? v = await this.eapiPrivatePostOrder(x) : b ? T ? v = await this.privatePostSorOrderTest(x) : v = await this.privatePostSorOrder(x) : a.linear ? u ? S ? v = await this.papiPostUmConditionalOrder(x) : v = await this.papiPostUmOrder(x) : v = await this.fapiPrivatePostOrder(x) : a.inverse ? u ? S ? v = await this.papiPostCmConditionalOrder(x) : v = await this.papiPostCmOrder(x) : v = await this.dapiPrivatePostOrder(x) : o === "margin" || c !== void 0 ? u ? v = await this.papiPostMarginOrder(x) : v = await this.sapiPostMarginOrder(x) : T ? v = await this.privatePostOrderTest(x) : v = await this.privatePostOrder(x), this.parseOrder(v, a);
  }
  createOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.market(e), o = this.safeString(r, "type", a.type), c = this.safeString2(r, "newClientOrderId", "clientOrderId"), u = t.toUpperCase(), f = u === "MARKET", h = u === "LIMIT", l = {
      symbol: a.id,
      side: i.toUpperCase()
    };
    let p;
    [p, r] = this.handleOptionAndParams2(r, "createOrder", "papi", "portfolioMargin", !1);
    let m;
    if ([m, r] = this.handleMarginModeAndParams("createOrder", r), o === "margin" || m !== void 0 || a.option) {
      const R = this.safeBool(r, "reduceOnly", !1);
      r = this.omit(r, "reduceOnly"), a.option ? l.reduceOnly = R : R && (l.sideEffectType = "AUTO_REPAY");
    }
    const y = this.safeString2(r, "triggerPrice", "stopPrice"), w = this.safeString(r, "stopLossPrice", y), S = this.safeString(r, "takeProfitPrice"), b = this.safeString(r, "trailingDelta"), T = this.safeString2(r, "trailingTriggerPrice", "activationPrice", this.numberToString(n)), x = this.safeString2(r, "trailingPercent", "callbackRate"), v = x !== void 0, _ = w !== void 0 || b !== void 0, V = S !== void 0, W = p && (y !== void 0 || v || _ || V);
    let B = t.toUpperCase(), Q;
    if (v ? (B = "TRAILING_STOP_MARKET", l.callbackRate = x, T !== void 0 && (l.activationPrice = this.priceToPrecision(e, T))) : _ ? (Q = w, f ? B = a.contract ? "STOP_MARKET" : "STOP_LOSS" : h && (B = a.contract ? "STOP" : "STOP_LOSS_LIMIT")) : V && (Q = S, f ? B = a.contract ? "TAKE_PROFIT_MARKET" : "TAKE_PROFIT" : h && (B = a.contract ? "TAKE_PROFIT" : "TAKE_PROFIT_LIMIT")), o === "spot" || o === "margin" ? l.newOrderRespType = this.safeString(this.options.newOrderRespType, t, "RESULT") : p || (l.newOrderRespType = "RESULT"), a.option) {
      if (t === "market")
        throw new g(t + " is not a valid order type for the " + e + " market").exchange(this.id);
    } else {
      const R = this.safeList(a.info, "orderTypes");
      if (!this.inArray(B, R))
        throw u !== B ? new g("stopPrice parameter is not allowed for " + e + " " + t + " orders").exchange(this.id) : new g(t + " is not a valid order type for the " + e + " market").exchange(this.id);
    }
    const se = W ? "newClientStrategyId" : "newClientOrderId";
    if (c === void 0) {
      const R = this.safeDict(this.options, "broker", {}), U = a.contract ? "x-xcKtGhcu" : "x-R4BD3S82", Y = this.safeString(R, o, U);
      l[se] = Y + this.uuid22();
    } else
      l[se] = c;
    let $;
    p || ($ = this.isPostOnly(f, u === "LIMIT_MAKER", r), (a.spot || o === "margin") && ($ && (B = "LIMIT_MAKER"), m === "isolated" && (l.isIsolated = !0)));
    const te = W ? "strategyType" : "type";
    l[te] = B;
    let E = !1, N = !1, L = !1, z = !1;
    if (B === "MARKET")
      if (a.spot)
        if (this.safeBool(this.options, "quoteOrderQty", !0)) {
          const U = this.safeString2(r, "quoteOrderQty", "cost");
          if (U !== void 0)
            l.quoteOrderQty = this.costToPrecision(e, U);
          else if (n !== void 0) {
            const Y = this.numberToString(s), J = this.numberToString(n), ae = P.stringMul(Y, J);
            l.quoteOrderQty = this.costToPrecision(e, ae);
          } else
            z = !0;
        } else
          z = !0;
      else
        z = !0;
    else if (B === "LIMIT")
      N = !0, E = !0, z = !0;
    else if (B === "STOP_LOSS" || B === "TAKE_PROFIT")
      L = !0, z = !0, (a.linear || a.inverse) && (N = !0);
    else if (B === "STOP_LOSS_LIMIT" || B === "TAKE_PROFIT_LIMIT")
      z = !0, L = !0, N = !0, E = !0;
    else if (B === "LIMIT_MAKER")
      N = !0, z = !0;
    else if (B === "STOP")
      z = !0, L = !0, N = !0;
    else if (B === "STOP_MARKET" || B === "TAKE_PROFIT_MARKET")
      this.safeBool(r, "closePosition") === void 0 && (z = !0), L = !0;
    else if (B === "TRAILING_STOP_MARKET" && (z = !0, x === void 0))
      throw new g("It requires a trailingPercent param for a " + t + " order").exchange(this.id);
    if (z && (p ? l.quantity = this.parseToNumeric(s) : l.quantity = this.amountToPrecision(e, s)), N) {
      if (n === void 0)
        throw new g("It requires a price argument for a " + t + " order").exchange(this.id);
      l.price = this.priceToPrecision(e, n);
    }
    if (L) {
      if (a.contract) {
        if (Q === void 0)
          throw new g("It requires a stopPrice extra param for a " + t + " order").exchange(this.id);
      } else if (b === void 0 && Q === void 0)
        throw new g("It requires a stopPrice or trailingDelta param for a " + t + " order").exchange(this.id);
      Q !== void 0 && (l.stopPrice = this.priceToPrecision(e, Q));
    }
    E && this.safeString(r, "timeInForce") === void 0 && (l.timeInForce = this.options.defaultTimeInForce), !p && a.contract && $ && (l.timeInForce = "GTX"), this.safeString(r, "timeInForce") === "PO" && (r = this.omit(r, "timeInForce"));
    const K = this.omit(r, ["type", "newClientOrderId", "clientOrderId", "postOnly", "stopLossPrice", "takeProfitPrice", "stopPrice", "triggerPrice", "trailingTriggerPrice", "trailingPercent", "quoteOrderQty", "cost", "test"]);
    return this.extend(l, K);
  }
  async createMarketOrderWithCost(e, t, i, s = {}) {
    await this.loadMarkets();
    const n = this.market(e);
    if (!n.spot)
      throw new ge(n.type).addMessage("It supports spot orders only").exchange(this.id);
    return s.quoteOrderQty = i, await this.createOrder(e, "market", t, i, void 0, s);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("It supports spot orders only").exchange(this.id);
    return i.quoteOrderQty = t, await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createMarketSellOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("It supports spot orders only").exchange(this.id);
    return i.quoteOrderQty = t, await this.createOrder(e, "market", "sell", t, void 0, i);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("fetchOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), n = this.safeString2(this.options, "fetchOrder", "defaultType", "spot"), r = this.safeString(i, "type", n);
    let a;
    [a, i] = this.handleMarginModeAndParams("fetchOrder", i);
    let o;
    [o, i] = this.handleOptionAndParams2(i, "fetchOrder", "papi", "portfolioMargin", !1);
    const c = {
      symbol: s.id
    }, u = this.safeString2(i, "origClientOrderId", "clientOrderId");
    u !== void 0 ? s.option ? c.clientOrderId = u : c.origClientOrderId = u : c.orderId = e, i = this.omit(i, ["type", "clientOrderId", "origClientOrderId"]);
    let f;
    return s.option ? f = await this.eapiPrivateGetOrder(this.extend(c, i)) : s.linear ? o ? f = await this.papiGetUmOrder(this.extend(c, i)) : f = await this.fapiPrivateGetOrder(this.extend(c, i)) : s.inverse ? o ? f = await this.papiGetCmOrder(this.extend(c, i)) : f = await this.dapiPrivateGetOrder(this.extend(c, i)) : r === "margin" || a !== void 0 || o ? o ? f = await this.papiGetMarginOrder(this.extend(c, i)) : (a === "isolated" && (c.isIsolated = !0), f = await this.sapiGetMarginOrder(this.extend(c, i))) : f = await this.privateGetOrder(this.extend(c, i)), this.parseOrder(f, s);
  }
  async fetchOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchOrders", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchOrders", e, t, i, s);
    const r = this.market(e), a = this.safeString2(this.options, "fetchOrders", "defaultType", r.type), o = this.safeString(s, "type", a);
    let c;
    [c, s] = this.handleMarginModeAndParams("fetchOrders", s);
    let u;
    [u, s] = this.handleOptionAndParams2(s, "fetchOrders", "papi", "portfolioMargin", !1);
    const f = this.safeBool2(s, "stop", "conditional");
    s = this.omit(s, ["stop", "conditional", "type"]);
    let h = {
      symbol: r.id
    };
    [h, s] = this.handleUntilOption("endTime", h, s), t !== void 0 && (h.startTime = t), i !== void 0 && (h.limit = i);
    let l;
    return r.option ? l = await this.eapiPrivateGetHistoryOrders(this.extend(h, s)) : r.linear ? u ? f ? l = await this.papiGetUmConditionalAllOrders(this.extend(h, s)) : l = await this.papiGetUmAllOrders(this.extend(h, s)) : l = await this.fapiPrivateGetAllOrders(this.extend(h, s)) : r.inverse ? u ? f ? l = await this.papiGetCmConditionalAllOrders(this.extend(h, s)) : l = await this.papiGetCmAllOrders(this.extend(h, s)) : l = await this.dapiPrivateGetAllOrders(this.extend(h, s)) : u ? l = await this.papiGetMarginAllOrders(this.extend(h, s)) : o === "margin" || c !== void 0 ? (c === "isolated" && (h.isIsolated = !0), l = await this.sapiGetMarginAllOrders(this.extend(h, s))) : l = await this.privateGetAllOrders(this.extend(h, s)), this.parseOrders(l, r, t, i);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n, r;
    const a = {};
    let o;
    [o, s] = this.handleMarginModeAndParams("fetchOpenOrders", s);
    let c;
    [c, s] = this.handleOptionAndParams2(s, "fetchOpenOrders", "papi", "portfolioMargin", !1);
    const u = this.safeBool2(s, "stop", "conditional");
    if (e !== void 0) {
      n = this.market(e), a.symbol = n.id;
      const l = this.safeString2(this.options, "fetchOpenOrders", "defaultType", "spot"), p = "type" in n ? n.type : l;
      r = this.safeString(s, "type", p);
    } else if (this.options.warnOnFetchOpenOrdersWithoutSymbol) {
      const p = this.symbols.length, m = this.parseToInt(p / 2);
      throw new O().overwriteMessage("fetchOpenOrders() WARNING: fetching open orders without specifying a symbol is rate-limited to one call per " + m.toString() + " seconds. Do not call this method frequently to avoid ban. Set " + this.id + '.options["warnOnFetchOpenOrdersWithoutSymbol"] = false to suppress this warning message.').exchange(this.id);
    } else {
      const l = this.safeString2(this.options, "fetchOpenOrders", "defaultType", "spot");
      r = this.safeString(s, "type", l);
    }
    let f;
    [f, s] = this.handleSubTypeAndParams("fetchOpenOrders", n, s), s = this.omit(s, ["type", "stop", "conditional"]);
    let h;
    if (r === "option")
      t !== void 0 && (a.startTime = t), i !== void 0 && (a.limit = i), h = await this.eapiPrivateGetOpenOrders(this.extend(a, s));
    else if (this.isLinear(r, f))
      c ? u ? h = await this.papiGetUmConditionalOpenOrders(this.extend(a, s)) : h = await this.papiGetUmOpenOrders(this.extend(a, s)) : h = await this.fapiPrivateGetOpenOrders(this.extend(a, s));
    else if (this.isInverse(r, f))
      c ? u ? h = await this.papiGetCmConditionalOpenOrders(this.extend(a, s)) : h = await this.papiGetCmOpenOrders(this.extend(a, s)) : h = await this.dapiPrivateGetOpenOrders(this.extend(a, s));
    else if (r === "margin" || o !== void 0)
      if (c)
        h = await this.papiGetMarginOpenOrders(this.extend(a, s));
      else {
        if (o === "isolated" && (a.isIsolated = !0, e === void 0))
          throw new g("fetchOpenOrders() requires a symbol argument for isolated markets").exchange(this.id);
        h = await this.sapiGetMarginOpenOrders(this.extend(a, s));
      }
    else
      h = await this.privateGetOpenOrders(this.extend(a, s));
    return this.parseOrders(h, n, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchClosedOrders() requires a symbol argument").exchange(this.id);
    const n = await this.fetchOrders(e, t, void 0, s), r = this.filterBy(n, "status", "closed");
    return this.filterBySinceLimit(r, t, i);
  }
  async fetchCanceledOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchCanceledOrders() requires a symbol argument").exchange(this.id);
    const n = await this.fetchOrders(e, t, void 0, s), r = this.filterBy(n, "status", "canceled");
    return this.filterBySinceLimit(r, t, i);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), n = this.safeString2(this.options, "cancelOrder", "defaultType", "spot"), r = this.safeString(i, "type", n);
    let a;
    [a, i] = this.handleMarginModeAndParams("cancelOrder", i);
    let o;
    [o, i] = this.handleOptionAndParams2(i, "cancelOrder", "papi", "portfolioMargin", !1);
    const c = this.safeBool2(i, "stop", "conditional"), u = {
      symbol: s.id
    }, f = this.safeStringN(i, ["origClientOrderId", "clientOrderId", "newClientStrategyId"]);
    f !== void 0 ? s.option ? u.clientOrderId = f : o && c ? u.newClientStrategyId = f : u.origClientOrderId = f : o && c ? u.strategyId = e : u.orderId = e, i = this.omit(i, ["type", "origClientOrderId", "clientOrderId", "newClientStrategyId", "stop", "conditional"]);
    let h;
    return s.option ? h = await this.eapiPrivateDeleteOrder(this.extend(u, i)) : s.linear ? o ? c ? h = await this.papiDeleteUmConditionalOrder(this.extend(u, i)) : h = await this.papiDeleteUmOrder(this.extend(u, i)) : h = await this.fapiPrivateDeleteOrder(this.extend(u, i)) : s.inverse ? o ? c ? h = await this.papiDeleteCmConditionalOrder(this.extend(u, i)) : h = await this.papiDeleteCmOrder(this.extend(u, i)) : h = await this.dapiPrivateDeleteOrder(this.extend(u, i)) : r === "margin" || a !== void 0 || o ? o ? h = await this.papiDeleteMarginOrder(this.extend(u, i)) : (a === "isolated" && (u.isIsolated = !0), h = await this.sapiDeleteMarginOrder(this.extend(u, i))) : h = await this.privateDeleteOrder(this.extend(u, i)), this.parseOrder(h, s);
  }
  async cancelAllOrders(e = void 0, t = {}) {
    if (e === void 0)
      throw new g("cancelAllOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    };
    let n;
    [n, t] = this.handleOptionAndParams2(t, "cancelAllOrders", "papi", "portfolioMargin", !1);
    const r = this.safeBool2(t, "stop", "conditional"), a = this.safeString(t, "type", i.type);
    t = this.omit(t, ["type", "stop", "conditional"]);
    let o;
    [o, t] = this.handleMarginModeAndParams("cancelAllOrders", t);
    let c;
    return i.option ? c = await this.eapiPrivateDeleteAllOpenOrders(this.extend(s, t)) : i.linear ? n ? r ? c = await this.papiDeleteUmConditionalAllOpenOrders(this.extend(s, t)) : c = await this.papiDeleteUmAllOpenOrders(this.extend(s, t)) : c = await this.fapiPrivateDeleteAllOpenOrders(this.extend(s, t)) : i.inverse ? n ? r ? c = await this.papiDeleteCmConditionalAllOpenOrders(this.extend(s, t)) : c = await this.papiDeleteCmAllOpenOrders(this.extend(s, t)) : c = await this.dapiPrivateDeleteAllOpenOrders(this.extend(s, t)) : a === "margin" || o !== void 0 ? n ? c = await this.papiDeleteMarginAllOpenOrders(this.extend(s, t)) : (o === "isolated" && (s.isIsolated = !0), c = await this.sapiDeleteMarginOpenOrders(this.extend(s, t))) : c = await this.privateDeleteOpenOrders(this.extend(s, t)), Array.isArray(c) ? this.parseOrders(c, i) : c;
  }
  async cancelOrders(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t);
    if (!s.contract)
      throw new ge(s.type).addMessage("cancelOrders is only supported for swap markets.").exchange(this.id);
    const n = {
      symbol: s.id,
      orderidlist: e
    };
    let r;
    return s.linear ? r = await this.fapiPrivateDeleteBatchOrders(this.extend(n, i)) : s.inverse && (r = await this.dapiPrivateDeleteBatchOrders(this.extend(n, i))), this.parseOrders(r, s);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    if (t === void 0)
      throw new g("fetchOrderTrades() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const r = this.market(t), a = this.safeString(n, "type", r.type);
    if (n = this.omit(n, "type"), a !== "spot")
      throw new ge(a).addMessage("It supports spot markets only").exchange(this.id);
    const o = {
      orderId: e
    };
    return await this.fetchMyTrades(t, i, s, this.extend(o, n));
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchMyTrades", e, t, i, s);
    const r = {};
    let a, o, c;
    e !== void 0 && (a = this.market(e), r.symbol = a.id), [o, s] = this.handleMarketTypeAndParams("fetchMyTrades", a, s);
    let u = this.safeInteger2(s, "until", "endTime");
    if (t !== void 0) {
      const h = t;
      r.startTime = h;
      const l = this.milliseconds(), p = 7 * 24 * 60 * 60 * 1e3;
      l - h >= p && u === void 0 && a.linear && (u = this.sum(h, p), u = Math.min(u, l));
    }
    u !== void 0 && (r.endTime = u, s = this.omit(s, ["endTime", "until"])), i !== void 0 && ((o === "option" || a.contract) && (i = Math.min(i, 1e3)), r.limit = i);
    let f;
    if (o === "option")
      f = await this.eapiPrivateGetUserTrades(this.extend(r, s));
    else {
      if (e === void 0)
        throw new g("It requires a symbol argument").exchange(this.id);
      [c, s] = this.handleMarginModeAndParams("fetchMyTrades", s);
      let h;
      [h, s] = this.handleOptionAndParams2(s, "fetchMyTrades", "papi", "portfolioMargin", !1), o === "spot" || o === "margin" ? h ? f = await this.papiGetMarginMyTrades(this.extend(r, s)) : o === "margin" || c !== void 0 ? (c === "isolated" && (r.isIsolated = !0), f = await this.sapiGetMarginMyTrades(this.extend(r, s))) : f = await this.privateGetMyTrades(this.extend(r, s)) : a.linear ? h ? f = await this.papiGetUmUserTrades(this.extend(r, s)) : f = await this.fapiPrivateGetUserTrades(this.extend(r, s)) : a.inverse && (h ? f = await this.papiGetCmUserTrades(this.extend(r, s)) : f = await this.dapiPrivateGetUserTrades(this.extend(r, s)));
    }
    return this.parseTrades(f, a, t, i);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchDeposits", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchDeposits", e, t, i, s);
    let r, a;
    const o = {}, c = this.safeDict(this.options, "legalMoney", {}), u = this.safeBool(s, "fiat", !1);
    s = this.omit(s, "fiatOnly");
    const f = this.safeInteger(s, "until");
    if (s = this.omit(s, "until"), u || e in c) {
      e !== void 0 && (r = this.currency(e)), o.transactionType = 0, t !== void 0 && (o.beginTime = t), f !== void 0 && (o.endTime = f);
      const h = await this.sapiGetFiatOrders(this.extend(o, s));
      a = this.safeValue(h, "data");
    } else {
      if (e !== void 0 && (r = this.currency(e), o.coin = r.id), t !== void 0) {
        o.startTime = t;
        let h = this.sum(t, 7776e6);
        f !== void 0 && (h = Math.min(h, f)), o.endTime = h;
      }
      i !== void 0 && (o.limit = i), a = await this.sapiGetCapitalDepositHisrec(this.extend(o, s));
    }
    for (let h = 0; h < a.length; h++)
      a[h].type = "deposit";
    return this.parseTransactions(a, r, t, i);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchWithdrawals", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchWithdrawals", e, t, i, s);
    const r = this.safeDict(this.options, "legalMoney", {}), a = this.safeBool(s, "fiat", !1);
    s = this.omit(s, "fiatOnly");
    const o = {}, c = this.safeInteger(s, "until");
    c !== void 0 && (s = this.omit(s, "until"), o.endTime = c);
    let u, f;
    if (a || e in r) {
      e !== void 0 && (f = this.currency(e)), o.transactionType = 1, t !== void 0 && (o.beginTime = t);
      const h = await this.sapiGetFiatOrders(this.extend(o, s));
      u = this.safeValue(h, "data");
    } else
      e !== void 0 && (f = this.currency(e), o.coin = f.id), t !== void 0 && (o.startTime = t, o.endTime = this.sum(t, 7776e6)), i !== void 0 && (o.limit = i), u = await this.sapiGetCapitalWithdrawHistory(this.extend(o, s));
    for (let h = 0; h < u.length; h++)
      u[h].type = "withdrawal";
    return this.parseTransactions(u, f, t, i);
  }
  parseTransactionStatusByType(e, t = void 0) {
    const i = {
      deposit: {
        0: "pending",
        1: "ok",
        6: "ok",
        // Fiat
        // Processing, Failed, Successful, Finished, Refunding, Refunded, Refund Failed, Order Partial credit Stopped
        Processing: "pending",
        Failed: "failed",
        Successful: "ok",
        Refunding: "canceled",
        Refunded: "canceled",
        "Refund Failed": "failed"
      },
      withdrawal: {
        0: "pending",
        1: "canceled",
        2: "pending",
        3: "failed",
        4: "pending",
        5: "failed",
        6: "ok",
        // Fiat
        // Processing, Failed, Successful, Finished, Refunding, Refunded, Refund Failed, Order Partial credit Stopped
        Processing: "pending",
        Failed: "failed",
        Successful: "ok",
        Refunding: "canceled",
        Refunded: "canceled",
        "Refund Failed": "failed"
      }
    }, s = this.safeDict(i, t, {});
    return this.safeString(s, e, e);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString2(e, "id", "orderNo"), s = this.safeString(e, "address");
    let n = this.safeString(e, "addressTag");
    n !== void 0 && n.length < 1 && (n = void 0);
    let r = this.safeString(e, "txId");
    r !== void 0 && r.indexOf("Internal transfer ") >= 0 && (r = r.slice(18));
    const a = this.safeString2(e, "coin", "fiatCurrency");
    let o = this.safeCurrencyCode(a, t), c;
    c = this.safeInteger2(e, "insertTime", "createTime"), c === void 0 && (c = this.parse8601(this.safeString(e, "applyTime")));
    const u = this.safeInteger2(e, "successTime", "updateTime");
    let f = this.safeString(e, "type");
    if (f === void 0) {
      const b = this.safeString(e, "transactionType");
      b !== void 0 && (f = b === "0" ? "deposit" : "withdrawal");
      const T = this.safeValue(this.options, "legalMoneyCurrenciesById");
      o = this.safeString(T, o, o);
    }
    const h = this.parseTransactionStatusByType(this.safeString(e, "status"), f), l = this.safeNumber(e, "amount"), p = this.safeNumber2(e, "transactionFee", "totalFee");
    let m;
    p !== void 0 && (m = { currency: o, cost: p });
    const y = this.safeInteger(e, "transferType");
    let w;
    y !== void 0 && (w = !!y);
    const S = this.safeString(e, "network");
    return {
      info: e,
      id: i,
      txid: r,
      timestamp: c,
      datetime: this.iso8601(c),
      network: S,
      address: s,
      addressTo: s,
      addressFrom: void 0,
      tag: n,
      tagTo: n,
      tagFrom: void 0,
      type: f,
      amount: l,
      currency: o,
      status: h,
      updated: u,
      internal: w,
      comment: void 0,
      fee: m
    };
  }
  parseTransferStatus(e) {
    const t = {
      CONFIRMED: "ok"
    };
    return this.safeString(t, e, e);
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeString(e, "tranId"), s = this.safeString(e, "asset"), n = this.safeCurrencyCode(s, t), r = this.safeNumber(e, "amount"), a = this.safeString(e, "type");
    let o, c;
    const u = this.safeDict(this.options, "accountsById", {});
    if (a !== void 0) {
      const l = a.split("_");
      o = this.safeValue(l, 0), c = this.safeValue(l, 1), o = this.safeString(u, o, o), c = this.safeString(u, c, c);
    }
    const f = this.safeInteger(e, "timestamp"), h = this.parseTransferStatus(this.safeString(e, "status"));
    return {
      info: e,
      id: i,
      timestamp: f,
      datetime: this.iso8601(f),
      currency: n,
      amount: r,
      fromAccount: o,
      toAccount: c,
      status: h
    };
  }
  // https://binance-docs.github.io/apidocs/spot/en/#get-summary-of-sub-account-39-s-futures-account-v2-for-master-account
  // https://binance-docs.github.io/apidocs/spot/en/#get-summary-of-sub-account-39-s-margin-account-for-master-account
  // https://binance-docs.github.io/apidocs/spot/en/#query-sub-account-spot-assets-summary-for-master-account
  // https://binance-docs.github.io/apidocs/spot/en/#query-managed-sub-account-margin-asset-details-for-investor-master-account-user_data
  async fetchSubAccountBalances(e, t = {}) {
    await this.loadMarkets();
    const i = await this.sapiV4GetSubAccountAssets(this.extend({ email: e })), s = {}, n = this.safeValue(i, "balances", []);
    for (let r = 0; r < n.length; r++) {
      const a = n[r], o = this.safeString(a, "asset"), c = this.safeCurrencyCode(o), u = this.safeString(a, "free"), f = this.safeString(a, "locked"), h = this.sum(u, f);
      s[c] = {
        free: this.parseNumber(u),
        used: this.parseNumber(f),
        total: this.parseNumber(h)
      };
    }
    return {
      spot: s
    };
  }
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.sapiGetSubAccountList(), t = this.safeValue(e, "subAccounts", []);
    return t == null ? void 0 : t.map((i) => ({
      uid: this.safeString(i, "email")
    }));
  }
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    await this.loadMarkets();
    const o = this.currency(e), c = {
      asset: o.id,
      amount: this.currencyToPrecision(e, t),
      fromAccountType: i,
      toAccountType: s,
      fromEmail: n,
      toEmail: r
    }, u = await this.sapiPostSubAccountUniversalTransfer(this.extend(c, a));
    return this.parseTransfer(u, o);
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = {
      asset: r.id,
      amount: this.currencyToPrecision(e, t)
    };
    if (a.type = this.safeString(n, "type"), n = this.omit(n, "type"), a.type === void 0) {
      const c = this.safeString(n, "symbol");
      let u;
      c !== void 0 && (u = this.market(c), n = this.omit(n, "symbol"));
      let f = this.convertTypeToAccount(i).toUpperCase(), h = this.convertTypeToAccount(s).toUpperCase(), l;
      if (u !== void 0 && (l = u.id), f === "ISOLATED" && c === void 0)
        throw new g('It requires params["symbol"] when fromAccount is ' + i).exchange(this.id);
      if (h === "ISOLATED" && c === void 0)
        throw new g('It requires params["symbol"] when toAccount is ' + s).exchange(this.id);
      const p = this.safeDict(this.options, "accountsById", {}), m = !(f in p), y = !(h in p);
      if (m && u === void 0 && (l = f), y && u === void 0 && (l = h), m || y) {
        const w = f === "UMFUTURE" || f === "CMFUTURE", S = h === "UMFUTURE" || h === "CMFUTURE", b = f === "MAIN", T = h === "MAIN";
        if ((m || y) && (w || S || (f === "FUNDING" || h === "FUNDING") || (f === "OPTION" || h === "OPTION")))
          throw new Vt().overwriteMessage(`Transfer not allowed between ${i} and ${s}`).exchange(this.id);
        T && m ? (f = "ISOLATED_MARGIN", a.fromSymbol = l) : b && y ? (h = "ISOLATED_MARGIN", a.toSymbol = l) : m && y ? (a.fromSymbol = f, a.toSymbol = h, f = "ISOLATEDMARGIN", h = "ISOLATEDMARGIN") : (m && (a.fromSymbol = l, f = "ISOLATEDMARGIN"), y && (a.toSymbol = l, h = "ISOLATEDMARGIN")), a.type = f + "_" + h;
      } else
        a.type = f + "_" + h;
    }
    const o = await this.sapiPostAssetTransfer(this.extend(a, n));
    return this.parseTransfer(o, r);
  }
  async fetchTransfers(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchTransfers", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchTransfers", e, t, i, s);
    let r;
    e !== void 0 && (r = this.currency(e));
    const a = this.safeString2(this.options, "fetchTransfers", "defaultType", "spot"), o = this.safeString(s, "fromAccount", a), c = o === "future" ? "spot" : "future", u = this.safeString(s, "toAccount", c);
    let f = this.safeString(s, "type");
    const h = this.safeDict(this.options, "accountsByType", {}), l = this.safeString(h, o), p = this.safeString(h, u);
    if (f === void 0) {
      if (l === void 0) {
        const b = Object.keys(h);
        throw new g("fromAccount parameter must be one of " + b.join(", ")).exchange(this.id);
      }
      if (p === void 0) {
        const b = Object.keys(h);
        throw new g("toAccount parameter must be one of " + b.join(", ")).exchange(this.id);
      }
      f = l + "_" + p;
    }
    const m = {
      type: f
    };
    t !== void 0 && (m.startTime = t), i !== void 0 && (m.size = i);
    const y = this.safeInteger(s, "until");
    y !== void 0 && (s = this.omit(s, "until"), m.endTime = y);
    const w = await this.sapiGetAssetTransfer(this.extend(m, s)), S = this.safeList(w, "rows", []);
    return this.parseTransfers(S, r, t, i);
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const s = {
      coin: this.currency(e).id
      // 'network': 'ETH', // 'BSC', 'XMR', you can get network and isDefault in networkList in the response of sapiGetCapitalConfigDetail
    }, n = this.safeDict(this.options, "networks", {});
    let r = this.safeStringUpper(t, "network");
    r = this.safeString(n, r, r), r !== void 0 && (s.network = r, t = this.omit(t, "network"));
    const a = await this.sapiGetCapitalDepositAddress(this.extend(s, t)), o = this.safeString(a, "address"), c = this.safeString(a, "url");
    let u;
    if (c !== void 0) {
      const h = this.safeDict(this.options, "reverseNetworks", {}), l = c.split("/");
      let p = this.safeString(l, 2);
      if (p === "blockchair.com" || p === "viewblock.io") {
        const y = this.safeString(l, 3);
        y !== void 0 && (p = p + "/" + y);
      }
      u = this.safeString(h, p);
      const m = this.safeValue(this.options, "impliedNetworks", {
        ETH: { ERC20: "ETH" },
        TRX: { TRC20: "TRX" }
      });
      if (e in m) {
        const y = this.safeDict(m, e, {});
        u = this.safeString(y, u, u);
      }
    }
    let f = this.safeString(a, "tag", "");
    return f.length === 0 && (f = void 0), this.checkAddress(o), {
      currency: e,
      address: o,
      tag: f,
      info: a,
      network: u
    };
  }
  async fetchTransactionFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.sapiGetCapitalConfigGetall(t), s = {};
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "coin"), o = this.safeCurrencyCode(a), c = this.safeList(r, "networkList", []);
      s[o] = {};
      for (let u = 0; u < c.length; u++) {
        const f = c[u], h = this.safeString(f, "network"), l = this.safeCurrencyCode(h), p = this.safeNumber(f, "withdrawFee");
        s[o][l] = p;
      }
    }
    return {
      withdraw: s,
      deposit: {},
      info: i
    };
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.sapiGetCapitalConfigGetall(t);
    return this.parseDepositWithdrawFees(i, e, "coin");
  }
  parseDepositWithdrawFee(e, t = void 0) {
    const i = this.safeList(e, "networkList", []), s = this.depositWithdrawFee(e);
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "network"), o = this.networkIdToCode(a), c = this.safeNumber(r, "withdrawFee");
      this.safeBool(r, "isDefault") === !0 && (s.withdraw = {
        fee: c,
        percentage: void 0
      }), s.networks[o] = {
        withdraw: {
          fee: c,
          percentage: void 0
        },
        deposit: {
          fee: void 0,
          percentage: void 0
        }
      };
    }
    return s;
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), this.checkAddress(i), await this.loadMarkets();
    const r = this.currency(e), a = {
      forceProxy: !0,
      coin: r.id,
      address: i
      // https://binance-docs.github.io/apidocs/spot/en/#withdraw-sapi
      // issue sapiGetCapitalConfigGetall () to get networks for withdrawing USDT ERC20 vs USDT Omni
      // 'network': 'ETH', // 'BTC', 'TRX', etc, optional
    };
    s !== void 0 && (a.addressTag = s);
    const o = this.safeDict(this.options, "networks", {});
    let c = this.safeStringUpper(n, "network");
    const u = this.currencyToPrecision(e, t, c);
    a.amount = u, c = this.safeString(o, c, c), c !== void 0 && (a.network = c, n = this.omit(n, "network"));
    const f = await this.sapiPostCapitalWithdrawApply(this.extend(a, n));
    return this.parseTransaction(f, r);
  }
  parseTradingFee(e, t = void 0) {
    const i = this.safeString(e, "symbol"), s = this.safeSymbol(i, t, void 0, "spot");
    return {
      info: e,
      symbol: s,
      maker: this.safeNumber2(e, "makerCommission", "makerCommissionRate"),
      taker: this.safeNumber2(e, "takerCommission", "takerCommissionRate")
    };
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = i.type;
    let n;
    [n, t] = this.handleSubTypeAndParams("fetchTradingFee", i, t);
    let r;
    [r, t] = this.handleOptionAndParams2(t, "fetchTradingFee", "papi", "portfolioMargin", !1);
    const a = this.isLinear(s, n), o = this.isInverse(s, n), c = {
      symbol: i.id
    };
    let u;
    a ? r ? u = await this.papiGetUmCommissionRate(this.extend(c, t)) : u = await this.fapiPrivateGetCommissionRate(this.extend(c, t)) : o ? r ? u = await this.papiGetCmCommissionRate(this.extend(c, t)) : u = await this.dapiPrivateGetCommissionRate(this.extend(c, t)) : u = await this.sapiGetAssetTradeFee(this.extend(c, t));
    let f = u;
    return Array.isArray(f) && (f = this.safeDict(f, 0, {})), this.parseTradingFee(f, i);
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    let t;
    [t, e] = this.handleMarketTypeAndParams("fetchTradingFees", void 0, e);
    let i;
    [i, e] = this.handleSubTypeAndParams("fetchTradingFees", void 0, e, "linear");
    const s = t === "spot" || t === "margin", n = this.isLinear(t, i), r = this.isInverse(t, i);
    let a;
    if (s ? a = await this.sapiGetAssetTradeFee(e) : n ? a = await this.fapiPrivateV2GetAccount(e) : r && (a = await this.dapiPrivateGetAccount(e)), s) {
      const o = {};
      for (let c = 0; c < a.length; c++) {
        const u = this.parseTradingFee(a[c]), f = u.symbol;
        o[f] = u;
      }
      return o;
    } else if (n) {
      const o = Object.keys(this.markets), c = {}, u = this.safeInteger(a, "feeTier"), f = this.fees.linear.trading.tiers, h = f.maker[u][1], l = f.taker[u][1];
      for (let p = 0; p < o.length; p++) {
        const m = o[p];
        this.markets[m].linear && (c[m] = {
          info: {
            feeTier: u
          },
          symbol: m,
          maker: h,
          taker: l
        });
      }
      return c;
    } else if (r) {
      const o = Object.keys(this.markets), c = {}, u = this.safeInteger(a, "feeTier"), f = this.fees.inverse.trading.tiers, h = f.maker[u][1], l = f.taker[u][1];
      for (let p = 0; p < o.length; p++) {
        const m = o[p];
        this.markets[m].inverse && (c[m] = {
          info: {
            feeTier: u
          },
          symbol: m,
          maker: h,
          taker: l
        });
      }
      return c;
    }
  }
  parseAccountPositions(e) {
    const t = this.safeList(e, "positions"), i = this.safeList(e, "assets", []), s = {};
    for (let r = 0; r < i.length; r++) {
      const a = i[r], o = this.safeString(a, "asset"), c = this.safeCurrencyCode(o), u = this.safeString(a, "crossWalletBalance"), f = this.safeString(a, "crossUnPnl");
      s[c] = {
        crossMargin: P.stringAdd(u, f),
        crossWalletBalance: u
      };
    }
    const n = [];
    for (let r = 0; r < t.length; r++) {
      const a = t[r], o = this.safeString(a, "symbol"), c = this.safeMarket(o, void 0, void 0, "contract"), u = c.linear ? c.quote : c.base, f = this.safeString(a, "maintMargin");
      if (f !== "0" && f !== "0.00000000" && u in s) {
        const h = this.parseAccountPosition(this.extend(a, {
          crossMargin: s[u].crossMargin,
          crossWalletBalance: s[u].crossWalletBalance
        }), c);
        n.push(h);
      }
    }
    return n;
  }
  parseAccountPosition(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t, void 0, "contract");
    const s = this.safeString(t, "symbol"), n = this.safeString(e, "leverage"), r = parseInt(n), a = this.safeString(e, "initialMargin"), o = this.parseNumber(a);
    let c = P.stringDiv("1", n, 8);
    this.isRoundNumber(1e3 % r) || (c = P.stringDiv(P.stringAdd(c, "1e-8"), "1", 8));
    const f = "notional" in e, h = this.safeString(e, "maintMargin"), l = this.parseNumber(h), p = this.safeString(e, "entryPrice");
    let m = this.parseNumber(p);
    const y = this.safeString2(e, "notional", "notionalValue"), w = P.stringAbs(y), S = this.parseNumber(w);
    let b = this.safeString(e, "positionAmt"), T = P.stringAbs(b);
    if (b === void 0) {
      const A = P.stringMul(P.stringMul(n, a), p), M = this.safeString(t, "contractSize");
      b = P.stringDiv(A, M), T = P.stringDiv(P.stringAdd(b, "0.5"), "1", 0);
    }
    const x = this.parseNumber(T), v = this.safeDict(this.options, "leverageBrackets", {}), _ = this.safeList(v, s, []);
    let V;
    for (let A = 0; A < _.length; A++) {
      const M = _[A];
      if (P.stringLt(w, M[0]))
        break;
      V = M[1];
    }
    const j = this.parseNumber(V), G = this.safeString(e, "unrealizedProfit"), W = this.parseNumber(G);
    let B = this.safeInteger(e, "updateTime");
    B === 0 && (B = void 0);
    const Q = this.safeBool(e, "isolated");
    let se, $, te;
    Q ? (se = "isolated", te = this.safeString(e, "isolatedWallet"), $ = P.stringAdd(te, G)) : (se = "cross", te = this.safeString(e, "crossWalletBalance"), $ = this.safeString(e, "crossMargin"));
    const E = this.parseNumber($);
    let N, L, z, K, R;
    const U = this.safeValue(t, "contractSize"), Y = this.numberToString(U);
    if (P.stringEquals(y, "0"))
      m = void 0;
    else {
      if (L = P.stringLt(y, "0") ? "short" : "long", N = this.parseNumber(P.stringDiv(P.stringAdd(P.stringDiv(h, $), "5e-5"), "1", 4)), z = this.parseNumber(P.stringMul(P.stringDiv(G, a, 4), "100")), f) {
        let Ie, Pe = p;
        L === "short" ? Ie = P.stringAdd("1", V) : (Ie = P.stringAdd("-1", V), Pe = P.stringMul("-1", Pe));
        const He = P.stringDiv(te, P.stringMul(T, Ie)), bt = P.stringDiv(Pe, Ie);
        K = P.stringAdd(He, bt);
      } else {
        let Ie, Pe = p;
        L === "short" ? Ie = P.stringSub("1", V) : (Ie = P.stringSub("-1", V), Pe = P.stringMul("-1", Pe));
        const He = P.stringMul(T, Y), bt = P.stringMul(He, Ie), mt = P.stringSub(P.stringMul(P.stringDiv("1", Pe), He), te);
        K = P.stringDiv(bt, mt);
      }
      const A = t.precision.price, q = (A + 1).toString(), le = new P("5e-" + q).toString(), oe = P.stringAdd(le, K);
      let he = P.stringDiv(oe, "1", A);
      he[0] === "-" && (he = void 0), R = this.parseNumber(he);
    }
    const ae = this.safeString(e, "positionSide") !== "BOTH";
    return {
      info: e,
      id: void 0,
      symbol: s,
      timestamp: B,
      datetime: this.iso8601(B),
      initialMargin: o,
      initialMarginPercentage: this.parseNumber(c),
      maintenanceMargin: l,
      maintenanceMarginPercentage: j,
      entryPrice: m,
      notional: S,
      leverage: this.parseNumber(n),
      unrealizedPnl: W,
      contracts: x,
      contractSize: U,
      marginRatio: N,
      liquidationPrice: R,
      markPrice: void 0,
      collateral: E,
      marginMode: se,
      side: L,
      hedged: ae,
      percentage: z
    };
  }
  parsePositionRisk(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t, void 0, "contract");
    const s = this.safeString(t, "symbol"), n = this.safeDict(this.options, "leverageBrackets", {}), r = this.safeList(n, s, []), a = this.safeString2(e, "notional", "notionalValue"), o = P.stringAbs(a);
    let c;
    for (let J = 0; J < r.length; J++) {
      const ae = r[J];
      if (P.stringLt(o, ae[0]))
        break;
      c = ae[1];
    }
    const u = this.parseNumber(o), f = P.stringAbs(this.safeString(e, "positionAmt")), h = this.parseNumber(f), l = this.safeString(e, "unRealizedProfit"), p = this.parseNumber(l), m = this.safeString(e, "leverage"), y = parseInt(m), w = this.omitZero(this.safeString(e, "liquidationPrice")), S = this.parseNumber(w);
    let b;
    const T = this.safeString(e, "marginType");
    let x;
    P.stringGt(a, "0") ? x = "long" : P.stringLt(a, "0") && (x = "short");
    const v = this.safeString(e, "entryPrice"), _ = this.parseNumber(v), V = this.safeValue(t, "contractSize"), j = this.numberToString(V), G = "notional" in e;
    if (T === "cross") {
      const J = this.safeDict(t, "precision", {});
      if (G) {
        let ae, A = v;
        x === "short" ? (ae = P.stringAdd("1", c), A = P.stringMul("-1", A)) : ae = P.stringAdd("-1", c);
        const M = P.stringMul(w, ae), q = P.stringAdd(M, A), H = this.safeInteger(J, "price"), le = this.safeInteger(J, "quote", H);
        le !== void 0 && (b = P.stringDiv(P.stringMul(q, f), "1", le));
      } else {
        let ae, A = v;
        x === "short" ? ae = P.stringSub("1", c) : (ae = P.stringSub("-1", c), A = P.stringMul("-1", A));
        const M = P.stringMul(f, j), q = P.stringSub(P.stringDiv("1", A), P.stringDiv(ae, w)), H = this.safeInteger(J, "base");
        H !== void 0 && (b = P.stringDiv(P.stringMul(M, q), "1", H));
      }
    } else
      b = this.safeString(e, "isolatedMargin");
    b = b === void 0 ? "0" : b;
    const W = this.parseNumber(b), B = this.parseNumber(this.omitZero(this.safeString(e, "markPrice")));
    let Q = this.safeInteger(e, "updateTime");
    Q === 0 && (Q = void 0);
    const se = this.parseNumber(c), $ = P.stringMul(c, o), te = this.parseNumber($);
    let E = P.stringDiv("1", m, 8);
    this.isRoundNumber(1e3 % y) || (E = P.stringAdd(E, "1e-8"));
    const L = P.stringDiv(P.stringMul(o, E), "1", 8), z = this.parseNumber(L);
    let K, R;
    P.stringEquals(b, "0") || (K = this.parseNumber(P.stringDiv(P.stringAdd(P.stringDiv($, b), "5e-5"), "1", 4)), R = this.parseNumber(P.stringMul(P.stringDiv(l, L, 4), "100")));
    const Y = this.safeString(e, "positionSide") !== "BOTH";
    return {
      info: e,
      id: void 0,
      symbol: s,
      contracts: h,
      contractSize: V,
      unrealizedPnl: p,
      leverage: this.parseNumber(m),
      liquidationPrice: S,
      collateral: W,
      notional: u,
      markPrice: B,
      entryPrice: _,
      timestamp: Q,
      initialMargin: z,
      initialMarginPercentage: this.parseNumber(E),
      maintenanceMargin: te,
      maintenanceMarginPercentage: se,
      marginRatio: K,
      datetime: this.iso8601(Q),
      marginMode: T,
      marginType: T,
      side: x,
      hedged: Y,
      percentage: R,
      stopLossPrice: void 0,
      takeProfitPrice: void 0
    };
  }
  async loadLeverageBrackets(e = !1, t = {}) {
    if (await this.loadMarkets(), this.safeValue(this.options, "leverageBrackets") === void 0 || e) {
      const s = this.safeString(this.options, "defaultType", "future"), n = this.safeString(t, "type", s), r = this.omit(t, "type");
      let a;
      [a, t] = this.handleSubTypeAndParams("loadLeverageBrackets", void 0, t, "linear");
      let o;
      [o, t] = this.handleOptionAndParams2(t, "loadLeverageBrackets", "papi", "portfolioMargin", !1);
      let c;
      if (this.isLinear(n, a))
        o ? c = await this.papiGetUmLeverageBracket(r) : c = await this.fapiPrivateGetLeverageBracket(r);
      else if (this.isInverse(n, a))
        o ? c = await this.papiGetCmLeverageBracket(r) : c = await this.dapiPrivateV2GetLeverageBracket(r);
      else
        throw new g("loadLeverageBrackets() supports linear and inverse contracts only").exchange(this.id);
      this.options.leverageBrackets = {};
      for (let u = 0; u < c.length; u++) {
        const f = c[u], h = this.safeString(f, "symbol"), l = this.safeSymbol(h, void 0, void 0, "contract"), p = this.safeList(f, "brackets", []), m = [];
        for (let y = 0; y < p.length; y++) {
          const w = p[y], S = this.safeString2(w, "notionalFloor", "qtyFloor"), b = this.safeString(w, "maintMarginRatio");
          m.push([S, b]);
        }
        this.options.leverageBrackets[l] = m;
      }
    }
    return this.options.leverageBrackets;
  }
  async fetchPosition(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e);
    if (!i.option)
      throw new ge(i.type).addMessage("It supports option markets only").exchange(this.id);
    const s = {
      symbol: i.id
    }, n = await this.eapiPrivateGetPosition(this.extend(s, t));
    return this.parsePosition(n[0], i);
  }
  async fetchOptionPositions(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = {};
    let s;
    if (e !== void 0) {
      let a;
      if (Array.isArray(e)) {
        if (e.length > 1)
          throw new g("fetchPositions() symbols argument cannot contain more than 1 symbol").exchange(this.id);
        a = e[0];
      } else
        a = e;
      s = this.market(a), i.symbol = s.id;
    }
    const n = await this.eapiPrivateGetPosition(this.extend(i, t)), r = [];
    for (let a = 0; a < n.length; a++)
      r.push(this.parsePosition(n[a], s));
    return this.filterByArrayPositions(r, "symbol", e, !1);
  }
  parsePosition(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t);
    const s = t.symbol, n = this.safeStringLower(e, "side");
    let r = this.safeString(e, "quantity");
    n !== "long" && (r = P.stringMul("-1", r));
    const a = this.safeInteger(e, "time");
    return this.safePosition({
      info: e,
      id: void 0,
      symbol: s,
      entryPrice: this.safeNumber(e, "entryPrice"),
      markPrice: this.safeNumber(e, "markPrice"),
      notional: this.safeNumber(e, "markValue"),
      collateral: this.safeNumber(e, "positionCost"),
      unrealizedPnl: this.safeNumber(e, "unrealizedPNL"),
      side: n,
      contracts: this.parseNumber(r),
      contractSize: void 0,
      timestamp: a,
      datetime: this.iso8601(a),
      hedged: void 0,
      maintenanceMargin: void 0,
      maintenanceMarginPercentage: void 0,
      initialMargin: void 0,
      initialMarginPercentage: void 0,
      leverage: void 0,
      liquidationPrice: void 0,
      marginRatio: void 0,
      marginMode: void 0,
      percentage: void 0
    });
  }
  async fetchPositions(e = void 0, t = {}) {
    const i = this.safeString(this.options, "fetchPositions", "positionRisk");
    let s;
    if ([s, t] = this.handleOptionAndParams(t, "fetchPositions", "method", i), s === "positionRisk")
      return await this.fetchPositionsRisk(e, t);
    if (s === "account")
      return await this.fetchAccountPositions(e, t);
    if (s === "option")
      return await this.fetchOptionPositions(e, t);
    throw new g(s + '" is invalid, please choose between "account", "positionRisk" and "option"').exchange(this.id);
  }
  async fetchAccountPositions(e = void 0, t = {}) {
    if (e !== void 0 && !Array.isArray(e))
      throw new g("It requires an array argument for symbols").exchange(this.id);
    await this.loadMarkets(), await this.loadLeverageBrackets(!1, t);
    const i = this.safeString(this.options, "defaultType", "future"), s = this.safeString(t, "type", i);
    t = this.omit(t, "type");
    let n;
    [n, t] = this.handleSubTypeAndParams("fetchAccountPositions", void 0, t, "linear");
    let r;
    [r, t] = this.handleOptionAndParams2(t, "fetchAccountPositions", "papi", "portfolioMargin", !1);
    let a;
    if (this.isLinear(s, n))
      r ? a = await this.papiGetUmAccount(t) : a = await this.fapiPrivateV2GetAccount(t);
    else if (this.isInverse(s, n))
      r ? a = await this.papiGetCmAccount(t) : a = await this.dapiPrivateGetAccount(t);
    else
      throw new g("fetchPositions() supports linear and inverse contracts only").exchange(this.id);
    const o = this.parseAccountPositions(a);
    return e = this.marketSymbols(e), this.filterByArrayPositions(o, "symbol", e, !1);
  }
  async fetchPositionsRisk(e = void 0, t = {}) {
    if (e !== void 0 && !Array.isArray(e))
      throw new g("fetchPositionsRisk() requires an array argument for symbols").exchange(this.id);
    await this.loadMarkets(), await this.loadLeverageBrackets(!1, t);
    const i = {};
    let s = "future";
    s = this.safeString(this.options, "defaultType", s);
    const n = this.safeString(t, "type", s);
    let r;
    [r, t] = this.handleSubTypeAndParams("fetchPositionsRisk", void 0, t, "linear");
    let a;
    [a, t] = this.handleOptionAndParams2(t, "fetchPositionsRisk", "papi", "portfolioMargin", !1), t = this.omit(t, "type");
    let o;
    if (this.isLinear(n, r))
      a ? o = await this.papiGetUmPositionRisk(this.extend(i, t)) : o = await this.fapiPrivateV2GetPositionRisk(this.extend(i, t));
    else if (this.isInverse(n, r))
      a ? o = await this.papiGetCmPositionRisk(this.extend(i, t)) : o = await this.dapiPrivateGetPositionRisk(this.extend(i, t));
    else
      throw new g("fetchPositionsRisk() supports linear and inverse contracts only").exchange(this.id);
    const c = [];
    for (let u = 0; u < o.length; u++) {
      const f = this.parsePositionRisk(o[u]);
      c.push(f);
    }
    return e = this.marketSymbols(e), this.filterByArrayPositions(c, "symbol", e, !1);
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchLedger", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchLedger", e, t, i, s);
    let r, a, o;
    e !== void 0 && (o = this.currency(e));
    const c = {};
    [r, s] = this.handleMarketTypeAndParams("fetchLedger", void 0, s), [a, s] = this.handleSubTypeAndParams("fetchLedger", void 0, s), t !== void 0 && (c.startTime = t), i !== void 0 && (c.limit = i);
    const u = this.safeInteger(s, "until");
    u !== void 0 && (s = this.omit(s, "until"), c.endTime = u);
    let f;
    [f, s] = this.handleOptionAndParams2(s, "fetchLedger", "papi", "portfolioMargin", !1);
    let h;
    if (r === "option")
      this.checkRequiredArgument("fetchLedger", e, "code"), c.currency = o.id, h = await this.eapiPrivateGetBill(this.extend(c, s));
    else if (this.isLinear(r, a))
      f ? h = await this.papiGetUmIncome(this.extend(c, s)) : h = await this.fapiPrivateGetIncome(this.extend(c, s));
    else if (this.isInverse(r, a))
      f ? h = await this.papiGetCmIncome(this.extend(c, s)) : h = await this.dapiPrivateGetIncome(this.extend(c, s));
    else
      throw new g("fetchLedger() supports contract wallets only").exchange(this.id);
    return this.parseLedger(h, o, t, i);
  }
  parseLedgerEntry(e, t = void 0) {
    let i = this.safeString2(e, "amount", "income"), s;
    P.stringLe(i, "0") ? (s = "out", i = P.stringMul("-1", i)) : s = "in";
    const n = this.safeString(e, "asset"), r = this.safeInteger2(e, "createDate", "time"), a = this.safeString2(e, "type", "incomeType");
    return {
      id: this.safeString2(e, "id", "tranId"),
      direction: s,
      account: void 0,
      referenceAccount: void 0,
      referenceId: this.safeString(e, "tradeId"),
      type: this.parseLedgerEntryType(a),
      currency: this.safeCurrencyCode(n, t),
      amount: this.parseNumber(i),
      timestamp: r,
      datetime: this.iso8601(r),
      before: void 0,
      after: void 0,
      status: void 0,
      fee: void 0,
      info: e
    };
  }
  parseLedgerEntryType(e) {
    const t = {
      FEE: "fee",
      FUNDING_FEE: "fee",
      OPTIONS_PREMIUM_FEE: "fee",
      POSITION_LIMIT_INCREASE_FEE: "fee",
      CONTRACT: "trade",
      REALIZED_PNL: "trade",
      TRANSFER: "transfer",
      CROSS_COLLATERAL_TRANSFER: "transfer",
      INTERNAL_TRANSFER: "transfer",
      COIN_SWAP_DEPOSIT: "deposit",
      COIN_SWAP_WITHDRAW: "withdrawal",
      OPTIONS_SETTLE_PROFIT: "settlement",
      DELIVERED_SETTELMENT: "settlement",
      WELCOME_BONUS: "cashback",
      CONTEST_REWARD: "cashback",
      COMMISSION_REBATE: "rebate",
      API_REBATE: "rebate",
      REFERRAL_KICKBACK: "referral",
      COMMISSION: "commission"
    };
    return this.safeString(t, e, e);
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    const a = this.urls;
    if (!(t in a.api))
      throw new O().overwriteMessage("It does not have a testnet/sandbox URL for " + t + " endpoints").exchange(this.id);
    let o = this.urls.api[t];
    if (o += "/" + e, e === "historicalTrades")
      if (this.apiKey)
        n = {
          "X-MBX-APIKEY": this.apiKey
        };
      else
        throw new Z().addMessage("historicalTrades endpoint requires `apiKey` credential").exchange(this.id);
    if (e === "userDataStream" || e === "listenKey")
      if (this.apiKey)
        n = {
          "X-MBX-APIKEY": this.apiKey,
          "Content-Type": "application/x-www-form-urlencoded"
        }, i !== "GET" && (r = this.urlencode(s));
      else
        throw new Z().addMessage(this.id + " userDataStream endpoint requires `apiKey` credential").exchange(this.id);
    else if (t === "private" || t === "eapiPrivate" || t === "sapi" && e !== "system/status" || t === "sapiV2" || t === "sapiV3" || t === "sapiV4" || t === "dapiPrivate" || t === "dapiPrivateV2" || t === "fapiPrivate" || t === "fapiPrivateV2" || t === "papi" && e !== "ping") {
      if (this.checkRequiredCredentials(), i === "POST" && (e === "order" || e === "sor/order") && this.safeString(s, "newClientOrderId") === void 0) {
        const y = t.indexOf("sapi") > -1 || t === "private", w = y ? "spot" : "future", S = y ? "x-R4BD3S82" : "x-xcKtGhcu", b = this.safeDict(this.options, "broker", {}), T = this.safeString(b, w, S);
        s.newClientOrderId = T + this.uuid22();
      }
      let u;
      if (e === "batchOrders" && i === "POST") {
        const m = this.safeValue(s, "batchOrders"), y = this.json(m);
        s.batchOrders = y;
      }
      const f = this.safeInteger(this.options, "recvWindow");
      let h = this.extend({
        timestamp: this.nonce()
      }, s);
      f !== void 0 && (h.recvWindow = f);
      const l = this.safeInteger(s, "recvWindow");
      if (l !== void 0 && (h.recvWindow = l), t === "sapi" && e === "asset/dust")
        u = this.urlencodeWithArrayRepeat(h);
      else if (e === "batchOrders" || e.indexOf("sub-account") >= 0 || e === "capital/withdraw/apply" || e.indexOf("staking") >= 0)
        if (i === "DELETE" && e === "batchOrders") {
          const m = this.safeList(h, "orderidlist", []), y = this.safeList(h, "origclientorderidlist", []);
          h = this.omit(h, ["orderidlist", "origclientorderidlist"]), u = this.rawencode(h);
          const w = m.length, S = y.length;
          w > 0 && (u = u + "&orderidlist=[" + m.join(",") + "]"), S > 0 && (u = u + "&origclientorderidlist=[" + y.join(",") + "]");
        } else
          u = this.rawencode(h);
      else
        u = this.urlencode(h);
      let p;
      this.secret && this.secret.indexOf("PRIVATE KEY") > -1 ? this.secret.length > 120 ? p = this.encodeURIComponent(Zn(u, this.secret, Re)) : p = this.encodeURIComponent(pu(this.encode(u), this.secret, at)) : this.externalSigner ? p = await this.externalSigner.sign({
        payload: this.encode(u),
        publicApiKey: this.apiKey,
        exchangeId: this.id
      }) : p = this.hmac(this.encode(u), this.encode(this.secret), Re), u += "&signature=" + p, n = {
        "X-MBX-APIKEY": this.apiKey
      }, i === "GET" || i === "DELETE" ? o += "?" + u : (r = u, n["Content-Type"] = "application/x-www-form-urlencoded");
    } else
      Object.keys(s).length && (o += "?" + this.urlencode(s));
    return { url: o, method: i, body: r, headers: n };
  }
  getExceptionsByUrl(e, t) {
    let i;
    const s = this.hostname !== void 0 ? this.hostname : "binance.com";
    if (e.startsWith("https://api." + s + "/") ? i = "spot" : e.startsWith("https://dapi." + s + "/") ? i = "inverse" : e.startsWith("https://fapi." + s + "/") ? i = "linear" : e.startsWith("https://eapi." + s + "/") ? i = "option" : e.startsWith("https://papi." + s + "/") && (i = "portfoliomargin"), i !== void 0) {
      const n = this.safeDict(this.exceptions, i, {});
      return this.safeDict(n, t, {});
    }
    return {};
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (e === 418 || e === 429)
      throw new Rt().addMessage(e.toString() + ":" + t).exchange(this.id);
    const u = this.safeString(a, "code");
    if (e >= 400) {
      if (r.indexOf("Price * QTY is zero or less") >= 0)
        throw new g(e.toString() + ": Order cost = amount * price is zero or less").exchange(this.id);
      if (r.indexOf("LOT_SIZE") >= 0)
        throw new g(e.toString() + ": Order amount should be evenly divisible by lot size").exchange(this.id);
      if (r.indexOf("PRICE_FILTER") >= 0)
        throw new g(e.toString() + ": Order price is invalid, i.e. exceeds allowed price precision, exceeds min price or max price limits or is invalid value in general, use this.priceToPrecision (symbol, amount) ").exchange(this.id);
    }
    if (a === void 0)
      return;
    const f = this.safeString(a, "msg"), h = this.safeValue(a, "success", !0);
    if (!h) {
      const l = this.safeString(a, "msg");
      let p;
      if (l !== void 0) {
        try {
          p = JSON.parse(l);
        } catch {
          p = void 0;
        }
        p !== void 0 && (a = p);
      }
    }
    if (f !== void 0) {
      const l = (u ? u + ": " : "") + f;
      this.throwExactlyMatchedException(this.getExceptionsByUrl(i, "exact"), f, l), this.throwExactlyMatchedException(this.exceptions.exact, f, l), this.throwBroadlyMatchedException(this.getExceptionsByUrl(i, "broad"), f, l), this.throwBroadlyMatchedException(this.exceptions.broad, f, l);
    }
    if (u !== void 0) {
      const l = u + ": " + f;
      if (u === "200" || P.stringEquals(u, "0"))
        return;
      throw f === "No need to change margin type." ? new k().addMessage(l).exchange(this.id) : (this.throwExactlyMatchedException(this.getExceptionsByUrl(i, "exact"), u, l), this.throwExactlyMatchedException(this.exceptions.exact, u, l), new O().addMessage(l).exchange(this.id));
    }
    if (!h)
      throw new O().addMessage(f).exchange(this.id);
    if (Array.isArray(a) && a.length === 1) {
      const p = a[0], m = this.safeString(p, "code"), y = this.safeString(p, "msg");
      m !== void 0 && (this.throwExactlyMatchedException(this.getExceptionsByUrl(i, "exact"), m, m + ": " + y), this.throwExactlyMatchedException(this.exceptions.exact, m, m + ": " + y));
    }
  }
  calculateRateLimiterCost(e, t, i, s, n = {}) {
    if ("noCoin" in n && !("coin" in s))
      return n.noCoin;
    if ("noSymbol" in n && !("symbol" in s))
      return n.noSymbol;
    if ("noPoolId" in n && !("poolId" in s))
      return n.noPoolId;
    if ("byLimit" in n && "limit" in s) {
      const r = s.limit, a = n.byLimit;
      for (let o = 0; o < a.length; o++) {
        const c = a[o];
        if (r <= c[0])
          return c[1];
      }
    }
    return this.safeValue(n, "cost", 1);
  }
  async request(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0, a = {}) {
    return await this.fetch2(e, t, i, s, n, r, a);
  }
}
let jy = class extends gt {
};
class Fy extends jy {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "bitfinex2",
      name: "Bitfinex",
      countries: ["VG"],
      version: "v2",
      certified: !1,
      pro: !0,
      // new metainfo interface
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: void 0,
        option: void 0,
        cancelAllOrders: !0,
        cancelOrder: !0,
        cancelOrders: !0,
        createDepositAddress: !0,
        createLimitOrder: !0,
        createMarketOrder: !0,
        createOrder: !0,
        createTrailingAmountOrder: !0,
        createTrailingPercentOrder: !1,
        createTriggerOrder: !0,
        editOrder: !0,
        fetchBalance: !0,
        fetchClosedOrder: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDepositAddress: !0,
        fetchDepositsWithdrawals: !0,
        fetchLedger: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrder: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderTrades: !0,
        fetchPosition: !1,
        fetchPositions: !0,
        fetchStatus: !0,
        fetchTickers: !0,
        fetchTime: !1,
        fetchTradingFee: !1,
        fetchTradingFees: !0,
        fetchTransactionFees: void 0,
        fetchTransactions: "emulated",
        withdraw: !0
      },
      timeframes: {
        "1m": "1m",
        "5m": "5m",
        "15m": "15m",
        "30m": "30m",
        "1h": "1h",
        "3h": "3h",
        "4h": "4h",
        "6h": "6h",
        "12h": "12h",
        "1d": "1D",
        "1w": "7D",
        "2w": "14D",
        "1M": "1M"
      },
      // cheapest endpoint is 240 requests per minute => ~ 4 requests per second => ( 1000ms / 4 ) = 250ms between requests on average
      rateLimit: 250,
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/27766244-e328a50c-5ed2-11e7-947b-041416579bb3.jpg",
        api: {
          v1: "https://api.bitfinex.com",
          public: "https://api-pub.bitfinex.com",
          private: "https://api.bitfinex.com"
        },
        www: "https://www.bitfinex.com",
        doc: [
          "https://docs.bitfinex.com/v2/docs/",
          "https://github.com/bitfinexcom/bitfinex-api-node"
        ],
        fees: "https://www.bitfinex.com/fees"
      },
      api: {
        public: {
          get: {
            "conf/{config}": 2.7,
            "conf/pub:{action}:{object}": 2.7,
            "conf/pub:{action}:{object}:{detail}": 2.7,
            "conf/pub:map:{object}": 2.7,
            "conf/pub:map:{object}:{detail}": 2.7,
            "conf/pub:map:currency:{detail}": 2.7,
            "conf/pub:map:currency:sym": 2.7,
            "conf/pub:map:currency:label": 2.7,
            "conf/pub:map:currency:unit": 2.7,
            "conf/pub:map:currency:undl": 2.7,
            "conf/pub:map:currency:pool": 2.7,
            "conf/pub:map:currency:explorer": 2.7,
            "conf/pub:map:currency:tx:fee": 2.7,
            "conf/pub:map:tx:method": 2.7,
            "conf/pub:list:{object}": 2.7,
            "conf/pub:list:{object}:{detail}": 2.7,
            "conf/pub:list:currency": 2.7,
            "conf/pub:list:pair:exchange": 2.7,
            "conf/pub:list:pair:margin": 2.7,
            "conf/pub:list:pair:futures": 2.7,
            "conf/pub:list:competitions": 2.7,
            "conf/pub:info:{object}": 2.7,
            "conf/pub:info:{object}:{detail}": 2.7,
            "conf/pub:info:pair": 2.7,
            "conf/pub:info:pair:futures": 2.7,
            "conf/pub:info:tx:status": 2.7,
            "conf/pub:fees": 2.7,
            "platform/status": 8,
            tickers: 2.7,
            "ticker/{symbol}": 2.7,
            "tickers/hist": 2.7,
            "trades/{symbol}/hist": 2.7,
            "book/{symbol}/{precision}": 1,
            "book/{symbol}/P0": 1,
            "book/{symbol}/P1": 1,
            "book/{symbol}/P2": 1,
            "book/{symbol}/P3": 1,
            "book/{symbol}/R0": 1,
            "stats1/{key}:{size}:{symbol}:{side}/{section}": 2.7,
            "stats1/{key}:{size}:{symbol}:{side}/last": 2.7,
            "stats1/{key}:{size}:{symbol}:{side}/hist": 2.7,
            "stats1/{key}:{size}:{symbol}/{section}": 2.7,
            "stats1/{key}:{size}:{symbol}/last": 2.7,
            "stats1/{key}:{size}:{symbol}/hist": 2.7,
            "stats1/{key}:{size}:{symbol}:long/last": 2.7,
            "stats1/{key}:{size}:{symbol}:long/hist": 2.7,
            "stats1/{key}:{size}:{symbol}:short/last": 2.7,
            "stats1/{key}:{size}:{symbol}:short/hist": 2.7,
            "candles/trade:{timeframe}:{symbol}:{period}/{section}": 2.7,
            "candles/trade:{timeframe}:{symbol}/{section}": 2.7,
            "candles/trade:{timeframe}:{symbol}/last": 2.7,
            "candles/trade:{timeframe}:{symbol}/hist": 2.7,
            "status/{type}": 2.7,
            "status/deriv": 2.7,
            "status/deriv/{symbol}/hist": 2.7,
            "liquidations/hist": 80,
            "rankings/{key}:{timeframe}:{symbol}/{section}": 2.7,
            "rankings/{key}:{timeframe}:{symbol}/hist": 2.7,
            "pulse/hist": 2.7,
            "pulse/profile/{nickname}": 2.7,
            "funding/stats/{symbol}/hist": 10
            // ratelimit not in docs
          },
          post: {
            "calc/trade/avg": 2.7,
            "calc/fx": 2.7
          }
        },
        private: {
          post: {
            // 'auth/r/orders/{symbol}/new', // outdated
            // 'auth/r/stats/perf:{timeframe}/hist', // outdated
            "auth/r/wallets": 2.7,
            "auth/r/wallets/hist": 2.7,
            "auth/r/orders": 2.7,
            "auth/r/orders/{symbol}": 2.7,
            "auth/w/order/submit": 2.7,
            "auth/w/order/update": 2.7,
            "auth/w/order/cancel": 2.7,
            "auth/w/order/multi": 2.7,
            "auth/w/order/cancel/multi": 2.7,
            "auth/r/orders/{symbol}/hist": 2.7,
            "auth/r/orders/hist": 2.7,
            "auth/r/order/{symbol}:{id}/trades": 2.7,
            "auth/r/trades/{symbol}/hist": 2.7,
            "auth/r/trades/hist": 2.7,
            "auth/r/ledgers/{currency}/hist": 2.7,
            "auth/r/ledgers/hist": 2.7,
            "auth/r/info/margin/{key}": 2.7,
            "auth/r/info/margin/base": 2.7,
            "auth/r/info/margin/sym_all": 2.7,
            "auth/r/positions": 2.7,
            "auth/w/position/claim": 2.7,
            "auth/w/position/increase:": 2.7,
            "auth/r/position/increase/info": 2.7,
            "auth/r/positions/hist": 2.7,
            "auth/r/positions/audit": 2.7,
            "auth/r/positions/snap": 2.7,
            "auth/w/deriv/collateral/set": 2.7,
            "auth/w/deriv/collateral/limits": 2.7,
            "auth/r/funding/offers": 2.7,
            "auth/r/funding/offers/{symbol}": 2.7,
            "auth/w/funding/offer/submit": 2.7,
            "auth/w/funding/offer/cancel": 2.7,
            "auth/w/funding/offer/cancel/all": 2.7,
            "auth/w/funding/close": 2.7,
            "auth/w/funding/auto": 2.7,
            "auth/w/funding/keep": 2.7,
            "auth/r/funding/offers/{symbol}/hist": 2.7,
            "auth/r/funding/offers/hist": 2.7,
            "auth/r/funding/loans": 2.7,
            "auth/r/funding/loans/hist": 2.7,
            "auth/r/funding/loans/{symbol}": 2.7,
            "auth/r/funding/loans/{symbol}/hist": 2.7,
            "auth/r/funding/credits": 2.7,
            "auth/r/funding/credits/hist": 2.7,
            "auth/r/funding/credits/{symbol}": 2.7,
            "auth/r/funding/credits/{symbol}/hist": 2.7,
            "auth/r/funding/trades/{symbol}/hist": 2.7,
            "auth/r/funding/trades/hist": 2.7,
            "auth/r/info/funding/{key}": 2.7,
            "auth/r/info/user": 2.7,
            "auth/r/summary": 2.7,
            "auth/r/logins/hist": 2.7,
            "auth/r/permissions": 2.7,
            "auth/w/token": 2.7,
            "auth/r/audit/hist": 2.7,
            "auth/w/transfer": 2.7,
            "auth/w/deposit/address": 24,
            "auth/w/deposit/invoice": 24,
            "auth/w/withdraw": 24,
            "auth/r/movements/{currency}/hist": 2.7,
            "auth/r/movements/hist": 2.7,
            "auth/r/alerts": 5.34,
            "auth/w/alert/set": 2.7,
            "auth/w/alert/price:{symbol}:{price}/del": 2.7,
            "auth/w/alert/{type}:{symbol}:{price}/del": 2.7,
            "auth/calc/order/avail": 2.7,
            "auth/w/settings/set": 2.7,
            "auth/r/settings": 2.7,
            "auth/w/settings/del": 2.7,
            "auth/r/pulse/hist": 2.7,
            "auth/w/pulse/add": 16,
            "auth/w/pulse/del": 2.7
          }
        }
      },
      fees: {
        trading: {
          feeSide: "get",
          percentage: !0,
          tierBased: !0,
          maker: this.parseNumber("0.001"),
          taker: this.parseNumber("0.002"),
          tiers: {
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.002")],
              [this.parseNumber("500000"), this.parseNumber("0.002")],
              [this.parseNumber("1000000"), this.parseNumber("0.002")],
              [this.parseNumber("2500000"), this.parseNumber("0.002")],
              [this.parseNumber("5000000"), this.parseNumber("0.002")],
              [this.parseNumber("7500000"), this.parseNumber("0.002")],
              [this.parseNumber("10000000"), this.parseNumber("0.0018")],
              [this.parseNumber("15000000"), this.parseNumber("0.0016")],
              [this.parseNumber("20000000"), this.parseNumber("0.0014")],
              [this.parseNumber("25000000"), this.parseNumber("0.0012")],
              [this.parseNumber("30000000"), this.parseNumber("0.001")]
            ],
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.001")],
              [this.parseNumber("500000"), this.parseNumber("0.0008")],
              [this.parseNumber("1000000"), this.parseNumber("0.0006")],
              [this.parseNumber("2500000"), this.parseNumber("0.0004")],
              [this.parseNumber("5000000"), this.parseNumber("0.0002")],
              [this.parseNumber("7500000"), this.parseNumber("0")],
              [this.parseNumber("10000000"), this.parseNumber("0")],
              [this.parseNumber("15000000"), this.parseNumber("0")],
              [this.parseNumber("20000000"), this.parseNumber("0")],
              [this.parseNumber("25000000"), this.parseNumber("0")],
              [this.parseNumber("30000000"), this.parseNumber("0")]
            ]
          }
        },
        funding: {
          withdraw: {}
        }
      },
      precisionMode: or,
      options: {
        precision: "R0",
        // convert 'EXCHANGE MARKET' to lowercase 'market'
        // convert 'EXCHANGE LIMIT' to lowercase 'limit'
        // everything else remains uppercase
        exchangeTypes: {
          // 'MARKET': undefined,
          "EXCHANGE MARKET": "market",
          // 'LIMIT': undefined,
          "EXCHANGE LIMIT": "limit",
          // 'STOP': undefined,
          "EXCHANGE STOP": "market",
          // 'TRAILING STOP': undefined,
          // 'EXCHANGE TRAILING STOP': undefined,
          // 'FOK': undefined,
          "EXCHANGE FOK": "limit",
          // 'STOP LIMIT': undefined,
          "EXCHANGE STOP LIMIT": "limit",
          // 'IOC': undefined,
          "EXCHANGE IOC": "limit"
        },
        // convert 'market' to 'EXCHANGE MARKET'
        // convert 'limit' 'EXCHANGE LIMIT'
        // everything else remains as is
        orderTypes: {
          market: "EXCHANGE MARKET",
          limit: "EXCHANGE LIMIT"
        },
        fiat: {
          USD: "USD",
          EUR: "EUR",
          JPY: "JPY",
          GBP: "GBP",
          CHN: "CHN"
        },
        // actually the correct names unlike the v1
        // we don't want to extend this with accountsByType in v1
        v2AccountsByType: {
          spot: "exchange",
          exchange: "exchange",
          funding: "funding",
          margin: "margin",
          derivatives: "margin",
          future: "margin",
          swap: "margin"
        },
        withdraw: {
          includeFee: !1
        }
      },
      exceptions: {
        exact: {
          11010: Ae,
          10001: ee,
          10020: O,
          10100: Z,
          10114: ze,
          20060: dt,
          // {"code":503,"error":"temporarily_unavailable","error_description":"Sorry, the service is temporarily unavailable. See https://www.bitfinex.com/ for more info."}
          temporarily_unavailable: Te
        },
        broad: {
          address: et,
          "available balance is only": re,
          "not enough exchange balance": re,
          "Order not found": Se,
          "symbol: invalid": O,
          "Invalid order: minimum size for": g,
          "Invalid order": k,
          "Momentary balance check": je,
          "digest invalid": Pt
        },
        messages: {
          "Invalid order: minimum size for": ye.ORDER_UNDER_MINIMUM
        }
      }
    });
  }
  isFiat(e) {
    return e in this.options.fiat;
  }
  getCurrencyId(e) {
    return "f" + e;
  }
  getCurrencyName(e) {
    if (e in this.options.currencyNames)
      return this.options.currencyNames[e];
    throw new ke().addMessage(e + " not supported for withdrawal").exchange(this.id);
  }
  amountToPrecision(e, t) {
    return e = this.safeSymbol(e), this.decimalToPrecision(t, Et, this.markets[e].precision.amount, St);
  }
  priceToPrecision(e, t) {
    return e = this.safeSymbol(e), t = this.decimalToPrecision(t, Dt, this.markets[e].precision.price, this.precisionMode), this.decimalToPrecision(t, Et, 8, St);
  }
  async fetchStatus(e = {}) {
    const t = await this.publicGetPlatformStatus(e), i = this.safeString(t, 0);
    return {
      status: this.safeString({ 0: "maintenance", 1: "ok" }, i, i),
      updated: void 0,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchMarkets(e = {}) {
    let t = await this.publicGetConfPubInfoPair(e), i = await this.publicGetConfPubInfoPairFutures(e);
    t = this.safeValue(t, 0, []), i = this.safeValue(i, 0, []);
    const s = this.arrayConcat(t, i);
    let n = await this.publicGetConfPubListPairMargin(e);
    n = this.safeValue(n, 0, []);
    const r = [];
    for (let a = 0; a < s.length; a++) {
      const o = s[a], c = this.safeStringUpper(o, 0), u = this.safeValue(o, 1, {});
      let f = !0;
      c.indexOf("F0") >= 0 && (f = !1);
      const h = !f;
      let l, p;
      if (c.indexOf(":") >= 0) {
        const j = c.split(":");
        l = j[0], p = j[1];
      } else
        l = c.slice(0, 3), p = c.slice(3, 6);
      let m = this.safeCurrencyCode(l), y = this.safeCurrencyCode(p);
      const w = m.split("F0"), S = y.split("F0");
      m = this.safeString(w, 0), y = this.safeString(S, 0);
      let b = m + "/" + y;
      l = this.getCurrencyId(l), p = this.getCurrencyId(p);
      let T, x;
      h && (T = y, x = y, b = b + ":" + T);
      const v = this.safeString(u, 3), _ = this.safeString(u, 4);
      let V = !1;
      f && this.inArray(c, n) && (V = !0), r.push({
        id: "t" + c,
        symbol: b,
        base: m,
        quote: y,
        settle: T,
        baseId: l,
        quoteId: p,
        settleId: x,
        type: f ? "spot" : "swap",
        spot: f,
        margin: V,
        swap: h,
        future: !1,
        option: !1,
        active: !0,
        contract: h,
        linear: h ? !0 : void 0,
        inverse: h ? !1 : void 0,
        contractSize: h ? this.parseNumber("1") : void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: parseInt("8"),
          price: parseInt("5")
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: this.parseNumber(v),
            max: this.parseNumber(_)
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: void 0,
            max: void 0
          }
        },
        created: void 0,
        info: u
      });
    }
    return r;
  }
  async fetchCurrencies(e = {}) {
    const s = {
      config: [
        "pub:list:currency",
        "pub:map:currency:sym",
        "pub:map:currency:label",
        "pub:map:currency:unit",
        "pub:map:currency:undl",
        "pub:map:currency:pool",
        "pub:map:currency:explorer",
        "pub:map:currency:tx:fee",
        "pub:map:tx:method",
        "pub:info:tx:status"
        // provides withdrawal/deposit statuses 1 = active, 0 = disabled
      ].join(",")
    }, n = await this.publicGetConfConfig(this.extend(s, e)), r = {
      sym: this.indexBy(this.safeValue(n, 1, []), 0),
      label: this.indexBy(this.safeValue(n, 2, []), 0),
      unit: this.indexBy(this.safeValue(n, 3, []), 0),
      undl: this.indexBy(this.safeValue(n, 4, []), 0),
      pool: this.indexBy(this.safeValue(n, 5, []), 0),
      explorer: this.indexBy(this.safeValue(n, 6, []), 0),
      fees: this.indexBy(this.safeValue(n, 7, []), 0),
      networkStatus: this.indexBy(this.safeValue(n, 9, []), 0)
    }, a = this.safeValue(n, 0, []), o = {};
    for (let c = 0; c < a.length; c++) {
      const u = a[c];
      if (u.indexOf("F0") >= 0)
        continue;
      const f = this.safeCurrencyCode(u), h = this.safeValue(r.label, u, []), l = this.safeString(h, 1), p = this.safeValue(r.pool, u, []), m = this.safeString(p, 1), y = m === void 0 ? "other" : "crypto", w = this.safeValue(r.fees, u, []), S = this.safeValue(w, 1, []), b = this.safeNumber(S, 1), T = this.safeValue(r.undl, u, []), x = "8", v = "f" + u;
      let _ = !1, V = !1;
      const j = {}, G = this.safeValue(n, 8, []), W = u.replace("F0", "");
      for (let se = 0; se < G.length; se++) {
        const $ = G[se], te = this.safeString($, 0);
        if (this.safeString(this.safeValue($, 1, []), 0) === W) {
          const N = m ?? this.safeNetwork(te), L = this.safeValue(r.networkStatus, te, []), z = this.safeInteger(L, 1, 0) === 1, K = this.safeInteger(L, 2, 0) === 1;
          V = z || V, _ = K || _, j[N] = {
            info: te,
            id: te.toLowerCase(),
            network: N,
            active: z && K,
            deposit: z,
            withdraw: K,
            fee: void 0,
            precision: void 0,
            limits: {
              withdraw: {
                min: void 0,
                max: void 0
              }
            }
          };
        }
      }
      o[f] = {
        id: v,
        uppercaseId: u,
        code: f,
        info: [u, h, p, w, T],
        type: y,
        name: l,
        active: _ && V,
        deposit: V,
        withdraw: _,
        fee: b,
        precision: parseInt(x),
        limits: {
          amount: {
            min: this.parseNumber(this.parsePrecision(x)),
            max: void 0
          },
          withdraw: {
            min: b,
            max: void 0
          }
        },
        networks: {}
      }, Object.keys(j).length > 0 && (o[f].networks = j);
    }
    return o;
  }
  safeNetwork(e) {
    const t = {
      BITCOIN: "BTC",
      LITECOIN: "LTC",
      ETHEREUM: "ETH",
      ERC20: "ETH",
      TETHERUSE: "ETH",
      TETHERUSO: "OMNI",
      TETHERUSL: "LIQUID",
      TETHERUSX: "TRX",
      TETHERUSS: "EOS",
      TETHERUSDTAVAX: "AVAX",
      TETHERUSDTSOL: "SOL",
      TETHERUSDTALG: "ALG",
      TETHERUSDTBCH: "BCH",
      TETHERUSDTKSM: "KSM",
      TETHERUSDTDVF: "DVF",
      TETHERUSDTOMG: "OMG",
      TETHERUSDTXTZ: "XTZ",
      TETHERUSDTNEAR: "NEAR",
      TETHERUSDTDOT: "DOT",
      TETHERUSDTPLY: "PLY",
      TETHERUSDTKAVA: "KAVA",
      TETHERMXNTE: "ETH",
      TETHERXAUTE: "ETH",
      TETHEREUE: "ETH",
      TETHERCNHTX: "ETH",
      TETHERCNHTE: "ETH",
      TETHERUSDTZK: "ZK2",
      XAUT: "ETH",
      CNHT: "ETH",
      EUT: "ETH",
      MXNT: "ETH",
      NEOGAS: "NEO",
      LES: "EOS",
      LET: "ETH"
    };
    return this.safeString(t, e, e);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const t = this.safeValue(this.options, "v2AccountsByType", {}), i = this.safeString(e, "type", "exchange"), s = this.safeString(t, i, i);
    if (s === void 0) {
      const c = Object.keys(t);
      throw new g("fetchBalance() type parameter must be one of " + c.join(", ")).exchange(this.id);
    }
    const n = i === "derivatives", r = this.omit(e, "type"), a = await this.privatePostAuthRWallets(r), o = { info: a };
    for (let c = 0; c < a.length; c++) {
      const u = a[c], f = this.account(), h = this.safeString(u, 3);
      h !== "0" && (f.debt = h);
      const l = this.safeString(u, 0), p = this.safeStringLower(u, 1, ""), m = p.length - 2, y = ["f0", "F0"].includes(p.slice(m));
      if (s === l && (n ? y : !y)) {
        const S = this.safeCurrencyCode(p);
        f.total = this.safeString(u, 2), f.free = this.safeString(u, 4), o[S] = f;
      }
    }
    return this.safeBalance(o);
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.safeValue(this.options, "v2AccountsByType", {}), a = this.safeString(r, i);
    if (a === void 0) {
      const y = Object.keys(r);
      throw new g("transfer() fromAccount must be one of " + y.join(", ")).exchange(this.id);
    }
    const o = this.safeString(r, s);
    if (o === void 0) {
      const y = Object.keys(r);
      throw new g("transfer() toAccount must be one of " + y.join(", ")).exchange(this.id);
    }
    const c = this.currency(e), u = this.convertDerivativesId(c, i), f = this.convertDerivativesId(c, s), l = {
      amount: this.currencyToPrecision(e, t),
      currency: u,
      currency_to: f,
      from: a,
      to: o
    }, p = await this.privatePostAuthWTransfer(this.extend(l, n));
    if (this.safeString(p, 0) === "error") {
      const y = this.safeString(p, 2, "");
      throw this.throwExactlyMatchedException(this.exceptions.exact, y, this.id + " " + y), new je().addMessage(y).exchange(this.id);
    }
    return this.parseTransfer(p, c);
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeInteger(e, 0), s = this.safeValue(e, 4), n = this.safeString(s, 1), r = this.safeString(s, 2), a = this.safeString(s, 5), o = this.safeString(e, 6);
    return {
      id: void 0,
      timestamp: i,
      datetime: this.iso8601(i),
      status: this.parseTransferStatus(o),
      amount: this.safeNumber(s, 7),
      currency: this.safeCurrencyCode(a, t),
      fromAccount: n,
      toAccount: r,
      info: e
    };
  }
  parseTransferStatus(e) {
    const t = {
      SUCCESS: "ok",
      ERROR: "failed",
      FAILURE: "failed"
    };
    return this.safeString(t, e, e);
  }
  convertDerivativesId(e, t) {
    const i = this.safeValue(e, "info"), s = this.safeString(i, 0), n = this.safeValue(i, 4, []);
    let r;
    if (t === "derivatives") {
      r = this.safeString(n, 0, s);
      const a = r.length - 2;
      r.slice(a) === "F0" || (r = r + "F0");
    } else
      t !== "margin" ? r = this.safeString(n, 1, s) : r = s;
    return r;
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.safeValue(this.options, "precision", "R0"), n = this.market(e), r = {
      symbol: n.id,
      precision: s
    };
    t !== void 0 && (r.len = t);
    const a = this.extend(r, i), o = await this.publicGetBookSymbolPrecision(a), c = this.milliseconds(), u = {
      symbol: n.symbol,
      bids: [],
      asks: [],
      timestamp: c,
      datetime: this.iso8601(c),
      nonce: void 0
    }, f = a.precision === "R0" ? 1 : 0;
    for (let h = 0; h < o.length; h++) {
      const l = o[h], p = this.safeNumber(l, f), m = this.safeString(l, 2), y = P.stringAbs(m), w = P.stringGt(m, "0") ? "bids" : "asks";
      u[w].push([p, this.parseNumber(y)]);
    }
    return u.bids = this.sortBy(u.bids, 0, !0), u.asks = this.sortBy(u.asks, 0), u;
  }
  parseTicker(e, t = void 0) {
    const i = this.safeSymbol(void 0, t), s = e.length, n = this.safeString(e, s - 4), r = this.safeString(e, s - 5);
    return this.safeTicker({
      symbol: i,
      timestamp: void 0,
      datetime: void 0,
      high: this.safeString(e, s - 2),
      low: this.safeString(e, s - 1),
      bid: this.safeString(e, s - 10),
      bidVolume: this.safeString(e, s - 9),
      ask: this.safeString(e, s - 8),
      askVolume: this.safeString(e, s - 7),
      vwap: void 0,
      open: void 0,
      close: n,
      last: n,
      previousClose: void 0,
      change: this.safeString(e, s - 6),
      percentage: P.stringMul(r, "100"),
      average: void 0,
      baseVolume: this.safeString(e, s - 3),
      quoteVolume: void 0,
      info: e
    }, t);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = {};
    if (e !== void 0) {
      const r = this.marketIds(e);
      i.symbols = r.join(",");
    } else
      i.symbols = "ALL";
    const s = await this.publicGetTickers(this.extend(i, t)), n = {};
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeString(a, 0), c = this.safeMarket(o), u = c.symbol;
      n[u] = this.parseTicker(a, c);
    }
    return this.filterByArrayTickers(n, "symbol", e);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    }, n = await this.publicGetTickerSymbol(this.extend(s, t));
    return this.parseTicker(n, i);
  }
  parseTrade(e, t = void 0) {
    const s = e.length > 5, n = this.safeString(e, 0), r = s ? 4 : 2;
    let a, o = this.safeString(e, r);
    const c = s ? 5 : 3, u = this.safeString(e, c);
    o[0] === "-" ? (a = "sell", o = P.stringAbs(o)) : a = "buy";
    let f, h, l, p, m = this.safeSymbol(void 0, t);
    const y = s ? 2 : 1, w = this.safeInteger(e, y);
    if (s) {
      const S = e[1];
      m = this.safeSymbol(S), f = this.safeString(e, 3), h = this.safeInteger(e, 8) === 1 ? "maker" : "taker";
      let T = this.safeString(e, 9);
      T = P.stringNeg(T);
      const x = this.safeString(e, 10), v = this.safeCurrencyCode(x);
      p = {
        cost: T,
        currency: v
      };
      const _ = e[6];
      l = this.safeString(this.options.exchangeTypes, _);
    }
    return this.safeTrade({
      id: n,
      timestamp: w,
      datetime: this.iso8601(w),
      symbol: m,
      order: f,
      side: a,
      type: l,
      takerOrMaker: h,
      price: u,
      amount: o,
      cost: void 0,
      fee: p,
      info: e
    }, t);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchTrades", e, t, i, s, 1e4);
    const r = this.market(e);
    let a = "-1", o = {
      symbol: r.id
    };
    t !== void 0 && (o.start = t, a = "1"), i !== void 0 && (o.limit = Math.min(i, 1e4)), o.sort = a, [o, s] = this.handleUntilOption("end", o, s);
    const c = await this.publicGetTradesSymbolHist(this.extend(o, s)), u = this.sortBy(c, 1);
    return this.parseTrades(u, r, void 0, i);
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = 100, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 1e4);
    const a = this.market(e);
    s === void 0 && (s = 1e4);
    let o = {
      symbol: a.id,
      timeframe: this.safeString(this.timeframes, t, t),
      sort: 1,
      start: i,
      limit: s
    };
    [o, n] = this.handleUntilOption("end", o, n);
    const c = await this.publicGetCandlesTradeTimeframeSymbolHist(this.extend(o, n));
    return this.parseOHLCVs(c, a, t, i, s);
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeInteger(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 2),
      this.safeNumber(e, 5)
    ];
  }
  parseOrderStatus(e) {
    if (e === void 0)
      return e;
    const t = e.split(" "), i = this.safeString(t, 0), s = {
      ACTIVE: "open",
      PARTIALLY: "open",
      EXECUTED: "closed",
      CANCELED: "canceled",
      INSUFFICIENT: "canceled",
      "POSTONLY CANCELED": "canceled",
      RSN_DUST: "rejected",
      RSN_PAUSE: "rejected",
      "IOC CANCELED": "canceled",
      "FILLORKILL CANCELED": "canceled"
    };
    return this.safeString(s, i, e);
  }
  parseOrderFlags(e) {
    const t = {
      1024: ["reduceOnly"],
      4096: ["postOnly"],
      5120: ["reduceOnly", "postOnly"]
      // '64': 'hidden', // The hidden order option ensures an order does not appear in the order book
      // '512': 'close', // Close position if position present.
      // '16384': 'OCO', // The one cancels other order option allows you to place a pair of orders stipulating that if one order is executed fully or partially, then the other is automatically canceled.
      // '524288': 'No Var Rates' // Excludes variable rate funding offers from matching against this order, if on margin
    };
    return this.safeValue(t, e, void 0);
  }
  parseTimeInForce(e) {
    const t = {
      "EXCHANGE IOC": "IOC",
      "EXCHANGE FOK": "FOK",
      IOC: "IOC",
      FOK: "FOK"
      // Margin
    };
    return this.safeString(t, e, "GTC");
  }
  parseOrder(e, t = void 0) {
    const i = this.safeString(e, 0), s = this.safeString(e, 3), n = this.safeSymbol(s), r = this.safeInteger(e, 5), a = P.stringAbs(this.safeString(e, 6)), o = this.safeString(e, 7), c = P.stringAbs(o), u = P.stringLt(o, "0") ? "sell" : "buy", f = this.safeString(e, 8), h = this.safeString(this.safeValue(this.options, "exchangeTypes"), f), l = this.parseTimeInForce(f), p = this.safeString(e, 12), m = this.parseOrderFlags(p);
    let y = !1;
    if (m !== void 0)
      for (let _ = 0; _ < m.length; _++)
        m[_] === "postOnly" && (y = !0);
    let w = this.safeString(e, 16), S;
    (f === "EXCHANGE STOP" || f === "EXCHANGE STOP LIMIT") && (w = void 0, S = this.safeString(e, 16), f === "EXCHANGE STOP LIMIT" && (w = this.safeString(e, 19)));
    let b;
    const T = this.safeString(e, 13);
    if (T !== void 0) {
      const _ = T.split(" @ ");
      b = this.parseOrderStatus(this.safeString(_, 0));
    }
    const x = this.safeString(e, 17), v = this.safeString(e, 2);
    return this.safeOrder({
      info: e,
      id: i,
      clientOrderId: v,
      timestamp: r,
      datetime: this.iso8601(r),
      lastTradeTimestamp: void 0,
      symbol: n,
      type: h,
      timeInForce: l,
      postOnly: y,
      side: u,
      price: w,
      stopPrice: S,
      triggerPrice: S,
      amount: c,
      cost: void 0,
      average: x,
      filled: void 0,
      remaining: a,
      status: b,
      fee: void 0,
      trades: void 0
    }, t);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const n = {
      symbol: this.market(t).id
    }, r = await this.privatePostAuthROrdersSymbolHist(this.extend(n, i));
    for (let a = 0; a < r.length; a++) {
      const o = this.parseOrder(r[a]);
      if (o.id === e)
        return o;
    }
  }
  async createOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.market(e);
    let o = this.amountToPrecision(e, s);
    o = i === "buy" ? o : P.stringNeg(o);
    const c = {
      symbol: a.id,
      amount: o
    }, u = this.safeString2(r, "stopPrice", "triggerPrice"), f = this.safeString(r, "trailingAmount"), h = this.safeString(r, "timeInForce"), l = this.safeBool(r, "postOnly", !1), p = this.safeBool(r, "reduceOnly", !1), m = this.safeValue2(r, "cid", "clientOrderId");
    let y = t.toUpperCase();
    f !== void 0 ? (y = "TRAILING STOP", c.price_trailing = f) : u !== void 0 && (c.price = this.priceToPrecision(e, u), t === "limit" ? (y = "STOP LIMIT", c.price_aux_limit = this.priceToPrecision(e, n)) : y = "STOP");
    const w = h === "IOC", S = h === "FOK", b = l || h === "PO";
    if ((w || S) && n === void 0)
      throw new g("createOrder() requires a price argument with IOC and FOK orders").exchange(this.id);
    if ((w || S) && t === "market")
      throw new g("createOrder() does not allow market IOC and FOK orders").exchange(this.id);
    t !== "market" && u === void 0 && (c.price = this.priceToPrecision(e, n)), w ? y = "IOC" : S && (y = "FOK");
    let T;
    [T, r] = this.handleMarginModeAndParams("createOrder", r), a.spot && T === void 0 && (y = "EXCHANGE " + y), c.type = y;
    let x = 0;
    return b && (x = this.sum(x, 4096)), p && (x = this.sum(x, 1024)), x !== 0 && (c.flags = x), m !== void 0 && (c.cid = m), r = this.omit(r, ["triggerPrice", "stopPrice", "timeInForce", "postOnly", "reduceOnly", "trailingAmount", "clientOrderId"]), this.extend(c, r);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = await this.createOrderRequest(e, t, i, s, n, r), c = await this.privatePostAuthWOrderSubmit(o);
    if (this.safeString(c, 6) !== "SUCCESS") {
      const l = c[5], p = c[7];
      throw new k().addMessage(c[6] + ": " + p + " (#" + l + ")").exchange(this.id);
    }
    const f = this.safeList(c, 4, []), h = this.safeList(f, 0);
    return this.parseOrder(h, a);
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [];
    for (let o = 0; o < e.length; o++) {
      const c = e[o], u = this.safeString(c, "symbol"), f = this.safeString(c, "type"), h = this.safeString(c, "side"), l = this.safeNumber(c, "amount"), p = this.safeNumber(c, "price"), m = this.safeDict(c, "params", {}), y = this.createOrderRequest(u, f, h, l, p, m);
      i.push(["on", y]);
    }
    const s = {
      ops: i
    }, n = await this.privatePostAuthWOrderMulti(s), r = [], a = this.safeList(n, 4, []);
    for (let o = 0; o < a.length; o++) {
      const u = a[o][4];
      r.push(u[0]);
    }
    return this.parseOrders(r);
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {
      all: 1
    }, s = await this.privatePostAuthWOrderCancelMulti(this.extend(i, t)), n = this.safeValue(s, 4, []);
    return this.parseOrders(n);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.safeValue2(i, "cid", "clientOrderId");
    let n;
    if (s !== void 0) {
      const o = this.safeValue(i, "cidDate");
      if (o === void 0)
        throw new g("canceling an order by clientOrderId ('cid') requires both 'cid' and 'cid_date' ('YYYY-MM-DD')").exchange(this.id);
      n = {
        cid: s,
        cid_date: o
      }, i = this.omit(i, ["cid", "clientOrderId"]);
    } else
      n = {
        id: parseInt(e)
      };
    const r = await this.privatePostAuthWOrderCancel(this.extend(n, i)), a = this.safeValue(r, 4);
    return this.parseOrder(a);
  }
  async cancelOrders(e, t = void 0, i = {}) {
    await this.loadMarkets();
    for (let o = 0; o < e.length; o++)
      e[o] = this.parseToNumeric(e[o]);
    const s = {
      id: e
    };
    let n;
    t !== void 0 && (n = this.market(t));
    const r = await this.privatePostAuthWOrderCancelMulti(this.extend(s, i)), a = this.safeList(r, 4, []);
    return this.parseOrders(a, n);
  }
  async fetchOpenOrder(e, t = void 0, i = {}) {
    const s = {
      id: [parseInt(e)]
    }, n = await this.fetchOpenOrders(t, void 0, void 0, this.extend(s, i)), r = this.safeValue(n, 0);
    if (r === void 0)
      throw new Se().addMessage(this.id + " order " + e + " not found").exchange(this.id);
    return r;
  }
  async fetchClosedOrder(e, t = void 0, i = {}) {
    const s = {
      id: [parseInt(e)]
    }, n = await this.fetchClosedOrders(t, void 0, void 0, this.extend(s, i)), r = this.safeValue(n, 0);
    if (r === void 0)
      throw new Se().addMessage("order " + e + " not found").exchange(this.id);
    return r;
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    let r, a;
    return e === void 0 ? a = await this.privatePostAuthROrders(this.extend(n, s)) : (r = this.market(e), n.symbol = r.id, a = await this.privatePostAuthROrdersSymbol(this.extend(n, s))), this.parseOrders(a, r, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchClosedOrders", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchClosedOrders", e, t, i, s);
    let r = {};
    t !== void 0 && (r.start = t), i !== void 0 && (r.limit = i), [r, s] = this.handleUntilOption("end", r, s);
    let a, o;
    return e === void 0 ? o = await this.privatePostAuthROrdersHist(this.extend(r, s)) : (a = this.market(e), r.symbol = a.id, o = await this.privatePostAuthROrdersSymbolHist(this.extend(r, s))), this.parseOrders(o, a, t, i);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    if (t === void 0)
      throw new g("fetchOrderTrades() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const r = this.market(t), o = {
      id: parseInt(e),
      symbol: r.id
    }, c = await this.privatePostAuthROrderSymbolIdTrades(this.extend(o, n));
    return this.parseTrades(c, r, i, s);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {
      end: this.milliseconds()
    };
    t !== void 0 && (r.start = t), i !== void 0 && (r.limit = i);
    let a;
    return e !== void 0 ? (n = this.market(e), r.symbol = n.id, a = await this.privatePostAuthRTradesSymbolHist(this.extend(r, s))) : a = await this.privatePostAuthRTradesHist(this.extend(r, s)), this.parseTrades(a, n, t, i);
  }
  async createDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = {
      op_renew: 1
    };
    return await this.fetchDepositAddress(e, this.extend(i, t));
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = this.safeString(t, "network", e), n = this.safeValue(i, "networks", {}), r = this.safeValue(n, s), a = this.safeString(r, "id");
    if (a === void 0)
      throw new Kn(e).addMessage("You can specify it by providing the 'network' value inside params").exchange(this.id);
    const o = this.safeString(t, "wallet", "exchange");
    t = this.omit(t, "network", "wallet");
    const c = {
      method: a,
      wallet: o,
      op_renew: 0
      // a value of 1 will generate a new address
    }, u = await this.privatePostAuthWDepositAddress(this.extend(c, t)), f = this.safeValue(u, 4, []), h = this.safeString(f, 5), l = h === void 0 ? this.safeString(f, 4) : h, p = h === void 0 ? void 0 : this.safeString(f, 4);
    return this.checkAddress(l), {
      currency: e,
      address: l,
      tag: p,
      network: void 0,
      info: u
    };
  }
  parseTransactionStatus(e) {
    const t = {
      SUCCESS: "ok",
      COMPLETED: "ok",
      ERROR: "failed",
      FAILURE: "failed",
      CANCELED: "canceled",
      "PENDING APPROVAL": "pending",
      PENDING: "pending",
      "PENDING REVIEW": "pending",
      "PENDING CANCELLATION": "pending",
      SENDING: "pending",
      "USER APPROVED": "pending"
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    const i = e.length;
    let s, n, r, a, o, c, u, f, h, l, p, m, y;
    if (i === 8) {
      const w = this.safeValue(e, 4, []);
      s = this.safeInteger(e, 0), t !== void 0 && (r = t.code), h = this.safeString(w, 8), h !== void 0 && (h = P.stringAbs(h)), a = this.safeNumber(w, 5), o = this.safeInteger(w, 0), c = "ok", o === 0 && (o = void 0, c = "failed"), u = this.safeString(w, 3), f = "withdrawal";
    } else if (i === 22) {
      o = this.safeString(e, 0);
      const w = this.safeString(e, 1);
      r = this.safeCurrencyCode(w, t);
      const S = this.safeString(e, 2);
      m = this.safeNetwork(S), s = this.safeInteger(e, 5), n = this.safeInteger(e, 6), c = this.parseTransactionStatus(this.safeString(e, 9));
      const b = this.safeString(e, 12);
      a = P.stringAbs(b), b !== void 0 && (P.stringLt(b, "0") ? f = "withdrawal" : f = "deposit"), h = this.safeString(e, 13), h !== void 0 && (h = P.stringAbs(h)), p = this.safeString(e, 16), l = this.safeString(e, 20), y = this.safeString(e, 21);
    }
    return {
      info: e,
      id: o,
      txid: l,
      type: f,
      currency: r,
      network: m,
      amount: this.parseNumber(a),
      status: c,
      timestamp: s,
      datetime: this.iso8601(s),
      address: p,
      addressFrom: void 0,
      addressTo: p,
      tag: u,
      tagFrom: void 0,
      tagTo: u,
      updated: n,
      comment: y,
      internal: void 0,
      fee: {
        currency: r,
        cost: this.parseNumber(h),
        rate: void 0
      }
    };
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    const t = await this.privatePostAuthRSummary(e), i = {}, s = this.safeValue(this.options, "fiat", {}), n = this.safeValue(t, 4, []), r = this.safeValue(n, 0, []), a = this.safeValue(n, 1, []), o = this.safeNumber(r, 0), c = this.safeNumber(r, 2), u = this.safeNumber(r, 5), f = this.safeNumber(a, 0), h = this.safeNumber(a, 2), l = this.safeNumber(a, 5);
    for (let p = 0; p < this.symbols.length; p++) {
      const m = this.symbols[p], y = this.market(m), w = {
        info: t,
        symbol: m,
        percentage: !0,
        tierBased: !0
      };
      y.quote in s ? (w.maker = c, w.taker = h) : y.contract ? (w.maker = u, w.taker = l) : (w.maker = o, w.taker = f), i[m] = w;
    }
    return i;
  }
  async fetchDepositsWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {};
    t !== void 0 && (r.start = t), i !== void 0 && (r.limit = i);
    let a;
    return e !== void 0 ? (n = this.currency(e), r.currency = n.uppercaseId, a = await this.privatePostAuthRMovementsCurrencyHist(this.extend(r, s))) : a = await this.privatePostAuthRMovementsHist(this.extend(r, s)), this.parseTransactions(a, n, t, i);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    this.checkAddress(i), await this.loadMarkets();
    const r = this.currency(e), a = this.safeString(n, "network", e);
    n = this.omit(n, "network");
    const o = this.safeValue(r, "networks", {}), c = this.safeValue(o, a), u = this.safeString(c, "id");
    if (u === void 0)
      throw new Kn(e).addMessage("You can specify it by providing the 'network' value inside params").exchange(this.id);
    const f = this.safeString(n, "wallet", "exchange");
    n = this.omit(n, "network", "wallet");
    const h = this.currencyToPrecision(e, t, a), l = {
      method: u,
      wallet: f,
      amount: this.numberToString(h),
      address: i
    };
    s !== void 0 && (l.payment_id = s);
    const p = this.safeValue(this.options, "withdraw", {});
    this.safeBool(p, "includeFee", !1) && (l.fee_deduct = 1);
    const y = await this.privatePostAuthWWithdraw(this.extend(l, n)), w = this.safeString(y, 0), S = this.safeValue(y, 4, []), b = this.safeInteger(S, 0);
    if (w === "error" || b === 0) {
      const v = this.safeString(y, 2, void 0) || this.safeString(y, 7, "");
      throw this.throwExactlyMatchedException(this.exceptions.exact, v, v), this.throwBroadlyMatchedException(this.exceptions.broad, v, v), new ke().addMessage(v).exchange(this.id);
    }
    const T = this.safeString(y, 7);
    T !== "success" && this.throwBroadlyMatchedException(this.exceptions.broad, T, T);
    const x = this.parseTransaction(y, r);
    return this.extend(x, {
      address: i
    });
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = await this.privatePostAuthRPositions(t);
    return this.parsePositions(i, e);
  }
  parsePosition(e, t = void 0) {
    const i = this.safeString(e, 0), s = this.safeString(e, 2), n = this.safeInteger(e, 12), r = this.safeString(e, 19), a = this.safeString(r, "trade_price"), o = this.safeString(r, "trade_amount");
    return this.safePosition({
      info: e,
      id: this.safeString(e, 11),
      symbol: this.safeSymbol(i, t),
      notional: this.parseNumber(s),
      marginMode: "isolated",
      liquidationPrice: this.safeNumber(e, 8),
      entryPrice: this.safeNumber(e, 3),
      unrealizedPnl: this.safeNumber(e, 6),
      percentage: this.safeNumber(e, 7),
      contracts: void 0,
      contractSize: void 0,
      markPrice: void 0,
      lastPrice: void 0,
      side: P.stringGt(s, "0") ? "long" : "short",
      hedged: void 0,
      timestamp: n,
      datetime: this.iso8601(n),
      lastUpdateTimestamp: this.safeInteger(e, 13),
      maintenanceMargin: this.safeNumber(e, 18),
      maintenanceMarginPercentage: void 0,
      collateral: this.safeNumber(e, 17),
      initialMargin: this.parseNumber(P.stringMul(o, a)),
      initialMarginPercentage: void 0,
      leverage: this.safeNumber(e, 9),
      marginRatio: void 0,
      stopLossPrice: void 0,
      takeProfitPrice: void 0
    });
  }
  nonce() {
    return this.milliseconds();
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    let a = "/" + this.implodeParams(e, s);
    const o = this.omit(s, this.extractParams(e));
    t === "v1" ? a = t + a : a = this.version + a;
    let c = this.urls.api[t] + "/" + a;
    if (t === "public" && Object.keys(o).length && (c += "?" + this.urlencode(o)), t === "private") {
      this.checkRequiredCredentials();
      const u = this.nonce().toString();
      r = this.json(o);
      const f = "/api/" + a + u + r;
      let h;
      this.externalSigner ? h = await this.externalSigner.sign({
        payload: this.encode(f),
        publicApiKey: this.apiKey,
        exchangeId: "bitfinex"
        // @todo replace by the id once migrated from ccxt to sdk exchange id
      }) : h = this.hmac(this.encode(f), this.encode(this.secret), wy), n = {
        "bfx-nonce": u,
        "bfx-apikey": this.apiKey,
        "bfx-signature": h,
        "Content-Type": "application/json"
      };
    }
    return { url: c, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (a !== void 0) {
      if (!Array.isArray(a)) {
        const u = this.safeString2(a, "message", "error"), f = this.id + " " + r;
        throw this.throwExactlyMatchedException(this.exceptions.exact, u, f), this.throwBroadlyMatchedException(this.exceptions.broad, u, f), new O().addMessage(r).exchange(this.id);
      }
    } else if (a === "")
      throw new O().addMessage("returned empty response").exchange(this.id);
    if (e === 429)
      throw new Ae().addMessage(r).exchange(this.id);
    if (e === 500) {
      const u = this.safeString(a, 1, ""), f = this.safeString(a, 2, ""), h = this.id + " " + f;
      throw this.throwBroadlyMatchedException(this.exceptions.broad, f, h), this.throwExactlyMatchedException(this.exceptions.exact, u, h), this.throwExactlyMatchedException(this.exceptions.exact, f, h), new O().addMessage(f + " (#" + u + ")").exchange(this.id);
    }
    return a;
  }
  parseLedgerEntryType(e) {
    if (e !== void 0)
      return e.indexOf("fee") >= 0 || e.indexOf("charged") >= 0 ? "fee" : e.indexOf("rebate") >= 0 ? "rebate" : e.indexOf("deposit") >= 0 || e.indexOf("withdrawal") >= 0 ? "transaction" : e.indexOf("transfer") >= 0 ? "transfer" : e.indexOf("payment") >= 0 ? "payout" : e.indexOf("exchange") >= 0 || e.indexOf("position") >= 0 ? "trade" : e;
  }
  parseLedgerEntry(e, t = void 0) {
    let i;
    const s = this.safeString(e, 0), n = this.safeString(e, 1), r = this.safeCurrencyCode(n, t), a = this.safeInteger(e, 3), o = this.safeNumber(e, 5), c = this.safeNumber(e, 6), u = this.safeString(e, 8);
    if (u !== void 0) {
      const f = u.split(" @ "), h = this.safeStringLower(f, 0);
      i = this.parseLedgerEntryType(h);
    }
    return {
      id: s,
      direction: void 0,
      account: void 0,
      referenceId: s,
      referenceAccount: void 0,
      type: i,
      currency: r,
      amount: o,
      timestamp: a,
      datetime: this.iso8601(a),
      before: void 0,
      after: c,
      status: void 0,
      fee: void 0,
      info: e
    };
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchLedger", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchLedger", e, t, i, s, 2500);
    let r, a = {};
    t !== void 0 && (a.start = t), i !== void 0 && (a.limit = i), [a, s] = this.handleUntilOption("end", a, s);
    let o;
    return e !== void 0 ? (r = this.currency(e), a.currency = r.uppercaseId, o = await this.privatePostAuthRLedgersCurrencyHist(this.extend(a, s))) : o = await this.privatePostAuthRLedgersHist(this.extend(a, s)), this.parseLedger(o, r, t, i);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t), c = {
      id: this.parseToNumeric(e)
    };
    if (n !== void 0) {
      let v = this.amountToPrecision(t, n);
      v = s === "buy" ? v : P.stringNeg(v), c.amount = v;
    }
    const u = this.safeString2(a, "stopPrice", "triggerPrice"), f = this.safeString(a, "trailingAmount"), h = this.safeString(a, "timeInForce"), l = this.safeBool(a, "postOnly", !1), p = this.safeBool(a, "reduceOnly", !1), m = this.safeInteger2(a, "cid", "clientOrderId");
    f !== void 0 ? c.price_trailing = f : u !== void 0 && (c.price = this.priceToPrecision(t, u), i === "limit" && (c.price_aux_limit = this.priceToPrecision(t, r)));
    const y = l || h === "PO";
    i !== "market" && u === void 0 && (c.price = this.priceToPrecision(t, r));
    let w = 0;
    y && (w = this.sum(w, 4096)), p && (w = this.sum(w, 1024)), w !== 0 && (c.flags = w), m !== void 0 && (c.cid = m);
    const S = this.safeInteger2(a, "leverage", "lev");
    S !== void 0 && (c.lev = S), a = this.omit(a, ["triggerPrice", "stopPrice", "timeInForce", "postOnly", "reduceOnly", "trailingAmount", "clientOrderId", "leverage"]);
    const b = await this.privatePostAuthWOrderUpdate(this.extend(c, a));
    if (this.safeString(b, 6) !== "SUCCESS") {
      const v = b[5], _ = b[7];
      throw new k().addMessage(b[6] + ": " + _ + " (#" + v + ")").exchange(this.id);
    }
    const x = this.safeList(b, 4, []);
    return this.parseOrder(x, o);
  }
}
let Uy = class extends gt {
};
class qy extends _t {
  constructor(e = ce.SUB_ACCOUNT_ERROR, t = ye.SUB_ACCOUNT_ERROR) {
    super(e, t), this.name = "SubAccountError";
  }
}
class ku extends qy {
  constructor(e) {
    super(ce.SUB_ACCOUNT_NOT_FOUND_ERROR, ye.SUB_ACCOUNT_NOT_FOUND_ERROR(e)), this.name = "SubAccountNotFoundError";
  }
}
class Gy extends Uy {
  constructor() {
    super(...arguments), this.USDT_FUTURES = "USDT-FUTURES", this.USDT_SETTLES = ["USDT"], this.USDC_FUTURES = "USDC-FUTURES", this.USDC_SETTLES = ["USDC"], this.SUSDT_FUTURES = "SUSDT-FUTURES", this.SUSDT_SETTLES = ["SUSDT"], this.SUSDC_FUTURES = "SUSDC-FUTURES", this.SUSDC_SETTLES = ["SUSDC"], this.COIN_FUTURES = "COIN-FUTURES", this.SCOIN_FUTURES = "SCOIN-FUTURES", this.SCOIN_SETTLES = ["SETH", "SBTC", "SEOS"];
  }
  describe() {
    return this.deepExtend(super.describe(), {
      id: "bitget",
      name: "Bitget",
      countries: ["SG"],
      version: "v2",
      rateLimit: 50,
      certified: !0,
      pro: !0,
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !0,
        option: !1,
        cancelAllOrders: !0,
        cancelOrder: !0,
        cancelOrders: !0,
        createDepositAddress: !1,
        createMarketBuyOrderWithCost: !0,
        createMarketOrderWithCost: !1,
        createMarketSellOrderWithCost: !1,
        createOrder: !0,
        createOrders: !0,
        createOrderWithTakeProfitAndStopLoss: !0,
        createTakeProfitOrder: !0,
        createTrailingAmountOrder: !1,
        createTrailingPercentOrder: !0,
        createTriggerOrder: !0,
        editOrder: !0,
        fetchAccounts: !1,
        fetchBalance: !0,
        fetchCanceledAndClosedOrders: !0,
        fetchCanceledOrders: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDeposit: !1,
        fetchDepositAddress: !0,
        fetchDepositAddresses: !1,
        fetchDeposits: !0,
        fetchDepositsWithdrawals: !1,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrderBooks: !1,
        fetchOrders: !1,
        fetchOrderTrades: !1,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchPositionsRisk: !1,
        fetchStatus: !1,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !0,
        fetchTransactions: !1,
        fetchTransfer: !1,
        fetchTransfers: !0,
        fetchWithdrawAddresses: !1,
        fetchWithdrawal: !1,
        fetchWithdrawals: !0,
        transfer: !0,
        withdraw: !0
      },
      timeframes: {
        "1m": "1m",
        "3m": "3m",
        "5m": "5m",
        "15m": "15m",
        "30m": "30m",
        "1h": "1h",
        "2h": "2h",
        "4h": "4h",
        "6h": "6h",
        "12h": "12h",
        "1d": "1d",
        "3d": "3d",
        "1w": "1w",
        "1M": "1m"
      },
      hostname: "bitget.com",
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/195989417-4253ddb0-afbe-4a1c-9dea-9dbcd121fa5d.jpg",
        api: {
          spot: "https://api.{hostname}",
          mix: "https://api.{hostname}",
          user: "https://api.{hostname}",
          p2p: "https://api.{hostname}",
          broker: "https://api.{hostname}",
          margin: "https://api.{hostname}",
          common: "https://api.{hostname}",
          tax: "https://api.{hostname}",
          convert: "https://api.{hostname}",
          copy: "https://api.{hostname}",
          earn: "https://api.{hostname}"
        },
        www: "https://www.bitget.com",
        doc: [
          "https://www.bitget.com/api-doc/common/intro",
          "https://www.bitget.com/api-doc/spot/intro",
          "https://www.bitget.com/api-doc/contract/intro",
          "https://www.bitget.com/api-doc/broker/intro",
          "https://www.bitget.com/api-doc/margin/intro",
          "https://www.bitget.com/api-doc/copytrading/intro",
          "https://www.bitget.com/api-doc/earn/intro",
          "https://bitgetlimited.github.io/apidoc/en/mix",
          "https://bitgetlimited.github.io/apidoc/en/spot",
          "https://bitgetlimited.github.io/apidoc/en/broker",
          "https://bitgetlimited.github.io/apidoc/en/margin"
        ],
        fees: "https://www.bitget.cc/zh-CN/rate?tab=1",
        // https://www.bitget.com/expressly?languageType=0&channelCode=ccxt&vipCode=tg9j - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
        referral: "https://www.bitget.com"
      },
      api: {
        public: {
          common: {
            get: {
              "v2/public/annoucements": 1,
              "v2/public/time": 1
            }
          },
          spot: {
            get: {
              "spot/v1/notice/queryAllNotices": 1,
              "spot/v1/public/time": 1,
              "spot/v1/public/currencies": 6.6667,
              "spot/v1/public/products": 1,
              "spot/v1/public/product": 1,
              "spot/v1/market/ticker": 1,
              "spot/v1/market/tickers": 1,
              "spot/v1/market/fills": 2,
              "spot/v1/market/fills-history": 2,
              "spot/v1/market/candles": 1,
              "spot/v1/market/depth": 1,
              "spot/v1/market/spot-vip-level": 2,
              "spot/v1/market/merge-depth": 1,
              "spot/v1/market/history-candles": 1,
              "spot/v1/public/loan/coinInfos": 2,
              "spot/v1/public/loan/hour-interest": 2,
              "v2/spot/public/coins": 6.6667,
              "v2/spot/public/symbols": 1,
              "v2/spot/market/vip-fee-rate": 2,
              "v2/spot/market/tickers": 1,
              "v2/spot/market/merge-depth": 1,
              "v2/spot/market/orderbook": 1,
              "v2/spot/market/candles": 1,
              "v2/spot/market/history-candles": 1,
              "v2/spot/market/fills": 2,
              "v2/spot/market/fills-history": 2
            }
          },
          mix: {
            get: {
              "mix/v1/market/contracts": 1,
              "mix/v1/market/depth": 1,
              "mix/v1/market/ticker": 1,
              "mix/v1/market/tickers": 1,
              "mix/v1/market/contract-vip-level": 2,
              "mix/v1/market/fills": 1,
              "mix/v1/market/fills-history": 2,
              "mix/v1/market/candles": 1,
              "mix/v1/market/index": 1,
              "mix/v1/market/funding-time": 1,
              "mix/v1/market/history-fundRate": 1,
              "mix/v1/market/current-fundRate": 1,
              "mix/v1/market/open-interest": 1,
              "mix/v1/market/mark-price": 1,
              "mix/v1/market/symbol-leverage": 1,
              "mix/v1/market/queryPositionLever": 1,
              "mix/v1/market/open-limit": 1,
              "mix/v1/market/history-candles": 1,
              "mix/v1/market/history-index-candles": 1,
              "mix/v1/market/history-mark-candles": 1,
              "mix/v1/market/merge-depth": 1,
              "v2/mix/market/vip-fee-rate": 2,
              "v2/mix/market/merge-depth": 1,
              "v2/mix/market/ticker": 1,
              "v2/mix/market/tickers": 1,
              "v2/mix/market/fills": 1,
              "v2/mix/market/fills-history": 2,
              "v2/mix/market/candles": 1,
              "v2/mix/market/history-candles": 1,
              "v2/mix/market/history-index-candles": 1,
              "v2/mix/market/history-mark-candles": 1,
              "v2/mix/market/open-interest": 1,
              "v2/mix/market/funding-time": 1,
              "v2/mix/market/symbol-price": 1,
              "v2/mix/market/history-fund-rate": 1,
              "v2/mix/market/current-fund-rate": 1,
              "v2/mix/market/contracts": 1,
              "v2/mix/market/query-position-lever": 2
            }
          },
          margin: {
            get: {
              "margin/v1/cross/public/interestRateAndLimit": 2,
              "margin/v1/isolated/public/interestRateAndLimit": 2,
              "margin/v1/cross/public/tierData": 2,
              "margin/v1/isolated/public/tierData": 2,
              "margin/v1/public/currencies": 1,
              "v2/margin/currencies": 2
            }
          },
          earn: {
            get: {
              "v2/earn/loan/public/coinInfos": 2,
              "v2/earn/loan/public/hour-interest": 2
            }
          }
        },
        private: {
          spot: {
            get: {
              "spot/v1/wallet/deposit-address": 4,
              "spot/v1/wallet/withdrawal-list": 1,
              "spot/v1/wallet/deposit-list": 1,
              "spot/v1/account/getInfo": 20,
              "spot/v1/account/assets": 2,
              "spot/v1/account/assets-lite": 2,
              "spot/v1/account/transferRecords": 1,
              "spot/v1/convert/currencies": 2,
              "spot/v1/convert/convert-record": 2,
              "spot/v1/loan/ongoing-orders": 2,
              "spot/v1/loan/repay-history": 2,
              "spot/v1/loan/revise-history": 2,
              "spot/v1/loan/borrow-history": 2,
              "spot/v1/loan/debts": 2,
              "v2/spot/trade/orderInfo": 1,
              "v2/spot/trade/unfilled-orders": 1,
              "v2/spot/trade/history-orders": 1,
              "v2/spot/trade/fills": 2,
              "v2/spot/trade/current-plan-order": 1,
              "v2/spot/trade/history-plan-order": 1,
              "v2/spot/account/info": 20,
              "v2/spot/account/assets": 2,
              "v2/spot/account/subaccount-assets": 2,
              "v2/spot/account/bills": 2,
              "v2/spot/account/transferRecords": 1,
              "v2/spot/wallet/deposit-address": 2,
              "v2/spot/wallet/deposit-records": 2,
              "v2/spot/wallet/withdrawal-records": 2
            },
            post: {
              "spot/v1/wallet/transfer": 4,
              "spot/v1/wallet/transfer-v2": 4,
              "spot/v1/wallet/subTransfer": 10,
              "spot/v1/wallet/withdrawal": 4,
              "spot/v1/wallet/withdrawal-v2": 4,
              "spot/v1/wallet/withdrawal-inner": 4,
              "spot/v1/wallet/withdrawal-inner-v2": 4,
              "spot/v1/account/sub-account-spot-assets": 200,
              "spot/v1/account/bills": 2,
              "spot/v1/trade/orders": 2,
              "spot/v1/trade/batch-orders": 4,
              "spot/v1/trade/cancel-order": 2,
              "spot/v1/trade/cancel-order-v2": 2,
              "spot/v1/trade/cancel-symbol-order": 2,
              "spot/v1/trade/cancel-batch-orders": 4,
              "spot/v1/trade/cancel-batch-orders-v2": 4,
              "spot/v1/trade/orderInfo": 1,
              "spot/v1/trade/open-orders": 1,
              "spot/v1/trade/history": 1,
              "spot/v1/trade/fills": 1,
              "spot/v1/plan/placePlan": 1,
              "spot/v1/plan/modifyPlan": 1,
              "spot/v1/plan/cancelPlan": 1,
              "spot/v1/plan/currentPlan": 1,
              "spot/v1/plan/historyPlan": 1,
              "spot/v1/plan/batchCancelPlan": 2,
              "spot/v1/convert/quoted-price": 4,
              "spot/v1/convert/trade": 4,
              "spot/v1/loan/borrow": 2,
              "spot/v1/loan/repay": 2,
              "spot/v1/loan/revise-pledge": 2,
              "spot/v1/trace/order/orderCurrentList": 2,
              "spot/v1/trace/order/orderHistoryList": 2,
              "spot/v1/trace/order/closeTrackingOrder": 2,
              "spot/v1/trace/order/updateTpsl": 2,
              "spot/v1/trace/order/followerEndOrder": 2,
              "spot/v1/trace/order/spotInfoList": 2,
              "spot/v1/trace/config/getTraderSettings": 2,
              "spot/v1/trace/config/getFollowerSettings": 2,
              "spot/v1/trace/user/myTraders": 2,
              "spot/v1/trace/config/setFollowerConfig": 2,
              "spot/v1/trace/user/myFollowers": 2,
              "spot/v1/trace/config/setProductCode": 2,
              "spot/v1/trace/user/removeTrader": 2,
              "spot/v1/trace/getRemovableFollower": 2,
              "spot/v1/trace/user/removeFollower": 2,
              "spot/v1/trace/profit/totalProfitInfo": 2,
              "spot/v1/trace/profit/totalProfitList": 2,
              "spot/v1/trace/profit/profitHisList": 2,
              "spot/v1/trace/profit/profitHisDetailList": 2,
              "spot/v1/trace/profit/waitProfitDetailList": 2,
              "spot/v1/trace/user/getTraderInfo": 2,
              "v2/spot/trade/place-order": 2,
              "v2/spot/trade/cancel-order": 2,
              "v2/spot/trade/batch-orders": 20,
              "v2/spot/trade/batch-cancel-order": 2,
              "v2/spot/trade/cancel-symbol-order": 4,
              "v2/spot/trade/place-plan-order": 1,
              "v2/spot/trade/modify-plan-order": 1,
              "v2/spot/trade/cancel-plan-order": 1,
              "v2/spot/trade/batch-cancel-plan-order": 2,
              "v2/spot/wallet/transfer": 2,
              "v2/spot/wallet/subaccount-transfer": 2,
              "v2/spot/wallet/withdrawal": 2
            }
          },
          mix: {
            get: {
              "mix/v1/account/account": 2,
              "mix/v1/account/accounts": 2,
              "mix/v1/position/singlePosition": 2,
              "mix/v1/position/singlePosition-v2": 2,
              "mix/v1/position/allPosition": 4,
              "mix/v1/position/allPosition-v2": 4,
              "mix/v1/position/history-position": 1,
              "mix/v1/account/accountBill": 2,
              "mix/v1/account/accountBusinessBill": 4,
              "mix/v1/order/current": 1,
              "mix/v1/order/marginCoinCurrent": 1,
              "mix/v1/order/history": 2,
              "mix/v1/order/historyProductType": 4,
              "mix/v1/order/detail": 2,
              "mix/v1/order/fills": 2,
              "mix/v1/order/allFills": 2,
              "mix/v1/plan/currentPlan": 1,
              "mix/v1/plan/historyPlan": 2,
              "mix/v1/trace/currentTrack": 2,
              "mix/v1/trace/followerOrder": 2,
              "mix/v1/trace/followerHistoryOrders": 2,
              "mix/v1/trace/historyTrack": 2,
              "mix/v1/trace/summary": 1,
              "mix/v1/trace/profitSettleTokenIdGroup": 1,
              "mix/v1/trace/profitDateGroupList": 1,
              "mix/v1/trade/profitDateList": 2,
              "mix/v1/trace/waitProfitDateList": 1,
              "mix/v1/trace/traderSymbols": 1,
              "mix/v1/trace/traderList": 2,
              "mix/v1/trace/traderDetail": 2,
              "mix/v1/trace/queryTraceConfig": 2,
              "v2/mix/account/account": 2,
              "v2/mix/account/accounts": 2,
              "v2/mix/account/sub-account-assets": 200,
              "v2/mix/account/open-count": 2,
              "v2/mix/account/bill": 2,
              "v2/mix/market/query-position-lever": 2,
              "v2/mix/position/single-position": 2,
              "v2/mix/position/all-position": 4,
              "v2/mix/position/history-position": 1,
              "v2/mix/order/detail": 2,
              "v2/mix/order/fills": 2,
              "v2/mix/order/fill-history": 2,
              "v2/mix/order/orders-pending": 2,
              "v2/mix/order/orders-history": 2,
              "v2/mix/order/orders-plan-pending": 2,
              "v2/mix/order/orders-plan-history": 2,
              "v2/account/funding-assets": 2
            },
            post: {
              "mix/v1/account/sub-account-contract-assets": 200,
              "mix/v1/account/open-count": 1,
              "mix/v1/account/setLeverage": 4,
              "mix/v1/account/setMargin": 4,
              "mix/v1/account/setMarginMode": 4,
              "mix/v1/account/setPositionMode": 4,
              "mix/v1/order/placeOrder": 2,
              "mix/v1/order/batch-orders": 2,
              "mix/v1/order/cancel-order": 2,
              "mix/v1/order/cancel-batch-orders": 2,
              "mix/v1/order/modifyOrder": 2,
              "mix/v1/order/cancel-symbol-orders": 2,
              "mix/v1/order/cancel-all-orders": 2,
              "mix/v1/order/close-all-positions": 20,
              "mix/v1/plan/placePlan": 2,
              "mix/v1/plan/modifyPlan": 2,
              "mix/v1/plan/modifyPlanPreset": 2,
              "mix/v1/plan/placeTPSL": 2,
              "mix/v1/plan/placeTrailStop": 2,
              "mix/v1/plan/placePositionsTPSL": 2,
              "mix/v1/plan/modifyTPSLPlan": 2,
              "mix/v1/plan/cancelPlan": 2,
              "mix/v1/plan/cancelSymbolPlan": 2,
              "mix/v1/plan/cancelAllPlan": 2,
              "mix/v1/trace/closeTrackOrder": 2,
              "mix/v1/trace/modifyTPSL": 2,
              "mix/v1/trace/closeTrackOrderBySymbol": 2,
              "mix/v1/trace/setUpCopySymbols": 2,
              "mix/v1/trace/followerSetBatchTraceConfig": 2,
              "mix/v1/trace/followerCloseByTrackingNo": 2,
              "mix/v1/trace/followerCloseByAll": 2,
              "mix/v1/trace/followerSetTpsl": 2,
              "mix/v1/trace/cancelCopyTrader": 4,
              "mix/v1/trace/traderUpdateConfig": 2,
              "mix/v1/trace/myTraderList": 2,
              "mix/v1/trace/myFollowerList": 2,
              "mix/v1/trace/removeFollower": 2,
              "mix/v1/trace/public/getFollowerConfig": 2,
              "mix/v1/trace/report/order/historyList": 2,
              "mix/v1/trace/report/order/currentList": 2,
              "mix/v1/trace/queryTraderTpslRatioConfig": 2,
              "mix/v1/trace/traderUpdateTpslRatioConfig": 2,
              "v2/mix/account/set-leverage": 4,
              "v2/mix/account/set-margin": 4,
              "v2/mix/account/set-margin-mode": 4,
              "v2/mix/account/set-position-mode": 4,
              "v2/mix/order/place-order": 20,
              "v2/mix/order/click-backhand": 20,
              "v2/mix/order/batch-place-order": 20,
              "v2/mix/order/modify-order": 2,
              "v2/mix/order/cancel-order": 2,
              "v2/mix/order/batch-cancel-orders": 2,
              "v2/mix/order/close-positions": 20,
              "v2/mix/order/place-tpsl-order": 2,
              "v2/mix/order/place-plan-order": 2,
              "v2/mix/order/modify-tpsl-order": 2,
              "v2/mix/order/modify-plan-order": 2,
              "v2/mix/order/cancel-plan-order": 2
            }
          },
          user: {
            get: {
              "user/v1/fee/query": 2,
              "user/v1/sub/virtual-list": 2,
              "user/v1/sub/virtual-api-list": 2,
              "user/v1/tax/spot-record": 1,
              "user/v1/tax/future-record": 1,
              "user/v1/tax/margin-record": 1,
              "user/v1/tax/p2p-record": 1,
              "v2/user/virtual-subaccount-list": 2,
              "v2/user/virtual-subaccount-apikey-list": 2
            },
            post: {
              "user/v1/sub/virtual-create": 4,
              "user/v1/sub/virtual-modify": 4,
              "user/v1/sub/virtual-api-batch-create": 20,
              "user/v1/sub/virtual-api-create": 4,
              "user/v1/sub/virtual-api-modify": 4,
              "v2/user/create-virtual-subaccount": 4,
              "v2/user/modify-virtual-subaccount": 4,
              "v2/user/batch-create-subaccount-and-apikey": 20,
              "v2/user/create-virtual-subaccount-apikey": 4,
              "v2/user/modify-virtual-subaccount-apikey": 4
            }
          },
          p2p: {
            get: {
              "p2p/v1/merchant/merchantList": 2,
              "p2p/v1/merchant/merchantInfo": 2,
              "p2p/v1/merchant/advList": 2,
              "p2p/v1/merchant/orderList": 2,
              "v2/p2p/merchantList": 2,
              "v2/p2p/merchantInfo": 2,
              "v2/p2p/orderList": 2,
              "v2/p2p/advList": 2
            }
          },
          broker: {
            get: {
              "broker/v1/account/info": 2,
              "broker/v1/account/sub-list": 20,
              "broker/v1/account/sub-email": 20,
              "broker/v1/account/sub-spot-assets": 2,
              "broker/v1/account/sub-future-assets": 2,
              "broker/v1/account/subaccount-transfer": 1,
              "broker/v1/account/subaccount-deposit": 1,
              "broker/v1/account/subaccount-withdrawal": 1,
              "broker/v1/account/sub-api-list": 2,
              "v2/broker/account/info": 2,
              "v2/broker/account/subaccount-list": 20,
              "v2/broker/account/subaccount-email": 2,
              "v2/broker/account/subaccount-spot-assets": 2,
              "v2/broker/account/subaccount-future-assets": 2,
              "v2/broker/manage/subaccount-apikey-list": 2
            },
            post: {
              "broker/v1/account/sub-create": 20,
              "broker/v1/account/sub-modify": 20,
              "broker/v1/account/sub-modify-email": 20,
              "broker/v1/account/sub-address": 2,
              "broker/v1/account/sub-withdrawal": 2,
              "broker/v1/account/sub-auto-transfer": 4,
              "broker/v1/account/sub-api-create": 2,
              "broker/v1/account/sub-api-modify": 2,
              "v2/broker/account/modify-subaccount-email": 2,
              "v2/broker/account/create-subaccount": 20,
              "v2/broker/account/modify-subaccount": 20,
              "v2/broker/account/subaccount-address": 2,
              "v2/broker/account/subaccount-withdrawal": 2,
              "v2/broker/account/set-subaccount-autotransfer": 2,
              "v2/broker/manage/create-subaccount-apikey": 2,
              "v2/broker/manage/modify-subaccount-apikey": 2
            }
          },
          margin: {
            get: {
              "margin/v1/cross/account/riskRate": 2,
              "margin/v1/cross/account/maxTransferOutAmount": 2,
              "margin/v1/isolated/account/maxTransferOutAmount": 2,
              "margin/v1/isolated/order/openOrders": 2,
              "margin/v1/isolated/order/history": 2,
              "margin/v1/isolated/order/fills": 2,
              "margin/v1/isolated/loan/list": 2,
              "margin/v1/isolated/repay/list": 2,
              "margin/v1/isolated/interest/list": 2,
              "margin/v1/isolated/liquidation/list": 2,
              "margin/v1/isolated/fin/list": 2,
              "margin/v1/cross/order/openOrders": 2,
              "margin/v1/cross/order/history": 2,
              "margin/v1/cross/order/fills": 2,
              "margin/v1/cross/loan/list": 2,
              "margin/v1/cross/repay/list": 2,
              "margin/v1/cross/interest/list": 2,
              "margin/v1/cross/liquidation/list": 2,
              "margin/v1/cross/fin/list": 2,
              "margin/v1/cross/account/assets": 2,
              "margin/v1/isolated/account/assets": 2,
              "v2/margin/crossed/borrow-history": 2,
              "v2/margin/crossed/repay-history": 2,
              "v2/margin/crossed/interest-history": 2,
              "v2/margin/crossed/liquidation-history": 2,
              "v2/margin/crossed/financial-records": 2,
              "v2/margin/crossed/account/assets": 2,
              "v2/margin/crossed/account/risk-rate": 2,
              "v2/margin/crossed/account/max-borrowable-amount": 2,
              "v2/margin/crossed/account/max-transfer-out-amount": 2,
              "v2/margin/crossed/interest-rate-and-limit": 2,
              "v2/margin/crossed/tier-data": 2,
              "v2/margin/crossed/open-orders": 2,
              "v2/margin/crossed/history-orders": 2,
              "v2/margin/crossed/fills": 2,
              "v2/margin/isolated/borrow-history": 2,
              "v2/margin/isolated/repay-history": 2,
              "v2/margin/isolated/interest-history": 2,
              "v2/margin/isolated/liquidation-history": 2,
              "v2/margin/isolated/financial-records": 2,
              "v2/margin/isolated/account/assets": 2,
              "v2/margin/isolated/account/risk-rate": 2,
              "v2/margin/isolated/account/max-borrowable-amount": 2,
              "v2/margin/isolated/account/max-transfer-out-amount": 2,
              "v2/margin/isolated/interest-rate-and-limit": 2,
              "v2/margin/isolated/tier-data": 2,
              "v2/margin/isolated/open-orders": 2,
              "v2/margin/isolated/history-orders": 2,
              "v2/margin/isolated/fills": 2
            },
            post: {
              "margin/v1/cross/account/borrow": 2,
              "margin/v1/isolated/account/borrow": 2,
              "margin/v1/cross/account/repay": 2,
              "margin/v1/isolated/account/repay": 2,
              "margin/v1/isolated/account/riskRate": 2,
              "margin/v1/cross/account/maxBorrowableAmount": 2,
              "margin/v1/isolated/account/maxBorrowableAmount": 2,
              "margin/v1/isolated/account/flashRepay": 2,
              "margin/v1/isolated/account/queryFlashRepayStatus": 2,
              "margin/v1/cross/account/flashRepay": 2,
              "margin/v1/cross/account/queryFlashRepayStatus": 2,
              "margin/v1/isolated/order/placeOrder": 4,
              "margin/v1/isolated/order/batchPlaceOrder": 4,
              "margin/v1/isolated/order/cancelOrder": 2,
              "margin/v1/isolated/order/batchCancelOrder": 2,
              "margin/v1/cross/order/placeOrder": 2,
              "margin/v1/cross/order/batchPlaceOrder": 2,
              "margin/v1/cross/order/cancelOrder": 2,
              "margin/v1/cross/order/batchCancelOrder": 2,
              "v2/margin/crossed/account/borrow": 2,
              "v2/margin/crossed/account/repay": 2,
              "v2/margin/crossed/account/flash-repay": 2,
              "v2/margin/crossed/account/query-flash-repay-status": 2,
              "v2/margin/crossed/place-order": 2,
              "v2/margin/crossed/batch-place-order": 2,
              "v2/margin/crossed/cancel-order": 2,
              "v2/margin/crossed/batch-cancel-order": 2,
              "v2/margin/isolated/account/borrow": 2,
              "v2/margin/isolated/account/repay": 2,
              "v2/margin/isolated/account/flash-repay": 2,
              "v2/margin/isolated/account/query-flash-repay-status": 2,
              "v2/margin/isolated/place-order": 2,
              "v2/margin/isolated/batch-place-order": 2,
              "v2/margin/isolated/cancel-order": 2,
              "v2/margin/isolated/batch-cancel-order": 2
            }
          },
          copy: {
            get: {
              "v2/copy/mix-trader/order-current-track": 2,
              "v2/copy/mix-trader/order-history-track": 2,
              "v2/copy/mix-trader/order-total-detail": 2,
              "v2/copy/mix-trader/profit-history-summarys": 1,
              "v2/copy/mix-trader/profit-history-details": 1,
              "v2/copy/mix-trader/profit-details": 1,
              "v2/copy/mix-trader/profits-group-coin-date": 1,
              "v2/copy/mix-trader/config-query-symbols": 1,
              "v2/copy/mix-trader/config-query-followers": 2,
              "v2/copy/mix-follower/query-current-orders": 2,
              "v2/copy/mix-follower/query-history-orders": 1,
              "v2/copy/mix-follower/query-settings": 2,
              "v2/copy/mix-follower/query-traders": 2,
              "v2/copy/mix-follower/query-quantity-limit": 2,
              "v2/copy/mix-broker/query-traders": 2,
              "v2/copy/mix-broker/query-history-traces": 2,
              "v2/copy/mix-broker/query-current-traces": 2,
              "v2/copy/spot-trader/profit-summarys": 2,
              "v2/copy/spot-trader/profit-history-details": 2,
              "v2/copy/spot-trader/profit-details": 2,
              "v2/copy/spot-trader/order-total-detail": 2,
              "v2/copy/spot-trader/order-history-track": 2,
              "v2/copy/spot-trader/order-current-track": 2,
              "v2/copy/spot-trader/config-query-settings": 2,
              "v2/copy/spot-trader/config-query-followers": 2,
              "v2/copy/spot-follower/query-traders": 2,
              "v2/copy/spot-follower/query-trader-symbols": 2,
              "v2/copy/spot-follower/query-settings": 2,
              "v2/copy/spot-follower/query-history-orders": 2,
              "v2/copy/spot-follower/query-current-orders": 2
            },
            post: {
              "v2/copy/mix-trader/order-modify-tpsl": 2,
              "v2/copy/mix-trader/order-close-positions": 2,
              "v2/copy/mix-trader/config-setting-symbols": 2,
              "v2/copy/mix-trader/config-setting-base": 2,
              "v2/copy/mix-trader/config-remove-follower": 2,
              "v2/copy/mix-follower/setting-tpsl": 1,
              "v2/copy/mix-follower/settings": 2,
              "v2/copy/mix-follower/close-positions": 2,
              "v2/copy/mix-follower/cancel-trader": 4,
              "v2/copy/spot-trader/order-modify-tpsl": 2,
              "v2/copy/spot-trader/order-close-tracking": 2,
              "v2/copy/spot-trader/config-setting-symbols": 2,
              "v2/copy/spot-trader/config-remove-follower": 2,
              "v2/copy/spot-follower/stop-order": 2,
              "v2/copy/spot-follower/settings": 2,
              "v2/copy/spot-follower/setting-tpsl": 2,
              "v2/copy/spot-follower/order-close-tracking": 2,
              "v2/copy/spot-follower/cancel-trader": 2
            }
          },
          tax: {
            get: {
              "v2/tax/spot-record": 20,
              "v2/tax/future-record": 20,
              "v2/tax/margin-record": 20,
              "v2/tax/p2p-record": 20
            }
          },
          convert: {
            get: {
              "v2/convert/currencies": 2,
              "v2/convert/quoted-price": 2,
              "v2/convert/convert-record": 2
            },
            post: {
              "v2/convert/trade": 2
            }
          },
          earn: {
            get: {
              "v2/earn/savings/product": 2,
              "v2/earn/savings/account": 2,
              "v2/earn/savings/assets": 2,
              "v2/earn/savings/records": 2,
              "v2/earn/savings/subscribe-info": 2,
              "v2/earn/savings/subscribe-result": 2,
              "v2/earn/savings/redeem-result": 2,
              "v2/earn/sharkfin/product": 2,
              "v2/earn/sharkfin/account": 2,
              "v2/earn/sharkfin/assets": 2,
              "v2/earn/sharkfin/records": 2,
              "v2/earn/sharkfin/subscribe-info": 2,
              "v2/earn/sharkfin/subscribe-result": 4,
              "v2/earn/loan/ongoing-orders": 2,
              "v2/earn/loan/repay-history": 2,
              "v2/earn/loan/revise-history": 2,
              "v2/earn/loan/borrow-history": 2,
              "v2/earn/loan/debts": 2,
              "v2/earn/loan/reduces": 2,
              "v2/earn/account/assets": 2
            },
            post: {
              "v2/earn/savings/subscribe": 2,
              "v2/earn/savings/redeem": 2,
              "v2/earn/sharkfin/subscribe": 2,
              "v2/earn/loan/borrow": 2,
              "v2/earn/loan/repay": 2,
              "v2/earn/loan/revise-pledge": 2
            }
          },
          common: {
            get: {
              "v2/common/trade-rate": 2
            }
          }
        }
      },
      fees: {
        spot: {
          taker: this.parseNumber("0.002"),
          maker: this.parseNumber("0.002")
        },
        swap: {
          taker: this.parseNumber("0.0006"),
          maker: this.parseNumber("0.0004")
        }
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0,
        password: !0
      },
      exceptions: {
        // http error codes
        // 400 Bad Request — Invalid request format
        // 401 Unauthorized — Invalid API Key
        // 403 Forbidden — You do not have access to the requested resource
        // 404 Not Found
        // 500 Internal Server Error — We had a problem with our server
        exact: {
          1: be,
          // undocumented
          "failure to get a peer from the ring-balancer": Te,
          4010: ee,
          // common
          // '0': ExchangeError, // 200 successful,when the order placement / cancellation / operation is successful
          4001: be,
          4002: be,
          // --------------------------------------------------------
          30001: Z,
          30002: Z,
          30003: Z,
          30004: Z,
          30005: ze,
          30006: Z,
          30007: be,
          30008: Nt,
          30009: be,
          30010: Z,
          30011: ee,
          30012: Z,
          30013: Z,
          30014: Rt,
          30015: Z,
          30016: ee,
          30017: Z,
          30018: Z,
          30019: Te,
          30020: be,
          30021: be,
          30022: ee,
          30023: g,
          30024: g,
          30025: g,
          30026: Rt,
          30027: Z,
          30028: ee,
          30029: Ee,
          30030: be,
          30031: $e,
          30032: it,
          30033: be,
          30034: be,
          30035: be,
          30036: be,
          30037: Te,
          // '30038': AuthenticationError, // { "code": 30038, "message": "user does not exist" }
          30038: dt,
          // futures
          32001: Ee,
          32002: ee,
          32003: k,
          32004: k,
          32005: g,
          32006: g,
          32007: g,
          32008: k,
          32009: k,
          32010: k,
          32011: k,
          32012: k,
          32013: k,
          32014: k,
          32015: k,
          32016: k,
          32017: k,
          32018: g,
          32019: g,
          32020: g,
          32021: k,
          32022: pe,
          32023: be,
          32024: k,
          32025: k,
          32026: ee,
          32027: k,
          32028: Ee,
          32029: k,
          32030: k,
          32031: g,
          32038: Z,
          32040: O,
          32044: k,
          32045: O,
          32046: k,
          32047: be,
          32048: k,
          32049: O,
          32050: k,
          32051: k,
          32052: O,
          32053: O,
          32057: O,
          32054: O,
          32055: k,
          32056: O,
          32058: O,
          32059: k,
          32060: g,
          32061: g,
          32062: g,
          32063: g,
          32064: O,
          32065: O,
          32066: O,
          32067: O,
          32068: O,
          32069: O,
          32070: O,
          32071: O,
          32072: O,
          32073: O,
          32074: O,
          32075: O,
          32076: O,
          32077: O,
          32078: O,
          32079: O,
          32080: O,
          32083: O,
          // token and margin trading
          33001: ee,
          33002: Ee,
          33003: re,
          33004: O,
          33005: O,
          33006: O,
          33007: O,
          33008: re,
          33009: O,
          33010: O,
          33011: O,
          33012: O,
          33013: k,
          33014: Se,
          33015: k,
          33016: O,
          33017: re,
          33018: O,
          33020: O,
          33021: k,
          33022: k,
          33023: O,
          33024: g,
          33025: g,
          33026: O,
          33027: k,
          33028: g,
          33029: g,
          33034: O,
          33035: O,
          33036: O,
          33037: O,
          33038: O,
          33039: O,
          33040: O,
          33041: O,
          33042: O,
          33043: O,
          33044: O,
          33045: O,
          33046: O,
          33047: O,
          33048: O,
          33049: O,
          33050: O,
          33051: O,
          33059: g,
          33060: g,
          33061: O,
          33062: O,
          33063: O,
          33064: O,
          33065: O,
          // account
          21009: O,
          34001: ee,
          34002: et,
          34003: ke,
          34004: ke,
          34005: ke,
          34006: Xt,
          34007: ws,
          34008: re,
          34009: ke,
          34010: je,
          34011: O,
          34012: ke,
          34013: je,
          34014: je,
          34015: O,
          34016: ee,
          34017: Ee,
          34018: Z,
          34019: ee,
          34020: ee,
          34021: et,
          34022: O,
          34023: ee,
          34026: O,
          34036: O,
          34037: O,
          34038: O,
          34039: O,
          // swap
          35001: O,
          35002: O,
          35003: O,
          35004: O,
          35005: Z,
          35008: g,
          35010: g,
          35012: g,
          35014: g,
          35015: g,
          35017: O,
          35019: g,
          35020: g,
          35021: g,
          35022: O,
          35024: O,
          35025: re,
          35026: O,
          35029: Se,
          35030: g,
          35031: g,
          35032: O,
          35037: O,
          35039: O,
          35040: g,
          35044: O,
          35046: re,
          35047: re,
          35048: O,
          35049: g,
          35050: g,
          35052: re,
          35053: O,
          35055: re,
          35057: O,
          35058: O,
          35059: g,
          35060: g,
          35061: g,
          35062: g,
          35063: g,
          35064: g,
          35066: k,
          35067: k,
          35068: k,
          35069: k,
          35070: k,
          35071: g,
          35072: k,
          35073: k,
          35074: k,
          35075: k,
          35076: k,
          35077: k,
          35078: g,
          35079: k,
          35080: k,
          35081: k,
          35082: k,
          35083: k,
          35084: g,
          35085: g,
          35086: g,
          35087: g,
          35088: g,
          35089: g,
          35090: O,
          35091: O,
          35092: O,
          35093: O,
          35094: O,
          35095: O,
          35096: O,
          35097: O,
          35098: O,
          35099: O,
          // option
          36001: O,
          36002: O,
          36005: O,
          36101: Z,
          36102: ee,
          36103: Ee,
          36104: ee,
          36105: ee,
          36106: Ee,
          36107: ee,
          36108: re,
          36109: ee,
          36201: ee,
          36202: ee,
          36203: g,
          36204: O,
          36205: O,
          36206: g,
          36207: g,
          36208: g,
          36209: g,
          36210: g,
          36211: k,
          36212: k,
          36213: k,
          36214: O,
          36216: Se,
          36217: k,
          36218: k,
          36219: k,
          36220: k,
          36221: g,
          36222: g,
          36223: g,
          36224: g,
          36225: k,
          36226: k,
          36227: k,
          36228: k,
          36229: k,
          36230: k,
          // --------------------------------------------------------
          // swap
          400: O,
          401: Z,
          403: ee,
          404: be,
          405: be,
          415: be,
          429: Rt,
          500: Te,
          1001: Ae,
          1002: O,
          1003: O,
          // '00000': ExchangeError, // success
          40001: Z,
          40002: Z,
          40003: Z,
          40004: ze,
          40005: ze,
          40006: Z,
          40007: be,
          40008: ze,
          40009: Z,
          40010: Z,
          40011: Z,
          40012: Z,
          40013: O,
          40014: ee,
          40015: O,
          40016: ee,
          40017: O,
          40018: ee,
          40019: O,
          40031: Ee,
          40037: Pt,
          40102: O,
          40103: O,
          40104: O,
          40105: O,
          40106: O,
          40107: O,
          40108: g,
          40109: Se,
          40200: dt,
          40201: g,
          40202: O,
          40203: g,
          40204: g,
          40205: g,
          40206: g,
          40207: g,
          40208: g,
          40209: g,
          40300: O,
          40301: ee,
          40302: g,
          40303: O,
          40304: g,
          40305: g,
          40306: O,
          40308: dt,
          40309: O,
          40400: O,
          40401: O,
          40402: g,
          40403: g,
          40404: g,
          40405: g,
          40406: g,
          40407: O,
          40408: O,
          40409: O,
          40500: g,
          40501: O,
          40502: O,
          40503: O,
          40504: O,
          40505: O,
          40506: Z,
          40507: Z,
          40508: O,
          40509: O,
          40600: O,
          40601: O,
          40602: O,
          40603: O,
          40604: Te,
          40605: O,
          40606: O,
          40607: O,
          40608: O,
          40609: O,
          40700: g,
          40701: O,
          40702: O,
          40703: O,
          40704: O,
          40705: g,
          40706: g,
          40707: g,
          40708: g,
          40709: O,
          40710: O,
          40711: re,
          40712: re,
          40713: O,
          40714: O,
          40768: Se,
          41114: dt,
          43011: g,
          43025: k,
          43115: dt,
          45110: g,
          // spot
          "invalid sign": Z,
          "invalid currency": g,
          "invalid symbol": g,
          "invalid period": g,
          "invalid user": O,
          "invalid amount": g,
          "invalid type": g,
          "invalid orderId": g,
          "invalid record": O,
          "invalid accountId": g,
          "invalid address": et,
          "accesskey not null": Z,
          "illegal accesskey": Z,
          "sign not null": Z,
          "req_time is too much difference from server time": ze,
          "permissions not right": ee,
          "illegal sign invalid": Z,
          "user locked": Ee,
          "Request Frequency Is Too High": Ae,
          "more than a daily rate of cash": O,
          "more than the maximum daily withdrawal amount": ke,
          "need to bind email or mobile": O,
          "user forbid": ee,
          "User Prohibited Cash Withdrawal": ee,
          "Cash Withdrawal Is Less Than The Minimum Value": Xt,
          "Cash Withdrawal Is More Than The Maximum Value": ws,
          "the account with in 24 hours ban coin": ee,
          "order cancel fail": k,
          "base symbol error": g,
          "base date error": O,
          "api signature not valid": Z,
          "gateway internal error": O,
          "audit failed": O,
          "order queryorder invalid": k,
          "market no need price": g,
          "limit need price": g,
          "userid not equal to account_id": O,
          "your balance is low": re,
          "address invalid cointype": O,
          "system exception": O,
          50003: O,
          50004: pt,
          50006: ee,
          50007: ee,
          50008: Nt,
          50009: Ae,
          50010: O,
          50014: g,
          50015: g,
          50016: g,
          50017: g,
          50018: g,
          50019: g,
          50020: re,
          50021: g,
          50026: g,
          "invalid order query time": O,
          "invalid start time": g,
          "invalid end time": g,
          20003: O,
          "01001": O,
          43111: gi,
          43114: Xt
          //  43114: Withdrawal is less than the minimum withdrawal count less than min withdraw amount
        },
        broad: {
          "invalid size, valid range": O
        },
        messages: {
          "less than the minimum amount": ye.ORDER_UNDER_MINIMUM
        }
      },
      precisionMode: ct,
      options: {
        timeDifference: 0,
        timeframes: {
          spot: {
            "1m": "1min",
            "5m": "5min",
            "15m": "15min",
            "30m": "30min",
            "1h": "1h",
            "4h": "4h",
            "6h": "6Hutc",
            "12h": "12Hutc",
            "1d": "1Dutc",
            "3d": "3Dutc",
            "1w": "1Wutc",
            "1M": "1Mutc"
          },
          swap: {
            "1m": "1m",
            "3m": "3m",
            "5m": "5m",
            "15m": "15m",
            "30m": "30m",
            "1h": "1H",
            "2h": "2H",
            "4h": "4H",
            "6h": "6Hutc",
            "12h": "12Hutc",
            "1d": "1Dutc",
            "3d": "3Dutc",
            "1w": "1Wutc",
            "1M": "1Mutc"
          }
        },
        fetchMarkets: [
          "spot",
          "swap"
          // there is future markets but they use the same endpoints as swap
        ],
        defaultType: "spot",
        defaultSubType: "linear",
        createMarketBuyOrderRequiresPrice: !0,
        broker: "gdlc3",
        withdraw: {
          fillResponseFromRequest: !0
        },
        fetchOHLCV: {
          spot: {
            method: "publicSpotGetV2SpotMarketCandles"
            // or publicSpotGetV2SpotMarketHistoryCandles
          },
          swap: {
            method: "publicMixGetV2MixMarketCandles"
            // or publicMixGetV2MixMarketHistoryCandles or publicMixGetV2MixMarketHistoryIndexCandles or publicMixGetV2MixMarketHistoryMarkCandles
          }
        },
        fetchTrades: {
          spot: {
            method: "publicSpotGetV2SpotMarketFillsHistory"
            // or publicSpotGetV2SpotMarketFills
          },
          swap: {
            method: "publicMixGetV2MixMarketFillsHistory"
            // or publicMixGetV2MixMarketFills
          }
        },
        accountsByType: {
          spot: "spot",
          cross: "crossed_margin",
          isolated: "isolated_margin",
          swap: "usdt_futures",
          usdc_swap: "usdc_futures",
          future: "coin_futures",
          p2p: "p2p"
        },
        accountsById: {
          spot: "spot",
          crossed_margin: "cross",
          isolated_margin: "isolated",
          usdt_futures: "swap",
          usdc_futures: "usdc_swap",
          coin_futures: "future",
          p2p: "p2p"
        },
        sandboxMode: !1,
        // network codes indexed by network IDs
        networksById: {
          TRC20: "TRX",
          TRC10: "TRX",
          ERC20: "ETH",
          BRC20: "BTC",
          BEP20: "BSC",
          POLYGON: "Polygon"
        },
        fetchPositions: {
          method: "privateMixGetV2MixPositionAllPosition"
          // or privateMixGetV2MixPositionHistoryPosition
        },
        defaultTimeInForce: "GTC"
        // 'GTC' = Good To Cancel (default), 'IOC' = Immediate Or Cancel
      }
    });
  }
  isUsingForcedProxy(e = {}, t = "public") {
    return t[0] === "private";
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  convertSymbolForSandbox(e) {
    if (e.startsWith("S"))
      return e;
    let t;
    if (e.indexOf("/") > -1) {
      if (e.indexOf(":") === -1)
        throw new ge("unkwnown").overwriteMessage("Sandbox supports swap and future markets only").exchange(this.id);
      const i = e.split("/"), s = this.safeString(i, 0), r = this.safeString(i, 1).split(":"), a = this.safeString(r, 0), c = this.safeString(r, 1).split("-"), u = this.safeString(c, 0), f = this.safeString(c, 1);
      t = "S" + s + "/S" + a + ":S" + u, f !== void 0 && (t = t + "-" + f);
    } else {
      const i = e.slice(0, 3), s = e.slice(3);
      t = "S" + i + "S" + s;
    }
    return t;
  }
  async fetchStatus(e = {}) {
    const t = await this.publicCommonGetV2PublicTime(e), i = this.safeValue(t, "data", {}), n = this.safeString(t, "code") === "00000" ? "ok" : "maintenance", r = this.safeInteger(i, "serverTime");
    return {
      status: n,
      updated: r,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  handleProductTypeAndParams(e = void 0, t = {}) {
    let i;
    [i, t] = this.handleSubTypeAndParams("handleProductTypeAndParams", void 0, t);
    let s;
    i !== void 0 && e === void 0 && (this.safeValue(this.options, "sandboxMode", !1) ? s = i === "linear" ? this.SUSDT_FUTURES : this.SCOIN_FUTURES : s = i === "linear" ? this.USDT_FUTURES : this.COIN_FUTURES);
    let n = this.safeString(t, "productType", s);
    if (n === void 0 && e !== void 0) {
      const r = e.settle;
      this.USDT_SETTLES.includes(r) ? n = this.USDT_FUTURES : this.USDC_SETTLES.includes(r) ? n = this.USDC_FUTURES : this.SUSDT_SETTLES.includes(r) ? n = this.SUSDT_FUTURES : this.SUSDC_SETTLES.includes(r) ? n = this.SUSDC_FUTURES : this.SCOIN_FUTURES.includes(r) ? n = this.SCOIN_FUTURES : n = this.COIN_FUTURES;
    }
    if (n === void 0)
      throw new g('Requires a productType param, one of "USDT-FUTURES", "USDC-FUTURES", "COIN-FUTURES", "SUSDT-FUTURES", "SUSDC-FUTURES" or "SCOIN-FUTURES"').exchange(this.id);
    return t = this.omit(t, "productType"), [n, t];
  }
  async fetchTime(e = {}) {
    const t = await this.publicCommonGetV2PublicTime(e), i = this.safeValue(t, "data", {});
    return this.safeInteger(i, "serverTime");
  }
  getFutureMarginCoin(e) {
    if (e === this.COIN_FUTURES) {
      const t = [...this.SCOIN_SETTLES, ...this.USDT_SETTLES, ...this.USDC_SETTLES, ...this.SUSDT_SETTLES, ...this.SUSDC_SETTLES];
      return [...new Set(Object.values(this.markets).map((i) => i.settle).filter((i) => i !== void 0 && !t.includes(i)))];
    } else {
      if (e === this.SCOIN_FUTURES)
        return this.SCOIN_SETTLES;
      if (e === this.USDC_FUTURES)
        return this.USDC_SETTLES;
      if (e === this.USDT_FUTURES)
        return this.USDT_SETTLES;
      if (e === this.SUSDT_FUTURES)
        return this.SUSDT_SETTLES;
      if (e === this.SUSDC_FUTURES)
        return this.SUSDC_SETTLES;
    }
    throw new g('Invalid productType, one of "USDT-FUTURES", "USDC-FUTURES", "COIN-FUTURES", "SUSDT-FUTURES", "SUSDC-FUTURES" or "SCOIN-FUTURES"');
  }
  async fetchMarkets(e = {}) {
    const t = this.safeValue(this.options, "sandboxMode", !1);
    let i = this.safeValue(this.options, "fetchMarkets", ["spot", "swap"]);
    t && (i = ["swap"]);
    let s = [];
    for (let r = 0; r < i.length; r++) {
      const a = i[r];
      if (a === "swap") {
        let o;
        t ? o = [this.SUSDT_FUTURES, this.SCOIN_FUTURES, this.SUSDC_FUTURES] : o = [this.USDT_FUTURES, this.COIN_FUTURES, this.USDC_FUTURES];
        for (let c = 0; c < o.length; c++)
          s.push(this.fetchMarketsByType(a, this.extend(e, {
            productType: o[c]
          })));
      } else
        s.push(this.fetchMarketsByType(i[r], e));
    }
    s = await Promise.all(s);
    let n = s[0];
    for (let r = 1; r < s.length; r++)
      n = this.arrayConcat(n, s[r]);
    return n;
  }
  parseMarket(e) {
    const t = this.safeString(e, "symbol"), i = this.safeString(e, "quoteCoin"), s = this.safeString(e, "baseCoin"), n = this.safeCurrencyCode(i), r = this.safeCurrencyCode(s), a = this.safeValue(e, "supportMarginCoins", []);
    let o;
    this.inArray(s, a) ? o = s : this.inArray(i, a) ? o = i : o = this.safeString(a, 0);
    const c = this.safeCurrencyCode(o);
    let u = r + "/" + n, f, h = !1, l = !1, p = !1, m = !1, y, w, S, b, T, x;
    const v = this.safeString(e, "symbolType");
    if (v === void 0)
      f = "spot", l = !0, y = this.parseNumber(this.parsePrecision(this.safeString(e, "pricePrecision"))), w = this.parseNumber(this.parsePrecision(this.safeString(e, "quantityPrecision")));
    else {
      if (v === "perpetual")
        f = "swap", h = !0, u = u + ":" + c;
      else if (v === "delivery") {
        T = this.safeInteger(e, "deliveryTime"), x = this.iso8601(T);
        const L = x.split("-"), z = this.safeString(L, 0), K = this.safeString(L, 2), R = z.slice(2, 4), U = this.safeString(L, 1), Y = K.slice(0, 2), J = R + U + Y;
        f = "future", p = !0, u = u + ":" + c + "-" + J;
      }
      m = !0, b = r === c, S = !b;
      const W = this.safeInteger(e, "pricePlace"), B = this.safeInteger(e, "volumePlace"), Q = this.safeString(e, "priceEndStep"), se = this.safeString(e, "minTradeNum"), $ = new P(Q);
      $.decimals = Math.max($.decimals, W), $.reduce();
      const te = $.toString();
      y = this.parseNumber(te);
      const E = new P(se);
      E.decimals = Math.max(E.decimals, B), E.reduce();
      const N = E.toString();
      w = this.parseNumber(N);
    }
    const _ = this.safeString2(e, "status", "symbolStatus");
    let V;
    _ !== void 0 && (V = _ === "online" || _ === "normal");
    let j;
    n === "USDT" && (j = this.safeNumber(e, "minTradeUSDT"));
    const G = m ? 1 : void 0;
    return {
      id: t,
      symbol: u,
      base: r,
      quote: n,
      settle: c,
      baseId: s,
      quoteId: i,
      settleId: o,
      type: f,
      spot: l,
      margin: void 0,
      swap: h,
      future: p,
      option: !1,
      active: V,
      contract: m,
      linear: S,
      inverse: b,
      taker: this.safeNumber(e, "takerFeeRate"),
      maker: this.safeNumber(e, "makerFeeRate"),
      contractSize: G,
      expiry: T,
      expiryDatetime: x,
      strike: void 0,
      optionType: void 0,
      precision: {
        amount: w,
        price: y
      },
      limits: {
        leverage: {
          min: this.safeNumber(e, "minLever"),
          max: this.safeNumber(e, "maxLever")
        },
        amount: {
          min: this.safeNumber2(e, "minTradeNum", "minTradeAmount"),
          max: this.safeNumber(e, "maxTradeAmount")
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: j,
          max: void 0
        }
      },
      created: this.safeInteger(e, "launchTime"),
      info: e
    };
  }
  async fetchMarketsByType(e, t = {}) {
    let i;
    if (e === "spot")
      i = await this.publicSpotGetV2SpotPublicSymbols(t);
    else if (e === "swap" || e === "future")
      i = await this.publicMixGetV2MixMarketContracts(t);
    else
      throw new ge(e).exchange(this.id);
    const s = this.safeValue(i, "data", []);
    return this.parseMarkets(s);
  }
  networkCodeToId(e, t) {
    const i = this.safeValue(this.options, "networkIdsByCurrencyAndNetworkCodes", {}), s = this.safeValue(i, t, {});
    return this.safeString(s, e);
  }
  async fetchCurrencies(e = {}) {
    const t = await this.publicSpotGetV2SpotPublicCoins(e), i = {}, s = this.safeValue(t, "data", []);
    this.options.networkIdsByCurrencyAndNetworkCodes = {};
    for (let n = 0; n < s.length; n++) {
      const r = s[n], a = this.safeString(r, "coinId"), o = this.safeCurrencyCode(this.safeString(r, "coin"));
      this.options.networkIdsByCurrencyAndNetworkCodes[o] = {};
      const c = this.safeValue(r, "chains", []), u = {};
      let f = !1, h = !1, l, p, m;
      for (let y = 0; y < c.length; y++) {
        const w = c[y], S = this.safeString(w, "chain"), b = this.networkIdToCode(S, o), x = this.safeString(w, "withdrawable") === "true", _ = this.safeString(w, "rechargeable") === "true";
        f = _ || f, h = x || h;
        const V = this.safeString(w, "withdrawFee");
        V !== void 0 && (m = m === void 0 ? V : P.stringMin(V, m));
        const j = this.safeString(w, "minWithdrawAmount");
        j !== void 0 && (l = l === void 0 ? j : P.stringMin(j, l));
        const G = this.safeString(w, "minDepositAmount");
        G !== void 0 && (p = p === void 0 ? G : P.stringMin(G, p)), this.options.networkIdsByCurrencyAndNetworkCodes[o][b] = S, u[b] = {
          info: w,
          id: S,
          network: b,
          limits: {
            withdraw: {
              min: this.parseNumber(j),
              max: void 0
            },
            deposit: {
              min: this.parseNumber(G),
              max: void 0
            }
          },
          active: x && _,
          withdraw: x,
          deposit: _,
          fee: this.parseNumber(V),
          precision: this.safeNumber(w, "withdrawMinScale", 8)
        };
      }
      i[o] = {
        info: r,
        id: a,
        code: o,
        networks: u,
        type: void 0,
        name: void 0,
        active: f && h,
        deposit: f,
        withdraw: h,
        fee: this.parseNumber(m),
        precision: void 0,
        limits: {
          amount: {
            min: void 0,
            max: void 0
          },
          withdraw: {
            min: this.parseNumber(l),
            max: void 0
          },
          deposit: {
            min: this.parseNumber(p),
            max: void 0
          }
        },
        created: void 0
      };
    }
    return await this.cache.set({
      key: dd(this.id),
      data: this.options.networkIdsByCurrencyAndNetworkCodes,
      clone: !1,
      ttl: null
    }), i;
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchDeposits", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchDeposits", void 0, t, i, s, "idLessThan", "idLessThan", void 0, 100);
    if (e === void 0)
      throw new g("fetchDeposits() requires a `code` argument").exchange(this.id);
    const r = this.currency(e);
    t === void 0 && (t = this.milliseconds() - 7776e6);
    let a = {
      coin: r.code,
      startTime: t,
      endTime: this.milliseconds()
    };
    i !== void 0 && (a.limit = i), [a, s] = this.handleUntilOption("endTime", a, s);
    const o = await this.privateSpotGetV2SpotWalletDepositRecords(this.extend(a, s)), c = this.safeValue(o, "data", []);
    return this.parseTransactions(c, r, t, i);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    this.checkAddress(i);
    const r = this.safeString2(n, "chain", "network");
    if (n = this.omit(n, "network"), r === void 0)
      throw new g("withdraw() requires a chain parameter or a network parameter").exchange(this.id);
    await this.loadMarkets();
    const a = this.currency(e), o = this.networkCodeToId(r, e), c = this.currencyToPrecision(e, t, r), u = {
      coin: a.code,
      address: i,
      chain: o,
      amount: c
    };
    s !== void 0 && (u.tag = s);
    const f = await this.privateSpotPostSpotV1WalletWithdrawalV2(this.extend(u, n)), h = this.safeValue(f, "data");
    let l;
    typeof h == "string" ? l = h : h !== void 0 && (l = this.safeString(h, "orderId"));
    const p = {
      id: l,
      info: f,
      txid: void 0,
      timestamp: void 0,
      datetime: void 0,
      network: void 0,
      addressFrom: void 0,
      address: void 0,
      addressTo: void 0,
      amount: void 0,
      type: "withdrawal",
      currency: void 0,
      status: void 0,
      updated: void 0,
      tagFrom: void 0,
      tag: void 0,
      tagTo: void 0,
      comment: void 0,
      fee: void 0
    }, m = this.safeValue(this.options, "withdraw", {});
    return this.safeBool(m, "fillResponseFromRequest", !0) && (p.currency = e, p.timestamp = this.milliseconds(), p.datetime = this.iso8601(this.milliseconds()), p.amount = t, p.tag = s, p.address = i, p.addressTo = i, p.network = r), p;
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchWithdrawals", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchWithdrawals", void 0, t, i, s, "idLessThan", "idLessThan", void 0, 100);
    if (e === void 0)
      throw new g("fetchWithdrawals() requires a `code` argument").exchange(this.id);
    const r = this.currency(e);
    t === void 0 && (t = this.milliseconds() - 7776e6);
    let a = {
      coin: r.code,
      startTime: t,
      endTime: this.milliseconds()
    };
    [a, s] = this.handleUntilOption("endTime", a, s), i !== void 0 && (a.limit = i);
    const o = await this.privateSpotGetV2SpotWalletWithdrawalRecords(this.extend(a, s)), c = this.safeValue(o, "data", []);
    return this.parseTransactions(c, r, t, i);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString(e, "coin"), s = this.safeCurrencyCode(i, t), n = this.safeInteger(e, "cTime"), r = this.safeString(e, "chain"), a = this.safeString(e, "status"), o = this.safeString(e, "tag"), c = this.safeString(e, "fee"), u = P.stringAbs(c);
    let f, h = this.safeString(e, "size");
    return u !== void 0 && (f = { currency: s, cost: this.parseNumber(u) }, h = P.stringSub(h, u)), {
      id: this.safeString(e, "orderId"),
      info: e,
      txid: this.safeString(e, "tradeId"),
      timestamp: n,
      datetime: this.iso8601(n),
      network: this.networkIdToCode(r),
      addressFrom: this.safeString(e, "fromAddress"),
      address: this.safeString(e, "toAddress"),
      addressTo: this.safeString(e, "toAddress"),
      amount: this.parseNumber(h),
      type: this.safeString(e, "type"),
      currency: s,
      status: this.parseTransactionStatus(a),
      updated: this.safeInteger(e, "uTime"),
      tagFrom: void 0,
      tag: o,
      tagTo: o,
      comment: void 0,
      internal: void 0,
      fee: f
    };
  }
  parseTransactionStatus(e) {
    const t = {
      success: "ok",
      Pending: "pending",
      pending_review: "pending",
      pending_review_fail: "failed",
      reject: "failed"
    };
    return this.safeString(t, e, e);
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.safeString2(t, "chain", "network");
    t = this.omit(t, "network");
    let s;
    i !== void 0 && (s = this.networkCodeToId(i, e));
    const n = this.currency(e), r = {
      coin: n.code
    };
    s !== void 0 && (r.chain = s);
    const a = await this.privateSpotGetV2SpotWalletDepositAddress(this.extend(r, t)), o = this.safeValue(a, "data", {});
    return this.parseDepositAddress(o, n);
  }
  parseDepositAddress(e, t = void 0) {
    const i = this.safeString(e, "coin"), s = this.safeString(e, "chain"), n = this.safeCurrencyCode(i, t);
    let r;
    return s !== void 0 && (r = this.networkIdToCode(s, n)), {
      currency: n,
      address: this.safeString(e, "address"),
      tag: this.safeString(e, "tag"),
      network: r,
      info: e
    };
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.safeValue(this.options, "sandboxMode", !1);
    let n;
    if (s) {
      const u = this.convertSymbolForSandbox(e);
      n = this.market(u);
    } else
      n = this.market(e);
    const r = {
      symbol: n.id
    };
    t !== void 0 && (r.limit = t);
    let a;
    if (n.spot)
      a = await this.publicSpotGetV2SpotMarketOrderbook(this.extend(r, i));
    else {
      let u;
      [u, i] = this.handleProductTypeAndParams(n, i), r.productType = u, a = await this.publicMixGetV2MixMarketMergeDepth(this.extend(r, i));
    }
    const o = this.safeValue(a, "data", {}), c = this.safeInteger(o, "ts");
    return this.parseOrderBook(o, n.symbol, c);
  }
  parseTicker(e, t = void 0) {
    const i = this.safeString(e, "symbol"), s = this.safeString(e, "lastPr"), n = this.safeInteger(e, "ts"), r = this.safeString(e, "change24h"), a = this.safeString(e, "open24"), o = this.safeString(e, "open");
    let c, u;
    return o === void 0 ? (c = this.safeSymbol(i, t, void 0, "contract"), u = a) : (c = this.safeSymbol(i, t, void 0, "spot"), u = o), this.safeTicker({
      symbol: c,
      timestamp: n,
      datetime: this.iso8601(n),
      high: this.safeString(e, "high24h"),
      low: this.safeString(e, "low24h"),
      bid: this.safeString(e, "bidPr"),
      bidVolume: this.safeString(e, "bidSz"),
      ask: this.safeString(e, "askPr"),
      askVolume: this.safeString(e, "askSz"),
      vwap: void 0,
      open: u,
      close: s,
      last: s,
      previousClose: void 0,
      change: r,
      percentage: P.stringMul(r, "100"),
      average: void 0,
      baseVolume: this.safeString(e, "baseVolume"),
      quoteVolume: this.safeString(e, "quoteVolume"),
      info: e
    }, t);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.safeValue(this.options, "sandboxMode", !1);
    let s;
    if (i) {
      const o = this.convertSymbolForSandbox(e);
      s = this.market(o);
    } else
      s = this.market(e);
    const n = {
      symbol: s.id
    };
    let r;
    if (s.spot)
      r = await this.publicSpotGetV2SpotMarketTickers(this.extend(n, t));
    else {
      let o;
      [o, t] = this.handleProductTypeAndParams(s, t), n.productType = o, r = await this.publicMixGetV2MixMarketTicker(this.extend(n, t));
    }
    const a = this.safeValue(r, "data", []);
    return this.parseTicker(a[0], s);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets();
    let i;
    if (e !== void 0) {
      const o = this.safeValue(e, 0);
      if (this.safeValue(this.options, "sandboxMode", !1)) {
        const u = this.convertSymbolForSandbox(o);
        i = this.market(u);
      } else
        i = this.market(o);
    }
    const s = {};
    let n;
    [n, t] = this.handleMarketTypeAndParams("fetchTickers", i, t);
    let r;
    if (n === "spot")
      r = await this.publicSpotGetV2SpotMarketTickers(this.extend(s, t));
    else {
      let o;
      [o, t] = this.handleProductTypeAndParams(i, t), s.productType = o, r = await this.publicMixGetV2MixMarketTickers(this.extend(s, t));
    }
    const a = this.safeValue(r, "data", []);
    return this.parseTickers(a, e);
  }
  parseTrade(e, t = void 0) {
    const i = this.safeString(e, "symbol"), s = this.safeSymbol(i, t), n = this.safeInteger2(e, "cTime", "ts");
    let r;
    const a = this.safeValue(e, "feeDetail"), c = this.safeString(e, "posMode") !== void 0 ? a[0] : a;
    return c !== void 0 && (r = {
      currency: this.safeCurrencyCode(this.safeString(c, "feeCoin")),
      cost: P.stringAbs(this.safeString(c, "totalFee"))
    }), this.safeTrade({
      info: e,
      id: this.safeString(e, "tradeId"),
      order: this.safeString(e, "orderId"),
      symbol: s,
      side: this.safeStringLower(e, "side"),
      type: this.safeString(e, "orderType"),
      takerOrMaker: this.safeString(e, "tradeScope"),
      price: this.safeString2(e, "priceAvg", "price"),
      amount: this.safeString2(e, "baseVolume", "size"),
      cost: this.safeString2(e, "quoteVolume", "amount"),
      timestamp: n,
      datetime: this.iso8601(n),
      fee: r
    }, t);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchTrades", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchTrades", e, t, i, s, "idLessThan", "idLessThan");
    const r = this.safeValue(this.options, "sandboxMode", !1);
    let a;
    if (r) {
      const h = this.convertSymbolForSandbox(e);
      a = this.market(h);
    } else
      a = this.market(e);
    let o = {
      symbol: a.id
    };
    i !== void 0 && (a.contract ? o.limit = Math.min(i, 1e3) : o.limit = i);
    const c = this.safeValue(this.options, "fetchTrades", {});
    let u;
    if (a.spot) {
      const h = this.safeValue(c, "spot", {}), l = this.safeString(h, "method", "publicSpotGetV2SpotMarketFillsHistory"), p = this.safeString(s, "method", l);
      s = this.omit(s, "method"), p === "publicSpotGetV2SpotMarketFillsHistory" ? ([o, s] = this.handleUntilOption("endTime", o, s), t !== void 0 && (o.startTime = t), u = await this.publicSpotGetV2SpotMarketFillsHistory(this.extend(o, s))) : p === "publicSpotGetV2SpotMarketFills" && (u = await this.publicSpotGetV2SpotMarketFills(this.extend(o, s)));
    } else {
      const h = this.safeValue(c, "swap", {}), l = this.safeString(h, "method", "publicMixGetV2MixMarketFillsHistory"), p = this.safeString(s, "method", l);
      s = this.omit(s, "method");
      let m;
      [m, s] = this.handleProductTypeAndParams(a, s), o.productType = m, p === "publicMixGetV2MixMarketFillsHistory" ? ([o, s] = this.handleUntilOption("endTime", o, s), t !== void 0 && (o.startTime = t), u = await this.publicMixGetV2MixMarketFillsHistory(this.extend(o, s))) : p === "publicMixGetV2MixMarketFills" && (u = await this.publicMixGetV2MixMarketFills(this.extend(o, s)));
    }
    const f = this.safeValue(u, "data", []);
    return this.parseTrades(f, a, t, i);
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    };
    let n;
    [n, t] = this.handleMarginModeAndParams("fetchTradingFee", t), i.spot ? n !== void 0 ? s.businessType = "margin" : s.businessType = "spot" : s.businessType = "contract";
    const r = await this.privateCommonGetV2CommonTradeRate(this.extend(s, t)), a = this.safeValue(r, "data", {});
    return this.parseTradingFee(a, i);
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    let t, i, s;
    if ([i, e] = this.handleMarginModeAndParams("fetchTradingFees", e), [s, e] = this.handleMarketTypeAndParams("fetchTradingFees", void 0, e), s === "spot") {
      const a = this.safeBool(e, "margin", !1);
      e = this.omit(e, "margin"), i !== void 0 || a ? t = await this.publicMarginGetV2MarginCurrencies(e) : t = await this.publicSpotGetV2SpotPublicSymbols(e);
    } else if (s === "swap" || s === "future") {
      let a;
      [a, e] = this.handleProductTypeAndParams(void 0, e), e.productType = a, t = await this.publicMixGetV2MixMarketContracts(e);
    } else
      throw new ge(s).exchange(this.id);
    const n = this.safeValue(t, "data", []), r = {};
    for (let a = 0; a < n.length; a++) {
      const o = n[a], c = this.safeString(o, "symbol"), u = this.safeSymbol(c, void 0, void 0, s), f = this.market(u), h = this.parseTradingFee(o, f);
      r[u] = h;
    }
    return r;
  }
  parseTradingFee(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    return {
      info: e,
      symbol: this.safeSymbol(i, t),
      maker: this.safeNumber(e, "makerFeeRate"),
      taker: this.safeNumber(e, "takerFeeRate")
    };
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeInteger(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 2),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 5)
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 1e3);
    const a = this.safeValue(this.options, "sandboxMode", !1);
    let o;
    if (a) {
      const w = this.convertSymbolForSandbox(e);
      o = this.market(w);
    } else
      o = this.market(e);
    const c = o.spot ? "spot" : "swap", u = this.options.timeframes[c], f = this.safeString(u, t, t), h = {
      symbol: o.id,
      granularity: f
    }, l = this.safeInteger2(n, "until", "till");
    if (n = this.omit(n, ["until", "till"]), s !== void 0 && (h.limit = s), i !== void 0 && (h.startTime = i), i !== void 0) {
      s === void 0 && (s = 100);
      const w = this.parseTimeframe(t) * 1e3;
      h.endTime = this.sum(i, w * (s + 1)) - 1;
    } else
      l !== void 0 ? h.endTime = l : h.endTime = this.milliseconds();
    let p;
    const m = this.milliseconds() - 26784e5;
    if (o.spot)
      i !== void 0 && i < m ? p = await this.publicSpotGetV2SpotMarketHistoryCandles(this.extend(h, n)) : p = await this.publicSpotGetV2SpotMarketCandles(this.extend(h, n));
    else {
      const w = this.safeString(n, "price");
      n = this.omit(n, ["price"]);
      let S;
      [S, n] = this.handleProductTypeAndParams(o, n), h.productType = S, w === "mark" ? p = await this.publicMixGetV2MixMarketHistoryMarkCandles(this.extend(h, n)) : w === "index" ? p = await this.publicMixGetV2MixMarketHistoryIndexCandles(this.extend(h, n)) : i !== void 0 && i < m ? p = await this.publicMixGetV2MixMarketHistoryCandles(this.extend(h, n)) : p = await this.publicMixGetV2MixMarketCandles(this.extend(h, n));
    }
    if (p === "")
      return [];
    const y = this.safeList(p, "data", p);
    return this.parseOHLCVs(y, o, t, i, s);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const t = {};
    let i, s, n;
    if ([i, e] = this.handleMarketTypeAndParams("fetchBalance", void 0, e), [s, e] = this.handleMarginModeAndParams("fetchBalance", e), i === "swap" || i === "future") {
      let a;
      [a, e] = this.handleProductTypeAndParams(void 0, e), t.productType = a, n = await this.privateMixGetV2MixAccountAccounts(this.extend(t, e));
    } else if (i === "funding")
      n = await this.privateMixGetV2AccountFundingAssets(this.extend(t, e));
    else if (s === "isolated") {
      n = await this.privateMarginGetMarginV1IsolatedAccountAssets(this.extend(t, e));
      const a = this.safeValue(n, "data", []);
      return this.parseIsolatedMarginBalance(a);
    } else if (s === "cross")
      n = await this.privateMarginGetMarginV1CrossAccountAssets(this.extend(t, e));
    else if (i === "spot")
      n = await this.privateSpotGetV2SpotAccountAssets(this.extend(t, e));
    else if (i === "earn") {
      n = await this.privateEarnGetV2EarnAccountAssets(this.extend(t, e));
      const a = this.safeValue(n, "data", []);
      return this.parseEarnBalance(a);
    } else if (i === "margin") {
      let a;
      s === "isolated" ? a = "privateMarginGetIsolatedAccountAssets" : a = "privateMarginGetCrossedAccountAssets", n = await this[a](this.extend(t, e));
    } else
      throw new ge(i).addMessage("fetchBalance() does not support " + i + " accounts").exchange(this.id);
    const r = this.safeValue(n, "data", []);
    return this.parseBalance(r);
  }
  parseEarnBalance(e) {
    const t = {};
    return e.forEach((i) => {
      const s = this.safeString(i, "coin"), n = this.safeCurrencyCode(s), r = this.account();
      r.free = "0", r.total = this.safeString(i, "amount"), r.used = this.safeString(i, "amount"), r.locked = this.safeString(i, "amount"), t[n] = r;
    }), this.safeBalance(t);
  }
  /**
   *
   * @param data - response data
   * @returns
   *  BTCUSDT: {
   *       USDT: { free: 0.001, used: 0, total: 0.001, debt: 0 },
   *       BTC: { free: 2.8e-7, used: 0, total: 2.8e-7, debt: 0 }
   *   }
   */
  parseIsolatedMarginBalance(e) {
    const t = {};
    return e.forEach((i) => {
      const s = this.safeString(i, "symbol"), n = this.safeString(i, "coin"), r = this.safeCurrencyCode(n);
      t[s] || (t[s] = {});
      const a = this.account();
      a.free = this.safeString(i, "available"), a.total = this.safeString(i, "totalAmount"), a.used = this.safeString(i, "frozen"), a.debt = this.safeString(i, "borrow"), t[s][r] = a;
    }), Object.keys(t).forEach((i) => {
      t[i] = this.safeBalance(t[i]);
    }), t;
  }
  parseBalance(e) {
    const t = { info: e };
    for (let i = 0; i < e.length; i++) {
      const s = e[i], n = this.account(), r = this.safeString2(s, "marginCoin", "coin"), a = this.safeCurrencyCode(r), o = this.safeString(s, "borrow");
      if (o !== void 0) {
        const c = this.safeString(s, "interest");
        n.free = this.safeString(s, "transferable"), n.total = this.safeString(s, "totalAmount"), n.debt = P.stringAdd(o, c);
      } else {
        const c = this.safeString(s, "available"), u = this.safeString(s, "maxTransferOut");
        if (u !== void 0)
          n.free = u, n.total = this.safeString(s, "accountEquity");
        else {
          n.free = c;
          const f = this.safeString(s, "frozen"), h = this.safeString(s, "locked");
          n.used = P.stringAdd(f, h);
        }
      }
      t[a] = n;
    }
    return this.safeBalance(t);
  }
  parseOrderStatus(e) {
    const t = {
      new: "open",
      init: "open",
      not_trigger: "open",
      partial_fill: "open",
      partially_fill: "open",
      triggered: "closed",
      full_fill: "closed",
      filled: "closed",
      fail_trigger: "rejected",
      cancel: "canceled",
      cancelled: "canceled",
      canceled: "canceled",
      live: "open",
      fail_execute: "rejected",
      executed: "closed"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    if (this.safeString(e, "errorMsg") !== void 0)
      return this.safeOrder({
        info: e,
        id: this.safeString(e, "orderId"),
        clientOrderId: this.safeString2(e, "clientOrderId", "clientOid"),
        status: "rejected"
      }, t);
    let n = "posSide" in e ? "contract" : "spot";
    t !== void 0 && (n = t.type);
    const r = this.safeString(e, "symbol");
    t = this.safeMarket(r, t, void 0, n);
    const a = this.safeInteger2(e, "cTime", "ctime"), o = this.safeInteger(e, "uTime"), c = this.safeString2(e, "status", "state");
    let u;
    const f = this.safeString(e, "fee");
    f !== void 0 && (u = {
      cost: this.parseNumber(P.stringAbs(f)),
      currency: t.settle
    });
    const h = this.safeValue(e, "feeDetail");
    if (h !== void 0) {
      const j = JSON.parse(h), G = Object.values(j);
      let W;
      for (let B = 0; B < G.length; B++) {
        const Q = G[B];
        if (this.safeValue(Q, "feeCoinCode") !== void 0) {
          W = Q;
          break;
        }
      }
      u = {
        cost: this.parseNumber(P.stringAbs(this.safeString(W, "totalFee"))),
        currency: this.safeCurrencyCode(this.safeString(W, "feeCoinCode"))
      };
    }
    let l, p = this.safeStringUpper(e, "force");
    p === "POST_ONLY" && (l = !0, p = "PO");
    let m;
    const y = this.safeString(e, "reduceOnly");
    y !== void 0 && (m = y !== "NO");
    let w, S;
    this.safeString(e, "basePrice") !== void 0 ? (w = this.safeString(e, "priceAvg"), S = this.safeString(e, "basePrice")) : (w = this.safeString2(e, "price", "executePrice"), S = this.safeString(e, "priceAvg"));
    let T, x;
    const v = this.safeString(e, "baseSize");
    v !== void 0 ? (T = v, x = this.safeString(e, "size")) : (T = this.safeString(e, "size"), x = this.safeString(e, "baseVolume"));
    let _ = this.safeString(e, "side");
    return this.safeString(e, "posMode") === "hedge_mode" && m && (_ = _ === "buy" ? "sell" : "buy"), this.safeOrder({
      info: e,
      id: this.safeString2(e, "orderId", "data"),
      clientOrderId: this.safeString2(e, "clientOrderId", "clientOid"),
      timestamp: a,
      datetime: this.iso8601(a),
      lastTradeTimestamp: o,
      lastUpdateTimestamp: o,
      symbol: t.symbol,
      type: this.safeString(e, "orderType"),
      side: _,
      price: w,
      amount: T,
      cost: this.safeString2(e, "quoteVolume", "quoteSize"),
      average: S,
      filled: x,
      remaining: void 0,
      timeInForce: p,
      postOnly: l,
      reduceOnly: m,
      stopPrice: this.safeNumber(e, "triggerPrice"),
      triggerPrice: this.safeNumber(e, "triggerPrice"),
      takeProfitPrice: this.safeNumber2(e, "presetStopSurplusPrice", "stopSurplusTriggerPrice"),
      stopLossPrice: this.safeNumber2(e, "presetStopLossPrice", "stopLossTriggerPrice"),
      status: this.parseOrderStatus(c),
      fee: u,
      trades: void 0
    }, t);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("It supports spot orders only").exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), c = this.handleMarginModeAndParams("createOrder", r)[0], u = this.safeValue2(r, "stopPrice", "triggerPrice"), f = this.safeValue(r, "stopLossPrice"), h = this.safeValue(r, "takeProfitPrice"), p = this.safeString2(r, "trailingPercent", "callbackRatio") !== void 0, m = u !== void 0, S = f !== void 0 || h !== void 0, b = this.createOrderRequest(e, t, i, s, n, r);
    let T;
    a.spot ? m ? T = await this.privateSpotPostV2SpotTradePlacePlanOrder(b) : c === "isolated" ? T = await this.privateMarginPostV2MarginIsolatedPlaceOrder(b) : c === "cross" ? T = await this.privateMarginPostV2MarginCrossedPlaceOrder(b) : T = await this.privateSpotPostV2SpotTradePlaceOrder(b) : m || p ? T = await this.privateMixPostV2MixOrderPlacePlanOrder(b) : S ? T = await this.privateMixPostV2MixOrderPlaceTpslOrder(b) : T = await this.privateMixPostV2MixOrderPlaceOrder(b);
    const x = this.safeValue(T, "data", {});
    return this.parseOrder(x, a);
  }
  createOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.safeValue(this.options, "sandboxMode", !1);
    let o;
    if (a) {
      const L = this.convertSymbolForSandbox(e);
      o = this.market(L);
    } else
      o = this.market(e);
    let c, u;
    [c, r] = this.handleMarketTypeAndParams("createOrder", o, r), [u, r] = this.handleMarginModeAndParams("createOrder", r);
    const f = {
      symbol: o.id,
      orderType: t
    }, h = t === "market", l = this.safeValue2(r, "stopPrice", "triggerPrice"), p = this.safeValue(r, "stopLossPrice"), m = this.safeValue(r, "takeProfitPrice"), y = this.safeValue(r, "stopLoss"), w = this.safeValue(r, "takeProfit"), S = l !== void 0, b = p !== void 0, T = m !== void 0, x = y !== void 0, v = w !== void 0, _ = b || T, V = x || v, j = this.safeString(r, "trailingTriggerPrice", this.numberToString(n)), G = this.safeString2(r, "trailingPercent", "callbackRatio"), W = G !== void 0;
    if (this.sum(S, b, T, W) > 1)
      throw new g("createOrder() params can only contain one of triggerPrice, stopLossPrice, takeProfitPrice, trailingPercent").exchange(this.id);
    t === "limit" && (f.price = this.priceToPrecision(e, n));
    const B = this.safeString(r, "triggerType", "mark_price"), Q = this.safeBool(r, "reduceOnly", !1), se = this.safeString2(r, "clientOid", "clientOrderId"), $ = this.safeString2(r, "force", "timeInForce");
    let te;
    [te, r] = this.handlePostOnly(h, $ === "post_only", r);
    const E = this.safeStringUpper(this.options, "defaultTimeInForce"), N = this.safeStringUpper(r, "timeInForce", E);
    if (te ? f.force = "post_only" : N === "GTC" ? f.force = "GTC" : N === "FOK" ? f.force = "FOK" : N === "IOC" && (f.force = "IOC"), r = this.omit(r, ["stopPrice", "triggerType", "stopLossPrice", "takeProfitPrice", "stopLoss", "takeProfit", "postOnly", "reduceOnly", "clientOrderId", "trailingPercent", "trailingTriggerPrice"]), c === "swap" || c === "future") {
      f.marginCoin = o.settleId, f.size = this.amountToPrecision(e, s);
      let L;
      if ([L, r] = this.handleProductTypeAndParams(o, r), f.productType = L, se !== void 0 && (f.clientOid = se), (S || _ || W) && (f.triggerType = B), W) {
        if (!h)
          throw new ge(t).addMessage("createOrder() bitget trailing orders must be market orders").exchange(this.id);
        if (j === void 0)
          throw new g("createOrder() bitget trailing orders must have a trailingTriggerPrice param").exchange(this.id);
        f.planType = "track_plan", f.triggerPrice = this.priceToPrecision(e, j), f.callbackRatio = G;
      } else if (S) {
        if (f.planType = "normal_plan", f.triggerPrice = this.priceToPrecision(e, l), n !== void 0 && (f.executePrice = this.priceToPrecision(e, n)), x) {
          const z = this.safeNumber2(y, "triggerPrice", "stopPrice");
          f.stopLossTriggerPrice = this.priceToPrecision(e, z);
          const K = this.safeNumber(y, "price");
          f.stopLossExecutePrice = this.priceToPrecision(e, K);
          const R = this.safeString(y, "type", "mark_price");
          f.stopLossTriggerType = R;
        }
        if (v) {
          const z = this.safeNumber2(w, "triggerPrice", "stopPrice");
          f.stopSurplusTriggerPrice = this.priceToPrecision(e, z);
          const K = this.safeNumber(w, "price");
          f.stopSurplusExecutePrice = this.priceToPrecision(e, K);
          const R = this.safeString(w, "type", "mark_price");
          f.stopSurplusTriggerType = R;
        }
      } else if (_) {
        if (!h)
          throw new ge(t).addMessage("createOrder() bitget stopLoss or takeProfit orders must be market orders").exchange(this.id);
        f.holdSide = i === "buy" ? "long" : "short", b ? (f.triggerPrice = this.priceToPrecision(e, p), f.planType = "pos_loss") : T && (f.triggerPrice = this.priceToPrecision(e, m), f.planType = "pos_profit");
      } else {
        if (x) {
          const z = this.safeValue2(y, "triggerPrice", "stopPrice");
          f.presetStopLossPrice = this.priceToPrecision(e, z);
        }
        if (v) {
          const z = this.safeValue2(w, "triggerPrice", "stopPrice");
          f.presetStopSurplusPrice = this.priceToPrecision(e, z);
        }
      }
      if (!_) {
        u === void 0 && (u = "cross");
        const z = u === "cross" ? "crossed" : "isolated";
        f.marginMode = z;
        const K = this.safeBool(r, "oneWayMode", !1);
        r = this.omit(r, "oneWayMode");
        let R = i;
        Q ? K ? f.reduceOnly = "YES" : (R = i === "buy" ? "sell" : "buy", f.tradeSide = "Close") : K || (f.tradeSide = "Open"), f.side = R;
      }
    } else if (c === "spot") {
      if (_ || V)
        throw new k().addMessage("createOrder() does not support stop loss/take profit orders on spot markets, only swap markets").exchange(this.id);
      f.side = i;
      let L, z, K = !0;
      if ([K, r] = this.handleOptionAndParams(r, "createOrder", "createMarketBuyOrderRequiresPrice", !0), h && i === "buy") {
        z = "total";
        const R = this.safeNumber(r, "cost");
        if (r = this.omit(r, "cost"), R !== void 0)
          L = this.costToPrecision(e, R);
        else if (K) {
          if (n === void 0)
            throw new g("createOrder() requires the price argument for market buy orders to calculate the total cost to spend (amount * price), alternatively set the createMarketBuyOrderRequiresPrice option or param to false and pass the cost to spend in the amount argument").exchange(this.id);
          {
            const U = this.numberToString(s), Y = this.numberToString(n), J = P.stringMul(U, Y);
            L = this.costToPrecision(e, J);
          }
        } else
          L = this.costToPrecision(e, s);
      } else
        z = "amount", L = this.amountToPrecision(e, s);
      se !== void 0 && (f.clientOid = se), u !== void 0 ? (f.loanType = "normal", K && h && i === "buy" ? f.quoteSize = L : f.baseSize = L) : (L !== void 0 && (f.size = L), l !== void 0 && (f.planType = z, f.triggerType = B, f.triggerPrice = this.priceToPrecision(e, l), n !== void 0 && (f.executePrice = this.priceToPrecision(e, n))));
    } else
      throw new ge(c).exchange(this.id);
    return this.extend(f, r);
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [];
    let s, n;
    for (let p = 0; p < e.length; p++) {
      const m = e[p], y = this.safeString(m, "symbol");
      if (s === void 0)
        s = y;
      else if (s !== y)
        throw new g("createOrders() requires all orders to have the same symbol").exchange(this.id);
      const w = this.safeString(m, "type"), S = this.safeString(m, "side"), b = this.safeValue(m, "amount"), T = this.safeValue(m, "price"), x = this.safeValue(m, "params", {}), _ = this.handleMarginModeAndParams("createOrders", x)[0];
      if (_ !== void 0) {
        if (n === void 0)
          n = _;
        else if (n !== _)
          throw new g("createOrders() requires all orders to have the same margin mode (isolated or cross)").exchange(this.id);
      }
      const V = this.createOrderRequest(y, w, S, b, T, x);
      i.push(V);
    }
    const r = this.safeValue(this.options, "sandboxMode", !1);
    let a;
    if (r) {
      const p = this.convertSymbolForSandbox(s);
      a = this.market(p);
    } else
      a = this.market(s);
    const o = {
      symbol: a.id,
      orderList: i
    };
    let c;
    if (a.swap || a.future) {
      n === void 0 && (n = "cross");
      const p = n === "cross" ? "crossed" : "isolated";
      o.marginMode = p, o.marginCoin = a.settleId;
      let m;
      [m, t] = this.handleProductTypeAndParams(a, t), o.productType = m, c = await this.privateMixPostV2MixOrderBatchPlaceOrder(o);
    } else
      n === "isolated" ? c = await this.privateMarginPostV2MarginIsolatedBatchPlaceOrder(o) : n === "cross" ? c = await this.privateMarginPostV2MarginCrossedBatchPlaceOrder(o) : c = await this.privateSpotPostV2SpotTradeBatchOrders(o);
    const u = this.safeValue(c, "data", {}), f = this.safeValue(u, "failureList", []), h = this.safeValue(u, "successList", []), l = this.arrayConcat(h, f);
    return this.parseOrders(l, a);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.safeValue(this.options, "sandboxMode", !1);
    let c;
    if (o) {
      const B = this.convertSymbolForSandbox(t);
      c = this.market(B);
    } else
      c = this.market(t);
    const u = {
      orderId: e
    }, f = i === "market", h = this.safeValue2(a, "stopPrice", "triggerPrice"), l = h !== void 0, p = this.safeValue(a, "stopLossPrice"), m = p !== void 0, y = this.safeValue(a, "takeProfitPrice"), w = y !== void 0, S = this.safeValue(a, "stopLoss"), b = this.safeValue(a, "takeProfit"), T = S !== void 0, x = b !== void 0, v = this.safeString(a, "trailingTriggerPrice", this.numberToString(r)), _ = this.safeString2(a, "trailingPercent", "newCallbackRatio"), V = _ !== void 0;
    if (this.sum(l, m, w, V) > 1)
      throw new g("editOrder() params can only contain one of triggerPrice, stopLossPrice, takeProfitPrice, trailingPercent").exchange(this.id);
    const j = this.safeString2(a, "clientOid", "clientOrderId");
    j !== void 0 && (u.clientOid = j), a = this.omit(a, ["stopPrice", "triggerType", "stopLossPrice", "takeProfitPrice", "stopLoss", "takeProfit", "clientOrderId", "trailingTriggerPrice", "trailingPercent"]);
    let G;
    if (c.spot) {
      if (this.safeValue(this.options, "editMarketBuyOrderRequiresPrice", !0) && f && s === "buy") {
        if (r === void 0)
          throw new g("editOrder() requires price argument for market buy orders on spot markets to calculate the total amount to spend (amount * price), alternatively set the editMarketBuyOrderRequiresPrice option to false and pass in the cost to spend into the amount parameter").exchange(this.id);
        {
          const Q = this.numberToString(n), se = this.numberToString(r), $ = this.parseNumber(P.stringMul(Q, se));
          u.size = this.priceToPrecision(t, $);
        }
      } else
        u.size = this.amountToPrecision(t, n);
      u.orderType = i, u.triggerPrice = this.priceToPrecision(t, h), u.executePrice = this.priceToPrecision(t, r), G = await this.privateSpotPostV2SpotTradeModifyPlanOrder(this.extend(u, a));
    } else {
      if (!c.swap && !c.future)
        throw new ge(c.type).addMessage("editOrder() does not support " + c.type + " orders").exchange(this.id);
      u.symbol = c.id;
      let B;
      if ([B, a] = this.handleProductTypeAndParams(c, a), u.productType = B, !w && !m && (u.newSize = this.amountToPrecision(t, n), r !== void 0 && !V && (u.newPrice = this.priceToPrecision(t, r))), V) {
        if (!f)
          throw new ge(i).addMessage("editOrder() bitget trailing orders must be market orders").exchange(this.id);
        v !== void 0 && (u.newTriggerPrice = this.priceToPrecision(t, v)), u.newCallbackRatio = _, G = await this.privateMixPostV2MixOrderModifyPlanOrder(this.extend(u, a));
      } else if (w || m)
        u.marginCoin = c.settleId, u.size = this.amountToPrecision(t, n), u.executePrice = this.priceToPrecision(t, r), m ? u.triggerPrice = this.priceToPrecision(t, p) : w && (u.triggerPrice = this.priceToPrecision(t, y)), G = await this.privateMixPostV2MixOrderModifyTpslOrder(this.extend(u, a));
      else if (l) {
        if (u.newTriggerPrice = this.priceToPrecision(t, h), T) {
          const Q = this.safeNumber2(S, "triggerPrice", "stopPrice");
          u.newStopLossTriggerPrice = this.priceToPrecision(t, Q);
          const se = this.safeNumber(S, "price");
          u.newStopLossExecutePrice = this.priceToPrecision(t, se);
          const $ = this.safeString(S, "type", "mark_price");
          u.newStopLossTriggerType = $;
        }
        if (x) {
          const Q = this.safeNumber2(b, "triggerPrice", "stopPrice");
          u.newSurplusTriggerPrice = this.priceToPrecision(t, Q);
          const se = this.safeNumber(b, "price");
          u.newStopSurplusExecutePrice = this.priceToPrecision(t, se);
          const $ = this.safeString(b, "type", "mark_price");
          u.newStopSurplusTriggerType = $;
        }
        G = await this.privateMixPostV2MixOrderModifyPlanOrder(this.extend(u, a));
      } else {
        const Q = this.uuid(), se = this.safeString2(a, "newClientOid", "newClientOrderId", Q);
        if (a = this.omit(a, "newClientOrderId"), u.newClientOid = se, T) {
          const $ = this.safeValue2(S, "triggerPrice", "stopPrice");
          u.newPresetStopLossPrice = this.priceToPrecision(t, $);
        }
        if (x) {
          const $ = this.safeValue2(b, "triggerPrice", "stopPrice");
          u.newPresetStopSurplusPrice = this.priceToPrecision(t, $);
        }
        G = await this.privateMixPostV2MixOrderModifyOrder(this.extend(u, a));
      }
    }
    const W = this.safeValue(G, "data", {});
    return this.parseOrder(W, c);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.safeValue(this.options, "sandboxMode", !1);
    let n;
    if (s) {
      const l = this.convertSymbolForSandbox(t);
      n = this.market(l);
    } else
      n = this.market(t);
    let r, a;
    [r, i] = this.handleMarginModeAndParams("cancelOrder", i);
    const o = {}, c = this.safeValue(i, "trailing"), u = this.safeValue2(i, "stop", "trigger");
    if (i = this.omit(i, ["stop", "trigger", "trailing"]), n.spot && u || (o.symbol = n.id), (n.swap || n.future) && u || (o.orderId = e), n.swap || n.future) {
      let l;
      if ([l, i] = this.handleProductTypeAndParams(n, i), o.productType = l, u || c) {
        const p = [], m = {
          orderId: e
        };
        p.push(m), o.orderIdList = p;
      }
      if (c) {
        const p = this.safeString(i, "planType", "track_plan");
        o.planType = p, a = await this.privateMixPostV2MixOrderCancelPlanOrder(this.extend(o, i));
      } else
        u ? a = await this.privateMixPostV2MixOrderCancelPlanOrder(this.extend(o, i)) : a = await this.privateMixPostV2MixOrderCancelOrder(this.extend(o, i));
    } else if (n.spot)
      r !== void 0 ? r === "isolated" ? a = await this.privateMarginPostV2MarginIsolatedCancelOrder(this.extend(o, i)) : r === "cross" && (a = await this.privateMarginPostV2MarginCrossedCancelOrder(this.extend(o, i))) : u ? a = await this.privateSpotPostV2SpotTradeCancelPlanOrder(this.extend(o, i)) : a = await this.privateSpotPostV2SpotTradeCancelOrder(this.extend(o, i));
    else
      throw new ge(n.type).addMessage("cancelOrder() does not support " + n.type + " orders").exchange(this.id);
    const f = this.safeValue(a, "data", {});
    let h;
    return (n.swap || n.future) && u ? h = this.safeValue(f, "successList", [])[0] : h = f, this.parseOrder(h, n);
  }
  async cancelOrders(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.safeValue(this.options, "sandboxMode", !1);
    let n;
    if (s) {
      const l = this.convertSymbolForSandbox(t);
      n = this.market(l);
    } else
      n = this.market(t);
    let r;
    [r, i] = this.handleMarginModeAndParams("cancelOrders", i);
    const a = this.safeValue2(i, "stop", "trigger");
    i = this.omit(i, ["stop", "trigger"]);
    const o = [];
    for (let l = 0; l < e.length; l++) {
      const m = {
        orderId: e[l]
      };
      o.push(m);
    }
    const c = {
      symbol: n.id
    };
    n.spot && r === void 0 ? c.orderList = o : c.orderIdList = o;
    let u;
    if (n.spot)
      r !== void 0 ? r === "cross" ? u = await this.privateMarginPostV2MarginCrossedBatchCancelOrder(this.extend(c, i)) : u = await this.privateMarginPostV2MarginIsolatedBatchCancelOrder(this.extend(c, i)) : u = await this.privateSpotPostV2SpotTradeBatchCancelOrder(this.extend(c, i));
    else {
      let l;
      [l, i] = this.handleProductTypeAndParams(n, i), c.productType = l, a ? u = await this.privateMixPostV2MixOrderCancelPlanOrder(this.extend(c, i)) : u = await this.privateMixPostV2MixOrderBatchCancelOrders(this.extend(c, i));
    }
    const f = this.safeValue(u, "data", {}), h = this.safeValue(f, "successList", []);
    return this.parseOrders(h, n);
  }
  async cancelAllOrders(e = void 0, t = {}) {
    if (e === void 0)
      throw new g("cancelAllOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const i = this.safeValue(this.options, "sandboxMode", !1);
    let s;
    if (i) {
      const c = this.convertSymbolForSandbox(e);
      s = this.market(c);
    } else
      s = this.market(e);
    let n;
    [n, t] = this.handleMarginModeAndParams("cancelAllOrders", t);
    const r = {
      symbol: s.id
    }, a = this.safeValue2(t, "stop", "trigger");
    t = this.omit(t, ["stop", "trigger"]);
    let o;
    if (s.spot)
      n !== void 0 ? n === "cross" ? o = await this.privateMarginPostMarginV1CrossOrderBatchCancelOrder(this.extend(r, t)) : o = await this.privateMarginPostMarginV1IsolatedOrderBatchCancelOrder(this.extend(r, t)) : o = await this.privateSpotPostV2SpotTradeCancelSymbolOrder(this.extend(r, t));
    else {
      let c;
      [c, t] = this.handleProductTypeAndParams(s, t), r.productType = c, a ? o = await this.privateMixPostV2MixOrderCancelPlanOrder(this.extend(r, t)) : o = await this.privateMixPostV2MixOrderBatchCancelOrders(this.extend(r, t));
    }
    return o;
  }
  async fetchOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("fetchOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.safeValue(this.options, "sandboxMode", !1);
    let n;
    if (s) {
      const u = this.convertSymbolForSandbox(t);
      n = this.market(u);
    } else
      n = this.market(t);
    const r = {
      orderId: e
    };
    let a;
    if (n.spot)
      a = await this.privateSpotGetV2SpotTradeOrderInfo(this.extend(r, i));
    else if (n.swap || n.future) {
      r.symbol = n.id;
      let u;
      [u, i] = this.handleProductTypeAndParams(n, i), r.productType = u, a = await this.privateMixGetV2MixOrderDetail(this.extend(r, i));
    } else
      throw new ge(n.type).addMessage("fetchOrder() does not support " + n.type + " orders").exchange(this.id);
    typeof a == "string" && (a = JSON.parse(a));
    const o = this.safeValue(a, "data"), c = this.safeValue(o, 0, o);
    return this.parseOrder(c, n);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.safeValue(this.options, "sandboxMode", !1);
    let r, a, o = {}, c;
    if ([c, s] = this.handleMarginModeAndParams("fetchOpenOrders", s), e !== void 0) {
      if (n) {
        const S = this.convertSymbolForSandbox(e);
        r = this.market(S);
      } else
        r = this.market(e);
      o.symbol = r.id;
      const y = this.safeString2(this.options, "fetchOpenOrders", "defaultType", "spot"), w = "type" in r ? r.type : y;
      a = this.safeString(s, "type", w);
    } else {
      const y = this.safeString2(this.options, "fetchOpenOrders", "defaultType", "spot");
      a = this.safeString(s, "type", y);
    }
    let u = !1;
    if ([u, s] = this.handleOptionAndParams(s, "fetchOpenOrders", "paginate"), u) {
      let y;
      return a === "spot" ? c !== void 0 && (y = "minId") : y = "endId", await this.fetchPaginatedCallCursor("fetchOpenOrders", e, t, i, s, y, "idLessThan");
    }
    let f;
    const h = this.safeValue(s, "trailing"), l = this.safeValue2(s, "stop", "trigger");
    if (s = this.omit(s, ["stop", "trigger", "trailing"]), [o, s] = this.handleUntilOption("endTime", o, s), t !== void 0 && (o.startTime = t), i !== void 0 && (o.limit = i), a === "swap" || a === "future" || c !== void 0) {
      const y = this.safeString2(s, "clientOid", "clientOrderId");
      s = this.omit(s, "clientOrderId"), y !== void 0 && (o.clientOid = y);
    }
    let p;
    if (p = this.omit(s, ["type"]), a === "spot")
      c !== void 0 ? (t === void 0 && (t = this.milliseconds() - 7776e6, o.startTime = t), c === "isolated" ? f = await this.privateMarginGetV2MarginIsolatedOpenOrders(this.extend(o, p)) : c === "cross" && (f = await this.privateMarginGetV2MarginCrossedOpenOrders(this.extend(o, p)))) : l ? f = await this.privateSpotGetV2SpotTradeCurrentPlanOrder(this.extend(o, p)) : f = await this.privateSpotGetV2SpotTradeUnfilledOrders(this.extend(o, p));
    else {
      let y;
      if ([y, p] = this.handleProductTypeAndParams(r, p), o.productType = y, h) {
        const w = this.safeString(s, "planType", "track_plan");
        o.planType = w, f = await this.privateMixGetV2MixOrderOrdersPlanPending(this.extend(o, p));
      } else if (l) {
        const w = this.safeString(p, "planType", "normal_plan");
        o.planType = w, f = await this.privateMixGetV2MixOrderOrdersPlanPending(this.extend(o, p));
      } else
        f = await this.privateMixGetV2MixOrderOrdersPending(this.extend(o, p));
    }
    const m = this.safeValue(f, "data");
    if (a === "spot") {
      if (c !== void 0 || l) {
        const y = this.safeValue(m, "orderList", []);
        return this.parseOrders(y, r, t, i);
      }
    } else {
      const y = this.safeValue(m, "entrustedList", []);
      return this.parseOrders(y, r, t, i);
    }
    return this.parseOrders(m, r, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = await this.fetchCanceledAndClosedOrders(e, t, i, s);
    return this.filterBy(n, "status", "closed");
  }
  async fetchCanceledOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = await this.fetchCanceledAndClosedOrders(e, t, i, s);
    return this.filterBy(n, "status", "canceled");
  }
  async fetchCanceledAndClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.safeValue(this.options, "sandboxMode", !1);
    let r;
    n && e !== void 0 && (e = this.convertSymbolForSandbox(e));
    let a = {};
    e !== void 0 && (r = this.market(e), a.symbol = r.id);
    let o;
    [o, s] = this.handleMarketTypeAndParams("fetchCanceledAndClosedOrders", r, s);
    let c;
    [c, s] = this.handleMarginModeAndParams("fetchCanceledAndClosedOrders", s);
    let u = !1;
    if ([u, s] = this.handleOptionAndParams(s, "fetchCanceledAndClosedOrders", "paginate"), u) {
      let w;
      return o === "spot" ? c !== void 0 && (w = "minId") : w = "endId", await this.fetchPaginatedCallCursor("fetchCanceledAndClosedOrders", e, t, i, s, w, "idLessThan");
    }
    let f;
    const h = this.safeValue(s, "trailing"), l = this.safeValue2(s, "stop", "trigger");
    if (s = this.omit(s, ["stop", "trigger", "trailing"]), [a, s] = this.handleUntilOption("endTime", a, s), t !== void 0 && (a.startTime = t), i !== void 0 && (a.limit = i), o === "swap" || o === "future" || c !== void 0) {
      const w = this.safeString2(s, "clientOid", "clientOrderId");
      s = this.omit(s, "clientOrderId"), w !== void 0 && (a.clientOid = w);
    }
    const p = this.milliseconds();
    if (o === "spot")
      if (c !== void 0)
        t === void 0 && (t = p - 7776e6, a.startTime = t), c === "isolated" ? f = await this.privateMarginGetV2MarginIsolatedHistoryOrders(this.extend(a, s)) : c === "cross" && (f = await this.privateMarginGetV2MarginCrossedHistoryOrders(this.extend(a, s)));
      else if (l) {
        if (e === void 0)
          throw new g("fetchCanceledAndClosedOrders() requires a symbol argument").exchange(this.id);
        const w = this.safeIntegerN(s, ["endTime", "until", "till"]);
        s = this.omit(s, ["until", "till"]), t === void 0 && (t = p - 7776e6, a.startTime = t), w === void 0 && (a.endTime = p), f = await this.privateSpotGetV2SpotTradeHistoryPlanOrder(this.extend(a, s));
      } else
        f = await this.privateSpotGetV2SpotTradeHistoryOrders(this.extend(a, s));
    else {
      let w;
      if ([w, s] = this.handleProductTypeAndParams(r, s), a.productType = w, h) {
        const S = this.safeString(s, "planType", "track_plan");
        a.planType = S, f = await this.privateMixGetV2MixOrderOrdersPlanHistory(this.extend(a, s));
      } else if (l) {
        const S = this.safeString(s, "planType", "normal_plan");
        a.planType = S, f = await this.privateMixGetV2MixOrderOrdersPlanHistory(this.extend(a, s));
      } else
        f = await this.privateMixGetV2MixOrderOrdersHistory(this.extend(a, s));
    }
    const m = this.safeValue(f, "data", {});
    if (o === "spot") {
      if (c !== void 0 || l)
        return this.parseOrders(this.safeValue(m, "orderList", []), r, t, i);
    } else
      return this.parseOrders(this.safeValue(m, "entrustedList", []), r, t, i);
    typeof f == "string" && (f = JSON.parse(f));
    const y = this.safeValue(f, "data", []);
    return this.parseOrders(y, r, t, i);
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.safeString(s, "symbol");
    s = this.omit(s, "symbol");
    let r;
    if (n !== void 0)
      if (this.safeValue(this.options, "sandboxMode", !1)) {
        const p = this.convertSymbolForSandbox(n);
        r = this.market(p);
      } else
        r = this.market(n);
    let a;
    [a, s] = this.handleMarketTypeAndParams("fetchLedger", r, s);
    let o = !1;
    if ([o, s] = this.handleOptionAndParams(s, "fetchLedger", "paginate"), o) {
      let l;
      return a !== "spot" && (l = "endId"), await this.fetchPaginatedCallCursor("fetchLedger", n, t, i, s, l, "idLessThan");
    }
    let c, u = {};
    e !== void 0 && (c = this.currency(e), u.coin = c.code), [u, s] = this.handleUntilOption("endTime", u, s), t !== void 0 && (u.startTime = t), i !== void 0 && (u.limit = i);
    let f;
    if (a === "spot")
      f = await this.privateSpotGetV2SpotAccountBills(this.extend(u, s));
    else {
      n !== void 0 && (u.symbol = r.id);
      let l;
      [l, s] = this.handleProductTypeAndParams(r, s), u.productType = l, f = await this.privateMixGetV2MixAccountBill(this.extend(u, s));
    }
    const h = this.safeValue(f, "data");
    if (a === "swap" || a === "future") {
      const l = this.safeValue(h, "bills", []);
      return this.parseLedger(l, c, t, i);
    }
    return this.parseLedger(h, c, t, i);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeString(e, "coin"), s = this.safeCurrencyCode(i, t), n = this.safeInteger(e, "cTime"), r = this.safeNumber(e, "balance"), a = this.safeNumber2(e, "fees", "fee"), o = this.safeString2(e, "size", "amount"), c = this.parseNumber(P.stringAbs(o));
    let u = "in";
    return o.indexOf("-") >= 0 && (u = "out"), {
      info: e,
      id: this.safeString(e, "billId"),
      timestamp: n,
      datetime: this.iso8601(n),
      direction: u,
      account: void 0,
      referenceId: void 0,
      referenceAccount: void 0,
      type: this.parseLedgerType(this.safeString(e, "businessType")),
      currency: s,
      amount: c,
      before: void 0,
      after: r,
      status: void 0,
      fee: a
    };
  }
  parseLedgerType(e) {
    const t = {
      trans_to_cross: "transfer",
      trans_from_cross: "transfer",
      trans_to_exchange: "transfer",
      trans_from_exchange: "transfer",
      trans_to_isolated: "transfer",
      trans_from_isolated: "transfer",
      trans_to_contract: "transfer",
      trans_from_contract: "transfer",
      trans_to_otc: "transfer",
      trans_from_otc: "transfer",
      open_long: "trade",
      close_long: "trade",
      open_short: "trade",
      close_short: "trade",
      force_close_long: "trade",
      force_close_short: "trade",
      burst_long_loss_query: "trade",
      burst_short_loss_query: "trade",
      force_buy: "trade",
      force_sell: "trade",
      burst_buy: "trade",
      burst_sell: "trade",
      delivery_long: "settlement",
      delivery_short: "settlement",
      contract_settle_fee: "fee",
      append_margin: "transaction",
      adjust_down_lever_append_margin: "transaction",
      reduce_margin: "transaction",
      auto_append_margin: "transaction",
      cash_gift_issue: "cashback",
      cash_gift_recycle: "cashback",
      bonus_issue: "rebate",
      bonus_recycle: "rebate",
      bonus_expired: "rebate",
      transfer_in: "transfer",
      transfer_out: "transfer",
      deposit: "deposit",
      withdraw: "withdrawal",
      buy: "trade",
      sell: "trade"
    };
    return this.safeString(t, e, e);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchMyTrades() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const n = this.safeValue(this.options, "sandboxMode", !1);
    let r;
    if (n) {
      const h = this.convertSymbolForSandbox(e);
      r = this.market(h);
    } else
      r = this.market(e);
    let a;
    [a, s] = this.handleMarginModeAndParams("fetchMyTrades", s);
    let o = !1;
    if ([o, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), o) {
      let h;
      return r.spot ? a !== void 0 && (h = "minId") : h = "endId", await this.fetchPaginatedCallCursor("fetchMyTrades", e, t, i, s, h, "idLessThan");
    }
    let c, u = {
      symbol: r.id
    };
    if ([u, s] = this.handleUntilOption("endTime", u, s), t !== void 0 && (u.startTime = t), i !== void 0 && (u.limit = i), r.spot)
      a !== void 0 ? (t === void 0 && (u.startTime = this.milliseconds() - 7776e6), a === "isolated" ? c = await this.privateMarginGetV2MarginIsolatedFills(this.extend(u, s)) : a === "cross" && (c = await this.privateMarginGetV2MarginCrossedFills(this.extend(u, s)))) : c = await this.privateSpotGetV2SpotTradeFills(this.extend(u, s));
    else {
      let h;
      [h, s] = this.handleProductTypeAndParams(r, s), u.productType = h, c = await this.privateMixGetV2MixOrderFills(this.extend(u, s));
    }
    const f = this.safeValue(c, "data");
    if (r.swap || r.future) {
      const h = this.safeValue(f, "fillList", []);
      return this.parseTrades(h, r, t, i);
    } else if (a !== void 0) {
      const h = this.safeValue(f, "fills", []);
      return this.parseTrades(h, r, t, i);
    }
    return this.parseTrades(f, r, t, i);
  }
  async fetchPosition(e, t = {}) {
    await this.loadMarkets();
    const i = this.safeValue(this.options, "sandboxMode", !1);
    let s;
    if (i) {
      const u = this.convertSymbolForSandbox(e);
      s = this.market(u);
    } else
      s = this.market(e);
    let n;
    [n, t] = this.handleProductTypeAndParams(s, t);
    const r = {
      symbol: s.id,
      marginCoin: s.settleId,
      productType: n
    }, a = await this.privateMixGetV2MixPositionSinglePosition(this.extend(r, t)), o = this.safeValue(a, "data", []), c = this.safeValue(o, 0, {});
    return this.parsePosition(c, s);
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets();
    let i = !1;
    if ([i, t] = this.handleOptionAndParams(t, "fetchPositions", "paginate"), i)
      return await this.fetchPaginatedCallCursor("fetchPositions", void 0, void 0, void 0, t, "endId", "idLessThan");
    const s = this.safeValue(this.options, "fetchPositions", {}), n = this.safeString(s, "method", "privateMixGetV2MixPositionAllPosition");
    let r;
    if (e !== void 0) {
      const l = this.safeString(e, 0);
      if (this.safeValue(this.options, "sandboxMode", !1)) {
        const m = this.convertSymbolForSandbox(l);
        r = this.market(m);
      } else
        r = this.market(l);
    }
    let a;
    [a, t] = this.handleProductTypeAndParams(r, t);
    const o = {
      productType: a
    };
    let c, u = !1;
    if (n === "privateMixGetV2MixPositionAllPosition") {
      let l = this.safeString(t, "marginCoin", "USDT");
      if (e !== void 0)
        l = r.settleId;
      else if (a === this.USDT_FUTURES)
        l = "USDT";
      else if (a === this.USDC_FUTURES)
        l = "USDC";
      else if (a === this.SUSDT_FUTURES)
        l = "SUSDT";
      else if (a === this.SUSDC_FUTURES)
        l = "SUSDC";
      else if ((a === this.SCOIN_FUTURES || a === this.COIN_FUTURES) && l === void 0)
        throw new g("fetchPositions() requires a marginCoin parameter that matches the productType").exchange(this.id);
      o.marginCoin = l, c = await this.privateMixGetV2MixPositionAllPosition(this.extend(o, t));
    } else
      u = !0, r !== void 0 && (o.symbol = r.id), c = await this.privateMixGetV2MixPositionHistoryPosition(this.extend(o, t));
    let f = [];
    if (!u)
      f = this.safeValue(c, "data", []);
    else {
      const l = this.safeValue(c, "data", {});
      f = this.safeValue(l, "list", []);
    }
    const h = [];
    for (let l = 0; l < f.length; l++)
      h.push(this.parsePosition(f[l], r));
    return e = this.marketSymbols(e), this.filterByArrayPositions(h, "symbol", e, !1);
  }
  parsePosition(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t, void 0, "contract");
    const s = t.symbol, n = this.safeInteger2(e, "cTime", "ctime");
    let r = this.safeString(e, "marginMode"), a, o;
    const c = this.safeString(e, "unrealizedPL"), u = this.safeString(e, "marginSize");
    r === "isolated" ? a = P.stringAdd(u, c) : r === "crossed" && (r = "cross", o = u);
    const f = this.safeString(e, "posMode");
    let h;
    f === "hedge_mode" ? h = !0 : f === "one_way_mode" && (h = !1);
    const l = this.safeString(e, "holdSide"), p = this.safeString(e, "leverage"), m = this.safeValue(t, "contractSize"), y = this.numberToString(m), w = this.safeString(e, "total"), S = this.safeString2(e, "openPriceAvg", "openAvgPrice"), b = this.safeString(e, "keepMarginRate"), T = P.stringMul(S, w);
    o === void 0 && (o = P.stringDiv(T, p));
    let x = this.parseNumber(P.stringDiv(w, y));
    x === void 0 && (x = this.safeNumber(e, "closeTotalPos"));
    const v = this.safeString(e, "markPrice"), _ = P.stringMul(w, v), V = P.stringDiv(o, _);
    let j = this.parseNumber(this.omitZero(this.safeString(e, "liquidationPrice")));
    const G = "0.0006", W = "0.9994";
    if (j === void 0 && r === "isolated" && P.stringGt(w, "0")) {
      let $ = P.stringDiv(u, w), te = b;
      l === "short" && ($ = P.stringNeg($), te = P.stringNeg(te));
      let E = P.stringSub("1", te), N = P.stringSub(S, $);
      l === "long" ? E = P.stringMul(E, W) : N = P.stringMul(N, W), j = this.parseNumber(P.stringDiv(N, E));
    }
    const B = P.stringMul(_, G), Q = P.stringAdd(P.stringMul(b, _), B), se = P.stringMul(P.stringDiv(c, o, 4), "100");
    return this.safePosition({
      info: e,
      id: this.safeString(e, "orderId"),
      symbol: s,
      notional: this.parseNumber(_),
      marginMode: r,
      liquidationPrice: j,
      entryPrice: this.parseNumber(S),
      unrealizedPnl: this.parseNumber(c),
      realizedPnl: this.safeNumber(e, "pnl"),
      percentage: this.parseNumber(se),
      contracts: x,
      contractSize: m,
      markPrice: this.parseNumber(v),
      lastPrice: this.safeNumber(e, "closeAvgPrice"),
      side: l,
      hedged: h,
      timestamp: n,
      datetime: this.iso8601(n),
      lastUpdateTimestamp: this.safeInteger(e, "utime"),
      maintenanceMargin: this.parseNumber(Q),
      maintenanceMarginPercentage: this.parseNumber(b),
      collateral: this.parseNumber(a),
      initialMargin: this.parseNumber(o),
      initialMarginPercentage: this.parseNumber(V),
      leverage: this.parseNumber(p),
      marginRatio: this.safeNumber(e, "marginRatio"),
      stopLossPrice: void 0,
      takeProfitPrice: void 0
    });
  }
  async fetchTransfers(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchTransfers() requires a code argument").exchange(this.id);
    await this.loadMarkets();
    let n;
    [n, s] = this.handleMarketTypeAndParams("fetchTransfers", void 0, s);
    const r = this.safeString(s, "fromAccount", n);
    s = this.omit(s, "fromAccount");
    const a = this.safeValue(this.options, "accountsByType", {});
    n = this.safeString(a, r);
    const o = this.currency(e);
    let c = {
      coin: o.code,
      fromType: n
    };
    t !== void 0 && (c.startTime = t), i !== void 0 && (c.limit = i), [c, s] = this.handleUntilOption("endTime", c, s);
    const u = await this.privateSpotGetV2SpotAccountTransferRecords(this.extend(c, s)), f = this.safeValue(u, "data", []);
    return this.parseTransfers(f, o, t, i);
  }
  // https://www.bitget.com/api-doc/spot/account/Get-Subaccount-Assets
  async fetchSubAccountBalances(e, t = {}) {
    await this.loadMarkets();
    const i = await this.privateSpotGetV2SpotAccountSubaccountAssets(), n = this.safeValue(i, "data", []).find((a) => (a == null ? void 0 : a.userId) === e);
    if (n === void 0)
      throw new ku(e);
    const r = this.safeValue(n, "assetsList", []);
    return { spot: this.parseBalance(r) };
  }
  // https://www.bitget.com/api-doc/spot/account/Get-Subaccount-Assets
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.privateSpotGetV2SpotAccountSubaccountAssets();
    return this.safeValue(e, "data", []).map((i) => ({
      uid: this.safeString(i, "userId")
    }));
  }
  // https://www.bitget.com/api-doc/spot/account/Sub-Transfer
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    await this.loadMarkets();
    const o = this.currency(e), c = this.currencyToPrecision(e, t), u = this.convertTypeToAccount(i), f = this.convertTypeToAccount(s), h = {
      coin: o.code,
      amount: c,
      fromType: u,
      toType: f,
      fromUserId: n,
      toUserId: r
    };
    "clientOid" in a || (h.clientOid = this.uuid());
    const l = await this.privateSpotPostV2SpotWalletSubaccountTransfer(this.extend(h, a)), p = this.safeValue(l, "data");
    return this.parseTransfer(p, o);
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = this.safeValue(this.options, "accountsByType", {}), o = this.safeString(a, i), c = this.safeString(a, s), u = this.currencyToPrecision(e, t), f = {
      fromType: o,
      toType: c,
      amount: u,
      coin: r.code
    }, h = this.safeString(n, "symbol");
    n = this.omit(n, "symbol");
    let l;
    h !== void 0 && (l = this.market(h), f.symbol = l.id);
    const p = await this.privateSpotPostV2SpotWalletTransfer(this.extend(f, n)), m = this.safeValue(p, "data", {});
    return m.ts = this.safeInteger(p, "requestTime"), this.parseTransfer(m, r);
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeInteger(e, "ts"), s = this.safeStringLower(e, "status"), n = this.safeString(e, "coin"), r = this.safeString(e, "fromType"), a = this.safeValue(this.options, "accountsById", {}), o = this.safeString(a, r, r), c = this.safeString(e, "toType"), u = this.safeString(a, c, c);
    return {
      info: e,
      id: this.safeString(e, "transferId"),
      timestamp: i,
      datetime: this.iso8601(i),
      currency: this.safeCurrencyCode(n, t),
      amount: this.safeNumber(e, "size"),
      fromAccount: o,
      toAccount: u,
      status: this.parseTransferStatus(s)
    };
  }
  parseTransferStatus(e) {
    const t = {
      successful: "ok"
    };
    return this.safeString(t, e, e);
  }
  parseDepositWithdrawFee(e, t = void 0) {
    const i = this.safeValue(e, "chains", []), s = i.length, n = {
      info: e,
      withdraw: {
        fee: void 0,
        percentage: void 0
      },
      deposit: {
        fee: void 0,
        percentage: void 0
      },
      networks: {}
    };
    for (let r = 0; r < s; r++) {
      const a = i[r], o = this.safeString(a, "chain"), c = this.safeString(t, "code"), u = this.networkIdToCode(o, c);
      n.networks[u] = {
        deposit: { fee: void 0, percentage: void 0 },
        withdraw: { fee: this.safeNumber(a, "withdrawFee"), percentage: !1 }
      }, s === 1 && (n.withdraw.fee = this.safeNumber(a, "withdrawFee"), n.withdraw.percentage = !1);
    }
    return n;
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.publicSpotGetV2SpotPublicCoins(t), s = this.safeValue(i, "data", []);
    return this.parseDepositWithdrawFees(s, e, "coin");
  }
  async loadMarketsHelper(e = !1, t = {}) {
    await super.loadMarketsHelper(e, t);
    const i = await this.cache.get(dd(this.id), { clone: !1 });
    this.options.networkIdsByCurrencyAndNetworkCodes = i == null ? void 0 : i.data;
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (!a)
      return;
    const u = this.safeString2(a, "err_msg", "msg"), f = this.safeString2(a, "code", "err_code"), h = f + ": " + u, l = u !== void 0 && u !== "";
    l && (this.throwExactlyMatchedException(this.exceptions.exact, u, h), this.throwBroadlyMatchedException(this.exceptions.broad, u, h));
    const p = f !== void 0 && f !== "00000";
    if (p && this.throwExactlyMatchedException(this.exceptions.exact, f, h), p || l && f !== "00000")
      throw new O().addMessage(h).exchange(this.id);
  }
  async sign(e, t = [], i = "GET", s = {}, n = void 0, r = void 0) {
    const a = t[0] === "private", o = t[1], c = "/api", u = "/" + this.implodeParams(e, s), f = c + u;
    let h = this.implodeHostname(this.urls.api[o]) + f;
    const l = this.omit(s, this.extractParams(e));
    if (!a && i === "GET" && Object.keys(l).length > 0 && (h = h + "?" + this.urlencode(l)), a) {
      this.checkRequiredCredentials();
      const p = this.nonce().toString();
      let m = p + i + f;
      if (i === "POST")
        r = this.json(s), m += r;
      else if (Object.keys(s).length) {
        let S = "?" + this.urlencode(this.keysort(s));
        S.indexOf("%24") > -1 && (S = S.replace("%24", "$")), h += S, m += S;
      }
      let y;
      this.externalSigner ? y = await this.externalSigner.sign({
        payload: this.encode(m),
        publicApiKey: this.apiKey,
        exchangeId: this.id
      }) : y = this.hmac(this.encode(m), this.encode(this.secret), Re, "base64");
      const w = this.safeString(this.options, "broker");
      n = {
        "ACCESS-KEY": this.apiKey,
        "ACCESS-SIGN": y,
        "ACCESS-TIMESTAMP": p,
        "ACCESS-PASSPHRASE": this.password,
        "X-CHANNEL-API-CODE": w
      }, i === "POST" && (n["Content-Type"] = "application/json");
    }
    return { url: h, method: i, body: r, headers: n };
  }
}
let zy = class extends gt {
};
const Pd = [
  "USDT",
  "USDC",
  "DAI",
  "USDE",
  "FDUSD",
  "USDB",
  "BUSD"
];
class Hy extends zy {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "bitmart",
      name: "BitMart",
      countries: ["US", "CN", "HK", "KR"],
      // 150 per 5 seconds = 30 per second
      // rateLimit = 1000ms / 30 ~= 33.334
      rateLimit: 33.34,
      version: "v2",
      certified: !0,
      pro: !0,
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !1,
        option: !1,
        cancelAllOrders: !0,
        cancelOrder: !0,
        cancelOrders: !1,
        createMarketBuyOrderWithCost: !0,
        createMarketOrderWithCost: !1,
        createMarketSellOrderWithCost: !1,
        createOrder: !0,
        createTrailingPercentOrder: !0,
        fetchBalance: !0,
        fetchCanceledOrders: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDeposit: !0,
        fetchDepositAddress: !0,
        fetchDepositAddresses: !1,
        fetchDepositAddressesByNetwork: !1,
        fetchDeposits: !0,
        fetchDepositWithdrawFee: !0,
        fetchDepositWithdrawFees: !1,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrders: !0,
        fetchOrderTrades: !0,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchStatus: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !1,
        fetchTransactionFee: !0,
        fetchTransactionFees: !1,
        fetchTransfer: !1,
        fetchTransfers: !0,
        fetchWithdrawAddressesByNetwork: !1,
        fetchWithdrawal: !0,
        fetchWithdrawals: !0,
        transfer: !0,
        withdraw: !0
      },
      hostname: "bitmart.com",
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/129991357-8f47464b-d0f4-41d6-8a82-34122f0d1398.jpg",
        api: {
          rest: "https://api-cloud.{hostname}",
          restV2: "https://api-cloud-v2.{hostname}"
        },
        www: "https://www.bitmart.com/",
        doc: "https://developer-pro.bitmart.com/",
        referral: {
          // http://www.bitmart.com/?r=rQCFLh - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
          url: "http://www.bitmart.com",
          discount: 0.3
        },
        fees: "https://www.bitmart.com/fee/en"
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0,
        uid: !0
      },
      api: {
        public: {
          get: {
            "system/time": 3,
            "system/service": 3,
            // spot markets
            "spot/v1/currencies": 7.5,
            "spot/v1/symbols": 7.5,
            "spot/v1/symbols/details": 5,
            "spot/quotation/v3/tickers": 6,
            "spot/quotation/v3/ticker": 4,
            "spot/quotation/v3/lite-klines": 5,
            "spot/quotation/v3/klines": 7,
            "spot/quotation/v3/books": 4,
            "spot/quotation/v3/trades": 4,
            "spot/v1/ticker": 5,
            "spot/v2/ticker": 30,
            "spot/v1/ticker_detail": 5,
            "spot/v1/steps": 30,
            "spot/v1/symbols/kline": 6,
            "spot/v1/symbols/book": 5,
            "spot/v1/symbols/trades": 5,
            // contract markets
            "contract/v1/tickers": 15,
            "contract/public/details": 5,
            "contract/public/depth": 5,
            "contract/public/open-interest": 30,
            "contract/public/funding-rate": 30,
            "contract/public/kline": 6,
            "account/v1/currencies": 30
          }
        },
        private: {
          get: {
            // sub-account
            "account/sub-account/v1/transfer-list": 7.5,
            "account/sub-account/v1/transfer-history": 7.5,
            "account/sub-account/main/v1/wallet": 5,
            "account/sub-account/main/v1/subaccount-list": 7.5,
            "account/contract/sub-account/main/v1/wallet": 5,
            "account/contract/sub-account/main/v1/transfer-list": 7.5,
            "account/contract/sub-account/v1/transfer-history": 7.5,
            // account
            "account/v1/wallet": 5,
            "account/v1/currencies": 30,
            "spot/v1/wallet": 5,
            "account/v1/deposit/address": 30,
            "account/v1/withdraw/charge": 32,
            "account/v2/deposit-withdraw/history": 9,
            "account/v1/deposit-withdraw/detail": 7.5,
            // order
            "spot/v1/order_detail": 1,
            "spot/v2/orders": 5,
            "spot/v1/trades": 5,
            // newer order endpoint
            "spot/v2/trades": 5,
            "spot/v3/orders": 5,
            "spot/v2/order_detail": 1,
            // margin
            "spot/v1/margin/isolated/borrow_record": 1,
            "spot/v1/margin/isolated/repay_record": 1,
            "spot/v1/margin/isolated/pairs": 30,
            "spot/v1/margin/isolated/account": 5,
            "spot/v1/trade_fee": 30,
            "spot/v1/user_fee": 30,
            // broker
            "spot/v1/broker/rebate": 1,
            // contract
            "contract/private/assets-detail": 5,
            "contract/private/order": 1.2,
            "contract/private/order-history": 10,
            "contract/private/position": 10,
            "contract/private/get-open-orders": 1.2,
            "contract/private/current-plan-order": 1.2,
            "contract/private/trades": 10
          },
          post: {
            // sub-account endpoints
            "account/sub-account/main/v1/sub-to-main": 30,
            "account/sub-account/sub/v1/sub-to-main": 30,
            "account/sub-account/main/v1/main-to-sub": 30,
            "account/sub-account/sub/v1/sub-to-sub": 30,
            "account/sub-account/main/v1/sub-to-sub": 30,
            "account/contract/sub-account/main/v1/sub-to-main": 7.5,
            "account/contract/sub-account/main/v1/main-to-sub": 7.5,
            "account/contract/sub-account/sub/v1/sub-to-main": 7.5,
            // account
            "account/v1/withdraw/apply": 7.5,
            // transaction and trading
            "spot/v1/submit_order": 1,
            "spot/v1/batch_orders": 1,
            "spot/v2/cancel_order": 1,
            "spot/v1/cancel_orders": 15,
            "spot/v4/query/order": 1,
            "spot/v4/query/client-order": 1,
            "spot/v4/query/open-orders": 5,
            "spot/v4/query/history-orders": 5,
            "spot/v4/query/trades": 5,
            "spot/v4/query/order-trades": 5,
            // newer endpoint
            "spot/v3/cancel_order": 1,
            "spot/v2/batch_orders": 1,
            "spot/v2/submit_order": 1,
            // margin
            "spot/v1/margin/submit_order": 1,
            "spot/v1/margin/isolated/borrow": 30,
            "spot/v1/margin/isolated/repay": 30,
            "spot/v1/margin/isolated/transfer": 30,
            // contract
            "account/v1/transfer-contract-list": 60,
            "account/v1/transfer-contract": 60,
            "contract/private/submit-order": 2.5,
            "contract/private/cancel-order": 1.5,
            "contract/private/cancel-orders": 30,
            "contract/private/submit-plan-order": 2.5,
            "contract/private/cancel-plan-order": 1.5,
            "contract/private/submit-leverage": 2.5
          }
        }
      },
      timeframes: {
        "1m": 1,
        "3m": 3,
        "5m": 5,
        "15m": 15,
        "30m": 30,
        "45m": 45,
        "1h": 60,
        "2h": 120,
        "3h": 180,
        "4h": 240,
        "1d": 1440,
        "1w": 10080,
        "1M": 43200
      },
      fees: {
        trading: {
          tierBased: !0,
          percentage: !0,
          taker: this.parseNumber("0.0040"),
          maker: this.parseNumber("0.0035"),
          tiers: {
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.0020")],
              [this.parseNumber("10"), this.parseNumber("0.18")],
              [this.parseNumber("50"), this.parseNumber("0.0016")],
              [this.parseNumber("250"), this.parseNumber("0.0014")],
              [this.parseNumber("1000"), this.parseNumber("0.0012")],
              [this.parseNumber("5000"), this.parseNumber("0.0010")],
              [this.parseNumber("25000"), this.parseNumber("0.0008")],
              [this.parseNumber("50000"), this.parseNumber("0.0006")]
            ],
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.001")],
              [this.parseNumber("10"), this.parseNumber("0.0009")],
              [this.parseNumber("50"), this.parseNumber("0.0008")],
              [this.parseNumber("250"), this.parseNumber("0.0007")],
              [this.parseNumber("1000"), this.parseNumber("0.0006")],
              [this.parseNumber("5000"), this.parseNumber("0.0005")],
              [this.parseNumber("25000"), this.parseNumber("0.0004")],
              [this.parseNumber("50000"), this.parseNumber("0.0003")]
            ]
          }
        }
      },
      precisionMode: ct,
      exceptions: {
        exact: {
          // general errors
          3e4: O,
          30001: Z,
          30002: Z,
          30003: Ee,
          30004: Z,
          30005: Z,
          30006: Z,
          30007: Z,
          30008: Z,
          30010: ee,
          30011: Z,
          30012: Z,
          30013: Ae,
          30014: Te,
          30016: dt,
          30017: Ae,
          30018: g,
          30019: ee,
          // funding account & sub account errors
          6e4: g,
          60001: O,
          60002: $e,
          60003: O,
          60004: ke,
          60005: O,
          60006: O,
          60007: gi,
          60008: re,
          60009: O,
          60010: O,
          60011: et,
          60012: pe,
          60020: ee,
          60021: ee,
          60022: ee,
          60026: ee,
          60027: ee,
          60028: Ee,
          60029: Ee,
          60030: pe,
          60031: O,
          60050: O,
          60051: O,
          61001: re,
          61003: O,
          61004: O,
          61005: je,
          61006: O,
          61007: ee,
          61008: Vt,
          // spot public errors
          7e4: O,
          70001: g,
          70002: g,
          71001: g,
          71002: g,
          71003: g,
          71004: g,
          71005: g,
          // spot & margin errors
          5e4: g,
          50001: g,
          50002: g,
          50003: g,
          50004: g,
          50005: Se,
          50006: g,
          50007: g,
          50008: g,
          50009: g,
          50010: g,
          50011: g,
          50012: g,
          50013: g,
          50014: g,
          50015: g,
          50016: g,
          50017: g,
          50018: g,
          50019: g,
          50020: re,
          50021: g,
          50022: Te,
          50023: g,
          50024: g,
          50025: g,
          50026: g,
          50027: g,
          50028: g,
          50029: g,
          50030: Se,
          50031: Se,
          50032: Se,
          50033: g,
          // below Error codes used interchangeably for both failed postOnly and IOC orders depending on market price and order side
          50034: g,
          50035: g,
          50036: k,
          50037: g,
          50038: g,
          50039: g,
          50040: g,
          50041: g,
          50042: g,
          51e3: $e,
          51001: O,
          51002: O,
          51003: O,
          51004: re,
          51005: g,
          51006: g,
          51007: g,
          51008: O,
          51009: g,
          51010: g,
          51011: g,
          51012: g,
          51013: g,
          51014: k,
          51015: g,
          52e3: g,
          52001: g,
          52002: g,
          52003: g,
          52004: g,
          53e3: Ee,
          53001: Ee,
          53002: ee,
          53003: ee,
          53005: ee,
          53006: ee,
          53007: ee,
          53008: ee,
          53009: ee,
          53010: ee,
          57001: pe,
          58001: O,
          59001: O,
          59002: be,
          59003: O,
          59004: O,
          59005: ee,
          59006: je,
          59007: O,
          59008: k,
          59009: k,
          59010: re,
          59011: be,
          // contract errors
          40001: O,
          40002: O,
          40003: O,
          40004: O,
          40005: O,
          40006: ee,
          40007: g,
          40008: ze,
          40009: g,
          40010: g,
          40011: g,
          40012: be,
          40013: O,
          40014: O,
          40015: O,
          40016: k,
          40017: k,
          40018: k,
          40019: O,
          40020: k,
          40021: O,
          40022: O,
          40023: O,
          40024: O,
          40025: O,
          40026: O,
          40027: re,
          40028: ee,
          40029: g,
          40030: g,
          40031: g,
          40032: g,
          40033: g,
          40034: O,
          40035: Se,
          40036: g,
          40037: Se,
          40038: O,
          40039: O,
          40040: g,
          40041: g,
          40042: g,
          40043: g,
          40044: g,
          40045: g,
          40046: ee,
          40047: ee,
          40048: O,
          40049: O,
          40050: k
          // 403, Client OrderId duplicated with existing orders
        },
        broad: {}
      },
      options: {
        timeDifference: 0,
        defaultNetwork: "ERC20",
        defaultNetworks: {
          USDT: "ERC20"
        },
        networksById: {
          SOLANA: "SOL",
          MATIC: "POLYGON",
          Polygon: "POLYGON",
          ARB: "ARBI",
          Arbitrum: "ARBI",
          klaytn: "KLAY",
          Klaytn: "KLAY",
          Vechain: "VET",
          OP: "OPTIMISM",
          Zksyncera_eth: "ZKSYNCERA",
          OZO: "OZONE",
          "Hedera Mainnet": "HBAR",
          "ZEN-20": "ZENIQ",
          Fantom: "FANTOM",
          MultiversX: "EGLD",
          ERC20: "ETH",
          BEP2: "BSC",
          BEP20: "BSC",
          SPL: "SOL",
          BRC20: "BTC",
          ARC20: "AVAX",
          ARBI: "ARBI",
          BSC_BNB: "BSC"
        },
        networks: {
          ERC20: "ERC20",
          BTC: "BTC",
          TRC20: "TRC20",
          // todo: should be TRX after unification
          // 'TRC20': [ 'TRC20', 'trc20', 'TRON' ], // todo: after unification i.e. TRON is returned from fetchDepositAddress
          // 'ERC20': [ 'ERC20', 'ERC-20', 'ERC20 ' ], // todo: after unification
          OMNI: "OMNI",
          XLM: "XLM",
          EOS: "EOS",
          NEO: "NEO",
          BTM: "BTM",
          BCH: "BCH",
          LTC: "LTC",
          BSV: "BSV",
          XRP: "XRP",
          // 'VECHAIN': [ 'VET', 'Vechain' ], // todo: after unification
          PLEX: "PLEX",
          XCH: "XCH",
          // 'AVALANCHE_C': [ 'AVAX', 'AVAX-C' ], // todo: after unification
          NEAR: "NEAR",
          FIO: "FIO",
          SCRT: "SCRT",
          IOTX: "IOTX",
          SOL: "SPL",
          ALGO: "ALGO",
          ATOM: "ATOM",
          DOT: "DOT",
          ADA: "ADA",
          DOGE: "DOGE",
          XYM: "XYM",
          GLMR: "GLMR",
          MOVR: "MOVR",
          ZIL: "ZIL",
          INJ: "INJ",
          KSM: "KSM",
          ZEC: "ZEC",
          NAS: "NAS",
          // 'POLYGON': [ 'MATIC', 'Polygon', 'POLYGON' ], // todo: after unification
          HRC20: "HECO",
          XDC: "XDC",
          ONE: "ONE",
          LAT: "LAT",
          CSPR: "Casper",
          ICP: "Computer",
          XTZ: "XTZ",
          MINA: "MINA",
          BEP20: "BSC",
          // 'BEP20': [ 'BEP20', 'BSC_BNB', 'bep20' ], // todo: after unification
          THETA: "THETA",
          AKT: "AKT",
          AR: "AR",
          CELO: "CELO",
          FIL: "FIL",
          NULS: "NULS",
          ETC: "ETC",
          DASH: "DASH",
          DGB: "DGB",
          BEP2: "BEP2",
          GRIN: "GRIN",
          WAVES: "WAVES",
          ABBC: "ABBC",
          ACA: "ACA",
          QTUM: "QTUM",
          PAC: "PAC",
          // 'TERRACLASSIC': 'LUNC', // TBD
          // 'TERRA': 'Terra', // TBD
          // 'HEDERA': [ 'HBAR', 'Hedera', 'Hedera Mainnet' ], // todo: after unification
          TLOS: "TLOS",
          KARDIA: "KardiaChain",
          FUSE: "FUSE",
          TRC10: "TRC10",
          FIRO: "FIRO",
          FTM: "Fantom",
          // 'KLAYTN': [ 'klaytn', 'KLAY', 'Klaytn' ], // todo: after unification
          // 'ELROND': [ 'EGLD', 'Elrond eGold', 'MultiversX' ], // todo: after unification
          EVER: "EVER",
          KAVA: "KAVA",
          HYDRA: "HYDRA",
          PLCU: "PLCU",
          BRISE: "BRISE",
          // 'CRC20': [ 'CRO', 'CRO_Chain' ], // todo: after unification
          // 'CONFLUX': [ 'CFX eSpace', 'CFX' ], // todo: after unification
          OPTIMISM: "OPTIMISM",
          REEF: "REEF",
          SYS: "SYS",
          VITE: "VITE",
          STX: "STX",
          SXP: "SXP",
          BITCI: "BITCI",
          // 'ARBITRUM': [ 'ARBI', 'Arbitrum' ], // todo: after unification
          XRD: "XRD",
          ASTR: "ASTAR",
          ZEN: "HORIZEN",
          LTO: "LTO",
          ETHW: "ETHW",
          ETHF: "ETHF",
          IOST: "IOST",
          // 'CHILIZ': [ 'CHZ', 'CHILIZ' ], // todo: after unification
          APT: "APT",
          // 'FLOW': [ 'FLOW', 'Flow' ], // todo: after unification
          ONT: "ONT",
          EVMOS: "EVMOS",
          XMR: "XMR",
          OASYS: "OAS",
          OSMO: "OSMO",
          OMAX: "OMAX Chain",
          DESO: "DESO",
          BFIC: "BFIC",
          OHO: "OHO",
          CS: "CS",
          CHEQ: "CHEQ",
          NODL: "NODL",
          NEM: "XEM",
          FRA: "FRA",
          ERGO: "ERG"
          // todo: below will be uncommented after unification
          // 'BITCOINHD': 'BHD',
          // 'CRUST': 'CRU',
          // 'MINTME': 'MINTME',
          // 'ZENITH': 'ZENITH',
          // 'ZENIQ': 'ZENIQ', // "ZEN-20" is different
          // 'BITCOINVAULT': 'BTCV',
          // 'MOBILECOIN': 'MBX',
          // 'PINETWORK': 'PI',
          // 'PI': 'PI',
          // 'REBUS': 'REBUS',
          // 'XODEX': 'XODEX',
          // 'ULTRONGLOW': 'UTG'
          // 'QIBLOCKCHAIN': 'QIE',
          // 'XIDEN': 'XDEN',
          // 'PHAETON': 'PHAE',
          // 'REDLIGHT': 'REDLC',
          // 'VERITISE': 'VTS',
          // 'VERIBLOCK': 'VBK',
          // 'RAMESTTA': 'RAMA',
          // 'BITICA': 'BDCC',
          // 'CROWNSOVEREIGN': 'CSOV',
          // 'DRAC': 'DRC20',
          // 'QCHAIN': 'QDT',
          // 'KINGARU': 'KRU',
          // 'PROOFOFMEMES': 'POM',
          // 'CUBE': 'CUBE',
          // 'CADUCEUS': 'CMP',
          // 'VEIL': 'VEIL',
          // 'ENERGYWEB': 'EWT',
          // 'CYPHERIUM': 'CPH',
          // 'LBRY': 'LBC',
          // 'ETHERCOIN': 'ETE',
          // undetermined chains:
          // LEX (for LexThum), TAYCAN (for TRICE), SFL (probably TAYCAN), OMNIA (for APEX), NAC (for NAC), KAG (Kinesis), CEM (crypto emergency), XVM (for Venidium), NEVM (for NEVM), IGT20 (for IGNITE), FILM (FILMCredits), CC (CloudCoin), MERGE (MERGE), LTNM (Bitcoin latinum), PLUGCN ( PlugChain), DINGO (dingo), LED (LEDGIS), AVAT (AVAT), VSOL (Vsolidus), EPIC (EPIC cash), NFC (netflowcoin), mrx (Metrix Coin), Idena (idena network), PKT (PKT Cash), BondDex (BondDex), XBN (XBN), KALAM (Kalamint), REV (RChain), KRC20 (MyDeFiPet), ARC20 (Hurricane Token), GMD (Coop network), BERS (Berith), ZEBI (Zebi), BRC (Baer Chain), DAPS (DAPS Coin), APL (Gold Secured Currency), NDAU (NDAU), WICC (WICC), UPG (Unipay God), TSL (TreasureSL), MXW (Maxonrow), CLC (Cifculation), SMH (SMH Coin), XIN (CPCoin), RDD (ReddCoin), OK (Okcash), KAR (KAR), CCX (ConcealNetwork),
        },
        defaultType: "spot",
        fetchBalance: {
          type: "spot"
          // 'spot', 'swap', 'account'
        },
        accountsByType: {
          spot: "spot",
          swap: "swap"
        },
        createMarketBuyOrderRequiresPrice: !0,
        brokerId: "CCXTxBitmart000"
      }
    });
  }
  isUsingForcedProxy(e = {}, t = "public") {
    return t === "private";
  }
  async fetchTime(e = {}) {
    const t = await this.publicGetSystemTime(e), i = this.safeValue(t, "data", {});
    return this.safeInteger(i, "server_time");
  }
  async fetchStatus(e = {}) {
    const t = this.safeValue(this.options, "fetchStatus", {}), i = this.safeString(this.options, "defaultType");
    let s = this.safeString(t, "type", i);
    s = this.safeString(e, "type", s), e = this.omit(e, "type");
    const n = await this.publicGetSystemService(e), r = this.safeValue(n, "data", {}), a = this.safeValue(r, "service", []), o = this.indexBy(a, "service_type");
    s === "swap" && (s = "contract");
    const c = this.safeValue(o, s);
    let u, f;
    return c !== void 0 && (this.safeInteger(c, "status") === 2 ? u = "ok" : (u = "maintenance", f = this.safeInteger(c, "end_time"))), {
      status: u,
      updated: void 0,
      eta: f,
      url: void 0,
      info: n
    };
  }
  async fetchSpotMarkets(e = {}) {
    const t = await this.publicGetSpotV1SymbolsDetails(e), i = this.safeValue(t, "data", {}), s = this.safeValue(i, "symbols", []), n = [];
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeString(a, "symbol"), c = this.safeInteger(a, "symbol_id"), u = this.safeString(a, "base_currency"), f = this.safeString(a, "quote_currency"), h = this.safeCurrencyCode(u), l = this.safeCurrencyCode(f), p = h + "/" + l, m = this.safeString(a, "min_buy_amount"), y = this.safeString(a, "min_sell_amount"), w = P.stringMax(m, y), S = this.safeNumber(a, "base_min_size");
      n.push({
        id: o,
        numericId: c,
        symbol: p,
        base: h,
        quote: l,
        settle: void 0,
        baseId: u,
        quoteId: f,
        settleId: void 0,
        type: "spot",
        spot: !0,
        margin: !1,
        swap: !1,
        future: !1,
        option: !1,
        active: !0,
        contract: !1,
        linear: void 0,
        inverse: void 0,
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: S,
          price: this.parseNumber(this.parsePrecision(this.safeString(a, "price_max_precision")))
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: S,
            max: this.safeNumber(a, "base_max_size")
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.parseNumber(w),
            max: void 0
          }
        },
        created: void 0,
        info: a
      });
    }
    return n;
  }
  async fetchContractMarkets(e = {}) {
    const t = await this.publicGetContractPublicDetails(e), i = this.safeValue(t, "data", {}), s = this.safeValue(i, "symbols", []), n = [];
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeString(a, "symbol"), c = this.safeString(a, "base_currency"), u = this.safeString(a, "quote_currency"), f = this.safeCurrencyCode(c), h = this.safeCurrencyCode(u), l = "USDT", p = this.safeCurrencyCode(l), m = f + "/" + h + ":" + p, y = this.safeInteger(a, "product_type"), w = y === 1, S = y === 2;
      let b = this.safeInteger(a, "expire_timestamp");
      !S && b === 0 && (b = void 0), n.push({
        id: o,
        numericId: void 0,
        symbol: m,
        base: f,
        quote: h,
        settle: p,
        baseId: c,
        quoteId: u,
        settleId: l,
        type: w ? "swap" : "future",
        spot: !1,
        margin: !1,
        swap: w,
        future: S,
        option: !1,
        active: !0,
        contract: !0,
        linear: !0,
        inverse: !1,
        contractSize: this.safeNumber(a, "contract_size"),
        expiry: b,
        expiryDatetime: this.iso8601(b),
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.safeNumber(a, "vol_precision"),
          price: this.safeNumber(a, "price_precision")
        },
        limits: {
          leverage: {
            min: this.safeNumber(a, "min_leverage"),
            max: this.safeNumber(a, "max_leverage")
          },
          amount: {
            min: this.safeNumber(a, "min_volume"),
            max: this.safeNumber(a, "max_volume")
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: void 0,
            max: void 0
          }
        },
        created: this.safeInteger(a, "open_timestamp"),
        info: a
      });
    }
    return n;
  }
  async fetchMarkets(e = {}) {
    const t = await this.fetchSpotMarkets(e), i = await this.fetchContractMarkets(e);
    return this.arrayConcat(t, i);
  }
  safeCurrencyCode(e) {
    const t = /[-|_][A-Z0-9]+$/;
    return e.replace(t, "");
  }
  safeCurrencyByCode(e) {
    return this.safeValue(this.currencies, e);
  }
  async fetchCurrencies(e = {}) {
    const t = await this.publicGetAccountV1Currencies(e), i = this.safeValue(t, "data", {}), s = this.safeValue(i, "currencies", []), n = {};
    this.options.currencyIdsByCodeAndNetwork = {};
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeString(a, "currency"), c = this.safeString(a, "network"), u = this.safeValue(this.options, "networksById", {}), f = this.safeString(u, c, c), h = this.safeCurrencyCode(o);
      this.safeValue(this.options.currencyIdsByCodeAndNetwork, h) === void 0 && (this.options.currencyIdsByCodeAndNetwork[h] = {}), this.options.currencyIdsByCodeAndNetwork[h][f] = this.safeString(a, "currency");
      const l = this.safeValue(a, "withdraw_enabled"), p = this.safeValue(a, "deposit_enabled"), m = this.safeNumber(a, "withdraw_minfee"), y = this.safeNumber(a, "withdraw_minsize"), w = {
        id: o,
        network: f,
        deposit: p,
        withdraw: l,
        fee: m,
        limits: {
          amount: { min: void 0, max: void 0 },
          withdraw: { min: y, max: void 0 }
        }
      };
      n[h] === void 0 ? n[h] = {
        id: h,
        code: h,
        active: p && l,
        deposit: p,
        withdraw: l,
        networks: [w]
      } : (n[h].networks.push(w), n[h].active = n[h].active || l || p, n[h].deposit = n[h].deposit || p, n[h].withdraw = n[h].withdraw || l);
    }
    return await this.cache.set({
      data: this.options.currencyIdsByCodeAndNetwork,
      key: cd(this.id),
      clone: !1,
      ttl: null
    }), this.currencies = this.deepExtend(this.currencies, n), n;
  }
  async fetchTransactionFee(e, t = {}) {
    await this.loadMarkets();
    const s = {
      currency: this.currency(e).id
    }, n = await this.privateGetAccountV1WithdrawCharge(this.extend(s, t)), r = n.data, a = {};
    return a[e] = this.safeNumber(r, "withdraw_fee"), {
      info: n,
      withdraw: a,
      deposit: {}
    };
  }
  parseDepositWithdrawFee(e, t = void 0) {
    return {
      info: e,
      withdraw: {
        fee: this.safeNumber(e, "withdraw_fee"),
        percentage: void 0
      },
      deposit: {
        fee: void 0,
        percentage: void 0
      },
      networks: {}
    };
  }
  async fetchDepositWithdrawFee(e, t = {}) {
    await this.loadMarkets();
    const s = {
      currency: this.currency(e).id
    }, r = (await this.privateGetAccountV1WithdrawCharge(this.extend(s, t))).data;
    return this.parseDepositWithdrawFee(r);
  }
  parseTicker(e, t = void 0) {
    const i = this.safeInteger(e, "timestamp"), s = this.safeString2(e, "symbol", "contract_symbol");
    t = this.safeMarket(s, t);
    const n = t.symbol, r = this.safeString2(e, "close_24h", "last_price");
    let a = this.safeString(e, "price_change_percent_24h");
    if (a === void 0) {
      const l = this.safeString(e, "fluctuation");
      if (l !== void 0 && l !== "0") {
        const p = l[0];
        a = p + P.stringMul(l.replace(p, ""), "100");
      } else
        l === "0" && (a = "0");
    }
    const o = this.safeString(e, "base_volume_24h");
    let c = this.safeString(e, "quote_volume_24h");
    c = this.safeString(e, "volume_24h", c);
    const u = this.safeString2(e, "avg_price", "index_price"), f = this.safeString2(e, "high_24h", "high_price"), h = this.safeString2(e, "low_24h", "low_price");
    return this.safeTicker({
      symbol: n,
      timestamp: i,
      datetime: this.iso8601(i),
      high: f,
      low: h,
      bid: this.safeString(e, "best_bid"),
      bidVolume: this.safeString(e, "best_bid_size"),
      ask: this.safeString(e, "best_ask"),
      askVolume: this.safeString(e, "best_ask_size"),
      vwap: void 0,
      open: this.safeString(e, "open_24h"),
      close: r,
      last: r,
      previousClose: void 0,
      change: void 0,
      percentage: a,
      average: u,
      baseVolume: o,
      quoteVolume: c,
      info: e
    }, t);
  }
  parseTickerV3(e, t = void 0) {
    const i = this.safeInteger(e, "ts", this.milliseconds()), s = this.safeString(e, "symbol");
    t = this.safeMarket(s, t);
    const n = t.symbol, r = this.safeString(e, "last");
    let a;
    const o = this.safeString(e, "fluctuation");
    if (o !== void 0 && o !== "0") {
      const c = o[0];
      a = c + P.stringMul(o.replace(c, ""), "100");
    } else
      o === "0" && (a = "0");
    return this.safeTicker({
      symbol: n,
      timestamp: i,
      datetime: this.iso8601(i),
      high: this.safeString(e, "high_24h"),
      low: this.safeString(e, "low_24h"),
      bid: this.safeString(e, "bid_px"),
      bidVolume: this.safeString(e, "bid_sz"),
      ask: this.safeString(e, "ask_px"),
      askVolume: this.safeString(e, "ask_sz"),
      vwap: void 0,
      open: this.safeString(e, "open_24h"),
      close: r,
      last: r,
      previousClose: void 0,
      change: void 0,
      percentage: a,
      average: void 0,
      baseVolume: this.safeString(e, "v_24h"),
      quoteVolume: this.safeString(e, "qv_24h"),
      info: e
    }, t);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {};
    let n;
    if (i.swap)
      s.contract_symbol = i.id, n = await this.publicGetContractV1Tickers(this.extend(s, t));
    else if (i.spot)
      s.symbol = i.id, n = await this.publicGetSpotQuotationV3Ticker(this.extend(s, t));
    else
      throw new ge(i.type).addMessage("only spot and swap markets are accepted").exchange(this.id);
    const r = this.safeValue(n, "data", {});
    let a, o;
    if (i.spot)
      o = this.parseTickerV3(r, i);
    else if (i.swap) {
      const c = this.safeValue(r, "tickers", []);
      a = this.indexBy(c, "contract_symbol");
      const u = this.safeValue(a, i.id);
      o = this.parseTicker(u, i);
    }
    return o;
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    let i, s;
    if (e !== void 0) {
      const c = this.safeValue(e, 0);
      s = this.market(c);
    }
    [i, t] = this.handleMarketTypeAndParams("fetchTickers", s, t);
    let n;
    if (i === "spot")
      n = await this.publicGetSpotV2Ticker(t);
    else if (i === "swap")
      n = await this.publicGetContractV1Tickers(t);
    else
      throw new ge(i).addMessage("only spot and swap markets are accepted").exchange(this.id);
    const r = this.safeValue(n, "data", {}), a = this.safeValue(r, "tickers", []), o = {};
    for (let c = 0; c < a.length; c++) {
      const u = this.parseTicker(a[c]), f = u.symbol;
      o[f] = u;
    }
    return this.filterByArrayTickers(o, "symbol", e);
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e), n = {
      symbol: s.id
    };
    let r;
    if (s.spot)
      t !== void 0 && (n.limit = t), r = await this.publicGetSpotQuotationV3Books(this.extend(n, i));
    else if (s.swap)
      r = await this.publicGetContractPublicDepth(this.extend(n, i));
    else
      throw new O().addMessage("fetchOrderBook() does not support " + s.type + " markets, only spot and swap markets are accepted").exchange(this.id);
    const a = this.safeValue(r, "data", {}), o = this.safeInteger2(a, "ts", "timestamp");
    return this.parseOrderBook(a, s.symbol, o);
  }
  parseTrade(e, t = void 0) {
    const i = this.safeIntegerN(e, ["order_time", "createTime", "create_time"]), s = "order_time" in e;
    let n, r, a, o;
    s ? (n = this.safeString(e, "count"), r = this.safeString(e, "amount"), o = this.safeString(e, "type")) : (n = this.safeStringN(e, ["size", "vol", "fillQty"]), r = this.safeString(e, "notional"), a = this.safeString(e, "type"), o = this.parseOrderSide(this.safeString(e, "side")));
    const c = this.safeString(e, "symbol");
    t = this.safeMarket(c, t);
    const u = this.safeString2(e, "fee", "paid_fees");
    let f;
    if (u !== void 0) {
      const h = this.safeString(e, "feeCoinName");
      let l = this.safeCurrencyCode(h);
      l === void 0 && (l = o === "buy" ? t.base : t.quote), f = {
        cost: u,
        currency: l
      };
    }
    return this.safeTrade({
      info: e,
      id: this.safeStringN(e, ["tradeId", "trade_id", "lastTradeID"]),
      order: this.safeString2(e, "orderId", "order_id"),
      timestamp: i,
      datetime: this.iso8601(i),
      symbol: t.symbol,
      type: a,
      side: o,
      price: this.safeString2(e, "price", "fillPrice"),
      amount: n,
      cost: r,
      takerOrMaker: this.safeStringLower2(e, "tradeRole", "exec_type"),
      fee: f
    }, t);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.market(e);
    if (!n.spot)
      throw new ge(n.type).addMessage("only spot orders are accepted").exchange(this.id);
    const r = {
      symbol: n.id
    }, a = await this.publicGetSpotV1SymbolsTrades(this.extend(r, s)), o = this.safeValue(a, "data", {}), c = this.safeValue(o, "trades", []);
    return this.parseTrades(c, n, t, i);
  }
  parseOHLCV(e, t = void 0) {
    return Array.isArray(e) ? [
      this.safeTimestamp(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 2),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 5)
    ] : [
      this.safeTimestamp2(e, "timestamp", "ts"),
      this.safeNumber2(e, "open_price", "o"),
      this.safeNumber2(e, "high_price", "h"),
      this.safeNumber2(e, "low_price", "l"),
      this.safeNumber2(e, "close_price", "c"),
      this.safeNumber2(e, "volume", "v")
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate", !1), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 200);
    const a = this.market(e), o = this.parseTimeframe(t), c = this.safeInteger(this.timeframes, t);
    let u = {
      symbol: a.id
    };
    if (c !== void 0 ? u.step = c : u.step = t, a.spot)
      [u, n] = this.handleUntilOption("before", u, n, 1e-3), s !== void 0 && (u.limit = s), i !== void 0 && (u.after = this.parseToInt(i / 1e3) - 1);
    else {
      s === void 0 && (s = 1200), s = Math.min(1200, s);
      const p = this.parseToInt(this.milliseconds() / 1e3);
      if (i === void 0) {
        const m = p - s * o;
        u.start_time = m, u.end_time = p;
      } else {
        const m = this.parseToInt(i / 1e3) - 1, y = this.sum(m, s * o);
        u.start_time = m, u.end_time = Math.min(y, p);
      }
      [u, n] = this.handleUntilOption("end_time", u, n, 1e-3);
    }
    let f;
    a.swap ? f = await this.publicGetContractPublicKline(this.extend(u, n)) : f = await this.publicGetSpotQuotationV3Klines(this.extend(u, n));
    const h = this.safeValue(f, "data", []);
    return this.parseOHLCVs(h, a, t, i, s);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {};
    e !== void 0 && (n = this.market(e), r.symbol = n.id);
    let a, o;
    [a, s] = this.handleMarketTypeAndParams("fetchMyTrades", n, s);
    const c = this.safeIntegerN(s, ["until", "endTime", "end_time"]);
    if (s = this.omit(s, ["until"]), a === "spot") {
      let f;
      [f, s] = this.handleMarginModeAndParams("fetchMyTrades", s), f === "isolated" && (r.orderMode = "iso_margin");
      const h = this.safeValue(this.options, "fetchMyTrades", {}), l = this.safeInteger(h, "limit", 200);
      i === void 0 && (i = l), r.limit = i, t !== void 0 && (r.startTime = t), c !== void 0 && (r.endTime = c), o = await this.privatePostSpotV4QueryTrades(this.extend(r, s));
    } else if (a === "swap") {
      if (e === void 0)
        throw new g("fetchMyTrades() requires a symbol argument").exchange(this.id);
      t !== void 0 && (r.start_time = t), c !== void 0 && (r.end_time = c), o = await this.privateGetContractPrivateTrades(this.extend(r, s));
    } else
      throw new ge(a).addMessage("only spot and swap orders are accepted").exchange(this.id);
    const u = this.safeValue(o, "data", []);
    return this.parseTrades(u, n, t, i);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = {
      orderId: e
    }, a = await this.privatePostSpotV4QueryOrderTrades(this.extend(r, n)), o = this.safeValue(a, "data", {});
    return this.parseTrades(o, void 0, i, s);
  }
  customParseBalance(e, t) {
    const i = this.safeValue(e, "data", {});
    let s;
    t === "usd-m" || t === "coin-m" ? s = this.safeValue(e, "data", []) : t === "margin" ? s = this.safeValue(i, "symbols", []) : s = this.safeValue(i, "wallet", []);
    const n = { info: e };
    if (t === "margin") {
      for (let r = 0; r < s.length; r++) {
        const a = s[r], o = this.safeString(a, "symbol"), c = this.safeSymbol(o, void 0, "_"), u = this.safeValue(a, "base", {}), f = this.safeValue(a, "quote", {}), h = this.safeCurrencyCode(this.safeString(u, "currency")), l = this.safeCurrencyCode(this.safeString(f, "currency")), p = {};
        p[h] = this.parseBalanceHelper(u), p[l] = this.parseBalanceHelper(f), n[c] = this.safeBalance(p);
      }
      return n;
    } else {
      for (let r = 0; r < s.length; r++) {
        const a = s[r];
        let o = this.safeString2(a, "id", "currency");
        o = this.safeString(a, "coin_code", o);
        const c = this.safeCurrencyCode(o), u = this.account();
        u.free = this.safeString2(a, "available", "available_balance"), u.used = this.safeString2(a, "frozen", "frozen_balance"), n[c] = u;
      }
      return this.safeBalance(n);
    }
  }
  parseBalanceHelper(e) {
    const t = this.account();
    t.used = this.safeString(e, "frozen"), t.free = this.safeString(e, "available"), t.total = this.safeString(e, "total_asset");
    const i = this.safeString(e, "borrow_unpaid"), s = this.safeString(e, "interest_unpaid");
    return t.debt = P.stringAdd(i, s), t;
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    let t;
    [t, e] = this.handleMarketTypeAndParams("fetchBalance", void 0, e);
    const i = this.safeString(e, "marginMode"), s = this.safeBool(e, "margin", !1);
    e = this.omit(e, ["margin", "marginMode"]), (i !== void 0 || s) && (t = "margin");
    let n;
    if (t === "spot")
      n = await this.privateGetSpotV1Wallet(e);
    else if (t === "usd-m" || t === "coin-m")
      n = await this.privateGetContractPrivateAssetsDetail(e), n.data = n.data.filter((r) => t === "usd-m" ? Pd.includes(r.currency) : !Pd.includes(r.currency));
    else if (t === "account")
      n = await this.privateGetAccountV1Wallet(e);
    else if (t === "margin")
      n = await this.privateGetSpotV1MarginIsolatedAccount(e);
    else
      throw new ge(t).addMessage("only spot, swap and account and margin markets are accepted").exchange(this.id);
    return this.customParseBalance(n, t);
  }
  parseTradingFee(e, t = void 0) {
    const i = this.safeString(e, "symbol"), s = this.safeSymbol(i);
    return {
      info: e,
      symbol: s,
      maker: this.safeNumber(e, "maker_fee_rate"),
      taker: this.safeNumber(e, "taker_fee_rate")
    };
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e);
    if (!i.spot)
      throw new ge(i.type).addMessage("only spot orders are accepted").exchange(this.id);
    const s = {
      symbol: i.id
    }, n = await this.privateGetSpotV1TradeFee(this.extend(s, t)), r = this.safeValue(n, "data");
    return this.parseTradingFee(r);
  }
  parseOrder(e, t = void 0) {
    let i;
    typeof e == "string" && (i = e, e = {}), i = this.safeString2(e, "order_id", "orderId", i);
    const s = this.safeInteger2(e, "create_time", "createTime"), n = this.safeString(e, "symbol"), r = this.safeSymbol(n, t);
    t = this.safeMarket(r, t);
    const a = this.safeString(t, "type", "spot");
    let o = this.safeString(e, "type"), c, u;
    o === "limit_maker" && (o = "limit", u = !0, c = "PO"), o === "ioc" && (o = "limit", c = "IOC");
    let f = this.safeString(e, "price");
    f === "market price" && (f = void 0);
    const h = this.omitZero(this.safeString(e, "size")), l = this.omitZero(this.safeString2(e, "filled_size", "filledSize")), p = h && l && P.stringSub(h, l);
    return this.safeOrder({
      id: i,
      clientOrderId: this.safeString2(e, "client_order_id", "clientOrderId"),
      info: e,
      timestamp: s,
      datetime: this.iso8601(s),
      lastTradeTimestamp: this.safeInteger(e, "update_time"),
      symbol: r,
      type: o,
      timeInForce: c,
      postOnly: u,
      side: this.parseOrderSide(this.safeString(e, "side")),
      price: this.omitZero(f),
      stopPrice: void 0,
      triggerPrice: void 0,
      amount: h,
      cost: this.safeString2(e, "filled_notional", "filledNotional"),
      average: this.safeStringN(e, ["price_avg", "priceAvg", "deal_avg_price"]),
      filled: l,
      remaining: p,
      status: this.parseOrderStatusByType(a, this.safeString2(e, "status", "state")),
      fee: void 0,
      trades: void 0
    }, t);
  }
  parseOrderSide(e) {
    const t = {
      1: "buy",
      2: "buy",
      3: "sell",
      4: "sell"
    };
    return this.safeString(t, e, e);
  }
  parseOrderStatusByType(e, t) {
    const i = {
      spot: {
        1: "rejected",
        2: "open",
        3: "rejected",
        4: "open",
        5: "open",
        6: "closed",
        7: "canceled",
        8: "canceled",
        new: "open",
        partially_filled: "open",
        filled: "closed",
        partially_canceled: "canceled"
      },
      swap: {
        1: "open",
        2: "open",
        4: "closed"
        // Completed
      }
    }, s = this.safeValue(i, e, {});
    return this.safeString(s, t, t);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    if (await this.loadMarkets(), !this.market(e).spot)
      throw new O().addMessage("createMarketBuyOrderWithCost() supports spot orders only").exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = this.handleMarginModeAndParams("createOrder", r), c = this.safeString(o, 0), f = this.safeStringN(r, ["triggerPrice", "stopPrice", "trigger_price"]) !== void 0;
    let h;
    if (a.spot) {
      const m = this.createSpotOrderRequest(e, t, i, s, n, r);
      c === "isolated" ? h = await this.privatePostSpotV1MarginSubmitOrder(m) : h = await this.privatePostSpotV2SubmitOrder(m);
    } else {
      const m = this.createSwapOrderRequest(e, t, i, s, n, r);
      f ? h = await this.privatePostContractPrivateSubmitPlanOrder(m) : h = await this.privatePostContractPrivateSubmitOrder(m);
    }
    const l = this.safeValue(h, "data", {}), p = this.parseOrder(l, a);
    return p.type = t, p.side = i, p.amount = s, p.price = n, p;
  }
  createSwapOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const o = {
      symbol: this.market(e).id,
      type: t,
      size: parseInt(this.amountToPrecision(e, s))
    }, c = this.safeString(r, "timeInForce"), u = this.safeInteger(r, "mode"), f = t === "market";
    let h;
    const l = this.safeValue(r, "reduceOnly"), p = u === 4;
    [h, r] = this.handlePostOnly(f, p, r);
    const y = t === "limit" || h || (c === "IOC" || u === 3);
    c === "GTC" ? o.mode = 1 : c === "FOK" ? o.mode = 2 : c === "IOC" && (o.mode = 3), h && (o.mode = 4);
    const w = this.safeStringN(r, ["triggerPrice", "stopPrice", "trigger_price"]), S = w !== void 0, b = this.safeString2(r, "trailingTriggerPrice", "activation_price", this.numberToString(n)), T = this.safeString2(r, "trailingPercent", "callback_rate");
    y ? o.price = this.priceToPrecision(e, n) : (t === "trailing" || T !== void 0) && (o.callback_rate = T, o.activation_price = this.priceToPrecision(e, b), o.activation_price_type = this.safeInteger(r, "activation_price_type", 1)), S && (o.executive_price = this.priceToPrecision(e, n), o.trigger_price = this.priceToPrecision(e, w), o.price_type = this.safeInteger(r, "price_type", 1), i === "buy" ? l ? o.price_way = 2 : o.price_way = 1 : i === "sell" && (l ? o.price_way = 1 : o.price_way = 2)), i === "buy" ? l ? o.side = 2 : o.side = 1 : i === "sell" && (l ? o.side = 3 : o.side = 4);
    let v;
    [v, r] = this.handleMarginModeAndParams("createOrder", r, "cross"), o.open_type = v;
    const _ = this.safeString(r, "clientOrderId");
    _ !== void 0 && (r = this.omit(r, "clientOrderId"), o.client_order_id = _);
    const V = this.safeInteger(r, "leverage", 1);
    return r = this.omit(r, ["timeInForce", "postOnly", "reduceOnly", "leverage", "trailingTriggerPrice", "trailingPercent", "triggerPrice", "stopPrice"]), o.leverage = this.numberToString(V), this.extend(o, r);
  }
  createSpotOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.market(e), o = {
      symbol: a.id,
      side: i,
      type: t
    }, c = this.safeString(r, "timeInForce");
    if (c === "FOK")
      throw new g("createOrder() only accepts timeInForce parameter values of IOC or PO").exchange(this.id);
    const u = this.safeInteger(r, "mode"), f = t === "market";
    let h;
    const l = t === "limit_maker" || u === 4;
    [h, r] = this.handlePostOnly(f, l, r), r = this.omit(r, ["timeInForce", "postOnly"]);
    const p = c === "IOC" || t === "ioc";
    if (t === "limit" || h || p)
      o.size = this.amountToPrecision(e, s), o.price = this.priceToPrecision(e, n);
    else if (f)
      if (i === "buy") {
        let y = this.safeNumber2(r, "cost", "notional");
        r = this.omit(r, "cost");
        let w = !0;
        if ([w, r] = this.handleOptionAndParams(r, "createOrder", "createMarketBuyOrderRequiresPrice", !0), w) {
          if (n === void 0 && y === void 0)
            throw new g('createOrder() requires the price argument for market buy orders to calculate the total cost to spend (amount * price), alternatively set the createMarketBuyOrderRequiresPrice option or param to false and pass the cost to spend in the amount argument or in the "notional" extra parameter (the exchange-specific behaviour)').exchange(this.id);
          {
            const S = this.numberToString(s), b = this.numberToString(n);
            y = this.parseNumber(P.stringMul(S, b));
          }
        } else
          y = y === void 0 ? s : y;
        o.notional = this.decimalToPrecision(y, Et, a.precision.price, this.precisionMode);
      } else
        i === "sell" && (o.size = this.amountToPrecision(e, s));
    return h && (o.type = "limit_maker"), p && (o.type = "ioc"), this.extend(o, r);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), n = {
      symbol: s.id
    }, r = this.safeString2(i, "clientOrderId", "client_order_id");
    r !== void 0 ? n.client_order_id = r : n.order_id = e.toString(), i = this.omit(i, ["clientOrderId"]);
    let a;
    if (s.spot)
      a = await this.privatePostSpotV3CancelOrder(this.extend(n, i));
    else {
      const f = this.safeValue2(i, "stop", "trigger");
      i = this.omit(i, ["stop", "trigger"]), f ? a = await this.privatePostContractPrivateCancelPlanOrder(this.extend(n, i)) : a = await this.privatePostContractPrivateCancelOrder(this.extend(n, i));
    }
    if (s.swap)
      return a;
    const o = this.safeValue(a, "data");
    if (o === !0)
      return this.parseOrder(e, s);
    const c = this.safeValue(o, "succeed");
    if (c !== void 0) {
      if (e = this.safeString(c, 0), e === void 0)
        throw new k().addMessage("cancelOrder() failed to cancel " + t + " order id " + e).exchange(this.id);
    } else if (!this.safeValue(o, "result"))
      throw new k().addMessage("cancelOrder() " + t + " order id " + e + " is filled or canceled").exchange(this.id);
    const u = this.parseOrder(e, s);
    return this.extend(u, { id: e });
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {};
    let s;
    e !== void 0 && (s = this.market(e), i.symbol = s.id);
    let n, r;
    if ([r, t] = this.handleMarketTypeAndParams("cancelAllOrders", s, t), r === "spot")
      n = await this.privatePostSpotV1CancelOrders(this.extend(i, t));
    else if (r === "swap") {
      if (e === void 0)
        throw new g("cancelAllOrders() requires a symbol argument").exchange(this.id);
      n = await this.privatePostContractPrivateCancelOrders(this.extend(i, t));
    }
    return n;
  }
  async fetchOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    i && (s.limit = i), t && (s.startTime = t), e && (s.symbol = e);
    const n = await this.privatePostSpotV4QueryHistoryOrders(s), r = await this.privatePostSpotV4QueryOpenOrders(s), a = this.safeValue(n, "data", []), o = this.safeValue(r, "data", []);
    return this.parseOrders([...a, ...o], void 0, t, i);
  }
  async fetchOrdersByStatus(e, t = void 0, i = void 0, s = void 0, n = {}) {
    if (t === void 0)
      throw new g("fetchOrdersByStatus() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const r = this.market(t);
    if (!r.spot)
      throw new ge(r.type).addMessage("only spot orders are accepted").exchange(this.id);
    const a = {
      symbol: r.id,
      offset: 1,
      N: 100
      // max limit is 100
    };
    e === "open" ? a.status = 9 : e === "closed" ? a.status = 6 : e === "canceled" ? a.status = 8 : a.status = e;
    const o = await this.privateGetSpotV3Orders(this.extend(a, n)), c = this.safeValue(o, "data", {}), u = this.safeValue(c, "orders", []);
    return this.parseOrders(u, r, i, s);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {};
    e !== void 0 && (n = this.market(e), r.symbol = n.id), i !== void 0 && (r.limit = i);
    let a, o;
    if ([a, s] = this.handleMarketTypeAndParams("fetchOpenOrders", n, s), a === "spot") {
      let u;
      [u, s] = this.handleMarginModeAndParams("fetchOpenOrders", s), u === "isolated" && (r.orderMode = "iso_margin"), t !== void 0 && (r.startTime = t);
      const f = this.safeInteger2(s, "until", "endTime");
      f !== void 0 && (s = this.omit(s, ["endTime"]), r.endTime = f), o = await this.privatePostSpotV4QueryOpenOrders(this.extend(r, s));
    } else if (a === "swap") {
      const u = this.safeValue2(s, "stop", "trigger");
      if (s = this.omit(s, ["stop", "trigger"]), u)
        o = await this.privateGetContractPrivateCurrentPlanOrder(this.extend(r, s));
      else {
        const f = this.safeBool(s, "trailing", !1);
        let h = this.safeString(s, "orderType");
        s = this.omit(s, ["orderType", "trailing"]), f && (h = "trailing"), h !== void 0 && (r.type = h), o = await this.privateGetContractPrivateGetOpenOrders(this.extend(r, s));
      }
    } else
      throw new ge(a).addMessage("only spot and swap orders are accepted").exchange(this.id);
    const c = this.safeValue(o, "data", []);
    return this.parseOrders(c, n, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {};
    e !== void 0 && (n = this.market(e), r.symbol = n.id);
    let a;
    if ([a, s] = this.handleMarketTypeAndParams("fetchClosedOrders", n, s), a !== "spot" && e === void 0)
      throw new g("fetchClosedOrders() requires a symbol argument").exchange(this.id);
    let o;
    [o, s] = this.handleMarginModeAndParams("fetchClosedOrders", s), o === "isolated" && (r.orderMode = "iso_margin");
    const c = a === "spot" ? "startTime" : "start_time";
    t !== void 0 && (r[c] = t);
    const u = a === "spot" ? "endTime" : "end_time", f = this.safeInteger2(s, "until", u);
    f !== void 0 && (s = this.omit(s, ["until"]), r[u] = f);
    let h;
    a === "spot" ? h = await this.privatePostSpotV4QueryHistoryOrders(this.extend(r, s)) : h = await this.privateGetContractPrivateOrderHistory(this.extend(r, s));
    const l = this.safeValue(h, "data", []);
    return this.parseOrders(l, n, t, i);
  }
  async fetchCanceledOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchOrdersByStatus("canceled", e, t, i, s);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {};
    let n, r, a;
    if (t !== void 0 && (r = this.market(t)), [n, i] = this.handleMarketTypeAndParams("fetchOrder", r, i), n === "spot") {
      const c = this.safeString(i, "clientOrderId");
      c || (s.orderId = e), c !== void 0 ? a = await this.privatePostSpotV4QueryClientOrder(this.extend(s, i)) : a = await this.privatePostSpotV4QueryOrder(this.extend(s, i));
    } else if (n === "swap") {
      if (t === void 0)
        throw new g("fetchOrder() requires a symbol argument").exchange(this.id);
      const c = this.safeBool(i, "trailing", !1);
      let u = this.safeString(i, "orderType");
      i = this.omit(i, ["orderType", "trailing"]), c && (u = "trailing"), u !== void 0 && (s.type = u), s.symbol = r.id, s.order_id = e, a = await this.privateGetContractPrivateOrder(this.extend(s, i));
    }
    const o = this.safeValue(a, "data", {});
    return this.parseOrder(o, r);
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.safeString(t, "network"), s = this.safeValue(this.options.currencyIdsByCodeAndNetwork[e], i);
    if (s === void 0)
      throw new O().addMessage("fetchDepositAddress() does not support " + e + " with network " + i + ", specify a supported network in params.network").exchange(this.id);
    const n = {
      currency: s
    }, r = await this.privateGetAccountV1DepositAddress(this.extend(n, t)), a = this.safeValue(r, "data", {}), o = this.safeString(a, "address"), c = this.safeString(a, "address_memo"), u = this.safeString(a, "chain");
    let f;
    if (u !== void 0) {
      const h = u.split("-"), l = this.safeString(h, 1);
      f = this.safeNetwork(l);
    }
    return this.checkAddress(o), {
      currency: e,
      address: o,
      tag: c,
      network: f,
      info: r
    };
  }
  safeNetwork(e) {
    return e;
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), this.checkAddress(i), await this.loadMarkets();
    const r = this.safeString(n, "network"), a = this.safeValue(this.options.currencyIdsByCodeAndNetwork[e], r);
    if (a === void 0)
      throw new O().addMessage("fetchDepositAddress() does not support " + e + " with network " + r + ", specify a supported network in params.network").exchange(this.id);
    const o = this.currencyToPrecision(e, t, r), c = {
      currency: a,
      amount: o,
      destination: "To Digital Address",
      address: i
    };
    s !== void 0 && (c.address_memo = s);
    const u = await this.privatePostAccountV1WithdrawApply(this.extend(c, n)), f = this.safeValue(u, "data"), h = this.safeCurrencyByCode(e), l = this.parseTransaction(f, h);
    return this.extend(l, {
      code: e,
      address: i,
      tag: s
    });
  }
  async fetchTransactionsByType(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets(), s === void 0 && (s = 50);
    const r = {
      operation_type: e,
      offset: 1,
      N: s
    };
    if (t !== void 0) {
      const f = t;
      r.currency = f;
    }
    const a = await this.privateGetAccountV2DepositWithdrawHistory(this.extend(r, n)), o = this.safeValue(a, "data", {}), c = this.safeValue(o, "records", []), u = this.safeCurrencyByCode(t);
    return this.parseTransactions(c, u, i, s);
  }
  async fetchDeposit(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      id: e
    }, n = await this.privateGetAccountV1DepositWithdrawDetail(this.extend(s, i)), r = this.safeValue(n, "data", {}), a = this.safeValue(r, "record", {});
    return this.parseTransaction(a);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchTransactionsByType("deposit", e, t, i, s);
  }
  async fetchWithdrawal(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      id: e
    }, n = await this.privateGetAccountV1DepositWithdrawDetail(this.extend(s, i)), r = this.safeValue(n, "data", {}), a = this.safeValue(r, "record", {});
    return this.parseTransaction(a);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchTransactionsByType("withdraw", e, t, i, s);
  }
  parseTransactionStatus(e) {
    const t = {
      0: "pending",
      1: "pending",
      2: "pending",
      3: "ok",
      4: "canceled",
      5: "failed"
      // Fail
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    let i;
    const s = this.safeString(e, "withdraw_id"), n = this.safeString(e, "deposit_id");
    let r;
    s !== void 0 && s !== "" ? (r = "withdraw", i = s) : n !== void 0 && n !== "" && (r = "deposit", i = n);
    const a = this.safeNumber(e, "arrival_amount"), o = this.safeInteger(e, "apply_time"), c = this.safeString(e, "currency");
    let u = this.safeCurrencyCode(c);
    const f = this.parseTransactionStatus(this.safeString(e, "status")), h = this.safeNumber(e, "fee");
    let l;
    h !== void 0 && (l = {
      cost: h,
      currency: u
    });
    const p = this.safeString(e, "tx_id"), m = this.safeString(e, "address"), y = this.safeString(e, "address_memo");
    let w;
    const S = "-";
    if (u.includes(S)) {
      const b = u.split(S);
      w = this.safeNetwork(b[1]), u = u.replace("-" + w.toUpperCase(), ""), l.currency.includes(S) && (l.currency = l.currency.split(S)[0]);
    }
    return {
      info: e,
      id: i,
      currency: u,
      amount: a,
      network: w,
      address: m,
      addressFrom: void 0,
      addressTo: void 0,
      tag: y,
      tagFrom: void 0,
      tagTo: void 0,
      status: f,
      type: r,
      updated: void 0,
      txid: p,
      internal: void 0,
      comment: void 0,
      timestamp: o !== 0 ? o : void 0,
      datetime: o !== 0 ? this.iso8601(o) : void 0,
      fee: l
    };
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currencyToPrecision(e, t), o = {
      amount: r,
      currency: e
    }, c = this.convertTypeToAccount(i), u = this.convertTypeToAccount(s);
    if (i === "spot")
      s === "margin" ? (o.side = "in", o.symbol = u) : s === "swap" && (o.type = "spot_to_contract");
    else if (s === "spot")
      i === "margin" ? (o.side = "out", o.symbol = c) : i === "swap" && (o.type = "contract_to_spot");
    else
      throw new g("transfer() requires either fromAccount or toAccount to be spot").exchange(this.id);
    let f;
    i === "margin" || s === "margin" ? f = await this.privatePostSpotV1MarginIsolatedTransfer(this.extend(o, n)) : (i === "swap" || s === "swap") && (f = await this.privatePostAccountV1TransferContract(this.extend(o, n)));
    const h = this.safeCurrencyByCode(e), l = this.safeValue(f, "data", {});
    return this.extend(this.parseTransfer(l, h), {
      amount: this.parseNumber(r),
      fromAccount: i,
      toAccount: s,
      status: this.parseTransferStatus(this.safeString2(f, "code", "message"))
    });
  }
  parseTransferStatus(e) {
    const t = {
      1e3: "ok",
      OK: "ok",
      FINISHED: "ok"
    };
    return this.safeString(t, e, e);
  }
  parseTransferToAccount(e) {
    const t = {
      contract_to_spot: "spot",
      spot_to_contract: "swap"
    };
    return this.safeString(t, e, e);
  }
  parseTransferFromAccount(e) {
    const t = {
      contract_to_spot: "swap",
      spot_to_contract: "spot"
    };
    return this.safeString(t, e, e);
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeString(e, "currency"), s = this.safeInteger(e, "timestamp");
    return {
      id: this.safeString(e, "transfer_id"),
      timestamp: s,
      datetime: this.iso8601(s),
      currency: this.safeCurrencyCode(i),
      amount: this.safeNumber(e, "amount"),
      fromAccount: this.parseTransferFromAccount(this.safeString(e, "type")),
      toAccount: this.parseTransferToAccount(this.safeString(e, "type")),
      status: this.parseTransferStatus(this.safeString(e, "state"))
    };
  }
  async fetchTransfers(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets(), i === void 0 && (i = 10);
    const n = {
      page: this.safeInteger(s, "page", 1),
      limit: i
      // default is 10, max is 100
    };
    let r;
    e !== void 0 && (r = this.currency(e), n.currency = r.id), t !== void 0 && (n.time_start = t), i !== void 0 && (n.limit = i);
    const a = this.safeInteger2(s, "until", "till"), o = this.safeInteger(s, "time_end", a);
    s = this.omit(s, ["till", "until"]), o !== void 0 && (n.time_end = o);
    const c = await this.privatePostAccountV1TransferContractList(this.extend(n, s)), u = this.safeValue(c, "data", {}), f = this.safeValue(u, "records", []);
    return this.parseTransfers(f, r, t, i);
  }
  async fetchPosition(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    }, n = await this.privateGetContractPrivatePosition(this.extend(s, t)), r = this.safeValue(n, "data", []), a = this.safeValue(r, 0, {});
    return this.parsePosition(a, i);
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets();
    let i, s;
    if (e !== void 0) {
      s = e.length;
      const c = this.safeString(e, 0);
      i = this.market(c);
    }
    const n = {};
    s === 1 && (n.symbol = i.id);
    const r = await this.privateGetContractPrivatePosition(this.extend(n, t)), a = this.safeValue(r, "data", []), o = [];
    for (let c = 0; c < a.length; c++)
      o.push(this.parsePosition(a[c]));
    return e = this.marketSymbols(e), this.filterByArrayPositions(o, "symbol", e, !1);
  }
  async loadMarketsHelper(e, t) {
    await super.loadMarketsHelper(e, t);
    const i = await this.cache.get(cd(this.id), { clone: !1 });
    this.options.currencyIdsByCodeAndNetwork = i == null ? void 0 : i.data;
  }
  parsePosition(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t);
    const s = t.symbol, n = this.safeInteger(e, "timestamp"), r = this.safeInteger(e, "position_type"), a = this.safeString(e, "maintenance_margin"), o = this.safeString(e, "current_value"), c = this.safeString(e, "position_cross"), u = P.stringDiv(a, o), f = P.stringDiv(a, c);
    return this.safePosition({
      info: e,
      id: void 0,
      symbol: s,
      timestamp: n,
      datetime: this.iso8601(n),
      lastUpdateTimestamp: void 0,
      hedged: void 0,
      side: r === 1 ? "long" : "short",
      contracts: this.safeNumber(e, "current_amount"),
      contractSize: this.safeNumber(t, "contractSize"),
      entryPrice: this.safeNumber(e, "entry_price"),
      markPrice: this.safeNumber(e, "mark_price"),
      lastPrice: void 0,
      notional: this.parseNumber(o),
      leverage: this.safeNumber(e, "leverage"),
      collateral: this.parseNumber(c),
      initialMargin: void 0,
      initialMarginPercentage: void 0,
      maintenanceMargin: this.parseNumber(a),
      maintenanceMarginPercentage: this.parseNumber(u),
      unrealizedPnl: this.safeNumber(e, "unrealized_value"),
      realizedPnl: this.safeNumber(e, "realized_value"),
      liquidationPrice: void 0,
      marginMode: void 0,
      percentage: void 0,
      marginRatio: this.parseNumber(f),
      stopLossPrice: void 0,
      takeProfitPrice: void 0
    });
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    const a = ["contract/private/assets-detail"];
    let c = this.implodeHostname(a.includes(e) ? this.urls.api.restV2 : this.urls.api.rest) + "/" + this.implodeParams(e, s);
    const u = this.omit(s, this.extractParams(e));
    let f = "";
    const h = i === "GET" || i === "DELETE";
    if (h && Object.keys(u).length && (f = this.urlencode(u), c += "?" + f), t === "private") {
      this.checkRequiredCredentials();
      const l = this.nonce().toString(), p = this.safeString(this.options, "brokerId", "CCXTxBitmart000");
      n = {
        "X-BM-KEY": this.apiKey,
        "X-BM-TIMESTAMP": l,
        "X-BM-BROKER-ID": p,
        "Content-Type": "application/json"
      }, h || (r = this.json(u), f = r);
      const m = l + "#" + this.uid + "#" + f;
      let y;
      this.externalSigner ? y = await this.externalSigner.sign({
        payload: this.encode(m),
        publicApiKey: this.apiKey,
        exchangeId: this.id
      }) : y = this.hmac(this.encode(m), this.encode(this.secret), Re), n["X-BM-SIGN"] = y;
    }
    return { url: c, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (a === void 0)
      return;
    const u = this.safeStringLower(a, "message"), f = u !== void 0 && u !== "ok" && u !== "success", h = this.safeString(a, "code");
    if (h !== void 0 && h !== "1000" || f) {
      const p = h + ": " + u;
      throw this.throwExactlyMatchedException(this.exceptions.exact, h, p), this.throwBroadlyMatchedException(this.exceptions.broad, h, p), this.throwExactlyMatchedException(this.exceptions.exact, u, p), this.throwBroadlyMatchedException(this.exceptions.broad, u, p), new O().addMessage(p).exchange(this.id);
    }
  }
}
let Wy = class extends gt {
};
class Yy extends Wy {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "bitstamp",
      name: "Bitstamp",
      countries: ["GB"],
      // 8000 requests per 10 minutes = 8000 / 600 = 13.33333333 requests per second => 1000ms / 13.33333333 = 75ms between requests on average
      rateLimit: 75,
      version: "v2",
      userAgent: this.userAgents.chrome,
      pro: !0,
      has: {
        CORS: !0,
        spot: !0,
        margin: !1,
        swap: !1,
        future: !1,
        option: !1,
        cancelAllOrders: !0,
        cancelOrder: !0,
        createOrder: !0,
        fetchBalance: !0,
        fetchCurrencies: !0,
        fetchDepositAddress: !0,
        fetchDepositsWithdrawals: !0,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchPosition: !1,
        fetchPositions: !1,
        fetchPositionsRisk: !1,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !0,
        fetchTransactionFees: !0,
        fetchTransactions: "emulated",
        fetchWithdrawals: !0,
        withdraw: !0
      },
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/27786377-8c8ab57e-5fe9-11e7-8ea4-2b05b6bcceec.jpg",
        api: {
          public: "https://www.bitstamp.net/api",
          private: "https://www.bitstamp.net/api"
        },
        www: "https://www.bitstamp.net",
        doc: "https://www.bitstamp.net/api"
      },
      timeframes: {
        "1m": "60",
        "3m": "180",
        "5m": "300",
        "15m": "900",
        "30m": "1800",
        "1h": "3600",
        "2h": "7200",
        "4h": "14400",
        "6h": "21600",
        "12h": "43200",
        "1d": "86400",
        "1w": "259200"
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0
      },
      api: {
        public: {
          get: {
            "ohlc/{pair}/": 1,
            "order_book/{pair}/": 1,
            "ticker/": 1,
            "ticker_hour/{pair}/": 1,
            "ticker/{pair}/": 1,
            "transactions/{pair}/": 1,
            "trading-pairs-info/": 1,
            "currencies/": 1,
            "eur_usd/": 1,
            "travel_rule/vasps/": 1
          }
        },
        private: {
          get: {
            "travel_rule/contacts/": 1,
            "contacts/{contact_uuid}/": 1,
            "earn/subscriptions/": 1,
            "earn/transactions/": 1
          },
          post: {
            "account_balances/": 1,
            "account_balances/{currency}/": 1,
            "balance/": 1,
            "balance/{pair}/": 1,
            "bch_withdrawal/": 1,
            "bch_address/": 1,
            "user_transactions/": 1,
            "user_transactions/{pair}/": 1,
            "crypto-transactions/": 1,
            "open_orders/all/": 1,
            "open_orders/{pair}/": 1,
            "order_status/": 1,
            "cancel_order/": 1,
            "cancel_all_orders/": 1,
            "cancel_all_orders/{pair}/": 1,
            "buy/{pair}/": 1,
            "buy/market/{pair}/": 1,
            "buy/instant/{pair}/": 1,
            "sell/{pair}/": 1,
            "sell/market/{pair}/": 1,
            "sell/instant/{pair}/": 1,
            "transfer-to-main/": 1,
            "transfer-from-main/": 1,
            "my_trading_pairs/": 1,
            "fees/trading/": 1,
            "fees/trading/{pair}": 1,
            "fees/withdrawal/": 1,
            "fees/withdrawal/{currency}/": 1,
            "withdrawal-requests/": 1,
            "withdrawal/open/": 1,
            "withdrawal/status/": 1,
            "withdrawal/cancel/": 1,
            "liquidation_address/new/": 1,
            "liquidation_address/info/": 1,
            "btc_unconfirmed/": 1,
            "websockets_token/": 1,
            // individual coins
            "btc_withdrawal/": 1,
            "btc_address/": 1,
            "ripple_withdrawal/": 1,
            "ripple_address/": 1,
            "ltc_withdrawal/": 1,
            "ltc_address/": 1,
            "eth_withdrawal/": 1,
            "eth_address/": 1,
            "xrp_withdrawal/": 1,
            "xrp_address/": 1,
            "xlm_withdrawal/": 1,
            "xlm_address/": 1,
            "pax_withdrawal/": 1,
            "pax_address/": 1,
            "link_withdrawal/": 1,
            "link_address/": 1,
            "usdc_withdrawal/": 1,
            "usdc_address/": 1,
            "omg_withdrawal/": 1,
            "omg_address/": 1,
            "dai_withdrawal/": 1,
            "dai_address/": 1,
            "knc_withdrawal/": 1,
            "knc_address/": 1,
            "mkr_withdrawal/": 1,
            "mkr_address/": 1,
            "zrx_withdrawal/": 1,
            "zrx_address/": 1,
            "gusd_withdrawal/": 1,
            "gusd_address/": 1,
            "aave_withdrawal/": 1,
            "aave_address/": 1,
            "bat_withdrawal/": 1,
            "bat_address/": 1,
            "uma_withdrawal/": 1,
            "uma_address/": 1,
            "snx_withdrawal/": 1,
            "snx_address/": 1,
            "uni_withdrawal/": 1,
            "uni_address/": 1,
            "yfi_withdrawal/": 1,
            yfi_address: 1,
            "audio_withdrawal/": 1,
            "audio_address/": 1,
            "crv_withdrawal/": 1,
            "crv_address/": 1,
            "algo_withdrawal/": 1,
            "algo_address/": 1,
            "comp_withdrawal/": 1,
            "comp_address/": 1,
            grt_withdrawal: 1,
            "grt_address/": 1,
            "usdt_withdrawal/": 1,
            "usdt_address/": 1,
            "eurt_withdrawal/": 1,
            "eurt_address/": 1,
            "matic_withdrawal/": 1,
            "matic_address/": 1,
            "sushi_withdrawal/": 1,
            "sushi_address/": 1,
            "chz_withdrawal/": 1,
            "chz_address/": 1,
            "enj_withdrawal/": 1,
            "enj_address/": 1,
            "alpha_withdrawal/": 1,
            "alpha_address/": 1,
            "ftt_withdrawal/": 1,
            "ftt_address/": 1,
            "storj_withdrawal/": 1,
            "storj_address/": 1,
            "axs_withdrawal/": 1,
            "axs_address/": 1,
            "sand_withdrawal/": 1,
            "sand_address/": 1,
            "hbar_withdrawal/": 1,
            "hbar_address/": 1,
            "rgt_withdrawal/": 1,
            "rgt_address/": 1,
            "fet_withdrawal/": 1,
            "fet_address/": 1,
            "skl_withdrawal/": 1,
            "skl_address/": 1,
            "cel_withdrawal/": 1,
            "cel_address/": 1,
            "sxp_withdrawal/": 1,
            "sxp_address/": 1,
            "ada_withdrawal/": 1,
            "ada_address/": 1,
            "slp_withdrawal/": 1,
            "slp_address/": 1,
            "ftm_withdrawal/": 1,
            "ftm_address/": 1,
            "perp_withdrawal/": 1,
            "perp_address/": 1,
            "dydx_withdrawal/": 1,
            "dydx_address/": 1,
            "gala_withdrawal/": 1,
            "gala_address/": 1,
            "shib_withdrawal/": 1,
            "shib_address/": 1,
            "amp_withdrawal/": 1,
            "amp_address/": 1,
            "sgb_withdrawal/": 1,
            "sgb_address/": 1,
            "avax_withdrawal/": 1,
            "avax_address/": 1,
            "wbtc_withdrawal/": 1,
            "wbtc_address/": 1,
            "ctsi_withdrawal/": 1,
            "ctsi_address/": 1,
            "cvx_withdrawal/": 1,
            "cvx_address/": 1,
            "imx_withdrawal/": 1,
            "imx_address/": 1,
            "nexo_withdrawal/": 1,
            "nexo_address/": 1,
            "ust_withdrawal/": 1,
            "ust_address/": 1,
            "ant_withdrawal/": 1,
            "ant_address/": 1,
            "gods_withdrawal/": 1,
            "gods_address/": 1,
            "rad_withdrawal/": 1,
            "rad_address/": 1,
            "band_withdrawal/": 1,
            "band_address/": 1,
            "inj_withdrawal/": 1,
            "inj_address/": 1,
            "rly_withdrawal/": 1,
            "rly_address/": 1,
            "rndr_withdrawal/": 1,
            "rndr_address/": 1,
            "vega_withdrawal/": 1,
            "vega_address/": 1,
            "1inch_withdrawal/": 1,
            "1inch_address/": 1,
            "ens_withdrawal/": 1,
            "ens_address/": 1,
            "mana_withdrawal/": 1,
            "mana_address/": 1,
            "lrc_withdrawal/": 1,
            "lrc_address/": 1,
            "ape_withdrawal/": 1,
            "ape_address/": 1,
            "mpl_withdrawal/": 1,
            "mpl_address/": 1,
            "euroc_withdrawal/": 1,
            "euroc_address/": 1,
            "sol_withdrawal/": 1,
            "sol_address/": 1,
            "dot_withdrawal/": 1,
            "dot_address/": 1,
            "near_withdrawal/": 1,
            "near_address/": 1,
            "doge_withdrawal/": 1,
            "doge_address/": 1,
            "flr_withdrawal/": 1,
            "flr_address/": 1,
            "dgld_withdrawal/": 1,
            "dgld_address/": 1,
            "ldo_withdrawal/": 1,
            "ldo_address/": 1,
            "travel_rule/contacts/": 1,
            "earn/subscribe/": 1,
            "earn/subscriptions/setting/": 1,
            "earn/unsubscribe": 1,
            "wecan_withdrawal/": 1,
            "wecan_address/": 1,
            "trac_withdrawal/": 1,
            "trac_address/": 1,
            "eurcv_withdrawal/": 1,
            "eurcv_address/": 1,
            "pyusd_withdrawal/": 1,
            "pyusd_address/": 1
          }
        }
      },
      fees: {
        trading: {
          tierBased: !0,
          percentage: !0,
          taker: this.parseNumber("0.005"),
          maker: this.parseNumber("0.005"),
          tiers: {
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.005")],
              [this.parseNumber("20000"), this.parseNumber("0.0025")],
              [this.parseNumber("100000"), this.parseNumber("0.0024")],
              [this.parseNumber("200000"), this.parseNumber("0.0022")],
              [this.parseNumber("400000"), this.parseNumber("0.0020")],
              [this.parseNumber("600000"), this.parseNumber("0.0015")],
              [this.parseNumber("1000000"), this.parseNumber("0.0014")],
              [this.parseNumber("2000000"), this.parseNumber("0.0013")],
              [this.parseNumber("4000000"), this.parseNumber("0.0012")],
              [this.parseNumber("20000000"), this.parseNumber("0.0011")],
              [this.parseNumber("50000000"), this.parseNumber("0.0010")],
              [this.parseNumber("100000000"), this.parseNumber("0.0007")],
              [this.parseNumber("500000000"), this.parseNumber("0.0005")],
              [this.parseNumber("2000000000"), this.parseNumber("0.0003")],
              [this.parseNumber("6000000000"), this.parseNumber("0.0001")],
              [this.parseNumber("20000000000"), this.parseNumber("0.00005")],
              [this.parseNumber("20000000001"), this.parseNumber("0")]
            ],
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.005")],
              [this.parseNumber("20000"), this.parseNumber("0.0025")],
              [this.parseNumber("100000"), this.parseNumber("0.0024")],
              [this.parseNumber("200000"), this.parseNumber("0.0022")],
              [this.parseNumber("400000"), this.parseNumber("0.0020")],
              [this.parseNumber("600000"), this.parseNumber("0.0015")],
              [this.parseNumber("1000000"), this.parseNumber("0.0014")],
              [this.parseNumber("2000000"), this.parseNumber("0.0013")],
              [this.parseNumber("4000000"), this.parseNumber("0.0012")],
              [this.parseNumber("20000000"), this.parseNumber("0.0011")],
              [this.parseNumber("50000000"), this.parseNumber("0.0010")],
              [this.parseNumber("100000000"), this.parseNumber("0.0007")],
              [this.parseNumber("500000000"), this.parseNumber("0.0005")],
              [this.parseNumber("2000000000"), this.parseNumber("0.0003")],
              [this.parseNumber("6000000000"), this.parseNumber("0.0001")],
              [this.parseNumber("20000000000"), this.parseNumber("0.00005")],
              [this.parseNumber("20000000001"), this.parseNumber("0")]
            ]
          }
        },
        funding: {
          tierBased: !1,
          percentage: !1,
          withdraw: {},
          deposit: {
            BTC: 0,
            BCH: 0,
            LTC: 0,
            ETH: 0,
            XRP: 0,
            XLM: 0,
            PAX: 0,
            USD: 7.5,
            EUR: 0
          }
        }
      },
      precisionMode: ct,
      exceptions: {
        exact: {
          "No permission found": ee,
          "API key not found": Z,
          "IP address not allowed": ee,
          "Invalid nonce": ze,
          "Invalid signature": Z,
          "Authentication failed": Z,
          "Missing key, signature and nonce parameters": Z,
          "Wrong API key format": Z,
          "Your account is frozen": ee,
          "Please update your profile with your FATCA information, before using API.": ee,
          "Order not found.": Se,
          "Price is more than 20% below market price.": g,
          "Bitstamp.net is under scheduled maintenance. We'll be back soon.": dt,
          "Order could not be placed.": Te,
          "Invalid offset.": g
        },
        broad: {
          "Minimum order size is": g,
          "Check your account balance for details.": re,
          "Ensure this value has at least": et,
          "Ensure that there are no more than": g
          // {"status": "error", "reason": {"amount": ["Ensure that there are no more than 0 decimal places."], "__all__": [""]}}
        }
      }
    });
  }
  async fetchStatus(e = {}) {
    const t = await this.publicGetEurUsd(e), i = this.safeNumber(t, "buy"), s = this.safeNumber(t, "sell");
    return {
      status: i !== void 0 && s !== void 0 ? "ok" : "maintenance",
      updated: void 0,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchMarkets(e = {}) {
    const t = await this.fetchMarketsFromCache(e), i = [];
    for (let s = 0; s < t.length; s++) {
      const n = t[s], r = this.safeString(n, "name");
      let [a, o] = r.split("/");
      const c = a.toLowerCase(), u = o.toLowerCase();
      a = this.safeCurrencyCode(a), o = this.safeCurrencyCode(o);
      const h = this.safeString(n, "minimum_order").split(" "), l = this.safeString(n, "trading");
      i.push({
        id: this.safeString(n, "url_symbol"),
        marketId: c + "_" + u,
        symbol: a + "/" + o,
        base: a,
        quote: o,
        settle: void 0,
        baseId: c,
        quoteId: u,
        settleId: void 0,
        type: "spot",
        spot: !0,
        margin: !1,
        future: !1,
        swap: !1,
        option: !1,
        active: l === "Enabled",
        contract: !1,
        linear: void 0,
        inverse: void 0,
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.parseNumber(this.parsePrecision(this.safeString(n, "base_decimals"))),
          price: this.parseNumber(this.parsePrecision(this.safeString(n, "counter_decimals")))
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: void 0,
            max: void 0
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.safeNumber(h, 0),
            max: void 0
          }
        },
        created: void 0,
        info: n
      });
    }
    return i;
  }
  constructCurrencyObject(e, t, i, s, n, r, a, o) {
    let c = "crypto";
    const u = this.describe();
    this.isFiat(t) && (c = "fiat");
    const f = this.parseNumber(this.parsePrecision(this.numberToString(s)));
    return {
      id: e,
      code: t,
      info: r,
      type: c,
      name: i,
      active: a && o,
      deposit: a,
      withdraw: o,
      fee: this.safeNumber(u.fees.funding.withdraw, t),
      precision: f,
      limits: {
        amount: {
          min: f,
          max: void 0
        },
        price: {
          min: f,
          max: void 0
        },
        cost: {
          min: n,
          max: void 0
        },
        withdraw: {
          min: void 0,
          max: void 0
        }
      },
      networks: {}
    };
  }
  async fetchMarketsFromCache(e = {}) {
    const t = this.safeValue(this.options, "fetchMarkets", {}), i = this.safeInteger(t, "timestamp"), s = this.safeInteger(t, "expires", 1e3), n = this.milliseconds();
    if (i === void 0 || n - i > s) {
      const r = await this.publicGetTradingPairsInfo(e);
      this.options.fetchMarkets = this.extend(t, {
        response: r,
        timestamp: n
      });
    }
    return this.safeValue(this.options.fetchMarkets, "response");
  }
  async fetchCurrencies(e = {}) {
    const t = this.fetchMarketsFromCache(e), i = this.publicGetCurrencies(), s = await Promise.all([t, i]), n = s[0], r = s[1], a = this.indexBy(r, "currency"), o = {};
    for (let c = 0; c < n.length; c++) {
      const u = n[c], f = this.safeString(u, "name");
      let [h, l] = f.split("/");
      const p = h.toLowerCase(), m = l.toLowerCase();
      h = this.safeCurrencyCode(h), l = this.safeCurrencyCode(l);
      const y = this.safeString(u, "description"), [w, S] = y.split(" / "), x = this.safeString(u, "minimum_order").split(" ")[0];
      if (!(h in o)) {
        const v = this.safeInteger(u, "base_decimals"), _ = this.safeValue(a, h, {}), V = this.safeString(_, "deposit") === "Enabled", j = this.safeString(_, "withdrawal") === "Enabled";
        o[h] = this.constructCurrencyObject(p, h, w, v, void 0, u, V, j);
      }
      if (!(l in o)) {
        const v = this.safeInteger(u, "counter_decimals"), _ = this.safeValue(a, h, {}), V = this.safeString(_, "deposit") === "Enabled", j = this.safeString(_, "withdrawal") === "Enabled";
        o[l] = this.constructCurrencyObject(m, l, S, v, this.parseNumber(x), u, V, j);
      }
    }
    return o;
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e), n = {
      pair: s.id
    }, r = await this.publicGetOrderBookPair(this.extend(n, i)), a = this.safeInteger(r, "microtimestamp"), o = this.parseToInt(a / 1e3), c = this.parseOrderBook(r, s.symbol, o);
    return c.nonce = a, c;
  }
  parseTicker(e, t = void 0) {
    const i = this.safeString(e, "pair"), s = this.safeSymbol(i, t, void 0), n = this.safeTimestamp(e, "timestamp"), r = this.safeString(e, "vwap"), a = this.safeString(e, "volume"), o = P.stringMul(a, r), c = this.safeString(e, "last");
    return this.safeTicker({
      symbol: s,
      timestamp: n,
      datetime: this.iso8601(n),
      high: this.safeString(e, "high"),
      low: this.safeString(e, "low"),
      bid: this.safeString(e, "bid"),
      bidVolume: void 0,
      ask: this.safeString(e, "ask"),
      askVolume: void 0,
      vwap: r,
      open: this.safeString(e, "open"),
      close: c,
      last: c,
      previousClose: void 0,
      change: void 0,
      percentage: void 0,
      average: void 0,
      baseVolume: a,
      quoteVolume: o,
      info: e
    }, t);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      pair: i.id
    }, n = await this.publicGetTickerPair(this.extend(s, t));
    return this.parseTicker(n, i);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.publicGetTicker(t);
    return this.parseTickers(i, e);
  }
  getCurrencyIdFromTransaction(e) {
    const t = this.safeStringLower(e, "currency");
    if (t !== void 0)
      return t;
    e = this.omit(e, [
      "fee",
      "price",
      "datetime",
      "type",
      "status",
      "id"
    ]);
    const i = Object.keys(e);
    for (let s = 0; s < i.length; s++) {
      const n = i[s];
      if (n.indexOf("_") < 0) {
        const r = this.safeInteger(e, n);
        if (r !== void 0 && r !== 0)
          return n;
      }
    }
  }
  getMarketFromTrade(e) {
    e = this.omit(e, [
      "fee",
      "price",
      "datetime",
      "tid",
      "type",
      "order_id",
      "side"
    ]);
    const t = Object.keys(e), i = t.length;
    if (i > 2)
      throw new O().addMessage("getMarketFromTrade() too many keys: " + this.json(t) + " in the trade: " + this.json(e)).exchange(this.id);
    if (i === 2) {
      let s = t[0] + t[1];
      if (s in this.markets_by_id)
        return this.safeMarket(s);
      if (s = t[1] + t[0], s in this.markets_by_id)
        return this.safeMarket(s);
    }
  }
  parseTrade(e, t = void 0) {
    const i = this.safeString2(e, "id", "tid");
    let s, n, r = this.safeString(e, "price"), a = this.safeString(e, "amount");
    const o = this.safeString(e, "order_id"), c = void 0;
    let u = this.safeString(e, "cost"), f;
    if (t === void 0) {
      const S = Object.keys(e);
      for (let b = 0; b < S.length; b++) {
        const T = S[b];
        T !== "order_id" && T.indexOf("_") >= 0 && (f = T, t = this.safeMarket(f, t, "_"));
      }
    }
    t === void 0 && (t = this.getMarketFromTrade(e));
    const h = this.safeString(e, "fee"), l = t.quote, p = f !== void 0 ? f : t.marketId;
    r = this.safeString(e, p, r), a = this.safeString(e, t.baseId, a), u = this.safeString(e, t.quoteId, u), s = t.symbol;
    const m = this.safeString2(e, "date", "datetime");
    let y;
    m !== void 0 && (m.indexOf(" ") >= 0 ? y = this.parse8601(m) : (y = parseInt(m), y = y * 1e3)), "id" in e ? a !== void 0 && (P.stringLt(a, "0") ? (n = "sell", a = P.stringNeg(a)) : n = "buy") : (n = this.safeString(e, "type"), n === "1" ? n = "sell" : n === "0" ? n = "buy" : n = void 0), u !== void 0 && (u = P.stringAbs(u));
    let w;
    return h !== void 0 && (w = {
      cost: h,
      currency: l
    }), this.safeTrade({
      id: i,
      info: e,
      timestamp: y,
      datetime: this.iso8601(y),
      symbol: s,
      order: o,
      type: c,
      side: n,
      takerOrMaker: void 0,
      price: r,
      amount: a,
      cost: u,
      fee: w
    }, t);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.market(e), r = {
      pair: n.id,
      time: "hour"
    }, a = await this.publicGetTransactionsPair(this.extend(r, s));
    return this.parseTrades(a, n, t, i);
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeTimestamp(e, "timestamp"),
      this.safeNumber(e, "open"),
      this.safeNumber(e, "high"),
      this.safeNumber(e, "low"),
      this.safeNumber(e, "close"),
      this.safeNumber(e, "volume")
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = this.market(e), a = {
      pair: r.id,
      step: this.safeString(this.timeframes, t, t)
    }, o = this.parseTimeframe(t);
    if (s === void 0)
      if (i === void 0)
        a.limit = 1e3;
      else {
        s = 1e3;
        const h = this.parseToInt(i / 1e3);
        a.start = h, a.end = this.sum(h, o * (s - 1)), a.limit = s;
      }
    else {
      if (i !== void 0) {
        const h = this.parseToInt(i / 1e3);
        a.start = h, a.end = this.sum(h, o * (s - 1));
      }
      a.limit = Math.min(s, 1e3);
    }
    const c = await this.publicGetOhlcPair(this.extend(a, n)), u = this.safeValue(c, "data", {}), f = this.safeValue(u, "ohlc", []);
    return this.parseOHLCVs(f, r, t, i, s);
  }
  parseBalance(e) {
    const t = {
      info: e,
      timestamp: void 0,
      datetime: void 0
    }, i = Object.keys(this.currencies);
    for (let s = 0; s < i.length; s++) {
      const n = i[s], a = this.currency(n).id, o = this.account();
      o.free = this.safeString(e, a + "_available"), o.used = this.safeString(e, a + "_reserved"), o.total = this.safeString(e, a + "_balance"), t[n] = o;
    }
    return this.safeBalance(t);
  }
  parseEarnBalance(e) {
    const t = {};
    return e.forEach((i) => {
      const s = i.currency, n = this.safeCurrencyCode(s), r = this.account();
      r.free = this.safeString(i, "available_amount"), r.used = this.safeString(i, "amount"), r.total = P.stringAdd(r.free, r.used), t[n] && (r.total = P.stringAdd(t[n].total, r.total), r.used = P.stringAdd(t[n].used, r.used), r.free = P.stringAdd(t[n].free, r.free)), t[n] = r;
    }), this.safeBalance(t);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    let t;
    return this.safeString(e, "type") === "earn" ? (t = await this.privateGetEarnSubscriptions(), this.parseEarnBalance(t)) : (t = await this.privatePostBalance(e), this.parseBalance(t));
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      pair: i.id
    }, n = await this.privatePostBalancePair(this.extend(s, t));
    return this.parseTradingFee(n, i);
  }
  parseTradingFee(e, t = void 0) {
    t = this.safeMarket(void 0, t);
    const i = this.safeString(e, t.id + "_fee"), s = P.stringDiv(i, "100"), n = this.parseNumber(s);
    return {
      info: e,
      symbol: t.symbol,
      maker: n,
      taker: n
    };
  }
  parseTradingFees(e) {
    const t = { info: e }, i = this.symbols;
    for (let s = 0; s < i.length; s++) {
      const n = i[s], r = this.market(n), a = this.parseTradingFee(e, r);
      t[n] = a;
    }
    return t;
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    const t = await this.privatePostBalance(e);
    return this.parseTradingFees(t);
  }
  async fetchTransactionFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.privatePostBalance(t);
    return this.parseTransactionFees(i);
  }
  parseTransactionFees(e, t = void 0) {
    t === void 0 && (t = Object.keys(this.currencies));
    const i = {};
    let s;
    const n = Object.keys(e);
    for (let r = 0; r < n.length; r++) {
      const a = n[r], o = a.split("_")[0], c = this.safeCurrencyCode(o);
      t !== void 0 && !this.inArray(c, t) || (a.indexOf("_available") >= 0 && (s = o, i[c] = {
        deposit: void 0,
        withdraw: void 0,
        info: {}
      }), o === s && (i[c].info[a] = this.safeNumber(e, a)), a.indexOf("_withdrawal_fee") >= 0 && (i[c].withdraw = this.safeNumber(e, a)));
    }
    return i;
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.privatePostBalance(t);
    return this.parseDepositWithdrawFees(i, e);
  }
  parseDepositWithdrawFees(e, t = void 0, i = void 0) {
    const s = {}, n = Object.keys(e);
    for (let r = 0; r < n.length; r++) {
      const a = n[r], o = a.split("_")[0], c = this.safeCurrencyCode(o), u = this.safeNumber(e, a);
      if (t !== void 0 && !this.inArray(c, t))
        continue;
      a.indexOf("_available") >= 0 && (s[c] = this.depositWithdrawFee({})), a.indexOf("_withdrawal_fee") >= 0 && (s[c].withdraw.fee = u), this.safeValue(s, c) !== void 0 && (s[c].info[a] = u);
    }
    return s;
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = {
      pair: a.id,
      amount: this.amountToPrecision(e, s)
    }, c = this.safeString2(r, "client_order_id", "clientOrderId");
    c !== void 0 && (o.client_order_id = c, r = this.omit(r, ["clientOrderId"]));
    let u;
    const f = this.capitalize(i);
    t === "market" ? f === "Buy" ? u = await this.privatePostBuyMarketPair(this.extend(o, r)) : u = await this.privatePostSellMarketPair(this.extend(o, r)) : t === "instant" ? f === "Buy" ? u = await this.privatePostBuyInstantPair(this.extend(o, r)) : u = await this.privatePostSellInstantPair(this.extend(o, r)) : (o.price = this.priceToPrecision(e, n), f === "Buy" ? u = await this.privatePostBuyPair(this.extend(o, r)) : u = await this.privatePostSellPair(this.extend(o, r)));
    const h = this.parseOrder(u, a);
    return h.type = t, h;
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      id: e
    };
    return await this.privatePostCancelOrder(this.extend(s, i));
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    let i;
    const s = {};
    let n;
    return e !== void 0 ? (i = this.market(e), s.pair = i.id, n = await this.privatePostCancelAllOrdersPair(this.extend(s, t))) : n = await this.privatePostCancelAllOrders(this.extend(s, t)), n;
  }
  parseOrderStatus(e) {
    const t = {
      "In Queue": "open",
      Open: "open",
      Finished: "closed",
      Canceled: "canceled"
    };
    return this.safeString(t, e, e);
  }
  async fetchOrderStatus(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.safeValue2(i, "client_order_id", "clientOrderId"), n = {};
    s !== void 0 ? (n.client_order_id = s, i = this.omit(i, ["client_order_id", "clientOrderId"])) : n.id = e;
    const r = await this.privatePostOrderStatus(this.extend(n, i));
    return this.parseOrderStatus(this.safeString(r, "status"));
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    t !== void 0 && (s = this.market(t));
    const n = this.safeValue2(i, "client_order_id", "clientOrderId"), r = {};
    n !== void 0 ? (r.client_order_id = n, i = this.omit(i, ["client_order_id", "clientOrderId"])) : r.id = e;
    const a = await this.privatePostOrderStatus(this.extend(r, i));
    return this.parseOrder(a, s);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    let r = "privatePostUserTransactions", a;
    e !== void 0 && (a = this.market(e), n.pair = a.id, r += "Pair"), i !== void 0 && (n.limit = i);
    const o = await this[r](this.extend(n, s)), c = this.filterBy(o, "type", "2");
    return this.parseTrades(c, a, t, i);
  }
  async fetchDepositsWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    i !== void 0 && (n.limit = i);
    const r = await this.privatePostUserTransactions(this.extend(n, s));
    let a;
    e !== void 0 && (a = this.currency(e));
    const o = this.filterByArray(r, "type", ["0", "1"], !1);
    return this.parseTransactions(o, a, t, i);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    t !== void 0 ? n.timedelta = this.milliseconds() - t : n.timedelta = 5e7;
    const r = await this.privatePostWithdrawalRequests(this.extend(n, s));
    return this.parseTransactions(r, void 0, t, i);
  }
  parseTransaction(e, t = void 0) {
    const i = this.parse8601(this.safeString(e, "datetime")), s = this.getCurrencyIdFromTransaction(e), n = this.safeCurrencyCode(s, t), r = this.safeString(e, "fee");
    let a, o;
    "amount" in e ? o = this.safeString(e, "amount") : t !== void 0 ? (o = this.safeString(e, t.id, o), a = t.code) : n !== void 0 && s !== void 0 && (o = this.safeString(e, s, o), a = n), o !== void 0 && (o = P.stringAbs(o));
    let c = "ok";
    "status" in e && (c = this.parseTransactionStatus(this.safeString(e, "status")));
    let u;
    if ("type" in e) {
      const p = this.safeString(e, "type");
      p === "0" ? u = "deposit" : p === "1" && (u = "withdrawal");
    } else
      u = "withdrawal";
    let f, h = this.safeString(e, "address");
    if (h !== void 0) {
      const p = h.split("?dt=");
      p.length > 1 && (h = p[0], f = p[1]);
    }
    let l = {
      currency: void 0,
      cost: void 0,
      rate: void 0
    };
    return r !== void 0 && (l = {
      currency: a,
      cost: r,
      rate: void 0
    }), {
      info: e,
      id: this.safeString(e, "id"),
      txid: this.safeString(e, "transaction_id"),
      type: u,
      currency: n,
      network: void 0,
      amount: this.parseNumber(o),
      status: c,
      timestamp: i,
      datetime: this.iso8601(i),
      address: h,
      addressFrom: void 0,
      addressTo: h,
      tag: f,
      tagFrom: void 0,
      tagTo: f,
      updated: void 0,
      comment: void 0,
      internal: void 0,
      fee: l
    };
  }
  parseTransactionStatus(e) {
    const t = {
      0: "pending",
      1: "pending",
      2: "ok",
      3: "canceled",
      4: "failed"
      // Failed
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    const i = this.safeString(e, "id"), s = this.safeString(e, "client_order_id");
    let n = this.safeString(e, "type");
    n !== void 0 && (n = n === "1" ? "sell" : "buy");
    const r = this.parse8601(this.safeString(e, "datetime")), a = this.safeStringLower(e, "currency_pair"), o = this.safeSymbol(a, t, "/"), c = this.parseOrderStatus(this.safeString(e, "status")), u = this.safeString(e, "amount"), f = this.safeValue(e, "transactions", []);
    let h = this.safeString(e, "price");
    return h || (h = String(f.reduce((l, p) => l + this.safeNumber(p, "price", 0), 0) / f.length)), this.safeOrder({
      id: i,
      clientOrderId: s,
      datetime: this.iso8601(r),
      timestamp: r,
      lastTradeTimestamp: void 0,
      status: c,
      symbol: o,
      type: void 0,
      timeInForce: void 0,
      postOnly: void 0,
      side: n,
      price: h,
      stopPrice: void 0,
      triggerPrice: void 0,
      cost: void 0,
      amount: u,
      filled: void 0,
      remaining: void 0,
      trades: f,
      fee: void 0,
      info: e,
      average: void 0
    }, t);
  }
  parseLedgerEntryType(e) {
    const t = {
      0: "transaction",
      1: "transaction",
      2: "trade",
      14: "transfer"
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.parseLedgerEntryType(this.safeString(e, "type"));
    if (i === "trade") {
      const s = this.parseTrade(e);
      let n;
      const r = Object.keys(e);
      for (let o = 0; o < r.length; o++)
        if (r[o].indexOf("_") >= 0) {
          const c = r[o].replace("_", "");
          n = this.safeMarket(c, n);
        }
      n === void 0 && (n = this.getMarketFromTrade(e));
      const a = s.side === "buy" ? "in" : "out";
      return {
        id: s.id,
        info: e,
        timestamp: s.timestamp,
        datetime: s.datetime,
        direction: a,
        account: void 0,
        referenceId: s.order,
        referenceAccount: void 0,
        type: i,
        currency: n.base,
        amount: s.amount,
        before: void 0,
        after: void 0,
        status: "ok",
        fee: s.fee
      };
    } else {
      const s = this.parseTransaction(e, t);
      let n;
      if ("amount" in e) {
        const r = this.safeString(e, "amount");
        n = P.stringGt(r, "0") ? "in" : "out";
      } else if ("currency" in s && s.currency !== void 0) {
        const r = this.safeString(s, "currency");
        t = this.currency(r);
        const a = this.safeString(e, t.id);
        n = P.stringGt(a, "0") ? "in" : "out";
      }
      return {
        id: s.id,
        info: e,
        timestamp: s.timestamp,
        datetime: s.datetime,
        direction: n,
        account: void 0,
        referenceId: s.txid,
        referenceAccount: void 0,
        type: i,
        currency: s.currency,
        amount: s.amount,
        before: void 0,
        after: void 0,
        status: s.status,
        fee: s.fee
      };
    }
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    i !== void 0 && (n.limit = i);
    const r = await this.privatePostUserTransactions(this.extend(n, s));
    let a;
    return e !== void 0 && (a = this.currency(e)), this.parseLedger(r, a, t, i);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    let n;
    await this.loadMarkets(), e !== void 0 && (n = this.market(e));
    const r = await this.privatePostOpenOrdersAll(s);
    return this.parseOrders(r, n, t, i, {
      status: "open",
      type: "limit"
    });
  }
  getCurrencyName(e) {
    return e.toLowerCase();
  }
  isFiat(e) {
    return e === "USD" || e === "EUR" || e === "GBP";
  }
  async fetchDepositAddress(e, t = {}) {
    if (this.isFiat(e))
      throw new It(e).addMessage("Fiat fetchDepositAddress() for " + e + " is not supported!").exchange(this.id);
    const i = this.getCurrencyName(e), s = "privatePost" + this.capitalize(i) + "Address", n = await this[s](t), r = this.safeString(n, "address"), a = this.safeString2(n, "memo_id", "destination_tag");
    return this.checkAddress(r), {
      currency: e,
      address: r,
      tag: a,
      network: void 0,
      info: n
    };
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), await this.loadMarkets(), this.checkAddress(i);
    const r = this.safeString(n, "network"), o = {
      amount: this.currencyToPrecision(e, t, r)
    };
    let c, u;
    if (this.isFiat(e))
      u = "privatePostWithdrawalOpen", c = this.currency(e), o.iban = i, o.account_currency = c.id;
    else {
      const h = this.getCurrencyName(e);
      u = "privatePost" + this.capitalize(h) + "Withdrawal", e === "XRP" ? s !== void 0 && (o.destination_tag = s) : (e === "XLM" || e === "HBAR") && s !== void 0 && (o.memo_id = s), o.address = i;
    }
    const f = await this[u](this.extend(o, n));
    return this.parseTransaction(f, c);
  }
  nonce() {
    return this.milliseconds();
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    let a = this.urls.api[t] + "/";
    a += this.version + "/", a += this.implodeParams(e, s);
    const o = this.omit(s, this.extractParams(e));
    if (t === "public")
      Object.keys(o).length && (a += "?" + this.urlencode(o));
    else {
      this.checkRequiredCredentials();
      const c = "BITSTAMP " + this.apiKey, u = this.uuid(), f = this.milliseconds().toString(), h = "v2";
      let l = "";
      n = {
        "X-Auth": c,
        "X-Auth-Nonce": u,
        "X-Auth-Timestamp": f,
        "X-Auth-Version": h
      }, i === "POST" && (Object.keys(o).length ? (r = this.urlencode(o), l = "application/x-www-form-urlencoded", n["Content-Type"] = l) : (r = this.urlencode({ foo: "bar" }), l = "application/x-www-form-urlencoded", n["Content-Type"] = l));
      const p = r || "", m = c + i + a.replace("https://", "") + l + u + f + h + p;
      let y;
      this.externalSigner ? y = await this.externalSigner.sign({
        payload: this.encode(m),
        publicApiKey: this.apiKey,
        exchangeId: this.id
      }) : y = this.hmac(this.encode(m), this.encode(this.secret), Re), n["X-Auth-Signature"] = y;
    }
    return { url: a, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (a === void 0)
      return;
    const u = this.safeString(a, "status"), f = this.safeValue(a, "error");
    if (u === "error" || f !== void 0) {
      let h = [];
      if (typeof f == "string")
        h.push(f);
      else if (f !== void 0) {
        const m = Object.keys(f);
        for (let y = 0; y < m.length; y++) {
          const w = m[y], S = this.safeValue(f, w);
          Array.isArray(S) ? h = this.arrayConcat(h, S) : h.push(S);
        }
      }
      const l = this.safeValue(a, "reason", {});
      if (typeof l == "string")
        h.push(l);
      else {
        const m = this.safeValue(l, "__all__", []);
        for (let y = 0; y < m.length; y++)
          h.push(m[y]);
      }
      const p = this.safeString(a, "code");
      if (p === "API0005")
        throw new Z().addMessage(p + ": invalid signature, use the uid for the main account if you have subaccounts").exchange(this.id);
      for (let m = 0; m < h.length; m++) {
        const y = h[m], w = y;
        this.throwExactlyMatchedException(this.exceptions.exact, y, w), this.throwBroadlyMatchedException(this.exceptions.broad, y, w);
      }
      throw new O().addMessage(f).exchange(this.id);
    }
  }
}
let Ky = class extends gt {
};
class Xy extends Ky {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "bybit",
      name: "Bybit",
      countries: ["VG"],
      version: "v5",
      userAgent: void 0,
      rateLimit: 20,
      hostname: "bybit.com",
      pro: !0,
      certified: !0,
      has: {
        CORS: !0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !0,
        option: !0,
        cancelAllOrders: !0,
        cancelOrder: !0,
        createMarketBuyOrderWithCost: !0,
        createMarketSellOrderWithCost: !0,
        createOrder: !0,
        createOrders: !0,
        createOrderWithTakeProfitAndStopLoss: !0,
        createTakeProfitOrder: !0,
        createTrailingAmountOrder: !0,
        createTriggerOrder: !0,
        editOrder: !0,
        fetchBalance: !0,
        fetchCanceledOrders: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDeposit: !1,
        fetchDepositAddress: !0,
        fetchDepositAddresses: !1,
        fetchDepositAddressesByNetwork: !0,
        fetchDeposits: !0,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrders: !0,
        fetchOrderTrades: !0,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !0,
        fetchTransactions: !1,
        fetchTransfers: !0,
        fetchWithdrawals: !0,
        transfer: !0,
        withdraw: !0
      },
      timeframes: {
        "1m": "1",
        "3m": "3",
        "5m": "5",
        "15m": "15",
        "30m": "30",
        "1h": "60",
        "2h": "120",
        "4h": "240",
        "6h": "360",
        "12h": "720",
        "1d": "D",
        "1w": "W",
        "1M": "M"
      },
      urls: {
        test: {
          spot: "https://api-testnet.{hostname}",
          futures: "https://api-testnet.{hostname}",
          v2: "https://api-testnet.{hostname}",
          public: "https://api-testnet.{hostname}",
          private: "https://api-testnet.{hostname}"
        },
        logo: "https://user-images.githubusercontent.com/51840849/76547799-daff5b80-649e-11ea-87fb-3be9bac08954.jpg",
        api: {
          spot: "https://api.{hostname}",
          futures: "https://api.{hostname}",
          v2: "https://api.{hostname}",
          public: "https://api.{hostname}",
          private: "https://api.{hostname}"
        },
        www: "https://www.bybit.com",
        doc: [
          "https://bybit-exchange.github.io/docs/inverse/",
          "https://bybit-exchange.github.io/docs/linear/",
          "https://github.com/bybit-exchange"
        ],
        fees: "https://help.bybit.com/hc/en-us/articles/360039261154",
        // https://www.bybit.com/register?affiliate_id=35953 - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
        referral: "https://www.bybit.com/register"
      },
      api: {
        public: {
          get: {
            // spot
            "spot/v3/public/symbols": 1,
            "spot/v3/public/quote/depth": 1,
            "spot/v3/public/quote/depth/merged": 1,
            "spot/v3/public/quote/trades": 1,
            "spot/v3/public/quote/kline": 1,
            "spot/v3/public/quote/ticker/24hr": 1,
            "spot/v3/public/quote/ticker/price": 1,
            "spot/v3/public/quote/ticker/bookTicker": 1,
            "spot/v3/public/server-time": 1,
            "spot/v3/public/infos": 1,
            "spot/v3/public/margin-product-infos": 1,
            "spot/v3/public/margin-ensure-tokens": 1,
            // data
            "v3/public/time": 1,
            "contract/v3/public/copytrading/symbol/list": 1,
            // derivative
            "derivatives/v3/public/order-book/L2": 1,
            "derivatives/v3/public/kline": 1,
            "derivatives/v3/public/tickers": 1,
            "derivatives/v3/public/instruments-info": 1,
            "derivatives/v3/public/mark-price-kline": 1,
            "derivatives/v3/public/index-price-kline": 1,
            "derivatives/v3/public/funding/history-funding-rate": 1,
            "derivatives/v3/public/risk-limit/list": 1,
            "derivatives/v3/public/delivery-price": 1,
            "derivatives/v3/public/recent-trade": 1,
            "derivatives/v3/public/open-interest": 1,
            "derivatives/v3/public/insurance": 1,
            // v5
            "v5/announcements/index": 5,
            // market
            "v5/market/time": 5,
            "v5/market/kline": 5,
            "v5/market/mark-price-kline": 5,
            "v5/market/index-price-kline": 5,
            "v5/market/premium-index-price-kline": 5,
            "v5/market/instruments-info": 5,
            "v5/market/orderbook": 5,
            "v5/market/tickers": 5,
            "v5/market/funding/history": 5,
            "v5/market/recent-trade": 5,
            "v5/market/open-interest": 5,
            "v5/market/historical-volatility": 5,
            "v5/market/insurance": 5,
            "v5/market/risk-limit": 5,
            "v5/market/delivery-price": 5,
            "v5/market/account-ratio": 5,
            // spot leverage token
            "v5/spot-lever-token/info": 5,
            "v5/spot-lever-token/reference": 5,
            // spot margin trade
            "v5/spot-margin-trade/data": 5,
            "v5/spot-cross-margin-trade/data": 5,
            "v5/spot-cross-margin-trade/pledge-token": 5,
            "v5/spot-cross-margin-trade/borrow-token": 5,
            // institutional lending
            "v5/ins-loan/product-infos": 5,
            "v5/ins-loan/ensure-tokens-convert": 5
          }
        },
        private: {
          get: {
            // Legacy inverse swap
            "v2/private/wallet/fund/records": 25,
            // spot
            "spot/v3/private/order": 2.5,
            "spot/v3/private/open-orders": 2.5,
            "spot/v3/private/history-orders": 2.5,
            "spot/v3/private/my-trades": 2.5,
            "spot/v3/private/account": 2.5,
            "spot/v3/private/reference": 2.5,
            "spot/v3/private/record": 2.5,
            "spot/v3/private/cross-margin-orders": 10,
            "spot/v3/private/cross-margin-account": 10,
            "spot/v3/private/cross-margin-loan-info": 10,
            "spot/v3/private/cross-margin-repay-history": 10,
            "spot/v3/private/margin-loan-infos": 10,
            "spot/v3/private/margin-repaid-infos": 10,
            "spot/v3/private/margin-ltv": 10,
            // account
            "asset/v3/private/transfer/inter-transfer/list/query": 50,
            "asset/v3/private/transfer/sub-member/list/query": 50,
            "asset/v3/private/transfer/sub-member-transfer/list/query": 50,
            "asset/v3/private/transfer/universal-transfer/list/query": 25,
            "asset/v3/private/coin-info/query": 25,
            "asset/v3/private/deposit/address/query": 10,
            "contract/v3/private/copytrading/order/list": 30,
            "contract/v3/private/copytrading/position/list": 40,
            "contract/v3/private/copytrading/wallet/balance": 25,
            "contract/v3/private/position/limit-info": 25,
            "contract/v3/private/order/unfilled-orders": 1,
            "contract/v3/private/order/list": 1,
            "contract/v3/private/position/list": 1,
            "contract/v3/private/execution/list": 1,
            "contract/v3/private/position/closed-pnl": 1,
            "contract/v3/private/account/wallet/balance": 1,
            "contract/v3/private/account/fee-rate": 1,
            "contract/v3/private/account/wallet/fund-records": 1,
            // derivative
            "unified/v3/private/order/unfilled-orders": 1,
            "unified/v3/private/order/list": 1,
            "unified/v3/private/position/list": 1,
            "unified/v3/private/execution/list": 1,
            "unified/v3/private/delivery-record": 1,
            "unified/v3/private/settlement-record": 1,
            "unified/v3/private/account/wallet/balance": 1,
            "unified/v3/private/account/transaction-log": 1,
            "unified/v3/private/account/borrow-history": 1,
            "unified/v3/private/account/borrow-rate": 1,
            "unified/v3/private/account/info": 1,
            "user/v3/private/frozen-sub-member": 10,
            "user/v3/private/query-sub-members": 5,
            "user/v3/private/query-api": 5,
            "user/v3/private/get-member-type": 1,
            "asset/v3/private/transfer/transfer-coin/list/query": 50,
            "asset/v3/private/transfer/account-coin/balance/query": 50,
            "asset/v3/private/transfer/account-coins/balance/query": 25,
            "asset/v3/private/transfer/asset-info/query": 50,
            "asset/v3/public/deposit/allowed-deposit-list/query": 0.17,
            "asset/v3/private/deposit/record/query": 10,
            "asset/v3/private/withdraw/record/query": 10,
            // v5
            // trade
            "v5/order/realtime": 5,
            "v5/order/history": 5,
            "v5/order/spot-borrow-check": 1,
            // position
            "v5/position/list": 5,
            "v5/execution/list": 5,
            "v5/position/closed-pnl": 5,
            "v5/position/move-history": 5,
            // pre-upgrade
            "v5/pre-upgrade/order/history": 5,
            "v5/pre-upgrade/execution/list": 5,
            "v5/pre-upgrade/position/closed-pnl": 5,
            "v5/pre-upgrade/account/transaction-log": 5,
            "v5/pre-upgrade/asset/delivery-record": 5,
            "v5/pre-upgrade/asset/settlement-record": 5,
            // account
            "v5/account/wallet-balance": 1,
            "v5/account/borrow-history": 1,
            "v5/account/collateral-info": 1,
            "v5/asset/coin-greeks": 1,
            "v5/account/fee-rate": 10,
            "v5/account/info": 5,
            "v5/account/transaction-log": 1,
            "v5/account/smp-group": 1,
            "v5/account/mmp-state": 5,
            // asset
            "v5/asset/exchange/order-record": 5,
            "v5/asset/delivery-record": 5,
            "v5/asset/settlement-record": 5,
            "v5/asset/transfer/query-asset-info": 50,
            "v5/asset/transfer/query-account-coins-balance": 25,
            "v5/asset/transfer/query-account-coin-balance": 50,
            "v5/asset/transfer/query-transfer-coin-list": 50,
            "v5/asset/transfer/query-inter-transfer-list": 50,
            "v5/asset/transfer/query-sub-member-list": 50,
            "v5/asset/transfer/query-universal-transfer-list": 25,
            "v5/asset/deposit/query-allowed-list": 5,
            "v5/asset/deposit/query-record": 10,
            "v5/asset/deposit/query-sub-member-record": 10,
            "v5/asset/deposit/query-internal-record": 5,
            "v5/asset/deposit/query-address": 10,
            "v5/asset/deposit/query-sub-member-address": 10,
            "v5/asset/coin/query-info": 28,
            "v5/asset/withdraw/query-record": 10,
            "v5/asset/withdraw/withdrawable-amount": 5,
            // user
            "v5/user/query-sub-members": 5,
            "v5/user/query-api": 5,
            "v5/user/sub-apikeys": 5,
            "v5/user/get-member-type": 5,
            "v5/user/aff-customer-info": 5,
            "v5/user/del-submember": 5,
            // spot leverage token
            "v5/spot-lever-token/order-record": 1,
            // spot margin trade
            "v5/spot-margin-trade/state": 5,
            "v5/spot-cross-margin-trade/loan-info": 1,
            "v5/spot-cross-margin-trade/account": 1,
            "v5/spot-cross-margin-trade/orders": 1,
            "v5/spot-cross-margin-trade/repay-history": 1,
            // institutional lending
            "v5/ins-loan/product-infos": 5,
            "v5/ins-loan/ensure-tokens-convert": 5,
            "v5/ins-loan/loan-order": 5,
            "v5/ins-loan/repaid-history": 5,
            "v5/ins-loan/ltv-convert": 5,
            // c2c lending
            "v5/lending/info": 5,
            "v5/lending/history-order": 5,
            "v5/lending/account": 5,
            // broker
            "v5/broker/earning-record": 5,
            "v5/broker/earnings-info": 5,
            "v5/broker/account-info": 5
          },
          post: {
            // Legacy option USDC
            "option/usdc/openapi/private/v1/place-order": 2.5,
            "option/usdc/openapi/private/v1/replace-order": 2.5,
            "option/usdc/openapi/private/v1/cancel-order": 2.5,
            "option/usdc/openapi/private/v1/cancel-all": 2.5,
            "option/usdc/openapi/private/v1/query-active-orders": 2.5,
            "option/usdc/openapi/private/v1/query-order-history": 2.5,
            "option/usdc/openapi/private/v1/execution-list": 2.5,
            "option/usdc/openapi/private/v1/query-position": 2.5,
            // Legacy perpetual swap USDC
            "perpetual/usdc/openapi/private/v1/place-order": 2.5,
            "perpetual/usdc/openapi/private/v1/replace-order": 2.5,
            "perpetual/usdc/openapi/private/v1/cancel-order": 2.5,
            "perpetual/usdc/openapi/private/v1/cancel-all": 2.5,
            "perpetual/usdc/openapi/private/v1/position/leverage/save": 2.5,
            // spot
            "spot/v3/private/order": 2.5,
            "spot/v3/private/cancel-order": 2.5,
            "spot/v3/private/cancel-orders": 2.5,
            "spot/v3/private/cancel-orders-by-ids": 2.5,
            "spot/v3/private/purchase": 2.5,
            "spot/v3/private/redeem": 2.5,
            "spot/v3/private/cross-margin-loan": 10,
            "spot/v3/private/cross-margin-repay": 10,
            // account
            "asset/v3/private/transfer/inter-transfer": 150,
            "asset/v3/private/withdraw/create": 300,
            "asset/v3/private/withdraw/cancel": 50,
            "asset/v3/private/transfer/sub-member-transfer": 150,
            "asset/v3/private/transfer/transfer-sub-member-save": 150,
            "asset/v3/private/transfer/universal-transfer": 10,
            "user/v3/private/create-sub-member": 10,
            "user/v3/private/create-sub-api": 10,
            "user/v3/private/update-api": 10,
            "user/v3/private/delete-api": 10,
            "user/v3/private/update-sub-api": 10,
            "user/v3/private/delete-sub-api": 10,
            // contract
            "contract/v3/private/copytrading/order/create": 30,
            "contract/v3/private/copytrading/order/cancel": 30,
            "contract/v3/private/copytrading/order/close": 30,
            "contract/v3/private/copytrading/position/close": 40,
            "contract/v3/private/copytrading/position/set-leverage": 40,
            "contract/v3/private/copytrading/wallet/transfer": 25,
            "contract/v3/private/copytrading/order/trading-stop": 2.5,
            "contract/v3/private/order/create": 1,
            "contract/v3/private/order/cancel": 1,
            "contract/v3/private/order/cancel-all": 1,
            "contract/v3/private/order/replace": 1,
            "contract/v3/private/position/set-auto-add-margin": 1,
            "contract/v3/private/position/switch-isolated": 1,
            "contract/v3/private/position/switch-mode": 1,
            "contract/v3/private/position/switch-tpsl-mode": 1,
            "contract/v3/private/position/set-leverage": 1,
            "contract/v3/private/position/trading-stop": 1,
            "contract/v3/private/position/set-risk-limit": 1,
            "contract/v3/private/account/setMarginMode": 1,
            // derivative
            "unified/v3/private/order/create": 30,
            "unified/v3/private/order/replace": 30,
            "unified/v3/private/order/cancel": 30,
            "unified/v3/private/order/create-batch": 30,
            "unified/v3/private/order/replace-batch": 30,
            "unified/v3/private/order/cancel-batch": 30,
            "unified/v3/private/order/cancel-all": 30,
            "unified/v3/private/position/set-leverage": 2.5,
            "unified/v3/private/position/tpsl/switch-mode": 2.5,
            "unified/v3/private/position/set-risk-limit": 2.5,
            "unified/v3/private/position/trading-stop": 2.5,
            "unified/v3/private/account/upgrade-unified-account": 2.5,
            "unified/v3/private/account/setMarginMode": 2.5,
            // tax
            "fht/compliance/tax/v3/private/registertime": 50,
            "fht/compliance/tax/v3/private/create": 50,
            "fht/compliance/tax/v3/private/status": 50,
            "fht/compliance/tax/v3/private/url": 50,
            // v5
            // trade
            "v5/order/create": 2.5,
            "v5/order/amend": 5,
            "v5/order/cancel": 2.5,
            "v5/order/cancel-all": 50,
            "v5/order/create-batch": 5,
            "v5/order/amend-batch": 5,
            "v5/order/cancel-batch": 5,
            "v5/order/disconnected-cancel-all": 5,
            // position
            "v5/position/set-leverage": 5,
            "v5/position/switch-isolated": 5,
            "v5/position/set-tpsl-mode": 5,
            "v5/position/switch-mode": 5,
            "v5/position/set-risk-limit": 5,
            "v5/position/trading-stop": 5,
            "v5/position/set-auto-add-margin": 5,
            "v5/position/add-margin": 5,
            "v5/position/move-positions": 5,
            "v5/position/confirm-pending-mmr": 5,
            // account
            "v5/account/upgrade-to-uta": 5,
            "v5/account/quick-repayment": 5,
            "v5/account/set-margin-mode": 5,
            "v5/account/set-hedging-mode": 5,
            "v5/account/mmp-modify": 5,
            "v5/account/mmp-reset": 5,
            // asset
            "v5/asset/transfer/inter-transfer": 50,
            "v5/asset/transfer/save-transfer-sub-member": 150,
            "v5/asset/transfer/universal-transfer": 10,
            "v5/asset/deposit/deposit-to-account": 5,
            "v5/asset/withdraw/create": 50,
            "v5/asset/withdraw/cancel": 50,
            // user
            "v5/user/create-sub-member": 10,
            "v5/user/create-sub-api": 10,
            "v5/user/frozen-sub-member": 10,
            "v5/user/update-api": 10,
            "v5/user/update-sub-api": 10,
            "v5/user/delete-api": 10,
            "v5/user/delete-sub-api": 10,
            // spot leverage token
            "v5/spot-lever-token/purchase": 2.5,
            "v5/spot-lever-token/redeem": 2.5,
            // spot margin trade
            "v5/spot-margin-trade/switch-mode": 5,
            "v5/spot-margin-trade/set-leverage": 5,
            "v5/spot-cross-margin-trade/loan": 2.5,
            "v5/spot-cross-margin-trade/repay": 2.5,
            "v5/spot-cross-margin-trade/switch": 2.5,
            // institutional lending
            "v5/ins-loan/association-uid": 5,
            // c2c lending
            "v5/lending/purchase": 5,
            "v5/lending/redeem": 5,
            "v5/lending/redeem-cancel": 5,
            "v5/account/set-collateral-switch": 5,
            "v5/account/set-collateral-switch-batch": 5
          }
        }
      },
      httpExceptions: {
        403: Ae
        // Forbidden -- You request too many times
      },
      exceptions: {
        // Uncodumented explanation of error strings:
        // - oc_diff: order cost needed to place this order
        // - new_oc: total order cost of open orders including the order you are trying to open
        // - ob: order balance - the total cost of current open orders
        // - ab: available balance
        exact: {
          "-10009": g,
          "-1004": g,
          "-1021": g,
          "-1103": g,
          "-1140": g,
          "-1197": g,
          "-2013": k,
          "-2015": Z,
          "-6017": g,
          "-6025": g,
          "-6029": g,
          5004: O,
          7001: g,
          10001: g,
          10002: ze,
          10003: Pt,
          10004: Z,
          10005: ee,
          10006: Ae,
          10007: Z,
          10008: Z,
          10009: Z,
          10010: ee,
          10014: O,
          10016: O,
          10017: O,
          10018: Ae,
          10020: ee,
          10024: ee,
          10027: ee,
          10028: ee,
          10029: ee,
          12137: g,
          12201: g,
          12141: g,
          100028: ee,
          110001: Se,
          110003: g,
          110004: re,
          110005: k,
          110006: re,
          110007: re,
          110008: k,
          110009: k,
          110010: k,
          110011: k,
          110012: re,
          110013: k,
          110014: re,
          110015: k,
          110016: k,
          110017: k,
          110018: O,
          110019: g,
          110020: k,
          110021: k,
          110022: k,
          110023: k,
          110024: k,
          110025: k,
          110026: O,
          110027: O,
          110028: k,
          110029: k,
          110030: k,
          110031: k,
          110032: k,
          110033: k,
          110034: k,
          110035: k,
          110036: k,
          110037: k,
          110038: k,
          110039: k,
          110040: k,
          110041: k,
          110042: k,
          110043: k,
          110044: re,
          110045: re,
          110046: O,
          110047: k,
          110048: k,
          110049: k,
          110050: k,
          110051: re,
          110052: re,
          110053: re,
          110054: k,
          110055: k,
          110056: k,
          110057: k,
          110058: k,
          110059: k,
          110060: O,
          110061: O,
          110062: O,
          110063: O,
          110064: k,
          110065: ee,
          110066: O,
          110067: ee,
          110068: ee,
          110069: ee,
          110070: k,
          110071: O,
          110072: k,
          110073: O,
          130006: k,
          130021: re,
          130074: k,
          131001: Xt,
          131084: O,
          131200: O,
          131201: O,
          131202: g,
          131203: g,
          131204: g,
          131205: g,
          131206: O,
          131207: g,
          131208: O,
          131209: g,
          131210: g,
          131211: g,
          131212: re,
          131213: g,
          131214: g,
          131215: g,
          131216: O,
          131217: O,
          131231: Vt,
          131232: Vt,
          131002: g,
          131003: O,
          131004: Z,
          131085: re,
          131086: ke,
          131088: ws,
          131089: ke,
          131090: O,
          131091: O,
          131092: O,
          131093: gi,
          131094: ee,
          131095: ke,
          131096: ke,
          131097: O,
          131098: O,
          131099: O,
          140001: Se,
          140003: g,
          140004: re,
          140005: k,
          140006: re,
          140007: re,
          140008: k,
          140009: k,
          140010: k,
          140011: k,
          140012: re,
          140013: k,
          140014: re,
          140015: k,
          140016: k,
          140017: k,
          140018: O,
          140019: k,
          140020: k,
          140021: k,
          140022: k,
          140023: k,
          140024: k,
          140025: k,
          140026: k,
          140027: k,
          140028: k,
          140029: k,
          140030: k,
          140031: k,
          140032: k,
          140033: k,
          140034: k,
          140035: k,
          140036: k,
          140037: k,
          140038: k,
          140039: k,
          140040: k,
          140041: k,
          140042: k,
          140043: k,
          140044: re,
          140045: re,
          140046: k,
          140047: k,
          140048: k,
          140049: k,
          140050: g,
          140051: re,
          140052: re,
          140053: re,
          140054: k,
          140055: k,
          140056: k,
          140057: k,
          140058: k,
          140059: k,
          140060: O,
          140061: O,
          140062: O,
          140063: O,
          140064: k,
          140065: ee,
          140066: O,
          140067: ee,
          140068: ee,
          140069: ee,
          140070: k,
          170001: O,
          170007: Nt,
          170005: k,
          170031: O,
          170032: O,
          170033: re,
          170034: re,
          170035: be,
          170036: O,
          170037: O,
          170105: g,
          170115: g,
          170116: g,
          170117: g,
          170121: g,
          170130: g,
          170131: re,
          170132: g,
          170133: g,
          170134: g,
          170135: g,
          170136: g,
          170137: g,
          170139: g,
          170140: g,
          170124: g,
          170141: k,
          170142: k,
          170143: k,
          170144: k,
          170145: k,
          170146: k,
          170147: k,
          170148: g,
          170149: O,
          170150: O,
          170151: k,
          170157: k,
          170159: k,
          170190: k,
          170191: k,
          170192: g,
          170193: g,
          170194: g,
          170195: k,
          170196: k,
          170197: g,
          170198: g,
          170199: g,
          170200: g,
          170221: $e,
          170222: Ae,
          170223: re,
          170224: ee,
          170226: re,
          170227: O,
          170228: k,
          170229: k,
          170234: O,
          170210: k,
          170213: Se,
          170217: k,
          170218: g,
          170010: g,
          170011: g,
          170019: g,
          170201: ee,
          170202: g,
          170203: g,
          170204: g,
          170206: g,
          175e3: g,
          175001: k,
          175002: k,
          175003: re,
          175004: k,
          175005: k,
          175006: re,
          175007: Se,
          175008: k,
          175009: k,
          175010: ee,
          175012: k,
          175013: k,
          175014: k,
          175015: k,
          175016: g,
          175017: g,
          175027: O,
          176002: O,
          176004: O,
          176003: O,
          176006: O,
          176005: O,
          176008: O,
          176007: O,
          176010: O,
          176009: O,
          176012: it,
          176011: O,
          176014: O,
          176013: O,
          176015: re,
          176016: O,
          176017: O,
          176018: O,
          176019: O,
          176020: O,
          176021: O,
          176022: O,
          176023: O,
          176024: O,
          176025: O,
          176026: O,
          176027: O,
          176028: O,
          176029: O,
          176030: O,
          176031: g,
          176034: O,
          176035: ee,
          176036: ee,
          176037: ee,
          176038: O,
          176039: O,
          176040: O,
          181e3: O,
          181001: g,
          181002: g,
          181003: g,
          181004: g,
          182e3: g,
          181017: g,
          20001: Se,
          20003: g,
          20004: g,
          20005: g,
          20006: g,
          20007: g,
          20008: g,
          20009: g,
          20010: g,
          20011: g,
          20012: g,
          20013: g,
          20014: g,
          20015: g,
          20016: g,
          20017: g,
          20018: g,
          20019: g,
          20020: g,
          20021: g,
          20022: g,
          20023: g,
          20031: g,
          20070: g,
          20071: g,
          20084: g,
          30001: g,
          30003: g,
          30004: g,
          30005: g,
          30007: g,
          30008: g,
          30009: O,
          30010: re,
          30011: ee,
          30012: ee,
          30013: ee,
          30014: g,
          30015: g,
          30016: O,
          30017: g,
          30018: g,
          30019: g,
          30020: k,
          30021: k,
          30022: g,
          30023: g,
          30024: k,
          30025: g,
          30026: g,
          30027: g,
          30028: g,
          30029: g,
          30030: g,
          30031: re,
          30032: k,
          30033: Ae,
          30034: Se,
          30035: Ae,
          30036: O,
          30037: k,
          30041: O,
          30042: re,
          30043: k,
          30044: k,
          30045: k,
          30049: re,
          30050: O,
          30051: O,
          30052: O,
          30054: O,
          30057: O,
          30063: O,
          30067: re,
          30068: O,
          30074: k,
          30075: k,
          30078: O,
          // '30084': BadRequest, // Isolated not modified, see handleErrors below
          33004: Z,
          34026: O,
          34036: O,
          35015: O,
          340099: O,
          3400045: O,
          3100116: g,
          3100198: g,
          3200300: re
          // {"retCode":3200300,"retMsg":"Insufficient margin balance.","result":null,"retExtMap":{}}
        },
        broad: {
          "Request timeout": Nt,
          "unknown orderInfo": Se,
          "invalid api_key": Z,
          // the below two issues are caused as described: issues/9149#issuecomment-1146559498, when response is such:  {"ret_code":130021,"ret_msg":"oc_diff[1707966351], new_oc[1707966351] with ob[....]+AB[....]","ext_code":"","ext_info":"","result":null,"time_now":"1658395300.872766","rate_limit_status":99,"rate_limit_reset_ms":1658395300855,"rate_limit":100}
          oc_diff: re,
          new_oc: re,
          "openapi sign params error!": Z,
          "withdraw address is invalid": et
        },
        messages: {
          "Order value exceeded lower limit": ye.ORDER_UNDER_MINIMUM
        }
      },
      precisionMode: ct,
      options: {
        fetchMarkets: ["spot", "linear", "inverse", "option"],
        enableUnifiedMargin: void 0,
        enableUnifiedAccount: void 0,
        createMarketBuyOrderRequiresPrice: !0,
        createUnifiedMarginAccount: !1,
        defaultType: "swap",
        defaultSubType: "linear",
        defaultSettle: "USDT",
        code: "BTC",
        recvWindow: 10 * 1e3,
        timeDifference: 0,
        adjustForTimeDifference: !1,
        loadAllOptions: !1,
        loadExpiredOptions: !1,
        brokerId: "CEDE",
        accountsByType: {
          spot: "SPOT",
          margin: "SPOT",
          future: "CONTRACT",
          swap: "CONTRACT",
          option: "OPTION",
          investment: "INVESTMENT",
          unified: "UNIFIED",
          funding: "FUND",
          fund: "FUND",
          contract: "CONTRACT"
        },
        accountsById: {
          SPOT: "spot",
          MARGIN: "spot",
          CONTRACT: "contract",
          OPTION: "option",
          INVESTMENT: "investment",
          UNIFIED: "unified",
          FUND: "fund"
        },
        networks: {
          ERC20: "ETH",
          TRC20: "TRX",
          BEP20: "BSC",
          OMNI: "OMNI",
          SPL: "SOL"
        },
        networksById: {
          ETH: "ERC20",
          TRX: "TRC20",
          BSC: "BEP20",
          OMNI: "OMNI",
          SPL: "SOL"
        },
        defaultNetwork: "ERC20",
        defaultNetworks: {
          USDT: "TRC20"
        },
        intervals: {
          "5m": "5min",
          "15m": "15min",
          "30m": "30min",
          "1h": "1h",
          "4h": "4h",
          "1d": "1d"
        }
      },
      fees: {
        trading: {
          feeSide: "get",
          tierBased: !0,
          percentage: !0,
          taker: 75e-5,
          maker: 1e-4
        },
        funding: {
          tierBased: !1,
          percentage: !1,
          withdraw: {},
          deposit: {}
        }
      }
    });
  }
  isUsingForcedProxy(e = {}, t = "public") {
    return t === "private";
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  addPaginationCursorToResult(e) {
    const t = this.safeValue(e, "result", {}), i = this.safeValueN(t, ["list", "rows", "data", "dataList"], []), s = this.safeString2(t, "nextPageCursor", "cursor"), n = i.length;
    if (s !== void 0 && n > 0) {
      const r = i[0];
      r.nextPageCursor = s, i[0] = r;
    }
    return i;
  }
  async isUnifiedEnabled(e = {}) {
    const t = this.safeValue(this.options, "enableUnifiedMargin"), i = this.safeValue(this.options, "enableUnifiedAccount"), s = this.safeValue(e, "methodCallId");
    if (t === void 0 || i === void 0 || s) {
      const n = await this.privateGetV5UserQueryApi(e), r = this.safeValue(n, "result", {});
      this.options.enableUnifiedMargin = this.safeInteger(r, "unified") === 1, this.options.enableUnifiedAccount = this.safeInteger(r, "uta") === 1;
    }
    return [this.options.enableUnifiedMargin, this.options.enableUnifiedAccount];
  }
  convertExpireDate(e) {
    const t = e.slice(0, 2), i = e.slice(2, 4), s = e.slice(4, 6);
    return "20" + t + "-" + i + "-" + s + "T00:00:00Z";
  }
  convertExpireDateToMarketIdDate(e) {
    const t = e.slice(0, 2), i = e.slice(2, 4);
    let s;
    const n = e.slice(4, 6);
    return i === "01" ? s = "JAN" : i === "02" ? s = "FEB" : i === "03" ? s = "MAR" : i === "04" ? s = "APR" : i === "05" ? s = "MAY" : i === "06" ? s = "JUN" : i === "07" ? s = "JUL" : i === "08" ? s = "AUG" : i === "09" ? s = "SEP" : i === "10" ? s = "OCT" : i === "11" ? s = "NOV" : i === "12" && (s = "DEC"), n + s + t;
  }
  convertMarketIdExpireDate(e) {
    const t = {
      JAN: "01",
      FEB: "02",
      MAR: "03",
      APR: "04",
      MAY: "05",
      JUN: "06",
      JUL: "07",
      AUG: "08",
      SEP: "09",
      OCT: "10",
      NOV: "11",
      DEC: "12"
    }, i = e.slice(0, 2), s = e.slice(2, 5), n = this.safeString(t, s);
    return e.slice(5, 7) + n + i;
  }
  createExpiredOptionMarket(e) {
    const t = "USD", i = "USDC", s = e.split("-"), n = e.split("/");
    let r, a;
    e.indexOf("/") > -1 ? (r = this.safeString(n, 0), a = this.safeString(s, 1)) : (r = this.safeString(s, 0), a = this.convertMarketIdExpireDate(this.safeString(s, 1)));
    const o = this.safeString(s, 2), c = this.safeString(s, 3), u = this.convertExpireDate(a), f = this.parse8601(u);
    return {
      id: r + "-" + this.convertExpireDateToMarketIdDate(a) + "-" + o + "-" + c,
      symbol: r + "/" + t + ":" + i + "-" + a + "-" + o + "-" + c,
      base: r,
      quote: t,
      settle: i,
      baseId: r,
      quoteId: t,
      settleId: i,
      active: !1,
      type: "option",
      linear: void 0,
      inverse: void 0,
      spot: !1,
      swap: !1,
      future: !1,
      option: !0,
      margin: !1,
      contract: !0,
      contractSize: void 0,
      expiry: f,
      expiryDatetime: u,
      optionType: c === "C" ? "call" : "put",
      strike: this.parseNumber(o),
      precision: {
        amount: void 0,
        price: void 0
      },
      limits: {
        amount: {
          min: void 0,
          max: void 0
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: void 0,
          max: void 0
        }
      },
      info: void 0
    };
  }
  safeMarket(e = void 0, t = void 0, i = void 0, s = void 0) {
    return e !== void 0 && (e.indexOf("-C") > -1 || e.indexOf("-P") > -1) && !(e in this.markets_by_id) ? this.createExpiredOptionMarket(e) : super.safeMarket(e, t, i, s);
  }
  getBybitType(e, t, i = {}) {
    let s;
    [s, i] = this.handleMarketTypeAndParams(e, t, i);
    let n;
    return [n, i] = this.handleSubTypeAndParams(e, t, i), s === "option" || s === "spot" ? [s, i] : [n, i];
  }
  async fetchStatus(e = {}) {
    const t = await this.publicGetV5MarketTime(e), s = this.safeString(t, "retCode") === "0" ? "ok" : "maintenance", n = this.safeInteger(t, "time");
    return {
      status: s,
      updated: n,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchTime(e = {}) {
    const t = await this.publicGetV5MarketTime(e);
    return this.safeInteger(t, "time");
  }
  async fetchCurrencies(e = {}) {
    if (!this.checkRequiredCredentials(!1))
      return;
    const t = await this.privateGetV5AssetCoinQueryInfo(e), i = this.safeValue(t, "result", []), s = this.safeValue(i, "rows", []), n = {};
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeString(a, "coin"), c = this.safeCurrencyCode(o), u = this.safeString(a, "name"), f = this.safeValue(a, "chains", []), h = {};
      let l, p, m, y, w = !1, S = !1;
      for (let b = 0; b < f.length; b++) {
        const T = f[b], x = this.safeString(T, "chain"), v = this.networkIdToCode(x), _ = this.parseNumber(this.parsePrecision(this.safeString(T, "minAccuracy")));
        l = l === void 0 ? _ : Math.min(l, _);
        const V = this.safeInteger(T, "chainDeposit") === 1, j = this.safeInteger(T, "chainWithdraw") === 1;
        w = V || w, S = j || S;
        const G = this.safeString(T, "withdrawFee");
        G !== void 0 && (p = p === void 0 ? G : P.stringMin(G, p));
        const W = this.safeString(T, "withdrawMin");
        W !== void 0 && (m = m === void 0 ? W : P.stringMin(W, m));
        const B = this.safeString(T, "depositMin");
        B !== void 0 && (y = y === void 0 ? B : P.stringMin(B, y)), h[v] = {
          info: T,
          id: x,
          network: v,
          active: V && j,
          deposit: V,
          withdraw: j,
          fee: this.parseNumber(G),
          precision: _,
          limits: {
            withdraw: {
              min: this.parseNumber(W),
              max: void 0
            },
            deposit: {
              min: this.parseNumber(B),
              max: void 0
            }
          }
        };
      }
      n[c] = {
        info: a,
        code: c,
        id: o,
        name: u,
        active: w && S,
        deposit: w,
        withdraw: S,
        fee: this.parseNumber(p),
        precision: l,
        limits: {
          amount: {
            min: void 0,
            max: void 0
          },
          withdraw: {
            min: this.parseNumber(m),
            max: void 0
          },
          deposit: {
            min: this.parseNumber(y),
            max: void 0
          }
        },
        networks: h
      };
    }
    return n;
  }
  async fetchMarkets(e = {}) {
    const t = [], i = this.safeValue(this.options, "fetchMarkets", ["spot", "linear", "inverse"]);
    for (let p = 0; p < i.length; p++) {
      const m = i[p];
      if (m === "spot")
        t.push(this.fetchSpotMarkets(e));
      else if (m === "linear")
        t.push(this.fetchFutureMarkets({ category: "linear" }));
      else if (m === "inverse")
        t.push(this.fetchFutureMarkets({ category: "inverse" }));
      else if (m === "option")
        t.push(this.fetchOptionMarkets({ baseCoin: "BTC" })), t.push(this.fetchOptionMarkets({ baseCoin: "ETH" })), t.push(this.fetchOptionMarkets({ baseCoin: "SOL" }));
      else
        throw new ge(m).exchange(this.id);
    }
    const s = await Promise.all(t), n = this.safeValue(s, 0, []), r = this.safeValue(s, 1, []), a = this.safeValue(s, 2, []), o = this.safeValue(s, 3, []), c = this.safeValue(s, 4, []), u = this.safeValue(s, 5, []), f = this.arrayConcat(r, a);
    let h = this.arrayConcat(o, c);
    h = this.arrayConcat(h, u);
    const l = this.arrayConcat(f, h);
    return this.arrayConcat(n, l);
  }
  async fetchSpotMarkets(e) {
    const t = {
      category: "spot"
    }, i = await this.publicGetV5MarketInstrumentsInfo(this.extend(t, e)), s = this.safeValue(i, "result", {}), n = this.safeValue(s, "list", []), r = [], a = this.parseNumber("0.001"), o = this.parseNumber("0.001");
    for (let c = 0; c < n.length; c++) {
      const u = n[c], f = this.safeString(u, "symbol"), h = this.safeString(u, "baseCoin"), l = this.safeString(u, "quoteCoin"), p = this.safeCurrencyCode(h), m = this.safeCurrencyCode(l), y = p + "/" + m, S = this.safeString(u, "status") === "Trading", b = this.safeValue(u, "lotSizeFilter"), T = this.safeValue(u, "priceFilter"), x = this.safeNumber(b, "quotePrecision");
      r.push({
        id: f,
        symbol: y,
        base: p,
        quote: m,
        settle: void 0,
        baseId: h,
        quoteId: l,
        settleId: void 0,
        type: "spot",
        spot: !0,
        margin: void 0,
        swap: !1,
        future: !1,
        option: !1,
        active: S,
        contract: !1,
        linear: void 0,
        inverse: void 0,
        taker: a,
        maker: o,
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.safeNumber(b, "basePrecision"),
          price: this.safeNumber(T, "tickSize", x)
        },
        limits: {
          leverage: {
            min: this.parseNumber("1"),
            max: void 0
          },
          amount: {
            min: this.safeNumber(b, "minOrderQty"),
            max: this.safeNumber(b, "maxOrderQty")
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.safeNumber(b, "minOrderAmt"),
            max: this.safeNumber(b, "maxOrderAmt")
          }
        },
        created: void 0,
        info: u
      });
    }
    return r;
  }
  async fetchFutureMarkets(e) {
    e = this.extend(e), e.limit = 1e3;
    const t = await this.publicGetV5MarketInstrumentsInfo(e), i = this.safeValue(t, "result", {});
    let s = this.safeValue(i, "list", []), n = this.safeString(i, "nextPageCursor");
    if (n !== void 0)
      for (; n !== void 0; ) {
        e.cursor = n;
        const o = await this.publicGetV5MarketInstrumentsInfo(e), c = this.safeValue(o, "result", {}), u = this.safeValue(c, "list", []);
        if (u.length === 0)
          break;
        s = this.arrayConcat(u, s), n = this.safeString(c, "nextPageCursor");
      }
    const r = [];
    let a = this.safeString(i, "category");
    for (let o = 0; o < s.length; o++) {
      const c = s[o];
      a === void 0 && (a = this.safeString(c, "category"));
      const u = a === "linear", f = a === "inverse", h = this.safeString(c, "contractType"), l = h === "InverseFutures", p = h === "LinearFutures", m = h === "LinearPerpetual", y = h === "InversePerpetual", w = this.safeString(c, "symbol"), S = this.safeString(c, "baseCoin"), b = this.safeString(c, "quoteCoin"), T = u ? b : S, x = this.safeString(c, "settleCoin", T), v = this.safeCurrencyCode(S), _ = this.safeCurrencyCode(b);
      let V;
      m && x === "USD" ? V = "USDC" : V = this.safeCurrencyCode(x);
      let j = v + "/" + _;
      const G = this.safeValue(c, "lotSizeFilter", {}), W = this.safeValue(c, "priceFilter", {}), B = this.safeValue(c, "leverageFilter", {}), Q = this.safeString(c, "status"), se = m || y, $ = l || p;
      let te;
      se ? te = "swap" : $ && (te = "future");
      let E;
      se || (E = this.omitZero(this.safeString(c, "deliveryTime")), E !== void 0 && (E = parseInt(E)));
      const N = this.iso8601(E);
      j = j + ":" + V, E !== void 0 && (j = j + "-" + this.yymmdd(E));
      const L = f ? this.safeNumber2(G, "minTradingQty", "minOrderQty") : this.parseNumber("1");
      r.push({
        id: w,
        symbol: j,
        base: v,
        quote: _,
        settle: V,
        baseId: S,
        quoteId: b,
        settleId: x,
        type: te,
        spot: !1,
        margin: void 0,
        swap: se,
        future: $,
        option: !1,
        active: Q === "Trading",
        contract: !0,
        linear: u,
        inverse: f,
        taker: this.safeNumber(c, "takerFee", this.parseNumber("0.0006")),
        maker: this.safeNumber(c, "makerFee", this.parseNumber("0.0001")),
        contractSize: L,
        expiry: E,
        expiryDatetime: N,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.safeNumber(G, "qtyStep"),
          price: this.safeNumber(W, "tickSize")
        },
        limits: {
          leverage: {
            min: this.safeNumber(B, "minLeverage"),
            max: this.safeNumber(B, "maxLeverage")
          },
          amount: {
            min: this.safeNumber2(G, "minTradingQty", "minOrderQty"),
            max: this.safeNumber2(G, "maxTradingQty", "maxOrderQty")
          },
          price: {
            min: this.safeNumber(W, "minPrice"),
            max: this.safeNumber(W, "maxPrice")
          },
          cost: {
            min: void 0,
            max: void 0
          }
        },
        created: this.safeInteger(c, "launchTime"),
        info: c
      });
    }
    return r;
  }
  async fetchOptionMarkets(e) {
    const t = {
      category: "option"
    }, i = await this.publicGetV5MarketInstrumentsInfo(this.extend(t, e)), s = this.safeValue(i, "result", {});
    let n = this.safeValue(s, "list", []);
    if (this.options.loadAllOptions) {
      t.limit = 1e3;
      let a = this.safeString(s, "nextPageCursor");
      if (a !== void 0)
        for (; a !== void 0; ) {
          t.cursor = a;
          const o = await this.publicGetV5MarketInstrumentsInfo(this.extend(t, e)), c = this.safeValue(o, "result", {}), u = this.safeValue(c, "list", []);
          if (u.length === 0)
            break;
          n = this.arrayConcat(u, n), a = this.safeString(c, "nextPageCursor");
        }
    }
    const r = [];
    for (let a = 0; a < n.length; a++) {
      const o = n[a], c = this.safeString(o, "symbol"), u = this.safeString(o, "baseCoin"), f = this.safeString(o, "quoteCoin"), h = this.safeString(o, "settleCoin"), l = this.safeCurrencyCode(u), p = this.safeCurrencyCode(f), m = this.safeCurrencyCode(h), y = this.safeValue(o, "lotSizeFilter", {}), w = this.safeValue(o, "priceFilter", {}), S = this.safeString(o, "status"), b = this.safeInteger(o, "deliveryTime"), T = c.split("-"), x = this.safeString(T, 2), v = this.safeString(T, 3), _ = S === "Trading";
      (_ || this.options.loadAllOptions || this.options.loadExpiredOptions) && r.push({
        id: c,
        symbol: l + "/" + p + ":" + m + "-" + this.yymmdd(b) + "-" + x + "-" + v,
        base: l,
        quote: p,
        settle: m,
        baseId: u,
        quoteId: f,
        settleId: h,
        type: "option",
        spot: !1,
        margin: !1,
        swap: !1,
        future: !1,
        option: !0,
        active: _,
        contract: !0,
        linear: void 0,
        inverse: void 0,
        taker: this.safeNumber(o, "takerFee", this.parseNumber("0.0006")),
        maker: this.safeNumber(o, "makerFee", this.parseNumber("0.0001")),
        contractSize: this.safeNumber(y, "minOrderQty"),
        expiry: b,
        expiryDatetime: this.iso8601(b),
        strike: this.parseNumber(x),
        optionType: this.safeStringLower(o, "optionsType"),
        precision: {
          amount: this.safeNumber(y, "qtyStep"),
          price: this.safeNumber(w, "tickSize")
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: this.safeNumber(y, "minOrderQty"),
            max: this.safeNumber(y, "maxOrderQty")
          },
          price: {
            min: this.safeNumber(w, "minPrice"),
            max: this.safeNumber(w, "maxPrice")
          },
          cost: {
            min: void 0,
            max: void 0
          }
        },
        created: this.safeInteger(o, "launchTime"),
        info: o
      });
    }
    return r;
  }
  parseTicker(e, t = void 0) {
    const i = this.safeString(e, "openInterestValue") === void 0, s = this.safeInteger(e, "time"), n = this.safeString(e, "symbol"), r = i ? "spot" : "contract";
    t = this.safeMarket(n, t, void 0, r);
    const a = this.safeSymbol(n, t, void 0, r), o = this.safeString(e, "lastPrice"), c = this.safeString(e, "prevPrice24h");
    let u = this.safeString(e, "price24hPcnt");
    u = P.stringMul(u, "100");
    const f = this.safeString(e, "turnover24h"), h = this.safeString(e, "volume24h"), l = this.safeString(e, "bid1Price"), p = this.safeString(e, "ask1Price"), m = this.safeString(e, "highPrice24h"), y = this.safeString(e, "lowPrice24h");
    return this.safeTicker({
      symbol: a,
      timestamp: s,
      datetime: this.iso8601(s),
      high: m,
      low: y,
      bid: l,
      bidVolume: this.safeString2(e, "bidSize", "bid1Size"),
      ask: p,
      askVolume: this.safeString2(e, "askSize", "ask1Size"),
      vwap: void 0,
      open: c,
      close: o,
      last: o,
      previousClose: void 0,
      change: void 0,
      percentage: u,
      average: void 0,
      baseVolume: h,
      quoteVolume: f,
      info: e
    }, t);
  }
  async fetchTicker(e, t = {}) {
    if (e === void 0)
      throw new g("fetchTicker() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
      // 'baseCoin': '', Base coin. For option only
      // 'expDate': '', Expiry date. e.g., 25DEC22. For option only
    };
    i.spot ? s.category = "spot" : i.option ? s.category = "option" : i.linear ? s.category = "linear" : i.inverse && (s.category = "inverse");
    const n = await this.publicGetV5MarketTickers(this.extend(s, t)), r = this.safeValue(n, "result", []), a = this.safeValue(r, "list", []), o = this.safeValue(a, 0);
    return this.parseTicker(o, i);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets();
    let i, s;
    if (e !== void 0) {
      s = [];
      const f = this.handleMarketTypeAndParams("fetchTickers", void 0, t)[0];
      let h;
      for (let l = 0; l < e.length; l++) {
        const p = e[l];
        if (p.indexOf("/") === -1 ? i = this.safeMarket(p, void 0, void 0, f) : i = this.market(p), h === void 0)
          h = i.type;
        else if (i.type !== h)
          throw new g("fetchTickers can only accept a list of symbols of the same type").exchange(this.id);
        s.push(i.symbol);
      }
    }
    const n = {
      // 'symbol': market['id'],
      // 'baseCoin': '', // Base coin. For option only
      // 'expDate': '', // Expiry date. e.g., 25DEC22. For option only
    };
    let r;
    if ([r, t] = this.handleMarketTypeAndParams("fetchTickers", i, t), r === "spot")
      n.category = "spot";
    else if (r === "swap" || r === "future") {
      let u;
      [u, t] = this.handleSubTypeAndParams("fetchTickers", i, t, "linear"), n.category = u;
    } else
      r === "option" && (n.category = "option");
    const a = await this.publicGetV5MarketTickers(this.extend(n, t)), o = this.safeValue(a, "result", {}), c = this.safeValue(o, "list", []);
    return this.parseTickers(c, s);
  }
  parseOHLCV(e, t = void 0) {
    const i = t.inverse ? 6 : 5;
    return [
      this.safeInteger(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 2),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, i)
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    if (e === void 0)
      throw new g("fetchOHLCV() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 1e3);
    const a = this.market(e);
    let o = {
      symbol: a.id
    };
    s === void 0 && (s = 200), i !== void 0 && (o.start = i), s !== void 0 && (o.limit = s), [o, n] = this.handleUntilOption("end", o, n), o.interval = this.safeString(this.timeframes, t, t);
    let c;
    if (a.spot)
      o.category = "spot", c = await this.publicGetV5MarketKline(this.extend(o, n));
    else {
      const h = this.safeString(n, "price");
      if (n = this.omit(n, "price"), a.linear)
        o.category = "linear";
      else if (a.inverse)
        o.category = "inverse";
      else
        throw new ge(a.type).exchange(this.id);
      h === "mark" ? c = await this.publicGetV5MarketMarkPriceKline(this.extend(o, n)) : h === "index" ? c = await this.publicGetV5MarketIndexPriceKline(this.extend(o, n)) : h === "premiumIndex" ? c = await this.publicGetV5MarketPremiumIndexPriceKline(this.extend(o, n)) : c = await this.publicGetV5MarketKline(this.extend(o, n));
    }
    const u = this.safeValue(c, "result", {}), f = this.safeValue(u, "list", []);
    return this.parseOHLCVs(f, a, t, i, s);
  }
  parseTrade(e, t = void 0) {
    const i = this.safeStringN(e, ["execId", "id", "tradeId"]), s = this.safeString(e, "symbol");
    let n = "contract";
    t !== void 0 && (n = t.type);
    const r = this.safeString(e, "category");
    r !== void 0 && r === "spot" && (n = "spot"), t = this.safeMarket(s, t, void 0, n);
    const a = t.symbol, o = this.safeStringN(e, ["execQty", "orderQty", "size"]), c = this.safeStringN(e, ["execPrice", "orderPrice", "price"]), u = this.safeString(e, "execValue"), f = this.safeIntegerN(e, ["time", "execTime", "tradeTime"]);
    let h = this.safeStringLower(e, "side");
    if (h === void 0) {
      const S = this.safeInteger(e, "isBuyer");
      S !== void 0 && (h = S ? "buy" : "sell");
    }
    const l = this.safeValue(e, "isMaker");
    let p;
    if (l !== void 0)
      p = l ? "maker" : "taker";
    else {
      let S = this.safeString(e, "lastLiquidityInd");
      S === "UNKNOWN" && (S = void 0), S !== void 0 && (S === "TAKER" || S === "MAKER" ? p = S.toLowerCase() : p = S === "AddedLiquidity" ? "maker" : "taker");
    }
    let m = this.safeStringLower(e, "orderType");
    m === "unknown" && (m = void 0);
    const y = this.safeString(e, "execFee");
    let w;
    if (y !== void 0) {
      const S = this.safeString(e, "feeRate");
      let b;
      t.spot ? P.stringGt(y, "0") ? h === "buy" ? b = t.base : b = t.quote : h === "buy" ? b = t.quote : b = t.base : b = t.inverse ? t.base : t.settle, w = {
        cost: y,
        currency: b,
        rate: S
      };
    }
    return this.safeTrade({
      id: i,
      info: e,
      timestamp: f,
      datetime: this.iso8601(f),
      symbol: a,
      order: this.safeString(e, "orderId"),
      type: m,
      side: h,
      takerOrMaker: p,
      price: c,
      amount: o,
      cost: u,
      fee: w
    }, t);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchTrades() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const n = this.market(e), r = {
      symbol: n.id
      // 'baseCoin': '', // Base coin. For option only. If not passed, return BTC data by default
      // 'optionType': 'Call', // Option type. Call or Put. For option only
    };
    i !== void 0 && (r.limit = i);
    let a;
    [a, s] = this.getBybitType("fetchTrades", n, s), r.category = a;
    const o = await this.publicGetV5MarketRecentTrade(this.extend(r, s)), c = this.safeValue(o, "result", {}), u = this.safeValue(c, "list", []);
    return this.parseTrades(u, n, t, i);
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    if (e === void 0)
      throw new g("fetchOrderBook() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(e), n = {
      symbol: s.id
    };
    let r = 25;
    s.spot ? (r = 50, n.category = "spot") : s.option ? n.category = "option" : s.linear ? n.category = "linear" : s.inverse && (n.category = "inverse"), n.limit = t !== void 0 ? t : r;
    const a = await this.publicGetV5MarketOrderbook(this.extend(n, i)), o = this.safeValue(a, "result", []), c = this.safeInteger(o, "ts");
    return this.parseOrderBook(o, e, c, "b", "a");
  }
  parseBalance(e) {
    const t = this.safeInteger(e, "time"), i = {
      info: e,
      timestamp: t,
      datetime: this.iso8601(t)
    }, s = this.safeValue(e, "result", {}), n = this.safeValueN(s, ["loanAccountList", "list", "balance"]);
    if (n === void 0) {
      const r = "USDC", a = this.account();
      a.free = this.safeString(s, "availableBalance"), a.total = this.safeString(s, "walletBalance"), i[r] = a;
    } else
      for (let r = 0; r < n.length; r++) {
        const a = n[r], o = this.safeString(a, "accountType");
        if (o === "UNIFIED" || o === "CONTRACT" || o === "SPOT") {
          const c = this.safeValue(a, "coin");
          for (let u = 0; u < c.length; u++) {
            const f = this.account(), h = c[u], l = this.safeString(h, "borrowAmount"), p = this.safeString(h, "accruedInterest");
            l !== void 0 && p !== void 0 && (f.debt = P.stringAdd(l, p)), f.total = this.safeString(h, "walletBalance"), f.free = this.safeString2(h, "availableToWithdraw", "free");
            const m = this.safeString(h, "coin"), y = this.safeCurrencyCode(m);
            i[y] = f;
          }
        } else {
          const c = this.account(), u = this.safeString(a, "loan"), f = this.safeString(a, "interest");
          u !== void 0 && f !== void 0 && (c.debt = P.stringAdd(u, f)), c.total = this.safeString2(a, "total", "walletBalance"), c.free = this.safeStringN(a, ["free", "availableBalanceWithoutConvert", "availableBalance", "transferBalance"]), c.used = this.safeString(a, "locked");
          const h = this.safeStringN(a, ["tokenId", "coin", "currencyCoin"]), l = this.safeCurrencyCode(h);
          i[l] = c;
        }
      }
    return this.safeBalance(i);
  }
  async fetchBalance(e = {}) {
    const t = e.methodCallId;
    await this.loadMarkets(!!t, { methodCallId: t });
    const i = {}, [s, n] = await this.isUnifiedEnabled({ methodCallId: t }), r = s || n;
    let a;
    [a, e] = this.handleMarketTypeAndParams("fetchBalance", void 0, e);
    const o = a === "spot", c = a === "swap";
    r ? (o || c) && (a = "unified") : c && (a = "contract");
    const u = this.safeValue(this.options, "accountsByType", {}), f = this.safeStringUpper(u, a, a);
    let h;
    [h, e] = this.handleMarginModeAndParams("fetchBalance", e);
    let l;
    const p = this.safeString(e, "memberId") !== void 0;
    return o && h !== void 0 ? l = await this.privateGetV5SpotCrossMarginTradeAccount(this.extend(i, e)) : f === "FUND" || p ? (i.accountType = f, l = await this.privateGetV5AssetTransferQueryAccountCoinsBalance(this.extend(i, e))) : (i.accountType = f, l = await this.privateGetV5AccountWalletBalance(this.extend(i, e))), this.parseBalance(l);
  }
  parseOrderStatus(e) {
    const t = {
      // v3 spot
      NEW: "open",
      PARTIALLY_FILLED: "open",
      FILLED: "closed",
      CANCELED: "canceled",
      PENDING_CANCEL: "open",
      PENDING_NEW: "open",
      REJECTED: "rejected",
      PARTIALLY_FILLED_CANCELLED: "closed",
      // v3 contract / unified margin / unified account
      Created: "open",
      New: "open",
      Rejected: "rejected",
      PartiallyFilled: "open",
      PartiallyFilledCanceled: "closed",
      Filled: "closed",
      PendingCancel: "open",
      Cancelled: "canceled",
      // below this line the status only pertains to conditional orders
      Untriggered: "open",
      Deactivated: "canceled",
      Triggered: "open",
      Active: "open"
    };
    return this.safeString(t, e, e);
  }
  parseTimeInForce(e) {
    const t = {
      GoodTillCancel: "GTC",
      ImmediateOrCancel: "IOC",
      FillOrKill: "FOK",
      PostOnly: "PO"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    const i = this.safeString(e, "code");
    if (i !== void 0 && i !== "0") {
      const N = this.safeString(e, "category") === "spot" ? "spot" : "contract";
      return this.safeOrder({
        info: e,
        status: "rejected",
        id: this.safeString(e, "orderId"),
        clientOrderId: this.safeString(e, "orderLinkId"),
        symbol: this.safeSymbol(this.safeString(e, "symbol"), void 0, void 0, N)
      });
    }
    const s = this.safeString(e, "symbol"), n = "tpslMode" in e;
    let r;
    t !== void 0 ? r = t.type : r = n ? "contract" : "spot", t = this.safeMarket(s, t, void 0, r);
    const a = t.symbol, o = this.safeInteger2(e, "createdTime", "createdAt"), c = this.safeString(e, "orderId"), u = this.safeStringLower(e, "orderType"), f = this.safeString(e, "price"), h = this.safeString(e, "cumExecValue"), l = this.safeString(e, "cumExecQty"), p = this.safeString(e, "leavesQty"), m = this.safeInteger2(e, "updatedTime", "updatedAt"), y = this.safeString(e, "orderStatus"), w = this.parseOrderStatus(y), S = this.safeStringLower(e, "side");
    let b = this.safeString(e, "qty");
    const T = this.omitZero(this.safeString(e, "avgPrice"));
    S === "buy" && (b = P.stringDiv(b, T));
    let x;
    const v = this.safeString(e, "cumExecFee");
    if (v !== void 0) {
      let E;
      t.spot ? P.stringGt(v, "0") ? S === "buy" ? E = t.base : E = t.quote : S === "buy" ? E = t.quote : E = t.base : E = t.inverse ? t.base : t.settle, x = {
        cost: v,
        currency: E
      };
    }
    let _ = this.safeString(e, "orderLinkId");
    _ !== void 0 && _.length < 1 && (_ = void 0);
    const V = this.safeString(e, "timeInForce"), j = this.parseTimeInForce(V), G = this.omitZero(this.safeString(e, "triggerPrice")), W = this.safeValue(e, "reduceOnly");
    let B = this.omitZero(this.safeString(e, "takeProfit")), Q = this.omitZero(this.safeString(e, "stopLoss"));
    const $ = this.safeString(e, "triggerDirection") === "1", te = G !== void 0 && W;
    return Q === void 0 && te && ($ && S === "buy" && (Q = G), !$ && S === "sell" && (Q = G)), B === void 0 && te && ($ && S === "sell" && (B = G), !$ && S === "buy" && (B = G)), this.safeOrder({
      info: e,
      id: c,
      clientOrderId: _,
      timestamp: o,
      datetime: this.iso8601(o),
      lastTradeTimestamp: m,
      lastUpdateTimestamp: m,
      symbol: a,
      type: u,
      timeInForce: j,
      postOnly: void 0,
      reduceOnly: this.safeValue(e, "reduceOnly"),
      side: S,
      price: f,
      stopPrice: G,
      triggerPrice: G,
      takeProfitPrice: B,
      stopLossPrice: Q,
      amount: b,
      cost: h,
      average: T,
      filled: l,
      remaining: p,
      status: w,
      fee: x,
      trades: void 0
    }, t);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("fetchOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = {
      orderId: e
    }, n = await this.fetchOrders(t, void 0, void 0, this.extend(s, i)), r = n.length;
    if (r === 0) {
      const o = (await this.fetchOpenOrders(t, void 0, void 0, i)).find((f) => f.id === e);
      if (o !== void 0)
        return o;
      const u = this.safeBoolN(i, ["trigger", "stop"], !1) ? "" : 'If you are trying to fetch SL/TP conditional order, you might try setting params["trigger"] = true';
      throw new Se().addMessage("Order " + e.toString() + " was not found." + u);
    }
    if (r > 1)
      throw new k().addMessage(this.id + " returned more than one order").exchange(this.id);
    return this.safeValue(n, 0);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("createMarketBuyOrderWithCost() supports spot orders only").exchange(this.id);
    return await this.createOrder(e, "market", "buy", t, 1, i);
  }
  async createMarketSellOrderWithCost(e, t, i = {}) {
    if (await this.loadMarkets(), !(await this.isUnifiedEnabled())[1])
      throw new k().addMessage("createMarketSellOrderWithCost() supports UTA accounts only").exchange(this.id);
    const r = this.market(e);
    if (!r.spot)
      throw new ge(r.type).addMessage("createMarketSellOrderWithCost() supports spot orders only").exchange(this.id);
    return await this.createOrder(e, "market", "sell", t, 1, i);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), [o, c] = await this.isUnifiedEnabled(), u = o || c;
    if (a.settle === "USDC" && !u)
      return await this.createUsdcOrder(e, t, i, s, n, r);
    const l = this.safeString2(r, "trailingAmount", "trailingStop") !== void 0, p = this.createOrderRequest(e, t, i, s, n, r, c);
    let m;
    l ? m = await this.privatePostV5PositionTradingStop(p) : m = await this.privatePostV5OrderCreate(p);
    const y = this.safeValue(m, "result", {});
    return this.parseOrder(y, a);
  }
  createOrderRequest(e, t, i, s, n = void 0, r = {}, a = !0) {
    const o = this.market(e);
    e = o.symbol;
    const c = t.toLowerCase();
    if (n === void 0 && c === "limit")
      throw new g("createOrder requires a price argument for limit orders").exchange(this.id);
    const u = {
      symbol: o.id,
      side: this.capitalize(i),
      orderType: this.capitalize(c)
      // limit or market
      // 'timeInForce': 'GTC', // IOC, FOK, PostOnly
      // 'takeProfit': 123.45, // take profit price, only take effect upon opening the position
      // 'stopLoss': 123.45, // stop loss price, only take effect upon opening the position
      // 'reduceOnly': false, // reduce only, required for linear orders
      // when creating a closing order, bybit recommends a True value for
      //  closeOnTrigger to avoid failing due to insufficient available margin
      // 'closeOnTrigger': false, required for linear orders
      // 'orderLinkId': 'string', // unique client order id, max 36 characters
      // 'triggerPrice': 123.46, // trigger price, required for conditional orders
      // 'triggerBy': 'MarkPrice', // IndexPrice, MarkPrice, LastPrice
      // 'tpTriggerby': 'MarkPrice', // IndexPrice, MarkPrice, LastPrice
      // 'slTriggerBy': 'MarkPrice', // IndexPrice, MarkPrice, LastPrice
      // 'mmp': false // market maker protection
      // 'positionIdx': 0, // Position mode. Unified account has one-way mode only (0)
      // 'triggerDirection': 1, // Conditional order param. Used to identify the expected direction of the conditional order. 1: triggered when market price rises to triggerPrice 2: triggered when market price falls to triggerPrice
      // Valid for spot only.
      // 'isLeverage': 0, // Whether to borrow. 0(default): false, 1: true
      // 'orderFilter': 'Order' // Order,tpslOrder. If not passed, Order by default
      // Valid for option only.
      // 'orderIv': '0', // Implied volatility; parameters are passed according to the real value; for example, for 10%, 0.1 is passed
    };
    o.spot ? u.category = "spot" : o.linear ? u.category = "linear" : o.inverse ? u.category = "inverse" : o.option && (u.category = "option");
    const f = this.safeString(r, "cost");
    if (r = this.omit(r, "cost"), o.spot && c === "market" && i === "sell" && a)
      u.marketUnit = "baseCoin", u.qty = this.amountToPrecision(e, s);
    else if (o.spot && c === "market" && i === "buy") {
      let se = !0;
      if ([se, r] = this.handleOptionAndParams(r, "createOrder", "createMarketBuyOrderRequiresPrice", !0), se) {
        if (n === void 0 && f === void 0)
          throw new g("createOrder() requires the price argument for market buy orders to calculate the total cost to spend (amount * price), alternatively set the createMarketBuyOrderRequiresPrice option or param to false and pass the cost to spend in the amount argument").exchange(this.id);
        {
          const $ = this.numberToString(s), te = this.numberToString(n), E = P.stringMul($, te), N = f !== void 0 ? f : E;
          u.qty = this.costToPrecision(e, N);
        }
      } else
        u.qty = this.costToPrecision(e, s);
    } else
      u.qty = this.amountToPrecision(e, s);
    const h = c === "market";
    c === "limit" && (u.price = this.priceToPrecision(e, n));
    const p = this.safeStringLower(r, "timeInForce");
    let m;
    [m, r] = this.handlePostOnly(h, p === "postonly", r), m ? u.timeInForce = "PostOnly" : p === "gtc" ? u.timeInForce = "GTC" : p === "fok" ? u.timeInForce = "FOK" : p === "ioc" && (u.timeInForce = "IOC");
    let y = this.safeValue2(r, "triggerPrice", "stopPrice");
    const w = this.safeValue(r, "stopLossPrice"), S = this.safeValue(r, "takeProfitPrice"), b = this.safeValue(r, "stopLoss"), T = this.safeValue(r, "takeProfit"), x = this.safeString2(r, "trailingTriggerPrice", "activePrice", this.numberToString(n)), v = this.safeString2(r, "trailingAmount", "trailingStop"), _ = v !== void 0, V = w !== void 0, j = S !== void 0, G = b !== void 0, W = T !== void 0, B = i === "buy";
    if (_)
      x !== void 0 && (u.activePrice = this.priceToPrecision(e, x)), u.trailingStop = v;
    else if (y !== void 0) {
      const se = this.safeString(r, "triggerDirection");
      if (r = this.omit(r, ["triggerPrice", "stopPrice", "triggerDirection"]), o.spot) {
        if (se !== void 0)
          throw new g("createOrder() : trigger order does not support triggerDirection for spot markets yet").exchange(this.id);
      } else {
        if (se === void 0)
          throw new g('stop/trigger orders require a triggerDirection parameter, either "above" or "below" to determine the direction of the trigger.').exchange(this.id);
        const $ = se === "above" || se === "1";
        u.triggerDirection = $ ? 1 : 2;
      }
      u.triggerPrice = this.priceToPrecision(e, y);
    } else
      (V || j) && (B ? u.triggerDirection = V ? 1 : 2 : u.triggerDirection = V ? 2 : 1, y = V ? w : S, u.triggerPrice = this.priceToPrecision(e, y), u.reduceOnly = !0);
    if (G || W) {
      if (G) {
        const se = this.safeValue2(b, "triggerPrice", "stopPrice", b);
        u.stopLoss = this.priceToPrecision(e, se);
        const $ = this.safeValue(b, "price");
        $ !== void 0 && (u.tpslMode = "Partial", u.slOrderType = "Limit", u.slLimitPrice = this.priceToPrecision(e, $));
      }
      if (W) {
        const se = this.safeValue2(T, "triggerPrice", "stopPrice", T);
        u.takeProfit = this.priceToPrecision(e, se);
        const $ = this.safeValue(T, "price");
        $ !== void 0 && (u.tpslMode = "Partial", u.tpOrderType = "Limit", u.tpLimitPrice = this.priceToPrecision(e, $));
      }
    }
    o.spot && (y !== void 0 ? u.orderFilter = "StopOrder" : (w !== void 0 || S !== void 0 || G || W) && (u.orderFilter = "tpslOrder"));
    const Q = this.safeString(r, "clientOrderId");
    return Q !== void 0 ? u.orderLinkId = Q : o.option && (u.orderLinkId = this.uuid16()), r = this.omit(r, ["stopPrice", "timeInForce", "stopLossPrice", "takeProfitPrice", "postOnly", "clientOrderId", "triggerPrice", "stopLoss", "takeProfit", "trailingAmount", "trailingTriggerPrice"]), this.extend(u, r);
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const s = (await this.isUnifiedEnabled())[1], n = [], r = [];
    for (let y = 0; y < e.length; y++) {
      const w = e[y], S = this.safeString(w, "symbol");
      r.push(S);
      const b = this.safeString(w, "type"), T = this.safeString(w, "side"), x = this.safeValue(w, "amount"), v = this.safeValue(w, "price"), _ = this.safeValue(w, "params", {}), V = this.createOrderRequest(S, b, T, x, v, _, s);
      n.push(V);
    }
    const a = this.marketSymbols(r, void 0, !1, !0, !0), o = this.market(a[0]);
    let c;
    if ([c, t] = this.getBybitType("createOrders", o, t), c === "spot" || c === "inverse")
      throw new g("createOrders does not allow spot or inverse orders").exchange(this.id);
    const u = {
      category: c,
      request: n
    }, f = await this.privatePostV5OrderCreateBatch(this.extend(u, t)), h = this.safeValue(f, "result", {}), l = this.safeValue(h, "list", []), p = this.safeValue(f, "retExtInfo", {}), m = this.safeValue(p, "list", []);
    for (let y = 0; y < m.length; y++) {
      const w = m[y];
      this.safeInteger(w, "code") !== 0 && (l[y] = this.extend(l[y], w));
    }
    return this.parseOrders(l);
  }
  async createUsdcOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e);
    if (t === "market")
      throw new k().addMessage("createOrder does not allow market orders for " + e + " markets").exchange(this.id);
    const o = t.toLowerCase();
    if (n === void 0 && o === "limit")
      throw new g("createOrder requires a price argument for limit orders").exchange(this.id);
    const c = {
      symbol: a.id,
      side: this.capitalize(i),
      orderType: this.capitalize(o),
      timeInForce: "GoodTillCancel",
      orderQty: this.amountToPrecision(e, s)
      // 'takeProfit': 123.45, // take profit price, only take effect upon opening the position
      // 'stopLoss': 123.45, // stop loss price, only take effect upon opening the position
      // 'reduceOnly': false, // reduce only, required for linear orders
      // when creating a closing order, bybit recommends a True value for
      //  closeOnTrigger to avoid failing due to insufficient available margin
      // 'closeOnTrigger': false, required for linear orders
      // 'orderLinkId': 'string', // unique client order id, max 36 characters
      // 'triggerPrice': 123.45, // trigger price, required for conditional orders
      // 'trigger_by': 'MarkPrice', // IndexPrice, MarkPrice
      // 'tptriggerby': 'MarkPrice', // IndexPrice, MarkPrice
      // 'slTriggerBy': 'MarkPrice', // IndexPrice, MarkPrice
      // 'orderFilter': 'Order' or 'StopOrder'
      // 'mmp': false // market maker protection
    }, u = o === "market";
    o === "limit" !== void 0 && (c.orderPrice = this.priceToPrecision(e, n));
    const h = this.safeString(r, "time_in_force"), l = this.safeStringLower(r, "timeInForce");
    if (this.isPostOnly(u, h === "PostOnly", r) ? c.time_in_force = "PostOnly" : l === "gtc" ? c.time_in_force = "GoodTillCancel" : l === "fok" ? c.time_in_force = "FillOrKill" : l === "ioc" && (c.time_in_force = "ImmediateOrCancel"), a.swap) {
      const S = this.safeValue2(r, "stopPrice", "triggerPrice"), b = this.safeValue(r, "stopLossPrice", S), T = this.safeValue(r, "takeProfitPrice"), x = this.safeValue(r, "stopLoss"), v = this.safeValue(r, "takeProfit"), _ = b !== void 0, V = T !== void 0, j = x !== void 0, G = v !== void 0;
      if (_ || V) {
        c.orderFilter = "StopOrder", c.trigger_by = "LastPrice";
        const B = _ ? b : T, Q = this.priceToPrecision(e, B);
        c.triggerPrice = Q;
        const se = this.numberToString(a.precision.price);
        c.basePrice = _ ? P.stringSub(Q, se) : P.stringAdd(Q, se);
      } else if (j || G) {
        if (j) {
          const B = this.safeValue2(x, "triggerPrice", "stopPrice", x);
          c.stopLoss = this.priceToPrecision(e, B);
        }
        if (G) {
          const B = this.safeValue2(v, "triggerPrice", "stopPrice", v);
          c.takeProfit = this.priceToPrecision(e, B);
        }
      } else
        c.orderFilter = "Order";
    }
    const m = this.safeString(r, "clientOrderId");
    m !== void 0 ? c.orderLinkId = m : a.option && (c.orderLinkId = this.uuid16()), r = this.omit(r, ["stopPrice", "timeInForce", "triggerPrice", "stopLossPrice", "takeProfitPrice", "postOnly", "clientOrderId"]);
    let y;
    a.option ? y = await this.privatePostOptionUsdcOpenapiPrivateV1PlaceOrder(this.extend(c, r)) : y = await this.privatePostPerpetualUsdcOpenapiPrivateV1PlaceOrder(this.extend(c, r));
    const w = this.safeValue(y, "result", {});
    return this.parseOrder(w, a);
  }
  async editUsdcOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t), c = {
      symbol: o.id,
      orderId: e
    };
    n !== void 0 && (c.orderQty = this.amountToPrecision(t, n)), r !== void 0 && (c.orderPrice = this.priceToPrecision(t, r));
    let u;
    if (o.option)
      u = await this.privatePostOptionUsdcOpenapiPrivateV1ReplaceOrder(this.extend(c, a));
    else {
      const h = this.safeValue2(a, "stop", "trigger", !1), l = this.safeValue2(a, "stopPrice", "triggerPrice"), p = this.safeValue(a, "stopLossPrice"), m = p !== void 0, y = this.safeValue(a, "takeProfitPrice");
      (m || y !== void 0 || h) && (c.orderFilter = h ? "StopOrder" : "Order", l !== void 0 && (c.triggerPrice = this.priceToPrecision(t, l)), p !== void 0 && (c.stopLoss = this.priceToPrecision(t, p)), y !== void 0 && (c.takeProfit = this.priceToPrecision(t, y))), a = this.omit(a, ["stop", "stopPrice", "triggerPrice", "stopLossPrice", "takeProfitPrice"]), u = await this.privatePostPerpetualUsdcOpenapiPrivateV1ReplaceOrder(this.extend(c, a));
    }
    const f = this.safeValue(u, "result", {});
    return this.parseOrder(f, o);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    if (t === void 0)
      throw new g("editOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const o = this.market(t), [c, u] = await this.isUnifiedEnabled(), f = c || u;
    if (o.settle === "USDC" && !f)
      return await this.editUsdcOrder(e, t, i, s, n, r, a);
    const l = {
      symbol: o.id,
      orderId: e
      // 'orderLinkId': 'string', // unique client order id, max 36 characters
      // 'takeProfit': 123.45, // take profit price, only take effect upon opening the position
      // 'stopLoss': 123.45, // stop loss price, only take effect upon opening the position
      // 'triggerPrice': 123.45, // trigger price, required for conditional orders
      // 'triggerBy': 'MarkPrice', // IndexPrice, MarkPrice, LastPrice
      // 'tpTriggerby': 'MarkPrice', // IndexPrice, MarkPrice, LastPrice
      // 'slTriggerBy': 'MarkPrice', // IndexPrice, MarkPrice, LastPrice
      // Valid for option only.
      // 'orderIv': '0', // Implied volatility; parameters are passed according to the real value; for example, for 10%, 0.1 is passed
    };
    o.spot ? l.category = "spot" : o.linear ? l.category = "linear" : o.inverse ? l.category = "inverse" : o.option && (l.category = "option"), n !== void 0 && (l.qty = this.amountToPrecision(t, n)), r !== void 0 && (l.price = this.priceToPrecision(t, r)), n !== void 0 && (l.qty = this.amountToPrecision(t, n));
    let p = this.safeString2(a, "triggerPrice", "stopPrice");
    const m = this.safeString(a, "stopLossPrice"), y = this.safeString(a, "takeProfitPrice"), w = this.safeValue(a, "stopLoss"), S = this.safeValue(a, "takeProfit"), b = m !== void 0, T = y !== void 0, x = w !== void 0, v = S !== void 0;
    if ((b || T) && (p = b ? m : y), p !== void 0) {
      const G = p === "0" ? p : this.priceToPrecision(t, p);
      l.triggerPrice = G;
      const W = this.safeString(a, "triggerBy", "LastPrice");
      l.triggerBy = W;
    }
    if (x || v) {
      if (x) {
        const G = this.safeString2(w, "triggerPrice", "stopPrice", w), W = G === "0" ? G : this.priceToPrecision(t, G);
        l.stopLoss = W;
        const B = this.safeString(a, "slTriggerBy", "LastPrice");
        l.slTriggerBy = B;
      }
      if (v) {
        const G = this.safeString2(S, "triggerPrice", "stopPrice", S), W = G === "0" ? G : this.priceToPrecision(t, G);
        l.takeProfit = W;
        const B = this.safeString(a, "tpTriggerBy", "LastPrice");
        l.tpTriggerBy = B;
      }
    }
    const _ = this.safeString(a, "clientOrderId");
    _ !== void 0 && (l.orderLinkId = _), a = this.omit(a, ["stopPrice", "stopLossPrice", "takeProfitPrice", "triggerPrice", "clientOrderId", "stopLoss", "takeProfit"]);
    const V = await this.privatePostV5OrderAmend(this.extend(l, a)), j = this.safeValue(V, "result", {});
    return this.safeOrder({
      info: V,
      id: this.safeString(j, "orderId")
    });
  }
  async cancelUsdcOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelUsdcOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), n = {
      symbol: s.id
      // 'orderLinkId': 'string', // one of order_id, stop_order_id or order_link_id is required
      // 'orderId': id,
    }, r = this.safeValue2(i, "stop", "trigger", !1);
    i = this.omit(i, ["stop", "trigger"]), e !== void 0 && (n.orderId = e);
    let a;
    s.option ? a = await this.privatePostOptionUsdcOpenapiPrivateV1CancelOrder(this.extend(n, i)) : (n.orderFilter = r ? "StopOrder" : "Order", a = await this.privatePostPerpetualUsdcOpenapiPrivateV1CancelOrder(this.extend(n, i)));
    const o = this.safeValue(a, "result", {});
    return this.parseOrder(o, s);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), [n, r] = await this.isUnifiedEnabled(), a = n || r;
    if (s.settle === "USDC" && !a)
      return await this.cancelUsdcOrder(e, t, i);
    const c = {
      symbol: s.id
      // 'orderLinkId': 'string',
      // 'orderId': id,
      // conditional orders
      // 'orderFilter': '', // Valid for spot only. Order,tpslOrder. If not passed, Order by default
    };
    if (s.spot) {
      const h = this.safeValue2(i, "stop", "trigger", !1);
      i = this.omit(i, ["stop", "trigger"]), c.orderFilter = h ? "StopOrder" : "Order";
    }
    e !== void 0 && (c.orderId = e), s.spot ? c.category = "spot" : s.linear ? c.category = "linear" : s.inverse ? c.category = "inverse" : s.option && (c.category = "option");
    const u = await this.privatePostV5OrderCancel(this.extend(c, i)), f = this.safeValue(u, "result", {});
    return this.parseOrder(f, s);
  }
  async cancelAllUsdcOrders(e = void 0, t = {}) {
    if (e === void 0)
      throw new g("cancelAllUsdcOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    };
    let n;
    i.option ? n = await this.privatePostOptionUsdcOpenapiPrivateV1CancelAll(this.extend(s, t)) : (this.safeValue2(t, "stop", "trigger", !1) ? s.orderFilter = "StopOrder" : s.orderFilter = "Order", t = this.omit(t, ["stop", "trigger"]), n = await this.privatePostPerpetualUsdcOpenapiPrivateV1CancelAll(this.extend(s, t)));
    const r = this.safeValue(n, "result", []);
    return Array.isArray(r) ? this.parseOrders(r, i) : n;
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    const [i, s] = await this.isUnifiedEnabled(), n = i || s;
    let r;
    const a = {};
    if (e !== void 0) {
      if (r = this.market(e), r.settle === "USDC" && !n)
        return await this.cancelAllUsdcOrders(e, t);
      a.symbol = r.id;
    }
    let o;
    if ([o, t] = this.getBybitType("cancelAllOrders", r, t), a.category = o, o === "option" && !n)
      throw new ge("type").addMessage("cancelAllOrders() Normal Account not support " + o + " market").exchange(this.id);
    if (o === "linear" || o === "inverse") {
      const l = this.safeString(t, "baseCoin");
      if (e === void 0 && l === void 0) {
        const p = this.safeString(this.options, "defaultSettle", "USDT");
        a.settleCoin = this.safeString(t, "settleCoin", p);
      }
    }
    const c = this.safeValue2(t, "stop", "trigger", !1);
    t = this.omit(t, ["stop", "trigger"]), c && (a.orderFilter = "StopOrder");
    const u = await this.privatePostV5OrderCancelAll(this.extend(a, t)), f = this.safeValue(u, "result", []), h = this.safeValue(f, "list");
    return Array.isArray(h) ? this.parseOrders(h, r) : u;
  }
  async fetchUsdcOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {
      // 'category': '', // Type. PERPETUAL, OPTION
      // 'symbol': '', // Contract name
      // 'baseCoin': '', // Base currency
      // 'orderId': '', // Order ID
      // 'orderLinkId': '', // Custom ID used for cross-platform strategy remarks; a max. of 32 characters
      // 'orderStatus': '', // Order status
      // 'orderFilter': '', // refer to Order Filter
      // 'direction': '', // prev: prev page, next: next page.
      // 'limit': 0, // Limit for data size per page, max size is 50. Default as showing 20 pieces of data per page
      // 'cursor': '', // API pass-through
    };
    e !== void 0 && (n = this.market(e), r.symbol = n.id);
    let a;
    [a, s] = this.handleMarketTypeAndParams("fetchOrders", n, s), a === "swap" ? r.category = "PERPETUAL" : r.category = "OPTION";
    const o = this.safeValue2(s, "stop", "trigger", !1);
    s = this.omit(s, ["stop", "trigger"]), o && (r.orderFilter = "StopOrder"), i !== void 0 && (r.limit = i);
    const c = await this.privatePostOptionUsdcOpenapiPrivateV1QueryOrderHistory(this.extend(r, s)), u = this.safeValue(c, "result", {}), f = this.safeValue(u, "dataList", []);
    return this.parseOrders(f, n, t, i);
  }
  async fetchOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchOrders", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchOrders", e, t, i, s, "nextPageCursor", "nextPageCursor", void 0, 50);
    const [r, a] = await this.isUnifiedEnabled(), o = r || a, c = {};
    let u, f = !1;
    e !== void 0 && (u = this.market(e), f = u.settle === "USDC", c.symbol = u.id);
    let h;
    if ([h, s] = this.getBybitType("fetchOrders", u, s), (h === "option" || f) && !o)
      return await this.fetchUsdcOrders(e, t, i, s);
    c.category = h;
    const l = this.safeBoolN(s, ["trigger", "stop"], !1);
    s = this.omit(s, ["trigger", "stop"]), l && (c.orderFilter = "StopOrder"), i !== void 0 && (c.limit = i), t !== void 0 && (c.startTime = t);
    const p = this.safeInteger2(s, "until", "till"), m = this.safeInteger(s, "endTime", p);
    s = this.omit(s, ["endTime", "till", "until"]), m !== void 0 && (c.endTime = m);
    const y = await this.privateGetV5OrderHistory(this.extend(c, s)), w = this.addPaginationCursorToResult(y);
    return this.parseOrders(w, u, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {
      orderStatus: "Filled"
    };
    return await this.fetchOrders(e, t, i, this.extend(n, s));
  }
  async fetchCanceledOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {
      orderStatus: "Cancelled"
    };
    return await this.fetchOrders(e, t, i, this.extend(n, s));
  }
  async fetchUsdcOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    let r;
    e !== void 0 && (r = this.market(e), n.symbol = r.id);
    let a;
    [a, s] = this.handleMarketTypeAndParams("fetchUsdcOpenOrders", r, s), n.category = a === "swap" ? "perpetual" : "option";
    const o = await this.privatePostOptionUsdcOpenapiPrivateV1QueryActiveOrders(this.extend(n, s)), c = this.safeValue(o, "result", {}), u = this.safeValue(c, "dataList", []);
    return this.parseOrders(u, r, t, i);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const [n, r] = await this.isUnifiedEnabled(), a = n || r, o = {};
    let c, u = !1;
    e !== void 0 && (c = this.market(e), u = c.settle === "USDC", o.symbol = c.id);
    let f;
    if ([f, s] = this.getBybitType("fetchOpenOrders", c, s), f === "linear" || f === "inverse") {
      const m = this.safeString(s, "baseCoin");
      if (e === void 0 && m === void 0) {
        const y = this.safeString(this.options, "defaultSettle", "USDT"), w = this.safeString(s, "settleCoin", y);
        o.settleCoin = w, u = w === "USDC";
      }
    }
    if ((f === "option" || u) && !a)
      return await this.fetchUsdcOpenOrders(e, t, i, s);
    o.category = f;
    const h = this.safeValue2(s, "stop", "trigger", !1);
    s = this.omit(s, ["stop", "trigger"]), h && (o.orderFilter = "StopOrder"), i !== void 0 && (o.limit = i);
    const l = await this.privateGetV5OrderRealtime(this.extend(o, s)), p = this.addPaginationCursorToResult(l);
    return this.parseOrders(p, c, t, i);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    const r = {}, a = this.safeString2(n, "clientOrderId", "orderLinkId");
    return a !== void 0 ? r.orderLinkId = a : r.orderId = e, n = this.omit(n, ["clientOrderId", "orderLinkId"]), await this.fetchMyTrades(t, i, s, this.extend(r, n));
  }
  async fetchMyUsdcTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {};
    e !== void 0 ? (n = this.market(e), r.symbol = n.id, r.category = n.option ? "OPTION" : "PERPETUAL") : r.category = "PERPETUAL";
    const a = await this.privatePostOptionUsdcOpenapiPrivateV1ExecutionList(this.extend(r, s)), o = this.safeValue(a, "result", {}), c = this.safeValue(o, "dataList", []);
    return this.parseTrades(c, n, t, i);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchMyTrades", e, t, i, s, "nextPageCursor", "nextPageCursor", void 0, 100);
    const [r, a] = await this.isUnifiedEnabled(), o = r || a;
    let c = {}, u, f = !1;
    e !== void 0 && (u = this.market(e), f = u.settle === "USDC", c.symbol = u.id);
    let h;
    if ([h, s] = this.getBybitType("fetchMyTrades", u, s), (h === "option" || f) && !o)
      return await this.fetchMyUsdcTrades(e, t, i, s);
    c.category = h, i !== void 0 && (c.limit = i), t !== void 0 && (c.startTime = t), [c, s] = this.handleUntilOption("endTime", c, s);
    const l = await this.privateGetV5ExecutionList(this.extend(c, s)), p = this.addPaginationCursorToResult(l);
    return this.parseTrades(p, u, t, i);
  }
  parseDepositAddress(e, t = void 0) {
    const i = this.safeString(e, "addressDeposit"), s = this.safeString(e, "tagDeposit"), n = this.safeString(t, "code"), r = this.safeString(e, "chain"), a = this.networkIdToCode(r);
    return this.checkAddress(i), {
      currency: n,
      address: i,
      tag: s,
      network: a,
      info: e
    };
  }
  async fetchDepositAddressesByNetwork(e, t = {}) {
    const i = t.methodCallId;
    await this.loadMarkets(!!i, { methodCallId: i });
    let s = this.currency(e);
    const n = {
      coin: s.id
    }, r = await this.privateGetV5AssetDepositQueryAddress(this.extend(n, t)), a = this.safeValue(r, "result", []), o = this.safeValue(a, "chains", []), c = this.safeString(a, "coin");
    s = this.currency(c);
    const u = this.parseDepositAddresses(o, [s.code], !1, {
      currency: s.id
    });
    return this.indexBy(u, "network");
  }
  async fetchDepositAddress(e, t = {}) {
    const i = t.methodCallId;
    await this.loadMarkets(!!i, { methodCallId: i });
    const [s, n] = this.handleNetworkCodeAndParams(t), r = this.networkCodeToId(s), a = this.currency(e), o = {
      coin: a.id
    };
    r !== void 0 && (o.chainType = r);
    const c = await this.privateGetV5AssetDepositQueryAddress(this.extend(o, n)), u = this.safeValue(c, "result", {}), f = this.safeValue(u, "chains", []), h = this.indexBy(f, "chain"), l = this.selectNetworkIdFromRawNetworks(e, s, h), p = this.safeValue(h, l, {});
    return this.parseDepositAddress(p, a);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchDeposits", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchDeposits", e, t, i, s, "nextPageCursor", "nextPageCursor", void 0, 50);
    let r = {
      // 'coin': currency['id'],
      // 'limit': 20, // max 50
      // 'cursor': '',
    }, a;
    e !== void 0 && (a = this.currency(e), r.coin = a.id), t !== void 0 && (r.startTime = t), i !== void 0 && (r.limit = i), [r, s] = this.handleUntilOption("endTime", r, s);
    const o = await this.privateGetV5AssetDepositQueryRecord(this.extend(r, s)), c = this.addPaginationCursorToResult(o);
    return this.parseTransactions(c, a, t, i);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchWithdrawals", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchWithdrawals", e, t, i, s, "nextPageCursor", "nextPageCursor", void 0, 50);
    let r = {
      // 'coin': currency['id'],
      // 'limit': 20, // max 50
      // 'cusor': '',
    }, a;
    e !== void 0 && (a = this.currency(e), r.coin = a.id), t !== void 0 && (r.startTime = t), i !== void 0 && (r.limit = i), [r, s] = this.handleUntilOption("endTime", r, s);
    const o = await this.privateGetV5AssetWithdrawQueryRecord(this.extend(r, s)), c = this.addPaginationCursorToResult(o);
    return this.parseTransactions(c, a, t, i);
  }
  parseTransactionStatus(e) {
    const t = {
      // v3 deposit status
      0: "unknown",
      1: "pending",
      2: "processing",
      3: "ok",
      4: "fail",
      // v3 withdrawal status
      SecurityCheck: "pending",
      Pending: "pending",
      success: "ok",
      CancelByUser: "canceled",
      Reject: "rejected",
      Fail: "failed",
      BlockchainConfirmed: "ok"
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString(e, "coin"), s = this.safeCurrencyCode(i, t), n = this.safeInteger2(e, "createTime", "successAt"), r = this.safeInteger(e, "updateTime"), a = this.parseTransactionStatus(this.safeString(e, "status")), o = this.safeNumber2(e, "depositFee", "withdrawFee"), c = "depositFee" in e ? "deposit" : "withdrawal";
    let u;
    o !== void 0 && (u = {
      cost: o,
      currency: s
    });
    const f = this.safeString(e, "toAddress");
    return {
      info: e,
      id: this.safeString2(e, "id", "withdrawId"),
      txid: this.safeString(e, "txID"),
      timestamp: n,
      datetime: this.iso8601(n),
      network: this.networkIdToCode(this.safeString(e, "chain")),
      address: void 0,
      addressTo: f,
      addressFrom: void 0,
      tag: this.safeString(e, "tag"),
      tagTo: void 0,
      tagFrom: void 0,
      type: c,
      amount: this.safeNumber(e, "amount"),
      currency: s,
      status: a,
      updated: r,
      fee: u,
      internal: void 0,
      comment: void 0
    };
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {
      // 'coin': currency['id'],
      // 'currency': currency['id'], // alias
      // 'start_date': this.iso8601 (since),
      // 'end_date': this.iso8601 (till),
      // 'wallet_fund_type': 'Deposit', // Withdraw, RealisedPNL, Commission, Refund, Prize, ExchangeOrderWithdraw, ExchangeOrderDeposit
      // 'page': 1,
      // 'limit': 20, // max 50
      // v5 transaction log
      // 'accountType': '', Account Type. UNIFIED
      // 'category': '', Product type. spot,linear,option
      // 'currency': '', Currency
      // 'baseCoin': '', BaseCoin. e.g., BTC of BTCPERP
      // 'type': '', Types of transaction logs
      // 'startTime': 0, The start timestamp (ms)
      // 'endTime': 0, The end timestamp (ms)
      // 'limit': 0, Limit for data size per page. [1, 50]. Default: 20
      // 'cursor': '', Cursor. Used for pagination
    }, r = await this.isUnifiedEnabled();
    let a, o = "coin";
    r[1] ? (o = "currency", t !== void 0 && (n.startTime = t)) : t !== void 0 && (n.start_date = this.yyyymmdd(t)), e !== void 0 && (a = this.currency(e), n[o] = a.id), i !== void 0 && (n.limit = i);
    let c;
    r[1] ? c = await this.privateGetV5AccountTransactionLog(this.extend(n, s)) : c = await this.privateGetV2PrivateWalletFundRecords(this.extend(n, s));
    const u = this.addPaginationCursorToResult(c);
    return this.parseLedger(u, a, t, i);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeString2(e, "coin", "currency"), s = this.safeCurrencyCode(i, t), n = this.safeString2(e, "amount", "change"), r = this.safeString2(e, "wallet_balance", "cashBalance"), a = P.stringLt(n, "0") ? "out" : "in";
    let o;
    if (r !== void 0 && n !== void 0) {
      const l = a === "out" ? n : P.stringNeg(n);
      o = P.stringAdd(r, l);
    }
    let c = this.parse8601(this.safeString(e, "exec_time"));
    c === void 0 && (c = this.safeInteger(e, "transactionTime"));
    const u = this.parseLedgerEntryType(this.safeString(e, "type")), f = this.safeString(e, "id"), h = this.safeString(e, "tx_id");
    return {
      id: f,
      currency: s,
      account: this.safeString(e, "wallet_id"),
      referenceAccount: void 0,
      referenceId: h,
      status: void 0,
      amount: this.parseNumber(P.stringAbs(n)),
      before: this.parseNumber(o),
      after: this.parseNumber(r),
      fee: this.parseNumber(this.safeString(e, "fee")),
      direction: a,
      timestamp: c,
      datetime: this.iso8601(c),
      type: u,
      info: e
    };
  }
  parseLedgerEntryType(e) {
    const t = {
      Deposit: "transaction",
      Withdraw: "transaction",
      RealisedPNL: "trade",
      Commission: "fee",
      Refund: "cashback",
      Prize: "prize",
      ExchangeOrderWithdraw: "transaction",
      ExchangeOrderDeposit: "transaction",
      // v5
      TRANSFER_IN: "transaction",
      TRANSFER_OUT: "transaction",
      TRADE: "trade",
      SETTLEMENT: "trade",
      DELIVERY: "trade",
      LIQUIDATION: "trade",
      BONUS: "Prize",
      FEE_REFUND: "cashback",
      INTEREST: "transaction",
      CURRENCY_BUY: "trade",
      CURRENCY_SELL: "trade"
    };
    return this.safeString(t, e, e);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), await this.loadMarkets(), this.checkAddress(i);
    const r = this.currency(e), a = {
      coin: r.id,
      address: i,
      timestamp: this.nonce(),
      feeType: 1
      // bybit will deduce the fee from the amount
    };
    s !== void 0 && (a.tag = s);
    const [o, c] = this.handleNetworkCodeAndParams(n), u = this.networkCodeToId(o), f = this.currencyToPrecision(e, t, o);
    a.amount = this.numberToString(f), u !== void 0 && (a.chain = u.toUpperCase());
    const h = await this.privatePostV5AssetWithdrawCreate(this.extend(a, c)), l = this.safeValue(h, "result", {});
    return this.parseTransaction(l, r);
  }
  async fetchPosition(e, t = {}) {
    if (e === void 0)
      throw new g("fetchPosition() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    }, [n, r] = await this.isUnifiedEnabled(), a = n || r, o = i.settle === "USDC";
    let c, u;
    [u, t] = this.getBybitType("fetchPosition", i, t), (u === "option" || o) && !a ? (s.category = u === "option" ? "OPTION" : "PERPETUAL", c = await this.privatePostOptionUsdcOpenapiPrivateV1QueryPosition(this.extend(s, t))) : (s.category = u, c = await this.privateGetV5PositionList(this.extend(s, t)));
    const f = this.safeDict(c, "result", {}), h = this.safeList2(f, "list", "dataList", []), l = this.safeInteger(c, "time"), p = this.safeDict(h, 0, {}), m = this.parsePosition(p, i);
    return m.timestamp = l, m.datetime = this.iso8601(l), m;
  }
  async fetchUsdcPositions(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {};
    let s;
    if (Array.isArray(e)) {
      if (e.length !== 1)
        throw new g("fetchUsdcPositions() takes an array with exactly one symbol").exchange(this.id);
      const f = this.safeString(e, 0);
      s = this.market(f), i.symbol = s.id;
    } else
      e !== void 0 && (s = this.market(e), i.symbol = s.id);
    let n;
    [n, t] = this.getBybitType("fetchUsdcPositions", s, t), i.category = n === "option" ? "OPTION" : "PERPETUAL";
    const r = await this.privatePostOptionUsdcOpenapiPrivateV1QueryPosition(this.extend(i, t)), a = this.safeValue(r, "result", {}), o = this.safeValue(a, "dataList", []), c = [];
    for (let u = 0; u < o.length; u++) {
      let f = o[u];
      "data" in f && "is_valid" in f && (f = this.safeValue(f, "data")), c.push(this.parsePosition(f, s));
    }
    return this.filterByArrayPositions(c, "symbol", e, !1);
  }
  async fetchPositions(e = void 0, t = {}) {
    let i;
    if (e !== void 0 && Array.isArray(e)) {
      const p = e.length;
      if (p > 1)
        throw new g("fetchPositions() does not accept an array with more than one symbol").exchange(this.id);
      p === 1 && (i = e[0]), e = this.marketSymbols(e);
    } else
      e !== void 0 && (i = e, e = [this.symbol(i)]);
    await this.loadMarkets();
    const [s, n] = await this.isUnifiedEnabled(), r = s || n, a = {};
    let o, c = !1;
    i !== void 0 && (o = this.market(i), i = o.symbol, a.symbol = o.id, c = o.settle === "USDC");
    let u;
    if ([u, t] = this.getBybitType("fetchPositions", o, t), u === "linear" || u === "inverse") {
      const p = this.safeString(t, "baseCoin");
      if (u === "linear") {
        if (i === void 0 && p === void 0) {
          const m = this.safeString(this.options, "defaultSettle", "USDT"), y = this.safeString(t, "settleCoin", m);
          a.settleCoin = y, c = y === "USDC";
        }
      } else
        i === void 0 && p === void 0 && (a.category = "inverse");
    }
    if ((u === "option" || c) && !r)
      return await this.fetchUsdcPositions(e, t);
    t = this.omit(t, ["type"]), a.category = u;
    const f = await this.privateGetV5PositionList(this.extend(a, t)), h = this.addPaginationCursorToResult(f), l = [];
    for (let p = 0; p < h.length; p++) {
      let m = h[p];
      "data" in m && "is_valid" in m && (m = this.safeValue(m, "data")), l.push(this.parsePosition(m));
    }
    return this.filterByArrayPositions(l, "symbol", e, !1);
  }
  parsePosition(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t, void 0, "contract");
    const s = P.stringAbs(this.safeString(e, "size"));
    let n = this.safeString(e, "side");
    n !== void 0 && (n === "Buy" ? n = "long" : n === "Sell" ? n = "short" : n = void 0);
    const r = this.safeString(e, "positionValue"), a = this.omitZero(this.safeString(e, "unrealisedPnl"));
    let o = this.safeString(e, "positionIM"), c = this.safeString(e, "positionMM"), u = this.parse8601(this.safeString(e, "updated_at"));
    u === void 0 && (u = this.safeIntegerN(e, ["updatedTime", "updatedAt"]));
    let f = this.safeString(e, "positionBalance");
    const h = this.omitZero(this.safeString2(e, "entryPrice", "avgPrice")), l = this.omitZero(this.safeString(e, "liqPrice")), p = this.safeString(e, "leverage");
    if (l !== void 0)
      if (t.settle === "USDC") {
        const w = P.stringAbs(P.stringSub(h, l));
        f = P.stringAdd(P.stringAdd(P.stringMul(w, s), c), a);
      } else {
        const w = this.safeString(e, "bustPrice");
        if (t.linear) {
          const S = P.stringAbs(P.stringSub(l, w));
          c = P.stringMul(S, s), h !== void 0 && (o = P.stringDiv(P.stringMul(s, h), p));
        } else {
          const S = P.stringAbs(P.stringSub(w, l)), b = P.stringMul(w, l);
          c = P.stringDiv(P.stringMul(s, S), b), h !== void 0 && (o = P.stringDiv(s, P.stringMul(h, p)));
        }
      }
    const m = P.stringDiv(c, r), y = P.stringDiv(c, f, 4);
    return this.safePosition({
      info: e,
      id: void 0,
      symbol: t.symbol,
      timestamp: u,
      datetime: this.iso8601(u),
      lastUpdateTimestamp: void 0,
      initialMargin: this.parseNumber(o),
      initialMarginPercentage: this.parseNumber(P.stringDiv(o, r)),
      maintenanceMargin: this.parseNumber(c),
      maintenanceMarginPercentage: this.parseNumber(m),
      entryPrice: this.parseNumber(h),
      notional: this.parseNumber(r),
      leverage: this.parseNumber(p),
      unrealizedPnl: this.parseNumber(a),
      contracts: this.parseNumber(s),
      contractSize: this.safeNumber(t, "contractSize"),
      marginRatio: this.parseNumber(y),
      liquidationPrice: this.parseNumber(l),
      markPrice: this.safeNumber(e, "markPrice"),
      lastPrice: void 0,
      collateral: this.parseNumber(f),
      marginMode: void 0,
      side: n,
      percentage: void 0,
      stopLossPrice: this.safeNumber2(e, "stop_loss", "stopLoss"),
      takeProfitPrice: this.safeNumber2(e, "take_profit", "takeProfit")
    });
  }
  // https://bybit-exchange.github.io/docs/v5/asset/balance/all-balance
  async fetchSubAccountBalances(e, t = {}) {
    const i = {}, [s, n] = await this.isUnifiedEnabled();
    if (!(s || n))
      throw new Error(this.id + " getSubAccountBalances() is only supported for unified accounts");
    const o = ["UNIFIED", "FUND", "CONTRACT"].map((u) => this.fetchBalance({ type: u, memberId: e }).then((f) => {
      const h = Object.keys(f), l = {};
      for (let p = 0; p < h.length; p++) {
        const m = h[p];
        l[m] = f[m];
      }
      return { accountType: u, balances: l };
    }).catch((f) => ({ accountType: u, balances: null, error: f })));
    return (await Promise.allSettled(o)).forEach((u) => {
      if (u.status === "fulfilled" && u.value.balances) {
        const { accountType: f, balances: h } = u.value;
        f in i || (i[f] = {}), Object.assign(i[f], h);
      }
    }), i;
  }
  // https://bybit-exchange.github.io/docs/account-asset/sub-uid-list
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.privateGetAssetV3PrivateTransferSubMemberListQuery(), t = this.safeValue(e, "result", {}), i = this.safeValue(t, "subMemberIds", []);
    return i == null ? void 0 : i.map((s) => ({
      uid: s
    }));
  }
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    await this.loadMarkets();
    const o = this.safeString(a, "transferId", this.uuid()), c = this.safeValue(this.options, "accountsByType", {});
    let u = this.safeString(c, i, i), f = this.safeString(c, s, s);
    const [h, l] = await this.isUnifiedEnabled();
    (h || l) && (u === "SPOT" && (u = "UNIFIED"), f === "SPOT" && (f = "UNIFIED"));
    const m = this.currency(e), y = this.currencyToPrecision(e, t), w = {
      transferId: o,
      fromAccountType: u,
      toAccountType: f,
      coin: m.id,
      amount: y,
      fromMemberId: n,
      toMemberId: r
    }, S = await this.privatePostV5AssetTransferUniversalTransfer(this.extend(w, a)), b = this.safeInteger(S, "time"), T = this.safeValue(S, "result", {}), x = this.safeStringN(S, ["retCode", "retMsg"]), v = this.parseTransferStatus(x);
    return this.extend(this.parseTransfer(T, m), {
      timestamp: b,
      datetime: this.iso8601(b),
      amount: this.parseNumber(y),
      fromAccount: i,
      toAccount: s,
      fromUid: n,
      toUid: r,
      status: v
    });
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.safeString(n, "transferId", this.uuid()), a = this.safeValue(this.options, "accountsByType", {});
    let o = this.safeString(a, i, i), c = this.safeString(a, s, s);
    const [u, f] = await this.isUnifiedEnabled();
    (u || f) && (o === "SPOT" && (o = "UNIFIED"), c === "SPOT" && (c = "UNIFIED"));
    const l = this.currency(e), p = this.currencyToPrecision(e, t), m = {
      transferId: r,
      fromAccountType: o,
      toAccountType: c,
      coin: l.id,
      amount: p
    }, y = await this.privatePostV5AssetTransferInterTransfer(this.extend(m, n)), w = this.safeInteger(y, "time"), S = this.safeValue(y, "result", {}), b = this.safeStringN(y, ["retCode", "retMsg"]), T = this.parseTransferStatus(b);
    return this.extend(this.parseTransfer(S, l), {
      timestamp: w,
      datetime: this.iso8601(w),
      amount: this.parseNumber(p),
      fromAccount: i,
      toAccount: s,
      status: T
    });
  }
  async fetchTransfers(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchTransfers", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchTransfers", e, t, i, s, "nextPageCursor", "nextPageCursor", void 0, 50);
    let r, a = {};
    e !== void 0 && (r = this.safeCurrencyCode(e), a.coin = r), t !== void 0 && (a.startTime = t), i !== void 0 && (a.limit = i), [a, s] = this.handleUntilOption("endTime", a, s);
    const o = await this.privateGetV5AssetTransferQueryInterTransferList(this.extend(a, s)), c = this.addPaginationCursorToResult(o);
    return this.parseTransfers(c, r, t, i);
  }
  parseTransferStatus(e) {
    const t = {
      0: "ok",
      OK: "ok",
      SUCCESS: "ok"
    };
    return this.safeString(t, e, e);
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeString(e, "coin"), s = this.safeInteger(e, "timestamp"), n = this.safeString(e, "fromAccountType"), r = this.safeString(e, "toAccountType"), a = this.safeValue(this.options, "accountsById", {}), o = this.safeString(a, n, n), c = this.safeString(a, r, r);
    return {
      info: e,
      id: this.safeString(e, "transferId"),
      timestamp: s,
      datetime: this.iso8601(s),
      currency: this.safeCurrencyCode(i, t),
      amount: this.safeNumber(e, "amount"),
      fromAccount: o,
      toAccount: c,
      status: this.parseTransferStatus(this.safeString(e, "status"))
    };
  }
  parseTradingFee(e, t = void 0) {
    const i = this.safeString(e, "symbol"), s = this.safeSymbol(i, void 0, void 0, "contract");
    return {
      info: e,
      symbol: s,
      maker: this.safeNumber(e, "makerFeeRate"),
      taker: this.safeNumber(e, "takerFeeRate")
    };
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e);
    if (i.spot)
      throw new ge("spot").exchange(this.id);
    const s = {
      symbol: i.id
    }, n = await this.privateGetV5AccountFeeRate(this.extend(s, t)), r = this.safeValue(n, "result", {}), a = this.safeValue(r, "list", []), o = this.safeValue(a, 0, {});
    return this.parseTradingFee(o);
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    let t;
    if ([t, e] = this.handleOptionAndParams(e, "fetchTradingFees", "type", "future"), t === "spot")
      throw new pe("fetchTradingFees").addMessage("It is not supported for spot market").exchange(this.id);
    const i = await this.privateGetV5AccountFeeRate(e);
    let s = this.safeValue(i, "result", {});
    s = this.safeValue(s, "list", []);
    const n = {};
    for (let r = 0; r < s.length; r++) {
      const a = this.parseTradingFee(s[r]), o = a.symbol;
      n[o] = a;
    }
    return n;
  }
  parseDepositWithdrawFee(e, t = void 0) {
    const i = this.safeValue(e, "chains", []), s = i.length, n = {
      info: e,
      withdraw: {
        fee: void 0,
        percentage: void 0
      },
      deposit: {
        fee: void 0,
        percentage: void 0
      },
      networks: {}
    };
    if (s !== 0)
      for (let r = 0; r < s; r++) {
        const a = i[r], o = this.safeString(a, "chain"), c = this.safeString(t, "code"), u = this.networkIdToCode(o, c);
        n.networks[u] = {
          deposit: { fee: void 0, percentage: void 0 },
          withdraw: { fee: this.safeNumber(a, "withdrawFee"), percentage: !1 }
        }, s === 1 && (n.withdraw.fee = this.safeNumber(a, "withdrawFee"), n.withdraw.percentage = !1);
      }
    return n;
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    this.checkRequiredCredentials(), await this.loadMarkets();
    const i = await this.privateGetV5AssetCoinQueryInfo(t), s = this.safeValue(i, "result", {}), n = this.safeValue(s, "rows", []);
    return this.parseDepositWithdrawFees(n, e, "coin");
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    let a = this.implodeHostname(this.urls.api[t]) + "/" + e;
    if (t === "public")
      Object.keys(s).length && (a += "?" + this.rawencode(s));
    else if (t === "private") {
      this.checkRequiredCredentials();
      const o = a.indexOf("openapi") >= 0, c = a.indexOf("unified/v3") >= 0, u = a.indexOf("contract/v3") >= 0, f = a.indexOf("v5") >= 0, h = this.nonce().toString();
      if (o) {
        Object.keys(s).length ? r = this.json(s) : r = "{}";
        const l = h + this.apiKey + r;
        let p;
        this.externalSigner ? p = await this.externalSigner.sign({
          payload: this.encode(l),
          publicApiKey: this.apiKey,
          exchangeId: this.id,
          opts: {
            digest: "hex"
          }
        }) : p = this.hmac(this.encode(l), this.encode(this.secret), Re, "hex"), n = {
          "Content-Type": "application/json",
          "X-BAPI-API-KEY": this.apiKey,
          "X-BAPI-TIMESTAMP": h,
          "X-BAPI-SIGN": p
        };
      } else if (c || u || f) {
        n = {
          "Content-Type": "application/json",
          "X-BAPI-API-KEY": this.apiKey,
          "X-BAPI-TIMESTAMP": h,
          "X-BAPI-RECV-WINDOW": this.options.recvWindow.toString()
        }, (c || u) && (n["X-BAPI-SIGN-TYPE"] = "2");
        const l = this.extend({}, s), p = this.rawencode(l), m = h.toString() + this.apiKey + this.options.recvWindow.toString();
        let y;
        i === "POST" ? (r = this.json(l), y = m + r) : (y = m + p, a += "?" + this.rawencode(l));
        let w;
        this.secret && this.secret.indexOf("PRIVATE KEY") > -1 ? w = Zn(y, this.secret, Re) : this.externalSigner ? w = await this.externalSigner.sign({
          payload: this.encode(y),
          publicApiKey: this.apiKey,
          exchangeId: this.id
        }) : w = this.hmac(this.encode(y), this.encode(this.secret), Re), n["X-BAPI-SIGN"] = w;
      } else {
        const l = this.extend(s, {
          api_key: this.apiKey,
          recv_window: this.options.recvWindow,
          timestamp: h
        }), p = this.keysort(l), m = this.rawencode(p);
        let y;
        if (this.secret && this.secret.indexOf("PRIVATE KEY") > -1 ? y = Zn(m, this.secret, Re) : this.externalSigner ? y = await this.externalSigner.sign({
          payload: this.encode(m),
          publicApiKey: this.apiKey,
          exchangeId: this.id
        }) : y = this.hmac(this.encode(m), this.encode(this.secret), Re), i === "POST") {
          const w = a.indexOf("spot") >= 0, S = this.extend(l, {
            sign: y
          });
          w ? (r = this.urlencode(S), n = {
            "Content-Type": "application/x-www-form-urlencoded"
          }) : (r = this.json(S), n = {
            "Content-Type": "application/json"
          });
        } else
          a += "?" + this.rawencode(p), a += "&sign=" + y;
      }
    }
    if (i === "POST") {
      const o = this.safeString(this.options, "brokerId");
      o !== void 0 && (n.Referer = o);
    }
    return { url: a, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (!a)
      return;
    const u = this.safeString2(a, "ret_code", "retCode");
    if (u !== "0") {
      if (u === "30084")
        return;
      const f = this.safeString2(a, "ret_msg", "retMsg");
      let h;
      throw u === "10005" && i.indexOf("order") < 0 ? h = u + ': Private api uses /user/v3/private/query-api to check if you have a unified account. The API key of user id must own one of permissions: "Account Transfer", "Subaccount Transfer", "Withdrawal" ' : h = u + ": " + f, this.throwBroadlyMatchedException(this.exceptions.broad, r, h), this.throwExactlyMatchedException(this.exceptions.exact, u, h), new O().addMessage(h).exchange(this.id);
    }
  }
}
let $y = class extends gt {
};
class Zy extends $y {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "coinbase",
      name: "Coinbase",
      countries: ["US"],
      pro: !0,
      rateLimit: 400,
      version: "v2",
      userAgent: this.userAgents.chrome,
      headers: {
        "CB-VERSION": "2018-05-30"
      },
      has: {
        CORS: !0,
        spot: !0,
        margin: !1,
        swap: !1,
        future: !1,
        option: !1,
        cancelOrder: !0,
        cancelOrders: !0,
        createDepositAddress: !0,
        createLimitBuyOrder: !0,
        createLimitSellOrder: !0,
        createMarketBuyOrder: !0,
        createMarketBuyOrderWithCost: !0,
        createMarketOrderWithCost: !1,
        createMarketSellOrder: !0,
        createMarketSellOrderWithCost: !1,
        createOrder: !0,
        editOrder: !0,
        fetchAccounts: !0,
        fetchBalance: !0,
        fetchCanceledOrders: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDeposits: !0,
        fetchL2OrderBook: !1,
        fetchLedger: !0,
        fetchMarkets: !0,
        fetchMyBuys: !0,
        fetchMySells: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrders: !0,
        fetchPosition: !1,
        fetchPositions: !1,
        fetchPositionsRisk: !1,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !1,
        fetchTradingFees: !1,
        fetchWithdrawals: !0,
        withdraw: !0
      },
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/40811661-b6eceae2-653a-11e8-829e-10bfadb078cf.jpg",
        api: {
          rest: "https://api.coinbase.com"
        },
        www: "https://www.coinbase.com",
        doc: [
          "https://developers.coinbase.com/api/v2",
          "https://docs.cloud.coinbase.com/advanced-trade-api/docs/welcome"
        ],
        fees: [
          "https://support.coinbase.com/customer/portal/articles/2109597-buy-sell-bank-transfer-fees",
          "https://www.coinbase.com/advanced-fees"
        ],
        // https://www.coinbase.com/join/58cbe25a355148797479dbd2 - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
        referral: "https://www.coinbase.com"
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0
      },
      api: {
        v2: {
          public: {
            get: [
              "currencies",
              "currencies/crypto",
              "time",
              "exchange-rates",
              "users/{user_id}",
              "prices/{symbol}/buy",
              "prices/{symbol}/sell",
              "prices/{symbol}/spot"
            ]
          },
          private: {
            get: [
              "accounts",
              "accounts/{account_id}",
              "accounts/{account_id}/addresses",
              "accounts/{account_id}/addresses/{address_id}",
              "accounts/{account_id}/addresses/{address_id}/transactions",
              "accounts/{account_id}/transactions",
              "accounts/{account_id}/transactions/{transaction_id}",
              "accounts/{account_id}/buys",
              "accounts/{account_id}/buys/{buy_id}",
              "accounts/{account_id}/sells",
              "accounts/{account_id}/sells/{sell_id}",
              "accounts/{account_id}/deposits",
              "accounts/{account_id}/deposits/{deposit_id}",
              "accounts/{account_id}/withdrawals",
              "accounts/{account_id}/withdrawals/{withdrawal_id}",
              "payment-methods",
              "payment-methods/{payment_method_id}",
              "user",
              "user/auth"
            ],
            post: [
              "accounts",
              "accounts/{account_id}/primary",
              "accounts/{account_id}/addresses",
              "accounts/{account_id}/transactions",
              "accounts/{account_id}/transactions/{transaction_id}/complete",
              "accounts/{account_id}/transactions/{transaction_id}/resend",
              "accounts/{account_id}/buys",
              "accounts/{account_id}/buys/{buy_id}/commit",
              "accounts/{account_id}/sells",
              "accounts/{account_id}/sells/{sell_id}/commit",
              "accounts/{account_id}/deposits",
              "accounts/{account_id}/deposits/{deposit_id}/commit",
              "accounts/{account_id}/withdrawals",
              "accounts/{account_id}/withdrawals/{withdrawal_id}/commit"
            ],
            put: [
              "accounts/{account_id}",
              "user"
            ],
            delete: [
              "accounts/{id}",
              "accounts/{account_id}/transactions/{transaction_id}"
            ]
          }
        },
        v3: {
          public: {
            get: [
              "brokerage/time"
            ]
          },
          private: {
            get: [
              "brokerage/accounts",
              "brokerage/accounts/{account_uuid}",
              "brokerage/orders/historical/batch",
              "brokerage/orders/historical/fills",
              "brokerage/orders/historical/{order_id}",
              "brokerage/products",
              "brokerage/products/{product_id}",
              "brokerage/products/{product_id}/candles",
              "brokerage/products/{product_id}/ticker",
              "brokerage/portfolios",
              "brokerage/portfolios/{portfolio_uuid}",
              "brokerage/transaction_summary",
              "brokerage/product_book",
              "brokerage/best_bid_ask",
              "brokerage/convert/trade/{trade_id}",
              "brokerage/cfm/balance_summary",
              "brokerage/cfm/positions",
              "brokerage/cfm/positions/{product_id}",
              "brokerage/cfm/sweeps",
              "brokerage/intx/portfolio/{portfolio_uuid}",
              "brokerage/intx/positions/{portfolio_uuid}",
              "brokerage/intx/positions/{portfolio_uuid}/{symbol}"
            ],
            post: [
              "brokerage/orders",
              "brokerage/orders/batch_cancel",
              "brokerage/orders/edit",
              "brokerage/orders/edit_preview",
              "brokerage/orders/preview",
              "brokerage/portfolios",
              "brokerage/portfolios/move_funds",
              "brokerage/convert/quote",
              "brokerage/convert/trade/{trade_id}",
              "brokerage/cfm/sweeps/schedule",
              "brokerage/intx/allocate"
            ],
            put: [
              "brokerage/portfolios/{portfolio_uuid}"
            ],
            delete: [
              "brokerage/portfolios/{portfolio_uuid}",
              "brokerage/cfm/sweeps"
            ]
          }
        }
      },
      fees: {
        trading: {
          taker: this.parseNumber("0.006"),
          maker: this.parseNumber("0.004"),
          tierBased: !0,
          percentage: !0,
          tiers: {
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.006")],
              [this.parseNumber("10000"), this.parseNumber("0.004")],
              [this.parseNumber("50000"), this.parseNumber("0.0025")],
              [this.parseNumber("100000"), this.parseNumber("0.002")],
              [this.parseNumber("1000000"), this.parseNumber("0.0018")],
              [this.parseNumber("15000000"), this.parseNumber("0.0016")],
              [this.parseNumber("75000000"), this.parseNumber("0.0012")],
              [this.parseNumber("250000000"), this.parseNumber("0.0008")],
              [this.parseNumber("400000000"), this.parseNumber("0.0005")]
            ],
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.004")],
              [this.parseNumber("10000"), this.parseNumber("0.0025")],
              [this.parseNumber("50000"), this.parseNumber("0.0015")],
              [this.parseNumber("100000"), this.parseNumber("0.001")],
              [this.parseNumber("1000000"), this.parseNumber("0.0008")],
              [this.parseNumber("15000000"), this.parseNumber("0.0006")],
              [this.parseNumber("75000000"), this.parseNumber("0.0003")],
              [this.parseNumber("250000000"), this.parseNumber("0.0")],
              [this.parseNumber("400000000"), this.parseNumber("0.0")]
            ]
          }
        }
      },
      precisionMode: ct,
      exceptions: {
        exact: {
          two_factor_required: Z,
          param_required: g,
          validation_error: O,
          invalid_request: g,
          personal_details_required: Z,
          identity_verification_required: Z,
          jumio_verification_required: Z,
          jumio_face_match_verification_required: Z,
          unverified_email: Z,
          authentication_error: Z,
          invalid_authentication_method: Z,
          invalid_token: Z,
          revoked_token: Z,
          expired_token: Z,
          invalid_scope: Z,
          not_found: O,
          rate_limit_exceeded: Ae,
          internal_server_error: O,
          UNSUPPORTED_ORDER_CONFIGURATION: k,
          INSUFFICIENT_FUND: re
        },
        broad: {
          "request timestamp expired": ze,
          "order with this orderID was not found": Se
          // {"error":"unknown","error_details":"order with this orderID was not found","message":"order with this orderID was not found"}
        }
      },
      timeframes: {
        "1m": "ONE_MINUTE",
        "5m": "FIVE_MINUTE",
        "15m": "FIFTEEN_MINUTE",
        "30m": "THIRTY_MINUTE",
        "1h": "ONE_HOUR",
        "2h": "TWO_HOUR",
        "6h": "SIX_HOUR",
        "1d": "ONE_DAY"
      },
      options: {
        stablePairs: ["BUSD-USD", "CBETH-ETH", "DAI-USD", "GUSD-USD", "GYEN-USD", "PAX-USD", "PAX-USDT", "USDC-EUR", "USDC-GBP", "USDT-EUR", "USDT-GBP", "USDT-USD", "USDT-USDC", "WBTC-BTC"],
        fetchCurrencies: {
          expires: 5e3
        },
        accounts: [
          "wallet",
          "fiat"
          // 'vault',
        ],
        v3Accounts: [
          "ACCOUNT_TYPE_CRYPTO",
          "ACCOUNT_TYPE_FIAT"
        ],
        createMarketBuyOrderRequiresPrice: !0,
        advanced: !0,
        fetchMarkets: "fetchMarketsV3",
        fetchTicker: "fetchTickerV3",
        fetchTickers: "fetchTickersV3",
        fetchAccounts: "fetchAccountsV3",
        fetchBalance: "v2PrivateGetAccounts",
        user_native_currency: "USD"
        // needed to get fees for v3
      }
    });
  }
  async fetchStatus(e = {}) {
    const t = await this.v3PublicGetBrokerageTime(e), i = this.safeString(t, "iso"), s = this.parse8601(i);
    return {
      status: s !== void 0 ? "ok" : "maintenance",
      updated: s,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchTime(e = {}) {
    const t = await this.v2PublicGetTime(e), i = this.safeValue(t, "data", {});
    return this.safeTimestamp(i, "epoch");
  }
  async fetchAccounts(e = {}) {
    return this.safeString(this.options, "fetchAccounts", "fetchAccountsV3") === "fetchAccountsV3" ? await this.fetchAccountsV3(e) : await this.fetchAccountsV2(e);
  }
  async fetchAccountsV2(e = {}) {
    await this.loadMarkets();
    let t = !1;
    if ([t, e] = this.handleOptionAndParams(e, "fetchAccounts", "paginate"), t)
      return await this.fetchPaginatedCallCursor("fetchAccounts", void 0, void 0, void 0, e, "next_starting_after", "starting_after", void 0, 100);
    const i = {
      limit: 250
    }, s = await this.v2PrivateGetAccounts(this.extend(i, e)), n = this.safeList(s, "data", []), r = this.safeDict(s, "pagination", {}), a = this.safeString(r, "next_starting_after"), o = this.safeList(s, "data", []), u = o.length - 1, f = this.safeValue(o, u);
    return a !== void 0 && a !== "" && (f.next_starting_after = a, o[u] = f), this.parseAccounts(n, e);
  }
  async fetchAccountsV3(e = {}) {
    await this.loadMarkets();
    let t = !0, i = null, s = [];
    for (; t; ) {
      const n = {
        cursor: i,
        limit: 250
      }, r = await this.v3PrivateGetBrokerageAccounts(this.extend(n, e));
      t = this.safeValue(r, "has_next"), i = this.safeValue(r, "cursor");
      const a = this.safeValue(r, "accounts", []);
      s = s.concat(a);
    }
    return this.parseAccounts(s, e);
  }
  parseAccount(e) {
    const t = this.safeValue(e, "active"), i = this.safeString(e, "currency"), s = this.safeValue(e, "currency", {}), n = this.safeString(s, "code", i), r = this.safeString(e, "type"), a = this.safeString(e, "type");
    return {
      id: this.safeString2(e, "id", "uuid"),
      type: t !== void 0 ? r : a,
      code: this.safeCurrencyCode(n),
      info: e,
      active: t
    };
  }
  async createDepositAddress(e, t = {}) {
    let i = this.safeString(t, "account_id");
    if (t = this.omit(t, "account_id"), i === void 0) {
      await this.loadAccounts();
      for (let u = 0; u < this.accounts.length; u++) {
        const f = this.accounts[u];
        if (f.code === e && f.type === "ACCOUNT_TYPE_CRYPTO") {
          i = f.id;
          break;
        }
      }
    }
    if (i === void 0)
      throw new mr(e).addMessage("createDepositAddress() could not find the account with matching currency code, specify an `account_id` extra param").exchange(this.id);
    const s = {
      account_id: i
    }, n = await this.v2PrivatePostAccountsAccountIdAddresses(this.extend(s, t)), r = this.safeValue(n, "data", {}), a = this.safeString(r, "destination_tag"), o = this.safeString(r, "address"), c = this.safeString(r, "network");
    return {
      currency: e,
      tag: a,
      address: o,
      network: c,
      info: n
    };
  }
  async fetchMySells(e = void 0, t = void 0, i = void 0, s = {}) {
    const n = this.prepareAccountRequest(i, s);
    await this.loadMarkets();
    const r = this.omit(s, ["account_id", "accountId"]), a = await this.v2PrivateGetAccountsAccountIdSells(this.extend(n, r));
    return this.parseTrades(a.data, void 0, t, i);
  }
  async fetchMyBuys(e = void 0, t = void 0, i = void 0, s = {}) {
    const n = this.prepareAccountRequest(i, s);
    await this.loadMarkets();
    const r = this.omit(s, ["account_id", "accountId"]), a = await this.v2PrivateGetAccountsAccountIdBuys(this.extend(n, r));
    return this.parseTrades(a.data, void 0, t, i);
  }
  async fetchTransactionsWithMethod(e, t = void 0, i = void 0, s = void 0, n = {}) {
    const r = await this.prepareAccountRequestWithCurrencyCode(t, s, n);
    await this.loadMarkets();
    const a = this.omit(n, ["account_id", "accountId"]), o = await this[e](this.extend(r, a));
    return this.parseTransactions(o.data, void 0, i, s);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchTransactionsWithMethod("v2PrivateGetAccountsAccountIdWithdrawals", e, t, i, s);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchTransactionsWithMethod("v2PrivateGetAccountsAccountIdDeposits", e, t, i, s);
  }
  parseTransactionStatus(e) {
    const t = {
      created: "pending",
      completed: "ok",
      canceled: "canceled"
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString(e, "type");
    let s, n;
    if (i === "send") {
      const l = this.safeValue(e, "network", {});
      s = this.safeValue(l, "transaction_amount", {}), n = this.safeValue(l, "transaction_fee", {});
    } else
      s = this.safeValue(e, "subtotal", {}), n = this.safeValue(e, "fee", {});
    let r = this.parseTransactionStatus(this.safeString(e, "status"));
    r === void 0 && (r = this.safeValue(e, "committed") ? "ok" : "pending");
    const a = this.safeString(e, "id"), o = this.safeString(s, "currency"), c = this.safeString(n, "currency"), u = this.safeValue(e, "created_at"), f = this.safeValue(e, "to", {}), h = this.safeString(f, "address");
    return {
      info: e,
      id: a,
      txid: a,
      timestamp: this.parse8601(u),
      datetime: u,
      network: void 0,
      address: h,
      addressTo: h,
      addressFrom: void 0,
      tag: void 0,
      tagTo: void 0,
      tagFrom: void 0,
      type: this.safeString(e, "resource"),
      amount: this.safeNumber(s, "amount"),
      currency: this.safeCurrencyCode(o, t),
      status: r,
      updated: this.parse8601(this.safeValue(e, "updated_at")),
      fee: {
        cost: this.safeNumber(n, "amount"),
        currency: this.safeCurrencyCode(c)
      }
    };
  }
  parseTrade(e, t = void 0) {
    let i;
    const s = this.safeValue(e, "total", {}), n = this.safeValue(e, "amount", {}), r = this.safeValue(e, "subtotal", {}), a = this.safeValue(e, "fee", {}), o = this.safeString(e, "product_id");
    if (t = this.safeMarket(o, t, "-"), t !== void 0)
      i = t.symbol;
    else {
      const V = this.safeString(n, "currency"), j = this.safeString(s, "currency");
      if (V !== void 0 && j !== void 0) {
        const G = this.safeCurrencyCode(V), W = this.safeCurrencyCode(j);
        i = G + "/" + W;
      }
    }
    const c = this.safeValue(e, "size_in_quote"), u = this.safeString(e, "price");
    let f, h = this.safeString(e, "size");
    c && (f = h, h = P.stringDiv(h, u));
    const l = this.safeString(e, "commission"), p = this.safeString(n, "amount", h), m = this.safeString(r, "amount", f);
    let y, w, S;
    m !== void 0 && p !== void 0 ? y = P.stringDiv(m, p) : y = u, y !== void 0 && p !== void 0 ? w = P.stringMul(y, p) : w = m, m !== void 0 && p === void 0 && y !== void 0 ? S = P.stringDiv(m, y) : S = p;
    let b = this.safeString(a, "currency");
    const T = this.safeNumber(a, "amount", this.parseNumber(l));
    b === void 0 && t !== void 0 && T !== void 0 && (b = t.quote);
    const x = this.safeStringN(e, ["created_at", "trade_time", "time"]), v = this.safeStringLower2(e, "resource", "side"), _ = this.safeStringLower(e, "liquidity_indicator");
    return this.safeTrade({
      info: e,
      id: this.safeString2(e, "id", "trade_id"),
      order: this.safeString(e, "order_id"),
      timestamp: this.parse8601(x),
      datetime: x,
      symbol: i,
      type: void 0,
      side: v === "unknown_order_side" ? void 0 : v,
      takerOrMaker: _ === "unknown_liquidity_indicator" ? void 0 : _,
      price: y,
      amount: S,
      cost: w,
      fee: {
        cost: T,
        currency: this.safeCurrencyCode(b)
      }
    });
  }
  async fetchMarkets(e = {}) {
    const t = this.safeString(this.options, "fetchMarkets", "fetchMarketsV3");
    return await this[t](e);
  }
  async fetchMarketsV2(e = {}) {
    const t = await this.fetchCurrenciesFromCache(e), i = this.safeValue(t, "currencies", {}), s = this.safeValue(t, "exchangeRates", {}), n = this.safeValue(i, "data", []), r = this.indexBy(n, "id"), a = this.safeValue(this.safeValue(s, "data", {}), "rates", {}), o = Object.keys(a), c = [];
    for (let u = 0; u < o.length; u++) {
      const f = o[u], h = this.safeCurrencyCode(f);
      if ((f in r ? "fiat" : "crypto") === "crypto")
        for (let p = 0; p < n.length; p++) {
          const m = n[p], y = this.safeString(m, "id"), w = this.safeCurrencyCode(y);
          c.push({
            id: f + "-" + y,
            symbol: h + "/" + w,
            base: h,
            quote: w,
            settle: void 0,
            baseId: f,
            quoteId: y,
            settleId: void 0,
            type: "spot",
            spot: !0,
            margin: !1,
            swap: !1,
            future: !1,
            option: !1,
            active: void 0,
            contract: !1,
            linear: void 0,
            inverse: void 0,
            contractSize: void 0,
            expiry: void 0,
            expiryDatetime: void 0,
            strike: void 0,
            optionType: void 0,
            precision: {
              amount: void 0,
              price: void 0
            },
            limits: {
              leverage: {
                min: void 0,
                max: void 0
              },
              amount: {
                min: void 0,
                max: void 0
              },
              price: {
                min: void 0,
                max: void 0
              },
              cost: {
                min: this.safeNumber(m, "min_size"),
                max: void 0
              }
            },
            info: m
          });
        }
    }
    return c;
  }
  async fetchMarketsV3(e = {}) {
    const t = await this.v3PrivateGetBrokerageProducts(e), i = await this.v3PrivateGetBrokerageTransactionSummary(e), s = this.safeValue(i, "fee_tier", {}), n = this.safeValue(t, "products", []), r = [];
    for (let a = 0; a < n.length; a++) {
      const o = n[a], c = this.safeString(o, "product_id"), u = this.safeString(o, "base_currency_id"), f = this.safeString(o, "quote_currency_id"), h = this.safeCurrencyCode(u), l = this.safeCurrencyCode(f), p = this.safeStringLower(o, "product_type"), m = this.safeValue(o, "trading_disabled"), y = this.safeValue(this.options, "stablePairs", []);
      r.push({
        id: c,
        symbol: h + "/" + l,
        base: h,
        quote: l,
        settle: void 0,
        baseId: u,
        quoteId: f,
        settleId: void 0,
        type: p,
        spot: p === "spot",
        margin: void 0,
        swap: !1,
        future: !1,
        option: !1,
        active: !m,
        contract: !1,
        linear: void 0,
        inverse: void 0,
        taker: this.inArray(c, y) ? 1e-5 : this.safeNumber(s, "taker_fee_rate"),
        maker: this.inArray(c, y) ? 0 : this.safeNumber(s, "maker_fee_rate"),
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.safeNumber(o, "base_increment"),
          price: this.safeNumber2(o, "price_increment", "quote_increment")
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: this.safeNumber(o, "base_min_size"),
            max: this.safeNumber(o, "base_max_size")
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.safeNumber(o, "quote_min_size"),
            max: this.safeNumber(o, "quote_max_size")
          }
        },
        created: void 0,
        info: o
      });
    }
    return r;
  }
  async fetchCurrenciesFromCache(e = {}) {
    const t = this.safeValue(this.options, "fetchCurrencies", {}), i = this.safeInteger(t, "timestamp"), s = this.safeInteger(t, "expires", 1e3), n = this.milliseconds();
    if (i === void 0 || n - i > s) {
      const r = this.v2PublicGetCurrenciesCrypto(e), a = this.v2PublicGetCurrencies(e), o = this.v2PublicGetExchangeRates(e), [c, u, f] = await Promise.all([r, a, o]);
      this.options.fetchCurrencies = this.extend(t, {
        currencies: c,
        exchangeRates: f,
        fiatCurrencies: u,
        timestamp: n
      });
    }
    return this.safeValue(this.options, "fetchCurrencies", {});
  }
  async fetchCurrencies(e = {}) {
    const t = await this.fetchCurrenciesFromCache(e), i = this.safeValue(t, "currencies", {}), s = this.safeValue(t, "fiatCurrencies", {}), n = this.safeValue(t, "exchangeRates", {}), r = this.safeValue(s, "data", []), a = this.safeValue(i, "data", []), o = this.indexBy(a, "code"), c = this.indexBy(r, "id"), u = this.safeValue(this.safeValue(n, "data", {}), "rates", {}), f = Object.keys(u), h = {};
    for (let l = 0; l < f.length; l++) {
      const p = f[l], m = p in c ? "fiat" : "crypto", y = this.safeValue(o, p, {}), w = this.safeString(y, "code", p), S = this.safeString(y, "name"), b = this.safeCurrencyCode(w), T = this.safeString(y, "exponent", "2"), x = Math.pow(10, -T).toString();
      h[b] = {
        id: w,
        code: b,
        info: y,
        type: m,
        name: S,
        active: !0,
        deposit: void 0,
        withdraw: void 0,
        fee: void 0,
        precision: x,
        limits: {
          amount: {
            min: this.safeNumber(y, "min_size"),
            max: void 0
          },
          withdraw: {
            min: void 0,
            max: void 0
          }
        }
      };
    }
    return h;
  }
  async fetchTickers(e = void 0, t = {}) {
    return this.safeString(this.options, "fetchTickers", "fetchTickersV3") === "fetchTickersV3" ? await this.fetchTickersV3(e, t) : await this.fetchTickersV2(e, t);
  }
  async fetchTickersV2(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = {
      // 'currency': 'USD',
    }, s = await this.v2PublicGetExchangeRates(this.extend(i, t)), n = this.safeValue(s, "data", {}), r = this.safeValue(n, "rates", {}), a = this.safeString(n, "currency"), o = {}, c = Object.keys(r), u = "-";
    for (let f = 0; f < c.length; f++) {
      const h = c[f], l = h + u + a, p = this.safeMarket(l, void 0, u), m = p.symbol;
      o[m] = this.parseTicker(r[h], p);
    }
    return this.filterByArrayTickers(o, "symbol", e);
  }
  async fetchTickersV3(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = {};
    e !== void 0 && (i.product_ids = this.marketIds(e));
    const s = await this.v3PrivateGetBrokerageProducts(this.extend(i, t)), n = this.safeValue(s, "products", []), r = {};
    for (let a = 0; a < n.length; a++) {
      const o = n[a], c = this.safeString(o, "product_id"), u = this.safeMarket(c, void 0, "-"), f = u.symbol;
      r[f] = this.parseTicker(o, u);
    }
    return this.filterByArrayTickers(r, "symbol", e);
  }
  async fetchTicker(e, t = {}) {
    return this.safeString(this.options, "fetchTicker", "fetchTickerV3") === "fetchTickerV3" ? await this.fetchTickerV3(e, t) : await this.fetchTickerV2(e, t);
  }
  async fetchTickerV2(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = this.extend({
      symbol: i.id
    }, t), n = await this.v2PublicGetPricesSymbolSpot(s), r = await this.v2PublicGetPricesSymbolBuy(s), a = await this.v2PublicGetPricesSymbolSell(s), o = this.safeValue(n, "data", {}), c = this.safeValue(r, "data", {}), u = this.safeValue(a, "data", {}), f = {
      bid: this.safeNumber(u, "amount"),
      ask: this.safeNumber(c, "amount"),
      price: this.safeNumber(o, "amount")
    };
    return this.parseTicker(f, i);
  }
  async fetchTickerV3(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      product_id: i.id,
      limit: 1
    }, n = await this.v3PrivateGetBrokerageProductsProductIdTicker(this.extend(s, t)), r = this.safeValue(n, "trades", []), a = this.parseTicker(r[0], i);
    return a.bid = this.safeNumber(n, "best_bid"), a.ask = this.safeNumber(n, "best_ask"), a;
  }
  parseTicker(e, t = void 0) {
    let i = this.safeNumber(e, "bid"), s = this.safeNumber(e, "ask"), n, r;
    if ("bids" in e) {
      const u = this.safeValue(e, "bids", []), f = this.safeValue(e, "asks", []);
      i = this.safeNumber(u[0], "price"), n = this.safeNumber(u[0], "size"), s = this.safeNumber(f[0], "price"), r = this.safeNumber(f[0], "size");
    }
    const a = this.safeString(e, "product_id"), o = this.safeNumber(e, "price"), c = this.safeString(e, "time");
    return this.safeTicker({
      symbol: this.safeSymbol(a, t),
      timestamp: this.parse8601(c),
      datetime: c,
      bid: i,
      ask: s,
      last: o,
      high: void 0,
      low: void 0,
      bidVolume: n,
      askVolume: r,
      vwap: void 0,
      open: void 0,
      close: o,
      previousClose: void 0,
      change: void 0,
      percentage: this.safeNumber(e, "price_percentage_change_24h"),
      average: void 0,
      baseVolume: void 0,
      quoteVolume: void 0,
      info: e
    }, t);
  }
  parseCustomBalance(e, t = {}) {
    const i = e, s = this.safeValue(t, "type", this.options.accounts), n = this.safeValue(t, "type", this.options.v3Accounts), r = { info: e };
    for (let a = 0; a < i.length; a++) {
      const o = i[a], c = this.safeString(o, "type");
      if (this.inArray(c, s)) {
        const u = this.safeValue(o, "balance");
        if (u !== void 0) {
          const f = this.safeString(u, "currency"), h = this.safeCurrencyCode(f), l = this.safeString(u, "amount"), p = l;
          let m = this.safeValue(r, h);
          m === void 0 ? (m = this.account(), m.free = p, m.total = l) : (m.free = P.stringAdd(m.free, l), m.total = P.stringAdd(m.total, l)), r[h] = m;
        }
      } else if (this.inArray(c, n)) {
        const u = this.safeValue(o, "available_balance"), f = this.safeValue(o, "hold");
        if (u !== void 0 && f !== void 0) {
          const h = this.safeString(u, "currency"), l = this.safeCurrencyCode(h), p = this.safeString(f, "value"), m = this.safeString(u, "value"), y = P.stringAdd(p, m);
          let w = this.safeValue(r, l);
          w === void 0 ? (w = this.account(), w.free = m, w.used = p, w.total = y) : (w.free = P.stringAdd(w.free, m), w.used = P.stringAdd(w.used, p), w.total = P.stringAdd(w.total, y)), r[l] = w;
        }
      }
    }
    return this.safeBalance(r);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    let t = !0, i = null, s = [];
    for (; t; ) {
      const n = {
        limit: 250
      };
      i && (n.starting_after = i);
      const r = await this.v2PrivateGetAccounts(this.extend(n, e));
      t = this.safeValue(r.pagination, "next_uri"), i = this.safeValue(r.pagination, "next_starting_after");
      const a = this.safeValue(r, "data", []);
      s = s.concat(a);
    }
    return this.parseCustomBalance(s, e);
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    e !== void 0 && (n = this.currency(e));
    const r = await this.prepareAccountRequestWithCurrencyCode(e, i, s), a = this.omit(s, ["account_id", "accountId"]), o = await this.v2PrivateGetAccountsAccountIdTransactions(this.extend(r, a));
    return this.parseLedger(o.data, n, t, i);
  }
  parseLedgerEntryStatus(e) {
    const t = {
      completed: "ok"
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntryType(e) {
    const t = {
      buy: "trade",
      sell: "trade",
      fiat_deposit: "transaction",
      fiat_withdrawal: "transaction",
      exchange_deposit: "transaction",
      exchange_withdrawal: "transaction",
      send: "transaction",
      pro_deposit: "transaction",
      pro_withdrawal: "transaction"
      // crypto deposit (to coinbase from coinbasepro)
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeValue(e, "amount", {});
    let s = this.safeString(i, "amount"), n;
    P.stringLt(s, "0") ? (n = "out", s = P.stringNeg(s)) : n = "in";
    const r = this.safeString(i, "currency"), a = this.safeCurrencyCode(r, t);
    let o;
    const c = this.safeValue(e, "network", {}), u = c.hash, f = this.safeString(c, "network_name"), h = this.safeValue(c, "transaction_fee");
    if (h !== void 0) {
      const b = this.safeString(h, "currency"), T = this.safeCurrencyCode(b, t);
      o = {
        cost: this.safeNumber(h, "amount"),
        currency: T
      };
    }
    const l = this.parse8601(this.safeValue(e, "created_at")), p = this.safeString(e, "id"), m = this.parseLedgerEntryType(this.safeString(e, "type")), y = this.parseLedgerEntryStatus(this.safeString(e, "status")), w = this.safeString(e, "resource_path");
    let S;
    if (w !== void 0) {
      const b = w.split("/");
      b.length > 3 && (S = b[3]);
    }
    return {
      info: e,
      id: p,
      txid: u,
      network: f,
      timestamp: l,
      datetime: this.iso8601(l),
      direction: n,
      account: S,
      referenceId: void 0,
      referenceAccount: void 0,
      type: m,
      currency: a,
      amount: this.parseNumber(s),
      before: void 0,
      after: void 0,
      status: y,
      fee: o
    };
  }
  async findAccountId(e) {
    await this.loadMarkets(), await this.loadAccounts();
    for (let t = 0; t < this.accounts.length; t++) {
      const i = this.accounts[t];
      if (i.code === e)
        return i.id;
    }
  }
  prepareAccountRequest(e = void 0, t = {}) {
    const i = this.safeString2(t, "account_id", "accountId");
    if (i === void 0)
      throw new g("prepareAccountRequest() method requires an account_id (or accountId) parameter").exchange(this.id);
    const s = {
      account_id: i
    };
    return e !== void 0 && (s.limit = e), s;
  }
  async prepareAccountRequestWithCurrencyCode(e = void 0, t = void 0, i = {}) {
    let s = this.safeString2(i, "account_id", "accountId");
    if (s === void 0) {
      if (e === void 0)
        throw new g("prepareAccountRequestWithCurrencyCode() method requires an account_id (or accountId) parameter OR a currency code argument").exchange(this.id);
      if (s = await this.findAccountId(e), s === void 0)
        throw new O().addMessage("prepareAccountRequestWithCurrencyCode() could not find account id for " + e).exchange(this.id);
    }
    const n = {
      account_id: s
    };
    return t !== void 0 && (n.limit = t), n;
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("createMarketBuyOrderWithCost() supports spot orders only").exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e);
    let o = {
      client_order_id: this.uuid(),
      product_id: a.id,
      side: i.toUpperCase()
    };
    const c = this.safeNumberN(r, ["stopPrice", "stop_price", "triggerPrice"]), u = this.safeNumber(r, "stopLossPrice"), f = this.safeNumber(r, "takeProfitPrice"), h = c !== void 0, l = u !== void 0, p = f !== void 0, m = this.safeString(r, "timeInForce"), y = m === "PO" ? !0 : this.safeValue2(r, "postOnly", "post_only", !1), w = this.safeString(r, "end_time");
    let S = this.safeString(r, "stop_direction");
    if (t === "limit")
      if (h)
        if (S === void 0 && (S = i === "buy" ? "STOP_DIRECTION_STOP_DOWN" : "STOP_DIRECTION_STOP_UP"), m === "GTD" || w !== void 0) {
          if (w === void 0)
            throw new g("createOrder() requires an end_time parameter for a GTD order").exchange(this.id);
          o.order_configuration = {
            stop_limit_stop_limit_gtd: {
              base_size: this.amountToPrecision(e, s),
              limit_price: this.priceToPrecision(e, n),
              stop_price: this.priceToPrecision(e, c),
              stop_direction: S,
              end_time: w
            }
          };
        } else
          o.order_configuration = {
            stop_limit_stop_limit_gtc: {
              base_size: this.amountToPrecision(e, s),
              limit_price: this.priceToPrecision(e, n),
              stop_price: this.priceToPrecision(e, c),
              stop_direction: S
            }
          };
      else if (l || p) {
        let _;
        l ? (S === void 0 && (S = i === "buy" ? "STOP_DIRECTION_STOP_UP" : "STOP_DIRECTION_STOP_DOWN"), _ = this.priceToPrecision(e, u)) : (S === void 0 && (S = i === "buy" ? "STOP_DIRECTION_STOP_DOWN" : "STOP_DIRECTION_STOP_UP"), _ = this.priceToPrecision(e, f)), o.order_configuration = {
          stop_limit_stop_limit_gtc: {
            base_size: this.amountToPrecision(e, s),
            limit_price: this.priceToPrecision(e, n),
            stop_price: _,
            stop_direction: S
          }
        };
      } else if (m === "GTD" || w !== void 0) {
        if (w === void 0)
          throw new g("createOrder() requires an end_time parameter for a GTD order").exchange(this.id);
        o.order_configuration = {
          limit_limit_gtd: {
            base_size: this.amountToPrecision(e, s),
            limit_price: this.priceToPrecision(e, n),
            end_time: w,
            post_only: y
          }
        };
      } else
        o.order_configuration = {
          limit_limit_gtc: {
            base_size: this.amountToPrecision(e, s),
            limit_price: this.priceToPrecision(e, n),
            post_only: y
          }
        };
    else {
      if (h || l || p)
        throw new k().addMessage("createOrder() only stop limit orders are supported").exchange(this.id);
      if (i === "buy") {
        let _, V = !0;
        [V, r] = this.handleOptionAndParams(r, "createOrder", "createMarketBuyOrderRequiresPrice", !0);
        const j = this.safeNumber(r, "cost");
        if (r = this.omit(r, "cost"), j !== void 0)
          _ = this.costToPrecision(e, j);
        else if (V) {
          if (n === void 0)
            throw new g("createOrder() requires a price argument for market buy orders on spot markets to calculate the total amount to spend (amount * price), alternatively set the createMarketBuyOrderRequiresPrice option or param to false and pass the cost to spend in the amount argument").exchange(this.id);
          {
            const G = this.numberToString(s), W = this.numberToString(n), B = P.stringMul(G, W);
            _ = this.costToPrecision(e, B);
          }
        } else
          _ = this.costToPrecision(e, s);
        o.order_configuration = {
          market_market_ioc: {
            quote_size: _
          }
        };
      } else
        o.order_configuration = {
          market_market_ioc: {
            base_size: this.amountToPrecision(e, s)
          }
        };
    }
    r = this.omit(r, ["timeInForce", "triggerPrice", "stopLossPrice", "takeProfitPrice", "stopPrice", "stop_price", "stopDirection", "stop_direction", "clientOrderId", "postOnly", "post_only", "end_time"]);
    const b = this.safeValue2(r, "preview", "test", !1);
    let T;
    if (b ? (r = this.omit(r, ["preview", "test"]), o = this.omit(o, "client_order_id"), T = await this.v3PrivatePostBrokerageOrdersPreview(this.extend(o, r))) : T = await this.v3PrivatePostBrokerageOrders(this.extend(o, r)), this.safeValue(T, "success") !== !0) {
      const _ = this.safeValue(T, "error_response"), V = this.safeString(_, "error"), j = this.safeString(_, "message");
      if (_ !== void 0)
        throw this.throwExactlyMatchedException(this.exceptions.exact, V, j), this.throwBroadlyMatchedException(this.exceptions.broad, V, j), new k().addMessage(j).exchange(this.id);
    }
    const v = this.safeValue(T, "success_response", {});
    return this.parseOrder(v, a);
  }
  parseOrder(e, t = void 0) {
    const i = this.safeString(e, "product_id"), s = this.safeSymbol(i, t, "-");
    s !== void 0 && (t = this.market(s));
    const n = this.safeValue(e, "order_configuration", {}), r = this.safeValue(n, "limit_limit_gtc"), a = this.safeValue(n, "limit_limit_gtd"), o = this.safeValue(n, "stop_limit_stop_limit_gtc"), c = this.safeValue(n, "stop_limit_stop_limit_gtd"), u = this.safeValue(n, "market_market_ioc"), f = r !== void 0 || a !== void 0, h = o !== void 0 || c !== void 0;
    let l, p, m, y;
    if (f) {
      const T = r !== void 0 ? r : a;
      l = this.safeString(T, "limit_price"), p = this.safeString(T, "base_size"), m = this.safeValue(T, "post_only");
    } else if (h) {
      const T = o !== void 0 ? o : c;
      l = this.safeString(T, "limit_price"), p = this.safeString(T, "base_size"), m = this.safeValue(T, "post_only"), y = this.safeString(T, "stop_price");
    } else
      p = this.safeString(u, "base_size");
    const w = this.safeString(e, "created_time"), S = this.safeString(e, "total_fees");
    let b;
    return S !== void 0 && t !== void 0 && (b = t.quote), this.safeOrder({
      info: e,
      id: this.safeString(e, "order_id"),
      clientOrderId: this.safeString(e, "client_order_id"),
      timestamp: this.parse8601(w),
      datetime: w,
      lastTradeTimestamp: void 0,
      symbol: s,
      type: this.parseOrderType(this.safeString(e, "order_type")),
      timeInForce: this.parseTimeInForce(this.safeString(e, "time_in_force")),
      postOnly: m,
      side: this.safeStringLower(e, "side"),
      price: l,
      stopPrice: y,
      triggerPrice: y,
      amount: p,
      filled: this.safeString(e, "filled_size"),
      remaining: void 0,
      cost: void 0,
      average: this.safeString(e, "average_filled_price"),
      status: this.parseOrderStatus(this.safeString(e, "status")),
      fee: {
        cost: this.safeString(e, "total_fees"),
        currency: b
      },
      trades: void 0
    }, t);
  }
  parseOrderStatus(e) {
    const t = {
      OPEN: "open",
      FILLED: "closed",
      CANCELLED: "canceled",
      EXPIRED: "canceled",
      FAILED: "canceled",
      UNKNOWN_ORDER_STATUS: void 0
    };
    return this.safeString(t, e, e);
  }
  parseOrderType(e) {
    if (e === "UNKNOWN_ORDER_TYPE")
      return;
    const t = {
      MARKET: "market",
      LIMIT: "limit",
      STOP: "limit",
      STOP_LIMIT: "limit"
    };
    return this.safeString(t, e, e);
  }
  parseTimeInForce(e) {
    const t = {
      GOOD_UNTIL_CANCELLED: "GTC",
      GOOD_UNTIL_DATE_TIME: "GTD",
      IMMEDIATE_OR_CANCEL: "IOC",
      FILL_OR_KILL: "FOK",
      UNKNOWN_TIME_IN_FORCE: void 0
    };
    return this.safeString(t, e, e);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = await this.cancelOrders([e], t, i);
    return this.safeValue(s, 0, {});
  }
  async cancelOrders(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    t !== void 0 && (s = this.market(t));
    const n = {
      order_ids: e
    }, r = await this.v3PrivatePostBrokerageOrdersBatchCancel(this.extend(n, i)), a = this.safeValue(r, "results", []);
    for (let o = 0; o < a.length; o++)
      if (this.safeValue(a[o], "success") !== !0)
        throw new k().addMessage("cancelOrders() has failed, check your arguments and parameters").exchange(this.id);
    return this.parseOrders(a, s);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t), c = {
      order_id: e
    };
    n !== void 0 && (c.size = this.amountToPrecision(t, n)), r !== void 0 && (c.price = this.priceToPrecision(t, r));
    const u = this.safeValue2(a, "preview", "test", !1);
    let f;
    return u ? (a = this.omit(a, ["preview", "test"]), f = await this.v3PrivatePostBrokerageOrdersEditPreview(this.extend(c, a))) : f = await this.v3PrivatePostBrokerageOrdersEdit(this.extend(c, a)), this.parseOrder(f, o);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    t !== void 0 && (s = this.market(t));
    const n = {
      order_id: e
    }, r = await this.v3PrivateGetBrokerageOrdersHistoricalOrderId(this.extend(n, i)), a = this.safeValue(r, "order", {});
    return this.parseOrder(a, s);
  }
  async fetchOrders(e = void 0, t = void 0, i = 100, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchOrders", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchOrders", e, t, i, s, "cursor", "cursor", void 0, 100);
    let r;
    e !== void 0 && (r = this.market(e));
    const a = {};
    r !== void 0 && (a.product_id = r.id), i !== void 0 && (a.limit = i), t !== void 0 && (a.start_date = this.iso8601(t));
    const o = this.safeValueN(s, ["until", "till"]);
    o !== void 0 && (s = this.omit(s, ["until", "till"]), a.end_date = this.iso8601(o));
    const c = await this.v3PrivateGetBrokerageOrdersHistoricalBatch(this.extend(a, s)), u = this.safeValue(c, "orders", []), f = this.safeValue(u, 0), h = this.safeString(c, "cursor");
    return h !== void 0 && h !== "" && (f.cursor = h, u[0] = f), this.parseOrders(u, r, t, i);
  }
  async fetchOrdersByStatus(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r;
    t !== void 0 && (r = this.market(t));
    const a = {
      order_status: e
    };
    r !== void 0 && (a.product_id = r.id), s === void 0 && (s = 100), a.limit = s, i !== void 0 && (a.start_date = this.iso8601(i));
    const o = this.safeValueN(n, ["until", "till"]);
    o !== void 0 && (n = this.omit(n, ["until", "till"]), a.end_date = this.iso8601(o));
    const c = await this.v3PrivateGetBrokerageOrdersHistoricalBatch(this.extend(a, n)), u = this.safeValue(c, "orders", []), f = this.safeValue(u, 0), h = this.safeString(c, "cursor");
    return h !== void 0 && h !== "" && (f.cursor = h, u[0] = f), this.parseOrders(u, r, i, s);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    return [n, s] = this.handleOptionAndParams(s, "fetchOpenOrders", "paginate"), n ? await this.fetchPaginatedCallCursor("fetchOpenOrders", e, t, i, s, "cursor", "cursor", void 0, 100) : await this.fetchOrdersByStatus("OPEN", e, t, i, s);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    return [n, s] = this.handleOptionAndParams(s, "fetchClosedOrders", "paginate"), n ? await this.fetchPaginatedCallCursor("fetchClosedOrders", e, t, i, s, "cursor", "cursor", void 0, 100) : await this.fetchOrdersByStatus("FILLED", e, t, i, s);
  }
  async fetchCanceledOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchOrdersByStatus("CANCELLED", e, t, i, s);
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate", !1), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 299);
    const a = this.market(e), o = {
      product_id: a.id,
      granularity: this.safeString(this.timeframes, t, t)
    }, c = this.safeValueN(n, ["until", "till", "end"]);
    n = this.omit(n, ["until", "till"]);
    const f = 300 * this.parseTimeframe(t);
    let h;
    if (i !== void 0)
      h = this.numberToString(this.parseToInt(i / 1e3));
    else {
      const y = this.seconds().toString();
      h = P.stringSub(y, f.toString());
    }
    o.start = h;
    let l = this.numberToString(c);
    c === void 0 && (l = P.stringAdd(h, f.toString())), o.end = l;
    const p = await this.v3PrivateGetBrokerageProductsProductIdCandles(this.extend(o, n)), m = this.safeValue(p, "candles", []);
    return this.parseOHLCVs(m, a, t, i, s);
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeTimestamp(e, "start"),
      this.safeNumber(e, "open"),
      this.safeNumber(e, "high"),
      this.safeNumber(e, "low"),
      this.safeNumber(e, "close"),
      this.safeNumber(e, "volume")
    ];
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.market(e), r = {
      product_id: n.id
    };
    i !== void 0 && (r.limit = i);
    const a = await this.v3PrivateGetBrokerageProductsProductIdTicker(this.extend(r, s)), o = this.safeValue(a, "trades", []);
    return this.parseTrades(o, n, t, i);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchMyTrades", e, t, i, s, "cursor", "cursor", void 0, 100);
    let r;
    e !== void 0 && (r = this.market(e));
    const a = {};
    r !== void 0 && (a.product_id = r.id), i !== void 0 && (a.limit = i), t !== void 0 && (a.start_sequence_timestamp = this.iso8601(t));
    const o = this.safeValueN(s, ["until", "till"]);
    o !== void 0 && (s = this.omit(s, ["until", "till"]), a.end_sequence_timestamp = this.iso8601(o));
    const c = await this.v3PrivateGetBrokerageOrdersHistoricalFills(this.extend(a, s)), u = this.safeValue(c, "fills", []), f = this.safeValue(u, 0), h = this.safeString(c, "cursor");
    return h !== void 0 && h !== "" && (f.cursor = h, u[0] = f), this.parseTrades(u, r, t, i);
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const n = {
      product_id: this.market(e).id
    };
    t !== void 0 && (n.limit = t);
    const r = await this.v3PrivateGetBrokerageProductBook(this.extend(n, i)), a = this.safeValue(r, "pricebook", {}), o = this.safeString(a, "time"), c = this.parse8601(o);
    return this.parseOrderBook(a, e, c, "bids", "asks", "price", "size");
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), this.checkAddress(i), await this.loadMarkets();
    const r = this.currency(e);
    let a = this.safeString2(n, "account_id", "accountId");
    if (n = this.omit(n, ["account_id", "accountId"]), a === void 0) {
      if (e === void 0)
        throw new g("withdraw() requires an account_id (or accountId) parameter OR a currency code argument").exchange(this.id);
      if (a = await this.findAccountId(e), a === void 0)
        throw new wo(e).addMessage("It could not find account id for " + e).exchange(this.id);
    }
    const o = this.safeString(n, "network"), c = this.currencyToPrecision(e, t, o), u = {
      account_id: a,
      type: "send",
      to: i,
      amount: c,
      currency: r.id
    };
    s !== void 0 && (u.destination_tag = s);
    const f = await this.v2PrivatePostAccountsAccountIdTransactions(this.extend(u, n)), h = this.safeValue(f, "data", {});
    return this.parseTransaction(h, r);
  }
  async createAuthToken(e, t = void 0, i = void 0) {
    let s;
    if (i !== void 0) {
      s = t + " " + i.replace("https://", "");
      const o = s.indexOf("?");
      o > 0 && (s = s.slice(0, o));
    }
    const n = this.randomBytes(16), r = {
      aud: ["retail_rest_api_proxy"],
      iss: "coinbase-cloud",
      nbf: e,
      exp: e + 120,
      sub: this.apiKey,
      iat: e
    };
    s !== void 0 && (r.uri = s);
    let a;
    return this.externalSigner ? a = await this.externalSigner.sign({
      payload: r,
      publicApiKey: this.apiKey,
      exchangeId: this.id,
      opts: {
        nonce: n,
        type: "jwt"
      }
    }) : a = Hm(r, this.encode(this.secret), Re, !1, { kid: this.apiKey, nonce: n, alg: "ES256" }), a;
  }
  async sign(e, t = [], i = "GET", s = {}, n = void 0, r = void 0) {
    var m;
    const a = t[0], o = t[1] === "private", c = a === "v3";
    let f = "/" + (c ? "api/v3" : "v2") + "/" + this.implodeParams(e, s);
    const h = this.omit(s, this.extractParams(e)), l = f;
    i === "GET" && Object.keys(h).length && (f += "?" + this.urlencodeWithArrayRepeat(h));
    const p = this.urls.api.rest + f;
    if (o) {
      const y = this.safeString(this.headers, "Authorization");
      let w;
      if (y !== void 0)
        w = y;
      else if (this.token)
        w = "Bearer " + this.token;
      else {
        this.checkRequiredCredentials();
        const S = this.seconds();
        let b = "";
        if (i !== "GET" ? Object.keys(h).length && (r = this.json(h), b = r) : c || Object.keys(h).length && (b += "?" + this.urlencode(h)), this.apiKey.indexOf("organizations/") >= 0 || ((m = this.secret) == null ? void 0 : m.startsWith("-----BEGIN")) || !this.secret && this.externalSigner) {
          if (this.apiKey.startsWith("-----BEGIN"))
            throw new Z().addMessage("apiKey should contain the name (eg: organizations/3b910e93....) and not the public key").exchange(this.id);
          w = "Bearer " + await this.createAuthToken(S, i, p);
        } else {
          const x = this.seconds().toString(), v = x + i + l + b;
          let _;
          this.externalSigner ? _ = await this.externalSigner.sign({
            payload: this.encode(v),
            publicApiKey: this.apiKey,
            exchangeId: this.id
          }) : _ = this.hmac(this.encode(v), this.encode(this.secret), Re), n = {
            "CB-ACCESS-KEY": this.apiKey,
            "CB-ACCESS-SIGN": _,
            "CB-ACCESS-TIMESTAMP": x,
            "Content-Type": "application/json"
          };
        }
      }
      w !== void 0 && (n = {
        Authorization: w,
        "Content-Type": "application/json"
      }, i !== "GET" && Object.keys(h).length && (r = this.json(h)));
    }
    return { url: p, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (a === void 0)
      return;
    let u = this.safeString(a, "error");
    if (u !== void 0) {
      const p = this.safeString2(a, "error_description", "message"), m = u + ": " + p;
      throw this.throwExactlyMatchedException(this.exceptions.exact, u, m), this.throwBroadlyMatchedException(this.exceptions.broad, p, m), new O().addMessage(m).exchange(this.id);
    }
    const f = this.safeValue(a, "errors");
    if (f !== void 0 && Array.isArray(f) && f.length > 0 && (u = this.safeString(f[0], "id"), u !== void 0)) {
      const m = this.safeString(f[0], "message"), y = u + ": " + m;
      throw this.throwExactlyMatchedException(this.exceptions.exact, u, y), this.throwBroadlyMatchedException(this.exceptions.broad, m, y), new O().addMessage(y).exchange(this.id);
    }
    const h = this.options.advanced;
    if (this.safeValue(a, "data") === void 0 && !h)
      throw new O().addMessage("Failed due to a malformed response " + this.json(a)).exchange(this.id);
  }
}
let Qy = class extends gt {
};
class Jy extends Qy {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "coinbaseexchange",
      name: "Coinbase Exchange",
      countries: ["US"],
      rateLimit: 100,
      userAgent: this.userAgents.chrome,
      pro: !0,
      has: {
        CORS: !0,
        spot: !0,
        margin: !1,
        swap: !1,
        future: !1,
        option: !1,
        cancelAllOrders: !0,
        cancelOrder: !0,
        createDepositAddress: !0,
        createOrder: !0,
        createStopLimitOrder: !0,
        createStopMarketOrder: !0,
        createStopOrder: !0,
        fetchAccounts: !0,
        fetchBalance: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDepositAddress: !1,
        fetchDeposits: !0,
        fetchDepositsWithdrawals: !0,
        fetchFundingRate: !1,
        fetchLedger: !0,
        fetchMarginMode: !1,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrders: !0,
        fetchOrderTrades: !0,
        fetchPosition: !1,
        fetchPositionHistory: !1,
        fetchPositionMode: !1,
        fetchPositions: !1,
        fetchPositionsForSymbol: !1,
        fetchPositionsHistory: !1,
        fetchPositionsRisk: !1,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !1,
        fetchTradingFees: !0,
        fetchTransactions: "emulated",
        fetchWithdrawals: !0,
        withdraw: !0
      },
      timeframes: {
        "1m": 60,
        "5m": 300,
        "15m": 900,
        "1h": 3600,
        "6h": 21600,
        "1d": 86400
      },
      hostname: "exchange.coinbase.com",
      urls: {
        test: {
          public: "https://api-public.sandbox.exchange.coinbase.com",
          private: "https://api-public.sandbox.exchange.coinbase.com"
        },
        logo: "https://github.com/ccxt/ccxt/assets/43336371/34a65553-88aa-4a38-a714-064bd228b97e",
        api: {
          public: "https://api.{hostname}",
          private: "https://api.{hostname}"
        },
        www: "https://coinbase.com/",
        doc: "https://docs.cloud.coinbase.com/exchange/docs/",
        fees: [
          "https://docs.pro.coinbase.com/#fees",
          "https://support.pro.coinbase.com/customer/en/portal/articles/2945310-fees"
        ]
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0,
        password: !0
      },
      api: {
        public: {
          get: [
            "currencies",
            "products",
            "products/{id}",
            "products/{id}/book",
            "products/{id}/candles",
            "products/{id}/stats",
            "products/{id}/ticker",
            "products/{id}/trades",
            "time",
            "products/spark-lines"
            // experimental
          ]
        },
        private: {
          get: [
            "address-book",
            "accounts",
            "accounts/{id}",
            "accounts/{id}/holds",
            "accounts/{id}/ledger",
            "accounts/{id}/transfers",
            "coinbase-accounts",
            "fills",
            "funding",
            "fees",
            "margin/profile_information",
            "margin/buying_power",
            "margin/withdrawal_power",
            "margin/withdrawal_power_all",
            "margin/exit_plan",
            "margin/liquidation_history",
            "margin/position_refresh_amounts",
            "margin/status",
            "oracle",
            "orders",
            "orders/{id}",
            "orders/client:{client_oid}",
            "otc/orders",
            "payment-methods",
            "position",
            "profiles",
            "profiles/{id}",
            "reports/{report_id}",
            "transfers",
            "transfers/{transfer_id}",
            "users/self/exchange-limits",
            "users/self/hold-balances",
            "users/self/trailing-volume",
            "withdrawals/fee-estimate",
            "conversions/{conversion_id}",
            "conversions/fees"
          ],
          post: [
            "conversions",
            "deposits/coinbase-account",
            "deposits/payment-method",
            "coinbase-accounts/{id}/addresses",
            "funding/repay",
            "orders",
            "position/close",
            "profiles/margin-transfer",
            "profiles/transfer",
            "reports",
            "withdrawals/coinbase",
            "withdrawals/coinbase-account",
            "withdrawals/crypto",
            "withdrawals/payment-method"
          ],
          delete: [
            "orders",
            "orders/client:{client_oid}",
            "orders/{id}"
          ]
        }
      },
      commonCurrencies: {
        CGLD: "CELO"
      },
      precisionMode: ct,
      fees: {
        trading: {
          tierBased: !0,
          percentage: !0,
          maker: this.parseNumber("0.004"),
          taker: this.parseNumber("0.006")
          // highest fee of all tiers
        },
        funding: {
          tierBased: !1,
          percentage: !1,
          withdraw: {
            BCH: 0,
            BTC: 0,
            LTC: 0,
            ETH: 0,
            EUR: 0.15,
            USD: 25
          },
          deposit: {
            BCH: 0,
            BTC: 0,
            LTC: 0,
            ETH: 0,
            EUR: 0.15,
            USD: 10
          }
        }
      },
      exceptions: {
        exact: {
          "Insufficient funds": re,
          NotFound: Se,
          "Invalid API Key": Z,
          "invalid signature": Z,
          "Invalid Passphrase": Z,
          "Invalid order id": g,
          "Private rate limit exceeded": Ae,
          "Trading pair not available": ee,
          "Product not found": it
        },
        broad: {
          "Order already done": Se,
          "order not found": Se,
          "price too small": g,
          "price too precise": g,
          "under maintenance": O,
          "size is too small": g,
          "Cancel only mode": O
          // https://github.com/ccxt/ccxt/issues/7690
        }
      }
    });
  }
  async fetchCurrencies(e = {}) {
    const t = await this.publicGetCurrencies(e), i = {};
    for (let s = 0; s < t.length; s++) {
      const n = t[s], r = this.safeString(n, "id"), a = this.safeString(n, "name"), o = this.safeCurrencyCode(r), c = this.safeValue(n, "details", {}), f = this.safeString(n, "status") === "online";
      i[o] = {
        id: r,
        code: o,
        info: n,
        type: this.safeString(c, "type"),
        name: a,
        active: f,
        deposit: void 0,
        withdraw: void 0,
        fee: void 0,
        precision: this.safeNumber(n, "max_precision"),
        limits: {
          amount: {
            min: this.safeNumber(c, "min_size"),
            max: void 0
          },
          withdraw: {
            min: this.safeNumber(c, "min_withdrawal_amount"),
            max: void 0
          }
        },
        networks: {}
      };
    }
    return i;
  }
  async fetchMarkets(e = {}) {
    const t = await this.publicGetProducts(e), i = [];
    for (let s = 0; s < t.length; s++) {
      const n = t[s], r = this.safeString(n, "id"), [a, o] = r.split("-"), c = this.safeCurrencyCode(a), u = this.safeCurrencyCode(o), f = this.safeString(n, "status");
      i.push(this.extend(this.fees.trading, {
        id: r,
        symbol: c + "/" + u,
        base: c,
        quote: u,
        settle: void 0,
        baseId: a,
        quoteId: o,
        settleId: void 0,
        type: "spot",
        spot: !0,
        margin: this.safeValue(n, "margin_enabled"),
        swap: !1,
        future: !1,
        option: !1,
        active: f === "online",
        contract: !1,
        linear: void 0,
        inverse: void 0,
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.safeNumber(n, "base_increment"),
          price: this.safeNumber(n, "quote_increment")
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: void 0,
            max: void 0
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.safeNumber(n, "min_market_funds"),
            max: void 0
          }
        },
        created: void 0,
        info: n
      }));
    }
    return i;
  }
  async fetchAccounts(e = {}) {
    await this.loadMarkets();
    const t = await this.privateGetAccounts(e);
    return this.parseAccounts(t, e);
  }
  parseAccount(e) {
    const t = this.safeString(e, "currency");
    return {
      id: this.safeString(e, "id"),
      type: void 0,
      code: this.safeCurrencyCode(t),
      info: e
    };
  }
  parseBalance(e) {
    const t = { info: e };
    for (let i = 0; i < e.length; i++) {
      const s = e[i], n = this.safeString(s, "currency"), r = this.safeCurrencyCode(n), a = this.account();
      a.free = this.safeString(s, "available"), a.used = this.safeString(s, "hold"), a.total = this.safeString(s, "balance"), t[r] = a;
    }
    return this.safeBalance(t);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const t = await this.privateGetAccounts(e);
    return this.parseBalance(t);
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      id: this.marketId(e),
      level: 2
      // 1 best bidask, 2 aggregated, 3 full
    }, n = await this.publicGetProductsIdBook(this.extend(s, i)), r = this.parseOrderBook(n, e);
    return r.nonce = this.safeInteger(n, "sequence"), r;
  }
  parseTicker(e, t = void 0) {
    let i, s, n, r, a, o, c, u;
    const f = t === void 0 ? void 0 : t.symbol;
    return Array.isArray(e) ? (r = this.safeString(e, 4), i = this.milliseconds()) : (i = this.parse8601(this.safeValue(e, "time")), s = this.safeString(e, "bid"), n = this.safeString(e, "ask"), a = this.safeString(e, "high"), o = this.safeString(e, "low"), c = this.safeString(e, "open"), r = this.safeString2(e, "price", "last"), u = this.safeString(e, "volume")), this.safeTicker({
      symbol: f,
      timestamp: i,
      datetime: this.iso8601(i),
      high: a,
      low: o,
      bid: s,
      bidVolume: void 0,
      ask: n,
      askVolume: void 0,
      vwap: void 0,
      open: c,
      close: r,
      last: r,
      previousClose: void 0,
      change: void 0,
      percentage: void 0,
      average: void 0,
      baseVolume: u,
      quoteVolume: void 0,
      info: e
    }, t);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = {}, s = await this.publicGetProductsSparkLines(this.extend(i, t)), n = {}, r = Object.keys(s), a = "-";
    for (let o = 0; o < r.length; o++) {
      const c = r[o], u = this.safeValue(s, c, []), f = this.safeValue(u, 0, []), h = this.safeMarket(c, void 0, a), l = h.symbol;
      n[l] = this.parseTicker(f, h);
    }
    return this.filterByArrayTickers(n, "symbol", e);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      id: i.id
    }, n = this.safeString(this.options, "fetchTickerMethod", "publicGetProductsIdTicker"), r = await this[n](this.extend(s, t));
    return this.parseTicker(r, i);
  }
  parseTrade(e, t = void 0) {
    const i = this.parse8601(this.safeString2(e, "time", "created_at")), s = this.safeString(e, "product_id");
    t = this.safeMarket(s, t, "-");
    let n, r, a;
    const o = this.safeStringLower(t, "quoteId");
    if (o !== void 0) {
      const S = o + "_value";
      a = this.safeString(e, S);
      const b = this.safeString(e, "liquidity");
      b !== void 0 && (r = b === "T" ? "taker" : "maker", n = this.safeString(t, r));
    }
    const u = {
      cost: this.safeString2(e, "fill_fees", "fee"),
      currency: t.quote,
      rate: n
    }, f = this.safeString(e, "trade_id");
    let h = e.side === "buy" ? "sell" : "buy";
    const l = this.safeString(e, "order_id"), p = this.safeString(e, "maker_order_id"), m = this.safeString(e, "taker_order_id");
    (l !== void 0 || p !== void 0 && m !== void 0) && (h = e.side === "buy" ? "buy" : "sell");
    const y = this.safeString(e, "price"), w = this.safeString(e, "size");
    return this.safeTrade({
      id: f,
      order: l,
      info: e,
      timestamp: i,
      datetime: this.iso8601(i),
      symbol: t.symbol,
      type: void 0,
      takerOrMaker: r,
      side: h,
      price: y,
      amount: w,
      fee: u,
      cost: a
    }, t);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new k().addMessage("fetchMyTrades() requires a symbol argument").exchange(this.id);
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchMyTrades", e, t, i, s, 100);
    await this.loadMarkets();
    const r = this.market(e), a = {
      product_id: r.id
    };
    i !== void 0 && (a.limit = i), t !== void 0 && (a.start_date = this.iso8601(t));
    const o = this.safeValue2(s, "until", "end_date");
    o !== void 0 && (s = this.omit(s, ["until"]), a.end_date = this.iso8601(o));
    const c = await this.privateGetFills(this.extend(a, s));
    return this.parseTrades(c, r, t, i);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.market(e), r = {
      id: n.id
      // fixes issue #2
    };
    i !== void 0 && (r.limit = i);
    const a = await this.publicGetProductsIdTrades(this.extend(r, s));
    return this.parseTrades(a, n, t, i);
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    const t = await this.privateGetFees(e), i = this.safeNumber(t, "maker_fee_rate"), s = this.safeNumber(t, "taker_fee_rate"), n = {};
    for (let r = 0; r < this.symbols.length; r++) {
      const a = this.symbols[r];
      n[a] = {
        info: t,
        symbol: a,
        maker: i,
        taker: s,
        percentage: !0,
        tierBased: !0
      };
    }
    return n;
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeTimestamp(e, 0),
      this.safeNumber(e, 3),
      this.safeNumber(e, 2),
      this.safeNumber(e, 1),
      this.safeNumber(e, 4),
      this.safeNumber(e, 5)
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate", !1), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 300);
    const a = this.market(e), o = this.safeInteger(this.timeframes, t), c = {
      id: a.id
    };
    o !== void 0 ? c.granularity = o : c.granularity = t;
    const u = this.safeValue2(n, "until", "end");
    if (n = this.omit(n, ["until"]), i !== void 0)
      if (c.start = this.iso8601(i), s === void 0 ? s = 300 : s = Math.min(300, s), u === void 0) {
        const h = o * 1e3;
        this.isRoundNumber(i % h) ? c.end = this.iso8601(this.sum((s - 1) * h, i)) : c.end = this.iso8601(this.sum(s * h, i));
      } else
        c.end = this.iso8601(u);
    const f = await this.publicGetProductsIdCandles(this.extend(c, n));
    return this.parseOHLCVs(f, a, t, i, s);
  }
  async fetchTime(e = {}) {
    const t = await this.publicGetTime(e);
    return this.safeTimestamp(t, "epoch");
  }
  parseOrderStatus(e) {
    const t = {
      pending: "open",
      active: "open",
      open: "open",
      done: "closed",
      canceled: "canceled",
      canceling: "open"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    const i = this.parse8601(this.safeString(e, "created_at")), s = this.safeString(e, "product_id");
    t = this.safeMarket(s, t, "-");
    let n = this.parseOrderStatus(this.safeString(e, "status"));
    const r = this.safeString(e, "done_reason");
    n === "closed" && r === "canceled" && (n = "canceled");
    const a = this.safeString(e, "price"), o = this.safeString(e, "filled_size"), c = this.safeString(e, "size", o), u = this.safeString(e, "executed_value"), f = this.safeNumber(e, "fill_fees");
    let h;
    f !== void 0 && (h = {
      cost: f,
      currency: t.quote,
      rate: void 0
    });
    const l = this.safeString(e, "id"), p = this.safeString(e, "type"), m = this.safeString(e, "side"), y = this.safeString(e, "time_in_force"), w = this.safeValue(e, "post_only"), S = this.safeNumber(e, "stop_price"), b = this.safeString(e, "client_oid");
    return this.safeOrder({
      id: l,
      clientOrderId: b,
      info: e,
      timestamp: i,
      datetime: this.iso8601(i),
      lastTradeTimestamp: void 0,
      status: n,
      symbol: t.symbol,
      type: p,
      timeInForce: y,
      postOnly: w,
      side: m,
      price: a,
      stopPrice: S,
      triggerPrice: S,
      cost: u,
      amount: c,
      filled: o,
      remaining: void 0,
      fee: h,
      average: void 0,
      trades: void 0
    }, t);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {}, n = this.safeString2(i, "clientOrderId", "client_oid");
    let r;
    n === void 0 ? (r = "privateGetOrdersId", s.id = e) : (r = "privateGetOrdersClientClientOid", s.client_oid = n, i = this.omit(i, ["clientOrderId", "client_oid"]));
    const a = await this[r](this.extend(s, i));
    return this.parseOrder(a);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r;
    t !== void 0 && (r = this.market(t));
    const a = {
      order_id: e
    }, o = await this.privateGetFills(this.extend(a, n));
    return this.parseTrades(o, r, i, s);
  }
  async fetchOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    const n = {
      status: "all"
    };
    return await this.fetchOpenOrders(e, t, i, this.extend(n, s));
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchOpenOrders", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchOpenOrders", e, t, i, s, 100);
    const r = {};
    let a;
    e !== void 0 && (a = this.market(e), r.product_id = a.id), i !== void 0 && (r.limit = i), t !== void 0 && (r.start_date = this.iso8601(t));
    const o = this.safeValue2(s, "until", "end_date");
    o !== void 0 && (s = this.omit(s, ["until"]), r.end_date = this.iso8601(o));
    const c = await this.privateGetOrders(this.extend(r, s));
    return this.parseOrders(c, a, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    const n = {
      status: "done"
    };
    return await this.fetchOpenOrders(e, t, i, this.extend(n, s));
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = {
      // common params --------------------------------------------------
      // 'client_oid': clientOrderId,
      type: t,
      side: i,
      product_id: a.id
      // 'size': this.amountToPrecision (symbol, amount),
      // 'stp': 'dc', // self-trade prevention, dc = decrease and cancel, co = cancel oldest, cn = cancel newest, cb = cancel both
      // 'stop': 'loss', // "loss" = stop loss below price, "entry" = take profit above price
      // 'stop_price': this.priceToPrecision (symbol, price),
      // limit order params ---------------------------------------------
      // 'price': this.priceToPrecision (symbol, price),
      // 'size': this.amountToPrecision (symbol, amount),
      // 'time_in_force': 'GTC', // GTC, GTT, IOC, or FOK
      // 'cancel_after' [optional]* min, hour, day, requires time_in_force to be GTT
      // 'post_only': false, // invalid when time_in_force is IOC or FOK
      // market order params --------------------------------------------
      // 'size': this.amountToPrecision (symbol, amount),
      // 'funds': this.costToPrecision (symbol, amount),
    }, c = this.safeString2(r, "clientOrderId", "client_oid");
    c !== void 0 && (o.client_oid = c);
    const u = this.safeNumberN(r, ["stopPrice", "stop_price", "triggerPrice"]);
    u !== void 0 && (o.stop_price = this.priceToPrecision(e, u));
    const f = this.safeString2(r, "timeInForce", "time_in_force");
    if (f !== void 0 && (o.time_in_force = f), this.safeValue2(r, "postOnly", "post_only", !1) && (o.post_only = !0), r = this.omit(r, ["timeInForce", "time_in_force", "stopPrice", "stop_price", "clientOrderId", "client_oid", "postOnly", "post_only", "triggerPrice"]), t === "limit")
      o.price = this.priceToPrecision(e, n), o.size = this.amountToPrecision(e, s);
    else if (t === "market") {
      let p = this.safeNumber2(r, "cost", "funds");
      p === void 0 ? n !== void 0 && (p = s * n) : r = this.omit(r, ["cost", "funds"]), p !== void 0 ? o.funds = this.costToPrecision(e, p) : o.size = this.amountToPrecision(e, s);
    }
    const l = await this.privatePostOrders(this.extend(o, r));
    return this.parseOrder(l, a);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      // 'product_id': market['id'], // the request will be more performant if you include it
    }, n = this.safeString2(i, "clientOrderId", "client_oid");
    let r;
    n === void 0 ? (r = "privateDeleteOrdersId", s.id = e) : (r = "privateDeleteOrdersClientClientOid", s.client_oid = n, i = this.omit(i, ["clientOrderId", "client_oid"]));
    let a;
    return t !== void 0 && (a = this.market(t), s.product_id = a.symbol), await this[r](this.extend(s, i));
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {};
    let s;
    return e !== void 0 && (s = this.market(e), i.product_id = s.symbol), await this.privateDeleteOrders(this.extend(i, t));
  }
  async fetchPaymentMethods(e = {}) {
    return await this.privateGetPaymentMethods(e);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), this.checkAddress(i), await this.loadMarkets();
    const r = this.currency(e), a = {
      currency: r.id,
      amount: t
    };
    let o = "privatePostWithdrawals";
    "payment_method_id" in n ? o += "PaymentMethod" : "coinbase_account_id" in n ? o += "CoinbaseAccount" : (o += "Crypto", a.crypto_address = i, s !== void 0 && (a.destination_tag = s));
    const c = await this[o](this.extend(a, n));
    if (!c)
      throw new O().addMessage(" withdraw() error: " + this.json(c)).exchange(this.id);
    return this.parseTransaction(c, r);
  }
  parseLedgerEntryType(e) {
    const t = {
      transfer: "transfer",
      match: "trade",
      fee: "fee",
      rebate: "rebate",
      conversion: "trade"
      // Funds converted between fiat currency and a stablecoin
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeString(e, "id");
    let s = this.safeString(e, "amount"), n;
    const r = this.safeString(e, "balance"), a = P.stringSub(r, s);
    P.stringLt(s, "0") ? (n = "out", s = P.stringAbs(s)) : n = "in";
    const o = this.parseNumber(s), c = this.parseNumber(r), u = this.parseNumber(a), f = this.parse8601(this.safeValue(e, "created_at")), h = this.parseLedgerEntryType(this.safeString(e, "type")), l = this.safeCurrencyCode(void 0, t), p = this.safeValue(e, "details", {});
    let m, y, w;
    h === "transfer" ? (m = this.safeString(p, "from"), y = this.safeString(p, "to"), w = this.safeString(p, "profile_transfer_id")) : w = this.safeString(p, "order_id");
    const S = "ok";
    return this.safeLedgerEntry({
      info: e,
      id: i,
      timestamp: f,
      datetime: this.iso8601(f),
      direction: n,
      account: m,
      referenceAccount: y,
      referenceId: w,
      type: h,
      currency: l,
      amount: o,
      before: u,
      after: c,
      status: S,
      fee: void 0
    }, t);
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("withdraw() requires an account_id (or accountId) parameter OR a currency code argument").exchange(this.id);
    await this.loadMarkets(), await this.loadAccounts();
    const n = this.currency(e), r = this.indexBy(this.accounts, "code"), a = this.safeValue(r, e);
    if (a === void 0)
      throw new wo(e).addMessage("It could not find account id for " + e).exchange(this.id);
    const o = {
      id: a.id
      // 'start_date': this.iso8601 (since),
      // 'end_date': this.iso8601 (this.milliseconds ()),
      // 'before': 'cursor', // sets start cursor to before date
      // 'after': 'cursor', // sets end cursor to after date
      // 'limit': limit, // default 100
      // 'profile_id': 'string'
    };
    t !== void 0 && (o.start_date = this.iso8601(t)), i !== void 0 && (o.limit = i);
    const c = this.safeValue2(s, "until", "end_date");
    c !== void 0 && (s = this.omit(s, ["until"]), o.end_date = this.iso8601(c));
    const u = await this.privateGetAccountsIdLedger(this.extend(o, s));
    for (let f = 0; f < u.length; f++)
      u[f].currency = e;
    return this.parseLedger(u, n, t, i);
  }
  async fetchDepositsWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets(), await this.loadAccounts();
    let n, r = this.safeString(s, "id");
    if (r === void 0 && e !== void 0) {
      n = this.currency(e);
      const c = this.indexBy(this.accounts, "code"), u = this.safeValue(c, e);
      if (u === void 0)
        throw new O().addMessage("fetchDepositsWithdrawals() could not find account id for " + e).exchange(this.id);
      r = u.id;
    }
    const a = {};
    r !== void 0 && (a.id = r), i !== void 0 && (a.limit = i);
    let o;
    if (r === void 0) {
      o = await this.privateGetTransfers(this.extend(a, s));
      for (let c = 0; c < o.length; c++) {
        const u = this.safeString(o[c], "account_id"), f = this.safeValue(this.accountsById, u), h = this.safeString(f, "code");
        o[c].currency = h;
      }
    } else {
      o = await this.privateGetAccountsIdTransfers(this.extend(a, s));
      for (let c = 0; c < o.length; c++)
        o[c].currency = e;
    }
    return this.parseTransactions(o, n, t, i);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchDepositsWithdrawals(e, t, i, this.extend({ type: "deposit" }, s));
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchDepositsWithdrawals(e, t, i, this.extend({ type: "withdraw" }, s));
  }
  parseTransactionStatus(e) {
    if (this.safeValue(e, "canceled_at"))
      return "canceled";
    const i = this.safeValue(e, "processed_at"), s = this.safeValue(e, "completed_at");
    return s ? "ok" : i && !s ? "failed" : "pending";
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeValue(e, "details", {}), s = this.parse8601(this.safeString(e, "created_at")), n = this.safeString(e, "currency"), r = this.safeCurrencyCode(n, t);
    let a = this.safeNumber(e, "amount"), o = this.safeString(e, "type"), c = this.safeString(i, "crypto_address");
    c = this.safeString(e, "crypto_address", c);
    const u = {
      currency: void 0,
      cost: void 0,
      rate: void 0
    };
    if (o === "withdraw") {
      o = "withdrawal", c = this.safeString(i, "sent_to_address", c);
      const h = this.safeNumber(i, "fee");
      h !== void 0 && (a !== void 0 && (a -= h), u.cost = h, u.currency = r);
    }
    const f = this.safeString(i, "network");
    return {
      info: e,
      id: this.safeString(e, "id"),
      txid: this.safeString(i, "crypto_transaction_hash"),
      type: o,
      currency: r,
      network: this.networkIdToCode(f),
      amount: a,
      status: this.parseTransactionStatus(e),
      timestamp: s,
      datetime: this.iso8601(s),
      address: c,
      addressFrom: void 0,
      addressTo: this.safeString(i, "crypto_address"),
      tag: this.safeString(i, "destination_tag"),
      tagFrom: void 0,
      tagTo: void 0,
      updated: this.parse8601(this.safeString(e, "processed_at")),
      comment: void 0,
      internal: !1,
      fee: u
    };
  }
  async createDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e);
    let s = this.safeValue(this.options, "coinbaseAccounts");
    s === void 0 && (s = await this.privateGetCoinbaseAccounts(), this.options.coinbaseAccounts = s, this.options.coinbaseAccountsByCurrencyId = this.indexBy(s, "currency"));
    const n = i.id, r = this.safeValue(this.options.coinbaseAccountsByCurrencyId, n);
    if (r === void 0)
      throw new mr(e).addMessage("createDepositAddress() could not find the account with matching currency code, specify an `account_id` extra param").exchange(this.id);
    const a = {
      id: r.id
    }, o = await this.privatePostCoinbaseAccountsIdAddresses(this.extend(a, t)), c = this.safeString(o, "address"), u = this.safeString(o, "destination_tag");
    return {
      currency: e,
      address: this.checkAddress(c),
      tag: u,
      info: o
    };
  }
  // https://docs.cdp.coinbase.com/exchange/reference/exchangerestapi_getprofiles
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.privateGetProfiles();
    return e == null ? void 0 : e.map((t) => ({
      uid: t.id
    }));
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    let a = "/" + this.implodeParams(e, s);
    const o = this.omit(s, this.extractParams(e));
    i === "GET" && Object.keys(o).length && (a += "?" + this.urlencode(o));
    const c = this.implodeHostname(this.urls.api[t]) + a;
    if (t === "private") {
      this.checkRequiredCredentials();
      const u = this.nonce().toString();
      let f = "";
      i !== "GET" && Object.keys(o).length && (r = this.json(o), f = r);
      const h = u + i + a + f;
      let l;
      try {
        l = this.base64ToBinary(this.secret);
      } catch {
        throw new Z().addMessage(" sign() invalid base64 secret").exchange(this.id);
      }
      let p;
      this.externalSigner ? p = await this.externalSigner.sign({
        payload: this.encode(h),
        publicApiKey: this.apiKey,
        exchangeId: this.id
      }) : p = this.hmac(this.encode(h), l, Re, "base64"), n = {
        "CB-ACCESS-KEY": this.apiKey,
        "CB-ACCESS-SIGN": p,
        "CB-ACCESS-TIMESTAMP": u,
        "CB-ACCESS-PASSPHRASE": this.password,
        "Content-Type": "application/json"
      };
    }
    return { url: c, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (e === 400 || e === 404) {
      if (r[0] === "{") {
        const u = this.safeString(a, "message"), f = this.id + " " + u;
        throw this.throwExactlyMatchedException(this.exceptions.exact, u, f), this.throwBroadlyMatchedException(this.exceptions.broad, u, f), new O().addMessage(u).exchange(this.id);
      }
      throw new O().addMessage(r).exchange(this.id);
    }
  }
  async request(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0, a = {}) {
    const o = await this.fetch2(e, t, i, s, n, r, a);
    if (typeof o != "string" && "message" in o)
      throw new O().addMessage(this.json(o)).exchange(this.id);
    return o;
  }
}
let ew = class extends gt {
};
class Eu extends ew {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "gate",
      name: "Gate.io",
      countries: ["KR"],
      rateLimit: 50,
      version: "v4",
      certified: !0,
      pro: !0,
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/31784029-0313c702-b509-11e7-9ccc-bc0da6a0e435.jpg",
        doc: "https://www.gate.io/docs/developers/apiv4/en/",
        www: "https://gate.io/",
        api: {
          public: {
            wallet: "https://api.gateio.ws/api/v4",
            futures: "https://api.gateio.ws/api/v4",
            margin: "https://api.gateio.ws/api/v4",
            delivery: "https://api.gateio.ws/api/v4",
            spot: "https://api.gateio.ws/api/v4",
            options: "https://api.gateio.ws/api/v4",
            sub_accounts: "https://api.gateio.ws/api/v4",
            earn: "https://api.gateio.ws/api/v4"
          },
          private: {
            withdrawals: "https://api.gateio.ws/api/v4",
            wallet: "https://api.gateio.ws/api/v4",
            futures: "https://api.gateio.ws/api/v4",
            margin: "https://api.gateio.ws/api/v4",
            delivery: "https://api.gateio.ws/api/v4",
            spot: "https://api.gateio.ws/api/v4",
            options: "https://api.gateio.ws/api/v4",
            subAccounts: "https://api.gateio.ws/api/v4",
            portfolio: "https://api.gateio.ws/api/v4",
            rebate: "https://api.gateio.ws/api/v4",
            earn: "https://api.gateio.ws/api/v4",
            account: "https://api.gateio.ws/api/v4"
          }
        },
        test: {
          public: {
            futures: "https://fx-api-testnet.gateio.ws/api/v4",
            delivery: "https://fx-api-testnet.gateio.ws/api/v4",
            options: "https://fx-api-testnet.gateio.ws/api/v4"
          },
          private: {
            futures: "https://fx-api-testnet.gateio.ws/api/v4",
            delivery: "https://fx-api-testnet.gateio.ws/api/v4",
            options: "https://fx-api-testnet.gateio.ws/api/v4"
          }
        },
        referral: {
          // https://www.gate.io/signup/2436035- I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
          url: "https://www.gate.io/signup",
          discount: 0.2
        }
      },
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !0,
        option: !0,
        cancelAllOrders: !0,
        cancelOrder: !0,
        createMarketBuyOrderWithCost: !0,
        createMarketOrder: !0,
        createMarketOrderWithCost: !1,
        createMarketSellOrderWithCost: !1,
        createOrder: !0,
        createOrders: !0,
        createTakeProfitOrder: !0,
        createTriggerOrder: !0,
        editOrder: !0,
        fetchBalance: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDepositAddress: !0,
        fetchDeposits: !0,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchNetworkDepositAddress: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !0,
        fetchTransactionFees: !0,
        fetchWithdrawals: !0,
        transfer: !0,
        withdraw: !0
      },
      api: {
        public: {
          // All public endpoints 200r/10s per endpoint
          wallet: {
            get: {
              currency_chains: 1
            }
          },
          spot: {
            get: {
              currencies: 1,
              "currencies/{currency}": 1,
              currency_pairs: 1,
              "currency_pairs/{currency_pair}": 1,
              tickers: 1,
              order_book: 1,
              trades: 1,
              candlesticks: 1,
              time: 1
            }
          },
          margin: {
            get: {
              currency_pairs: 1,
              "currency_pairs/{currency_pair}": 1,
              funding_book: 1,
              "cross/currencies": 1,
              "cross/currencies/{currency}": 1,
              "uni/currency_pairs": 1,
              "uni/currency_pairs/{currency_pair}": 1
            }
          },
          flash_swap: {
            get: {
              currencies: 1
            }
          },
          futures: {
            get: {
              "{settle}/contracts": 1,
              "{settle}/contracts/{contract}": 1,
              "{settle}/order_book": 1,
              "{settle}/trades": 1,
              "{settle}/candlesticks": 1,
              "{settle}/premium_index": 1,
              "{settle}/tickers": 1,
              "{settle}/funding_rate": 1,
              "{settle}/insurance": 1,
              "{settle}/contract_stats": 1,
              "{settle}/index_constituents/{index}": 1,
              "{settle}/liq_orders": 1
            }
          },
          delivery: {
            get: {
              "{settle}/contracts": 1,
              "{settle}/contracts/{contract}": 1,
              "{settle}/order_book": 1,
              "{settle}/trades": 1,
              "{settle}/candlesticks": 1,
              "{settle}/tickers": 1,
              "{settle}/insurance": 1
            }
          },
          options: {
            get: {
              underlyings: 1,
              expirations: 1,
              contracts: 1,
              "contracts/{contract}": 1,
              settlements: 1,
              "settlements/{contract}": 1,
              order_book: 1,
              tickers: 1,
              "underlying/tickers/{underlying}": 1,
              candlesticks: 1,
              "underlying/candlesticks": 1,
              trades: 1
            }
          },
          earn: {
            get: {
              "uni/currencies": 1,
              "uni/currencies/{currency}": 1
            }
          }
        },
        private: {
          // private endpoints default is 150r/10s per endpoint
          withdrawals: {
            post: {
              withdrawals: 20
              // 1r/s cost = 20 / 1 = 20
            },
            delete: {
              "withdrawals/{withdrawal_id}": 1
            }
          },
          wallet: {
            get: {
              deposit_address: 1,
              withdrawals: 1,
              deposits: 1,
              sub_account_transfers: 1,
              withdraw_status: 1,
              sub_account_balances: 2.5,
              sub_account_margin_balances: 2.5,
              sub_account_futures_balances: 2.5,
              sub_account_cross_margin_balances: 2.5,
              saved_address: 1,
              fee: 1,
              total_balance: 2.5
            },
            post: {
              transfers: 2.5,
              sub_account_transfers: 2.5,
              sub_account_to_sub_account: 2.5
            }
          },
          subAccounts: {
            get: {
              sub_accounts: 2.5,
              "sub_accounts/{user_id}": 2.5,
              "sub_accounts/{user_id}/keys": 2.5,
              "sub_accounts/{user_id}/keys/{key}": 2.5
            },
            post: {
              sub_accounts: 2.5,
              "sub_accounts/{user_id}/keys": 2.5,
              "sub_accounts/{user_id}/lock": 2.5,
              "sub_accounts/{user_id}/unlock": 2.5
            },
            put: {
              "sub_accounts/{user_id}/keys/{key}": 2.5
            },
            delete: {
              "sub_accounts/{user_id}/keys/{key}": 2.5
            }
          },
          portfolio: {
            get: {
              accounts: 20 / 15,
              account_mode: 20 / 15,
              borrowable: 20 / 15,
              transferable: 20 / 15,
              loans: 20 / 15,
              loan_records: 20 / 15,
              interest_records: 20 / 15
            },
            post: {
              account_mode: 20 / 15,
              loans: 200 / 15
              // 15r/10s cost = 20 / 1.5 = 13.33
            }
          },
          spot: {
            // default is 200r/10s
            get: {
              fee: 1,
              batch_fee: 1,
              accounts: 1,
              account_book: 1,
              open_orders: 1,
              orders: 1,
              "orders/{order_id}": 1,
              my_trades: 1,
              price_orders: 1,
              "price_orders/{order_id}": 1
            },
            post: {
              batch_orders: 0.4,
              cross_liquidate_orders: 1,
              orders: 0.4,
              cancel_batch_orders: 20 / 75,
              countdown_cancel_all: 20 / 75,
              amend_batch_orders: 0.4,
              price_orders: 0.4
            },
            delete: {
              orders: 20 / 75,
              "orders/{order_id}": 20 / 75,
              price_orders: 20 / 75,
              "price_orders/{order_id}": 20 / 75
            },
            patch: {
              "orders/{order_id}": 0.4
            }
          },
          margin: {
            get: {
              accounts: 20 / 15,
              account_book: 20 / 15,
              funding_accounts: 20 / 15,
              auto_repay: 20 / 15,
              transferable: 20 / 15,
              loans: 20 / 15,
              "loans/{loan_id}": 20 / 15,
              "loans/{loan_id}/repayment": 20 / 15,
              loan_records: 20 / 15,
              "loan_records/{loan_record_id}": 20 / 15,
              borrowable: 20 / 15,
              "cross/accounts": 20 / 15,
              "cross/account_book": 20 / 15,
              "cross/loans": 20 / 15,
              "cross/loans/{loan_id}": 20 / 15,
              "cross/repayments": 20 / 15,
              "cross/interest_records": 20 / 15,
              "cross/transferable": 20 / 15,
              "cross/estimate_rate": 20 / 15,
              "cross/borrowable": 20 / 15,
              "uni/estimate_rate": 20 / 15,
              "uni/loans": 20 / 15,
              "uni/loan_records": 20 / 15,
              "uni/interest_records": 20 / 15,
              "uni/borrowable": 20 / 15
            },
            post: {
              auto_repay: 20 / 15,
              loans: 20 / 15,
              merged_loans: 20 / 15,
              "loans/{loan_id}/repayment": 20 / 15,
              "cross/loans": 20 / 15,
              "cross/repayments": 20 / 15,
              "uni/loans": 20 / 15
            },
            patch: {
              "loans/{loan_id}": 20 / 15,
              "loan_records/{loan_record_id}": 20 / 15
            },
            delete: {
              "loans/{loan_id}": 20 / 15
            }
          },
          flash_swap: {
            get: {
              currencies: 1,
              currency_pairs: 1,
              orders: 1,
              "orders/{order_id}": 1
            },
            post: {
              orders: 1,
              "orders/preview": 1
            }
          },
          futures: {
            get: {
              "{settle}/accounts": 1,
              "{settle}/account_book": 1,
              "{settle}/positions": 1,
              "{settle}/positions/{contract}": 1,
              "{settle}/dual_comp/positions/{contract}": 1,
              "{settle}/orders": 1,
              "{settle}/orders_timerange": 1,
              "{settle}/orders/{order_id}": 1,
              "{settle}/my_trades": 1,
              "{settle}/my_trades_timerange": 1,
              "{settle}/position_close": 1,
              "{settle}/liquidates": 1,
              "{settle}/auto_deleverages": 1,
              "{settle}/fee": 1,
              "{settle}/risk_limit_tiers": 1,
              "{settle}/price_orders": 1,
              "{settle}/price_orders/{order_id}": 1
            },
            post: {
              "{settle}/positions/{contract}/margin": 1,
              "{settle}/positions/{contract}/leverage": 1,
              "{settle}/positions/{contract}/risk_limit": 1,
              "{settle}/dual_mode": 1,
              "{settle}/dual_comp/positions/{contract}/margin": 1,
              "{settle}/dual_comp/positions/{contract}/leverage": 1,
              "{settle}/dual_comp/positions/{contract}/risk_limit": 1,
              "{settle}/orders": 0.4,
              "{settle}/batch_orders": 0.4,
              "{settle}/countdown_cancel_all": 0.4,
              "{settle}/batch_cancel_orders": 0.4,
              "{settle}/price_orders": 0.4
            },
            put: {
              "{settle}/orders/{order_id}": 1
            },
            delete: {
              "{settle}/orders": 20 / 75,
              "{settle}/orders/{order_id}": 20 / 75,
              "{settle}/price_orders": 20 / 75,
              "{settle}/price_orders/{order_id}": 20 / 75
            }
          },
          delivery: {
            get: {
              "{settle}/accounts": 20 / 15,
              "{settle}/account_book": 20 / 15,
              "{settle}/positions": 20 / 15,
              "{settle}/positions/{contract}": 20 / 15,
              "{settle}/orders": 20 / 15,
              "{settle}/orders/{order_id}": 20 / 15,
              "{settle}/my_trades": 20 / 15,
              "{settle}/position_close": 20 / 15,
              "{settle}/liquidates": 20 / 15,
              "{settle}/settlements": 20 / 15,
              "{settle}/price_orders": 20 / 15,
              "{settle}/price_orders/{order_id}": 20 / 15
            },
            post: {
              "{settle}/positions/{contract}/margin": 20 / 15,
              "{settle}/positions/{contract}/leverage": 20 / 15,
              "{settle}/positions/{contract}/risk_limit": 20 / 15,
              "{settle}/orders": 20 / 15,
              "{settle}/price_orders": 20 / 15
            },
            delete: {
              "{settle}/orders": 20 / 15,
              "{settle}/orders/{order_id}": 20 / 15,
              "{settle}/price_orders": 20 / 15,
              "{settle}/price_orders/{order_id}": 20 / 15
            }
          },
          options: {
            get: {
              my_settlements: 20 / 15,
              accounts: 20 / 15,
              account_book: 20 / 15,
              positions: 20 / 15,
              "positions/{contract}": 20 / 15,
              position_close: 20 / 15,
              orders: 20 / 15,
              "orders/{order_id}": 20 / 15,
              my_trades: 20 / 15
            },
            post: {
              orders: 20 / 15
            },
            delete: {
              orders: 20 / 15,
              "orders/{order_id}": 20 / 15
            }
          },
          earn: {
            get: {
              "uni/currencies": 20 / 15,
              "uni/currencies/{currency}": 20 / 15,
              "uni/lends": 20 / 15,
              "uni/lend_records": 20 / 15,
              "uni/interests/{currency}": 20 / 15,
              "uni/interest_records": 20 / 15,
              "uni/interest_status/{currency}": 20 / 15
            },
            post: {
              "uni/lends": 20 / 15
            },
            put: {
              "uni/interest_reinvest": 20 / 15
            },
            patch: {
              "uni/lends": 20 / 15
            }
          },
          loan: {
            get: {
              "collateral/orders": 20 / 15,
              "collateral/orders/{order_id}": 20 / 15,
              "collateral/repay_records": 20 / 15,
              "collateral/collaterals": 20 / 15,
              "collateral/total_amount": 20 / 15,
              "collateral/ltv": 20 / 15,
              "collateral/currencies": 20 / 15,
              "multi_collateral/orders": 20 / 15,
              "multi_collateral/orders/{order_id}": 20 / 15,
              "multi_collateral/repay": 20 / 15,
              "multi_collateral/mortgage": 20 / 15,
              "multi_collateral/currency_quota": 20 / 15,
              "multi_collateral/currencies": 20 / 15,
              "multi_collateral/ltv": 20 / 15,
              "multi_collateral/fixed_rate": 20 / 15
            },
            post: {
              "collateral/orders": 20 / 15,
              "collateral/repay": 20 / 15,
              "collateral/collaterals": 20 / 15,
              "multi_collateral/orders": 20 / 15,
              "multi_collateral/repay": 20 / 15,
              "multi_collateral/mortgage": 20 / 15
            }
          },
          account: {
            get: {
              detail: 20 / 15,
              stp_groups: 20 / 15,
              "stp_groups/{stp_id}/users": 20 / 15
            },
            post: {
              stp_groups: 20 / 15,
              "stp_groups/{stp_id}/users": 20 / 15
            },
            delete: {
              "stp_groups/{stp_id}/users": 20 / 15
            }
          },
          rebate: {
            get: {
              "agency/transaction_history": 20 / 15,
              "agency/commission_history": 20 / 15
            }
          }
        }
      },
      timeframes: {
        "10s": "10s",
        "1m": "1m",
        "5m": "5m",
        "15m": "15m",
        "30m": "30m",
        "1h": "1h",
        "2h": "2h",
        "4h": "4h",
        "8h": "8h",
        "1d": "1d",
        "7d": "7d",
        "1w": "7d"
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0
      },
      headers: {
        "X-Gate-Channel-Id": "cede"
      },
      options: {
        sandboxMode: !1,
        timeDifference: 0,
        createOrder: {
          expiration: 86400
          // for conditional orders
        },
        networks: {
          CHZ: "CHZ2",
          GATEIO: "GTEVM",
          KSM: "KSMSM",
          DOT: "DOTSM",
          MANTA: "MANTAETH"
        },
        networksById: {
          CHZ2: "CHZ",
          DOTSM: "DOT",
          GTEVM: "GATEIO",
          KSMSM: "KSM",
          MANTAETH: "MANTA"
        },
        timeInForce: {
          GTC: "gtc",
          IOC: "ioc",
          PO: "poc",
          POC: "poc",
          FOK: "fok"
        },
        accountsByType: {
          funding: "spot",
          spot: "spot",
          margin: "margin",
          cross_margin: "cross_margin",
          cross: "cross_margin",
          isolated: "margin",
          swap: "futures",
          future: "delivery",
          futures: "futures",
          delivery: "delivery",
          option: "options",
          options: "options"
        },
        defaultType: "spot",
        swap: {
          fetchMarkets: {
            settlementCurrencies: ["usdt", "btc"]
          }
        },
        future: {
          fetchMarkets: {
            settlementCurrencies: ["usdt"]
          }
        }
      },
      precisionMode: ct,
      fees: {
        trading: {
          tierBased: !0,
          feeSide: "get",
          percentage: !0,
          maker: this.parseNumber("0.002"),
          taker: this.parseNumber("0.002"),
          tiers: {
            // volume is in BTC
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.002")],
              [this.parseNumber("1.5"), this.parseNumber("0.00185")],
              [this.parseNumber("3"), this.parseNumber("0.00175")],
              [this.parseNumber("6"), this.parseNumber("0.00165")],
              [this.parseNumber("12.5"), this.parseNumber("0.00155")],
              [this.parseNumber("25"), this.parseNumber("0.00145")],
              [this.parseNumber("75"), this.parseNumber("0.00135")],
              [this.parseNumber("200"), this.parseNumber("0.00125")],
              [this.parseNumber("500"), this.parseNumber("0.00115")],
              [this.parseNumber("1250"), this.parseNumber("0.00105")],
              [this.parseNumber("2500"), this.parseNumber("0.00095")],
              [this.parseNumber("3000"), this.parseNumber("0.00085")],
              [this.parseNumber("6000"), this.parseNumber("0.00075")],
              [this.parseNumber("11000"), this.parseNumber("0.00065")],
              [this.parseNumber("20000"), this.parseNumber("0.00055")],
              [this.parseNumber("40000"), this.parseNumber("0.00055")],
              [this.parseNumber("75000"), this.parseNumber("0.00055")]
            ],
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.002")],
              [this.parseNumber("1.5"), this.parseNumber("0.00195")],
              [this.parseNumber("3"), this.parseNumber("0.00185")],
              [this.parseNumber("6"), this.parseNumber("0.00175")],
              [this.parseNumber("12.5"), this.parseNumber("0.00165")],
              [this.parseNumber("25"), this.parseNumber("0.00155")],
              [this.parseNumber("75"), this.parseNumber("0.00145")],
              [this.parseNumber("200"), this.parseNumber("0.00135")],
              [this.parseNumber("500"), this.parseNumber("0.00125")],
              [this.parseNumber("1250"), this.parseNumber("0.00115")],
              [this.parseNumber("2500"), this.parseNumber("0.00105")],
              [this.parseNumber("3000"), this.parseNumber("0.00095")],
              [this.parseNumber("6000"), this.parseNumber("0.00085")],
              [this.parseNumber("11000"), this.parseNumber("0.00075")],
              [this.parseNumber("20000"), this.parseNumber("0.00065")],
              [this.parseNumber("40000"), this.parseNumber("0.00065")],
              [this.parseNumber("75000"), this.parseNumber("0.00065")]
            ]
          }
        },
        swap: {
          tierBased: !0,
          feeSide: "base",
          percentage: !0,
          maker: this.parseNumber("0.0"),
          taker: this.parseNumber("0.0005"),
          tiers: {
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.0000")],
              [this.parseNumber("1.5"), this.parseNumber("-0.00005")],
              [this.parseNumber("3"), this.parseNumber("-0.00005")],
              [this.parseNumber("6"), this.parseNumber("-0.00005")],
              [this.parseNumber("12.5"), this.parseNumber("-0.00005")],
              [this.parseNumber("25"), this.parseNumber("-0.00005")],
              [this.parseNumber("75"), this.parseNumber("-0.00005")],
              [this.parseNumber("200"), this.parseNumber("-0.00005")],
              [this.parseNumber("500"), this.parseNumber("-0.00005")],
              [this.parseNumber("1250"), this.parseNumber("-0.00005")],
              [this.parseNumber("2500"), this.parseNumber("-0.00005")],
              [this.parseNumber("3000"), this.parseNumber("-0.00008")],
              [this.parseNumber("6000"), this.parseNumber("-0.01000")],
              [this.parseNumber("11000"), this.parseNumber("-0.01002")],
              [this.parseNumber("20000"), this.parseNumber("-0.01005")],
              [this.parseNumber("40000"), this.parseNumber("-0.02000")],
              [this.parseNumber("75000"), this.parseNumber("-0.02005")]
            ],
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.00050")],
              [this.parseNumber("1.5"), this.parseNumber("0.00048")],
              [this.parseNumber("3"), this.parseNumber("0.00046")],
              [this.parseNumber("6"), this.parseNumber("0.00044")],
              [this.parseNumber("12.5"), this.parseNumber("0.00042")],
              [this.parseNumber("25"), this.parseNumber("0.00040")],
              [this.parseNumber("75"), this.parseNumber("0.00038")],
              [this.parseNumber("200"), this.parseNumber("0.00036")],
              [this.parseNumber("500"), this.parseNumber("0.00034")],
              [this.parseNumber("1250"), this.parseNumber("0.00032")],
              [this.parseNumber("2500"), this.parseNumber("0.00030")],
              [this.parseNumber("3000"), this.parseNumber("0.00030")],
              [this.parseNumber("6000"), this.parseNumber("0.00030")],
              [this.parseNumber("11000"), this.parseNumber("0.00030")],
              [this.parseNumber("20000"), this.parseNumber("0.00030")],
              [this.parseNumber("40000"), this.parseNumber("0.00030")],
              [this.parseNumber("75000"), this.parseNumber("0.00030")]
            ]
          }
        }
      },
      // https://www.gate.io/docs/developers/apiv4/en/#label-list
      exceptions: {
        exact: {
          INVALID_PARAM_VALUE: g,
          INVALID_PROTOCOL: g,
          INVALID_ARGUMENT: g,
          INVALID_REQUEST_BODY: g,
          MISSING_REQUIRED_PARAM: g,
          BAD_REQUEST: g,
          INVALID_CONTENT_TYPE: g,
          NOT_ACCEPTABLE: g,
          METHOD_NOT_ALLOWED: g,
          NOT_FOUND: O,
          INVALID_CREDENTIALS: Pt,
          INVALID_KEY: Pt,
          IP_FORBIDDEN: Z,
          READ_ONLY: ee,
          INVALID_SIGNATURE: Z,
          MISSING_REQUIRED_HEADER: Z,
          REQUEST_EXPIRED: Z,
          ACCOUNT_LOCKED: Ee,
          FORBIDDEN: ee,
          SUB_ACCOUNT_NOT_FOUND: O,
          SUB_ACCOUNT_LOCKED: Ee,
          MARGIN_BALANCE_EXCEPTION: O,
          MARGIN_TRANSFER_FAILED: O,
          TOO_MUCH_FUTURES_AVAILABLE: O,
          FUTURES_BALANCE_NOT_ENOUGH: re,
          ACCOUNT_EXCEPTION: O,
          SUB_ACCOUNT_TRANSFER_FAILED: O,
          ADDRESS_NOT_USED: O,
          TOO_FAST: Ae,
          WITHDRAWAL_OVER_LIMIT: O,
          API_WITHDRAW_DISABLED: Te,
          INVALID_WITHDRAW_ID: O,
          INVALID_WITHDRAW_CANCEL_STATUS: O,
          INVALID_PRECISION: g,
          INVALID_CURRENCY: g,
          INVALID_CURRENCY_PAIR: it,
          POC_FILL_IMMEDIATELY: k,
          ORDER_NOT_FOUND: Se,
          CLIENT_ID_NOT_FOUND: Se,
          ORDER_CLOSED: k,
          ORDER_CANCELLED: k,
          QUANTITY_NOT_ENOUGH: g,
          BALANCE_NOT_ENOUGH: re,
          MARGIN_NOT_SUPPORTED: k,
          MARGIN_BALANCE_NOT_ENOUGH: re,
          AMOUNT_TOO_LITTLE: g,
          AMOUNT_TOO_MUCH: g,
          REPEATED_CREATION: k,
          LOAN_NOT_FOUND: Se,
          LOAN_RECORD_NOT_FOUND: Se,
          NO_MATCHED_LOAN: O,
          NOT_MERGEABLE: O,
          NO_CHANGE: O,
          REPAY_TOO_MUCH: O,
          TOO_MANY_CURRENCY_PAIRS: k,
          TOO_MANY_ORDERS: k,
          TOO_MANY_REQUESTS: Ae,
          MIXED_ACCOUNT_TYPE: k,
          AUTO_BORROW_TOO_MUCH: O,
          TRADE_RESTRICTED: re,
          USER_NOT_FOUND: Z,
          CONTRACT_NO_COUNTER: O,
          CONTRACT_NOT_FOUND: O,
          RISK_LIMIT_EXCEEDED: O,
          INSUFFICIENT_AVAILABLE: re,
          LIQUIDATE_IMMEDIATELY: k,
          LEVERAGE_TOO_HIGH: g,
          LEVERAGE_TOO_LOW: g,
          ORDER_NOT_OWNED: O,
          ORDER_FINISHED: O,
          POSITION_CROSS_MARGIN: O,
          POSITION_IN_LIQUIDATION: O,
          POSITION_IN_CLOSE: O,
          POSITION_EMPTY: k,
          REMOVE_TOO_MUCH: O,
          RISK_LIMIT_NOT_MULTIPLE: O,
          RISK_LIMIT_TOO_HIGH: O,
          RISK_LIMIT_TOO_lOW: O,
          PRICE_TOO_DEVIATED: k,
          SIZE_TOO_LARGE: g,
          SIZE_TOO_SMALL: g,
          PRICE_OVER_LIQUIDATION: g,
          PRICE_OVER_BANKRUPT: g,
          ORDER_POC_IMMEDIATE: g,
          INCREASE_POSITION: k,
          CONTRACT_IN_DELISTING: O,
          INTERNAL: Te,
          SERVER_ERROR: Te,
          TOO_BUSY: Te,
          CROSS_ACCOUNT_NOT_FOUND: O,
          RISK_LIMIT_TOO_LOW: g,
          AUTO_TRIGGER_PRICE_LESS_LAST: k,
          AUTO_TRIGGER_PRICE_GREATE_LAST: k,
          POSITION_HOLDING: g,
          USER_LOAN_EXCEEDED: g
          // {"label":"USER_LOAN_EXCEEDED","message":"Max loan amount per user would be exceeded"}
        },
        broad: {
          "only used addresses or verified addresses are allowed for api withdrawal": gi,
          "Error: Invalid amount or below minimum amount limit.": Xt,
          "Candlestick too long ago. Maximum 10000 points ago are allowed": Au
        },
        messages: {
          "INVALID_PARAM_VALUE: Your order size %% is too small": ye.ORDER_UNDER_MINIMUM
        }
      }
    });
  }
  convertExpireDate(e) {
    const t = e.slice(0, 2), i = e.slice(2, 4), s = e.slice(4, 6);
    return "20" + t + "-" + i + "-" + s + "T00:00:00Z";
  }
  createExpiredOptionMarket(e) {
    const t = "USDT", i = t, s = e.split("-"), n = e.split("/"), r = e.split("_");
    let a, o = this.safeString(s, 1);
    e.indexOf("/") > -1 ? a = this.safeString(n, 0) : (a = this.safeString(r, 0), o = o.slice(2, 8));
    const c = this.safeString(s, 2), u = this.safeString(s, 3), f = this.convertExpireDate(o), h = this.parse8601(f);
    return {
      id: a + "_" + t + "-20" + o + "-" + c + "-" + u,
      symbol: a + "/" + t + ":" + i + "-" + o + "-" + c + "-" + u,
      base: a,
      quote: t,
      settle: i,
      baseId: a,
      quoteId: t,
      settleId: i,
      active: !1,
      type: "option",
      linear: void 0,
      inverse: void 0,
      spot: !1,
      swap: !1,
      future: !1,
      option: !0,
      margin: !1,
      contract: !0,
      contractSize: this.parseNumber("1"),
      expiry: h,
      expiryDatetime: f,
      optionType: u === "C" ? "call" : "put",
      strike: this.parseNumber(c),
      precision: {
        amount: this.parseNumber("1"),
        price: void 0
      },
      limits: {
        amount: {
          min: void 0,
          max: void 0
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: void 0,
          max: void 0
        }
      },
      info: void 0
    };
  }
  safeMarket(e = void 0, t = void 0, i = void 0, s = void 0) {
    return e !== void 0 && (e.indexOf("-C") > -1 || e.indexOf("-P") > -1) && !(e in this.markets_by_id) ? this.createExpiredOptionMarket(e) : super.safeMarket(e, t, i, s);
  }
  isUsingForcedProxy(e = {}, t = []) {
    return t[0] === "private";
  }
  nonce() {
    const e = this.safeString(this.options, "timeDifference"), t = this.parseNumber(P.stringDiv(e, "1000"));
    return this.seconds() - t;
  }
  async fetchStatus(e = {}) {
    const t = await this.publicSpotGetTime(e), i = this.safeInteger(t, "server_time");
    return {
      status: i !== void 0 ? "ok" : "maintenance",
      updated: i,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchTime(e) {
    const t = await this.publicSpotGetTime(e);
    return this.safeInteger(t, "server_time");
  }
  async fetchMarkets(e = {}) {
    const t = this.safeValue(this.options, "sandboxMode", !1);
    let i = [
      this.fetchContractMarkets(e),
      this.fetchOptionMarkets(e)
    ];
    if (!t) {
      const c = [this.fetchSpotMarkets(e)];
      i = this.arrayConcat(i, c);
    }
    const s = await Promise.all(i), n = this.safeValue(s, 0, []), r = this.safeValue(s, 1, []), a = this.safeValue(s, 2, []), o = this.arrayConcat(n, r);
    return this.arrayConcat(o, a);
  }
  async fetchSpotMarkets(e = {}) {
    const t = await this.publicMarginGetCurrencyPairs(e), i = await this.publicSpotGetCurrencyPairs(e), s = this.indexBy(t, "id"), n = [];
    for (let r = 0; r < i.length; r++) {
      const a = i[r], o = this.safeString(a, "id"), c = this.safeValue(s, o), u = this.deepExtend(c, a), [f, h] = o.split("_"), l = this.safeCurrencyCode(f), p = this.safeCurrencyCode(h), m = this.safeString(u, "fee"), y = this.safeString(u, "maker_fee_rate", m), w = this.parseNumber(this.parsePrecision(this.safeString(u, "amount_precision"))), S = this.safeString(u, "trade_status"), T = this.safeNumber(u, "leverage") !== void 0;
      n.push({
        id: o,
        symbol: l + "/" + p,
        base: l,
        quote: p,
        settle: void 0,
        baseId: f,
        quoteId: h,
        settleId: void 0,
        type: "spot",
        spot: !0,
        margin: T,
        swap: !1,
        future: !1,
        option: !1,
        active: S === "tradable",
        contract: !1,
        linear: void 0,
        inverse: void 0,
        // Fee is in %, so divide by 100
        taker: this.parseNumber(P.stringDiv(m, "100")),
        maker: this.parseNumber(P.stringDiv(y, "100")),
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: w,
          price: this.parseNumber(this.parsePrecision(this.safeString(u, "precision")))
        },
        limits: {
          leverage: {
            min: this.parseNumber("1"),
            max: this.safeNumber(u, "leverage", 1)
          },
          amount: {
            min: this.safeNumber(a, "min_base_amount", w),
            max: void 0
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.safeNumber(u, "min_quote_amount"),
            max: T ? this.safeNumber(u, "max_quote_amount") : void 0
          }
        },
        created: void 0,
        info: u
      });
    }
    return n;
  }
  async fetchContractMarkets(e = {}) {
    const t = [], i = this.getSettlementCurrencies("swap", "fetchMarkets"), s = this.getSettlementCurrencies("future", "fetchMarkets");
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = {
        settle: r
      }, o = await this.publicFuturesGetSettleContracts(this.extend(a, e));
      for (let c = 0; c < o.length; c++) {
        const u = this.parseContractMarket(o[c], r);
        t.push(u);
      }
    }
    for (let n = 0; n < s.length; n++) {
      const r = s[n], a = {
        settle: r
      }, o = await this.publicDeliveryGetSettleContracts(this.extend(a, e));
      for (let c = 0; c < o.length; c++) {
        const u = this.parseContractMarket(o[c], r);
        t.push(u);
      }
    }
    return t;
  }
  parseContractMarket(e, t) {
    const i = this.safeString(e, "name"), s = i.split("_"), n = this.safeString(s, 0), r = this.safeString(s, 1), a = this.safeString(s, 2), o = this.safeCurrencyCode(n), c = this.safeCurrencyCode(r), u = this.safeCurrencyCode(t), f = this.safeTimestamp(e, "expire_time");
    let h = "", l = "swap";
    a !== void 0 ? (h = o + "/" + c + ":" + u + "-" + this.yymmdd(f, ""), l = "future") : h = o + "/" + c + ":" + u;
    const p = this.safeString(e, "order_price_deviate"), m = this.safeString(e, "mark_price"), y = P.stringSub("1", p), w = P.stringAdd("1", p), S = P.stringMul(y, m), b = P.stringMul(w, m), T = this.safeString(e, "taker_fee_rate"), x = this.safeString(e, "maker_fee_rate", T), v = c === u;
    return {
      id: i,
      symbol: h,
      base: o,
      quote: c,
      settle: u,
      baseId: n,
      quoteId: r,
      settleId: t,
      type: l,
      spot: !1,
      margin: !1,
      swap: l === "swap",
      future: l === "future",
      option: l === "option",
      active: !0,
      contract: !0,
      linear: v,
      inverse: !v,
      taker: this.parseNumber(P.stringDiv(T, "100")),
      maker: this.parseNumber(P.stringDiv(x, "100")),
      contractSize: this.safeNumber(e, "quanto_multiplier"),
      expiry: f,
      expiryDatetime: this.iso8601(f),
      strike: void 0,
      optionType: void 0,
      precision: {
        amount: this.parseNumber("1"),
        price: this.safeNumber(e, "order_price_round")
      },
      limits: {
        leverage: {
          min: this.safeNumber(e, "leverage_min"),
          max: this.safeNumber(e, "leverage_max")
        },
        amount: {
          min: this.safeNumber(e, "order_size_min"),
          max: this.safeNumber(e, "order_size_max")
        },
        price: {
          min: this.parseNumber(S),
          max: this.parseNumber(b)
        },
        cost: {
          min: void 0,
          max: void 0
        }
      },
      created: void 0,
      info: e
    };
  }
  async fetchOptionMarkets(e = {}) {
    const t = [], i = await this.fetchOptionUnderlyings();
    for (let s = 0; s < i.length; s++) {
      const n = i[s], r = this.extend({}, e);
      r.underlying = n;
      const a = await this.publicOptionsGetContracts(r);
      for (let o = 0; o < a.length; o++) {
        const c = a[o], u = this.safeString(c, "name"), f = n.split("_"), h = this.safeString(f, 0), l = this.safeString(f, 1), p = this.safeCurrencyCode(h), m = this.safeCurrencyCode(l);
        let y = p + "/" + m;
        const w = this.safeTimestamp(c, "expiration_time"), S = this.safeString(c, "strike_price"), b = this.safeValue(c, "is_call"), T = b ? "C" : "P", x = b ? "call" : "put";
        y = y + ":" + m + "-" + this.yymmdd(w) + "-" + S + "-" + T;
        const v = this.safeString(c, "order_price_deviate"), _ = this.safeString(c, "mark_price"), V = P.stringSub("1", v), j = P.stringAdd("1", v), G = P.stringMul(V, _), W = P.stringMul(j, _), B = this.safeString(c, "taker_fee_rate"), Q = this.safeString(c, "maker_fee_rate", B);
        t.push({
          id: u,
          symbol: y,
          base: p,
          quote: m,
          settle: m,
          baseId: h,
          quoteId: l,
          settleId: l,
          type: "option",
          spot: !1,
          margin: !1,
          swap: !1,
          future: !1,
          option: !0,
          active: !0,
          contract: !0,
          linear: !0,
          inverse: !1,
          taker: this.parseNumber(P.stringDiv(B, "100")),
          maker: this.parseNumber(P.stringDiv(Q, "100")),
          contractSize: this.parseNumber("1"),
          expiry: w,
          expiryDatetime: this.iso8601(w),
          strike: S,
          optionType: x,
          precision: {
            amount: this.parseNumber("1"),
            price: this.safeNumber(c, "order_price_round")
          },
          limits: {
            leverage: {
              min: void 0,
              max: void 0
            },
            amount: {
              min: this.safeNumber(c, "order_size_min"),
              max: this.safeNumber(c, "order_size_max")
            },
            price: {
              min: this.parseNumber(G),
              max: this.parseNumber(W)
            },
            cost: {
              min: void 0,
              max: void 0
            }
          },
          created: this.safeTimestamp(c, "create_time"),
          info: c
        });
      }
    }
    return t;
  }
  async fetchOptionUnderlyings() {
    const e = await this.publicOptionsGetUnderlyings(), t = [];
    for (let i = 0; i < e.length; i++) {
      const s = e[i], n = this.safeString(s, "name");
      n !== void 0 && t.push(n);
    }
    return t;
  }
  prepareRequest(e = void 0, t = void 0, i = {}) {
    const s = {};
    if (e !== void 0)
      e.contract ? (s.contract = e.id, e.option || (s.settle = e.settleId)) : s.currency_pair = e.id;
    else {
      const n = t === "swap";
      if (n || t === "future") {
        const a = n ? "usdt" : "btc", o = this.safeStringLower(i, "settle", a);
        i = this.omit(i, "settle"), s.settle = o;
      }
    }
    return [s, i];
  }
  spotOrderPrepareRequest(e = void 0, t = !1, i = {}) {
    const [s, n] = this.getMarginMode(t, i), r = {};
    if (!t) {
      if (e === void 0)
        throw new g("spotOrderPrepareRequest() requires a market argument for non-stop orders").exchange(this.id);
      r.account = s, r.currency_pair = e.id;
    }
    return [r, n];
  }
  multiOrderSpotPrepareRequest(e = void 0, t = !1, i = {}) {
    const [s, n] = this.getMarginMode(t, i), r = {
      account: s
    };
    return e !== void 0 && (t ? r.market = e.id : r.currency_pair = e.id), [r, n];
  }
  getMarginMode(e, t) {
    const i = this.safeStringLower2(this.options, "defaultMarginMode", "marginMode", "spot");
    let s = this.safeStringLower2(t, "marginMode", "account", i);
    if (t = this.omit(t, ["marginMode", "account"]), s === "cross" ? s = "cross_margin" : s === "isolated" ? s = "margin" : s === "" && (s = "spot"), e && (s === "spot" && (s = "normal"), s === "cross_margin"))
      throw new O().addMessage("getMarginMode() does not support stop orders for cross margin").exchange(this.id);
    return [s, t];
  }
  getSettlementCurrencies(e, t) {
    const i = this.safeValue(this.options, e, {}), s = this.safeValue(i, t, {}), n = e === "swap" ? ["usdt"] : ["btc"];
    return this.safeValue(s, "settlementCurrencies", n);
  }
  async fetchCurrencies(e = {}) {
    if (this.safeValue(this.urls, "apiBackup") !== void 0)
      return;
    const i = await this.publicSpotGetCurrencies(e), s = {};
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "currency"), o = this.safeStringLower(r, "currency"), u = a.split("_")[0], f = this.safeCurrencyCode(u), h = this.safeString(r, "chain");
      let l;
      h !== void 0 && (l = this.networkIdToCode(h, f));
      const p = this.safeValue(r, "delisted"), m = this.safeBool(r, "withdraw_disabled", !1), y = this.safeBool(r, "deposit_disabled", !1), w = this.safeBool(r, "trade_disabled", !1), S = !m, b = !y, v = !p && !w && S && b;
      this.safeValue(s, f) === void 0 && (s[f] = {
        id: f.toLowerCase(),
        code: f,
        info: void 0,
        name: void 0,
        active: v,
        deposit: b,
        withdraw: S,
        fee: void 0,
        fees: [],
        precision: a === "BTC" ? this.parseNumber("1e-6") : this.parseNumber("1e-4"),
        limits: this.limits,
        networks: {}
      });
      let _ = this.safeValue(s[f], "deposit"), V = this.safeValue(s[f], "withdraw");
      _ = b || _, V = S || V;
      const j = this.safeValue(s[f], "networks", {});
      l !== void 0 && (j[l] = {
        info: r,
        id: h,
        network: l,
        currencyId: a,
        lowerCaseCurrencyId: o,
        deposit: b,
        withdraw: S,
        active: v,
        fee: void 0,
        precision: a === "BTC" ? this.parseNumber("1e-6") : this.parseNumber("1e-4"),
        limits: {
          amount: {
            min: void 0,
            max: void 0
          },
          withdraw: {
            min: void 0,
            max: void 0
          },
          deposit: {
            min: void 0,
            max: void 0
          }
        }
      }), s[f].networks = j;
      const G = this.safeValue(s[f], "info", []);
      G.push(r), s[f].info = G, s[f].active = _ && V, s[f].deposit = _, s[f].withdraw = V;
    }
    return s;
  }
  async fetchNetworkDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const s = {
      currency: this.currency(e).id
    }, n = await this.privateWalletGetDepositAddress(this.extend(s, t)), r = this.safeValue(n, "multichain_addresses"), a = this.safeString(n, "currency");
    e = this.safeCurrencyCode(a);
    const o = {};
    for (let c = 0; c < r.length; c++) {
      const u = r[c];
      if (this.safeInteger(u, "obtain_failed"))
        continue;
      const h = this.safeString(u, "chain"), l = this.safeString(u, "address"), p = this.safeString(u, "payment_id");
      o[h] = {
        info: u,
        code: e,
        currency: e,
        address: l,
        tag: p
      };
    }
    return o;
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const s = {
      currency: this.currency(e).id
    }, n = await this.privateWalletGetDepositAddress(this.extend(s, t)), r = this.safeString(n, "currency");
    e = this.safeCurrencyCode(r);
    let a, o;
    const c = this.safeString(t, "network");
    if (c !== void 0) {
      const u = this.safeValue(n, "multichain_addresses");
      for (let f = 0; f < u.length; f++) {
        const h = u[f], l = this.safeString(h, "chain");
        if (c === l) {
          if (this.safeInteger(h, "obtain_failed"))
            break;
          o = this.safeString(h, "address"), a = this.safeString(h, "payment_id");
          break;
        }
      }
    } else {
      const u = this.safeString(n, "address");
      if (u !== void 0) {
        if (u.indexOf("New address is being generated for you, please wait") >= 0)
          throw new It(e).overwriteMessage("New address is being generated for you, please wait a few seconds and try again to get the address.").exchange(this.id);
        if (u.indexOf(" ") >= 0) {
          const f = u.split(" ");
          o = f[0], a = f[1];
        } else
          o = u;
      }
    }
    return this.checkAddress(o), {
      info: n,
      code: e,
      currency: e,
      address: o,
      tag: a,
      network: c
    };
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      currency_pair: i.id
    }, n = await this.privateWalletGetFee(this.extend(s, t));
    return this.parseTradingFee(n, i);
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    const t = await this.privateWalletGetFee(e);
    return this.parseTradingFees(t);
  }
  parseTradingFees(e) {
    const t = {};
    for (let i = 0; i < this.symbols.length; i++) {
      const s = this.symbols[i], n = this.market(s);
      t[s] = this.parseTradingFee(e, n);
    }
    return t;
  }
  parseTradingFee(e, t = void 0) {
    const i = this.safeValue(e, "gt_discount"), s = i ? "gt_taker_fee" : "taker_fee", n = i ? "gt_maker_fee" : "maker_fee", r = this.safeValue(t, "contract"), a = r ? "futures_taker_fee" : s, o = r ? "futures_maker_fee" : n;
    return {
      info: e,
      symbol: this.safeString(t, "symbol"),
      maker: this.safeNumber(e, o),
      taker: this.safeNumber(e, a)
    };
  }
  async fetchTransactionFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.privateWalletGetWithdrawStatus(t), s = {};
    let n = {};
    for (let r = 0; r < i.length; r++) {
      n = {};
      const a = i[r], o = this.safeString(a, "currency"), c = this.safeCurrencyCode(o);
      if (e !== void 0 && !this.inArray(c, e))
        continue;
      const u = this.safeValue(a, "withdraw_fix_on_chains");
      if (u === void 0)
        n = this.safeNumber(a, "withdraw_fix");
      else {
        const f = Object.keys(u);
        for (let h = 0; h < f.length; h++) {
          const l = f[h];
          n[l] = this.parseNumber(u[l]);
        }
      }
      s[c] = {
        withdraw: n,
        deposit: void 0,
        info: a
      };
    }
    return s;
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.privateWalletGetWithdrawStatus(t);
    return this.parseDepositWithdrawFees(i, e, "currency");
  }
  parseDepositWithdrawFee(e, t = void 0) {
    const i = this.safeValue(e, "withdraw_fix_on_chains"), s = {
      info: e,
      withdraw: {
        fee: this.safeNumber(e, "withdraw_fix"),
        min: this.safeNumber(e, "withdraw_amount_mini"),
        percentage: !1
      },
      deposit: {
        fee: this.safeNumber(e, "deposit"),
        percentage: !1
      },
      networks: {}
    };
    if (i !== void 0) {
      const n = Object.keys(i);
      for (let r = 0; r < n.length; r++) {
        const a = n[r];
        s.networks[a] = {
          withdraw: {
            fee: this.parseNumber(i[a]),
            percentage: !1,
            min: this.safeNumber(e, "withdraw_amount_mini")
          },
          deposit: {
            fee: void 0,
            percentage: void 0
          }
        };
      }
    }
    return s;
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e), [n, r] = this.prepareRequest(s, s.type, i);
    t !== void 0 && (n.limit = t), n.with_id = !0;
    let a;
    if (s.spot || s.margin)
      a = await this.publicSpotGetOrderBook(this.extend(n, r));
    else if (s.swap)
      a = await this.publicFuturesGetSettleOrderBook(this.extend(n, r));
    else if (s.future)
      a = await this.publicDeliveryGetSettleOrderBook(this.extend(n, r));
    else if (s.option)
      a = await this.publicOptionsGetOrderBook(this.extend(n, r));
    else
      throw new ge(s.type).addMessage("fetchOrderBook() not support this market type").exchange(this.id);
    let o = this.safeInteger(a, "current");
    s.spot || (o = o * 1e3);
    const c = s.spot ? 0 : "p", u = s.spot ? 1 : "s", f = this.safeInteger(a, "id"), h = this.parseOrderBook(a, e, o, "bids", "asks", c, u);
    return h.nonce = f, h;
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), [s, n] = this.prepareRequest(i, void 0, t);
    let r;
    if (i.spot || i.margin)
      r = await this.publicSpotGetTickers(this.extend(s, n));
    else if (i.swap)
      r = await this.publicFuturesGetSettleTickers(this.extend(s, n));
    else if (i.future)
      r = await this.publicDeliveryGetSettleTickers(this.extend(s, n));
    else if (i.option) {
      const c = i.id.split("-");
      s.underlying = this.safeString(c, 0), r = await this.publicOptionsGetTickers(this.extend(s, n));
    } else
      throw new ge(i.type).exchange(this.id);
    let a;
    if (i.option)
      for (let o = 0; o < r.length; o++) {
        const c = r[o];
        if (c.name === i.id) {
          a = c;
          break;
        }
      }
    else
      a = this.safeValue(r, 0);
    return this.parseTicker(a, i);
  }
  parseTicker(e, t = void 0) {
    const i = this.safeStringN(e, ["currency_pair", "contract", "name"]), s = "mark_price" in e ? "contract" : "spot", n = this.safeSymbol(i, t, "_", s), r = this.safeString2(e, "last", "last_price"), a = this.safeStringN(e, ["lowest_ask", "a", "ask1_price"]), o = this.safeStringN(e, ["highest_bid", "b", "bid1_price"]), c = this.safeString(e, "high_24h"), u = this.safeString(e, "low_24h"), f = this.safeString2(e, "B", "bid1_size"), h = this.safeString2(e, "A", "ask1_size"), l = this.safeInteger(e, "t");
    let p = this.safeString2(e, "base_volume", "volume_24h_base");
    p === "nan" && (p = "0");
    let m = this.safeString2(e, "quote_volume", "volume_24h_quote");
    m === "nan" && (m = "0");
    const y = this.safeString(e, "change_percentage");
    return this.safeTicker({
      symbol: n,
      timestamp: l,
      datetime: this.iso8601(l),
      high: c,
      low: u,
      bid: o,
      bidVolume: f,
      ask: a,
      askVolume: h,
      vwap: void 0,
      open: void 0,
      close: r,
      last: r,
      previousClose: void 0,
      change: void 0,
      percentage: y,
      average: void 0,
      baseVolume: p,
      quoteVolume: m,
      info: e
    }, t);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = this.safeString(e, 0);
    let s;
    i !== void 0 && (s = this.market(i));
    const [n, r] = this.handleMarketTypeAndParams("fetchTickers", s, t), [a, o] = this.prepareRequest(void 0, n, r);
    let c;
    if (a.timezone = "utc0", n === "spot" || n === "margin")
      c = await this.publicSpotGetTickers(this.extend(a, o));
    else if (n === "swap")
      c = await this.publicFuturesGetSettleTickers(this.extend(a, o));
    else if (n === "future")
      c = await this.publicDeliveryGetSettleTickers(this.extend(a, o));
    else if (n === "option") {
      this.checkRequiredArgument("fetchTickers", e, "symbols");
      const f = s.id.split("-");
      a.underlying = this.safeString(f, 0), c = await this.publicOptionsGetTickers(this.extend(a, o));
    } else
      throw new ge(n).addMessage('fetchTickers() not support this market type, provide symbols or set params["defaultType"] to one from spot/margin/swap/future/options').exchange(this.id);
    return this.parseTickers(c, e);
  }
  parseBalanceHelper(e) {
    const t = this.account();
    return t.used = this.safeString2(e, "freeze", "locked"), t.free = this.safeString(e, "available"), t.total = this.safeString(e, "total"), "borrowed" in e && (t.debt = this.safeString(e, "borrowed")), t;
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const t = this.safeString(e, "symbol");
    e = this.omit(e, "symbol");
    const [i, s] = this.handleMarketTypeAndParams("fetchBalance", void 0, e), [n, r] = this.prepareRequest(void 0, i, s), [a, o] = this.getMarginMode(!1, r);
    if (t !== void 0) {
      const m = this.market(t);
      n.currency_pair = m.id;
    }
    let c;
    if (i === "spot")
      if (a === "spot")
        c = await this.privateSpotGetAccounts(this.extend(n, o));
      else if (a === "margin")
        c = await this.privateMarginGetAccounts(this.extend(n, o));
      else if (a === "cross_margin")
        c = await this.privateMarginGetCrossAccounts(this.extend(n, o));
      else
        throw new To().addMessage("fetchBalance() not support this marginMode").exchange(this.id);
    else if (i === "funding")
      c = await this.privateMarginGetFundingAccounts(this.extend(n, o));
    else if (i === "swap")
      c = await this.privateFuturesGetSettleAccounts(this.extend(n, o));
    else if (i === "future")
      c = await this.privateDeliveryGetSettleAccounts(this.extend(n, o));
    else if (i === "option")
      c = await this.privateOptionsGetAccounts(this.extend(n, o));
    else
      throw new ge(i).exchange(this.id);
    (i === "swap" || i === "future" || i === "option") && (c = [c]);
    const f = {
      info: c
    }, h = a === "margin";
    let l = c;
    if ("balances" in l) {
      const m = [], y = this.safeValue(l, "balances", []), w = Object.keys(y);
      for (let S = 0; S < w.length; S++) {
        const b = w[S], T = y[b];
        T.currency = b, m.push(T);
      }
      l = m;
    }
    for (let m = 0; m < l.length; m++) {
      const y = l[m];
      if (h) {
        const w = this.safeString(y, "currency_pair"), S = this.safeSymbol(w, void 0, "_", "margin"), b = this.safeValue(y, "base", {}), T = this.safeValue(y, "quote", {}), x = this.safeCurrencyCode(this.safeString(b, "currency")), v = this.safeCurrencyCode(this.safeString(T, "currency")), _ = {};
        _[x] = this.parseBalanceHelper(b), _[v] = this.parseBalanceHelper(T), f[S] = this.safeBalance(_);
      } else {
        const w = this.safeCurrencyCode(this.safeString(y, "currency"));
        f[w] = this.parseBalanceHelper(y);
      }
    }
    return h ? f : this.safeBalance(f);
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = this.market(e);
    let a = !1;
    if ([a, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), a)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 1e3);
    if (r.option)
      return await this.fetchOptionOHLCV(e, t, i, s, n);
    const o = this.safeString(n, "price");
    let c = {};
    [c, n] = this.prepareRequest(r, void 0, n), c.interval = this.safeString(this.timeframes, t, t);
    let u = 1e3;
    s = s === void 0 ? u : Math.min(s, u);
    let f = this.safeInteger(n, "until");
    if (f !== void 0 && (f = this.parseToInt(f / 1e3), n = this.omit(n, "until")), i !== void 0) {
      const l = this.parseTimeframe(t);
      c.from = this.parseToInt(i / 1e3);
      const p = (s - 1) * l, m = this.sum(c.from, p), y = this.seconds(), w = Math.min(m, y);
      f !== void 0 ? c.to = Math.min(w, f) : c.to = w;
    } else
      f !== void 0 && (c.to = f), c.limit = s;
    let h;
    return r.contract ? (u = 1999, (o === "mark" || o === "index") && (c.contract = o + "_" + r.id, n = this.omit(n, "price")), r.future ? h = await this.publicDeliveryGetSettleCandlesticks(this.extend(c, n)) : r.swap && (h = await this.publicFuturesGetSettleCandlesticks(this.extend(c, n)))) : h = await this.publicSpotGetCandlesticks(this.extend(c, n)), this.parseOHLCVs(h, r, t, i, s);
  }
  async fetchOptionOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = this.market(e);
    let a = {};
    [a, n] = this.prepareRequest(r, void 0, n), a.interval = this.safeString(this.timeframes, t, t);
    const o = await this.publicOptionsGetCandlesticks(this.extend(a, n));
    return this.parseOHLCVs(o, r, t, i, s);
  }
  parseOHLCV(e, t = void 0) {
    return Array.isArray(e) ? [
      this.safeTimestamp(e, 0),
      this.safeNumber(e, 5),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 2),
      this.safeNumber(e, 6)
      // trading volume
    ] : [
      this.safeTimestamp(e, "t"),
      this.safeNumber(e, "o"),
      this.safeNumber(e, "h"),
      this.safeNumber(e, "l"),
      this.safeNumber(e, "c"),
      this.safeNumber(e, "v")
      // trading volume, undefined for mark or index price
    ];
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchTrades", e, t, i, s);
    const r = this.market(e), [a, o] = this.prepareRequest(r, void 0, s), c = this.safeInteger2(s, "to", "until");
    c !== void 0 && (s = this.omit(s, ["until"]), a.to = this.parseToInt(c / 1e3)), i !== void 0 && (a.limit = Math.min(i, 1e3)), t !== void 0 && r.contract && (a.from = this.parseToInt(t / 1e3));
    let u;
    if (r.type === "spot" || r.type === "margin")
      u = await this.publicSpotGetTrades(this.extend(a, o));
    else if (r.swap)
      u = await this.publicFuturesGetSettleTrades(this.extend(a, o));
    else if (r.future)
      u = await this.publicDeliveryGetSettleTrades(this.extend(a, o));
    else if (r.type === "option")
      u = await this.publicOptionsGetTrades(this.extend(a, o));
    else
      throw new ge(r.type).exchange(this.id);
    return this.parseTrades(u, r, t, i);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    if (t === void 0)
      throw new g("fetchOrderTrades() requires a symbol argument").exchange(this.id);
    return await this.loadMarkets(), await this.fetchMyTrades(t, i, s, { order_id: e });
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchMyTrades", e, t, i, s);
    let r, a, o = {};
    const c = e !== void 0 ? this.market(e) : void 0, u = this.safeInteger2(s, "until", "till");
    s = this.omit(s, ["until", "till"]), [r, s] = this.handleMarketTypeAndParams("fetchMyTrades", c, s), r === "swap" || r === "future" || r === "option" ? ([o, s] = this.prepareRequest(c, r, s), r === "option" && (s = this.omit(s, "order_id"))) : (c !== void 0 && (o.currency_pair = c.id), [a, s] = this.getMarginMode(!1, s), o.account = a), i !== void 0 && (o.limit = i), t !== void 0 && (o.from = this.parseToInt(t / 1e3)), u !== void 0 && (o.to = this.parseToInt(u / 1e3));
    let h;
    if (r === "spot" || r === "margin")
      h = await this.privateSpotGetMyTrades(this.extend(o, s));
    else if (r === "swap")
      h = await this.privateFuturesGetSettleMyTradesTimerange(this.extend(o, s));
    else if (r === "future")
      h = await this.privateDeliveryGetSettleMyTrades(this.extend(o, s));
    else if (r === "option")
      h = await this.privateOptionsGetMyTrades(this.extend(o, s));
    else
      throw new ge(r).exchange(this.id);
    return this.parseTrades(h, c, t, i);
  }
  parseTrade(e, t = void 0) {
    const i = this.safeString2(e, "id", "trade_id");
    let s = this.safeTimestamp2(e, "time", "create_time");
    s = this.safeInteger(e, "create_time_ms", s);
    const n = this.safeString2(e, "currency_pair", "contract"), r = "contract" in e ? "contract" : "spot";
    t = this.safeMarket(n, t, "_", r);
    let a = this.safeString2(e, "amount", "size");
    const o = this.safeString(e, "price"), c = P.stringLt(a, "0") ? "sell" : "buy";
    a = P.stringAbs(a);
    const u = this.safeString2(e, "side", "type", c), f = this.safeString(e, "order_id"), h = this.safeString(e, "fee"), l = this.safeString(e, "gt_fee"), p = this.safeString(e, "point_fee"), m = [];
    if (h !== void 0) {
      const w = this.safeString(e, "fee_currency");
      let S = this.safeCurrencyCode(w);
      S === void 0 && (S = this.safeString(t, "settle")), m.push({
        cost: h,
        currency: S
      });
    }
    l !== void 0 && m.push({
      cost: l,
      currency: "GT"
    }), p !== void 0 && m.push({
      cost: p,
      currency: "GatePoint"
    });
    const y = this.safeString(e, "role");
    return this.safeTrade({
      info: e,
      id: i,
      timestamp: s,
      datetime: this.iso8601(s),
      symbol: t.symbol,
      order: f,
      type: void 0,
      side: u,
      takerOrMaker: y,
      price: o,
      amount: a,
      cost: void 0,
      fee: m.length ? m[0] : void 0,
      fees: m
    }, t);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchDeposits", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchDeposits", e, t, i, s);
    let r = {}, a;
    if (e !== void 0 && (a = this.currency(e), r.currency = a.id), i !== void 0 && (r.limit = i), t !== void 0) {
      const c = this.parseToInt(t / 1e3);
      r.from = c, r.to = this.sum(c, 30 * 24 * 60 * 60);
    }
    [r, s] = this.handleUntilOption("to", r, s);
    const o = await this.privateWalletGetDeposits(this.extend(r, s));
    return this.parseTransactions(o, a);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchWithdrawals", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchWithdrawals", e, t, i, s);
    let r = {}, a;
    if (e !== void 0 && (a = this.currency(e), r.currency = a.id), i !== void 0 && (r.limit = i), t !== void 0) {
      const c = this.parseToInt(t / 1e3);
      r.from = c, r.to = this.sum(c, 30 * 24 * 60 * 60);
    }
    [r, s] = this.handleUntilOption("to", r, s);
    const o = await this.privateWalletGetWithdrawals(this.extend(r, s));
    return this.parseTransactions(o, a);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), this.checkAddress(i), await this.loadMarkets();
    const r = this.currency(e), a = {
      currency: r.id,
      address: i
    };
    s !== void 0 && (a.memo = s);
    const o = this.safeValue(this.options, "networks", {});
    let c = this.safeStringUpper(n, "network");
    c = this.safeStringLower(o, c, c), c !== void 0 ? (a.chain = c, n = this.omit(n, "network")) : a.chain = r.id;
    const u = this.currencyToPrecision(e, t, c);
    a.amount = u;
    const f = await this.privateWithdrawalsPostWithdrawals(this.extend(a, n));
    return this.parseTransaction(f, r);
  }
  parseTransactionStatus(e) {
    const t = {
      PEND: "pending",
      REQUEST: "pending",
      DMOVE: "pending",
      MANUAL: "pending",
      VERIFY: "pending",
      PROCES: "pending",
      EXTPEND: "pending",
      SPLITPEND: "pending",
      CANCEL: "canceled",
      FAIL: "failed",
      INVALID: "failed",
      DONE: "ok",
      BCODE: "ok"
      // GateCode withdrawal
    };
    return this.safeString(t, e, e);
  }
  parseTransactionType(e) {
    const t = {
      d: "deposit",
      w: "withdrawal"
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString(e, "id");
    let s, n = this.safeString(e, "amount");
    i !== void 0 && (i[0] === "b" ? (s = P.stringGt(n, "0") ? "deposit" : "withdrawal", n = P.stringAbs(n)) : s = this.parseTransactionType(i[0]));
    const r = this.safeString(e, "fee");
    s === "withdrawal" && (n = P.stringSub(n, r));
    const a = this.safeStringUpper(e, "chain"), o = this.safeString(e, "currency"), c = this.safeCurrencyCode(o), u = this.safeString(e, "txid"), f = this.safeString(e, "status"), h = this.parseTransactionStatus(f), l = this.safeString(e, "address"), p = this.safeString(e, "memo"), m = this.safeTimestamp(e, "timestamp");
    return {
      info: e,
      id: i,
      txid: u,
      currency: c,
      amount: this.parseNumber(n),
      network: this.networkIdToCode(a),
      address: l,
      addressTo: void 0,
      addressFrom: void 0,
      tag: p,
      tagTo: void 0,
      tagFrom: void 0,
      status: h,
      type: s,
      timestamp: m,
      datetime: this.iso8601(m),
      updated: void 0,
      internal: void 0,
      comment: void 0,
      fee: {
        currency: c,
        cost: this.parseNumber(r)
      }
    };
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = this.safeValue(r, "trigger"), c = this.safeValue2(r, "triggerPrice", "stopPrice"), u = this.safeValue(r, "stopLossPrice", c), f = this.safeValue(r, "takeProfitPrice"), m = !(u !== void 0 || f !== void 0) && o === void 0, y = this.createOrderRequest(e, t, i, s, n, r);
    let w;
    return a.spot || a.margin ? m ? w = await this.privateSpotPostOrders(y) : w = await this.privateSpotPostPriceOrders(y) : a.swap ? m ? w = await this.privateFuturesPostSettleOrders(y) : w = await this.privateFuturesPostSettlePriceOrders(y) : a.future ? m ? w = await this.privateDeliveryPostSettleOrders(y) : w = await this.privateDeliveryPostSettlePriceOrders(y) : w = await this.privateOptionsPostOrders(y), this.parseOrder(w, a);
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [], s = [];
    for (let o = 0; o < e.length; o++) {
      const c = e[o], u = this.safeString(c, "symbol");
      s.push(u);
      const f = this.safeString(c, "type"), h = this.safeString(c, "side"), l = this.safeValue(c, "amount"), p = this.safeValue(c, "price"), m = this.safeValue(c, "params", {}), y = this.extend(m, t);
      if (this.safeValueN(m, ["triggerPrice", "stopPrice", "takeProfitPrice", "stopLossPrice"]) !== void 0)
        throw new g("createOrders() does not support advanced order properties (stopPrice, takeProfitPrice, stopLossPrice)").exchange(this.id);
      y.textIsRequired = !0;
      const S = this.createOrderRequest(u, f, h, l, p, y);
      i.push(S);
    }
    const n = this.marketSymbols(s, void 0, !1, !0, !0), r = this.market(n[0]);
    if (r.future || r.option)
      throw new ge(r.type).overwriteMessage("createOrders() does not support futures or options markets").exchange(this.id);
    let a;
    return r.spot ? a = await this.privateSpotPostBatchOrders(i) : r.swap && (a = await this.privateFuturesPostSettleBatchOrders(i)), this.parseOrders(a);
  }
  createOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.market(e), o = a.contract, c = this.safeValue(r, "trigger"), u = this.safeValue2(r, "triggerPrice", "stopPrice"), f = this.safeValue(r, "stopLossPrice", u), h = this.safeValue(r, "takeProfitPrice"), l = f !== void 0, p = h !== void 0, m = l || p;
    if (l && p)
      throw new g("createOrder() stopLossPrice and takeProfitPrice cannot both be defined").exchange(this.id);
    const y = this.safeValue(r, "reduceOnly"), w = this.safeStringLowerN(r, ["timeInForce", "tif", "time_in_force"]);
    let S;
    [S, r] = this.handlePostOnly(t === "market", w === "poc", r);
    let b = this.handleTimeInForce(r);
    S && (b = "poc"), r = this.omit(r, ["stopPrice", "triggerPrice", "stopLossPrice", "takeProfitPrice", "reduceOnly", "timeInForce", "postOnly"]);
    const T = t === "limit", x = t === "market";
    if (T && n === void 0)
      throw new g(" createOrder () requires a price argument for " + t + " orders").exchange(this.id);
    if (x) {
      if (b === "poc" || b === "gtc")
        throw new g('createOrder () timeInForce for market order can only be "FOK" or "IOC"').exchange(this.id);
      if (b === void 0) {
        const V = this.safeString(this.options, "defaultTimeInForce", "IOC");
        b = this.safeString(this.options.timeInForce, V, "ioc");
      }
      o && (n = 0);
    }
    if (o)
      if (this.safeValue(r, "close"))
        s = 0;
      else {
        const j = this.amountToPrecision(e, s), G = i === "sell" ? P.stringNeg(j) : j;
        s = parseInt(G);
      }
    let v;
    if (!m && c === void 0) {
      if (o)
        v = {
          contract: a.id,
          size: s
          // int64, positive = bid, negative = ask
          // 'iceberg': 0, // int64, display size for iceberg order, 0 for non-iceberg, note that you will have to pay the taker fee for the hidden size
          // 'close': false, // true to close the position, with size set to 0
          // 'reduce_only': false, // St as true to be reduce-only order
          // 'tif': 'gtc', // gtc, ioc, poc PendingOrCancelled == postOnly order
          // 'text': clientOrderId, // 't-abcdef1234567890',
          // 'auto_size': '', // close_long, close_short, note size also needs to be set to 0
        }, a.option || (v.settle = a.settleId), x ? v.price = n : v.price = this.priceToPrecision(e, n), y !== void 0 && (v.reduce_only = y), b !== void 0 && (v.tif = b);
      else {
        let G;
        if ([G, r] = this.getMarginMode(!1, r), v = {
          // 'text': clientOrderId, // 't-abcdef1234567890',
          currency_pair: a.id,
          type: t,
          account: G,
          side: i
          // 'time_in_force': 'gtc', // gtc, ioc, poc PendingOrCancelled == postOnly order
          // 'iceberg': 0, // amount to display for the iceberg order, null or 0 for normal orders, set to -1 to hide the order completely
          // 'auto_borrow': false, // used in margin or cross margin trading to allow automatic loan of insufficient amount if balance is not enough
          // 'auto_repay': false, // automatic repayment for automatic borrow loan generated by cross margin order, diabled by default
        }, x && i === "buy") {
          let W, B = !0;
          [B, r] = this.handleOptionAndParams(r, "createOrder", "createMarketBuyOrderRequiresPrice", !0);
          const Q = this.safeNumber(r, "cost");
          if (r = this.omit(r, "cost"), Q !== void 0)
            W = this.costToPrecision(e, Q);
          else if (B) {
            if (n === void 0)
              throw new g("createOrder() requires the price argument for market buy orders to calculate the total cost to spend (amount * price), alternatively set the createMarketBuyOrderRequiresPrice option or param to false and pass the cost to spend (quote quantity) in the amount argument").exchange(this.id);
            {
              const se = this.numberToString(s), $ = this.numberToString(n), te = P.stringMul(se, $);
              W = this.costToPrecision(e, te);
            }
          } else
            W = this.costToPrecision(e, s);
          v.amount = W;
        } else
          v.amount = this.amountToPrecision(e, s);
        T && (v.price = this.priceToPrecision(e, n)), b !== void 0 && (v.time_in_force = b);
      }
      let V = this.safeString2(r, "text", "clientOrderId");
      const j = this.safeBool(r, "textIsRequired", !1);
      if (V !== void 0) {
        if (V.length > 28)
          throw new g("createOrder () clientOrderId or text param must be up to 28 characters").exchange(this.id);
        r = this.omit(r, ["text", "clientOrderId", "textIsRequired"]), V[0] !== "t" && (V = "t-" + V), v.text = V;
      } else
        j && (v.text = "t-" + this.uuid16());
    } else {
      if (a.option)
        throw new ge("option").addMessage("createOrder() conditional option orders are not supported").exchange(this.id);
      if (o) {
        if (v = {
          initial: {
            contract: a.id,
            size: s,
            price: this.priceToPrecision(e, n)
            // set to 0 to use market price
            // 'close': false, // set to true if trying to close the position
            // 'tif': 'gtc', // gtc, ioc, if using market price, only ioc is supported
            // 'text': clientOrderId, // web, api, app
            // 'reduce_only': false,
          },
          settle: a.settleId
        }, c === void 0) {
          let V, j;
          l ? (V = i === "buy" ? 1 : 2, j = this.priceToPrecision(e, f)) : p && (V = i === "buy" ? 2 : 1, j = this.priceToPrecision(e, h));
          const G = this.safeInteger(r, "price_type", 0);
          if (G < 0 || G > 2)
            throw new g(this.id + " createOrder () price_type should be 0 latest deal price, 1 mark price, 2 index price").exchange(this.id);
          r = this.omit(r, ["price_type"]), v.trigger = {
            // 'strategy_type': 0, // 0 = by price, 1 = by price gap, only 0 is supported currently
            price_type: G,
            price: this.priceToPrecision(e, j),
            rule: V
            // 1 means price_type >= price, 2 means price_type <= price
            // 'expiration': expiration, how many seconds to wait for the condition to be triggered before cancelling the order
          };
        }
        y !== void 0 && (v.initial.reduce_only = y), b !== void 0 && (v.initial.tif = b);
      } else {
        const V = this.safeValue(this.options, "createOrder", {});
        let j;
        if ([j, r] = this.getMarginMode(!0, r), b === void 0 && (b = "gtc"), v = {
          put: {
            type: t,
            side: i,
            price: this.priceToPrecision(e, n),
            amount: this.amountToPrecision(e, s),
            account: j,
            time_in_force: b
            // gtc, ioc (ioc is for taker only, so shouldnt't be in conditional order)
          },
          market: a.id
        }, c === void 0) {
          const G = this.safeInteger(V, "expiration"), W = this.safeInteger(r, "expiration", G);
          let B, Q;
          l ? (B = i === "buy" ? ">=" : "<=", Q = this.priceToPrecision(e, f)) : p && (B = i === "buy" ? "<=" : ">=", Q = this.priceToPrecision(e, h)), v.trigger = {
            price: this.priceToPrecision(e, Q),
            rule: B,
            expiration: W
            // required, how long (in seconds) to wait for the condition to be triggered before cancelling the order
          };
        }
      }
    }
    return this.extend(v, r);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("createMarketBuyOrderWithCost() supports spot orders only").exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t), [c, u] = this.handleMarketTypeAndParams("editOrder", o, a), f = this.convertTypeToAccount(c);
    if (f === "spot" && !(i === "limit"))
      throw new ge(c).addMessage("editOrder() does not support " + i + " orders for " + c + " markets").exchange(this.id);
    const l = {
      order_id: e,
      currency_pair: o.id,
      account: f
    };
    n !== void 0 && (l.amount = this.amountToPrecision(t, n)), r !== void 0 && (l.price = this.priceToPrecision(t, r));
    let p;
    return o.spot ? p = await this.privateSpotPatchOrdersOrderId(this.extend(l, u)) : (l.settle = o.settleId, p = await this.privateFuturesPutSettleOrdersOrderId(this.extend(l, u))), this.parseOrder(p, o);
  }
  parseOrderStatus(e) {
    const t = {
      open: "open",
      _new: "open",
      filled: "closed",
      cancelled: "canceled",
      liquidated: "closed",
      ioc: "canceled",
      failed: "canceled",
      expired: "canceled",
      finished: "closed",
      succeeded: "closed"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    if (!this.safeBool(e, "succeeded", !0))
      return this.safeOrder({
        clientOrderId: this.safeString(e, "text"),
        info: e,
        status: "rejected"
      });
    const s = this.safeValue2(e, "put", "initial", {}), n = this.safeValue(e, "trigger", {});
    let r = this.safeString(s, "contract"), a = this.safeString(s, "type"), o = this.safeStringUpper2(s, "time_in_force", "tif"), c = this.safeString2(s, "amount", "size"), u = this.safeString(s, "side"), f = this.safeString(s, "price");
    r = this.safeString(e, "contract", r), a = this.safeString(e, "type", a), o = this.safeStringUpper2(e, "time_in_force", "tif", o), o === "POC" && (o = "PO");
    const h = o === "PO";
    c = this.safeString2(e, "amount", "size", c), u = this.safeString(e, "side", u), f = this.safeString(e, "price", f);
    let l = this.safeString(e, "left"), p = this.safeString(e, "filled_total");
    const m = this.safeNumber(n, "price");
    let y = this.safeNumber2(e, "avg_deal_price", "fill_price");
    m && (l = c, p = "0"), r && (a = P.stringEquals(f, "0") && o === "IOC" ? "market" : "limit", u = P.stringGt(c, "0") ? "buy" : "sell");
    const w = this.safeStringN(e, ["finish_as", "status", "open"]);
    let S = this.safeInteger(e, "create_time_ms");
    S === void 0 && (S = this.safeTimestamp2(e, "create_time", "ctime"));
    let b = this.safeInteger(e, "update_time_ms");
    b === void 0 && (b = this.safeTimestamp2(e, "update_time", "finish_time"));
    const T = "currency_pair" in e ? "spot" : "contract", x = this.safeString2(e, "currency_pair", "market", r), v = this.safeSymbol(x, t, "_", T), _ = [], V = this.safeString(e, "gt_fee");
    V && _.push({
      currency: "GT",
      cost: V
    });
    const j = this.safeString(e, "fee");
    j && _.push({
      currency: this.safeCurrencyCode(this.safeString(e, "fee_currency")),
      cost: j
    });
    const G = this.safeString(e, "rebated_fee");
    G && _.push({
      currency: this.safeCurrencyCode(this.safeString(e, "rebated_fee_currency")),
      cost: P.stringNeg(G)
    });
    const B = _.length > 1, Q = this.parseOrderStatus(w);
    let se = P.stringAbs(l);
    if (this.safeString(e, "account") === "spot") {
      const te = this.safeString(e, "avg_deal_price");
      if (y = this.parseNumber(te), a === "market" && u === "buy") {
        const E = this.safeString2(e, "filled_total", "amount");
        se = P.stringDiv(l, te), f = void 0, p = E, c = P.stringDiv(E, te);
      }
    }
    return this.safeOrder({
      id: this.safeString(e, "id"),
      clientOrderId: this.safeString(e, "text"),
      timestamp: S,
      datetime: this.iso8601(S),
      lastTradeTimestamp: b,
      status: Q,
      symbol: v,
      type: a,
      timeInForce: o,
      postOnly: h,
      reduceOnly: this.safeValue(e, "is_reduce_only"),
      side: u,
      price: f,
      stopPrice: m,
      triggerPrice: m,
      average: y,
      amount: P.stringAbs(c),
      cost: P.stringAbs(p),
      filled: void 0,
      remaining: se,
      fee: B ? void 0 : this.safeValue(_, 0),
      fees: B ? _ : [],
      trades: void 0,
      info: e
    }, t);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.safeValue2(i, "is_stop_order", "stop", !1);
    i = this.omit(i, ["is_stop_order", "stop"]);
    let n = this.safeString2(i, "text", "clientOrderId"), r = e;
    n !== void 0 && (i = this.omit(i, ["text", "clientOrderId"]), n[0] !== "t" && (n = "t-" + n), r = n);
    const a = t === void 0 ? void 0 : this.market(t), [o, c] = this.handleMarketTypeAndParams("fetchOrder", a, i), u = o === "swap" || o === "future" || o === "option", [f, h] = u ? this.prepareRequest(a, o, c) : this.spotOrderPrepareRequest(a, s, c);
    f.order_id = r;
    let l;
    if (o === "spot" || o === "margin")
      s ? l = await this.privateSpotGetPriceOrdersOrderId(this.extend(f, h)) : l = await this.privateSpotGetOrdersOrderId(this.extend(f, h));
    else if (o === "swap")
      s ? l = await this.privateFuturesGetSettlePriceOrdersOrderId(this.extend(f, h)) : l = await this.privateFuturesGetSettleOrdersOrderId(this.extend(f, h));
    else if (o === "future")
      s ? l = await this.privateDeliveryGetSettlePriceOrdersOrderId(this.extend(f, h)) : l = await this.privateDeliveryGetSettleOrdersOrderId(this.extend(f, h));
    else if (o === "option")
      l = await this.privateOptionsGetOrdersOrderId(this.extend(f, h));
    else
      throw new ge(o).exchange(this.id);
    return this.parseOrder(l, a);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchOrdersByStatus("open", e, t, i, s);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchOrdersByStatus("finished", e, t, i, s);
  }
  async fetchOrdersByStatus(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r;
    t !== void 0 && (r = this.market(t), t = r.symbol);
    const a = this.safeValue(n, "stop");
    n = this.omit(n, "stop");
    const [o, c] = this.handleMarketTypeAndParams("fetchOrdersByStatus", r, n), u = o === "spot" || o === "margin", [f, h] = u ? this.multiOrderSpotPrepareRequest(r, a, c) : this.prepareRequest(r, o, c);
    e === "closed" && (e = "finished"), f.status = e, s !== void 0 && (f.limit = s), i !== void 0 && u && (f.from = this.parseToInt(i / 1e3));
    const l = u && e === "open" && !a;
    let p;
    if (o === "spot" || o === "margin")
      l ? p = await this.privateSpotGetOpenOrders(this.extend(f, h)) : a ? p = await this.privateSpotGetPriceOrders(this.extend(f, h)) : p = await this.privateSpotGetOrders(this.extend(f, h));
    else if (o === "swap")
      a ? p = await this.privateFuturesGetSettlePriceOrders(this.extend(f, h)) : p = await this.privateFuturesGetSettleOrders(this.extend(f, h));
    else if (o === "future")
      a ? p = await this.privateDeliveryGetSettlePriceOrders(this.extend(f, h)) : p = await this.privateDeliveryGetSettleOrders(this.extend(f, h));
    else if (o === "option")
      p = await this.privateOptionsGetOrders(this.extend(f, h));
    else
      throw new ge(o).exchange(this.id);
    let m = p;
    if (l) {
      m = [];
      for (let w = 0; w < p.length; w++) {
        const S = this.safeValue(p[w], "orders");
        m = this.arrayConcat(m, S);
      }
    }
    const y = this.parseOrders(m, r, i, s);
    return this.filterBySymbolSinceLimit(y, t, i, s);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = t === void 0 ? void 0 : this.market(t), n = this.safeValue2(i, "is_stop_order", "stop", !1);
    i = this.omit(i, ["is_stop_order", "stop"]);
    const [r, a] = this.handleMarketTypeAndParams("cancelOrder", s, i), [o, c] = r === "spot" || r === "margin" ? this.spotOrderPrepareRequest(s, n, a) : this.prepareRequest(s, r, a);
    o.order_id = e;
    let u;
    if (r === "spot" || r === "margin")
      n ? u = await this.privateSpotDeletePriceOrdersOrderId(this.extend(o, c)) : u = await this.privateSpotDeleteOrdersOrderId(this.extend(o, c));
    else if (r === "swap")
      n ? u = await this.privateFuturesDeleteSettlePriceOrdersOrderId(this.extend(o, c)) : u = await this.privateFuturesDeleteSettleOrdersOrderId(this.extend(o, c));
    else if (r === "future")
      n ? u = await this.privateDeliveryDeleteSettlePriceOrdersOrderId(this.extend(o, c)) : u = await this.privateDeliveryDeleteSettleOrdersOrderId(this.extend(o, c));
    else if (r === "option")
      u = await this.privateOptionsDeleteOrdersOrderId(this.extend(o, c));
    else
      throw new ge(r).exchange(this.id);
    return this.parseOrder(u, s);
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = e === void 0 ? void 0 : this.market(e), s = this.safeValue(t, "stop");
    t = this.omit(t, "stop");
    const [n, r] = this.handleMarketTypeAndParams("cancelAllOrders", i, t), [a, o] = n === "spot" ? this.multiOrderSpotPrepareRequest(i, s, r) : this.prepareRequest(i, n, r);
    let c;
    if (n === "spot" || n === "margin")
      s ? c = await this.privateSpotDeletePriceOrders(this.extend(a, o)) : c = await this.privateSpotDeleteOrders(this.extend(a, o));
    else if (n === "swap")
      s ? c = await this.privateFuturesDeleteSettlePriceOrders(this.extend(a, o)) : c = await this.privateFuturesDeleteSettleOrders(this.extend(a, o));
    else if (n === "future")
      s ? c = await this.privateDeliveryDeleteSettlePriceOrders(this.extend(a, o)) : c = await this.privateDeliveryDeleteSettleOrders(this.extend(a, o));
    else if (n === "option")
      c = await this.privateOptionsDeleteOrders(this.extend(a, o));
    else
      throw new ge(n).exchange(this.id);
    return this.parseOrders(c, i);
  }
  // https://www.gate.io/docs/developers/apiv4/#retrieve-sub-account-balances
  async fetchSubAccountBalances(e, t = {}) {
    await this.loadMarkets();
    const i = await this.privateWalletGetSubAccountBalances({
      sub_uid: e
    }), s = {}, n = this.safeValue(i, 0), r = this.safeValue(n, "available", {}), a = Object.keys(r);
    for (let o = 0; o < a.length; o++) {
      const c = a[o], u = this.safeCurrencyCode(c);
      s[u] = {
        free: this.safeString(r, c),
        used: "0",
        total: this.safeString(r, c)
      };
    }
    return { spot: s };
  }
  // https://www.gate.io/docs/developers/apiv4/#list-sub-accounts
  async getSubAccounts() {
    return await this.loadMarkets(), (await this.privateSubAccountsGetSubAccounts()).map((t) => ({
      uid: t.user_id
    }));
  }
  // https://www.gate.io/docs/developers/apiv4/#sub-account-transfers-to-sub-account
  // https://www.gate.io/docs/developers/apiv4/#transfer-between-main-and-sub-accounts
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    await this.loadMarkets();
    const o = this.currency(e), c = this.convertTypeToAccount(i), u = this.convertTypeToAccount(s), f = this.currencyToPrecision(e, t), h = n === "master" ? "to" : "from", l = {
      currency: o.id,
      amount: f,
      fromAccountType: c,
      toAccountType: u,
      direction: h
    };
    n !== "master" && (l.sub_account = n, l.sub_account_type = c), r !== "master" && (l.sub_account = r, l.sub_account_type = u), "clientOid" in a || (l.clientOid = this.uuid());
    const p = await this.privateWalletPostSubAccountTransfers(this.extend(l, a)), m = this.parseTransfer(p, o);
    return this.extend(m, {
      amount: f,
      fromAccount: n,
      toAccount: r
    });
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = this.convertTypeToAccount(i), o = this.convertTypeToAccount(s), c = this.currencyToPrecision(e, t), u = {
      currency: r.id,
      amount: c
    };
    if (a in this.options.accountsByType ? u.from = a : (u.from = "margin", u.currency_pair = a), o in this.options.accountsByType ? u.to = o : (u.to = "margin", u.currency_pair = o), a === "margin" || o === "margin") {
      const h = this.safeString2(n, "symbol", "currency_pair");
      if (h === void 0)
        throw new g('transfer requires params["symbol"] for isolated margin transfers').exchange(this.id);
      const l = this.market(h);
      u.currency_pair = l.id, n = this.omit(n, "symbol");
    }
    (o === "futures" || o === "delivery" || a === "futures" || a === "delivery") && (u.settle = r.id);
    const f = await this.privateWalletPostTransfers(this.extend(u, n));
    return this.parseTransfer(f, r);
  }
  parseTransfer(e, t = void 0) {
    return {
      id: this.safeString(e, "tx_id"),
      timestamp: void 0,
      datetime: void 0,
      currency: this.safeCurrencyCode(void 0, t),
      amount: void 0,
      fromAccount: void 0,
      toAccount: void 0,
      status: void 0,
      info: e
    };
  }
  async fetchPosition(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e);
    if (!i.contract)
      throw new ge(i.type).addMessage("fetchPosition() supports contract markets only").exchange(this.id);
    let s = {};
    [s, t] = this.prepareRequest(i, i.type, t);
    const n = this.extend(s, t);
    let r;
    return i.swap ? r = await this.privateFuturesGetSettlePositionsContract(n) : i.future ? r = await this.privateDeliveryGetSettlePositionsContract(n) : i.type === "option" && (r = await this.privateOptionsGetPositionsContract(n)), this.parsePosition(r, i);
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets();
    let i;
    e = this.marketSymbols(e, void 0, !0, !0, !0), e !== void 0 && e.length > 0 && (i = this.market(e[0]));
    let s, n = {};
    if ([s, t] = this.handleMarketTypeAndParams("fetchPositions", i, t), (s === void 0 || s === "spot") && (s = "swap"), s === "option") {
      if (e !== void 0) {
        const o = i.id.split("-");
        n.underlying = this.safeString(o, 0);
      }
    } else
      [n, t] = this.prepareRequest(void 0, s, t);
    let r;
    return s === "swap" ? r = await this.privateFuturesGetSettlePositions(this.extend(n, t)) : s === "future" ? r = await this.privateDeliveryGetSettlePositions(this.extend(n, t)) : s === "option" && (r = await this.privateOptionsGetPositions(this.extend(n, t))), this.parsePositions(r, e);
  }
  parseMarginLoan(e, t = void 0) {
    const i = this.safeString2(this.options, "defaultMarginMode", "marginMode", "cross");
    let s = this.safeInteger(e, "create_time");
    i === "isolated" && (s = this.safeTimestamp(e, "create_time"));
    const n = this.safeString(e, "currency"), r = this.safeString(e, "currency_pair");
    return {
      id: this.safeInteger(e, "id"),
      currency: this.safeCurrencyCode(n, t),
      amount: this.safeNumber(e, "amount"),
      symbol: this.safeSymbol(r, void 0, "_", "margin"),
      timestamp: s,
      datetime: this.iso8601(s),
      info: e
    };
  }
  async sign(e, t = [], i = "GET", s = {}, n = void 0, r = void 0) {
    const a = t[0], o = t[1];
    let c = this.omit(s, this.extractParams(e));
    if (Array.isArray(s)) {
      const l = this.safeValue(s, 0, {});
      e = this.implodeParams(e, l);
    } else
      e = this.implodeParams(e, s);
    const u = e === "" ? "" : "/" + e;
    let f = "/" + o + u;
    (o === "subAccounts" || o === "withdrawals") && (f = u);
    let h = this.urls.api[a][o];
    if (h === void 0)
      throw new be().addMessage("It does not have a testnet for the " + o + " market type.").exchange(this.id);
    if (h += f, a === "public")
      Object.keys(c).length && (h += "?" + this.urlencode(c));
    else {
      this.checkRequiredCredentials();
      let l = "", p = !1;
      if ((o === "futures" || o === "delivery") && i === "POST") {
        const v = e.split("/"), _ = this.safeString(v, 1, "");
        p = _.indexOf("dual") >= 0 || _.indexOf("positions") >= 0;
      }
      if (i === "GET" || i === "DELETE" || p || i === "PATCH")
        Object.keys(c).length && (l = this.urlencode(c), h += "?" + l), i === "PATCH" && (r = this.json(c));
      else {
        const v = this.safeValue(c, "query", {});
        Object.keys(v).length && (l = this.urlencode(v), h += "?" + l), c = this.omit(c, "query"), r = this.json(c);
      }
      const m = r === void 0 ? "" : r, y = this.hash(this.encode(m), Ss), w = this.nonce().toString(), S = "/api/" + this.version + f, T = [i.toUpperCase(), S, l, y, w].join(`
`);
      let x;
      this.externalSigner ? x = await this.externalSigner.sign({
        payload: this.encode(T),
        publicApiKey: this.apiKey,
        exchangeId: this.id
      }) : x = this.hmac(this.encode(T), this.encode(this.secret), Ss), n = {
        KEY: this.apiKey,
        Timestamp: w,
        SIGN: x,
        "Content-Type": "application/json"
      };
    }
    return { url: h, method: i, body: r, headers: n };
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchLedger", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchLedger", e, t, i, s);
    let r, a, o, c = {};
    if ([r, s] = this.handleMarketTypeAndParams("fetchLedger", void 0, s), (r === "spot" || r === "margin") && e !== void 0 && (a = this.currency(e), c.currency = a.id), r === "swap" || r === "future") {
      const u = r === "swap" ? "usdt" : "btc", f = this.safeStringLower(s, "settle", u);
      s = this.omit(s, "settle"), c.settle = f;
    }
    return t !== void 0 && (c.from = t), i !== void 0 && (c.limit = i), [c, s] = this.handleUntilOption("to", c, s), r === "spot" ? o = await this.privateSpotGetAccountBook(this.extend(c, s)) : r === "margin" ? o = await this.privateMarginGetAccountBook(this.extend(c, s)) : r === "swap" ? o = await this.privateFuturesGetSettleAccountBook(this.extend(c, s)) : r === "future" ? o = await this.privateDeliveryGetSettleAccountBook(this.extend(c, s)) : r === "option" && (o = await this.privateOptionsGetAccountBook(this.extend(c, s))), this.parseLedger(o, a, t, i);
  }
  parseLedgerEntry(e, t = void 0) {
    let i, s = this.safeString(e, "change");
    P.stringLt(s, "0") ? (i = "out", s = P.stringAbs(s)) : i = "in";
    const n = this.safeString(e, "currency"), r = this.safeString(e, "type"), a = this.safeString(e, "time");
    let o;
    a.length > 10 ? o = parseInt(a) : o = parseInt(a) * 1e3;
    const c = this.safeString(e, "balance"), u = this.safeString(e, "change"), f = this.parseNumber(P.stringSub(c, u));
    return {
      id: this.safeString(e, "id"),
      direction: i,
      account: void 0,
      referenceAccount: void 0,
      referenceId: void 0,
      type: this.parseLedgerEntryType(r),
      currency: this.safeCurrencyCode(n, t),
      amount: this.parseNumber(s),
      timestamp: o,
      datetime: this.iso8601(o),
      before: f,
      after: this.safeNumber(e, "balance"),
      status: void 0,
      fee: void 0,
      info: e
    };
  }
  parseLedgerEntryType(e) {
    const t = {
      deposit: "deposit",
      withdraw: "withdrawal",
      sub_account_transfer: "transfer",
      margin_in: "transfer",
      margin_out: "transfer",
      margin_funding_in: "transfer",
      margin_funding_out: "transfer",
      cross_margin_in: "transfer",
      cross_margin_out: "transfer",
      copy_trading_in: "transfer",
      copy_trading_out: "transfer",
      quant_in: "transfer",
      quant_out: "transfer",
      futures_in: "transfer",
      futures_out: "transfer",
      delivery_in: "transfer",
      delivery_out: "transfer",
      new_order: "trade",
      order_fill: "trade",
      referral_fee: "rebate",
      order_fee: "fee",
      interest: "interest",
      lend: "loan",
      redeem: "loan",
      profit: "interest",
      flash_swap_buy: "trade",
      flash_swap_sell: "trade",
      unknown: "unknown",
      set: "settlement",
      prem: "trade",
      point_refr: "rebate",
      point_fee: "fee",
      point_dnw: "deposit/withdraw",
      fund: "fee",
      refr: "rebate",
      fee: "fee",
      pnl: "trade",
      dnw: "deposit/withdraw"
    };
    return this.safeString(t, e, e);
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (a === void 0)
      return;
    const u = this.safeString(a, "label");
    if (u !== void 0) {
      const f = this.safeString(a, "message"), h = u + ": " + f;
      throw this.throwBroadlyMatchedException(this.exceptions.broad, h, h), this.throwExactlyMatchedException(this.exceptions.exact, u, h), new O().addMessage(h).exchange(this.id);
    }
  }
}
class tw extends Eu {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "gateio",
      alias: !0
    });
  }
}
let iw = class extends gt {
};
class sw extends iw {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "htx",
      name: "HTX",
      countries: ["CN"],
      rateLimit: 100,
      userAgent: this.userAgents.chrome100,
      certified: !0,
      version: "v1",
      hostname: "api.huobi.pro",
      pro: !0,
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !0,
        option: void 0,
        cancelAllOrders: !0,
        cancelOrder: !0,
        cancelOrders: !0,
        createDepositAddress: void 0,
        createMarketBuyOrderWithCost: !0,
        createMarketOrderWithCost: !1,
        createMarketSellOrderWithCost: !1,
        createOrder: !0,
        createOrders: !0,
        createTakeProfitOrder: !0,
        createTrailingPercentOrder: !0,
        createTriggerOrder: !0,
        fetchAccounts: !0,
        fetchBalance: !0,
        fetchCanceledOrders: void 0,
        fetchClosedOrder: void 0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDeposit: void 0,
        fetchDepositAddress: !0,
        fetchDepositAddresses: void 0,
        fetchDepositAddressesByNetwork: !0,
        fetchDeposits: !0,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchLedgerEntry: void 0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrder: void 0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrderBooks: void 0,
        fetchOrders: !0,
        fetchOrderTrades: !0,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchPositionsRisk: !1,
        fetchStatus: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !1,
        fetchTradingLimits: !0,
        fetchTransactionFee: void 0,
        fetchTransactionFees: void 0,
        fetchTransactions: void 0,
        fetchTransfers: void 0,
        fetchWithdrawAddresses: !0,
        fetchWithdrawal: void 0,
        fetchWithdrawals: !0,
        fetchWithdrawalWhitelist: void 0,
        transfer: !0,
        withdraw: !0
      },
      timeframes: {
        "1m": "1min",
        "5m": "5min",
        "15m": "15min",
        "30m": "30min",
        "1h": "60min",
        "4h": "4hour",
        "1d": "1day",
        "1w": "1week",
        "1M": "1mon",
        "1y": "1year"
      },
      urls: {
        // 'test': {
        //     'market': 'https://api.testnet.huobi.pro',
        //     'public': 'https://api.testnet.huobi.pro',
        //     'private': 'https://api.testnet.huobi.pro',
        // },
        logo: "https://user-images.githubusercontent.com/1294454/76137448-22748a80-604e-11ea-8069-6e389271911d.jpg",
        hostnames: {
          contract: "api.hbdm.com",
          spot: "api.huobi.pro",
          status: {
            spot: "status.huobigroup.com",
            future: {
              inverse: "status-dm.huobigroup.com",
              linear: "status-linear-swap.huobigroup.com"
              // USDT-Margined Contracts
            },
            swap: {
              inverse: "status-swap.huobigroup.com",
              linear: "status-linear-swap.huobigroup.com"
              // USDT-Margined Contracts
            }
          }
          // recommended for AWS
          // 'contract': 'api.hbdm.vn',
          // 'spot': 'api-aws.huobi.pro',
        },
        api: {
          status: "https://{hostname}",
          contract: "https://{hostname}",
          spot: "https://{hostname}",
          public: "https://{hostname}",
          private: "https://{hostname}",
          v2Public: "https://{hostname}",
          v2Private: "https://{hostname}"
        },
        www: "https://www.huobi.com",
        referral: {
          // https://www.huobi.com/en-us/v/register/double-invite/?inviter_id=11343840&invite_code=6rmm2223 - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
          url: "https://www.huobi.com/en-us/v/register",
          discount: 0.15
        },
        doc: [
          "https://huobiapi.github.io/docs/spot/v1/en/",
          "https://huobiapi.github.io/docs/dm/v1/en/",
          "https://huobiapi.github.io/docs/coin_margined_swap/v1/en/",
          "https://huobiapi.github.io/docs/usdt_swap/v1/en/",
          "https://www.huobi.com/en-us/opend/newApiPages/"
        ],
        fees: "https://www.huobi.com/about/fee/"
      },
      api: {
        // ------------------------------------------------------------
        // old api definitions
        v2Public: {
          get: {
            "reference/currencies": 1,
            "market-status": 1
            // 获取当前市场状态
          }
        },
        v2Private: {
          get: {
            "account/ledger": 1,
            "account/withdraw/quota": 1,
            "account/withdraw/address": 1,
            "account/deposit/address": 1,
            "account/repayment": 5,
            "reference/transact-fee-rate": 1,
            "account/asset-valuation": 0.2,
            "point/account": 5,
            "sub-user/user-list": 1,
            "sub-user/user-state": 1,
            "sub-user/account-list": 1,
            "sub-user/deposit-address": 1,
            "sub-user/query-deposit": 1,
            "user/api-key": 1,
            "user/uid": 1,
            "algo-orders/opening": 1,
            "algo-orders/history": 1,
            "algo-orders/specific": 1,
            "c2c/offers": 1,
            "c2c/offer": 1,
            "c2c/transactions": 1,
            "c2c/repayment": 1,
            "c2c/account": 1,
            "etp/reference": 1,
            "etp/transactions": 5,
            "etp/transaction": 5,
            "etp/rebalance": 1,
            "etp/limit": 1
            // 获取ETP持仓限额
          },
          post: {
            "account/transfer": 1,
            "account/repayment": 5,
            "point/transfer": 5,
            "sub-user/management": 1,
            "sub-user/creation": 1,
            "sub-user/tradable-market": 1,
            "sub-user/transferability": 1,
            "sub-user/api-key-generation": 1,
            "sub-user/api-key-modification": 1,
            "sub-user/api-key-deletion": 1,
            "sub-user/deduct-mode": 1,
            "algo-orders": 1,
            "algo-orders/cancel-all-after": 1,
            "algo-orders/cancellation": 1,
            "c2c/offer": 1,
            "c2c/cancellation": 1,
            "c2c/cancel-all": 1,
            "c2c/repayment": 1,
            "c2c/transfer": 1,
            "etp/creation": 5,
            "etp/redemption": 5,
            "etp/{transactId}/cancel": 10,
            "etp/batch-cancel": 50
            // 杠杆ETP批量撤单
          }
        },
        public: {
          get: {
            "common/symbols": 1,
            "common/currencys": 1,
            "common/timestamp": 1,
            "common/exchange": 1,
            "settings/currencys": 1
            // ?language=en-US
          }
        },
        private: {
          get: {
            "account/accounts": 0.2,
            "account/accounts/{id}/balance": 0.2,
            "account/accounts/{sub-uid}": 1,
            "account/history": 4,
            "cross-margin/loan-info": 1,
            "margin/loan-info": 1,
            "fee/fee-rate/get": 1,
            "order/openOrders": 0.4,
            "order/orders": 0.4,
            "order/orders/{id}": 0.4,
            "order/orders/{id}/matchresults": 0.4,
            "order/orders/getClientOrder": 0.4,
            "order/history": 1,
            "order/matchresults": 1,
            // 'dw/withdraw-virtual/addresses', // 查询虚拟币提现地址（Deprecated）
            "query/deposit-withdraw": 1,
            // 'margin/loan-info', // duplicate
            "margin/loan-orders": 0.2,
            "margin/accounts/balance": 0.2,
            "cross-margin/loan-orders": 1,
            "cross-margin/accounts/balance": 1,
            "points/actions": 1,
            "points/orders": 1,
            "subuser/aggregate-balance": 10,
            "stable-coin/exchange_rate": 1,
            "stable-coin/quote": 1
          },
          post: {
            "account/transfer": 1,
            "futures/transfer": 1,
            "order/batch-orders": 0.4,
            "order/orders/place": 0.2,
            "order/orders/submitCancelClientOrder": 0.2,
            "order/orders/batchCancelOpenOrders": 0.4,
            // 'order/orders', // 创建一个新的订单请求 （仅创建订单，不执行下单）
            // 'order/orders/{id}/place', // 执行一个订单 （仅执行已创建的订单）
            "order/orders/{id}/submitcancel": 0.2,
            "order/orders/batchcancel": 0.4,
            // 'dw/balance/transfer', // 资产划转
            "dw/withdraw/api/create": 1,
            // 'dw/withdraw-virtual/create', // 申请提现虚拟币
            // 'dw/withdraw-virtual/{id}/place', // 确认申请虚拟币提现（Deprecated）
            "dw/withdraw-virtual/{id}/cancel": 1,
            "dw/transfer-in/margin": 10,
            "dw/transfer-out/margin": 10,
            "margin/orders": 10,
            "margin/orders/{id}/repay": 10,
            "cross-margin/transfer-in": 1,
            "cross-margin/transfer-out": 1,
            "cross-margin/orders": 1,
            "cross-margin/orders/{id}/repay": 1,
            "stable-coin/exchange": 1,
            "subuser/transfer": 10
          }
        },
        // ------------------------------------------------------------
        // new api definitions
        // 'https://status.huobigroup.com/api/v2/summary.json': 1,
        // 'https://status-dm.huobigroup.com/api/v2/summary.json': 1,
        // 'https://status-swap.huobigroup.com/api/v2/summary.json': 1,
        // 'https://status-linear-swap.huobigroup.com/api/v2/summary.json': 1,
        status: {
          public: {
            spot: {
              get: {
                "api/v2/summary.json": 1
              }
            },
            future: {
              inverse: {
                get: {
                  "api/v2/summary.json": 1
                }
              },
              linear: {
                get: {
                  "api/v2/summary.json": 1
                }
              }
            },
            swap: {
              inverse: {
                get: {
                  "api/v2/summary.json": 1
                }
              },
              linear: {
                get: {
                  "api/v2/summary.json": 1
                }
              }
            }
          }
        },
        spot: {
          public: {
            get: {
              "v2/market-status": 1,
              "v1/common/symbols": 1,
              "v1/common/currencys": 1,
              "v2/settings/common/currencies": 1,
              "v2/reference/currencies": 1,
              "v1/common/timestamp": 1,
              "v1/common/exchange": 1,
              "v1/settings/common/chains": 1,
              "v1/settings/common/currencys": 1,
              "v1/settings/common/symbols": 1,
              "v2/settings/common/symbols": 1,
              "v1/settings/common/market-symbols": 1,
              // Market Data
              "market/history/candles": 1,
              "market/history/kline": 1,
              "market/detail/merged": 1,
              "market/tickers": 1,
              "market/detail": 1,
              "market/depth": 1,
              "market/trade": 1,
              "market/history/trade": 1,
              "market/etp": 1,
              // ETP
              "v2/etp/reference": 1,
              "v2/etp/rebalance": 1
            }
          },
          private: {
            get: {
              // Account
              "v1/account/accounts": 0.2,
              "v1/account/accounts/{account-id}/balance": 0.2,
              "v2/account/valuation": 1,
              "v2/account/asset-valuation": 0.2,
              "v1/account/history": 4,
              "v2/account/ledger": 1,
              "v2/point/account": 5,
              // Wallet (Deposit and Withdraw)
              "v2/account/deposit/address": 1,
              "v2/account/withdraw/quota": 1,
              "v2/account/withdraw/address": 1,
              "v2/reference/currencies": 1,
              "v1/query/deposit-withdraw": 1,
              "v1/query/withdraw/client-order-id": 1,
              // Sub user management
              "v2/user/api-key": 1,
              "v2/user/uid": 1,
              "v2/sub-user/user-list": 1,
              "v2/sub-user/user-state": 1,
              "v2/sub-user/account-list": 1,
              "v2/sub-user/deposit-address": 1,
              "v2/sub-user/query-deposit": 1,
              "v1/subuser/aggregate-balance": 10,
              "v1/account/accounts/{sub-uid}": 1,
              // Trading
              "v1/order/openOrders": 0.4,
              "v1/order/orders/{order-id}": 0.4,
              "v1/order/orders/getClientOrder": 0.4,
              "v1/order/orders/{order-id}/matchresult": 0.4,
              "v1/order/orders/{order-id}/matchresults": 0.4,
              "v1/order/orders": 0.4,
              "v1/order/history": 1,
              "v1/order/matchresults": 1,
              "v2/reference/transact-fee-rate": 1,
              // Conditional Order
              "v2/algo-orders/opening": 1,
              "v2/algo-orders/history": 1,
              "v2/algo-orders/specific": 1,
              // Margin Loan (Cross/Isolated)
              "v1/margin/loan-info": 1,
              "v1/margin/loan-orders": 0.2,
              "v1/margin/accounts/balance": 0.2,
              "v1/cross-margin/loan-info": 1,
              "v1/cross-margin/loan-orders": 1,
              "v1/cross-margin/accounts/balance": 1,
              "v2/account/repayment": 5,
              // Stable Coin Exchange
              "v1/stable-coin/quote": 1,
              "v1/stable_coin/exchange_rate": 1,
              // ETP
              "v2/etp/transactions": 5,
              "v2/etp/transaction": 5,
              "v2/etp/limit": 1
            },
            post: {
              // Account
              "v1/account/transfer": 1,
              "v1/futures/transfer": 1,
              "v2/point/transfer": 5,
              "v2/account/transfer": 1,
              // Wallet (Deposit and Withdraw)
              "v1/dw/withdraw/api/create": 1,
              "v1/dw/withdraw-virtual/{withdraw-id}/cancel": 1,
              // Sub user management
              "v2/sub-user/deduct-mode": 1,
              "v2/sub-user/creation": 1,
              "v2/sub-user/management": 1,
              "v2/sub-user/tradable-market": 1,
              "v2/sub-user/transferability": 1,
              "v2/sub-user/api-key-generation": 1,
              "v2/sub-user/api-key-modification": 1,
              "v2/sub-user/api-key-deletion": 1,
              "v1/subuser/transfer": 10,
              // Trading
              "v1/order/orders/place": 0.2,
              "v1/order/batch-orders": 0.4,
              "v1/order/auto/place": 0.2,
              "v1/order/orders/{order-id}/submitcancel": 0.2,
              "v1/order/orders/submitCancelClientOrder": 0.2,
              "v1/order/orders/batchCancelOpenOrders": 0.4,
              "v1/order/orders/batchcancel": 0.4,
              "v2/algo-orders/cancel-all-after": 1,
              // Conditional Order
              "v2/algo-orders": 1,
              "v2/algo-orders/cancellation": 1,
              // Margin Loan (Cross/Isolated)
              "v2/account/repayment": 5,
              "v1/dw/transfer-in/margin": 10,
              "v1/dw/transfer-out/margin": 10,
              "v1/margin/orders": 10,
              "v1/margin/orders/{order-id}/repay": 10,
              "v1/cross-margin/transfer-in": 1,
              "v1/cross-margin/transfer-out": 1,
              "v1/cross-margin/orders": 1,
              "v1/cross-margin/orders/{order-id}/repay": 1,
              // Stable Coin Exchange
              "v1/stable-coin/exchange": 1,
              // ETP
              "v2/etp/creation": 5,
              "v2/etp/redemption": 5,
              "v2/etp/{transactId}/cancel": 10,
              "v2/etp/batch-cancel": 50
            }
          }
        },
        contract: {
          public: {
            get: {
              "api/v1/timestamp": 1,
              "heartbeat/": 1,
              // Future Market Data interface
              "api/v1/contract_contract_info": 1,
              "api/v1/contract_index": 1,
              "api/v1/contract_query_elements": 1,
              "api/v1/contract_price_limit": 1,
              "api/v1/contract_open_interest": 1,
              "api/v1/contract_delivery_price": 1,
              "market/depth": 1,
              "market/bbo": 1,
              "market/history/kline": 1,
              "index/market/history/mark_price_kline": 1,
              "market/detail/merged": 1,
              "market/detail/batch_merged": 1,
              "v2/market/detail/batch_merged": 1,
              "market/trade": 1,
              "market/history/trade": 1,
              "api/v1/contract_risk_info": 1,
              "api/v1/contract_insurance_fund": 1,
              "api/v1/contract_adjustfactor": 1,
              "api/v1/contract_his_open_interest": 1,
              "api/v1/contract_ladder_margin": 1,
              "api/v1/contract_api_state": 1,
              "api/v1/contract_elite_account_ratio": 1,
              "api/v1/contract_elite_position_ratio": 1,
              "api/v1/contract_liquidation_orders": 1,
              "api/v1/contract_settlement_records": 1,
              "index/market/history/index": 1,
              "index/market/history/basis": 1,
              "api/v1/contract_estimated_settlement_price": 1,
              "api/v3/contract_liquidation_orders": 1,
              // Swap Market Data interface
              "swap-api/v1/swap_contract_info": 1,
              "swap-api/v1/swap_index": 1,
              "swap-api/v1/swap_query_elements": 1,
              "swap-api/v1/swap_price_limit": 1,
              "swap-api/v1/swap_open_interest": 1,
              "swap-ex/market/depth": 1,
              "swap-ex/market/bbo": 1,
              "swap-ex/market/history/kline": 1,
              "index/market/history/swap_mark_price_kline": 1,
              "swap-ex/market/detail/merged": 1,
              "v2/swap-ex/market/detail/batch_merged": 1,
              "index/market/history/swap_premium_index_kline": 1,
              "swap-ex/market/detail/batch_merged": 1,
              "swap-ex/market/trade": 1,
              "swap-ex/market/history/trade": 1,
              "swap-api/v1/swap_risk_info": 1,
              "swap-api/v1/swap_insurance_fund": 1,
              "swap-api/v1/swap_adjustfactor": 1,
              "swap-api/v1/swap_his_open_interest": 1,
              "swap-api/v1/swap_ladder_margin": 1,
              "swap-api/v1/swap_api_state": 1,
              "swap-api/v1/swap_elite_account_ratio": 1,
              "swap-api/v1/swap_elite_position_ratio": 1,
              "swap-api/v1/swap_estimated_settlement_price": 1,
              "swap-api/v1/swap_liquidation_orders": 1,
              "swap-api/v1/swap_settlement_records": 1,
              "swap-api/v1/swap_funding_rate": 1,
              "swap-api/v1/swap_batch_funding_rate": 1,
              "swap-api/v1/swap_historical_funding_rate": 1,
              "swap-api/v3/swap_liquidation_orders": 1,
              "index/market/history/swap_estimated_rate_kline": 1,
              "index/market/history/swap_basis": 1,
              // Swap Market Data interface
              "linear-swap-api/v1/swap_contract_info": 1,
              "linear-swap-api/v1/swap_index": 1,
              "linear-swap-api/v1/swap_query_elements": 1,
              "linear-swap-api/v1/swap_price_limit": 1,
              "linear-swap-api/v1/swap_open_interest": 1,
              "linear-swap-ex/market/depth": 1,
              "linear-swap-ex/market/bbo": 1,
              "linear-swap-ex/market/history/kline": 1,
              "index/market/history/linear_swap_mark_price_kline": 1,
              "linear-swap-ex/market/detail/merged": 1,
              "linear-swap-ex/market/detail/batch_merged": 1,
              "v2/linear-swap-ex/market/detail/batch_merged": 1,
              "linear-swap-ex/market/trade": 1,
              "linear-swap-ex/market/history/trade": 1,
              "linear-swap-api/v1/swap_risk_info": 1,
              "swap-api/v1/linear-swap-api/v1/swap_insurance_fund": 1,
              "linear-swap-api/v1/swap_adjustfactor": 1,
              "linear-swap-api/v1/swap_cross_adjustfactor": 1,
              "linear-swap-api/v1/swap_his_open_interest": 1,
              "linear-swap-api/v1/swap_ladder_margin": 1,
              "linear-swap-api/v1/swap_cross_ladder_margin": 1,
              "linear-swap-api/v1/swap_api_state": 1,
              "linear-swap-api/v1/swap_cross_transfer_state": 1,
              "linear-swap-api/v1/swap_cross_trade_state": 1,
              "linear-swap-api/v1/swap_elite_account_ratio": 1,
              "linear-swap-api/v1/swap_elite_position_ratio": 1,
              "linear-swap-api/v1/swap_liquidation_orders": 1,
              "linear-swap-api/v1/swap_settlement_records": 1,
              "linear-swap-api/v1/swap_funding_rate": 1,
              "linear-swap-api/v1/swap_batch_funding_rate": 1,
              "linear-swap-api/v1/swap_historical_funding_rate": 1,
              "linear-swap-api/v3/swap_liquidation_orders": 1,
              "index/market/history/linear_swap_premium_index_kline": 1,
              "index/market/history/linear_swap_estimated_rate_kline": 1,
              "index/market/history/linear_swap_basis": 1,
              "linear-swap-api/v1/swap_estimated_settlement_price": 1
            }
          },
          private: {
            get: {
              // Future Account Interface
              "api/v1/contract_sub_auth_list": 1,
              "api/v1/contract_api_trading_status": 1,
              // Swap Account Interface
              "swap-api/v1/swap_sub_auth_list": 1,
              "swap-api/v1/swap_api_trading_status": 1,
              // Swap Account Interface
              "linear-swap-api/v1/swap_sub_auth_list": 1,
              "linear-swap-api/v1/swap_api_trading_status": 1,
              "linear-swap-api/v1/swap_cross_position_side": 1,
              "linear-swap-api/v1/swap_position_side": 1,
              "linear-swap-api/v3/unified_account_info": 1,
              "linear-swap-api/v3/fix_position_margin_change_record": 1,
              "linear-swap-api/v3/swap_unified_account_type": 1,
              "linear-swap-api/v3/linear_swap_overview_account_info": 1
            },
            post: {
              // Future Account Interface
              "api/v1/contract_balance_valuation": 1,
              "api/v1/contract_account_info": 1,
              "api/v1/contract_position_info": 1,
              "api/v1/contract_sub_auth": 1,
              "api/v1/contract_sub_account_list": 1,
              "api/v1/contract_sub_account_info_list": 1,
              "api/v1/contract_sub_account_info": 1,
              "api/v1/contract_sub_position_info": 1,
              "api/v1/contract_financial_record": 1,
              "api/v1/contract_financial_record_exact": 1,
              "api/v1/contract_user_settlement_records": 1,
              "api/v1/contract_order_limit": 1,
              "api/v1/contract_fee": 1,
              "api/v1/contract_transfer_limit": 1,
              "api/v1/contract_position_limit": 1,
              "api/v1/contract_account_position_info": 1,
              "api/v1/contract_master_sub_transfer": 1,
              "api/v1/contract_master_sub_transfer_record": 1,
              "api/v1/contract_available_level_rate": 1,
              "api/v3/contract_financial_record": 1,
              "api/v3/contract_financial_record_exact": 1,
              // Future Trade Interface
              "api/v1/contract-cancel-after": 1,
              "api/v1/contract_order": 1,
              "api/v1/contract_batchorder": 1,
              "api/v1/contract_cancel": 1,
              "api/v1/contract_cancelall": 1,
              "api/v1/contract_switch_lever_rate": 1,
              "api/v1/lightning_close_position": 1,
              "api/v1/contract_order_info": 1,
              "api/v1/contract_order_detail": 1,
              "api/v1/contract_openorders": 1,
              "api/v1/contract_hisorders": 1,
              "api/v1/contract_hisorders_exact": 1,
              "api/v1/contract_matchresults": 1,
              "api/v1/contract_matchresults_exact": 1,
              "api/v3/contract_hisorders": 1,
              "api/v3/contract_hisorders_exact": 1,
              "api/v3/contract_matchresults": 1,
              "api/v3/contract_matchresults_exact": 1,
              // Contract Strategy Order Interface
              "api/v1/contract_trigger_order": 1,
              "api/v1/contract_trigger_cancel": 1,
              "api/v1/contract_trigger_cancelall": 1,
              "api/v1/contract_trigger_openorders": 1,
              "api/v1/contract_trigger_hisorders": 1,
              "api/v1/contract_tpsl_order": 1,
              "api/v1/contract_tpsl_cancel": 1,
              "api/v1/contract_tpsl_cancelall": 1,
              "api/v1/contract_tpsl_openorders": 1,
              "api/v1/contract_tpsl_hisorders": 1,
              "api/v1/contract_relation_tpsl_order": 1,
              "api/v1/contract_track_order": 1,
              "api/v1/contract_track_cancel": 1,
              "api/v1/contract_track_cancelall": 1,
              "api/v1/contract_track_openorders": 1,
              "api/v1/contract_track_hisorders": 1,
              // Swap Account Interface
              "swap-api/v1/swap_balance_valuation": 1,
              "swap-api/v1/swap_account_info": 1,
              "swap-api/v1/swap_position_info": 1,
              "swap-api/v1/swap_account_position_info": 1,
              "swap-api/v1/swap_sub_auth": 1,
              "swap-api/v1/swap_sub_account_list": 1,
              "swap-api/v1/swap_sub_account_info_list": 1,
              "swap-api/v1/swap_sub_account_info": 1,
              "swap-api/v1/swap_sub_position_info": 1,
              "swap-api/v1/swap_financial_record": 1,
              "swap-api/v1/swap_financial_record_exact": 1,
              "swap-api/v1/swap_user_settlement_records": 1,
              "swap-api/v1/swap_available_level_rate": 1,
              "swap-api/v1/swap_order_limit": 1,
              "swap-api/v1/swap_fee": 1,
              "swap-api/v1/swap_transfer_limit": 1,
              "swap-api/v1/swap_position_limit": 1,
              "swap-api/v1/swap_master_sub_transfer": 1,
              "swap-api/v1/swap_master_sub_transfer_record": 1,
              "swap-api/v3/swap_financial_record": 1,
              "swap-api/v3/swap_financial_record_exact": 1,
              // Swap Trade Interface
              "swap-api/v1/swap-cancel-after": 1,
              "swap-api/v1/swap_order": 1,
              "swap-api/v1/swap_batchorder": 1,
              "swap-api/v1/swap_cancel": 1,
              "swap-api/v1/swap_cancelall": 1,
              "swap-api/v1/swap_lightning_close_position": 1,
              "swap-api/v1/swap_switch_lever_rate": 1,
              "swap-api/v1/swap_order_info": 1,
              "swap-api/v1/swap_order_detail": 1,
              "swap-api/v1/swap_openorders": 1,
              "swap-api/v1/swap_hisorders": 1,
              "swap-api/v1/swap_hisorders_exact": 1,
              "swap-api/v1/swap_matchresults": 1,
              "swap-api/v1/swap_matchresults_exact": 1,
              "swap-api/v3/swap_matchresults": 1,
              "swap-api/v3/swap_matchresults_exact": 1,
              "swap-api/v3/swap_hisorders": 1,
              "swap-api/v3/swap_hisorders_exact": 1,
              // Swap Strategy Order Interface
              "swap-api/v1/swap_trigger_order": 1,
              "swap-api/v1/swap_trigger_cancel": 1,
              "swap-api/v1/swap_trigger_cancelall": 1,
              "swap-api/v1/swap_trigger_openorders": 1,
              "swap-api/v1/swap_trigger_hisorders": 1,
              "swap-api/v1/swap_tpsl_order": 1,
              "swap-api/v1/swap_tpsl_cancel": 1,
              "swap-api/v1/swap_tpsl_cancelall": 1,
              "swap-api/v1/swap_tpsl_openorders": 1,
              "swap-api/v1/swap_tpsl_hisorders": 1,
              "swap-api/v1/swap_relation_tpsl_order": 1,
              "swap-api/v1/swap_track_order": 1,
              "swap-api/v1/swap_track_cancel": 1,
              "swap-api/v1/swap_track_cancelall": 1,
              "swap-api/v1/swap_track_openorders": 1,
              "swap-api/v1/swap_track_hisorders": 1,
              // Swap Account Interface
              "linear-swap-api/v1/swap_lever_position_limit": 1,
              "linear-swap-api/v1/swap_cross_lever_position_limit": 1,
              "linear-swap-api/v1/swap_balance_valuation": 1,
              "linear-swap-api/v1/swap_account_info": 1,
              "linear-swap-api/v1/swap_cross_account_info": 1,
              "linear-swap-api/v1/swap_position_info": 1,
              "linear-swap-api/v1/swap_cross_position_info": 1,
              "linear-swap-api/v1/swap_account_position_info": 1,
              "linear-swap-api/v1/swap_cross_account_position_info": 1,
              "linear-swap-api/v1/swap_sub_auth": 1,
              "linear-swap-api/v1/swap_sub_account_list": 1,
              "linear-swap-api/v1/swap_cross_sub_account_list": 1,
              "linear-swap-api/v1/swap_sub_account_info_list": 1,
              "linear-swap-api/v1/swap_cross_sub_account_info_list": 1,
              "linear-swap-api/v1/swap_sub_account_info": 1,
              "linear-swap-api/v1/swap_cross_sub_account_info": 1,
              "linear-swap-api/v1/swap_sub_position_info": 1,
              "linear-swap-api/v1/swap_cross_sub_position_info": 1,
              "linear-swap-api/v1/swap_financial_record": 1,
              "linear-swap-api/v1/swap_financial_record_exact": 1,
              "linear-swap-api/v1/swap_user_settlement_records": 1,
              "linear-swap-api/v1/swap_cross_user_settlement_records": 1,
              "linear-swap-api/v1/swap_available_level_rate": 1,
              "linear-swap-api/v1/swap_cross_available_level_rate": 1,
              "linear-swap-api/v1/swap_order_limit": 1,
              "linear-swap-api/v1/swap_fee": 1,
              "linear-swap-api/v1/swap_transfer_limit": 1,
              "linear-swap-api/v1/swap_cross_transfer_limit": 1,
              "linear-swap-api/v1/swap_position_limit": 1,
              "linear-swap-api/v1/swap_cross_position_limit": 1,
              "linear-swap-api/v1/swap_master_sub_transfer": 1,
              "linear-swap-api/v1/swap_master_sub_transfer_record": 1,
              "linear-swap-api/v1/swap_transfer_inner": 1,
              "linear-swap-api/v3/swap_financial_record": 1,
              "linear-swap-api/v3/swap_financial_record_exact": 1,
              // Swap Trade Interface
              "linear-swap-api/v1/swap_order": 1,
              "linear-swap-api/v1/swap_cross_order": 1,
              "linear-swap-api/v1/swap_batchorder": 1,
              "linear-swap-api/v1/swap_cross_batchorder": 1,
              "linear-swap-api/v1/swap_cancel": 1,
              "linear-swap-api/v1/swap_cross_cancel": 1,
              "linear-swap-api/v1/swap_cancelall": 1,
              "linear-swap-api/v1/swap_cross_cancelall": 1,
              "linear-swap-api/v1/swap_switch_lever_rate": 1,
              "linear-swap-api/v1/swap_cross_switch_lever_rate": 1,
              "linear-swap-api/v1/swap_lightning_close_position": 1,
              "linear-swap-api/v1/swap_cross_lightning_close_position": 1,
              "linear-swap-api/v1/swap_order_info": 1,
              "linear-swap-api/v1/swap_cross_order_info": 1,
              "linear-swap-api/v1/swap_order_detail": 1,
              "linear-swap-api/v1/swap_cross_order_detail": 1,
              "linear-swap-api/v1/swap_openorders": 1,
              "linear-swap-api/v1/swap_cross_openorders": 1,
              "linear-swap-api/v1/swap_hisorders": 1,
              "linear-swap-api/v1/swap_cross_hisorders": 1,
              "linear-swap-api/v1/swap_hisorders_exact": 1,
              "linear-swap-api/v1/swap_cross_hisorders_exact": 1,
              "linear-swap-api/v1/swap_matchresults": 1,
              "linear-swap-api/v1/swap_cross_matchresults": 1,
              "linear-swap-api/v1/swap_matchresults_exact": 1,
              "linear-swap-api/v1/swap_cross_matchresults_exact": 1,
              "linear-swap-api/v1/linear-cancel-after": 1,
              "linear-swap-api/v1/swap_switch_position_mode": 1,
              "linear-swap-api/v1/swap_cross_switch_position_mode": 1,
              "linear-swap-api/v3/swap_matchresults": 1,
              "linear-swap-api/v3/swap_cross_matchresults": 1,
              "linear-swap-api/v3/swap_matchresults_exact": 1,
              "linear-swap-api/v3/swap_cross_matchresults_exact": 1,
              "linear-swap-api/v3/swap_hisorders": 1,
              "linear-swap-api/v3/swap_cross_hisorders": 1,
              "linear-swap-api/v3/swap_hisorders_exact": 1,
              "linear-swap-api/v3/swap_cross_hisorders_exact": 1,
              "linear-swap-api/v3/fix_position_margin_change": 1,
              "linear-swap-api/v3/swap_switch_account_type": 1,
              "linear-swap-api/v3/linear_swap_fee_switch": 1,
              // Swap Strategy Order Interface
              "linear-swap-api/v1/swap_trigger_order": 1,
              "linear-swap-api/v1/swap_cross_trigger_order": 1,
              "linear-swap-api/v1/swap_trigger_cancel": 1,
              "linear-swap-api/v1/swap_cross_trigger_cancel": 1,
              "linear-swap-api/v1/swap_trigger_cancelall": 1,
              "linear-swap-api/v1/swap_cross_trigger_cancelall": 1,
              "linear-swap-api/v1/swap_trigger_openorders": 1,
              "linear-swap-api/v1/swap_cross_trigger_openorders": 1,
              "linear-swap-api/v1/swap_trigger_hisorders": 1,
              "linear-swap-api/v1/swap_cross_trigger_hisorders": 1,
              "linear-swap-api/v1/swap_tpsl_order": 1,
              "linear-swap-api/v1/swap_cross_tpsl_order": 1,
              "linear-swap-api/v1/swap_tpsl_cancel": 1,
              "linear-swap-api/v1/swap_cross_tpsl_cancel": 1,
              "linear-swap-api/v1/swap_tpsl_cancelall": 1,
              "linear-swap-api/v1/swap_cross_tpsl_cancelall": 1,
              "linear-swap-api/v1/swap_tpsl_openorders": 1,
              "linear-swap-api/v1/swap_cross_tpsl_openorders": 1,
              "linear-swap-api/v1/swap_tpsl_hisorders": 1,
              "linear-swap-api/v1/swap_cross_tpsl_hisorders": 1,
              "linear-swap-api/v1/swap_relation_tpsl_order": 1,
              "linear-swap-api/v1/swap_cross_relation_tpsl_order": 1,
              "linear-swap-api/v1/swap_track_order": 1,
              "linear-swap-api/v1/swap_cross_track_order": 1,
              "linear-swap-api/v1/swap_track_cancel": 1,
              "linear-swap-api/v1/swap_cross_track_cancel": 1,
              "linear-swap-api/v1/swap_track_cancelall": 1,
              "linear-swap-api/v1/swap_cross_track_cancelall": 1,
              "linear-swap-api/v1/swap_track_openorders": 1,
              "linear-swap-api/v1/swap_cross_track_openorders": 1,
              "linear-swap-api/v1/swap_track_hisorders": 1,
              "linear-swap-api/v1/swap_cross_track_hisorders": 1
            }
          }
        }
      },
      fees: {
        trading: {
          feeSide: "get",
          tierBased: !1,
          percentage: !0,
          maker: this.parseNumber("0.002"),
          taker: this.parseNumber("0.002")
        }
      },
      exceptions: {
        broad: {
          "contract is restricted of closing positions on API.  Please contact customer service": dt,
          maintain: dt,
          "API key has no permission": ee
          // {"status":"error","err-code":"api-signature-not-valid","err-msg":"Signature not valid: API key has no permission [API Key没有权限]","data":null}
        },
        exact: {
          // err-code
          403: Pt,
          1010: O,
          1003: Z,
          1013: k,
          1017: Se,
          1034: g,
          1036: g,
          1039: g,
          1041: g,
          1047: re,
          1048: re,
          1051: k,
          1066: g,
          1067: g,
          1094: g,
          1220: ee,
          1303: je,
          1461: k,
          4007: O,
          "bad-request": O,
          "validation-format-error": g,
          "validation-constraints-required": g,
          "base-date-limit-error": g,
          "api-not-support-temp-addr": et,
          timeout: Nt,
          "gateway-internal-error": Te,
          "account-frozen-balance-insufficient-error": re,
          "invalid-amount": g,
          "order-limitorder-amount-min-error": g,
          "order-limitorder-amount-max-error": g,
          "order-marketorder-amount-min-error": g,
          "order-limitorder-price-min-error": g,
          "order-limitorder-price-max-error": g,
          "order-stop-order-hit-trigger": k,
          "order-value-min-error": g,
          "order-invalid-price": g,
          "order-holding-limit-failed": k,
          "order-orderprice-precision-error": g,
          "order-etp-nav-price-max-error": g,
          "order-orderstate-error": Se,
          "order-queryorder-invalid": Se,
          "order-update-error": Te,
          "api-signature-check-failed": Z,
          "api-signature-not-valid": Pt,
          "base-record-invalid": Se,
          "base-symbol-trade-disabled": k,
          "base-symbol-error": k,
          "system-maintenance": dt,
          "base-request-exceed-frequency-limit": Ae,
          // err-msg
          "invalid symbol": g,
          "symbol trade not open now": it,
          "require-symbol": g,
          "invalid-address": et,
          "base-currency-chain-error": O,
          "dw-insufficient-balance": re,
          "base-withdraw-fee-error": ke,
          "dw-withdraw-min-limit": Xt,
          "request limit": Ae
          // {"ts":1687004814731,"status":"error","err-code":"invalid-parameter","err-msg":"request limit"}
        },
        messages: {
          "market order trading volume can not be less than": ye.ORDER_UNDER_MINIMUM,
          "Order total cannot be lower than": ye.ORDER_UNDER_MINIMUM
        }
      },
      precisionMode: ct,
      options: {
        timeDifference: 0,
        fetchMarkets: {
          types: {
            spot: !0,
            future: {
              linear: !0,
              inverse: !0
            },
            swap: {
              linear: !0,
              inverse: !0
            }
          }
        },
        withdraw: {
          includeFee: !1
        },
        defaultType: "spot",
        defaultSubType: "linear",
        defaultNetwork: "ERC20",
        defaultNetworks: {
          ETH: "ERC20",
          BTC: "BTC",
          USDT: "TRC20"
        },
        networks: {
          // by displaynames
          TRC20: "TRX",
          BTC: "BTC",
          ERC20: "ETH",
          SOL: "SOLANA",
          HRC20: "HECO",
          BEP20: "BSC",
          XMR: "XMR",
          LTC: "LTC",
          XRP: "XRP",
          XLM: "XLM",
          CRONOS: "CRO",
          CRO: "CRO",
          GLMR: "GLMR",
          POLYGON: "MATIC",
          MATIC: "MATIC",
          BTT: "BTT",
          CUBE: "CUBE",
          IOST: "IOST",
          NEO: "NEO",
          KLAY: "KLAY",
          EOS: "EOS",
          THETA: "THETA",
          NAS: "NAS",
          NULS: "NULS",
          QTUM: "QTUM",
          FTM: "FTM",
          CELO: "CELO",
          DOGE: "DOGE",
          DOGECHAIN: "DOGECHAIN",
          NEAR: "NEAR",
          STEP: "STEP",
          BITCI: "BITCI",
          CARDANO: "ADA",
          ADA: "ADA",
          ETC: "ETC",
          LUK: "LUK",
          MINEPLEX: "MINEPLEX",
          DASH: "DASH",
          ZEC: "ZEC",
          IOTA: "IOTA",
          NEON3: "NEON3",
          XEM: "XEM",
          HC: "HC",
          LSK: "LSK",
          DCR: "DCR",
          BTG: "BTG",
          STEEM: "STEEM",
          BTS: "BTS",
          ICX: "ICX",
          WAVES: "WAVES",
          CMT: "CMT",
          BTM: "BTM",
          VET: "VET",
          XZC: "XZC",
          ACT: "ACT",
          SMT: "SMT",
          BCD: "BCD",
          WAX: "WAX1",
          WICC: "WICC",
          ELF: "ELF",
          ZIL: "ZIL",
          ELA: "ELA",
          BCX: "BCX",
          SBTC: "SBTC",
          BIFI: "BIFI",
          CTXC: "CTXC",
          WAN: "WAN",
          POLYX: "POLYX",
          PAI: "PAI",
          WTC: "WTC",
          DGB: "DGB",
          XVG: "XVG",
          AAC: "AAC",
          AE: "AE",
          SEELE: "SEELE",
          BCV: "BCV",
          GRS: "GRS",
          ARDR: "ARDR",
          NANO: "NANO",
          ZEN: "ZEN",
          RBTC: "RBTC",
          BSV: "BSV",
          GAS: "GAS",
          XTZ: "XTZ",
          LAMB: "LAMB",
          CVNT1: "CVNT1",
          DOCK: "DOCK",
          SC: "SC",
          KMD: "KMD",
          ETN: "ETN",
          TOP: "TOP",
          IRIS: "IRIS",
          UGAS: "UGAS",
          TT: "TT",
          NEWTON: "NEWTON",
          VSYS: "VSYS",
          FSN: "FSN",
          BHD: "BHD",
          ONE: "ONE",
          EM: "EM",
          CKB: "CKB",
          EOSS: "EOSS",
          HIVE: "HIVE",
          RVN: "RVN",
          DOT: "DOT",
          KSM: "KSM",
          BAND: "BAND",
          OEP4: "OEP4",
          NBS: "NBS",
          FIS: "FIS",
          AR: "AR",
          HBAR: "HBAR",
          FIL: "FIL",
          MASS: "MASS",
          KAVA: "KAVA",
          XYM: "XYM",
          ENJ: "ENJ",
          CRUST: "CRUST",
          ICP: "ICP",
          CSPR: "CSPR",
          FLOW: "FLOW",
          IOTX: "IOTX",
          LAT: "LAT",
          APT: "APT",
          XCH: "XCH",
          MINA: "MINA",
          XEC: "ECASH",
          XPRT: "XPRT",
          CCA: "ACA",
          AOTI: "COTI",
          AKT: "AKT",
          ARS: "ARS",
          ASTR: "ASTR",
          AZERO: "AZERO",
          BLD: "BLD",
          BRISE: "BRISE",
          CORE: "CORE",
          DESO: "DESO",
          DFI: "DFI",
          EGLD: "EGLD",
          ERG: "ERG",
          ETHF: "ETHFAIR",
          ETHW: "ETHW",
          EVMOS: "EVMOS",
          FIO: "FIO",
          FLR: "FLR",
          FINSCHIA: "FINSCHIA",
          KMA: "KMA",
          KYVE: "KYVE",
          MEV: "MEV",
          MOVR: "MOVR",
          NODL: "NODL",
          OAS: "OAS",
          OSMO: "OSMO",
          PAYCOIN: "PAYCOIN",
          POKT: "POKT",
          PYG: "PYG",
          REI: "REI",
          SCRT: "SCRT",
          SDN: "SDN",
          SEI: "SEI",
          SGB: "SGB",
          SUI: "SUI",
          SXP: "SOLAR",
          SYS: "SYS",
          TENET: "TENET",
          TON: "TON",
          UNQ: "UNQ",
          UYU: "UYU",
          WEMIX: "WEMIX",
          XDC: "XDC",
          XPLA: "XPLA"
          // todo: below
          // 'LUNC': 'LUNC',
          // 'TERRA': 'TERRA', // tbd
          // 'LUNA': 'LUNA', tbd
          // 'FCT2': 'FCT2',
          // FIL-0X ?
          // 'COSMOS': 'ATOM1',
          // 'ATOM': 'ATOM1',
          // 'CRO': 'CRO',
          // 'OP': [ 'OPTIMISM', 'OPTIMISMETH' ]
          // 'ARB': ['ARB', 'ARBITRUMETH']
          // 'CHZ': [ 'CHZ', 'CZH' ],
          // todo: AVAXCCHAIN CCHAIN AVAX
          // 'ALGO': ['ALGO', 'ALGOUSDT']
          // 'ONT': [ 'ONT', 'ONTOLOGY' ],
          // 'BCC': 'BCC', BCH's somewhat chain
          // 'DBC1': 'DBC1',
        },
        // https://github.com/ccxt/ccxt/issues/5376
        fetchOrdersByStatesMethod: "spot_private_get_v1_order_orders",
        createMarketBuyOrderRequiresPrice: !0,
        language: "en-US",
        broker: {
          id: "AA03022abc"
        },
        accountsByType: {
          spot: "pro",
          funding: "pro",
          future: "futures"
        },
        accountsById: {
          spot: "spot",
          margin: "margin",
          otc: "otc",
          point: "point",
          "super-margin": "super-margin",
          investment: "investment",
          borrow: "borrow",
          "grid-trading": "grid-trading",
          "deposit-earning": "deposit-earning",
          "otc-options": "otc-options"
        },
        typesByAccount: {
          pro: "spot",
          futures: "future"
        },
        spot: {
          stopOrderTypes: {
            "stop-limit": !0,
            "buy-stop-limit": !0,
            "sell-stop-limit": !0,
            "stop-limit-fok": !0,
            "buy-stop-limit-fok": !0,
            "sell-stop-limit-fok": !0
          },
          limitOrderTypes: {
            limit: !0,
            "buy-limit": !0,
            "sell-limit": !0,
            ioc: !0,
            "buy-ioc": !0,
            "sell-ioc": !0,
            "limit-maker": !0,
            "buy-limit-maker": !0,
            "sell-limit-maker": !0,
            "stop-limit": !0,
            "buy-stop-limit": !0,
            "sell-stop-limit": !0,
            "limit-fok": !0,
            "buy-limit-fok": !0,
            "sell-limit-fok": !0,
            "stop-limit-fok": !0,
            "buy-stop-limit-fok": !0,
            "sell-stop-limit-fok": !0
          }
        }
      }
    });
  }
  isUsingForcedProxy(e = {}, t = []) {
    const i = Array.isArray(t) ? t[1] : t;
    return i === "private" || i === "v2Private";
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  async fetchStatus(e = {}) {
    await this.loadMarkets();
    let t;
    [t, e] = this.handleMarketTypeAndParams("fetchMyTrades", void 0, e);
    let i;
    if (t !== "spot") {
      const a = this.safeString(e, "subType", this.options.defaultSubType);
      t === "swap" ? a === "linear" ? i = await this.statusPublicSwapLinearGetApiV2SummaryJson() : a === "inverse" && (i = await this.statusPublicSwapInverseGetApiV2SummaryJson()) : t === "future" ? a === "linear" ? i = await this.statusPublicFutureLinearGetApiV2SummaryJson() : a === "inverse" && (i = await this.statusPublicFutureInverseGetApiV2SummaryJson()) : t === "contract" && (i = await this.contractPublicGetHeartbeat());
    } else
      i = await this.statusPublicSpotGetApiV2SummaryJson();
    let s, n, r;
    if (t === "contract")
      s = this.safeString(i, "status") === "ok" ? "ok" : "maintenance", n = this.safeString(i, "ts");
    else {
      const a = this.safeValue(i, "status", {});
      s = this.safeString(a, "indicator") === "none" ? "ok" : "maintenance";
      const c = this.safeValue(i, "page", {}), u = this.safeString(c, "updated_at");
      n = this.parse8601(u), r = this.safeString(c, "url");
    }
    return {
      status: s,
      updated: n,
      eta: void 0,
      url: r,
      info: i
    };
  }
  async fetchTime(e = {}) {
    const t = this.safeValue(this.options, "fetchTime", {}), i = this.safeString(this.options, "defaultType", "spot");
    let s = this.safeString(t, "type", i);
    s = this.safeString(e, "type", s);
    let n;
    return s === "future" || s === "swap" ? n = await this.contractPublicGetApiV1Timestamp(e) : n = await this.spotPublicGetV1CommonTimestamp(e), this.safeInteger2(n, "data", "ts");
  }
  parseTradingFee(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    return {
      info: e,
      symbol: this.safeSymbol(i, t),
      maker: this.safeNumber(e, "actualMakerRate"),
      taker: this.safeNumber(e, "actualTakerRate")
    };
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbols: i.id
      // trading symbols comma-separated
    }, n = await this.spotPrivateGetV2ReferenceTransactFeeRate(this.extend(s, t)), r = this.safeValue(n, "data", []), a = this.safeValue(r, 0, {});
    return this.parseTradingFee(a, i);
  }
  async fetchTradingLimits(e = void 0, t = {}) {
    await this.loadMarkets(), e === void 0 && (e = this.symbols);
    const i = {};
    for (let s = 0; s < e.length; s++) {
      const n = e[s];
      i[n] = await this.fetchTradingLimitsById(this.marketId(n), t);
    }
    return i;
  }
  async fetchTradingLimitsById(e, t = {}) {
    const i = {
      symbol: e
    }, s = await this.spotPublicGetV1CommonExchange(this.extend(i, t));
    return this.parseTradingLimits(this.safeValue(s, "data", {}));
  }
  parseTradingLimits(e, t = void 0, i = {}) {
    return {
      info: e,
      limits: {
        amount: {
          min: this.safeNumber(e, "limit-order-must-greater-than"),
          max: this.safeNumber(e, "limit-order-must-less-than")
        }
      }
    };
  }
  costToPrecision(e, t) {
    return this.decimalToPrecision(t, Et, this.markets[e].precision.cost, this.precisionMode);
  }
  async fetchMarkets(e = {}) {
    const t = this.safeValue(this.options, "fetchMarkets", {}), i = this.safeValue(t, "types", {});
    let s = [], n = [];
    const r = Object.keys(i);
    for (let a = 0; a < r.length; a++) {
      const o = r[a], c = this.safeValue(i, o);
      if (c === !0)
        n.push(this.fetchMarketsByTypeAndSubType(o, void 0, e));
      else if (c) {
        const u = Object.keys(c);
        for (let f = 0; f < u.length; f++) {
          const h = u[f];
          this.safeValue(c, h) && n.push(this.fetchMarketsByTypeAndSubType(o, h, e));
        }
      }
    }
    n = await Promise.all(n);
    for (let a = 0; a < n.length; a++)
      s = this.arrayConcat(s, n[a]);
    return s;
  }
  async fetchMarketsByTypeAndSubType(e, t, i = {}) {
    const s = this.omit(i, ["type", "subType"]), n = e === "spot", r = e !== "spot", a = e === "future", o = e === "swap";
    let c, u;
    const f = {};
    let h;
    r ? (c = t === "linear", u = t === "inverse", c ? (a && (f.business_type = "futures"), h = await this.contractPublicGetLinearSwapApiV1SwapContractInfo(this.extend(f, s))) : u && (a ? h = await this.contractPublicGetApiV1ContractContractInfo(this.extend(f, s)) : o && (h = await this.contractPublicGetSwapApiV1SwapContractInfo(this.extend(f, s))))) : h = await this.spotPublicGetV1CommonSymbols(this.extend(f, s));
    const l = this.safeValue(h, "data", []);
    if (l.length < 1)
      throw new pt().addMessage("fetchMarkets() returned an empty response: " + this.json(l)).exchange(this.id);
    const m = [];
    for (let y = 0; y < l.length; y++) {
      const w = l[y];
      let S, b, T, x, v;
      if (r) {
        if (x = this.safeString(w, "contract_code"), v = x.toLowerCase(), o) {
          const A = x.split("-");
          S = this.safeStringLower(w, "symbol"), b = this.safeStringLower(A, 1), T = u ? S : b;
        } else if (a)
          if (S = this.safeStringLower(w, "symbol"), u)
            b = "USD", T = S;
          else {
            const M = this.safeString(w, "pair").split("-");
            b = this.safeStringLower(M, 1), T = b;
          }
      } else
        S = this.safeString(w, "base-currency"), b = this.safeString(w, "quote-currency"), x = S + b, v = x.toLowerCase();
      const _ = this.safeCurrencyCode(S), V = this.safeCurrencyCode(b), j = this.safeCurrencyCode(T);
      let G = _ + "/" + V, W;
      r && (u ? G += ":" + _ : c && (G += ":" + V), a && (W = this.safeInteger(w, "delivery_time"), G += "-" + this.yymmdd(W)));
      const B = this.safeNumber(w, "contract_size");
      let Q = this.safeNumber(w, "min-order-value");
      const se = this.safeNumber(w, "max-order-amt");
      let $ = this.safeNumber(w, "min-order-amt");
      r && (c ? $ = B : u && (Q = B));
      let te, E, N, L, z, K;
      n ? (te = this.parseNumber(this.parsePrecision(this.safeString(w, "price-precision"))), E = this.parseNumber(this.parsePrecision(this.safeString(w, "amount-precision"))), N = this.parseNumber(this.parsePrecision(this.safeString(w, "value-precision"))), L = this.parseNumber("0.002"), z = this.parseNumber("0.002"), K = this.safeString(w, "state") === "online") : (te = this.safeNumber(w, "price_tick"), E = this.parseNumber("1"), L = this.parseNumber("0.0002"), z = this.parseNumber("0.0005"), K = this.safeInteger(w, "contract_status") === 1);
      const R = this.safeString(w, "leverage-ratio", "1"), U = this.safeString(w, "super-margin-leverage-ratio", "1"), Y = P.stringGt(R, "1") || P.stringGt(U, "1");
      let J, ae = this.safeString(w, "create_date");
      if (ae !== void 0) {
        const A = this.stringToCharsArray(ae);
        ae = A[0] + A[1] + A[2] + A[3] + "-" + A[4] + A[5] + "-" + A[6] + A[7] + " 00:00:00", J = this.parse8601(ae);
      }
      m.push({
        id: x,
        lowercaseId: v,
        symbol: G,
        base: _,
        quote: V,
        settle: j,
        baseId: S,
        quoteId: b,
        settleId: T,
        type: e,
        spot: n,
        margin: n && Y,
        swap: o,
        future: a,
        option: !1,
        active: K,
        contract: r,
        linear: c,
        inverse: u,
        taker: z,
        maker: L,
        contractSize: B,
        expiry: W,
        expiryDatetime: this.iso8601(W),
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: E,
          price: te,
          cost: N
        },
        limits: {
          leverage: {
            min: this.parseNumber("1"),
            max: this.parseNumber(R),
            superMax: this.parseNumber(U)
          },
          amount: {
            min: $,
            max: se
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: Q,
            max: void 0
          }
        },
        created: J,
        info: w
      });
    }
    return m;
  }
  parseTicker(e, t = void 0) {
    const i = this.safeString2(e, "symbol", "contract_code"), s = this.safeSymbol(i, t), n = this.safeInteger2(e, "ts", "quoteTime");
    let r, a, o, c;
    "bid" in e && (Array.isArray(e.bid) ? (r = this.safeString(e.bid, 0), a = this.safeString(e.bid, 1)) : (r = this.safeString(e, "bid"), a = this.safeString(e, "bidSize"))), "ask" in e && (Array.isArray(e.ask) ? (o = this.safeString(e.ask, 0), c = this.safeString(e.ask, 1)) : (o = this.safeString(e, "ask"), c = this.safeString(e, "askSize")));
    const u = this.safeString(e, "open"), f = this.safeString(e, "close"), h = this.safeString(e, "amount"), l = this.safeString(e, "vol");
    return this.safeTicker({
      symbol: s,
      timestamp: n,
      datetime: this.iso8601(n),
      high: this.safeString(e, "high"),
      low: this.safeString(e, "low"),
      bid: r,
      bidVolume: a,
      ask: o,
      askVolume: c,
      vwap: void 0,
      open: u,
      close: f,
      last: f,
      previousClose: void 0,
      change: void 0,
      percentage: void 0,
      average: void 0,
      baseVolume: h,
      quoteVolume: l,
      info: e
    }, t);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {};
    let n;
    i.linear ? (s.contract_code = i.id, n = await this.contractPublicGetLinearSwapExMarketDetailMerged(this.extend(s, t))) : i.inverse ? i.future ? (s.symbol = i.id, n = await this.contractPublicGetMarketDetailMerged(this.extend(s, t))) : i.swap && (s.contract_code = i.id, n = await this.contractPublicGetSwapExMarketDetailMerged(this.extend(s, t))) : (s.symbol = i.id, n = await this.spotPublicGetMarketDetailMerged(this.extend(s, t)));
    const r = this.safeValue(n, "tick", {}), a = this.parseTicker(r, i), o = this.safeInteger(n, "ts");
    return a.timestamp = o, a.datetime = this.iso8601(o), a;
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = this.safeString(e, 0);
    let s;
    i !== void 0 && (s = this.market(i));
    let n, r;
    [n, t] = this.handleMarketTypeAndParams("fetchTickers", s, t), [r, t] = this.handleSubTypeAndParams("fetchTickers", s, t);
    const a = {}, o = n === "future", c = n === "swap", u = r === "linear", f = r === "inverse";
    t = this.omit(t, ["type", "subType"]);
    let h;
    o || c ? u ? (o && (a.business_type = "futures"), h = await this.contractPublicGetLinearSwapExMarketDetailBatchMerged(this.extend(a, t))) : f && (o ? h = await this.contractPublicGetMarketDetailBatchMerged(this.extend(a, t)) : c && (h = await this.contractPublicGetSwapExMarketDetailBatchMerged(this.extend(a, t)))) : h = await this.spotPublicGetMarketTickers(this.extend(a, t));
    const l = this.safeValue2(h, "data", "ticks", []), p = this.safeInteger(h, "ts"), m = {};
    for (let y = 0; y < l.length; y++) {
      const w = this.parseTicker(l[y]);
      if (o && u)
        for (let b = 0; b < this.symbols.length; b++) {
          const T = this.symbols[b], x = this.market(T), v = this.safeString(x.info, "contract_type");
          if (v === "this_week" && w.symbol === x.baseId + "-" + x.quoteId + "-CW") {
            w.symbol = x.symbol;
            break;
          } else if (v === "next_week" && w.symbol === x.baseId + "-" + x.quoteId + "-NW") {
            w.symbol = x.symbol;
            break;
          } else if (v === "this_quarter" && w.symbol === x.baseId + "-" + x.quoteId + "-CQ") {
            w.symbol = x.symbol;
            break;
          } else if (v === "next_quarter" && w.symbol === x.baseId + "-" + x.quoteId + "-NQ") {
            w.symbol = x.symbol;
            break;
          }
        }
      const S = w.symbol;
      w.timestamp = p, w.datetime = this.iso8601(p), m[S] = w;
    }
    return this.filterByArrayTickers(m, "symbol", e);
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e), n = {
      //
      // from the API docs
      //
      //     to get depth data within step 150, use step0, step1, step2, step3, step4, step5, step14, step15（merged depth data 0-5,14-15, when step is 0，depth data will not be merged
      //     to get depth data within step 20, use step6, step7, step8, step9, step10, step11, step12, step13(merged depth data 7-13), when step is 6, depth data will not be merged
      //
      type: "step0"
      // 'symbol': market['id'], // spot, future
      // 'contract_code': market['id'], // swap
    };
    let r;
    if (s.linear)
      n.contract_code = s.id, r = await this.contractPublicGetLinearSwapExMarketDepth(this.extend(n, i));
    else if (s.inverse)
      s.future ? (n.symbol = s.id, r = await this.contractPublicGetMarketDepth(this.extend(n, i))) : s.swap && (n.contract_code = s.id, r = await this.contractPublicGetSwapExMarketDepth(this.extend(n, i)));
    else {
      if (t !== void 0) {
        if (t !== 5 && t !== 10 && t !== 20 && t !== 150)
          throw new g("fetchOrderBook() limit argument must be undefined, 5, 10, 20, or 150, default is 150").exchange(this.id);
        t !== 150 && (n.depth = t);
      }
      n.symbol = s.id, r = await this.spotPublicGetMarketDepth(this.extend(n, i));
    }
    if ("tick" in r) {
      if (!r.tick)
        throw new k().addMessage("fetchOrderBook() returned empty response: " + this.json(r)).exchange(this.id);
      const a = this.safeValue(r, "tick"), o = this.safeInteger(a, "ts", this.safeInteger(r, "ts")), c = this.parseOrderBook(a, e, o);
      return c.nonce = this.safeInteger(a, "version"), c;
    }
    throw new O().addMessage("fetchOrderBook() returned unrecognized response: " + this.json(r)).exchange(this.id);
  }
  parseTrade(e, t = void 0) {
    const i = this.safeString2(e, "contract_code", "symbol");
    t = this.safeMarket(i, t);
    const s = t.symbol;
    let n = this.safeInteger2(e, "ts", "created-at");
    n = this.safeInteger2(e, "created_at", "create_date", n);
    const r = this.safeString2(e, "order-id", "order_id");
    let a = this.safeString(e, "direction"), o = this.safeString(e, "type");
    if (o !== void 0) {
      const b = o.split("-");
      a = b[0], o = b[1];
    }
    const c = this.safeStringLower(e, "role"), u = this.safeString2(e, "price", "trade_price");
    let f = this.safeString2(e, "filled-amount", "amount");
    f = this.safeString(e, "trade_volume", f);
    const h = this.safeString(e, "trade_turnover");
    let l, p = this.safeString2(e, "filled-fees", "trade_fee");
    const m = this.safeString2(e, "fee-currency", "fee_asset");
    let y = this.safeCurrencyCode(m);
    const w = this.safeString(e, "filled-points");
    if (w !== void 0 && (p === void 0 || P.stringEquals(p, "0"))) {
      const b = this.safeString(e, "fee-deduct-currency");
      b !== void 0 && (p = w, y = this.safeCurrencyCode(b));
    }
    p !== void 0 && (l = {
      cost: p,
      currency: y
    });
    const S = this.safeStringN(e, ["trade_id", "trade-id", "id"]);
    return this.safeTrade({
      id: S,
      info: e,
      order: r,
      timestamp: n,
      datetime: this.iso8601(n),
      symbol: s,
      type: o,
      side: a,
      takerOrMaker: c,
      price: u,
      amount: f,
      cost: h,
      fee: l
    }, t);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    let r;
    t !== void 0 && (r = this.market(t));
    let a;
    if ([a, n] = this.handleMarketTypeAndParams("fetchOrderTrades", r, n), a !== "spot")
      throw new ge(a).addMessage("fetchOrderTrades() is only supported for spot markets").exchange(this.id);
    return await this.fetchSpotOrderTrades(e, t, i, s, n);
  }
  async fetchSpotOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = {
      "order-id": e
    }, a = await this.spotPrivateGetV1OrderOrdersOrderIdMatchresults(this.extend(r, n));
    return this.parseTrades(a.data, void 0, i, s);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchMyTrades", e, t, i, s);
    let r;
    e !== void 0 && (r = this.market(e));
    let a;
    [a, s] = this.handleMarketTypeAndParams("fetchMyTrades", r, s);
    let o = {
      // spot -----------------------------------------------------------
      // 'symbol': market['id'],
      // 'types': 'buy-market,sell-market,buy-limit,sell-limit,buy-ioc,sell-ioc,buy-limit-maker,sell-limit-maker,buy-stop-limit,sell-stop-limit',
      // 'start-time': since, // max 48 hours within 120 days
      // 'end-time': this.milliseconds (), // max 48 hours within 120 days
      // 'from': 'id', // tring false N/A Search internal id to begin with if search next page, then this should be the last id (not trade-id) of last page; if search previous page, then this should be the first id (not trade-id) of last page
      // 'direct': 'next', // next, prev
      // 'size': limit, // default 100, max 500 The number of orders to return [1-500]
      // contracts ------------------------------------------------------
      // 'symbol': market['settleId'], // required
      // 'trade_type': 0, // required, 0 all, 1 open long, 2 open short, 3 close short, 4 close long, 5 liquidate long positions, 6 liquidate short positions
      // 'contract_code': market['id'],
      // 'start_time': since, // max 48 hours within 120 days
      // 'end_time': this.milliseconds (), // max 48 hours within 120 days
      // 'from_id': 'id', // tring false N/A Search internal id to begin with if search next page, then this should be the last id (not trade-id) of last page; if search previous page, then this should be the first id (not trade-id) of last page
      // 'direct': 'prev', // next, prev
      // 'size': limit, // default 20, max 50
    }, c;
    if (a === "spot")
      e !== void 0 && (r = this.market(e), o.symbol = r.id), i !== void 0 && (o.size = i), t !== void 0 && (o["start-time"] = t), [o, s] = this.handleUntilOption("end-time", o, s), c = await this.spotPrivateGetV1OrderMatchresults(this.extend(o, s));
    else {
      if (e === void 0)
        throw new g("fetchMyTrades() requires a symbol argument").exchange(this.id);
      if (o.contract = r.id, o.trade_type = 0, t !== void 0 && (o.start_time = t), [o, s] = this.handleUntilOption("end_time", o, s), i !== void 0 && (o.page_size = i), r.linear) {
        let f;
        [f, s] = this.handleMarginModeAndParams("fetchMyTrades", s), f = f === void 0 ? "cross" : f, f === "isolated" ? c = await this.contractPrivatePostLinearSwapApiV3SwapMatchresultsExact(this.extend(o, s)) : f === "cross" && (c = await this.contractPrivatePostLinearSwapApiV3SwapCrossMatchresultsExact(this.extend(o, s)));
      } else if (r.inverse)
        if (a === "future")
          o.symbol = r.settleId, c = await this.contractPrivatePostApiV3ContractMatchresultsExact(this.extend(o, s));
        else if (a === "swap")
          c = await this.contractPrivatePostSwapApiV3SwapMatchresultsExact(this.extend(o, s));
        else
          throw new ge(a).exchange(this.id);
    }
    let u = this.safeValue(c, "data");
    return Array.isArray(u) || (u = this.safeValue(u, "trades")), this.parseTrades(u, r, t, i);
  }
  async fetchTrades(e, t = void 0, i = 1e3, s = {}) {
    await this.loadMarkets();
    const n = this.market(e), r = {
      // 'symbol': market['id'], // spot, future
      // 'contract_code': market['id'], // swap
    };
    i !== void 0 && (r.size = Math.min(i, 2e3));
    let a;
    n.future ? n.inverse ? (r.symbol = n.id, a = await this.contractPublicGetMarketHistoryTrade(this.extend(r, s))) : n.linear && (r.contract_code = n.id, a = await this.contractPublicGetLinearSwapExMarketHistoryTrade(this.extend(r, s))) : n.swap ? (r.contract_code = n.id, n.inverse ? a = await this.contractPublicGetSwapExMarketHistoryTrade(this.extend(r, s)) : n.linear && (a = await this.contractPublicGetLinearSwapExMarketHistoryTrade(this.extend(r, s)))) : (r.symbol = n.id, a = await this.spotPublicGetMarketHistoryTrade(this.extend(r, s)));
    const o = this.safeValue(a, "data", []);
    let c = [];
    for (let u = 0; u < o.length; u++) {
      const f = this.safeValue(o[u], "data", []);
      for (let h = 0; h < f.length; h++) {
        const l = this.parseTrade(f[h], n);
        c.push(l);
      }
    }
    return c = this.sortBy(c, "timestamp"), this.filterBySymbolSinceLimit(c, n.symbol, t, i);
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeTimestamp(e, "id"),
      this.safeNumber(e, "open"),
      this.safeNumber(e, "high"),
      this.safeNumber(e, "low"),
      this.safeNumber(e, "close"),
      this.safeNumber(e, "amount")
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 1e3);
    const a = this.market(e), o = {
      period: this.safeString(this.timeframes, t, t)
      // 'symbol': market['id'], // spot, future
      // 'contract_code': market['id'], // swap
      // 'size': 1000, // max 1000 for spot, 2000 for contracts
      // 'from': parseInt ((since / 1000).toString ()), spot only
      // 'to': this.seconds (), spot only
    }, c = this.safeString(n, "price");
    if (n = this.omit(n, "price"), a.contract && (s !== void 0 ? o.size = s : s = 2e3, c === void 0)) {
      const h = this.parseTimeframe(t);
      if (i === void 0) {
        const l = this.seconds();
        o.from = l - h * (s - 1), o.to = l;
      } else {
        const l = this.parseToInt(i / 1e3);
        o.from = l, o.to = this.sum(l, h * (s - 1));
      }
    }
    let u;
    if (a.future) {
      if (a.inverse)
        if (o.symbol = a.id, c === "mark")
          u = await this.contractPublicGetIndexMarketHistoryMarkPriceKline(this.extend(o, n));
        else if (c === "index")
          u = await this.contractPublicGetIndexMarketHistoryIndex(this.extend(o, n));
        else {
          if (c === "premiumIndex")
            throw new O().addMessage(a.type + " has no api endpoint for " + c + " kline data").exchange(this.id);
          u = await this.contractPublicGetMarketHistoryKline(this.extend(o, n));
        }
      else if (a.linear)
        if (o.contract_code = a.id, c === "mark")
          u = await this.contractPublicGetIndexMarketHistoryLinearSwapMarkPriceKline(this.extend(o, n));
        else {
          if (c === "index")
            throw new O().addMessage(a.type + " has no api endpoint for " + c + " kline data").exchange(this.id);
          c === "premiumIndex" ? u = await this.contractPublicGetIndexMarketHistoryLinearSwapPremiumIndexKline(this.extend(o, n)) : u = await this.contractPublicGetLinearSwapExMarketHistoryKline(this.extend(o, n));
        }
    } else if (a.swap) {
      if (o.contract_code = a.id, a.inverse)
        if (c === "mark")
          u = await this.contractPublicGetIndexMarketHistorySwapMarkPriceKline(this.extend(o, n));
        else {
          if (c === "index")
            throw new O().addMessage(a.type + " has no api endpoint for " + c + " kline data").exchange(this.id);
          c === "premiumIndex" ? u = await this.contractPublicGetIndexMarketHistorySwapPremiumIndexKline(this.extend(o, n)) : u = await this.contractPublicGetSwapExMarketHistoryKline(this.extend(o, n));
        }
      else if (a.linear)
        if (c === "mark")
          u = await this.contractPublicGetIndexMarketHistoryLinearSwapMarkPriceKline(this.extend(o, n));
        else {
          if (c === "index")
            throw new O().addMessage(a.type + " has no api endpoint for " + c + " kline data").exchange(this.id);
          c === "premiumIndex" ? u = await this.contractPublicGetIndexMarketHistoryLinearSwapPremiumIndexKline(this.extend(o, n)) : u = await this.contractPublicGetLinearSwapExMarketHistoryKline(this.extend(o, n));
        }
    } else
      i !== void 0 && (o.from = this.parseToInt(i / 1e3)), s !== void 0 && (o.size = s), o.symbol = a.id, t === "1M" || t === "1y" ? u = await this.spotPublicGetMarketHistoryKline(this.extend(o, n)) : u = await this.spotPublicGetMarketHistoryCandles(this.extend(o, n));
    const f = this.safeValue(u, "data", []);
    return this.parseOHLCVs(f, a, t, i, s);
  }
  async fetchAccounts(e = {}) {
    await this.loadMarkets();
    const t = await this.spotPrivateGetV1AccountAccounts(e), i = this.safeValue(t, "data");
    return this.parseAccounts(i);
  }
  parseAccount(e) {
    const t = this.safeString(e, "type"), i = this.safeValue(this.options, "accountsById", {}), s = this.safeValue(i, t, t);
    return {
      info: e,
      id: this.safeString(e, "id"),
      type: s,
      code: void 0
    };
  }
  async fetchAccountIdByType(e, t = void 0, i = void 0, s = {}) {
    const n = await this.loadAccounts(), r = this.safeValue2(s, "accountId", "account-id");
    if (r !== void 0)
      return r;
    e === "spot" && (t === "cross" ? e = "super-margin" : t === "isolated" && (e = "margin"));
    const a = i === void 0 ? void 0 : this.marketId(i);
    for (let c = 0; c < n.length; c++) {
      const u = n[c], f = this.safeValue(u, "info"), h = this.safeString(f, "subtype", void 0), l = this.safeString(u, "type");
      if (e === "margin") {
        if (h === a)
          return this.safeString(u, "id");
      } else if (e === l)
        return this.safeString(u, "id");
    }
    const o = this.safeValue(n, 0, {});
    return this.safeString(o, "id");
  }
  async generateMethodsMapping(e) {
    const t = e.data.map((s) => s.currency), i = {};
    return this.cedeMapping.forEach((s) => {
      const n = s.ecid.toLowerCase();
      i[n] = n, t.forEach((r) => {
        const a = n + r.toLowerCase(), o = r.toLowerCase() + n;
        i[a] = n, i[o] = n;
      });
    }), i;
  }
  safeNetwork(e) {
    const t = {
      hbtc: "erc20",
      ht2: "erc20",
      hbch: "erc20",
      eth: "erc20",
      ETH: "erc20",
      rain: "erc20",
      xfi: "erc20",
      arbieth: "arb",
      gas1: "neo1",
      avax: "arc20",
      atm: "chz20",
      babydoge: "bep20",
      bscface1: "bep20",
      mbl: "ont",
      wld: "opt",
      aury: "sol",
      bonk: "sol",
      wlkn: "sol",
      dio: "sol",
      elu: "sol",
      gari: "sol",
      gmt: "sol",
      hbb: "sol",
      sao: "sol",
      like: "sol",
      mlpx: "sol",
      zbc: "sol",
      sns: "sol",
      dav: "arb",
      ARBITRUM: "arb",
      ARBITRUMONE: "arb",
      SOLANA: "sol",
      "C-CHAIN": "cchain",
      BTT: "btt2",
      gns: "arb",
      ipv: "klay",
      joy: "klay",
      mbx: "klay",
      npt: "klay",
      we: "klay",
      well: "glmr",
      wmt: "ada",
      roco: "cchain",
      fio: "cchain",
      hec: "cchain",
      gmx: "cchain",
      xeta: "cchain",
      kube: "ADA",
      nt: "erc20",
      solo: "xrp",
      tao: "near",
      uft: "erc20"
    };
    return this.safeString(t, e, e);
  }
  async fetchCurrencies(e = {}) {
    const t = await this.spotPublicGetV2ReferenceCurrencies(e), i = await this.generateMethodsMapping(t), s = this.safeValue(t, "data", []), n = {};
    this.options.networkNamesByChainIds = {}, this.options.ecidByChainIds = {}, this.options.chainIdbyEcids = {};
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeString(a, "currency"), c = this.safeCurrencyCode(o);
      this.options.chainIdbyEcids[c] = {};
      const u = this.safeValue(a, "chains", []), f = {}, l = this.safeString(a, "instStatus") === "normal";
      let p, m, y, w = !1, S = !1;
      for (let b = 0; b < u.length; b++) {
        const T = u[b], x = this.safeString(T, "chain"), v = this.safeString2(T, "baseChain", "displayName");
        m = this.safeNumber(T, "minWithdrawAmt"), y = this.safeNumber(T, "maxWithdrawAmt");
        const _ = this.safeString(T, "withdrawStatus"), V = this.safeString(T, "depositStatus"), j = _ === "allowed", G = V === "allowed";
        S = j || S, w = G || w;
        const W = j && G, B = this.parsePrecision(this.safeString(T, "withdrawPrecision"));
        B !== void 0 && (p = p === void 0 ? B : P.stringMin(B, p));
        const Q = this.safeNumber(T, "transactFeeWithdraw"), se = this.safeNetwork(v), $ = this.safeNetwork(x), te = i[se.toLowerCase()] || i[$.toLowerCase()];
        this.options.ecidByChainIds[x] = te, this.options.chainIdbyEcids[c][te] = x, f[se] = {
          info: T,
          id: x,
          network: te,
          limits: {
            deposit: {
              min: void 0,
              max: void 0
            },
            withdraw: {
              min: m,
              max: y
            }
          },
          active: W,
          deposit: G,
          withdraw: j,
          fee: Q,
          precision: this.parseNumber(B)
        };
      }
      n[c] = {
        info: a,
        code: c,
        id: o,
        active: l,
        deposit: w,
        withdraw: S,
        fee: void 0,
        name: void 0,
        limits: {
          amount: {
            min: void 0,
            max: void 0
          },
          withdraw: {
            min: m,
            max: y
          },
          deposit: {
            min: void 0,
            max: void 0
          }
        },
        precision: this.parseNumber(p),
        networks: f
      };
    }
    return await Promise.all([
      this.cache.set({
        key: fd(this.id),
        data: this.options.ecidByChainIds,
        clone: !1,
        ttl: null
      }),
      this.cache.set({
        key: ud(this.id),
        data: this.options.chainIdbyEcids,
        clone: !1,
        ttl: null
      })
    ]), n;
  }
  networkIdToEcid(e) {
    if (Object.keys(this.options.ecidByChainIds).length === 0)
      throw new bs().addMessage("networkIdToEcid() - markets need to be loaded at first").exchange(this.id);
    return this.safeValue(this.options.ecidByChainIds, e, e);
  }
  ecidToNetworkId(e, t = void 0) {
    if (Object.keys(this.options.chainIdbyEcids).length === 0)
      throw new bs().addMessage("ecidToNetworkId() - markets need to be loaded at first").exchange(this.id);
    const n = this.safeValue(this.options.chainIdbyEcids, t, {});
    return this.safeValue(n, e, e);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    let t;
    [t, e] = this.handleMarketTypeAndParams("fetchBalance", void 0, e);
    const i = this.safeValue(this.options, "fetchBalance", {}), s = this.safeValue2(e, "isUnifiedAccount", "unified", !1);
    e = this.omit(e, ["isUnifiedAccount", "unified"]);
    const n = {}, r = t === "spot", a = t === "future", o = this.safeString2(this.options, "defaultSubType", "subType", "linear");
    let c = this.safeString2(i, "defaultSubType", "subType", o);
    c = this.safeString2(e, "defaultSubType", "subType", c);
    const u = c === "inverse", f = c === "linear";
    let h;
    [h, e] = this.handleMarginModeAndParams("fetchBalance", e), e = this.omit(e, ["defaultSubType", "subType"]);
    const l = h === "isolated", m = t === "margin" || r && (h === "cross" || l);
    let y;
    if (r || m)
      if (m)
        l ? y = await this.spotPrivateGetV1MarginAccountsBalance(this.extend(n, e)) : y = await this.spotPrivateGetV1CrossMarginAccountsBalance(this.extend(n, e));
      else {
        const b = this.safeString(e, "methodCallId");
        await this.loadAccounts(!!b, { methodCallId: b });
        const T = await this.fetchAccountIdByType(t, void 0, void 0, e);
        n["account-id"] = T, y = await this.spotPrivateGetV1AccountAccountsAccountIdBalance(this.extend(n, e));
      }
    else
      s ? y = await this.contractPrivateGetLinearSwapApiV3UnifiedAccountInfo(this.extend(n, e)) : f ? l ? y = await this.contractPrivatePostLinearSwapApiV1SwapAccountInfo(this.extend(n, e)) : y = await this.contractPrivatePostLinearSwapApiV1SwapCrossAccountInfo(this.extend(n, e)) : u && (a ? y = await this.contractPrivatePostApiV1ContractAccountInfo(this.extend(n, e)) : y = await this.contractPrivatePostSwapApiV1SwapAccountInfo(this.extend(n, e)));
    let w = { info: y };
    const S = this.safeValue(y, "data");
    if (r || m)
      if (l)
        for (let b = 0; b < S.length; b++) {
          const T = S[b], x = this.safeSymbol(this.safeString(T, "symbol")), v = this.safeValue(T, "list"), _ = {};
          for (let V = 0; V < v.length; V++) {
            const j = v[V], G = this.safeString(j, "currency"), W = this.safeCurrencyCode(G);
            _[W] = this.parseMarginBalanceHelper(j, W, _);
          }
          w[x] = this.safeBalance(_);
        }
      else {
        const b = this.safeValue(S, "list", []);
        for (let T = 0; T < b.length; T++) {
          const x = b[T], v = this.safeString(x, "currency"), _ = this.safeCurrencyCode(v);
          w[_] = this.parseMarginBalanceHelper(x, _, w);
        }
        w = this.safeBalance(w);
      }
    else if (s)
      for (let b = 0; b < S.length; b++) {
        const T = S[b], x = this.safeString(T, "margin_asset"), v = this.safeCurrencyCode(x);
        if (l) {
          const _ = this.safeValue(T, "isolated_swap", {});
          for (let V = 0; V < _.length; V++) {
            const j = _[V], G = this.safeString(j, "contract_code"), W = {
              code: v,
              free: this.safeNumber(j, "margin_available")
            }, B = this.safeSymbol(G);
            w[B] = W, w = this.safeBalance(w);
          }
        } else {
          const _ = this.account();
          _.free = this.safeString(T, "margin_static"), _.used = this.safeString(T, "margin_frozen"), w[v] = _, w = this.safeBalance(w);
        }
      }
    else if (f)
      if (l)
        for (let b = 0; b < S.length; b++) {
          const T = S[b], x = this.safeString2(T, "contract_code", "margin_account"), v = this.safeMarket(x), _ = this.safeString(T, "margin_asset"), V = this.safeCurrency(_), j = this.safeString(v, "settle", V.code);
          if (j !== void 0) {
            const G = this.account();
            G.free = this.safeString(T, "margin_balance"), G.used = this.safeString(T, "margin_frozen");
            const W = {};
            W[j] = G;
            const B = v.symbol;
            w[B] = this.safeBalance(W);
          }
        }
      else {
        for (let b = 0; b < S.length; b++) {
          const T = S[b], x = this.account();
          x.free = this.safeString(T, "withdraw_available"), x.total = this.safeString(T, "margin_balance");
          const v = this.safeString2(T, "margin_asset", "symbol"), _ = this.safeCurrencyCode(v);
          w[_] = x;
        }
        w = this.safeBalance(w);
      }
    else if (u) {
      for (let b = 0; b < S.length; b++) {
        const T = S[b], x = this.safeString(T, "symbol"), v = this.safeCurrencyCode(x), _ = this.account();
        _.free = this.safeString(T, "margin_available"), _.used = this.safeString(T, "margin_frozen"), w[v] = _;
      }
      w = this.safeBalance(w);
    }
    return w;
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    t !== void 0 && (s = this.market(t));
    let n;
    [n, i] = this.handleMarketTypeAndParams("fetchOrder", s, i);
    const r = {
      // spot -----------------------------------------------------------
      // 'order-id': 'id',
      // 'symbol': market['id'],
      // 'client-order-id': clientOrderId,
      // 'clientOrderId': clientOrderId,
      // contracts ------------------------------------------------------
      // 'order_id': id,
      // 'client_order_id': clientOrderId,
      // 'contract_code': market['id'],
      // 'pair': 'BTC-USDT',
      // 'contract_type': 'this_week', // swap, this_week, next_week, quarter, next_ quarter
    };
    let a;
    if (n === "spot")
      this.safeString(i, "clientOrderId") !== void 0 ? a = await this.spotPrivateGetV1OrderOrdersGetClientOrder(this.extend(r, i)) : (r["order-id"] = e, a = await this.spotPrivateGetV1OrderOrdersOrderId(this.extend(r, i)));
    else {
      if (t === void 0)
        throw new g("fetchOrder() requires a symbol argument").exchange(this.id);
      const c = this.safeString2(i, "client_order_id", "clientOrderId");
      if (c === void 0 ? r.order_id = e : (r.client_order_id = c, i = this.omit(i, ["client_order_id", "clientOrderId"])), r.contract_code = s.id, s.linear) {
        let u;
        [u, i] = this.handleMarginModeAndParams("fetchOrder", i), u = u === void 0 ? "cross" : u, u === "isolated" ? a = await this.contractPrivatePostLinearSwapApiV1SwapOrderInfo(this.extend(r, i)) : u === "cross" && (a = await this.contractPrivatePostLinearSwapApiV1SwapCrossOrderInfo(this.extend(r, i)));
      } else if (s.inverse)
        if (n === "future")
          r.symbol = s.settleId, a = await this.contractPrivatePostApiV1ContractOrderInfo(this.extend(r, i));
        else if (n === "swap")
          a = await this.contractPrivatePostSwapApiV1SwapOrderInfo(this.extend(r, i));
        else
          throw new ge(n).exchange(this.id);
    }
    let o = this.safeValue(a, "data");
    return Array.isArray(o) && (o = this.safeValue(o, 0)), this.parseOrder(o);
  }
  parseMarginBalanceHelper(e, t, i) {
    let s;
    return t in i ? s = i[t] : s = this.account(), e.type === "trade" && (s.free = this.safeString(e, "balance")), e.type === "frozen" && (s.used = this.safeString(e, "balance")), s;
  }
  async fetchSpotOrdersByStates(e, t = void 0, i = void 0, s = void 0, n = {}) {
    const r = this.safeString(this.options, "fetchOrdersByStatesMethod", "spot_private_get_v1_order_orders");
    if (r === "spot_private_get_v1_order_orders" && t === void 0)
      throw new g("fetchOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    let a, o = {
      // spot_private_get_v1_order_orders GET /v1/order/orders ----------
      // 'symbol': market['id'], // required
      // 'types': 'buy-market,sell-market,buy-limit,sell-limit,buy-ioc,sell-ioc,buy-stop-limit,sell-stop-limit,buy-limit-fok,sell-limit-fok,buy-stop-limit-fok,sell-stop-limit-fok',
      // 'start-time': since, // max window of 48h within a range of 180 days, within past 2 hours for cancelled orders
      // 'end-time': this.milliseconds (),
      states: e
      // filled, partial-canceled, canceled
      // 'from': order['id'],
      // 'direct': 'next', // next, prev, used with from
      // 'size': 100, // max 100
      // spot_private_get_v1_order_history GET /v1/order/history --------
      // 'symbol': market['id'], // optional
      // 'start-time': since, // max window of 48h within a range of 180 days, within past 2 hours for cancelled orders
      // 'end-time': this.milliseconds (),
      // 'direct': 'next', // next, prev, used with from
      // 'size': 100, // max 100
    };
    t !== void 0 && (a = this.market(t), o.symbol = a.id), i !== void 0 && (o["start-time"] = i, o["end-time"] = this.sum(i, 48 * 60 * 60 * 1e3)), [o, n] = this.handleUntilOption("end-time", o, n), s !== void 0 && (o.size = s);
    let c;
    r === "spot_private_get_v1_order_orders" ? c = await this.spotPrivateGetV1OrderOrders(this.extend(o, n)) : c = await this.spotPrivateGetV1OrderHistory(this.extend(o, n));
    const u = this.safeValue(c, "data", []);
    return this.parseOrders(u, a, i, s);
  }
  async fetchSpotOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchSpotOrdersByStates("pre-submitted,submitted,partial-filled,filled,partial-canceled,canceled", e, t, i, s);
  }
  async fetchClosedSpotOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchSpotOrdersByStates("filled,partial-canceled,canceled", e, t, i, s);
  }
  async fetchContractOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchContractOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const n = this.market(e);
    let r = {
      // POST /api/v1/contract_hisorders inverse futures ----------------
      // 'symbol': market['settleId'], // BTC, ETH, ...
      // 'order_type': '1', // 1 limit，3 opponent，4 lightning, 5 trigger order, 6 pst_only, 7 optimal_5, 8 optimal_10, 9 optimal_20, 10 fok, 11 ioc
      // POST /swap-api/v3/swap_hisorders inverse swap ------------------
      // POST /linear-swap-api/v3/swap_hisorders linear isolated --------
      // POST /linear-swap-api/v3/swap_cross_hisorders linear cross -----
      trade_type: 0,
      status: "0"
      // support multiple query seperated by ',',such as '3,4,5', 0: all. 3. Have sumbmitted the orders; 4. Orders partially matched; 5. Orders cancelled with partially matched; 6. Orders fully matched; 7. Orders cancelled;
    }, a;
    const o = this.safeValue(s, "stop"), c = this.safeValue(s, "stopLossTakeProfit"), u = this.safeBool(s, "trailing", !1);
    if (s = this.omit(s, ["stop", "stopLossTakeProfit", "trailing"]), o || c || u ? (i !== void 0 && (r.page_size = i), r.contract_code = n.id, r.create_date = 90) : (t !== void 0 && (r.start_time = t), r.contract = n.id, r.type = 1), [r, s] = this.handleUntilOption("end_time", r, s), n.linear) {
      let h;
      [h, s] = this.handleMarginModeAndParams("fetchContractOrders", s), h = h === void 0 ? "cross" : h, h === "isolated" ? o ? a = await this.contractPrivatePostLinearSwapApiV1SwapTriggerHisorders(this.extend(r, s)) : c ? a = await this.contractPrivatePostLinearSwapApiV1SwapTpslHisorders(this.extend(r, s)) : u ? a = await this.contractPrivatePostLinearSwapApiV1SwapTrackHisorders(this.extend(r, s)) : a = await this.contractPrivatePostLinearSwapApiV3SwapHisorders(this.extend(r, s)) : h === "cross" && (o ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTriggerHisorders(this.extend(r, s)) : c ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTpslHisorders(this.extend(r, s)) : u ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTrackHisorders(this.extend(r, s)) : a = await this.contractPrivatePostLinearSwapApiV3SwapCrossHisorders(this.extend(r, s)));
    } else
      n.inverse && (n.swap ? o ? a = await this.contractPrivatePostSwapApiV1SwapTriggerHisorders(this.extend(r, s)) : c ? a = await this.contractPrivatePostSwapApiV1SwapTpslHisorders(this.extend(r, s)) : u ? a = await this.contractPrivatePostSwapApiV1SwapTrackHisorders(this.extend(r, s)) : a = await this.contractPrivatePostSwapApiV3SwapHisorders(this.extend(r, s)) : n.future && (r.symbol = n.settleId, o ? a = await this.contractPrivatePostApiV1ContractTriggerHisorders(this.extend(r, s)) : c ? a = await this.contractPrivatePostApiV1ContractTpslHisorders(this.extend(r, s)) : u ? a = await this.contractPrivatePostApiV1ContractTrackHisorders(this.extend(r, s)) : a = await this.contractPrivatePostApiV3ContractHisorders(this.extend(r, s))));
    let f = this.safeValue(a, "data");
    return Array.isArray(f) || (f = this.safeValue(f, "orders", [])), this.parseOrders(f, n, t, i);
  }
  async fetchClosedContractOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    const n = {
      status: "5,6,7"
      // comma separated, 0 all, 3 submitted orders, 4 partially matched, 5 partially cancelled, 6 fully matched and closed, 7 canceled
    };
    return await this.fetchContractOrders(e, t, i, this.extend(n, s));
  }
  async fetchOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    e !== void 0 && (n = this.market(e));
    let r;
    [r, s] = this.handleMarketTypeAndParams("fetchOrders", n, s);
    const a = r === "swap" || r === "future";
    if (a && e === void 0)
      throw new g(" fetchOrders() requires a symbol argument for " + r + " orders").exchange(this.id);
    return a ? await this.fetchContractOrders(e, t, i, s) : await this.fetchSpotOrders(e, t, i, s);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchClosedOrders", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchClosedOrders", e, t, i, s, 100);
    let r;
    e !== void 0 && (r = this.market(e));
    let a;
    return [a, s] = this.handleMarketTypeAndParams("fetchClosedOrders", r, s), a === "spot" ? await this.fetchClosedSpotOrders(e, t, i, s) : await this.fetchClosedContractOrders(e, t, i, s);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    e !== void 0 && (n = this.market(e));
    const r = {};
    let a;
    [a, s] = this.handleMarketTypeAndParams("fetchOpenOrders", n, s);
    let o;
    if (a === "spot") {
      e !== void 0 && (r.symbol = n.id);
      let u = this.safeString(s, "account-id");
      if (u === void 0) {
        await this.loadAccounts();
        for (let f = 0; f < this.accounts.length; f++) {
          const h = this.accounts[f];
          if (h.type === "spot" && (u = this.safeString(h, "id"), u !== void 0))
            break;
        }
      }
      r["account-id"] = u, i !== void 0 && (r.size = i), s = this.omit(s, "account-id"), o = await this.spotPrivateGetV1OrderOpenOrders(this.extend(r, s));
    } else {
      if (e === void 0)
        throw new g("fetchOpenOrders() requires a symbol argument").exchange(this.id);
      i !== void 0 && (r.page_size = i), r.contract_code = n.id;
      const u = this.safeValue(s, "stop"), f = this.safeValue(s, "stopLossTakeProfit"), h = this.safeBool(s, "trailing", !1);
      if (s = this.omit(s, ["stop", "stopLossTakeProfit", "trailing"]), n.linear) {
        let l;
        [l, s] = this.handleMarginModeAndParams("fetchOpenOrders", s), l = l === void 0 ? "cross" : l, l === "isolated" ? u ? o = await this.contractPrivatePostLinearSwapApiV1SwapTriggerOpenorders(this.extend(r, s)) : f ? o = await this.contractPrivatePostLinearSwapApiV1SwapTpslOpenorders(this.extend(r, s)) : h ? o = await this.contractPrivatePostLinearSwapApiV1SwapTrackOpenorders(this.extend(r, s)) : o = await this.contractPrivatePostLinearSwapApiV1SwapOpenorders(this.extend(r, s)) : l === "cross" && (u ? o = await this.contractPrivatePostLinearSwapApiV1SwapCrossTriggerOpenorders(this.extend(r, s)) : f ? o = await this.contractPrivatePostLinearSwapApiV1SwapCrossTpslOpenorders(this.extend(r, s)) : h ? o = await this.contractPrivatePostLinearSwapApiV1SwapCrossTrackOpenorders(this.extend(r, s)) : o = await this.contractPrivatePostLinearSwapApiV1SwapCrossOpenorders(this.extend(r, s)));
      } else
        n.inverse && (n.swap ? u ? o = await this.contractPrivatePostSwapApiV1SwapTriggerOpenorders(this.extend(r, s)) : f ? o = await this.contractPrivatePostSwapApiV1SwapTpslOpenorders(this.extend(r, s)) : h ? o = await this.contractPrivatePostSwapApiV1SwapTrackOpenorders(this.extend(r, s)) : o = await this.contractPrivatePostSwapApiV1SwapOpenorders(this.extend(r, s)) : n.future && (r.symbol = n.settleId, u ? o = await this.contractPrivatePostApiV1ContractTriggerOpenorders(this.extend(r, s)) : f ? o = await this.contractPrivatePostApiV1ContractTpslOpenorders(this.extend(r, s)) : h ? o = await this.contractPrivatePostApiV1ContractTrackOpenorders(this.extend(r, s)) : o = await this.contractPrivatePostApiV1ContractOpenorders(this.extend(r, s))));
    }
    let c = this.safeValue(o, "data");
    return Array.isArray(c) || (c = this.safeValue(c, "orders", [])), this.parseOrders(c, n, t, i);
  }
  parseOrderStatus(e) {
    const t = {
      // spot
      "partial-filled": "open",
      "partial-canceled": "canceled",
      filled: "closed",
      canceled: "canceled",
      submitted: "open",
      created: "open",
      // contract
      1: "open",
      2: "open",
      3: "open",
      4: "open",
      5: "canceled",
      6: "closed",
      7: "canceled",
      11: "canceling"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    const i = this.safeString2(e, "err_code", "err-code");
    let s = this.parseOrderStatus(this.safeString2(e, "state", "status"));
    i !== void 0 && (s = "rejected");
    const n = this.safeStringN(e, ["id", "order_id_str", "order-id"]);
    let r = this.safeString(e, "direction"), a = this.safeString(e, "order_price_type");
    if ("type" in e) {
      const v = e.type.split("-");
      r = v[0], a = v[1];
    }
    const o = this.safeString2(e, "contract_code", "symbol");
    t = this.safeMarket(o, t);
    const c = this.safeIntegerN(e, ["created_at", "created-at", "create_date"]), u = this.safeString2(e, "client_order_id", "client-order-id");
    let f, h;
    a !== void 0 && a.indexOf("market") >= 0 ? r === "sell" ? f = this.safeString(e, "field-cash-amount") : f = this.safeString(e, "amount") : (h = this.safeString2(e, "volume", "amount"), f = this.safeStringN(e, ["filled-cash-amount", "field-cash-amount", "trade_turnover"]));
    const l = this.safeStringN(e, ["filled-amount", "field-amount", "trade_volume"]), p = this.safeString2(e, "price", "order_price");
    let m = this.safeString2(e, "filled-fees", "field-fees");
    m = this.safeString(e, "fee", m);
    let y;
    if (m !== void 0) {
      let v;
      const _ = this.safeString(e, "fee_asset");
      _ !== void 0 ? v = this.safeCurrencyCode(_) : v = r === "sell" ? t.quote : t.base, y = {
        cost: m,
        currency: v
      };
    }
    const w = this.safeString2(e, "stop-price", "trigger_price"), S = this.safeString(e, "trade_avg_price"), b = this.safeValue(e, "trades"), T = this.safeInteger(e, "reduce_only");
    let x;
    return T !== void 0 && (x = T !== 0), this.safeOrder({
      info: e,
      id: n,
      clientOrderId: u,
      timestamp: c,
      datetime: this.iso8601(c),
      lastTradeTimestamp: void 0,
      symbol: t.symbol,
      type: a,
      timeInForce: void 0,
      postOnly: void 0,
      side: r,
      price: p,
      stopPrice: w,
      triggerPrice: w,
      average: S,
      cost: f,
      amount: h,
      filled: l,
      remaining: void 0,
      status: s,
      reduceOnly: x,
      fee: y,
      trades: b
    }, t);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("It supports spot orders only").exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createTrailingPercentOrder(e, t, i, s, n = void 0, r = void 0, a = void 0, o = {}) {
    if (r === void 0)
      throw new g("createTrailingPercentOrder() requires a trailingPercent argument").exchange(this.id);
    if (a === void 0)
      throw new g("createTrailingPercentOrder() requires a trailingTriggerPrice argument").exchange(this.id);
    return o.trailingPercent = r, o.trailingTriggerPrice = a, await this.createOrder(e, t, i, s, n, o);
  }
  async createSpotOrderRequest(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets(), await this.loadAccounts();
    const a = this.market(e);
    let o;
    [o, r] = this.handleMarginModeAndParams("createOrder", r);
    const u = {
      // spot -----------------------------------------------------------
      "account-id": await this.fetchAccountIdByType(a.type, o, e),
      symbol: a.id
      // 'type': side + '-' + type, // buy-market, sell-market, buy-limit, sell-limit, buy-ioc, sell-ioc, buy-limit-maker, sell-limit-maker, buy-stop-limit, sell-stop-limit, buy-limit-fok, sell-limit-fok, buy-stop-limit-fok, sell-stop-limit-fok
      // 'amount': this.amountToPrecision (symbol, amount), // for buy market orders it's the order cost
      // 'price': this.priceToPrecision (symbol, price),
      // 'source': 'spot-api', // optional, spot-api, margin-api = isolated margin, super-margin-api = cross margin, c2c-margin-api
      // 'client-order-id': clientOrderId, // optional, max 64 chars, must be unique within 8 hours
      // 'stop-price': this.priceToPrecision (symbol, stopPrice), // trigger price for stop limit orders
      // 'operator': 'gte', // gte, lte, trigger price condition
    };
    let f = t.replace("buy-", "");
    f = f.replace("sell-", "");
    const h = this.safeValue(this.options, a.type, {}), l = this.safeString2(r, "stopPrice", "stop-price");
    if (l === void 0) {
      const S = this.safeValue(h, "stopOrderTypes", {});
      if (f in S)
        throw new g("createOrder() requires a stopPrice or a stop-price parameter for a stop order").exchange(this.id);
    } else {
      const S = i === "sell" ? "lte" : "gte", b = this.safeString(r, "operator", S);
      if (u["stop-price"] = this.priceToPrecision(e, l), u.operator = b, f === "limit" || f === "limit-fok")
        f = "stop-" + f;
      else if (f !== "stop-limit" && f !== "stop-limit-fok")
        throw new ge(t).addMessage("createOrder() does not support " + t + " orders").exchange(this.id);
    }
    let p;
    [p, r] = this.handlePostOnly(f === "market", f === "limit-maker", r), p && (f = "limit-maker");
    const m = this.safeString(r, "timeInForce", "GTC");
    m === "FOK" ? f = f + "-fok" : m === "IOC" && (f = "ioc"), u.type = i + "-" + f;
    const y = this.safeString2(r, "clientOrderId", "client-order-id");
    if (y === void 0) {
      const S = this.safeValue(this.options, "broker", {}), b = this.safeString(S, "id");
      u["client-order-id"] = b + this.uuid();
    } else
      u["client-order-id"] = y;
    if (o === "cross" ? u.source = "super-margin-api" : o === "isolated" ? u.source = "margin-api" : o === "c2c" && (u.source = "c2c-margin-api"), f === "market" && i === "buy") {
      let S, b = !0;
      [b, r] = this.handleOptionAndParams(r, "createOrder", "createMarketBuyOrderRequiresPrice", !0);
      const T = this.safeNumber(r, "cost");
      if (r = this.omit(r, "cost"), T !== void 0)
        S = this.amountToPrecision(e, T);
      else if (b) {
        if (n === void 0)
          throw new g("createOrder() requires the price argument for market buy orders to calculate the total cost to spend (amount * price), alternatively set the createMarketBuyOrderRequiresPrice option or param to false and pass the cost to spend in the amount argument").exchange(this.id);
        {
          const x = this.numberToString(s), v = this.numberToString(n);
          S = this.costToPrecision(e, P.stringMul(x, v));
        }
      } else
        S = this.amountToPrecision(e, s);
      u.amount = S;
    } else
      u.amount = this.amountToPrecision(e, s);
    const w = this.safeValue(h, "limitOrderTypes", {});
    return f in w && (u.price = this.priceToPrecision(e, n)), r = this.omit(r, ["stopPrice", "stop-price", "clientOrderId", "client-order-id", "operator", "timeInForce"]), this.extend(u, r);
  }
  createContractOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const o = {
      contract_code: this.market(e).id,
      volume: this.amountToPrecision(e, s),
      direction: i
    };
    let c;
    [c, r] = this.handlePostOnly(t === "market", t === "post_only", r), c && (t = "post_only");
    const u = this.safeString(r, "timeInForce", "GTC");
    u === "FOK" ? t = "fok" : u === "IOC" && (t = "ioc");
    const f = this.safeNumber2(r, "stopPrice", "trigger_price"), h = this.safeNumber2(r, "stopLossPrice", "sl_trigger_price"), l = this.safeNumber2(r, "takeProfitPrice", "tp_trigger_price"), p = this.safeString2(r, "trailingPercent", "callback_rate"), m = this.safeNumber(r, "trailingTriggerPrice", n), y = p !== void 0, w = f !== void 0, S = h !== void 0, b = l !== void 0;
    if (w) {
      const v = this.safeString2(r, "triggerType", "trigger_type", "le");
      o.trigger_type = v, o.trigger_price = this.priceToPrecision(e, f), n !== void 0 && (o.order_price = this.priceToPrecision(e, n));
    } else if (S || b)
      S ? (o.sl_order_price_type = t, o.sl_trigger_price = this.priceToPrecision(e, h), n !== void 0 && (o.sl_order_price = this.priceToPrecision(e, n))) : (o.tp_order_price_type = t, o.tp_trigger_price = this.priceToPrecision(e, l), n !== void 0 && (o.tp_order_price = this.priceToPrecision(e, n)));
    else if (y) {
      const v = P.stringDiv(p, "100");
      o.callback_rate = this.parseToNumeric(v), o.active_price = m, o.order_price_type = this.safeString(r, "order_price_type", "formula_price");
    } else {
      const v = this.safeInteger2(r, "client_order_id", "clientOrderId");
      v !== void 0 && (o.client_order_id = v, r = this.omit(r, ["clientOrderId"])), (t === "limit" || t === "ioc" || t === "fok" || t === "post_only") && (o.price = this.priceToPrecision(e, n));
    }
    !S && !b && (this.safeValue2(r, "reduceOnly", "reduce_only", !1) && (o.reduce_only = 1), o.lever_rate = this.safeIntegerN(r, ["leverRate", "lever_rate", "leverage"], 1), y || (o.order_price_type = t));
    const T = this.safeValue(this.options, "broker", {}), x = this.safeString(T, "id");
    return o.channel_code = x, r = this.omit(r, ["reduceOnly", "stopPrice", "stopLossPrice", "takeProfitPrice", "triggerType", "leverRate", "timeInForce", "leverage", "trailingPercent", "trailingTriggerPrice"]), this.extend(o, r);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = this.safeNumber2(r, "stopPrice", "trigger_price"), c = this.safeNumber2(r, "stopLossPrice", "sl_trigger_price"), u = this.safeNumber2(r, "takeProfitPrice", "tp_trigger_price"), h = this.safeNumber(r, "trailingPercent") !== void 0, l = o !== void 0, p = c !== void 0, m = u !== void 0;
    let y;
    if (a.spot) {
      if (h)
        throw new k().addMessage("createOrder() does not support trailing orders for spot markets").exchange(this.id);
      const b = await this.createSpotOrderRequest(e, t, i, s, n, r);
      y = await this.spotPrivatePostV1OrderOrdersPlace(b);
    } else {
      let b = this.createContractOrderRequest(e, t, i, s, n, r);
      if (a.linear) {
        let T;
        [T, b] = this.handleMarginModeAndParams("createOrder", b), T = T === void 0 ? "cross" : T, T === "isolated" ? l ? y = await this.contractPrivatePostLinearSwapApiV1SwapTriggerOrder(b) : p || m ? y = await this.contractPrivatePostLinearSwapApiV1SwapTpslOrder(b) : h ? y = await this.contractPrivatePostLinearSwapApiV1SwapTrackOrder(b) : y = await this.contractPrivatePostLinearSwapApiV1SwapOrder(b) : T === "cross" && (l ? y = await this.contractPrivatePostLinearSwapApiV1SwapCrossTriggerOrder(b) : p || m ? y = await this.contractPrivatePostLinearSwapApiV1SwapCrossTpslOrder(b) : h ? y = await this.contractPrivatePostLinearSwapApiV1SwapCrossTrackOrder(b) : y = await this.contractPrivatePostLinearSwapApiV1SwapCrossOrder(b));
      } else
        a.inverse && (a.swap ? l ? y = await this.contractPrivatePostSwapApiV1SwapTriggerOrder(b) : p || m ? y = await this.contractPrivatePostSwapApiV1SwapTpslOrder(b) : h ? y = await this.contractPrivatePostSwapApiV1SwapTrackOrder(b) : y = await this.contractPrivatePostSwapApiV1SwapOrder(b) : a.future && (l ? y = await this.contractPrivatePostApiV1ContractTriggerOrder(b) : p || m ? y = await this.contractPrivatePostApiV1ContractTpslOrder(b) : h ? y = await this.contractPrivatePostApiV1ContractTrackOrder(b) : y = await this.contractPrivatePostApiV1ContractOrder(b)));
    }
    let w, S;
    return a.spot ? this.safeOrder({
      info: y,
      id: this.safeString(y, "data"),
      timestamp: void 0,
      datetime: void 0,
      lastTradeTimestamp: void 0,
      status: void 0,
      symbol: void 0,
      type: t,
      side: i,
      price: n,
      amount: s,
      filled: void 0,
      remaining: void 0,
      cost: void 0,
      trades: void 0,
      fee: void 0,
      clientOrderId: void 0,
      average: void 0
    }, a) : (p ? (w = this.safeValue(y, "data", {}), S = this.safeValue(w, "sl_order", {})) : m ? (w = this.safeValue(y, "data", {}), S = this.safeValue(w, "tp_order", {})) : S = this.safeValue(y, "data", {}), this.parseOrder(S, a));
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [];
    let s, n, r;
    for (let u = 0; u < e.length; u++) {
      const f = e[u], h = this.safeString(f, "symbol");
      if (s === void 0)
        s = h;
      else if (s !== h)
        throw new g("createOrders() requires all orders to have the same symbol").exchange(this.id);
      const l = this.safeString(f, "type"), p = this.safeString(f, "side"), m = this.safeValue(f, "amount"), y = this.safeValue(f, "price"), w = this.safeValue(f, "params", {}), b = this.handleMarginModeAndParams("createOrders", w)[0];
      if (b !== void 0) {
        if (r === void 0)
          r = b;
        else if (r !== b)
          throw new g("createOrders() requires all orders to have the same margin mode (isolated or cross)").exchange(this.id);
      }
      n = this.market(s);
      let T;
      n.spot ? T = await this.createSpotOrderRequest(h, l, p, m, y, w) : T = this.createContractOrderRequest(h, l, p, m, y, w), T = this.omit(T, "marginMode"), i.push(T);
    }
    const a = {};
    let o;
    n.spot ? o = await this.privatePostOrderBatchOrders(i) : (a.orders_data = i, n.linear ? (r = r === void 0 ? "cross" : r, r === "isolated" ? o = await this.contractPrivatePostLinearSwapApiV1SwapBatchorder(a) : r === "cross" && (o = await this.contractPrivatePostLinearSwapApiV1SwapCrossBatchorder(a))) : n.inverse && (n.swap ? o = await this.contractPrivatePostSwapApiV1SwapBatchorder(a) : n.future && (o = await this.contractPrivatePostApiV1ContractBatchorder(a))));
    let c;
    if (n.spot)
      c = this.safeValue(o, "data", []);
    else {
      const u = this.safeValue(o, "data", {}), f = this.safeValue(u, "success", []), h = this.safeValue(u, "errors", []);
      c = this.arrayConcat(f, h);
    }
    return this.parseOrders(c, n);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    t !== void 0 && (s = this.market(t));
    let n;
    [n, i] = this.handleMarketTypeAndParams("cancelOrder", s, i);
    const r = {
      // spot -----------------------------------------------------------
      // 'order-id': 'id',
      // 'symbol': market['id'],
      // 'client-order-id': clientOrderId,
      // contracts ------------------------------------------------------
      // 'order_id': id,
      // 'client_order_id': clientOrderId,
      // 'contract_code': market['id'],
      // 'pair': 'BTC-USDT',
      // 'contract_type': 'this_week', // swap, this_week, next_week, quarter, next_ quarter
    };
    let a;
    if (n === "spot") {
      const o = this.safeString2(i, "client-order-id", "clientOrderId");
      o === void 0 ? (r["order-id"] = e, a = await this.spotPrivatePostV1OrderOrdersOrderIdSubmitcancel(this.extend(r, i))) : (r["client-order-id"] = o, i = this.omit(i, ["client-order-id", "clientOrderId"]), a = await this.spotPrivatePostV1OrderOrdersSubmitCancelClientOrder(this.extend(r, i)));
    } else {
      if (t === void 0)
        throw new g("cancelOrder() requires a symbol argument").exchange(this.id);
      const o = this.safeString2(i, "client_order_id", "clientOrderId");
      o === void 0 ? r.order_id = e : (r.client_order_id = o, i = this.omit(i, ["client_order_id", "clientOrderId"])), s.future ? r.symbol = s.settleId : r.contract_code = s.id;
      const c = this.safeValue(i, "stop"), u = this.safeValue(i, "stopLossTakeProfit"), f = this.safeBool(i, "trailing", !1);
      if (i = this.omit(i, ["stop", "stopLossTakeProfit", "trailing"]), s.linear) {
        let h;
        [h, i] = this.handleMarginModeAndParams("cancelOrder", i), h = h === void 0 ? "cross" : h, h === "isolated" ? c ? a = await this.contractPrivatePostLinearSwapApiV1SwapTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostLinearSwapApiV1SwapTpslCancel(this.extend(r, i)) : f ? a = await this.contractPrivatePostLinearSwapApiV1SwapTrackCancel(this.extend(r, i)) : a = await this.contractPrivatePostLinearSwapApiV1SwapCancel(this.extend(r, i)) : h === "cross" && (c ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTpslCancel(this.extend(r, i)) : f ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTrackCancel(this.extend(r, i)) : a = await this.contractPrivatePostLinearSwapApiV1SwapCrossCancel(this.extend(r, i)));
      } else if (s.inverse)
        s.swap ? c ? a = await this.contractPrivatePostSwapApiV1SwapTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostSwapApiV1SwapTpslCancel(this.extend(r, i)) : f ? a = await this.contractPrivatePostSwapApiV1SwapTrackCancel(this.extend(r, i)) : a = await this.contractPrivatePostSwapApiV1SwapCancel(this.extend(r, i)) : s.future && (c ? a = await this.contractPrivatePostApiV1ContractTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostApiV1ContractTpslCancel(this.extend(r, i)) : f ? a = await this.contractPrivatePostApiV1ContractTrackCancel(this.extend(r, i)) : a = await this.contractPrivatePostApiV1ContractCancel(this.extend(r, i)));
      else
        throw new ge(n).exchange(this.id);
    }
    return this.extend(this.parseOrder(a, s), {
      id: e,
      status: "canceled"
    });
  }
  async cancelOrders(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    t !== void 0 && (s = this.market(t));
    let n;
    [n, i] = this.handleMarketTypeAndParams("cancelOrders", s, i);
    const r = {
      // spot -----------------------------------------------------------
      // 'order-ids': ids.join (','), // max 50
      // 'client-order-ids': ids.join (','), // max 50
      // contracts ------------------------------------------------------
      // 'order_id': id, // comma separated, max 10
      // 'client_order_id': clientOrderId, // comma separated, max 10
      // 'contract_code': market['id'],
      // 'symbol': market['settleId'],
    };
    let a;
    if (n === "spot") {
      let o = this.safeValue2(i, "client-order-id", "clientOrderId");
      o = this.safeValue2(i, "client-order-ids", "clientOrderIds", o), o === void 0 ? typeof o == "string" ? r["order-ids"] = [e] : r["order-ids"] = e : (typeof o == "string" ? r["client-order-ids"] = [o] : r["client-order-ids"] = o, i = this.omit(i, ["client-order-id", "client-order-ids", "clientOrderId", "clientOrderIds"])), a = await this.spotPrivatePostV1OrderOrdersBatchcancel(this.extend(r, i));
    } else {
      if (t === void 0)
        throw new g("cancelOrders() requires a symbol argument").exchange(this.id);
      let o = this.safeString2(i, "client_order_id", "clientOrderId");
      o = this.safeString2(i, "client_order_ids", "clientOrderIds", o), o === void 0 ? r.order_id = e.join(",") : (r.client_order_id = o, i = this.omit(i, ["client_order_id", "client_order_ids", "clientOrderId", "clientOrderIds"])), s.future ? r.symbol = s.settleId : r.contract_code = s.id;
      const c = this.safeValue(i, "stop"), u = this.safeValue(i, "stopLossTakeProfit");
      if (i = this.omit(i, ["stop", "stopLossTakeProfit"]), s.linear) {
        let f;
        [f, i] = this.handleMarginModeAndParams("cancelOrders", i), f = f === void 0 ? "cross" : f, f === "isolated" ? c ? a = await this.contractPrivatePostLinearSwapApiV1SwapTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostLinearSwapApiV1SwapTpslCancel(this.extend(r, i)) : a = await this.contractPrivatePostLinearSwapApiV1SwapCancel(this.extend(r, i)) : f === "cross" && (c ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostLinearSwapApiV1SwapCrossTpslCancel(this.extend(r, i)) : a = await this.contractPrivatePostLinearSwapApiV1SwapCrossCancel(this.extend(r, i)));
      } else if (s.inverse)
        s.swap ? c ? a = await this.contractPrivatePostSwapApiV1SwapTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostSwapApiV1SwapTpslCancel(this.extend(r, i)) : a = await this.contractPrivatePostSwapApiV1SwapCancel(this.extend(r, i)) : s.future && (c ? a = await this.contractPrivatePostApiV1ContractTriggerCancel(this.extend(r, i)) : u ? a = await this.contractPrivatePostApiV1ContractTpslCancel(this.extend(r, i)) : a = await this.contractPrivatePostApiV1ContractCancel(this.extend(r, i)));
      else
        throw new ge(n).exchange(this.id);
    }
    return a;
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    let i;
    e !== void 0 && (i = this.market(e));
    let s;
    [s, t] = this.handleMarketTypeAndParams("cancelAllOrders", i, t);
    const n = {
      // spot -----------------------------------------------------------
      // 'account-id': account['id'],
      // 'symbol': market['id'], // a list of comma-separated symbols, all symbols by default
      // 'types' 'string', buy-market, sell-market, buy-limit, sell-limit, buy-ioc, sell-ioc, buy-stop-limit, sell-stop-limit, buy-limit-fok, sell-limit-fok, buy-stop-limit-fok, sell-stop-limit-fok
      // 'side': 'buy', // or 'sell'
      // 'size': 100, // the number of orders to cancel 1-100
      // contract -------------------------------------------------------
      // 'symbol': market['settleId'], // required
      // 'contract_code': market['id'],
      // 'contract_type': 'this_week', // swap, this_week, next_week, quarter, next_ quarter
      // 'direction': 'buy': // buy, sell
      // 'offset': 'open', // open, close
    };
    let r;
    if (s === "spot")
      e !== void 0 && (n.symbol = i.id), r = await this.spotPrivatePostV1OrderOrdersBatchCancelOpenOrders(this.extend(n, t));
    else {
      if (e === void 0)
        throw new g("cancelAllOrders() requires a symbol argument").exchange(this.id);
      i.future && (n.symbol = i.settleId), n.contract_code = i.id;
      const a = this.safeValue(t, "stop"), o = this.safeValue(t, "stopLossTakeProfit"), c = this.safeBool(t, "trailing", !1);
      if (t = this.omit(t, ["stop", "stopLossTakeProfit", "trailing"]), i.linear) {
        let u;
        [u, t] = this.handleMarginModeAndParams("cancelAllOrders", t), u = u === void 0 ? "cross" : u, u === "isolated" ? a ? r = await this.contractPrivatePostLinearSwapApiV1SwapTriggerCancelall(this.extend(n, t)) : o ? r = await this.contractPrivatePostLinearSwapApiV1SwapTpslCancelall(this.extend(n, t)) : c ? r = await this.contractPrivatePostLinearSwapApiV1SwapTrackCancelall(this.extend(n, t)) : r = await this.contractPrivatePostLinearSwapApiV1SwapCancelall(this.extend(n, t)) : u === "cross" && (a ? r = await this.contractPrivatePostLinearSwapApiV1SwapCrossTriggerCancelall(this.extend(n, t)) : o ? r = await this.contractPrivatePostLinearSwapApiV1SwapCrossTpslCancelall(this.extend(n, t)) : c ? r = await this.contractPrivatePostLinearSwapApiV1SwapCrossTrackCancelall(this.extend(n, t)) : r = await this.contractPrivatePostLinearSwapApiV1SwapCrossCancelall(this.extend(n, t)));
      } else if (i.inverse)
        i.swap ? a ? r = await this.contractPrivatePostSwapApiV1SwapTriggerCancelall(this.extend(n, t)) : o ? r = await this.contractPrivatePostSwapApiV1SwapTpslCancelall(this.extend(n, t)) : c ? r = await this.contractPrivatePostSwapApiV1SwapTrackCancelall(this.extend(n, t)) : r = await this.contractPrivatePostSwapApiV1SwapCancelall(this.extend(n, t)) : i.future && (a ? r = await this.contractPrivatePostApiV1ContractTriggerCancelall(this.extend(n, t)) : o ? r = await this.contractPrivatePostApiV1ContractTpslCancelall(this.extend(n, t)) : c ? r = await this.contractPrivatePostApiV1ContractTrackCancelall(this.extend(n, t)) : r = await this.contractPrivatePostApiV1ContractCancelall(this.extend(n, t)));
      else
        throw new ge(s).exchange(this.id);
    }
    return r;
  }
  parseDepositAddress(e, t = void 0) {
    const i = this.safeString(e, "address"), s = this.safeString(e, "addressTag"), n = this.safeString(e, "currency");
    t = this.safeCurrency(n, t);
    const r = this.safeCurrencyCode(n, t), a = this.safeString(e, "note"), o = this.safeString(e, "chain");
    return this.checkAddress(i), {
      currency: r,
      address: i,
      tag: s,
      network: this.networkIdToEcid(o),
      note: a,
      info: e
    };
  }
  async fetchDepositAddressesByNetwork(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = {
      currency: i.id
    }, n = await this.spotPrivateGetV2AccountDepositAddress(this.extend(s, t)), r = this.safeValue(n, "data", []), a = this.parseDepositAddresses(r, [i.code], !1);
    return this.indexBy(a, "network");
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const [i, s] = this.handleEcidAndParams(t);
    return (await this.fetchDepositAddressesByNetwork(e, s))[i];
  }
  async fetchWithdrawAddresses(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.currency(e), r = {
      currency: n.id
    }, a = await this.spotPrivateGetV2AccountWithdrawAddress(this.extend(r, s)), o = this.safeValue(a, "data", []), c = this.parseDepositAddresses(o, [n.code], !1), u = [];
    for (let f = 0; f < c.length; f++) {
      const h = c[f], l = t === void 0 || h.note === t, p = i === void 0 || h.network === i;
      l && p && u.push(h);
    }
    return u;
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    (i === void 0 || i > 100) && (i = 100), await this.loadMarkets();
    let n;
    e !== void 0 && (n = this.currency(e));
    const r = {
      type: "deposit",
      direct: "next",
      from: 0
      // From 'id' ... if you want to get results after a particular transaction id, pass the id in params.from
    };
    n !== void 0 && (r.currency = n.id), i !== void 0 && (r.size = i);
    const a = await this.spotPrivateGetV1QueryDepositWithdraw(this.extend(r, s));
    return this.parseTransactions(a.data, n, t, i);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    (i === void 0 || i > 100) && (i = 100), await this.loadMarkets();
    let n;
    e !== void 0 && (n = this.currency(e));
    const r = {
      type: "withdraw",
      direct: "next",
      from: 0
      // From 'id' ... if you want to get results after a particular transaction id, pass the id in params.from
    };
    n !== void 0 && (r.currency = n.id), i !== void 0 && (r.size = i);
    const a = await this.spotPrivateGetV1QueryDepositWithdraw(this.extend(r, s));
    return this.parseTransactions(a.data, n, t, i);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeInteger(e, "created-at"), s = this.safeCurrencyCode(this.safeString(e, "currency"));
    let n = this.safeString(e, "type");
    n === "withdraw" && (n = "withdrawal");
    let r = this.safeString(e, "fee");
    r !== void 0 && (r = P.stringAbs(r));
    const a = this.safeString(e, "chain");
    let o = this.safeString(e, "tx-hash");
    a === "ETH" && o.indexOf("0x") < 0 && (o = "0x" + o);
    const u = this.safeString(e, "sub-type") === "FAST";
    return {
      info: e,
      id: this.safeString2(e, "id", "data"),
      txid: o,
      timestamp: i,
      datetime: this.iso8601(i),
      network: this.networkIdToEcid(a),
      address: this.safeString(e, "address"),
      addressTo: void 0,
      addressFrom: void 0,
      tag: this.safeString(e, "address-tag"),
      tagTo: void 0,
      tagFrom: void 0,
      type: n,
      amount: this.safeNumber(e, "amount"),
      currency: s,
      status: this.parseTransactionStatus(this.safeString(e, "state")),
      updated: this.safeInteger(e, "updated-at"),
      comment: void 0,
      internal: u,
      fee: {
        currency: s,
        cost: this.parseNumber(r),
        rate: void 0
      }
    };
  }
  parseTransactionStatus(e) {
    const t = {
      // deposit statuses
      unknown: "failed",
      confirming: "pending",
      confirmed: "ok",
      safe: "ok",
      orphan: "failed",
      // withdrawal statuses
      submitted: "pending",
      canceled: "canceled",
      reexamine: "pending",
      reject: "failed",
      pass: "pending",
      "wallet-reject": "failed",
      // 'confirmed': 'ok', // present in deposit statuses
      "confirm-error": "failed",
      repealed: "failed",
      "wallet-transfer": "pending",
      "pre-transfer": "pending"
    };
    return this.safeString(t, e, e);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), await this.loadMarkets(), this.checkAddress(i);
    const r = this.currency(e), a = {
      address: i,
      currency: r.id.toLowerCase()
    };
    s !== void 0 && (a["addr-tag"] = s);
    let o;
    [o, n] = this.handleEcidAndParams(n), o !== void 0 && (a.chain = this.ecidToNetworkId(o, e)), t = this.currencyToPrecision(e, t, o);
    const c = this.safeValue(this.options, "withdraw", {});
    if (this.safeBool(c, "includeFee", !1)) {
      let f = this.safeNumber(n, "fee");
      if (f === void 0) {
        const y = await this.fetchCurrencies();
        this.currencies = this.deepExtend(this.currencies, y);
        const w = this.safeValue(r.networks, o, {});
        if (f = this.safeNumber(w, "fee"), f === void 0)
          throw new ke().addMessage('withdraw() function can not find withdraw fee for chosen network. You need to re-load markets with "exchange.loadMarkets(true)", or provide the "fee" parameter').exchange(this.id);
      }
      const h = this.currencyToPrecision(e, f, o);
      n = this.omit(n, "fee");
      const l = this.numberToString(t), p = P.stringSub(l, h), m = parseFloat(p);
      a.fee = parseFloat(h), t = parseFloat(this.currencyToPrecision(e, m, o));
    }
    a.amount = t;
    const u = await this.spotPrivatePostV1DwWithdrawApiCreate(this.extend(a, n));
    return this.parseTransaction(u, r);
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeString(e, "data"), s = this.safeCurrencyCode(void 0, t);
    return {
      info: e,
      id: i,
      timestamp: void 0,
      datetime: void 0,
      currency: s,
      amount: void 0,
      fromAccount: void 0,
      toAccount: void 0,
      status: void 0
    };
  }
  // https://www.htx.com/en-us/opend/newApiPages/?id=7ec4b62b-7773-11ed-9966-0242ac110003
  async fetchSubAccountBalances(e, t = {}) {
    await this.loadMarkets();
    const i = await this.privateGetAccountAccountsSubUid({
      "sub-uid": e
    }), s = this.safeValue(i, "data"), n = {};
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeValue(a, "list", []);
      for (let c = 0; c < o.length; c++) {
        const u = o[c], f = this.safeString(u, "currency"), h = this.safeCurrencyCode(f), l = this.safeString(a, "type"), p = this.safeValue(this.options, "accountsById", {}), m = this.safeValue(p, l, l);
        m in n || (n[m] = {}), n[m][h] = {
          free: this.safeString(u, "available"),
          used: this.safeString(u, "debt"),
          total: this.safeString(u, "balance")
        };
      }
    }
    return n;
  }
  // https://www.htx.com/en-us/opend/newApiPages/?id=7ec52a87-7773-11ed-9966-0242ac110003
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.v2PrivateGetSubUserUserList();
    return this.safeValue(e, "data").map((i) => ({
      uid: i.uid
    }));
  }
  async subAccountTransfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = i === "master" ? "master-transfer-out" : "master-transfer-in", o = i === "master" ? s : i, c = {
      currency: r.id,
      amount: parseFloat(this.currencyToPrecision(e, t)),
      type: a,
      "sub-uid": o
    }, u = await this.privatePostSubuserTransfer(this.extend(c, n));
    return {
      transferId: this.safeValue(u, "data")
    };
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = {
      currency: r.id,
      amount: parseFloat(this.currencyToPrecision(e, t))
    };
    let o;
    [o, n] = this.handleSubTypeAndParams("transfer", void 0, n);
    let c = this.convertTypeToAccount(i), u = this.convertTypeToAccount(s);
    const f = u === "cross", h = c === "cross", l = this.inArray(u, this.ids), p = this.inArray(c, this.ids), m = c === "pro", y = u === "pro";
    if (m && y)
      throw new je().addMessage("Cannot make a transfer between " + i + " and " + s).exchange(this.id);
    const w = c === "futures" || u === "futures";
    let S;
    if (w) {
      let b = c + "-to-" + u;
      b = this.safeString(n, "type", b), a.type = b, S = await this.spotPrivatePostV1FuturesTransfer(this.extend(a, n));
    } else if (m && f)
      S = await this.privatePostCrossMarginTransferIn(this.extend(a, n));
    else if (h && y)
      S = await this.privatePostCrossMarginTransferOut(this.extend(a, n));
    else if (m && l)
      a.symbol = u, S = await this.privatePostDwTransferInMargin(this.extend(a, n));
    else if (p && y)
      a.symbol = c, S = await this.privatePostDwTransferOutMargin(this.extend(a, n));
    else {
      if (o === "linear") {
        c === "swap" || i === "linear-swap" ? c = "linear-swap" : u = "linear-swap";
        let b = this.safeString(n, "symbol");
        n = this.omit(n, "symbol"), b !== void 0 ? (b = this.marketId(b), a["margin-account"] = b) : a["margin-account"] = "USDT";
      }
      a.from = m ? "spot" : c, a.to = y ? "spot" : u, S = await this.v2PrivatePostAccountTransfer(this.extend(a, n));
    }
    return this.parseTransfer(S, r);
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    let a = "/";
    const o = this.omit(s, this.extractParams(e));
    if (typeof t == "string") {
      if (t === "public" || t === "private" ? a += this.version : (t === "v2Public" || t === "v2Private") && (a += "v2"), a += "/" + this.implodeParams(e, s), t === "private" || t === "v2Private") {
        this.checkRequiredCredentials();
        const c = this.ymdhms(this.nonce(), "T");
        let u = {
          SignatureMethod: "HmacSHA256",
          SignatureVersion: "2",
          AccessKeyId: this.apiKey,
          Timestamp: c
        };
        i !== "POST" && (u = this.extend(u, o));
        const f = this.keysort(u);
        let h = this.urlencode(f);
        const l = [i, this.hostname, a, h].join(`
`);
        let p;
        this.externalSigner ? p = await this.externalSigner.sign({
          payload: this.encode(l),
          publicApiKey: this.apiKey,
          exchangeId: "huobi"
          // @todo replace by the id once migrated from ccxt to sdk exchange id
        }) : p = this.hmac(this.encode(l), this.encode(this.secret), Re, "base64"), h += "&" + this.urlencode({ Signature: p }), a += "?" + h, i === "POST" ? (r = this.json(o), n = {
          "Content-Type": "application/json"
        }) : n = {
          "Content-Type": "application/x-www-form-urlencoded"
        };
      } else
        Object.keys(o).length && (a += "?" + this.urlencode(o));
      a = this.implodeParams(this.urls.api[t], {
        hostname: this.hostname
      }) + a;
    } else {
      const c = this.safeString(t, 0), u = this.safeString(t, 1), f = this.safeString(t, 2), h = this.safeString(t, 3);
      let l, p = this.safeValue(this.urls.hostnames, c);
      if (typeof p != "string" && (p = this.safeValue(p, f), typeof p != "string" && h !== void 0 && (p = this.safeValue(p, h))), l = p, a += this.implodeParams(e, s), u === "public")
        Object.keys(o).length && (a += "?" + this.urlencode(o));
      else if (u === "private") {
        if (this.checkRequiredCredentials(), i === "POST") {
          const T = this.safeValue(this.options, "broker", {}), x = this.safeString(T, "id", "AA03022abc");
          e.indexOf("cancel") === -1 && e.endsWith("order") ? this.safeString(s, "channel_code") === void 0 && (s.channel_code = x) : e.endsWith("orders/place") && this.safeString(s, "client-order-id") === void 0 && (s["client-order-id"] = x + this.uuid());
        }
        const m = this.ymdhms(this.nonce(), "T");
        let y = {
          SignatureMethod: "HmacSHA256",
          SignatureVersion: "2",
          AccessKeyId: this.apiKey,
          Timestamp: m
        };
        i !== "POST" && (y = this.extend(y, o)), y = this.keysort(y);
        let w = this.urlencode(y);
        const S = [i, l, a, w].join(`
`);
        let b;
        this.externalSigner ? b = await this.externalSigner.sign({
          payload: this.encode(S),
          publicApiKey: this.apiKey,
          exchangeId: "huobi"
          // @todo replace by the id once migrated from ccxt to sdk exchange id
        }) : b = this.hmac(this.encode(S), this.encode(this.secret), Re, "base64"), w += "&" + this.urlencode({ Signature: b }), a += "?" + w, i === "POST" ? (r = this.json(o), r.length === 2 && (r = "{}"), n = {
          "Content-Type": "application/json"
        }) : n = {
          "Content-Type": "application/x-www-form-urlencoded"
        };
      }
      a = this.implodeParams(this.urls.api[c], {
        hostname: l
      }) + a;
    }
    return { url: a, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (a !== void 0) {
      if ("status" in a && this.safeString(a, "status") === "error") {
        const f = this.safeString2(a, "err-code", "err_code"), h = this.safeString2(a, "err-msg", "err_msg"), l = f + ": " + h;
        throw this.throwBroadlyMatchedException(this.exceptions.broad, r, l), this.throwExactlyMatchedException(this.exceptions.exact, f, l), this.throwExactlyMatchedException(this.exceptions.exact, h, l), new O().addMessage(l).exchange(this.id);
      }
      if ("code" in a) {
        const u = this.safeString(a, "code"), f = this.safeString(a, "message"), h = u + ": " + f;
        this.throwExactlyMatchedException(this.exceptions.exact, u, h);
      }
    }
  }
  parsePosition(e, t = void 0) {
    t = this.safeMarket(this.safeString(e, "contract_code"));
    const i = t.symbol, s = this.safeString(e, "volume"), n = this.safeValue(t, "contractSize"), r = this.numberToString(n), a = this.safeNumber(e, "cost_open"), o = this.safeString(e, "position_margin"), u = this.safeString(e, "direction") === "buy" ? "long" : "short", f = this.safeNumber(e, "profit_unreal");
    let h = this.safeString(e, "margin_mode");
    const l = this.safeString(e, "lever_rate"), p = P.stringMul(this.safeString(e, "profit_rate"), "100"), m = this.safeString(e, "last_price"), y = P.stringMul(s, r);
    let w;
    t.linear ? w = P.stringMul(y, m) : (w = P.stringDiv(y, m), h = "cross");
    const S = P.stringDiv(o, w), b = this.safeString(e, "margin_balance"), T = this.safeNumber(e, "liquidation_price"), x = this.safeString(e, "adjust_factor"), v = P.stringDiv(x, l), _ = P.stringMul(v, w), V = P.stringDiv(_, b);
    return this.safePosition({
      info: e,
      id: void 0,
      symbol: i,
      contracts: this.parseNumber(s),
      contractSize: n,
      entryPrice: a,
      collateral: this.parseNumber(b),
      side: u,
      unrealizedPnl: f,
      leverage: this.parseNumber(l),
      percentage: this.parseNumber(p),
      marginMode: h,
      notional: this.parseNumber(w),
      markPrice: void 0,
      lastPrice: void 0,
      liquidationPrice: T,
      initialMargin: this.parseNumber(o),
      initialMarginPercentage: this.parseNumber(S),
      maintenanceMargin: this.parseNumber(_),
      maintenanceMarginPercentage: this.parseNumber(v),
      marginRatio: this.parseNumber(V),
      timestamp: void 0,
      datetime: void 0,
      hedged: void 0,
      lastUpdateTimestamp: void 0,
      stopLossPrice: void 0,
      takeProfitPrice: void 0
    });
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    let i;
    if (e !== void 0) {
      const f = this.safeString(e, 0);
      i = this.market(f);
    }
    let s;
    [s, t] = this.handleMarginModeAndParams("fetchPositions", t, "cross");
    let n;
    [n, t] = this.handleSubTypeAndParams("fetchPositions", i, t, "linear");
    let r;
    [r, t] = this.handleMarketTypeAndParams("fetchPositions", i, t), r === "spot" && (r = "future");
    let a;
    if (n === "linear")
      if (s === "isolated")
        a = await this.contractPrivatePostLinearSwapApiV1SwapPositionInfo(t);
      else if (s === "cross")
        a = await this.contractPrivatePostLinearSwapApiV1SwapCrossPositionInfo(t);
      else
        throw new ge(s).exchange(this.id);
    else if (r === "future")
      a = await this.contractPrivatePostApiV1ContractPositionInfo(t);
    else if (r === "swap")
      a = await this.contractPrivatePostSwapApiV1SwapPositionInfo(t);
    else
      throw new ge(r).exchange(this.id);
    const o = this.safeValue(a, "data", []), c = this.safeInteger(a, "ts"), u = [];
    for (let f = 0; f < o.length; f++) {
      const h = o[f], l = this.parsePosition(h);
      u.push(this.extend(l, {
        timestamp: c,
        datetime: this.iso8601(c)
      }));
    }
    return this.filterByArrayPositions(u, "symbol", e, !1);
  }
  async fetchPosition(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e);
    let s;
    [s, t] = this.handleMarginModeAndParams("fetchPosition", t), s = s === void 0 ? "cross" : s;
    const [n, r] = this.handleMarketTypeAndParams("fetchPosition", i, t), a = {};
    i.future && i.inverse ? a.symbol = i.settleId : (s === "cross" && (a.margin_account = "USDT"), a.contract_code = i.id);
    let o;
    if (i.linear)
      if (s === "isolated")
        o = await this.contractPrivatePostLinearSwapApiV1SwapAccountPositionInfo(this.extend(a, r));
      else if (s === "cross")
        o = await this.contractPrivatePostLinearSwapApiV1SwapCrossAccountPositionInfo(this.extend(a, r));
      else
        throw new ge(s).exchange(this.id);
    else if (n === "future")
      o = await this.contractPrivatePostApiV1ContractAccountPositionInfo(this.extend(a, r));
    else if (n === "swap")
      o = await this.contractPrivatePostSwapApiV1SwapAccountPositionInfo(this.extend(a, r));
    else
      throw new ge(n).exchange(this.id);
    const c = this.safeValue(o, "data");
    let u;
    s === "cross" ? u = c : u = this.safeValue(c, 0);
    const f = this.omit(u, ["positions"]), h = this.safeValue(u, "positions");
    let l;
    if (i.future && i.inverse)
      for (let y = 0; y < h.length; y++) {
        const w = h[y];
        if (w.contract_code === i.id) {
          l = w;
          break;
        }
      }
    else
      l = this.safeValue(h, 0);
    const p = this.safeInteger(o, "ts"), m = this.parsePosition(this.extend(l, f));
    return m.timestamp = p, m.datetime = this.iso8601(p), m;
  }
  parseLedgerEntryType(e) {
    const t = {
      trade: "trade",
      etf: "trade",
      "transact-fee": "fee",
      "fee-deduction": "fee",
      transfer: "transfer",
      credit: "credit",
      liquidation: "trade",
      interest: "credit",
      deposit: "deposit",
      withdraw: "withdrawal",
      "withdraw-fee": "fee",
      exchange: "exchange",
      "other-types": "transfer",
      rebate: "rebate"
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeString(e, "transactId"), s = this.safeString(e, "currency"), n = this.safeCurrencyCode(s, t), r = this.safeNumber(e, "transactAmt"), a = this.safeString(e, "transferType"), o = this.parseLedgerEntryType(a), c = this.safeString(e, "direction"), u = this.safeInteger(e, "transactTime"), f = this.iso8601(u), h = this.safeString(e, "accountId");
    return {
      id: i,
      direction: c,
      account: h,
      referenceId: i,
      referenceAccount: h,
      type: o,
      currency: n,
      amount: r,
      timestamp: u,
      datetime: f,
      before: void 0,
      after: void 0,
      status: void 0,
      fee: void 0,
      info: e
    };
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchLedger", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchLedger", e, t, i, s, 500);
    let a = {
      accountId: await this.fetchAccountIdByType("spot", void 0, void 0, s)
      // 'currency': code,
      // 'transactTypes': 'all', // default all
      // 'startTime': 1546272000000,
      // 'endTime': 1546272000000,
      // 'sort': asc, // asc, desc
      // 'limit': 100, // range 1-500
      // 'fromId': 323 // first record ID in this query for pagination
    }, o;
    e !== void 0 && (o = this.currency(e), a.currency = o.id), t !== void 0 && (a.startTime = t), i !== void 0 && (a.limit = i), [a, s] = this.handleUntilOption("endTime", a, s);
    const c = await this.spotPrivateGetV2AccountLedger(this.extend(a, s)), u = this.safeValue(c, "data", []);
    return this.parseLedger(u, o, t, i);
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.spotPublicGetV2ReferenceCurrencies(t), s = this.safeValue(i, "data");
    return this.parseDepositWithdrawFees(s, e, "currency");
  }
  parseDepositWithdrawFee(e, t = void 0) {
    const i = this.safeValue(e, "chains", []);
    let s = this.depositWithdrawFee(e);
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "chain"), o = this.safeString(r, "withdrawFeeType"), c = this.networkIdToEcid(a);
      let u, f;
      o === "fixed" ? (u = this.safeNumber(r, "transactFeeWithdraw"), f = {
        fee: u,
        percentage: !1
      }) : (u = this.safeNumber(r, "transactFeeRateWithdraw"), f = {
        fee: u,
        percentage: !0
      }), s.networks[c] = {
        withdraw: f,
        deposit: {
          fee: void 0,
          percentage: void 0
        }
      }, s = this.assignDefaultDepositWithdrawFees(s, t);
    }
    return s;
  }
  async loadMarketsHelper(e, t) {
    var i, s;
    await super.loadMarketsHelper(e, t), this.options.ecidByChainIds = (i = await this.cache.get(fd(this.id), { clone: !1 })) == null ? void 0 : i.data, this.options.chainIdbyEcids = (s = await this.cache.get(ud(this.id), { clone: !1 })) == null ? void 0 : s.data;
  }
}
let nw = class extends gt {
};
class rw extends nw {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "kraken",
      name: "Kraken",
      countries: ["US"],
      version: "0",
      rateLimit: 3e3,
      certified: !1,
      pro: !0,
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !1,
        future: !1,
        option: !1,
        cancelAllOrders: !0,
        cancelOrder: !0,
        cancelOrders: !0,
        createDepositAddress: !0,
        createOrder: !0,
        createTrailingAmountOrder: !0,
        editOrder: !0,
        fetchBalance: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDepositAddress: !0,
        fetchDeposits: !0,
        fetchLedger: !0,
        fetchLedgerEntry: !0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrderTrades: "emulated",
        fetchPositions: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !1,
        fetchWithdrawals: !0,
        transfer: !0,
        withdraw: !0
      },
      timeframes: {
        "1m": 1,
        "5m": 5,
        "15m": 15,
        "30m": 30,
        "1h": 60,
        "4h": 240,
        "1d": 1440,
        "1w": 10080,
        "2w": 21600
      },
      urls: {
        logo: "https://user-images.githubusercontent.com/51840849/76173629-fc67fb00-61b1-11ea-84fe-f2de582f58a3.jpg",
        api: {
          public: "https://api.kraken.com",
          private: "https://api.kraken.com",
          zendesk: "https://kraken.zendesk.com/api/v2/help_center/en-us/articles"
          // use the public zendesk api to receive article bodies and bypass new anti-spam protections
        },
        www: "https://www.kraken.com",
        doc: "https://docs.kraken.com/rest/",
        fees: "https://www.kraken.com/en-us/features/fee-schedule"
      },
      fees: {
        trading: {
          tierBased: !0,
          percentage: !0,
          taker: this.parseNumber("0.0026"),
          maker: this.parseNumber("0.0016"),
          tiers: {
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.0026")],
              [this.parseNumber("50000"), this.parseNumber("0.0024")],
              [this.parseNumber("100000"), this.parseNumber("0.0022")],
              [this.parseNumber("250000"), this.parseNumber("0.0020")],
              [this.parseNumber("500000"), this.parseNumber("0.0018")],
              [this.parseNumber("1000000"), this.parseNumber("0.0016")],
              [this.parseNumber("2500000"), this.parseNumber("0.0014")],
              [this.parseNumber("5000000"), this.parseNumber("0.0012")],
              [this.parseNumber("10000000"), this.parseNumber("0.0001")]
            ],
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.0016")],
              [this.parseNumber("50000"), this.parseNumber("0.0014")],
              [this.parseNumber("100000"), this.parseNumber("0.0012")],
              [this.parseNumber("250000"), this.parseNumber("0.0010")],
              [this.parseNumber("500000"), this.parseNumber("0.0008")],
              [this.parseNumber("1000000"), this.parseNumber("0.0006")],
              [this.parseNumber("2500000"), this.parseNumber("0.0004")],
              [this.parseNumber("5000000"), this.parseNumber("0.0002")],
              [this.parseNumber("10000000"), this.parseNumber("0.0")]
            ]
          }
        }
      },
      handleContentTypeApplicationZip: !0,
      api: {
        zendesk: {
          get: [
            // we should really refrain from putting fixed fee numbers and stop hardcoding
            // we will be using their web APIs to scrape all numbers from these articles
            "360000292886",
            "201893608"
            // -What-are-the-withdrawal-fees-
          ]
        },
        public: {
          get: {
            // public endpoint rate-limits are described in article: https://support.kraken.com/hc/en-us/articles/206548367-What-are-the-API-rate-limits-#1
            Assets: 1,
            AssetPairs: 1,
            Depth: 1,
            OHLC: 1,
            Spread: 1,
            SystemStatus: 1,
            Ticker: 1,
            Time: 1,
            Trades: 1
          }
        },
        private: {
          post: {
            AddOrder: 0,
            AddOrderBatch: 0,
            AddExport: 1,
            Balance: 1,
            CancelAll: 1,
            CancelAllOrdersAfter: 1,
            CancelOrder: 0,
            CancelOrderBatch: 0,
            ClosedOrders: 1,
            DepositAddresses: 1,
            DepositMethods: 1,
            DepositStatus: 1,
            EditOrder: 0,
            ExportStatus: 1,
            GetWebSocketsToken: 1,
            Ledgers: 2,
            OpenOrders: 1,
            OpenPositions: 1,
            QueryLedgers: 1,
            QueryOrders: 1,
            QueryTrades: 1,
            RetrieveExport: 1,
            RemoveExport: 1,
            BalanceEx: 1,
            TradeBalance: 1,
            TradesHistory: 2,
            TradeVolume: 1,
            Withdraw: 1,
            WithdrawCancel: 1,
            WithdrawInfo: 1,
            WithdrawMethods: 1,
            WithdrawAddresses: 1,
            WithdrawStatus: 1,
            WalletTransfer: 1,
            // sub accounts
            CreateSubaccount: 1,
            AccountTransfer: 1,
            // earn
            "Earn/Allocate": 1,
            "Earn/Deallocate": 1,
            "Earn/AllocateStatus": 1,
            "Earn/DeallocateStatus": 1,
            "Earn/Strategies": 1,
            "Earn/Allocations": 1
          }
        }
      },
      options: {
        marketsByAltname: {},
        timeDifference: 0,
        delistedMarketsById: {},
        // cannot withdraw/deposit these
        inactiveCurrencies: ["CAD", "USD", "JPY", "GBP"],
        networks: {
          ETH: "ERC20",
          TRX: "TRC20"
        },
        // used for deposit methods since they are different from withdrawal methods sometimes
        hardCodedMethodsToEcid: {
          "Ethereum (ERC20)": "Ethereum",
          "1INCH - Ethereum (Unified)": "Ethereum",
          "AAVE - Ethereum (Unified)": "Ethereum",
          "ACH - Ethereum (Unified)": "Ethereum",
          "ADX - Ethereum (Unified)": "Ethereum",
          "AGLD - Ethereum (Unified)": "Ethereum",
          "ALCX - Ethereum (Unified)": "Ethereum",
          "ALICE - Ethereum (Unified)": "Ethereum",
          "ALPHA - Ethereum (Unified)": "Ethereum",
          "ANKR - Ethereum (Unified)": "Ethereum",
          "Link - Ethereum (Unified)": "Ethereum",
          "Marinade SOL (mSOL)": "Solana",
          "ETHW  - Ethereum PoW (Unified)": "Ethereum PoW",
          "REPv2 - Ethereum (Unified)": "Ethereum",
          "TRC20 (USDC)": "Tron",
          "USDC.e - Polygon (Unified)": "Polygon (USDC.e)",
          "USDC - Optimism (Unified)": "Optimism",
          "USDC - Arbitrum One (Unified)": "Arbitrum One",
          "USDC - Polygon (Unified)": "Polygon",
          "USDC.e - Arbitrum One (Unified)": "Arbitrum One (USDC.e)",
          "USDC.e - Optimism (Unified)": "Optimism (USDC.e)"
        },
        withdrawalNetworks: [],
        currenciesNetworks: {}
      },
      precisionMode: ct,
      exceptions: {
        exact: {
          "EQuery:Invalid asset pair": it,
          "EAPI:Invalid key": Z,
          "EFunding:Unknown withdraw key": et,
          "EFunding:Invalid amount": re,
          "EFunding:Fee amount is greater than asset amount": Xt,
          "EService:Unavailable": Te,
          "EDatabase:Internal error": Te,
          "EService:Busy": Te,
          "EQuery:Unknown asset": $e,
          "EAPI:Rate limit exceeded": Rt,
          "EOrder:Rate limit exceeded": Rt,
          "EGeneral:Internal error": Te,
          "EGeneral:Temporary lockout": Rt,
          "EGeneral:Permission denied": ee,
          "EOrder:Unknown order": k,
          "EOrder:Order minimum not met": g,
          "EGeneral:Invalid arguments": g,
          "ESession:Invalid session": Z,
          "EAPI:Invalid nonce": ze,
          "EFunding:No funding method": O,
          "EFunding:Unknown asset": $e,
          "EService:Market in post_only mode": dt,
          "EGeneral:Too many requests": Rt,
          "ETrade:User Locked": Ee
          // {"error":["ETrade:User Locked"]}
        },
        broad: {
          "Invalid order": g,
          "Invalid nonce": ze,
          "Insufficient funds": re,
          "Cancel pending": O,
          "Invalid arguments:volume": g,
          "Rate limit exceeded": Rt
        },
        messages: {
          "EGeneral:Invalid arguments:volume": ye.ORDER_UNDER_MINIMUM
        }
      }
    });
  }
  feeToPrecision(e, t) {
    return this.decimalToPrecision(t, Et, this.markets[e].precision.amount, this.precisionMode);
  }
  async fetchMarkets(e = {}) {
    const t = await this.publicGetAssetPairs(e), i = this.safeValue(t, "result", {}), s = Object.keys(i);
    let n = [];
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = i[a], c = this.safeString(o, "base"), u = this.safeString(o, "quote"), f = this.safeCurrencyCode(c), h = this.safeCurrencyCode(u), l = a.indexOf(".d") >= 0, p = this.safeString(o, "altname"), m = this.safeValue(o, "fees_maker", []), y = this.safeValue(m, 0, []), w = this.safeString(y, 1);
      let S;
      w !== void 0 && (S = this.parseNumber(P.stringDiv(w, "100")));
      const b = this.safeValue(o, "fees", []), T = this.safeValue(b, 0, []), x = this.safeString(T, 1);
      let v;
      x !== void 0 && (v = this.parseNumber(P.stringDiv(x, "100")));
      const _ = this.safeValue(o, "leverage_buy", []), V = _.length, j = this.parseNumber(this.parsePrecision(this.safeString(o, "pair_decimals")));
      n.push({
        id: a,
        wsId: this.safeString(o, "wsname"),
        symbol: l ? p : f + "/" + h,
        base: f,
        quote: h,
        settle: void 0,
        baseId: c,
        quoteId: u,
        settleId: void 0,
        darkpool: l,
        altname: o.altname,
        type: "spot",
        spot: !0,
        margin: V > 0,
        swap: !1,
        future: !1,
        option: !1,
        active: !0,
        contract: !1,
        linear: void 0,
        inverse: void 0,
        taker: v,
        maker: S,
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.parseNumber(this.parsePrecision(this.safeString(o, "lot_decimals"))),
          price: j
        },
        limits: {
          leverage: {
            min: this.parseNumber("1"),
            max: this.safeNumber(_, V - 1, 1)
          },
          amount: {
            min: this.safeNumber(o, "ordermin"),
            max: void 0
          },
          price: {
            min: j,
            max: void 0
          },
          cost: {
            min: this.safeNumber(o, "costmin"),
            max: void 0
          }
        },
        created: void 0,
        info: o
      });
    }
    return n = this.appendInactiveMarkets(n), this.options.marketsByAltname = this.indexBy(n, "altname"), n;
  }
  safeCurrency(e, t = void 0) {
    if (e !== void 0 && e.length > 3 && (e.indexOf("X") === 0 || e.indexOf("Z") === 0)) {
      if (e.indexOf(".") > 0)
        return super.safeCurrency(e, t);
      e = e.slice(1);
    }
    return super.safeCurrency(e, t);
  }
  appendInactiveMarkets(e) {
    const t = {
      amount: this.parseNumber("1e-8"),
      price: this.parseNumber("1e-8")
    }, i = { min: void 0, max: void 0 }, s = { min: t.price, max: void 0 }, r = { amount: { min: t.amount, max: void 0 }, price: s, cost: i }, a = {
      darkpool: !1,
      info: void 0,
      maker: void 0,
      taker: void 0,
      active: !1,
      precision: t,
      limits: r
    }, o = [
      // { 'id': 'XXLMZEUR', 'symbol': 'XLM/EUR', 'base': 'XLM', 'quote': 'EUR', 'altname': 'XLMEUR' },
    ];
    for (let c = 0; c < o.length; c++)
      e.push(this.extend(a, o[c]));
    return e;
  }
  async fetchStatus(e = {}) {
    const t = await this.publicGetSystemStatus(e), i = this.safeValue(t, "result", {}), s = this.safeString(i, "status"), n = this.safeString({ online: "ok", maintenance: "maintenance", cancel_only: "maintenance", post_only: "maintenance" }, s, "maintenance"), r = this.parse8601(this.safeString(i, "timestamp"));
    return {
      status: n,
      updated: r,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchWithdrawalMethods() {
    let e = this.safeValue(this.options, "withdrawalNetworks", []);
    if (e.length === 0 && this.checkRequiredCredentials(!1))
      try {
        const i = await this.privatePostWithdrawMethods();
        this.handleErrors(null, null, null, null, null, {}, i, null, null), e = this.safeValue(i, "result", []), this.options.withdrawalNetworks = e;
      } catch (i) {
        if (i instanceof ee)
          return [];
        throw i;
      }
    this.options.methodsByEcids = {}, this.options.ecidsByMethods = {};
    const t = {};
    for (let i = 0; i < e.length; i++) {
      const s = this.safeValue(e, i), n = this.safeString(s, "asset"), r = this.safeCurrencyCode(n), a = {
        info: s,
        network: this.safeString(s, "network"),
        withdraw: {
          min: this.parseNumber(this.safeString(s, "minimum")),
          max: void 0
        },
        withdraw_enabled: !0
      };
      this.options.methodsByEcids[r] = this.safeValue(this.options.methodsByEcids, r, {}), this.options.ecidsByMethods[r] = this.safeValue(this.options.ecidsByMethods, r, {});
      const o = this.safeString(a.info, "method");
      this.options.methodsByEcids[r][a.network] = o, this.options.ecidsByMethods[r][o] = a.network;
      const c = this.safeValue(t, r, []);
      c.push(a), t[r] = c;
    }
    return this.options.currenciesNetworks = t, e;
  }
  async fetchCurrencies(e = {}) {
    const t = await this.publicGetAssets(e);
    await this.fetchWithdrawalMethods();
    const i = this.safeValue(t, "result", {}), s = Object.keys(i), n = {};
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = i[a], c = this.safeCurrencyCode(this.safeString(o, "altname")), u = this.parseNumber(this.parsePrecision(this.safeString(o, "decimals"))), f = this.safeString(o, "status"), h = f === "enabled" || f === "deposit_only", l = f === "enabled" || f === "withdrawal_only", p = this.safeValue(this.options, "currenciesNetworks", {}), m = this.safeValue(p, c, []);
      n[c] = {
        id: a,
        code: c,
        info: o,
        name: c,
        active: h && l,
        deposit: h,
        withdraw: l,
        fee: void 0,
        precision: u,
        limits: {
          amount: {
            min: u,
            max: void 0
          },
          withdraw: {
            min: void 0,
            max: void 0
          }
        },
        networks: m
      };
    }
    return n;
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      pair: i.id,
      "fee-info": !0
    }, n = await this.privatePostTradeVolume(this.extend(s, t)), r = this.safeValue(n, "result", {});
    return this.parseTradingFee(r, i);
  }
  async getWhitelistedAddresses(e) {
    await this.loadMarkets();
    const t = await this.privatePostWithdrawAddresses(e), i = [];
    return this.safeValue(t, "result", []).forEach((n) => {
      const r = this.safeString(n, "asset"), a = this.safeString(n, "method"), o = this.safeCurrencyCode(r), c = this.methodToEcid(a, o);
      i.push({
        address: this.safeString(n, "address"),
        asset: o,
        method: a,
        key: this.safeString(n, "key"),
        verified: this.safeValue(n, "verified"),
        network: c
      });
    }), i;
  }
  methodToEcid(e, t) {
    if (Object.keys(this.options.ecidsByMethods).length === 0)
      throw new bs().addMessage("methodToEcid() - markets need to be loaded at first").exchange(this.id);
    const n = this.safeValue(this.options.ecidsByMethods, t, {});
    let r = this.safeValue(n, e);
    if (r || (r = this.safeValue(this.options.hardCodedMethodsToEcid, e)), !r) {
      const a = e.replace(/\s*\((Unified|Hex)\)/g, "").trim();
      r = this.safeValue(n, a);
    }
    if (!r) {
      const a = e.replace(/\s*\((Unified|Hex)\)/g, "").replace(`${t} -`, "").trim();
      r = this.safeValue(n, a);
    }
    if (!r) {
      const a = this.options.withdrawalNetworks;
      for (let o = 0; o < a.length; o++) {
        const c = this.safeValue(a, o), u = this.safeString(c, "asset"), f = this.safeCurrencyCode(u), h = this.safeString(c, "network"), l = e.replace(/\s*\((Unified|Hex)\)/g, "").trim();
        if (`${f} - ${h}` === l) {
          r = h;
          break;
        }
      }
    }
    if (!r) {
      const a = e.replace(`${t} -`, "").trim();
      r = this.safeValue(this.options.hardCodedMethodsToEcid, a);
    }
    return r;
  }
  parseTradingFee(e, t) {
    const i = this.safeValue(e, "fees_maker", {}), s = this.safeValue(e, "fees", {}), n = this.safeValue(i, t.id, {}), r = this.safeValue(s, t.id, {});
    return {
      info: e,
      symbol: t.symbol,
      maker: this.safeNumber(n, "fee"),
      taker: this.safeNumber(r, "fee"),
      percentage: !0,
      tierBased: !0
    };
  }
  parseBidAsk(e, t = 0, i = 1, s = 2) {
    const n = this.safeNumber(e, t), r = this.safeNumber(e, i), a = this.safeInteger(e, 2);
    return [n, r, a];
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (s.darkpool)
      throw new ge("darkpool").addMessage(" fetchOrderBook() does not provide an order book for darkpool symbol " + e).exchange(this.id);
    const n = {
      pair: s.id
    };
    t !== void 0 && (n.count = t);
    const r = await this.publicGetDepth(this.extend(n, i)), a = this.safeValue(r, "result", {});
    let o = this.safeValue(a, s.id);
    const c = this.safeValue(s, "info", {}), u = this.safeValue(c, "wsname");
    return u !== void 0 && (o = this.safeValue(a, u, o)), this.parseOrderBook(o, e);
  }
  parseTicker(e, t = void 0) {
    const i = this.safeSymbol(void 0, t), s = this.safeValue(e, "v", []), n = this.safeString(s, 1), r = this.safeValue(e, "p", []), a = this.safeString(r, 1), o = P.stringMul(n, a), c = this.safeValue(e, "c", []), u = this.safeString(c, 0), f = this.safeValue(e, "h", []), h = this.safeValue(e, "l", []), l = this.safeValue(e, "b", []), p = this.safeValue(e, "a", []);
    return this.safeTicker({
      symbol: i,
      timestamp: void 0,
      datetime: void 0,
      high: this.safeString(f, 1),
      low: this.safeString(h, 1),
      bid: this.safeString(l, 0),
      bidVolume: void 0,
      ask: this.safeString(p, 0),
      askVolume: void 0,
      vwap: a,
      open: this.safeString(e, "o"),
      close: u,
      last: u,
      previousClose: void 0,
      change: void 0,
      percentage: void 0,
      average: void 0,
      baseVolume: n,
      quoteVolume: o,
      info: e
    }, t);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {};
    if (e !== void 0) {
      e = this.marketSymbols(e);
      const o = [];
      for (let c = 0; c < e.length; c++) {
        const u = e[c], f = this.markets[u];
        f.active && !f.darkpool && o.push(f.id);
      }
      i.pair = o.join(",");
    }
    const n = (await this.publicGetTicker(this.extend(i, t))).result, r = Object.keys(n), a = {};
    for (let o = 0; o < r.length; o++) {
      const c = r[o], u = this.safeMarket(c), f = u.symbol, h = n[c];
      a[f] = this.parseTicker(h, u);
    }
    return this.filterByArrayTickers(a, "symbol", e);
  }
  async fetchTicker(e, t = {}) {
    if (await this.loadMarkets(), e.indexOf(".d") >= 0)
      throw new k().addMessage("fetchTicker() does not provide a ticker for darkpool symbol " + e).exchange(this.id);
    const s = this.market(e), n = {
      pair: s.id
    }, a = (await this.publicGetTicker(this.extend(n, t))).result[s.id];
    return this.parseTicker(a, s);
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeTimestamp(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 2),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 6)
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 720);
    const a = this.market(e), o = this.safeInteger(this.timeframes, t), c = {
      pair: a.id
    };
    o !== void 0 ? c.interval = o : c.interval = t, i !== void 0 && (c.since = this.numberToString(i) + "000000");
    const u = await this.publicGetOHLC(this.extend(c, n)), f = this.safeValue(u, "result", {}), h = this.safeValue(f, a.id, []);
    return this.parseOHLCVs(h, a, t, i, s);
  }
  parseLedgerEntryType(e) {
    const t = {
      trade: "trade",
      withdrawal: "transaction",
      deposit: "transaction",
      transfer: "transfer",
      margin: "margin"
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeString(e, "id");
    let s;
    const n = void 0, r = this.safeString(e, "refid"), a = void 0, o = this.parseLedgerEntryType(this.safeString(e, "type")), c = this.safeCurrencyCode(this.safeString(e, "asset"), t);
    let u = this.safeString(e, "amount");
    P.stringLt(u, "0") ? (s = "out", u = P.stringAbs(u)) : s = "in";
    const f = this.safeTimestamp(e, "time");
    return {
      info: e,
      id: i,
      direction: s,
      account: n,
      referenceId: r,
      referenceAccount: a,
      type: o,
      currency: c,
      amount: this.parseNumber(u),
      before: void 0,
      after: this.safeNumber(e, "balance"),
      status: "ok",
      timestamp: f,
      datetime: this.iso8601(f),
      fee: {
        cost: this.safeNumber(e, "fee"),
        currency: c
      }
    };
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = {}, r;
    e !== void 0 && (r = this.currency(e), n.asset = r.id), t !== void 0 && (n.start = this.parseToInt(t / 1e3)), [n, s] = this.handleUntilOption("end", n, s);
    const a = await this.privatePostLedgers(this.extend(n, s)), o = this.safeValue(a, "result", {}), c = this.safeValue(o, "ledger", {}), u = Object.keys(c), f = [];
    for (let h = 0; h < u.length; h++) {
      const l = u[h], p = c[l];
      p.id = l, f.push(p);
    }
    return this.parseLedger(f, r, t, i);
  }
  async fetchLedgerEntriesByIds(e, t = void 0, i = {}) {
    await this.loadMarkets(), e = e.join(",");
    const s = this.extend({
      id: e
    }, i), r = (await this.privatePostQueryLedgers(s)).result, a = Object.keys(r), o = [];
    for (let c = 0; c < a.length; c++) {
      const u = a[c], f = r[u];
      f.id = u, o.push(f);
    }
    return this.parseLedger(o);
  }
  async fetchLedgerEntry(e, t = void 0, i = {}) {
    return (await this.fetchLedgerEntriesByIds([e], t, i))[0];
  }
  parseTrade(e, t = void 0) {
    let i, s, n, r, a, o, c, u, f;
    if (Array.isArray(e))
      i = this.safeTimestamp(e, 2), s = e[3] === "s" ? "sell" : "buy", n = e[4] === "l" ? "limit" : "market", r = this.safeString(e, 0), a = this.safeString(e, 1), e.length > 6 && (o = this.safeString(e, 6));
    else if (typeof e == "string")
      o = e;
    else if ("ordertxid" in e) {
      const l = this.safeString(e, "pair"), p = this.findMarketByAltnameOrId(l);
      if (p !== void 0 ? t = p : l !== void 0 && (t = this.getDelistedMarketById(l)), c = this.safeString(e, "ordertxid"), o = this.safeString2(e, "id", "postxid"), i = this.safeTimestamp(e, "time"), s = this.safeString(e, "type"), n = this.safeString(e, "ordertype"), r = this.safeString(e, "price"), a = this.safeString(e, "vol"), "fee" in e) {
        let m;
        t !== void 0 && (m = t.quote), u = {
          cost: this.safeString(e, "fee"),
          currency: m
        };
      }
    }
    t !== void 0 && (f = t.symbol);
    const h = this.safeString(e, "cost");
    return this.safeTrade({
      id: o,
      order: c,
      info: e,
      timestamp: i,
      datetime: this.iso8601(i),
      symbol: f,
      type: n,
      side: s,
      takerOrMaker: void 0,
      price: r,
      amount: a,
      cost: h,
      fee: u
    }, t);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.market(e), r = n.id, a = {
      pair: r
    };
    t !== void 0 && (a.since = t * 1e6, a.since = t.toString() + "000000"), i !== void 0 && (a.count = i);
    const c = (await this.publicGetTrades(this.extend(a, s))).result, u = c[r], f = u.length;
    if (f <= 0)
      return [];
    const h = u[f - 1], l = this.safeString(c, "last");
    return h.push(l), this.parseTrades(u, n, t, i);
  }
  parseBalanceCustom(e, t) {
    const i = {
      info: e,
      timestamp: void 0,
      datetime: void 0
    }, s = this.safeValue(e, "result", {});
    if (t === "earn") {
      const n = this.safeValue(s, "items", []);
      for (let r = 0; r < n.length; r++) {
        const a = n[r], o = this.safeValue(a, "native_asset"), c = this.safeValue(a, "amount_allocated"), u = this.safeValue(a, "total_rewarded"), f = this.safeValue(c, "total"), h = this.safeNumber(f, "native"), l = this.safeNumber(u, "native"), p = h + l, m = this.safeCurrencyCode(o);
        i[m] = {
          free: 0,
          used: p,
          total: p
        };
      }
    } else {
      const n = Object.keys(s);
      for (let r = 0; r < n.length; r++) {
        const a = n[r], o = this.safeCurrencyCode(a), c = s[a], u = this.safeNumber(c, "balance", 0), f = this.safeNumber(c, "credit", 0), h = this.safeNumber(c, "credit_used", 0), l = this.safeNumber(c, "hold_trade", 0), p = this.safeNumber(c, "debt", 0), m = u + f - h - l, y = l + h, w = m + y;
        i[o] = {
          free: m,
          used: y,
          total: w,
          debt: p
        };
      }
    }
    return this.safeBalance(i);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const t = this.safeString(e, "type", "spot");
    let i;
    return t === "earn" ? i = await this.privatePostEarnAllocations(e) : i = await this.privatePostBalanceEx(e), this.parseBalanceCustom(i, t);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const o = {
      pair: this.market(e).id,
      type: i,
      ordertype: t,
      volume: this.amountToPrecision(e, s)
    }, c = this.orderRequest("createOrder()", e, t, o, n, r), u = await this.privatePostAddOrder(this.extend(c[0], c[1])), f = this.safeValue(u, "result");
    return this.parseOrder(f);
  }
  findMarketByAltnameOrId(e) {
    const t = this.safeValue(this.options, "marketsByAltname", {});
    return e in t ? t[e] : this.safeMarket(e);
  }
  getDelistedMarketById(e) {
    if (e === void 0)
      return e;
    let t = this.safeValue(this.options.delistedMarketsById, e);
    if (t !== void 0)
      return t;
    const i = 0;
    let s = 3, n = 3, r = 6;
    e.length === 8 ? (s = 4, n = 4, r = 8) : e.length === 7 && (s = 4, n = 4, r = 7);
    const a = e.slice(i, s), o = e.slice(n, r), c = this.safeCurrencyCode(a), u = this.safeCurrencyCode(o);
    return t = {
      symbol: c + "/" + u,
      base: c,
      quote: u,
      baseId: a,
      quoteId: o
    }, this.options.delistedMarketsById[e] = t, t;
  }
  parseOrderStatus(e) {
    const t = {
      pending: "open",
      open: "open",
      closed: "closed",
      canceled: "canceled",
      expired: "expired"
    };
    return this.safeString(t, e, e);
  }
  parseOrderType(e) {
    const t = {
      "take-profit": "market",
      "stop-loss-limit": "limit",
      "stop-loss": "market",
      "take-profit-limit": "limit",
      "trailing-stop-limit": "limit"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    const i = this.safeValue(e, "descr", {}), s = this.safeString(i, "order", i);
    let n, r, a, o, c, u;
    if (s !== void 0) {
      const G = s.split(" ");
      n = this.safeString(G, 0), c = this.safeString(G, 1), a = this.safeString(G, 2), r = this.safeString(G, 4), r === "stop" ? (u = this.safeString(G, 6), o = this.safeString(G, 9)) : r === "limit" && (o = this.safeString(G, 5));
    }
    n = this.safeString(i, "type", n), r = this.safeString(i, "ordertype", r), a = this.safeString(i, "pair", a);
    const f = this.findMarketByAltnameOrId(a);
    let h;
    f !== void 0 ? t = f : a !== void 0 && (t = this.getDelistedMarketById(a));
    const l = this.safeTimestamp(e, "opentm");
    c = this.safeString(e, "vol", c);
    const p = this.safeString(e, "vol_exec");
    let m;
    o = this.safeString(i, "price", o), o !== void 0 && o.endsWith("%") && (o = void 0), (o === void 0 || P.stringEquals(o, "0")) && (o = this.safeString(i, "price2")), (o === void 0 || P.stringEquals(o, "0")) && (o = this.safeString(e, "price", o));
    const y = this.safeString(e, "oflags", ""), w = y.indexOf("post") > -1, S = this.safeNumber(e, "price");
    t !== void 0 && (h = t.symbol, "fee" in e && (m = {
      cost: this.safeString(e, "fee"),
      rate: void 0
    }, y.indexOf("fciq") >= 0 ? m.currency = t.quote : y.indexOf("fcib") >= 0 && (m.currency = t.base)));
    const b = this.parseOrderStatus(this.safeString(e, "status"));
    let T = this.safeString2(e, "id", "txid");
    if (T === void 0 || T.slice(0, 1) === "[") {
      const G = this.safeValue(e, "txid");
      T = this.safeString(G, 0);
    }
    const x = this.safeString(e, "userref"), v = this.safeValue(e, "trades", []), _ = [];
    for (let G = 0; G < v.length; G++) {
      const W = v[G];
      typeof W == "string" ? _.push(this.safeTrade({ id: W, orderId: T, symbol: h, info: {} })) : _.push(W);
    }
    u = this.omitZero(this.safeString(e, "stopprice", u));
    let V, j;
    return r.startsWith("take-profit") ? (j = this.safeString(i, "price"), o = this.omitZero(this.safeString(i, "price2"))) : r.startsWith("stop-loss") && (V = this.safeString(i, "price"), o = this.omitZero(this.safeString(i, "price2"))), this.safeOrder({
      id: T,
      clientOrderId: x,
      info: e,
      timestamp: l,
      datetime: this.iso8601(l),
      lastTradeTimestamp: void 0,
      status: b,
      symbol: h,
      type: this.parseOrderType(r),
      timeInForce: void 0,
      postOnly: w,
      side: n,
      price: o,
      stopPrice: u,
      triggerPrice: u,
      takeProfitPrice: j,
      stopLossPrice: V,
      cost: void 0,
      amount: c,
      filled: p,
      average: S,
      remaining: void 0,
      fee: m,
      trades: _
    }, t);
  }
  orderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.safeString2(r, "userref", "clientOrderId");
    r = this.omit(r, ["userref", "clientOrderId"]), a !== void 0 && (s.userref = a);
    const o = this.safeString(r, "stopLossPrice"), c = this.safeString(r, "takeProfitPrice"), u = o !== void 0, f = c !== void 0, h = u || f, l = this.safeString(r, "trailingAmount"), p = this.safeString(r, "trailingLimitAmount"), m = l !== void 0, y = i.endsWith("limit");
    y && !m && (s.price = this.priceToPrecision(t, n));
    const w = this.safeValue2(r, "reduceOnly", "reduce_only");
    if (h)
      u ? (s.price = this.priceToPrecision(t, o), y ? s.ordertype = "stop-loss-limit" : s.ordertype = "stop-loss") : f && (s.price = this.priceToPrecision(t, c), y ? s.ordertype = "take-profit-limit" : s.ordertype = "take-profit"), y && (s.price2 = this.priceToPrecision(t, n));
    else if (m) {
      const v = this.safeString(r, "trigger", "last"), _ = "+" + l;
      if (s.trigger = v, y || p !== void 0) {
        const j = this.safeString(r, "offset", "-") + this.numberToString(p);
        s.price = _, s.price2 = j, s.ordertype = "trailing-stop-limit";
      } else
        s.price = _, s.ordertype = "trailing-stop";
    }
    w && (s.reduce_only = "true");
    let S = this.safeValue(r, "close");
    if (S !== void 0) {
      S = this.extend({}, S);
      const v = this.safeValue(S, "price");
      v !== void 0 && (S.price = this.priceToPrecision(t, v));
      const _ = this.safeValue(S, "price2");
      _ !== void 0 && (S.price2 = this.priceToPrecision(t, _)), s.close = S;
    }
    const b = this.safeString2(r, "timeInForce", "timeinforce");
    b !== void 0 && (s.timeinforce = b);
    const T = i === "market";
    let x;
    return [x, r] = this.handlePostOnly(T, !1, r), x && (s.oflags = "post"), r = this.omit(r, ["timeInForce", "reduceOnly", "stopLossPrice", "takeProfitPrice", "trailingAmount", "trailingLimitAmount", "offset"]), [s, r];
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t);
    if (!o.spot)
      throw new ge(o.type).addMessage("Only spot orders are accepted").exchange(this.id);
    const c = {
      txid: e,
      pair: o.id
    };
    n !== void 0 && (c.volume = this.amountToPrecision(t, n));
    const u = this.orderRequest("editOrder()", t, i, c, r, a), f = await this.privatePostEditOrder(this.extend(u[0], u[1])), h = this.safeValue(f, "result", {});
    return this.parseOrder(h, o);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.safeValue2(i, "userref", "clientOrderId"), n = {
      trades: !0
      // whether or not to include trades in output (optional, default false)
      // 'txid': id, // do not comma separate a list of ids - use fetchOrdersByIds instead
      // 'userref': 'optional', // restrict results to given user reference id (optional)
    };
    let r = i;
    s !== void 0 ? (n.userref = s, r = this.omit(i, ["userref", "clientOrderId"])) : n.txid = e;
    const a = await this.privatePostQueryOrders(this.extend(n, r)), o = this.safeValue(a, "result", []);
    if (!(e in o))
      throw new Se().addMessage("fetchOrder() could not find order id " + e).exchange(this.id);
    return this.parseOrder(this.extend({ id: e }, o[e]));
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    const r = this.safeValue(n, "trades"), a = [];
    if (r === void 0)
      throw new g("fetchOrderTrades() requires a unified order structure in the params argument or a 'trades' param (an array of trade id strings)").exchange(this.id);
    for (let l = 0; l < r.length; l++) {
      const p = r[l];
      typeof p == "string" ? a.push(p) : a.push(p.id);
    }
    await this.loadMarkets(), t !== void 0 && (t = this.symbol(t));
    const o = this.safeValue(this.options, "fetchOrderTrades", {}), c = this.safeInteger(o, "batchSize", 20), u = a.length;
    let f = this.parseToInt(u / c);
    f = this.sum(f, 1);
    let h = [];
    for (let l = 0; l < f; l++) {
      const p = [];
      for (let x = 0; x < c; x++) {
        const v = this.sum(l * c, x);
        v < u && p.push(a[v]);
      }
      const m = {
        txid: p.join(",")
      }, y = await this.privatePostQueryTrades(m), w = this.safeValue(y, "result"), S = Object.keys(w);
      for (let x = 0; x < S.length; x++)
        w[S[x]].id = S[x];
      const b = this.parseTrades(w, void 0, i, s), T = this.filterBySymbol(b, t);
      h = this.arrayConcat(h, T);
    }
    return h;
  }
  async fetchOrdersByIds(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = await this.privatePostQueryOrders(this.extend({
      trades: !0,
      txid: e.join(",")
      // comma delimited list of transaction ids to query info about (20 maximum)
    }, i)), n = this.safeValue(s, "result", {}), r = [], a = Object.keys(n);
    for (let o = 0; o < a.length; o++) {
      const c = a[o], u = n[c], f = this.parseOrder(this.extend({ id: c }, u));
      r.push(f);
    }
    return r;
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {
      // 'type': 'all', // any position, closed position, closing position, no position
      // 'trades': false, // whether or not to include trades related to position in output
      // 'start': 1234567890, // starting unix timestamp or trade tx id of results (exclusive)
      // 'end': 1234567890, // ending unix timestamp or trade tx id of results (inclusive)
      // 'ofs' = result offset
    };
    t !== void 0 && (n.start = this.parseToInt(t / 1e3));
    const a = (await this.privatePostTradesHistory(this.extend(n, s))).result.trades, o = Object.keys(a);
    for (let u = 0; u < o.length; u++)
      a[o[u]].id = o[u];
    let c;
    return e !== void 0 && (c = this.market(e)), this.parseTrades(a, c, t, i);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    const r = {
      txid: this.safeValue2(i, "userref", "clientOrderId", e)
      // order id or userref
    };
    i = this.omit(i, ["userref", "clientOrderId"]);
    try {
      s = await this.privatePostCancelOrder(this.extend(r, i));
    } catch (a) {
      throw this.last_http_response && this.last_http_response.indexOf("EOrder:Unknown order") >= 0 ? new Se().addMessage(this.last_http_response).exchange(this.id) : a;
    }
    return s;
  }
  async cancelOrders(e, t = void 0, i = {}) {
    const s = {
      orders: e
    };
    return await this.privatePostCancelOrderBatch(this.extend(s, i));
  }
  async cancelAllOrders(e = void 0, t = {}) {
    return await this.loadMarkets(), await this.privatePostCancelAll(t);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    t !== void 0 && (n.start = this.parseToInt(t / 1e3));
    let r = s;
    const a = this.safeValue2(s, "userref", "clientOrderId");
    a !== void 0 && (n.userref = a, r = this.omit(s, ["userref", "clientOrderId"]));
    const o = await this.privatePostOpenOrders(this.extend(n, r));
    let c;
    e !== void 0 && (c = this.market(e));
    const u = this.safeValue(o, "result", {}), f = this.safeValue(u, "open", []);
    return this.parseOrders(f, c, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = {};
    t !== void 0 && (n.start = this.parseToInt(t / 1e3));
    let r = s;
    const a = this.safeValue2(s, "userref", "clientOrderId");
    a !== void 0 && (n.userref = a, r = this.omit(s, ["userref", "clientOrderId"])), [n, s] = this.handleUntilOption("end", n, s);
    const o = await this.privatePostClosedOrders(this.extend(n, r));
    let c;
    e !== void 0 && (c = this.market(e));
    const u = this.safeValue(o, "result", {}), f = this.safeValue(u, "closed", []);
    return this.parseOrders(f, c, t, i);
  }
  parseTransactionStatus(e) {
    const t = {
      Initial: "pending",
      Pending: "pending",
      Success: "ok",
      Settled: "pending",
      Failure: "failed",
      Partial: "ok"
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString(e, "refid"), s = this.safeString(e, "txid"), n = this.safeTimestamp(e, "time"), r = this.safeString(e, "asset"), a = this.safeCurrencyCode(r, t), o = this.safeString(e, "info"), c = this.safeNumber(e, "amount");
    let u = this.safeString(e, "network");
    const f = this.safeString(e, "method");
    f !== void 0 && (u = this.methodToEcid(f, a));
    let h = this.parseTransactionStatus(this.safeString(e, "status"));
    const l = this.safeString(e, "status-prop");
    (l === "on-hold" || l === "cancel-pending" || l === "onhold") && (h = "pending");
    const w = this.safeString(e, "type");
    let S = this.safeNumber(e, "fee");
    return S === void 0 && w === "deposit" && (S = 0), {
      info: e,
      id: i,
      currency: a,
      amount: c,
      network: u,
      address: o,
      addressTo: void 0,
      addressFrom: void 0,
      tag: void 0,
      tagTo: void 0,
      tagFrom: void 0,
      status: h,
      type: w,
      updated: void 0,
      txid: s,
      timestamp: n,
      datetime: this.iso8601(n),
      comment: void 0,
      internal: void 0,
      fee: {
        currency: a,
        cost: S
      }
    };
  }
  parseTransactionsByType(e, t, i = void 0, s = void 0, n = void 0) {
    const r = [];
    for (let a = 0; a < t.length; a++) {
      const o = this.parseTransaction(this.extend({
        type: e
      }, t[a]));
      r.push(o);
    }
    return this.filterByCurrencySinceLimit(r, i, s, n);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchDeposits() requires a currency code argument").exchange(this.id);
    await this.loadMarkets();
    const r = {
      asset: this.currency(e).id
    };
    t !== void 0 && (r.start = t);
    const a = await this.privatePostDepositStatus(this.extend(r, s));
    return this.parseTransactionsByType("deposit", a.result, e, t, i);
  }
  async fetchTime(e = {}) {
    const t = await this.publicGetTime(e), i = this.safeValue(t, "result", {});
    return this.safeTimestamp(i, "unixtime");
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchWithdrawals", "paginate"), n)
      return s.cursor = !0, await this.fetchPaginatedCallCursor("fetchWithdrawals", e, t, i, s, "next_cursor", "cursor");
    const r = {};
    if (e !== void 0) {
      const u = this.currency(e);
      r.asset = u.id;
    }
    t !== void 0 && (r.since = t.toString());
    const a = await this.privatePostWithdrawStatus(this.extend(r, s));
    let o;
    const c = this.safeValue(a, "result");
    return Array.isArray(c) ? o = c : o = this.addPaginationCursorToResult(c), this.parseTransactionsByType("withdrawal", o, e, t, i);
  }
  addPaginationCursorToResult(e) {
    const t = this.safeString(e, "next_cursor"), i = this.safeValue(e, "withdrawals"), s = i.length;
    if (t !== void 0 && s > 0) {
      const n = i[s - 1];
      n.next_cursor = t, i[s - 1] = n;
    }
    return i;
  }
  async createDepositAddress(e, t = {}) {
    const i = {
      new: "true"
    };
    return await this.fetchDepositAddress(e, this.extend(i, t));
  }
  async fetchDepositMethods(e, t = {}) {
    var o, c;
    await this.loadMarkets();
    const s = {
      asset: this.currency(e).id
    }, n = await this.privatePostDepositMethods(this.extend(s, t)), r = this.safeValue(n, "result", []), a = [];
    for (let u = 0; u < r.length; u++) {
      const f = this.safeValue(r, u, {}), h = this.safeString(f, "method"), l = this.safeString2(f, "address-setup-fee", "fee"), p = this.safeValue(f, "limit"), m = this.methodToEcid(h, e);
      m === void 0 && ((c = (o = this.options) == null ? void 0 : o.report) == null || c.call(o, "unmapped_network", {
        method: h,
        tokenSymbol: e
      })), a.push({
        method: h,
        network: m,
        fee: l,
        limit: p,
        info: f
      });
    }
    return a;
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = this.safeValue(t, "network");
    if (!s)
      throw new g("network parameter is required").exchange(this.id);
    const r = (await this.fetchDepositMethods(e)).filter((l) => this.safeString(l, "network") === s), a = this.safeValue(r, 0, void 0);
    if (!a)
      throw new It(e, s).exchange(this.id);
    const o = this.safeString(a, "method"), c = {
      asset: i.id,
      method: o
    }, u = await this.privatePostDepositAddresses(this.extend(c, t)), f = this.safeValue(u, "result", []), h = this.safeValue(f, 0, {});
    if (h === void 0)
      throw new It(e, s).exchange(this.id);
    return this.parseDepositAddress(h, i);
  }
  parseDepositAddress(e, t = void 0) {
    const i = this.safeString(e, "address"), s = this.safeString(e, "tag");
    t = this.safeCurrency(void 0, t);
    const n = t.code;
    return this.checkAddress(i), {
      currency: n,
      address: i,
      tag: s,
      network: void 0,
      info: e
    };
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    if ([s, n] = this.handleWithdrawTagAndParams(s, n), i !== void 0 && this.checkAddress(i), "key" in n) {
      await this.loadMarkets();
      const r = this.currency(e), a = this.currencyToPrecision(e, t), o = {
        asset: r.id,
        amount: a
      };
      i && (o.address = i);
      const c = await this.privatePostWithdraw(this.extend(o, n)), u = this.safeValue(c, "result", {});
      return this.parseTransaction(u, r);
    }
    throw new g("withdraw() requires a 'key' parameter (withdrawal key name, as set up on your account)").exchange(this.id);
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {
      // 'txid': 'comma delimited list of transaction ids to restrict output to',
      // 'docalcs': false, // whether or not to include profit/loss calculations
      // 'consolidation': 'market', // what to consolidate the positions data around, market will consolidate positions based on market pair
    }, s = await this.privatePostOpenPositions(this.extend(i, t));
    return this.safeValue(s, "result");
  }
  parseAccount(e) {
    const t = {
      spot: "Spot Wallet",
      swap: "Futures Wallet",
      future: "Futures Wallet"
    };
    return this.safeString(t, e, e);
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e);
    i = this.parseAccount(i), s = this.parseAccount(s);
    const a = {
      amount: this.currencyToPrecision(e, t),
      from: i,
      to: s,
      asset: r.id
    };
    if (i !== "Spot Wallet")
      throw new je().addMessage("Transfer cannot transfer from " + i + " to " + s + ". Use krakenfutures instead to transfer from the futures account.").exchange(this.id);
    const o = await this.privatePostWalletTransfer(this.extend(a, n)), c = this.parseTransfer(o, r);
    return this.extend(c, {
      amount: t,
      fromAccount: i,
      toAccount: s
    });
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeValue(e, "result", {}), s = this.safeString(i, "refid");
    return {
      info: e,
      id: s,
      timestamp: void 0,
      datetime: void 0,
      currency: this.safeString(t, "code"),
      amount: void 0,
      fromAccount: void 0,
      toAccount: void 0,
      status: "sucess"
    };
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    let a = "/" + this.version + "/" + t + "/" + e;
    if (t === "public")
      Object.keys(s).length && (a += "?" + this.urlencodeNested(s));
    else if (t === "private") {
      const o = e === "CancelOrderBatch";
      this.checkRequiredCredentials();
      const c = this.nonce().toString();
      o ? r = this.json(this.extend({ nonce: c }, s)) : r = this.urlencodeNested(this.extend({ nonce: c }, s));
      const u = this.encode(c + r), f = this.hash(u, Re, "binary"), h = this.encode(a), l = this.binaryConcat(h, f);
      let p;
      if (this.externalSigner)
        p = await this.externalSigner.sign({
          payload: l,
          publicApiKey: this.apiKey,
          exchangeId: this.id
        });
      else {
        const m = this.base64ToBinary(this.secret);
        p = this.hmac(l, m, Ss, "base64");
      }
      n = {
        "API-Key": this.apiKey,
        "API-Sign": p
        // 'Content-Type': 'application/x-www-form-urlencoded',
      }, o ? n["Content-Type"] = "application/json" : n["Content-Type"] = "application/x-www-form-urlencoded";
    } else
      a = "/" + e;
    return a = this.urls.api[t] + a, { url: a, method: i, body: r, headers: n };
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (r) {
      if (e === 520)
        throw new Te().addMessage(e.toString() + ": " + t).exchange(this.id);
      const u = this.safeValue(a, "error", []);
      if (u.length > 0) {
        for (let f = 0; f < u.length; f++) {
          const h = u[f], l = h;
          this.throwExactlyMatchedException(this.exceptions.exact, h, l), this.throwBroadlyMatchedException(this.exceptions.broad, h, l);
        }
        throw new O().addMessage(u.join(", ")).exchange(this.id);
      }
    }
  }
}
let aw = class extends gt {
};
class ow extends aw {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "kucoin",
      name: "KuCoin",
      countries: ["SC"],
      rateLimit: 10,
      version: "v2",
      certified: !0,
      pro: !0,
      comment: "Platform 2.0",
      quoteJsonNumbers: !1,
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !1,
        future: !1,
        option: !1,
        cancelAllOrders: !0,
        cancelOrder: !0,
        createDepositAddress: !0,
        createMarketBuyOrderWithCost: !0,
        createMarketOrderWithCost: !0,
        createMarketSellOrderWithCost: !0,
        createOrder: !0,
        createOrders: !0,
        createTriggerOrder: !0,
        editOrder: !0,
        fetchAccounts: !0,
        fetchBalance: !0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDepositAddress: !0,
        fetchDepositAddressesByNetwork: !0,
        fetchDeposits: !0,
        fetchDepositWithdrawFee: !0,
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrderBooks: !1,
        fetchOrdersByStatus: !0,
        fetchOrderTrades: !0,
        fetchStatus: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !1,
        fetchTransactionFee: !0,
        fetchTransfers: !1,
        fetchWithdrawals: !0,
        transfer: !0,
        withdraw: !0
      },
      urls: {
        logo: "https://user-images.githubusercontent.com/51840849/87295558-132aaf80-c50e-11ea-9801-a2fb0c57c799.jpg",
        // https://www.kucoin.com/ucenter/signup?rcode=E5wkqe - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
        referral: "https://www.kucoin.com/ucenter/signup",
        api: {
          public: "https://api.kucoin.com",
          private: "https://api.kucoin.com",
          futuresPrivate: "https://api-futures.kucoin.com",
          futuresPublic: "https://api-futures.kucoin.com",
          webExchange: "https://kucoin.com/_api"
        },
        www: "https://www.kucoin.com",
        doc: [
          "https://docs.kucoin.com"
        ]
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0,
        password: !0
      },
      api: {
        // level VIP0
        // Spot => 3000/30s => 100/s
        // Weight = x => 100/(100/x) = x
        // Futures Management Public => 2000/30s => 200/3/s
        // Weight = x => 100/(200/3/x) = x*1.5
        public: {
          get: {
            // spot trading
            currencies: 4.5,
            "currencies/{currency}": 4.5,
            symbols: 6,
            "market/orderbook/level1": 3,
            "market/allTickers": 22.5,
            "market/stats": 22.5,
            markets: 4.5,
            "market/orderbook/level{level}_{limit}": 6,
            "market/orderbook/level2_20": 3,
            "market/orderbook/level2_100": 6,
            "market/histories": 4.5,
            "market/candles": 4.5,
            prices: 4.5,
            timestamp: 4.5,
            status: 4.5,
            // margin trading
            "mark-price/{symbol}/current": 3,
            "margin/config": 25
            // 25SW
          },
          post: {
            // ws
            "bullet-public": 15
            // 10PW
          }
        },
        private: {
          get: {
            // account
            "user-info": 30,
            accounts: 7.5,
            "accounts/{accountId}": 7.5,
            "accounts/ledgers": 3,
            "hf/accounts/ledgers": 2,
            "hf/margin/account/ledgers": 2,
            "transaction-history": 3,
            "sub/user": 30,
            "sub-accounts/{subUserId}": 22.5,
            "sub-accounts": 30,
            "sub/api-key": 30,
            // funding
            "margin/account": 40,
            "margin/accounts": 15,
            "isolated/accounts": 15,
            "deposit-addresses": 7.5,
            deposits: 7.5,
            "hist-deposits": 7.5,
            withdrawals: 30,
            "hist-withdrawals": 30,
            "withdrawals/quotas": 30,
            "accounts/transferable": 30,
            "transfer-list": 30,
            "base-fee": 3,
            "trade-fees": 3,
            // spot trading
            "market/orderbook/level{level}": 3,
            "market/orderbook/level2": 3,
            "market/orderbook/level3": 3,
            "hf/orders/active": 2,
            "hf/orders/active/symbols": 2,
            "hf/orders/done": 2,
            "hf/orders/{orderId}": 2,
            "hf/orders/client-order/{clientOid}": 2,
            "hf/orders/dead-cancel-all/query": 2,
            "hf/fills": 2,
            orders: 2,
            "limit/orders": 3,
            "orders/{orderId}": 2,
            "order/client-order/{clientOid}": 3,
            fills: 10,
            "limit/fills": 20,
            "stop-order": 8,
            "stop-order/{orderId}": 3,
            "stop-order/queryOrderByClientOid": 3,
            "oco/order/{orderId}": 2,
            "oco/order/details/{orderId}": 2,
            "oco/client-order/{clientOid}": 2,
            "oco/orders": 2,
            // margin trading
            "hf/margin/orders/active": 4,
            "hf/margin/orders/done": 10,
            "hf/margin/orders/{orderId}": 4,
            "hf/margin/orders/client-order/{clientOid}": 5,
            "hf/margin/fills": 5,
            "etf/info": 25,
            "margin/currencies": 20,
            "risk/limit/strategy": 20,
            "isolated/symbols": 20,
            "isolated/account/{symbol}": 50,
            "margin/borrow": 15,
            "margin/repay": 15,
            "project/list": 10,
            "project/marketInterestRate": 7.5,
            "redeem/orders": 10,
            "purchase/orders": 10,
            "earn/hold-assets": 5
            // 5SW
          },
          post: {
            // account
            "sub/user/created": 22.5,
            "sub/api-key": 30,
            "sub/api-key/update": 45,
            // funding
            "deposit-addresses": 30,
            withdrawals: 7.5,
            "accounts/universal-transfer": 6,
            "accounts/sub-transfer": 45,
            "accounts/inner-transfer": 15,
            "transfer-out": 30,
            "transfer-in": 30,
            // spot trading
            "hf/orders": 1,
            "hf/orders/test": 1,
            "hf/orders/sync": 1,
            "hf/orders/multi": 1,
            "hf/orders/multi/sync": 1,
            "hf/orders/alter": 3,
            "hf/orders/dead-cancel-all": 2,
            orders: 2,
            "orders/test": 2,
            "orders/multi": 3,
            "stop-order": 2,
            "oco/order": 2,
            // margin trading
            "hf/margin/order": 5,
            "hf/margin/order/test": 5,
            "margin/order": 5,
            "margin/order/test": 5,
            "margin/borrow": 15,
            "margin/repay": 10,
            purchase: 15,
            redeem: 15,
            "lend/purchase/update": 10,
            // ws
            "bullet-private": 10
            // 10SW
          },
          delete: {
            // account
            "sub/api-key": 45,
            // funding
            "withdrawals/{withdrawalId}": 30,
            // spot trading
            "hf/orders/{orderId}": 1,
            "hf/orders/sync/{orderId}": 1,
            "hf/orders/client-order/{clientOid}": 1,
            "hf/orders/sync/client-order/{clientOid}": 1,
            "hf/orders/cancel/{orderId}": 2,
            "hf/orders": 2,
            "hf/orders/cancelAll": 30,
            "orders/{orderId}": 3,
            "order/client-order/{clientOid}": 5,
            orders: 20,
            "stop-order/{orderId}": 3,
            "stop-order/cancelOrderByClientOid": 5,
            "stop-order/cancel": 3,
            "oco/order/{orderId}": 3,
            "oco/client-order/{clientOid}": 3,
            "oco/orders": 3,
            // margin trading
            "hf/margin/orders/{orderId}": 5,
            "hf/margin/orders/client-order/{clientOid}": 5,
            "hf/margin/orders": 10
            // 10SW
          }
        },
        futuresPublic: {
          get: {
            "contracts/active": 4.5,
            "contracts/{symbol}": 4.5,
            ticker: 3,
            "level2/snapshot": 4.5,
            "level2/depth20": 7.5,
            "level2/depth100": 15,
            "trade/history": 7.5,
            "kline/query": 4.5,
            "interest/query": 7.5,
            "index/query": 3,
            "mark-price/{symbol}/current": 4.5,
            "premium/query": 4.5,
            "trade-statistics": 4.5,
            "funding-rate/{symbol}/current": 3,
            "contract/funding-rates": 7.5,
            timestamp: 3,
            status: 6,
            // ?
            "level2/message/query": 1.3953
          },
          post: {
            // ws
            "bullet-public": 15
            // 10PW
          }
        },
        futuresPrivate: {
          get: {
            // account
            "transaction-history": 3,
            // funding
            "account-overview": 7.5,
            "account-overview-all": 9,
            "transfer-list": 30,
            // futures
            orders: 3,
            stopOrders: 9,
            recentDoneOrders: 7.5,
            "orders/{orderId}": 7.5,
            "orders/byClientOid": 7.5,
            fills: 7.5,
            recentFills: 4.5,
            openOrderStatistics: 15,
            position: 3,
            positions: 3,
            "margin/maxWithdrawMargin": 15,
            "contracts/risk-limit/{symbol}": 7.5,
            "funding-history": 7.5
            // 5FW
          },
          post: {
            // funding
            "transfer-out": 30,
            "transfer-in": 30,
            // futures
            orders: 3,
            "orders/test": 3,
            "orders/multi": 4.5,
            "position/margin/auto-deposit-status": 6,
            "margin/withdrawMargin": 15,
            "position/margin/deposit-margin": 6,
            "position/risk-limit-level/change": 6,
            // ws
            "bullet-private": 15
            // 10FW
          },
          delete: {
            "orders/{orderId}": 1.5,
            "orders/client-order/{clientOid}": 1.5,
            orders: 45,
            stopOrders: 22.5
            // 15FW
          }
        },
        webExchange: {
          get: {
            "currency/currency/chain-info": 1
            // this is temporary from webApi
          }
        }
      },
      timeframes: {
        "1m": "1min",
        "3m": "3min",
        "5m": "5min",
        "15m": "15min",
        "30m": "30min",
        "1h": "1hour",
        "2h": "2hour",
        "4h": "4hour",
        "6h": "6hour",
        "8h": "8hour",
        "12h": "12hour",
        "1d": "1day",
        "1w": "1week"
      },
      precisionMode: ct,
      exceptions: {
        exact: {
          "order not exist": Se,
          "order not exist.": Se,
          order_not_exist: Se,
          order_not_exist_or_not_allow_to_cancel: k,
          "Order size below the minimum requirement.": g,
          "Withdrawal amount is below the minimum requirement.": Xt,
          "Unsuccessful! Exceeded the max. funds out-transfer limit": re,
          400: be,
          401: Z,
          403: pe,
          404: pe,
          405: pe,
          415: pe,
          429: Ae,
          500: Te,
          503: Te,
          101030: ee,
          103e3: g,
          130101: g,
          130102: O,
          130103: Se,
          130104: O,
          130105: re,
          130106: O,
          130107: O,
          130108: Se,
          130201: ee,
          130202: O,
          130203: re,
          130204: O,
          200004: re,
          210014: g,
          210021: re,
          230003: re,
          26e4: mr,
          260100: re,
          260325: gi,
          3e5: k,
          4e5: g,
          400001: Z,
          400002: ze,
          400003: Pt,
          400004: Pt,
          400005: Z,
          400006: Z,
          400007: ee,
          400008: O,
          400100: O,
          400200: ee,
          400350: k,
          400370: g,
          400400: g,
          400500: go,
          400600: g,
          400760: g,
          401e3: g,
          411100: Ee,
          415e3: g,
          400303: ee,
          5e5: Te,
          260220: It,
          900014: g
          // {"code":"900014","msg":"Invalid chainId"}
        },
        broad: {
          "Exceeded the access frequency": Ae,
          "require more permission": ee
        },
        messages: {
          "The quantity is below the minimum requirement": ye.ORDER_UNDER_MINIMUM
        }
      },
      fees: {
        trading: {
          tierBased: !0,
          percentage: !0,
          taker: this.parseNumber("0.001"),
          maker: this.parseNumber("0.001"),
          tiers: {
            taker: [
              [this.parseNumber("0"), this.parseNumber("0.001")],
              [this.parseNumber("50"), this.parseNumber("0.001")],
              [this.parseNumber("200"), this.parseNumber("0.0009")],
              [this.parseNumber("500"), this.parseNumber("0.0008")],
              [this.parseNumber("1000"), this.parseNumber("0.0007")],
              [this.parseNumber("2000"), this.parseNumber("0.0007")],
              [this.parseNumber("4000"), this.parseNumber("0.0006")],
              [this.parseNumber("8000"), this.parseNumber("0.0005")],
              [this.parseNumber("15000"), this.parseNumber("0.00045")],
              [this.parseNumber("25000"), this.parseNumber("0.0004")],
              [this.parseNumber("40000"), this.parseNumber("0.00035")],
              [this.parseNumber("60000"), this.parseNumber("0.0003")],
              [this.parseNumber("80000"), this.parseNumber("0.00025")]
            ],
            maker: [
              [this.parseNumber("0"), this.parseNumber("0.001")],
              [this.parseNumber("50"), this.parseNumber("0.0009")],
              [this.parseNumber("200"), this.parseNumber("0.0007")],
              [this.parseNumber("500"), this.parseNumber("0.0005")],
              [this.parseNumber("1000"), this.parseNumber("0.0003")],
              [this.parseNumber("2000"), this.parseNumber("0")],
              [this.parseNumber("4000"), this.parseNumber("0")],
              [this.parseNumber("8000"), this.parseNumber("0")],
              [this.parseNumber("15000"), this.parseNumber("-0.00005")],
              [this.parseNumber("25000"), this.parseNumber("-0.00005")],
              [this.parseNumber("40000"), this.parseNumber("-0.00005")],
              [this.parseNumber("60000"), this.parseNumber("-0.00005")],
              [this.parseNumber("80000"), this.parseNumber("-0.00005")]
            ]
          }
        },
        funding: {
          tierBased: !1,
          percentage: !1,
          withdraw: {},
          deposit: {}
        }
      },
      options: {
        version: "v1",
        timeDifference: 0,
        symbolSeparator: "-",
        fetchMyTradesMethod: "private_get_fills",
        fetchCurrencies: {
          webApiEnable: !0,
          webApiRetries: 1,
          webApiMuteFailure: !0
        },
        fetchMarkets: {
          fetchTickersFees: !0
        },
        withdraw: {
          includeFee: !1
        },
        // endpoint versions
        versions: {
          public: {
            GET: {
              // spot trading
              currencies: "v3",
              "currencies/{currency}": "v3",
              symbols: "v2"
            }
          },
          private: {
            GET: {
              // account
              "user-info": "v2",
              "hf/margin/account/ledgers": "v3",
              "sub/user": "v2",
              "sub-accounts": "v2",
              // funding
              "margin/accounts": "v3",
              "isolated/accounts": "v3",
              // 'deposit-addresses': 'v2',
              "deposit-addresses": "v1",
              // spot trading
              "market/orderbook/level2": "v3",
              "market/orderbook/level3": "v3",
              "market/orderbook/level{level}": "v3",
              "oco/order/{orderId}": "v3",
              "oco/order/details/{orderId}": "v3",
              "oco/client-order/{clientOid}": "v3",
              "oco/orders": "v3",
              // margin trading
              "hf/margin/orders/active": "v3",
              "hf/margin/orders/done": "v3",
              "hf/margin/orders/{orderId}": "v3",
              "hf/margin/orders/client-order/{clientOid}": "v3",
              "hf/margin/fills": "v3",
              "etf/info": "v3",
              "margin/currencies": "v3",
              "margin/borrow": "v3",
              "margin/repay": "v3",
              "project/list": "v3",
              "project/marketInterestRate": "v3",
              "redeem/orders": "v3",
              "purchase/orders": "v3"
            },
            POST: {
              // account
              "sub/user/created": "v2",
              // funding
              "accounts/universal-transfer": "v3",
              "accounts/sub-transfer": "v2",
              "accounts/inner-transfer": "v2",
              "transfer-out": "v3",
              // spot trading
              "oco/order": "v3",
              // margin trading
              "hf/margin/order": "v3",
              "hf/margin/order/test": "v3",
              "margin/borrow": "v3",
              "margin/repay": "v3",
              purchase: "v3",
              redeem: "v3",
              "lend/purchase/update": "v3"
            },
            DELETE: {
              // account
              // funding
              // spot trading
              "hf/margin/orders/{orderId}": "v3",
              "hf/margin/orders/client-order/{clientOid}": "v3",
              "hf/margin/orders": "v3",
              "oco/order/{orderId}": "v3",
              "oco/client-order/{clientOid}": "v3",
              "oco/orders": "v3"
              // margin trading
            }
          },
          futuresPrivate: {
            POST: {
              "transfer-out": "v3"
            }
          }
        },
        partner: {
          // the support for spot and future exchanges as separate settings
          spot: {
            id: "ccxt",
            key: "9e58cc35-5b5e-4133-92ec-166e3f077cb8"
          },
          future: {
            id: "ccxtfutures",
            key: "1b327198-f30c-4f14-a0ac-918871282f15"
          }
          // exchange-wide settings are also supported
          // 'id': 'ccxt'
          // 'key': '9e58cc35-5b5e-4133-92ec-166e3f077cb8',
        },
        accountsByType: {
          spot: "trade",
          margin: "margin",
          cross: "margin",
          isolated: "isolated",
          main: "main",
          funding: "main",
          future: "contract",
          swap: "contract",
          mining: "pool",
          hf: "trade_hf"
        },
        marginModes: {
          cross: "MARGIN_TRADE",
          isolated: "MARGIN_ISOLATED_TRADE",
          spot: "TRADE"
        }
      }
    });
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  async fetchTime(e = {}) {
    const t = await this.publicGetTimestamp(e);
    return this.safeInteger(t, "data");
  }
  isUsingForcedProxy(e = {}, t = "public") {
    return t === "private" || t === "futuresPrivate";
  }
  async fetchStatus(e = {}) {
    const t = await this.publicGetStatus(e), i = this.safeValue(t, "data", {});
    return {
      status: this.safeString(i, "status") === "open" ? "ok" : "maintenance",
      updated: void 0,
      eta: void 0,
      url: void 0,
      info: t
    };
  }
  async fetchMarkets(e = {}) {
    const t = await this.publicGetSymbols(e), i = this.safeValue(t, "data"), s = this.safeValue(this.options, "fetchMarkets", {}), n = this.safeBool(s, "fetchTickersFees", !0);
    let r = {};
    n && (r = await this.publicGetMarketAllTickers(e));
    const a = this.safeValue(r, "data", {}), o = this.safeValue(a, "ticker", []), c = this.indexBy(o, "symbol"), u = [];
    for (let f = 0; f < i.length; f++) {
      const h = i[f], l = this.safeString(h, "symbol"), [p, m] = l.split("-"), y = this.safeCurrencyCode(p), w = this.safeCurrencyCode(m), S = this.safeValue(c, l, {}), b = this.safeString(S, "makerFeeRate"), T = this.safeString(S, "takerFeeRate"), x = this.safeString(S, "makerCoefficient"), v = this.safeString(S, "takerCoefficient");
      u.push({
        id: l,
        symbol: y + "/" + w,
        base: y,
        quote: w,
        settle: void 0,
        baseId: p,
        quoteId: m,
        settleId: void 0,
        type: "spot",
        spot: !0,
        margin: this.safeValue(h, "isMarginEnabled"),
        swap: !1,
        future: !1,
        option: !1,
        active: this.safeValue(h, "enableTrading"),
        contract: !1,
        linear: void 0,
        inverse: void 0,
        taker: this.parseNumber(P.stringMul(T, v)),
        maker: this.parseNumber(P.stringMul(b, x)),
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.safeNumber(h, "baseIncrement"),
          price: this.safeNumber(h, "priceIncrement")
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: this.safeNumber(h, "baseMinSize"),
            max: this.safeNumber(h, "baseMaxSize")
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.safeNumber(h, "quoteMinSize"),
            max: this.safeNumber(h, "quoteMaxSize")
          }
        },
        created: void 0,
        info: h
      });
    }
    return u;
  }
  async fetchCurrencies(e = {}) {
    const t = [];
    t.push(this.publicGetCurrencies(e)), t.push(this.fetchWebEndpoint("fetchCurrencies", "webExchangeGetCurrencyCurrencyChainInfo", !0));
    const i = await Promise.all(t), s = this.safeValue(i, 0, {}), n = this.safeValue(s, "data", []), r = this.safeValue(i, 1, {}), a = this.safeValue(r, "data", []), o = this.groupBy(a, "currency"), c = {};
    for (let u = 0; u < n.length; u++) {
      const f = n[u], h = this.safeString(f, "currency"), l = this.safeString(f, "fullName"), p = this.safeCurrencyCode(h);
      let m = !1, y = !1;
      const w = {}, S = this.safeValue(f, "chains", []), b = this.indexBy(this.safeValue(o, h, []), "chain"), T = this.safeString(f, "precision"), x = this.parseNumber(this.parsePrecision(T)), v = S.length;
      v || (m = !1, y = !1);
      for (let V = 0; V < v; V++) {
        const j = S[V], G = this.safeString(j, "chainId"), W = this.networkIdToCode(G), B = this.safeBool(j, "isWithdrawEnabled", !1), Q = this.safeBool(j, "isDepositEnabled", !1);
        y = Q || y, m = B || m;
        const se = this.safeValue(b, G, {}), $ = this.safeNumber(j, "withdrawalMinSize", 0);
        w[W] = {
          info: {
            ...j,
            chainExtraData: se
          },
          id: G,
          name: this.safeString(j, "chainName"),
          code: W,
          active: B && Q,
          fee: this.safeNumber(j, "withdrawalMinFee"),
          deposit: Q,
          withdraw: B,
          limits: {
            withdraw: {
              min: $,
              max: void 0
            },
            deposit: {
              min: this.safeNumber(se, "depositMinSize"),
              max: void 0
            }
          }
        };
      }
      const _ = T === "2" && v === 0;
      c[p] = {
        id: h,
        name: l,
        code: p,
        type: _ ? "fiat" : "crypto",
        precision: x,
        info: f,
        active: y || m,
        deposit: y,
        withdraw: m,
        fee: void 0,
        limits: this.limits,
        networks: w
      };
    }
    return c;
  }
  async fetchAccounts(e = {}) {
    const t = await this.privateGetAccounts(e), i = this.safeValue(t, "data", []), s = [];
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "id"), o = this.safeString(r, "currency"), c = this.safeCurrencyCode(o), u = this.safeString(r, "type");
      s.push({
        id: a,
        type: u,
        currency: c,
        code: c,
        info: r
      });
    }
    return s;
  }
  async fetchTransactionFee(e, t = {}) {
    await this.loadMarkets();
    const s = {
      currency: this.currency(e).id
    };
    let n;
    [n, t] = this.handleNetworkCodeAndParams(t), n !== void 0 && (s.chain = this.networkCodeToId(n).toLowerCase());
    const r = await this.privateGetWithdrawalsQuotas(this.extend(s, t)), a = this.safeValue(r, "data"), o = {};
    return o[e] = this.safeNumber(a, "withdrawMinFee"), {
      info: r,
      withdraw: o,
      deposit: {}
    };
  }
  async fetchDepositWithdrawFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = {
      currency: i.id
    };
    let n;
    [n, t] = this.handleNetworkCodeAndParams(t), n !== void 0 && (s.chain = this.networkCodeToId(n).toLowerCase());
    const r = await this.privateGetWithdrawalsQuotas(this.extend(s, t)), a = this.safeValue(r, "data");
    return this.parseDepositWithdrawFee(a, i);
  }
  parseDepositWithdrawFee(e, t = void 0) {
    const i = {
      info: e,
      withdraw: {
        fee: void 0,
        percentage: void 0
      },
      deposit: {
        fee: void 0,
        percentage: void 0
      },
      networks: {}
    };
    if (this.safeValue(e, "isWithdrawEnabled")) {
      i.withdraw.fee = this.safeNumber2(e, "withdrawalMinFee", "withdrawMinFee"), i.withdraw.percentage = !1;
      const n = this.safeString(e, "chain");
      if (n) {
        const r = this.networkIdToCode(n, this.safeString(t, "code"));
        i.networks[r] = {
          withdraw: i.withdraw,
          deposit: {
            fee: void 0,
            percentage: void 0
          }
        };
      }
    }
    return i;
  }
  parseTicker(e, t = void 0) {
    let i = this.safeString(e, "changeRate");
    i !== void 0 && (i = P.stringMul(i, "100"));
    let s = this.safeString2(e, "last", "lastTradedPrice");
    s = this.safeString(e, "price", s);
    const n = this.safeString(e, "symbol");
    t = this.safeMarket(n, t, "-");
    const r = t.symbol, a = this.safeString(e, "vol"), o = this.safeString(e, "volValue"), c = this.safeInteger2(e, "time", "datetime");
    return this.safeTicker({
      symbol: r,
      timestamp: c,
      datetime: this.iso8601(c),
      high: this.safeString(e, "high"),
      low: this.safeString(e, "low"),
      bid: this.safeString2(e, "buy", "bestBid"),
      bidVolume: this.safeString(e, "bestBidSize"),
      ask: this.safeString2(e, "sell", "bestAsk"),
      askVolume: this.safeString(e, "bestAskSize"),
      vwap: void 0,
      open: this.safeString(e, "open"),
      close: s,
      last: s,
      previousClose: void 0,
      change: this.safeString(e, "changePrice"),
      percentage: i,
      average: this.safeString(e, "averagePrice"),
      baseVolume: a,
      quoteVolume: o,
      info: e
    }, t);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = await this.publicGetMarketAllTickers(t), s = this.safeValue(i, "data", {}), n = this.safeValue(s, "ticker", []), r = this.safeInteger(s, "time"), a = {};
    for (let o = 0; o < n.length; o++) {
      n[o].time = r;
      const c = this.parseTicker(n[o]), u = this.safeString(c, "symbol");
      u !== void 0 && (a[u] = c);
    }
    return this.filterByArrayTickers(a, "symbol", e);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbol: i.id
    }, n = await this.publicGetMarketStats(this.extend(s, t));
    return this.parseTicker(n.data, i);
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeTimestamp(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 2),
      this.safeNumber(e, 5)
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = !1;
    if ([r, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), r)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 1500);
    const a = this.market(e), c = {
      symbol: a.id,
      type: this.safeString(this.timeframes, t, t)
    }, u = this.parseTimeframe(t) * 1e3;
    let f = this.milliseconds();
    i !== void 0 ? (c.startAt = this.parseToInt(Math.floor(i / 1e3)), s === void 0 && (s = this.safeInteger(this.options, "fetchOHLCVLimit", 1500)), f = this.sum(i, s * u)) : s !== void 0 && (i = f - s * u, c.startAt = this.parseToInt(Math.floor(i / 1e3))), c.endAt = this.parseToInt(Math.floor(f / 1e3));
    const h = await this.publicGetMarketCandles(this.extend(c, n)), l = this.safeValue(h, "data", []);
    return this.parseOHLCVs(l, a, t, i, s);
  }
  async createDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = {
      currency: i.id
    };
    let n;
    [n, t] = this.handleNetworkCodeAndParams(t), n !== void 0 && (s.chain = this.networkCodeToId(n).toLowerCase());
    const r = await this.privatePostDepositAddresses(this.extend(s, t)), a = this.safeValue(r, "data", {});
    return this.parseDepositAddress(a, i);
  }
  async fetchDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = {
      currency: i.id
      // for USDT - OMNI, ERC20, TRC20, default is ERC20
      // for BTC - Native, Segwit, TRC20, the parameters are bech32, btc, trx, default is Native
      // 'chain': 'ERC20', // optional
    };
    let n;
    [n, t] = this.handleNetworkCodeAndParams(t), n !== void 0 && (s.chain = this.networkCodeToId(n).toLowerCase());
    const r = this.options.versions.private.GET["deposit-addresses"];
    this.options.versions.private.GET["deposit-addresses"] = "v1";
    const a = await this.privateGetDepositAddresses(this.extend(s, t));
    this.options.versions.private.GET["deposit-addresses"] = r;
    const o = this.safeValue(a, "data");
    if (o === void 0)
      throw new It(e, n).addMessage("fetchDepositAddress() returned an empty response, you might try to run createDepositAddress() first and try again").exchange(this.id);
    return this.parseDepositAddress(o, i);
  }
  parseDepositAddress(e, t = void 0) {
    let i = this.safeString(e, "address");
    i !== void 0 && (i = i.replace("bitcoincash:", ""));
    let s;
    return t !== void 0 && (s = t.id, s !== "NIM" && this.checkAddress(i)), {
      info: e,
      currency: s,
      address: i,
      tag: this.safeString(e, "memo")
      // it's hard to retrieve the network here, the api returns the chain name, not the id
    };
  }
  async fetchDepositAddressesByNetwork(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = {
      currency: i.id
    }, n = this.options.versions.private.GET["deposit-addresses"];
    this.options.versions.private.GET["deposit-addresses"] = "v2";
    const r = await this.privateGetDepositAddresses(this.extend(s, t));
    this.options.versions.private.GET["deposit-addresses"] = n;
    const a = this.safeValue(r, "data", []), o = this.parseDepositAddresses(a, [i.code], !1, {
      currency: i.id
    });
    return this.indexBy(o, "network");
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e), n = this.safeInteger(i, "level", 2), r = { symbol: s.id }, a = this.checkRequiredCredentials(!1);
    let o;
    if (!a || t !== void 0) {
      if (n === 2) {
        if (r.level = n, t !== void 0)
          if (t === 20 || t === 100)
            r.limit = t;
          else
            throw new g("fetchOrderBook() limit argument must be 20 or 100").exchange(this.id);
        r.limit = t || 100;
      }
      o = await this.publicGetMarketOrderbookLevelLevelLimit(this.extend(r, i));
    } else
      o = await this.privateGetMarketOrderbookLevel2(this.extend(r, i));
    const c = this.safeValue(o, "data", {}), u = this.safeInteger(c, "time"), f = this.parseOrderBook(c, s.symbol, u, "bids", "asks", n - 2, n - 1);
    return f.nonce = this.safeInteger(c, "sequence"), f;
  }
  handleTriggerPrices(e) {
    const t = this.safeValue2(e, "triggerPrice", "stopPrice"), i = this.safeValue(e, "stopLossPrice"), s = this.safeValue(e, "takeProfitPrice"), n = i !== void 0, r = s !== void 0;
    if (n && r || t && i || t && r)
      throw new g("createOrder() - you should use either triggerPrice or stopLossPrice or takeProfitPrice").exchange(this.id);
    return [t, i, s];
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), o = this.safeBool(r, "test", !1);
    r = this.omit(r, "test");
    const c = this.safeBool(r, "hf", !1), [u, f, h] = this.handleTriggerPrices(r), l = this.safeString(r, "tradeType"), p = u || f || h, m = this.handleMarginModeAndParams("createOrder", r), y = this.safeString(m, 0), w = l === "MARGIN_TRADE" || y !== void 0, S = this.createOrderRequest(e, t, i, s, n, r);
    let b;
    o ? w ? b = await this.privatePostMarginOrderTest(S) : b = await this.privatePostOrdersTest(S) : c ? b = await this.privatePostHfOrders(S) : p ? b = await this.privatePostStopOrder(S) : w ? b = await this.privatePostMarginOrder(S) : b = await this.privatePostOrders(S);
    const T = this.safeValue(b, "data", {});
    return this.parseOrder(T, a);
  }
  async createMarketOrderWithCost(e, t, i, s = {}) {
    return await this.loadMarkets(), s.cost = i, await this.createOrder(e, "market", t, i, void 0, s);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    return await this.loadMarkets(), await this.createMarketOrderWithCost(e, "buy", t, i);
  }
  async createMarketSellOrderWithCost(e, t, i = {}) {
    return await this.loadMarkets(), await this.createMarketOrderWithCost(e, "sell", t, i);
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [];
    let s;
    for (let u = 0; u < e.length; u++) {
      const f = e[u], h = this.safeString(f, "symbol");
      if (s === void 0)
        s = h;
      else if (s !== h)
        throw new g("createOrders() requires all orders to have the same symbol").exchange(this.id);
      const l = this.safeString(f, "type");
      if (l !== "limit")
        throw new ge(l).addMessage("createOrders() only supports limit orders").exchange(this.id);
      const p = this.safeString(f, "side"), m = this.safeValue(f, "amount"), y = this.safeValue(f, "price"), w = this.safeValue(f, "params", {}), S = this.createOrderRequest(h, l, p, m, y, w);
      i.push(S);
    }
    const r = {
      symbol: this.market(s).id,
      orderList: i
    }, a = this.safeBool(t, "hf", !1);
    t = this.omit(t, "hf");
    let o;
    a ? o = await this.privatePostHfOrdersMulti(this.extend(r, t)) : o = await this.privatePostOrdersMulti(this.extend(r, t));
    let c = this.safeValue(o, "data", {});
    return c = this.safeValue(c, "data", []), this.parseOrders(c);
  }
  createOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.market(e), o = this.safeString2(r, "clientOid", "clientOrderId", this.uuid());
    r = this.omit(r, ["clientOid", "clientOrderId"]);
    const c = {
      clientOid: o,
      side: i,
      symbol: a.id,
      type: t
      // limit or market
    }, u = this.safeNumber2(r, "cost", "funds");
    let f, h, l;
    [l, r] = this.handleMarginModeAndParams("createOrder", r), t === "market" ? u !== void 0 ? (r = this.omit(r, ["cost", "funds"]), h = this.amountToPrecision(e, u), c.funds = h) : (f = this.amountToPrecision(e, s), c.size = this.amountToPrecision(e, s)) : (f = this.amountToPrecision(e, s), c.size = f, c.price = this.priceToPrecision(e, n));
    const p = this.safeString(r, "tradeType"), [m, y, w] = this.handleTriggerPrices(r), S = m || y || w, b = p === "MARGIN_TRADE" || l !== void 0;
    if (r = this.omit(r, ["stopLossPrice", "takeProfitPrice", "triggerPrice", "stopPrice"]), S) {
      if (m ? c.stopPrice = this.priceToPrecision(e, m) : (y || w) && (y ? (c.stop = i === "buy" ? "entry" : "loss", c.stopPrice = this.priceToPrecision(e, y)) : (c.stop = i === "buy" ? "loss" : "entry", c.stopPrice = this.priceToPrecision(e, w))), l === "isolated")
        throw new k().addMessage("createOrder does not support isolated margin for stop orders").exchange(this.id);
      l === "cross" && (c.tradeType = this.options.marginModes[l]);
    } else
      b && l === "isolated" && (c.marginModel = "isolated");
    let T;
    return [T, r] = this.handlePostOnly(t === "market", !1, r), T && (c.postOnly = !0), this.extend(c, r);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t), c = {
      symbol: o.id
    }, u = this.safeString2(a, "clientOid", "clientOrderId");
    u !== void 0 ? c.clientOid = u : c.orderId = e, n !== void 0 && (c.newSize = this.amountToPrecision(t, n)), r !== void 0 && (c.newPrice = this.priceToPrecision(t, r));
    const f = await this.privatePostHfOrdersAlter(this.extend(c, a)), h = this.safeValue(f, "data", {});
    return this.parseOrder(h, o);
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {}, n = this.safeString2(i, "clientOid", "clientOrderId"), r = this.safeValue2(i, "stop", "trigger", !1), a = this.safeBool(i, "hf", !1);
    if (a) {
      if (t === void 0)
        throw new g("cancelOrder() requires a symbol parameter for hf orders").exchange(this.id);
      const c = this.market(t);
      s.symbol = c.id;
    }
    let o;
    return i = this.omit(i, ["clientOid", "clientOrderId", "stop", "hf", "trigger"]), n !== void 0 ? (s.clientOid = n, r ? o = await this.privateDeleteStopOrderCancelOrderByClientOid(this.extend(s, i)) : a ? o = await this.privateDeleteHfOrdersClientOrderClientOid(this.extend(s, i)) : o = await this.privateDeleteOrderClientOrderClientOid(this.extend(s, i))) : (s.orderId = e, r ? o = await this.privateDeleteStopOrderOrderId(this.extend(s, i)) : a ? o = await this.privateDeleteHfOrdersOrderId(this.extend(s, i)) : o = await this.privateDeleteOrdersOrderId(this.extend(s, i))), o;
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {}, s = this.safeBool(t, "stop", !1), n = this.safeBool(t, "hf", !1);
    t = this.omit(t, ["stop", "hf"]);
    const [r, a] = this.handleMarginModeAndParams("cancelAllOrders", t);
    if (e !== void 0 && (i.symbol = this.marketId(e)), r !== void 0 && (i.tradeType = this.options.marginModes[r], r === "isolated" && s))
      throw new g("cancelAllOrders does not support isolated margin for stop orders").exchange(this.id);
    let o;
    return s ? o = await this.privateDeleteStopOrderCancel(this.extend(i, a)) : n ? e === void 0 ? o = await this.privateDeleteHfOrdersCancelAll(this.extend(i, a)) : o = await this.privateDeleteHfOrders(this.extend(i, a)) : o = await this.privateDeleteOrders(this.extend(i, a)), o;
  }
  async fetchOrdersByStatus(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    let r = e.toLowerCase();
    const a = this.safeInteger2(n, "until", "till"), o = this.safeBool(n, "stop", !1), c = this.safeBool(n, "hf", !1);
    n = this.omit(n, ["stop", "hf", "till", "until"]);
    const [u, f] = this.handleMarginModeAndParams("fetchOrdersByStatus", n);
    r === "open" ? r = "active" : r === "closed" && (r = "done");
    const h = {
      status: r
    };
    let l;
    t !== void 0 && (l = this.market(t), h.symbol = l.id), i !== void 0 && (h.startAt = i), s !== void 0 && (h.pageSize = s), a && (h.endAt = a), h.tradeType = this.safeString(this.options.marginModes, u, "TRADE");
    let p;
    o ? p = await this.privateGetStopOrder(this.extend(h, f)) : c ? r === "active" ? p = await this.privateGetHfOrdersActive(this.extend(h, f)) : r === "done" && (p = await this.privateGetHfOrdersDone(this.extend(h, f))) : p = await this.privateGetOrders(this.extend(h, f));
    const m = this.safeValue(p, "data", {}), y = this.safeValue(m, "items", m);
    return this.parseOrders(y, l, i, s);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    return [n, s] = this.handleOptionAndParams(s, "fetchClosedOrders", "paginate"), n ? await this.fetchPaginatedCallDynamic("fetchClosedOrders", e, t, i, s) : await this.fetchOrdersByStatus("done", e, t, i, s);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    return [n, s] = this.handleOptionAndParams(s, "fetchOpenOrders", "paginate"), n ? await this.fetchPaginatedCallDynamic("fetchOpenOrders", e, t, i, s) : await this.fetchOrdersByStatus("active", e, t, i, s);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {}, n = this.safeString2(i, "clientOid", "clientOrderId"), r = this.safeBool(i, "stop", !1), a = this.safeBool(i, "hf", !1);
    let o;
    if (t !== void 0 && (o = this.market(t)), a) {
      if (t === void 0)
        throw new g("fetchOrder() requires a symbol parameter for hf orders").exchange(this.id);
      s.symbol = o.id;
    }
    i = this.omit(i, ["stop", "hf", "clientOid", "clientOrderId"]);
    let c;
    if (n !== void 0)
      s.clientOid = n, r ? (t !== void 0 && (s.symbol = o.id), c = await this.privateGetStopOrderQueryOrderByClientOid(this.extend(s, i))) : a ? c = await this.privateGetHfOrdersClientOrderClientOid(this.extend(s, i)) : c = await this.privateGetOrderClientOrderClientOid(this.extend(s, i));
    else {
      if (e === void 0)
        throw new g("fetchOrder() requires an order id").exchange(this.id);
      s.orderId = e, r ? c = await this.privateGetStopOrderOrderId(this.extend(s, i)) : a ? c = await this.privateGetHfOrdersOrderId(this.extend(s, i)) : c = await this.privateGetOrdersOrderId(this.extend(s, i));
    }
    let u = this.safeValue(c, "data", {});
    return Array.isArray(u) && (u = this.safeValue(u, 0)), this.parseOrder(u, o);
  }
  parseOrder(e, t = void 0) {
    const i = this.safeString(e, "symbol"), s = this.safeInteger(e, "createdAt"), n = this.safeString(e, "feeCurrency"), r = this.safeBool(e, "cancelExist", !1), o = this.safeString(e, "stop") !== void 0, c = this.safeBool(e, "stopTriggered", !1), u = this.safeValue2(e, "isActive", "active"), f = this.safeString(e, "status");
    let h;
    u !== void 0 && (u === !0 ? h = "open" : h = "closed"), o && (f === "NEW" ? h = "open" : !u && !c && (h = "cancelled")), r && (h = "canceled"), f === "fail" && (h = "rejected");
    const l = this.safeNumber(e, "stopPrice");
    return this.safeOrder({
      info: e,
      id: this.safeStringN(e, ["id", "orderId", "newOrderId"]),
      clientOrderId: this.safeString(e, "clientOid"),
      symbol: this.safeSymbol(i, t, "-"),
      type: this.safeString(e, "type"),
      timeInForce: this.safeString(e, "timeInForce"),
      postOnly: this.safeValue(e, "postOnly"),
      side: this.safeString(e, "side"),
      amount: this.safeString(e, "size"),
      price: this.safeString(e, "price"),
      stopPrice: l,
      triggerPrice: l,
      cost: this.safeString(e, "dealFunds"),
      filled: this.safeString(e, "dealSize"),
      remaining: void 0,
      timestamp: s,
      datetime: this.iso8601(s),
      fee: {
        currency: this.safeCurrencyCode(n),
        cost: this.safeNumber(e, "fee")
      },
      status: h,
      lastTradeTimestamp: void 0,
      average: void 0,
      trades: void 0
    }, t);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    const r = {
      orderId: e
    };
    return await this.fetchMyTrades(t, i, s, this.extend(r, n));
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchMyTrades", e, t, i, s);
    let r = {};
    const a = this.safeBool(s, "hf", !1);
    if (a && e === void 0)
      throw new g("fetchMyTrades() requires a symbol parameter for hf orders").exchange(this.id);
    let o;
    e !== void 0 && (o = this.market(e), r.symbol = o.id), i !== void 0 && (r.pageSize = i);
    const c = this.options.fetchMyTradesMethod;
    let u = !1, f;
    if ([r, s] = this.handleUntilOption("endAt", r, s), a)
      f = await this.privateGetHfFills(this.extend(r, s));
    else if (c === "private_get_fills")
      t !== void 0 && (r.startAt = t), f = await this.privateGetFills(this.extend(r, s));
    else if (c === "private_get_limit_fills")
      u = !0, f = await this.privateGetLimitFills(this.extend(r, s));
    else
      throw new pe("fetchMyTradesMethod() invalid method").exchange(this.id);
    const h = this.safeValue(f, "data", {});
    let l;
    return u ? l = h : l = this.safeValue(h, "items", []), this.parseTrades(l, o, t, i);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.market(e), r = {
      symbol: n.id
    }, a = await this.publicGetMarketHistories(this.extend(r, s)), o = this.safeValue(a, "data", []);
    return this.parseTrades(o, n, t, i);
  }
  parseTrade(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t, "-");
    const s = this.safeString2(e, "tradeId", "id"), n = this.safeString(e, "orderId"), r = this.safeString(e, "liquidity");
    let a = this.safeInteger(e, "time");
    a !== void 0 ? a = this.parseToInt(a / 1e6) : (a = this.safeInteger(e, "createdAt"), "dealValue" in e && a !== void 0 && (a = a * 1e3));
    const o = this.safeString2(e, "price", "dealPrice"), c = this.safeString2(e, "size", "amount"), u = this.safeString(e, "side");
    let f;
    const h = this.safeString(e, "fee");
    if (h !== void 0) {
      const m = this.safeString(e, "feeCurrency");
      let y = this.safeCurrencyCode(m);
      y === void 0 && (y = u === "sell" ? t.quote : t.base), f = {
        cost: h,
        currency: y,
        rate: this.safeString(e, "feeRate")
      };
    }
    let l = this.safeString(e, "type");
    l === "match" && (l = void 0);
    const p = this.safeString2(e, "funds", "dealValue");
    return this.safeTrade({
      info: e,
      id: s,
      order: n,
      timestamp: a,
      datetime: this.iso8601(a),
      symbol: t.symbol,
      type: l,
      takerOrMaker: r,
      side: u,
      price: o,
      amount: c,
      cost: p,
      fee: f
    }, t);
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      symbols: i.id
    }, n = await this.privateGetTradeFees(this.extend(s, t)), r = this.safeValue(n, "data", []), a = this.safeValue(r, 0), o = this.safeString(a, "symbol");
    return {
      info: n,
      symbol: this.safeSymbol(o, i),
      maker: this.safeNumber(a, "makerFeeRate"),
      taker: this.safeNumber(a, "takerFeeRate"),
      percentage: !0,
      tierBased: !0
    };
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), await this.loadMarkets(), this.checkAddress(i);
    const r = this.currency(e), a = this.safeString(n, "network"), o = this.currencyToPrecision(e, t, a), c = {
      currency: r.id,
      address: i,
      amount: o
      // 'memo': tag,
      // 'isInner': false, // internal transfer or external withdrawal
      // 'remark': 'optional',
      // 'chain': 'OMNI', // 'ERC20', 'TRC20', default is ERC20, This only apply for multi-chain currency, and there is no need for single chain currency.
    };
    s !== void 0 && (c.memo = s);
    let u;
    [u, n] = this.handleNetworkCodeAndParams(n), u !== void 0 && (c.chain = this.networkCodeToId(u).toLowerCase());
    let f;
    [f, n] = this.handleOptionAndParams(n, "withdraw", "includeFee", !1), f && (c.feeDeductType = "INTERNAL");
    const h = await this.privatePostWithdrawals(this.extend(c, n)), l = this.safeValue(h, "data", {});
    return this.parseTransaction(l, r);
  }
  parseTransactionStatus(e) {
    const t = {
      SUCCESS: "ok",
      PROCESSING: "pending",
      WALLET_PROCESSING: "pending",
      FAILURE: "failed"
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString(e, "currency"), s = this.safeCurrencyCode(i, t);
    let n = this.safeString(e, "address");
    const r = this.safeString(e, "amount");
    let a = this.safeString(e, "walletTxId");
    if (a !== void 0) {
      const w = a.split("@");
      w.length > 1 && n === void 0 && w[1].length > 1 && (n = w[1]), a = w[0];
    }
    let o = a === void 0 ? "withdrawal" : "deposit";
    const c = this.safeString(e, "status");
    let u;
    const f = this.safeString(e, "fee");
    if (f !== void 0) {
      let w;
      r !== void 0 && (w = P.stringDiv(f, r)), u = {
        cost: this.parseNumber(f),
        rate: this.parseNumber(w),
        currency: s
      };
    }
    let h = this.safeInteger2(e, "createdAt", "createAt"), l = this.safeInteger(e, "updatedAt");
    !("createdAt" in e) && (o = "address" in e ? "withdrawal" : "deposit", h !== void 0 && (h = h * 1e3), l !== void 0 && (l = l * 1e3));
    const m = this.safeValue(e, "isInner"), y = this.safeString(e, "memo");
    return {
      info: e,
      id: this.safeString2(e, "id", "withdrawalId"),
      timestamp: h,
      datetime: this.iso8601(h),
      network: this.networkIdToCode(this.safeString(e, "chain")),
      address: n,
      addressTo: n,
      addressFrom: void 0,
      tag: y,
      tagTo: y,
      tagFrom: void 0,
      currency: s,
      amount: this.parseNumber(r),
      txid: a,
      type: o,
      status: this.parseTransactionStatus(c),
      comment: this.safeString(e, "remark"),
      internal: m,
      fee: u,
      updated: l
    };
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchDeposits", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchDeposits", e, t, i, s);
    let r = {}, a;
    e !== void 0 && (a = this.currency(e), r.currency = a.id), i !== void 0 && (r.pageSize = i), [r, s] = this.handleUntilOption("endAt", r, s);
    let o;
    t !== void 0 && t < 1550448e6 ? (r.startAt = this.parseToInt(t / 1e3), o = await this.privateGetHistDeposits(this.extend(r, s))) : (t !== void 0 && (r.startAt = t), o = await this.privateGetDeposits(this.extend(r, s)));
    const c = o.data.items;
    return this.parseTransactions(c, a, t, i, { type: "deposit" });
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchWithdrawals", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchWithdrawals", e, t, i, s);
    let r = {}, a;
    e !== void 0 && (a = this.currency(e), r.currency = a.id), i !== void 0 && (r.pageSize = i), [r, s] = this.handleUntilOption("endAt", r, s);
    let o;
    t !== void 0 && t < 1550448e6 ? (r.startAt = this.parseToInt(t / 1e3), o = await this.privateGetHistWithdrawals(this.extend(r, s))) : (t !== void 0 && (r.startAt = t), o = await this.privateGetWithdrawals(this.extend(r, s)));
    const c = o.data.items;
    return this.parseTransactions(c, a, t, i, { type: "withdrawal" });
  }
  parseBalanceHelper(e) {
    const t = this.account();
    t.used = this.safeString(e, "holdBalance", this.safeString(e, "hold")), t.free = this.safeString(e, "availableBalance", this.safeString(e, "available")), t.total = this.safeString(e, "totalBalance", this.safeString(e, "total"));
    const i = this.safeString(e, "liability"), s = this.safeString(e, "interest");
    return t.debt = P.stringAdd(i, s), t;
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const t = this.safeString(e, "code"), i = this.safeString(e, "future");
    let s;
    t !== void 0 && (s = this.currency(t));
    const n = this.safeString2(this.options, "fetchBalance", "defaultType", "spot"), r = this.safeString(e, "type", n), a = this.safeValue(this.options, "accountsByType");
    let o = this.safeString(a, r, r);
    e = this.omit(e, "type"), this.safeBool(e, "hf", !1) && (o = "trade_hf"), e = this.omit(e, "hf");
    const [u, f] = this.handleMarginModeAndParams("fetchBalance", e);
    let h;
    const l = {}, p = u === "isolated" || o === "isolated", m = u === "cross" || o === "cross";
    if (p)
      s !== void 0 && (l.balanceCurrency = s.id), h = await this.privateGetIsolatedAccounts(this.extend(l, f));
    else if (m)
      h = await this.privateGetMarginAccount(this.extend(l, f));
    else if (i) {
      const b = o === "coin-m" ? ["BTC", "ETH", "DOT", "XRP", "SOL"] : ["USDT", "USDC"], T = {
        info: void 0,
        timestamp: void 0,
        datetime: void 0
      };
      return await Promise.all(b.map(async (x) => {
        const v = { currency: x }, _ = await this.futuresPrivateGetAccountOverview(this.extend(v, e)), V = this.account(), j = this.safeValue(_, "data"), G = this.safeCurrencyCode(x);
        V.free = this.safeString(j, "availableBalance"), V.total = this.safeString(j, "accountEquity"), V.used = P.stringSub(V.total, V.free), T[G] = V;
      })), this.safeBalance(T);
    } else
      o === "earn" ? h = await this.paginate("privateGetEarnHoldAssets", this.extend(l, f), "items") : (s !== void 0 && (l.currency = s.id), l.type = o, h = await this.privateGetAccounts(this.extend(l, f)));
    const y = this.safeValue(h, "data", []), w = {
      info: h,
      timestamp: void 0,
      datetime: void 0
    };
    if (p) {
      const b = this.safeValue(y, "assets", y);
      for (let T = 0; T < b.length; T++) {
        const x = b[T], v = this.safeString(x, "symbol"), _ = this.safeSymbol(v, void 0, "_"), V = this.safeValue(x, "baseAsset", {}), j = this.safeValue(x, "quoteAsset", {}), G = this.safeCurrencyCode(this.safeString(V, "currency")), W = this.safeCurrencyCode(this.safeString(j, "currency")), B = {};
        B[G] = this.parseBalanceHelper(V), B[W] = this.parseBalanceHelper(j), w[_] = this.safeBalance(B);
      }
    } else if (m) {
      const b = this.safeValue(y, "accounts", []);
      for (let T = 0; T < b.length; T++) {
        const x = b[T], v = this.safeString(x, "currency"), _ = this.safeCurrencyCode(v);
        w[_] = this.parseBalanceHelper(x);
      }
    } else if (o === "earn")
      h.forEach((b) => {
        const T = this.safeString(b, "currency"), x = this.safeCurrencyCode(T), v = this.account();
        v.used = this.safeString(b, "holdAmount"), v.total = this.safeString(b, "holdAmount"), w[x] = v;
      });
    else
      for (let b = 0; b < y.length; b++) {
        const T = y[b];
        if (this.safeString(T, "type") === o) {
          const v = this.safeString(T, "currency"), _ = this.safeCurrencyCode(v), V = this.account();
          V.total = this.safeString(T, "balance"), V.free = this.safeString(T, "available"), V.used = this.safeString(T, "holds"), w[_] = V;
        }
      }
    return p ? w : this.safeBalance(w);
  }
  async paginate(e, t, i, s = {}) {
    const n = await this[e](this.extend(t, s)), r = this.safeValue(n, "data", {}), a = this.safeValue(r, i, []), o = this.safeInteger(r, "totalPage"), c = this.safeInteger(r, "currentPage");
    if (c < o) {
      const u = this.extend(t, { page: c + 1 }), f = await this.paginate(e, u, i, s);
      return this.arrayConcat(a, f);
    }
    return a;
  }
  parseSubAccountTypeBalances(e) {
    const t = {};
    for (let i = 0; i < e.length; i++) {
      const s = e[i], n = this.safeString(s, "currency"), r = this.safeCurrencyCode(n);
      t[r] = {
        free: this.safeString(s, "available"),
        used: this.safeString(s, "holds"),
        total: this.safeString(s, "balance")
      };
    }
    return t;
  }
  // https://www.kucoin.com/docs/rest/account/sub-account/get-all-sub-accounts-balance-v2-
  async fetchSubAccountBalances(e, t = {}) {
    await this.loadMarkets();
    const s = (await this.paginate("privateGetSubAccounts", {}, "items")).find((c) => c.subUserId === e);
    if (s === void 0)
      throw new ku(e);
    const n = this.safeValue(s, "mainAccounts", []), r = this.safeValue(s, "tradeAccounts", []), a = this.safeValue(s, "marginAccounts", []), o = this.safeValue(s, "tradeHFAccounts", []);
    return {
      main: this.parseSubAccountTypeBalances(n),
      trade: this.parseSubAccountTypeBalances(r),
      margin: this.parseSubAccountTypeBalances(a),
      tradeHF: this.parseSubAccountTypeBalances(o)
    };
  }
  // https://www.kucoin.com/docs/rest/account/sub-account/get-all-sub-accounts-info-v2-
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.paginate("privateGetSubUser", {}, "items");
    return e == null ? void 0 : e.map((t) => ({
      uid: this.safeString(t, "userId")
    }));
  }
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    await this.loadMarkets();
    const o = this.currency(e), c = this.currencyToPrecision(e, t), u = n === "master" ? "OUT" : "IN", f = n === "master" ? r : n, h = this.convertTypeToAccount(i), l = this.convertTypeToAccount(s), p = n === "master" ? l : h, m = n === "master" ? h : l;
    if (m !== "trade" || p !== "trade")
      throw new Error("subAccountTransfer() only supports transferring between TRADE accounts");
    const y = {
      currency: o.id,
      amount: c,
      direction: u,
      subUserId: f,
      subAccountTypeExt: p,
      accountTypeExt: m
    };
    "clientOid" in a || (y.clientOid = this.uuid());
    const w = await this.privatePostAccountsSubTransfer(this.extend(y, a)), S = this.safeValue(w, "data");
    return this.parseTransfer(S, o);
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = this.currencyToPrecision(e, t);
    let o = this.convertTypeToAccount(i), c = this.convertTypeToAccount(s);
    const u = this.inArray(o, this.ids), f = this.inArray(c, this.ids);
    if (o === "contract") {
      if (c !== "main")
        throw new Vt().addMessage("transfer() only supports transferring from futures account to main account").exchange(this.id);
      const h = {
        currency: r.id,
        amount: a
      };
      "bizNo" in n || (h.bizNo = this.uuid22());
      const l = await this.futuresPrivatePostTransferOut(this.extend(h, n)), p = this.safeValue(l, "data");
      return this.parseTransfer(p, r);
    } else {
      const h = {
        currency: r.id,
        amount: a
      };
      (u || f) && (this.inArray(o, this.ids) && (h.fromTag = o, o = "isolated"), this.inArray(c, this.ids) && (h.toTag = c, c = "isolated")), h.from = o, h.to = c, "clientOid" in n || (h.clientOid = this.uuid());
      const l = await this.privatePostAccountsInnerTransfer(this.extend(h, n)), p = this.safeValue(l, "data");
      return this.parseTransfer(p, r);
    }
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeInteger(e, "createdAt"), s = this.safeString(e, "currency"), n = this.safeString(e, "status"), r = this.safeStringLower(e, "payAccountType"), a = this.safeStringLower(e, "recAccountType"), o = this.safeValue(this.options, "accountsByType"), c = this.safeString(o, r, r), u = this.safeString(o, a, a);
    return {
      id: this.safeString2(e, "applyId", "orderId"),
      currency: this.safeCurrencyCode(s, t),
      timestamp: i,
      datetime: this.iso8601(i),
      amount: this.safeNumber(e, "amount"),
      fromAccount: c,
      toAccount: u,
      status: this.parseTransferStatus(n),
      info: e
    };
  }
  parseTransferStatus(e) {
    const t = {
      PROCESSING: "pending"
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntryType(e) {
    const t = {
      "Assets Transferred in After Upgrading": "transfer",
      Deposit: "transaction",
      Withdrawal: "transaction",
      Transfer: "transfer",
      Trade_Exchange: "trade",
      // 'Vote for Coin': 'Vote for Coin', // Vote for Coin
      "KuCoin Bonus": "bonus",
      "Referral Bonus": "referral",
      Rewards: "bonus",
      // 'Distribution': 'Distribution', // Distribution, such as get GAS by holding NEO
      "Airdrop/Fork": "airdrop",
      "Other rewards": "bonus",
      "Fee Rebate": "rebate",
      "Buy Crypto": "trade",
      "Sell Crypto": "sell",
      "Public Offering Purchase": "trade",
      // 'Send red envelope': 'Send red envelope', // Send red envelope
      // 'Open red envelope': 'Open red envelope', // Open red envelope
      // 'Staking': 'Staking', // Staking
      // 'LockDrop Vesting': 'LockDrop Vesting', // LockDrop Vesting
      // 'Staking Profits': 'Staking Profits', // Staking Profits
      // 'Redemption': 'Redemption', // Redemption
      "Refunded Fees": "fee",
      "KCS Pay Fees": "fee",
      "Margin Trade": "trade",
      Loans: "Loans",
      // 'Borrowings': 'Borrowings', // Borrowings
      // 'Debt Repayment': 'Debt Repayment', // Debt Repayment
      // 'Loans Repaid': 'Loans Repaid', // Loans Repaid
      // 'Lendings': 'Lendings', // Lendings
      // 'Pool transactions': 'Pool transactions', // Pool-X transactions
      "Instant Exchange": "trade",
      "Sub-account transfer": "transfer",
      "Liquidation Fees": "fee"
      // Liquidation Fees
      // 'Soft Staking Profits': 'Soft Staking Profits', // Soft Staking Profits
      // 'Voting Earnings': 'Voting Earnings', // Voting Earnings on Pool-X
      // 'Redemption of Voting': 'Redemption of Voting', // Redemption of Voting on Pool-X
      // 'Voting': 'Voting', // Voting on Pool-X
      // 'Convert to KCS': 'Convert to KCS', // Convert to KCS
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeString(e, "id"), s = this.safeString(e, "currency"), n = this.safeCurrencyCode(s, t), r = this.safeNumber(e, "amount"), a = void 0, o = this.safeString(e, "bizType"), c = this.parseLedgerEntryType(o), u = this.safeString(e, "direction"), f = this.safeInteger(e, "createdAt"), h = this.iso8601(f), l = this.safeString(e, "accountType"), p = this.safeString(e, "context");
    let m;
    if (p !== void 0 && p !== "")
      try {
        const b = JSON.parse(p), T = this.safeString(b, "orderId"), x = this.safeString(b, "tradeId");
        x !== void 0 ? m = x : m = T;
      } catch {
        m = p;
      }
    let y;
    const w = this.safeString(e, "fee");
    let S;
    return w !== "0" && (S = n, y = { cost: this.parseNumber(w), currency: S }), {
      id: i,
      direction: u,
      account: l,
      referenceId: m,
      referenceAccount: l,
      type: c,
      currency: n,
      amount: r,
      timestamp: f,
      datetime: h,
      before: void 0,
      after: a,
      status: void 0,
      fee: y,
      info: e
    };
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets(), await this.loadAccounts();
    let n = !1;
    [n, s] = this.handleOptionAndParams(s, "fetchLedger", "paginate");
    const r = this.safeValue(s, "hf");
    if (s = this.omit(s, "hf"), n)
      return await this.fetchPaginatedCallDynamic("fetchLedger", e, t, i, s);
    let a = {
      // 'currency': currency['id'], // can choose up to 10, if not provided returns for all currencies by default
      // 'direction': 'in', // 'out'
      // 'bizType': 'DEPOSIT', // DEPOSIT, WITHDRAW, TRANSFER, SUB_TRANSFER,TRADE_EXCHANGE, MARGIN_EXCHANGE, KUCOIN_BONUS (optional)
      // 'startAt': since,
      // 'endAt': exchange.milliseconds (),
    };
    t !== void 0 && (a.startAt = t);
    let o;
    e !== void 0 && (o = this.currency(e), a.currency = o.id), [a, s] = this.handleUntilOption("endAt", a, s);
    let c;
    [c, s] = this.handleMarginModeAndParams("fetchLedger", s);
    let u;
    r ? c !== void 0 ? u = await this.privateGetHfMarginAccountLedgers(this.extend(a, s)) : u = await this.privateGetHfAccountsLedgers(this.extend(a, s)) : u = await this.privateGetAccountsLedgers(this.extend(a, s));
    const f = this.safeList(u, "data");
    if (f !== void 0)
      return this.parseLedger(f, o, t, i);
    const h = this.safeDict(u, "data"), l = this.safeList(h, "items", []);
    return this.parseLedger(l, o, t, i);
  }
  calculateRateLimiterCost(e, t, i, s, n = {}) {
    const r = this.safeValue(this.options, "versions", {}), a = this.safeValue(r, e, {}), o = this.safeValue(a, t, {}), c = this.safeString(o, i, this.options.version), u = this.safeString(s, "version", c);
    return u === "v3" && "v3" in n ? n.v3 : u === "v2" && "v2" in n ? n.v2 : u === "v1" && "v1" in n ? n.v1 : this.safeValue(n, "cost", 1);
  }
  parseBorrowRateHistory(e, t, i, s) {
    const n = [];
    for (let a = 0; a < e.length; a++) {
      const o = e[a], c = this.parseBorrowRate(o);
      n.push(c);
    }
    const r = this.sortBy(n, "timestamp");
    return this.filterByCurrencySinceLimit(r, t, i, s);
  }
  parseBorrowRate(e, t = void 0) {
    const i = this.safeString(e, "timestamp"), s = P.stringMul(i, "0.000001"), n = this.safeString(e, "currency");
    return {
      currency: this.safeCurrencyCode(n, t),
      rate: this.safeNumber(e, "dailyIntRate"),
      period: 864e5,
      timestamp: s,
      datetime: this.iso8601(s),
      info: e
    };
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.publicGetCurrencies(t), s = this.safeValue(i, "data", []);
    return this.parseDepositWithdrawFees(s, e, "currency");
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    const a = this.safeValue(this.options, "versions", {}), o = this.safeValue(a, t, {}), c = this.safeValue(o, i, {}), u = this.safeString(c, e, this.options.version), f = this.safeString(s, "version", u);
    s = this.omit(s, "version");
    let h = "/api/" + f + "/" + this.implodeParams(e, s);
    t === "webExchange" && (h = "/" + this.implodeParams(e, s));
    const l = this.omit(s, this.extractParams(e));
    let p = "";
    n = n !== void 0 ? n : {};
    let m = this.urls.api[t];
    this.isEmpty(l) || (i === "GET" || i === "DELETE" ? h += "?" + this.rawencode(l) : (r = this.json(l), p = r, n["Content-Type"] = "application/json")), m = m + h;
    const y = t === "futuresPrivate";
    if (t === "private" || y) {
      this.checkRequiredCredentials();
      const S = this.nonce().toString();
      n = this.extend({
        "KC-API-KEY-VERSION": "2",
        "KC-API-KEY": this.apiKey,
        "KC-API-TIMESTAMP": S
      }, n);
      const b = this.safeString(n, "KC-API-KEY-VERSION");
      if (b === "2" || b === "3") {
        let j;
        this.externalSigner ? j = await this.externalSigner.sign({
          payload: this.encode(this.password),
          publicApiKey: this.apiKey,
          exchangeId: this.id
        }) : j = this.hmac(this.encode(this.password), this.encode(this.secret), Re, "base64"), n["KC-API-PASSPHRASE"] = j;
      } else
        n["KC-API-PASSPHRASE"] = this.password;
      const T = S + i + h + p;
      let x;
      this.externalSigner ? x = await this.externalSigner.sign({
        payload: this.encode(T),
        publicApiKey: this.apiKey,
        exchangeId: this.id
      }) : x = this.hmac(this.encode(T), this.encode(this.secret), Re, "base64"), n["KC-API-SIGN"] = x;
      let v = this.safeValue(this.options, "partner", {});
      v = y ? this.safeValue(v, "future", v) : this.safeValue(v, "spot", v);
      const _ = this.safeString(v, "id"), V = this.safeString2(v, "secret", "key");
      if (_ !== void 0 && V !== void 0) {
        const j = S + _ + this.apiKey, G = this.hmac(this.encode(j), this.encode(V), Re, "base64");
        n["KC-API-PARTNER-SIGN"] = G, n["KC-API-PARTNER"] = _;
      }
    }
    return { url: m, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (!a) {
      this.throwBroadlyMatchedException(this.exceptions.broad, r, r);
      return;
    }
    const u = this.safeString(a, "code"), f = this.safeString2(a, "msg", "data", ""), h = u + ": " + f;
    if (this.throwExactlyMatchedException(this.exceptions.exact, f, h), this.throwExactlyMatchedException(this.exceptions.exact, u, h), this.throwBroadlyMatchedException(this.exceptions.broad, r, h), u !== "200000" && u !== "200")
      throw new O().addMessage(h).exchange(this.id);
  }
}
let dw = class extends gt {
};
class cw extends dw {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "mexc",
      name: "MEXC Global",
      countries: ["SC"],
      rateLimit: 50,
      version: "v3",
      certified: !0,
      pro: !0,
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !1,
        option: !1,
        cancelAllOrders: !0,
        cancelOrder: !0,
        cancelOrders: void 0,
        createDepositAddress: !0,
        createMarketBuyOrderWithCost: !0,
        createMarketOrderWithCost: !1,
        createMarketSellOrderWithCost: !1,
        createOrder: !0,
        createOrders: !0,
        deposit: void 0,
        editOrder: void 0,
        fetchAccounts: !0,
        fetchBalance: !0,
        fetchCanceledOrders: !0,
        fetchClosedOrder: void 0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDeposit: void 0,
        fetchDepositAddress: !0,
        fetchDepositAddresses: void 0,
        fetchDepositAddressesByNetwork: !0,
        fetchDeposits: !0,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchL2OrderBook: !0,
        fetchLedger: void 0,
        fetchLedgerEntry: void 0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrder: void 0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrderBooks: void 0,
        fetchOrders: !0,
        fetchOrderTrades: !0,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchPositionsRisk: void 0,
        fetchStatus: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: void 0,
        fetchTradingFees: !0,
        fetchTradingLimits: void 0,
        fetchTransactionFee: "emulated",
        fetchTransactionFees: !0,
        fetchTransactions: void 0,
        fetchTransfer: !0,
        fetchTransfers: !0,
        fetchWithdrawal: void 0,
        fetchWithdrawals: !0,
        transfer: void 0,
        withdraw: !0
      },
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/137283979-8b2a818d-8633-461b-bfca-de89e8c446b2.jpg",
        api: {
          spot: {
            public: "https://api.mexc.com",
            private: "https://api.mexc.com"
          },
          spot2: {
            public: "https://www.mexc.com/open/api/v2",
            private: "https://www.mexc.com/open/api/v2"
          },
          contract: {
            public: "https://contract.mexc.com/api/v1/contract",
            private: "https://contract.mexc.com/api/v1/private"
          },
          broker: {
            private: "https://api.mexc.com/api/v3/broker"
          }
        },
        www: "https://www.mexc.com/",
        doc: [
          "https://mexcdevelop.github.io/apidocs/"
        ],
        fees: [
          "https://www.mexc.com/fee"
        ],
        // https://m.mexc.com/auth/signup?inviteCode=1FQ1G - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
        referral: "https://m.mexc.com/auth/signup"
      },
      api: {
        spot: {
          public: {
            get: {
              ping: 1,
              time: 1,
              exchangeInfo: 10,
              depth: 1,
              trades: 5,
              historicalTrades: 1,
              aggTrades: 1,
              klines: 1,
              avgPrice: 1,
              "ticker/24hr": 1,
              "ticker/price": 1,
              "ticker/bookTicker": 1,
              "etf/info": 1
            }
          },
          private: {
            get: {
              order: 2,
              openOrders: 3,
              allOrders: 10,
              account: 10,
              myTrades: 10,
              "sub-account/list": 1,
              "sub-account/apiKey": 1,
              "sub-account/asset": 1,
              "capital/config/getall": 10,
              "capital/deposit/hisrec": 1,
              "capital/withdraw/history": 1,
              "capital/withdraw/address": 10,
              "capital/deposit/address": 10,
              "capital/transfer": 1,
              "capital/transfer/tranId": 1,
              "capital/transfer/internal": 1,
              "capital/sub-account/universalTransfer": 1,
              "capital/convert": 1,
              "capital/convert/list": 1,
              "margin/loan": 1,
              "margin/allOrders": 1,
              "margin/myTrades": 1,
              "margin/openOrders": 1,
              "margin/maxTransferable": 1,
              "margin/priceIndex": 1,
              "margin/order": 1,
              "margin/isolated/account": 1,
              "margin/maxBorrowable": 1,
              "margin/repay": 1,
              "margin/isolated/pair": 1,
              "margin/forceLiquidationRec": 1,
              "margin/isolatedMarginData": 1,
              "margin/isolatedMarginTier": 1,
              "rebate/taxQuery": 1,
              "rebate/detail": 1,
              "rebate/detail/kickback": 1,
              "rebate/referCode": 1,
              "rebate/affiliate/commission": 1,
              "rebate/affiliate/withdraw": 1,
              "rebate/affiliate/commission/detail": 1,
              "mxDeduct/enable": 1,
              userDataStream: 1
            },
            post: {
              order: 1,
              "order/test": 1,
              "sub-account/virtualSubAccount": 1,
              "sub-account/apiKey": 1,
              "sub-account/futures": 1,
              "sub-account/margin": 1,
              batchOrders: 10,
              "capital/withdraw/apply": 1,
              "capital/transfer": 1,
              "capital/transfer/internal": 1,
              "capital/deposit/address": 1,
              "capital/sub-account/universalTransfer": 1,
              "capital/convert": 10,
              "mxDeduct/enable": 1,
              userDataStream: 1
            },
            put: {
              userDataStream: 1
            },
            delete: {
              order: 1,
              openOrders: 1,
              "sub-account/apiKey": 1,
              "margin/order": 1,
              "margin/openOrders": 1,
              userDataStream: 1
            }
          }
        },
        contract: {
          public: {
            get: {
              ping: 2,
              detail: 100,
              support_currencies: 2,
              "depth/{symbol}": 2,
              "depth_commits/{symbol}/{limit}": 2,
              "index_price/{symbol}": 2,
              "fair_price/{symbol}": 2,
              "funding_rate/{symbol}": 2,
              "kline/{symbol}": 2,
              "kline/index_price/{symbol}": 2,
              "kline/fair_price/{symbol}": 2,
              "deals/{symbol}": 2,
              ticker: 2,
              risk_reverse: 2,
              "risk_reverse/history": 2,
              "funding_rate/history": 2
            }
          },
          private: {
            get: {
              "account/assets": 2,
              "account/asset/{currency}": 2,
              "account/transfer_record": 2,
              "position/list/history_positions": 2,
              "position/open_positions": 2,
              "position/funding_records": 2,
              "position/position_mode": 2,
              "order/list/open_orders/{symbol}": 2,
              "order/list/history_orders": 2,
              "order/external/{symbol}/{external_oid}": 2,
              "order/get/{order_id}": 2,
              "order/batch_query": 8,
              "order/deal_details/{order_id}": 2,
              "order/list/order_deals": 2,
              "planorder/list/orders": 2,
              "stoporder/list/orders": 2,
              "stoporder/order_details/{stop_order_id}": 2,
              "account/risk_limit": 2,
              "account/tiered_fee_rate": 2,
              "position/leverage": 2
            },
            post: {
              "position/change_margin": 2,
              "position/change_leverage": 2,
              "position/change_position_mode": 2,
              "order/submit": 2,
              "order/submit_batch": 40,
              "order/cancel": 2,
              "order/cancel_with_external": 2,
              "order/cancel_all": 2,
              "account/change_risk_level": 2,
              "planorder/place": 2,
              "planorder/cancel": 2,
              "planorder/cancel_all": 2,
              "stoporder/cancel": 2,
              "stoporder/cancel_all": 2,
              "stoporder/change_price": 2,
              "stoporder/change_plan_price": 2
            }
          }
        },
        spot2: {
          public: {
            get: {
              "market/symbols": 1,
              "market/coin/list": 2,
              "common/timestamp": 1,
              "common/ping": 2,
              "market/ticker": 1,
              "market/depth": 1,
              "market/deals": 1,
              "market/kline": 1,
              "market/api_default_symbols": 2
            }
          },
          private: {
            get: {
              "account/info": 1,
              "order/open_orders": 1,
              "order/list": 1,
              "order/query": 1,
              "order/deals": 1,
              "order/deal_detail": 1,
              "asset/deposit/address/list": 2,
              "asset/deposit/list": 2,
              "asset/address/list": 2,
              "asset/withdraw/list": 2,
              "asset/internal/transfer/record": 10,
              "account/balance": 10,
              "asset/internal/transfer/info": 10,
              "market/api_symbols": 2
            },
            post: {
              "order/place": 1,
              "order/place_batch": 1,
              "order/advanced/place_batch": 1,
              "asset/withdraw": 2,
              "asset/internal/transfer": 10
            },
            delete: {
              "order/cancel": 1,
              "order/cancel_by_symbol": 1,
              "asset/withdraw": 2
            }
          }
        },
        broker: {
          private: {
            get: {
              "sub-account/universalTransfer": 1,
              "sub-account/list": 1,
              "sub-account/apiKey": 1,
              "capital/deposit/subAddress": 1,
              "capital/deposit/subHisrec": 1,
              "capital/deposit/subHisrec/getall": 1
            },
            post: {
              "sub-account/virtualSubAccount": 1,
              "sub-account/apiKey": 1,
              "capital/deposit/subAddress": 1,
              "capital/withdraw/apply": 1,
              "sub-account/universalTransfer": 1,
              "sub-account/futures": 1
            },
            delete: {
              "sub-account/apiKey": 1
            }
          }
        }
      },
      precisionMode: ct,
      timeframes: {
        "1m": "1m",
        "5m": "5m",
        "15m": "15m",
        "30m": "30m",
        "1h": "1h",
        "4h": "4h",
        "8h": "8h",
        "1d": "1d",
        "1w": "1w",
        "1M": "1M"
        // spot, swap
      },
      fees: {
        trading: {
          tierBased: !1,
          percentage: !0,
          maker: this.parseNumber("0.002"),
          taker: this.parseNumber("0.002")
        }
      },
      options: {
        timeDifference: 0,
        createMarketBuyOrderRequiresPrice: !0,
        unavailableContracts: {
          "BTC/USDT:USDT": !0,
          "LTC/USDT:USDT": !0,
          "ETH/USDT:USDT": !0
        },
        fetchMarkets: {
          types: {
            spot: !0,
            swap: {
              linear: !0,
              inverse: !1
            }
          }
        },
        timeframes: {
          spot: {
            "1m": "1m",
            "5m": "5m",
            "15m": "15m",
            "30m": "30m",
            "1h": "60m",
            "4h": "4h",
            "1d": "1d",
            "1M": "1M"
          },
          swap: {
            "1m": "Min1",
            "5m": "Min5",
            "15m": "Min15",
            "30m": "Min30",
            "1h": "Min60",
            "4h": "Hour4",
            "8h": "Hour8",
            "1d": "Day1",
            "1w": "Week1",
            "1M": "Month1"
          }
        },
        defaultType: "spot",
        defaultNetwork: "ETH",
        defaultNetworks: {
          ETH: "ETH",
          USDT: "ERC20",
          USDC: "ERC20",
          BTC: "BTC",
          LTC: "LTC"
        },
        networks: {
          ABBC: "ABBC",
          ACA: "ACALA",
          ADA: "Cardano(ADA)",
          AE: "AE",
          ALGO: "Algorand(ALGO)",
          ALPH: "Alephium(ALPH)",
          AME: "AME",
          AOK: "AOK",
          APT: "APTOS(APT)",
          AR: "AR",
          ARB: "Arbitrum One(ARB)",
          ARBNOVA: "ARBNOVA",
          ARBONE: "ArbitrumOne(ARB)",
          ARK: "ARK",
          ASTR: "ASTAR",
          ATOM: "Cosmos(ATOM)",
          AVAXC: "Avalanche C Chain(AVAX CCHAIN)",
          AVAXX: "Avalanche X Chain(AVAX XCHAIN)",
          AZERO: "Aleph Zero(AZERO)",
          BCH: "Bitcoin Cash(BCH)",
          BDX: "BDX",
          BEAM: "BEAM",
          BEP2: "BNB Beacon Chain(BEP2)",
          BEP20: "BNB Smart Chain(BEP20)",
          BITCI: "BITCI",
          BNC: "BNC",
          BNCDOT: "BNCPOLKA",
          BOBA: "BOBA",
          BSC: "BEP20(BSC)",
          BSV: "Bitcoin SV(BSV)",
          BTC: "Bitcoin(BTC)",
          BTM: "BTM2",
          CELO: "CELO",
          CFX: "CFX",
          CHZ: "Chiliz Legacy Chain(CHZ)",
          CHZ2: "Chiliz Chain(CHZ2)",
          CKB: "CKB",
          CLORE: "Clore.ai(CLORE)",
          CRC20: "CRONOS",
          CSPR: "CSPR",
          DASH: "DASH",
          DC: "Dogechain(DC)",
          DCR: "DCR",
          DNX: "Dynex(DNX)",
          DOGE: "Dogecoin(DOGE)",
          DOT: "Polkadot(DOT)",
          DYM: "Dymension(DYM)",
          EDG: "EDG",
          EGLD: "EGLD",
          EOS: "EOS",
          ERC20: "Ethereum(ERC20)",
          ETC: "Ethereum Classic(ETC)",
          ETHF: "ETF",
          ETHW: "ETHW",
          EVER: "EVER",
          FET: "FET",
          FIL: "FIL",
          FIO: "FIO",
          FLOW: "FLOW",
          FSN: "FSN",
          FTM: "Fantom(FTM)",
          FUSE: "FUSE",
          GLMR: "GLMR",
          GRIN: "GRIN",
          HBAR: "Hedera(HBAR)",
          HIVE: "HIVE",
          HRC20: "HECO",
          HYDRA: "HYDRA",
          ICP: "Internet Computer(ICP)",
          INDEX: "Index Chain",
          IOST: "IOST",
          IOTA: "IOTA",
          IOTX: "IOTX",
          IRIS: "IRIS",
          KAR: "KAR",
          KAS: "Kaspa(KAS)",
          KAVA: "KAVA",
          KDA: "KDA",
          KILT: "KILT",
          KLAY: "Klaytn(KLAY)",
          KMA: "KMA",
          KSM: "KSM",
          LAT: "LAT",
          LAVA: "Elysium(LAVA)",
          LTC: "Litecoin(LTC)",
          LUNA: "Terra(LUNA)",
          MASS: "MASS",
          MATIC: "Polygon(MATIC)",
          MCOIN: "Mcoin Network",
          METIS: "METIS",
          MINA: "MINA",
          MNT: "Mantle(MNT)",
          MOVR: "MOVR",
          MTRG: "Meter(MTRG)",
          NAS: "NAS",
          NEAR: "NEAR Protocol(NEAR)",
          NEBL: "NEBL",
          NEM: "NEM",
          NEO: "NEO",
          NEO3: "NEO3",
          NEOXA: "Neoxa Network",
          NULS: "NULS",
          OASIS: "ROSE",
          OASYS: "OASYS",
          OKC: "OKT",
          OMN: "Omega Network(OMN)",
          OMNI: "OMNI",
          ONE: "ONE",
          ONT: "ONT",
          OPTIMISM: "Optimism(OP)",
          OSMO: "OSMO",
          PLCU: "PLCU",
          POKT: "POKT",
          QKC: "QKC",
          QTUM: "QTUM",
          RAP20: "RAP20 (Rangers Mainnet)",
          REI: "REI",
          RSK: "RBTC",
          RVN: "Ravencoin(RVN)",
          SATOX: "Satoxcoin(SATOX)",
          SC: "SC",
          SCRT: "SCRT",
          SDN: "SDN",
          SGB: "SGB",
          SOL: "Solana(SOL)",
          STAR: "STAR",
          STARK: "Starknet(STARK)",
          STEEM: "STEEM",
          SYS: "SYS",
          TAO: "Bittensor(TAO)",
          TIA: "Celestia(TIA)",
          TOMO: "TOMO",
          TON: "Toncoin(TON)",
          TRC10: "TRC10",
          TRC20: "Tron(TRC20)",
          UGAS: "UGAS(Ultrain)",
          VET: "VeChain(VET)",
          VEX: "Vexanium(VEX)",
          VSYS: "VSYS",
          WAVES: "WAVES",
          WAX: "WAX",
          WEMIX: "WEMIX",
          XCH: "Chia(XCH)",
          XDC: "XDC",
          XEC: "XEC",
          XLM: "Stellar(XLM)",
          XMR: "Monero(XMR)",
          XNA: "Neurai(XNA)",
          XPR: "XPR Network",
          XRD: "XRD",
          XRP: "Ripple(XRP)",
          XTZ: "XTZ",
          XVG: "XVG",
          XYM: "XYM",
          ZEC: "ZEC",
          ZEN: "ZEN",
          ZIL: "Zilliqa(ZIL)",
          ZTG: "ZTG"
          // todo: uncomment below after concensus
          // 'ALAYA': 'ATP',
          // 'ANDUSCHAIN': 'DEB',
          // 'ASSETMANTLE': 'MNTL',
          // 'AXE': 'AXE',
          // 'BITCOINHD': 'BHD',
          // 'BITCOINVAULT': 'BTCV',
          // 'BITKUB': 'KUB',
          // 'BITSHARES_OLD': 'BTS',
          // 'BITSHARES': 'NBS',
          // 'BYTZ': 'BYTZ',
          // 'CANTO': 'CANTO', // CANTOEVM
          // 'CENNZ': 'CENNZ',
          // 'CHAINX': 'PCX',
          // 'CONCODRIUM': 'CCD',
          // 'CONTENTVALUENETWORK': 'CVNT',
          // 'CORTEX': 'CTXC',
          // 'CYPHERIUM': 'CPH',
          // 'DANGNN': 'DGC',
          // 'DARWINIASMARTCHAIN': 'Darwinia Smart Chain',
          // 'DHEALTH': 'DHP',
          // 'DOGECOIN': [ 'DOGE', 'DOGECHAIN' ], // todo after unification
          // 'DRAC': 'DRAC',
          // 'DRAKEN': 'DRK',
          // 'ECOCHAIN': 'ECOC',
          // 'ELECTRAPROTOCOL': 'XEP',
          // 'EMERALD': 'EMERALD', // sits on top of OASIS
          // 'EVMOS': 'EVMOS', // EVMOSETH is different
          // 'EXOSAMA': 'SAMA',
          // 'FIBOS': 'FO',
          // 'FILECASH': 'FIC',
          // 'FIRMACHAIN': 'FCT',
          // 'FIRO': 'XZC',
          // 'FNCY': 'FNCY',
          // 'FRUITS': 'FRTS',
          // 'GLEEC': 'GLEEC',
          // 'GXCHAIN': 'GXC',
          // 'HANDSHAKE': 'HNS',
          // 'HPB': 'HPB',
          // 'HSHARE': 'HC',
          // 'HUAHUA': 'HUAHUA',
          // 'HUPAYX': 'HPX',
          // 'INDEXCHAIN': 'IDX',
          // 'INTCHAIN': 'INT',
          // 'INTEGRITEE': 'TEER',
          // 'INTERLAY': 'INTR',
          // 'IOEX': 'IOEX',
          // 'JUNO': 'JUNO',
          // 'KASPA': 'KASPA',
          // 'KEKCHAIN': 'KEKCHAIN',
          // 'KINTSUGI': 'KINT',
          // 'KOINOS': 'KOINOS',
          // 'KONSTELLATION': 'DARC',
          // 'KUJIRA': 'KUJI',
          // 'KULUPU': 'KLP',
          // 'LBRY': 'LBC',
          // 'LEDGIS': 'LED',
          // 'LIGHTNINGBITCOIN': 'LBTC',
          // 'LINE': 'LINE',
          // 'MDNA': 'DNA',
          // 'MDUKEY': 'MDU',
          // 'METAMUI': 'MMUI',
          // 'METAVERSE_ETP': 'ETP',
          // 'METER': 'MTRG',
          // 'MEVERSE': 'MEVerse',
          // 'NEWTON': 'NEW',
          // 'NODLE': 'NODLE',
          // 'ORIGYN': 'OGY',
          // 'PAC': 'PAC',
          // 'PASTEL': 'PSL',
          // 'PHALA': 'Khala',
          // 'PLEX': 'PLEX',
          // 'PMG': 'PMG',
          // 'POINT': 'POINT', // POINTEVM is different
          // 'PROOFOFMEMES': 'POM',
          // 'PROXIMAX': 'XPX',
          // 'RCHAIN': 'REV',
          // 'REBUS': 'REBUS', // REBUSEVM is different
          // 'RIZON': 'ATOLO',
          // 'SENTINEL': 'DVPN',
          // 'SERO': 'SERO',
          // 'TECHPAY': 'TPC',
          // 'TELOSCOIN': 'TLOS', // todo
          // 'TERRA': 'LUNA2',
          // 'TERRACLASSIC': 'LUNC',
          // 'TLOS': 'TELOS', // todo
          // 'TOMAINFO': 'TON',
          // 'TONGTONG': 'TTC',
          // 'TURTLECOIN': 'TRTL',
          // 'ULORD': 'UT',
          // 'ULTRAIN': 'UGAS',
          // 'UMEE': 'UMEE',
          // 'VDIMENSION': 'VOLLAR',
          // 'VEXANIUM': 'VEX',
          // 'VNT': 'VNT',
          // 'WAYKICHAIN': 'WICC',
          // 'WHITECOIN': 'XWC',
          // 'WITNET': 'WIT',
          // 'XDAI': 'XDAI',
          // 'XX': 'XX',
          // 'YAS': 'YAS',
          // 'ZENITH': 'ZENITH',
          // 'ZKSYNC': 'ZKSYNC',
          // // 'BAJUN': '',
          // OKB <> OKT (for usdt it's exception) for OKC, PMEER, FLARE, STRD, ZEL, FUND, "NONE", CRING, FREETON, QTZ  (probably unique network is meant), HT, BSC(RACAV1), BSC(RACAV2), AMBROSUS, BAJUN, NOM. their individual info is at https://www.mexc.com/api/platform/asset/spot/{COINNAME}
        },
        networksById: {
          "Aleph Zero(AZERO)": "AZERO",
          "Alephium(ALPH)": "ALPH",
          "Algorand(ALGO)": "ALGO",
          "APTOS(APT)": "APT",
          "Arbitrum One(ARB)": "ARB",
          "Avalanche C Chain(AVAX CCHAIN)": "AVAXC",
          "Avalanche X Chain(AVAX XCHAIN)": "AVAXX",
          "BEP20(BSC)": "BSC",
          "Bitcoin Cash(BCH)": "BCH",
          "Bitcoin SV(BSV)": "BSV",
          "Bitcoin(BTC)": "BTC",
          "Bittensor(TAO)": "TAO",
          "BNB Beacon Chain(BEP2)": "BEP2",
          "BNB Smart Chain(BEP20-RACAV1)": "BSC",
          "BNB Smart Chain(BEP20-RACAV2)": "BSC",
          "BNB Smart Chain(BEP20)": "BSC",
          "Cardano(ADA)": "ADA",
          "Celestia(TIA)": "TIA",
          "Chia(XCH)": "XCH",
          "Chiliz Chain(CHZ2)": "CHZ2",
          "Chiliz Legacy Chain(CHZ)": "CHZ",
          "Clore.ai(CLORE)": "CLORE",
          "Cosmos(ATOM)": "ATOM",
          "Dogechain(DC)": "DC",
          "Dogecoin(DOGE)": "DOGE",
          "Dymension(DYM)": "DYM",
          "Dynex(DNX)": "DNX",
          "Elysium(LAVA)": "LAVA",
          "Ethereum Classic(ETC)": "ETC",
          "Ethereum(ERC20)": "ERC20",
          "Fantom(FTM)": "FTM",
          "Hedera(HBAR)": "HBAR",
          "Index Chain": "INDEX",
          "Internet Computer(ICP)": "ICP",
          "Kaspa(KAS)": "KAS",
          "Klaytn(KLAY)": "KLAY",
          "Litecoin(LTC)": "LTC",
          "Mantle(MNT)": "MNT",
          "Mcoin Network": "MCOIN",
          "Meter(MTRG)": "MTRG",
          "Monero(XMR)": "XMR",
          "NEAR Protocol(NEAR)": "NEAR",
          "Neoxa Network": "NEOXA",
          "Neurai(XNA)": "XNA",
          "Omega Network(OMN)": "OMN",
          "Optimism(OP)": "OPTIMISM",
          "Polkadot(DOT)": "DOT",
          "Polygon(MATIC)": "MATIC",
          "RAP20 (Rangers Mainnet)": "RAP20",
          "Ravencoin(RVN)": "RVN",
          "Ripple(XRP)": "XRP",
          "Satoxcoin(SATOX)": "SATOX",
          "Solana(SOL)": "SOL",
          "Starknet(STARK)": "STARK",
          "Stellar(XLM)": "XLM",
          "Terra(LUNA)": "LUNA",
          "Toncoin(TON)": "TON",
          "Tron(TRC20)": "TRC20",
          "UGAS(Ultrain)": "UGAS",
          "VeChain(VET)": "VET",
          "Vexanium(VEX)": "VEX",
          "XPR Network": "XPR",
          "Zilliqa(ZIL)": "ZIL"
          // TODO: uncomment below after deciding unified name
          // 'PEPE COIN BSC':
          // 'SMART BLOCKCHAIN':
          // 'f(x)Core':
          // 'Syscoin Rollux':
          // 'Syscoin UTXO':
          // 'zkSync Era':
          // 'zkSync Lite':
          // 'Darwinia Smart Chain':
          // 'Arbitrum One(ARB-Bridged)':
          // 'Optimism(OP-Bridged)':
          // 'Polygon(MATIC-Bridged)':
        },
        recvWindow: 5 * 1e3,
        maxTimeTillEnd: 90 * 86400 * 1e3 - 1,
        broker: "CEDE",
        accountsByType: {
          spot: "SPOT",
          swap: "FUTURES",
          margin: "ISOLATED_MARGIN"
        }
      },
      exceptions: {
        exact: {
          // until mexc migrates fully to v3, it might be worth to note the version & market aside errors, not easily remove obsolete version's exceptions in future
          "-1128": O,
          "-2011": O,
          "-1121": g,
          10101: re,
          2009: k,
          2011: O,
          30004: re,
          33333: g,
          44444: O,
          1002: k,
          30019: pe,
          30005: k,
          2003: k,
          2005: re,
          400: g,
          // '500': OnMaintenance, // {"code": 500,"message": "Under maintenance, please try again later","announcement": "https://www.mexc.com/support/articles/17827791510263"}
          600: O,
          70011: ee,
          88004: re,
          88009: O,
          88013: g,
          88015: re,
          700003: ze,
          26: O,
          602: Z,
          10001: Z,
          10007: g,
          10015: g,
          10072: Z,
          10073: Nt,
          10095: g,
          10096: g,
          10097: g,
          10098: k,
          10099: O,
          10100: $e,
          10102: g,
          10103: O,
          10200: je,
          10201: je,
          10202: je,
          10206: Vt,
          10211: Vt,
          10212: ke,
          10216: O,
          10219: O,
          10222: g,
          10232: $e,
          10259: O,
          10265: O,
          10268: g,
          20001: O,
          20002: O,
          22222: O,
          3e4: O,
          30001: k,
          30002: g,
          30003: g,
          30010: g,
          30014: g,
          30016: k,
          30018: Ee,
          30020: Z,
          30021: g,
          30025: k,
          30026: Se,
          30027: k,
          30028: k,
          30029: k,
          30032: k,
          30041: k,
          60005: O,
          700001: Z,
          700002: Z,
          700004: g,
          700005: ze,
          700006: ee,
          700007: ee,
          700008: g,
          730001: it,
          730002: g,
          73e4: O,
          730003: O,
          730100: O,
          730600: O,
          730601: O,
          730602: O,
          730700: O,
          730701: O,
          730702: O,
          730703: O,
          730704: O,
          730705: O,
          730706: Z,
          730707: Z,
          730101: O,
          140001: O,
          140002: Z,
          152046: gi
          // Unable to withdraw to this address. Please contact the relevant business party.
        },
        broad: {
          "Order quantity error, please try to modify.": g,
          "Combination of optional parameters invalid": g,
          "api market order is disabled": pe,
          "Contract not allow place order!": k,
          Oversold: k,
          "Insufficient position": re,
          "Insufficient balance!": re,
          "Bid price is great than max allow price": g,
          "Invalid symbol.": g,
          "Param error!": g,
          maintenance: dt
          // {"code": 500,"message": "Under maintenance, please try again later","announcement": "https://www.mexc.com/support/articles/17827791510263"}
        }
      }
    });
  }
  async fetchStatus(e = {}) {
    const [t, i] = this.handleMarketTypeAndParams("fetchStatus", void 0, e);
    let s, n, r;
    return t === "spot" ? (s = await this.spotPublicGetPing(i), n = Object.keys(s).length ? this.json(s) : "ok") : t === "swap" && (s = await this.contractPublicGetPing(i), n = this.safeValue(s, "success") ? "ok" : this.json(s), r = this.safeInteger(s, "data")), {
      status: n,
      updated: r,
      url: void 0,
      eta: void 0,
      info: s
    };
  }
  async fetchTime(e = {}) {
    const [t, i] = this.handleMarketTypeAndParams("fetchTime", void 0, e);
    let s;
    if (t === "spot")
      return s = await this.spotPublicGetTime(i), this.safeInteger(s, "serverTime");
    if (t === "swap")
      return s = await this.contractPublicGetPing(i), this.safeInteger(s, "data");
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  isUsingForcedProxy(e = {}, t = []) {
    return t[1] === "private";
  }
  async fetchCurrencies(e = {}) {
    if (!this.checkRequiredCredentials(!1))
      return;
    const t = await this.spotPrivateGetCapitalConfigGetall(e), i = {};
    for (let s = 0; s < t.length; s++) {
      const n = t[s], r = this.safeString(n, "coin"), a = this.safeCurrencyCode(r), o = this.safeString(n, "name");
      let c = !1, u, f, h, l = !1, p = !1;
      const m = {}, y = this.safeValue(n, "networkList", []);
      for (let b = 0; b < y.length; b++) {
        const T = y[b], x = this.safeString(T, "network"), v = this.safeBool(T, "depositEnable", !1), _ = this.safeBool(T, "withdrawEnable", !1), V = v && _;
        c = V || c;
        const j = this.safeString(T, "withdrawMin"), G = this.safeString(T, "withdrawMax");
        f = f === void 0 ? j : f, h = h === void 0 ? G : h;
        const W = this.safeNumber(T, "withdrawFee");
        u = u === void 0 ? W : u, P.stringGt(f, j) && (f = j), P.stringLt(h, G) && (h = G), v && (l = !0), _ && (p = !0), m[x] = {
          info: T,
          id: x,
          network: x,
          active: V,
          deposit: v,
          withdraw: _,
          fee: W,
          precision: void 0,
          limits: {
            withdraw: {
              min: j,
              max: G
            }
          }
        };
      }
      const S = Object.keys(m).length;
      if (S === 1 || "NONE" in m) {
        const b = this.safeValue2(m, "NONE", S - 1);
        b !== void 0 && (u = b.fee);
      }
      i[a] = {
        info: n,
        id: r,
        code: a,
        name: o,
        active: c,
        deposit: l,
        withdraw: p,
        fee: u,
        precision: void 0,
        limits: {
          amount: {
            min: void 0,
            max: void 0
          },
          withdraw: {
            min: f,
            max: h
          }
        },
        networks: m
      };
    }
    return i;
  }
  async fetchMarkets(e = {}) {
    const t = await this.fetchSpotMarkets(e), i = await this.fetchSwapMarkets(e);
    return this.arrayConcat(t, i);
  }
  async fetchSpotMarkets(e = {}) {
    const t = await this.spotPublicGetExchangeInfo(e), i = this.safeValue(t, "symbols", []), s = [];
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "symbol"), o = this.safeString(r, "baseAsset"), c = this.safeString(r, "quoteAsset"), u = this.safeCurrencyCode(o), f = this.safeCurrencyCode(c), h = this.safeString(r, "status"), l = this.safeValue(r, "isSpotTradingAllowed");
      let p = !1;
      (h === "ENABLED" || h === "1") && l && (p = !0);
      const m = this.safeValue(r, "isMarginTradingAllowed"), y = this.safeNumber(r, "makerCommission"), w = this.safeNumber(r, "takerCommission"), S = this.safeNumber(r, "maxQuoteAmount");
      s.push({
        id: a,
        symbol: u + "/" + f,
        base: u,
        quote: f,
        settle: void 0,
        baseId: o,
        quoteId: c,
        settleId: void 0,
        type: "spot",
        spot: !0,
        margin: m,
        swap: !1,
        future: !1,
        option: !1,
        active: p,
        contract: !1,
        linear: void 0,
        inverse: void 0,
        taker: w,
        maker: y,
        contractSize: void 0,
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.parseNumber(this.parsePrecision(this.safeString(r, "baseAssetPrecision"))),
          price: this.parseNumber(this.parsePrecision(this.safeString(r, "quoteAssetPrecision")))
        },
        limits: {
          leverage: {
            min: void 0,
            max: void 0
          },
          amount: {
            min: this.safeNumber(r, "baseSizePrecision"),
            max: void 0
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: this.safeNumber(r, "quoteAmountPrecision"),
            max: S
          }
        },
        created: void 0,
        info: r
      });
    }
    return s;
  }
  async fetchSwapMarkets(e = {}) {
    const t = await this.contractPublicGetDetail(e), i = this.safeValue(t, "data", []), s = [];
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "symbol"), o = this.safeString(r, "baseCoin"), c = this.safeString(r, "quoteCoin"), u = this.safeString(r, "settleCoin"), f = this.safeCurrencyCode(o), h = this.safeCurrencyCode(c), l = this.safeCurrencyCode(u), p = this.safeString(r, "state");
      s.push({
        id: a,
        symbol: f + "/" + h + ":" + l,
        base: f,
        quote: h,
        settle: l,
        baseId: o,
        quoteId: c,
        settleId: u,
        type: "swap",
        spot: !1,
        margin: !1,
        swap: !0,
        future: !1,
        option: !1,
        active: p === "0",
        contract: !0,
        linear: !0,
        inverse: !1,
        taker: this.safeNumber(r, "takerFeeRate"),
        maker: this.safeNumber(r, "makerFeeRate"),
        contractSize: this.safeNumber(r, "contractSize"),
        expiry: void 0,
        expiryDatetime: void 0,
        strike: void 0,
        optionType: void 0,
        precision: {
          amount: this.safeNumber(r, "volUnit"),
          price: this.safeNumber(r, "priceUnit")
        },
        limits: {
          leverage: {
            min: this.safeNumber(r, "minLeverage"),
            max: this.safeNumber(r, "maxLeverage")
          },
          amount: {
            min: this.safeNumber(r, "minVol"),
            max: this.safeNumber(r, "maxVol")
          },
          price: {
            min: void 0,
            max: void 0
          },
          cost: {
            min: void 0,
            max: void 0
          }
        },
        created: void 0,
        info: r
      });
    }
    return s;
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = this.market(e), n = {
      symbol: s.id
    };
    t !== void 0 && (n.limit = t);
    let r;
    if (s.spot) {
      const a = await this.spotPublicGetDepth(this.extend(n, i)), o = this.safeInteger(a, "timestamp");
      r = this.parseOrderBook(a, e, o), r.nonce = this.safeInteger(a, "lastUpdateId");
    } else if (s.swap) {
      const a = await this.contractPublicGetDepthSymbol(this.extend(n, i)), o = this.safeValue(a, "data"), c = this.safeInteger(o, "timestamp");
      r = this.parseOrderBook(o, e, c), r.nonce = this.safeInteger(o, "version");
    }
    return r;
  }
  parseBidAsk(e, t = 0, i = 1, s = 2) {
    const r = this.safeNumber(e, t), a = this.safeNumber(e, i), o = this.safeNumber(e, 2);
    return o !== void 0 ? [r, a, o] : [r, a];
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = this.market(e), r = {
      symbol: n.id
    };
    i !== void 0 && (r.limit = i);
    let a;
    if (n.spot) {
      const o = this.safeIntegerN(s, ["endTime", "until", "till"]);
      if (t !== void 0 && (r.startTime = t, o === void 0))
        throw new g("fetchTrades() requires an until parameter when since is provided").exchange(this.id);
      if (o !== void 0) {
        if (t === void 0)
          throw new g("fetchTrades() requires a since parameter when until is provided").exchange(this.id);
        r.endTime = o;
      }
      let c = this.safeString(this.options, "fetchTradesMethod", "spotPublicGetAggTrades");
      if (c = this.safeString(s, "method", c), s = this.omit(s, ["method"]), c === "spotPublicGetAggTrades")
        a = await this.spotPublicGetAggTrades(this.extend(r, s));
      else if (c === "spotPublicGetHistoricalTrades")
        a = await this.spotPublicGetHistoricalTrades(this.extend(r, s));
      else if (c === "spotPublicGetTrades")
        a = await this.spotPublicGetTrades(this.extend(r, s));
      else
        throw new pe(c).addMessage("fetchTrades() not support this method").exchange(this.id);
    } else if (n.swap) {
      const o = await this.contractPublicGetDealsSymbol(this.extend(r, s));
      a = this.safeValue(o, "data");
    }
    return this.parseTrades(a, n, t, i);
  }
  parseTrade(e, t = void 0) {
    let i, s, n, r, a, c, u, f, h, l;
    if ("v" in e)
      s = this.safeInteger(e, "t"), t = this.safeMarket(void 0, t), r = t.symbol, f = this.safeString(e, "p"), h = this.safeString(e, "v"), c = this.parseOrderSide(this.safeString(e, "T")), u = "taker";
    else {
      const p = this.safeString(e, "symbol");
      if (t = this.safeMarket(p, t), r = t.symbol, i = this.safeString2(e, "id", "a"), f = this.safeString2(e, "price", "p"), n = this.safeString(e, "orderId"), "positionMode" in e)
        s = this.safeInteger(e, "timestamp"), h = this.safeString(e, "vol"), c = this.parseOrderSide(this.safeString(e, "side")), a = {
          cost: this.safeString(e, "fee"),
          currency: this.safeCurrencyCode(this.safeString(e, "feeCurrency"))
        }, u = this.safeValue(e, "taker") ? "taker" : "maker";
      else {
        s = this.safeInteger2(e, "time", "T"), h = this.safeString2(e, "qty", "q"), l = this.safeString(e, "quoteQty");
        const m = this.safeValue(e, "isBuyer"), y = this.safeValue(e, "isMaker"), w = this.safeValue2(e, "isBuyerMaker", "m");
        y !== void 0 && (u = y ? "maker" : "taker"), m !== void 0 && (c = m ? "buy" : "sell"), w !== void 0 && (c = w ? "sell" : "buy", u = "taker");
        const S = this.safeString(e, "commissionAsset");
        S !== void 0 && (a = {
          cost: this.safeString(e, "commission"),
          currency: this.safeCurrencyCode(S)
        });
      }
    }
    return i === void 0 && (i = this.syntheticTradeId(t, s, c, h, f, void 0, u)), this.safeTrade({
      id: i,
      order: n,
      timestamp: s,
      datetime: this.iso8601(s),
      symbol: r,
      type: void 0,
      side: c,
      takerOrMaker: u,
      price: f,
      amount: h,
      cost: l,
      fee: a,
      info: e
    }, t);
  }
  syntheticTradeId(e = void 0, t = void 0, i = void 0, s = void 0, n = void 0, r = void 0, a = void 0) {
    let o = "";
    return t !== void 0 && (o = this.numberToString(t) + "-" + this.safeString(e, "id", "_"), i !== void 0 && (o += "-" + i), s !== void 0 && (o += "-" + this.numberToString(s)), n !== void 0 && (o += "-" + this.numberToString(n)), a !== void 0 && (o += "-" + a), r !== void 0 && (o += "-" + r)), o;
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = this.market(e), a = r.spot ? 1e3 : 2e3;
    let o = !1;
    if ([o, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate", !1), o)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, a);
    const c = this.safeValue(this.options, "timeframes", {}), u = this.safeValue(c, r.type, {}), f = this.safeString(u, t), h = this.parseTimeframe(t) * 1e3, l = {
      symbol: r.id,
      interval: f
    };
    let p;
    if (r.spot) {
      const m = this.safeIntegerN(n, ["until", "endTime", "till"]);
      if (i !== void 0 && (l.startTime = i, m === void 0)) {
        const w = this.sum(i, a * h), S = this.milliseconds();
        l.endTime = Math.min(w, S);
      }
      s !== void 0 && (l.limit = s), m !== void 0 && (n = this.omit(n, ["until", "till"]), l.endTime = m), p = await this.spotPublicGetKlines(this.extend(l, n));
    } else if (r.swap) {
      const m = this.safeIntegerProductN(n, ["until", "endTime", "till"], 1e-3);
      i !== void 0 && (l.start = this.parseToInt(i / 1e3)), m !== void 0 && (n = this.omit(n, ["until", "till"]), l.end = m);
      const y = this.safeString(n, "price", "default");
      n = this.omit(n, "price");
      let w;
      if (y === "default")
        w = await this.contractPublicGetKlineSymbol(this.extend(l, n));
      else if (y === "index")
        w = await this.contractPublicGetKlineIndexPriceSymbol(this.extend(l, n));
      else if (y === "mark")
        w = await this.contractPublicGetKlineFairPriceSymbol(this.extend(l, n));
      else
        throw new g("fetchOHLCV() not support this price type, [default, index, mark]").exchange(this.id);
      const S = this.safeValue(w, "data");
      p = this.convertTradingViewToOHLCV(S, "time", "open", "high", "low", "close", "vol");
    }
    return this.parseOHLCVs(p, r, t, i, s);
  }
  parseOHLCV(e, t = void 0) {
    return [
      this.safeInteger(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 2),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, 5)
    ];
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {};
    let s, n = !1;
    if (e !== void 0) {
      n = e.length === 1;
      const u = this.safeString(e, 0);
      s = this.market(u);
    }
    const [r, a] = this.handleMarketTypeAndParams("fetchTickers", s, t);
    let o;
    if (n && (i.symbol = s.id), r === "spot")
      o = await this.spotPublicGetTicker24hr(this.extend(i, a));
    else if (r === "swap") {
      const c = await this.contractPublicGetTicker(this.extend(i, a));
      o = this.safeValue(c, "data", []);
    }
    return n && (o = [o]), this.parseTickers(o, e);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), [s, n] = this.handleMarketTypeAndParams("fetchTicker", i, t);
    let r;
    const a = {
      symbol: i.id
    };
    if (s === "spot")
      r = await this.spotPublicGetTicker24hr(this.extend(a, n));
    else if (s === "swap") {
      const o = await this.contractPublicGetTicker(this.extend(a, n));
      r = this.safeValue(o, "data", {});
    }
    return this.parseTicker(r, i);
  }
  parseTicker(e, t = void 0) {
    const i = this.safeString(e, "symbol");
    t = this.safeMarket(i, t);
    let s, n, r, a, o, c, u, f, h, l, p, m, y;
    return this.safeValue(t, "swap") || "timestamp" in e ? (s = this.safeInteger(e, "timestamp"), n = this.safeString(e, "bid1"), r = this.safeString(e, "ask1"), c = this.safeString(e, "volume24"), u = this.safeString(e, "amount24"), h = this.safeString(e, "high24Price"), l = this.safeString(e, "lower24Price"), m = this.safeString(e, "riseFallValue"), p = this.safeString(e, "riseFallRate"), p = P.stringMul(p, "100")) : (s = this.safeInteger(e, "closeTime"), n = this.safeString(e, "bidPrice"), r = this.safeString(e, "askPrice"), a = this.safeString(e, "bidQty"), o = this.safeString(e, "askQty"), P.stringEq(a, "0") && (a = void 0), P.stringEq(o, "0") && (o = void 0), c = this.safeString(e, "volume"), u = this.safeString(e, "quoteVolume"), f = this.safeString(e, "openPrice"), h = this.safeString(e, "highPrice"), l = this.safeString(e, "lowPrice"), y = this.safeString(e, "prevClosePrice"), m = this.safeString(e, "priceChange"), p = this.safeString(e, "priceChangePercent"), p = P.stringMul(p, "100")), this.safeTicker({
      symbol: t.symbol,
      timestamp: s,
      datetime: this.iso8601(s),
      open: f,
      high: h,
      low: l,
      close: this.safeString(e, "lastPrice"),
      bid: n,
      bidVolume: a,
      ask: r,
      askVolume: o,
      vwap: void 0,
      previousClose: y,
      change: m,
      percentage: p,
      average: void 0,
      baseVolume: c,
      quoteVolume: u,
      info: e
    }, t);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e), [o, c] = this.handleMarginModeAndParams("createOrder", r);
    return a.spot ? await this.createSpotOrder(a, t, i, s, n, o, c) : await this.createSwapOrder(a, t, i, s, n, o, c);
  }
  createSpotOrderRequest(e, t, i, s, n = void 0, r = void 0, a = {}) {
    const o = e.symbol, c = i.toUpperCase(), u = {
      symbol: e.id,
      side: c,
      type: t.toUpperCase()
    };
    if (c === "BUY" && t === "market") {
      let l = !0;
      [l, a] = this.handleOptionAndParams(a, "createOrder", "createMarketBuyOrderRequiresPrice", !0);
      const p = this.safeNumber2(a, "cost", "quoteOrderQty");
      if (a = this.omit(a, "cost"), p !== void 0)
        s = p;
      else if (l) {
        if (n === void 0)
          throw new g("createOrder() requires the price argument for market buy orders to calculate the total cost to spend (amount * price), alternatively set the createMarketBuyOrderRequiresPrice option or param to false and pass the cost to spend in the amount argument").exchange(this.id);
        {
          const m = this.numberToString(s), y = this.numberToString(n);
          s = P.stringMul(m, y);
        }
      }
      u.quoteOrderQty = this.costToPrecision(o, s);
    } else
      u.quantity = this.amountToPrecision(o, s);
    n !== void 0 && (u.price = this.priceToPrecision(o, n));
    const f = this.safeString(a, "clientOrderId");
    if (f !== void 0 && (u.newClientOrderId = f, a = this.omit(a, ["type", "clientOrderId"])), r !== void 0 && r !== "isolated")
      throw new k().addMessage("createOrder() does not support marginMode " + r + " for spot-margin trading").exchange(this.id);
    let h;
    return [h, a] = this.handlePostOnly(t === "market", t === "LIMIT_MAKER", a), h && (u.type = "LIMIT_MAKER"), this.extend(u, a);
  }
  async createSpotOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.createSpotOrderRequest(e, t, i, s, n, r, a), c = await this.spotPrivatePostOrder(this.extend(o, a)), u = this.parseOrder(c, e);
    return u.side = i, u.type = t, u.price = n, u.amount = s, u;
  }
  async createSwapOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = e.symbol, c = this.safeValue(this.options, "unavailableContracts", {});
    if (this.safeBool(c, o, !1))
      throw new it(o).addMessage("createSwapOrder() does not support yet this symbol:" + o).exchange(this.id);
    let f;
    if (r !== void 0)
      if (r === "cross")
        f = 2;
      else if (r === "isolated")
        f = 1;
      else
        throw new g('createSwapOrder() marginMode parameter should be either "cross" or "isolated"').exchange(this.id);
    else
      f = this.safeInteger(a, "openType", 2);
    if (t !== "limit" && t !== "market" && t !== 1 && t !== 2 && t !== 3 && t !== 4 && t !== 5 && t !== 6)
      throw new g("createSwapOrder() order type must either limit, market, or 1 for limit orders, 2 for post-only orders, 3 for IOC orders, 4 for FOK orders, 5 for market orders or 6 to convert market price to current price").exchange(this.id);
    let h;
    [h, a] = this.handlePostOnly(t === "market", t === 2, a), h ? t = 2 : t === "limit" ? t = 1 : t === "market" && (t = 6);
    const l = {
      symbol: e.id,
      // 'price': parseFloat (this.priceToPrecision (symbol, price)),
      vol: parseFloat(this.amountToPrecision(o, s)),
      // 'leverage': int, // required for isolated margin
      // 'side': side, // 1 open long, 2 close short, 3 open short, 4 close long
      //
      // supported order types
      //
      //     1 limit
      //     2 post only maker (PO)
      //     3 transact or cancel instantly (IOC)
      //     4 transact completely or cancel completely (FOK)
      //     5 market orders
      //     6 convert market price to current price
      //
      type: t,
      openType: f
      // 1 isolated, 2 cross
      // 'positionId': 1394650, // long, filling in this parameter when closing a position is recommended
      // 'externalOid': clientOrderId,
      // 'triggerPrice': 10.0, // Required for trigger order
      // 'triggerType': 1, // Required for trigger order 1: more than or equal, 2: less than or equal
      // 'executeCycle': 1, // Required for trigger order 1: 24 hours,2: 7 days
      // 'trend': 1, // Required for trigger order 1: latest price, 2: fair price, 3: index price
      // 'orderType': 1, // Required for trigger order 1: limit order,2:Post Only Maker,3: close or cancel instantly ,4: close or cancel completely,5: Market order
    };
    if (t !== 5 && t !== 6 && t !== "market" && (l.price = parseFloat(this.priceToPrecision(o, n))), f === 1 && this.safeInteger(a, "leverage") === void 0)
      throw new g("createSwapOrder() requires a leverage parameter for isolated margin orders").exchange(this.id);
    this.safeBool(a, "reduceOnly", !1) ? l.side = i === "buy" ? 2 : 4 : l.side = i === "buy" ? 1 : 3;
    const m = this.safeString2(a, "clientOrderId", "externalOid");
    m !== void 0 && (l.externalOid = m);
    const y = this.safeNumber2(a, "triggerPrice", "stopPrice");
    a = this.omit(a, ["clientOrderId", "externalOid", "postOnly", "stopPrice", "triggerPrice"]);
    let w;
    y ? (l.triggerPrice = this.priceToPrecision(o, y), l.triggerType = this.safeInteger(a, "triggerType", 1), l.executeCycle = this.safeInteger(a, "executeCycle", 1), l.trend = this.safeInteger(a, "trend", 1), l.orderType = this.safeInteger(a, "orderType", 1), w = await this.contractPrivatePostPlanorderPlace(this.extend(l, a))) : w = await this.contractPrivatePostOrderSubmit(this.extend(l, a));
    const S = this.safeString(w, "data");
    return this.parseOrder(S, e);
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [];
    let s;
    for (let a = 0; a < e.length; a++) {
      const o = e[a], c = this.safeString(o, "symbol"), u = this.market(c);
      if (!u.spot)
        throw new ge(u.type).addMessage("createOrders() is only supported for spot markets").exchange(this.id);
      if (s === void 0)
        s = c;
      else if (s !== c)
        throw new g("createOrders() requires all orders to have the same symbol").exchange(this.id);
      const f = this.safeString(o, "type"), h = this.safeString(o, "side"), l = this.safeValue(o, "amount"), p = this.safeValue(o, "price"), m = this.safeValue(o, "params", {});
      let y;
      [y, t] = this.handleMarginModeAndParams("createOrder", t);
      const w = this.createSpotOrderRequest(u, f, h, l, p, y, m);
      i.push(w);
    }
    const n = {
      batchOrders: this.json(i)
    }, r = await this.spotPrivatePostBatchOrders(n);
    return this.parseOrders(r);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("fetchOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), n = {
      symbol: s.id
    };
    let r;
    if (s.spot) {
      const a = this.safeString(i, "clientOrderId");
      a !== void 0 ? (i = this.omit(i, "clientOrderId"), n.origClientOrderId = a) : n.orderId = e;
      const [o, c] = this.handleMarginModeAndParams("fetchOrder", i);
      if (o !== void 0) {
        if (o !== "isolated")
          throw new g("fetchOrder() does not support marginMode " + o + " for spot-margin trading").exchange(this.id);
        r = await this.spotPrivateGetMarginOrder(this.extend(n, c));
      } else
        r = await this.spotPrivateGetOrder(this.extend(n, c));
    } else if (s.swap) {
      n.order_id = e;
      const a = await this.contractPrivateGetOrderGetOrderId(this.extend(n, i));
      r = this.safeValue(a, "data");
    }
    return this.parseOrder(r, s);
  }
  async fetchOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    let r;
    e !== void 0 && (r = this.market(e), n.symbol = r.id);
    const [a, o] = this.handleMarketTypeAndParams("fetchOrders", r, s);
    if (a === "spot") {
      if (e === void 0)
        throw new g("fetchOrders() requires a symbol argument for spot market").exchange(this.id);
      const [c, u] = this.handleMarginModeAndParams("fetchOrders", s);
      t !== void 0 && (n.startTime = t), i !== void 0 && (n.limit = i);
      let f;
      if (c !== void 0) {
        if (c !== "isolated")
          throw new g(" fetchOrders() does not support marginMode " + c + " for spot-margin trading").exchange(this.id);
        f = await this.spotPrivateGetMarginAllOrders(this.extend(n, u));
      } else
        f = await this.spotPrivateGetAllOrders(this.extend(n, u));
      return this.parseOrders(f, r, t, i);
    } else {
      t !== void 0 && (n.start_time = t, this.safeInteger(s, "end_time") === void 0 && (n.end_time = this.sum(t, this.options.maxTimeTillEnd))), i !== void 0 && (n.page_size = i);
      let c = this.safeString(this.options, "fetchOrders", "contractPrivateGetOrderListHistoryOrders");
      c = this.safeString(o, "method", c);
      let u = [], f = [];
      if (c === "contractPrivateGetOrderListHistoryOrders") {
        const l = await this.contractPrivateGetOrderListHistoryOrders(this.extend(n, o));
        u = this.safeValue(l, "data");
      } else {
        const l = await this.contractPrivateGetPlanorderListOrders(this.extend(n, o));
        f = this.safeValue(l, "data");
      }
      const h = this.arrayConcat(f, u);
      return this.parseOrders(h, r, t, i, s);
    }
  }
  async fetchOrdersByIds(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {};
    let n;
    t !== void 0 && (n = this.market(t), s.symbol = n.id);
    const [r, a] = this.handleMarketTypeAndParams("fetchOrdersByIds", n, i);
    if (r === "spot")
      throw new ge(r).exchange(this.id);
    {
      s.order_ids = e.join(",");
      const o = await this.contractPrivateGetOrderBatchQuery(this.extend(s, a)), c = this.safeValue(o, "data");
      return this.parseOrders(c, n);
    }
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {};
    let r, a;
    if (e !== void 0 && (r = this.market(e)), [a, s] = this.handleMarketTypeAndParams("fetchOpenOrders", r, s), a === "spot") {
      if (e === void 0)
        throw new g(" fetchOpenOrders() requires a symbol argument for spot market").exchange(this.id);
      n.symbol = r.id;
      const [o, c] = this.handleMarginModeAndParams("fetchOpenOrders", s);
      let u;
      if (o !== void 0) {
        if (o !== "isolated")
          throw new g("fetchOpenOrders() does not support marginMode " + o + " for spot-margin trading").exchange(this.id);
        u = await this.spotPrivateGetMarginOpenOrders(this.extend(n, c));
      } else
        u = await this.spotPrivateGetOpenOrders(this.extend(n, c));
      return this.parseOrders(u, r, t, i);
    } else
      return await this.fetchOrdersByState(2, e, t, i, s);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchOrdersByState(3, e, t, i, s);
  }
  async fetchCanceledOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    return await this.fetchOrdersByState(4, e, t, i, s);
  }
  async fetchOrdersByState(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = {};
    let a;
    t !== void 0 && (a = this.market(t));
    const [o] = this.handleMarketTypeAndParams("fetchOrdersByState", a, n);
    if (o === "spot")
      throw new ge(o).exchange(this.id);
    return r.states = e, await this.fetchOrders(t, i, s, this.extend(r, n));
  }
  async cancelOrder(e, t = void 0, i = {}) {
    await this.loadMarkets();
    let s;
    t !== void 0 && (s = this.market(t), s.id);
    let n;
    [n, i] = this.handleMarketTypeAndParams("cancelOrder", s, i);
    const [r, a] = this.handleMarginModeAndParams("cancelOrder", i);
    let o;
    if (n === "spot") {
      if (t === void 0)
        throw new g("cancelOrder() requires a symbol argument").exchange(this.id);
      const c = {
        symbol: s.id
      }, u = this.safeString(i, "clientOrderId");
      if (u !== void 0 ? (i = this.omit(a, "clientOrderId"), c.origClientOrderId = u) : c.orderId = e, r !== void 0) {
        if (r !== "isolated")
          throw new k().addMessage("cancelOrder() does not support marginMode " + r + " for spot-margin trading").exchange(this.id);
        o = await this.spotPrivateDeleteMarginOrder(this.extend(c, a));
      } else
        o = await this.spotPrivateDeleteOrder(this.extend(c, a));
    } else {
      let c = this.safeString(this.options, "cancelOrder", "contractPrivatePostOrderCancel");
      c = this.safeString(a, "method", c);
      let u;
      if (c === "contractPrivatePostOrderCancel")
        u = await this.contractPrivatePostOrderCancel([e]);
      else if (c === "contractPrivatePostPlanorderCancel")
        u = await this.contractPrivatePostPlanorderCancel([e]);
      else
        throw new pe(c).exchange(this.id);
      o = this.safeValue(u, "data");
      const f = this.safeValue(o, 0), h = this.safeValue(f, "errorMsg", "");
      if (h !== "success")
        throw new k().addMessage("cancelOrder() the order with id " + e + " cannot be cancelled: " + h).exchange(this.id);
    }
    return this.parseOrder(o, s);
  }
  async cancelOrders(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = t !== void 0 ? this.market(t) : void 0, [n] = this.handleMarketTypeAndParams("cancelOrders", s, i);
    if (n === "spot")
      throw new ge(n).addMessage("cancelOrders() is not supported for " + n).exchange(this.id);
    {
      const r = await this.contractPrivatePostOrderCancel(e), a = this.safeValue(r, "data");
      return this.parseOrders(a, s);
    }
  }
  async cancelAllOrders(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = e !== void 0 ? this.market(e) : void 0, s = {};
    let n;
    [n, t] = this.handleMarketTypeAndParams("cancelAllOrders", i, t);
    const [r, a] = this.handleMarginModeAndParams("cancelAllOrders", t);
    if (n === "spot") {
      if (e === void 0)
        throw new g("cancelAllOrders() requires a symbol argument on spot").exchange(this.id);
      s.symbol = i.id;
      let o;
      if (r !== void 0) {
        if (r !== "isolated")
          throw new k().addMessage(" cancelAllOrders() does not support marginMode " + r + " for spot-margin trading").exchange(this.id);
        o = await this.spotPrivateDeleteMarginOpenOrders(this.extend(s, a));
      } else
        o = await this.spotPrivateDeleteOpenOrders(this.extend(s, a));
      return this.parseOrders(o, i);
    } else {
      e !== void 0 && (s.symbol = i.id);
      let o = this.safeString(this.options, "cancelAllOrders", "contractPrivatePostOrderCancelAll");
      o = this.safeString(a, "method", o);
      let c;
      o === "contractPrivatePostOrderCancelAll" ? c = await this.contractPrivatePostOrderCancelAll(this.extend(s, a)) : o === "contractPrivatePostPlanorderCancelAll" && (c = await this.contractPrivatePostPlanorderCancelAll(this.extend(s, a)));
      const u = this.safeValue(c, "data", []);
      return this.parseOrders(u, i);
    }
  }
  parseOrder(e, t = void 0) {
    if (this.safeInteger(e, "code") !== void 0)
      return this.safeOrder({
        info: e,
        status: "rejected",
        clientOrderId: this.safeString(e, "newClientOrderId")
      });
    let s;
    typeof e == "string" ? s = e : s = this.safeString2(e, "orderId", "id");
    const n = this.safeString(e, "symbol");
    t = this.safeMarket(n, t);
    const r = this.safeIntegerN(e, ["time", "createTime", "transactTime"]);
    let a;
    const o = this.safeString(e, "feeCurrency");
    if (o !== void 0) {
      const c = this.safeString(e, "takerFee"), u = this.safeString(e, "makerFee"), f = P.stringAdd(c, u);
      a = {
        currency: o,
        cost: this.parseNumber(f)
      };
    }
    return this.safeOrder({
      id: s,
      clientOrderId: this.safeString(e, "clientOrderId"),
      timestamp: r,
      datetime: this.iso8601(r),
      lastTradeTimestamp: void 0,
      status: this.parseOrderStatus(this.safeString2(e, "status", "state")),
      symbol: t.symbol,
      type: this.parseOrderType(this.safeString(e, "type")),
      timeInForce: this.parseOrderTimeInForce(this.safeString(e, "timeInForce")),
      side: this.parseOrderSide(this.safeString(e, "side")),
      price: this.safeNumber(e, "price"),
      stopPrice: this.safeNumber2(e, "stopPrice", "triggerPrice"),
      triggerPrice: this.safeNumber2(e, "stopPrice", "triggerPrice"),
      average: this.safeNumber(e, "dealAvgPrice"),
      amount: this.safeNumber2(e, "origQty", "vol"),
      cost: this.safeNumber(e, "cummulativeQuoteQty"),
      filled: this.safeNumber2(e, "executedQty", "dealVol"),
      remaining: void 0,
      fee: a,
      trades: void 0,
      info: e
    }, t);
  }
  parseOrderSide(e) {
    const t = {
      BUY: "buy",
      SELL: "sell",
      1: "buy",
      2: "sell"
      // contracts v1 : TODO
    };
    return this.safeString(t, e, e);
  }
  parseOrderType(e) {
    const t = {
      MARKET: "market",
      LIMIT: "limit",
      LIMIT_MAKER: "limit"
    };
    return this.safeString(t, e, e);
  }
  parseOrderStatus(e) {
    const t = {
      NEW: "open",
      FILLED: "closed",
      CANCELED: "canceled",
      PARTIALLY_FILLED: "open",
      PARTIALLY_CANCELED: "canceled",
      // contracts v1
      // '1': 'uninformed', // TODO: wt?
      2: "open",
      3: "closed",
      4: "canceled"
      // '5': 'invalid', //  TODO: wt?
    };
    return this.safeString(t, e, e);
  }
  parseOrderTimeInForce(e) {
    const t = {
      GTC: "GTC",
      FOK: "FOK",
      IOC: "IOC"
    };
    return this.safeString(t, e, e);
  }
  async fetchAccountHelper(e, t) {
    if (e === "spot")
      return await this.spotPrivateGetAccount(t);
    if (e === "swap") {
      const i = await this.contractPrivateGetAccountAssets(t);
      return this.safeValue(i, "data");
    }
  }
  async fetchAccounts(e = {}) {
    const [t, i] = this.handleMarketTypeAndParams("fetchAccounts", void 0, e);
    await this.loadMarkets();
    const s = await this.fetchAccountHelper(t, i), n = this.safeValue(s, "balances", []), r = [];
    for (let a = 0; a < n.length; a++) {
      const o = n[a], c = this.safeString2(o, "asset", "currency"), u = this.safeCurrencyCode(c);
      r.push({
        id: this.safeString(o, "id"),
        type: this.safeString(o, "type"),
        code: u,
        info: o
      });
    }
    return r;
  }
  async fetchTradingFees(e = {}) {
    await this.loadMarkets();
    const t = await this.fetchAccountHelper("spot", e);
    let i = this.safeString(t, "makerCommission"), s = this.safeString(t, "takerCommission");
    i = P.stringDiv(i, "1000"), s = P.stringDiv(s, "1000");
    const n = {};
    for (let r = 0; r < this.symbols.length; r++) {
      const a = this.symbols[r];
      n[a] = {
        symbol: a,
        maker: this.parseNumber(i),
        taker: this.parseNumber(s),
        percentage: !0,
        tierBased: !1,
        info: t
      };
    }
    return n;
  }
  customParseBalance(e, t) {
    let i;
    t === "margin" ? i = this.safeValue(e, "assets", []) : t === "coin-m" || t === "usd-m" ? i = this.safeValue(e, "data", []) : i = this.safeValue(e, "balances", []);
    const s = { info: e };
    if (t === "margin") {
      for (let n = 0; n < i.length; n++) {
        const r = i[n], a = this.safeString(r, "symbol"), o = this.safeSymbol(a, void 0), c = this.safeValue(r, "baseAsset", {}), u = this.safeValue(r, "quoteAsset", {}), f = this.safeCurrencyCode(this.safeString(c, "asset")), h = this.safeCurrencyCode(this.safeString(u, "asset")), l = {};
        l[f] = this.parseBalanceHelper(c), l[h] = this.parseBalanceHelper(u), s[o] = this.safeBalance(l);
      }
      return s;
    } else if (t === "coin-m" || t === "usd-m") {
      for (let n = 0; n < i.length; n++) {
        const r = i[n], a = this.safeString(r, "currency"), o = this.safeCurrencyCode(a);
        if (t === "coin-m" && o === "USDT" || t === "usd-m" && o !== "USDT")
          continue;
        const c = this.account();
        c.free = this.safeString(r, "availableBalance"), c.used = this.safeString(r, "frozenBalance"), s[o] = c;
      }
      return this.safeBalance(s);
    } else {
      for (let n = 0; n < i.length; n++) {
        const r = i[n], a = this.safeString(r, "asset"), o = this.safeCurrencyCode(a), c = this.account();
        c.free = this.safeString(r, "free"), c.used = this.safeString(r, "locked"), s[o] = c;
      }
      return this.safeBalance(s);
    }
  }
  parseBalanceHelper(e) {
    const t = this.account();
    t.used = this.safeString(e, "locked"), t.free = this.safeString(e, "free"), t.total = this.safeString(e, "totalAsset");
    const i = this.safeString(e, "borrowed"), s = this.safeString(e, "interest");
    return t.debt = P.stringAdd(i, s), t;
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    let t;
    const i = {};
    [t, e] = this.handleMarketTypeAndParams("fetchBalance", void 0, e);
    const s = this.safeString(e, "marginMode"), n = this.safeBool(e, "margin", !1);
    e = this.omit(e, ["margin", "marginMode"]);
    let r;
    if (s !== void 0 || n || t === "margin") {
      let a;
      const o = this.safeString(e, "symbol");
      if (o === void 0) {
        const c = this.safeValue(e, "symbols");
        c !== void 0 && (a = this.marketIds(c).join(","));
      } else
        a = this.market(o).id;
      this.checkRequiredArgument("fetchBalance", a, "symbol or symbols"), t = "margin", i.symbols = a, e = this.omit(e, ["symbol", "symbols"]), r = await this.spotPrivateGetMarginIsolatedAccount(this.extend(i, e));
    } else if (t === "spot")
      r = await this.spotPrivateGetAccount(this.extend(i, e));
    else if (t === "coin-m" || t === "usd-m")
      r = await this.contractPrivateGetAccountAssets(this.extend(i, e));
    else
      throw new pe("fetchBalance").exchange(this.id);
    return this.customParseBalance(r, t);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    if (e === void 0)
      throw new g("fetchMyTrades() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const n = this.market(e), [r, a] = this.handleMarketTypeAndParams("fetchMyTrades", n, s), o = {
      symbol: n.id
    };
    let c;
    if (r === "spot")
      t !== void 0 && (o.start_time = t), i !== void 0 && (o.limit = i), c = await this.spotPrivateGetMyTrades(this.extend(o, a));
    else {
      t !== void 0 && (o.start_time = t, this.safeInteger(s, "end_time") === void 0 && (o.end_time = this.sum(t, this.options.maxTimeTillEnd))), i !== void 0 && (o.page_size = i);
      const u = await this.contractPrivateGetOrderListOrderDeals(this.extend(o, a));
      c = this.safeValue(u, "data");
    }
    return this.parseTrades(c, n, t, i);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = {};
    let a;
    t !== void 0 && (a = this.market(t));
    const [o, c] = this.handleMarketTypeAndParams("fetchOrderTrades", a, n);
    let u;
    if (o === "spot") {
      if (t === void 0)
        throw new g("fetchOrderTrades() requires a symbol argument").exchange(this.id);
      r.symbol = a.id, r.orderId = e, u = await this.spotPrivateGetMyTrades(this.extend(r, c));
    } else {
      r.order_id = e;
      const f = await this.contractPrivateGetOrderDealDetailsOrderId(this.extend(r, c));
      u = this.safeValue(f, "data");
    }
    return this.parseTrades(u, a, i, s, c);
  }
  parseDepositAddress(e, t = void 0) {
    const i = this.safeString(e, "address"), s = this.safeString(e, "coin"), n = this.safeString(e, "network");
    return this.checkAddress(i), {
      currency: this.safeCurrencyCode(s, t),
      address: i,
      tag: this.safeString(e, "memo"),
      network: n,
      info: e
    };
  }
  async fetchDepositAddressesByNetwork(e, t = {}) {
    await this.loadMarkets();
    const s = {
      coin: this.currency(e).id
    }, n = this.safeString(t, "network");
    n !== void 0 && (s.network = n), t = this.omit(t, "network");
    const r = await this.spotPrivateGetCapitalDepositAddress(this.extend(s, t)), a = this.parseDepositAddresses(r, void 0, !1);
    return this.indexBy(a, "network");
  }
  async createDepositAddress(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = {
      coin: i.id
    }, n = this.safeString(t, "network");
    if (n === void 0)
      throw new g("createDepositAddress requires a `network` parameter").exchange(this.id);
    n !== void 0 && (s.network = n), t = this.omit(t, "network");
    const r = await this.spotPrivatePostCapitalDepositAddress(this.extend(s, t));
    return this.parseDepositAddress(r, i);
  }
  async fetchDepositAddress(e, t = {}) {
    const i = this.safeString(t, "network");
    t = this.omit(t, ["network"]);
    const s = await this.fetchDepositAddressesByNetwork(e, t);
    let n;
    if (i !== void 0)
      n = this.safeDict(s, i);
    else {
      const r = this.safeDict(this.options, "defaultNetworks"), a = this.safeString(r, e);
      if (a !== void 0)
        n = this.safeDict(s, a);
      else {
        const o = Object.keys(s), c = this.safeString(o, 0);
        n = this.safeDict(s, c);
      }
    }
    if (n === void 0)
      throw new It(e, i).addMessage("consider creating one using the MEXC platform").exchange(this.id);
    return n;
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {
      // 'coin': currency['id'] + network example: USDT-TRX,
      // 'status': 'status',
      // 'startTime': since, // default 90 days
      // 'endTime': this.milliseconds (),
      // 'limit': limit, // default 1000, maximum 1000
    };
    let r;
    if (e !== void 0) {
      r = this.currency(e), n.coin = r.id;
      const o = this.safeString(s, "network");
      o !== void 0 && (s = this.omit(s, "network"), n.coin += "-" + o);
    }
    if (t !== void 0 && (n.startTime = t), i !== void 0) {
      if (i > 1e3)
        throw new O().addMessage("This exchange supports a maximum limit of 1000").exchange(this.id);
      n.limit = i;
    }
    const a = await this.spotPrivateGetCapitalDepositHisrec(this.extend(n, s));
    return this.parseTransactions(a, r, t, i);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {
      // 'coin': currency['id'],
      // 'status': 'status',
      // 'startTime': since, // default 90 days
      // 'endTime': this.milliseconds (),
      // 'limit': limit, // default 1000, maximum 1000
    };
    let r;
    if (e !== void 0 && (r = this.currency(e), n.coin = r.id), t !== void 0 && (n.startTime = t), i !== void 0) {
      if (i > 1e3)
        throw new O().addMessage("This exchange supports a maximum limit of 1000").exchange(this.id);
      n.limit = i;
    }
    const a = await this.spotPrivateGetCapitalWithdrawHistory(this.extend(n, s));
    return this.parseTransactions(a, r, t, i);
  }
  parseTransaction(e, t = void 0) {
    const i = this.safeString(e, "id"), s = i === void 0 ? "deposit" : "withdrawal", n = this.safeInteger2(e, "insertTime", "applyTime");
    let r;
    const a = this.safeString(e, "coin");
    a !== void 0 && (r = a.split("-")[0]);
    const o = this.safeString(e, "network"), c = this.safeCurrencyCode(r, t), u = this.parseTransactionStatusByType(this.safeString(e, "status"), s);
    let f = this.safeString(e, "amount");
    const h = this.safeString(e, "address"), l = this.safeString(e, "txId", "").split(":")[0];
    let p;
    const m = this.safeString(e, "transactionFee");
    return m !== void 0 && (p = {
      cost: this.parseNumber(m),
      currency: c
    }), s === "withdrawal" && (f = P.stringSub(f, m)), {
      info: e,
      id: i,
      txid: l,
      timestamp: n,
      datetime: this.iso8601(n),
      network: o,
      address: h,
      addressTo: h,
      addressFrom: void 0,
      tag: this.safeString(e, "memo"),
      tagTo: void 0,
      tagFrom: void 0,
      type: s,
      amount: this.parseNumber(f),
      currency: c,
      status: u,
      updated: void 0,
      comment: void 0,
      internal: void 0,
      fee: p
    };
  }
  parseTransactionStatusByType(e, t = void 0) {
    const i = {
      deposit: {
        1: "failed",
        2: "pending",
        3: "pending",
        4: "pending",
        5: "ok",
        6: "pending",
        7: "failed"
        // REJECTED
      },
      withdrawal: {
        1: "pending",
        2: "pending",
        3: "pending",
        4: "pending",
        5: "pending",
        6: "pending",
        7: "ok",
        8: "failed",
        9: "canceled",
        10: "pending"
        // MANUAL
      }
    }, s = this.safeValue(i, t, {});
    return this.safeString(s, e, e);
  }
  async fetchPosition(e, t = {}) {
    await this.loadMarkets();
    const s = {
      symbol: this.market(e).id
    }, n = await this.fetchPositions(void 0, this.extend(s, t));
    return this.safeValue(n, 0);
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.contractPrivateGetPositionOpenPositions(t), s = this.safeValue(i, "data", []);
    return this.parsePositions(s, e);
  }
  parsePosition(e, t = void 0) {
    t = this.safeMarket(this.safeString(e, "symbol"), t);
    const i = t.symbol, s = this.safeString(e, "holdVol"), n = this.safeNumber(e, "openAvgPrice"), r = this.safeString(e, "im"), o = this.safeString(e, "positionType") === "1" ? "long" : "short", u = this.safeString(e, "margin_mode") === "1" ? "isolated" : "cross", f = this.safeNumber(e, "leverage"), h = this.safeNumber(e, "liquidatePrice"), l = this.safeInteger(e, "updateTime");
    return this.safePosition({
      info: e,
      id: void 0,
      symbol: i,
      contracts: this.parseNumber(s),
      contractSize: void 0,
      entryPrice: n,
      collateral: void 0,
      side: o,
      unrealizedProfit: void 0,
      leverage: this.parseNumber(f),
      percentage: void 0,
      marginMode: u,
      notional: void 0,
      markPrice: void 0,
      lastPrice: void 0,
      liquidationPrice: h,
      initialMargin: this.parseNumber(r),
      initialMarginPercentage: void 0,
      maintenanceMargin: void 0,
      maintenanceMarginPercentage: void 0,
      marginRatio: void 0,
      timestamp: l,
      datetime: this.iso8601(l),
      hedged: void 0,
      stopLossPrice: void 0,
      takeProfitPrice: void 0,
      lastUpdateTimestamp: void 0
    });
  }
  async fetchTransfer(e, t = void 0, i = void 0, s = {}) {
    const [n, r] = this.handleMarketTypeAndParams("fetchTransfer", void 0, s);
    if (await this.loadMarkets(), n === "spot") {
      const a = {
        transact_id: e
      }, o = await this.spot2PrivateGetAssetInternalTransferInfo(this.extend(a, r)), c = this.safeValue(o, "data", {});
      return this.parseTransfer(c);
    } else if (n === "swap")
      throw new ge(n).addMessage("fetchTransfer() is not supported for " + n).exchange(this.id);
  }
  async fetchTransfers(e = void 0, t = void 0, i = void 0, s = {}) {
    const [n, r] = this.handleMarketTypeAndParams("fetchTransfers", void 0, s);
    await this.loadMarkets();
    const a = {};
    let o, c;
    if (e !== void 0 && (o = this.currency(e), a.currency = o.id), n === "spot") {
      if (t !== void 0 && (a.start_time = t), i !== void 0) {
        if (i > 50)
          throw new O().addMessage("This exchange supports a maximum limit of 50").exchange(this.id);
        a["page-size"] = i;
      }
      const u = await this.spot2PrivateGetAssetInternalTransferRecord(this.extend(a, r)), f = this.safeValue(u, "data", {});
      c = this.safeValue(f, "result_list", []);
    } else if (n === "swap") {
      i !== void 0 && (a.page_size = i);
      const u = await this.contractPrivateGetAccountTransferRecord(this.extend(a, r)), f = this.safeValue(u, "data");
      c = this.safeValue(f, "resultList");
    }
    return this.parseTransfers(c, o, t, i);
  }
  // https://mexcdevelop.github.io/apidocs/spot_v3_en/#query-sub-account-asset
  // currently only spot wallet is supported by the exchange
  async fetchSubAccountBalances(e, t = {}) {
    await this.loadMarkets();
    const i = await this.spotPrivateGetSubAccountAsset(this.extend({ subAccount: e, accountType: "SPOT" })), s = this.safeValue(i, "balances", []), n = {};
    for (let r = 0; r < s.length; r++) {
      const a = s[r], o = this.safeCurrencyCode(this.safeString(a, "asset"));
      n[o] = {
        free: this.safeNumber(a, "free"),
        used: this.safeNumber(a, "locked"),
        total: this.safeNumber(a, "free") + this.safeNumber(a, "locked")
      };
    }
    return { spot: n };
  }
  // https://mexcdevelop.github.io/apidocs/spot_v3_en/#query-sub-account-list-for-master-account
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.spotPrivateGetSubAccountList();
    return this.safeValue(e, "subAccounts", {}).map((i) => ({
      uid: i.subAccount
    }));
  }
  // https://mexcdevelop.github.io/apidocs/spot_v3_en/#universal-transfer-for-master-account
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    await this.loadMarkets();
    const o = this.currency(e), c = this.safeDict(this.options, "accountsByType", {}), u = this.safeString(c, i), f = this.safeString(c, s), h = this.currencyToPrecision(e, t), l = {
      asset: o.id,
      amount: h,
      fromAccountType: u,
      toAccountType: f
    };
    n !== "master" && (l.fromAccount = n), r !== "master" && (l.toAccount = r), "clientOid" in a || (l.clientOid = this.uuid());
    const p = await this.spotPrivatePostCapitalSubAccountUniversalTransfer(this.extend(l, a)), m = this.parseTransfer(p, o);
    return this.extend(m, {
      amount: h,
      fromAccount: n,
      toAccount: r
    });
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = {
      spot: "SPOT",
      swap: "FUTURES",
      margin: "ISOLATED_MARGIN"
    }, o = this.safeString(a, i), c = this.safeString(a, s);
    if (o === void 0) {
      const l = Object.keys(a);
      throw new g("fromAccount must be one of " + l.join(", ")).exchange(this.id);
    }
    if (c === void 0) {
      const l = Object.keys(a);
      throw new g("toAccount must be one of " + l.join(", ")).exchange(this.id);
    }
    const u = {
      asset: r.id,
      amount: this.currencyToPrecision(e, t),
      fromAccountType: o,
      toAccountType: c
    };
    if (o === "ISOLATED_MARGIN" || c === "ISOLATED_MARGIN") {
      const l = this.safeString(n, "symbol");
      if (n = this.omit(n, "symbol"), l === void 0)
        throw new g("transfer() requires a symbol argument for isolated margin").exchange(this.id);
      const p = this.market(l);
      u.symbol = p.id;
    }
    const f = await this.spotPrivatePostCapitalTransfer(this.extend(u, n)), h = this.parseTransfer(f, r);
    return this.extend(h, {
      amount: this.amountToPrecision(e, t),
      fromAccount: i,
      toAccount: s
    });
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeString(e, "currency"), s = this.safeStringN(e, ["transact_id", "txid", "tranId"]), n = this.safeInteger(e, "createTime"), r = n !== void 0 ? this.iso8601(n) : void 0, a = this.safeString(e, "type");
    let o, c;
    return a !== void 0 ? (o = a === "IN" ? "MAIN" : "CONTRACT", c = a === "IN" ? "CONTRACT" : "MAIN") : (o = this.safeString(e, "from"), c = this.safeString(e, "to")), {
      info: e,
      id: s,
      timestamp: n,
      datetime: r,
      currency: this.safeCurrencyCode(i, t),
      amount: this.safeNumber(e, "amount"),
      fromAccount: this.parseAccountId(o),
      toAccount: this.parseAccountId(c),
      status: this.parseTransferStatus(this.safeString2(e, "transact_state", "state"))
    };
  }
  parseAccountId(e) {
    const t = {
      MAIN: "spot",
      CONTRACT: "swap"
    };
    return this.safeString(t, e, e);
  }
  parseTransferStatus(e) {
    const t = {
      SUCCESS: "ok",
      FAILED: "failed",
      WAIT: "pending"
    };
    return this.safeString(t, e, e);
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n);
    const r = this.safeValue(this.options, "networks", {});
    let a = this.safeString2(n, "network", "chain");
    a = this.safeString(r, a, a), this.checkAddress(i), await this.loadMarkets();
    const o = this.currency(e), c = this.currencyToPrecision(e, t, a), u = {
      coin: o.id,
      address: i,
      amount: c
    };
    s !== void 0 && (u.memo = s), a !== void 0 && (u.network = a, n = this.omit(n, ["network", "chain"]));
    const f = await this.spotPrivatePostCapitalWithdrawApply(this.extend(u, n));
    return this.parseTransaction(f, o);
  }
  async fetchTransactionFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.spotPrivateGetCapitalConfigGetall(t);
    return this.parseTransactionFees(i, e);
  }
  parseTransactionFees(e, t = void 0) {
    const i = {};
    for (let s = 0; s < e.length; s++) {
      const n = e[s], r = this.safeString(n, "coin"), a = this.safeCurrency(r), o = this.safeString(a, "code");
      (t === void 0 || this.inArray(o, t)) && (i[o] = this.parseTransactionFee(n, a));
    }
    return {
      withdraw: i,
      deposit: {},
      info: e
    };
  }
  parseTransactionFee(e, t = void 0) {
    const i = this.safeValue(e, "networkList", []), s = {};
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "network"), o = this.safeNumber(r, "withdrawFee");
      s[a] = o;
    }
    return s;
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.spotPrivateGetCapitalConfigGetall(t);
    return this.parseDepositWithdrawFees(i, e, "coin");
  }
  parseDepositWithdrawFee(e, t = void 0) {
    const i = this.safeValue(e, "networkList", []), s = this.depositWithdrawFee(e);
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "network");
      s.networks[a] = {
        withdraw: {
          fee: this.safeNumber(r, "withdrawFee"),
          percentage: void 0
        },
        deposit: {
          fee: void 0,
          percentage: void 0
        }
      };
    }
    return this.assignDefaultDepositWithdrawFees(s);
  }
  handleMarginModeAndParams(e, t = {}, i = void 0) {
    const s = this.safeString(this.options, "defaultType"), n = this.safeBool(t, "margin", !1);
    let r;
    return [r, t] = super.handleMarginModeAndParams(e, t, i), (s === "margin" || n === !0) && (r = "isolated"), [r, t];
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    const a = this.safeString(t, 0), o = this.safeString(t, 1);
    [e, s] = this.resolvePath(e, s);
    let c;
    if (a === "spot" || a === "broker") {
      a === "broker" ? c = this.urls.api[a][o] + "/" + e : c = this.urls.api[a][o] + "/api/" + this.version + "/" + e;
      let u = "";
      if (o === "private" && (s.timestamp = this.nonce(), s.recvWindow = this.safeInteger(this.options, "recvWindow", 5e3)), Object.keys(s).length && (u = this.urlencode(s), c += "?" + u), o === "private") {
        this.checkRequiredCredentials();
        let f;
        this.externalSigner ? f = await this.externalSigner.sign({
          payload: this.encode(u),
          publicApiKey: this.apiKey,
          exchangeId: this.id
        }) : f = this.hmac(this.encode(u), this.encode(this.secret), Re), c += "&signature=" + f, n = {
          "X-MEXC-APIKEY": this.apiKey,
          source: this.safeString(this.options, "broker", "CEDE")
        };
      }
      i === "POST" && (n["Content-Type"] = "application/json");
    } else if (a === "contract" || a === "spot2")
      if (c = this.urls.api[a][o] + "/" + this.implodeParams(e, s), s = this.omit(s, this.extractParams(e)), o === "public")
        Object.keys(s).length && (c += "?" + this.urlencode(s));
      else {
        this.checkRequiredCredentials();
        const u = this.nonce().toString();
        let f = "";
        n = {
          ApiKey: this.apiKey,
          "Request-Time": u,
          "Content-Type": "application/json",
          source: this.safeString(this.options, "broker", "CEDE")
        }, i === "POST" ? (f = this.json(s), r = f) : (s = this.keysort(s), Object.keys(s).length && (f += this.urlencode(s), c += "?" + f)), f = this.apiKey + u + f;
        let h;
        this.externalSigner ? h = await this.externalSigner.sign({
          payload: this.encode(f),
          publicApiKey: this.apiKey,
          exchangeId: this.id
        }) : h = this.hmac(this.encode(f), this.encode(this.secret), Re), n.Signature = h;
      }
    return { url: c, method: i, body: r, headers: n };
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (a === void 0 || this.safeBool(a, "success", !1) === !0)
      return;
    const f = this.safeString(a, "code", void 0);
    if (f !== void 0 && f !== "200" && f !== "0") {
      const h = this.id + " " + r;
      throw this.throwBroadlyMatchedException(this.exceptions.broad, r, h), this.throwExactlyMatchedException(this.exceptions.exact, f, h), new O().addMessage(h).exchange(this.id);
    }
  }
}
class uw extends gt {
}
class fw extends uw {
  describe() {
    return this.deepExtend(super.describe(), {
      id: "okx",
      name: "OKX",
      countries: ["CN", "US"],
      version: "v5",
      rateLimit: 100 * 1.03,
      pro: !0,
      certified: !0,
      termId: "",
      has: {
        CORS: void 0,
        spot: !0,
        margin: !0,
        swap: !0,
        future: !0,
        option: !0,
        cancelAllOrders: !1,
        cancelOrder: !0,
        cancelOrders: !0,
        createDepositAddress: !1,
        createMarketBuyOrderWithCost: !0,
        createMarketSellOrderWithCost: !0,
        createOrder: !0,
        createOrders: !0,
        createOrderWithTakeProfitAndStopLoss: !0,
        createTakeProfitOrder: !0,
        createTrailingPercentOrder: !0,
        createTriggerOrder: !0,
        editOrder: !0,
        fetchAccounts: !0,
        fetchBalance: !0,
        fetchCanceledOrders: !0,
        fetchClosedOrder: void 0,
        fetchClosedOrders: !0,
        fetchCurrencies: !0,
        fetchDeposit: !0,
        fetchDepositAddress: !0,
        fetchDepositAddresses: !1,
        fetchDepositAddressesByNetwork: !0,
        fetchDeposits: !0,
        fetchDepositsWithdrawals: !1,
        fetchDepositWithdrawFee: "emulated",
        fetchDepositWithdrawFees: !0,
        fetchLedger: !0,
        fetchLedgerEntry: void 0,
        fetchMarkets: !0,
        fetchMyTrades: !0,
        fetchOHLCV: !0,
        fetchOpenOrder: void 0,
        fetchOpenOrders: !0,
        fetchOrder: !0,
        fetchOrderBook: !0,
        fetchOrderBooks: !1,
        fetchOrders: !1,
        fetchOrderTrades: !0,
        fetchPermissions: void 0,
        fetchPosition: !0,
        fetchPositions: !0,
        fetchPositionsForSymbol: !0,
        fetchPositionsRisk: !1,
        fetchStatus: !0,
        fetchTicker: !0,
        fetchTickers: !0,
        fetchTime: !0,
        fetchTrades: !0,
        fetchTradingFee: !0,
        fetchTradingFees: !1,
        fetchTradingLimits: !1,
        fetchTransactionFee: !1,
        fetchTransactionFees: !1,
        fetchTransactions: !1,
        fetchTransfer: !0,
        fetchTransfers: !0,
        fetchWithdrawal: !0,
        fetchWithdrawals: !0,
        fetchWithdrawalWhitelist: !1,
        transfer: !0,
        withdraw: !0
      },
      timeframes: {
        "1m": "1m",
        "3m": "3m",
        "5m": "5m",
        "15m": "15m",
        "30m": "30m",
        "1h": "1H",
        "2h": "2H",
        "4h": "4H",
        "6h": "6H",
        "12h": "12H",
        "1d": "1D",
        "1w": "1W",
        "1M": "1M",
        "3M": "3M"
      },
      hostname: "www.okx.com",
      urls: {
        logo: "https://user-images.githubusercontent.com/1294454/152485636-38b19e4a-bece-4dec-979a-5982859ffc04.jpg",
        api: {
          rest: "https://{hostname}"
        },
        www: "https://www.okx.com",
        doc: "https://www.okx.com/docs-v5/en/",
        fees: "https://www.okx.com/pages/products/fees.html",
        referral: {
          // https://www.okx.com/join/CCXT2023 - I removed the code for now, because CWS is blocking until we explain our affiliate program to our users
          // old reflink 0% discount https://www.okx.com/join/1888677
          // new reflink 20% discount https://www.okx.com/join/CCXT2023
          url: "https://www.okx.com/",
          discount: 0.2
        },
        test: {
          rest: "https://{hostname}"
        }
      },
      api: {
        public: {
          get: {
            "market/books-full": 2,
            "market/tickers": 1,
            "market/ticker": 1,
            "market/index-tickers": 1,
            "market/books": 1 / 2,
            "market/books-lite": 5 / 3,
            "market/candles": 1 / 2,
            "market/history-candles": 1,
            "market/index-candles": 1,
            "market/history-index-candles": 2,
            "market/mark-price-candles": 1,
            "market/history-mark-price-candles": 2,
            "market/trades": 1 / 5,
            "market/history-trades": 2,
            "market/option/instrument-family-trades": 1,
            "market/platform-24-volume": 10,
            "market/open-oracle": 50,
            "market/exchange-rate": 20,
            "market/index-components": 1,
            "public/economic-calendar": 50,
            "market/block-tickers": 1,
            "market/block-ticker": 1,
            "public/block-trades": 1,
            "public/instruments": 1,
            "public/delivery-exercise-history": 1 / 2,
            "public/open-interest": 1,
            "public/funding-rate": 1,
            "public/funding-rate-history": 1,
            "public/price-limit": 1,
            "public/opt-summary": 1,
            "public/estimated-price": 2,
            "public/discount-rate-interest-free-quota": 10,
            "public/time": 2,
            "public/mark-price": 2,
            "public/position-tiers": 2,
            "public/interest-rate-loan-quota": 10,
            "public/vip-interest-rate-loan-quota": 10,
            "public/underlying": 1,
            "public/insurance-fund": 2,
            "public/convert-contract-coin": 2,
            "public/option-trades": 1,
            "public/instrument-tick-bands": 4,
            "rubik/stat/trading-data/support-coin": 4,
            "rubik/stat/taker-volume": 4,
            "rubik/stat/margin/loan-ratio": 4,
            // long/short
            "rubik/stat/contracts/long-short-account-ratio": 4,
            "rubik/stat/contracts/open-interest-volume": 4,
            "rubik/stat/option/open-interest-volume": 4,
            // put/call
            "rubik/stat/option/open-interest-volume-ratio": 4,
            "rubik/stat/option/open-interest-volume-expiry": 4,
            "rubik/stat/option/open-interest-volume-strike": 4,
            "rubik/stat/option/taker-block-volume": 4,
            "system/status": 50,
            // public api
            "sprd/spreads": 1,
            "sprd/books": 1 / 2,
            "sprd/ticker": 1,
            "sprd/public-trades": 1 / 5,
            "tradingBot/grid/ai-param": 1,
            "tradingBot/grid/min-investment": 1,
            "tradingBot/public/rsi-back-testing": 1,
            "asset/exchange-list": 5 / 3,
            "finance/staking-defi/eth/apy-history": 5 / 3,
            "finance/savings/lending-rate-summary": 5 / 3,
            "finance/savings/lending-rate-history": 5 / 3,
            // public broker
            "finance/sfp/dcd/products": 2 / 3,
            // copytrading
            "copytrading/public-lead-traders": 4,
            "copytrading/public-weekly-pnl": 4,
            "copytrading/public-stats": 4,
            "copytrading/public-preference-currency": 4,
            "copytrading/public-current-subpositions": 4,
            "copytrading/public-subpositions-history": 4
          }
        },
        private: {
          get: {
            // rfq
            "rfq/counterparties": 4,
            "rfq/maker-instrument-settings": 4,
            "rfq/mmp-config": 4,
            "rfq/rfqs": 10,
            "rfq/quotes": 10,
            "rfq/trades": 4,
            "rfq/public-trades": 4,
            // sprd
            "sprd/order": 1 / 3,
            "sprd/orders-pending": 1 / 3,
            "sprd/orders-history": 1 / 2,
            "sprd/orders-history-archive": 1 / 2,
            "sprd/trades": 1 / 3,
            // trade
            "trade/order": 1 / 3,
            "trade/orders-pending": 1 / 3,
            "trade/orders-history": 1 / 2,
            "trade/orders-history-archive": 1,
            "trade/fills": 1 / 3,
            "trade/fills-history": 2.2,
            "trade/fills-archive": 2,
            "trade/order-algo": 1,
            "trade/orders-algo-pending": 1,
            "trade/orders-algo-history": 1,
            "trade/easy-convert-currency-list": 20,
            "trade/easy-convert-history": 20,
            "trade/one-click-repay-currency-list": 20,
            "trade/one-click-repay-history": 20,
            "trade/account-rate-limit": 1,
            // asset
            "asset/currencies": 5 / 3,
            "asset/balances": 5 / 3,
            "asset/non-tradable-assets": 5 / 3,
            "asset/asset-valuation": 10,
            "asset/transfer-state": 10,
            "asset/bills": 5 / 3,
            "asset/deposit-lightning": 5,
            "asset/deposit-address": 5 / 3,
            "asset/deposit-history": 5 / 3,
            "asset/withdrawal-history": 5 / 3,
            "asset/deposit-withdraw-status": 20,
            "asset/convert/currencies": 5 / 3,
            "asset/convert/currency-pair": 5 / 3,
            "asset/convert/history": 5 / 3,
            "asset/monthly-statement": 2,
            // account
            "account/balance": 2,
            "account/positions": 2,
            "account/positions-history": 100,
            "account/account-position-risk": 2,
            "account/bills": 5 / 3,
            "account/bills-archive": 5 / 3,
            "account/config": 4,
            "account/max-size": 1,
            "account/max-avail-size": 1,
            "account/leverage-info": 1,
            "account/adjust-leverage-info": 4,
            "account/max-loan": 1,
            "account/trade-fee": 4,
            "account/interest-accrued": 4,
            "account/interest-rate": 4,
            "account/max-withdrawal": 1,
            "account/risk-state": 2,
            "account/quick-margin-borrow-repay-history": 4,
            "account/borrow-repay-history": 4,
            "account/vip-interest-accrued": 4,
            "account/vip-interest-deducted": 4,
            "account/vip-loan-order-list": 4,
            "account/vip-loan-order-detail": 4,
            "account/interest-limits": 4,
            "account/greeks": 2,
            "account/position-tiers": 2,
            "account/mmp-config": 4,
            // subaccount
            "users/subaccount/list": 10,
            "account/subaccount/balances": 10 / 3,
            "asset/subaccount/balances": 10 / 3,
            "account/subaccount/max-withdrawal": 1,
            "asset/subaccount/bills": 5 / 3,
            "asset/subaccount/managed-subaccount-bills": 5 / 3,
            "users/entrust-subaccount-list": 10,
            "account/subaccount/interest-limits": 4,
            // grid trading
            "tradingBot/grid/orders-algo-pending": 1,
            "tradingBot/grid/orders-algo-history": 1,
            "tradingBot/grid/orders-algo-details": 1,
            "tradingBot/grid/sub-orders": 1,
            "tradingBot/grid/positions": 1,
            "tradingBot/grid/ai-param": 1,
            "tradingBot/signal/signals": 1,
            "tradingBot/signal/orders-algo-details": 1,
            "tradingBot/signal/orders-algo-history": 1,
            "tradingBot/signal/positions": 1,
            "tradingBot/signal/positions-history": 1,
            "tradingBot/signal/sub-orders": 1,
            "tradingBot/signal/event-history": 1,
            "tradingBot/recurring/orders-algo-pending": 1,
            "tradingBot/recurring/orders-algo-history": 1,
            "tradingBot/recurring/orders-algo-details": 1,
            "tradingBot/recurring/sub-orders": 1,
            // earn
            "finance/savings/balance": 5 / 3,
            "finance/savings/lending-history": 5 / 3,
            "finance/staking-defi/offers": 10 / 3,
            "finance/staking-defi/orders-active": 10 / 3,
            "finance/staking-defi/orders-history": 10 / 3,
            // eth staking
            "finance/staking-defi/eth/balance": 5 / 3,
            "finance/staking-defi/eth/purchase-redeem-history": 5 / 3,
            // copytrading
            "copytrading/current-subpositions": 1,
            "copytrading/subpositions-history": 1,
            "copytrading/instruments": 4,
            "copytrading/profit-sharing-details": 4,
            "copytrading/total-profit-sharing": 4,
            "copytrading/unrealized-profit-sharing-details": 4,
            "copytrading/copy-settings": 4,
            "copytrading/batch-leverage-info": 4,
            "copytrading/current-lead-traders": 4,
            "copytrading/lead-traders-history": 4,
            // broker
            "broker/nd/info": 10,
            "broker/nd/subaccount-info": 10,
            "broker/nd/subaccount/apikey": 10,
            "asset/broker/nd/subaccount-deposit-address": 5 / 3,
            "asset/broker/nd/subaccount-deposit-history": 4,
            "asset/broker/nd/subaccount-withdrawal-history": 4,
            "broker/nd/rebate-daily": 100,
            "broker/nd/rebate-per-orders": 300,
            "finance/sfp/dcd/order": 2,
            "finance/sfp/dcd/orders": 2,
            "broker/fd/rebate-per-orders": 300,
            "broker/fd/if-rebate": 5,
            // affiliate
            "affiliate/invitee/detail": 1,
            "users/partner/if-rebate": 1
          },
          post: {
            // rfq
            "rfq/create-rfq": 4,
            "rfq/cancel-rfq": 4,
            "rfq/cancel-batch-rfqs": 10,
            "rfq/cancel-all-rfqs": 10,
            "rfq/execute-quote": 15,
            "rfq/maker-instrument-settings": 4,
            "rfq/mmp-reset": 4,
            "rfq/mmp-config": 100,
            "rfq/create-quote": 0.4,
            "rfq/cancel-quote": 0.4,
            "rfq/cancel-batch-quotes": 10,
            "rfq/cancel-all-quotes": 10,
            // sprd
            "sprd/order": 1,
            "sprd/cancel-order": 1,
            "sprd/mass-cancel": 1,
            "sprd/amend-order": 1,
            // trade
            "trade/order": 1 / 3,
            "trade/batch-orders": 1 / 15,
            "trade/cancel-order": 1 / 3,
            "trade/cancel-batch-orders": 1 / 15,
            "trade/amend-order": 1 / 3,
            "trade/amend-batch-orders": 1 / 150,
            "trade/close-position": 1,
            "trade/fills-archive": 172800,
            "trade/order-algo": 1,
            "trade/cancel-algos": 1,
            "trade/amend-algos": 1,
            "trade/cancel-advance-algos": 1,
            "trade/easy-convert": 20,
            "trade/one-click-repay": 20,
            "trade/mass-cancel": 4,
            "trade/cancel-all-after": 10,
            // asset
            "asset/transfer": 10,
            "asset/withdrawal": 5 / 3,
            "asset/withdrawal-lightning": 5,
            "asset/cancel-withdrawal": 5 / 3,
            "asset/convert-dust-assets": 10,
            "asset/convert/estimate-quote": 1,
            "asset/convert/trade": 1,
            "asset/monthly-statement": 1,
            // account
            "account/set-position-mode": 4,
            "account/set-leverage": 1,
            "account/position/margin-balance": 1,
            "account/set-greeks": 4,
            "account/set-isolated-mode": 4,
            "account/quick-margin-borrow-repay": 4,
            "account/borrow-repay": 5 / 3,
            "account/simulated_margin": 10,
            "account/set-riskOffset-type": 2,
            "account/activate-option": 4,
            "account/set-auto-loan": 4,
            "account/set-account-level": 4,
            "account/mmp-reset": 4,
            "account/mmp-config": 100,
            // subaccount
            "users/subaccount/modify-apikey": 10,
            "asset/subaccount/transfer": 10,
            "users/subaccount/set-transfer-out": 10,
            "account/subaccount/set-loan-allocation": 4,
            // grid trading
            "tradingBot/grid/order-algo": 1,
            "tradingBot/grid/amend-order-algo": 1,
            "tradingBot/grid/stop-order-algo": 1,
            "tradingBot/grid/close-position": 1,
            "tradingBot/grid/cancel-close-order": 1,
            "tradingBot/grid/order-instant-trigger": 1,
            "tradingBot/grid/withdraw-income": 1,
            "tradingBot/grid/compute-margin-balance": 1,
            "tradingBot/grid/margin-balance": 1,
            "tradingBot/grid/min-investment": 1,
            "tradingBot/signal/create-signal": 1,
            "tradingBot/signal/order-algo": 1,
            "tradingBot/signal/stop-order-algo": 1,
            "tradingBot/signal/margin-balance": 1,
            "tradingBot/signal/amendTPSL": 1,
            "tradingBot/signal/set-instruments": 1,
            "tradingBot/signal/close-position": 1,
            "tradingBot/signal/sub-order": 1,
            "tradingBot/signal/cancel-sub-order": 1,
            "tradingBot/recurring/order-algo": 1,
            "tradingBot/recurring/amend-order-algo": 1,
            "tradingBot/recurring/stop-order-algo": 1,
            // earn
            "finance/savings/purchase-redempt": 5 / 3,
            "finance/savings/set-lending-rate": 5 / 3,
            "finance/staking-defi/purchase": 3,
            "finance/staking-defi/redeem": 3,
            "finance/staking-defi/cancel": 3,
            // eth staking
            "finance/staking-defi/eth/purchase": 5,
            "finance/staking-defi/eth/redeem": 5,
            // copytrading
            "copytrading/algo-order": 1,
            "copytrading/close-subposition": 1,
            "copytrading/set-instruments": 4,
            "copytrading/first-copy-settings": 4,
            "copytrading/amend-copy-settings": 4,
            "copytrading/stop-copy-trading": 4,
            "copytrading/batch-set-leverage": 4,
            // broker
            "broker/nd/create-subaccount": 0.25,
            "broker/nd/delete-subaccount": 1,
            "broker/nd/subaccount/apikey": 0.25,
            "broker/nd/subaccount/modify-apikey": 1,
            "broker/nd/subaccount/delete-apikey": 1,
            "broker/nd/set-subaccount-level": 4,
            "broker/nd/set-subaccount-fee-rate": 4,
            "broker/nd/set-subaccount-assets": 0.25,
            "asset/broker/nd/subaccount-deposit-address": 1,
            "asset/broker/nd/modify-subaccount-deposit-address": 5 / 3,
            "broker/nd/rebate-per-orders": 36e3,
            "finance/sfp/dcd/quote": 10,
            "finance/sfp/dcd/order": 10,
            "broker/nd/report-subaccount-ip": 0.25,
            "broker/fd/rebate-per-orders": 36e3
          }
        }
      },
      fees: {
        trading: {
          taker: this.parseNumber("0.0015"),
          maker: this.parseNumber("0.0010")
        },
        spot: {
          taker: this.parseNumber("0.0015"),
          maker: this.parseNumber("0.0010")
        },
        future: {
          taker: this.parseNumber("0.0005"),
          maker: this.parseNumber("0.0002")
        },
        swap: {
          taker: this.parseNumber("0.00050"),
          maker: this.parseNumber("0.00020")
        }
      },
      requiredCredentials: {
        apiKey: !0,
        secret: !0,
        password: !0
      },
      exceptions: {
        exact: {
          // Public error codes from 50000-53999
          // General Class
          1: ie,
          2: ie,
          5e4: g,
          50001: dt,
          50002: g,
          50004: Nt,
          50005: Te,
          50006: g,
          50007: Ee,
          50008: Z,
          50009: Ee,
          50010: g,
          50011: Ae,
          50012: O,
          50013: Te,
          50014: g,
          50015: g,
          50016: g,
          50017: O,
          50018: O,
          50019: O,
          50020: O,
          50021: O,
          50022: O,
          50023: O,
          50024: g,
          50025: g,
          50026: Te,
          50027: ee,
          50028: k,
          50044: k,
          // API Class
          50100: Te,
          50101: Z,
          50102: ze,
          50103: Z,
          50104: Z,
          50105: Z,
          50106: Z,
          50107: Z,
          50108: g,
          50109: O,
          50110: ee,
          50111: Z,
          50112: Z,
          50113: Z,
          50114: Z,
          50115: pe,
          50120: ee,
          // Trade Class
          51e3: g,
          51001: g,
          51002: g,
          51003: g,
          51004: g,
          51005: g,
          51006: g,
          51007: k,
          51008: re,
          51009: Ee,
          51010: ee,
          51011: k,
          51012: $e,
          51014: O,
          51015: O,
          51016: k,
          51017: g,
          51018: O,
          51019: O,
          51020: g,
          51021: O,
          51022: O,
          51023: k,
          51024: Ee,
          51025: k,
          51026: O,
          51027: O,
          51028: O,
          51029: O,
          51030: O,
          51031: g,
          51046: g,
          51047: g,
          51072: k,
          51073: k,
          51074: k,
          51100: g,
          51101: g,
          51102: g,
          51103: g,
          51104: g,
          51105: g,
          51106: g,
          51107: g,
          51108: k,
          51109: k,
          51110: k,
          51111: k,
          51112: k,
          51113: Ae,
          51115: k,
          51116: g,
          51117: k,
          51118: k,
          51119: re,
          51120: g,
          51121: g,
          51122: g,
          51124: k,
          51125: k,
          51126: k,
          51127: re,
          51128: k,
          51129: k,
          51130: k,
          51131: re,
          51132: g,
          51133: k,
          51134: k,
          51135: g,
          51136: g,
          51137: g,
          51138: g,
          51139: k,
          51156: k,
          51159: k,
          51162: k,
          51163: k,
          51166: k,
          51174: k,
          51185: g,
          51201: k,
          51202: g,
          51203: g,
          51204: g,
          51205: g,
          51250: g,
          51251: g,
          51252: g,
          51253: k,
          51254: k,
          51255: k,
          51256: k,
          51257: k,
          51258: k,
          51259: k,
          51260: k,
          51261: k,
          51262: k,
          51263: k,
          51264: k,
          51265: k,
          51267: k,
          51268: k,
          51269: k,
          51270: k,
          51271: k,
          51272: k,
          51273: k,
          51274: k,
          51275: k,
          51276: k,
          51277: k,
          51278: k,
          51279: k,
          51280: k,
          51321: k,
          51322: k,
          51323: k,
          51324: k,
          51325: k,
          51327: k,
          51328: k,
          51329: k,
          51330: k,
          51400: Se,
          51401: Se,
          51402: Se,
          51403: k,
          51404: k,
          51405: k,
          51406: k,
          51407: g,
          51408: k,
          51409: g,
          51410: k,
          51500: g,
          51501: k,
          51502: re,
          51503: k,
          51506: k,
          51508: k,
          51509: k,
          51510: k,
          51511: k,
          51600: g,
          51601: g,
          51602: g,
          51603: Se,
          51732: Z,
          51733: Z,
          51734: Z,
          51735: O,
          51736: re,
          // Data class
          52e3: O,
          // SPOT/MARGIN error codes 54000-54999
          54e3: O,
          54001: O,
          // FUNDING error codes 58000-58999
          58e3: O,
          58001: Z,
          58002: ee,
          58003: $e,
          58004: Ee,
          58005: g,
          58006: O,
          58007: be,
          58100: je,
          58101: Ee,
          58102: Ae,
          58103: O,
          58104: O,
          58105: O,
          58106: O,
          58107: O,
          58108: O,
          58109: O,
          58110: je,
          58111: je,
          58112: je,
          58114: g,
          58115: O,
          58116: je,
          58117: O,
          58125: je,
          58126: je,
          58127: je,
          58128: je,
          58200: Yn,
          58201: Yn,
          58202: ke,
          58203: et,
          58204: Ee,
          58205: ws,
          58206: Xt,
          58207: gi,
          58208: ke,
          58209: ke,
          58210: ke,
          58211: ke,
          58212: ke,
          58213: Z,
          58221: et,
          58222: et,
          58224: ke,
          58227: ke,
          58228: ke,
          58229: re,
          58300: It,
          58350: re,
          // Account error codes 59000-59999
          59e3: O,
          59001: O,
          59100: k,
          59101: k,
          59102: k,
          59103: re,
          59104: k,
          59105: k,
          59106: k,
          59107: k,
          59108: re,
          59109: k,
          59128: k,
          59200: re,
          59201: re,
          59216: k,
          59260: ee,
          59262: ee,
          59300: O,
          59301: O,
          59313: O,
          59401: O,
          59500: ee,
          59501: Z,
          59502: O,
          59503: Z,
          59504: pe,
          59505: Z,
          59506: Z,
          59507: je,
          59508: Ee,
          59642: O,
          59643: O,
          // WebSocket error Codes from 60000-63999
          60001: Z,
          60002: Z,
          60003: Z,
          60004: Z,
          60005: Z,
          60006: ze,
          60007: Z,
          60008: Z,
          60009: Z,
          60010: Z,
          60011: Z,
          60012: g,
          60013: g,
          60014: Ae,
          60015: O,
          60016: Te,
          60017: g,
          60018: g,
          60019: g,
          63999: be,
          70010: be,
          70013: g,
          70016: g
          // Please specify your instrument settings for at least one instType.
        },
        broad: {
          "Internal Server Error": Te,
          "server error": Te
          // {"code":500,"data":{},"detailMsg":"","error_code":"500","error_message":"server error 1236805249","msg":"server error 1236805249"}
        },
        messages: {
          "Order amount should be greater than the minimum available amount": ye.ORDER_UNDER_MINIMUM
        }
      },
      httpExceptions: {
        429: Te
        // https://github.com/ccxt/ccxt/issues/9612
      },
      precisionMode: ct,
      options: {
        sandboxMode: !1,
        timeDifference: 0,
        defaultNetwork: "ERC20",
        defaultNetworks: {
          ETH: "ERC20",
          BTC: "BTC",
          USDT: "TRC20"
        },
        networks: {
          BTC: "Bitcoin",
          BTCLN: "Lightning",
          BEP20: "BSC",
          ERC20: "ERC20",
          TRC20: "TRC20",
          CRC20: "Crypto",
          // sorted
          ACA: "Acala",
          ALGO: "Algorand",
          BHP: "BHP",
          APT: "Aptos",
          ARBONE: "Arbitrum One",
          AVAXC: "Avalanche C",
          AVAXX: "Avalanche X-Chain",
          ARK: "ARK",
          AR: "Arweave",
          ASTR: "Astar",
          BCH: "BitcoinCash",
          BSV: "Bitcoin SV",
          BTM: "Bytom",
          ADA: "Cardano",
          CSPR: "Casper",
          CELO: "CELO",
          XCH: "Chia",
          CHZ: "Chiliz",
          ATOM: "Cosmos",
          TRUE: "TrueChain",
          DCR: "Decred",
          DGB: "Digibyte",
          DOGE: "Dogecoin",
          XEC: "XEC",
          EGLD: "Elrond",
          EOS: "EOS",
          ETC: "Ethereum Classic",
          ETHW: "EthereumPow",
          FTM: "Fantom",
          FIL: "Filecoin",
          FLOW: "FLOW",
          FSN: "Fusion",
          ONE: "Harmony",
          HBAR: "Hedera",
          HNT: "Helium",
          ZEN: "Horizen",
          ICX: "ICON",
          ICP: "Dfinity",
          IOST: "IOST",
          IOTA: "MIOTA",
          KDA: "Kadena",
          KAR: "KAR",
          KLAY: "Klaytn",
          KSM: "Kusama",
          LSK: "Lisk",
          LTC: "Litecoin",
          METIS: "Metis",
          MINA: "Mina",
          XMR: "Monero",
          GLRM: "Moonbeam",
          MOVR: "Moonriver",
          NANO: "Nano",
          NEAR: "NEAR",
          NAS: "Nebulas",
          NEM: "New Economy Movement",
          NULS: "NULS",
          OASYS: "OASYS",
          OKC: "OKC",
          ONT: "Ontology",
          OPTIMISM: "Optimism",
          LAT: "PlatON",
          DOT: "Polkadot",
          MATIC: "Polygon",
          RVN: "Ravencoin",
          XRP: "Ripple",
          SC: "Siacoin",
          SOL: "Solana",
          STX: "l-Stacks",
          XLM: "Stellar Lumens",
          XTZ: "Tezos",
          TON: "TON",
          THETA: "Theta",
          VSYS: "VSYSTEMS",
          WAVES: "WAVES",
          WAX: "Wax",
          ZEC: "Zcash",
          ZIL: "Zilliqa",
          ZKSYNC: "ZKSYNC"
          // 'NEON3': 'N3', // tbd
          // undetermined : "CELO-TOKEN", "Digital Cash", Khala
          // todo: uncomment below after consensus
          // 'AELF': 'AELF',
          // 'BITCOINDIAMOND': 'Bitcoin Diamond',
          // 'BITCOINGOLD': 'BitcoinGold',
          // 'YOYOW': 'YOYOW',
          // 'QTUM': 'Quantum',
          // 'INTCHAIN': 'INTCHAIN',
          // 'YOUCHAIN': 'YOUCHAIN',
          // 'RONIN': 'Ronin',
          // 'OEC': 'OEC',
          // 'WAYIKICHAIN': 'WGRT',
          // 'MDNA': 'DNA',
          // 'STEP': 'Step Network',
          // 'EMINER': 'Eminer',
          // 'CYBERMILES': 'CyberMiles',
          // 'HYPERCASH': 'HyperCash',
          // 'CONFLUX': 'Conflux',
          // 'CORTEX': 'Cortex',
          // 'TERRA': 'Terra',
          // 'TERRACLASSIC': 'Terra Classic',
        },
        fetchOHLCV: {
          // 'type': 'Candles', // Candles or HistoryCandles, IndexCandles, MarkPriceCandles
          timezone: "UTC"
          // UTC, HK
        },
        fetchPositions: {
          method: "privateGetAccountPositions"
          // privateGetAccountPositions or privateGetAccountPositionsHistory
        },
        createOrder: "privatePostTradeBatchOrders",
        createMarketBuyOrderRequiresPrice: !1,
        fetchMarkets: ["spot", "future", "swap", "option"],
        defaultType: "spot",
        // 'fetchBalance': {
        //     'type': 'spot', // 'funding', 'trading', 'spot'
        // },
        fetchLedger: {
          method: "privateGetAccountBills"
          // privateGetAccountBills, privateGetAccountBillsArchive, privateGetAssetBills
        },
        // 6: Funding account, 18: Trading account
        fetchOrder: {
          method: "privateGetTradeOrder"
          // privateGetTradeOrdersAlgoHistory
        },
        fetchOpenOrders: {
          method: "privateGetTradeOrdersPending"
          // privateGetTradeOrdersAlgoPending
        },
        cancelOrders: {
          method: "privatePostTradeCancelBatchOrders"
          // privatePostTradeCancelAlgos
        },
        fetchCanceledOrders: {
          method: "privateGetTradeOrdersHistory"
          // privateGetTradeOrdersAlgoHistory
        },
        fetchClosedOrders: {
          method: "privateGetTradeOrdersHistory"
          // privateGetTradeOrdersAlgoHistory
        },
        withdraw: {
          // a funding password credential is required by the exchange for the
          // withdraw call (not to be confused with the api password credential)
          password: void 0,
          pwd: void 0
          // password or pwd both work
        },
        algoOrderTypes: {
          conditional: !0,
          trigger: !0,
          oco: !0,
          move_order_stop: !0,
          iceberg: !0,
          twap: !0
        },
        accountsByType: {
          funding: "6",
          trading: "18",
          spot: "18",
          future: "18",
          futures: "18",
          margin: "18",
          swap: "18",
          option: "18"
        },
        accountsById: {
          6: "funding",
          18: "trading"
          // unified trading account
        },
        exchangeType: {
          spot: "SPOT",
          margin: "MARGIN",
          swap: "SWAP",
          future: "FUTURES",
          futures: "FUTURES",
          option: "OPTION",
          SPOT: "SPOT",
          MARGIN: "MARGIN",
          SWAP: "SWAP",
          FUTURES: "FUTURES",
          OPTION: "OPTION"
        },
        brokerId: "e847386590ce4dBC"
      }
    });
  }
  isUsingForcedProxy(e = {}, t = "public") {
    return t === "private";
  }
  nonce() {
    return this.milliseconds() - this.options.timeDifference;
  }
  handleMarketTypeAndParams(e, t = void 0, i = {}) {
    const s = this.safeString(i, "instType");
    return i = this.omit(i, "instType"), this.safeString(i, "type") === void 0 && s !== void 0 && (i.type = s), super.handleMarketTypeAndParams(e, t, i);
  }
  convertToInstrumentType(e) {
    const t = this.safeValue(this.options, "exchangeType", {});
    return this.safeString(t, e, e);
  }
  convertExpireDate(e) {
    const t = e.slice(0, 2), i = e.slice(2, 4), s = e.slice(4, 6);
    return "20" + t + "-" + i + "-" + s + "T00:00:00Z";
  }
  createExpiredOptionMarket(e) {
    const t = "USD", i = e.split("-"), s = e.split("/");
    let n;
    e.indexOf("/") > -1 ? n = this.safeString(s, 0) : n = this.safeString(i, 0);
    const r = n, a = this.safeString(i, 2), o = this.safeString(i, 3), c = this.safeString(i, 4), u = this.convertExpireDate(a), f = this.parse8601(u);
    return {
      id: n + "-" + t + "-" + a + "-" + o + "-" + c,
      symbol: n + "/" + t + ":" + r + "-" + a + "-" + o + "-" + c,
      base: n,
      quote: t,
      settle: r,
      baseId: n,
      quoteId: t,
      settleId: r,
      active: !1,
      type: "option",
      linear: void 0,
      inverse: void 0,
      spot: !1,
      swap: !1,
      future: !1,
      option: !0,
      margin: !1,
      contract: !0,
      contractSize: this.parseNumber("1"),
      expiry: f,
      expiryDatetime: u,
      optionType: c === "C" ? "call" : "put",
      strike: this.parseNumber(o),
      precision: {
        amount: void 0,
        price: void 0
      },
      limits: {
        amount: {
          min: void 0,
          max: void 0
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: void 0,
          max: void 0
        }
      },
      info: void 0
    };
  }
  safeMarket(e = void 0, t = void 0, i = void 0, s = void 0) {
    return e !== void 0 && (e.indexOf("-C") > -1 || e.indexOf("-P") > -1) && !(e in this.markets_by_id) ? this.createExpiredOptionMarket(e) : super.safeMarket(e, t, i, s);
  }
  async fetchStatus(e = {}) {
    const t = await this.publicGetSystemStatus(e), i = this.safeValue(t, "data", []), n = {
      updated: void 0,
      status: i.length === 0 ? "ok" : "maintenance",
      eta: void 0,
      url: void 0,
      info: t
    };
    for (let r = 0; r < i.length; r++) {
      const a = i[r], o = this.safeString(a, "state");
      n.eta = this.safeInteger(a, "end"), n.url = this.safeString(a, "href"), o === "ongoing" ? n.status = "maintenance" : (o === "scheduled" || o === "completed" || o === "canceled") && (n.status = "ok");
    }
    return n;
  }
  async fetchTime(e = {}) {
    const t = await this.publicGetPublicTime(e), i = this.safeValue(t, "data", []), s = this.safeValue(i, 0, {});
    return this.safeInteger(s, "ts");
  }
  async fetchAccounts(e = {}) {
    const t = await this.privateGetAccountConfig(e), i = this.safeValue(t, "data", []), s = [];
    for (let n = 0; n < i.length; n++) {
      const r = i[n], a = this.safeString(r, "uid"), o = this.safeString(r, "acctLv");
      s.push({
        id: a,
        type: o,
        currency: void 0,
        info: r,
        code: void 0
      });
    }
    return s;
  }
  async fetchMarkets(e = {}) {
    const t = this.safeValue(this.options, "fetchMarkets");
    let i = [], s = [];
    for (let n = 0; n < t.length; n++)
      i.push(this.fetchMarketsByType(t[n], e));
    i = await Promise.all(i);
    for (let n = 0; n < i.length; n++)
      s = this.arrayConcat(s, i[n]);
    return s;
  }
  parseMarket(e) {
    const t = this.safeString(e, "instId");
    let i = this.safeStringLower(e, "instType");
    i === "futures" && (i = "future");
    const s = i === "spot", n = i === "future", r = i === "swap", a = i === "option", o = r || n || a;
    let c = this.safeString(e, "baseCcy"), u = this.safeString(e, "quoteCcy");
    const f = this.safeString(e, "settleCcy"), h = this.safeCurrencyCode(f), l = this.safeString(e, "uly");
    if (l !== void 0 && !s) {
      const V = l.split("-");
      c = this.safeString(V, 0), u = this.safeString(V, 1);
    }
    const p = this.safeCurrencyCode(c), m = this.safeCurrencyCode(u);
    let y = p + "/" + m, w, S, b;
    if (o) {
      if (y = y + ":" + h, w = this.safeInteger(e, "expTime"), n) {
        const V = this.yymmdd(w);
        y = y + "-" + V;
      } else if (a) {
        S = this.safeString(e, "stk"), b = this.safeString(e, "optType");
        const V = this.yymmdd(w);
        y = y + "-" + V + "-" + S + "-" + b, b = b === "P" ? "put" : "call";
      }
    }
    const T = this.safeString(e, "tickSz"), x = this.safeValue2(this.fees, i, "trading", {});
    let v = this.safeString(e, "lever", "1");
    v = P.stringMax(v, "1");
    const _ = this.safeNumber(e, "maxMktSz");
    return this.extend(x, {
      id: t,
      symbol: y,
      base: p,
      quote: m,
      settle: h,
      baseId: c,
      quoteId: u,
      settleId: f,
      type: i,
      spot: s,
      margin: s && P.stringGt(v, "1"),
      swap: r,
      future: n,
      option: a,
      active: !0,
      contract: o,
      linear: o ? u === f : void 0,
      inverse: o ? c === f : void 0,
      contractSize: o ? this.safeNumber(e, "ctVal") : void 0,
      expiry: w,
      expiryDatetime: this.iso8601(w),
      strike: S,
      optionType: b,
      created: this.safeInteger(e, "listTime"),
      precision: {
        amount: this.safeNumber(e, "lotSz"),
        price: this.parseNumber(T)
      },
      limits: {
        leverage: {
          min: this.parseNumber("1"),
          max: this.parseNumber(v)
        },
        amount: {
          min: this.safeNumber(e, "minSz"),
          max: void 0
        },
        price: {
          min: void 0,
          max: void 0
        },
        cost: {
          min: void 0,
          max: o ? void 0 : _
        }
      },
      info: e
    });
  }
  async fetchMarketsByType(e, t = {}) {
    const i = {
      instType: this.convertToInstrumentType(e)
    };
    if (e === "option") {
      const r = this.safeValue(this.options, "defaultUnderlying", ["BTC-USD", "ETH-USD"]), a = [];
      for (let u = 0; u < r.length; u++) {
        const f = r[u];
        i.uly = f, a.push(this.publicGetPublicInstruments(this.extend(i, t)));
      }
      const o = await Promise.all(a);
      let c = [];
      for (let u = 0; u < o.length; u++) {
        const f = this.safeValue(o, u, {}), h = this.safeValue(f, "data", []);
        c = this.arrayConcat(c, h);
      }
      return this.parseMarkets(c);
    }
    const s = await this.publicGetPublicInstruments(this.extend(i, t)), n = this.safeValue(s, "data", []);
    return this.parseMarkets(n);
  }
  safeNetwork(e) {
    const t = {
      Bitcoin: "BTC",
      "Optimism (V2)": "Optimism",
      Omni: "OMNI",
      TRON: "TRC20"
    };
    return this.safeString(t, e, e);
  }
  async fetchCurrencies(e = {}) {
    const t = this.safeValue(this.options, "sandboxMode", !1);
    if (!this.checkRequiredCredentials(!1) || t)
      return;
    const i = await this.privateGetAssetCurrencies(e), s = this.safeValue(i, "data", []), n = {}, r = this.groupBy(s, "ccy"), a = Object.keys(r);
    for (let o = 0; o < a.length; o++) {
      const c = a[o], f = this.safeCurrency(c).code, h = r[c], l = {};
      let p = !1, m = !1, y = !1, w;
      for (let b = 0; b < h.length; b++) {
        const T = h[b], x = this.safeValue(T, "canDep"), v = this.safeValue(T, "canWd");
        m = x || m, y = v || y;
        const _ = this.safeValue(T, "canInternal"), V = !!(x && v && _);
        p = V || p;
        const j = this.safeString(T, "chain");
        if (j !== void 0 && j.indexOf("-") >= 0) {
          const W = j.split("-").slice(1).join("-"), B = this.safeNetwork(W), Q = this.parsePrecision(this.safeString(T, "wdTickSz"));
          w === void 0 ? w = Q : w = P.stringMin(w, Q), l[B] = {
            id: j,
            network: B,
            active: V,
            deposit: x,
            withdraw: v,
            fee: this.safeNumber(T, "minFee"),
            precision: this.parseNumber(Q),
            limits: {
              withdraw: {
                min: this.safeNumber(T, "minWd"),
                max: this.safeNumber(T, "maxWd")
              }
            },
            info: T
          };
        }
      }
      const S = this.safeValue(h, 0);
      n[f] = {
        info: void 0,
        code: f,
        id: c,
        name: this.safeString(S, "name"),
        active: p,
        deposit: m,
        withdraw: y,
        fee: void 0,
        precision: this.parseNumber(w),
        limits: {
          amount: {
            min: void 0,
            max: void 0
          }
        },
        networks: l
      };
    }
    return n;
  }
  async fetchOrderBook(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const n = {
      instId: this.market(e).id
    };
    let r;
    [r, i] = this.handleOptionAndParams(i, "fetchOrderBook", "method", "publicGetMarketBooks"), r === "publicGetMarketBooksFull" && t === void 0 && (t = 5e3), t = t === void 0 ? 100 : t, t !== void 0 && (n.sz = t);
    let a;
    r === "publicGetMarketBooksFull" || t > 400 ? a = await this.publicGetMarketBooksFull(this.extend(n, i)) : a = await this.publicGetMarketBooks(this.extend(n, i));
    const o = this.safeValue(a, "data", []), c = this.safeValue(o, 0, {}), u = this.safeInteger(c, "ts");
    return this.parseOrderBook(c, e, u);
  }
  parseTicker(e, t = void 0) {
    const i = this.safeInteger(e, "ts"), s = this.safeString(e, "instId");
    t = this.safeMarket(s, t, "-");
    const n = t.symbol, r = this.safeString(e, "last"), a = this.safeString(e, "open24h"), c = this.safeBool(t, "spot", !1) ? this.safeString(e, "volCcy24h") : void 0, u = this.safeString(e, "vol24h"), f = this.safeString(e, "high24h"), h = this.safeString(e, "low24h");
    return this.safeTicker({
      symbol: n,
      timestamp: i,
      datetime: this.iso8601(i),
      high: f,
      low: h,
      bid: this.safeString(e, "bidPx"),
      bidVolume: this.safeString(e, "bidSz"),
      ask: this.safeString(e, "askPx"),
      askVolume: this.safeString(e, "askSz"),
      vwap: void 0,
      open: a,
      close: r,
      last: r,
      previousClose: void 0,
      change: void 0,
      percentage: void 0,
      average: void 0,
      baseVolume: u,
      quoteVolume: c,
      info: e
    }, t);
  }
  async fetchTicker(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      instId: i.id
    }, n = await this.publicGetMarketTicker(this.extend(s, t)), r = this.safeValue(n, "data", []), a = this.safeValue(r, 0, {});
    return this.parseTicker(a, i);
  }
  async fetchTickersByType(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      instType: this.convertToInstrumentType(e)
    };
    if (e === "option") {
      const a = this.safeValue(this.options, "defaultUnderlying", "BTC-USD"), o = this.safeString2(i, "uly", "marketId", a);
      if (o === void 0)
        throw new g("fetchTickersByType() requires an underlying uly or marketId parameter for options markets").exchange(this.id);
      s.uly = o;
    }
    const n = await this.publicGetMarketTickers(this.extend(s, i)), r = this.safeValue(n, "data", []);
    return this.parseTickers(r, t);
  }
  async fetchTickers(e = void 0, t = {}) {
    await this.loadMarkets(), e = this.marketSymbols(e);
    const i = this.safeString(e, 0);
    let s;
    i !== void 0 && (s = this.market(i));
    const [n, r] = this.handleMarketTypeAndParams("fetchTickers", s, t);
    return await this.fetchTickersByType(n, e, r);
  }
  parseTrade(e, t = void 0) {
    const i = this.safeString(e, "tradeId"), s = this.safeString(e, "instId");
    t = this.safeMarket(s, t, "-");
    const n = t.symbol, r = this.safeInteger(e, "ts"), a = this.safeString2(e, "fillPx", "px"), o = this.safeString2(e, "fillSz", "sz"), c = this.safeString(e, "side"), u = this.safeString(e, "ordId"), f = this.safeString(e, "fee");
    let h;
    if (f !== void 0) {
      const p = P.stringNeg(f), m = this.safeString(e, "feeCcy"), y = this.safeCurrencyCode(m);
      h = {
        cost: p,
        currency: y
      };
    }
    let l = this.safeString(e, "execType");
    return l === "T" ? l = "taker" : l === "M" && (l = "maker"), this.safeTrade({
      info: e,
      timestamp: r,
      datetime: this.iso8601(r),
      symbol: n,
      id: i,
      order: u,
      type: void 0,
      takerOrMaker: l,
      side: c,
      price: a,
      amount: o,
      cost: void 0,
      fee: h
    }, t);
  }
  async fetchTrades(e, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchTrades", "paginate"), n)
      return await this.fetchPaginatedCallCursor("fetchTrades", e, t, i, s, "tradeId", "after", void 0, 100);
    const r = this.market(e), a = {
      instId: r.id
    };
    let o;
    if (r.option)
      o = await this.publicGetPublicOptionTrades(this.extend(a, s));
    else {
      i !== void 0 && (a.limit = i);
      let u;
      [u, s] = this.handleOptionAndParams(s, "fetchTrades", "method", "publicGetMarketTrades"), u === "publicGetMarketTrades" ? o = await this.publicGetMarketTrades(this.extend(a, s)) : u === "publicGetMarketHistoryTrades" && (o = await this.publicGetMarketHistoryTrades(this.extend(a, s)));
    }
    const c = this.safeValue(o, "data", []);
    return this.parseTrades(c, r, t, i);
  }
  parseOHLCV(e, t = void 0) {
    const n = this.handleMarketTypeAndParams("fetchOHLCV", t, void 0)[0] === "spot" ? 5 : 6;
    return [
      this.safeInteger(e, 0),
      this.safeNumber(e, 1),
      this.safeNumber(e, 2),
      this.safeNumber(e, 3),
      this.safeNumber(e, 4),
      this.safeNumber(e, n)
    ];
  }
  async fetchOHLCV(e, t = "1m", i = void 0, s = void 0, n = {}) {
    await this.loadMarkets();
    const r = this.market(e);
    let a = !1;
    if ([a, n] = this.handleOptionAndParams(n, "fetchOHLCV", "paginate"), a)
      return await this.fetchPaginatedCallDeterministic("fetchOHLCV", e, i, s, t, n, 200);
    const o = this.safeString(n, "price");
    n = this.omit(n, "price");
    const c = this.safeValue(this.options, "fetchOHLCV", {}), u = this.safeString(c, "timezone", "UTC");
    s === void 0 && (s = 100);
    const f = this.parseTimeframe(t);
    let h = this.safeString(this.timeframes, t, t);
    u === "UTC" && f >= 21600 && (h += u.toLowerCase());
    const l = {
      instId: r.id,
      bar: h,
      limit: s
    };
    let p = "Candles";
    if (i !== void 0) {
      const T = this.milliseconds(), x = f * 1e3, v = T - (1440 - 1) * x;
      i < v && (p = "HistoryCandles");
      const _ = Math.max(i - 1, 0);
      l.before = _, l.after = this.sum(i, x * s);
    }
    const m = this.safeInteger(n, "until");
    m !== void 0 && (l.after = m, n = this.omit(n, "until")), p = this.safeString(c, "type", p);
    const y = this.safeString(n, "type", p);
    n = this.omit(n, "type");
    const w = y === "HistoryCandles";
    let S;
    o === "mark" ? w ? S = await this.publicGetMarketHistoryMarkPriceCandles(this.extend(l, n)) : S = await this.publicGetMarketMarkPriceCandles(this.extend(l, n)) : o === "index" ? (l.instId = r.info.instFamily, w ? S = await this.publicGetMarketHistoryIndexCandles(this.extend(l, n)) : S = await this.publicGetMarketIndexCandles(this.extend(l, n))) : w ? S = await this.publicGetMarketHistoryCandles(this.extend(l, n)) : S = await this.publicGetMarketCandles(this.extend(l, n));
    const b = this.safeValue(S, "data", []);
    return this.parseOHLCVs(b, r, t, i, s);
  }
  parseBalanceByType(e, t) {
    return e === "funding" ? this.parseFundingBalance(t) : e === "savings" ? this.parseSavingsBalance(t) : this.parseTradingBalance(t);
  }
  parseSavingsBalance(e) {
    const t = { info: e }, i = this.safeValue(e, "data", []);
    for (let s = 0; s < i.length; s++) {
      const n = i[s], r = this.safeString(n, "ccy"), a = this.safeCurrencyCode(r), o = this.account();
      o.total = this.safeString(n, "amt"), o.used = this.safeString(n, "loanAmt"), o.free = P.stringSub(o.total, o.used), t[a] = o;
    }
    return this.safeBalance(t);
  }
  parseTradingBalance(e) {
    const t = { info: e }, i = this.safeValue(e, "data", []), s = this.safeValue(i, 0, {}), n = this.safeInteger(s, "uTime"), r = this.safeValue(s, "details", []);
    for (let a = 0; a < r.length; a++) {
      const o = r[a], c = this.safeString(o, "ccy"), u = this.safeCurrencyCode(c), f = this.account(), h = this.safeString(o, "eq"), l = this.safeString(o, "availEq");
      h === void 0 || l === void 0 ? (f.free = this.safeString(o, "availBal"), f.used = this.safeString(o, "frozenBal")) : (f.total = h, f.free = l), t[u] = f;
    }
    return t.timestamp = n, t.datetime = this.iso8601(n), this.safeBalance(t);
  }
  parseFundingBalance(e) {
    const t = { info: e }, i = this.safeValue(e, "data", []);
    for (let s = 0; s < i.length; s++) {
      const n = i[s], r = this.safeString(n, "ccy"), a = this.safeCurrencyCode(r), o = this.account();
      o.total = this.safeString(n, "bal"), o.free = this.safeString(n, "availBal"), o.used = this.safeString(n, "frozenBal"), t[a] = o;
    }
    return this.safeBalance(t);
  }
  parseTradingFee(e, t = void 0) {
    return {
      info: e,
      symbol: this.safeSymbol(void 0, t),
      // OKX returns the fees as negative values opposed to other exchanges, so the sign needs to be flipped
      maker: this.parseNumber(P.stringNeg(this.safeString2(e, "maker", "makerU"))),
      taker: this.parseNumber(P.stringNeg(this.safeString2(e, "taker", "takerU")))
    };
  }
  async fetchTradingFee(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), s = {
      instType: this.convertToInstrumentType(i.type)
      // SPOT, MARGIN, SWAP, FUTURES, OPTION
      // "instId": market["id"], // only applicable to SPOT/MARGIN
      // "uly": market["id"], // only applicable to FUTURES/SWAP/OPTION
      // "category": "1", // 1 = Class A, 2 = Class B, 3 = Class C, 4 = Class D
    };
    if (i.spot)
      s.instId = i.id;
    else if (i.swap || i.future || i.option)
      s.uly = i.baseId + "-" + i.quoteId;
    else
      throw new ge(i.type).addMessage("fetchTradingFee() supports spot, swap, future or option markets only").exchange(this.id);
    const n = await this.privateGetAccountTradeFee(this.extend(s, t)), r = this.safeValue(n, "data", []), a = this.safeValue(r, 0, {});
    return this.parseTradingFee(a, i);
  }
  async fetchBalance(e = {}) {
    await this.loadMarkets();
    const [t, i] = this.handleMarketTypeAndParams("fetchBalance", void 0, e), s = {
      // 'ccy': 'BTC,ETH', // comma-separated list of currency ids
    };
    let n;
    return t === "funding" ? n = await this.privateGetAssetBalances(this.extend(s, i)) : t === "savings" ? n = await this.privateGetFinanceSavingsBalance(this.extend(s, i)) : n = await this.privateGetAccountBalance(this.extend(s, i)), this.parseBalanceByType(t, n);
  }
  async createMarketBuyOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("createMarketBuyOrderWithCost() supports spot markets only").exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, i.tgtCcy = "quote_ccy", await this.createOrder(e, "market", "buy", t, void 0, i);
  }
  async createMarketSellOrderWithCost(e, t, i = {}) {
    await this.loadMarkets();
    const s = this.market(e);
    if (!s.spot)
      throw new ge(s.type).addMessage("createMarketSellOrderWithCost() supports spot markets only").exchange(this.id);
    return i.createMarketBuyOrderRequiresPrice = !1, i.tgtCcy = "quote_ccy", await this.createOrder(e, "market", "sell", t, void 0, i);
  }
  createOrderRequest(e, t, i, s, n = void 0, r = {}) {
    const a = this.market(e), o = {
      instId: a.id,
      // 'ccy': currency['id'], // only applicable to cross MARGIN orders in single-currency margin
      // 'clOrdId': clientOrderId, // up to 32 characters, must be unique
      // 'tag': tag, // up to 8 characters
      side: i,
      // 'posSide': 'long', // long, short, // required in the long/short mode, and can only be long or short (only for future or swap)
      ordType: t,
      // 'ordType': type, // privatePostTradeOrder: market, limit, post_only, fok, ioc, optimal_limit_ioc
      // 'ordType': type, // privatePostTradeOrderAlgo: conditional, oco, trigger, move_order_stop, iceberg, twap
      sz: this.amountToPrecision(e, s)
      // 'px': this.priceToPrecision (symbol, price), // limit orders only
      // 'reduceOnly': false,
      //
      // 'triggerPx': 10, // stopPrice (trigger orders)
      // 'orderPx': 10, // Order price if -1, the order will be executed at the market price. (trigger orders)
      // 'triggerPxType': 'last', // Conditional default is last, mark or index (trigger orders)
      //
      // 'tpTriggerPx': 10, // takeProfitPrice (conditional orders)
      // 'tpTriggerPxType': 'last', // Conditional default is last, mark or index (conditional orders)
      // 'tpOrdPx': 10, // Order price for Take-Profit orders, if -1 will be executed at market price (conditional orders)
      //
      // 'slTriggerPx': 10, // stopLossPrice (conditional orders)
      // 'slTriggerPxType': 'last', // Conditional default is last, mark or index (conditional orders)
      // 'slOrdPx': 10, // Order price for Stop-Loss orders, if -1 will be executed at market price (conditional orders)
    }, c = a.spot, u = a.contract, f = this.safeValueN(r, ["triggerPrice", "stopPrice", "triggerPx"]), h = this.safeString(r, "timeInForce", "GTC"), l = this.safeValue2(r, "takeProfitPrice", "tpTriggerPx"), p = this.safeValue(r, "tpOrdPx", n), m = this.safeString(r, "tpTriggerPxType", "last"), y = this.safeValue2(r, "stopLossPrice", "slTriggerPx"), w = this.safeValue(r, "slOrdPx", n), S = this.safeString(r, "slTriggerPxType", "last"), b = this.safeString2(r, "clOrdId", "clientOrderId"), T = this.safeValue(r, "stopLoss"), x = T !== void 0, v = this.safeValue(r, "takeProfit"), _ = v !== void 0, V = this.safeString2(r, "trailingPercent", "callbackRatio"), j = V !== void 0, G = this.safeString2(this.options, "defaultMarginMode", "marginMode", "cross");
    let W = this.safeString2(r, "marginMode", "tdMode"), B = !1;
    if (W !== void 0 && W !== "cash" ? B = !0 : (W = G, B = this.safeBool(r, "margin", !1)), c) {
      if (B) {
        const U = i === "buy" ? a.quote : a.base, Y = this.safeString(r, "ccy", U);
        o.ccy = this.safeCurrencyCode(Y);
      }
      const R = B ? W : "cash";
      o.tdMode = R;
    } else if (u) {
      if (a.swap || a.future) {
        let R;
        [R, r] = this.handleOptionAndParams(r, "createOrder", "positionSide"), R !== void 0 && (o.posSide = R);
      }
      o.tdMode = W;
    }
    const Q = t === "market";
    let se = !1;
    [se, r] = this.handlePostOnly(Q, t === "post_only", r), r = this.omit(r, ["currency", "ccy", "marginMode", "timeInForce", "stopPrice", "triggerPrice", "clientOrderId", "stopLossPrice", "takeProfitPrice", "slOrdPx", "tpOrdPx", "margin", "stopLoss", "takeProfit", "trailingPercent"]);
    const $ = h === "IOC" || t === "ioc", te = h === "FOK" || t === "fok", E = f !== void 0 || t === "trigger", N = y !== void 0 || l !== void 0 || t === "conditional", L = Q && $ || t === "optimal_limit_ioc", z = this.safeString(this.options, "tgtCcy", "base_ccy"), K = this.safeString(r, "tgtCcy", z);
    if (!u && !B && (o.tgtCcy = K), Q || L) {
      if (o.ordType = "market", c && i === "buy" && K === "quote_ccy") {
        let R = !0;
        [R, r] = this.handleOptionAndParams(r, "createOrder", "createMarketBuyOrderRequiresPrice", !0);
        let U = this.safeNumber2(r, "cost", "sz");
        if (r = this.omit(r, ["cost", "sz"]), R) {
          if (n !== void 0) {
            if (U === void 0) {
              const Y = this.numberToString(s), J = this.numberToString(n), ae = P.stringMul(Y, J);
              U = this.parseNumber(ae);
            }
          } else if (U === void 0)
            throw new g("createOrder() requires the price argument with market buy orders to calculate total order cost (amount to spend), where cost = amount * price. Supply a price argument to createOrder() call if you want the cost to be calculated for you from price and amount, or, alternatively, add .options['createMarketBuyOrderRequiresPrice'] = false and supply the total cost value in the 'amount' argument or in the 'cost' unified extra parameter or in exchange-specific 'sz' extra parameter (the exchange-specific behaviour)").exchange(this.id);
        } else
          U = U === void 0 ? s : U;
        o.sz = this.costToPrecision(e, U);
      }
      L && u && (o.ordType = "optimal_limit_ioc");
    } else
      !E && !N && (o.px = this.priceToPrecision(e, n));
    if (se ? o.ordType = "post_only" : $ && !L ? o.ordType = "ioc" : te && (o.ordType = "fok"), j) {
      const R = P.stringDiv(V, "100");
      o.callbackRatio = R, o.ordType = "move_order_stop";
    } else if (x || _) {
      if (x) {
        const R = this.safeValueN(T, ["triggerPrice", "stopPrice", "slTriggerPx"]);
        if (R === void 0)
          throw new g('createOrder() requires a trigger price in params["stopLoss"]["triggerPrice"], or params["stopLoss"]["stopPrice"], or params["stopLoss"]["slTriggerPx"] for a stop loss order').exchange(this.id);
        o.slTriggerPx = this.priceToPrecision(e, R);
        const U = this.safeValueN(T, ["price", "stopLossPrice", "slOrdPx"]), Y = this.safeString(T, "type");
        if (Y !== void 0) {
          const ae = Y === "limit";
          if (!ae && !(Y === "market"))
            throw new g('createOrder() params["stopLoss"]["type"] must be either "limit" or "market"').exchange(this.id);
          if (ae) {
            if (U === void 0)
              throw new g('createOrder() requires a limit price in params["stopLoss"]["price"] or params["stopLoss"]["slOrdPx"] for a stop loss limit order').exchange(this.id);
            o.slOrdPx = this.priceToPrecision(e, U);
          } else
            Y === "market" && (o.slOrdPx = "-1");
        } else
          U !== void 0 ? o.slOrdPx = this.priceToPrecision(e, U) : o.slOrdPx = "-1";
        const J = this.safeString2(T, "triggerPriceType", "slTriggerPxType", "last");
        if (J !== void 0) {
          if (J !== "last" && J !== "index" && J !== "mark")
            throw new g('createOrder() stop loss trigger price type must be one of "last", "index" or "mark"').exchange(this.id);
          o.slTriggerPxType = J;
        }
      }
      if (_) {
        const R = this.safeValueN(v, ["triggerPrice", "stopPrice", "tpTriggerPx"]);
        if (R === void 0)
          throw new g('createOrder() requires a trigger price in params["takeProfit"]["triggerPrice"], or params["takeProfit"]["stopPrice"], or params["takeProfit"]["tpTriggerPx"] for a take profit order').exchange(this.id);
        o.tpTriggerPx = this.priceToPrecision(e, R);
        const U = this.safeValueN(v, ["price", "takeProfitPrice", "tpOrdPx"]), Y = this.safeString(v, "type");
        if (Y !== void 0) {
          const ae = Y === "limit";
          if (!ae && !(Y === "market"))
            throw new g('createOrder() params["takeProfit"]["type"] must be either "limit" or "market"').exchange(this.id);
          if (ae) {
            if (U === void 0)
              throw new g('createOrder() requires a limit price in params["takeProfit"]["price"] or params["takeProfit"]["tpOrdPx"] for a take profit limit order').exchange(this.id);
            o.tpOrdPx = this.priceToPrecision(e, U);
          } else
            Y === "market" && (o.tpOrdPx = "-1");
        } else
          U !== void 0 ? o.tpOrdPx = this.priceToPrecision(e, U) : o.tpOrdPx = "-1";
        const J = this.safeString2(v, "triggerPriceType", "tpTriggerPxType", "last");
        if (J !== void 0) {
          if (J !== "last" && J !== "index" && J !== "mark")
            throw new g('createOrder() take profit trigger price type must be one of "last", "index" or "mark"').exchange(this.id);
          o.tpTriggerPxType = J;
        }
      }
    } else
      E ? (o.ordType = "trigger", o.triggerPx = this.priceToPrecision(e, f), o.orderPx = Q ? "-1" : this.priceToPrecision(e, n)) : N && (o.ordType = "conditional", l !== void 0 && y !== void 0 && (o.ordType = "oco"), l !== void 0 && (o.tpTriggerPx = this.priceToPrecision(e, l), o.tpOrdPx = p === void 0 ? "-1" : this.priceToPrecision(e, p), o.tpTriggerPxType = m), y !== void 0 && (o.slTriggerPx = this.priceToPrecision(e, y), o.slOrdPx = w === void 0 ? "-1" : this.priceToPrecision(e, w), o.slTriggerPxType = S));
    if (b === void 0) {
      const R = this.safeString(this.options, "brokerId");
      R !== void 0 && (o.clOrdId = R + this.uuid16(), o.tag = R);
    } else
      o.clOrdId = b, r = this.omit(r, ["clOrdId", "clientOrderId"]);
    return this.extend(o, r);
  }
  async createOrder(e, t, i, s, n = void 0, r = {}) {
    await this.loadMarkets();
    const a = this.market(e);
    let o = this.createOrderRequest(e, t, i, s, n, r), c = this.safeString(this.options, "createOrder", "privatePostTradeBatchOrders");
    const u = this.safeString(o, "ordType");
    if ((u === "trigger" || u === "conditional" || u === "move_order_stop" || t === "move_order_stop" || t === "oco" || t === "iceberg" || t === "twap") && (c = "privatePostTradeOrderAlgo"), c !== "privatePostTradeOrder" && c !== "privatePostTradeOrderAlgo" && c !== "privatePostTradeBatchOrders")
      throw new be().addMessage('createOrder() this.options["createOrder"] must be either privatePostTradeBatchOrders or privatePostTradeOrder or privatePostTradeOrderAlgo').exchange(this.id);
    c === "privatePostTradeBatchOrders" && (o = [o]);
    let f;
    c === "privatePostTradeOrder" ? f = await this.privatePostTradeOrder(o) : c === "privatePostTradeOrderAlgo" ? f = await this.privatePostTradeOrderAlgo(o) : f = await this.privatePostTradeBatchOrders(o);
    const h = this.safeValue(f, "data", []), l = this.safeValue(h, 0), p = this.parseOrder(l, a);
    return p.type = t, p.side = i, p;
  }
  async createOrders(e, t = {}) {
    await this.loadMarkets();
    const i = [];
    for (let r = 0; r < e.length; r++) {
      const a = e[r], o = this.safeString(a, "symbol"), c = this.safeString(a, "type"), u = this.safeString(a, "side"), f = this.safeValue(a, "amount"), h = this.safeValue(a, "price"), l = this.safeValue(a, "params", {}), p = this.extend(l, t), m = this.createOrderRequest(o, c, u, f, h, p);
      i.push(m);
    }
    const s = await this.privatePostTradeBatchOrders(i), n = this.safeValue(s, "data", []);
    return this.parseOrders(n);
  }
  editOrderRequest(e, t, i, s, n = void 0, r = void 0, a = {}) {
    const c = {
      instId: this.market(t).id
    };
    let u;
    (i === "trigger" || i === "conditional" || i === "move_order_stop" || i === "oco" || i === "iceberg" || i === "twap") && (u = !0);
    const f = this.safeString2(a, "clOrdId", "clientOrderId");
    f !== void 0 ? u ? c.algoClOrdId = f : c.clOrdId = f : u ? c.algoId = e : c.ordId = e;
    let h = this.safeValue2(a, "stopLossPrice", "newSlTriggerPx"), l = this.safeValue(a, "newSlOrdPx");
    const p = this.safeString(a, "newSlTriggerPxType", "last");
    let m = this.safeValue2(a, "takeProfitPrice", "newTpTriggerPx"), y = this.safeValue(a, "newTpOrdPx");
    const w = this.safeString(a, "newTpTriggerPxType", "last"), S = this.safeValue(a, "stopLoss"), b = this.safeValue(a, "takeProfit"), T = S !== void 0, x = b !== void 0;
    if (u) {
      if (h === void 0 && m === void 0)
        throw new g("editOrder() requires a stopLossPrice or takeProfitPrice parameter for editing an algo order").exchange(this.id);
      if (h !== void 0) {
        if (l === void 0)
          throw new g("editOrder() requires a newSlOrdPx parameter for editing an algo order").exchange(this.id);
        c.newSlTriggerPx = this.priceToPrecision(t, h), c.newSlOrdPx = i === "market" ? "-1" : this.priceToPrecision(t, l), c.newSlTriggerPxType = p;
      }
      if (m !== void 0) {
        if (y === void 0)
          throw new g("editOrder() requires a newTpOrdPx parameter for editing an algo order").exchange(this.id);
        c.newTpTriggerPx = this.priceToPrecision(t, m), c.newTpOrdPx = i === "market" ? "-1" : this.priceToPrecision(t, y), c.newTpTriggerPxType = w;
      }
    } else {
      if (h !== void 0 && (c.newSlTriggerPx = this.priceToPrecision(t, h), c.newSlOrdPx = i === "market" ? "-1" : this.priceToPrecision(t, l), c.newSlTriggerPxType = p), m !== void 0 && (c.newTpTriggerPx = this.priceToPrecision(t, m), c.newTpOrdPx = i === "market" ? "-1" : this.priceToPrecision(t, y), c.newTpTriggerPxType = w), T) {
        h = this.safeValue(S, "triggerPrice"), l = this.safeValue(S, "price");
        const v = this.safeString(S, "type");
        c.newSlTriggerPx = this.priceToPrecision(t, h), c.newSlOrdPx = v === "market" ? "-1" : this.priceToPrecision(t, l), c.newSlTriggerPxType = p;
      }
      if (x) {
        m = this.safeValue(b, "triggerPrice"), y = this.safeValue(b, "price");
        const v = this.safeString(b, "type");
        c.newTpTriggerPx = this.priceToPrecision(t, m), c.newTpOrdPx = v === "market" ? "-1" : this.priceToPrecision(t, y), c.newTpTriggerPxType = w;
      }
    }
    return n !== void 0 && (c.newSz = this.amountToPrecision(t, n)), u || r !== void 0 && (c.newPx = this.priceToPrecision(t, r)), a = this.omit(a, ["clOrdId", "clientOrderId", "takeProfitPrice", "stopLossPrice", "stopLoss", "takeProfit"]), this.extend(c, a);
  }
  async editOrder(e, t, i, s, n = void 0, r = void 0, a = {}) {
    await this.loadMarkets();
    const o = this.market(t), c = this.editOrderRequest(e, t, i, s, n, r, a);
    let u;
    (i === "trigger" || i === "conditional" || i === "move_order_stop" || i === "oco" || i === "iceberg" || i === "twap") && (u = !0);
    let f;
    u ? f = await this.privatePostTradeAmendAlgos(this.extend(c, a)) : f = await this.privatePostTradeAmendOrder(this.extend(c, a));
    const h = this.safeValue(f, "data", []), l = this.safeValue(h, 0), p = this.parseOrder(l, o);
    return p.type = i, p.side = s, p;
  }
  async cancelOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrder() requires a symbol argument").exchange(this.id);
    const s = this.safeValue2(i, "stop", "trigger"), n = this.safeBool(i, "trailing", !1);
    if (s || n) {
      const l = await this.cancelOrders([e], t, i);
      return this.safeValue(l, 0);
    }
    await this.loadMarkets();
    const r = this.market(t), a = {
      instId: r.id
      // 'ordId': id, // either ordId or clOrdId is required
      // 'clOrdId': clientOrderId,
    }, o = this.safeString2(i, "clOrdId", "clientOrderId");
    o !== void 0 ? a.clOrdId = o : a.ordId = e;
    const c = this.omit(i, ["clOrdId", "clientOrderId"]), u = await this.privatePostTradeCancelOrder(this.extend(a, c)), f = this.safeValue(u, "data", []), h = this.safeValue(f, 0);
    return this.parseOrder(h, r);
  }
  parseIds(e) {
    return e !== void 0 && typeof e == "string" ? e.split(",") : e;
  }
  async cancelOrders(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("cancelOrders() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), n = [], r = this.safeValue(this.options, "cancelOrders", {}), a = this.safeString(r, "method", "privatePostTradeCancelBatchOrders");
    let o = this.safeString(i, "method", a);
    const c = this.parseIds(this.safeValue2(i, "clOrdId", "clientOrderId")), u = this.parseIds(this.safeValue(i, "algoId")), f = this.safeValue2(i, "stop", "trigger"), h = this.safeBool(i, "trailing", !1);
    if ((f || h) && (o = "privatePostTradeCancelAlgos"), c === void 0) {
      if (e = this.parseIds(e), u !== void 0)
        for (let m = 0; m < u.length; m++)
          n.push({
            algoId: u[m],
            instId: s.id
          });
      for (let m = 0; m < e.length; m++)
        h || f ? n.push({
          algoId: e[m],
          instId: s.id
        }) : n.push({
          ordId: e[m],
          instId: s.id
        });
    } else
      for (let m = 0; m < c.length; m++)
        n.push({
          instId: s.id,
          clOrdId: c[m]
        });
    let l;
    o === "privatePostTradeCancelAlgos" ? l = await this.privatePostTradeCancelAlgos(n) : l = await this.privatePostTradeCancelBatchOrders(n);
    const p = this.safeValue(l, "data", []);
    return this.parseOrders(p, s, void 0, void 0, i);
  }
  parseOrderStatus(e) {
    const t = {
      canceled: "canceled",
      order_failed: "canceled",
      live: "open",
      partially_filled: "open",
      filled: "closed",
      effective: "closed"
    };
    return this.safeString(t, e, e);
  }
  parseOrder(e, t = void 0) {
    const i = this.safeString(e, "sCode");
    if (i !== void 0 && i !== "0")
      return this.safeOrder({
        id: this.safeString(e, "ordId"),
        clientOrderId: this.safeString(e, "clOrdId"),
        status: "rejected",
        info: e
      });
    const s = this.safeString2(e, "algoId", "ordId"), n = this.safeInteger(e, "cTime"), r = this.safeInteger(e, "uTime"), a = this.safeInteger(e, "fillTime"), o = this.safeString(e, "side");
    let c = this.safeString(e, "ordType"), u, f;
    c === "post_only" ? (u = !0, c = "limit") : c === "fok" ? (f = "FOK", c = "limit") : c === "ioc" && (f = "IOC", c = "limit");
    const h = this.safeString(e, "instId");
    t = this.safeMarket(h, t);
    const l = this.safeSymbol(h, t, "-"), p = this.safeString(e, "accFillSz"), m = this.safeString2(e, "px", "ordPx"), y = this.safeString(e, "avgPx"), w = this.parseOrderStatus(this.safeString(e, "state")), S = this.safeString(e, "fee");
    let b, T;
    const x = this.safeString(this.options, "tgtCcy", "base_ccy"), v = this.safeString(e, "tgtCcy", x), _ = this.safeString(e, "instType");
    o === "buy" && c === "market" && _ === "SPOT" && v === "quote_ccy" ? T = this.safeString(e, "sz") : b = this.safeString(e, "sz");
    let V;
    if (S !== void 0) {
      const $ = P.stringNeg(S), te = this.safeString(e, "feeCcy"), E = this.safeCurrencyCode(te);
      V = {
        cost: this.parseNumber($),
        currency: E
      };
    }
    let j = this.safeString(e, "clOrdId");
    j !== void 0 && j.length < 1 && (j = void 0);
    const G = this.safeNumber2(e, "slTriggerPx", "slOrdPx"), W = this.safeNumber2(e, "tpTriggerPx", "tpOrdPx"), B = this.safeNumberN(e, ["triggerPx", "moveTriggerPx"]), Q = this.safeString(e, "reduceOnly");
    let se = !1;
    return se !== void 0 && (se = Q === "true"), this.safeOrder({
      info: e,
      id: s,
      clientOrderId: j,
      timestamp: n,
      datetime: this.iso8601(n),
      lastTradeTimestamp: a,
      lastUpdateTimestamp: r,
      symbol: l,
      type: c,
      timeInForce: f,
      postOnly: u,
      side: o,
      price: m,
      stopLossPrice: G,
      takeProfitPrice: W,
      stopPrice: B,
      triggerPrice: B,
      average: y,
      cost: T,
      amount: b,
      filled: p,
      remaining: void 0,
      status: w,
      fee: V,
      trades: void 0,
      reduceOnly: se
    }, t);
  }
  async fetchOrder(e, t = void 0, i = {}) {
    if (t === void 0)
      throw new g("fetchOrder() requires a symbol argument").exchange(this.id);
    await this.loadMarkets();
    const s = this.market(t), n = {
      instId: s.id
      // 'clOrdId': 'abcdef12345', // optional, [a-z0-9]{1,32}
      // 'ordId': id,
      // 'instType': // spot, swap, futures, margin
    }, r = this.safeString2(i, "clOrdId", "clientOrderId"), a = this.safeValue(this.options, "fetchOrder", {}), o = this.safeString(a, "method", "privateGetTradeOrder");
    let c = this.safeString(i, "method", o);
    this.safeValue2(i, "stop", "trigger") ? (c = "privateGetTradeOrderAlgo", r !== void 0 ? n.algoClOrdId = r : n.algoId = e) : r !== void 0 ? n.clOrdId = r : n.ordId = e;
    const f = this.omit(i, ["method", "clOrdId", "clientOrderId", "stop", "trigger"]);
    let h;
    c === "privateGetTradeOrderAlgo" ? h = await this.privateGetTradeOrderAlgo(this.extend(n, f)) : h = await this.privateGetTradeOrder(this.extend(n, f));
    const l = this.safeValue(h, "data", []), p = this.safeValue(l, 0);
    return this.parseOrder(p, s);
  }
  async fetchOpenOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchOpenOrders", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchOpenOrders", e, t, i, s);
    const r = {
      // 'instType': 'SPOT', // SPOT, MARGIN, SWAP, FUTURES, OPTION
      // 'uly': currency['id'],
      // 'instId': market['id'],
      // 'ordType': 'limit', // market, limit, post_only, fok, ioc, comma-separated, stop orders: conditional, oco, trigger, move_order_stop, iceberg, or twap
      // 'state': 'live', // live, partially_filled
      // 'after': orderId,
      // 'before': orderId,
      // 'limit': limit, // default 100, max 100
    };
    let a;
    e !== void 0 && (a = this.market(e), r.instId = a.id), i !== void 0 && (r.limit = i);
    const o = this.safeValue(this.options, "fetchOpenOrders", {}), c = this.safeValue(this.options, "algoOrderTypes", {}), u = this.safeString(o, "method", "privateGetTradeOrdersPending");
    let f = this.safeString(s, "method", u);
    const h = this.safeString(s, "ordType"), l = this.safeValue2(s, "stop", "trigger"), p = this.safeBool(s, "trailing", !1);
    (p || l || h in c) && (f = "privateGetTradeOrdersAlgoPending"), p ? r.ordType = "move_order_stop" : l && h === void 0 && (r.ordType = "trigger");
    const m = this.omit(s, ["method", "stop", "trigger", "trailing"]);
    let y;
    f === "privateGetTradeOrdersAlgoPending" ? y = await this.privateGetTradeOrdersAlgoPending(this.extend(r, m)) : y = await this.privateGetTradeOrdersPending(this.extend(r, m));
    const w = this.safeValue(y, "data", []);
    return this.parseOrders(w, a, t, i);
  }
  async fetchCanceledOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    const n = {
      // 'instType': type.toUpperCase (), // SPOT, MARGIN, SWAP, FUTURES, OPTION
      // 'uly': currency['id'],
      // 'instId': market['id'],
      // 'ordType': 'limit', // market, limit, post_only, fok, ioc, comma-separated stop orders: conditional, oco, trigger, move_order_stop, iceberg, or twap
      // 'state': 'canceled', // filled, canceled
      // 'after': orderId,
      // 'before': orderId,
      // 'limit': limit, // default 100, max 100
      // 'algoId': "'433845797218942976'", // Algo order
    };
    let r;
    e !== void 0 && (r = this.market(e), n.instId = r.id);
    let a, o;
    [a, o] = this.handleMarketTypeAndParams("fetchCanceledOrders", r, s), n.instType = this.convertToInstrumentType(a), i !== void 0 && (n.limit = i), n.state = "canceled";
    const c = this.safeValue(this.options, "fetchCanceledOrders", {}), u = this.safeValue(this.options, "algoOrderTypes", {}), f = this.safeString(c, "method", "privateGetTradeOrdersHistory");
    let h = this.safeString(s, "method", f);
    const l = this.safeString(s, "ordType"), p = this.safeValue2(s, "stop", "trigger");
    if (this.safeBool(s, "trailing", !1))
      h = "privateGetTradeOrdersAlgoHistory", n.ordType = "move_order_stop";
    else if (p || l in u) {
      h = "privateGetTradeOrdersAlgoHistory";
      const b = this.safeString(s, "algoId");
      if (b !== void 0 && (n.algoId = b, s = this.omit(s, "algoId")), p && l === void 0)
        throw new g('fetchCanceledOrders() requires an "ordType" string parameter, "conditional", "oco", "trigger", "move_order_stop", "iceberg", or "twap"').exchange(this.id);
    } else {
      t !== void 0 && (n.begin = t);
      const b = this.safeInteger2(o, "till", "until");
      b !== void 0 && (n.end = b, o = this.omit(o, ["until", "till"]));
    }
    const y = this.omit(o, ["method", "stop", "trigger", "trailing"]);
    let w;
    h === "privateGetTradeOrdersAlgoHistory" ? w = await this.privateGetTradeOrdersAlgoHistory(this.extend(n, y)) : w = await this.privateGetTradeOrdersHistory(this.extend(n, y));
    const S = this.safeValue(w, "data", []);
    return this.parseOrders(S, r, t, i);
  }
  async fetchClosedOrders(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchClosedOrders", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchClosedOrders", e, t, i, s);
    const r = {
      // 'instType': type.toUpperCase (), // SPOT, MARGIN, SWAP, FUTURES, OPTION
      // 'uly': currency['id'],
      // 'instId': market['id'],
      // 'ordType': 'limit', // market, limit, post_only, fok, ioc, comma-separated stop orders: conditional, oco, trigger, move_order_stop, iceberg, or twap
      // 'state': 'filled', // filled, effective
      // 'after': orderId,
      // 'before': orderId,
      // 'limit': limit, // default 100, max 100
      // 'algoId': "'433845797218942976'", // Algo order
    };
    let a;
    e !== void 0 && (a = this.market(e), r.instId = a.id);
    let o, c;
    [o, c] = this.handleMarketTypeAndParams("fetchClosedOrders", a, s), r.instType = this.convertToInstrumentType(o), i !== void 0 && (r.limit = i);
    const u = this.safeDict(this.options, "fetchClosedOrders", {}), f = this.safeDict(this.options, "algoOrderTypes", {}), h = this.safeString(u, "method", "privateGetTradeOrdersHistory");
    let l = this.safeString(s, "method", h);
    const p = this.safeString(s, "ordType"), m = this.safeBool2(s, "stop", "trigger"), y = this.safeBool(s, "trailing", !1);
    if ((y || m || p in f) && (l = "privateGetTradeOrdersAlgoHistory", r.state = "effective"), y)
      r.ordType = "move_order_stop";
    else if (m)
      p === void 0 && (r.ordType = "trigger");
    else {
      t !== void 0 && (r.begin = t);
      const T = this.safeInteger2(c, "till", "until");
      T !== void 0 && (r.end = T, c = this.omit(c, ["until", "till"])), r.state = "filled";
    }
    const w = this.omit(c, ["method", "stop", "trigger", "trailing"]);
    let S;
    l === "privateGetTradeOrdersAlgoHistory" ? S = await this.privateGetTradeOrdersAlgoHistory(this.extend(r, w)) : l === "privateGetTradeOrdersHistoryArchive" ? S = await this.privateGetTradeOrdersHistoryArchive(this.extend(r, w)) : S = await this.privateGetTradeOrdersHistory(this.extend(r, w));
    const b = this.safeValue(S, "data", []);
    return this.parseOrders(b, a, t, i);
  }
  async fetchMyTrades(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchMyTrades", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchMyTrades", e, t, i, s);
    let r = {
      // 'instType': 'SPOT', // SPOT, MARGIN, SWAP, FUTURES, OPTION
      // 'uly': currency['id'],
      // 'instId': market['id'],
      // 'ordId': orderId,
      // 'after': billId,
      // 'before': billId,
      // 'limit': limit, // default 100, max 100
    }, a;
    e !== void 0 && (a = this.market(e), r.instId = a.id), t !== void 0 && (r.begin = t), [r, s] = this.handleUntilOption("end", r, s);
    const [o, c] = this.handleMarketTypeAndParams("fetchMyTrades", a, s);
    r.instType = this.convertToInstrumentType(o), i !== void 0 && t === void 0 && (r.limit = i);
    const u = await this.privateGetTradeFillsHistory(this.extend(r, c)), f = this.safeValue(u, "data", []);
    return this.parseTrades(f, a, t, i, c);
  }
  async fetchOrderTrades(e, t = void 0, i = void 0, s = void 0, n = {}) {
    const r = {
      // 'instrument_id': market['id'],
      ordId: e
      // 'after': '1', // return the page after the specified page number
      // 'before': '1', // return the page before the specified page number
      // 'limit': limit, // optional, number of results per request, default = maximum = 100
    };
    return await this.fetchMyTrades(t, i, s, this.extend(r, n));
  }
  async fetchLedger(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchLedger", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchLedger", e, t, i, s);
    const r = this.safeValue(this.options, "fetchLedger", {});
    let a = this.safeString(r, "method");
    a = this.safeString(s, "method", a), s = this.omit(s, "method");
    let o = {
      // 'instType': undefined, // 'SPOT', 'MARGIN', 'SWAP', 'FUTURES", 'OPTION'
      // 'ccy': undefined, // currency['id'],
      // 'mgnMode': undefined, // 'isolated', 'cross'
      // 'ctType': undefined, // 'linear', 'inverse', only applicable to FUTURES/SWAP
      // 'type': varies depending the 'method' endpoint :
      //     - https://www.okx.com/docs-v5/en/#rest-api-account-get-bills-details-last-7-days
      //     - https://www.okx.com/docs-v5/en/#rest-api-funding-asset-bills-details
      //     - https://www.okx.com/docs-v5/en/#rest-api-account-get-bills-details-last-3-months
      // 'after': 'id', // return records earlier than the requested bill id
      // 'before': 'id', // return records newer than the requested bill id
      // 'limit': 100, // default 100, max 100
    }, c;
    [c, s] = this.handleMarginModeAndParams("fetchLedger", s), c === void 0 && (c = this.safeString(s, "mgnMode")), a !== "privateGetAssetBills" && c !== void 0 && (o.mgnMode = c);
    const [u, f] = this.handleMarketTypeAndParams("fetchLedger", void 0, s);
    u !== void 0 && (o.instType = this.convertToInstrumentType(u)), i !== void 0 && (o.limit = i);
    let h;
    e !== void 0 && (h = this.currency(e), o.ccy = h.id), [o, s] = this.handleUntilOption("end", o, s);
    let l;
    a === "privateGetAccountBillsArchive" ? l = await this.privateGetAccountBillsArchive(this.extend(o, f)) : a === "privateGetAssetBills" ? l = await this.privateGetAssetBills(this.extend(o, f)) : l = await this.privateGetAccountBills(this.extend(o, f));
    const p = this.safeValue(l, "data", []);
    return this.parseLedger(p, h, t, i);
  }
  parseLedgerEntryType(e) {
    const t = {
      1: "transfer",
      2: "trade",
      3: "trade",
      4: "rebate",
      5: "trade",
      6: "transfer",
      7: "trade",
      8: "fee",
      9: "trade",
      10: "trade",
      11: "trade"
      // system token conversion
    };
    return this.safeString(t, e, e);
  }
  parseLedgerEntry(e, t = void 0) {
    const i = this.safeString(e, "billId"), s = void 0, n = this.safeString(e, "ordId"), r = void 0, a = this.parseLedgerEntryType(this.safeString(e, "type")), o = this.safeCurrencyCode(this.safeString(e, "ccy"), t), c = this.safeString(e, "balChg"), u = this.parseNumber(c), f = this.safeInteger(e, "ts"), h = this.safeString(e, "fee");
    let l;
    h !== void 0 && (l = {
      cost: this.parseNumber(P.stringNeg(h)),
      currency: o
    });
    const p = void 0, m = this.safeString(e, "bal"), y = this.parseNumber(m), w = "ok", S = this.safeString(e, "instId"), b = this.safeSymbol(S, void 0, "-");
    return {
      id: i,
      info: e,
      timestamp: f,
      datetime: this.iso8601(f),
      account: s,
      referenceId: n,
      referenceAccount: r,
      type: a,
      currency: o,
      symbol: b,
      amount: u,
      before: p,
      after: y,
      status: w,
      fee: l
    };
  }
  parseDepositAddress(e, t = void 0) {
    const i = this.safeString(e, "addr");
    let s = this.safeStringN(e, ["tag", "pmtId", "memo"]);
    if (s === void 0) {
      const h = this.safeValue(e, "addrEx", {});
      s = this.safeString(h, "comment");
    }
    const n = this.safeString(e, "ccy");
    t = this.safeCurrency(n, t);
    const r = t.code, a = this.safeString(e, "chain"), o = this.safeValue(t, "networks", {}), c = this.indexBy(o, "id"), u = this.safeValue(c, a), f = this.safeString(u, "network");
    return this.checkAddress(i), {
      currency: r,
      address: i,
      tag: s,
      network: f,
      info: e
    };
  }
  async fetchDepositAddressesByNetwork(e, t = {}) {
    await this.loadMarkets();
    const i = this.currency(e), s = {
      ccy: i.id
    }, n = await this.privateGetAssetDepositAddress(this.extend(s, t)), r = this.safeValue(n, "data", []), a = this.filterBy(r, "selected", !0), o = this.parseDepositAddresses(a, [i.code], !1);
    return this.indexBy(o, "network");
  }
  async fetchDepositAddress(e, t = {}) {
    const i = this.safeString(t, "network"), s = this.safeValue(this.options, "networks", {});
    t = this.omit(t, "network");
    const n = await this.fetchDepositAddressesByNetwork(e, t);
    let r;
    if (i === void 0) {
      if (r = this.safeValue(n, e), r === void 0) {
        const a = this.safeString(s, e, e);
        if (r = this.safeValue(n, a), r === void 0) {
          const o = this.safeString(this.options, "defaultNetwork", "ERC20");
          if (r = this.safeValue(n, o), r === void 0) {
            const c = Object.values(n);
            if (r = this.safeValue(c, 0), r === void 0)
              throw new It(e, i).exchange(this.id);
          }
        }
      }
      return r;
    }
    if (r = this.safeValue(n, i), r === void 0)
      throw new It(e, i).exchange(this.id);
    return r;
  }
  async withdraw(e, t, i, s = void 0, n = {}) {
    [s, n] = this.handleWithdrawTagAndParams(s, n), this.checkAddress(i), await this.loadMarkets();
    const r = this.currency(e);
    s !== void 0 && s.length > 0 && (i = i + ":" + s);
    const a = {
      ccy: r.id,
      toAddr: i,
      dest: "4"
      // 2 = OKCoin International, 3 = OKX 4 = others
    };
    let o = this.safeString(n, "network");
    if (o !== void 0) {
      const m = this.safeValue(this.options, "networks", {});
      o = this.safeString(m, o.toUpperCase(), o), a.chain = r.id + "-" + o, n = this.omit(n, "network");
    }
    const c = this.currencyToPrecision(e, t, o);
    a.amt = this.numberToString(c);
    let u = this.safeString(n, "fee");
    if (u === void 0) {
      const m = await this.fetchCurrencies();
      this.currencies = this.deepExtend(this.currencies, m);
      const y = this.safeValue(r.networks, this.networkIdToCode(o), {});
      if (u = this.safeString(y, "fee"), u === void 0)
        throw new g('withdraw() requires a "fee" string parameter, network transaction fee must be ≥ 0. Withdrawals to OKCoin or OKX are fee-free, please set "0". Withdrawing to external digital asset address requires network transaction fee.').exchange(this.id);
    }
    if (a.fee = this.numberToString(u), "password" in n)
      a.pwd = n.password;
    else if ("pwd" in n)
      a.pwd = n.pwd;
    else {
      const m = this.safeValue(this.options, "withdraw", {}), y = this.safeString2(m, "password", "pwd");
      y !== void 0 && (a.pwd = y);
    }
    const f = this.omit(n, ["fee", "password", "pwd"]);
    if (!("pwd" in a))
      throw new g("withdraw() requires a password parameter or a pwd parameter, it must be the funding password, not the API passphrase").exchange(this.id);
    const h = await this.privatePostAssetWithdrawal(this.extend(a, f)), l = this.safeValue(h, "data", []), p = this.safeValue(l, 0);
    return this.parseTransaction(p, r);
  }
  async fetchDeposits(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchDeposits", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchDeposits", e, t, i, s);
    let r = {
      // 'ccy': currency['id'],
      // 'state': 2, // 0 waiting for confirmation, 1 deposit credited, 2 deposit successful
      // 'after': since,
      // 'before' this.milliseconds (),
      // 'limit': limit, // default 100, max 100
    }, a;
    e !== void 0 && (a = this.currency(e), r.ccy = a.id), t !== void 0 && (r.before = Math.max(t - 1, 0)), i !== void 0 && (r.limit = i), [r, s] = this.handleUntilOption("after", r, s);
    const o = await this.privateGetAssetDepositHistory(this.extend(r, s)), c = this.safeValue(o, "data", []);
    return this.parseTransactions(c, a, t, i, s);
  }
  async fetchDeposit(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      depId: e
    };
    let n;
    t !== void 0 && (n = this.currency(t), s.ccy = n.id);
    const r = await this.privateGetAssetDepositHistory(this.extend(s, i)), a = this.safeValue(r, "data"), o = this.safeValue(a, 0, {});
    return this.parseTransaction(o, n);
  }
  async fetchWithdrawals(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n = !1;
    if ([n, s] = this.handleOptionAndParams(s, "fetchWithdrawals", "paginate"), n)
      return await this.fetchPaginatedCallDynamic("fetchWithdrawals", e, t, i, s);
    let r = {
      // 'ccy': currency['id'],
      // 'state': 2, // -3: pending cancel, -2 canceled, -1 failed, 0, pending, 1 sending, 2 sent, 3 awaiting email verification, 4 awaiting manual verification, 5 awaiting identity verification
      // 'after': since,
      // 'before': this.milliseconds (),
      // 'limit': limit, // default 100, max 100
    }, a;
    e !== void 0 && (a = this.currency(e), r.ccy = a.id), t !== void 0 && (r.before = Math.max(t - 1, 0)), i !== void 0 && (r.limit = i), [r, s] = this.handleUntilOption("after", r, s);
    const o = await this.privateGetAssetWithdrawalHistory(this.extend(r, s)), c = this.safeValue(o, "data", []);
    return this.parseTransactions(c, a, t, i, s);
  }
  async fetchWithdrawal(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      wdId: e
    };
    let n;
    t !== void 0 && (n = this.currency(t), s.ccy = n.id);
    const r = await this.privateGetAssetWithdrawalHistory(this.extend(s, i)), a = this.safeValue(r, "data"), o = this.safeValue(a, 0, {});
    return this.parseTransaction(o);
  }
  parseTransactionStatus(e) {
    const t = {
      "-3": "pending",
      "-2": "canceled",
      "-1": "failed",
      0: "pending",
      1: "pending",
      2: "ok",
      3: "pending",
      4: "pending",
      5: "pending"
    };
    return this.safeString(t, e, e);
  }
  parseTransaction(e, t = void 0) {
    let i, s;
    const n = this.safeString(e, "wdId"), r = this.safeString(e, "from"), a = this.safeString(e, "to"), u = this.safeString(e, "chain").split("-").slice(1).join("-"), f = this.safeNetwork(u), h = a;
    let l = this.safeString2(e, "tag", "memo");
    l = this.safeString2(e, "pmtId", l), n !== void 0 ? (i = "withdrawal", s = n) : (s = this.safeString(e, "depId"), i = "deposit");
    const p = this.safeString(e, "ccy"), m = this.safeCurrencyCode(p), y = this.safeNumber(e, "amt"), w = this.parseTransactionStatus(this.safeString(e, "state")), S = this.safeString(e, "txId"), b = this.safeInteger(e, "ts");
    let T;
    return i === "deposit" ? T = 0 : T = this.safeNumber(e, "fee"), {
      info: e,
      id: s,
      currency: m,
      amount: y,
      network: f,
      addressFrom: r,
      addressTo: a,
      address: h,
      tagFrom: void 0,
      tagTo: l,
      tag: l,
      status: w,
      type: i,
      updated: void 0,
      txid: S,
      timestamp: b,
      datetime: this.iso8601(b),
      internal: void 0,
      comment: void 0,
      fee: {
        currency: m,
        cost: T
      }
    };
  }
  async fetchPosition(e, t = {}) {
    await this.loadMarkets();
    const i = this.market(e), [s, n] = this.handleMarketTypeAndParams("fetchPosition", i, t), r = {
      // instType String No Instrument type, MARGIN, SWAP, FUTURES, OPTION
      instId: i.id
      // posId String No Single position ID or multiple position IDs (no more than 20) separated with comma
    };
    s !== void 0 && (r.instType = this.convertToInstrumentType(s));
    const a = await this.privateGetAccountPositions(this.extend(r, n)), o = this.safeValue(a, "data", []), c = this.safeValue(o, 0);
    if (c !== void 0)
      return this.parsePosition(c, i);
  }
  async fetchPositions(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = {
      // 'instType': 'MARGIN', // optional string, MARGIN, SWAP, FUTURES, OPTION
      // 'instId': market['id'], // optional string, e.g. 'BTC-USD-190927-5000-C'
      // 'posId': '307173036051017730', // optional string, Single or multiple position IDs (no more than 20) separated with commas
    };
    if (e !== void 0) {
      const c = [];
      for (let f = 0; f < e.length; f++) {
        const h = e[f], l = this.market(h);
        c.push(l.id);
      }
      c.length > 0 && (i.instId = c.join(","));
    }
    const s = this.safeValue(this.options, "fetchPositions", {}), n = this.safeString(s, "method", "privateGetAccountPositions");
    let r;
    n === "privateGetAccountPositionsHistory" ? r = await this.privateGetAccountPositionsHistory(this.extend(i, t)) : r = await this.privateGetAccountPositions(this.extend(i, t));
    const a = this.safeValue(r, "data", []), o = [];
    for (let c = 0; c < a.length; c++)
      o.push(this.parsePosition(a[c]));
    return this.filterByArrayPositions(o, "symbol", e, !1);
  }
  async fetchPositionsForSymbol(e, t = {}) {
    return await this.fetchPositions([e], t);
  }
  parsePosition(e, t = void 0) {
    const i = this.safeString(e, "instId");
    t = this.safeMarket(i, t);
    const s = t.symbol, n = this.safeString(e, "pos"), r = P.stringAbs(n);
    let a = this.safeString(e, "posSide");
    const o = a !== "net", c = this.parseNumber(r);
    if (t.margin) {
      if (a === "net") {
        const te = this.safeString(e, "posCcy"), E = this.safeCurrencyCode(te);
        E !== void 0 && (a = t.base === E ? "long" : "short");
      }
      a === void 0 && (a = this.safeString(e, "direction"));
    } else
      n !== void 0 && a === "net" && (P.stringGt(n, "0") ? a = "long" : P.stringLt(n, "0") ? a = "short" : a = void 0);
    const u = this.safeNumber(t, "contractSize"), f = this.numberToString(u), h = this.safeString(e, "markPx");
    let l = this.safeString(e, "notionalUsd");
    t.inverse && (l = P.stringDiv(P.stringMul(r, f), h));
    const p = this.parseNumber(l), m = this.safeString(e, "mgnMode");
    let y;
    const w = this.safeString(e, "avgPx"), S = this.safeString(e, "upl"), b = this.safeString(e, "lever");
    let T, x;
    m === "cross" ? (y = this.safeString(e, "imr"), x = P.stringAdd(y, S)) : m === "isolated" && (T = P.stringDiv("1", b), x = this.safeString(e, "margin"));
    const v = this.safeString(e, "mmr"), _ = this.parseNumber(v), V = P.stringDiv(v, l);
    T === void 0 ? T = this.parseNumber(P.stringDiv(y, l, 4)) : y === void 0 && (y = P.stringMul(T, l));
    const j = "0.00005", G = this.parseNumber(P.stringDiv(P.stringAdd(V, j), "1", 4)), W = this.safeNumber(e, "liqPx"), B = this.safeString(e, "uplRatio"), Q = this.parseNumber(P.stringMul(B, "100")), se = this.safeInteger(e, "uTime"), $ = this.parseNumber(P.stringDiv(v, x, 4));
    return this.safePosition({
      info: e,
      id: void 0,
      symbol: s,
      notional: p,
      marginMode: m,
      liquidationPrice: W,
      entryPrice: this.parseNumber(w),
      unrealizedPnl: this.parseNumber(S),
      percentage: Q,
      contracts: c,
      contractSize: u,
      markPrice: this.parseNumber(h),
      lastPrice: void 0,
      side: a,
      hedged: o,
      timestamp: se,
      datetime: this.iso8601(se),
      lastUpdateTimestamp: void 0,
      maintenanceMargin: _,
      maintenanceMarginPercentage: G,
      collateral: this.parseNumber(x),
      initialMargin: this.parseNumber(y),
      initialMarginPercentage: this.parseNumber(T),
      leverage: this.parseNumber(b),
      marginRatio: $,
      stopLossPrice: void 0,
      takeProfitPrice: void 0
    });
  }
  // https://www.okx.com/docs-v5/en/#sub-account-rest-api-get-sub-account-trading-balance
  // https://www.okx.com/docs-v5/en/#sub-account-rest-api-get-sub-account-funding-balance
  async fetchSubAccountBalances(e, t = {}) {
    await this.loadMarkets();
    const i = await this.privateGetAssetSubaccountBalances({
      subAcct: e
    }), s = this.parseFundingBalance(i), n = await this.privateGetAccountSubaccountBalances({
      subAcct: e
    }), r = this.parseFundingBalance(n);
    return {
      trading: s,
      funding: r
    };
  }
  // https://www.okx.com/docs-v5/en/#sub-account-rest-api-get-sub-account-list
  async getSubAccounts() {
    await this.loadMarkets();
    const e = await this.privateGetUsersSubaccountList();
    return this.safeValue(e, "data", []).map((i) => ({
      uid: i.subAcct
    }));
  }
  // https://www.okx.com/docs-v5/en/#funding-account-rest-api-funds-transfer
  async subAccountTransfer(e, t, i, s, n, r, a = {}) {
    await this.loadMarkets();
    const o = this.currency(e), c = this.safeValue(this.options, "accountsByType", {}), u = this.safeString(c, i, i), f = this.safeString(c, s, s), h = {
      ccy: o.id,
      amt: this.currencyToPrecision(e, t),
      type: "0",
      from: u,
      to: f
      // beneficiary account, 6: Funding account, 18: Trading account
      // 'subAcct': 'sub-account-name', // optional, only required when type is 1, 2 or 4
      // 'loanTrans': false, // Whether or not borrowed coins can be transferred out under Multi-currency margin and Portfolio margin. The default is false
      // 'clientId': 'client-supplied id', // A combination of case-sensitive alphanumerics, all numbers, or all letters of up to 32 characters
      // 'omitPosRisk': false, // Ignore position risk. Default is false. Applicable to Portfolio margin
    };
    n === "master" ? (h.type = "1", h.subAcct = r) : r === "master" && (h.type = "2", h.subAcct = n);
    const l = await this.privatePostAssetTransfer(this.extend(h, a)), p = this.safeValue(l, "data", []), m = this.safeValue(p, 0, {});
    return this.parseTransfer(m, o);
  }
  async transfer(e, t, i, s, n = {}) {
    await this.loadMarkets();
    const r = this.currency(e), a = this.safeValue(this.options, "accountsByType", {}), o = this.safeString(a, i, i), c = this.safeString(a, s, s), u = {
      ccy: r.id,
      amt: this.currencyToPrecision(e, t),
      type: "0",
      from: o,
      to: c
      // beneficiary account, 6: Funding account, 18: Trading account
      // 'subAcct': 'sub-account-name', // optional, only required when type is 1, 2 or 4
      // 'loanTrans': false, // Whether or not borrowed coins can be transferred out under Multi-currency margin and Portfolio margin. The default is false
      // 'clientId': 'client-supplied id', // A combination of case-sensitive alphanumerics, all numbers, or all letters of up to 32 characters
      // 'omitPosRisk': false, // Ignore position risk. Default is false. Applicable to Portfolio margin
    };
    o === "master" ? (u.type = "1", u.subAcct = c, u.from = this.safeString(n, "from", "6"), u.to = this.safeString(n, "to", "6")) : c === "master" && (u.type = "2", u.subAcct = o, u.from = this.safeString(n, "from", "6"), u.to = this.safeString(n, "to", "6"));
    const f = await this.privatePostAssetTransfer(this.extend(u, n)), h = this.safeValue(f, "data", []), l = this.safeValue(h, 0, {});
    return this.parseTransfer(l, r);
  }
  parseTransfer(e, t = void 0) {
    const i = this.safeString2(e, "transId", "billId"), s = this.safeString(e, "ccy"), n = this.safeCurrencyCode(s, t);
    let r = this.safeNumber(e, "amt");
    const a = this.safeString(e, "from"), o = this.safeString(e, "to"), c = this.safeValue(this.options, "accountsById", {}), u = this.safeInteger(e, "ts", this.milliseconds()), f = this.safeString(e, "sz");
    return f !== void 0 && (r = this.parseNumber(P.stringAbs(f))), {
      info: e,
      id: i,
      timestamp: u,
      datetime: this.iso8601(u),
      currency: n,
      amount: r,
      fromAccount: this.safeString(c, a),
      toAccount: this.safeString(c, o),
      status: this.parseTransferStatus(this.safeString(e, "state"))
    };
  }
  parseTransferStatus(e) {
    const t = {
      success: "ok"
    };
    return this.safeString(t, e, e);
  }
  async fetchTransfer(e, t = void 0, i = {}) {
    await this.loadMarkets();
    const s = {
      transId: e
      // 'type': 0, // default is 0 transfer within account, 1 master to sub, 2 sub to master
    }, n = await this.privateGetAssetTransferState(this.extend(s, i)), r = this.safeValue(n, "data", []), a = this.safeValue(r, 0);
    return this.parseTransfer(a);
  }
  async fetchTransfers(e = void 0, t = void 0, i = void 0, s = {}) {
    await this.loadMarkets();
    let n;
    const r = {
      type: "1"
      // https://www.okx.com/docs-v5/en/#rest-api-account-get-bills-details-last-3-months
    };
    e !== void 0 && (n = this.currency(e), r.ccy = n.id), t !== void 0 && (r.begin = t), i !== void 0 && (r.limit = i);
    const a = await this.privateGetAccountBillsArchive(this.extend(r, s)), o = this.safeValue(a, "data", []);
    return this.parseTransfers(o, n, t, i, s);
  }
  async sign(e, t = "public", i = "GET", s = {}, n = void 0, r = void 0) {
    const a = Array.isArray(s), o = "/api/" + this.version + "/" + this.implodeParams(e, s), c = this.omit(s, this.extractParams(e));
    let u = this.implodeHostname(this.urls.api.rest) + o;
    if (t === "public")
      Object.keys(c).length && (u += "?" + this.urlencode(c));
    else if (t === "private")
      if (this.checkRequiredCredentials(), this.token)
        n = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
          TERMID: this.termId
        }, i !== "GET" ? Object.keys(c).length && (r = this.json(c)) : Object.keys(c).length && (u += "?" + this.urlencode(c));
      else {
        if (i === "POST" && (e === "trade/batch-orders" || e === "trade/order-algo" || e === "trade/order")) {
          const p = this.safeString(this.options, "brokerId", "e847386590ce4dBC");
          if (Array.isArray(s))
            for (let m = 0; m < s.length; m++) {
              const y = s[m];
              this.safeString(y, "clOrdId") === void 0 && (y.clOrdId = p + this.uuid16(), y.tag = p, s[m] = y);
            }
          else
            this.safeString(s, "clOrdId") === void 0 && (s.clOrdId = p + this.uuid16(), s.tag = p);
        }
        const f = this.iso8601(this.nonce());
        n = {
          "OK-ACCESS-KEY": this.apiKey,
          "OK-ACCESS-PASSPHRASE": this.password,
          "OK-ACCESS-TIMESTAMP": f
          // 'OK-FROM': '',
          // 'OK-TO': '',
          // 'OK-LIMIT': '',
        };
        let h = f + i + o;
        if (i === "GET") {
          if (Object.keys(c).length) {
            const p = "?" + this.urlencode(c);
            u += p, h += p;
          }
        } else
          (a || Object.keys(c).length) && (r = this.json(c), h += r), n["Content-Type"] = "application/json";
        let l;
        this.externalSigner ? l = await this.externalSigner.sign({
          payload: this.encode(h),
          publicApiKey: this.apiKey,
          exchangeId: this.id
        }) : l = this.hmac(this.encode(h), this.encode(this.secret), Re, "base64"), n["OK-ACCESS-SIGN"] = l;
      }
    return { url: u, method: i, body: r, headers: n };
  }
  async fetchDepositWithdrawFees(e = void 0, t = {}) {
    await this.loadMarkets();
    const i = await this.privateGetAssetCurrencies(t), s = this.safeValue(i, "data");
    return this.parseDepositWithdrawFees(s, e);
  }
  parseDepositWithdrawFees(e, t = void 0, i = void 0) {
    const s = {};
    t = this.marketCodes(t);
    for (let r = 0; r < e.length; r++) {
      const a = e[r], o = this.safeString(a, "ccy"), c = this.safeCurrencyCode(o);
      if (t === void 0 || this.inArray(c, t)) {
        this.safeValue(s, c) === void 0 && (s[c] = this.depositWithdrawFee({})), s[c].info[o] = a;
        const h = this.safeString(a, "chain").split("-"), l = this.safeValue(h, 1), p = this.safeNumber(a, "minFee"), m = {
          fee: p,
          percentage: p !== void 0 ? !1 : void 0
        }, y = {
          fee: void 0,
          percentage: void 0
        }, w = this.networkIdToCode(l, c);
        s[c].networks[w] = {
          withdraw: m,
          deposit: y
        };
      }
    }
    const n = Object.keys(s);
    for (let r = 0; r < n.length; r++) {
      const a = n[r], o = this.currency(a);
      s[a] = this.assignDefaultDepositWithdrawFees(s[a], o);
    }
    return s;
  }
  handleErrors(e, t, i, s, n, r, a, o, c) {
    if (!a)
      return;
    const u = this.safeString(a, "code");
    if (u !== "0" && u !== "2") {
      const f = this.safeValue(a, "data", []);
      let h, l;
      for (let p = 0; p < f.length; p++) {
        const m = f[p], y = this.safeString(m, "sCode");
        h = this.safeString(m, "sMsg"), l = y + ": " + h, this.throwExactlyMatchedException(this.exceptions.exact, y, l), this.throwBroadlyMatchedException(this.exceptions.broad, h, l);
      }
      throw h = this.safeString(a, "msg"), l = u + ": " + h, this.throwExactlyMatchedException(this.exceptions.exact, u, l), new O().addMessage(h).exchange(this.id);
    }
  }
}
const Nu = "4.2.44";
gt.ccxtVersion = Nu;
const _d = {
  binance: Vy,
  bitfinex2: Fy,
  bitget: Gy,
  bitmart: Hy,
  bitstamp: Yy,
  bybit: Xy,
  coinbase: Zy,
  coinbaseexchange: Jy,
  gate: Eu,
  gateio: tw,
  htx: sw,
  kraken: rw,
  kucoin: ow,
  mexc: cw,
  okx: fw
};
Object.assign({ errors: od, version: Nu, Exchange: gt, Precise: P, exchanges: Object.keys(_d), ...od }, _d, mo);
var vi = /* @__PURE__ */ ((d) => (d.TRADE = "trade", d.SEND = "send", d))(vi || {});
Fs.WITHDRAW, Fs.TRADE, Fs.READ, Fs.TRADE;
function Ld() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
const hw = (d) => {
  const e = {};
  function t(i, s = "") {
    for (const n in i) {
      const r = i[n], a = s ? `${s}.${n}` : n;
      typeof r == "object" && "code" in r && typeof r.code == "number" && typeof r.documentation == "string" && typeof r.message == "string" ? e[a] = {
        code: r.code,
        message: r.message,
        documentation: r.documentation
      } : typeof r == "object" && t(r, a);
    }
  }
  return t(d), e;
}, br = `
    <svg width="110" height="110" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.00745909 26.3991C0.00745909 11.815 11.8292 0 26.4048 0H83.6027C98.1857 0 110 11.8225 110 26.3991V83.6009C110 98.185 98.1783 110 83.6027 110H26.2704C11.762 110 0 98.2372 0 83.7278V26.3917L0.00745909 26.3991Z" fill="url(#paint0_linear_2187_113375)"/>
        <path d="M6.35721 29.6979C6.35721 16.8006 16.8131 6.34399 29.7095 6.34399H80.31C93.2064 6.34399 103.662 16.8006 103.662 29.6979V80.3018C103.662 93.1991 93.2064 103.656 80.31 103.656H29.5901C16.7534 103.656 6.34974 93.2513 6.34974 80.4138V29.6904L6.35721 29.6979Z" fill="black"/>
        <path d="M12.6995 32.9969C12.6995 21.7789 21.7896 12.6881 33.0068 12.6881H77.0098C88.227 12.6881 97.3171 21.7789 97.3171 32.9969V77.0029C97.3171 88.2208 88.227 97.3116 77.0098 97.3116H32.9098C21.7523 97.3116 12.7069 88.2656 12.7069 77.0999V32.9969H12.6995Z" fill="white"/>
        <path d="M45.7361 59.2219C49.8786 52.0466 48.6935 43.6066 43.0892 40.3708C37.485 37.1349 29.5838 40.3286 25.4414 47.5039C21.2989 54.6793 22.484 63.1192 28.0882 66.355C33.6925 69.5909 41.5937 66.3973 45.7361 59.2219Z" fill="black"/>
        <path d="M41.3015 52.747C43.7375 52.747 45.7123 50.7721 45.7123 48.3359C45.7123 45.8998 43.7375 43.9249 41.3015 43.9249C38.8656 43.9249 36.8908 45.8998 36.8908 48.3359C36.8908 50.7721 38.8656 52.747 41.3015 52.747Z" fill="white"/>
        <path d="M82.1606 66.4148C87.7649 63.1789 88.9499 54.739 84.8075 47.5636C80.6651 40.3883 72.7639 37.1947 67.1596 40.4305C61.5554 43.6663 60.3703 52.1063 64.5127 59.2817C68.6551 66.457 76.5564 69.6506 82.1606 66.4148Z" fill="black"/>
        <path d="M68.9501 52.814C71.3861 52.814 73.3608 50.8392 73.3608 48.403C73.3608 45.9669 71.3861 43.9919 68.9501 43.9919C66.5141 43.9919 64.5393 45.9669 64.5393 48.403C64.5393 50.8392 66.5141 52.814 68.9501 52.814Z" fill="white"/>
        <path d="M55.1234 71.4422C55.1234 71.4422 51.9739 71.3153 50.8469 72.1213C49.72 72.9274 49.7946 74.1739 49.7946 74.1739C49.7946 74.1739 49.6454 75.4501 50.0185 76.2786C50.3917 77.1071 52.5784 76.9653 53.6531 78.8088C53.6531 78.8088 54.6382 79.1447 55.1234 79.0477" fill="black"/>
        <path d="M55.1234 71.4422C55.1234 71.4422 58.273 71.3154 59.4 72.1215C60.5269 72.9276 60.4523 74.174 60.4523 74.174C60.4523 74.174 60.6015 75.4503 60.2284 76.2788C59.8552 77.1073 57.6685 76.9655 56.5938 78.809C56.5938 78.809 55.6085 79.1447 55.1234 79.0477" fill="black"/>
        <defs>
            <linearGradient id="paint0_linear_2187_113375" x1="55" y1="0" x2="55" y2="123.049" gradientUnits="userSpaceOnUse">
                <stop stop-color="currentColor"/>
                <stop offset="1" stop-color="currentColor" stop-opacity="0.4"/>
            </linearGradient>
        </defs>
    </svg>
`, lw = (d) => `
  .error-container {
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: ${d.custom.gutterMargin} 0;
    gap: ${d.custom.gutterMargin};
  }
  .error-logo {
    height: ${d.custom.imgSize.large};
    width: ${d.custom.imgSize.large};
  }
  .error-title {
    color: ${d.palette.error.main};
  }
  .error-content {
    color: ${d.palette.error.main};
    text-align: center;
    font-size: ${d.typography(d.palette).body1.fontSize};;
    font-weight: normal;
  }
`, pw = (d, { error: e }) => `
  <section class="error-container">
    <div class="error-logo cede-logo">
      ${br}
    </div>
    <h1 class="error-title">
      Error
    </h1>
    <h2 class="error-content">
      ${e}
    </h2>
  </section>
`, gw = {
  style: lw,
  html: pw
}, Dd = "https://discord.gg/V7hgKf6NWf", mw = (d) => `
  .help-container {
    position: absolute;
    top: 2%;
    right: 4%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: ${d.custom.smallGutterMargin};
    z-index: 3;
  }

  .help-button {
    cursor: pointer;
    display: inline-flex;
    border-radius: 100%;
    border: none;
    background: transparent;
  }

  .help-button svg {
    fill: ${d.palette.text.primary};
  }

  .help-popper__hidden {
    display: none;
  }

  .help-popper__exit {
    animation: scale-out 0.2s ease-in-out forwards;
  }

  .help-popper__visible {
    animation: scale-in 0.2s ease-in;
  }

  .help-popper {
    transform-origin: top right;
    background: ${d.palette.background.help};
    padding: ${d.custom.smallGutterMargin};
    border-radius: ${d.custom.buttonDefaultRadius}px;
  }

  .help-popper a {
    text-decoration: none;
    transition: 0.2s;
    display: inline-flex;
    align-items: center;
    gap: ${d.custom.gutterMargin};
  }

  .help-popper a:hover {
    opacity: 0.6;
  }

  .help-popper svg {
    fill: ${d.palette.text.primary};
  }

  .help-inner-icon {
    fill: ${d.palette.background.default};
  }

  @keyframes scale-in {
    from {
      transform: scale(0.7);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes scale-out {
    from {
      transform: scale(1);
      opacity: 1;
    }
    to {
      transform: scale(0.7);
      opacity: 0;
    }
  }
`, yw = () => `
  <div class="help-container">
    <a href="${Dd}" target="_blank" id="help-button" class="help-button">
     <svg width="20" height="20" focusable="false" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z">
        </path>
      </svg>
    </a>
    <div id="help-popper" class="help-popper help-popper__hidden">
      <a href="${Dd}" target="_blank">
        Get help on Discord 
        <svg width="24" height="24" focusable="false" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12C0 5.373 5.373 0 12 0C18.627 0 24 5.373 24 12Z"
          />
          <path
            fill="transparent"
            class="help-inner-icon"
            d="M16.8515 7.82936C15.959 7.44605 15.0024 7.16274 14.002 7.00164C13.9931 7.00001 13.9839 7.00106 13.9756 7.00464C13.9674 7.00823 13.9605 7.01416 13.9559 7.02164C13.8334 7.22662 13.6969 7.49383 13.6013 7.70493C12.5403 7.55396 11.4616 7.55396 10.4006 7.70493C10.2941 7.47097 10.1739 7.24286 10.0407 7.02164C10.0362 7.01407 10.0294 7.008 10.0211 7.00423C10.0129 7.00046 10.0037 6.99917 9.99464 7.00053C8.99483 7.16163 8.03819 7.44494 7.14513 7.82881C7.13745 7.83188 7.13094 7.83711 7.12647 7.84381C5.31119 10.3853 4.81362 12.864 5.05803 15.3116C5.05871 15.3176 5.06066 15.3234 5.06377 15.3287C5.06688 15.3339 5.07108 15.3385 5.07611 15.3422C6.13564 16.0768 7.31741 16.6365 8.57193 16.9976C8.58067 17.0002 8.59003 17.0002 8.59877 16.9976C8.60751 16.9951 8.61523 16.99 8.62092 16.9832C8.89088 16.6394 9.1301 16.2746 9.33607 15.8927C9.33893 15.8875 9.34058 15.8818 9.3409 15.8759C9.34123 15.87 9.34022 15.8641 9.33795 15.8586C9.33569 15.8532 9.33221 15.8482 9.32776 15.8441C9.32331 15.84 9.31799 15.8369 9.31216 15.8349C8.93534 15.6998 8.57023 15.5367 8.22019 15.3472C8.2139 15.3438 8.2086 15.3389 8.20476 15.3331C8.20093 15.3272 8.19868 15.3206 8.19822 15.3137C8.19775 15.3068 8.19909 15.2999 8.20211 15.2936C8.20513 15.2874 8.20974 15.2819 8.21552 15.2778C8.28902 15.2261 8.36252 15.1722 8.43251 15.1183C8.43882 15.1135 8.44641 15.1104 8.45444 15.1094C8.46247 15.1084 8.47063 15.1096 8.47801 15.1128C10.7687 16.0927 13.2495 16.0927 15.5134 15.1128C15.5208 15.1094 15.529 15.1081 15.5372 15.109C15.5453 15.1099 15.5531 15.1129 15.5595 15.1178C15.6295 15.1722 15.7024 15.2261 15.7765 15.2778C15.7823 15.2818 15.787 15.2872 15.7901 15.2934C15.7932 15.2996 15.7947 15.3065 15.7943 15.3134C15.794 15.3203 15.7918 15.3269 15.7881 15.3329C15.7844 15.3388 15.7792 15.3437 15.773 15.3472C15.4241 15.5383 15.0613 15.7 14.6804 15.8344C14.6746 15.8364 14.6692 15.8396 14.6648 15.8437C14.6603 15.8479 14.6569 15.8529 14.6546 15.8584C14.6523 15.8639 14.6513 15.8698 14.6517 15.8758C14.652 15.8817 14.6536 15.8875 14.6565 15.8927C14.8665 16.2744 15.1068 16.6377 15.3711 16.9826C15.3766 16.9897 15.3842 16.995 15.393 16.9978C15.4017 17.0006 15.4112 17.0007 15.4201 16.9982C16.6767 16.638 17.8604 16.0781 18.9211 15.3422C18.9263 15.3388 18.9306 15.3343 18.9339 15.3291C18.9371 15.3239 18.9391 15.3182 18.9398 15.3122C19.2315 12.4824 18.451 10.0237 16.8696 7.84492C16.8657 7.83784 16.8593 7.83232 16.8515 7.82936ZM9.67848 13.8212C8.989 13.8212 8.42026 13.2273 8.42026 12.4991C8.42026 11.7702 8.97791 11.1769 9.67848 11.1769C10.3843 11.1769 10.9478 11.7752 10.9367 12.4991C10.9367 13.2279 10.379 13.8212 9.67848 13.8212ZM14.3304 13.8212C13.6404 13.8212 13.0722 13.2273 13.0722 12.4991C13.0722 11.7702 13.6293 11.1769 14.3304 11.1769C15.0362 11.1769 15.5997 11.7752 15.5886 12.4991C15.5886 13.2279 15.0368 13.8212 14.3304 13.8212Z"
          />
        </svg>
      </a>

    </div>
  </div>
`, ww = (d) => {
  const e = d.html.querySelector(".help-container"), t = d.html.querySelector("#help-button"), i = d.html.querySelector("#help-popper");
  let s = !1;
  if (!t || !i || !e)
    throw new Error("Could not find help button or popper");
  t.addEventListener("mouseenter", () => {
    s = !0, i.classList.remove("help-popper__hidden"), i.classList.remove("help-popper__exit"), i.classList.add("help-popper__visible");
  }), e.addEventListener("mouseleave", () => {
    s = !1, i.classList.add("help-popper__exit"), i.classList.remove("help-popper__visible"), setTimeout(() => {
      s || (i.classList.add("help-popper__hidden"), i.classList.remove("help-popper__exit"));
    }, 250);
  });
}, bw = {
  style: mw,
  html: yw,
  action: ww
}, Sw = "data:image/svg+xml;base64,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", Tw = (d) => `
  .loader-container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    background: ${d.palette.background.default};
  }


  .cede-loader-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${d.custom.imgSize.large};
    width: ${d.custom.imgSize.large};
    padding: 6px;
    overflow: hidden;
    border-radius: 25%;
    box-sizing: border-box;
  }

  .cede-loader-wrapper::before {
    content: "";
    position: absolute;
    top: -20px;
    bottom: -20px;
    left: -20px;
    right: -20px;
    background: linear-gradient(${d.palette.logoBorderColor}, ${d.palette.logoBorderColor}, ${d.palette.logoBorderColor}, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
    z-index: 0;
    border-radius: 50%;
    animation: spinner-spin 2s linear infinite;
  }

  @keyframes spinner-spin {
    100% {
      transform: rotate(360deg); 
    }
  }

  .cede-loader-img {
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`, Aw = () => `
  <div id="cede-loader" class="loader-container">
    <div class="cede-loader-wrapper">
      <img class="cede-loader-img" src="${Sw}" />
    </div>
  </div>
`, Iw = {
  style: Tw,
  html: Aw
}, Ow = "data:image/svg+xml;base64,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", Mw = (d) => `
  .modal-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    animation: fade-in 0.3s ease-in-out;
  }

  .modal {
    max-width: 100%;
    width: 600px;
    height: 500px;
    border-radius: 14px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: ${d.palette.background.default};
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0px 4px 70px 50px #5EA6FF26;
  }

  .modal-header {
    display: flex;
    flex-direction: row-reverse;
    width: auto;
    min-height: 50px;
    padding: 8px;
  }

  .close-icon {
    width: 24px;
    height: 24px;
    fill: rgb(155, 155, 155);
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 50px);
    overflow: hidden;
    padding: 10px 50px 25px 50px;
    justify-content: space-between;
  }

  .modal-title {
    width: 100%;
  }

  .modal-title img {
    width: 110px;
    height: 110px;
  }

  .modal-title h1 {
    font-weight: 600;
    margin-top: 28px;
    font-size: 24px;
    color: ${d.palette.text.primary};
  }

  .modal-title h1 span {
    color: ${d.palette.primary.main};
  }

  .modal-title p {
    font-size: 14px;
    color: ${d.palette.text.secondary};
    line-height: 18px;
    font-weight: 400;
    margin-top: 20px;
  }

  .modal-title p.modal-content-last {
    margin-top: 35px;
  }

  .modal-title p strong {
    color: ${d.palette.text.secondary};
  }

  .modal-content-image:hover {
    box-shadow: 0px 0px 20px 14px rgba(94, 166, 255, 0.31);
  }
  
  .modal-content-image {
    margin-top: 20px;
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 0px 0px 0px 0px rgba(94, 166, 255, 0.31);
    height: 67px;
    width: 220px;
    border: 1px solid ${d.palette.cedeComponentHr};
    border-radius: 13px;
    padding: 0 10px;
    cursor: pointer;
  }

  .modal-banner-link {
    color: ${d.palette.text.secondary};
    margin-top: 20px;
  }
`, Cw = () => `
  <div class="modal-container" id="cede-modal-onboarding">
    <div class="modal">
      <header class="modal-header">
        <button class="icon-button" id="close-modal">
          <svg class="close-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
        </button>
      </header>
      <section class="modal-content">
        <div class="modal-title">
          <div class="cede-logo">
            ${br}
          </div>
          <h1>
            <span>Cede.store</span>
            is not detected
          </h1>
          <p>
            To proceed, you will need to <strong>download</strong> the extension from the 
            <strong>Chrome Web Store</strong>. Let you guide by the <strong>onboarding flow</strong>.
          </p>
          <p class="modal-content-last">
            Click below to access the Chrome Web Store
          </p>
        </div>
        <img id="chrome-web-store" src=${Ow} class="modal-content-image" alt="Download from Chrome Web Store" />
        <a href="https://cede.store" target="_blank" class="modal-banner-link">
          Discover more about cede.store
        </a>
      </section>
    </div>
  </div>
`, xw = (d) => (e, t) => {
  const i = e.html.querySelector("#close-modal"), s = e.html.querySelector("#chrome-web-store");
  !i || !s || (i.addEventListener("click", () => {
    t.remove(e);
  }), s.addEventListener("click", () => {
    localStorage.setItem("cede.store-onboarding", JSON.stringify(d ?? {})), window.open("https://chrome.google.com/webstore/detail/cedestore/dcfphbfmjohnlcpelbhfbjolhmmlcbhd", "_blank");
  }));
}, vw = (d) => ({
  style: Mw,
  html: Cw,
  action: xw(d)
}), kw = (d) => `
  .login-container {
    height: 100%;
    width: 100%;
    padding: ${d.custom.gutterMargin} 0;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
    box-sizing: border-box;
  }

  .login-banner {
    margin-top: 122px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .login-logo {
    height: ${d.custom.imgSize.large};
    width: ${d.custom.imgSize.large};
    margin-bottom: ${d.custom.gutterMargin};
  }

  .login-title {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .login-title-link {
    font-size: 20px;
    color: ${d.palette.primary.main};
    display: inline;
    text-decoration: none;
  }

  .login-title-link:hover {
    text-decoration: underline;
  }

  .login-title-2 {
    margin-top: 4px;
    font-size: ${d.typography(d.palette).body1.fontSize};
    font-weight: normal;
    color: ${d.palette.text.secondary};
    text-align: center;
  }

  .login-footer {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${d.custom.gutterMargin};
    padding-top: ${d.custom.bigGutterMargin};
  }
`, Ew = (d, { widgetType: e }) => `
  <section class="login-container">
    <div class="login-banner">
      <div class="login-logo cede-logo">
        ${br}
      </div>
      <h1 class="login-title">
        Welcome to <a href="https://cede.store" target="_blank" class="login-title-link">cede.store</a> ${e === vi.SEND ? "send" : "trade"} portal
      </h1>
      <h2 class="login-title-2">
      ${e === vi.SEND ? Gs.WIDGETS.SEND.TRANSFER_CEX_ASSETS : Gs.WIDGETS.TRADE.WELCOME_MESSAGE}
      </h2>
    </div>
    <div class="login-footer">
      <button class="cede-button" data-testid="widget-connect-button" id="login-btn">${Gs.WIDGETS.SEND.CONNECT}</button>
    </div>
  </section>
`, Nw = (d, e) => {
  const t = d.html.querySelector("#login-btn");
  t && t.addEventListener("click", () => {
    e.renderHtml(vw(), { clearPrevious: !1, animateOnExit: !0 });
  });
}, Pw = {
  style: kw,
  html: Ew,
  action: Nw
}, _w = "data:image/svg+xml;base64,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", Lw = (d) => `
  .not-supported-container {
    height: 100%;
    width: 100%;
    padding: ${d.custom.gutterMargin} 0;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
  }

  .not-supported-banner {
    text-align: center;
    margin-top: 116px;
  }

  .not-supported-logo {
    height: ${d.custom.imgSize.large};
    width: ${d.custom.imgSize.large};
  }

  .not-supported-title {
    font-size: 20px;
    font-weight: 600;
    color: ${d.palette.text.primary};
    margin-top: ${d.custom.gutterMargin};
    line-height: 1.167;
  }

  .not-supported-title span {
    font-size: 20px;
    color: ${d.palette.primary.main};
    display: inline;
  }

  .not-supported-banner-retry {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${d.custom.gutterMargin};
    padding-top: ${d.custom.gutterMargin};
  }

  .not-supported-banner-retry p {
    color: ${d.palette.text.secondary};
  }

  .not-supported-footer {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${d.custom.gutterMargin};
    margin-top: 40px;
  }

  .not-supported-banner-link {
    color: ${d.palette.text.secondary};
    margin-top: ${d.custom.smallGutterMargin};
    display: inline-flex;
    align-items: center;
    gap: ${d.custom.smallGutterMargin};
  }
  
  .not-supported-banner-link path {
    stroke: ${d.palette.text.secondary};
  }
`, Dw = () => `
  <section id="not-supported-page" class="not-supported-container">
    <div class="not-supported-banner">
      <div class="not-supported-logo cede-logo">
        ${br}
      </div>
      <h1 class="not-supported-title">
        <span>Cede.store</span>
        send portal is not available on ${Ld() ? "mobile" : "your current browser"}.
      </h1>
      <div class="not-supported-banner-retry">
        <p>
          Retry on a ${Ld() ? "desktop" : ""} chromium browser.
        </p>
        <img src="${_w}" width="20" alt="Google Chrome Icon" />
      </div>
      <a
        href="https://en.wikipedia.org/wiki/Chromium_(web_browser)#Active"
        target="_blank"
        rel="noopener noreferrer"
        class="not-supported-banner-link"
      >
        List of compatible browser 
        <svg width="13" height="13" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 1H7.66667M11 1L6 6M11 1V4.33333" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 6.55556V9.88889C11 10.5026 10.5026 11 9.88889 11H2.11111C1.49746 11 1 10.5026 1 9.88889V2.11111C1 1.49746 1.49746 1 2.11111 1H5.44444" stroke="#B8B8B8" stroke-linecap="round"/>
        </svg>
      </a>
    </div>
    <div class="not-supported-footer">
      <button class="cede-button" id="return-to-menu">Return to the menu</button>
    </div>
  </section>
`, Rw = (d) => {
  const e = d.html.querySelector("#return-to-menu");
  if (!e)
    throw new Error("Could not find button");
  e.addEventListener("click", () => {
    window.location.href = "/";
  });
}, Bw = {
  style: Lw,
  html: Dw,
  action: Rw
}, Vw = (d) => `
  * {
    color: ${d.palette.text.primary};
    font-family: ${d.typography(d.palette).fontFamily};
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .cede-layout {
    position: relative;
    overflow: hidden;
    max-width: ${d.custom.storeSize.widgetMaxWidth};
    min-width: ${d.custom.storeSize.widgetMinWidth};
    background: ${d.palette.background.default};
    width: ${d.custom.storeSize.widgetWidth};
    height: ${d.custom.storeSize.widgetHeight};
    border-radius: 12px;
    padding: 12px;
    border: 1px solid transparent;
  }

  .component-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
  }

  .cede-button {
    height: 50px;
    border-radius: 14px;
    background: ${d.palette.primary.main};
    color: ${d.palette.text.primary};
    border: none;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
    width: 100%;
    font-size: ${d.typography(d.palette).body1.fontSize};
  }

  .icon-button {
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .cede-logo, .cede-logo * {
    color: ${d.palette.logoBorderColor};
    display: inline-block;
  }

  .animate-exit {
    z-index: 2;
    animation: fade-out .5s ease-in forwards;
  }

  @keyframes fade-out {
    from { opacity: 1; }
    to { opacity: 0; }
  }

  @keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
class jw {
  constructor(e, t, i) {
    // Shadow dom to isolate styles
    ft(this, "shadow");
    // Layout to contain components
    ft(this, "layout");
    // Keep track of active components to remove them later
    ft(this, "activeComponents", []);
    this.root = e, this.theme = t, this.config = i;
    const s = document.createElement("div");
    this.root.appendChild(s), this.shadow = s.attachShadow({ mode: "open" });
    const n = document.createElement("style");
    n.innerHTML = Vw(this.theme), n.id = "cede-global-style", this.shadow.appendChild(n), this.layout = document.createElement("div"), (i == null ? void 0 : i.displayLayout) !== !1 && this.layout.classList.add("cede-layout"), this.layout.id = "cede-layout", this.shadow.appendChild(this.layout);
  }
  renderHtml(e, { clearPrevious: t = !0, animateOnExit: i = !1, layout: s = !1, data: n = {} } = {}) {
    var c;
    (c = this.activeComponents) != null && c.length && t && !s && (this.activeComponents.forEach((u) => this.remove(u)), this.activeComponents = []);
    const r = document.createElement("style");
    r.innerHTML = e.style(this.theme), this.shadow.appendChild(r), e.name && (r.id = `${e.name}-style`);
    const a = document.createElement("div");
    a.classList.add("component-container"), a.innerHTML = e.html(this.config, n), this.layout.appendChild(a), e.name && (a.id = `${e.name}-html`);
    const o = { style: r, html: a, opts: { animateOnExit: i } };
    s || this.activeComponents.push(o), e.action && e.action(o, this);
  }
  remove(e) {
    var t;
    if ((t = e.opts) != null && t.animateOnExit) {
      e.html.classList.add("animate-exit"), setTimeout(() => {
        this.layout.removeChild(e.html), this.shadow.removeChild(e.style);
      }, 600);
      return;
    }
    this.layout.removeChild(e.html), this.shadow.removeChild(e.style);
  }
  clear() {
    this.root.innerHTML = "";
  }
}
const Co = {
  primaryDarkBlue: "#3D4E5B",
  //Grey Blue
  secondaryDarkBlue: "#247CEC",
  //Navy blue
  cedePrimaryColor: "#5EA6FF",
  //Blue
  cedePrimaryColorLight: "#9acfed",
  // This color is not part of the DS can change at any time
  cedeSecondaryColor: "#A6FB74",
  //Green
  cedeSuccessColor: "#A6FB74",
  // Same color as above but this is not a primary color it is a success color
  cedeWarningColor: "#FFA726",
  cedeWarningLightColor: "#E2C395",
  cedeErrorColor: "#f44335",
  cedeSecondaryColorDark: "#0B7400",
  // This color is not part of the DS can change at any time
  cedePrimaryBackgroundColor: "#0A0B0b",
  //Black
  cedeTextPrimaryColor: "#FFFFFF",
  //White
  cedeTextSecondaryColor: "#9B9B9B",
  cedeSecondaryBackgroundColor: "#1B1B1B",
  //Black
  cedeTextGrey: "rgba(255, 255, 255, 0.5)",
  cedeTextDisabled: "rgba(255, 255, 255, 0.7)",
  cedeSkeleton: "rgba(255, 255, 255, 0.2)",
  cedeComponentHr: "rgba(255, 255, 255, 0.12)",
  cedeComponentBackgroundColor: "rgba(255, 255, 255, 0.08)",
  cedeComponentBorderGreyColor: "#A3A3A3",
  cedeComponentHoveredBackgroundColor: "rgba(255, 255, 255, 0.18)",
  cedePaperBackgroundColor: "linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), #121212",
  cedePaperLightBackgroundColor: "#373737",
  cedePaperDarkBackgroundColor: "#1F1F1F",
  cedePaperGradientBackground: "linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, rgba(255, 255, 255, 0.13) 100%), #121212",
  cedePaperModalGradientBackground: "linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%), #121212",
  cedeBubbleBackgroundColor: "#616161E5",
  cedeGradientPrimaryBackground: "linear-gradient(140.84deg, #5EA6FF -14.8%, #A6FB75 127.29%);",
  cedeBuyColor: "#11cb81",
  cedeSellColor: "#f5465d",
  cedeHelpBackgroundColor: "#404040"
}, Fw = {
  ...Co,
  cedePrimaryBackgroundColor: "#FFFEFD",
  cedeTextPrimaryColor: "#1B2026",
  cedeTextSecondaryColor: "#525860",
  cedeHelpBackgroundColor: "#EDEDED",
  cedePaperLightBackgroundColor: "#EDEDED",
  cedePaperDarkBackgroundColor: "#F6F6F6",
  cedePaperBackgroundColor: "#FFFEFD",
  cedeTextDisabled: "rgba(54, 63, 77, 0.5)",
  cedeSkeleton: "rgba(54, 63, 77, 0.2)",
  cedeComponentBackgroundColor: "#F6F6F6",
  cedeSuccessColor: "rgb(91, 188, 33)",
  cedeComponentHr: "#EDEDED"
}, Uw = (d, e = "dark") => ({
  mode: e,
  background: {
    default: d.cedePrimaryBackgroundColor,
    paper: d.cedePaperBackgroundColor,
    lightPaper: d.cedePaperLightBackgroundColor,
    darkPaper: d.cedePaperDarkBackgroundColor,
    component: d.cedeComponentBackgroundColor,
    help: d.cedeHelpBackgroundColor
  },
  primary: { main: d.cedePrimaryColor },
  secondary: { main: d.cedeSecondaryColor },
  text: {
    primary: d.cedeTextPrimaryColor,
    secondary: d.cedeTextSecondaryColor,
    disabled: d.cedeTextDisabled
  },
  action: {
    disabledBackground: d.cedeComponentHr,
    disabled: d.cedeTextDisabled
  },
  success: {
    main: d.cedeSuccessColor
  },
  warning: {
    main: d.cedeWarningColor,
    light: d.cedeWarningLightColor
  },
  error: {
    main: d.cedeErrorColor
  },
  logoBorderColor: d.cedePrimaryColor,
  ...d
}), qw = {
  zIndex: {
    baseLayer: 1,
    mediumLayer: 5,
    topLayer: 10,
    extraLayer: 15
  },
  storeSize: {
    width: "370px",
    tabWidth: "450px",
    bigTabWidth: "1265px",
    requestTabWidth: "600px",
    height: "600px",
    tabHeight: "600px",
    bigTabHeight: "800px",
    requestTabHeight: "500px",
    widgetWidth: "385px",
    tradeWidgetHeight: "600px",
    widgetHeight: "565px",
    widgetMinWidth: "330px",
    widgetMaxWidth: "500px"
  },
  navBarSize: {
    height: "50px",
    widgetHeight: "35px"
  },
  defaultBoxRadius: 1,
  largeBoxRadius: 3.5,
  mediumBoxRadius: 2,
  buttonSmallRadius: 3,
  buttonDefaultRadius: 3.5,
  buttonRoundedRadius: 100,
  smallGutterMargin: "8px",
  gutterMargin: "16px",
  mediumGutterMargin: "28px",
  bigGutterMargin: "40px",
  cedeLinkBigContentMargin: "60px",
  cedeLinkSmallContentMargin: "16px",
  cedeLinkBigContentMaxWidth: "1315px",
  inputRadius: {
    default: 4,
    rounded: 5
  },
  imgSize: {
    small: "32px",
    medium: "56px",
    large: "110px"
  },
  iconSize: {
    small: "16px",
    medium: "20px",
    large: "29px"
  },
  linkLogoWidth: {
    small: "99px",
    medium: "151px",
    large: "230px"
  },
  linkLogoHeight: {
    small: "15px",
    medium: "23px",
    large: "35px"
  },
  inputWidth: {
    small: "256px"
  },
  circleSize: {
    small: "8px"
  },
  opacity: {
    alert: 0.6,
    legend: 0.7
  },
  textSize: {
    small: "9px",
    medium: "11px",
    large: "13px"
  },
  iconUnderlayMargin: 4,
  portfolioItemWidth: "170px",
  portfolioItemHeight: "60px",
  linkInactiveFilterWidth: "160px",
  linkActiveFilterWidth: "200px",
  txHistoryItem: {
    height: 50
  },
  txHistoryList: {
    dateLineHeight: 74,
    dateLineMargin: 16,
    txDate: {
      margin: 15,
      height: 35
    },
    txPlace: {
      margin: 16,
      height: 50
    },
    txItem: {
      collapsed: 75,
      toggled: 145
    }
  },
  dappListItemHeight: 55,
  gradientButtonBackground: Co.cedeGradientPrimaryBackground
}, Gw = "'Inter', sans-serif", zw = (d) => {
  var e, t, i, s, n, r, a, o, c, u;
  return {
    fontFamily: Gw,
    h1: {
      fontWeight: "600",
      marginTop: "16px",
      fontSize: "24px",
      color: (e = d.text) == null ? void 0 : e.primary
    },
    h2: {
      fontWeight: "500",
      fontSize: "20px",
      marginBottom: "15px",
      lineHeight: "18px",
      color: (t = d.text) == null ? void 0 : t.secondary
    },
    h3: {
      fontSize: "16px",
      color: (i = d.text) == null ? void 0 : i.primary
    },
    h4: {
      color: (s = d.text) == null ? void 0 : s.primary
    },
    h5: {
      color: (n = d.text) == null ? void 0 : n.primary
    },
    subtitle1: {
      color: (r = d.text) == null ? void 0 : r.primary
    },
    subtitle2: {
      color: (a = d.text) == null ? void 0 : a.secondary
    },
    body1: {
      fontSize: "14px",
      lineHeight: "18px",
      fontWeight: 400,
      color: (o = d.text) == null ? void 0 : o.primary
    },
    body2: {
      color: (c = d.text) == null ? void 0 : c.secondary,
      fontSize: "14px"
    },
    caption: {
      fontSize: "11px",
      color: (u = d.text) == null ? void 0 : u.secondary
    }
  };
}, Hw = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1480,
    xl: 1920
  }
}, Ww = {
  borderRadius: 4
}, xn = { palette: Uw, custom: qw, typography: zw, breakpoints: Hw, shape: Ww }, Yw = (d) => {
  var n, r, a, o, c, u;
  const { palette: e, typography: t, custom: i } = xn, s = e((d == null ? void 0 : d.mode) === "light" ? Fw : Co, d == null ? void 0 : d.mode);
  return {
    ...xn,
    palette: {
      ...s,
      background: {
        ...s.background,
        default: (d == null ? void 0 : d.primaryColor) ?? ((n = s.background) == null ? void 0 : n.default),
        darkPaper: (d == null ? void 0 : d.primaryColor) ?? ((r = s.background) == null ? void 0 : r.darkPaper),
        paper: (d == null ? void 0 : d.secondaryColor) ?? ((a = s.background) == null ? void 0 : a.paper),
        component: (d == null ? void 0 : d.secondaryColor) ?? ((o = s.background) == null ? void 0 : o.component)
      },
      text: {
        ...s.text,
        primary: (d == null ? void 0 : d.primaryTextColor) ?? ((c = s.text) == null ? void 0 : c.primary),
        secondary: (d == null ? void 0 : d.secondaryTextColor) ?? ((u = s.text) == null ? void 0 : u.secondary)
      },
      error: {
        main: (d == null ? void 0 : d.errorColor) ?? s.cedeErrorColor
      },
      primary: {
        main: (d == null ? void 0 : d.accentColor) ?? s.cedePrimaryColor
      },
      warning: {
        main: (d == null ? void 0 : d.warningColor) ?? s.cedeWarningColor
      },
      cedeTextDisabled: (d == null ? void 0 : d.primaryTextColor) ?? s.cedeTextDisabled,
      logoBorderColor: (d == null ? void 0 : d.logoBorderColor) ?? s.logoBorderColor,
      cedeComponentHr: (d == null ? void 0 : d.inputBorderColor) ?? s.cedeComponentHr
    },
    typography: (f) => ({
      ...t(f),
      fontFamily: (d == null ? void 0 : d.fontFamily) ?? t(f).fontFamily
    }),
    shape: {
      borderRadius: (d == null ? void 0 : d.borderRadius) ?? xn.shape.borderRadius
    },
    custom: {
      ...i,
      storeSize: {
        ...i.storeSize,
        widgetWidth: (d == null ? void 0 : d.width) ?? i.storeSize.widgetWidth
      }
    },
    breakpoints: xn.breakpoints
  };
}, Kw = {
  connect: 2,
  disconnect: 1,
  vaults: 1,
  vaultAccounts: 1,
  supportedExchanges: 1,
  getWithdrawalById: 2,
  transactions: 2,
  balances: 3,
  nfts: 2,
  openOrders: 2,
  retrieveOrder: 2,
  editOrder: 2,
  getMinAmounts: 2,
  createOrder: 2,
  prepareOrder: 2,
  getStandardizedNetworks: 1,
  getMarketPairs: 2,
  getMarketRate: 2,
  tickers: 1,
  tokens: 1,
  activeVault: 1,
  depositableTokens: 2,
  getNetworks: 2,
  deposit: 2,
  cancelOrder: 2,
  addCex: 2,
  withdrawToDefi: 2,
  withdrawableTokens: 2,
  getPrices: 1,
  prepareWithdrawal: 2,
  getSettings: 1,
  getEnvironment: 1,
  getAddressBook: 1,
  checkAddressIsWhitelisted: 1,
  searchTransaction: 1,
  getWidgetBundleUrl: 1,
  getWhitelistedAddresses: 1,
  getTradePath: 1,
  getSupportedTokens: 1,
  isWalletTypeTotupNeeded: 1,
  trackLink: 1,
  openPageWithHelper: 1,
  untrackLink: 1,
  getConfig: 1,
  fetchPartners: 1,
  getCurrentAppTab: 1,
  focusTab: 1,
  getUserId: 1,
  getTradePathBySupportedTokens: 1,
  verifyKYC: 1,
  getTokenNamesAndSymbols: 1,
  getDiscordInvitation: 1,
  hasJoinedDiscord: 1,
  getOHLCV: 1,
  openTab: 1,
  setByPassApprovalTradeHub: 1,
  canByPassApprovalTradeHub: 1,
  getAppVersion: 1
  /* V1 */
};
class Rd {
  constructor(e) {
    ft(this, "inpageProvider");
    ft(this, "request", async (e) => {
      const i = Kw[e.method] ?? -1, s = e;
      return s.params ? s.params = { ...s.params, version: i } : s.params = { version: i }, this.inpageProvider.request(s);
    });
    ft(this, "on", (e, t) => (this.inpageProvider.on(e, t), this));
    ft(this, "once", (e, t) => (this.inpageProvider.on(e, t), this));
    ft(this, "off", (e, t) => (this.inpageProvider.off(e, t), this));
    ft(this, "removeListener", (e, t) => (this.inpageProvider.removeListener(e, t), this));
    ft(this, "removeAllListeners", (e) => (this.inpageProvider.removeAllListeners(e), this));
    ft(this, "emit", (e, ...t) => this.inpageProvider.emit(e, ...t));
    ft(this, "getVaultPreviews", () => this.inpageProvider.getVaultPreviews());
    ft(this, "getIsUnlocked", () => this.inpageProvider.getIsUnlocked());
    ft(this, "getIsConnected", () => this.inpageProvider.getIsConnected());
    ft(this, "getActiveVault", () => this.inpageProvider.getActiveVault());
    this.inpageProvider = e;
  }
}
function Xw(d = 1500) {
  let e = !1;
  return new Promise((t) => {
    window.cede ? i() : (window.addEventListener("cede#initialized", i, {
      once: !0
    }), setTimeout(() => {
      i();
    }, d));
    function i() {
      if (e) {
        const n = window.cede, r = new Rd(n);
        t(r);
        return;
      }
      e = !0, window.removeEventListener("cede#initialized", i);
      const { cede: s } = window;
      if (s) {
        const n = window.cede, r = new Rd(n);
        t(r);
      } else
        t(null);
    }
  });
}
hw(Yf);
var Sr = {}, Pa = { exports: {} }, _a = { exports: {} };
typeof Ce > "u" || !Ce.version || Ce.version.indexOf("v0.") === 0 || Ce.version.indexOf("v1.") === 0 && Ce.version.indexOf("v1.8.") !== 0 ? _a.exports = { nextTick: $w } : _a.exports = Ce;
function $w(d, e, t, i) {
  if (typeof d != "function")
    throw new TypeError('"callback" argument must be a function');
  var s = arguments.length, n, r;
  switch (s) {
    case 0:
    case 1:
      return Ce.nextTick(d);
    case 2:
      return Ce.nextTick(function() {
        d.call(null, e);
      });
    case 3:
      return Ce.nextTick(function() {
        d.call(null, e, t);
      });
    case 4:
      return Ce.nextTick(function() {
        d.call(null, e, t, i);
      });
    default:
      for (n = new Array(s - 1), r = 0; r < n.length; )
        n[r++] = arguments[r];
      return Ce.nextTick(function() {
        d.apply(null, n);
      });
  }
}
var Vi = _a.exports, Zw = {}.toString, Qw = Array.isArray || function(d) {
  return Zw.call(d) == "[object Array]";
}, xo = { exports: {} }, ls = typeof Reflect == "object" ? Reflect : null, Bd = ls && typeof ls.apply == "function" ? ls.apply : function(e, t, i) {
  return Function.prototype.apply.call(e, t, i);
}, Rn;
ls && typeof ls.ownKeys == "function" ? Rn = ls.ownKeys : Object.getOwnPropertySymbols ? Rn = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Rn = function(e) {
  return Object.getOwnPropertyNames(e);
};
function Jw(d) {
  console && console.warn && console.warn(d);
}
var Pu = Number.isNaN || function(e) {
  return e !== e;
};
function Be() {
  Be.init.call(this);
}
xo.exports = Be;
var vT = xo.exports.once = s1;
Be.EventEmitter = Be;
Be.prototype._events = void 0;
Be.prototype._eventsCount = 0;
Be.prototype._maxListeners = void 0;
var Vd = 10;
function Tr(d) {
  if (typeof d != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof d);
}
Object.defineProperty(Be, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Vd;
  },
  set: function(d) {
    if (typeof d != "number" || d < 0 || Pu(d))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + d + ".");
    Vd = d;
  }
});
Be.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Be.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || Pu(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function _u(d) {
  return d._maxListeners === void 0 ? Be.defaultMaxListeners : d._maxListeners;
}
Be.prototype.getMaxListeners = function() {
  return _u(this);
};
Be.prototype.emit = function(e) {
  for (var t = [], i = 1; i < arguments.length; i++)
    t.push(arguments[i]);
  var s = e === "error", n = this._events;
  if (n !== void 0)
    s = s && n.error === void 0;
  else if (!s)
    return !1;
  if (s) {
    var r;
    if (t.length > 0 && (r = t[0]), r instanceof Error)
      throw r;
    var a = new Error("Unhandled error." + (r ? " (" + r.message + ")" : ""));
    throw a.context = r, a;
  }
  var o = n[e];
  if (o === void 0)
    return !1;
  if (typeof o == "function")
    Bd(o, this, t);
  else
    for (var c = o.length, u = Vu(o, c), i = 0; i < c; ++i)
      Bd(u[i], this, t);
  return !0;
};
function Lu(d, e, t, i) {
  var s, n, r;
  if (Tr(t), n = d._events, n === void 0 ? (n = d._events = /* @__PURE__ */ Object.create(null), d._eventsCount = 0) : (n.newListener !== void 0 && (d.emit(
    "newListener",
    e,
    t.listener ? t.listener : t
  ), n = d._events), r = n[e]), r === void 0)
    r = n[e] = t, ++d._eventsCount;
  else if (typeof r == "function" ? r = n[e] = i ? [t, r] : [r, t] : i ? r.unshift(t) : r.push(t), s = _u(d), s > 0 && r.length > s && !r.warned) {
    r.warned = !0;
    var a = new Error("Possible EventEmitter memory leak detected. " + r.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    a.name = "MaxListenersExceededWarning", a.emitter = d, a.type = e, a.count = r.length, Jw(a);
  }
  return d;
}
Be.prototype.addListener = function(e, t) {
  return Lu(this, e, t, !1);
};
Be.prototype.on = Be.prototype.addListener;
Be.prototype.prependListener = function(e, t) {
  return Lu(this, e, t, !0);
};
function e1() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Du(d, e, t) {
  var i = { fired: !1, wrapFn: void 0, target: d, type: e, listener: t }, s = e1.bind(i);
  return s.listener = t, i.wrapFn = s, s;
}
Be.prototype.once = function(e, t) {
  return Tr(t), this.on(e, Du(this, e, t)), this;
};
Be.prototype.prependOnceListener = function(e, t) {
  return Tr(t), this.prependListener(e, Du(this, e, t)), this;
};
Be.prototype.removeListener = function(e, t) {
  var i, s, n, r, a;
  if (Tr(t), s = this._events, s === void 0)
    return this;
  if (i = s[e], i === void 0)
    return this;
  if (i === t || i.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete s[e], s.removeListener && this.emit("removeListener", e, i.listener || t));
  else if (typeof i != "function") {
    for (n = -1, r = i.length - 1; r >= 0; r--)
      if (i[r] === t || i[r].listener === t) {
        a = i[r].listener, n = r;
        break;
      }
    if (n < 0)
      return this;
    n === 0 ? i.shift() : t1(i, n), i.length === 1 && (s[e] = i[0]), s.removeListener !== void 0 && this.emit("removeListener", e, a || t);
  }
  return this;
};
Be.prototype.off = Be.prototype.removeListener;
Be.prototype.removeAllListeners = function(e) {
  var t, i, s;
  if (i = this._events, i === void 0)
    return this;
  if (i.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : i[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete i[e]), this;
  if (arguments.length === 0) {
    var n = Object.keys(i), r;
    for (s = 0; s < n.length; ++s)
      r = n[s], r !== "removeListener" && this.removeAllListeners(r);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = i[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (s = t.length - 1; s >= 0; s--)
      this.removeListener(e, t[s]);
  return this;
};
function Ru(d, e, t) {
  var i = d._events;
  if (i === void 0)
    return [];
  var s = i[e];
  return s === void 0 ? [] : typeof s == "function" ? t ? [s.listener || s] : [s] : t ? i1(s) : Vu(s, s.length);
}
Be.prototype.listeners = function(e) {
  return Ru(this, e, !0);
};
Be.prototype.rawListeners = function(e) {
  return Ru(this, e, !1);
};
Be.listenerCount = function(d, e) {
  return typeof d.listenerCount == "function" ? d.listenerCount(e) : Bu.call(d, e);
};
Be.prototype.listenerCount = Bu;
function Bu(d) {
  var e = this._events;
  if (e !== void 0) {
    var t = e[d];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
Be.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Rn(this._events) : [];
};
function Vu(d, e) {
  for (var t = new Array(e), i = 0; i < e; ++i)
    t[i] = d[i];
  return t;
}
function t1(d, e) {
  for (; e + 1 < d.length; e++)
    d[e] = d[e + 1];
  d.pop();
}
function i1(d) {
  for (var e = new Array(d.length), t = 0; t < e.length; ++t)
    e[t] = d[t].listener || d[t];
  return e;
}
function s1(d, e) {
  return new Promise(function(t, i) {
    function s(r) {
      d.removeListener(e, n), i(r);
    }
    function n() {
      typeof d.removeListener == "function" && d.removeListener("error", s), t([].slice.call(arguments));
    }
    ju(d, e, n, { once: !0 }), e !== "error" && n1(d, s, { once: !0 });
  });
}
function n1(d, e, t) {
  typeof d.on == "function" && ju(d, "error", e, t);
}
function ju(d, e, t, i) {
  if (typeof d.on == "function")
    i.once ? d.once(e, t) : d.on(e, t);
  else if (typeof d.addEventListener == "function")
    d.addEventListener(e, function s(n) {
      i.once && d.removeEventListener(e, s), t(n);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof d);
}
var vs = xo.exports, Fu = vs.EventEmitter, La = { exports: {} };
(function(d, e) {
  var t = nn(), i = t.Buffer;
  function s(r, a) {
    for (var o in r)
      a[o] = r[o];
  }
  i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? d.exports = t : (s(t, e), e.Buffer = n);
  function n(r, a, o) {
    return i(r, a, o);
  }
  s(i, n), n.from = function(r, a, o) {
    if (typeof r == "number")
      throw new TypeError("Argument must not be a number");
    return i(r, a, o);
  }, n.alloc = function(r, a, o) {
    if (typeof r != "number")
      throw new TypeError("Argument must be a number");
    var c = i(r);
    return a !== void 0 ? typeof o == "string" ? c.fill(a, o) : c.fill(a) : c.fill(0), c;
  }, n.allocUnsafe = function(r) {
    if (typeof r != "number")
      throw new TypeError("Argument must be a number");
    return i(r);
  }, n.allocUnsafeSlow = function(r) {
    if (typeof r != "number")
      throw new TypeError("Argument must be a number");
    return t.SlowBuffer(r);
  };
})(La, La.exports);
var vo = La.exports, Fe = {};
function r1(d) {
  return Array.isArray ? Array.isArray(d) : Ar(d) === "[object Array]";
}
Fe.isArray = r1;
function a1(d) {
  return typeof d == "boolean";
}
Fe.isBoolean = a1;
function o1(d) {
  return d === null;
}
Fe.isNull = o1;
function d1(d) {
  return d == null;
}
Fe.isNullOrUndefined = d1;
function c1(d) {
  return typeof d == "number";
}
Fe.isNumber = c1;
function u1(d) {
  return typeof d == "string";
}
Fe.isString = u1;
function f1(d) {
  return typeof d == "symbol";
}
Fe.isSymbol = f1;
function h1(d) {
  return d === void 0;
}
Fe.isUndefined = h1;
function l1(d) {
  return Ar(d) === "[object RegExp]";
}
Fe.isRegExp = l1;
function p1(d) {
  return typeof d == "object" && d !== null;
}
Fe.isObject = p1;
function g1(d) {
  return Ar(d) === "[object Date]";
}
Fe.isDate = g1;
function m1(d) {
  return Ar(d) === "[object Error]" || d instanceof Error;
}
Fe.isError = m1;
function y1(d) {
  return typeof d == "function";
}
Fe.isFunction = y1;
function w1(d) {
  return d === null || typeof d == "boolean" || typeof d == "number" || typeof d == "string" || typeof d == "symbol" || // ES6 symbol
  typeof d > "u";
}
Fe.isPrimitive = w1;
Fe.isBuffer = nn().Buffer.isBuffer;
function Ar(d) {
  return Object.prototype.toString.call(d);
}
var Da = { exports: {} };
typeof Object.create == "function" ? Da.exports = function(e, t) {
  t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : Da.exports = function(e, t) {
  if (t) {
    e.super_ = t;
    var i = function() {
    };
    i.prototype = t.prototype, e.prototype = new i(), e.prototype.constructor = e;
  }
};
var jt = Da.exports, dn = {}, Uu = {}, qu = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, t = Symbol("test"), i = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object Symbol]")
    return !1;
  var s = 42;
  e[t] = s;
  for (t in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var n = Object.getOwnPropertySymbols(e);
  if (n.length !== 1 || n[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var r = Object.getOwnPropertyDescriptor(e, t);
    if (r.value !== s || r.enumerable !== !0)
      return !1;
  }
  return !0;
}, b1 = qu, ko = function() {
  return b1() && !!Symbol.toStringTag;
}, S1 = Error, T1 = EvalError, A1 = RangeError, I1 = ReferenceError, Gu = SyntaxError, Ir = TypeError, O1 = URIError, jd = typeof Symbol < "u" && Symbol, M1 = qu, C1 = function() {
  return typeof jd != "function" || typeof Symbol != "function" || typeof jd("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : M1();
}, Xr = {
  __proto__: null,
  foo: {}
}, x1 = Object, v1 = function() {
  return { __proto__: Xr }.foo === Xr.foo && !(Xr instanceof x1);
}, k1 = "Function.prototype.bind called on incompatible ", E1 = Object.prototype.toString, N1 = Math.max, P1 = "[object Function]", Fd = function(e, t) {
  for (var i = [], s = 0; s < e.length; s += 1)
    i[s] = e[s];
  for (var n = 0; n < t.length; n += 1)
    i[n + e.length] = t[n];
  return i;
}, _1 = function(e, t) {
  for (var i = [], s = t || 0, n = 0; s < e.length; s += 1, n += 1)
    i[n] = e[s];
  return i;
}, L1 = function(d, e) {
  for (var t = "", i = 0; i < d.length; i += 1)
    t += d[i], i + 1 < d.length && (t += e);
  return t;
}, D1 = function(e) {
  var t = this;
  if (typeof t != "function" || E1.apply(t) !== P1)
    throw new TypeError(k1 + t);
  for (var i = _1(arguments, 1), s, n = function() {
    if (this instanceof s) {
      var u = t.apply(
        this,
        Fd(i, arguments)
      );
      return Object(u) === u ? u : this;
    }
    return t.apply(
      e,
      Fd(i, arguments)
    );
  }, r = N1(0, t.length - i.length), a = [], o = 0; o < r; o++)
    a[o] = "$" + o;
  if (s = Function("binder", "return function (" + L1(a, ",") + "){ return binder.apply(this,arguments); }")(n), t.prototype) {
    var c = function() {
    };
    c.prototype = t.prototype, s.prototype = new c(), c.prototype = null;
  }
  return s;
}, R1 = D1, Eo = Function.prototype.bind || R1, B1 = Function.prototype.call, V1 = Object.prototype.hasOwnProperty, j1 = Eo, F1 = j1.call(B1, V1), ve, U1 = S1, q1 = T1, G1 = A1, z1 = I1, Ts = Gu, ps = Ir, H1 = O1, zu = Function, $r = function(d) {
  try {
    return zu('"use strict"; return (' + d + ").constructor;")();
  } catch {
  }
}, Yi = Object.getOwnPropertyDescriptor;
if (Yi)
  try {
    Yi({}, "");
  } catch {
    Yi = null;
  }
var Zr = function() {
  throw new ps();
}, W1 = Yi ? function() {
  try {
    return arguments.callee, Zr;
  } catch {
    try {
      return Yi(arguments, "callee").get;
    } catch {
      return Zr;
    }
  }
}() : Zr, ns = C1(), Y1 = v1(), tt = Object.getPrototypeOf || (Y1 ? function(d) {
  return d.__proto__;
} : null), ds = {}, K1 = typeof Uint8Array > "u" || !tt ? ve : tt(Uint8Array), Ki = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? ve : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? ve : ArrayBuffer,
  "%ArrayIteratorPrototype%": ns && tt ? tt([][Symbol.iterator]()) : ve,
  "%AsyncFromSyncIteratorPrototype%": ve,
  "%AsyncFunction%": ds,
  "%AsyncGenerator%": ds,
  "%AsyncGeneratorFunction%": ds,
  "%AsyncIteratorPrototype%": ds,
  "%Atomics%": typeof Atomics > "u" ? ve : Atomics,
  "%BigInt%": typeof BigInt > "u" ? ve : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? ve : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? ve : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? ve : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": U1,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": q1,
  "%Float32Array%": typeof Float32Array > "u" ? ve : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? ve : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? ve : FinalizationRegistry,
  "%Function%": zu,
  "%GeneratorFunction%": ds,
  "%Int8Array%": typeof Int8Array > "u" ? ve : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? ve : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? ve : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": ns && tt ? tt(tt([][Symbol.iterator]())) : ve,
  "%JSON%": typeof JSON == "object" ? JSON : ve,
  "%Map%": typeof Map > "u" ? ve : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !ns || !tt ? ve : tt((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? ve : Promise,
  "%Proxy%": typeof Proxy > "u" ? ve : Proxy,
  "%RangeError%": G1,
  "%ReferenceError%": z1,
  "%Reflect%": typeof Reflect > "u" ? ve : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? ve : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !ns || !tt ? ve : tt((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? ve : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": ns && tt ? tt(""[Symbol.iterator]()) : ve,
  "%Symbol%": ns ? Symbol : ve,
  "%SyntaxError%": Ts,
  "%ThrowTypeError%": W1,
  "%TypedArray%": K1,
  "%TypeError%": ps,
  "%Uint8Array%": typeof Uint8Array > "u" ? ve : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? ve : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? ve : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? ve : Uint32Array,
  "%URIError%": H1,
  "%WeakMap%": typeof WeakMap > "u" ? ve : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? ve : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? ve : WeakSet
};
if (tt)
  try {
    null.error;
  } catch (d) {
    var X1 = tt(tt(d));
    Ki["%Error.prototype%"] = X1;
  }
var $1 = function d(e) {
  var t;
  if (e === "%AsyncFunction%")
    t = $r("async function () {}");
  else if (e === "%GeneratorFunction%")
    t = $r("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    t = $r("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var i = d("%AsyncGeneratorFunction%");
    i && (t = i.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var s = d("%AsyncGenerator%");
    s && tt && (t = tt(s.prototype));
  }
  return Ki[e] = t, t;
}, Ud = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, cn = Eo, Jn = F1, Z1 = cn.call(Function.call, Array.prototype.concat), Q1 = cn.call(Function.apply, Array.prototype.splice), qd = cn.call(Function.call, String.prototype.replace), er = cn.call(Function.call, String.prototype.slice), J1 = cn.call(Function.call, RegExp.prototype.exec), eb = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, tb = /\\(\\)?/g, ib = function(e) {
  var t = er(e, 0, 1), i = er(e, -1);
  if (t === "%" && i !== "%")
    throw new Ts("invalid intrinsic syntax, expected closing `%`");
  if (i === "%" && t !== "%")
    throw new Ts("invalid intrinsic syntax, expected opening `%`");
  var s = [];
  return qd(e, eb, function(n, r, a, o) {
    s[s.length] = a ? qd(o, tb, "$1") : r || n;
  }), s;
}, sb = function(e, t) {
  var i = e, s;
  if (Jn(Ud, i) && (s = Ud[i], i = "%" + s[0] + "%"), Jn(Ki, i)) {
    var n = Ki[i];
    if (n === ds && (n = $1(i)), typeof n > "u" && !t)
      throw new ps("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: s,
      name: i,
      value: n
    };
  }
  throw new Ts("intrinsic " + e + " does not exist!");
}, un = function(e, t) {
  if (typeof e != "string" || e.length === 0)
    throw new ps("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new ps('"allowMissing" argument must be a boolean');
  if (J1(/^%?[^%]*%?$/, e) === null)
    throw new Ts("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var i = ib(e), s = i.length > 0 ? i[0] : "", n = sb("%" + s + "%", t), r = n.name, a = n.value, o = !1, c = n.alias;
  c && (s = c[0], Q1(i, Z1([0, 1], c)));
  for (var u = 1, f = !0; u < i.length; u += 1) {
    var h = i[u], l = er(h, 0, 1), p = er(h, -1);
    if ((l === '"' || l === "'" || l === "`" || p === '"' || p === "'" || p === "`") && l !== p)
      throw new Ts("property names with quotes must have matching quotes");
    if ((h === "constructor" || !f) && (o = !0), s += "." + h, r = "%" + s + "%", Jn(Ki, r))
      a = Ki[r];
    else if (a != null) {
      if (!(h in a)) {
        if (!t)
          throw new ps("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (Yi && u + 1 >= i.length) {
        var m = Yi(a, h);
        f = !!m, f && "get" in m && !("originalValue" in m.get) ? a = m.get : a = a[h];
      } else
        f = Jn(a, h), a = a[h];
      f && !o && (Ki[r] = a);
    }
  }
  return a;
}, Hu = { exports: {} }, Qr, Gd;
function No() {
  if (Gd)
    return Qr;
  Gd = 1;
  var d = un, e = d("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Qr = e, Qr;
}
var nb = un, Bn = nb("%Object.getOwnPropertyDescriptor%", !0);
if (Bn)
  try {
    Bn([], "length");
  } catch {
    Bn = null;
  }
var Po = Bn, zd = No(), rb = Gu, rs = Ir, Hd = Po, ab = function(e, t, i) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new rs("`obj` must be an object or a function`");
  if (typeof t != "string" && typeof t != "symbol")
    throw new rs("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new rs("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new rs("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new rs("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new rs("`loose`, if provided, must be a boolean");
  var s = arguments.length > 3 ? arguments[3] : null, n = arguments.length > 4 ? arguments[4] : null, r = arguments.length > 5 ? arguments[5] : null, a = arguments.length > 6 ? arguments[6] : !1, o = !!Hd && Hd(e, t);
  if (zd)
    zd(e, t, {
      configurable: r === null && o ? o.configurable : !r,
      enumerable: s === null && o ? o.enumerable : !s,
      value: i,
      writable: n === null && o ? o.writable : !n
    });
  else if (a || !s && !n && !r)
    e[t] = i;
  else
    throw new rb("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Ra = No(), Wu = function() {
  return !!Ra;
};
Wu.hasArrayLengthDefineBug = function() {
  if (!Ra)
    return null;
  try {
    return Ra([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var ob = Wu, db = un, Wd = ab, cb = ob(), Yd = Po, Kd = Ir, ub = db("%Math.floor%"), fb = function(e, t) {
  if (typeof e != "function")
    throw new Kd("`fn` is not a function");
  if (typeof t != "number" || t < 0 || t > 4294967295 || ub(t) !== t)
    throw new Kd("`length` must be a positive 32-bit integer");
  var i = arguments.length > 2 && !!arguments[2], s = !0, n = !0;
  if ("length" in e && Yd) {
    var r = Yd(e, "length");
    r && !r.configurable && (s = !1), r && !r.writable && (n = !1);
  }
  return (s || n || !i) && (cb ? Wd(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t,
    !0,
    !0
  ) : Wd(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t
  )), e;
};
(function(d) {
  var e = Eo, t = un, i = fb, s = Ir, n = t("%Function.prototype.apply%"), r = t("%Function.prototype.call%"), a = t("%Reflect.apply%", !0) || e.call(r, n), o = No(), c = t("%Math.max%");
  d.exports = function(h) {
    if (typeof h != "function")
      throw new s("a function is required");
    var l = a(e, r, arguments);
    return i(
      l,
      1 + c(0, h.length - (arguments.length - 1)),
      !0
    );
  };
  var u = function() {
    return a(e, n, arguments);
  };
  o ? o(d.exports, "apply", { value: u }) : d.exports.apply = u;
})(Hu);
var Yu = Hu.exports, Ku = un, Xu = Yu, hb = Xu(Ku("String.prototype.indexOf")), $u = function(e, t) {
  var i = Ku(e, !!t);
  return typeof i == "function" && hb(e, ".prototype.") > -1 ? Xu(i) : i;
}, lb = ko(), pb = $u, Ba = pb("Object.prototype.toString"), Or = function(e) {
  return lb && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : Ba(e) === "[object Arguments]";
}, Zu = function(e) {
  return Or(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && Ba(e) !== "[object Array]" && Ba(e.callee) === "[object Function]";
}, gb = function() {
  return Or(arguments);
}();
Or.isLegacyArguments = Zu;
var mb = gb ? Or : Zu, yb = Object.prototype.toString, wb = Function.prototype.toString, bb = /^\s*(?:function)?\*/, Qu = ko(), Jr = Object.getPrototypeOf, Sb = function() {
  if (!Qu)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, ea, Tb = function(e) {
  if (typeof e != "function")
    return !1;
  if (bb.test(wb.call(e)))
    return !0;
  if (!Qu) {
    var t = yb.call(e);
    return t === "[object GeneratorFunction]";
  }
  if (!Jr)
    return !1;
  if (typeof ea > "u") {
    var i = Sb();
    ea = i ? Jr(i) : !1;
  }
  return Jr(e) === ea;
}, Ju = Function.prototype.toString, cs = typeof Reflect == "object" && Reflect !== null && Reflect.apply, Va, Vn;
if (typeof cs == "function" && typeof Object.defineProperty == "function")
  try {
    Va = Object.defineProperty({}, "length", {
      get: function() {
        throw Vn;
      }
    }), Vn = {}, cs(function() {
      throw 42;
    }, null, Va);
  } catch (d) {
    d !== Vn && (cs = null);
  }
else
  cs = null;
var Ab = /^\s*class\b/, ja = function(e) {
  try {
    var t = Ju.call(e);
    return Ab.test(t);
  } catch {
    return !1;
  }
}, ta = function(e) {
  try {
    return ja(e) ? !1 : (Ju.call(e), !0);
  } catch {
    return !1;
  }
}, jn = Object.prototype.toString, Ib = "[object Object]", Ob = "[object Function]", Mb = "[object GeneratorFunction]", Cb = "[object HTMLAllCollection]", xb = "[object HTML document.all class]", vb = "[object HTMLCollection]", kb = typeof Symbol == "function" && !!Symbol.toStringTag, Eb = !(0 in [,]), Fa = function() {
  return !1;
};
if (typeof document == "object") {
  var Nb = document.all;
  jn.call(Nb) === jn.call(document.all) && (Fa = function(e) {
    if ((Eb || !e) && (typeof e > "u" || typeof e == "object"))
      try {
        var t = jn.call(e);
        return (t === Cb || t === xb || t === vb || t === Ib) && e("") == null;
      } catch {
      }
    return !1;
  });
}
var Pb = cs ? function(e) {
  if (Fa(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  try {
    cs(e, null, Va);
  } catch (t) {
    if (t !== Vn)
      return !1;
  }
  return !ja(e) && ta(e);
} : function(e) {
  if (Fa(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  if (kb)
    return ta(e);
  if (ja(e))
    return !1;
  var t = jn.call(e);
  return t !== Ob && t !== Mb && !/^\[object HTML/.test(t) ? !1 : ta(e);
}, _b = Pb, Lb = Object.prototype.toString, ef = Object.prototype.hasOwnProperty, Db = function(e, t, i) {
  for (var s = 0, n = e.length; s < n; s++)
    ef.call(e, s) && (i == null ? t(e[s], s, e) : t.call(i, e[s], s, e));
}, Rb = function(e, t, i) {
  for (var s = 0, n = e.length; s < n; s++)
    i == null ? t(e.charAt(s), s, e) : t.call(i, e.charAt(s), s, e);
}, Bb = function(e, t, i) {
  for (var s in e)
    ef.call(e, s) && (i == null ? t(e[s], s, e) : t.call(i, e[s], s, e));
}, Vb = function(e, t, i) {
  if (!_b(t))
    throw new TypeError("iterator must be a function");
  var s;
  arguments.length >= 3 && (s = i), Lb.call(e) === "[object Array]" ? Db(e, t, s) : typeof e == "string" ? Rb(e, t, s) : Bb(e, t, s);
}, jb = Vb, Fb = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], ia = Fb, Ub = typeof globalThis > "u" ? qe : globalThis, qb = function() {
  for (var e = [], t = 0; t < ia.length; t++)
    typeof Ub[ia[t]] == "function" && (e[e.length] = ia[t]);
  return e;
}, tr = jb, Gb = qb, Xd = Yu, _o = $u, Fn = Po, zb = _o("Object.prototype.toString"), tf = ko(), $d = typeof globalThis > "u" ? qe : globalThis, Ua = Gb(), Lo = _o("String.prototype.slice"), sa = Object.getPrototypeOf, Hb = _o("Array.prototype.indexOf", !0) || function(e, t) {
  for (var i = 0; i < e.length; i += 1)
    if (e[i] === t)
      return i;
  return -1;
}, ir = { __proto__: null };
tf && Fn && sa ? tr(Ua, function(d) {
  var e = new $d[d]();
  if (Symbol.toStringTag in e) {
    var t = sa(e), i = Fn(t, Symbol.toStringTag);
    if (!i) {
      var s = sa(t);
      i = Fn(s, Symbol.toStringTag);
    }
    ir["$" + d] = Xd(i.get);
  }
}) : tr(Ua, function(d) {
  var e = new $d[d](), t = e.slice || e.set;
  t && (ir["$" + d] = Xd(t));
});
var Wb = function(e) {
  var t = !1;
  return tr(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    ir,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(i, s) {
      if (!t)
        try {
          "$" + i(e) === s && (t = Lo(s, 1));
        } catch {
        }
    }
  ), t;
}, Yb = function(e) {
  var t = !1;
  return tr(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    ir,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(i, s) {
      if (!t)
        try {
          i(e), t = Lo(s, 1);
        } catch {
        }
    }
  ), t;
}, sf = function(e) {
  if (!e || typeof e != "object")
    return !1;
  if (!tf) {
    var t = Lo(zb(e), 8, -1);
    return Hb(Ua, t) > -1 ? t : t !== "Object" ? !1 : Yb(e);
  }
  return Fn ? Wb(e) : null;
}, Kb = sf, Xb = function(e) {
  return !!Kb(e);
};
(function(d) {
  var e = mb, t = Tb, i = sf, s = Xb;
  function n(ue) {
    return ue.call.bind(ue);
  }
  var r = typeof BigInt < "u", a = typeof Symbol < "u", o = n(Object.prototype.toString), c = n(Number.prototype.valueOf), u = n(String.prototype.valueOf), f = n(Boolean.prototype.valueOf);
  if (r)
    var h = n(BigInt.prototype.valueOf);
  if (a)
    var l = n(Symbol.prototype.valueOf);
  function p(ue, Tt) {
    if (typeof ue != "object")
      return !1;
    try {
      return Tt(ue), !0;
    } catch {
      return !1;
    }
  }
  d.isArgumentsObject = e, d.isGeneratorFunction = t, d.isTypedArray = s;
  function m(ue) {
    return typeof Promise < "u" && ue instanceof Promise || ue !== null && typeof ue == "object" && typeof ue.then == "function" && typeof ue.catch == "function";
  }
  d.isPromise = m;
  function y(ue) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ue) : s(ue) || U(ue);
  }
  d.isArrayBufferView = y;
  function w(ue) {
    return i(ue) === "Uint8Array";
  }
  d.isUint8Array = w;
  function S(ue) {
    return i(ue) === "Uint8ClampedArray";
  }
  d.isUint8ClampedArray = S;
  function b(ue) {
    return i(ue) === "Uint16Array";
  }
  d.isUint16Array = b;
  function T(ue) {
    return i(ue) === "Uint32Array";
  }
  d.isUint32Array = T;
  function x(ue) {
    return i(ue) === "Int8Array";
  }
  d.isInt8Array = x;
  function v(ue) {
    return i(ue) === "Int16Array";
  }
  d.isInt16Array = v;
  function _(ue) {
    return i(ue) === "Int32Array";
  }
  d.isInt32Array = _;
  function V(ue) {
    return i(ue) === "Float32Array";
  }
  d.isFloat32Array = V;
  function j(ue) {
    return i(ue) === "Float64Array";
  }
  d.isFloat64Array = j;
  function G(ue) {
    return i(ue) === "BigInt64Array";
  }
  d.isBigInt64Array = G;
  function W(ue) {
    return i(ue) === "BigUint64Array";
  }
  d.isBigUint64Array = W;
  function B(ue) {
    return o(ue) === "[object Map]";
  }
  B.working = typeof Map < "u" && B(/* @__PURE__ */ new Map());
  function Q(ue) {
    return typeof Map > "u" ? !1 : B.working ? B(ue) : ue instanceof Map;
  }
  d.isMap = Q;
  function se(ue) {
    return o(ue) === "[object Set]";
  }
  se.working = typeof Set < "u" && se(/* @__PURE__ */ new Set());
  function $(ue) {
    return typeof Set > "u" ? !1 : se.working ? se(ue) : ue instanceof Set;
  }
  d.isSet = $;
  function te(ue) {
    return o(ue) === "[object WeakMap]";
  }
  te.working = typeof WeakMap < "u" && te(/* @__PURE__ */ new WeakMap());
  function E(ue) {
    return typeof WeakMap > "u" ? !1 : te.working ? te(ue) : ue instanceof WeakMap;
  }
  d.isWeakMap = E;
  function N(ue) {
    return o(ue) === "[object WeakSet]";
  }
  N.working = typeof WeakSet < "u" && N(/* @__PURE__ */ new WeakSet());
  function L(ue) {
    return N(ue);
  }
  d.isWeakSet = L;
  function z(ue) {
    return o(ue) === "[object ArrayBuffer]";
  }
  z.working = typeof ArrayBuffer < "u" && z(new ArrayBuffer());
  function K(ue) {
    return typeof ArrayBuffer > "u" ? !1 : z.working ? z(ue) : ue instanceof ArrayBuffer;
  }
  d.isArrayBuffer = K;
  function R(ue) {
    return o(ue) === "[object DataView]";
  }
  R.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && R(new DataView(new ArrayBuffer(1), 0, 1));
  function U(ue) {
    return typeof DataView > "u" ? !1 : R.working ? R(ue) : ue instanceof DataView;
  }
  d.isDataView = U;
  var Y = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function J(ue) {
    return o(ue) === "[object SharedArrayBuffer]";
  }
  function ae(ue) {
    return typeof Y > "u" ? !1 : (typeof J.working > "u" && (J.working = J(new Y())), J.working ? J(ue) : ue instanceof Y);
  }
  d.isSharedArrayBuffer = ae;
  function A(ue) {
    return o(ue) === "[object AsyncFunction]";
  }
  d.isAsyncFunction = A;
  function M(ue) {
    return o(ue) === "[object Map Iterator]";
  }
  d.isMapIterator = M;
  function q(ue) {
    return o(ue) === "[object Set Iterator]";
  }
  d.isSetIterator = q;
  function H(ue) {
    return o(ue) === "[object Generator]";
  }
  d.isGeneratorObject = H;
  function le(ue) {
    return o(ue) === "[object WebAssembly.Module]";
  }
  d.isWebAssemblyCompiledModule = le;
  function oe(ue) {
    return p(ue, c);
  }
  d.isNumberObject = oe;
  function he(ue) {
    return p(ue, u);
  }
  d.isStringObject = he;
  function Ie(ue) {
    return p(ue, f);
  }
  d.isBooleanObject = Ie;
  function Pe(ue) {
    return r && p(ue, h);
  }
  d.isBigIntObject = Pe;
  function He(ue) {
    return a && p(ue, l);
  }
  d.isSymbolObject = He;
  function bt(ue) {
    return oe(ue) || he(ue) || Ie(ue) || Pe(ue) || He(ue);
  }
  d.isBoxedPrimitive = bt;
  function mt(ue) {
    return typeof Uint8Array < "u" && (K(ue) || ae(ue));
  }
  d.isAnyArrayBuffer = mt, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ue) {
    Object.defineProperty(d, ue, {
      enumerable: !1,
      value: function() {
        throw new Error(ue + " is not supported in userland");
      }
    });
  });
})(Uu);
var $b = function(e) {
  return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
};
(function(d) {
  var e = Object.getOwnPropertyDescriptors || function(U) {
    for (var Y = Object.keys(U), J = {}, ae = 0; ae < Y.length; ae++)
      J[Y[ae]] = Object.getOwnPropertyDescriptor(U, Y[ae]);
    return J;
  }, t = /%[sdj%]/g;
  d.format = function(R) {
    if (!x(R)) {
      for (var U = [], Y = 0; Y < arguments.length; Y++)
        U.push(r(arguments[Y]));
      return U.join(" ");
    }
    for (var Y = 1, J = arguments, ae = J.length, A = String(R).replace(t, function(q) {
      if (q === "%%")
        return "%";
      if (Y >= ae)
        return q;
      switch (q) {
        case "%s":
          return String(J[Y++]);
        case "%d":
          return Number(J[Y++]);
        case "%j":
          try {
            return JSON.stringify(J[Y++]);
          } catch {
            return "[Circular]";
          }
        default:
          return q;
      }
    }), M = J[Y]; Y < ae; M = J[++Y])
      S(M) || !j(M) ? A += " " + M : A += " " + r(M);
    return A;
  }, d.deprecate = function(R, U) {
    if (typeof Ce < "u" && Ce.noDeprecation === !0)
      return R;
    if (typeof Ce > "u")
      return function() {
        return d.deprecate(R, U).apply(this, arguments);
      };
    var Y = !1;
    function J() {
      if (!Y) {
        if (Ce.throwDeprecation)
          throw new Error(U);
        Ce.traceDeprecation ? console.trace(U) : console.error(U), Y = !0;
      }
      return R.apply(this, arguments);
    }
    return J;
  };
  var i = {}, s = /^$/;
  if (Ce.env.NODE_DEBUG) {
    var n = Ce.env.NODE_DEBUG;
    n = n.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), s = new RegExp("^" + n + "$", "i");
  }
  d.debuglog = function(R) {
    if (R = R.toUpperCase(), !i[R])
      if (s.test(R)) {
        var U = Ce.pid;
        i[R] = function() {
          var Y = d.format.apply(d, arguments);
          console.error("%s %d: %s", R, U, Y);
        };
      } else
        i[R] = function() {
        };
    return i[R];
  };
  function r(R, U) {
    var Y = {
      seen: [],
      stylize: o
    };
    return arguments.length >= 3 && (Y.depth = arguments[2]), arguments.length >= 4 && (Y.colors = arguments[3]), w(U) ? Y.showHidden = U : U && d._extend(Y, U), _(Y.showHidden) && (Y.showHidden = !1), _(Y.depth) && (Y.depth = 2), _(Y.colors) && (Y.colors = !1), _(Y.customInspect) && (Y.customInspect = !0), Y.colors && (Y.stylize = a), u(Y, R, Y.depth);
  }
  d.inspect = r, r.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, r.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function a(R, U) {
    var Y = r.styles[U];
    return Y ? "\x1B[" + r.colors[Y][0] + "m" + R + "\x1B[" + r.colors[Y][1] + "m" : R;
  }
  function o(R, U) {
    return R;
  }
  function c(R) {
    var U = {};
    return R.forEach(function(Y, J) {
      U[Y] = !0;
    }), U;
  }
  function u(R, U, Y) {
    if (R.customInspect && U && B(U.inspect) && // Filter out the util module, it's inspect function is special
    U.inspect !== d.inspect && // Also filter out any prototype objects using the circular check.
    !(U.constructor && U.constructor.prototype === U)) {
      var J = U.inspect(Y, R);
      return x(J) || (J = u(R, J, Y)), J;
    }
    var ae = f(R, U);
    if (ae)
      return ae;
    var A = Object.keys(U), M = c(A);
    if (R.showHidden && (A = Object.getOwnPropertyNames(U)), W(U) && (A.indexOf("message") >= 0 || A.indexOf("description") >= 0))
      return h(U);
    if (A.length === 0) {
      if (B(U)) {
        var q = U.name ? ": " + U.name : "";
        return R.stylize("[Function" + q + "]", "special");
      }
      if (V(U))
        return R.stylize(RegExp.prototype.toString.call(U), "regexp");
      if (G(U))
        return R.stylize(Date.prototype.toString.call(U), "date");
      if (W(U))
        return h(U);
    }
    var H = "", le = !1, oe = ["{", "}"];
    if (y(U) && (le = !0, oe = ["[", "]"]), B(U)) {
      var he = U.name ? ": " + U.name : "";
      H = " [Function" + he + "]";
    }
    if (V(U) && (H = " " + RegExp.prototype.toString.call(U)), G(U) && (H = " " + Date.prototype.toUTCString.call(U)), W(U) && (H = " " + h(U)), A.length === 0 && (!le || U.length == 0))
      return oe[0] + H + oe[1];
    if (Y < 0)
      return V(U) ? R.stylize(RegExp.prototype.toString.call(U), "regexp") : R.stylize("[Object]", "special");
    R.seen.push(U);
    var Ie;
    return le ? Ie = l(R, U, Y, M, A) : Ie = A.map(function(Pe) {
      return p(R, U, Y, M, Pe, le);
    }), R.seen.pop(), m(Ie, H, oe);
  }
  function f(R, U) {
    if (_(U))
      return R.stylize("undefined", "undefined");
    if (x(U)) {
      var Y = "'" + JSON.stringify(U).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return R.stylize(Y, "string");
    }
    if (T(U))
      return R.stylize("" + U, "number");
    if (w(U))
      return R.stylize("" + U, "boolean");
    if (S(U))
      return R.stylize("null", "null");
  }
  function h(R) {
    return "[" + Error.prototype.toString.call(R) + "]";
  }
  function l(R, U, Y, J, ae) {
    for (var A = [], M = 0, q = U.length; M < q; ++M)
      N(U, String(M)) ? A.push(p(
        R,
        U,
        Y,
        J,
        String(M),
        !0
      )) : A.push("");
    return ae.forEach(function(H) {
      H.match(/^\d+$/) || A.push(p(
        R,
        U,
        Y,
        J,
        H,
        !0
      ));
    }), A;
  }
  function p(R, U, Y, J, ae, A) {
    var M, q, H;
    if (H = Object.getOwnPropertyDescriptor(U, ae) || { value: U[ae] }, H.get ? H.set ? q = R.stylize("[Getter/Setter]", "special") : q = R.stylize("[Getter]", "special") : H.set && (q = R.stylize("[Setter]", "special")), N(J, ae) || (M = "[" + ae + "]"), q || (R.seen.indexOf(H.value) < 0 ? (S(Y) ? q = u(R, H.value, null) : q = u(R, H.value, Y - 1), q.indexOf(`
`) > -1 && (A ? q = q.split(`
`).map(function(le) {
      return "  " + le;
    }).join(`
`).slice(2) : q = `
` + q.split(`
`).map(function(le) {
      return "   " + le;
    }).join(`
`))) : q = R.stylize("[Circular]", "special")), _(M)) {
      if (A && ae.match(/^\d+$/))
        return q;
      M = JSON.stringify("" + ae), M.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (M = M.slice(1, -1), M = R.stylize(M, "name")) : (M = M.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), M = R.stylize(M, "string"));
    }
    return M + ": " + q;
  }
  function m(R, U, Y) {
    var J = R.reduce(function(ae, A) {
      return A.indexOf(`
`) >= 0, ae + A.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return J > 60 ? Y[0] + (U === "" ? "" : U + `
 `) + " " + R.join(`,
  `) + " " + Y[1] : Y[0] + U + " " + R.join(", ") + " " + Y[1];
  }
  d.types = Uu;
  function y(R) {
    return Array.isArray(R);
  }
  d.isArray = y;
  function w(R) {
    return typeof R == "boolean";
  }
  d.isBoolean = w;
  function S(R) {
    return R === null;
  }
  d.isNull = S;
  function b(R) {
    return R == null;
  }
  d.isNullOrUndefined = b;
  function T(R) {
    return typeof R == "number";
  }
  d.isNumber = T;
  function x(R) {
    return typeof R == "string";
  }
  d.isString = x;
  function v(R) {
    return typeof R == "symbol";
  }
  d.isSymbol = v;
  function _(R) {
    return R === void 0;
  }
  d.isUndefined = _;
  function V(R) {
    return j(R) && se(R) === "[object RegExp]";
  }
  d.isRegExp = V, d.types.isRegExp = V;
  function j(R) {
    return typeof R == "object" && R !== null;
  }
  d.isObject = j;
  function G(R) {
    return j(R) && se(R) === "[object Date]";
  }
  d.isDate = G, d.types.isDate = G;
  function W(R) {
    return j(R) && (se(R) === "[object Error]" || R instanceof Error);
  }
  d.isError = W, d.types.isNativeError = W;
  function B(R) {
    return typeof R == "function";
  }
  d.isFunction = B;
  function Q(R) {
    return R === null || typeof R == "boolean" || typeof R == "number" || typeof R == "string" || typeof R == "symbol" || // ES6 symbol
    typeof R > "u";
  }
  d.isPrimitive = Q, d.isBuffer = $b;
  function se(R) {
    return Object.prototype.toString.call(R);
  }
  function $(R) {
    return R < 10 ? "0" + R.toString(10) : R.toString(10);
  }
  var te = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function E() {
    var R = /* @__PURE__ */ new Date(), U = [
      $(R.getHours()),
      $(R.getMinutes()),
      $(R.getSeconds())
    ].join(":");
    return [R.getDate(), te[R.getMonth()], U].join(" ");
  }
  d.log = function() {
    console.log("%s - %s", E(), d.format.apply(d, arguments));
  }, d.inherits = jt, d._extend = function(R, U) {
    if (!U || !j(U))
      return R;
    for (var Y = Object.keys(U), J = Y.length; J--; )
      R[Y[J]] = U[Y[J]];
    return R;
  };
  function N(R, U) {
    return Object.prototype.hasOwnProperty.call(R, U);
  }
  var L = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  d.promisify = function(U) {
    if (typeof U != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (L && U[L]) {
      var Y = U[L];
      if (typeof Y != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(Y, L, {
        value: Y,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Y;
    }
    function Y() {
      for (var J, ae, A = new Promise(function(H, le) {
        J = H, ae = le;
      }), M = [], q = 0; q < arguments.length; q++)
        M.push(arguments[q]);
      M.push(function(H, le) {
        H ? ae(H) : J(le);
      });
      try {
        U.apply(this, M);
      } catch (H) {
        ae(H);
      }
      return A;
    }
    return Object.setPrototypeOf(Y, Object.getPrototypeOf(U)), L && Object.defineProperty(Y, L, {
      value: Y,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      Y,
      e(U)
    );
  }, d.promisify.custom = L;
  function z(R, U) {
    if (!R) {
      var Y = new Error("Promise was rejected with a falsy value");
      Y.reason = R, R = Y;
    }
    return U(R);
  }
  function K(R) {
    if (typeof R != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function U() {
      for (var Y = [], J = 0; J < arguments.length; J++)
        Y.push(arguments[J]);
      var ae = Y.pop();
      if (typeof ae != "function")
        throw new TypeError("The last argument must be of type Function");
      var A = this, M = function() {
        return ae.apply(A, arguments);
      };
      R.apply(this, Y).then(
        function(q) {
          Ce.nextTick(M.bind(null, null, q));
        },
        function(q) {
          Ce.nextTick(z.bind(null, q, M));
        }
      );
    }
    return Object.setPrototypeOf(U, Object.getPrototypeOf(R)), Object.defineProperties(
      U,
      e(R)
    ), U;
  }
  d.callbackify = K;
})(dn);
var na = { exports: {} }, Zd;
function Zb() {
  return Zd || (Zd = 1, function(d) {
    function e(n, r) {
      if (!(n instanceof r))
        throw new TypeError("Cannot call a class as a function");
    }
    var t = vo.Buffer, i = dn;
    function s(n, r, a) {
      n.copy(r, a);
    }
    d.exports = function() {
      function n() {
        e(this, n), this.head = null, this.tail = null, this.length = 0;
      }
      return n.prototype.push = function(a) {
        var o = { data: a, next: null };
        this.length > 0 ? this.tail.next = o : this.head = o, this.tail = o, ++this.length;
      }, n.prototype.unshift = function(a) {
        var o = { data: a, next: this.head };
        this.length === 0 && (this.tail = o), this.head = o, ++this.length;
      }, n.prototype.shift = function() {
        if (this.length !== 0) {
          var a = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, a;
        }
      }, n.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, n.prototype.join = function(a) {
        if (this.length === 0)
          return "";
        for (var o = this.head, c = "" + o.data; o = o.next; )
          c += a + o.data;
        return c;
      }, n.prototype.concat = function(a) {
        if (this.length === 0)
          return t.alloc(0);
        for (var o = t.allocUnsafe(a >>> 0), c = this.head, u = 0; c; )
          s(c.data, o, u), u += c.data.length, c = c.next;
        return o;
      }, n;
    }(), i && i.inspect && i.inspect.custom && (d.exports.prototype[i.inspect.custom] = function() {
      var n = i.inspect({ length: this.length });
      return this.constructor.name + " " + n;
    });
  }(na)), na.exports;
}
var vn = Vi;
function Qb(d, e) {
  var t = this, i = this._readableState && this._readableState.destroyed, s = this._writableState && this._writableState.destroyed;
  return i || s ? (e ? e(d) : d && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, vn.nextTick(kn, this, d)) : vn.nextTick(kn, this, d)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(d || null, function(n) {
    !e && n ? t._writableState ? t._writableState.errorEmitted || (t._writableState.errorEmitted = !0, vn.nextTick(kn, t, n)) : vn.nextTick(kn, t, n) : e && e(n);
  }), this);
}
function Jb() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function kn(d, e) {
  d.emit("error", e);
}
var nf = {
  destroy: Qb,
  undestroy: Jb
}, rf = eS;
function eS(d, e) {
  if (ra("noDeprecation"))
    return d;
  var t = !1;
  function i() {
    if (!t) {
      if (ra("throwDeprecation"))
        throw new Error(e);
      ra("traceDeprecation") ? console.trace(e) : console.warn(e), t = !0;
    }
    return d.apply(this, arguments);
  }
  return i;
}
function ra(d) {
  try {
    if (!qe.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var e = qe.localStorage[d];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
var aa, Qd;
function af() {
  if (Qd)
    return aa;
  Qd = 1;
  var d = Vi;
  aa = m;
  function e(E) {
    var N = this;
    this.next = null, this.entry = null, this.finish = function() {
      te(N, E);
    };
  }
  var t = !Ce.browser && ["v0.10", "v0.9."].indexOf(Ce.version.slice(0, 5)) > -1 ? setImmediate : d.nextTick, i;
  m.WritableState = l;
  var s = Object.create(Fe);
  s.inherits = jt;
  var n = {
    deprecate: rf
  }, r = Fu, a = vo.Buffer, o = (typeof qe < "u" ? qe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function c(E) {
    return a.from(E);
  }
  function u(E) {
    return a.isBuffer(E) || E instanceof o;
  }
  var f = nf;
  s.inherits(m, r);
  function h() {
  }
  function l(E, N) {
    i = i || As(), E = E || {};
    var L = N instanceof i;
    this.objectMode = !!E.objectMode, L && (this.objectMode = this.objectMode || !!E.writableObjectMode);
    var z = E.highWaterMark, K = E.writableHighWaterMark, R = this.objectMode ? 16 : 16 * 1024;
    z || z === 0 ? this.highWaterMark = z : L && (K || K === 0) ? this.highWaterMark = K : this.highWaterMark = R, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var U = E.decodeStrings === !1;
    this.decodeStrings = !U, this.defaultEncoding = E.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Y) {
      _(N, Y);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  l.prototype.getBuffer = function() {
    for (var N = this.bufferedRequest, L = []; N; )
      L.push(N), N = N.next;
    return L;
  }, function() {
    try {
      Object.defineProperty(l.prototype, "buffer", {
        get: n.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var p;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(m, Symbol.hasInstance, {
    value: function(E) {
      return p.call(this, E) ? !0 : this !== m ? !1 : E && E._writableState instanceof l;
    }
  })) : p = function(E) {
    return E instanceof this;
  };
  function m(E) {
    if (i = i || As(), !p.call(m, this) && !(this instanceof i))
      return new m(E);
    this._writableState = new l(E, this), this.writable = !0, E && (typeof E.write == "function" && (this._write = E.write), typeof E.writev == "function" && (this._writev = E.writev), typeof E.destroy == "function" && (this._destroy = E.destroy), typeof E.final == "function" && (this._final = E.final)), r.call(this);
  }
  m.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function y(E, N) {
    var L = new Error("write after end");
    E.emit("error", L), d.nextTick(N, L);
  }
  function w(E, N, L, z) {
    var K = !0, R = !1;
    return L === null ? R = new TypeError("May not write null values to stream") : typeof L != "string" && L !== void 0 && !N.objectMode && (R = new TypeError("Invalid non-string/buffer chunk")), R && (E.emit("error", R), d.nextTick(z, R), K = !1), K;
  }
  m.prototype.write = function(E, N, L) {
    var z = this._writableState, K = !1, R = !z.objectMode && u(E);
    return R && !a.isBuffer(E) && (E = c(E)), typeof N == "function" && (L = N, N = null), R ? N = "buffer" : N || (N = z.defaultEncoding), typeof L != "function" && (L = h), z.ended ? y(this, L) : (R || w(this, z, E, L)) && (z.pendingcb++, K = b(this, z, R, E, N, L)), K;
  }, m.prototype.cork = function() {
    var E = this._writableState;
    E.corked++;
  }, m.prototype.uncork = function() {
    var E = this._writableState;
    E.corked && (E.corked--, !E.writing && !E.corked && !E.bufferProcessing && E.bufferedRequest && G(this, E));
  }, m.prototype.setDefaultEncoding = function(N) {
    if (typeof N == "string" && (N = N.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((N + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + N);
    return this._writableState.defaultEncoding = N, this;
  };
  function S(E, N, L) {
    return !E.objectMode && E.decodeStrings !== !1 && typeof N == "string" && (N = a.from(N, L)), N;
  }
  Object.defineProperty(m.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function b(E, N, L, z, K, R) {
    if (!L) {
      var U = S(N, z, K);
      z !== U && (L = !0, K = "buffer", z = U);
    }
    var Y = N.objectMode ? 1 : z.length;
    N.length += Y;
    var J = N.length < N.highWaterMark;
    if (J || (N.needDrain = !0), N.writing || N.corked) {
      var ae = N.lastBufferedRequest;
      N.lastBufferedRequest = {
        chunk: z,
        encoding: K,
        isBuf: L,
        callback: R,
        next: null
      }, ae ? ae.next = N.lastBufferedRequest : N.bufferedRequest = N.lastBufferedRequest, N.bufferedRequestCount += 1;
    } else
      T(E, N, !1, Y, z, K, R);
    return J;
  }
  function T(E, N, L, z, K, R, U) {
    N.writelen = z, N.writecb = U, N.writing = !0, N.sync = !0, L ? E._writev(K, N.onwrite) : E._write(K, R, N.onwrite), N.sync = !1;
  }
  function x(E, N, L, z, K) {
    --N.pendingcb, L ? (d.nextTick(K, z), d.nextTick(se, E, N), E._writableState.errorEmitted = !0, E.emit("error", z)) : (K(z), E._writableState.errorEmitted = !0, E.emit("error", z), se(E, N));
  }
  function v(E) {
    E.writing = !1, E.writecb = null, E.length -= E.writelen, E.writelen = 0;
  }
  function _(E, N) {
    var L = E._writableState, z = L.sync, K = L.writecb;
    if (v(L), N)
      x(E, L, z, N, K);
    else {
      var R = W(L);
      !R && !L.corked && !L.bufferProcessing && L.bufferedRequest && G(E, L), z ? t(V, E, L, R, K) : V(E, L, R, K);
    }
  }
  function V(E, N, L, z) {
    L || j(E, N), N.pendingcb--, z(), se(E, N);
  }
  function j(E, N) {
    N.length === 0 && N.needDrain && (N.needDrain = !1, E.emit("drain"));
  }
  function G(E, N) {
    N.bufferProcessing = !0;
    var L = N.bufferedRequest;
    if (E._writev && L && L.next) {
      var z = N.bufferedRequestCount, K = new Array(z), R = N.corkedRequestsFree;
      R.entry = L;
      for (var U = 0, Y = !0; L; )
        K[U] = L, L.isBuf || (Y = !1), L = L.next, U += 1;
      K.allBuffers = Y, T(E, N, !0, N.length, K, "", R.finish), N.pendingcb++, N.lastBufferedRequest = null, R.next ? (N.corkedRequestsFree = R.next, R.next = null) : N.corkedRequestsFree = new e(N), N.bufferedRequestCount = 0;
    } else {
      for (; L; ) {
        var J = L.chunk, ae = L.encoding, A = L.callback, M = N.objectMode ? 1 : J.length;
        if (T(E, N, !1, M, J, ae, A), L = L.next, N.bufferedRequestCount--, N.writing)
          break;
      }
      L === null && (N.lastBufferedRequest = null);
    }
    N.bufferedRequest = L, N.bufferProcessing = !1;
  }
  m.prototype._write = function(E, N, L) {
    L(new Error("_write() is not implemented"));
  }, m.prototype._writev = null, m.prototype.end = function(E, N, L) {
    var z = this._writableState;
    typeof E == "function" ? (L = E, E = null, N = null) : typeof N == "function" && (L = N, N = null), E != null && this.write(E, N), z.corked && (z.corked = 1, this.uncork()), z.ending || $(this, z, L);
  };
  function W(E) {
    return E.ending && E.length === 0 && E.bufferedRequest === null && !E.finished && !E.writing;
  }
  function B(E, N) {
    E._final(function(L) {
      N.pendingcb--, L && E.emit("error", L), N.prefinished = !0, E.emit("prefinish"), se(E, N);
    });
  }
  function Q(E, N) {
    !N.prefinished && !N.finalCalled && (typeof E._final == "function" ? (N.pendingcb++, N.finalCalled = !0, d.nextTick(B, E, N)) : (N.prefinished = !0, E.emit("prefinish")));
  }
  function se(E, N) {
    var L = W(N);
    return L && (Q(E, N), N.pendingcb === 0 && (N.finished = !0, E.emit("finish"))), L;
  }
  function $(E, N, L) {
    N.ending = !0, se(E, N), L && (N.finished ? d.nextTick(L) : E.once("finish", L)), N.ended = !0, E.writable = !1;
  }
  function te(E, N, L) {
    var z = E.entry;
    for (E.entry = null; z; ) {
      var K = z.callback;
      N.pendingcb--, K(L), z = z.next;
    }
    N.corkedRequestsFree.next = E;
  }
  return Object.defineProperty(m.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(E) {
      this._writableState && (this._writableState.destroyed = E);
    }
  }), m.prototype.destroy = f.destroy, m.prototype._undestroy = f.undestroy, m.prototype._destroy = function(E, N) {
    this.end(), N(E);
  }, aa;
}
var oa, Jd;
function As() {
  if (Jd)
    return oa;
  Jd = 1;
  var d = Vi, e = Object.keys || function(f) {
    var h = [];
    for (var l in f)
      h.push(l);
    return h;
  };
  oa = o;
  var t = Object.create(Fe);
  t.inherits = jt;
  var i = of(), s = af();
  t.inherits(o, i);
  for (var n = e(s.prototype), r = 0; r < n.length; r++) {
    var a = n[r];
    o.prototype[a] || (o.prototype[a] = s.prototype[a]);
  }
  function o(f) {
    if (!(this instanceof o))
      return new o(f);
    i.call(this, f), s.call(this, f), f && f.readable === !1 && (this.readable = !1), f && f.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, f && f.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", c);
  }
  Object.defineProperty(o.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function c() {
    this.allowHalfOpen || this._writableState.ended || d.nextTick(u, this);
  }
  function u(f) {
    f.end();
  }
  return Object.defineProperty(o.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(f) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = f, this._writableState.destroyed = f);
    }
  }), o.prototype._destroy = function(f, h) {
    this.push(null), this.end(), d.nextTick(h, f);
  }, oa;
}
var da = {}, En = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var ec;
function tS() {
  return ec || (ec = 1, function(d, e) {
    var t = nn(), i = t.Buffer;
    function s(r, a) {
      for (var o in r)
        a[o] = r[o];
    }
    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? d.exports = t : (s(t, e), e.Buffer = n);
    function n(r, a, o) {
      return i(r, a, o);
    }
    n.prototype = Object.create(i.prototype), s(i, n), n.from = function(r, a, o) {
      if (typeof r == "number")
        throw new TypeError("Argument must not be a number");
      return i(r, a, o);
    }, n.alloc = function(r, a, o) {
      if (typeof r != "number")
        throw new TypeError("Argument must be a number");
      var c = i(r);
      return a !== void 0 ? typeof o == "string" ? c.fill(a, o) : c.fill(a) : c.fill(0), c;
    }, n.allocUnsafe = function(r) {
      if (typeof r != "number")
        throw new TypeError("Argument must be a number");
      return i(r);
    }, n.allocUnsafeSlow = function(r) {
      if (typeof r != "number")
        throw new TypeError("Argument must be a number");
      return t.SlowBuffer(r);
    };
  }(En, En.exports)), En.exports;
}
var tc;
function sr() {
  if (tc)
    return da;
  tc = 1;
  var d = tS().Buffer, e = d.isEncoding || function(w) {
    switch (w = "" + w, w && w.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function t(w) {
    if (!w)
      return "utf8";
    for (var S; ; )
      switch (w) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return w;
        default:
          if (S)
            return;
          w = ("" + w).toLowerCase(), S = !0;
      }
  }
  function i(w) {
    var S = t(w);
    if (typeof S != "string" && (d.isEncoding === e || !e(w)))
      throw new Error("Unknown encoding: " + w);
    return S || w;
  }
  da.StringDecoder = s;
  function s(w) {
    this.encoding = i(w);
    var S;
    switch (this.encoding) {
      case "utf16le":
        this.text = f, this.end = h, S = 4;
        break;
      case "utf8":
        this.fillLast = o, S = 4;
        break;
      case "base64":
        this.text = l, this.end = p, S = 3;
        break;
      default:
        this.write = m, this.end = y;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = d.allocUnsafe(S);
  }
  s.prototype.write = function(w) {
    if (w.length === 0)
      return "";
    var S, b;
    if (this.lastNeed) {
      if (S = this.fillLast(w), S === void 0)
        return "";
      b = this.lastNeed, this.lastNeed = 0;
    } else
      b = 0;
    return b < w.length ? S ? S + this.text(w, b) : this.text(w, b) : S || "";
  }, s.prototype.end = u, s.prototype.text = c, s.prototype.fillLast = function(w) {
    if (this.lastNeed <= w.length)
      return w.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    w.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, w.length), this.lastNeed -= w.length;
  };
  function n(w) {
    return w <= 127 ? 0 : w >> 5 === 6 ? 2 : w >> 4 === 14 ? 3 : w >> 3 === 30 ? 4 : w >> 6 === 2 ? -1 : -2;
  }
  function r(w, S, b) {
    var T = S.length - 1;
    if (T < b)
      return 0;
    var x = n(S[T]);
    return x >= 0 ? (x > 0 && (w.lastNeed = x - 1), x) : --T < b || x === -2 ? 0 : (x = n(S[T]), x >= 0 ? (x > 0 && (w.lastNeed = x - 2), x) : --T < b || x === -2 ? 0 : (x = n(S[T]), x >= 0 ? (x > 0 && (x === 2 ? x = 0 : w.lastNeed = x - 3), x) : 0));
  }
  function a(w, S, b) {
    if ((S[0] & 192) !== 128)
      return w.lastNeed = 0, "�";
    if (w.lastNeed > 1 && S.length > 1) {
      if ((S[1] & 192) !== 128)
        return w.lastNeed = 1, "�";
      if (w.lastNeed > 2 && S.length > 2 && (S[2] & 192) !== 128)
        return w.lastNeed = 2, "�";
    }
  }
  function o(w) {
    var S = this.lastTotal - this.lastNeed, b = a(this, w);
    if (b !== void 0)
      return b;
    if (this.lastNeed <= w.length)
      return w.copy(this.lastChar, S, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    w.copy(this.lastChar, S, 0, w.length), this.lastNeed -= w.length;
  }
  function c(w, S) {
    var b = r(this, w, S);
    if (!this.lastNeed)
      return w.toString("utf8", S);
    this.lastTotal = b;
    var T = w.length - (b - this.lastNeed);
    return w.copy(this.lastChar, 0, T), w.toString("utf8", S, T);
  }
  function u(w) {
    var S = w && w.length ? this.write(w) : "";
    return this.lastNeed ? S + "�" : S;
  }
  function f(w, S) {
    if ((w.length - S) % 2 === 0) {
      var b = w.toString("utf16le", S);
      if (b) {
        var T = b.charCodeAt(b.length - 1);
        if (T >= 55296 && T <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = w[w.length - 2], this.lastChar[1] = w[w.length - 1], b.slice(0, -1);
      }
      return b;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = w[w.length - 1], w.toString("utf16le", S, w.length - 1);
  }
  function h(w) {
    var S = w && w.length ? this.write(w) : "";
    if (this.lastNeed) {
      var b = this.lastTotal - this.lastNeed;
      return S + this.lastChar.toString("utf16le", 0, b);
    }
    return S;
  }
  function l(w, S) {
    var b = (w.length - S) % 3;
    return b === 0 ? w.toString("base64", S) : (this.lastNeed = 3 - b, this.lastTotal = 3, b === 1 ? this.lastChar[0] = w[w.length - 1] : (this.lastChar[0] = w[w.length - 2], this.lastChar[1] = w[w.length - 1]), w.toString("base64", S, w.length - b));
  }
  function p(w) {
    var S = w && w.length ? this.write(w) : "";
    return this.lastNeed ? S + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : S;
  }
  function m(w) {
    return w.toString(this.encoding);
  }
  function y(w) {
    return w && w.length ? this.write(w) : "";
  }
  return da;
}
var ca, ic;
function of() {
  if (ic)
    return ca;
  ic = 1;
  var d = Vi;
  ca = S;
  var e = Qw, t;
  S.ReadableState = w, vs.EventEmitter;
  var i = function(A, M) {
    return A.listeners(M).length;
  }, s = Fu, n = vo.Buffer, r = (typeof qe < "u" ? qe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function a(A) {
    return n.from(A);
  }
  function o(A) {
    return n.isBuffer(A) || A instanceof r;
  }
  var c = Object.create(Fe);
  c.inherits = jt;
  var u = dn, f = void 0;
  u && u.debuglog ? f = u.debuglog("stream") : f = function() {
  };
  var h = Zb(), l = nf, p;
  c.inherits(S, s);
  var m = ["error", "close", "destroy", "pause", "resume"];
  function y(A, M, q) {
    if (typeof A.prependListener == "function")
      return A.prependListener(M, q);
    !A._events || !A._events[M] ? A.on(M, q) : e(A._events[M]) ? A._events[M].unshift(q) : A._events[M] = [q, A._events[M]];
  }
  function w(A, M) {
    t = t || As(), A = A || {};
    var q = M instanceof t;
    this.objectMode = !!A.objectMode, q && (this.objectMode = this.objectMode || !!A.readableObjectMode);
    var H = A.highWaterMark, le = A.readableHighWaterMark, oe = this.objectMode ? 16 : 16 * 1024;
    H || H === 0 ? this.highWaterMark = H : q && (le || le === 0) ? this.highWaterMark = le : this.highWaterMark = oe, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new h(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = A.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, A.encoding && (p || (p = sr().StringDecoder), this.decoder = new p(A.encoding), this.encoding = A.encoding);
  }
  function S(A) {
    if (t = t || As(), !(this instanceof S))
      return new S(A);
    this._readableState = new w(A, this), this.readable = !0, A && (typeof A.read == "function" && (this._read = A.read), typeof A.destroy == "function" && (this._destroy = A.destroy)), s.call(this);
  }
  Object.defineProperty(S.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(A) {
      this._readableState && (this._readableState.destroyed = A);
    }
  }), S.prototype.destroy = l.destroy, S.prototype._undestroy = l.undestroy, S.prototype._destroy = function(A, M) {
    this.push(null), M(A);
  }, S.prototype.push = function(A, M) {
    var q = this._readableState, H;
    return q.objectMode ? H = !0 : typeof A == "string" && (M = M || q.defaultEncoding, M !== q.encoding && (A = n.from(A, M), M = ""), H = !0), b(this, A, M, !1, H);
  }, S.prototype.unshift = function(A) {
    return b(this, A, null, !0, !1);
  };
  function b(A, M, q, H, le) {
    var oe = A._readableState;
    if (M === null)
      oe.reading = !1, G(A, oe);
    else {
      var he;
      le || (he = x(oe, M)), he ? A.emit("error", he) : oe.objectMode || M && M.length > 0 ? (typeof M != "string" && !oe.objectMode && Object.getPrototypeOf(M) !== n.prototype && (M = a(M)), H ? oe.endEmitted ? A.emit("error", new Error("stream.unshift() after end event")) : T(A, oe, M, !0) : oe.ended ? A.emit("error", new Error("stream.push() after EOF")) : (oe.reading = !1, oe.decoder && !q ? (M = oe.decoder.write(M), oe.objectMode || M.length !== 0 ? T(A, oe, M, !1) : Q(A, oe)) : T(A, oe, M, !1))) : H || (oe.reading = !1);
    }
    return v(oe);
  }
  function T(A, M, q, H) {
    M.flowing && M.length === 0 && !M.sync ? (A.emit("data", q), A.read(0)) : (M.length += M.objectMode ? 1 : q.length, H ? M.buffer.unshift(q) : M.buffer.push(q), M.needReadable && W(A)), Q(A, M);
  }
  function x(A, M) {
    var q;
    return !o(M) && typeof M != "string" && M !== void 0 && !A.objectMode && (q = new TypeError("Invalid non-string/buffer chunk")), q;
  }
  function v(A) {
    return !A.ended && (A.needReadable || A.length < A.highWaterMark || A.length === 0);
  }
  S.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, S.prototype.setEncoding = function(A) {
    return p || (p = sr().StringDecoder), this._readableState.decoder = new p(A), this._readableState.encoding = A, this;
  };
  var _ = 8388608;
  function V(A) {
    return A >= _ ? A = _ : (A--, A |= A >>> 1, A |= A >>> 2, A |= A >>> 4, A |= A >>> 8, A |= A >>> 16, A++), A;
  }
  function j(A, M) {
    return A <= 0 || M.length === 0 && M.ended ? 0 : M.objectMode ? 1 : A !== A ? M.flowing && M.length ? M.buffer.head.data.length : M.length : (A > M.highWaterMark && (M.highWaterMark = V(A)), A <= M.length ? A : M.ended ? M.length : (M.needReadable = !0, 0));
  }
  S.prototype.read = function(A) {
    f("read", A), A = parseInt(A, 10);
    var M = this._readableState, q = A;
    if (A !== 0 && (M.emittedReadable = !1), A === 0 && M.needReadable && (M.length >= M.highWaterMark || M.ended))
      return f("read: emitReadable", M.length, M.ended), M.length === 0 && M.ended ? Y(this) : W(this), null;
    if (A = j(A, M), A === 0 && M.ended)
      return M.length === 0 && Y(this), null;
    var H = M.needReadable;
    f("need readable", H), (M.length === 0 || M.length - A < M.highWaterMark) && (H = !0, f("length less than watermark", H)), M.ended || M.reading ? (H = !1, f("reading or ended", H)) : H && (f("do read"), M.reading = !0, M.sync = !0, M.length === 0 && (M.needReadable = !0), this._read(M.highWaterMark), M.sync = !1, M.reading || (A = j(q, M)));
    var le;
    return A > 0 ? le = z(A, M) : le = null, le === null ? (M.needReadable = !0, A = 0) : M.length -= A, M.length === 0 && (M.ended || (M.needReadable = !0), q !== A && M.ended && Y(this)), le !== null && this.emit("data", le), le;
  };
  function G(A, M) {
    if (!M.ended) {
      if (M.decoder) {
        var q = M.decoder.end();
        q && q.length && (M.buffer.push(q), M.length += M.objectMode ? 1 : q.length);
      }
      M.ended = !0, W(A);
    }
  }
  function W(A) {
    var M = A._readableState;
    M.needReadable = !1, M.emittedReadable || (f("emitReadable", M.flowing), M.emittedReadable = !0, M.sync ? d.nextTick(B, A) : B(A));
  }
  function B(A) {
    f("emit readable"), A.emit("readable"), L(A);
  }
  function Q(A, M) {
    M.readingMore || (M.readingMore = !0, d.nextTick(se, A, M));
  }
  function se(A, M) {
    for (var q = M.length; !M.reading && !M.flowing && !M.ended && M.length < M.highWaterMark && (f("maybeReadMore read 0"), A.read(0), q !== M.length); )
      q = M.length;
    M.readingMore = !1;
  }
  S.prototype._read = function(A) {
    this.emit("error", new Error("_read() is not implemented"));
  }, S.prototype.pipe = function(A, M) {
    var q = this, H = this._readableState;
    switch (H.pipesCount) {
      case 0:
        H.pipes = A;
        break;
      case 1:
        H.pipes = [H.pipes, A];
        break;
      default:
        H.pipes.push(A);
        break;
    }
    H.pipesCount += 1, f("pipe count=%d opts=%j", H.pipesCount, M);
    var le = (!M || M.end !== !1) && A !== Ce.stdout && A !== Ce.stderr, oe = le ? Ie : De;
    H.endEmitted ? d.nextTick(oe) : q.once("end", oe), A.on("unpipe", he);
    function he(Je, nt) {
      f("onunpipe"), Je === q && nt && nt.hasUnpiped === !1 && (nt.hasUnpiped = !0, bt());
    }
    function Ie() {
      f("onend"), A.end();
    }
    var Pe = $(q);
    A.on("drain", Pe);
    var He = !1;
    function bt() {
      f("cleanup"), A.removeListener("close", Ot), A.removeListener("finish", Le), A.removeListener("drain", Pe), A.removeListener("error", Tt), A.removeListener("unpipe", he), q.removeListener("end", Ie), q.removeListener("end", De), q.removeListener("data", ue), He = !0, H.awaitDrain && (!A._writableState || A._writableState.needDrain) && Pe();
    }
    var mt = !1;
    q.on("data", ue);
    function ue(Je) {
      f("ondata"), mt = !1;
      var nt = A.write(Je);
      nt === !1 && !mt && ((H.pipesCount === 1 && H.pipes === A || H.pipesCount > 1 && ae(H.pipes, A) !== -1) && !He && (f("false write response, pause", H.awaitDrain), H.awaitDrain++, mt = !0), q.pause());
    }
    function Tt(Je) {
      f("onerror", Je), De(), A.removeListener("error", Tt), i(A, "error") === 0 && A.emit("error", Je);
    }
    y(A, "error", Tt);
    function Ot() {
      A.removeListener("finish", Le), De();
    }
    A.once("close", Ot);
    function Le() {
      f("onfinish"), A.removeListener("close", Ot), De();
    }
    A.once("finish", Le);
    function De() {
      f("unpipe"), q.unpipe(A);
    }
    return A.emit("pipe", q), H.flowing || (f("pipe resume"), q.resume()), A;
  };
  function $(A) {
    return function() {
      var M = A._readableState;
      f("pipeOnDrain", M.awaitDrain), M.awaitDrain && M.awaitDrain--, M.awaitDrain === 0 && i(A, "data") && (M.flowing = !0, L(A));
    };
  }
  S.prototype.unpipe = function(A) {
    var M = this._readableState, q = { hasUnpiped: !1 };
    if (M.pipesCount === 0)
      return this;
    if (M.pipesCount === 1)
      return A && A !== M.pipes ? this : (A || (A = M.pipes), M.pipes = null, M.pipesCount = 0, M.flowing = !1, A && A.emit("unpipe", this, q), this);
    if (!A) {
      var H = M.pipes, le = M.pipesCount;
      M.pipes = null, M.pipesCount = 0, M.flowing = !1;
      for (var oe = 0; oe < le; oe++)
        H[oe].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var he = ae(M.pipes, A);
    return he === -1 ? this : (M.pipes.splice(he, 1), M.pipesCount -= 1, M.pipesCount === 1 && (M.pipes = M.pipes[0]), A.emit("unpipe", this, q), this);
  }, S.prototype.on = function(A, M) {
    var q = s.prototype.on.call(this, A, M);
    if (A === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (A === "readable") {
      var H = this._readableState;
      !H.endEmitted && !H.readableListening && (H.readableListening = H.needReadable = !0, H.emittedReadable = !1, H.reading ? H.length && W(this) : d.nextTick(te, this));
    }
    return q;
  }, S.prototype.addListener = S.prototype.on;
  function te(A) {
    f("readable nexttick read 0"), A.read(0);
  }
  S.prototype.resume = function() {
    var A = this._readableState;
    return A.flowing || (f("resume"), A.flowing = !0, E(this, A)), this;
  };
  function E(A, M) {
    M.resumeScheduled || (M.resumeScheduled = !0, d.nextTick(N, A, M));
  }
  function N(A, M) {
    M.reading || (f("resume read 0"), A.read(0)), M.resumeScheduled = !1, M.awaitDrain = 0, A.emit("resume"), L(A), M.flowing && !M.reading && A.read(0);
  }
  S.prototype.pause = function() {
    return f("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (f("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function L(A) {
    var M = A._readableState;
    for (f("flow", M.flowing); M.flowing && A.read() !== null; )
      ;
  }
  S.prototype.wrap = function(A) {
    var M = this, q = this._readableState, H = !1;
    A.on("end", function() {
      if (f("wrapped end"), q.decoder && !q.ended) {
        var he = q.decoder.end();
        he && he.length && M.push(he);
      }
      M.push(null);
    }), A.on("data", function(he) {
      if (f("wrapped data"), q.decoder && (he = q.decoder.write(he)), !(q.objectMode && he == null) && !(!q.objectMode && (!he || !he.length))) {
        var Ie = M.push(he);
        Ie || (H = !0, A.pause());
      }
    });
    for (var le in A)
      this[le] === void 0 && typeof A[le] == "function" && (this[le] = function(he) {
        return function() {
          return A[he].apply(A, arguments);
        };
      }(le));
    for (var oe = 0; oe < m.length; oe++)
      A.on(m[oe], this.emit.bind(this, m[oe]));
    return this._read = function(he) {
      f("wrapped _read", he), H && (H = !1, A.resume());
    }, this;
  }, Object.defineProperty(S.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), S._fromList = z;
  function z(A, M) {
    if (M.length === 0)
      return null;
    var q;
    return M.objectMode ? q = M.buffer.shift() : !A || A >= M.length ? (M.decoder ? q = M.buffer.join("") : M.buffer.length === 1 ? q = M.buffer.head.data : q = M.buffer.concat(M.length), M.buffer.clear()) : q = K(A, M.buffer, M.decoder), q;
  }
  function K(A, M, q) {
    var H;
    return A < M.head.data.length ? (H = M.head.data.slice(0, A), M.head.data = M.head.data.slice(A)) : A === M.head.data.length ? H = M.shift() : H = q ? R(A, M) : U(A, M), H;
  }
  function R(A, M) {
    var q = M.head, H = 1, le = q.data;
    for (A -= le.length; q = q.next; ) {
      var oe = q.data, he = A > oe.length ? oe.length : A;
      if (he === oe.length ? le += oe : le += oe.slice(0, A), A -= he, A === 0) {
        he === oe.length ? (++H, q.next ? M.head = q.next : M.head = M.tail = null) : (M.head = q, q.data = oe.slice(he));
        break;
      }
      ++H;
    }
    return M.length -= H, le;
  }
  function U(A, M) {
    var q = n.allocUnsafe(A), H = M.head, le = 1;
    for (H.data.copy(q), A -= H.data.length; H = H.next; ) {
      var oe = H.data, he = A > oe.length ? oe.length : A;
      if (oe.copy(q, q.length - A, 0, he), A -= he, A === 0) {
        he === oe.length ? (++le, H.next ? M.head = H.next : M.head = M.tail = null) : (M.head = H, H.data = oe.slice(he));
        break;
      }
      ++le;
    }
    return M.length -= le, q;
  }
  function Y(A) {
    var M = A._readableState;
    if (M.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    M.endEmitted || (M.ended = !0, d.nextTick(J, M, A));
  }
  function J(A, M) {
    !A.endEmitted && A.length === 0 && (A.endEmitted = !0, M.readable = !1, M.emit("end"));
  }
  function ae(A, M) {
    for (var q = 0, H = A.length; q < H; q++)
      if (A[q] === M)
        return q;
    return -1;
  }
  return ca;
}
var df = oi, Mr = As(), cf = Object.create(Fe);
cf.inherits = jt;
cf.inherits(oi, Mr);
function iS(d, e) {
  var t = this._transformState;
  t.transforming = !1;
  var i = t.writecb;
  if (!i)
    return this.emit("error", new Error("write callback called multiple times"));
  t.writechunk = null, t.writecb = null, e != null && this.push(e), i(d);
  var s = this._readableState;
  s.reading = !1, (s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark);
}
function oi(d) {
  if (!(this instanceof oi))
    return new oi(d);
  Mr.call(this, d), this._transformState = {
    afterTransform: iS.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, d && (typeof d.transform == "function" && (this._transform = d.transform), typeof d.flush == "function" && (this._flush = d.flush)), this.on("prefinish", sS);
}
function sS() {
  var d = this;
  typeof this._flush == "function" ? this._flush(function(e, t) {
    sc(d, e, t);
  }) : sc(this, null, null);
}
oi.prototype.push = function(d, e) {
  return this._transformState.needTransform = !1, Mr.prototype.push.call(this, d, e);
};
oi.prototype._transform = function(d, e, t) {
  throw new Error("_transform() is not implemented");
};
oi.prototype._write = function(d, e, t) {
  var i = this._transformState;
  if (i.writecb = t, i.writechunk = d, i.writeencoding = e, !i.transforming) {
    var s = this._readableState;
    (i.needTransform || s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark);
  }
};
oi.prototype._read = function(d) {
  var e = this._transformState;
  e.writechunk !== null && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
oi.prototype._destroy = function(d, e) {
  var t = this;
  Mr.prototype._destroy.call(this, d, function(i) {
    e(i), t.emit("close");
  });
};
function sc(d, e, t) {
  if (e)
    return d.emit("error", e);
  if (t != null && d.push(t), d._writableState.length)
    throw new Error("Calling transform done when ws.length != 0");
  if (d._transformState.transforming)
    throw new Error("Calling transform done when still transforming");
  return d.push(null);
}
var nS = Js, uf = df, ff = Object.create(Fe);
ff.inherits = jt;
ff.inherits(Js, uf);
function Js(d) {
  if (!(this instanceof Js))
    return new Js(d);
  uf.call(this, d);
}
Js.prototype._transform = function(d, e, t) {
  t(null, d);
};
(function(d, e) {
  e = d.exports = of(), e.Stream = e, e.Readable = e, e.Writable = af(), e.Duplex = As(), e.Transform = df, e.PassThrough = nS;
})(Pa, Pa.exports);
var hf = Pa.exports, Do = { exports: {} }, rS = lf;
function lf(d, e) {
  if (d && e)
    return lf(d)(e);
  if (typeof d != "function")
    throw new TypeError("need wrapper function");
  return Object.keys(d).forEach(function(i) {
    t[i] = d[i];
  }), t;
  function t() {
    for (var i = new Array(arguments.length), s = 0; s < i.length; s++)
      i[s] = arguments[s];
    var n = d.apply(this, i), r = i[i.length - 1];
    return typeof n == "function" && n !== r && Object.keys(r).forEach(function(a) {
      n[a] = r[a];
    }), n;
  }
}
var pf = rS;
Do.exports = pf(Un);
Do.exports.strict = pf(gf);
Un.proto = Un(function() {
  Object.defineProperty(Function.prototype, "once", {
    value: function() {
      return Un(this);
    },
    configurable: !0
  }), Object.defineProperty(Function.prototype, "onceStrict", {
    value: function() {
      return gf(this);
    },
    configurable: !0
  });
});
function Un(d) {
  var e = function() {
    return e.called ? e.value : (e.called = !0, e.value = d.apply(this, arguments));
  };
  return e.called = !1, e;
}
function gf(d) {
  var e = function() {
    if (e.called)
      throw new Error(e.onceError);
    return e.called = !0, e.value = d.apply(this, arguments);
  }, t = d.name || "Function wrapped with `once`";
  return e.onceError = t + " shouldn't be called more than once", e.called = !1, e;
}
var mf = Do.exports, aS = mf, oS = function() {
}, dS = function(d) {
  return d.setHeader && typeof d.abort == "function";
}, cS = function(d) {
  return d.stdio && Array.isArray(d.stdio) && d.stdio.length === 3;
}, yf = function(d, e, t) {
  if (typeof e == "function")
    return yf(d, null, e);
  e || (e = {}), t = aS(t || oS);
  var i = d._writableState, s = d._readableState, n = e.readable || e.readable !== !1 && d.readable, r = e.writable || e.writable !== !1 && d.writable, a = !1, o = function() {
    d.writable || c();
  }, c = function() {
    r = !1, n || t.call(d);
  }, u = function() {
    n = !1, r || t.call(d);
  }, f = function(y) {
    t.call(d, y ? new Error("exited with error code: " + y) : null);
  }, h = function(y) {
    t.call(d, y);
  }, l = function() {
    Ce.nextTick(p);
  }, p = function() {
    if (!a) {
      if (n && !(s && s.ended && !s.destroyed))
        return t.call(d, new Error("premature close"));
      if (r && !(i && i.ended && !i.destroyed))
        return t.call(d, new Error("premature close"));
    }
  }, m = function() {
    d.req.on("finish", c);
  };
  return dS(d) ? (d.on("complete", c), d.on("abort", l), d.req ? m() : d.on("request", m)) : r && !i && (d.on("end", o), d.on("close", o)), cS(d) && d.on("exit", f), d.on("end", u), d.on("finish", c), e.error !== !1 && d.on("error", h), d.on("close", l), function() {
    a = !0, d.removeListener("complete", c), d.removeListener("abort", l), d.removeListener("request", m), d.req && d.req.removeListener("finish", c), d.removeListener("end", o), d.removeListener("close", o), d.removeListener("finish", c), d.removeListener("exit", f), d.removeListener("end", u), d.removeListener("error", h), d.removeListener("close", l);
  };
}, uS = yf, Cr = {};
Object.defineProperty(Cr, "__esModule", { value: !0 });
Cr.Substream = void 0;
const fS = hf;
class hS extends fS.Duplex {
  constructor({ parent: e, name: t }) {
    super({ objectMode: !0 }), this._parent = e, this._name = t;
  }
  /**
   * Explicitly sets read operations to a no-op.
   */
  _read() {
  }
  /**
   * Called when data should be written to this writable stream.
   *
   * @param chunk - Arbitrary object to write
   * @param encoding - Encoding to use when writing payload
   * @param callback - Called when writing is complete or an error occurs
   */
  _write(e, t, i) {
    this._parent.push({
      name: this._name,
      data: e
    }), i();
  }
}
Cr.Substream = hS;
var wf = qe && qe.__importDefault || function(d) {
  return d && d.__esModule ? d : { default: d };
};
Object.defineProperty(Sr, "__esModule", { value: !0 });
Sr.ObjectMultiplex = void 0;
const lS = hf, nc = wf(uS), pS = wf(mf), gS = Cr, rc = Symbol("IGNORE_SUBSTREAM");
class mS extends lS.Duplex {
  constructor(e = {}) {
    super(Object.assign(Object.assign({}, e), { objectMode: !0 })), this._substreams = {};
  }
  createStream(e) {
    if (this.destroyed)
      throw new Error(`ObjectMultiplex - parent stream for name "${e}" already destroyed`);
    if (this._readableState.ended || this._writableState.ended)
      throw new Error(`ObjectMultiplex - parent stream for name "${e}" already ended`);
    if (!e)
      throw new Error("ObjectMultiplex - name must not be empty");
    if (this._substreams[e])
      throw new Error(`ObjectMultiplex - Substream for name "${e}" already exists`);
    const t = new gS.Substream({ parent: this, name: e });
    return this._substreams[e] = t, yS(this, (i) => t.destroy(i || void 0)), t;
  }
  // ignore streams (dont display orphaned data warning)
  ignoreStream(e) {
    if (!e)
      throw new Error("ObjectMultiplex - name must not be empty");
    if (this._substreams[e])
      throw new Error(`ObjectMultiplex - Substream for name "${e}" already exists`);
    this._substreams[e] = rc;
  }
  _read() {
  }
  _write(e, t, i) {
    const { name: s, data: n } = e;
    if (!s)
      return console.warn(`ObjectMultiplex - malformed chunk without name "${e}"`), i();
    const r = this._substreams[s];
    return r ? (r !== rc && r.push(n), i()) : (console.warn(`ObjectMultiplex - orphaned data for stream "${s}"`), i());
  }
}
Sr.ObjectMultiplex = mS;
function yS(d, e) {
  const t = pS.default(e);
  nc.default(d, { readable: !1 }, t), nc.default(d, { writable: !1 }, t);
}
const wS = Sr;
wS.ObjectMultiplex;
var bf = {};
Object.defineProperty(bf, "__esModule", { value: !0 });
const bS = {
  errors: {
    disconnected: () => "MetaMask: Disconnected from chain. Attempting to connect.",
    permanentlyDisconnected: () => "MetaMask: Disconnected from MetaMask background. Page reload required.",
    sendSiteMetadata: () => "MetaMask: Failed to send site metadata. This is an internal error, please report this bug.",
    unsupportedSync: (d) => `MetaMask: The MetaMask Ethereum provider does not support synchronous methods like ${d} without a callback parameter.`,
    invalidDuplexStream: () => "Must provide a Node.js-style duplex stream.",
    invalidRequestArgs: () => "Expected a single, non-array, object argument.",
    invalidRequestMethod: () => "'args.method' must be a non-empty string.",
    invalidRequestParams: () => "'args.params' must be an object or array if provided.",
    invalidLoggerObject: () => "'args.logger' must be an object if provided.",
    invalidLoggerMethod: (d) => `'args.logger' must include required method '${d}'.`
  },
  info: {
    connected: (d) => `MetaMask: Connected to chain with ID "${d}".`
  },
  warnings: {
    // deprecated methods
    enableDeprecation: `MetaMask: 'ethereum.enable()' is deprecated and may be removed in the future. Please use the 'eth_requestAccounts' RPC method instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1102`,
    sendDeprecation: `MetaMask: 'ethereum.send(...)' is deprecated and may be removed in the future. Please use 'ethereum.sendAsync(...)' or 'ethereum.request(...)' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193`,
    // deprecated events
    events: {
      close: `MetaMask: The event 'close' is deprecated and may be removed in the future. Please use 'disconnect' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#disconnect`,
      data: `MetaMask: The event 'data' is deprecated and will be removed in the future. Use 'message' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#message`,
      networkChanged: `MetaMask: The event 'networkChanged' is deprecated and may be removed in the future. Use 'chainChanged' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#chainchanged`,
      notification: `MetaMask: The event 'notification' is deprecated and may be removed in the future. Use 'message' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#message`
    },
    // misc
    experimentalMethods: "MetaMask: 'ethereum._metamask' exposes non-standard, experimental methods. They may be removed or changed without warning."
  }
};
bf.default = bS;
var Bt = {}, Ro = {}, Ni = {}, SS = en;
en.default = en;
en.stable = Af;
en.stableStringify = Af;
var nr = "[...]", Sf = "[Circular]", Xi = [], Wi = [];
function Tf() {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  };
}
function en(d, e, t, i) {
  typeof i > "u" && (i = Tf()), qa(d, "", 0, [], void 0, 0, i);
  var s;
  try {
    Wi.length === 0 ? s = JSON.stringify(d, e, t) : s = JSON.stringify(d, If(e), t);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; Xi.length !== 0; ) {
      var n = Xi.pop();
      n.length === 4 ? Object.defineProperty(n[0], n[1], n[3]) : n[0][n[1]] = n[2];
    }
  }
  return s;
}
function gs(d, e, t, i) {
  var s = Object.getOwnPropertyDescriptor(i, t);
  s.get !== void 0 ? s.configurable ? (Object.defineProperty(i, t, { value: d }), Xi.push([i, t, e, s])) : Wi.push([e, t, d]) : (i[t] = d, Xi.push([i, t, e]));
}
function qa(d, e, t, i, s, n, r) {
  n += 1;
  var a;
  if (typeof d == "object" && d !== null) {
    for (a = 0; a < i.length; a++)
      if (i[a] === d) {
        gs(Sf, d, e, s);
        return;
      }
    if (typeof r.depthLimit < "u" && n > r.depthLimit) {
      gs(nr, d, e, s);
      return;
    }
    if (typeof r.edgesLimit < "u" && t + 1 > r.edgesLimit) {
      gs(nr, d, e, s);
      return;
    }
    if (i.push(d), Array.isArray(d))
      for (a = 0; a < d.length; a++)
        qa(d[a], a, a, i, d, n, r);
    else {
      var o = Object.keys(d);
      for (a = 0; a < o.length; a++) {
        var c = o[a];
        qa(d[c], c, a, i, d, n, r);
      }
    }
    i.pop();
  }
}
function TS(d, e) {
  return d < e ? -1 : d > e ? 1 : 0;
}
function Af(d, e, t, i) {
  typeof i > "u" && (i = Tf());
  var s = Ga(d, "", 0, [], void 0, 0, i) || d, n;
  try {
    Wi.length === 0 ? n = JSON.stringify(s, e, t) : n = JSON.stringify(s, If(e), t);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; Xi.length !== 0; ) {
      var r = Xi.pop();
      r.length === 4 ? Object.defineProperty(r[0], r[1], r[3]) : r[0][r[1]] = r[2];
    }
  }
  return n;
}
function Ga(d, e, t, i, s, n, r) {
  n += 1;
  var a;
  if (typeof d == "object" && d !== null) {
    for (a = 0; a < i.length; a++)
      if (i[a] === d) {
        gs(Sf, d, e, s);
        return;
      }
    try {
      if (typeof d.toJSON == "function")
        return;
    } catch {
      return;
    }
    if (typeof r.depthLimit < "u" && n > r.depthLimit) {
      gs(nr, d, e, s);
      return;
    }
    if (typeof r.edgesLimit < "u" && t + 1 > r.edgesLimit) {
      gs(nr, d, e, s);
      return;
    }
    if (i.push(d), Array.isArray(d))
      for (a = 0; a < d.length; a++)
        Ga(d[a], a, a, i, d, n, r);
    else {
      var o = {}, c = Object.keys(d).sort(TS);
      for (a = 0; a < c.length; a++) {
        var u = c[a];
        Ga(d[u], u, a, i, d, n, r), o[u] = d[u];
      }
      if (typeof s < "u")
        Xi.push([s, e, d]), s[e] = o;
      else
        return o;
    }
    i.pop();
  }
}
function If(d) {
  return d = typeof d < "u" ? d : function(e, t) {
    return t;
  }, function(e, t) {
    if (Wi.length > 0)
      for (var i = 0; i < Wi.length; i++) {
        var s = Wi[i];
        if (s[1] === e && s[0] === t) {
          t = s[2], Wi.splice(i, 1);
          break;
        }
      }
    return d.call(this, e, t);
  };
}
Object.defineProperty(Ni, "__esModule", { value: !0 });
Ni.EthereumProviderError = Ni.EthereumRpcError = void 0;
const AS = SS;
class Of extends Error {
  constructor(e, t, i) {
    if (!Number.isInteger(e))
      throw new Error('"code" must be an integer.');
    if (!t || typeof t != "string")
      throw new Error('"message" must be a nonempty string.');
    super(t), this.code = e, i !== void 0 && (this.data = i);
  }
  /**
   * Returns a plain object with all public class properties.
   */
  serialize() {
    const e = {
      code: this.code,
      message: this.message
    };
    return this.data !== void 0 && (e.data = this.data), this.stack && (e.stack = this.stack), e;
  }
  /**
   * Return a string representation of the serialized error, omitting
   * any circular references.
   */
  toString() {
    return AS.default(this.serialize(), MS, 2);
  }
}
Ni.EthereumRpcError = Of;
class IS extends Of {
  /**
   * Create an Ethereum Provider JSON-RPC error.
   * `code` must be an integer in the 1000 <= 4999 range.
   */
  constructor(e, t, i) {
    if (!OS(e))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(e, t, i);
  }
}
Ni.EthereumProviderError = IS;
function OS(d) {
  return Number.isInteger(d) && d >= 1e3 && d <= 4999;
}
function MS(d, e) {
  if (e !== "[Circular]")
    return e;
}
var Bo = {}, Pi = {};
Object.defineProperty(Pi, "__esModule", { value: !0 });
Pi.errorValues = Pi.errorCodes = void 0;
Pi.errorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};
Pi.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  }
};
(function(d) {
  Object.defineProperty(d, "__esModule", { value: !0 }), d.serializeError = d.isValidCode = d.getMessageFromCode = d.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const e = Pi, t = Ni, i = e.errorCodes.rpc.internal, s = "Unspecified error message. This is a bug, please report it.", n = {
    code: i,
    message: r(i)
  };
  d.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function r(h, l = s) {
    if (Number.isInteger(h)) {
      const p = h.toString();
      if (f(e.errorValues, p))
        return e.errorValues[p].message;
      if (c(h))
        return d.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return l;
  }
  d.getMessageFromCode = r;
  function a(h) {
    if (!Number.isInteger(h))
      return !1;
    const l = h.toString();
    return !!(e.errorValues[l] || c(h));
  }
  d.isValidCode = a;
  function o(h, { fallbackError: l = n, shouldIncludeStack: p = !1 } = {}) {
    var m, y;
    if (!l || !Number.isInteger(l.code) || typeof l.message != "string")
      throw new Error("Must provide fallback error with integer number code and string message.");
    if (h instanceof t.EthereumRpcError)
      return h.serialize();
    const w = {};
    if (h && typeof h == "object" && !Array.isArray(h) && f(h, "code") && a(h.code)) {
      const b = h;
      w.code = b.code, b.message && typeof b.message == "string" ? (w.message = b.message, f(b, "data") && (w.data = b.data)) : (w.message = r(w.code), w.data = { originalError: u(h) });
    } else {
      w.code = l.code;
      const b = (m = h) === null || m === void 0 ? void 0 : m.message;
      w.message = b && typeof b == "string" ? b : l.message, w.data = { originalError: u(h) };
    }
    const S = (y = h) === null || y === void 0 ? void 0 : y.stack;
    return p && h && S && typeof S == "string" && (w.stack = S), w;
  }
  d.serializeError = o;
  function c(h) {
    return h >= -32099 && h <= -32e3;
  }
  function u(h) {
    return h && typeof h == "object" && !Array.isArray(h) ? Object.assign({}, h) : h;
  }
  function f(h, l) {
    return Object.prototype.hasOwnProperty.call(h, l);
  }
})(Bo);
var xr = {};
Object.defineProperty(xr, "__esModule", { value: !0 });
xr.ethErrors = void 0;
const Vo = Ni, Mf = Bo, ht = Pi;
xr.ethErrors = {
  rpc: {
    /**
     * Get a JSON RPC 2.0 Parse (-32700) error.
     */
    parse: (d) => Ct(ht.errorCodes.rpc.parse, d),
    /**
     * Get a JSON RPC 2.0 Invalid Request (-32600) error.
     */
    invalidRequest: (d) => Ct(ht.errorCodes.rpc.invalidRequest, d),
    /**
     * Get a JSON RPC 2.0 Invalid Params (-32602) error.
     */
    invalidParams: (d) => Ct(ht.errorCodes.rpc.invalidParams, d),
    /**
     * Get a JSON RPC 2.0 Method Not Found (-32601) error.
     */
    methodNotFound: (d) => Ct(ht.errorCodes.rpc.methodNotFound, d),
    /**
     * Get a JSON RPC 2.0 Internal (-32603) error.
     */
    internal: (d) => Ct(ht.errorCodes.rpc.internal, d),
    /**
     * Get a JSON RPC 2.0 Server error.
     * Permits integer error codes in the [ -32099 <= -32005 ] range.
     * Codes -32000 through -32004 are reserved by EIP-1474.
     */
    server: (d) => {
      if (!d || typeof d != "object" || Array.isArray(d))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: e } = d;
      if (!Number.isInteger(e) || e > -32005 || e < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return Ct(e, d);
    },
    /**
     * Get an Ethereum JSON RPC Invalid Input (-32000) error.
     */
    invalidInput: (d) => Ct(ht.errorCodes.rpc.invalidInput, d),
    /**
     * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
     */
    resourceNotFound: (d) => Ct(ht.errorCodes.rpc.resourceNotFound, d),
    /**
     * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
     */
    resourceUnavailable: (d) => Ct(ht.errorCodes.rpc.resourceUnavailable, d),
    /**
     * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
     */
    transactionRejected: (d) => Ct(ht.errorCodes.rpc.transactionRejected, d),
    /**
     * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
     */
    methodNotSupported: (d) => Ct(ht.errorCodes.rpc.methodNotSupported, d),
    /**
     * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
     */
    limitExceeded: (d) => Ct(ht.errorCodes.rpc.limitExceeded, d)
  },
  provider: {
    /**
     * Get an Ethereum Provider User Rejected Request (4001) error.
     */
    userRejectedRequest: (d) => js(ht.errorCodes.provider.userRejectedRequest, d),
    /**
     * Get an Ethereum Provider Unauthorized (4100) error.
     */
    unauthorized: (d) => js(ht.errorCodes.provider.unauthorized, d),
    /**
     * Get an Ethereum Provider Unsupported Method (4200) error.
     */
    unsupportedMethod: (d) => js(ht.errorCodes.provider.unsupportedMethod, d),
    /**
     * Get an Ethereum Provider Not Connected (4900) error.
     */
    disconnected: (d) => js(ht.errorCodes.provider.disconnected, d),
    /**
     * Get an Ethereum Provider Chain Not Connected (4901) error.
     */
    chainDisconnected: (d) => js(ht.errorCodes.provider.chainDisconnected, d),
    /**
     * Get a custom Ethereum Provider error.
     */
    custom: (d) => {
      if (!d || typeof d != "object" || Array.isArray(d))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: e, message: t, data: i } = d;
      if (!t || typeof t != "string")
        throw new Error('"message" must be a nonempty string');
      return new Vo.EthereumProviderError(e, t, i);
    }
  }
};
function Ct(d, e) {
  const [t, i] = Cf(e);
  return new Vo.EthereumRpcError(d, t || Mf.getMessageFromCode(d), i);
}
function js(d, e) {
  const [t, i] = Cf(e);
  return new Vo.EthereumProviderError(d, t || Mf.getMessageFromCode(d), i);
}
function Cf(d) {
  if (d) {
    if (typeof d == "string")
      return [d];
    if (typeof d == "object" && !Array.isArray(d)) {
      const { message: e, data: t } = d;
      if (e && typeof e != "string")
        throw new Error("Must specify string message.");
      return [e || void 0, t];
    }
  }
  return [];
}
(function(d) {
  Object.defineProperty(d, "__esModule", { value: !0 }), d.getMessageFromCode = d.serializeError = d.EthereumProviderError = d.EthereumRpcError = d.ethErrors = d.errorCodes = void 0;
  const e = Ni;
  Object.defineProperty(d, "EthereumRpcError", { enumerable: !0, get: function() {
    return e.EthereumRpcError;
  } }), Object.defineProperty(d, "EthereumProviderError", { enumerable: !0, get: function() {
    return e.EthereumProviderError;
  } });
  const t = Bo;
  Object.defineProperty(d, "serializeError", { enumerable: !0, get: function() {
    return t.serializeError;
  } }), Object.defineProperty(d, "getMessageFromCode", { enumerable: !0, get: function() {
    return t.getMessageFromCode;
  } });
  const i = xr;
  Object.defineProperty(d, "ethErrors", { enumerable: !0, get: function() {
    return i.ethErrors;
  } });
  const s = Pi;
  Object.defineProperty(d, "errorCodes", { enumerable: !0, get: function() {
    return s.errorCodes;
  } });
})(Ro);
Object.defineProperty(Bt, "__esModule", { value: !0 });
Bt.EMITTED_NOTIFICATIONS = Bt.NOOP = Bt.logStreamDisconnectWarning = Bt.getRpcPromiseCallback = Bt.createErrorMiddleware = void 0;
const CS = Ro;
function xS(d) {
  return (e, t, i) => {
    (typeof e.method != "string" || !e.method) && (t.error = CS.ethErrors.rpc.invalidRequest({
      message: "The request 'method' must be a non-empty string.",
      data: e
    })), i((s) => {
      const { error: n } = t;
      return n && d.error(`MetaMask - RPC Error: ${n.message}`, n), s();
    });
  };
}
Bt.createErrorMiddleware = xS;
const vS = (d, e, t = !0) => (i, s) => {
  i || s.error ? e(i || s.error) : !t || Array.isArray(s) ? d(s) : d(s.result);
};
Bt.getRpcPromiseCallback = vS;
function kS(d, e, t, i) {
  let s = `MetaMask: Lost connection to "${e}".`;
  t != null && t.stack && (s += `
${t.stack}`), d.warn(s), i && i.listenerCount("error") > 0 && i.emit("error", s);
}
Bt.logStreamDisconnectWarning = kS;
const ES = () => {
};
Bt.NOOP = ES;
Bt.EMITTED_NOTIFICATIONS = [
  "eth_subscription"
  // per eth-json-rpc-filters/subscriptionManager
];
const ri = (d) => d !== null && typeof d == "object" && typeof d.pipe == "function";
ri.writable = (d) => ri(d) && d.writable !== !1 && typeof d._write == "function" && typeof d._writableState == "object";
ri.readable = (d) => ri(d) && d.readable !== !1 && typeof d._read == "function" && typeof d._readableState == "object";
ri.duplex = (d) => ri.writable(d) && ri.readable(d);
ri.transform = (d) => ri.duplex(d) && typeof d._transform == "function";
var NS = {}, vr = {}, fn = {};
Object.defineProperty(fn, "__esModule", { value: !0 });
fn.getUniqueId = void 0;
const xf = 4294967295;
let ua = Math.floor(Math.random() * xf);
function PS() {
  return ua = (ua + 1) % xf, ua;
}
fn.getUniqueId = PS;
Object.defineProperty(vr, "__esModule", { value: !0 });
vr.createIdRemapMiddleware = void 0;
const _S = fn;
function LS() {
  return (d, e, t, i) => {
    const s = d.id, n = _S.getUniqueId();
    d.id = n, e.id = n, t((r) => {
      d.id = s, e.id = s, r();
    });
  };
}
vr.createIdRemapMiddleware = LS;
var kr = {};
Object.defineProperty(kr, "__esModule", { value: !0 });
kr.createAsyncMiddleware = void 0;
function DS(d) {
  return async (e, t, i, s) => {
    let n;
    const r = new Promise((u) => {
      n = u;
    });
    let a = null, o = !1;
    const c = async () => {
      o = !0, i((u) => {
        a = u, n();
      }), await r;
    };
    try {
      await d(e, t, c), o ? (await r, a(null)) : s(null);
    } catch (u) {
      a ? a(u) : s(u);
    }
  };
}
kr.createAsyncMiddleware = DS;
var Er = {};
Object.defineProperty(Er, "__esModule", { value: !0 });
Er.createScaffoldMiddleware = void 0;
function RS(d) {
  return (e, t, i, s) => {
    const n = d[e.method];
    return n === void 0 ? i() : typeof n == "function" ? n(e, t, i, s) : (t.result = n, s());
  };
}
Er.createScaffoldMiddleware = RS;
var hn = {}, jo = {};
Object.defineProperty(jo, "__esModule", { value: !0 });
const BS = vs;
function ac(d, e, t) {
  try {
    Reflect.apply(d, e, t);
  } catch (i) {
    setTimeout(() => {
      throw i;
    });
  }
}
function VS(d) {
  const e = d.length, t = new Array(e);
  for (let i = 0; i < e; i += 1)
    t[i] = d[i];
  return t;
}
let jS = class extends BS.EventEmitter {
  emit(e, ...t) {
    let i = e === "error";
    const s = this._events;
    if (s !== void 0)
      i = i && s.error === void 0;
    else if (!i)
      return !1;
    if (i) {
      let r;
      if (t.length > 0 && ([r] = t), r instanceof Error)
        throw r;
      const a = new Error(`Unhandled error.${r ? ` (${r.message})` : ""}`);
      throw a.context = r, a;
    }
    const n = s[e];
    if (n === void 0)
      return !1;
    if (typeof n == "function")
      ac(n, this, t);
    else {
      const r = n.length, a = VS(n);
      for (let o = 0; o < r; o += 1)
        ac(a[o], this, t);
    }
    return !0;
  }
};
jo.default = jS;
var FS = qe && qe.__importDefault || function(d) {
  return d && d.__esModule ? d : { default: d };
};
Object.defineProperty(hn, "__esModule", { value: !0 });
hn.JsonRpcEngine = void 0;
const US = FS(jo), xt = Ro;
class ei extends US.default {
  constructor() {
    super(), this._middleware = [];
  }
  /**
   * Add a middleware function to the engine's middleware stack.
   *
   * @param middleware - The middleware function to add.
   */
  push(e) {
    this._middleware.push(e);
  }
  handle(e, t) {
    if (t && typeof t != "function")
      throw new Error('"callback" must be a function if provided.');
    return Array.isArray(e) ? t ? this._handleBatch(e, t) : this._handleBatch(e) : t ? this._handle(e, t) : this._promiseHandle(e);
  }
  /**
   * Returns this engine as a middleware function that can be pushed to other
   * engines.
   *
   * @returns This engine as a middleware function.
   */
  asMiddleware() {
    return async (e, t, i, s) => {
      try {
        const [n, r, a] = await ei._runAllMiddleware(e, t, this._middleware);
        return r ? (await ei._runReturnHandlers(a), s(n)) : i(async (o) => {
          try {
            await ei._runReturnHandlers(a);
          } catch (c) {
            return o(c);
          }
          return o();
        });
      } catch (n) {
        return s(n);
      }
    };
  }
  async _handleBatch(e, t) {
    try {
      const i = await Promise.all(
        // 1. Begin executing each request in the order received
        e.map(this._promiseHandle.bind(this))
      );
      return t ? t(null, i) : i;
    } catch (i) {
      if (t)
        return t(i);
      throw i;
    }
  }
  /**
   * A promise-wrapped _handle.
   */
  _promiseHandle(e) {
    return new Promise((t) => {
      this._handle(e, (i, s) => {
        t(s);
      });
    });
  }
  /**
   * Ensures that the request object is valid, processes it, and passes any
   * error and the response object to the given callback.
   *
   * Does not reject.
   */
  async _handle(e, t) {
    if (!e || Array.isArray(e) || typeof e != "object") {
      const r = new xt.EthereumRpcError(xt.errorCodes.rpc.invalidRequest, `Requests must be plain objects. Received: ${typeof e}`, { request: e });
      return t(r, { id: void 0, jsonrpc: "2.0", error: r });
    }
    if (typeof e.method != "string") {
      const r = new xt.EthereumRpcError(xt.errorCodes.rpc.invalidRequest, `Must specify a string method. Received: ${typeof e.method}`, { request: e });
      return t(r, { id: e.id, jsonrpc: "2.0", error: r });
    }
    const i = Object.assign({}, e), s = {
      id: i.id,
      jsonrpc: i.jsonrpc
    };
    let n = null;
    try {
      await this._processRequest(i, s);
    } catch (r) {
      n = r;
    }
    return n && (delete s.result, s.error || (s.error = xt.serializeError(n))), t(n, s);
  }
  /**
   * For the given request and response, runs all middleware and their return
   * handlers, if any, and ensures that internal request processing semantics
   * are satisfied.
   */
  async _processRequest(e, t) {
    const [i, s, n] = await ei._runAllMiddleware(e, t, this._middleware);
    if (ei._checkForCompletion(e, t, s), await ei._runReturnHandlers(n), i)
      throw i;
  }
  /**
   * Serially executes the given stack of middleware.
   *
   * @returns An array of any error encountered during middleware execution,
   * a boolean indicating whether the request was completed, and an array of
   * middleware-defined return handlers.
   */
  static async _runAllMiddleware(e, t, i) {
    const s = [];
    let n = null, r = !1;
    for (const a of i)
      if ([n, r] = await ei._runMiddleware(e, t, a, s), r)
        break;
    return [n, r, s.reverse()];
  }
  /**
   * Runs an individual middleware.
   *
   * @returns An array of any error encountered during middleware exection,
   * and a boolean indicating whether the request should end.
   */
  static _runMiddleware(e, t, i, s) {
    return new Promise((n) => {
      const r = (o) => {
        const c = o || t.error;
        c && (t.error = xt.serializeError(c)), n([c, !0]);
      }, a = (o) => {
        t.error ? r(t.error) : (o && (typeof o != "function" && r(new xt.EthereumRpcError(xt.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. Received "${typeof o}" for request:
${fa(e)}`, { request: e })), s.push(o)), n([null, !1]));
      };
      try {
        i(e, t, a, r);
      } catch (o) {
        r(o);
      }
    });
  }
  /**
   * Serially executes array of return handlers. The request and response are
   * assumed to be in their scope.
   */
  static async _runReturnHandlers(e) {
    for (const t of e)
      await new Promise((i, s) => {
        t((n) => n ? s(n) : i());
      });
  }
  /**
   * Throws an error if the response has neither a result nor an error, or if
   * the "isComplete" flag is falsy.
   */
  static _checkForCompletion(e, t, i) {
    if (!("result" in t) && !("error" in t))
      throw new xt.EthereumRpcError(xt.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:
${fa(e)}`, { request: e });
    if (!i)
      throw new xt.EthereumRpcError(xt.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:
${fa(e)}`, { request: e });
  }
}
hn.JsonRpcEngine = ei;
function fa(d) {
  return JSON.stringify(d, null, 2);
}
var Nr = {};
Object.defineProperty(Nr, "__esModule", { value: !0 });
Nr.mergeMiddleware = void 0;
const qS = hn;
function GS(d) {
  const e = new qS.JsonRpcEngine();
  return d.forEach((t) => e.push(t)), e.asMiddleware();
}
Nr.mergeMiddleware = GS;
(function(d) {
  var e = qe && qe.__createBinding || (Object.create ? function(i, s, n, r) {
    r === void 0 && (r = n), Object.defineProperty(i, r, { enumerable: !0, get: function() {
      return s[n];
    } });
  } : function(i, s, n, r) {
    r === void 0 && (r = n), i[r] = s[n];
  }), t = qe && qe.__exportStar || function(i, s) {
    for (var n in i)
      n !== "default" && !Object.prototype.hasOwnProperty.call(s, n) && e(s, i, n);
  };
  Object.defineProperty(d, "__esModule", { value: !0 }), t(vr, d), t(kr, d), t(Er, d), t(fn, d), t(hn, d), t(Nr, d);
})(NS);
var tn = {}, Fo = {}, za = { exports: {} }, zS = {}.toString, HS = Array.isArray || function(d) {
  return zS.call(d) == "[object Array]";
}, vf = vs.EventEmitter, Ha = { exports: {} };
(function(d, e) {
  var t = nn(), i = t.Buffer;
  function s(r, a) {
    for (var o in r)
      a[o] = r[o];
  }
  i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? d.exports = t : (s(t, e), e.Buffer = n);
  function n(r, a, o) {
    return i(r, a, o);
  }
  s(i, n), n.from = function(r, a, o) {
    if (typeof r == "number")
      throw new TypeError("Argument must not be a number");
    return i(r, a, o);
  }, n.alloc = function(r, a, o) {
    if (typeof r != "number")
      throw new TypeError("Argument must be a number");
    var c = i(r);
    return a !== void 0 ? typeof o == "string" ? c.fill(a, o) : c.fill(a) : c.fill(0), c;
  }, n.allocUnsafe = function(r) {
    if (typeof r != "number")
      throw new TypeError("Argument must be a number");
    return i(r);
  }, n.allocUnsafeSlow = function(r) {
    if (typeof r != "number")
      throw new TypeError("Argument must be a number");
    return t.SlowBuffer(r);
  };
})(Ha, Ha.exports);
var Uo = Ha.exports, ha = { exports: {} }, oc;
function WS() {
  return oc || (oc = 1, function(d) {
    function e(n, r) {
      if (!(n instanceof r))
        throw new TypeError("Cannot call a class as a function");
    }
    var t = Uo.Buffer, i = dn;
    function s(n, r, a) {
      n.copy(r, a);
    }
    d.exports = function() {
      function n() {
        e(this, n), this.head = null, this.tail = null, this.length = 0;
      }
      return n.prototype.push = function(a) {
        var o = { data: a, next: null };
        this.length > 0 ? this.tail.next = o : this.head = o, this.tail = o, ++this.length;
      }, n.prototype.unshift = function(a) {
        var o = { data: a, next: this.head };
        this.length === 0 && (this.tail = o), this.head = o, ++this.length;
      }, n.prototype.shift = function() {
        if (this.length !== 0) {
          var a = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, a;
        }
      }, n.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, n.prototype.join = function(a) {
        if (this.length === 0)
          return "";
        for (var o = this.head, c = "" + o.data; o = o.next; )
          c += a + o.data;
        return c;
      }, n.prototype.concat = function(a) {
        if (this.length === 0)
          return t.alloc(0);
        for (var o = t.allocUnsafe(a >>> 0), c = this.head, u = 0; c; )
          s(c.data, o, u), u += c.data.length, c = c.next;
        return o;
      }, n;
    }(), i && i.inspect && i.inspect.custom && (d.exports.prototype[i.inspect.custom] = function() {
      var n = i.inspect({ length: this.length });
      return this.constructor.name + " " + n;
    });
  }(ha)), ha.exports;
}
var Nn = Vi;
function YS(d, e) {
  var t = this, i = this._readableState && this._readableState.destroyed, s = this._writableState && this._writableState.destroyed;
  return i || s ? (e ? e(d) : d && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, Nn.nextTick(Pn, this, d)) : Nn.nextTick(Pn, this, d)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(d || null, function(n) {
    !e && n ? t._writableState ? t._writableState.errorEmitted || (t._writableState.errorEmitted = !0, Nn.nextTick(Pn, t, n)) : Nn.nextTick(Pn, t, n) : e && e(n);
  }), this);
}
function KS() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function Pn(d, e) {
  d.emit("error", e);
}
var kf = {
  destroy: YS,
  undestroy: KS
}, la, dc;
function Ef() {
  if (dc)
    return la;
  dc = 1;
  var d = Vi;
  la = m;
  function e(E) {
    var N = this;
    this.next = null, this.entry = null, this.finish = function() {
      te(N, E);
    };
  }
  var t = !Ce.browser && ["v0.10", "v0.9."].indexOf(Ce.version.slice(0, 5)) > -1 ? setImmediate : d.nextTick, i;
  m.WritableState = l;
  var s = Object.create(Fe);
  s.inherits = jt;
  var n = {
    deprecate: rf
  }, r = vf, a = Uo.Buffer, o = (typeof qe < "u" ? qe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function c(E) {
    return a.from(E);
  }
  function u(E) {
    return a.isBuffer(E) || E instanceof o;
  }
  var f = kf;
  s.inherits(m, r);
  function h() {
  }
  function l(E, N) {
    i = i || Is(), E = E || {};
    var L = N instanceof i;
    this.objectMode = !!E.objectMode, L && (this.objectMode = this.objectMode || !!E.writableObjectMode);
    var z = E.highWaterMark, K = E.writableHighWaterMark, R = this.objectMode ? 16 : 16 * 1024;
    z || z === 0 ? this.highWaterMark = z : L && (K || K === 0) ? this.highWaterMark = K : this.highWaterMark = R, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var U = E.decodeStrings === !1;
    this.decodeStrings = !U, this.defaultEncoding = E.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Y) {
      _(N, Y);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  l.prototype.getBuffer = function() {
    for (var N = this.bufferedRequest, L = []; N; )
      L.push(N), N = N.next;
    return L;
  }, function() {
    try {
      Object.defineProperty(l.prototype, "buffer", {
        get: n.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var p;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(m, Symbol.hasInstance, {
    value: function(E) {
      return p.call(this, E) ? !0 : this !== m ? !1 : E && E._writableState instanceof l;
    }
  })) : p = function(E) {
    return E instanceof this;
  };
  function m(E) {
    if (i = i || Is(), !p.call(m, this) && !(this instanceof i))
      return new m(E);
    this._writableState = new l(E, this), this.writable = !0, E && (typeof E.write == "function" && (this._write = E.write), typeof E.writev == "function" && (this._writev = E.writev), typeof E.destroy == "function" && (this._destroy = E.destroy), typeof E.final == "function" && (this._final = E.final)), r.call(this);
  }
  m.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function y(E, N) {
    var L = new Error("write after end");
    E.emit("error", L), d.nextTick(N, L);
  }
  function w(E, N, L, z) {
    var K = !0, R = !1;
    return L === null ? R = new TypeError("May not write null values to stream") : typeof L != "string" && L !== void 0 && !N.objectMode && (R = new TypeError("Invalid non-string/buffer chunk")), R && (E.emit("error", R), d.nextTick(z, R), K = !1), K;
  }
  m.prototype.write = function(E, N, L) {
    var z = this._writableState, K = !1, R = !z.objectMode && u(E);
    return R && !a.isBuffer(E) && (E = c(E)), typeof N == "function" && (L = N, N = null), R ? N = "buffer" : N || (N = z.defaultEncoding), typeof L != "function" && (L = h), z.ended ? y(this, L) : (R || w(this, z, E, L)) && (z.pendingcb++, K = b(this, z, R, E, N, L)), K;
  }, m.prototype.cork = function() {
    var E = this._writableState;
    E.corked++;
  }, m.prototype.uncork = function() {
    var E = this._writableState;
    E.corked && (E.corked--, !E.writing && !E.corked && !E.bufferProcessing && E.bufferedRequest && G(this, E));
  }, m.prototype.setDefaultEncoding = function(N) {
    if (typeof N == "string" && (N = N.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((N + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + N);
    return this._writableState.defaultEncoding = N, this;
  };
  function S(E, N, L) {
    return !E.objectMode && E.decodeStrings !== !1 && typeof N == "string" && (N = a.from(N, L)), N;
  }
  Object.defineProperty(m.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function b(E, N, L, z, K, R) {
    if (!L) {
      var U = S(N, z, K);
      z !== U && (L = !0, K = "buffer", z = U);
    }
    var Y = N.objectMode ? 1 : z.length;
    N.length += Y;
    var J = N.length < N.highWaterMark;
    if (J || (N.needDrain = !0), N.writing || N.corked) {
      var ae = N.lastBufferedRequest;
      N.lastBufferedRequest = {
        chunk: z,
        encoding: K,
        isBuf: L,
        callback: R,
        next: null
      }, ae ? ae.next = N.lastBufferedRequest : N.bufferedRequest = N.lastBufferedRequest, N.bufferedRequestCount += 1;
    } else
      T(E, N, !1, Y, z, K, R);
    return J;
  }
  function T(E, N, L, z, K, R, U) {
    N.writelen = z, N.writecb = U, N.writing = !0, N.sync = !0, L ? E._writev(K, N.onwrite) : E._write(K, R, N.onwrite), N.sync = !1;
  }
  function x(E, N, L, z, K) {
    --N.pendingcb, L ? (d.nextTick(K, z), d.nextTick(se, E, N), E._writableState.errorEmitted = !0, E.emit("error", z)) : (K(z), E._writableState.errorEmitted = !0, E.emit("error", z), se(E, N));
  }
  function v(E) {
    E.writing = !1, E.writecb = null, E.length -= E.writelen, E.writelen = 0;
  }
  function _(E, N) {
    var L = E._writableState, z = L.sync, K = L.writecb;
    if (v(L), N)
      x(E, L, z, N, K);
    else {
      var R = W(L);
      !R && !L.corked && !L.bufferProcessing && L.bufferedRequest && G(E, L), z ? t(V, E, L, R, K) : V(E, L, R, K);
    }
  }
  function V(E, N, L, z) {
    L || j(E, N), N.pendingcb--, z(), se(E, N);
  }
  function j(E, N) {
    N.length === 0 && N.needDrain && (N.needDrain = !1, E.emit("drain"));
  }
  function G(E, N) {
    N.bufferProcessing = !0;
    var L = N.bufferedRequest;
    if (E._writev && L && L.next) {
      var z = N.bufferedRequestCount, K = new Array(z), R = N.corkedRequestsFree;
      R.entry = L;
      for (var U = 0, Y = !0; L; )
        K[U] = L, L.isBuf || (Y = !1), L = L.next, U += 1;
      K.allBuffers = Y, T(E, N, !0, N.length, K, "", R.finish), N.pendingcb++, N.lastBufferedRequest = null, R.next ? (N.corkedRequestsFree = R.next, R.next = null) : N.corkedRequestsFree = new e(N), N.bufferedRequestCount = 0;
    } else {
      for (; L; ) {
        var J = L.chunk, ae = L.encoding, A = L.callback, M = N.objectMode ? 1 : J.length;
        if (T(E, N, !1, M, J, ae, A), L = L.next, N.bufferedRequestCount--, N.writing)
          break;
      }
      L === null && (N.lastBufferedRequest = null);
    }
    N.bufferedRequest = L, N.bufferProcessing = !1;
  }
  m.prototype._write = function(E, N, L) {
    L(new Error("_write() is not implemented"));
  }, m.prototype._writev = null, m.prototype.end = function(E, N, L) {
    var z = this._writableState;
    typeof E == "function" ? (L = E, E = null, N = null) : typeof N == "function" && (L = N, N = null), E != null && this.write(E, N), z.corked && (z.corked = 1, this.uncork()), z.ending || $(this, z, L);
  };
  function W(E) {
    return E.ending && E.length === 0 && E.bufferedRequest === null && !E.finished && !E.writing;
  }
  function B(E, N) {
    E._final(function(L) {
      N.pendingcb--, L && E.emit("error", L), N.prefinished = !0, E.emit("prefinish"), se(E, N);
    });
  }
  function Q(E, N) {
    !N.prefinished && !N.finalCalled && (typeof E._final == "function" ? (N.pendingcb++, N.finalCalled = !0, d.nextTick(B, E, N)) : (N.prefinished = !0, E.emit("prefinish")));
  }
  function se(E, N) {
    var L = W(N);
    return L && (Q(E, N), N.pendingcb === 0 && (N.finished = !0, E.emit("finish"))), L;
  }
  function $(E, N, L) {
    N.ending = !0, se(E, N), L && (N.finished ? d.nextTick(L) : E.once("finish", L)), N.ended = !0, E.writable = !1;
  }
  function te(E, N, L) {
    var z = E.entry;
    for (E.entry = null; z; ) {
      var K = z.callback;
      N.pendingcb--, K(L), z = z.next;
    }
    N.corkedRequestsFree.next = E;
  }
  return Object.defineProperty(m.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(E) {
      this._writableState && (this._writableState.destroyed = E);
    }
  }), m.prototype.destroy = f.destroy, m.prototype._undestroy = f.undestroy, m.prototype._destroy = function(E, N) {
    this.end(), N(E);
  }, la;
}
var pa, cc;
function Is() {
  if (cc)
    return pa;
  cc = 1;
  var d = Vi, e = Object.keys || function(f) {
    var h = [];
    for (var l in f)
      h.push(l);
    return h;
  };
  pa = o;
  var t = Object.create(Fe);
  t.inherits = jt;
  var i = Nf(), s = Ef();
  t.inherits(o, i);
  for (var n = e(s.prototype), r = 0; r < n.length; r++) {
    var a = n[r];
    o.prototype[a] || (o.prototype[a] = s.prototype[a]);
  }
  function o(f) {
    if (!(this instanceof o))
      return new o(f);
    i.call(this, f), s.call(this, f), f && f.readable === !1 && (this.readable = !1), f && f.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, f && f.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", c);
  }
  Object.defineProperty(o.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function c() {
    this.allowHalfOpen || this._writableState.ended || d.nextTick(u, this);
  }
  function u(f) {
    f.end();
  }
  return Object.defineProperty(o.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(f) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = f, this._writableState.destroyed = f);
    }
  }), o.prototype._destroy = function(f, h) {
    this.push(null), this.end(), d.nextTick(h, f);
  }, pa;
}
var ga, uc;
function Nf() {
  if (uc)
    return ga;
  uc = 1;
  var d = Vi;
  ga = S;
  var e = HS, t;
  S.ReadableState = w, vs.EventEmitter;
  var i = function(A, M) {
    return A.listeners(M).length;
  }, s = vf, n = Uo.Buffer, r = (typeof qe < "u" ? qe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function a(A) {
    return n.from(A);
  }
  function o(A) {
    return n.isBuffer(A) || A instanceof r;
  }
  var c = Object.create(Fe);
  c.inherits = jt;
  var u = dn, f = void 0;
  u && u.debuglog ? f = u.debuglog("stream") : f = function() {
  };
  var h = WS(), l = kf, p;
  c.inherits(S, s);
  var m = ["error", "close", "destroy", "pause", "resume"];
  function y(A, M, q) {
    if (typeof A.prependListener == "function")
      return A.prependListener(M, q);
    !A._events || !A._events[M] ? A.on(M, q) : e(A._events[M]) ? A._events[M].unshift(q) : A._events[M] = [q, A._events[M]];
  }
  function w(A, M) {
    t = t || Is(), A = A || {};
    var q = M instanceof t;
    this.objectMode = !!A.objectMode, q && (this.objectMode = this.objectMode || !!A.readableObjectMode);
    var H = A.highWaterMark, le = A.readableHighWaterMark, oe = this.objectMode ? 16 : 16 * 1024;
    H || H === 0 ? this.highWaterMark = H : q && (le || le === 0) ? this.highWaterMark = le : this.highWaterMark = oe, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new h(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = A.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, A.encoding && (p || (p = sr().StringDecoder), this.decoder = new p(A.encoding), this.encoding = A.encoding);
  }
  function S(A) {
    if (t = t || Is(), !(this instanceof S))
      return new S(A);
    this._readableState = new w(A, this), this.readable = !0, A && (typeof A.read == "function" && (this._read = A.read), typeof A.destroy == "function" && (this._destroy = A.destroy)), s.call(this);
  }
  Object.defineProperty(S.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(A) {
      this._readableState && (this._readableState.destroyed = A);
    }
  }), S.prototype.destroy = l.destroy, S.prototype._undestroy = l.undestroy, S.prototype._destroy = function(A, M) {
    this.push(null), M(A);
  }, S.prototype.push = function(A, M) {
    var q = this._readableState, H;
    return q.objectMode ? H = !0 : typeof A == "string" && (M = M || q.defaultEncoding, M !== q.encoding && (A = n.from(A, M), M = ""), H = !0), b(this, A, M, !1, H);
  }, S.prototype.unshift = function(A) {
    return b(this, A, null, !0, !1);
  };
  function b(A, M, q, H, le) {
    var oe = A._readableState;
    if (M === null)
      oe.reading = !1, G(A, oe);
    else {
      var he;
      le || (he = x(oe, M)), he ? A.emit("error", he) : oe.objectMode || M && M.length > 0 ? (typeof M != "string" && !oe.objectMode && Object.getPrototypeOf(M) !== n.prototype && (M = a(M)), H ? oe.endEmitted ? A.emit("error", new Error("stream.unshift() after end event")) : T(A, oe, M, !0) : oe.ended ? A.emit("error", new Error("stream.push() after EOF")) : (oe.reading = !1, oe.decoder && !q ? (M = oe.decoder.write(M), oe.objectMode || M.length !== 0 ? T(A, oe, M, !1) : Q(A, oe)) : T(A, oe, M, !1))) : H || (oe.reading = !1);
    }
    return v(oe);
  }
  function T(A, M, q, H) {
    M.flowing && M.length === 0 && !M.sync ? (A.emit("data", q), A.read(0)) : (M.length += M.objectMode ? 1 : q.length, H ? M.buffer.unshift(q) : M.buffer.push(q), M.needReadable && W(A)), Q(A, M);
  }
  function x(A, M) {
    var q;
    return !o(M) && typeof M != "string" && M !== void 0 && !A.objectMode && (q = new TypeError("Invalid non-string/buffer chunk")), q;
  }
  function v(A) {
    return !A.ended && (A.needReadable || A.length < A.highWaterMark || A.length === 0);
  }
  S.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, S.prototype.setEncoding = function(A) {
    return p || (p = sr().StringDecoder), this._readableState.decoder = new p(A), this._readableState.encoding = A, this;
  };
  var _ = 8388608;
  function V(A) {
    return A >= _ ? A = _ : (A--, A |= A >>> 1, A |= A >>> 2, A |= A >>> 4, A |= A >>> 8, A |= A >>> 16, A++), A;
  }
  function j(A, M) {
    return A <= 0 || M.length === 0 && M.ended ? 0 : M.objectMode ? 1 : A !== A ? M.flowing && M.length ? M.buffer.head.data.length : M.length : (A > M.highWaterMark && (M.highWaterMark = V(A)), A <= M.length ? A : M.ended ? M.length : (M.needReadable = !0, 0));
  }
  S.prototype.read = function(A) {
    f("read", A), A = parseInt(A, 10);
    var M = this._readableState, q = A;
    if (A !== 0 && (M.emittedReadable = !1), A === 0 && M.needReadable && (M.length >= M.highWaterMark || M.ended))
      return f("read: emitReadable", M.length, M.ended), M.length === 0 && M.ended ? Y(this) : W(this), null;
    if (A = j(A, M), A === 0 && M.ended)
      return M.length === 0 && Y(this), null;
    var H = M.needReadable;
    f("need readable", H), (M.length === 0 || M.length - A < M.highWaterMark) && (H = !0, f("length less than watermark", H)), M.ended || M.reading ? (H = !1, f("reading or ended", H)) : H && (f("do read"), M.reading = !0, M.sync = !0, M.length === 0 && (M.needReadable = !0), this._read(M.highWaterMark), M.sync = !1, M.reading || (A = j(q, M)));
    var le;
    return A > 0 ? le = z(A, M) : le = null, le === null ? (M.needReadable = !0, A = 0) : M.length -= A, M.length === 0 && (M.ended || (M.needReadable = !0), q !== A && M.ended && Y(this)), le !== null && this.emit("data", le), le;
  };
  function G(A, M) {
    if (!M.ended) {
      if (M.decoder) {
        var q = M.decoder.end();
        q && q.length && (M.buffer.push(q), M.length += M.objectMode ? 1 : q.length);
      }
      M.ended = !0, W(A);
    }
  }
  function W(A) {
    var M = A._readableState;
    M.needReadable = !1, M.emittedReadable || (f("emitReadable", M.flowing), M.emittedReadable = !0, M.sync ? d.nextTick(B, A) : B(A));
  }
  function B(A) {
    f("emit readable"), A.emit("readable"), L(A);
  }
  function Q(A, M) {
    M.readingMore || (M.readingMore = !0, d.nextTick(se, A, M));
  }
  function se(A, M) {
    for (var q = M.length; !M.reading && !M.flowing && !M.ended && M.length < M.highWaterMark && (f("maybeReadMore read 0"), A.read(0), q !== M.length); )
      q = M.length;
    M.readingMore = !1;
  }
  S.prototype._read = function(A) {
    this.emit("error", new Error("_read() is not implemented"));
  }, S.prototype.pipe = function(A, M) {
    var q = this, H = this._readableState;
    switch (H.pipesCount) {
      case 0:
        H.pipes = A;
        break;
      case 1:
        H.pipes = [H.pipes, A];
        break;
      default:
        H.pipes.push(A);
        break;
    }
    H.pipesCount += 1, f("pipe count=%d opts=%j", H.pipesCount, M);
    var le = (!M || M.end !== !1) && A !== Ce.stdout && A !== Ce.stderr, oe = le ? Ie : De;
    H.endEmitted ? d.nextTick(oe) : q.once("end", oe), A.on("unpipe", he);
    function he(Je, nt) {
      f("onunpipe"), Je === q && nt && nt.hasUnpiped === !1 && (nt.hasUnpiped = !0, bt());
    }
    function Ie() {
      f("onend"), A.end();
    }
    var Pe = $(q);
    A.on("drain", Pe);
    var He = !1;
    function bt() {
      f("cleanup"), A.removeListener("close", Ot), A.removeListener("finish", Le), A.removeListener("drain", Pe), A.removeListener("error", Tt), A.removeListener("unpipe", he), q.removeListener("end", Ie), q.removeListener("end", De), q.removeListener("data", ue), He = !0, H.awaitDrain && (!A._writableState || A._writableState.needDrain) && Pe();
    }
    var mt = !1;
    q.on("data", ue);
    function ue(Je) {
      f("ondata"), mt = !1;
      var nt = A.write(Je);
      nt === !1 && !mt && ((H.pipesCount === 1 && H.pipes === A || H.pipesCount > 1 && ae(H.pipes, A) !== -1) && !He && (f("false write response, pause", H.awaitDrain), H.awaitDrain++, mt = !0), q.pause());
    }
    function Tt(Je) {
      f("onerror", Je), De(), A.removeListener("error", Tt), i(A, "error") === 0 && A.emit("error", Je);
    }
    y(A, "error", Tt);
    function Ot() {
      A.removeListener("finish", Le), De();
    }
    A.once("close", Ot);
    function Le() {
      f("onfinish"), A.removeListener("close", Ot), De();
    }
    A.once("finish", Le);
    function De() {
      f("unpipe"), q.unpipe(A);
    }
    return A.emit("pipe", q), H.flowing || (f("pipe resume"), q.resume()), A;
  };
  function $(A) {
    return function() {
      var M = A._readableState;
      f("pipeOnDrain", M.awaitDrain), M.awaitDrain && M.awaitDrain--, M.awaitDrain === 0 && i(A, "data") && (M.flowing = !0, L(A));
    };
  }
  S.prototype.unpipe = function(A) {
    var M = this._readableState, q = { hasUnpiped: !1 };
    if (M.pipesCount === 0)
      return this;
    if (M.pipesCount === 1)
      return A && A !== M.pipes ? this : (A || (A = M.pipes), M.pipes = null, M.pipesCount = 0, M.flowing = !1, A && A.emit("unpipe", this, q), this);
    if (!A) {
      var H = M.pipes, le = M.pipesCount;
      M.pipes = null, M.pipesCount = 0, M.flowing = !1;
      for (var oe = 0; oe < le; oe++)
        H[oe].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var he = ae(M.pipes, A);
    return he === -1 ? this : (M.pipes.splice(he, 1), M.pipesCount -= 1, M.pipesCount === 1 && (M.pipes = M.pipes[0]), A.emit("unpipe", this, q), this);
  }, S.prototype.on = function(A, M) {
    var q = s.prototype.on.call(this, A, M);
    if (A === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (A === "readable") {
      var H = this._readableState;
      !H.endEmitted && !H.readableListening && (H.readableListening = H.needReadable = !0, H.emittedReadable = !1, H.reading ? H.length && W(this) : d.nextTick(te, this));
    }
    return q;
  }, S.prototype.addListener = S.prototype.on;
  function te(A) {
    f("readable nexttick read 0"), A.read(0);
  }
  S.prototype.resume = function() {
    var A = this._readableState;
    return A.flowing || (f("resume"), A.flowing = !0, E(this, A)), this;
  };
  function E(A, M) {
    M.resumeScheduled || (M.resumeScheduled = !0, d.nextTick(N, A, M));
  }
  function N(A, M) {
    M.reading || (f("resume read 0"), A.read(0)), M.resumeScheduled = !1, M.awaitDrain = 0, A.emit("resume"), L(A), M.flowing && !M.reading && A.read(0);
  }
  S.prototype.pause = function() {
    return f("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (f("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function L(A) {
    var M = A._readableState;
    for (f("flow", M.flowing); M.flowing && A.read() !== null; )
      ;
  }
  S.prototype.wrap = function(A) {
    var M = this, q = this._readableState, H = !1;
    A.on("end", function() {
      if (f("wrapped end"), q.decoder && !q.ended) {
        var he = q.decoder.end();
        he && he.length && M.push(he);
      }
      M.push(null);
    }), A.on("data", function(he) {
      if (f("wrapped data"), q.decoder && (he = q.decoder.write(he)), !(q.objectMode && he == null) && !(!q.objectMode && (!he || !he.length))) {
        var Ie = M.push(he);
        Ie || (H = !0, A.pause());
      }
    });
    for (var le in A)
      this[le] === void 0 && typeof A[le] == "function" && (this[le] = function(he) {
        return function() {
          return A[he].apply(A, arguments);
        };
      }(le));
    for (var oe = 0; oe < m.length; oe++)
      A.on(m[oe], this.emit.bind(this, m[oe]));
    return this._read = function(he) {
      f("wrapped _read", he), H && (H = !1, A.resume());
    }, this;
  }, Object.defineProperty(S.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), S._fromList = z;
  function z(A, M) {
    if (M.length === 0)
      return null;
    var q;
    return M.objectMode ? q = M.buffer.shift() : !A || A >= M.length ? (M.decoder ? q = M.buffer.join("") : M.buffer.length === 1 ? q = M.buffer.head.data : q = M.buffer.concat(M.length), M.buffer.clear()) : q = K(A, M.buffer, M.decoder), q;
  }
  function K(A, M, q) {
    var H;
    return A < M.head.data.length ? (H = M.head.data.slice(0, A), M.head.data = M.head.data.slice(A)) : A === M.head.data.length ? H = M.shift() : H = q ? R(A, M) : U(A, M), H;
  }
  function R(A, M) {
    var q = M.head, H = 1, le = q.data;
    for (A -= le.length; q = q.next; ) {
      var oe = q.data, he = A > oe.length ? oe.length : A;
      if (he === oe.length ? le += oe : le += oe.slice(0, A), A -= he, A === 0) {
        he === oe.length ? (++H, q.next ? M.head = q.next : M.head = M.tail = null) : (M.head = q, q.data = oe.slice(he));
        break;
      }
      ++H;
    }
    return M.length -= H, le;
  }
  function U(A, M) {
    var q = n.allocUnsafe(A), H = M.head, le = 1;
    for (H.data.copy(q), A -= H.data.length; H = H.next; ) {
      var oe = H.data, he = A > oe.length ? oe.length : A;
      if (oe.copy(q, q.length - A, 0, he), A -= he, A === 0) {
        he === oe.length ? (++le, H.next ? M.head = H.next : M.head = M.tail = null) : (M.head = H, H.data = oe.slice(he));
        break;
      }
      ++le;
    }
    return M.length -= le, q;
  }
  function Y(A) {
    var M = A._readableState;
    if (M.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    M.endEmitted || (M.ended = !0, d.nextTick(J, M, A));
  }
  function J(A, M) {
    !A.endEmitted && A.length === 0 && (A.endEmitted = !0, M.readable = !1, M.emit("end"));
  }
  function ae(A, M) {
    for (var q = 0, H = A.length; q < H; q++)
      if (A[q] === M)
        return q;
    return -1;
  }
  return ga;
}
var Pf = di, Pr = Is(), _f = Object.create(Fe);
_f.inherits = jt;
_f.inherits(di, Pr);
function XS(d, e) {
  var t = this._transformState;
  t.transforming = !1;
  var i = t.writecb;
  if (!i)
    return this.emit("error", new Error("write callback called multiple times"));
  t.writechunk = null, t.writecb = null, e != null && this.push(e), i(d);
  var s = this._readableState;
  s.reading = !1, (s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark);
}
function di(d) {
  if (!(this instanceof di))
    return new di(d);
  Pr.call(this, d), this._transformState = {
    afterTransform: XS.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, d && (typeof d.transform == "function" && (this._transform = d.transform), typeof d.flush == "function" && (this._flush = d.flush)), this.on("prefinish", $S);
}
function $S() {
  var d = this;
  typeof this._flush == "function" ? this._flush(function(e, t) {
    fc(d, e, t);
  }) : fc(this, null, null);
}
di.prototype.push = function(d, e) {
  return this._transformState.needTransform = !1, Pr.prototype.push.call(this, d, e);
};
di.prototype._transform = function(d, e, t) {
  throw new Error("_transform() is not implemented");
};
di.prototype._write = function(d, e, t) {
  var i = this._transformState;
  if (i.writecb = t, i.writechunk = d, i.writeencoding = e, !i.transforming) {
    var s = this._readableState;
    (i.needTransform || s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark);
  }
};
di.prototype._read = function(d) {
  var e = this._transformState;
  e.writechunk !== null && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
di.prototype._destroy = function(d, e) {
  var t = this;
  Pr.prototype._destroy.call(this, d, function(i) {
    e(i), t.emit("close");
  });
};
function fc(d, e, t) {
  if (e)
    return d.emit("error", e);
  if (t != null && d.push(t), d._writableState.length)
    throw new Error("Calling transform done when ws.length != 0");
  if (d._transformState.transforming)
    throw new Error("Calling transform done when still transforming");
  return d.push(null);
}
var ZS = sn, Lf = Pf, Df = Object.create(Fe);
Df.inherits = jt;
Df.inherits(sn, Lf);
function sn(d) {
  if (!(this instanceof sn))
    return new sn(d);
  Lf.call(this, d);
}
sn.prototype._transform = function(d, e, t) {
  t(null, d);
};
(function(d, e) {
  e = d.exports = Nf(), e.Stream = e, e.Readable = e, e.Writable = Ef(), e.Duplex = Is(), e.Transform = Pf, e.PassThrough = ZS;
})(za, za.exports);
var Rf = za.exports;
Object.defineProperty(Fo, "__esModule", { value: !0 });
const QS = Rf;
function JS(d) {
  if (!d || !d.engine)
    throw new Error("Missing engine parameter!");
  const { engine: e } = d, t = new QS.Duplex({ objectMode: !0, read: i, write: s });
  return e.on && e.on("notification", (n) => {
    t.push(n);
  }), t;
  function i() {
  }
  function s(n, r, a) {
    e.handle(n, (o, c) => {
      t.push(c);
    }), a();
  }
}
Fo.default = JS;
var qo = {}, Go = {};
Object.defineProperty(Go, "__esModule", { value: !0 });
const eT = vs;
function hc(d, e, t) {
  try {
    Reflect.apply(d, e, t);
  } catch (i) {
    setTimeout(() => {
      throw i;
    });
  }
}
function tT(d) {
  const e = d.length, t = new Array(e);
  for (let i = 0; i < e; i += 1)
    t[i] = d[i];
  return t;
}
class iT extends eT.EventEmitter {
  emit(e, ...t) {
    let i = e === "error";
    const s = this._events;
    if (s !== void 0)
      i = i && s.error === void 0;
    else if (!i)
      return !1;
    if (i) {
      let r;
      if (t.length > 0 && ([r] = t), r instanceof Error)
        throw r;
      const a = new Error(`Unhandled error.${r ? ` (${r.message})` : ""}`);
      throw a.context = r, a;
    }
    const n = s[e];
    if (n === void 0)
      return !1;
    if (typeof n == "function")
      hc(n, this, t);
    else {
      const r = n.length, a = tT(n);
      for (let o = 0; o < r; o += 1)
        hc(a[o], this, t);
    }
    return !0;
  }
}
Go.default = iT;
var sT = qe && qe.__importDefault || function(d) {
  return d && d.__esModule ? d : { default: d };
};
Object.defineProperty(qo, "__esModule", { value: !0 });
const nT = sT(Go), rT = Rf;
function aT() {
  const d = {}, e = new rT.Duplex({
    objectMode: !0,
    read: s,
    write: n
  }), t = new nT.default();
  return { events: t, middleware: (o, c, u, f) => {
    e.push(o), d[o.id] = { req: o, res: c, next: u, end: f };
  }, stream: e };
  function s() {
    return !1;
  }
  function n(o, c, u) {
    let f;
    try {
      !o.id ? a(o) : r(o);
    } catch (h) {
      f = h;
    }
    u(f);
  }
  function r(o) {
    const c = d[o.id];
    if (!c)
      throw new Error(`StreamMiddleware - Unknown response id "${o.id}"`);
    delete d[o.id], Object.assign(c.res, o), setTimeout(c.end);
  }
  function a(o) {
    t.emit("notification", o);
  }
}
qo.default = aT;
var Bf = qe && qe.__importDefault || function(d) {
  return d && d.__esModule ? d : { default: d };
};
Object.defineProperty(tn, "__esModule", { value: !0 });
tn.createStreamMiddleware = tn.createEngineStream = void 0;
const oT = Bf(Fo);
tn.createEngineStream = oT.default;
const dT = Bf(qo);
tn.createStreamMiddleware = dT.default;
/^v?\.0/.test(Ce.version);
async function Vf({ selector: d, widgetType: e, config: t }) {
  const i = document.querySelector(d);
  if (!i)
    throw new Error("Could not find root element");
  if (i.innerHTML = "", e !== vi.TRADE && e !== vi.SEND)
    throw new Error("Invalid widget type");
  window.cedeWidgets = window.cedeWidgets || {};
  const s = { ...t, selector: d };
  window.cedeWidgets[e] = s;
  const n = Yw(t == null ? void 0 : t.theme), r = new jw(i, n, s);
  if (r.renderHtml(bw, { layout: !0 }), !window.chrome) {
    r.renderHtml(Bw);
    return;
  }
  r.renderHtml(Iw, { animateOnExit: !0 });
  const a = await Xw();
  if (!a) {
    r.renderHtml(Pw, {
      data: {
        widgetType: e
      }
    });
    return;
  }
  a.on("widgetClosed", () => r.clear());
  const o = await a.request({ method: "getWidgetBundleUrl", params: { name: e } }).catch(() => null);
  if (!o) {
    r.renderHtml(gw, {
      data: {
        error: e === vi.SEND ? Gs.WIDGETS.SEND.CANT_FETCH_BUNDLE : Gs.WIDGETS.TRADE.CANT_FETCH_BUNDLE
      }
    });
    return;
  }
  const c = document.createElement("script");
  return c.src = o, document.body.appendChild(c), a;
}
const ET = async (d, e) => Vf({ selector: d, widgetType: vi.SEND, config: e }), NT = async (d, e) => Vf({ selector: d, widgetType: vi.TRADE, config: e });
export {
  $f as B,
  $u as a,
  ab as b,
  qe as c,
  Xf as d,
  vs as e,
  Yu as f,
  Kf as g,
  ob as h,
  jt as i,
  rf as j,
  sr as k,
  ET as l,
  NT as m,
  vT as o,
  Ce as p,
  nn as r,
  qu as s,
  dn as u
};
